
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb604"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb604"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $27ab08c24269de64$var$_extends.apply(this, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("jcqzj", function(module, exports) {

var $8VOIs = parcelRequire("8VOIs");
module.exports = {
    questionUnit: $8VOIs
};

});
parcelRegister("8VOIs", function(module, exports) {

var $aB89e = parcelRequire("aB89e");
var $680afcc6b4b95c59$require$constants = $aB89e.spacerFree;

var $fPryk = parcelRequire("fPryk");
var $680afcc6b4b95c59$require$questionUnitMap = $fPryk.questionUnitMap;
var $680afcc6b4b95c59$require$quizOrderInfo = $fPryk.quizOrderInfo;

var $f1q41 = parcelRequire("f1q41");
function $680afcc6b4b95c59$var$getQuestionUnit(questionIndex) {
    return $680afcc6b4b95c59$require$questionUnitMap.getQuestionUnitById($680afcc6b4b95c59$require$quizOrderInfo.quizOrder[questionIndex]);
}
function $680afcc6b4b95c59$var$isRankQuestion(questionUnit) {
    return questionUnit.answerType === $680afcc6b4b95c59$require$constants.questionUnit.PROFILE_ANSWER_TYPE.RANK;
}
function $680afcc6b4b95c59$var$isGroupedQuestion(questionUnit) {
    return $680afcc6b4b95c59$require$quizOrderInfo.groupedQuestions.indexOf(questionUnit.id) > -1;
}
function $680afcc6b4b95c59$var$isQuestionAnswerComplete(questionIndex, questionAnswer) {
    const questionUnit = $680afcc6b4b95c59$var$getQuestionUnit(questionIndex);
    return $680afcc6b4b95c59$var$isRankQuestion(questionUnit) ? questionAnswer.indexOf(null) === -1 : !!questionAnswer;
}
function $680afcc6b4b95c59$var$getInitialAnswer(questionUnit) {
    if (!$680afcc6b4b95c59$var$isRankQuestion(questionUnit)) return "";
    const answer = [];
    for(let i = 0, len = questionUnit.points.length; i < len; i += 1)answer.push(null);
    return answer;
}
function $680afcc6b4b95c59$var$hasQuestionResponse(questionUnit) {
    return !!(questionUnit.response || questionUnit.options && $f1q41.find(questionUnit.options, "response"));
}
function $680afcc6b4b95c59$var$getQuestionResponse(questionUnit, selectedOption) {
    if (questionUnit.response) return {
        text: questionUnit.response,
        illustrationName: questionUnit.responseIllustrationName
    };
    if (questionUnit.options && questionUnit.options[selectedOption]) return {
        text: questionUnit.options[selectedOption].response,
        illustrationName: questionUnit.options[selectedOption].responseIllustrationName
    };
    return {};
}
function $680afcc6b4b95c59$var$getAllResponseIllustrationNames(questionUnit) {
    if (questionUnit.responseIllustrationName) return [
        questionUnit.responseIllustrationName
    ];
    const illustrationNames = [];
    if (questionUnit.options) Object.keys(questionUnit.options).forEach((option)=>{
        const responseIllustrationName = questionUnit.options[option].responseIllustrationName;
        // sometimes, two responses have the same illustration, don't double up
        if (responseIllustrationName && !$f1q41.includes(illustrationNames, responseIllustrationName)) illustrationNames.push(responseIllustrationName);
    });
    return illustrationNames;
}
function $680afcc6b4b95c59$var$tokenizeAnswerText(questionUnits, t) {
    const answerText = questionUnits.answerText;
    if ($680afcc6b4b95c59$var$isRankQuestion(questionUnits)) Object.keys(answerText).forEach((id)=>{
        answerText[id][0] = t(answerText[id][0]);
    });
    else Object.keys(answerText).forEach((idx)=>{
        if (answerText[idx] !== "[INPUT]") answerText[idx] = t(answerText[idx]);
    });
}
function $680afcc6b4b95c59$var$tokenizeOptionsText(options, t) {
    Object.keys(options).forEach((optionId)=>{
        options[optionId].text = t(options[optionId].text);
    });
}
function $680afcc6b4b95c59$var$tokenizePlaceholderText(questionUnit, t) {
    questionUnit.emptyAnswerPlaceholder = t(questionUnit.emptyAnswerPlaceholder);
}
function $680afcc6b4b95c59$var$tokenizeHelperText(questionUnit, t) {
    questionUnit.answerHelperText = t(questionUnit.answerHelperText);
}
function $680afcc6b4b95c59$var$tokenizeResponseText(questionUnit, t) {
    if (questionUnit.response) questionUnit.response = t(questionUnit.response);
    else {
        const options = questionUnit.options;
        Object.keys(options).forEach((optionId)=>{
            options[optionId].response = t(options[optionId].response);
        });
    }
}
function $680afcc6b4b95c59$var$tokenizeQuestionUnit(questionUnit, t) {
    const tokenizedQuestionUnit = $f1q41.cloneDeep(questionUnit);
    if (tokenizedQuestionUnit.answerText) $680afcc6b4b95c59$var$tokenizeAnswerText(tokenizedQuestionUnit, t);
    if (tokenizedQuestionUnit.options) $680afcc6b4b95c59$var$tokenizeOptionsText(tokenizedQuestionUnit.options, t);
    if (tokenizedQuestionUnit.emptyAnswerPlaceholder) $680afcc6b4b95c59$var$tokenizePlaceholderText(tokenizedQuestionUnit, t);
    if (tokenizedQuestionUnit.answerHelperText) $680afcc6b4b95c59$var$tokenizeHelperText(tokenizedQuestionUnit, t);
    if (this.hasQuestionResponse(tokenizedQuestionUnit)) $680afcc6b4b95c59$var$tokenizeResponseText(tokenizedQuestionUnit, t);
    return tokenizedQuestionUnit;
}
module.exports = {
    getQuestionUnit: $680afcc6b4b95c59$var$getQuestionUnit,
    isRankQuestion: $680afcc6b4b95c59$var$isRankQuestion,
    isGroupedQuestion: $680afcc6b4b95c59$var$isGroupedQuestion,
    isQuestionAnswerComplete: $680afcc6b4b95c59$var$isQuestionAnswerComplete,
    getInitialAnswer: $680afcc6b4b95c59$var$getInitialAnswer,
    hasQuestionResponse: $680afcc6b4b95c59$var$hasQuestionResponse,
    getQuestionResponse: $680afcc6b4b95c59$var$getQuestionResponse,
    getAllResponseIllustrationNames: $680afcc6b4b95c59$var$getAllResponseIllustrationNames,
    tokenizeQuestionUnit: $680afcc6b4b95c59$var$tokenizeQuestionUnit
};

});


parcelRegister("fhb9G", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $3EC2Q = parcelRequire("3EC2Q");
class $f74e64e7ee4ffea8$var$Slider extends $acw62.Component {
    constructor(props){
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onDragStart = this.onDragStart.bind(this);
    }
    onChange(evt) {
        this.props.onChange(parseFloat(evt.target.value));
    }
    onDragStart(evt) {
        evt.preventDefault();
    }
    render() {
        const value = this.props.value || Math.floor((this.props.max + this.props.min) / 2);
        let additionalStyles = null;
        if (this.props.primarySliderColor && this.props.secondarySliderColor) additionalStyles = {
            background: `linear-gradient(90deg, #003F2D 0% ${value * 100}%, var(${this.props.secondarySliderColor}) ${value * 100}% 100%)`
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "slider-wrapper",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "slider-text slider-item has-text-right",
                    children: this.props.min
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "slider-item",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        className: "slider-custom",
                        draggable: true,
                        onDragStart: this.onDragStart,
                        style: additionalStyles,
                        min: this.props.min,
                        max: this.props.max,
                        step: this.props.step,
                        value: value,
                        "aria-valuemin": this.props.min,
                        "aria-valuemax": this.props.max,
                        "aria-valuenow": value,
                        type: "range",
                        onChange: this.onChange
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "slider-text slider-item slider-right-text",
                    children: this.props.max
                })
            ]
        });
    }
}
$f74e64e7ee4ffea8$var$Slider.propTypes = {
    min: $c9Z8w.number,
    max: $c9Z8w.number.isRequired,
    value: $3EC2Q.stringOrNumber.isRequired,
    onChange: $c9Z8w.func.isRequired,
    step: $c9Z8w.number,
    primarySliderColor: $c9Z8w.string,
    secondarySliderColor: $c9Z8w.string
};
$f74e64e7ee4ffea8$var$Slider.defaultProps = {
    step: 1,
    min: 0,
    primarySliderColor: "",
    secondarySliderColor: ""
};
module.exports = $f74e64e7ee4ffea8$var$Slider;

});

parcelRegister("6CC1t", function(module, exports) {
var $4d23c93a56f2557e$var$__create = Object.create;
var $4d23c93a56f2557e$var$__defProp = Object.defineProperty;
var $4d23c93a56f2557e$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $4d23c93a56f2557e$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $4d23c93a56f2557e$var$__getProtoOf = Object.getPrototypeOf;
var $4d23c93a56f2557e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $4d23c93a56f2557e$var$__export = (target, all)=>{
    for(var name in all)$4d23c93a56f2557e$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $4d23c93a56f2557e$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $4d23c93a56f2557e$var$__getOwnPropNames(from))if (!$4d23c93a56f2557e$var$__hasOwnProp.call(to, key) && key !== except) $4d23c93a56f2557e$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $4d23c93a56f2557e$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $4d23c93a56f2557e$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $4d23c93a56f2557e$var$__create($4d23c93a56f2557e$var$__getProtoOf(mod)) : {}, $4d23c93a56f2557e$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $4d23c93a56f2557e$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $4d23c93a56f2557e$var$__toCommonJS = (mod)=>$4d23c93a56f2557e$var$__copyProps($4d23c93a56f2557e$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $4d23c93a56f2557e$var$players_exports = {};
$4d23c93a56f2557e$var$__export($4d23c93a56f2557e$var$players_exports, {
    default: ()=>$4d23c93a56f2557e$var$players_default
});
module.exports = $4d23c93a56f2557e$var$__toCommonJS($4d23c93a56f2557e$var$players_exports);

var $eRsTE = parcelRequire("eRsTE");

var $9PnFD = parcelRequire("9PnFD");













var $4d23c93a56f2557e$var$players_default = [
    {
        key: "youtube",
        name: "YouTube",
        canPlay: $9PnFD.canPlay.youtube,
        lazyPlayer: (0, $eRsTE.lazy)(()=>(parcelRequire("3i2Yt")))
    },
    {
        key: "soundcloud",
        name: "SoundCloud",
        canPlay: $9PnFD.canPlay.soundcloud,
        lazyPlayer: (0, $eRsTE.lazy)(()=>(parcelRequire("hTtih")))
    },
    {
        key: "vimeo",
        name: "Vimeo",
        canPlay: $9PnFD.canPlay.vimeo,
        lazyPlayer: (0, $eRsTE.lazy)(()=>(parcelRequire("bCX2t")))
    },
    {
        key: "mux",
        name: "Mux",
        canPlay: $9PnFD.canPlay.mux,
        lazyPlayer: (0, $eRsTE.lazy)(()=>(parcelRequire("5yoG9")))
    },
    {
        key: "facebook",
        name: "Facebook",
        canPlay: $9PnFD.canPlay.facebook,
        lazyPlayer: (0, $eRsTE.lazy)(()=>(parcelRequire("90Qc2")))
    },
    {
        key: "streamable",
        name: "Streamable",
        canPlay: $9PnFD.canPlay.streamable,
        lazyPlayer: (0, $eRsTE.lazy)(()=>(parcelRequire("4pWXK")))
    },
    {
        key: "wistia",
        name: "Wistia",
        canPlay: $9PnFD.canPlay.wistia,
        lazyPlayer: (0, $eRsTE.lazy)(()=>(parcelRequire("al2FK")))
    },
    {
        key: "twitch",
        name: "Twitch",
        canPlay: $9PnFD.canPlay.twitch,
        lazyPlayer: (0, $eRsTE.lazy)(()=>(parcelRequire("12xYe")))
    },
    {
        key: "dailymotion",
        name: "DailyMotion",
        canPlay: $9PnFD.canPlay.dailymotion,
        lazyPlayer: (0, $eRsTE.lazy)(()=>(parcelRequire("bsOCL")))
    },
    {
        key: "mixcloud",
        name: "Mixcloud",
        canPlay: $9PnFD.canPlay.mixcloud,
        lazyPlayer: (0, $eRsTE.lazy)(()=>(parcelRequire("cm7ju")))
    },
    {
        key: "vidyard",
        name: "Vidyard",
        canPlay: $9PnFD.canPlay.vidyard,
        lazyPlayer: (0, $eRsTE.lazy)(()=>(parcelRequire("aoeiw")))
    },
    {
        key: "kaltura",
        name: "Kaltura",
        canPlay: $9PnFD.canPlay.kaltura,
        lazyPlayer: (0, $eRsTE.lazy)(()=>(parcelRequire("cId8S")))
    },
    {
        key: "file",
        name: "FilePlayer",
        canPlay: $9PnFD.canPlay.file,
        canEnablePIP: (url)=>{
            return $9PnFD.canPlay.file(url) && (document.pictureInPictureEnabled || (0, $eRsTE.supportsWebKitPresentationMode)()) && !$9PnFD.AUDIO_EXTENSIONS.test(url);
        },
        lazyPlayer: (0, $eRsTE.lazy)(()=>(parcelRequire("jCSba")))
    }
];

});
parcelRegister("eRsTE", function(module, exports) {
var $ad1c6e2a3dfee4f3$var$__create = Object.create;
var $ad1c6e2a3dfee4f3$var$__defProp = Object.defineProperty;
var $ad1c6e2a3dfee4f3$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $ad1c6e2a3dfee4f3$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $ad1c6e2a3dfee4f3$var$__getProtoOf = Object.getPrototypeOf;
var $ad1c6e2a3dfee4f3$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ad1c6e2a3dfee4f3$var$__export = (target, all)=>{
    for(var name in all)$ad1c6e2a3dfee4f3$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $ad1c6e2a3dfee4f3$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $ad1c6e2a3dfee4f3$var$__getOwnPropNames(from))if (!$ad1c6e2a3dfee4f3$var$__hasOwnProp.call(to, key) && key !== except) $ad1c6e2a3dfee4f3$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $ad1c6e2a3dfee4f3$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $ad1c6e2a3dfee4f3$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $ad1c6e2a3dfee4f3$var$__create($ad1c6e2a3dfee4f3$var$__getProtoOf(mod)) : {}, $ad1c6e2a3dfee4f3$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $ad1c6e2a3dfee4f3$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $ad1c6e2a3dfee4f3$var$__toCommonJS = (mod)=>$ad1c6e2a3dfee4f3$var$__copyProps($ad1c6e2a3dfee4f3$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $ad1c6e2a3dfee4f3$var$utils_exports = {};
$ad1c6e2a3dfee4f3$var$__export($ad1c6e2a3dfee4f3$var$utils_exports, {
    callPlayer: ()=>$ad1c6e2a3dfee4f3$var$callPlayer,
    getConfig: ()=>$ad1c6e2a3dfee4f3$var$getConfig,
    getSDK: ()=>$ad1c6e2a3dfee4f3$var$getSDK,
    isBlobUrl: ()=>$ad1c6e2a3dfee4f3$var$isBlobUrl,
    isMediaStream: ()=>$ad1c6e2a3dfee4f3$var$isMediaStream,
    lazy: ()=>$ad1c6e2a3dfee4f3$var$lazy,
    omit: ()=>$ad1c6e2a3dfee4f3$var$omit,
    parseEndTime: ()=>$ad1c6e2a3dfee4f3$var$parseEndTime,
    parseStartTime: ()=>$ad1c6e2a3dfee4f3$var$parseStartTime,
    queryString: ()=>$ad1c6e2a3dfee4f3$var$queryString,
    randomString: ()=>$ad1c6e2a3dfee4f3$var$randomString,
    supportsWebKitPresentationMode: ()=>$ad1c6e2a3dfee4f3$var$supportsWebKitPresentationMode
});
module.exports = $ad1c6e2a3dfee4f3$var$__toCommonJS($ad1c6e2a3dfee4f3$var$utils_exports);

var $ad1c6e2a3dfee4f3$var$import_react = $ad1c6e2a3dfee4f3$var$__toESM((parcelRequire("acw62")));

var $ad1c6e2a3dfee4f3$var$import_load_script = $ad1c6e2a3dfee4f3$var$__toESM((parcelRequire("ccybn")));

var $ad1c6e2a3dfee4f3$var$import_deepmerge = $ad1c6e2a3dfee4f3$var$__toESM((parcelRequire("bc5yV")));
const $ad1c6e2a3dfee4f3$var$lazy = (componentImportFn)=>$ad1c6e2a3dfee4f3$var$import_react.default.lazy(async ()=>{
        const obj = await componentImportFn();
        return typeof obj.default === "function" ? obj : obj.default;
    });
const $ad1c6e2a3dfee4f3$var$MATCH_START_QUERY = /[?&#](?:start|t)=([0-9hms]+)/;
const $ad1c6e2a3dfee4f3$var$MATCH_END_QUERY = /[?&#]end=([0-9hms]+)/;
const $ad1c6e2a3dfee4f3$var$MATCH_START_STAMP = /(\d+)(h|m|s)/g;
const $ad1c6e2a3dfee4f3$var$MATCH_NUMERIC = /^\d+$/;
function $ad1c6e2a3dfee4f3$var$parseTimeParam(url, pattern) {
    if (url instanceof Array) return void 0;
    const match = url.match(pattern);
    if (match) {
        const stamp = match[1];
        if (stamp.match($ad1c6e2a3dfee4f3$var$MATCH_START_STAMP)) return $ad1c6e2a3dfee4f3$var$parseTimeString(stamp);
        if ($ad1c6e2a3dfee4f3$var$MATCH_NUMERIC.test(stamp)) return parseInt(stamp);
    }
    return void 0;
}
function $ad1c6e2a3dfee4f3$var$parseTimeString(stamp) {
    let seconds = 0;
    let array = $ad1c6e2a3dfee4f3$var$MATCH_START_STAMP.exec(stamp);
    while(array !== null){
        const [, count, period] = array;
        if (period === "h") seconds += parseInt(count, 10) * 3600;
        if (period === "m") seconds += parseInt(count, 10) * 60;
        if (period === "s") seconds += parseInt(count, 10);
        array = $ad1c6e2a3dfee4f3$var$MATCH_START_STAMP.exec(stamp);
    }
    return seconds;
}
function $ad1c6e2a3dfee4f3$var$parseStartTime(url) {
    return $ad1c6e2a3dfee4f3$var$parseTimeParam(url, $ad1c6e2a3dfee4f3$var$MATCH_START_QUERY);
}
function $ad1c6e2a3dfee4f3$var$parseEndTime(url) {
    return $ad1c6e2a3dfee4f3$var$parseTimeParam(url, $ad1c6e2a3dfee4f3$var$MATCH_END_QUERY);
}
function $ad1c6e2a3dfee4f3$var$randomString() {
    return Math.random().toString(36).substr(2, 5);
}
function $ad1c6e2a3dfee4f3$var$queryString(object) {
    return Object.keys(object).map((key)=>`${key}=${object[key]}`).join("&");
}
function $ad1c6e2a3dfee4f3$var$getGlobal(key) {
    if (window[key]) return window[key];
    if (window.exports && window.exports[key]) return window.exports[key];
    if (window.module && window.module.exports && window.module.exports[key]) return window.module.exports[key];
    return null;
}
const $ad1c6e2a3dfee4f3$var$requests = {};
const $ad1c6e2a3dfee4f3$var$getSDK = $ad1c6e2a3dfee4f3$var$enableStubOn(function getSDK2(url, sdkGlobal, sdkReady = null, isLoaded = ()=>true, fetchScript = $ad1c6e2a3dfee4f3$var$import_load_script.default) {
    const existingGlobal = $ad1c6e2a3dfee4f3$var$getGlobal(sdkGlobal);
    if (existingGlobal && isLoaded(existingGlobal)) return Promise.resolve(existingGlobal);
    return new Promise((resolve, reject)=>{
        if ($ad1c6e2a3dfee4f3$var$requests[url]) {
            $ad1c6e2a3dfee4f3$var$requests[url].push({
                resolve: resolve,
                reject: reject
            });
            return;
        }
        $ad1c6e2a3dfee4f3$var$requests[url] = [
            {
                resolve: resolve,
                reject: reject
            }
        ];
        const onLoaded = (sdk)=>{
            $ad1c6e2a3dfee4f3$var$requests[url].forEach((request)=>request.resolve(sdk));
        };
        if (sdkReady) {
            const previousOnReady = window[sdkReady];
            window[sdkReady] = function() {
                if (previousOnReady) previousOnReady();
                onLoaded($ad1c6e2a3dfee4f3$var$getGlobal(sdkGlobal));
            };
        }
        fetchScript(url, (err)=>{
            if (err) {
                $ad1c6e2a3dfee4f3$var$requests[url].forEach((request)=>request.reject(err));
                $ad1c6e2a3dfee4f3$var$requests[url] = null;
            } else if (!sdkReady) onLoaded($ad1c6e2a3dfee4f3$var$getGlobal(sdkGlobal));
        });
    });
});
function $ad1c6e2a3dfee4f3$var$getConfig(props, defaultProps) {
    return (0, $ad1c6e2a3dfee4f3$var$import_deepmerge.default)(defaultProps.config, props.config);
}
function $ad1c6e2a3dfee4f3$var$omit(object, ...arrays) {
    const omitKeys = [].concat(...arrays);
    const output = {};
    const keys = Object.keys(object);
    for (const key of keys)if (omitKeys.indexOf(key) === -1) output[key] = object[key];
    return output;
}
function $ad1c6e2a3dfee4f3$var$callPlayer(method, ...args) {
    if (!this.player || !this.player[method]) {
        let message = `ReactPlayer: ${this.constructor.displayName} player could not call %c${method}%c \u2013 `;
        if (!this.player) message += "The player was not available";
        else if (!this.player[method]) message += "The method was not available";
        console.warn(message, "font-weight: bold", "");
        return null;
    }
    return this.player[method](...args);
}
function $ad1c6e2a3dfee4f3$var$isMediaStream(url) {
    return typeof window !== "undefined" && typeof window.MediaStream !== "undefined" && url instanceof window.MediaStream;
}
function $ad1c6e2a3dfee4f3$var$isBlobUrl(url) {
    return /^blob:/.test(url);
}
function $ad1c6e2a3dfee4f3$var$supportsWebKitPresentationMode(video = document.createElement("video")) {
    const notMobile = /iPhone|iPod/.test(navigator.userAgent) === false;
    return video.webkitSupportsPresentationMode && typeof video.webkitSetPresentationMode === "function" && notMobile;
}
function $ad1c6e2a3dfee4f3$var$enableStubOn(fn) {
    return fn;
}

});
parcelRegister("ccybn", function(module, exports) {
module.exports = function load(src, opts, cb) {
    var head = document.head || document.getElementsByTagName("head")[0];
    var script = document.createElement("script");
    if (typeof opts === "function") {
        cb = opts;
        opts = {};
    }
    opts = opts || {};
    cb = cb || function() {};
    script.type = opts.type || "text/javascript";
    script.charset = opts.charset || "utf8";
    script.async = "async" in opts ? !!opts.async : true;
    script.src = src;
    if (opts.attrs) $8e211ef4b8dfaa4b$var$setAttributes(script, opts.attrs);
    if (opts.text) script.text = "" + opts.text;
    var onend = "onload" in script ? $8e211ef4b8dfaa4b$var$stdOnEnd : $8e211ef4b8dfaa4b$var$ieOnEnd;
    onend(script, cb);
    // some good legacy browsers (firefox) fail the 'in' detection above
    // so as a fallback we always set onload
    // old IE will ignore this and new IE will set onload
    if (!script.onload) $8e211ef4b8dfaa4b$var$stdOnEnd(script, cb);
    head.appendChild(script);
};
function $8e211ef4b8dfaa4b$var$setAttributes(script, attrs) {
    for(var attr in attrs)script.setAttribute(attr, attrs[attr]);
}
function $8e211ef4b8dfaa4b$var$stdOnEnd(script, cb) {
    script.onload = function() {
        this.onerror = this.onload = null;
        cb(null, script);
    };
    script.onerror = function() {
        // this.onload = null here is necessary
        // because even IE9 works not like others
        this.onerror = this.onload = null;
        cb(new Error("Failed to load " + this.src), script);
    };
}
function $8e211ef4b8dfaa4b$var$ieOnEnd(script, cb) {
    script.onreadystatechange = function() {
        if (this.readyState != "complete" && this.readyState != "loaded") return;
        this.onreadystatechange = null;
        cb(null, script) // there is no way to catch loading errors in IE8
        ;
    };
}

});

parcelRegister("bc5yV", function(module, exports) {
"use strict";
var $82652140c2d744c1$var$isMergeableObject = function isMergeableObject(value) {
    return $82652140c2d744c1$var$isNonNullObject(value) && !$82652140c2d744c1$var$isSpecial(value);
};
function $82652140c2d744c1$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $82652140c2d744c1$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $82652140c2d744c1$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $82652140c2d744c1$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $82652140c2d744c1$var$REACT_ELEMENT_TYPE = $82652140c2d744c1$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $82652140c2d744c1$var$isReactElement(value) {
    return value.$$typeof === $82652140c2d744c1$var$REACT_ELEMENT_TYPE;
}
function $82652140c2d744c1$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $82652140c2d744c1$var$deepmerge($82652140c2d744c1$var$emptyTarget(value), value, options) : value;
}
function $82652140c2d744c1$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $82652140c2d744c1$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $82652140c2d744c1$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === "function" ? customMerge : $82652140c2d744c1$var$deepmerge;
}
function $82652140c2d744c1$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function $82652140c2d744c1$var$getKeys(target) {
    return Object.keys(target).concat($82652140c2d744c1$var$getEnumerableOwnPropertySymbols(target));
}
function $82652140c2d744c1$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function $82652140c2d744c1$var$propertyIsUnsafe(target, key) {
    return $82652140c2d744c1$var$propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function $82652140c2d744c1$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $82652140c2d744c1$var$getKeys(target).forEach(function(key) {
        destination[key] = $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $82652140c2d744c1$var$getKeys(source).forEach(function(key) {
        if ($82652140c2d744c1$var$propertyIsUnsafe(target, key)) return;
        if ($82652140c2d744c1$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $82652140c2d744c1$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $82652140c2d744c1$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $82652140c2d744c1$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $82652140c2d744c1$var$isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $82652140c2d744c1$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $82652140c2d744c1$var$mergeObject(target, source, options);
}
$82652140c2d744c1$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $82652140c2d744c1$var$deepmerge(prev, next, options);
    }, {});
};
var $82652140c2d744c1$var$deepmerge_1 = $82652140c2d744c1$var$deepmerge;
module.exports = $82652140c2d744c1$var$deepmerge_1;

});


parcelRegister("9PnFD", function(module, exports) {
var $727b3cf1c6492541$var$__defProp = Object.defineProperty;
var $727b3cf1c6492541$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $727b3cf1c6492541$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $727b3cf1c6492541$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $727b3cf1c6492541$var$__export = (target, all)=>{
    for(var name in all)$727b3cf1c6492541$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $727b3cf1c6492541$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $727b3cf1c6492541$var$__getOwnPropNames(from))if (!$727b3cf1c6492541$var$__hasOwnProp.call(to, key) && key !== except) $727b3cf1c6492541$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $727b3cf1c6492541$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $727b3cf1c6492541$var$__toCommonJS = (mod)=>$727b3cf1c6492541$var$__copyProps($727b3cf1c6492541$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $727b3cf1c6492541$var$patterns_exports = {};
$727b3cf1c6492541$var$__export($727b3cf1c6492541$var$patterns_exports, {
    AUDIO_EXTENSIONS: ()=>$727b3cf1c6492541$var$AUDIO_EXTENSIONS,
    DASH_EXTENSIONS: ()=>$727b3cf1c6492541$var$DASH_EXTENSIONS,
    FLV_EXTENSIONS: ()=>$727b3cf1c6492541$var$FLV_EXTENSIONS,
    HLS_EXTENSIONS: ()=>$727b3cf1c6492541$var$HLS_EXTENSIONS,
    MATCH_URL_DAILYMOTION: ()=>$727b3cf1c6492541$var$MATCH_URL_DAILYMOTION,
    MATCH_URL_FACEBOOK: ()=>$727b3cf1c6492541$var$MATCH_URL_FACEBOOK,
    MATCH_URL_FACEBOOK_WATCH: ()=>$727b3cf1c6492541$var$MATCH_URL_FACEBOOK_WATCH,
    MATCH_URL_KALTURA: ()=>$727b3cf1c6492541$var$MATCH_URL_KALTURA,
    MATCH_URL_MIXCLOUD: ()=>$727b3cf1c6492541$var$MATCH_URL_MIXCLOUD,
    MATCH_URL_MUX: ()=>$727b3cf1c6492541$var$MATCH_URL_MUX,
    MATCH_URL_SOUNDCLOUD: ()=>$727b3cf1c6492541$var$MATCH_URL_SOUNDCLOUD,
    MATCH_URL_STREAMABLE: ()=>$727b3cf1c6492541$var$MATCH_URL_STREAMABLE,
    MATCH_URL_TWITCH_CHANNEL: ()=>$727b3cf1c6492541$var$MATCH_URL_TWITCH_CHANNEL,
    MATCH_URL_TWITCH_VIDEO: ()=>$727b3cf1c6492541$var$MATCH_URL_TWITCH_VIDEO,
    MATCH_URL_VIDYARD: ()=>$727b3cf1c6492541$var$MATCH_URL_VIDYARD,
    MATCH_URL_VIMEO: ()=>$727b3cf1c6492541$var$MATCH_URL_VIMEO,
    MATCH_URL_WISTIA: ()=>$727b3cf1c6492541$var$MATCH_URL_WISTIA,
    MATCH_URL_YOUTUBE: ()=>$727b3cf1c6492541$var$MATCH_URL_YOUTUBE,
    VIDEO_EXTENSIONS: ()=>$727b3cf1c6492541$var$VIDEO_EXTENSIONS,
    canPlay: ()=>$727b3cf1c6492541$var$canPlay
});
module.exports = $727b3cf1c6492541$var$__toCommonJS($727b3cf1c6492541$var$patterns_exports);

var $eRsTE = parcelRequire("eRsTE");
const $727b3cf1c6492541$var$MATCH_URL_YOUTUBE = /(?:youtu\.be\/|youtube(?:-nocookie|education)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=|shorts\/|live\/))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//;
const $727b3cf1c6492541$var$MATCH_URL_SOUNDCLOUD = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/;
const $727b3cf1c6492541$var$MATCH_URL_VIMEO = /vimeo\.com\/(?!progressive_redirect).+/;
const $727b3cf1c6492541$var$MATCH_URL_MUX = /stream\.mux\.com\/(?!\w+\.m3u8)(\w+)/;
const $727b3cf1c6492541$var$MATCH_URL_FACEBOOK = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/;
const $727b3cf1c6492541$var$MATCH_URL_FACEBOOK_WATCH = /^https?:\/\/fb\.watch\/.+$/;
const $727b3cf1c6492541$var$MATCH_URL_STREAMABLE = /streamable\.com\/([a-z0-9]+)$/;
const $727b3cf1c6492541$var$MATCH_URL_WISTIA = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?([^?]+)/;
const $727b3cf1c6492541$var$MATCH_URL_TWITCH_VIDEO = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
const $727b3cf1c6492541$var$MATCH_URL_TWITCH_CHANNEL = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+)($|\?)/;
const $727b3cf1c6492541$var$MATCH_URL_DAILYMOTION = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?(?:[\w.#_-]+)?/;
const $727b3cf1c6492541$var$MATCH_URL_MIXCLOUD = /mixcloud\.com\/([^/]+\/[^/]+)/;
const $727b3cf1c6492541$var$MATCH_URL_VIDYARD = /vidyard.com\/(?:watch\/)?([a-zA-Z0-9-_]+)/;
const $727b3cf1c6492541$var$MATCH_URL_KALTURA = /^https?:\/\/[a-zA-Z]+\.kaltura.(com|org)\/p\/([0-9]+)\/sp\/([0-9]+)00\/embedIframeJs\/uiconf_id\/([0-9]+)\/partner_id\/([0-9]+)(.*)entry_id.([a-zA-Z0-9-_].*)$/;
const $727b3cf1c6492541$var$AUDIO_EXTENSIONS = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
const $727b3cf1c6492541$var$VIDEO_EXTENSIONS = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i;
const $727b3cf1c6492541$var$HLS_EXTENSIONS = /\.(m3u8)($|\?)/i;
const $727b3cf1c6492541$var$DASH_EXTENSIONS = /\.(mpd)($|\?)/i;
const $727b3cf1c6492541$var$FLV_EXTENSIONS = /\.(flv)($|\?)/i;
const $727b3cf1c6492541$var$canPlayFile = (url)=>{
    if (url instanceof Array) {
        for (const item of url){
            if (typeof item === "string" && $727b3cf1c6492541$var$canPlayFile(item)) return true;
            if ($727b3cf1c6492541$var$canPlayFile(item.src)) return true;
        }
        return false;
    }
    if ((0, $eRsTE.isMediaStream)(url) || (0, $eRsTE.isBlobUrl)(url)) return true;
    return $727b3cf1c6492541$var$AUDIO_EXTENSIONS.test(url) || $727b3cf1c6492541$var$VIDEO_EXTENSIONS.test(url) || $727b3cf1c6492541$var$HLS_EXTENSIONS.test(url) || $727b3cf1c6492541$var$DASH_EXTENSIONS.test(url) || $727b3cf1c6492541$var$FLV_EXTENSIONS.test(url);
};
const $727b3cf1c6492541$var$canPlay = {
    youtube: (url)=>{
        if (url instanceof Array) return url.every((item)=>$727b3cf1c6492541$var$MATCH_URL_YOUTUBE.test(item));
        return $727b3cf1c6492541$var$MATCH_URL_YOUTUBE.test(url);
    },
    soundcloud: (url)=>$727b3cf1c6492541$var$MATCH_URL_SOUNDCLOUD.test(url) && !$727b3cf1c6492541$var$AUDIO_EXTENSIONS.test(url),
    vimeo: (url)=>$727b3cf1c6492541$var$MATCH_URL_VIMEO.test(url) && !$727b3cf1c6492541$var$VIDEO_EXTENSIONS.test(url) && !$727b3cf1c6492541$var$HLS_EXTENSIONS.test(url),
    mux: (url)=>$727b3cf1c6492541$var$MATCH_URL_MUX.test(url),
    facebook: (url)=>$727b3cf1c6492541$var$MATCH_URL_FACEBOOK.test(url) || $727b3cf1c6492541$var$MATCH_URL_FACEBOOK_WATCH.test(url),
    streamable: (url)=>$727b3cf1c6492541$var$MATCH_URL_STREAMABLE.test(url),
    wistia: (url)=>$727b3cf1c6492541$var$MATCH_URL_WISTIA.test(url),
    twitch: (url)=>$727b3cf1c6492541$var$MATCH_URL_TWITCH_VIDEO.test(url) || $727b3cf1c6492541$var$MATCH_URL_TWITCH_CHANNEL.test(url),
    dailymotion: (url)=>$727b3cf1c6492541$var$MATCH_URL_DAILYMOTION.test(url),
    mixcloud: (url)=>$727b3cf1c6492541$var$MATCH_URL_MIXCLOUD.test(url),
    vidyard: (url)=>$727b3cf1c6492541$var$MATCH_URL_VIDYARD.test(url),
    kaltura: (url)=>$727b3cf1c6492541$var$MATCH_URL_KALTURA.test(url),
    file: $727b3cf1c6492541$var$canPlayFile
};

});

parcelRegister("3i2Yt", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4VIi0").then(()=>parcelRequire("ia0bJ"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("hTtih", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("7taUx").then(()=>parcelRequire("18IL4"));

});

parcelRegister("bCX2t", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jpbUt").then(()=>parcelRequire("k8bnK"));

});

parcelRegister("5yoG9", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("h6cQL").then(()=>parcelRequire("kU35s"));

});

parcelRegister("90Qc2", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("91E62").then(()=>parcelRequire("1mynu"));

});

parcelRegister("4pWXK", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bRQQ0").then(()=>parcelRequire("azArz"));

});

parcelRegister("al2FK", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("ewabU").then(()=>parcelRequire("ihvEA"));

});

parcelRegister("12xYe", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dzusJ").then(()=>parcelRequire("h79hS"));

});

parcelRegister("bsOCL", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("clIYg").then(()=>parcelRequire("kxfo4"));

});

parcelRegister("cm7ju", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("afQbt").then(()=>parcelRequire("1UO3X"));

});

parcelRegister("aoeiw", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("27HA8").then(()=>parcelRequire("agcfe"));

});

parcelRegister("cId8S", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("jbuHT").then(()=>parcelRequire("63yYm"));

});

parcelRegister("jCSba", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("bFTSM").then(()=>parcelRequire("iDQ8g"));

});


parcelRegister("jk22o", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e111773323c0bcc0$export$2e2bcd8739ae039);
var $e111773323c0bcc0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $e111773323c0bcc0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e111773323c0bcc0$var$safeIsNaN(first) && $e111773323c0bcc0$var$safeIsNaN(second)) return true;
    return false;
}
function $e111773323c0bcc0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e111773323c0bcc0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e111773323c0bcc0$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e111773323c0bcc0$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $e111773323c0bcc0$export$2e2bcd8739ae039 = $e111773323c0bcc0$var$memoizeOne;

});

parcelRegister("ai2Pb", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $77ddc6be16b1d7de$var$hasElementType = typeof Element !== "undefined";
var $77ddc6be16b1d7de$var$hasMap = typeof Map === "function";
var $77ddc6be16b1d7de$var$hasSet = typeof Set === "function";
var $77ddc6be16b1d7de$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $77ddc6be16b1d7de$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($77ddc6be16b1d7de$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$77ddc6be16b1d7de$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($77ddc6be16b1d7de$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($77ddc6be16b1d7de$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($77ddc6be16b1d7de$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$77ddc6be16b1d7de$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $77ddc6be16b1d7de$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("lTdXI", function(module, exports) {
var $fef990a33d96bbdb$var$__create = Object.create;
var $fef990a33d96bbdb$var$__defProp = Object.defineProperty;
var $fef990a33d96bbdb$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $fef990a33d96bbdb$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $fef990a33d96bbdb$var$__getProtoOf = Object.getPrototypeOf;
var $fef990a33d96bbdb$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $fef990a33d96bbdb$var$__defNormalProp = (obj, key, value)=>key in obj ? $fef990a33d96bbdb$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $fef990a33d96bbdb$var$__export = (target, all)=>{
    for(var name in all)$fef990a33d96bbdb$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $fef990a33d96bbdb$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $fef990a33d96bbdb$var$__getOwnPropNames(from))if (!$fef990a33d96bbdb$var$__hasOwnProp.call(to, key) && key !== except) $fef990a33d96bbdb$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $fef990a33d96bbdb$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $fef990a33d96bbdb$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $fef990a33d96bbdb$var$__create($fef990a33d96bbdb$var$__getProtoOf(mod)) : {}, $fef990a33d96bbdb$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $fef990a33d96bbdb$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $fef990a33d96bbdb$var$__toCommonJS = (mod)=>$fef990a33d96bbdb$var$__copyProps($fef990a33d96bbdb$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $fef990a33d96bbdb$var$__publicField = (obj, key, value)=>{
    $fef990a33d96bbdb$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
var $fef990a33d96bbdb$var$Player_exports = {};
$fef990a33d96bbdb$var$__export($fef990a33d96bbdb$var$Player_exports, {
    default: ()=>$fef990a33d96bbdb$var$Player
});
module.exports = $fef990a33d96bbdb$var$__toCommonJS($fef990a33d96bbdb$var$Player_exports);

var $fef990a33d96bbdb$var$import_react = $fef990a33d96bbdb$var$__toESM((parcelRequire("acw62")));

var $fef990a33d96bbdb$var$import_react_fast_compare = $fef990a33d96bbdb$var$__toESM((parcelRequire("ai2Pb")));

var $fri5W = parcelRequire("fri5W");

var $eRsTE = parcelRequire("eRsTE");
const $fef990a33d96bbdb$var$SEEK_ON_PLAY_EXPIRY = 5e3;
class $fef990a33d96bbdb$var$Player extends $fef990a33d96bbdb$var$import_react.Component {
    constructor(){
        super(...arguments);
        $fef990a33d96bbdb$var$__publicField(this, "mounted", false);
        $fef990a33d96bbdb$var$__publicField(this, "isReady", false);
        $fef990a33d96bbdb$var$__publicField(this, "isPlaying", false);
        // Track playing state internally to prevent bugs
        $fef990a33d96bbdb$var$__publicField(this, "isLoading", true);
        // Use isLoading to prevent onPause when switching URL
        $fef990a33d96bbdb$var$__publicField(this, "loadOnReady", null);
        $fef990a33d96bbdb$var$__publicField(this, "startOnPlay", true);
        $fef990a33d96bbdb$var$__publicField(this, "seekOnPlay", null);
        $fef990a33d96bbdb$var$__publicField(this, "onDurationCalled", false);
        $fef990a33d96bbdb$var$__publicField(this, "handlePlayerMount", (player)=>{
            if (this.player) {
                this.progress();
                return;
            }
            this.player = player;
            this.player.load(this.props.url);
            this.progress();
        });
        $fef990a33d96bbdb$var$__publicField(this, "getInternalPlayer", (key)=>{
            if (!this.player) return null;
            return this.player[key];
        });
        $fef990a33d96bbdb$var$__publicField(this, "progress", ()=>{
            if (this.props.url && this.player && this.isReady) {
                const playedSeconds = this.getCurrentTime() || 0;
                const loadedSeconds = this.getSecondsLoaded();
                const duration = this.getDuration();
                if (duration) {
                    const progress = {
                        playedSeconds: playedSeconds,
                        played: playedSeconds / duration
                    };
                    if (loadedSeconds !== null) {
                        progress.loadedSeconds = loadedSeconds;
                        progress.loaded = loadedSeconds / duration;
                    }
                    if (progress.playedSeconds !== this.prevPlayed || progress.loadedSeconds !== this.prevLoaded) this.props.onProgress(progress);
                    this.prevPlayed = progress.playedSeconds;
                    this.prevLoaded = progress.loadedSeconds;
                }
            }
            this.progressTimeout = setTimeout(this.progress, this.props.progressFrequency || this.props.progressInterval);
        });
        $fef990a33d96bbdb$var$__publicField(this, "handleReady", ()=>{
            if (!this.mounted) return;
            this.isReady = true;
            this.isLoading = false;
            const { onReady: onReady, playing: playing, volume: volume, muted: muted } = this.props;
            onReady();
            if (!muted && volume !== null) this.player.setVolume(volume);
            if (this.loadOnReady) {
                this.player.load(this.loadOnReady, true);
                this.loadOnReady = null;
            } else if (playing) this.player.play();
            this.handleDurationCheck();
        });
        $fef990a33d96bbdb$var$__publicField(this, "handlePlay", ()=>{
            this.isPlaying = true;
            this.isLoading = false;
            const { onStart: onStart, onPlay: onPlay, playbackRate: playbackRate } = this.props;
            if (this.startOnPlay) {
                if (this.player.setPlaybackRate && playbackRate !== 1) this.player.setPlaybackRate(playbackRate);
                onStart();
                this.startOnPlay = false;
            }
            onPlay();
            if (this.seekOnPlay) {
                this.seekTo(this.seekOnPlay);
                this.seekOnPlay = null;
            }
            this.handleDurationCheck();
        });
        $fef990a33d96bbdb$var$__publicField(this, "handlePause", (e)=>{
            this.isPlaying = false;
            if (!this.isLoading) this.props.onPause(e);
        });
        $fef990a33d96bbdb$var$__publicField(this, "handleEnded", ()=>{
            const { activePlayer: activePlayer, loop: loop, onEnded: onEnded } = this.props;
            if (activePlayer.loopOnEnded && loop) this.seekTo(0);
            if (!loop) {
                this.isPlaying = false;
                onEnded();
            }
        });
        $fef990a33d96bbdb$var$__publicField(this, "handleError", (...args)=>{
            this.isLoading = false;
            this.props.onError(...args);
        });
        $fef990a33d96bbdb$var$__publicField(this, "handleDurationCheck", ()=>{
            clearTimeout(this.durationCheckTimeout);
            const duration = this.getDuration();
            if (duration) {
                if (!this.onDurationCalled) {
                    this.props.onDuration(duration);
                    this.onDurationCalled = true;
                }
            } else this.durationCheckTimeout = setTimeout(this.handleDurationCheck, 100);
        });
        $fef990a33d96bbdb$var$__publicField(this, "handleLoaded", ()=>{
            this.isLoading = false;
        });
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        clearTimeout(this.progressTimeout);
        clearTimeout(this.durationCheckTimeout);
        if (this.isReady && this.props.stopOnUnmount) {
            this.player.stop();
            if (this.player.disablePIP) this.player.disablePIP();
        }
        this.mounted = false;
    }
    componentDidUpdate(prevProps) {
        if (!this.player) return;
        const { url: url, playing: playing, volume: volume, muted: muted, playbackRate: playbackRate, pip: pip, loop: loop, activePlayer: activePlayer, disableDeferredLoading: disableDeferredLoading } = this.props;
        if (!(0, $fef990a33d96bbdb$var$import_react_fast_compare.default)(prevProps.url, url)) {
            if (this.isLoading && !activePlayer.forceLoad && !disableDeferredLoading && !(0, $eRsTE.isMediaStream)(url)) {
                console.warn(`ReactPlayer: the attempt to load ${url} is being deferred until the player has loaded`);
                this.loadOnReady = url;
                return;
            }
            this.isLoading = true;
            this.startOnPlay = true;
            this.onDurationCalled = false;
            this.player.load(url, this.isReady);
        }
        if (!prevProps.playing && playing && !this.isPlaying) this.player.play();
        if (prevProps.playing && !playing && this.isPlaying) this.player.pause();
        if (!prevProps.pip && pip && this.player.enablePIP) this.player.enablePIP();
        if (prevProps.pip && !pip && this.player.disablePIP) this.player.disablePIP();
        if (prevProps.volume !== volume && volume !== null) this.player.setVolume(volume);
        if (prevProps.muted !== muted) {
            if (muted) this.player.mute();
            else {
                this.player.unmute();
                if (volume !== null) setTimeout(()=>this.player.setVolume(volume));
            }
        }
        if (prevProps.playbackRate !== playbackRate && this.player.setPlaybackRate) this.player.setPlaybackRate(playbackRate);
        if (prevProps.loop !== loop && this.player.setLoop) this.player.setLoop(loop);
    }
    getDuration() {
        if (!this.isReady) return null;
        return this.player.getDuration();
    }
    getCurrentTime() {
        if (!this.isReady) return null;
        return this.player.getCurrentTime();
    }
    getSecondsLoaded() {
        if (!this.isReady) return null;
        return this.player.getSecondsLoaded();
    }
    seekTo(amount, type, keepPlaying) {
        if (!this.isReady) {
            if (amount !== 0) {
                this.seekOnPlay = amount;
                setTimeout(()=>{
                    this.seekOnPlay = null;
                }, $fef990a33d96bbdb$var$SEEK_ON_PLAY_EXPIRY);
            }
            return;
        }
        const isFraction = !type ? amount > 0 && amount < 1 : type === "fraction";
        if (isFraction) {
            const duration = this.player.getDuration();
            if (!duration) {
                console.warn("ReactPlayer: could not seek using fraction \u2013\xa0duration not yet available");
                return;
            }
            this.player.seekTo(duration * amount, keepPlaying);
            return;
        }
        this.player.seekTo(amount, keepPlaying);
    }
    render() {
        const Player2 = this.props.activePlayer;
        if (!Player2) return null;
        return /* @__PURE__ */ $fef990a33d96bbdb$var$import_react.default.createElement(Player2, {
            ...this.props,
            onMount: this.handlePlayerMount,
            onReady: this.handleReady,
            onPlay: this.handlePlay,
            onPause: this.handlePause,
            onEnded: this.handleEnded,
            onLoaded: this.handleLoaded,
            onError: this.handleError
        });
    }
}
$fef990a33d96bbdb$var$__publicField($fef990a33d96bbdb$var$Player, "displayName", "Player");
$fef990a33d96bbdb$var$__publicField($fef990a33d96bbdb$var$Player, "propTypes", $fri5W.propTypes);
$fef990a33d96bbdb$var$__publicField($fef990a33d96bbdb$var$Player, "defaultProps", $fri5W.defaultProps);

});
parcelRegister("fri5W", function(module, exports) {
var $b3d769e1bab6708d$var$__create = Object.create;
var $b3d769e1bab6708d$var$__defProp = Object.defineProperty;
var $b3d769e1bab6708d$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $b3d769e1bab6708d$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $b3d769e1bab6708d$var$__getProtoOf = Object.getPrototypeOf;
var $b3d769e1bab6708d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $b3d769e1bab6708d$var$__export = (target, all)=>{
    for(var name in all)$b3d769e1bab6708d$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $b3d769e1bab6708d$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $b3d769e1bab6708d$var$__getOwnPropNames(from))if (!$b3d769e1bab6708d$var$__hasOwnProp.call(to, key) && key !== except) $b3d769e1bab6708d$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $b3d769e1bab6708d$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $b3d769e1bab6708d$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $b3d769e1bab6708d$var$__create($b3d769e1bab6708d$var$__getProtoOf(mod)) : {}, $b3d769e1bab6708d$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $b3d769e1bab6708d$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $b3d769e1bab6708d$var$__toCommonJS = (mod)=>$b3d769e1bab6708d$var$__copyProps($b3d769e1bab6708d$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $b3d769e1bab6708d$var$props_exports = {};
$b3d769e1bab6708d$var$__export($b3d769e1bab6708d$var$props_exports, {
    defaultProps: ()=>$b3d769e1bab6708d$var$defaultProps,
    propTypes: ()=>$b3d769e1bab6708d$var$propTypes
});
module.exports = $b3d769e1bab6708d$var$__toCommonJS($b3d769e1bab6708d$var$props_exports);

var $b3d769e1bab6708d$var$import_prop_types = $b3d769e1bab6708d$var$__toESM((parcelRequire("c9Z8w")));
const { string: $b3d769e1bab6708d$var$string, bool: $b3d769e1bab6708d$var$bool, number: $b3d769e1bab6708d$var$number, array: $b3d769e1bab6708d$var$array, oneOfType: $b3d769e1bab6708d$var$oneOfType, shape: $b3d769e1bab6708d$var$shape, object: $b3d769e1bab6708d$var$object, func: $b3d769e1bab6708d$var$func, node: $b3d769e1bab6708d$var$node } = $b3d769e1bab6708d$var$import_prop_types.default;
const $b3d769e1bab6708d$var$propTypes = {
    url: $b3d769e1bab6708d$var$oneOfType([
        $b3d769e1bab6708d$var$string,
        $b3d769e1bab6708d$var$array,
        $b3d769e1bab6708d$var$object
    ]),
    playing: $b3d769e1bab6708d$var$bool,
    loop: $b3d769e1bab6708d$var$bool,
    controls: $b3d769e1bab6708d$var$bool,
    volume: $b3d769e1bab6708d$var$number,
    muted: $b3d769e1bab6708d$var$bool,
    playbackRate: $b3d769e1bab6708d$var$number,
    width: $b3d769e1bab6708d$var$oneOfType([
        $b3d769e1bab6708d$var$string,
        $b3d769e1bab6708d$var$number
    ]),
    height: $b3d769e1bab6708d$var$oneOfType([
        $b3d769e1bab6708d$var$string,
        $b3d769e1bab6708d$var$number
    ]),
    style: $b3d769e1bab6708d$var$object,
    progressInterval: $b3d769e1bab6708d$var$number,
    playsinline: $b3d769e1bab6708d$var$bool,
    pip: $b3d769e1bab6708d$var$bool,
    stopOnUnmount: $b3d769e1bab6708d$var$bool,
    light: $b3d769e1bab6708d$var$oneOfType([
        $b3d769e1bab6708d$var$bool,
        $b3d769e1bab6708d$var$string,
        $b3d769e1bab6708d$var$object
    ]),
    playIcon: $b3d769e1bab6708d$var$node,
    previewTabIndex: $b3d769e1bab6708d$var$number,
    previewAriaLabel: $b3d769e1bab6708d$var$string,
    fallback: $b3d769e1bab6708d$var$node,
    oEmbedUrl: $b3d769e1bab6708d$var$string,
    wrapper: $b3d769e1bab6708d$var$oneOfType([
        $b3d769e1bab6708d$var$string,
        $b3d769e1bab6708d$var$func,
        $b3d769e1bab6708d$var$shape({
            render: $b3d769e1bab6708d$var$func.isRequired
        })
    ]),
    config: $b3d769e1bab6708d$var$shape({
        soundcloud: $b3d769e1bab6708d$var$shape({
            options: $b3d769e1bab6708d$var$object
        }),
        youtube: $b3d769e1bab6708d$var$shape({
            playerVars: $b3d769e1bab6708d$var$object,
            embedOptions: $b3d769e1bab6708d$var$object,
            onUnstarted: $b3d769e1bab6708d$var$func
        }),
        facebook: $b3d769e1bab6708d$var$shape({
            appId: $b3d769e1bab6708d$var$string,
            version: $b3d769e1bab6708d$var$string,
            playerId: $b3d769e1bab6708d$var$string,
            attributes: $b3d769e1bab6708d$var$object
        }),
        dailymotion: $b3d769e1bab6708d$var$shape({
            params: $b3d769e1bab6708d$var$object
        }),
        vimeo: $b3d769e1bab6708d$var$shape({
            playerOptions: $b3d769e1bab6708d$var$object,
            title: $b3d769e1bab6708d$var$string
        }),
        mux: $b3d769e1bab6708d$var$shape({
            attributes: $b3d769e1bab6708d$var$object,
            version: $b3d769e1bab6708d$var$string
        }),
        file: $b3d769e1bab6708d$var$shape({
            attributes: $b3d769e1bab6708d$var$object,
            tracks: $b3d769e1bab6708d$var$array,
            forceVideo: $b3d769e1bab6708d$var$bool,
            forceAudio: $b3d769e1bab6708d$var$bool,
            forceHLS: $b3d769e1bab6708d$var$bool,
            forceSafariHLS: $b3d769e1bab6708d$var$bool,
            forceDisableHls: $b3d769e1bab6708d$var$bool,
            forceDASH: $b3d769e1bab6708d$var$bool,
            forceFLV: $b3d769e1bab6708d$var$bool,
            hlsOptions: $b3d769e1bab6708d$var$object,
            hlsVersion: $b3d769e1bab6708d$var$string,
            dashVersion: $b3d769e1bab6708d$var$string,
            flvVersion: $b3d769e1bab6708d$var$string
        }),
        wistia: $b3d769e1bab6708d$var$shape({
            options: $b3d769e1bab6708d$var$object,
            playerId: $b3d769e1bab6708d$var$string,
            customControls: $b3d769e1bab6708d$var$array
        }),
        mixcloud: $b3d769e1bab6708d$var$shape({
            options: $b3d769e1bab6708d$var$object
        }),
        twitch: $b3d769e1bab6708d$var$shape({
            options: $b3d769e1bab6708d$var$object,
            playerId: $b3d769e1bab6708d$var$string
        }),
        vidyard: $b3d769e1bab6708d$var$shape({
            options: $b3d769e1bab6708d$var$object
        })
    }),
    onReady: $b3d769e1bab6708d$var$func,
    onStart: $b3d769e1bab6708d$var$func,
    onPlay: $b3d769e1bab6708d$var$func,
    onPause: $b3d769e1bab6708d$var$func,
    onBuffer: $b3d769e1bab6708d$var$func,
    onBufferEnd: $b3d769e1bab6708d$var$func,
    onEnded: $b3d769e1bab6708d$var$func,
    onError: $b3d769e1bab6708d$var$func,
    onDuration: $b3d769e1bab6708d$var$func,
    onSeek: $b3d769e1bab6708d$var$func,
    onPlaybackRateChange: $b3d769e1bab6708d$var$func,
    onPlaybackQualityChange: $b3d769e1bab6708d$var$func,
    onProgress: $b3d769e1bab6708d$var$func,
    onClickPreview: $b3d769e1bab6708d$var$func,
    onEnablePIP: $b3d769e1bab6708d$var$func,
    onDisablePIP: $b3d769e1bab6708d$var$func
};
const $b3d769e1bab6708d$var$noop = ()=>{};
const $b3d769e1bab6708d$var$defaultProps = {
    playing: false,
    loop: false,
    controls: false,
    volume: null,
    muted: false,
    playbackRate: 1,
    width: "640px",
    height: "360px",
    style: {},
    progressInterval: 1e3,
    playsinline: false,
    pip: false,
    stopOnUnmount: true,
    light: false,
    fallback: null,
    wrapper: "div",
    previewTabIndex: 0,
    previewAriaLabel: "",
    oEmbedUrl: "https://noembed.com/embed?url={url}",
    config: {
        soundcloud: {
            options: {
                visual: true,
                // Undocumented, but makes player fill container and look better
                buying: false,
                liking: false,
                download: false,
                sharing: false,
                show_comments: false,
                show_playcount: false
            }
        },
        youtube: {
            playerVars: {
                playsinline: 1,
                showinfo: 0,
                rel: 0,
                iv_load_policy: 3,
                modestbranding: 1
            },
            embedOptions: {},
            onUnstarted: $b3d769e1bab6708d$var$noop
        },
        facebook: {
            appId: "1309697205772819",
            version: "v3.3",
            playerId: null,
            attributes: {}
        },
        dailymotion: {
            params: {
                api: 1,
                "endscreen-enable": false
            }
        },
        vimeo: {
            playerOptions: {
                autopause: false,
                byline: false,
                portrait: false,
                title: false
            },
            title: null
        },
        mux: {
            attributes: {},
            version: "2"
        },
        file: {
            attributes: {},
            tracks: [],
            forceVideo: false,
            forceAudio: false,
            forceHLS: false,
            forceDASH: false,
            forceFLV: false,
            hlsOptions: {},
            hlsVersion: "1.1.4",
            dashVersion: "3.1.3",
            flvVersion: "1.5.0",
            forceDisableHls: false
        },
        wistia: {
            options: {},
            playerId: null,
            customControls: null
        },
        mixcloud: {
            options: {
                hide_cover: 1
            }
        },
        twitch: {
            options: {},
            playerId: null
        },
        vidyard: {
            options: {}
        }
    },
    onReady: $b3d769e1bab6708d$var$noop,
    onStart: $b3d769e1bab6708d$var$noop,
    onPlay: $b3d769e1bab6708d$var$noop,
    onPause: $b3d769e1bab6708d$var$noop,
    onBuffer: $b3d769e1bab6708d$var$noop,
    onBufferEnd: $b3d769e1bab6708d$var$noop,
    onEnded: $b3d769e1bab6708d$var$noop,
    onError: $b3d769e1bab6708d$var$noop,
    onDuration: $b3d769e1bab6708d$var$noop,
    onSeek: $b3d769e1bab6708d$var$noop,
    onPlaybackRateChange: $b3d769e1bab6708d$var$noop,
    onPlaybackQualityChange: $b3d769e1bab6708d$var$noop,
    onProgress: $b3d769e1bab6708d$var$noop,
    onClickPreview: $b3d769e1bab6708d$var$noop,
    onEnablePIP: $b3d769e1bab6708d$var$noop,
    onDisablePIP: $b3d769e1bab6708d$var$noop
};

});


parcelRegister("7Iwfb", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("dB0Hl").then(()=>parcelRequire("MTexj"));

});

parcelRegister("5zOsi", function(module, exports) {
/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(module.exports, function() {
    return /******/ function() {
        /******/ var __webpack_modules__ = {
            /***/ 686: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "default": function() {
                        return /* binding */ clipboard;
                    }
                });
                // EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
                var tiny_emitter = __webpack_require__(279);
                var tiny_emitter_default = /*#__PURE__*/ __webpack_require__.n(tiny_emitter);
                // EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
                var listen = __webpack_require__(370);
                var listen_default = /*#__PURE__*/ __webpack_require__.n(listen);
                // EXTERNAL MODULE: ./node_modules/select/src/select.js
                var src_select = __webpack_require__(817);
                var select_default = /*#__PURE__*/ __webpack_require__.n(src_select);
                /**
 * Executes a given operation type.
 * @param {String} type
 * @return {Boolean}
 */ function command(type) {
                    try {
                        return document.execCommand(type);
                    } catch (err) {
                        return false;
                    }
                }
                /**
 * Cut action wrapper.
 * @param {String|HTMLElement} target
 * @return {String}
 */ var ClipboardActionCut = function ClipboardActionCut(target) {
                    var selectedText = select_default()(target);
                    command("cut");
                    return selectedText;
                };
                /* harmony default export */ var actions_cut = ClipboardActionCut;
                /**
 * Creates a fake textarea element with a value.
 * @param {String} value
 * @return {HTMLElement}
 */ function createFakeElement(value) {
                    var isRTL = document.documentElement.getAttribute("dir") === "rtl";
                    var fakeElement = document.createElement("textarea"); // Prevent zooming on iOS
                    fakeElement.style.fontSize = "12pt"; // Reset box model
                    fakeElement.style.border = "0";
                    fakeElement.style.padding = "0";
                    fakeElement.style.margin = "0"; // Move element out of screen horizontally
                    fakeElement.style.position = "absolute";
                    fakeElement.style[isRTL ? "right" : "left"] = "-9999px"; // Move element to the same position vertically
                    var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                    fakeElement.style.top = "".concat(yPosition, "px");
                    fakeElement.setAttribute("readonly", "");
                    fakeElement.value = value;
                    return fakeElement;
                }
                /**
 * Create fake copy action wrapper using a fake element.
 * @param {String} target
 * @param {Object} options
 * @return {String}
 */ var fakeCopyAction = function fakeCopyAction(value, options) {
                    var fakeElement = createFakeElement(value);
                    options.container.appendChild(fakeElement);
                    var selectedText = select_default()(fakeElement);
                    command("copy");
                    fakeElement.remove();
                    return selectedText;
                };
                /**
 * Copy action wrapper.
 * @param {String|HTMLElement} target
 * @param {Object} options
 * @return {String}
 */ var ClipboardActionCopy = function ClipboardActionCopy(target) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                        container: document.body
                    };
                    var selectedText = "";
                    if (typeof target === "string") selectedText = fakeCopyAction(target, options);
                    else if (target instanceof HTMLInputElement && ![
                        "text",
                        "search",
                        "url",
                        "tel",
                        "password"
                    ].includes(target === null || target === void 0 ? void 0 : target.type)) // If input type doesn't support `setSelectionRange`. Simulate it. https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
                    selectedText = fakeCopyAction(target.value, options);
                    else {
                        selectedText = select_default()(target);
                        command("copy");
                    }
                    return selectedText;
                };
                /* harmony default export */ var actions_copy = ClipboardActionCopy;
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                /**
 * Inner function which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 * @param {Object} options
 */ var ClipboardActionDefault = function ClipboardActionDefault() {
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    // Defines base properties passed from constructor.
                    var _options$action = options.action, action = _options$action === void 0 ? "copy" : _options$action, container = options.container, target = options.target, text = options.text; // Sets the `action` to be performed which can be either 'copy' or 'cut'.
                    if (action !== "copy" && action !== "cut") throw new Error('Invalid "action" value, use either "copy" or "cut"');
                     // Sets the `target` property using an element that will be have its content copied.
                    if (target !== undefined) {
                        if (target && _typeof(target) === "object" && target.nodeType === 1) {
                            if (action === "copy" && target.hasAttribute("disabled")) throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                            if (action === "cut" && (target.hasAttribute("readonly") || target.hasAttribute("disabled"))) throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        } else throw new Error('Invalid "target" value, use a valid Element');
                    } // Define selection strategy based on `text` property.
                    if (text) return actions_copy(text, {
                        container: container
                    });
                     // Defines which selection strategy based on `target` property.
                    if (target) return action === "cut" ? actions_cut(target) : actions_copy(target, {
                        container: container
                    });
                };
                /* harmony default export */ var actions_default = ClipboardActionDefault;
                function clipboard_typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") clipboard_typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else clipboard_typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return clipboard_typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self, call) {
                    if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) return call;
                    return _assertThisInitialized(self);
                }
                function _assertThisInitialized(self) {
                    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                /**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */ function getAttributeValue(suffix, element) {
                    var attribute = "data-clipboard-".concat(suffix);
                    if (!element.hasAttribute(attribute)) return;
                    return element.getAttribute(attribute);
                }
                /**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */ var Clipboard = /*#__PURE__*/ function(_Emitter) {
                    _inherits(Clipboard, _Emitter);
                    var _super = _createSuper(Clipboard);
                    /**
   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
   * @param {Object} options
   */ function Clipboard(trigger, options) {
                        var _this;
                        _classCallCheck(this, Clipboard);
                        _this = _super.call(this);
                        _this.resolveOptions(options);
                        _this.listenClick(trigger);
                        return _this;
                    }
                    /**
   * Defines if attributes would be resolved using internal setter functions
   * or custom functions that were passed in the constructor.
   * @param {Object} options
   */ _createClass(Clipboard, [
                        {
                            key: "resolveOptions",
                            value: function resolveOptions() {
                                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                this.action = typeof options.action === "function" ? options.action : this.defaultAction;
                                this.target = typeof options.target === "function" ? options.target : this.defaultTarget;
                                this.text = typeof options.text === "function" ? options.text : this.defaultText;
                                this.container = clipboard_typeof(options.container) === "object" ? options.container : document.body;
                            }
                        },
                        {
                            key: "listenClick",
                            value: function listenClick(trigger) {
                                var _this2 = this;
                                this.listener = listen_default()(trigger, "click", function(e) {
                                    return _this2.onClick(e);
                                });
                            }
                        },
                        {
                            key: "onClick",
                            value: function onClick(e) {
                                var trigger = e.delegateTarget || e.currentTarget;
                                var action = this.action(trigger) || "copy";
                                var text = actions_default({
                                    action: action,
                                    container: this.container,
                                    target: this.target(trigger),
                                    text: this.text(trigger)
                                }); // Fires an event based on the copy operation result.
                                this.emit(text ? "success" : "error", {
                                    action: action,
                                    text: text,
                                    trigger: trigger,
                                    clearSelection: function clearSelection() {
                                        if (trigger) trigger.focus();
                                        window.getSelection().removeAllRanges();
                                    }
                                });
                            }
                        },
                        {
                            key: "defaultAction",
                            value: function defaultAction(trigger) {
                                return getAttributeValue("action", trigger);
                            }
                        },
                        {
                            key: "defaultTarget",
                            value: function defaultTarget(trigger) {
                                var selector = getAttributeValue("target", trigger);
                                if (selector) return document.querySelector(selector);
                            }
                        },
                        {
                            key: "defaultText",
                            /**
     * Default `text` lookup function.
     * @param {Element} trigger
     */ value: function defaultText(trigger) {
                                return getAttributeValue("text", trigger);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.listener.destroy();
                            }
                        }
                    ], [
                        {
                            key: "copy",
                            value: function copy(target) {
                                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                                    container: document.body
                                };
                                return actions_copy(target, options);
                            }
                        },
                        {
                            key: "cut",
                            value: function cut(target) {
                                return actions_cut(target);
                            }
                        },
                        {
                            key: "isSupported",
                            value: function isSupported() {
                                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
                                    "copy",
                                    "cut"
                                ];
                                var actions = typeof action === "string" ? [
                                    action
                                ] : action;
                                var support = !!document.queryCommandSupported;
                                actions.forEach(function(action) {
                                    support = support && !!document.queryCommandSupported(action);
                                });
                                return support;
                            }
                        }
                    ]);
                    return Clipboard;
                }(tiny_emitter_default());
                /* harmony default export */ var clipboard = Clipboard;
            /***/ },
            /***/ 828: /***/ function(module1) {
                var DOCUMENT_NODE_TYPE = 9;
                /**
 * A polyfill for Element.matches()
 */ if (typeof Element !== "undefined" && !Element.prototype.matches) {
                    var proto = Element.prototype;
                    proto.matches = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector;
                }
                /**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */ function closest(element, selector) {
                    while(element && element.nodeType !== DOCUMENT_NODE_TYPE){
                        if (typeof element.matches === "function" && element.matches(selector)) return element;
                        element = element.parentNode;
                    }
                }
                module1.exports = closest;
            /***/ },
            /***/ 438: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var closest = __webpack_require__(828);
                /**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function _delegate(element, selector, type, callback, useCapture) {
                    var listenerFn = listener.apply(this, arguments);
                    element.addEventListener(type, listenerFn, useCapture);
                    return {
                        destroy: function() {
                            element.removeEventListener(type, listenerFn, useCapture);
                        }
                    };
                }
                /**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function delegate(elements, selector, type, callback, useCapture) {
                    // Handle the regular Element usage
                    if (typeof elements.addEventListener === "function") return _delegate.apply(null, arguments);
                    // Handle Element-less usage, it defaults to global delegation
                    if (typeof type === "function") // Use `document` as the first parameter, then apply arguments
                    // This is a short way to .unshift `arguments` without running into deoptimizations
                    return _delegate.bind(null, document).apply(null, arguments);
                    // Handle Selector-based usage
                    if (typeof elements === "string") elements = document.querySelectorAll(elements);
                    // Handle Array-like based usage
                    return Array.prototype.map.call(elements, function(element) {
                        return _delegate(element, selector, type, callback, useCapture);
                    });
                }
                /**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */ function listener(element, selector, type, callback) {
                    return function(e) {
                        e.delegateTarget = closest(e.target, selector);
                        if (e.delegateTarget) callback.call(element, e);
                    };
                }
                module1.exports = delegate;
            /***/ },
            /***/ 879: /***/ function(__unused_webpack_module, exports) {
                /**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.node = function(value) {
                    return value !== undefined && value instanceof HTMLElement && value.nodeType === 1;
                };
                /**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.nodeList = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return value !== undefined && (type === "[object NodeList]" || type === "[object HTMLCollection]") && "length" in value && (value.length === 0 || exports.node(value[0]));
                };
                /**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.string = function(value) {
                    return typeof value === "string" || value instanceof String;
                };
                /**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.fn = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return type === "[object Function]";
                };
            /***/ },
            /***/ 370: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var is = __webpack_require__(879);
                var delegate = __webpack_require__(438);
                /**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listen(target, type, callback) {
                    if (!target && !type && !callback) throw new Error("Missing required arguments");
                    if (!is.string(type)) throw new TypeError("Second argument must be a String");
                    if (!is.fn(callback)) throw new TypeError("Third argument must be a Function");
                    if (is.node(target)) return listenNode(target, type, callback);
                    else if (is.nodeList(target)) return listenNodeList(target, type, callback);
                    else if (is.string(target)) return listenSelector(target, type, callback);
                    else throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList");
                }
                /**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNode(node, type, callback) {
                    node.addEventListener(type, callback);
                    return {
                        destroy: function() {
                            node.removeEventListener(type, callback);
                        }
                    };
                }
                /**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNodeList(nodeList, type, callback) {
                    Array.prototype.forEach.call(nodeList, function(node) {
                        node.addEventListener(type, callback);
                    });
                    return {
                        destroy: function() {
                            Array.prototype.forEach.call(nodeList, function(node) {
                                node.removeEventListener(type, callback);
                            });
                        }
                    };
                }
                /**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenSelector(selector, type, callback) {
                    return delegate(document.body, selector, type, callback);
                }
                module1.exports = listen;
            /***/ },
            /***/ 817: /***/ function(module1) {
                function select(element) {
                    var selectedText;
                    if (element.nodeName === "SELECT") {
                        element.focus();
                        selectedText = element.value;
                    } else if (element.nodeName === "INPUT" || element.nodeName === "TEXTAREA") {
                        var isReadOnly = element.hasAttribute("readonly");
                        if (!isReadOnly) element.setAttribute("readonly", "");
                        element.select();
                        element.setSelectionRange(0, element.value.length);
                        if (!isReadOnly) element.removeAttribute("readonly");
                        selectedText = element.value;
                    } else {
                        if (element.hasAttribute("contenteditable")) element.focus();
                        var selection = window.getSelection();
                        var range = document.createRange();
                        range.selectNodeContents(element);
                        selection.removeAllRanges();
                        selection.addRange(range);
                        selectedText = selection.toString();
                    }
                    return selectedText;
                }
                module1.exports = select;
            /***/ },
            /***/ 279: /***/ function(module1) {
                function E() {
                // Keep this empty so it's easier to inherit from
                // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
                }
                E.prototype = {
                    on: function(name, callback, ctx) {
                        var e = this.e || (this.e = {});
                        (e[name] || (e[name] = [])).push({
                            fn: callback,
                            ctx: ctx
                        });
                        return this;
                    },
                    once: function(name, callback, ctx) {
                        var self = this;
                        function listener() {
                            self.off(name, listener);
                            callback.apply(ctx, arguments);
                        }
                        listener._ = callback;
                        return this.on(name, listener, ctx);
                    },
                    emit: function(name) {
                        var data = [].slice.call(arguments, 1);
                        var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
                        var i = 0;
                        var len = evtArr.length;
                        for(i; i < len; i++)evtArr[i].fn.apply(evtArr[i].ctx, data);
                        return this;
                    },
                    off: function(name, callback) {
                        var e = this.e || (this.e = {});
                        var evts = e[name];
                        var liveEvents = [];
                        if (evts && callback) {
                            for(var i = 0, len = evts.length; i < len; i++)if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
                        }
                        // Remove event from queue to prevent memory leak
                        // Suggested by https://github.com/lazd
                        // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
                        liveEvents.length ? e[name] = liveEvents : delete e[name];
                        return this;
                    }
                };
                module1.exports = E;
                module1.exports.TinyEmitter = E;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ if (__webpack_module_cache__[moduleId]) /******/ return __webpack_module_cache__[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1["default"];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /************************************************************************/ /******/ // module exports must be returned from runtime so entry inlining is disabled
        /******/ // startup
        /******/ // Load entry module and return exports
        /******/ return __webpack_require__(686);
    /******/ }().default;
});

});

parcelRegister("9sdkt", function(module, exports) {

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
function $0a5b787a54ab9d0d$var$Tooltip(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: `tooltip has-icon is-tooltip-${props.position} ${props.noMultiline ? "" : "is-tooltip-multiline"} is-hidden-mobile`,
        "data-tooltip": props.text,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
            className: "icon is-small",
            src: props.img,
            alt: props.altText || props.text
        })
    });
}
$0a5b787a54ab9d0d$var$Tooltip.propTypes = {
    text: $c9Z8w.string.isRequired,
    position: $c9Z8w.string,
    img: $c9Z8w.string.isRequired,
    noMultiline: $c9Z8w.bool,
    altText: $c9Z8w.string
};
$0a5b787a54ab9d0d$var$Tooltip.defaultProps = {
    position: "right",
    noMultiline: false,
    altText: null
};
module.exports = $0a5b787a54ab9d0d$var$Tooltip;

});

/* eslint-env browser */ // require('isomorphic-fetch');
// require('es6-promise').polyfill();
// require('@babel/polyfill');

var $ayMG0 = parcelRequire("ayMG0");
var $0ac28f67a425659a$exports = {};
/*
   Use Notes: The Trans component
   The Trans component is somewhat confusingly formatted. (Reading the i18next v9 documentation for the component is strongly suggested.)
   Using the Trans component necessitates two steps: making a key-value pair (the translation) in a namespace file, and using the Trans component on the string that will be tokenized.
   The Trans component is to be preferred to props.t when the translated string has multiple components or formatting: ex. components within the string, <strong> or <u> tags, and so forth.
   When enclosed by the Trans component, the string is essentially delimited by inner components or formatting, starting with index 0:
   For example, "Well, <strong>hello</strong>, world!" is "split into" three segments: 0: "Well, ", 1: "hello", 2: ", world!"
   In the namespace file, you would have a key-value pair something similar to: key: "Well, <1>hello</1>, world!"
   In the Trans component, all that is important is that the structure of the string maintains the delimiting structure.
   So you could write: <Trans i18nKey="key">Text0<strong>Text1</strong>Text2</Trans>"
   And then i18next will make substitutions based on the locale. So, for the English namespace, we will have:
   "Text0" is substituted with "Well, ", "Text1" with "hello", and "Text2" with ", world!"
   What is most important to remember is that the text itself in the Trans component is not important. Our Trans component could also be
   <Trans i18nKey="key">Unicorn<strong>Rainbow</strong>Flowers</Trans>" and the tokenization would still work, as the essential "delimiting structure" is still maintained.
   The convention used here is to make the Trans component text numbers, for ease of reading;
   For example, following our example above, the Trans component would look like this:
   <Trans i18nKey="key">0<strong>1</strong>2</Trans>
   For a working example of this, see TermsOfService.jsx.
   Alternately, find a copy of the documentation located at (at the time of this writing) https://react.i18next.com/legacy-v9/trans-component.
*/ /* Use Notes: Pluralization
   i18next has this really nifty feature that handles pluralization. Here's how you do it:
   1. Pass the t function a "count" variable
   2. In the namespace file, include both "token" and "token_plural"
   i18next will automatically decide whether or not to use "token" or "token_plural" depending on the value of quantity!
   For example, let's say you have the plaintext "cat", which you might want to be "cats" sometimes.
   You'd have something like this:
   t('catText', { count }) // where "count" is a variable that tracks the quantity [of cats]
   catText: 'cat', catText_plural: 'cats'
   And then pluralization will be set up! When quantity is 1, it will say "cat"; otherwise, it will say "cats".
   See a woirking example of this in CustomAmenityUnitRow.jsx.
   For more information, also consult the documentation at https://www.i18next.com/translation-function/plurals.
*/ /* Use Notes: withTranslation
   withTranslation is a Higher-Order Component HOC that passes the t function into a component. It wraps module.exports and in so doing, designates which namespace file the component should refer to.
   For example, if LandingPageHero's exports line says "module.exports = withTranslation('landingPage')(LandingPageHero)", this means that by default, LandingPageHero will look for translations in the
   "landingPage" namespace.
   If you want to refer to multiple namespaces within a component, you can specify which namespace a given token should be found in. So, continuing our example above, if LandingPageHero also has a token
   whose translation is found in the "common" namespace, you can use the following notation to designate this:
      props.t('common:someToken');
   A good example of this can be seen at SpaceCategoryBreakdownMobile, line 66.
*/ const $673ff3dfc4a496de$var$consoleLogger = {
    type: "logger",
    log (args) {
        this.output("log", args);
    },
    warn (args) {
        this.output("warn", args);
    },
    error (args) {
        this.output("error", args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class $673ff3dfc4a496de$var$Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || "i18next:";
        this.logger = concreteLogger || $673ff3dfc4a496de$var$consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, "log", "", true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, "warn", "", true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, "error", "");
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if (typeof args[0] === "string") args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new $673ff3dfc4a496de$var$Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new $673ff3dfc4a496de$var$Logger(this.logger, options);
    }
}
var $673ff3dfc4a496de$var$baseLogger = new $673ff3dfc4a496de$var$Logger();
class $673ff3dfc4a496de$var$EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(" ").forEach((event)=>{
            if (!this.observers[event]) this.observers[event] = new Map();
            const numListeners = this.observers[event].get(listener) || 0;
            this.observers[event].set(listener, numListeners + 1);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event].delete(listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = Array.from(this.observers[event].entries());
            cloned.forEach((_ref)=>{
                let [observer, numTimesAdded] = _ref;
                for(let i = 0; i < numTimesAdded; i++)observer(...args);
            });
        }
        if (this.observers["*"]) {
            const cloned = Array.from(this.observers["*"].entries());
            cloned.forEach((_ref2)=>{
                let [observer, numTimesAdded] = _ref2;
                for(let i = 0; i < numTimesAdded; i++)observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
function $673ff3dfc4a496de$var$defer() {
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $673ff3dfc4a496de$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $673ff3dfc4a496de$var$copy(a, s, t) {
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
}
const $673ff3dfc4a496de$var$lastOfPathSeparatorRegExp = /###/g;
function $673ff3dfc4a496de$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace($673ff3dfc4a496de$var$lastOfPathSeparatorRegExp, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    const stack = typeof path !== "string" ? path : path.split(".");
    let stackIndex = 0;
    while(stackIndex < stack.length - 1){
        if (canNotTraverseDeeper()) return {};
        const key = cleanKey(stack[stackIndex]);
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
        ++stackIndex;
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack[stackIndex])
    };
}
function $673ff3dfc4a496de$var$setPath(object, path, newValue) {
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    if (obj !== undefined || path.length === 1) {
        obj[k] = newValue;
        return;
    }
    let e = path[path.length - 1];
    let p = path.slice(0, path.length - 1);
    let last = $673ff3dfc4a496de$var$getLastOfPath(object, p, Object);
    while(last.obj === undefined && p.length){
        e = `${p[p.length - 1]}.${e}`;
        p = p.slice(0, p.length - 1);
        last = $673ff3dfc4a496de$var$getLastOfPath(object, p, Object);
        if (last && last.obj && typeof last.obj[`${last.k}.${e}`] !== "undefined") last.obj = undefined;
    }
    last.obj[`${last.k}.${e}`] = newValue;
}
function $673ff3dfc4a496de$var$pushPath(object, path, newValue, concat) {
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $673ff3dfc4a496de$var$getPath(object, path) {
    const { obj: obj, k: k } = $673ff3dfc4a496de$var$getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
}
function $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key) {
    const value = $673ff3dfc4a496de$var$getPath(data, key);
    if (value !== undefined) return value;
    return $673ff3dfc4a496de$var$getPath(defaultData, key);
}
function $673ff3dfc4a496de$var$deepExtend(target, source, overwrite) {
    for(const prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $673ff3dfc4a496de$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $673ff3dfc4a496de$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $673ff3dfc4a496de$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $673ff3dfc4a496de$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, (s)=>$673ff3dfc4a496de$var$_entityMap[s]);
    return data;
}
class $673ff3dfc4a496de$var$RegExpCache {
    constructor(capacity){
        this.capacity = capacity;
        this.regExpMap = new Map();
        this.regExpQueue = [];
    }
    getRegExp(pattern) {
        const regExpFromCache = this.regExpMap.get(pattern);
        if (regExpFromCache !== undefined) return regExpFromCache;
        const regExpNew = new RegExp(pattern);
        if (this.regExpQueue.length === this.capacity) this.regExpMap.delete(this.regExpQueue.shift());
        this.regExpMap.set(pattern, regExpNew);
        this.regExpQueue.push(pattern);
        return regExpNew;
    }
}
const $673ff3dfc4a496de$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
const $673ff3dfc4a496de$var$looksLikeObjectPathRegExpCache = new $673ff3dfc4a496de$var$RegExpCache(20);
function $673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    const possibleChars = $673ff3dfc4a496de$var$chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = $673ff3dfc4a496de$var$looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c)=>c === "?" ? "\\?" : c).join("|")})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $673ff3dfc4a496de$var$deepFind(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const tokens = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < tokens.length;){
        if (!current || typeof current !== "object") return undefined;
        let next;
        let nextPath = "";
        for(let j = i; j < tokens.length; ++j){
            if (j !== i) nextPath += keySeparator;
            nextPath += tokens[j];
            next = current[nextPath];
            if (next !== undefined) {
                if ([
                    "string",
                    "number",
                    "boolean"
                ].indexOf(typeof next) > -1 && j < tokens.length - 1) continue;
                i += j - i + 1;
                break;
            }
        }
        current = next;
    }
    return current;
}
function $673ff3dfc4a496de$var$getCleanedCode(code) {
    if (code && code.indexOf("_") > 0) return code.replace("_", "-");
    return code;
}
class $673ff3dfc4a496de$var$ResourceStore extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path;
        if (lng.indexOf(".") > -1) path = lng.split(".");
        else {
            path = [
                lng,
                ns
            ];
            if (key) {
                if (Array.isArray(key)) path.push(...key);
                else if (typeof key === "string" && keySeparator) path.push(...key.split(keySeparator));
                else path.push(key);
            }
        }
        const result = $673ff3dfc4a496de$var$getPath(this.data, path);
        if (!result && !ns && !key && lng.indexOf(".") > -1) {
            lng = path[0];
            ns = path[1];
            key = path.slice(2).join(".");
        }
        if (result || !ignoreJSONStructure || typeof key !== "string") return result;
        return $673ff3dfc4a496de$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        $673ff3dfc4a496de$var$setPath(this.data, path, value);
        if (!options.silent) this.emit("added", lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false,
            skipCopy: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf(".") > -1) {
            path = lng.split(".");
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = $673ff3dfc4a496de$var$getPath(this.data, path) || {};
        if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
        if (deep) $673ff3dfc4a496de$var$deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        $673ff3dfc4a496de$var$setPath(this.data, path, pack);
        if (!options.silent) this.emit("added", lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit("removed", lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === "v1") return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var $673ff3dfc4a496de$var$postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const $673ff3dfc4a496de$var$checkedLoadedFor = {};
class $673ff3dfc4a496de$var$Translator extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $673ff3dfc4a496de$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = ".";
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("translator");
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ":";
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$673ff3dfc4a496de$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key: key,
                namespaces: namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        return {
            key: key,
            namespaces: namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === "object") options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return "";
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key: key, namespaces: namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === "cimode") {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            "[object Number]",
            "[object Function]",
            "[object RegExp]"
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = resType === "[object Array]";
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const hasDefaultValue = $673ff3dfc4a496de$var$Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : "";
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit("missingKey", l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        const suffixes = this.pluralResolver.getSuffixes(language, options);
                        if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) suffixes.push(`${this.options.pluralSeparator}zero`);
                        suffixes.forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved: resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && typeof options.replace !== "string" ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = typeof postProcess === "string" ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $673ff3dfc4a496de$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: {
                ...resolved,
                usedParams: this.getUsedParamsDetails(options)
            },
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if (typeof keys === "string") keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!$673ff3dfc4a496de$var$checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    $673ff3dfc4a496de$var$checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(", ")}" won't get resolved as namespace "${usedNS}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey: usedKey,
            exactUsedKey: exactUsedKey,
            usedLng: usedLng,
            usedNS: usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            "defaultValue",
            "ordinal",
            "context",
            "replace",
            "lng",
            "lngs",
            "fallbackLng",
            "ns",
            "keySeparator",
            "nsSeparator",
            "returnObjects",
            "returnDetails",
            "joinArrays",
            "postProcess",
            "interpolation"
        ];
        const useOptionsReplaceForData = options.replace && typeof options.replace !== "string";
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== "undefined") data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = "defaultValue";
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
function $673ff3dfc4a496de$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
class $673ff3dfc4a496de$var$LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("languageUtils");
    }
    getScriptPartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return null;
        const p = code.split("-");
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === "x") return null;
        return this.formatLanguageCode(p.join("-"));
    }
    getLanguagePartFromCode(code) {
        code = $673ff3dfc4a496de$var$getCleanedCode(code);
        if (!code || code.indexOf("-") < 0) return code;
        const p = code.split("-");
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if (typeof code === "string" && code.indexOf("-") > -1) {
            const specialCases = [
                "hans",
                "hant",
                "latn",
                "cyrl",
                "cans",
                "mong",
                "arab"
            ];
            let p = code.split("-");
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $673ff3dfc4a496de$var$capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $673ff3dfc4a496de$var$capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $673ff3dfc4a496de$var$capitalize(p[2].toLowerCase());
            }
            return p.join("-");
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                if (supportedLng.indexOf("-") > 0 && lngOnly.indexOf("-") < 0 && supportedLng.substring(0, supportedLng.indexOf("-")) === lngOnly) return supportedLng;
                if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === "function") fallbacks = fallbacks(code);
        if (typeof fallbacks === "string") fallbacks = [
            fallbacks
        ];
        if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if (typeof code === "string" && (code.indexOf("-") > -1 || code.indexOf("_") > -1)) {
            if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
            if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
        } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let $673ff3dfc4a496de$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let $673ff3dfc4a496de$var$_rulesPluralsTypes = {
    1: function(n) {
        return Number(n > 1);
    },
    2: function(n) {
        return Number(n != 1);
    },
    3: function(n) {
        return 0;
    },
    4: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function(n) {
        return Number(n >= 2);
    },
    10: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function(n) {
        return Number(n !== 0);
    },
    14: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
const $673ff3dfc4a496de$var$nonIntlVersions = [
    "v1",
    "v2",
    "v3"
];
const $673ff3dfc4a496de$var$intlVersions = [
    "v4"
];
const $673ff3dfc4a496de$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $673ff3dfc4a496de$var$createRules() {
    const rules = {};
    $673ff3dfc4a496de$var$sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: $673ff3dfc4a496de$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
class $673ff3dfc4a496de$var$PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || $673ff3dfc4a496de$var$intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $673ff3dfc4a496de$var$createRules();
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) try {
            return new Intl.PluralRules($673ff3dfc4a496de$var$getCleanedCode(code === "dev" ? "en" : code), {
                type: options.ordinal ? "ordinal" : "cardinal"
            });
        } catch (err) {
            return;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>$673ff3dfc4a496de$var$suffixesOrder[pluralCategory1] - $673ff3dfc4a496de$var$suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return "";
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = "plural";
            else if (suffix === 1) suffix = "";
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === "v1") {
            if (suffix === 1) return "";
            if (typeof suffix === "number") return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !$673ff3dfc4a496de$var$nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
function $673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = $673ff3dfc4a496de$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
        path = $673ff3dfc4a496de$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $673ff3dfc4a496de$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
}
class $673ff3dfc4a496de$var$Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const iOpts = options.interpolation;
        this.escape = iOpts.escape !== undefined ? iOpts.escape : $673ff3dfc4a496de$var$escape;
        this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
        this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
        this.prefix = iOpts.prefix ? $673ff3dfc4a496de$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
        this.suffix = iOpts.suffix ? $673ff3dfc4a496de$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
        this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
        this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
        this.nestingPrefix = iOpts.nestingPrefix ? $673ff3dfc4a496de$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $673ff3dfc4a496de$var$regexEscape("$t(");
        this.nestingSuffix = iOpts.nestingSuffix ? $673ff3dfc4a496de$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $673ff3dfc4a496de$var$regexEscape(")");
        this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
        this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
        this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const getOrResetRegExp = (existingRegExp, pattern)=>{
            if (existingRegExp && existingRegExp.source === pattern) {
                existingRegExp.lastIndex = 0;
                return existingRegExp;
            }
            return new RegExp(pattern, "g");
        };
        this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
        this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
        this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        function regexSafe(val) {
            return val.replace(/\$/g, "$$$$");
        }
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = $673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format($673ff3dfc4a496de$var$deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === "function") {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = typeof temp === "string" ? temp : "";
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = "";
                    }
                } else if (typeof value !== "string" && !this.useRawValueToEscape) value = $673ff3dfc4a496de$var$makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        function handleHasOptions(key, inheritedOptions) {
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
            return key;
        }
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && typeof value !== "string") return value;
            if (typeof value !== "string") value = $673ff3dfc4a496de$var$makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = "";
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
function $673ff3dfc4a496de$var$parseFormatStr(formatStr) {
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        const p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(";");
            opts.forEach((opt)=>{
                if (!opt) return;
                const [key, ...rest] = opt.split(":");
                const val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $673ff3dfc4a496de$var$createCachedFormatter(fn) {
    const cache = {};
    return function invokeFormatter(val, lng, options) {
        const key = lng + JSON.stringify(options);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn($673ff3dfc4a496de$var$getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
class $673ff3dfc4a496de$var$Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: "currency"
                });
                return (val)=>formatter.format(val);
            }),
            datetime: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || "day");
            }),
            list: $673ff3dfc4a496de$var$createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        const iOpts = options.interpolation;
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = $673ff3dfc4a496de$var$createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        const result = formats.reduce((mem, f)=>{
            const { formatName: formatName, formatOptions: formatOptions } = $673ff3dfc4a496de$var$parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
function $673ff3dfc4a496de$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
class $673ff3dfc4a496de$var$Connector extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = $673ff3dfc4a496de$var$baseLogger.create("backendConnector");
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending: pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback: callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit("failedLoading", lng, ns, err);
        if (data) this.store.addResourceBundle(lng, ns, data, undefined, undefined, {
            skipCopy: true
        });
        this.state[name] = err ? -1 : 2;
        const loaded = {};
        this.queue.forEach((q)=>{
            $673ff3dfc4a496de$var$pushPath(q.loaded, [
                lng
            ], ns);
            $673ff3dfc4a496de$var$removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit("loaded", loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng: lng,
                ns: ns,
                fcName: fcName,
                tried: tried,
                wait: wait,
                callback: callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === "function") r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn("No backend was added via i18next.use. Will not load resources.");
            return callback && callback();
        }
        if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
        if (typeof namespaces === "string") namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        const s = name.split("|");
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, "read", undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
            return;
        }
        if (key === undefined || key === null || key === "") return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate: isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === "function") r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
function $673ff3dfc4a496de$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            let ret = {};
            if (typeof args[1] === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if (typeof args[2] === "object" || typeof args[3] === "object") {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value)=>value,
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $673ff3dfc4a496de$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $673ff3dfc4a496de$var$noop() {}
function $673ff3dfc4a496de$var$bindMemberFunctions(inst) {
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
class $673ff3dfc4a496de$var$I18n extends $673ff3dfc4a496de$var$EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = $673ff3dfc4a496de$var$transformOptions(options);
        this.services = {};
        this.logger = $673ff3dfc4a496de$var$baseLogger;
        this.modules = {
            external: []
        };
        $673ff3dfc4a496de$var$bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        this.isInitializing = true;
        if (typeof options === "function") {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if (typeof options.ns === "string") options.defaultNS = options.ns;
            else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = $673ff3dfc4a496de$var$get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...$673ff3dfc4a496de$var$transformOptions(options)
        };
        if (this.options.compatibilityAPI !== "v1") this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        function createClassOnDemand(ClassOrObject) {
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === "function") return new ClassOrObject();
            return ClassOrObject;
        }
        if (!this.options.isClone) {
            if (this.modules.logger) $673ff3dfc4a496de$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else $673ff3dfc4a496de$var$baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== "undefined") formatter = $673ff3dfc4a496de$var$Formatter;
            const lu = new $673ff3dfc4a496de$var$LanguageUtil(this.options);
            this.store = new $673ff3dfc4a496de$var$ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = $673ff3dfc4a496de$var$baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new $673ff3dfc4a496de$var$PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new $673ff3dfc4a496de$var$Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new $673ff3dfc4a496de$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on("*", function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new $673ff3dfc4a496de$var$Translator(this.services, this.options);
            this.translator.on("*", function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
        const storeApi = [
            "getResource",
            "hasResourceBundle",
            "getResourceBundle",
            "getDataByLanguage"
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            "addResource",
            "addResources",
            "addResourceBundle",
            "removeResourceBundle"
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = $673ff3dfc4a496de$var$defer();
        const load = ()=>{
            const finish = (err, t)=>{
                this.isInitializing = false;
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn("init: i18next is already initialized. You should call init just once!");
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log("initialized", this.options);
                this.emit("initialized", this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
        let usedCallback = callback;
        const usedLng = typeof language === "string" ? language : this.language;
        if (typeof language === "function") usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === "cimode") return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === "cimode") return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = $673ff3dfc4a496de$var$noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
        if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
        if (module.type === "backend") this.modules.backend = module;
        if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === "languageDetector") this.modules.languageDetector = module;
        if (module.type === "i18nFormat") this.modules.i18nFormat = module;
        if (module.type === "postProcessor") $673ff3dfc4a496de$var$postProcessor.addPostProcessor(module);
        if (module.type === "formatter") this.modules.formatter = module;
        if (module.type === "3rdParty") this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            "cimode",
            "dev"
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                "cimode",
                "dev"
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = $673ff3dfc4a496de$var$defer();
        this.emit("languageChanging", lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit("languageChanged", l);
                this.logger.log("languageChanged", l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = typeof lngs === "string" ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== "object") {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || ".";
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if (typeof lng === "string") fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === "cimode") return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if (typeof ns === "string") ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = $673ff3dfc4a496de$var$defer();
        if (typeof lngs === "string") lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return "rtl";
        const rtlLngs = [
            "ar",
            "shu",
            "sqr",
            "ssh",
            "xaa",
            "yhd",
            "yud",
            "aao",
            "abh",
            "abv",
            "acm",
            "acq",
            "acw",
            "acx",
            "acy",
            "adf",
            "ads",
            "aeb",
            "aec",
            "afb",
            "ajp",
            "apc",
            "apd",
            "arb",
            "arq",
            "ars",
            "ary",
            "arz",
            "auz",
            "avl",
            "ayh",
            "ayl",
            "ayn",
            "ayp",
            "bbz",
            "pga",
            "he",
            "iw",
            "ps",
            "pbt",
            "pbu",
            "pst",
            "prp",
            "prd",
            "ug",
            "ur",
            "ydd",
            "yds",
            "yih",
            "ji",
            "yi",
            "hbo",
            "men",
            "xmn",
            "fa",
            "jpr",
            "peo",
            "pes",
            "prs",
            "dv",
            "sam",
            "ckb"
        ];
        const languageUtils = this.services && this.services.languageUtils || new $673ff3dfc4a496de$var$LanguageUtil($673ff3dfc4a496de$var$get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new $673ff3dfc4a496de$var$I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $673ff3dfc4a496de$var$noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new $673ff3dfc4a496de$var$I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            "store",
            "services",
            "language"
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new $673ff3dfc4a496de$var$ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new $673ff3dfc4a496de$var$Translator(clone.services, mergedOptions);
        clone.translator.on("*", function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const $673ff3dfc4a496de$export$2e2bcd8739ae039 = $673ff3dfc4a496de$var$I18n.createInstance();
$673ff3dfc4a496de$export$2e2bcd8739ae039.createInstance = $673ff3dfc4a496de$var$I18n.createInstance;
const $673ff3dfc4a496de$export$99152e8d49ca4e7d = $673ff3dfc4a496de$export$2e2bcd8739ae039.createInstance;
const $673ff3dfc4a496de$export$147ec2801e896265 = $673ff3dfc4a496de$export$2e2bcd8739ae039.dir;
const $673ff3dfc4a496de$export$2cd8252107eb640b = $673ff3dfc4a496de$export$2e2bcd8739ae039.init;
const $673ff3dfc4a496de$export$d3d08d944062d7e = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadResources;
const $673ff3dfc4a496de$export$a5d9bf5d83fcab09 = $673ff3dfc4a496de$export$2e2bcd8739ae039.reloadResources;
const $673ff3dfc4a496de$export$1f96ae73734a86cc = $673ff3dfc4a496de$export$2e2bcd8739ae039.use;
const $673ff3dfc4a496de$export$61465194746e7fd2 = $673ff3dfc4a496de$export$2e2bcd8739ae039.changeLanguage;
const $673ff3dfc4a496de$export$f90d180fc7da3b3b = $673ff3dfc4a496de$export$2e2bcd8739ae039.getFixedT;
const $673ff3dfc4a496de$export$625550452a3fa3ec = $673ff3dfc4a496de$export$2e2bcd8739ae039.t;
const $673ff3dfc4a496de$export$f7e9f41ea797a17 = $673ff3dfc4a496de$export$2e2bcd8739ae039.exists;
const $673ff3dfc4a496de$export$2b4b218e406d2d00 = $673ff3dfc4a496de$export$2e2bcd8739ae039.setDefaultNamespace;
const $673ff3dfc4a496de$export$93d9ee97c1ad3f31 = $673ff3dfc4a496de$export$2e2bcd8739ae039.hasLoadedNamespace;
const $673ff3dfc4a496de$export$83be934b53fff43b = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadNamespaces;
const $673ff3dfc4a496de$export$8cd7e7a54fa865bc = $673ff3dfc4a496de$export$2e2bcd8739ae039.loadLanguages;


var $0ac28f67a425659a$require$i18n = $673ff3dfc4a496de$export$2e2bcd8739ae039;

var $acw62 = parcelRequire("acw62");

var $3p9rK = parcelRequire("3p9rK");

var $acw62 = parcelRequire("acw62");
var $dca61ba26e2661d8$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $dca61ba26e2661d8$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $69084eaa2e6a0d50$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $69084eaa2e6a0d50$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($dca61ba26e2661d8$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($69084eaa2e6a0d50$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $69084eaa2e6a0d50$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $69084eaa2e6a0d50$var$i = /^\s*$/, $69084eaa2e6a0d50$var$s = Object.create(null);
function $69084eaa2e6a0d50$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($69084eaa2e6a0d50$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $69084eaa2e6a0d50$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $69084eaa2e6a0d50$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($69084eaa2e6a0d50$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $69084eaa2e6a0d50$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $69084eaa2e6a0d50$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $69084eaa2e6a0d50$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $69084eaa2e6a0d50$var$a("", t);
        }, "");
    }
};
var $69084eaa2e6a0d50$export$2e2bcd8739ae039 = $69084eaa2e6a0d50$var$c;


function $cfb6e0167e0b350d$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
}
const $cfb6e0167e0b350d$var$alreadyWarned = {};
function $cfb6e0167e0b350d$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $cfb6e0167e0b350d$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $cfb6e0167e0b350d$var$alreadyWarned[args[0]] = new Date();
    $cfb6e0167e0b350d$export$c106dd0671a0fc2d(...args);
}
const $cfb6e0167e0b350d$var$loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    };
function $cfb6e0167e0b350d$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $cfb6e0167e0b350d$var$loadedClb(i18n, cb));
}
function $cfb6e0167e0b350d$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === "string") ns = [
        ns
    ];
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $cfb6e0167e0b350d$var$loadedClb(i18n, cb));
}
function $cfb6e0167e0b350d$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const lng = i18n.languages[0];
    const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    const lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    const loadNotPending = (l, n)=>{
        const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $cfb6e0167e0b350d$export$93d9ee97c1ad3f31(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $cfb6e0167e0b350d$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $cfb6e0167e0b350d$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $cfb6e0167e0b350d$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}


const $d7f2d92b0368699f$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const $d7f2d92b0368699f$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "\u2026",
    "&#8230;": "\u2026",
    "&#x2F;": "/",
    "&#47;": "/"
};
const $d7f2d92b0368699f$var$unescapeHtmlEntity = (m)=>$d7f2d92b0368699f$var$htmlEntities[m];
const $d7f2d92b0368699f$export$e8bacd2802a88316 = (text)=>text.replace($d7f2d92b0368699f$var$matchHtmlEntity, $d7f2d92b0368699f$var$unescapeHtmlEntity);


let $4f75eea5b29ffc65$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: $d7f2d92b0368699f$export$e8bacd2802a88316
};
function $4f75eea5b29ffc65$export$2e2366488d12e20d() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $4f75eea5b29ffc65$var$defaultOptions = {
        ...$4f75eea5b29ffc65$var$defaultOptions,
        ...options
    };
}
function $4f75eea5b29ffc65$export$212bb2fc580a90a8() {
    return $4f75eea5b29ffc65$var$defaultOptions;
}


let $1d04edb3ddd0d89e$var$i18nInstance;
function $1d04edb3ddd0d89e$export$a039134f2fc7e0(instance) {
    $1d04edb3ddd0d89e$var$i18nInstance = instance;
}
function $1d04edb3ddd0d89e$export$64af334f494c2f47() {
    return $1d04edb3ddd0d89e$var$i18nInstance;
}


function $acffcb171536f8e9$var$hasChildren(node, checkLength) {
    if (!node) return false;
    const base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $acffcb171536f8e9$var$getChildren(node) {
    if (!node) return [];
    const children = node.props ? node.props.children : node.children;
    return node.props && node.props.i18nIsDynamicList ? $acffcb171536f8e9$var$getAsArray(children) : children;
}
function $acffcb171536f8e9$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every((child)=>(0, $acw62.isValidElement)(child));
}
function $acffcb171536f8e9$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $acffcb171536f8e9$var$mergeProps(source, target) {
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $acffcb171536f8e9$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    let stringNode = "";
    const childrenArray = $acffcb171536f8e9$var$getAsArray(children);
    const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach((child, childIndex)=>{
        if (typeof child === "string") stringNode += `${child}`;
        else if ((0, $acw62.isValidElement)(child)) {
            const childPropsCount = Object.keys(child.props).length;
            const shouldKeepChild = keepArray.indexOf(child.type) > -1;
            const childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += `<${child.type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += `<${childIndex}></${childIndex}>`;
            else if (child.props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += `<${child.type}>${childChildren}</${child.type}>`;
            else {
                const content = $acffcb171536f8e9$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if (typeof child === "object") {
            const { format: format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else (0, $cfb6e0167e0b350d$export$c106dd0671a0fc2d)(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
}
function $acffcb171536f8e9$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    function getData(childs) {
        const childrenArray = $acffcb171536f8e9$var$getAsArray(childs);
        childrenArray.forEach((child)=>{
            if (typeof child === "string") return;
            if ($acffcb171536f8e9$var$hasChildren(child)) getData($acffcb171536f8e9$var$getChildren(child));
            else if (typeof child === "object" && !(0, $acw62.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    const ast = (0, $69084eaa2e6a0d50$export$2e2bcd8739ae039).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    function renderInner(child, node, rootReactNode) {
        const childs = $acffcb171536f8e9$var$getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $acffcb171536f8e9$var$hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props && child.props.i18nIsDynamicList ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) {
            child.children = inner;
            mem.push((0, $acw62.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, $acw62.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(c.type, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, props, {
                key: i,
                ref: c.ref
            }, isVoid ? {} : {
                children: inner
            }));
        }));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        const reactNodes = $acffcb171536f8e9$var$getAsArray(reactNode);
        const astNodes = $acffcb171536f8e9$var$getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? $acffcb171536f8e9$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, $acw62.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && $acffcb171536f8e9$var$hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && typeof child === "object" && child.dummy && !isElement;
                const isKnownComponent = typeof children === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($acffcb171536f8e9$var$hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $acw62.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $acw62.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if (typeof child === "object" && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === "text") {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $acw62.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    }
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $acffcb171536f8e9$var$getAsArray(children || []));
    return $acffcb171536f8e9$var$getChildren(result[0]);
}
function $acffcb171536f8e9$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const i18n = i18nFromProps || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    if (context) tOptions.context = context;
    const reactI18nextOptions = {
        ...(0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)(),
        ...i18n.options && i18n.options.react
    };
    let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    const nodeAsString = $acffcb171536f8e9$export$4f7a36dd898f1267(children, reactI18nextOptions);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey: hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options && i18n.options.interpolation && i18n.options.interpolation.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: "#$?",
            suffix: "?$#"
        }
    };
    const combinedTOpts = {
        ...tOptions,
        count: count,
        ...values,
        ...interpolationOverride,
        defaultValue: defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    if (components) Object.keys(components).forEach((c)=>{
        const comp = components[c];
        if (typeof comp.type === "function" || !comp.props || !comp.props.children || translation.indexOf(`${c}/>`) < 0 && translation.indexOf(`${c} />`) < 0) return;
        function Componentized() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, comp);
        }
        components[c] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Componentized, null);
    });
    const content = $acffcb171536f8e9$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $acw62.createElement)(useAsParent, additionalProps, content) : content;
}



var $acw62 = parcelRequire("acw62");




const $26bfda595e5aa141$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init (instance) {
        (0, $4f75eea5b29ffc65$export$2e2366488d12e20d)(instance.options.react);
        (0, $1d04edb3ddd0d89e$export$a039134f2fc7e0)(instance);
    }
};


const $0636c84fe4549f1f$export$5603ab5ced17ce64 = (0, $acw62.createContext)();
class $0636c84fe4549f1f$export$ea171b67e3820290 {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
function $0636c84fe4549f1f$export$30ff0342ccf735a(ForComponent) {
    return (ctx)=>new Promise((resolve)=>{
            const i18nInitialProps = $0636c84fe4549f1f$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then((componentsInitialProps)=>{
                resolve({
                    ...componentsInitialProps,
                    ...i18nInitialProps
                });
            });
            else resolve(i18nInitialProps);
        });
}
function $0636c84fe4549f1f$export$704200e5d0b9e8f() {
    const i18n = (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


function $e04d9533328ca578$export$8d6a9236f2e3f2ce(_ref) {
    let { children: children, count: count, parent: parent, i18nKey: i18nKey, context: context, tOptions: tOptions = {}, values: values, defaults: defaults, components: components, ns: ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape: shouldUnescape, ...additionalProps } = _ref;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    const t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $acffcb171536f8e9$export$8d6a9236f2e3f2ce)({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape,
        ...additionalProps
    });
}




var $acw62 = parcelRequire("acw62");


const $3765cebd031b52c0$var$usePrevious = (value, ignore)=>{
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $3765cebd031b52c0$export$9fc83ad70ead8663(ns) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $0636c84fe4549f1f$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $cfb6e0167e0b350d$export$5b28268982f175ba)("You will need to pass in an i18next instance by using initReactI18next");
        const notReadyT = (k, optsOrDefaultValue)=>{
            if (typeof optsOrDefaultValue === "string") return optsOrDefaultValue;
            if (optsOrDefaultValue && typeof optsOrDefaultValue === "object" && typeof optsOrDefaultValue.defaultValue === "string") return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $cfb6e0167e0b350d$export$5b28268982f175ba)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    const i18nOptions = {
        ...(0, $4f75eea5b29ffc65$export$212bb2fc580a90a8)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense: useSuspense, keyPrefix: keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, $cfb6e0167e0b350d$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions));
    function getT() {
        return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    const [t, setT] = (0, $acw62.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = $3765cebd031b52c0$var$usePrevious(joinedNS);
    const isMounted = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        const { bindI18n: bindI18n, bindI18nStore: bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $cfb6e0167e0b350d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
            else (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    const isInitial = (0, $acw62.useRef)(true);
    (0, $acw62.useEffect)(()=>{
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, $cfb6e0167e0b350d$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, $cfb6e0167e0b350d$export$83be934b53fff43b)(i18n, namespaces, ()=>resolve());
    });
}



var $acw62 = parcelRequire("acw62");


function $d9bd4545752f9667$export$2dcb0053efd21124(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            let { forwardedRef: forwardedRef, ...rest } = _ref;
            const [t, i18n, ready] = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t: t,
                i18n: i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $acw62.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, $acw62.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, $acw62.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}



function $868685a400877801$export$b63289fbda65eed1(props) {
    const { ns: ns, children: children, ...options } = props;
    const [t, i18n, ready] = (0, $3765cebd031b52c0$export$9fc83ad70ead8663)(ns, options);
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}



var $acw62 = parcelRequire("acw62");

function $c313608318d394ab$export$1325e8699caa160f(_ref) {
    let { i18n: i18n, defaultNS: defaultNS, children: children } = _ref;
    const value = (0, $acw62.useMemo)(()=>({
            i18n: i18n,
            defaultNS: defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, $acw62.createElement)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

function $d97c91d803f78bcc$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, $acw62.useContext)((0, $0636c84fe4549f1f$export$5603ab5ced17ce64)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, $1d04edb3ddd0d89e$export$64af334f494c2f47)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}




function $afd5c8e3ef499392$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            let { initialI18nStore: initialI18nStore, initialLanguage: initialLanguage, ...rest } = _ref;
            (0, $d97c91d803f78bcc$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $acw62.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, $0636c84fe4549f1f$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, $cfb6e0167e0b350d$export$be63e0664592e141)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}







const $2843511fe0fbbf82$export$324d90190a8b822a = ()=>"";
const $2843511fe0fbbf82$export$2da9be4cfdb689b1 = ()=>"";
const $2843511fe0fbbf82$export$98e628dec113755e = ()=>"";
const $2843511fe0fbbf82$export$2e6c959c16ff56b8 = ()=>"";
const $2843511fe0fbbf82$export$4e35d5c922a95490 = ()=>"";
const $2843511fe0fbbf82$export$720a3b9db04b7a0f = ()=>"";


var $0ac28f67a425659a$require$initReactI18next = $26bfda595e5aa141$export$ae7e14d40d89f296;
var $b8cd368031f674c5$exports = {};
function $4d35ca0862055760$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}



var $4ZreY = parcelRequire("4ZreY");
function $94019358ecbcf36b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $4ZreY.default)(descriptor.key), descriptor);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $94019358ecbcf36b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $94019358ecbcf36b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}


var $60196a4650e96cb1$var$arr = [];
var $60196a4650e96cb1$var$each = $60196a4650e96cb1$var$arr.forEach;
var $60196a4650e96cb1$var$slice = $60196a4650e96cb1$var$arr.slice;
function $60196a4650e96cb1$var$defaults(obj) {
    $60196a4650e96cb1$var$each.call($60196a4650e96cb1$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $60196a4650e96cb1$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $60196a4650e96cb1$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || "/";
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error("maxAge should be a Number");
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$60196a4650e96cb1$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
};
var $60196a4650e96cb1$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: "/",
            sameSite: "strict"
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $60196a4650e96cb1$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, "", -1);
    }
};
var $60196a4650e96cb1$var$cookie$1 = {
    name: "cookie",
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== "undefined") {
            var c = $60196a4650e96cb1$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== "undefined") $60196a4650e96cb1$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $60196a4650e96cb1$var$querystring = {
    name: "querystring",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1) search = window.location.hash.substring(window.location.hash.indexOf("?"));
            var query = search.substring(1);
            var params = query.split("&");
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf("=");
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $60196a4650e96cb1$var$hasLocalStorageSupport = null;
var $60196a4650e96cb1$var$localStorageAvailable = function localStorageAvailable() {
    if ($60196a4650e96cb1$var$hasLocalStorageSupport !== null) return $60196a4650e96cb1$var$hasLocalStorageSupport;
    try {
        $60196a4650e96cb1$var$hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
        var testKey = "i18next.translate.boo";
        window.localStorage.setItem(testKey, "foo");
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasLocalStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasLocalStorageSupport;
};
var $60196a4650e96cb1$var$localStorage = {
    name: "localStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $60196a4650e96cb1$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $60196a4650e96cb1$var$hasSessionStorageSupport = null;
var $60196a4650e96cb1$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($60196a4650e96cb1$var$hasSessionStorageSupport !== null) return $60196a4650e96cb1$var$hasSessionStorageSupport;
    try {
        $60196a4650e96cb1$var$hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
        var testKey = "i18next.translate.boo";
        window.sessionStorage.setItem(testKey, "foo");
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $60196a4650e96cb1$var$hasSessionStorageSupport = false;
    }
    return $60196a4650e96cb1$var$hasSessionStorageSupport;
};
var $60196a4650e96cb1$var$sessionStorage = {
    name: "sessionStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $60196a4650e96cb1$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $60196a4650e96cb1$var$navigator$1 = {
    name: "navigator",
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== "undefined") {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $60196a4650e96cb1$var$htmlTag = {
    name: "htmlTag",
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== "undefined" ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === "function") found = htmlTag.getAttribute("lang");
        return found;
    }
};
var $60196a4650e96cb1$var$path = {
    name: "path",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === "number") {
                    if (typeof language[options.lookupFromPathIndex] !== "string") return undefined;
                    found = language[options.lookupFromPathIndex].replace("/", "");
                } else found = language[0].replace("/", "");
            }
        }
        return found;
    }
};
var $60196a4650e96cb1$var$subdomain = {
    name: "subdomain",
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === "number" ? options.lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
function $60196a4650e96cb1$var$getDefaults() {
    return {
        order: [
            "querystring",
            "cookie",
            "localStorage",
            "sessionStorage",
            "navigator",
            "htmlTag"
        ],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        // cache user language
        caches: [
            "localStorage"
        ],
        excludeCacheFor: [
            "cimode"
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: function convertDetectedLanguage(l) {
            return l;
        }
    };
}
var $60196a4650e96cb1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $4d35ca0862055760$export$2e2bcd8739ae039)(this, Browser);
        this.type = "languageDetector";
        this.detectors = {};
        this.init(services, options);
    }
    (0, $94019358ecbcf36b$export$2e2bcd8739ae039)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services || {
                    languageUtils: {}
                }; // this way the language detector can be used without i18next
                this.options = $60196a4650e96cb1$var$defaults(options, this.options || {}, $60196a4650e96cb1$var$getDefaults());
                if (typeof this.options.convertDetectedLanguage === "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1) this.options.convertDetectedLanguage = function(l) {
                    return l.replace("-", "_");
                };
                // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($60196a4650e96cb1$var$cookie$1);
                this.addDetector($60196a4650e96cb1$var$querystring);
                this.addDetector($60196a4650e96cb1$var$localStorage);
                this.addDetector($60196a4650e96cb1$var$sessionStorage);
                this.addDetector($60196a4650e96cb1$var$navigator$1);
                this.addDetector($60196a4650e96cb1$var$htmlTag);
                this.addDetector($60196a4650e96cb1$var$path);
                this.addDetector($60196a4650e96cb1$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
                return this;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === "string") lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                detected = detected.map(function(d) {
                    return _this.options.convertDetectedLanguage(d);
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
$60196a4650e96cb1$export$2e2bcd8739ae039.type = "languageDetector";


var $b8cd368031f674c5$require$BrowserLngDetector = $60196a4650e96cb1$export$2e2bcd8739ae039;
function $1d366c1d1cf4940d$export$1518ffc4a8ff94f2(object, path, newValue) {
    var stack;
    if (typeof path !== "string") stack = [].concat(path);
    if (typeof path === "string") stack = path.split(".");
    while(stack.length > 1){
        var _key = stack.shift();
        if (_key.indexOf("###") > -1) _key = _key.replace(/###/g, ".");
        if (!object[_key]) object[_key] = {};
        object = object[_key];
    }
    var key = stack.shift();
    if (key.indexOf("###") > -1) key = key.replace(/###/g, ".");
    object[key] = newValue;
}
var $1d366c1d1cf4940d$var$arr = [];
var $1d366c1d1cf4940d$var$each = $1d366c1d1cf4940d$var$arr.forEach;
var $1d366c1d1cf4940d$var$slice = $1d366c1d1cf4940d$var$arr.slice;
function $1d366c1d1cf4940d$export$ebe90cb607ad99e(obj) {
    $1d366c1d1cf4940d$var$each.call($1d366c1d1cf4940d$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
function $1d366c1d1cf4940d$export$8b58be045bf06082(obj) {
    $1d366c1d1cf4940d$var$each.call($1d366c1d1cf4940d$var$slice.call(arguments, 1), function(source) {
        if (source) for(var prop in source)obj[prop] = source[prop];
    });
    return obj;
}
function $1d366c1d1cf4940d$export$deaa871f179221a4(url, lookupFromPathIndex) {
    var first = "";
    var pos = lookupFromPathIndex;
    if (url[0] === "/") {
        pos++;
        first = "/";
    }
    var parts = url.split("/");
    parts.splice(pos, 1);
    url = parts.join("/");
    if (url[0] !== "/") url = first + url;
    return url;
}



var $54e44d35cf108a73$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $54e44d35cf108a73$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || "/";
    var value = encodeURIComponent(val);
    var str = name + "=" + value;
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge)) throw new Error("maxAge should be a Number");
        str += "; Max-Age=" + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$54e44d35cf108a73$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=" + opt.domain;
    }
    if (opt.path) {
        if (!$54e44d35cf108a73$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=" + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=" + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
};
var $54e44d35cf108a73$export$2e2bcd8739ae039 = {
    name: "cookie",
    lookup: function lookup(req, res, options) {
        var found;
        if (options.lookupCookie && typeof req !== "undefined") {
            var cookies = options.getCookies(req);
            if (cookies) found = cookies[options.lookupCookie];
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(req, res, lng) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (options.lookupCookie && req !== "undefined") {
            var expirationDate = options.cookieExpirationDate;
            if (!expirationDate) {
                expirationDate = new Date();
                expirationDate.setFullYear(expirationDate.getFullYear() + 1);
            }
            var cookieOptions = {
                expires: expirationDate,
                domain: options.cookieDomain,
                path: options.cookiePath,
                httpOnly: false,
                overwrite: true,
                sameSite: options.cookieSameSite
            };
            if (options.cookieSecure) cookieOptions.secure = options.cookieSecure;
            var existingCookie = options.getHeader(res, "set-cookie") || options.getHeader(res, "Set-Cookie") || [];
            if (typeof existingCookie === "string") existingCookie = [
                existingCookie
            ];
            if (!Array.isArray(existingCookie)) existingCookie = [];
            existingCookie = existingCookie.filter(function(c) {
                return c.indexOf("".concat(options.lookupCookie, "=")) !== 0;
            });
            existingCookie.push($54e44d35cf108a73$var$serializeCookie(options.lookupCookie, lng, cookieOptions));
            options.setHeader(res, "Set-Cookie", existingCookie.length === 1 ? existingCookie[0] : existingCookie);
        }
    }
};


var $4a416fa61f6bda51$export$2e2bcd8739ae039 = {
    name: "querystring",
    lookup: function lookup(req, res, options) {
        var found;
        if (options.lookupQuerystring !== undefined && typeof req !== "undefined") {
            if (options.getQuery(req)) found = options.getQuery(req)[options.lookupQuerystring];
            if (!found && options.getUrl(req) && options.getUrl(req).indexOf("?")) {
                var lastPartOfUri = options.getUrl(req).substring(options.getUrl(req).indexOf("?"));
                if (typeof URLSearchParams !== "undefined") {
                    var urlParams = new URLSearchParams(lastPartOfUri);
                    found = urlParams.get(options.lookupQuerystring);
                } else {
                    var indexOfQsStart = lastPartOfUri.indexOf("".concat(options.lookupQuerystring, "="));
                    if (indexOfQsStart > -1) {
                        var restOfUri = lastPartOfUri.substring(options.lookupQuerystring.length + 2);
                        if (restOfUri.indexOf("&") < 0) found = restOfUri;
                        else found = restOfUri.substring(0, restOfUri.indexOf("&"));
                    }
                }
            }
        }
        return found;
    }
};


var $407ce4c099247a89$export$2e2bcd8739ae039 = {
    name: "path",
    lookup: function lookup(req, res, options) {
        var found;
        if (req === undefined) return found;
        if (options.lookupPath !== undefined && req.params) found = options.getParams(req)[options.lookupPath];
        if (!found && typeof options.lookupFromPathIndex === "number" && options.getOriginalUrl(req)) {
            var path = options.getOriginalUrl(req).split("?")[0];
            var parts = path.split("/");
            if (parts[0] === "") parts.shift();
            if (parts.length > options.lookupFromPathIndex) found = parts[options.lookupFromPathIndex];
        }
        return found;
    }
};


var $76afd90a0d0d4551$var$specialCases = [
    "hans",
    "hant",
    "latn",
    "cyrl",
    "cans",
    "mong",
    "arab",
    "419"
];
var $76afd90a0d0d4551$export$2e2bcd8739ae039 = {
    name: "header",
    lookup: function lookup(req, res, options) {
        var found;
        if (typeof req !== "undefined") {
            var headers = options.getHeaders(req);
            if (!headers) return found;
            var locales = [];
            var acceptLanguage = options.lookupHeader ? headers[options.lookupHeader] : headers["accept-language"];
            if (acceptLanguage) {
                var lookupRegex = /(([a-z]{2,3})-?([A-Z]{2})?)\s*;?\s*(q=([0-9.]+))?/gi;
                if (acceptLanguage.indexOf("-") > 0) {
                    var foundSpecialCase = $76afd90a0d0d4551$var$specialCases.find(function(s) {
                        return acceptLanguage.toLowerCase().indexOf("-".concat(s)) > 0;
                    });
                    if (foundSpecialCase) lookupRegex = /(([a-z]{2,3})-?([A-Z0-9]{2,4})?)\s*;?\s*(q=([0-9.]+))?/gi;
                }
                var lngs = [];
                var i;
                var m;
                var rgx = options.lookupHeaderRegex || lookupRegex;
                do {
                    m = rgx.exec(acceptLanguage);
                    if (m) {
                        var lng = m[1];
                        var weight = m[5] || "1";
                        var q = Number(weight);
                        if (lng && !isNaN(q)) lngs.push({
                            lng: lng,
                            q: q
                        });
                    }
                }while (m);
                lngs.sort(function(a, b) {
                    return b.q - a.q;
                });
                for(i = 0; i < lngs.length; i++)locales.push(lngs[i].lng);
                if (locales.length) found = locales;
            }
        }
        return found;
    }
};


function $0ee2f8eaab9d8c49$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0ee2f8eaab9d8c49$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0ee2f8eaab9d8c49$var$_typeof(o);
}
var $0ee2f8eaab9d8c49$export$2e2bcd8739ae039 = {
    name: "session",
    lookup: function lookup(req, res, options) {
        var found;
        if (options.lookupSession !== undefined && $0ee2f8eaab9d8c49$var$_typeof(req) && options.getSession(req)) found = options.getSession(req)[options.lookupSession];
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(req, res, lng) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (options.lookupSession && req && options.getSession(req)) options.getSession(req)[options.lookupSession] = lng;
    }
};


var $2bddb7b25230c822$export$2aa3fd96c49a84a8 = function getPath(req) {
    if (req.path) return req.path;
    if (req.raw && req.raw.path) return req.raw.path;
    if (req.url) return req.url;
    console.log("no possibility found to get path");
};
var $2bddb7b25230c822$export$94df0e59ebebf4a7 = function getUrl(req) {
    if (req.url && req.url.href) return req.url.href;
    if (req.url) return req.url;
    if (req.raw && req.raw.url) return req.raw.url;
    console.log("no possibility found to get url");
};
var $2bddb7b25230c822$export$6f5f9061e41e006a = function setUrl(req, url) {
    if (req.url) {
        req.url = url;
        return;
    }
    console.log("no possibility found to get url");
};
var $2bddb7b25230c822$export$4396067fc7c17682 = function getOriginalUrl(req) {
    if (req.originalUrl) return req.originalUrl;
    if (req.raw && req.raw.originalUrl) return req.raw.originalUrl;
    return $2bddb7b25230c822$export$94df0e59ebebf4a7(req);
};
var $2bddb7b25230c822$export$71eec30d9db46a56 = function getQuery(req) {
    if (req.query && typeof req.query.entries === "function" && typeof Object.fromEntries === "function" && typeof req.query[Symbol.iterator] === "function") return Object.fromEntries(req.query);
    if (req.query) return req.query;
    if (req.searchParams) return req.searchParams;
    if (req.raw && req.raw.query) return req.raw.query;
    if (req.ctx && req.ctx.queryParams) return req.ctx.queryParams;
    if (req.url && req.url.searchParams) return req.url.searchParams;
    var url = req.url || req.raw && req.raw.url;
    if (url && url.indexOf("?") < 0) return {};
    console.log("no possibility found to get query");
    return {};
};
var $2bddb7b25230c822$export$ec161d740909e39d = function getParams(req) {
    if (req.params) return req.params;
    if (req.raw && req.raw.params) return req.raw.params;
    if (req.ctx && req.ctx.params) return req.ctx.params;
    console.log("no possibility found to get params");
    return {};
};
var $2bddb7b25230c822$export$6a9b8dd1339b1a17 = function getHeaders(req) {
    if (req.headers) return req.headers;
    console.log("no possibility found to get headers");
};
var $2bddb7b25230c822$export$f3eb5caaef7b2b34 = function getCookies(req) {
    if (req.cookies) return req.cookies;
    if ($2bddb7b25230c822$export$6a9b8dd1339b1a17(req)) {
        var list = {};
        var rc = $2bddb7b25230c822$export$6a9b8dd1339b1a17(req).cookie;
        rc && rc.split(";").forEach(function(cookie) {
            var parts = cookie.split("=");
            list[parts.shift().trim()] = decodeURI(encodeURI(parts.join("=")));
        });
        return list;
    }
    console.log("no possibility found to get cookies");
};
var $2bddb7b25230c822$export$135b49d4bc2964c6 = function getBody(req) {
    if (req.ctx && typeof req.ctx.body === "function") return req.ctx.body.bind(req.ctx);
    if (req.ctx && req.ctx.body) return req.ctx.body;
    if (req.json) return req.json;
    if (req.body) return req.body;
    if (req.payload) return req.payload;
    if (req.request && req.request.body) return req.request.body;
    console.log("no possibility found to get body");
    return {};
};
var $2bddb7b25230c822$export$47ed31abc613cf55 = function getHeader(res, name) {
    if (res.getHeader) return res.getHeader(name);
    if (res.headers) return res.headers[name];
    if ($2bddb7b25230c822$export$6a9b8dd1339b1a17(res) && $2bddb7b25230c822$export$6a9b8dd1339b1a17(res)[name]) return $2bddb7b25230c822$export$6a9b8dd1339b1a17(res)[name];
    console.log("no possibility found to get header");
    return undefined;
};
var $2bddb7b25230c822$export$604ed74fb893f0e2 = function setHeader(res, name, value) {
    if (res._headerSent || res.headersSent) return;
    if (typeof res.setHeader === "function") return res.setHeader(name, value);
    if (typeof res.header === "function") return res.header(name, value);
    if (res.responseHeaders && typeof res.responseHeaders.set === "function") return res.responseHeaders.set(name, value);
    if (res.headers && typeof res.headers.set === "function") return res.headers.set(name, value);
    if (typeof res.set === "function") return res.set(name, value);
    console.log("no possibility found to set header");
};
var $2bddb7b25230c822$export$f0b2c59960f4bfcc = function setContentType(res, type) {
    if (typeof res.contentType === "function") return res.contentType(type);
    if (typeof res.type === "function") return res.type(type);
    $2bddb7b25230c822$export$604ed74fb893f0e2(res, "Content-Type", type);
};
var $2bddb7b25230c822$export$e23f2da38df8914e = function setStatus(res, code) {
    if (typeof res.status === "function") return res.status(code);
    if (res.status) return res.status = code;
    console.log("no possibility found to set status");
};
var $2bddb7b25230c822$export$89db4734f6c919c4 = function send(res, body) {
    if (typeof res.send === "function") return res.send(body);
    if (res.request && res.response && res.app) res.body = body;
    return body;
};
var $2bddb7b25230c822$export$12151e9ef3722552 = function getSession(req) {
    if (req.session) return req.session;
    if (req.raw && req.raw.session) return req.raw.session;
    console.log("no possibility found to get session");
};
var $2bddb7b25230c822$export$aa180f3a5525da2d = function extendOptionsWithDefaults() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    options.getPath = options.getPath || $2bddb7b25230c822$export$2aa3fd96c49a84a8;
    options.getOriginalUrl = options.getOriginalUrl || $2bddb7b25230c822$export$4396067fc7c17682;
    options.getUrl = options.getUrl || $2bddb7b25230c822$export$94df0e59ebebf4a7;
    options.setUrl = options.setUrl || $2bddb7b25230c822$export$6f5f9061e41e006a;
    options.getParams = options.getParams || $2bddb7b25230c822$export$ec161d740909e39d;
    options.getSession = options.getSession || $2bddb7b25230c822$export$12151e9ef3722552;
    options.getQuery = options.getQuery || $2bddb7b25230c822$export$71eec30d9db46a56;
    options.getCookies = options.getCookies || $2bddb7b25230c822$export$f3eb5caaef7b2b34;
    options.getBody = options.getBody || $2bddb7b25230c822$export$135b49d4bc2964c6;
    options.getHeaders = options.getHeaders || $2bddb7b25230c822$export$6a9b8dd1339b1a17;
    options.getHeader = options.getHeader || $2bddb7b25230c822$export$47ed31abc613cf55;
    options.setHeader = options.setHeader || $2bddb7b25230c822$export$604ed74fb893f0e2;
    options.setContentType = options.setContentType || $2bddb7b25230c822$export$f0b2c59960f4bfcc;
    options.setStatus = options.setStatus || $2bddb7b25230c822$export$e23f2da38df8914e;
    options.send = options.send || $2bddb7b25230c822$export$89db4734f6c919c4;
    return options;
};


function $02d9e8dce13fcc82$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $02d9e8dce13fcc82$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $02d9e8dce13fcc82$var$_typeof(o);
}
function $02d9e8dce13fcc82$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $02d9e8dce13fcc82$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $02d9e8dce13fcc82$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $02d9e8dce13fcc82$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $02d9e8dce13fcc82$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $02d9e8dce13fcc82$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $02d9e8dce13fcc82$var$_toPropertyKey(arg) {
    var key = $02d9e8dce13fcc82$var$_toPrimitive(arg, "string");
    return $02d9e8dce13fcc82$var$_typeof(key) === "symbol" ? key : String(key);
}
function $02d9e8dce13fcc82$var$_toPrimitive(input, hint) {
    if ($02d9e8dce13fcc82$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($02d9e8dce13fcc82$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $02d9e8dce13fcc82$var$getDefaults() {
    return (0, $2bddb7b25230c822$export$aa180f3a5525da2d)({
        order: [
            "querystring",
            "cookie",
            "header"
        ],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupSession: "lng",
        lookupFromPathIndex: 0,
        caches: false,
        cookieSameSite: "strict",
        ignoreCase: true,
        convertDetectedLanguage: function convertDetectedLanguage(l) {
            return l;
        }
    });
}
var $02d9e8dce13fcc82$var$LanguageDetector = function() {
    function LanguageDetector(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $02d9e8dce13fcc82$var$_classCallCheck(this, LanguageDetector);
        this.type = "languageDetector";
        this.detectors = {};
        this.init(services, options, allOptions);
    }
    $02d9e8dce13fcc82$var$_createClass(LanguageDetector, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $1d366c1d1cf4940d$export$ebe90cb607ad99e(options, this.options || {}, $02d9e8dce13fcc82$var$getDefaults());
                this.allOptions = allOptions;
                if (typeof this.options.convertDetectedLanguage === "string" && this.options.convertDetectedLanguage.indexOf("15897") > -1) this.options.convertDetectedLanguage = function(l) {
                    return l.replace("-", "_");
                };
                this.addDetector((0, $54e44d35cf108a73$export$2e2bcd8739ae039));
                this.addDetector((0, $4a416fa61f6bda51$export$2e2bcd8739ae039));
                this.addDetector((0, $407ce4c099247a89$export$2e2bcd8739ae039));
                this.addDetector((0, $76afd90a0d0d4551$export$2e2bcd8739ae039));
                this.addDetector((0, $0ee2f8eaab9d8c49$export$2e2bcd8739ae039));
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(req, res, detectionOrder) {
                var _this = this;
                if (arguments.length < 2) return;
                if (!detectionOrder) detectionOrder = this.options.order;
                var found;
                detectionOrder.forEach(function(detectorName) {
                    if (found || !_this.detectors[detectorName]) return;
                    var detections = _this.detectors[detectorName].lookup(req, res, _this.options);
                    if (!detections) return;
                    if (!Array.isArray(detections)) detections = [
                        detections
                    ];
                    detections = detections.filter(function(d) {
                        return d !== undefined && d !== null;
                    });
                    detections = detections.map(function(d) {
                        return _this.options.convertDetectedLanguage(d);
                    });
                    if (_this.services.languageUtils.getBestMatchFromCodes) {
                        found = _this.services.languageUtils.getBestMatchFromCodes(detections);
                        if (found) {
                            if (_this.options.ignoreCase) {
                                if (detections.map(function(d) {
                                    return d.toLowerCase();
                                }).indexOf(found.toLowerCase()) < 0) found = undefined;
                            } else if (detections.indexOf(found) < 0) found = undefined;
                        }
                        if (found) req.i18nextLookupName = detectorName;
                    } else found = detections.length > 0 ? detections[0] : null;
                });
                if (!found) {
                    var fallbacks = this.allOptions.fallbackLng;
                    if (typeof fallbacks === "function") fallbacks = fallbacks();
                    if (typeof fallbacks === "string") fallbacks = [
                        fallbacks
                    ];
                    if (!fallbacks) fallbacks = [];
                    if (Object.prototype.toString.apply(fallbacks) === "[object Array]") found = fallbacks[0];
                    else found = fallbacks[0] || fallbacks.default && fallbacks.default[0];
                }
                return found;
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(req, res, lng, caches) {
                var _this2 = this;
                if (arguments.length < 3) return;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName] && _this2.detectors[cacheName].cacheUserLanguage && res.cachedUserLanguage !== lng) {
                        _this2.detectors[cacheName].cacheUserLanguage(req, res, lng, _this2.options);
                        res.cachedUserLanguage = lng;
                    }
                });
            }
        }
    ]);
    return LanguageDetector;
}();
$02d9e8dce13fcc82$var$LanguageDetector.type = "languageDetector";
var $02d9e8dce13fcc82$export$2e2bcd8739ae039 = $02d9e8dce13fcc82$var$LanguageDetector;




var $hPtJY = parcelRequire("hPtJY");
function $ec141a35d03dcff3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ec141a35d03dcff3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ec141a35d03dcff3$var$_typeof(o);
}
function $ec141a35d03dcff3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ec141a35d03dcff3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ec141a35d03dcff3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ec141a35d03dcff3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ec141a35d03dcff3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ec141a35d03dcff3$var$_defineProperty(obj, key, value) {
    key = $ec141a35d03dcff3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ec141a35d03dcff3$var$_toPropertyKey(arg) {
    var key = $ec141a35d03dcff3$var$_toPrimitive(arg, "string");
    return $ec141a35d03dcff3$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ec141a35d03dcff3$var$_toPrimitive(input, hint) {
    if ($ec141a35d03dcff3$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ec141a35d03dcff3$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $ec141a35d03dcff3$var$_regeneratorRuntime() {
    "use strict";
    $ec141a35d03dcff3$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $ec141a35d03dcff3$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw new Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($ec141a35d03dcff3$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw new Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        catch: function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function $ec141a35d03dcff3$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $ec141a35d03dcff3$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $ec141a35d03dcff3$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $ec141a35d03dcff3$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var $ec141a35d03dcff3$export$36df6eadd61c72e4 = (0, $02d9e8dce13fcc82$export$2e2bcd8739ae039);
var $ec141a35d03dcff3$var$checkForCombinedReqRes = function checkForCombinedReqRes(req, res, next) {
    if (!res) {
        if (req.request && req.response) {
            res = req.response;
            if (!req.request.ctx) req.request.ctx = req;
            req = req.request;
            if (!next) next = function next() {};
        } else if (req.respond) {
            res = req;
            if (!next) next = function next() {};
        }
    } else if (!next && typeof res === "function" && req.req && req.res) return {
        req: req,
        res: req,
        next: res
    };
    return {
        req: req,
        res: res,
        next: next
    };
};
function $ec141a35d03dcff3$export$8f34ce051745d39e(i18next) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, $2bddb7b25230c822$export$aa180f3a5525da2d)(options);
    return function i18nextMiddleware(rq, rs, n) {
        var _checkForCombinedReqR = $ec141a35d03dcff3$var$checkForCombinedReqRes(rq, rs, n), req = _checkForCombinedReqR.req, res = _checkForCombinedReqR.res, next = _checkForCombinedReqR.next;
        if (typeof options.ignoreRoutes === "function") {
            if (options.ignoreRoutes(req, res, options, i18next)) return next();
        } else {
            var ignores = options.ignoreRoutes instanceof Array && options.ignoreRoutes || [];
            for(var i = 0; i < ignores.length; i++){
                if (options.getPath(req).indexOf(ignores[i]) > -1) return next();
            }
        }
        var i18n = i18next.cloneInstance({
            initImmediate: false
        });
        i18n.on("languageChanged", function(lng) {
            req.language = req.locale = req.lng = lng;
            if (options.attachLocals) res.locals = res.locals || {};
            if (res.locals) {
                res.locals.language = lng;
                res.locals.languageDir = i18next.dir(lng);
            }
            if (lng && options.getHeader(res, "Content-Language") !== lng) options.setHeader(res, "Content-Language", lng);
            req.languages = i18next.services.languageUtils.toResolveHierarchy(lng);
            if (i18next.services.languageDetector) i18next.services.languageDetector.cacheUserLanguage(req, res, lng);
        });
        var lng = req.lng;
        if (!lng && i18next.services.languageDetector) lng = i18next.services.languageDetector.detect(req, res);
        req.language = req.locale = req.lng = lng;
        if (lng && options.getHeader(res, "Content-Language") !== lng) options.setHeader(res, "Content-Language", lng);
        req.languages = i18next.services.languageUtils.toResolveHierarchy(lng);
        i18n.changeLanguage(lng || i18next.options.fallbackLng[0]);
        if (req.i18nextLookupName === "path" && options.removeLngFromUrl) options.setUrl(req, $1d366c1d1cf4940d$export$deaa871f179221a4(options.getUrl(req), i18next.services.languageDetector.options.lookupFromPathIndex));
        var t = i18n.t.bind(i18n);
        var exists = i18n.exists.bind(i18n);
        req.i18n = i18n;
        req.t = t;
        if (options.attachLocals) res.locals = res.locals || {};
        if (res.locals) {
            res.locals.t = t;
            res.locals.exists = exists;
            res.locals.i18n = i18n;
            res.locals.language = lng;
            res.locals.languageDir = i18next.dir(lng);
        }
        if (i18next.services.languageDetector) i18next.services.languageDetector.cacheUserLanguage(req, res, lng);
        if (!req.lng) return next();
        i18next.loadLanguages(req.lng, function() {
            return next();
        });
    };
}
function $ec141a35d03dcff3$export$ca524d3785e2543(instance, options, next) {
    options.attachLocals = true;
    var middleware = $ec141a35d03dcff3$export$8f34ce051745d39e(options.i18next, options);
    instance.addHook("preHandler", function(request, reply, next) {
        return middleware(request, reply, next);
    });
    return next();
}
function $ec141a35d03dcff3$export$7e33439fc443b840(i18next, options) {
    var middleware = $ec141a35d03dcff3$export$8f34ce051745d39e(i18next, options);
    return function() {
        var _koaMiddleware = $ec141a35d03dcff3$var$_asyncToGenerator($ec141a35d03dcff3$var$_regeneratorRuntime().mark(function _callee(ctx, next) {
            return $ec141a35d03dcff3$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.next = 2;
                        return new Promise(function(resolve) {
                            return middleware(ctx, ctx, resolve);
                        });
                    case 2:
                        _context.next = 4;
                        return next();
                    case 4:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        function koaMiddleware(_x, _x2) {
            return _koaMiddleware.apply(this, arguments);
        }
        return koaMiddleware;
    }();
}
var $ec141a35d03dcff3$export$bb901c5b1a653f37 = {
    name: "i18next-http-middleware",
    version: "1",
    register: function register(server, options) {
        options.attachLocals = true;
        var middleware = $ec141a35d03dcff3$export$8f34ce051745d39e(options.i18next, $ec141a35d03dcff3$var$_objectSpread({}, options));
        server.ext("onPreAuth", function(request, h) {
            middleware(request, request.raw.res || h.response() || request.Response, function() {
                return h.continue;
            });
            return h.continue;
        });
    }
};
$ec141a35d03dcff3$export$ca524d3785e2543[Symbol.for("skip-override")] = true;
function $ec141a35d03dcff3$export$5a62aa7c0dee78a9(i18next) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, $2bddb7b25230c822$export$aa180f3a5525da2d)(options);
    var maxAge = options.maxAge || 2592000;
    return function(rq, rs) {
        var _checkForCombinedReqR2 = $ec141a35d03dcff3$var$checkForCombinedReqRes(rq, rs), req = _checkForCombinedReqR2.req, res = _checkForCombinedReqR2.res;
        if (!i18next.services.backendConnector) {
            options.setStatus(res, 404);
            return options.send(res, "i18next-express-middleware:: no backend configured");
        }
        var resources = {};
        options.setContentType(res, "application/json");
        if (options.cache !== undefined ? options.cache : typeof $hPtJY !== "undefined" && $hPtJY.env && true) {
            options.setHeader(res, "Cache-Control", "public, max-age=" + maxAge);
            options.setHeader(res, "Expires", new Date(new Date().getTime() + maxAge * 1000).toUTCString());
        } else {
            options.setHeader(res, "Pragma", "no-cache");
            options.setHeader(res, "Cache-Control", "no-cache");
        }
        var languages = options.getQuery(req)[options.lngParam || "lng"] ? options.getQuery(req)[options.lngParam || "lng"].split(" ") : [];
        var namespaces = options.getQuery(req)[options.nsParam || "ns"] ? options.getQuery(req)[options.nsParam || "ns"].split(" ") : [];
        if (languages.length === 0 && namespaces.length === 0) {
            languages = options.getParams(req)[options.lngParam || "lng"] ? options.getParams(req)[options.lngParam || "lng"].split(" ") : [];
            namespaces = options.getParams(req)[options.nsParam || "ns"] ? options.getParams(req)[options.nsParam || "ns"].split(" ") : [];
        }
        namespaces.forEach(function(ns) {
            if (i18next.options.ns && i18next.options.ns.indexOf(ns) < 0) i18next.options.ns.push(ns);
        });
        i18next.services.backendConnector.load(languages, namespaces, function() {
            languages.forEach(function(lng) {
                namespaces.forEach(function(ns) {
                    $1d366c1d1cf4940d$export$1518ffc4a8ff94f2(resources, [
                        lng,
                        ns
                    ], i18next.getResourceBundle(lng, ns));
                });
            });
        });
        return options.send(res, resources);
    };
}
function $ec141a35d03dcff3$export$59e55e25813f572f(i18next) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, $2bddb7b25230c822$export$aa180f3a5525da2d)(options);
    return function(rq, rs) {
        var _checkForCombinedReqR3 = $ec141a35d03dcff3$var$checkForCombinedReqRes(rq, rs), req = _checkForCombinedReqR3.req, res = _checkForCombinedReqR3.res;
        var lng = options.getParams(req)[options.lngParam || "lng"];
        var ns = options.getParams(req)[options.nsParam || "ns"];
        if (!i18next.services.backendConnector) {
            options.setStatus(res, 404);
            return options.send(res, "i18next-express-middleware:: no backend configured");
        }
        var body = options.getBody(req);
        if (typeof body === "function") {
            var promise = body();
            if (promise && typeof promise.then === "function") return new Promise(function(resolve) {
                promise.then(function(b) {
                    for(var m in b)i18next.services.backendConnector.saveMissing([
                        lng
                    ], ns, m, b[m]);
                    resolve(options.send(res, "ok"));
                });
            });
        }
        for(var m in body)i18next.services.backendConnector.saveMissing([
            lng
        ], ns, m, body[m]);
        return options.send(res, "ok");
    };
}
function $ec141a35d03dcff3$export$61ac59f68e6d5762(i18next, route, lngs, app, verb, fc) {
    if (typeof verb === "function") {
        fc = verb;
        verb = "get";
    }
    var callbacks = [
        fc
    ].concat(Array.prototype.slice.call(arguments, 6));
    for(var i = 0, li = lngs.length; i < li; i++){
        var parts = String(route).split("/");
        var locRoute = [];
        for(var y = 0, ly = parts.length; y < ly; y++){
            var part = parts[y];
            if (part === ":lng") locRoute.push(lngs[i]);
            else if (part.indexOf(":") === 0 || part === "") locRoute.push(part);
            else locRoute.push(i18next.t(part, {
                lng: lngs[i]
            }));
        }
        var routes = [
            locRoute.join("/")
        ];
        app[verb || "get"].apply(app, routes.concat(callbacks));
    }
}
var $ec141a35d03dcff3$export$2e2bcd8739ae039 = {
    plugin: $ec141a35d03dcff3$export$ca524d3785e2543,
    hapiPlugin: $ec141a35d03dcff3$export$bb901c5b1a653f37,
    koaPlugin: $ec141a35d03dcff3$export$7e33439fc443b840,
    handle: $ec141a35d03dcff3$export$8f34ce051745d39e,
    getResourcesHandler: $ec141a35d03dcff3$export$5a62aa7c0dee78a9,
    missingKeyHandler: $ec141a35d03dcff3$export$59e55e25813f572f,
    addRoute: $ec141a35d03dcff3$export$61ac59f68e6d5762,
    LanguageDetector: $ec141a35d03dcff3$export$36df6eadd61c72e4
};


var $4202a5939499f6a1$exports = {};
var $1475fcca6d28e4b3$exports = {};
$1475fcca6d28e4b3$exports = JSON.parse('"ac>com,edu,gov,net,mil,org<ad>nom<ae>co,net,org,sch,ac,gov,mil<aero>accident-investigation,accident-prevention,aerobatic,aeroclub,aerodrome,agents,aircraft,airline,airport,air-surveillance,airtraffic,air-traffic-control,ambulance,amusement,association,author,ballooning,broker,caa,cargo,catering,certification,championship,charter,civilaviation,club,conference,consultant,consulting,control,council,crew,design,dgca,educator,emergency,engine,engineer,entertainment,equipment,exchange,express,federation,flight,fuel,gliding,government,groundhandling,group,hanggliding,homebuilt,insurance,journal,journalist,leasing,logistics,magazine,maintenance,media,microlight,modelling,navigation,parachuting,paragliding,passenger-association,pilot,press,production,recreation,repbody,res,research,rotorcraft,safety,scientist,services,show,skydiving,software,student,trader,trading,trainer,union,workinggroup,works<af>gov,com,org,net,edu<ag>com,org,net,co,nom<ai>off,com,net,org<al>com,edu,gov,mil,net,org<am>co,com,commune,net,org<ao>ed,gv,og,co,pb,it<aq,ar>bet,com,coop,edu,gob,gov,int,mil,musica,mutual,net,org,senasa,tur<arpa>e164,in-addr,ip6,iris,uri,urn<as>gov<asia,at>ac>sth<co,gv,or<au>com,net,org,edu>act,catholic,nsw>schools<nt,qld,sa,tas,vic,wa<gov>qld,sa,tas,vic,wa<asn,id,info,conf,oz,act,nsw,nt,qld,sa,tas,vic,wa<aw>com<ax,az>com,net,int,gov,org,edu,info,pp,mil,name,pro,biz<ba>com,edu,gov,mil,net,org<bb>biz,co,com,edu,gov,info,net,org,store,tv<bd>*<be>ac<bf>gov<bg>a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,0,1,2,3,4,5,6,7,8,9<bh>com,edu,net,org,gov<bi>co,com,edu,or,org<biz,bj>asso,barreau,gouv<bm>com,edu,gov,net,org<bn>com,edu,gov,net,org<bo>com,edu,gob,int,org,net,mil,tv,web,academia,agro,arte,blog,bolivia,ciencia,cooperativa,democracia,deporte,ecologia,economia,empresa,indigena,industria,info,medicina,movimiento,musica,natural,nombre,noticias,patria,politica,profesional,plurinacional,pueblo,revista,salud,tecnologia,tksat,transporte,wiki<br>9guacu,abc,adm,adv,agr,aju,am,anani,aparecida,app,arq,art,ato,b,barueri,belem,bhz,bib,bio,blog,bmd,boavista,bsb,campinagrande,campinas,caxias,cim,cng,cnt,com,contagem,coop,coz,cri,cuiaba,curitiba,def,des,det,dev,ecn,eco,edu,emp,enf,eng,esp,etc,eti,far,feira,flog,floripa,fm,fnd,fortal,fot,foz,fst,g12,geo,ggf,goiania,gov>ac,al,am,ap,ba,ce,df,es,go,ma,mg,ms,mt,pa,pb,pe,pi,pr,rj,rn,ro,rr,rs,sc,se,sp,to<gru,imb,ind,inf,jab,jampa,jdf,joinville,jor,jus,leg,lel,log,londrina,macapa,maceio,manaus,maringa,mat,med,mil,morena,mp,mus,natal,net,niteroi,nom>*<not,ntr,odo,ong,org,osasco,palmas,poa,ppg,pro,psc,psi,pvh,qsl,radio,rec,recife,rep,ribeirao,rio,riobranco,riopreto,salvador,sampa,santamaria,santoandre,saobernardo,saogonca,seg,sjc,slg,slz,sorocaba,srv,taxi,tc,tec,teo,the,tmp,trd,tur,tv,udi,vet,vix,vlog,wiki,zlg<bs>com,net,org,edu,gov<bt>com,edu,gov,net,org<bv,bw>co,org<by>gov,mil,com,of<bz>com,net,org,edu,gov<ca>ab,bc,mb,nb,nf,nl,ns,nt,nu,on,pe,qc,sk,yk,gc<cat,cc,cd>gov<cf,cg,ch,ci>org,or,com,co,edu,ed,ac,net,go,asso,xn--aroport-bya,int,presse,md,gouv<ck>*,!www<cl>co,gob,gov,mil<cm>co,com,gov,net<cn>ac,com,edu,gov,net,org,mil,xn--55qx5d,xn--io0a7i,xn--od0alg,ah,bj,cq,fj,gd,gs,gz,gx,ha,hb,he,hi,hl,hn,jl,js,jx,ln,nm,nx,qh,sc,sd,sh,sn,sx,tj,xj,xz,yn,zj,hk,mo,tw<co>arts,com,edu,firm,gov,info,int,mil,net,nom,org,rec,web<com,coop,cr>ac,co,ed,fi,go,or,sa<cu>com,edu,org,net,gov,inf<cv>com,edu,int,nome,org<cw>com,edu,net,org<cx>gov<cy>ac,biz,com,ekloges,gov,ltd,name,net,org,parliament,press,pro,tm<cz,de,dj,dk,dm>com,net,org,edu,gov<do>art,com,edu,gob,gov,mil,net,org,sld,web<dz>art,asso,com,edu,gov,org,net,pol,soc,tm<ec>com,info,net,fin,k12,med,pro,org,edu,gov,gob,mil<edu,ee>edu,gov,riik,lib,med,com,pri,aip,org,fie<eg>com,edu,eun,gov,mil,name,net,org,sci<er>*<es>com,nom,org,gob,edu<et>com,gov,org,edu,biz,name,info,net<eu,fi>aland<fj>ac,biz,com,gov,info,mil,name,net,org,pro<fk>*<fm>com,edu,net,org<fo,fr>asso,com,gouv,nom,prd,tm,aeroport,avocat,avoues,cci,chambagri,chirurgiens-dentistes,experts-comptables,geometre-expert,greta,huissier-justice,medecin,notaires,pharmacien,port,veterinaire<ga,gb,gd>edu,gov<ge>com,edu,gov,org,mil,net,pvt<gf,gg>co,net,org<gh>com,edu,gov,org,mil<gi>com,ltd,gov,mod,edu,org<gl>co,com,edu,net,org<gm,gn>ac,com,edu,gov,org,net<gov,gp>com,net,mobi,edu,org,asso<gq,gr>com,edu,net,org,gov<gs,gt>com,edu,gob,ind,mil,net,org<gu>com,edu,gov,guam,info,net,org,web<gw,gy>co,com,edu,gov,net,org<hk>com,edu,gov,idv,net,org,xn--55qx5d,xn--wcvs22d,xn--lcvr32d,xn--mxtq1m,xn--gmqw5a,xn--ciqpn,xn--gmq050i,xn--zf0avx,xn--io0a7i,xn--mk0axi,xn--od0alg,xn--od0aq3b,xn--tn0ag,xn--uc0atv,xn--uc0ay4a<hm,hn>com,edu,org,net,mil,gob<hr>iz,from,name,com<ht>com,shop,firm,info,adult,net,pro,org,med,art,coop,pol,asso,edu,rel,gouv,perso<hu>co,info,org,priv,sport,tm,2000,agrar,bolt,casino,city,erotica,erotika,film,forum,games,hotel,ingatlan,jogasz,konyvelo,lakas,media,news,reklam,sex,shop,suli,szex,tozsde,utazas,video<id>ac,biz,co,desa,go,mil,my,net,or,ponpes,sch,web<ie>gov<il>ac,co,gov,idf,k12,muni,net,org<im>ac,co>ltd,plc<com,net,org,tt,tv<in>co,firm,net,org,gen,ind,nic,ac,edu,res,gov,mil<info,int>eu<io>com<iq>gov,edu,mil,com,org,net<ir>ac,co,gov,id,net,org,sch,xn--mgba3a4f16a,xn--mgba3a4fra<is>net,com,edu,gov,org,int<it>gov,edu,abr,abruzzo,aosta-valley,aostavalley,bas,basilicata,cal,calabria,cam,campania,emilia-romagna,emiliaromagna,emr,friuli-v-giulia,friuli-ve-giulia,friuli-vegiulia,friuli-venezia-giulia,friuli-veneziagiulia,friuli-vgiulia,friuliv-giulia,friulive-giulia,friulivegiulia,friulivenezia-giulia,friuliveneziagiulia,friulivgiulia,fvg,laz,lazio,lig,liguria,lom,lombardia,lombardy,lucania,mar,marche,mol,molise,piedmont,piemonte,pmn,pug,puglia,sar,sardegna,sardinia,sic,sicilia,sicily,taa,tos,toscana,trentin-sud-tirol,xn--trentin-sd-tirol-rzb,trentin-sudtirol,xn--trentin-sdtirol-7vb,trentin-sued-tirol,trentin-suedtirol,trentino-a-adige,trentino-aadige,trentino-alto-adige,trentino-altoadige,trentino-s-tirol,trentino-stirol,trentino-sud-tirol,xn--trentino-sd-tirol-c3b,trentino-sudtirol,xn--trentino-sdtirol-szb,trentino-sued-tirol,trentino-suedtirol,trentino,trentinoa-adige,trentinoaadige,trentinoalto-adige,trentinoaltoadige,trentinos-tirol,trentinostirol,trentinosud-tirol,xn--trentinosd-tirol-rzb,trentinosudtirol,xn--trentinosdtirol-7vb,trentinosued-tirol,trentinosuedtirol,trentinsud-tirol,xn--trentinsd-tirol-6vb,trentinsudtirol,xn--trentinsdtirol-nsb,trentinsued-tirol,trentinsuedtirol,tuscany,umb,umbria,val-d-aosta,val-daosta,vald-aosta,valdaosta,valle-aosta,valle-d-aosta,valle-daosta,valleaosta,valled-aosta,valledaosta,vallee-aoste,xn--valle-aoste-ebb,vallee-d-aoste,xn--valle-d-aoste-ehb,valleeaoste,xn--valleaoste-e7a,valleedaoste,xn--valledaoste-ebb,vao,vda,ven,veneto,ag,agrigento,al,alessandria,alto-adige,altoadige,an,ancona,andria-barletta-trani,andria-trani-barletta,andriabarlettatrani,andriatranibarletta,ao,aosta,aoste,ap,aq,aquila,ar,arezzo,ascoli-piceno,ascolipiceno,asti,at,av,avellino,ba,balsan-sudtirol,xn--balsan-sdtirol-nsb,balsan-suedtirol,balsan,bari,barletta-trani-andria,barlettatraniandria,belluno,benevento,bergamo,bg,bi,biella,bl,bn,bo,bologna,bolzano-altoadige,bolzano,bozen-sudtirol,xn--bozen-sdtirol-2ob,bozen-suedtirol,bozen,br,brescia,brindisi,bs,bt,bulsan-sudtirol,xn--bulsan-sdtirol-nsb,bulsan-suedtirol,bulsan,bz,ca,cagliari,caltanissetta,campidano-medio,campidanomedio,campobasso,carbonia-iglesias,carboniaiglesias,carrara-massa,carraramassa,caserta,catania,catanzaro,cb,ce,cesena-forli,xn--cesena-forl-mcb,cesenaforli,xn--cesenaforl-i8a,ch,chieti,ci,cl,cn,co,como,cosenza,cr,cremona,crotone,cs,ct,cuneo,cz,dell-ogliastra,dellogliastra,en,enna,fc,fe,fermo,ferrara,fg,fi,firenze,florence,fm,foggia,forli-cesena,xn--forl-cesena-fcb,forlicesena,xn--forlcesena-c8a,fr,frosinone,ge,genoa,genova,go,gorizia,gr,grosseto,iglesias-carbonia,iglesiascarbonia,im,imperia,is,isernia,kr,la-spezia,laquila,laspezia,latina,lc,le,lecce,lecco,li,livorno,lo,lodi,lt,lu,lucca,macerata,mantova,massa-carrara,massacarrara,matera,mb,mc,me,medio-campidano,mediocampidano,messina,mi,milan,milano,mn,mo,modena,monza-brianza,monza-e-della-brianza,monza,monzabrianza,monzaebrianza,monzaedellabrianza,ms,mt,na,naples,napoli,no,novara,nu,nuoro,og,ogliastra,olbia-tempio,olbiatempio,or,oristano,ot,pa,padova,padua,palermo,parma,pavia,pc,pd,pe,perugia,pesaro-urbino,pesarourbino,pescara,pg,pi,piacenza,pisa,pistoia,pn,po,pordenone,potenza,pr,prato,pt,pu,pv,pz,ra,ragusa,ravenna,rc,re,reggio-calabria,reggio-emilia,reggiocalabria,reggioemilia,rg,ri,rieti,rimini,rm,rn,ro,roma,rome,rovigo,sa,salerno,sassari,savona,si,siena,siracusa,so,sondrio,sp,sr,ss,suedtirol,xn--sdtirol-n2a,sv,ta,taranto,te,tempio-olbia,tempioolbia,teramo,terni,tn,to,torino,tp,tr,trani-andria-barletta,trani-barletta-andria,traniandriabarletta,tranibarlettaandria,trapani,trento,treviso,trieste,ts,turin,tv,ud,udine,urbino-pesaro,urbinopesaro,va,varese,vb,vc,ve,venezia,venice,verbania,vercelli,verona,vi,vibo-valentia,vibovalentia,vicenza,viterbo,vr,vs,vt,vv<je>co,net,org<jm>*<jo>com,org,net,edu,sch,gov,mil,name<jobs,jp>ac,ad,co,ed,go,gr,lg,ne,or,aichi>aisai,ama,anjo,asuke,chiryu,chita,fuso,gamagori,handa,hazu,hekinan,higashiura,ichinomiya,inazawa,inuyama,isshiki,iwakura,kanie,kariya,kasugai,kira,kiyosu,komaki,konan,kota,mihama,miyoshi,nishio,nisshin,obu,oguchi,oharu,okazaki,owariasahi,seto,shikatsu,shinshiro,shitara,tahara,takahama,tobishima,toei,togo,tokai,tokoname,toyoake,toyohashi,toyokawa,toyone,toyota,tsushima,yatomi<akita>akita,daisen,fujisato,gojome,hachirogata,happou,higashinaruse,honjo,honjyo,ikawa,kamikoani,kamioka,katagami,kazuno,kitaakita,kosaka,kyowa,misato,mitane,moriyoshi,nikaho,noshiro,odate,oga,ogata,semboku,yokote,yurihonjo<aomori>aomori,gonohe,hachinohe,hashikami,hiranai,hirosaki,itayanagi,kuroishi,misawa,mutsu,nakadomari,noheji,oirase,owani,rokunohe,sannohe,shichinohe,shingo,takko,towada,tsugaru,tsuruta<chiba>abiko,asahi,chonan,chosei,choshi,chuo,funabashi,futtsu,hanamigawa,ichihara,ichikawa,ichinomiya,inzai,isumi,kamagaya,kamogawa,kashiwa,katori,katsuura,kimitsu,kisarazu,kozaki,kujukuri,kyonan,matsudo,midori,mihama,minamiboso,mobara,mutsuzawa,nagara,nagareyama,narashino,narita,noda,oamishirasato,omigawa,onjuku,otaki,sakae,sakura,shimofusa,shirako,shiroi,shisui,sodegaura,sosa,tako,tateyama,togane,tohnosho,tomisato,urayasu,yachimata,yachiyo,yokaichiba,yokoshibahikari,yotsukaido<ehime>ainan,honai,ikata,imabari,iyo,kamijima,kihoku,kumakogen,masaki,matsuno,matsuyama,namikata,niihama,ozu,saijo,seiyo,shikokuchuo,tobe,toon,uchiko,uwajima,yawatahama<fukui>echizen,eiheiji,fukui,ikeda,katsuyama,mihama,minamiechizen,obama,ohi,ono,sabae,sakai,takahama,tsuruga,wakasa<fukuoka>ashiya,buzen,chikugo,chikuho,chikujo,chikushino,chikuzen,chuo,dazaifu,fukuchi,hakata,higashi,hirokawa,hisayama,iizuka,inatsuki,kaho,kasuga,kasuya,kawara,keisen,koga,kurate,kurogi,kurume,minami,miyako,miyama,miyawaka,mizumaki,munakata,nakagawa,nakama,nishi,nogata,ogori,okagaki,okawa,oki,omuta,onga,onojo,oto,saigawa,sasaguri,shingu,shinyoshitomi,shonai,soeda,sue,tachiarai,tagawa,takata,toho,toyotsu,tsuiki,ukiha,umi,usui,yamada,yame,yanagawa,yukuhashi<fukushima>aizubange,aizumisato,aizuwakamatsu,asakawa,bandai,date,fukushima,furudono,futaba,hanawa,higashi,hirata,hirono,iitate,inawashiro,ishikawa,iwaki,izumizaki,kagamiishi,kaneyama,kawamata,kitakata,kitashiobara,koori,koriyama,kunimi,miharu,mishima,namie,nango,nishiaizu,nishigo,okuma,omotego,ono,otama,samegawa,shimogo,shirakawa,showa,soma,sukagawa,taishin,tamakawa,tanagura,tenei,yabuki,yamato,yamatsuri,yanaizu,yugawa<gifu>anpachi,ena,gifu,ginan,godo,gujo,hashima,hichiso,hida,higashishirakawa,ibigawa,ikeda,kakamigahara,kani,kasahara,kasamatsu,kawaue,kitagata,mino,minokamo,mitake,mizunami,motosu,nakatsugawa,ogaki,sakahogi,seki,sekigahara,shirakawa,tajimi,takayama,tarui,toki,tomika,wanouchi,yamagata,yaotsu,yoro<gunma>annaka,chiyoda,fujioka,higashiagatsuma,isesaki,itakura,kanna,kanra,katashina,kawaba,kiryu,kusatsu,maebashi,meiwa,midori,minakami,naganohara,nakanojo,nanmoku,numata,oizumi,ora,ota,shibukawa,shimonita,shinto,showa,takasaki,takayama,tamamura,tatebayashi,tomioka,tsukiyono,tsumagoi,ueno,yoshioka<hiroshima>asaminami,daiwa,etajima,fuchu,fukuyama,hatsukaichi,higashihiroshima,hongo,jinsekikogen,kaita,kui,kumano,kure,mihara,miyoshi,naka,onomichi,osakikamijima,otake,saka,sera,seranishi,shinichi,shobara,takehara<hokkaido>abashiri,abira,aibetsu,akabira,akkeshi,asahikawa,ashibetsu,ashoro,assabu,atsuma,bibai,biei,bifuka,bihoro,biratori,chippubetsu,chitose,date,ebetsu,embetsu,eniwa,erimo,esan,esashi,fukagawa,fukushima,furano,furubira,haboro,hakodate,hamatonbetsu,hidaka,higashikagura,higashikawa,hiroo,hokuryu,hokuto,honbetsu,horokanai,horonobe,ikeda,imakane,ishikari,iwamizawa,iwanai,kamifurano,kamikawa,kamishihoro,kamisunagawa,kamoenai,kayabe,kembuchi,kikonai,kimobetsu,kitahiroshima,kitami,kiyosato,koshimizu,kunneppu,kuriyama,kuromatsunai,kushiro,kutchan,kyowa,mashike,matsumae,mikasa,minamifurano,mombetsu,moseushi,mukawa,muroran,naie,nakagawa,nakasatsunai,nakatombetsu,nanae,nanporo,nayoro,nemuro,niikappu,niki,nishiokoppe,noboribetsu,numata,obihiro,obira,oketo,okoppe,otaru,otobe,otofuke,otoineppu,oumu,ozora,pippu,rankoshi,rebun,rikubetsu,rishiri,rishirifuji,saroma,sarufutsu,shakotan,shari,shibecha,shibetsu,shikabe,shikaoi,shimamaki,shimizu,shimokawa,shinshinotsu,shintoku,shiranuka,shiraoi,shiriuchi,sobetsu,sunagawa,taiki,takasu,takikawa,takinoue,teshikaga,tobetsu,tohma,tomakomai,tomari,toya,toyako,toyotomi,toyoura,tsubetsu,tsukigata,urakawa,urausu,uryu,utashinai,wakkanai,wassamu,yakumo,yoichi<hyogo>aioi,akashi,ako,amagasaki,aogaki,asago,ashiya,awaji,fukusaki,goshiki,harima,himeji,ichikawa,inagawa,itami,kakogawa,kamigori,kamikawa,kasai,kasuga,kawanishi,miki,minamiawaji,nishinomiya,nishiwaki,ono,sanda,sannan,sasayama,sayo,shingu,shinonsen,shiso,sumoto,taishi,taka,takarazuka,takasago,takino,tamba,tatsuno,toyooka,yabu,yashiro,yoka,yokawa<ibaraki>ami,asahi,bando,chikusei,daigo,fujishiro,hitachi,hitachinaka,hitachiomiya,hitachiota,ibaraki,ina,inashiki,itako,iwama,joso,kamisu,kasama,kashima,kasumigaura,koga,miho,mito,moriya,naka,namegata,oarai,ogawa,omitama,ryugasaki,sakai,sakuragawa,shimodate,shimotsuma,shirosato,sowa,suifu,takahagi,tamatsukuri,tokai,tomobe,tone,toride,tsuchiura,tsukuba,uchihara,ushiku,yachiyo,yamagata,yawara,yuki<ishikawa>anamizu,hakui,hakusan,kaga,kahoku,kanazawa,kawakita,komatsu,nakanoto,nanao,nomi,nonoichi,noto,shika,suzu,tsubata,tsurugi,uchinada,wajima<iwate>fudai,fujisawa,hanamaki,hiraizumi,hirono,ichinohe,ichinoseki,iwaizumi,iwate,joboji,kamaishi,kanegasaki,karumai,kawai,kitakami,kuji,kunohe,kuzumaki,miyako,mizusawa,morioka,ninohe,noda,ofunato,oshu,otsuchi,rikuzentakata,shiwa,shizukuishi,sumita,tanohata,tono,yahaba,yamada<kagawa>ayagawa,higashikagawa,kanonji,kotohira,manno,marugame,mitoyo,naoshima,sanuki,tadotsu,takamatsu,tonosho,uchinomi,utazu,zentsuji<kagoshima>akune,amami,hioki,isa,isen,izumi,kagoshima,kanoya,kawanabe,kinko,kouyama,makurazaki,matsumoto,minamitane,nakatane,nishinoomote,satsumasendai,soo,tarumizu,yusui<kanagawa>aikawa,atsugi,ayase,chigasaki,ebina,fujisawa,hadano,hakone,hiratsuka,isehara,kaisei,kamakura,kiyokawa,matsuda,minamiashigara,miura,nakai,ninomiya,odawara,oi,oiso,sagamihara,samukawa,tsukui,yamakita,yamato,yokosuka,yugawara,zama,zushi<kochi>aki,geisei,hidaka,higashitsuno,ino,kagami,kami,kitagawa,kochi,mihara,motoyama,muroto,nahari,nakamura,nankoku,nishitosa,niyodogawa,ochi,okawa,otoyo,otsuki,sakawa,sukumo,susaki,tosa,tosashimizu,toyo,tsuno,umaji,yasuda,yusuhara<kumamoto>amakusa,arao,aso,choyo,gyokuto,kamiamakusa,kikuchi,kumamoto,mashiki,mifune,minamata,minamioguni,nagasu,nishihara,oguni,ozu,sumoto,takamori,uki,uto,yamaga,yamato,yatsushiro<kyoto>ayabe,fukuchiyama,higashiyama,ide,ine,joyo,kameoka,kamo,kita,kizu,kumiyama,kyotamba,kyotanabe,kyotango,maizuru,minami,minamiyamashiro,miyazu,muko,nagaokakyo,nakagyo,nantan,oyamazaki,sakyo,seika,tanabe,uji,ujitawara,wazuka,yamashina,yawata<mie>asahi,inabe,ise,kameyama,kawagoe,kiho,kisosaki,kiwa,komono,kumano,kuwana,matsusaka,meiwa,mihama,minamiise,misugi,miyama,nabari,shima,suzuka,tado,taiki,taki,tamaki,toba,tsu,udono,ureshino,watarai,yokkaichi<miyagi>furukawa,higashimatsushima,ishinomaki,iwanuma,kakuda,kami,kawasaki,marumori,matsushima,minamisanriku,misato,murata,natori,ogawara,ohira,onagawa,osaki,rifu,semine,shibata,shichikashuku,shikama,shiogama,shiroishi,tagajo,taiwa,tome,tomiya,wakuya,watari,yamamoto,zao<miyazaki>aya,ebino,gokase,hyuga,kadogawa,kawaminami,kijo,kitagawa,kitakata,kitaura,kobayashi,kunitomi,kushima,mimata,miyakonojo,miyazaki,morotsuka,nichinan,nishimera,nobeoka,saito,shiiba,shintomi,takaharu,takanabe,takazaki,tsuno<nagano>achi,agematsu,anan,aoki,asahi,azumino,chikuhoku,chikuma,chino,fujimi,hakuba,hara,hiraya,iida,iijima,iiyama,iizuna,ikeda,ikusaka,ina,karuizawa,kawakami,kiso,kisofukushima,kitaaiki,komagane,komoro,matsukawa,matsumoto,miasa,minamiaiki,minamimaki,minamiminowa,minowa,miyada,miyota,mochizuki,nagano,nagawa,nagiso,nakagawa,nakano,nozawaonsen,obuse,ogawa,okaya,omachi,omi,ookuwa,ooshika,otaki,otari,sakae,sakaki,saku,sakuho,shimosuwa,shinanomachi,shiojiri,suwa,suzaka,takagi,takamori,takayama,tateshina,tatsuno,togakushi,togura,tomi,ueda,wada,yamagata,yamanouchi,yasaka,yasuoka<nagasaki>chijiwa,futsu,goto,hasami,hirado,iki,isahaya,kawatana,kuchinotsu,matsuura,nagasaki,obama,omura,oseto,saikai,sasebo,seihi,shimabara,shinkamigoto,togitsu,tsushima,unzen<nara>ando,gose,heguri,higashiyoshino,ikaruga,ikoma,kamikitayama,kanmaki,kashiba,kashihara,katsuragi,kawai,kawakami,kawanishi,koryo,kurotaki,mitsue,miyake,nara,nosegawa,oji,ouda,oyodo,sakurai,sango,shimoichi,shimokitayama,shinjo,soni,takatori,tawaramoto,tenkawa,tenri,uda,yamatokoriyama,yamatotakada,yamazoe,yoshino<niigata>aga,agano,gosen,itoigawa,izumozaki,joetsu,kamo,kariwa,kashiwazaki,minamiuonuma,mitsuke,muika,murakami,myoko,nagaoka,niigata,ojiya,omi,sado,sanjo,seiro,seirou,sekikawa,shibata,tagami,tainai,tochio,tokamachi,tsubame,tsunan,uonuma,yahiko,yoita,yuzawa<oita>beppu,bungoono,bungotakada,hasama,hiji,himeshima,hita,kamitsue,kokonoe,kuju,kunisaki,kusu,oita,saiki,taketa,tsukumi,usa,usuki,yufu<okayama>akaiwa,asakuchi,bizen,hayashima,ibara,kagamino,kasaoka,kibichuo,kumenan,kurashiki,maniwa,misaki,nagi,niimi,nishiawakura,okayama,satosho,setouchi,shinjo,shoo,soja,takahashi,tamano,tsuyama,wake,yakage<okinawa>aguni,ginowan,ginoza,gushikami,haebaru,higashi,hirara,iheya,ishigaki,ishikawa,itoman,izena,kadena,kin,kitadaito,kitanakagusuku,kumejima,kunigami,minamidaito,motobu,nago,naha,nakagusuku,nakijin,nanjo,nishihara,ogimi,okinawa,onna,shimoji,taketomi,tarama,tokashiki,tomigusuku,tonaki,urasoe,uruma,yaese,yomitan,yonabaru,yonaguni,zamami<osaka>abeno,chihayaakasaka,chuo,daito,fujiidera,habikino,hannan,higashiosaka,higashisumiyoshi,higashiyodogawa,hirakata,ibaraki,ikeda,izumi,izumiotsu,izumisano,kadoma,kaizuka,kanan,kashiwara,katano,kawachinagano,kishiwada,kita,kumatori,matsubara,minato,minoh,misaki,moriguchi,neyagawa,nishi,nose,osakasayama,sakai,sayama,sennan,settsu,shijonawate,shimamoto,suita,tadaoka,taishi,tajiri,takaishi,takatsuki,tondabayashi,toyonaka,toyono,yao<saga>ariake,arita,fukudomi,genkai,hamatama,hizen,imari,kamimine,kanzaki,karatsu,kashima,kitagata,kitahata,kiyama,kouhoku,kyuragi,nishiarita,ogi,omachi,ouchi,saga,shiroishi,taku,tara,tosu,yoshinogari<saitama>arakawa,asaka,chichibu,fujimi,fujimino,fukaya,hanno,hanyu,hasuda,hatogaya,hatoyama,hidaka,higashichichibu,higashimatsuyama,honjo,ina,iruma,iwatsuki,kamiizumi,kamikawa,kamisato,kasukabe,kawagoe,kawaguchi,kawajima,kazo,kitamoto,koshigaya,kounosu,kuki,kumagaya,matsubushi,minano,misato,miyashiro,miyoshi,moroyama,nagatoro,namegawa,niiza,ogano,ogawa,ogose,okegawa,omiya,otaki,ranzan,ryokami,saitama,sakado,satte,sayama,shiki,shiraoka,soka,sugito,toda,tokigawa,tokorozawa,tsurugashima,urawa,warabi,yashio,yokoze,yono,yorii,yoshida,yoshikawa,yoshimi<shiga>aisho,gamo,higashiomi,hikone,koka,konan,kosei,koto,kusatsu,maibara,moriyama,nagahama,nishiazai,notogawa,omihachiman,otsu,ritto,ryuoh,takashima,takatsuki,torahime,toyosato,yasu<shimane>akagi,ama,gotsu,hamada,higashiizumo,hikawa,hikimi,izumo,kakinoki,masuda,matsue,misato,nishinoshima,ohda,okinoshima,okuizumo,shimane,tamayu,tsuwano,unnan,yakumo,yasugi,yatsuka<shizuoka>arai,atami,fuji,fujieda,fujikawa,fujinomiya,fukuroi,gotemba,haibara,hamamatsu,higashiizu,ito,iwata,izu,izunokuni,kakegawa,kannami,kawanehon,kawazu,kikugawa,kosai,makinohara,matsuzaki,minamiizu,mishima,morimachi,nishiizu,numazu,omaezaki,shimada,shimizu,shimoda,shizuoka,susono,yaizu,yoshida<tochigi>ashikaga,bato,haga,ichikai,iwafune,kaminokawa,kanuma,karasuyama,kuroiso,mashiko,mibu,moka,motegi,nasu,nasushiobara,nikko,nishikata,nogi,ohira,ohtawara,oyama,sakura,sano,shimotsuke,shioya,takanezawa,tochigi,tsuga,ujiie,utsunomiya,yaita<tokushima>aizumi,anan,ichiba,itano,kainan,komatsushima,matsushige,mima,minami,miyoshi,mugi,nakagawa,naruto,sanagochi,shishikui,tokushima,wajiki<tokyo>adachi,akiruno,akishima,aogashima,arakawa,bunkyo,chiyoda,chofu,chuo,edogawa,fuchu,fussa,hachijo,hachioji,hamura,higashikurume,higashimurayama,higashiyamato,hino,hinode,hinohara,inagi,itabashi,katsushika,kita,kiyose,kodaira,koganei,kokubunji,komae,koto,kouzushima,kunitachi,machida,meguro,minato,mitaka,mizuho,musashimurayama,musashino,nakano,nerima,ogasawara,okutama,ome,oshima,ota,setagaya,shibuya,shinagawa,shinjuku,suginami,sumida,tachikawa,taito,tama,toshima<tottori>chizu,hino,kawahara,koge,kotoura,misasa,nanbu,nichinan,sakaiminato,tottori,wakasa,yazu,yonago<toyama>asahi,fuchu,fukumitsu,funahashi,himi,imizu,inami,johana,kamiichi,kurobe,nakaniikawa,namerikawa,nanto,nyuzen,oyabe,taira,takaoka,tateyama,toga,tonami,toyama,unazuki,uozu,yamada<wakayama>arida,aridagawa,gobo,hashimoto,hidaka,hirogawa,inami,iwade,kainan,kamitonda,katsuragi,kimino,kinokawa,kitayama,koya,koza,kozagawa,kudoyama,kushimoto,mihama,misato,nachikatsuura,shingu,shirahama,taiji,tanabe,wakayama,yuasa,yura<yamagata>asahi,funagata,higashine,iide,kahoku,kaminoyama,kaneyama,kawanishi,mamurogawa,mikawa,murayama,nagai,nakayama,nanyo,nishikawa,obanazawa,oe,oguni,ohkura,oishida,sagae,sakata,sakegawa,shinjo,shirataka,shonai,takahata,tendo,tozawa,tsuruoka,yamagata,yamanobe,yonezawa,yuza<yamaguchi>abu,hagi,hikari,hofu,iwakuni,kudamatsu,mitou,nagato,oshima,shimonoseki,shunan,tabuse,tokuyama,toyota,ube,yuu<yamanashi>chuo,doshi,fuefuki,fujikawa,fujikawaguchiko,fujiyoshida,hayakawa,hokuto,ichikawamisato,kai,kofu,koshu,kosuge,minami-alps,minobu,nakamichi,nanbu,narusawa,nirasaki,nishikatsura,oshino,otsuki,showa,tabayama,tsuru,uenohara,yamanakako,yamanashi<xn--4pvxs,xn--vgu402c,xn--c3s14m,xn--f6qx53a,xn--8pvr4u,xn--uist22h,xn--djrs72d6uy,xn--mkru45i,xn--0trq7p7nn,xn--8ltr62k,xn--2m4a15e,xn--efvn9s,xn--32vp30h,xn--4it797k,xn--1lqs71d,xn--5rtp49c,xn--5js045d,xn--ehqz56n,xn--1lqs03n,xn--qqqt11m,xn--kbrq7o,xn--pssu33l,xn--ntsq17g,xn--uisz3g,xn--6btw5a,xn--1ctwo,xn--6orx2r,xn--rht61e,xn--rht27z,xn--djty4k,xn--nit225k,xn--rht3d,xn--klty5x,xn--kltx9a,xn--kltp7d,xn--uuwu58a,xn--zbx025d,xn--ntso0iqx3a,xn--elqq16h,xn--4it168d,xn--klt787d,xn--rny31h,xn--7t0a264c,xn--5rtq34k,xn--k7yn95e,xn--tor131o,xn--d5qv7z876c,kawasaki>*,!city<kitakyushu>*,!city<kobe>*,!city<nagoya>*,!city<sapporo>*,!city<sendai>*,!city<yokohama>*,!city<<ke>ac,co,go,info,me,mobi,ne,or,sc<kg>org,net,com,edu,gov,mil<kh>*<ki>edu,biz,net,org,gov,info,com<km>org,nom,gov,prd,tm,edu,mil,ass,com,coop,asso,presse,medecin,notaires,pharmaciens,veterinaire,gouv<kn>net,org,edu,gov<kp>com,edu,gov,org,rep,tra<kr>ac,co,es,go,hs,kg,mil,ms,ne,or,pe,re,sc,busan,chungbuk,chungnam,daegu,daejeon,gangwon,gwangju,gyeongbuk,gyeonggi,gyeongnam,incheon,jeju,jeonbuk,jeonnam,seoul,ulsan<kw>com,edu,emb,gov,ind,net,org<ky>com,edu,net,org<kz>org,edu,net,gov,mil,com<la>int,net,info,edu,gov,per,com,org<lb>com,edu,gov,net,org<lc>com,net,co,org,edu,gov<li,lk>gov,sch,net,int,com,org,edu,ngo,soc,web,ltd,assn,grp,hotel,ac<lr>com,edu,gov,org,net<ls>ac,biz,co,edu,gov,info,net,org,sc<lt>gov<lu,lv>com,edu,gov,org,mil,id,net,asn,conf<ly>com,net,gov,plc,edu,sch,med,org,id<ma>co,net,gov,org,ac,press<mc>tm,asso<md,me>co,net,org,edu,ac,gov,its,priv<mg>org,nom,gov,prd,tm,edu,mil,com,co<mh,mil,mk>com,org,net,edu,gov,inf,name<ml>com,edu,gouv,gov,net,org,presse<mm>*<mn>gov,edu,org<mo>com,net,org,edu,gov<mobi,mp,mq,mr>gov<ms>com,edu,gov,net,org<mt>com,edu,net,org<mu>com,net,org,gov,ac,co,or<museum>academy,agriculture,air,airguard,alabama,alaska,amber,ambulance,american,americana,americanantiques,americanart,amsterdam,and,annefrank,anthro,anthropology,antiques,aquarium,arboretum,archaeological,archaeology,architecture,art,artanddesign,artcenter,artdeco,arteducation,artgallery,arts,artsandcrafts,asmatart,assassination,assisi,association,astronomy,atlanta,austin,australia,automotive,aviation,axis,badajoz,baghdad,bahn,bale,baltimore,barcelona,baseball,basel,baths,bauern,beauxarts,beeldengeluid,bellevue,bergbau,berkeley,berlin,bern,bible,bilbao,bill,birdart,birthplace,bonn,boston,botanical,botanicalgarden,botanicgarden,botany,brandywinevalley,brasil,bristol,british,britishcolumbia,broadcast,brunel,brussel,brussels,bruxelles,building,burghof,bus,bushey,cadaques,california,cambridge,can,canada,capebreton,carrier,cartoonart,casadelamoneda,castle,castres,celtic,center,chattanooga,cheltenham,chesapeakebay,chicago,children,childrens,childrensgarden,chiropractic,chocolate,christiansburg,cincinnati,cinema,circus,civilisation,civilization,civilwar,clinton,clock,coal,coastaldefence,cody,coldwar,collection,colonialwilliamsburg,coloradoplateau,columbia,columbus,communication,communications,community,computer,computerhistory,xn--comunicaes-v6a2o,contemporary,contemporaryart,convent,copenhagen,corporation,xn--correios-e-telecomunicaes-ghc29a,corvette,costume,countryestate,county,crafts,cranbrook,creation,cultural,culturalcenter,culture,cyber,cymru,dali,dallas,database,ddr,decorativearts,delaware,delmenhorst,denmark,depot,design,detroit,dinosaur,discovery,dolls,donostia,durham,eastafrica,eastcoast,education,educational,egyptian,eisenbahn,elburg,elvendrell,embroidery,encyclopedic,england,entomology,environment,environmentalconservation,epilepsy,essex,estate,ethnology,exeter,exhibition,family,farm,farmequipment,farmers,farmstead,field,figueres,filatelia,film,fineart,finearts,finland,flanders,florida,force,fortmissoula,fortworth,foundation,francaise,frankfurt,franziskaner,freemasonry,freiburg,fribourg,frog,fundacio,furniture,gallery,garden,gateway,geelvinck,gemological,geology,georgia,giessen,glas,glass,gorge,grandrapids,graz,guernsey,halloffame,hamburg,handson,harvestcelebration,hawaii,health,heimatunduhren,hellas,helsinki,hembygdsforbund,heritage,histoire,historical,historicalsociety,historichouses,historisch,historisches,history,historyofscience,horology,house,humanities,illustration,imageandsound,indian,indiana,indianapolis,indianmarket,intelligence,interactive,iraq,iron,isleofman,jamison,jefferson,jerusalem,jewelry,jewish,jewishart,jfk,journalism,judaica,judygarland,juedisches,juif,karate,karikatur,kids,koebenhavn,koeln,kunst,kunstsammlung,kunstunddesign,labor,labour,lajolla,lancashire,landes,lans,xn--lns-qla,larsson,lewismiller,lincoln,linz,living,livinghistory,localhistory,london,losangeles,louvre,loyalist,lucerne,luxembourg,luzern,mad,madrid,mallorca,manchester,mansion,mansions,manx,marburg,maritime,maritimo,maryland,marylhurst,media,medical,medizinhistorisches,meeres,memorial,mesaverde,michigan,midatlantic,military,mill,miners,mining,minnesota,missile,missoula,modern,moma,money,monmouth,monticello,montreal,moscow,motorcycle,muenchen,muenster,mulhouse,muncie,museet,museumcenter,museumvereniging,music,national,nationalfirearms,nationalheritage,nativeamerican,naturalhistory,naturalhistorymuseum,naturalsciences,nature,naturhistorisches,natuurwetenschappen,naumburg,naval,nebraska,neues,newhampshire,newjersey,newmexico,newport,newspaper,newyork,niepce,norfolk,north,nrw,nyc,nyny,oceanographic,oceanographique,omaha,online,ontario,openair,oregon,oregontrail,otago,oxford,pacific,paderborn,palace,paleo,palmsprings,panama,paris,pasadena,pharmacy,philadelphia,philadelphiaarea,philately,phoenix,photography,pilots,pittsburgh,planetarium,plantation,plants,plaza,portal,portland,portlligat,posts-and-telecommunications,preservation,presidio,press,project,public,pubol,quebec,railroad,railway,research,resistance,riodejaneiro,rochester,rockart,roma,russia,saintlouis,salem,salvadordali,salzburg,sandiego,sanfrancisco,santabarbara,santacruz,santafe,saskatchewan,satx,savannahga,schlesisches,schoenbrunn,schokoladen,school,schweiz,science,scienceandhistory,scienceandindustry,sciencecenter,sciencecenters,science-fiction,sciencehistory,sciences,sciencesnaturelles,scotland,seaport,settlement,settlers,shell,sherbrooke,sibenik,silk,ski,skole,society,sologne,soundandvision,southcarolina,southwest,space,spy,square,stadt,stalbans,starnberg,state,stateofdelaware,station,steam,steiermark,stjohn,stockholm,stpetersburg,stuttgart,suisse,surgeonshall,surrey,svizzera,sweden,sydney,tank,tcm,technology,telekommunikation,television,texas,textile,theater,time,timekeeping,topology,torino,touch,town,transport,tree,trolley,trust,trustee,uhren,ulm,undersea,university,usa,usantiques,usarts,uscountryestate,usculture,usdecorativearts,usgarden,ushistory,ushuaia,uslivinghistory,utah,uvic,valley,vantaa,versailles,viking,village,virginia,virtual,virtuel,vlaanderen,volkenkunde,wales,wallonie,war,washingtondc,watchandclock,watch-and-clock,western,westfalen,whaling,wildlife,williamsburg,windmill,workshop,york,yorkshire,yosemite,youth,zoological,zoology,xn--9dbhblg6di,xn--h1aegh<mv>aero,biz,com,coop,edu,gov,info,int,mil,museum,name,net,org,pro<mw>ac,biz,co,com,coop,edu,gov,int,museum,net,org<mx>com,org,gob,edu,net<my>biz,com,edu,gov,mil,name,net,org<mz>ac,adv,co,edu,gov,mil,net,org<na>info,pro,name,school,or,dr,us,mx,ca,in,cc,tv,ws,mobi,co,com,org<name,nc>asso,nom<ne,net,nf>com,net,per,rec,web,arts,firm,info,other,store<ng>com,edu,gov,i,mil,mobi,name,net,org,sch<ni>ac,biz,co,com,edu,gob,in,info,int,mil,net,nom,org,web<nl,no>fhs,vgs,fylkesbibl,folkebibl,museum,idrett,priv,mil,stat,dep,kommune,herad,aa>gs<ah>gs<bu>gs<fm>gs<hl>gs<hm>gs<jan-mayen>gs<mr>gs<nl>gs<nt>gs<of>gs<ol>gs<oslo>gs<rl>gs<sf>gs<st>gs<svalbard>gs<tm>gs<tr>gs<va>gs<vf>gs<akrehamn,xn--krehamn-dxa,algard,xn--lgrd-poac,arna,brumunddal,bryne,bronnoysund,xn--brnnysund-m8ac,drobak,xn--drbak-wua,egersund,fetsund,floro,xn--flor-jra,fredrikstad,hokksund,honefoss,xn--hnefoss-q1a,jessheim,jorpeland,xn--jrpeland-54a,kirkenes,kopervik,krokstadelva,langevag,xn--langevg-jxa,leirvik,mjondalen,xn--mjndalen-64a,mo-i-rana,mosjoen,xn--mosjen-eya,nesoddtangen,orkanger,osoyro,xn--osyro-wua,raholt,xn--rholt-mra,sandnessjoen,xn--sandnessjen-ogb,skedsmokorset,slattum,spjelkavik,stathelle,stavern,stjordalshalsen,xn--stjrdalshalsen-sqb,tananger,tranby,vossevangen,afjord,xn--fjord-lra,agdenes,al,xn--l-1fa,alesund,xn--lesund-hua,alstahaug,alta,xn--lt-liac,alaheadju,xn--laheadju-7ya,alvdal,amli,xn--mli-tla,amot,xn--mot-tla,andebu,andoy,xn--andy-ira,andasuolo,ardal,xn--rdal-poa,aremark,arendal,xn--s-1fa,aseral,xn--seral-lra,asker,askim,askvoll,askoy,xn--asky-ira,asnes,xn--snes-poa,audnedaln,aukra,aure,aurland,aurskog-holand,xn--aurskog-hland-jnb,austevoll,austrheim,averoy,xn--avery-yua,balestrand,ballangen,balat,xn--blt-elab,balsfjord,bahccavuotna,xn--bhccavuotna-k7a,bamble,bardu,beardu,beiarn,bajddar,xn--bjddar-pta,baidar,xn--bidr-5nac,berg,bergen,berlevag,xn--berlevg-jxa,bearalvahki,xn--bearalvhki-y4a,bindal,birkenes,bjarkoy,xn--bjarky-fya,bjerkreim,bjugn,bodo,xn--bod-2na,badaddja,xn--bdddj-mrabd,budejju,bokn,bremanger,bronnoy,xn--brnny-wuac,bygland,bykle,barum,xn--brum-voa,telemark>bo,xn--b-5ga<nordland>bo,xn--b-5ga,heroy,xn--hery-ira<bievat,xn--bievt-0qa,bomlo,xn--bmlo-gra,batsfjord,xn--btsfjord-9za,bahcavuotna,xn--bhcavuotna-s4a,dovre,drammen,drangedal,dyroy,xn--dyry-ira,donna,xn--dnna-gra,eid,eidfjord,eidsberg,eidskog,eidsvoll,eigersund,elverum,enebakk,engerdal,etne,etnedal,evenes,evenassi,xn--eveni-0qa01ga,evje-og-hornnes,farsund,fauske,fuossko,fuoisku,fedje,fet,finnoy,xn--finny-yua,fitjar,fjaler,fjell,flakstad,flatanger,flekkefjord,flesberg,flora,fla,xn--fl-zia,folldal,forsand,fosnes,frei,frogn,froland,frosta,frana,xn--frna-woa,froya,xn--frya-hra,fusa,fyresdal,forde,xn--frde-gra,gamvik,gangaviika,xn--ggaviika-8ya47h,gaular,gausdal,gildeskal,xn--gildeskl-g0a,giske,gjemnes,gjerdrum,gjerstad,gjesdal,gjovik,xn--gjvik-wua,gloppen,gol,gran,grane,granvin,gratangen,grimstad,grong,kraanghke,xn--kranghke-b0a,grue,gulen,hadsel,halden,halsa,hamar,hamaroy,habmer,xn--hbmer-xqa,hapmir,xn--hpmir-xqa,hammerfest,hammarfeasta,xn--hmmrfeasta-s4ac,haram,hareid,harstad,hasvik,aknoluokta,xn--koluokta-7ya57h,hattfjelldal,aarborte,haugesund,hemne,hemnes,hemsedal,more-og-romsdal>heroy,sande<xn--mre-og-romsdal-qqb>xn--hery-ira,sande<hitra,hjartdal,hjelmeland,hobol,xn--hobl-ira,hof,hol,hole,holmestrand,holtalen,xn--holtlen-hxa,hornindal,horten,hurdal,hurum,hvaler,hyllestad,hagebostad,xn--hgebostad-g3a,hoyanger,xn--hyanger-q1a,hoylandet,xn--hylandet-54a,ha,xn--h-2fa,ibestad,inderoy,xn--indery-fya,iveland,jevnaker,jondal,jolster,xn--jlster-bya,karasjok,karasjohka,xn--krjohka-hwab49j,karlsoy,galsa,xn--gls-elac,karmoy,xn--karmy-yua,kautokeino,guovdageaidnu,klepp,klabu,xn--klbu-woa,kongsberg,kongsvinger,kragero,xn--krager-gya,kristiansand,kristiansund,krodsherad,xn--krdsherad-m8a,kvalsund,rahkkeravju,xn--rhkkervju-01af,kvam,kvinesdal,kvinnherad,kviteseid,kvitsoy,xn--kvitsy-fya,kvafjord,xn--kvfjord-nxa,giehtavuoatna,kvanangen,xn--kvnangen-k0a,navuotna,xn--nvuotna-hwa,kafjord,xn--kfjord-iua,gaivuotna,xn--givuotna-8ya,larvik,lavangen,lavagis,loabat,xn--loabt-0qa,lebesby,davvesiida,leikanger,leirfjord,leka,leksvik,lenvik,leangaviika,xn--leagaviika-52b,lesja,levanger,lier,lierne,lillehammer,lillesand,lindesnes,lindas,xn--linds-pra,lom,loppa,lahppi,xn--lhppi-xqa,lund,lunner,luroy,xn--lury-ira,luster,lyngdal,lyngen,ivgu,lardal,lerdal,xn--lrdal-sra,lodingen,xn--ldingen-q1a,lorenskog,xn--lrenskog-54a,loten,xn--lten-gra,malvik,masoy,xn--msy-ula0h,muosat,xn--muost-0qa,mandal,marker,marnardal,masfjorden,meland,meldal,melhus,meloy,xn--mely-ira,meraker,xn--merker-kua,moareke,xn--moreke-jua,midsund,midtre-gauldal,modalen,modum,molde,moskenes,moss,mosvik,malselv,xn--mlselv-iua,malatvuopmi,xn--mlatvuopmi-s4a,namdalseid,aejrie,namsos,namsskogan,naamesjevuemie,xn--nmesjevuemie-tcba,laakesvuemie,nannestad,narvik,narviika,naustdal,nedre-eiker,akershus>nes<buskerud>nes<nesna,nesodden,nesseby,unjarga,xn--unjrga-rta,nesset,nissedal,nittedal,nord-aurdal,nord-fron,nord-odal,norddal,nordkapp,davvenjarga,xn--davvenjrga-y4a,nordre-land,nordreisa,raisa,xn--risa-5na,nore-og-uvdal,notodden,naroy,xn--nry-yla5g,notteroy,xn--nttery-byae,odda,oksnes,xn--ksnes-uua,oppdal,oppegard,xn--oppegrd-ixa,orkdal,orland,xn--rland-uua,orskog,xn--rskog-uua,orsta,xn--rsta-fra,hedmark>os,valer,xn--vler-qoa<hordaland>os<osen,osteroy,xn--ostery-fya,ostre-toten,xn--stre-toten-zcb,overhalla,ovre-eiker,xn--vre-eiker-k8a,oyer,xn--yer-zna,oygarden,xn--ygarden-p1a,oystre-slidre,xn--ystre-slidre-ujb,porsanger,porsangu,xn--porsgu-sta26f,porsgrunn,radoy,xn--rady-ira,rakkestad,rana,ruovat,randaberg,rauma,rendalen,rennebu,rennesoy,xn--rennesy-v1a,rindal,ringebu,ringerike,ringsaker,rissa,risor,xn--risr-ira,roan,rollag,rygge,ralingen,xn--rlingen-mxa,rodoy,xn--rdy-0nab,romskog,xn--rmskog-bya,roros,xn--rros-gra,rost,xn--rst-0na,royken,xn--ryken-vua,royrvik,xn--ryrvik-bya,rade,xn--rde-ula,salangen,siellak,saltdal,salat,xn--slt-elab,xn--slat-5na,samnanger,vestfold>sande<sandefjord,sandnes,sandoy,xn--sandy-yua,sarpsborg,sauda,sauherad,sel,selbu,selje,seljord,sigdal,siljan,sirdal,skaun,skedsmo,ski,skien,skiptvet,skjervoy,xn--skjervy-v1a,skierva,xn--skierv-uta,skjak,xn--skjk-soa,skodje,skanland,xn--sknland-fxa,skanit,xn--sknit-yqa,smola,xn--smla-hra,snillfjord,snasa,xn--snsa-roa,snoasa,snaase,xn--snase-nra,sogndal,sokndal,sola,solund,songdalen,sortland,spydeberg,stange,stavanger,steigen,steinkjer,stjordal,xn--stjrdal-s1a,stokke,stor-elvdal,stord,stordal,storfjord,omasvuotna,strand,stranda,stryn,sula,suldal,sund,sunndal,surnadal,sveio,svelvik,sykkylven,sogne,xn--sgne-gra,somna,xn--smna-gra,sondre-land,xn--sndre-land-0cb,sor-aurdal,xn--sr-aurdal-l8a,sor-fron,xn--sr-fron-q1a,sor-odal,xn--sr-odal-q1a,sor-varanger,xn--sr-varanger-ggb,matta-varjjat,xn--mtta-vrjjat-k7af,sorfold,xn--srfold-bya,sorreisa,xn--srreisa-q1a,sorum,xn--srum-gra,tana,deatnu,time,tingvoll,tinn,tjeldsund,dielddanuorri,tjome,xn--tjme-hra,tokke,tolga,torsken,tranoy,xn--trany-yua,tromso,xn--troms-zua,tromsa,romsa,trondheim,troandin,trysil,trana,xn--trna-woa,trogstad,xn--trgstad-r1a,tvedestrand,tydal,tynset,tysfjord,divtasvuodna,divttasvuotna,tysnes,tysvar,xn--tysvr-vra,tonsberg,xn--tnsberg-q1a,ullensaker,ullensvang,ulvik,utsira,vadso,xn--vads-jra,cahcesuolo,xn--hcesuolo-7ya35b,vaksdal,valle,vang,vanylven,vardo,xn--vard-jra,varggat,xn--vrggt-xqad,vefsn,vaapste,vega,vegarshei,xn--vegrshei-c0a,vennesla,verdal,verran,vestby,vestnes,vestre-slidre,vestre-toten,vestvagoy,xn--vestvgy-ixa6o,vevelstad,vik,vikna,vindafjord,volda,voss,varoy,xn--vry-yla5g,vagan,xn--vgan-qoa,voagat,vagsoy,xn--vgsy-qoa0j,vaga,xn--vg-yiab,ostfold>valer<xn--stfold-9xa>xn--vler-qoa<<np>*<nr>biz,info,gov,edu,org,net,com<nu,nz>ac,co,cri,geek,gen,govt,health,iwi,kiwi,maori,mil,xn--mori-qsa,net,org,parliament,school<om>co,com,edu,gov,med,museum,net,org,pro<onion,org,pa>ac,gob,com,org,sld,edu,net,ing,abo,med,nom<pe>edu,gob,nom,mil,org,com,net<pf>com,org,edu<pg>*<ph>com,net,org,gov,edu,ngo,mil,i<pk>com,net,edu,org,fam,biz,web,gov,gob,gok,gon,gop,gos,info<pl>com,net,org,aid,agro,atm,auto,biz,edu,gmina,gsm,info,mail,miasta,media,mil,nieruchomosci,nom,pc,powiat,priv,realestate,rel,sex,shop,sklep,sos,szkola,targi,tm,tourism,travel,turystyka,gov>ap,ic,is,us,kmpsp,kppsp,kwpsp,psp,wskr,kwp,mw,ug,um,umig,ugim,upow,uw,starostwo,pa,po,psse,pup,rzgw,sa,so,sr,wsa,sko,uzs,wiih,winb,pinb,wios,witd,wzmiuw,piw,wiw,griw,wif,oum,sdn,zp,uppo,mup,wuoz,konsulat,oirm<augustow,babia-gora,bedzin,beskidy,bialowieza,bialystok,bielawa,bieszczady,boleslawiec,bydgoszcz,bytom,cieszyn,czeladz,czest,dlugoleka,elblag,elk,glogow,gniezno,gorlice,grajewo,ilawa,jaworzno,jelenia-gora,jgora,kalisz,kazimierz-dolny,karpacz,kartuzy,kaszuby,katowice,kepno,ketrzyn,klodzko,kobierzyce,kolobrzeg,konin,konskowola,kutno,lapy,lebork,legnica,lezajsk,limanowa,lomza,lowicz,lubin,lukow,malbork,malopolska,mazowsze,mazury,mielec,mielno,mragowo,naklo,nowaruda,nysa,olawa,olecko,olkusz,olsztyn,opoczno,opole,ostroda,ostroleka,ostrowiec,ostrowwlkp,pila,pisz,podhale,podlasie,polkowice,pomorze,pomorskie,prochowice,pruszkow,przeworsk,pulawy,radom,rawa-maz,rybnik,rzeszow,sanok,sejny,slask,slupsk,sosnowiec,stalowa-wola,skoczow,starachowice,stargard,suwalki,swidnica,swiebodzin,swinoujscie,szczecin,szczytno,tarnobrzeg,tgory,turek,tychy,ustka,walbrzych,warmia,warszawa,waw,wegrow,wielun,wlocl,wloclawek,wodzislaw,wolomin,wroclaw,zachpomor,zagan,zarow,zgora,zgorzelec<pm,pn>gov,co,org,edu,net<post,pr>com,net,org,gov,edu,isla,pro,biz,info,name,est,prof,ac<pro>aaa,aca,acct,avocat,bar,cpa,eng,jur,law,med,recht<ps>edu,gov,sec,plo,com,org,net<pt>net,gov,org,edu,int,publ,com,nome<pw>co,ne,or,ed,go,belau<py>com,coop,edu,gov,mil,net,org<qa>com,edu,gov,mil,name,net,org,sch<re>asso,com,nom<ro>arts,com,firm,info,nom,nt,org,rec,store,tm,www<rs>ac,co,edu,gov,in,org<ru,rw>ac,co,coop,gov,mil,net,org<sa>com,net,org,gov,med,pub,edu,sch<sb>com,edu,gov,net,org<sc>com,gov,net,org,edu<sd>com,net,org,edu,med,tv,gov,info<se>a,ac,b,bd,brand,c,d,e,f,fh,fhsk,fhv,g,h,i,k,komforb,kommunalforbund,komvux,l,lanbib,m,n,naturbruksgymn,o,org,p,parti,pp,press,r,s,t,tm,u,w,x,y,z<sg>com,net,org,gov,edu,per<sh>com,net,gov,org,mil<si,sj,sk,sl>com,net,edu,gov,org<sm,sn>art,com,edu,gouv,org,perso,univ<so>com,edu,gov,me,net,org<sr,ss>biz,com,edu,gov,me,net,org,sch<st>co,com,consulado,edu,embaixada,mil,net,org,principe,saotome,store<su,sv>com,edu,gob,org,red<sx>gov<sy>edu,gov,net,mil,com,org<sz>co,ac,org<tc,td,tel,tf,tg,th>ac,co,go,in,mi,net,or<tj>ac,biz,co,com,edu,go,gov,int,mil,name,net,nic,org,test,web<tk,tl>gov<tm>com,co,org,net,nom,gov,mil,edu<tn>com,ens,fin,gov,ind,info,intl,mincom,nat,net,org,perso,tourism<to>com,gov,net,org,edu,mil<tr>av,bbs,bel,biz,com,dr,edu,gen,gov,info,mil,k12,kep,name,net,org,pol,tel,tsk,tv,web,nc>gov<<tt>co,com,org,net,biz,info,pro,int,coop,jobs,mobi,travel,museum,aero,name,gov,edu<tv,tw>edu,gov,mil,com,net,org,idv,game,ebiz,club,xn--zf0ao64a,xn--uc0atv,xn--czrw28b<tz>ac,co,go,hotel,info,me,mil,mobi,ne,or,sc,tv<ua>com,edu,gov,in,net,org,cherkassy,cherkasy,chernigov,chernihiv,chernivtsi,chernovtsy,ck,cn,cr,crimea,cv,dn,dnepropetrovsk,dnipropetrovsk,donetsk,dp,if,ivano-frankivsk,kh,kharkiv,kharkov,kherson,khmelnitskiy,khmelnytskyi,kiev,kirovograd,km,kr,krym,ks,kv,kyiv,lg,lt,lugansk,lutsk,lv,lviv,mk,mykolaiv,nikolaev,od,odesa,odessa,pl,poltava,rivne,rovno,rv,sb,sebastopol,sevastopol,sm,sumy,te,ternopil,uz,uzhgorod,vinnica,vinnytsia,vn,volyn,yalta,zaporizhzhe,zaporizhzhia,zhitomir,zhytomyr,zp,zt<ug>co,or,ac,sc,go,ne,com,org<uk>ac,co,gov,ltd,me,net,nhs,org,plc,police,sch>*<<us>dni,fed,isa,kids,nsn,ak>k12,cc,lib<al>k12,cc,lib<ar>k12,cc,lib<as>k12,cc,lib<az>k12,cc,lib<ca>k12,cc,lib<co>k12,cc,lib<ct>k12,cc,lib<dc>k12,cc,lib<de>k12,cc<fl>k12,cc,lib<ga>k12,cc,lib<gu>k12,cc,lib<hi>cc,lib<ia>k12,cc,lib<id>k12,cc,lib<il>k12,cc,lib<in>k12,cc,lib<ks>k12,cc,lib<ky>k12,cc,lib<la>k12,cc,lib<ma>k12>pvt,chtr,paroch<cc,lib<md>k12,cc,lib<me>k12,cc,lib<mi>k12,cc,lib,ann-arbor,cog,dst,eaton,gen,mus,tec,washtenaw<mn>k12,cc,lib<mo>k12,cc,lib<ms>k12,cc,lib<mt>k12,cc,lib<nc>k12,cc,lib<nd>cc,lib<ne>k12,cc,lib<nh>k12,cc,lib<nj>k12,cc,lib<nm>k12,cc,lib<nv>k12,cc,lib<ny>k12,cc,lib<oh>k12,cc,lib<ok>k12,cc,lib<or>k12,cc,lib<pa>k12,cc,lib<pr>k12,cc,lib<ri>cc,lib<sc>k12,cc,lib<sd>cc,lib<tn>k12,cc,lib<tx>k12,cc,lib<ut>k12,cc,lib<vi>k12,cc,lib<vt>k12,cc,lib<va>k12,cc,lib<wa>k12,cc,lib<wi>k12,cc,lib<wv>cc<wy>k12,cc,lib<<uy>com,edu,gub,mil,net,org<uz>co,com,net,org<va,vc>com,net,org,gov,mil,edu<ve>arts,bib,co,com,e12,edu,firm,gob,gov,info,int,mil,net,nom,org,rar,rec,store,tec,web<vg,vi>co,com,k12,net,org<vn>com,net,org,edu,gov,int,ac,biz,info,name,pro,health<vu>com,edu,net,org<wf,ws>com,net,org,gov,edu<yt,xn--mgbaam7a8h,xn--y9a3aq,xn--54b7fta0cc,xn--90ae,xn--mgbcpq6gpa1a,xn--90ais,xn--fiqs8s,xn--fiqz9s,xn--lgbbat1ad8j,xn--wgbh1c,xn--e1a4c,xn--qxa6a,xn--mgbah1a3hjkrd,xn--node,xn--qxam,xn--j6w193g>xn--55qx5d,xn--wcvs22d,xn--mxtq1m,xn--gmqw5a,xn--od0alg,xn--uc0atv<xn--2scrj9c,xn--3hcrj9c,xn--45br5cyl,xn--h2breg3eve,xn--h2brj9c8c,xn--mgbgu82a,xn--rvc1e0am3e,xn--h2brj9c,xn--mgbbh1a,xn--mgbbh1a71e,xn--fpcrj9c3d,xn--gecrj9c,xn--s9brj9c,xn--45brj9c,xn--xkc2dl3a5ee0h,xn--mgba3a4f16a,xn--mgba3a4fra,xn--mgbtx2b,xn--mgbayh7gpa,xn--3e0b707e,xn--80ao21a,xn--q7ce6a,xn--fzc2c9e2c,xn--xkc2al3hye2a,xn--mgbc0a9azcg,xn--d1alf,xn--l1acc,xn--mix891f,xn--mix082f,xn--mgbx4cd0ab,xn--mgb9awbf,xn--mgbai9azgqp6j,xn--mgbai9a5eva00b,xn--ygbi2ammx,xn--90a3ac>xn--o1ac,xn--c1avg,xn--90azh,xn--d1at,xn--o1ach,xn--80au<xn--p1ai,xn--wgbl6a,xn--mgberp4a5d4ar,xn--mgberp4a5d4a87g,xn--mgbqly7c0a67fbc,xn--mgbqly7cvafr,xn--mgbpl2fh,xn--yfro4i67o,xn--clchc0ea0b2g2a9gcd,xn--ogbpf8fl,xn--mgbtf8fl,xn--o3cw4h>xn--12c1fe0br,xn--12co0c3b4eva,xn--h3cuzk1di,xn--o3cyx2a,xn--m3ch0j3a,xn--12cfi8ixb8l<xn--pgbs0dh,xn--kpry57d,xn--kprw13d,xn--nnx388a,xn--j1amh,xn--mgb2ddes,xxx,ye>com,edu,gov,net,mil,org<za>ac,agric,alt,co,edu,gov,grondar,law,mil,net,ngo,nic,nis,nom,org,school,tm,web<zm>ac,biz,co,com,edu,gov,info,mil,net,org,sch<zw>ac,co,gov,mil,org<aaa,aarp,abarth,abb,abbott,abbvie,abc,able,abogado,abudhabi,academy,accenture,accountant,accountants,aco,actor,adac,ads,adult,aeg,aetna,afl,africa,agakhan,agency,aig,airbus,airforce,airtel,akdn,alfaromeo,alibaba,alipay,allfinanz,allstate,ally,alsace,alstom,amazon,americanexpress,americanfamily,amex,amfam,amica,amsterdam,analytics,android,anquan,anz,aol,apartments,app,apple,aquarelle,arab,aramco,archi,army,art,arte,asda,associates,athleta,attorney,auction,audi,audible,audio,auspost,author,auto,autos,avianca,aws,axa,azure,baby,baidu,banamex,bananarepublic,band,bank,bar,barcelona,barclaycard,barclays,barefoot,bargains,baseball,basketball,bauhaus,bayern,bbc,bbt,bbva,bcg,bcn,beats,beauty,beer,bentley,berlin,best,bestbuy,bet,bharti,bible,bid,bike,bing,bingo,bio,black,blackfriday,blockbuster,blog,bloomberg,blue,bms,bmw,bnpparibas,boats,boehringer,bofa,bom,bond,boo,book,booking,bosch,bostik,boston,bot,boutique,box,bradesco,bridgestone,broadway,broker,brother,brussels,budapest,bugatti,build,builders,business,buy,buzz,bzh,cab,cafe,cal,call,calvinklein,cam,camera,camp,cancerresearch,canon,capetown,capital,capitalone,car,caravan,cards,care,career,careers,cars,casa,case,cash,casino,catering,catholic,cba,cbn,cbre,cbs,center,ceo,cern,cfa,cfd,chanel,channel,charity,chase,chat,cheap,chintai,christmas,chrome,church,cipriani,circle,cisco,citadel,citi,citic,city,cityeats,claims,cleaning,click,clinic,clinique,clothing,cloud,club,clubmed,coach,codes,coffee,college,cologne,comcast,commbank,community,company,compare,computer,comsec,condos,construction,consulting,contact,contractors,cooking,cookingchannel,cool,corsica,country,coupon,coupons,courses,cpa,credit,creditcard,creditunion,cricket,crown,crs,cruise,cruises,csc,cuisinella,cymru,cyou,dabur,dad,dance,data,date,dating,datsun,day,dclk,dds,deal,dealer,deals,degree,delivery,dell,deloitte,delta,democrat,dental,dentist,desi,design,dev,dhl,diamonds,diet,digital,direct,directory,discount,discover,dish,diy,dnp,docs,doctor,dog,domains,dot,download,drive,dtv,dubai,dunlop,dupont,durban,dvag,dvr,earth,eat,eco,edeka,education,email,emerck,energy,engineer,engineering,enterprises,epson,equipment,ericsson,erni,esq,estate,etisalat,eurovision,eus,events,exchange,expert,exposed,express,extraspace,fage,fail,fairwinds,faith,family,fan,fans,farm,farmers,fashion,fast,fedex,feedback,ferrari,ferrero,fiat,fidelity,fido,film,final,finance,financial,fire,firestone,firmdale,fish,fishing,fit,fitness,flickr,flights,flir,florist,flowers,fly,foo,food,foodnetwork,football,ford,forex,forsale,forum,foundation,fox,free,fresenius,frl,frogans,frontdoor,frontier,ftr,fujitsu,fun,fund,furniture,futbol,fyi,gal,gallery,gallo,gallup,game,games,gap,garden,gay,gbiz,gdn,gea,gent,genting,george,ggee,gift,gifts,gives,giving,glass,gle,global,globo,gmail,gmbh,gmo,gmx,godaddy,gold,goldpoint,golf,goo,goodyear,goog,google,gop,got,grainger,graphics,gratis,green,gripe,grocery,group,guardian,gucci,guge,guide,guitars,guru,hair,hamburg,hangout,haus,hbo,hdfc,hdfcbank,health,healthcare,help,helsinki,here,hermes,hgtv,hiphop,hisamitsu,hitachi,hiv,hkt,hockey,holdings,holiday,homedepot,homegoods,homes,homesense,honda,horse,hospital,host,hosting,hot,hoteles,hotels,hotmail,house,how,hsbc,hughes,hyatt,hyundai,ibm,icbc,ice,icu,ieee,ifm,ikano,imamat,imdb,immo,immobilien,inc,industries,infiniti,ing,ink,institute,insurance,insure,international,intuit,investments,ipiranga,irish,ismaili,ist,istanbul,itau,itv,jaguar,java,jcb,jeep,jetzt,jewelry,jio,jll,jmp,jnj,joburg,jot,joy,jpmorgan,jprs,juegos,juniper,kaufen,kddi,kerryhotels,kerrylogistics,kerryproperties,kfh,kia,kids,kim,kinder,kindle,kitchen,kiwi,koeln,komatsu,kosher,kpmg,kpn,krd,kred,kuokgroup,kyoto,lacaixa,lamborghini,lamer,lancaster,lancia,land,landrover,lanxess,lasalle,lat,latino,latrobe,law,lawyer,lds,lease,leclerc,lefrak,legal,lego,lexus,lgbt,lidl,life,lifeinsurance,lifestyle,lighting,like,lilly,limited,limo,lincoln,linde,link,lipsy,live,living,llc,llp,loan,loans,locker,locus,loft,lol,london,lotte,lotto,love,lpl,lplfinancial,ltd,ltda,lundbeck,luxe,luxury,macys,madrid,maif,maison,makeup,man,management,mango,map,market,marketing,markets,marriott,marshalls,maserati,mattel,mba,mckinsey,med,media,meet,melbourne,meme,memorial,men,menu,merckmsd,miami,microsoft,mini,mint,mit,mitsubishi,mlb,mls,mma,mobile,moda,moe,moi,mom,monash,money,monster,mormon,mortgage,moscow,moto,motorcycles,mov,movie,msd,mtn,mtr,music,mutual,nab,nagoya,natura,navy,nba,nec,netbank,netflix,network,neustar,new,news,next,nextdirect,nexus,nfl,ngo,nhk,nico,nike,nikon,ninja,nissan,nissay,nokia,northwesternmutual,norton,now,nowruz,nowtv,nra,nrw,ntt,nyc,obi,observer,office,okinawa,olayan,olayangroup,oldnavy,ollo,omega,one,ong,onl,online,ooo,open,oracle,orange,organic,origins,osaka,otsuka,ott,ovh,page,panasonic,paris,pars,partners,parts,party,passagens,pay,pccw,pet,pfizer,pharmacy,phd,philips,phone,photo,photography,photos,physio,pics,pictet,pictures,pid,pin,ping,pink,pioneer,pizza,place,play,playstation,plumbing,plus,pnc,pohl,poker,politie,porn,pramerica,praxi,press,prime,prod,productions,prof,progressive,promo,properties,property,protection,pru,prudential,pub,pwc,qpon,quebec,quest,racing,radio,read,realestate,realtor,realty,recipes,red,redstone,redumbrella,rehab,reise,reisen,reit,reliance,ren,rent,rentals,repair,report,republican,rest,restaurant,review,reviews,rexroth,rich,richardli,ricoh,ril,rio,rip,rocher,rocks,rodeo,rogers,room,rsvp,rugby,ruhr,run,rwe,ryukyu,saarland,safe,safety,sakura,sale,salon,samsclub,samsung,sandvik,sandvikcoromant,sanofi,sap,sarl,sas,save,saxo,sbi,sbs,sca,scb,schaeffler,schmidt,scholarships,school,schule,schwarz,science,scot,search,seat,secure,security,seek,select,sener,services,ses,seven,sew,sex,sexy,sfr,shangrila,sharp,shaw,shell,shia,shiksha,shoes,shop,shopping,shouji,show,showtime,silk,sina,singles,site,ski,skin,sky,skype,sling,smart,smile,sncf,soccer,social,softbank,software,sohu,solar,solutions,song,sony,soy,spa,space,sport,spot,srl,stada,staples,star,statebank,statefarm,stc,stcgroup,stockholm,storage,store,stream,studio,study,style,sucks,supplies,supply,support,surf,surgery,suzuki,swatch,swiss,sydney,systems,tab,taipei,talk,taobao,target,tatamotors,tatar,tattoo,tax,taxi,tci,tdk,team,tech,technology,temasek,tennis,teva,thd,theater,theatre,tiaa,tickets,tienda,tiffany,tips,tires,tirol,tjmaxx,tjx,tkmaxx,tmall,today,tokyo,tools,top,toray,toshiba,total,tours,town,toyota,toys,trade,trading,training,travel,travelchannel,travelers,travelersinsurance,trust,trv,tube,tui,tunes,tushu,tvs,ubank,ubs,unicom,university,uno,uol,ups,vacations,vana,vanguard,vegas,ventures,verisign,versicherung,vet,viajes,video,vig,viking,villas,vin,vip,virgin,visa,vision,viva,vivo,vlaanderen,vodka,volkswagen,volvo,vote,voting,voto,voyage,vuelos,wales,walmart,walter,wang,wanggou,watch,watches,weather,weatherchannel,webcam,weber,website,wedding,weibo,weir,whoswho,wien,wiki,williamhill,win,windows,wine,winners,wme,wolterskluwer,woodside,work,works,world,wow,wtc,wtf,xbox,xerox,xfinity,xihuan,xin,xn--11b4c3d,xn--1ck2e1b,xn--1qqw23a,xn--30rr7y,xn--3bst00m,xn--3ds443g,xn--3pxu8k,xn--42c2d9a,xn--45q11c,xn--4gbrim,xn--55qw42g,xn--55qx5d,xn--5su34j936bgsg,xn--5tzm5g,xn--6frz82g,xn--6qq986b3xl,xn--80adxhks,xn--80aqecdr1a,xn--80asehdb,xn--80aswg,xn--8y0a063a,xn--9dbq2a,xn--9et52u,xn--9krt00a,xn--b4w605ferd,xn--bck1b9a5dre4c,xn--c1avg,xn--c2br7g,xn--cck2b3b,xn--cckwcxetd,xn--cg4bki,xn--czr694b,xn--czrs0t,xn--czru2d,xn--d1acj3b,xn--eckvdtc9d,xn--efvy88h,xn--fct429k,xn--fhbei,xn--fiq228c5hs,xn--fiq64b,xn--fjq720a,xn--flw351e,xn--fzys8d69uvgm,xn--g2xx48c,xn--gckr3f0f,xn--gk3at1e,xn--hxt814e,xn--i1b6b1a6a2e,xn--imr513n,xn--io0a7i,xn--j1aef,xn--jlq480n2rg,xn--jlq61u9w7b,xn--jvr189m,xn--kcrx77d1x4a,xn--kput3i,xn--mgba3a3ejt,xn--mgba7c0bbn0a,xn--mgbaakc7dvf,xn--mgbab2bd,xn--mgbca7dzdo,xn--mgbi4ecexp,xn--mgbt3dhd,xn--mk1bu44c,xn--mxtq1m,xn--ngbc5azd,xn--ngbe9e0a,xn--ngbrx,xn--nqv7f,xn--nqv7fs00ema,xn--nyqy26a,xn--otu796d,xn--p1acf,xn--pssy2u,xn--q9jyb4c,xn--qcka1pmc,xn--rhqv96g,xn--rovu88b,xn--ses554g,xn--t60b56a,xn--tckwe,xn--tiq49xqyj,xn--unup4y,xn--vermgensberater-ctb,xn--vermgensberatung-pwb,xn--vhquv,xn--vuq861b,xn--w4r85el8fhu5dnra,xn--w4rs40l,xn--xhq521b,xn--zfr164b,xyz,yachts,yahoo,yamaxun,yandex,yodobashi,yoga,yokohama,you,youtube,yun,zappos,zara,zero,zip,zone,zuerich"');

var $4c1e41cfee030721$exports = {};
$4c1e41cfee030721$exports = JSON.parse('"ua>cc,inf,ltd,cx,biz,co,pp,v<to>611,oya,rdv,vpnplus,quickconnect>direct<nyan<us>graphox,cloudns,drud,is-by,land-4-sale,stuff-4-sale,enscaled>phx<mircloud,freeddns,golffan,noip,pointto,platterp,de>lib<<com>devcdnaccesso>*<adobeaemcloud>dev>*<<kasserver,amazonaws>compute>*<compute-1>*<us-east-1>dualstack>s3<<elb>*<s3,s3-ap-northeast-1,s3-ap-northeast-2,s3-ap-south-1,s3-ap-southeast-1,s3-ap-southeast-2,s3-ca-central-1,s3-eu-central-1,s3-eu-west-1,s3-eu-west-2,s3-eu-west-3,s3-external-1,s3-fips-us-gov-west-1,s3-sa-east-1,s3-us-gov-west-1,s3-us-east-2,s3-us-west-1,s3-us-west-2,ap-northeast-2>s3,dualstack>s3<s3-website<ap-south-1>s3,dualstack>s3<s3-website<ca-central-1>s3,dualstack>s3<s3-website<eu-central-1>s3,dualstack>s3<s3-website<eu-west-2>s3,dualstack>s3<s3-website<eu-west-3>s3,dualstack>s3<s3-website<us-east-2>s3,dualstack>s3<s3-website<ap-northeast-1>dualstack>s3<<ap-southeast-1>dualstack>s3<<ap-southeast-2>dualstack>s3<<eu-west-1>dualstack>s3<<sa-east-1>dualstack>s3<<s3-website-us-east-1,s3-website-us-west-1,s3-website-us-west-2,s3-website-ap-northeast-1,s3-website-ap-southeast-1,s3-website-ap-southeast-2,s3-website-eu-west-1,s3-website-sa-east-1<elasticbeanstalk>ap-northeast-1,ap-northeast-2,ap-northeast-3,ap-south-1,ap-southeast-1,ap-southeast-2,ca-central-1,eu-central-1,eu-west-1,eu-west-2,eu-west-3,sa-east-1,us-east-1,us-east-2,us-gov-west-1,us-west-1,us-west-2<awsglobalaccelerator,siiites,appspacehosted,appspaceusercontent,on-aptible,myasustor,balena-devices,betainabox,boutir,bplaced,cafjs,br,cn,de,eu,jpn,mex,ru,sa,uk,us,za,ar,hu,kr,no,qc,uy,africa,gr,co,jdevcloud,wpdevcloud,cloudcontrolled,cloudcontrolapp,trycloudflare,customer-oci>*,oci>*<ocp>*<ocs>*<<dattolocal,dattorelay,dattoweb,mydatto,builtwithdark,datadetect>demo,instance<ddns5,drayddns,dreamhosters,mydrobo,dyndns-at-home,dyndns-at-work,dyndns-blog,dyndns-free,dyndns-home,dyndns-ip,dyndns-mail,dyndns-office,dyndns-pics,dyndns-remote,dyndns-server,dyndns-web,dyndns-wiki,dyndns-work,blogdns,cechire,dnsalias,dnsdojo,doesntexist,dontexist,doomdns,dyn-o-saur,dynalias,est-a-la-maison,est-a-la-masion,est-le-patron,est-mon-blogueur,from-ak,from-al,from-ar,from-ca,from-ct,from-dc,from-de,from-fl,from-ga,from-hi,from-ia,from-id,from-il,from-in,from-ks,from-ky,from-ma,from-md,from-mi,from-mn,from-mo,from-ms,from-mt,from-nc,from-nd,from-ne,from-nh,from-nj,from-nm,from-nv,from-oh,from-ok,from-or,from-pa,from-pr,from-ri,from-sc,from-sd,from-tn,from-tx,from-ut,from-va,from-vt,from-wa,from-wi,from-wv,from-wy,getmyip,gotdns,hobby-site,homelinux,homeunix,iamallama,is-a-anarchist,is-a-blogger,is-a-bookkeeper,is-a-bulls-fan,is-a-caterer,is-a-chef,is-a-conservative,is-a-cpa,is-a-cubicle-slave,is-a-democrat,is-a-designer,is-a-doctor,is-a-financialadvisor,is-a-geek,is-a-green,is-a-guru,is-a-hard-worker,is-a-hunter,is-a-landscaper,is-a-lawyer,is-a-liberal,is-a-libertarian,is-a-llama,is-a-musician,is-a-nascarfan,is-a-nurse,is-a-painter,is-a-personaltrainer,is-a-photographer,is-a-player,is-a-republican,is-a-rockstar,is-a-socialist,is-a-student,is-a-teacher,is-a-techie,is-a-therapist,is-an-accountant,is-an-actor,is-an-actress,is-an-anarchist,is-an-artist,is-an-engineer,is-an-entertainer,is-certified,is-gone,is-into-anime,is-into-cars,is-into-cartoons,is-into-games,is-leet,is-not-certified,is-slick,is-uberleet,is-with-theband,isa-geek,isa-hockeynut,issmarterthanyou,likes-pie,likescandy,neat-url,saves-the-whales,selfip,sells-for-less,sells-for-u,servebbs,simple-url,space-to-rent,teaches-yoga,writesthisblog,digitaloceanspaces>*<ddnsfree,ddnsgeek,giize,gleeze,kozow,loseyourip,ooguy,theworkpc,mytuleap,tuleap-partners,evennode>eu-1,eu-2,eu-3,eu-4,us-1,us-2,us-3,us-4<onfabrica,fbsbx>apps<fastly-terrarium,fastvps-server,mydobiss,firebaseapp,fldrv,forgeblocks,framercanvas,freebox-os,freeboxos,freemyip,gentapps,gentlentapis,githubusercontent,0emm>*<appspot>r>*<<codespot,googleapis,googlecode,pagespeedmobilizer,publishproxy,withgoogle,withyoutube,blogspot,awsmppl,herokuapp,herokussl,myravendb,impertrixcdn,impertrix,smushcdn,wphostedmail,wpmucdn,pixolino,amscompute,clicketcloud,dopaas,hidora,hosted-by-previder>paas<hosteur>rag-cloud,rag-cloud-ch<ik-server>jcloud,jcloud-ver-jpc<jelastic>demo<kilatiron,massivegrid>paas<wafaicloud>jed,lon,ryd<joyent>cns>*<<lpusercontent,lmpm>app<linode>members,nodebalancer>*<<linodeobjects>*<linodeusercontent>ip<barsycenter,barsyonline,mazeplay,miniserver,meteorapp>eu<hostedpi,mythic-beasts>customer,caracal,fentiger,lynx,ocelot,oncilla,onza,sphinx,vs,x,yali<nospamproxy>cloud<4u,nfshost,001www,ddnslive,myiphost,blogsyte,ciscofreak,damnserver,ditchyourip,dnsiskinky,dynns,geekgalaxy,health-carereform,homesecuritymac,homesecuritypc,myactivedirectory,mysecuritycamera,net-freaks,onthewifi,point2this,quicksytes,securitytactics,serveexchange,servehumour,servep2p,servesarcasm,stufftoread,unusualperson,workisboring,3utilities,ddnsking,myvnc,servebeer,servecounterstrike,serveftp,servegame,servehalflife,servehttp,serveirc,servemp3,servepics,servequake,observableusercontent>static<orsites,operaunite,authgear-staging,authgearapps,skygearapp,outsystemscloud,ownprovider,pgfog,pagefrontapp,pagexl,paywhirl>*<gotpantheon,platter-app,pleskns,postman-echo,prgmr>xen<pythonanywhere>eu<qualifioapp,qbuser,qa2,dev-myqnapcloud,alpha-myqnapcloud,myqnapcloud,quipelements>*<rackmaze,rhcloud,render>app<onrender,logoip,scrysec,firewall-gateway,myshopblocks,myshopify,shopitsite,1kapp,appchizi,applinzi,sinaapp,vipsinaapp,bounty-full>alpha,beta<try-snowplow,stackhero-network,playstation-cloud,myspreadshop,stdlib>api<temp-dns,dsmynas,familyds,tb-hosting>site<reservd,thingdustdata,bloxcms,townnews-staging,typeform>pro<hk,wafflecell,idnblogger,indowapblog,reserve-online,hotelwithflight,remotewd,wiardweb>pages<woltlab-demo,wpenginepowered>js<wixsite,xnbay>u2,u2-local<yolasite<live>hlx<net>adobeaemcloud,alwaysdata,cloudfront,t3l3p0rt,appudo,atlassian-dev>prod>cdn<<myfritz,onavstack,shopselect,blackbaudcdn,boomla,bplaced,square7,gb,hu,jp,se,uk,in,clickrising,cloudaccess,cdn77-ssl,cdn77>r<feste-ip,knx-server,static-access,cryptonomic>*<dattolocal,mydatto,debian,bitbridge,at-band-camp,blogdns,broke-it,buyshouses,dnsalias,dnsdojo,does-it,dontexist,dynalias,dynathome,endofinternet,from-az,from-co,from-la,from-ny,gets-it,ham-radio-op,homeftp,homeip,homelinux,homeunix,in-the-band,is-a-chef,is-a-geek,isa-geek,kicks-ass,office-on-the,podzone,scrapper-site,selfip,sells-it,servebbs,serveftp,thruhere,webhop,definima,casacam,dynu,dynv6,twmail,ru,channelsdvr>u<fastlylb>map<fastly>freetls,map,prod>a,global<ssl>a,b,global<<edgeapp,flynnhosting,cdn-edges,cloudfunctions,moonscale,in-dsl,in-vpn,ipifony,iobb,cloudjiffy>fra1-de,west1-us<elastx>jls-sto1,jls-sto2,jls-sto3<faststacks,massivegrid>paas>fr-1,lon-1,lon-2,ny-1,ny-2,sg-1<<saveincloud>jelastic,nordeste-idc<scaleforce>j<tsukaeru>jelastic<kinghost,uni5,krellian,barsy,memset,azurewebsites,azure-mobile,cloudapp,azurestaticapps>centralus,eastasia,eastus2,westeurope,westus2<dnsup,hicam,now-dns,ownip,vpndns,eating-organic,mydissent,myeffect,mymediapc,mypsx,mysecuritycamera,nhlfan,no-ip,pgafan,privatizehealthinsurance,bounceme,ddns,redirectme,serveblog,serveminecraft,sytes,cloudycluster,ovh>webpaas>*<hosting>*<<bar0,bar1,bar2,rackmaze,schokokeks,firewall-gateway,seidat,senseering,siteleaf,vps-host>jelastic>atl,njs,ric<<myspreadshop,srcf>soc,user<supabase,dsmynas,familyds,tailscale>beta<ts,torproject>pages<fastblog,reserve-online,community-pro,meinforum,yandexcloud>storage,website<za<page>hlx,hlx3,codeberg,pdns,plesk,prvcy,magnet<pl>beep,ecommerce-shop,shoparena,homesklep,sdscloud,unicloud,krasnik,leczna,lubartow,lublin,poniatowa,swidnik,co,art,gliwice,krakow,poznan,wroc,zakopane,myspreadshop,gda,gdansk,gdynia,med,sopot<ca>barsy,awdev>*<co,blogspot,no-ip,myspreadshop<estate>compute>*<<network>alces>*<co,arvo,azimuth,tlon<org>altervista,amune>tele<pimienta,poivron,potager,sweetpepper,ae,us,certmgr,cdn77>c,rsc<cdn77-secure>origin>ssl<<cloudns,duckdns,tunk,dyndns>go,home<blogdns,blogsite,boldlygoingnowhere,dnsalias,dnsdojo,doesntexist,dontexist,doomdns,dvrdns,dynalias,endofinternet,endoftheinternet,from-me,game-host,gotdns,hobby-site,homedns,homeftp,homelinux,homeunix,is-a-bruinsfan,is-a-candidate,is-a-celticsfan,is-a-chef,is-a-geek,is-a-knight,is-a-linux-user,is-a-patsfan,is-a-soxfan,is-found,is-lost,is-saved,is-very-bad,is-very-evil,is-very-good,is-very-nice,is-very-sweet,isa-geek,kicks-ass,misconfused,podzone,readmyblog,selfip,sellsyourhome,servebbs,serveftp,servegame,stuff-4-sale,webhop,ddnss,accesscam,camdvr,freeddns,mywire,webredirect,eu>al,asso,at,au,be,bg,ca,cd,ch,cn,cy,cz,de,dk,edu,ee,es,fi,fr,gr,hr,hu,ie,il,in,int,is,it,jp,kr,lt,lu,lv,mc,me,mk,mt,my,net,ng,nl,no,nz,paris,pl,pt,q-a,ro,ru,se,si,sk,tr,uk,us<twmail,fedorainfracloud,fedorapeople,fedoraproject>cloud,os>app<stg>os>app<<<freedesktop,hepforge,in-dsl,in-vpn,js,barsy,mayfirst,mozilla-iot,bmoattachments,dynserv,now-dns,cable-modem,collegefan,couchpotatofries,mlbfan,mysecuritycamera,nflfan,read-books,ufcfan,hopto,myftp,no-ip,zapto,httpbin,pubtls,my-firewall,myfirewall,spdns,small-web,dsmynas,familyds,teckids>s3<tuxfamily,diskstation,hk,wmflabs,toolforge,wmcloud,za<cn>com>amazonaws>compute>*<eb>cn-north-1,cn-northwest-1<elb>*<cn-north-1>s3<<<instantcloud<io>apigee,b-data,backplaneapp,banzaicloud>app,backyards>*<<bitbucket,bluebite,boxfuse,browsersafetymark,bigv>uk0<cleverapps,dappnode>dyndns<dedyn,drud,definima,fh-muenster,shw,forgerock>id<ghost,github,gitlab,lolipop,hasura-app,hostyhosting,moonscale>*<beebyte>paas<beebyteapp>sekd1<jele,unispace>cloud-fr1<webthings,loginline,barsy,azurecontainer>*<ngrok,nodeart>stage<nid,pantheonsite,dyn53,pstmn>mock<protonet,qoto,qcx>sys>*<<vaporcloud,vbrplsbx>g<on-k3s>*<on-rio>*<readthedocs,resindevice,resinstaging>devices<hzc,sandcats,shiftcrypto,shiftedit,mo-siemens,lair>apps<stolos>*<spacekit,utwente,s5y>*<edugit,telebit,thingdust>dev>cust,reservd<disrec>cust,reservd<prod>cust<testing>cust,reservd<<tickets,upli,2038,wedeploy,editorx,basicserver,virtualserver<jp>ne>aseinet>user<gehirn<buyshop,fashionstore,handcrafted,kawaiishop,supersale,theshop,usercontent,blogspot<vc>gv>d<0e<eus>party>user<<ws>advisor>*<cloud66,dyndns,mypets<ba>rs,blogspot<cloud>banzai>*<elementor,encoway>eu<statics>*<ravendb,axarnet>es-1<diadem,jelastic>vip<jele,jenv-aruba>aruba>eur>it1<<it1<keliweb>cs<oxa>tn,uk<primetel>uk<reclaim>ca,uk,us<trendhosting>ch,de<jotelulu,kuleuven,linkyard,magentosite>*<perspecta,vapor,on-rancher>*<sensiosite>*<trafficplex,urown,voorloper<ec>base,official<shop>base,hoplix,barsy<la>bnr,c<je>of<ch>square7,blogspot,flow>ae>alp1<appengine<linkyard-cloud,dnsking,gotdns,myspreadshop,firenet>*,svc>*<<12hp,2ix,4lima,lima-city<de>bplaced,square7,com,cosidns>dyn<dynamisches-dns,dnsupdater,internet-dns,l-o-g-i-n,dnshome,fuettertdasnetz,isteingeek,istmein,lebtimnetz,leitungsen,traeumtgerade,ddnss>dyn,dyndns<dyndns1,dyn-ip24,home-webserver>dyn<myhome-server,frusky>*<goip,blogspot,xn--gnstigbestellen-zvb,xn--gnstigliefern-wob,hs-heilbronn>it>pages<<dyn-berlin,in-berlin,in-brb,in-butter,in-dsl,in-vpn,mein-iserv,schulserver,test-iserv,keymachine,git-repos,lcube-server,svn-repos,barsy,logoip,firewall-gateway,my-gateway,my-router,spdns,speedpartner>customer<myspreadshop,taifun-dns,12hp,2ix,4lima,lima-city,dd-dns,dray-dns,draydns,dyn-vpn,dynvpn,mein-vigor,my-vigor,my-wan,syno-ds,synology-diskstation,synology-ds,uberspace>*<virtualuser,virtual-user,community-pro,diskussionsbereich<rs>brendly>shop<blogspot,ua,ox<uk>co>bytemark>dh,vm<blogspot,layershift>j<barsy,barsyonline,retrosnub>cust<nh-serv,no-ip,wellbeingzone,adimo,myspreadshop,gwiddle<conn,copro,hosp,gov>service,homeoffice<pymnt,org>glug,lug,lugs,affinitylottery,raffleentry,weeklylottery<barsy<eu>mycd,cloudns,dogado>jelastic<barsy,wellbeingzone,spdns,transurl>*<diskstation<ac>drr<ai>uwu<co>carrd,crd,otap>*<com>blogspot<leadpages,lpages,mypi,n4t,repl>id<supabase<mp>ju<se>com,blogspot,conf,iopsys,itcouldbewor,myspreadshop,paba>su<<bz>za,gsj<in>web,cloudns,blogspot,barsy,supabase<basketball>aus,nz<am>radio,blogspot,neko,nyaa<fm>radio<group>discourse<team>discourse,jelastic<app>clerk,clerkstage,wnext,platform0,ondigitalocean,edgecompute,fireweb,onflashdrive,framer,run>a<web,hasura,loginline,netlify,developer>*<noop,northflank>*<telebit,vercel,bookonline<dev>lcl>*<lclstage>*<stg>*<stgstage>*<pages,workers,curv,deno,deno-staging,fly,githubpreview,gateway>*<iserv,loginline,mediatech,platter-app,shiftcrypto,vercel,webhare>*<<me>c66,daplie>localhost<edgestack,couk,ukco,filegear,filegear-au,filegear-de,filegear-gb,filegear-ie,filegear-jp,filegear-sg,glitch,ravendb,lohmus,barsy,mcpe,mcdir,soundcast,tcp4,brasilia,ddns,dnsfor,hopto,loginto,noip,webhop,vp4,diskstation,dscloud,i234,myds,synology,tbits,wbq,wedeploy,yombo,nohost<zone>cloud66,hs,triton>*<lima<host>cloudaccess,freesite,fastvps,myfast,tempurl,wpmudev,jele,mircloud,pcloud,half<site>cloudera>*<cyon,fnwk,folionetwork,fastvps,jele,lelux,loginline,barsy,mintere,omniwe,opensocial,platformsh>*<tst>*<byen,srht,novecore<cz>co,realm,e4,blogspot,metacentrum>cloud>*<custom<muni>cloud>flt,usr<<<asia>cloudns<biz>cloudns,jozi,dyndns,for-better,for-more,for-some,for-the,selfip,webhop,orx,mmafan,myftp,no-ip,dscloud<club>cloudns,jele,barsy,pony<cc>cloudns,ftpaccess,game-server,myphotos,scrapping,twmail,csx,fantasyleague,spawn>instances<<info>cloudns,dynamic-dns,dyndns,barrel-of-knowledge,barrell-of-knowledge,for-our,groks-the,groks-this,here-for-more,knowsitall,selfip,webhop,barsy,mayfirst,forumz,nsupdate,dvrcam,ilovecollege,no-ip,dnsupdate,v-info<pro>cloudns,dnstrace>bci<barsy<pw>cloudns,x443<gdn>cnpy<nl>co,hosting-cluster,blogspot,khplay,myspreadshop,transurl>*<cistron,demon<no>co,blogspot,myspreadshop<be>webhosting,blogspot,interhostsolutions>cloud<kuleuven>ezproxy<myspreadshop,transurl>*<<ru>ac,edu,gov,int,mil,test,eurodir,adygeya,bashkiria,bir,cbg,com,dagestan,grozny,kalmykia,kustanai,marine,mordovia,msk,mytis,nalchik,nov,pyatigorsk,spb,vladikavkaz,vladimir,blogspot,na4u,mircloud,regruhosting>jelastic<myjino>hosting>*<landing>*<spectrum>*<vps>*<<cldmail>hb<mcdir>vps<mcpre,net,org,pp,lk3,ras<is>cupcake,blogspot<link>cyon,mypep,dweb>*<<dk>biz,co,firm,reg,store,blogspot,myspreadshop<earth>dapps>*,bzz>*<<<id>my>rss>*<<flap,co>blogspot<forte,bloger,wblog<solutions>diher>*<<th>online,shop<sh>bip,hashbang,platform>bc,ent,eu,us<now,vxl,wedeploy<fi>dy,blogspot,xn--hkkinen-5wa,iki,cloudplatform>fi<datacenter>demo,paas<myspreadshop<tv>dyndns,better-than,on-the-web,worse-than<cx>ath,info<name>her>forgot<his>forgot<<nu>merseine,mine,shacknet,enterprisecloud<rocks>myddns,lima-city,webspace<xyz>blogsite,localzone,crafting,zapto,telebit>*<<online>eero,eero-stage,barsy<cool>elementor,de<fr>en-root,fbx-os,fbxos,freebox-os,freeboxos,blogspot,goupile,on-web,chirurgiens-dentistes-en-france,myspreadshop,ynh<one>onred>staging<for,under,service,homelink<tw>com>mymailer<url,blogspot<su>abkhazia,adygeya,aktyubinsk,arkhangelsk,armenia,ashgabad,azerbaijan,balashov,bashkiria,bryansk,bukhara,chimkent,dagestan,east-kazakhstan,exnet,georgia,grozny,ivanovo,jambyl,kalmykia,kaluga,karacol,karaganda,karelia,khakassia,krasnodar,kurgan,kustanai,lenug,mangyshlak,mordovia,msk,murmansk,nalchik,navoi,north-kazakhstan,nov,obninsk,penza,pokrovsk,sochi,spb,tashkent,termez,togliatti,troitsk,tselinograd,tula,tuva,vladikavkaz,vladimir,vologda<space>myfast,uber,xs4all<il>co>ravpage,blogspot,tabitorder<<at>funkfeuer>wien<futurecms>*,ex>*<in>*<<futurehosting,futuremailing,ortsinfo>ex>*<kunden>*<<co>blogspot<biz,info,priv,myspreadshop,12hp,2ix,4lima,lima-city<ms>lab,minisite<si>gitapp,gitpage,blogspot<community>nog,ravendb,myforum<ro>co,shop,blogspot,barsy<digital>cloudapps>london<<im>ro<goog>cloud,translate,usercontent>*<<ae>blogspot<al>blogspot<bg>blogspot,barsy<bj>blogspot<cf>blogspot<cl>blogspot<ke>co>blogspot<<nz>co>blogspot<<za>co>blogspot<<ar>com>blogspot<<au>com>blogspot,cloudlets>mel<myspreadshop<<br>com>blogspot,virtualcloud>scale>users<<<leg>ac,al,am,ap,ba,ce,df,es,go,ma,mg,ms,mt,pa,pb,pe,pi,pr,rj,rn,ro,rr,rs,sc,se,sp,to<<by>com>blogspot<mycloud,mediatech<cy>com>blogspot,scaleforce>j<<<ee>com>blogspot<<eg>com>blogspot<<es>com>blogspot<myspreadshop<mt>com>blogspot<<ng>com>blogspot<col,firm,gen,ltd,ngo<tr>com>blogspot<<uy>com>blogspot<<cv>blogspot<gr>blogspot<hk>blogspot,secaas,ltd,inc<hr>blogspot,free<hu>blogspot<ie>blogspot,myspreadshop<it>blogspot,neen>jc<tim>open>jelastic>cloud<<<16-b,32-b,64-b,myspreadshop,syncloud<kr>blogspot<li>blogspot,caa<lt>blogspot<lu>blogspot<md>blogspot,at,de,jp,to<mk>blogspot<mr>blogspot<mx>blogspot<my>blogspot<pe>blogspot<pt>blogspot<qa>blogspot<re>blogspot<sg>blogspot,enscaled<sk>blogspot<sn>blogspot<td>blogspot<ug>blogspot<vn>blogspot<ci>fin,nl<run>hs,development,ravendb,servers,code>*<repl<gl>biz,xx<scot>edu,gov>service<<so>sch<yt>org<kz>jcloud,kazteleport>upaas<<tn>orangecloud<gg>kaas,cya,panel>daemon<<systems>knightpoint<events>koobin,co<krd>co,edu<business>co<education>co<financial>co<place>co<technology>co<bs>we<services>loginline<menu>barsy<mobi>barsy,dscloud<pub>barsy<support>barsy<vu>cn,blog,dev,me<health>hra<casa>nabu>ui<<fashion>of<london>in,of<marketing>from,with<men>for,repair<mom>and,for<sale>for<win>that<work>from,to<news>noticeable<top>now-dns,ntdll<ovh>nerdpol<mn>nyc<lol>omg<hosting>opencraft<pm>own<codes>owo>*<<lc>oy<bn>co<today>prequalifyme<builders>cloudsite<edu>rit>git-pages<<xn--p1acf>xn--90amc,xn--j1aef,xn--j1ael8b,xn--h1ahn,xn--j1adp,xn--c1avg,xn--80aaa0cvac,xn--h1aliz,xn--90a1af,xn--41a<store>sellfy,shopware,storebase<land>static>dev,sites<<farm>storj<pictures>1337<rip>clan<management>router<ax>be,cat,es,eu,gg,mc,us,xy<gp>app<gt>blog,de,to<gy>be<hn>cc<kg>blog,io,jp,tv,uk,us<ls>de<porn>indie<tc>ch,me,we<vg>at<academy>official<faith>ybo<party>ybo<review>ybo<science>ybo<trade>ybo<st>noho<design>bss"');


// UP, SAME, DOWN, RESET should not be special regex characters in a character class.
const $cd99543034913be8$export$b29f845fa4b57508 = "<"; // one level up
const $cd99543034913be8$export$7359a57b3ac1f378 = ","; // same level
const $cd99543034913be8$export$c7c029a231f98d34 = ">"; // one level down
const $cd99543034913be8$export$4a991c87e640ef77 = "|"; // reset level index and start new
const $cd99543034913be8$export$7c5337e72dc7d60e = "*"; // as defined by publicsuffix.org
const $cd99543034913be8$export$e7e66e0bc92d8ea1 = "!"; // as defined by publicsuffix.org


const $8e493016ce105ef2$export$4ecf1803c40ca846 = (labels, trie)=>{
    const labelsToCheck = labels.slice();
    const tlds = [];
    let node = trie;
    while(labelsToCheck.length !== 0){
        const label = labelsToCheck.pop();
        const labelLowerCase = label.toLowerCase();
        if (node.children.has($cd99543034913be8$export$7c5337e72dc7d60e)) {
            if (node.children.has($cd99543034913be8$export$e7e66e0bc92d8ea1 + labelLowerCase)) break;
            node = node.children.get($cd99543034913be8$export$7c5337e72dc7d60e);
        } else {
            if (node.children.has(labelLowerCase) === false) break;
            node = node.children.get(labelLowerCase);
        }
        tlds.unshift(label);
    }
    return tlds;
};


var $67881467b3a9d0e8$exports = {};
"use strict";
var $c3f3a9c026f22276$exports = {};
"use strict";
const $c3f3a9c026f22276$var$word = "[a-fA-F\\d:]";
const $c3f3a9c026f22276$var$b = (options)=>options && options.includeBoundaries ? `(?:(?<=\\s|^)(?=${$c3f3a9c026f22276$var$word})|(?<=${$c3f3a9c026f22276$var$word})(?=\\s|$))` : "";
const $c3f3a9c026f22276$var$v4 = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}";
const $c3f3a9c026f22276$var$v6seg = "[a-fA-F\\d]{1,4}";
const $c3f3a9c026f22276$var$v6 = `
(?:
(?:${$c3f3a9c026f22276$var$v6seg}:){7}(?:${$c3f3a9c026f22276$var$v6seg}|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8
(?:${$c3f3a9c026f22276$var$v6seg}:){6}(?:${$c3f3a9c026f22276$var$v4}|:${$c3f3a9c026f22276$var$v6seg}|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4
(?:${$c3f3a9c026f22276$var$v6seg}:){5}(?::${$c3f3a9c026f22276$var$v4}|(?::${$c3f3a9c026f22276$var$v6seg}){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4
(?:${$c3f3a9c026f22276$var$v6seg}:){4}(?:(?::${$c3f3a9c026f22276$var$v6seg}){0,1}:${$c3f3a9c026f22276$var$v4}|(?::${$c3f3a9c026f22276$var$v6seg}){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4
(?:${$c3f3a9c026f22276$var$v6seg}:){3}(?:(?::${$c3f3a9c026f22276$var$v6seg}){0,2}:${$c3f3a9c026f22276$var$v4}|(?::${$c3f3a9c026f22276$var$v6seg}){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4
(?:${$c3f3a9c026f22276$var$v6seg}:){2}(?:(?::${$c3f3a9c026f22276$var$v6seg}){0,3}:${$c3f3a9c026f22276$var$v4}|(?::${$c3f3a9c026f22276$var$v6seg}){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4
(?:${$c3f3a9c026f22276$var$v6seg}:){1}(?:(?::${$c3f3a9c026f22276$var$v6seg}){0,4}:${$c3f3a9c026f22276$var$v4}|(?::${$c3f3a9c026f22276$var$v6seg}){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4
(?::(?:(?::${$c3f3a9c026f22276$var$v6seg}){0,5}:${$c3f3a9c026f22276$var$v4}|(?::${$c3f3a9c026f22276$var$v6seg}){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4
)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1
`.replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim();
// Pre-compile only the exact regexes because adding a global flag make regexes stateful
const $c3f3a9c026f22276$var$v46Exact = new RegExp(`(?:^${$c3f3a9c026f22276$var$v4}$)|(?:^${$c3f3a9c026f22276$var$v6}$)`);
const $c3f3a9c026f22276$var$v4exact = new RegExp(`^${$c3f3a9c026f22276$var$v4}$`);
const $c3f3a9c026f22276$var$v6exact = new RegExp(`^${$c3f3a9c026f22276$var$v6}$`);
const $c3f3a9c026f22276$var$ip = (options)=>options && options.exact ? $c3f3a9c026f22276$var$v46Exact : new RegExp(`(?:${$c3f3a9c026f22276$var$b(options)}${$c3f3a9c026f22276$var$v4}${$c3f3a9c026f22276$var$b(options)})|(?:${$c3f3a9c026f22276$var$b(options)}${$c3f3a9c026f22276$var$v6}${$c3f3a9c026f22276$var$b(options)})`, "g");
$c3f3a9c026f22276$var$ip.v4 = (options)=>options && options.exact ? $c3f3a9c026f22276$var$v4exact : new RegExp(`${$c3f3a9c026f22276$var$b(options)}${$c3f3a9c026f22276$var$v4}${$c3f3a9c026f22276$var$b(options)}`, "g");
$c3f3a9c026f22276$var$ip.v6 = (options)=>options && options.exact ? $c3f3a9c026f22276$var$v6exact : new RegExp(`${$c3f3a9c026f22276$var$b(options)}${$c3f3a9c026f22276$var$v6}${$c3f3a9c026f22276$var$b(options)}`, "g");
$c3f3a9c026f22276$exports = $c3f3a9c026f22276$var$ip;


const $67881467b3a9d0e8$var$isIp = (string)=>$c3f3a9c026f22276$exports({
        exact: true
    }).test(string);
$67881467b3a9d0e8$var$isIp.v4 = (string)=>$c3f3a9c026f22276$exports.v4({
        exact: true
    }).test(string);
$67881467b3a9d0e8$var$isIp.v6 = (string)=>$c3f3a9c026f22276$exports.v6({
        exact: true
    }).test(string);
$67881467b3a9d0e8$var$isIp.version = (string)=>$67881467b3a9d0e8$var$isIp(string) ? $67881467b3a9d0e8$var$isIp.v4(string) ? 4 : 6 : undefined;
$67881467b3a9d0e8$exports = $67881467b3a9d0e8$var$isIp;


// See https://en.wikipedia.org/wiki/Domain_name
// See https://tools.ietf.org/html/rfc1034
const $98b7f7041de863f1$var$LABEL_SEPARATOR = ".";
const $98b7f7041de863f1$var$LABEL_LENGTH_MIN = 1;
const $98b7f7041de863f1$var$LABEL_LENGTH_MAX = 63;
/**
 * 255 octets - 2 octets if you remove the last dot
 * @see https://devblogs.microsoft.com/oldnewthing/20120412-00/?p=7873
 */ const $98b7f7041de863f1$var$DOMAIN_LENGTH_MAX = 253;
const $98b7f7041de863f1$var$textEncoder = new TextEncoder();
var $98b7f7041de863f1$export$794e892580855985;
(function(Validation) {
    /**
     * Allows any octets as labels
     * but still restricts the length of labels and the overall domain.
     *
     * @see https://www.rfc-editor.org/rfc/rfc2181#section-11
     **/ Validation["Lax"] = "LAX";
    /**
     * Only allows ASCII letters, digits and hyphens (aka LDH),
     * forbids hyphens at the beginning or end of a label
     * and requires top-level domain names not to be all-numeric.
     *
     * This is the default if no validation is configured.
     *
     * @see https://datatracker.ietf.org/doc/html/rfc3696#section-2
     */ Validation["Strict"] = "STRICT";
})($98b7f7041de863f1$export$794e892580855985 || ($98b7f7041de863f1$export$794e892580855985 = {}));
var $98b7f7041de863f1$export$d17349b889375991;
(function(ValidationErrorType) {
    ValidationErrorType["NoHostname"] = "NO_HOSTNAME";
    ValidationErrorType["DomainMaxLength"] = "DOMAIN_MAX_LENGTH";
    ValidationErrorType["LabelMinLength"] = "LABEL_MIN_LENGTH";
    ValidationErrorType["LabelMaxLength"] = "LABEL_MAX_LENGTH";
    ValidationErrorType["LabelInvalidCharacter"] = "LABEL_INVALID_CHARACTER";
    ValidationErrorType["LastLabelInvalid"] = "LAST_LABEL_INVALID";
})($98b7f7041de863f1$export$d17349b889375991 || ($98b7f7041de863f1$export$d17349b889375991 = {}));
var $98b7f7041de863f1$export$a84f8d7a6b866582;
(function(SanitizationResultType) {
    SanitizationResultType["ValidIp"] = "VALID_IP";
    SanitizationResultType["ValidDomain"] = "VALID_DOMAIN";
    SanitizationResultType["Error"] = "ERROR";
})($98b7f7041de863f1$export$a84f8d7a6b866582 || ($98b7f7041de863f1$export$a84f8d7a6b866582 = {}));
const $98b7f7041de863f1$var$createNoHostnameError = (input)=>{
    return {
        type: $98b7f7041de863f1$export$d17349b889375991.NoHostname,
        message: `The given input ${String(input)} does not look like a hostname.`,
        column: 1
    };
};
const $98b7f7041de863f1$var$createDomainMaxLengthError = (domain, length)=>{
    return {
        type: $98b7f7041de863f1$export$d17349b889375991.DomainMaxLength,
        message: `Domain "${domain}" is too long. Domain is ${length} octets long but should not be longer than ${$98b7f7041de863f1$var$DOMAIN_LENGTH_MAX}.`,
        column: length
    };
};
const $98b7f7041de863f1$var$createLabelMinLengthError = (label, column)=>{
    const length = label.length;
    return {
        type: $98b7f7041de863f1$export$d17349b889375991.LabelMinLength,
        message: `Label "${label}" is too short. Label is ${length} octets long but should be at least ${$98b7f7041de863f1$var$LABEL_LENGTH_MIN}.`,
        column: column
    };
};
const $98b7f7041de863f1$var$createLabelMaxLengthError = (label, column)=>{
    const length = label.length;
    return {
        type: $98b7f7041de863f1$export$d17349b889375991.LabelMaxLength,
        message: `Label "${label}" is too long. Label is ${length} octets long but should not be longer than ${$98b7f7041de863f1$var$LABEL_LENGTH_MAX}.`,
        column: column
    };
};
const $98b7f7041de863f1$var$createLabelInvalidCharacterError = (label, invalidCharacter, column)=>{
    return {
        type: $98b7f7041de863f1$export$d17349b889375991.LabelInvalidCharacter,
        message: `Label "${label}" contains invalid character "${invalidCharacter}" at column ${column}.`,
        column: column
    };
};
const $98b7f7041de863f1$var$createLastLabelInvalidError = (label, column)=>{
    return {
        type: $98b7f7041de863f1$export$d17349b889375991.LabelInvalidCharacter,
        message: `Last label "${label}" must not be all-numeric.`,
        column: column
    };
};
const $98b7f7041de863f1$export$83d2e9e3e4ee39ed = (input, options = {})=>{
    // Extra check for non-TypeScript users
    if (typeof input !== "string") return {
        type: $98b7f7041de863f1$export$a84f8d7a6b866582.Error,
        errors: [
            $98b7f7041de863f1$var$createNoHostnameError(input)
        ]
    };
    const inputTrimmed = input.trim();
    if (inputTrimmed === "") return {
        type: $98b7f7041de863f1$export$a84f8d7a6b866582.ValidDomain,
        domain: inputTrimmed,
        labels: []
    };
    // IPv6 addresses are surrounded by square brackets in URLs
    // See https://tools.ietf.org/html/rfc3986#section-3.2.2
    const inputTrimmedAsIp = inputTrimmed.replace(/^\[|]$/g, "");
    const ipVersion = (0, $67881467b3a9d0e8$exports.version)(inputTrimmedAsIp);
    if (ipVersion !== undefined) return {
        type: $98b7f7041de863f1$export$a84f8d7a6b866582.ValidIp,
        ip: inputTrimmedAsIp,
        ipVersion: ipVersion
    };
    const lastChar = inputTrimmed.charAt(inputTrimmed.length - 1);
    const canonicalInput = lastChar === $98b7f7041de863f1$var$LABEL_SEPARATOR ? inputTrimmed.slice(0, -1) : inputTrimmed;
    const octets = new TextEncoder().encode(canonicalInput);
    if (octets.length > $98b7f7041de863f1$var$DOMAIN_LENGTH_MAX) return {
        type: $98b7f7041de863f1$export$a84f8d7a6b866582.Error,
        errors: [
            $98b7f7041de863f1$var$createDomainMaxLengthError(inputTrimmed, octets.length)
        ]
    };
    const labels = canonicalInput.split($98b7f7041de863f1$var$LABEL_SEPARATOR);
    const { validation: validation = $98b7f7041de863f1$export$794e892580855985.Strict } = options;
    const labelValidationErrors = $98b7f7041de863f1$var$validateLabels[validation](labels);
    if (labelValidationErrors.length > 0) return {
        type: $98b7f7041de863f1$export$a84f8d7a6b866582.Error,
        errors: labelValidationErrors
    };
    return {
        type: $98b7f7041de863f1$export$a84f8d7a6b866582.ValidDomain,
        domain: inputTrimmed,
        labels: labels
    };
};
const $98b7f7041de863f1$var$validateLabels = {
    [$98b7f7041de863f1$export$794e892580855985.Lax]: (labels)=>{
        const labelValidationErrors = [];
        let column = 1;
        for (const label of labels){
            const octets = $98b7f7041de863f1$var$textEncoder.encode(label);
            if (octets.length < $98b7f7041de863f1$var$LABEL_LENGTH_MIN) labelValidationErrors.push($98b7f7041de863f1$var$createLabelMinLengthError(label, column));
            else if (octets.length > $98b7f7041de863f1$var$LABEL_LENGTH_MAX) labelValidationErrors.push($98b7f7041de863f1$var$createLabelMaxLengthError(label, column));
            column += label.length + $98b7f7041de863f1$var$LABEL_SEPARATOR.length;
        }
        return labelValidationErrors;
    },
    [$98b7f7041de863f1$export$794e892580855985.Strict]: (labels)=>{
        const labelValidationErrors = [];
        let column = 1;
        let lastLabel;
        for (const label of labels){
            // According to https://tools.ietf.org/html/rfc6761 labels should
            // only contain ASCII letters, digits and hyphens (LDH).
            const invalidCharacter = /[^\da-z-]/i.exec(label);
            if (invalidCharacter) labelValidationErrors.push($98b7f7041de863f1$var$createLabelInvalidCharacterError(label, invalidCharacter[0], invalidCharacter.index + 1));
            if (label.startsWith("-")) labelValidationErrors.push($98b7f7041de863f1$var$createLabelInvalidCharacterError(label, "-", column));
            else if (label.endsWith("-")) labelValidationErrors.push($98b7f7041de863f1$var$createLabelInvalidCharacterError(label, "-", column + label.length - 1));
            if (// We can use .length here to check for the octet size because
            // label can only contain ASCII LDH characters at this point.
            label.length < $98b7f7041de863f1$var$LABEL_LENGTH_MIN) labelValidationErrors.push($98b7f7041de863f1$var$createLabelMinLengthError(label, column));
            else if (label.length > $98b7f7041de863f1$var$LABEL_LENGTH_MAX) labelValidationErrors.push($98b7f7041de863f1$var$createLabelMaxLengthError(label, column));
            column += label.length + $98b7f7041de863f1$var$LABEL_SEPARATOR.length;
            lastLabel = label;
        }
        if (lastLabel !== undefined && /[a-z-]/iu.test(lastLabel) === false) labelValidationErrors.push($98b7f7041de863f1$var$createLastLabelInvalidError(lastLabel, column - lastLabel.length - $98b7f7041de863f1$var$LABEL_SEPARATOR.length));
        return labelValidationErrors;
    }
};



const $0254e73a635edba0$export$cc3f916331a7eba8 = Symbol("ROOT");
const $0254e73a635edba0$export$f68322cbeb02972f = Symbol("CHILD");
const $0254e73a635edba0$export$19862575e23c23f8 = ()=>{
    return {
        type: $0254e73a635edba0$export$cc3f916331a7eba8,
        children: new Map()
    };
};
const $0254e73a635edba0$export$40723f2fa00c027e = (parent, label)=>{
    let child = parent.children.get(label);
    if (child === undefined) {
        child = {
            type: $0254e73a635edba0$export$f68322cbeb02972f,
            label: label,
            children: new Map(),
            parent: parent
        };
        parent.children.set(label, child);
    }
    return child;
};


const $475490fb2d51796a$export$2a3eda41008947a3 = (serializedTrie)=>{
    const rootNode = (0, $0254e73a635edba0$export$19862575e23c23f8)();
    let domain = "";
    let parentNode = rootNode;
    // Type assertion necessary here due to a TypeScript unsoundness
    // https://github.com/microsoft/TypeScript/issues/9998#issuecomment-235963457
    let node = rootNode;
    const addDomain = ()=>{
        node = (0, $0254e73a635edba0$export$40723f2fa00c027e)(parentNode, domain);
        domain = "";
    };
    for(let i = 0; i < serializedTrie.length; i++){
        const char = serializedTrie.charAt(i);
        switch(char){
            case $cd99543034913be8$export$7359a57b3ac1f378:
                addDomain();
                continue;
            case $cd99543034913be8$export$c7c029a231f98d34:
                addDomain();
                parentNode = node;
                continue;
            case $cd99543034913be8$export$4a991c87e640ef77:
                addDomain();
                parentNode = rootNode;
                continue;
            case $cd99543034913be8$export$b29f845fa4b57508:
                if (parentNode.type === (0, $0254e73a635edba0$export$cc3f916331a7eba8)) throw new Error(`Error in serialized trie at position ${i}: Cannot go up, current parent node is already root`);
                addDomain();
                parentNode = parentNode.parent;
                continue;
        }
        domain += char;
    }
    if (domain !== "") addDomain();
    return rootNode;
};


const $8c8b54d97f00ef0b$export$47de78fc237165d8 = [
    "localhost",
    "local",
    "example",
    "invalid",
    "test"
];
var $8c8b54d97f00ef0b$export$1808bbb04470ca2c;
(function(ParseResultType) {
    /**
     * This parse result is returned in case the given hostname does not adhere to [RFC 1034](https://tools.ietf.org/html/rfc1034).
     */ ParseResultType["Invalid"] = "INVALID";
    /**
     * This parse result is returned if the given hostname was an IPv4 or IPv6.
     */ ParseResultType["Ip"] = "IP";
    /**
     * This parse result is returned when the given hostname
     * - is the root domain (the empty string `""`)
     * - belongs to the top-level domain `localhost`, `local`, `example`, `invalid` or `test`
     */ ParseResultType["Reserved"] = "RESERVED";
    /**
     * This parse result is returned when the given hostname is valid and does not belong to a reserved top-level domain, but is not listed in the public suffix list.
     */ ParseResultType["NotListed"] = "NOT_LISTED";
    /**
     * This parse result is returned when the given hostname belongs to a top-level domain that is listed in the public suffix list.
     */ ParseResultType["Listed"] = "LISTED";
})($8c8b54d97f00ef0b$export$1808bbb04470ca2c || ($8c8b54d97f00ef0b$export$1808bbb04470ca2c = {}));
const $8c8b54d97f00ef0b$var$getAtIndex = (array, index)=>{
    return index >= 0 && index < array.length ? array[index] : undefined;
};
const $8c8b54d97f00ef0b$var$splitLabelsIntoDomains = (labels, index)=>{
    return {
        subDomains: labels.slice(0, Math.max(0, index)),
        domain: $8c8b54d97f00ef0b$var$getAtIndex(labels, index),
        topLevelDomains: labels.slice(index + 1)
    };
};
let $8c8b54d97f00ef0b$var$parsedIcannTrie;
let $8c8b54d97f00ef0b$var$parsedPrivateTrie;
const $8c8b54d97f00ef0b$export$294ead44cbc289a5 = (hostname, options)=>{
    const sanitizationResult = (0, $98b7f7041de863f1$export$83d2e9e3e4ee39ed)(hostname, options);
    if (sanitizationResult.type === (0, $98b7f7041de863f1$export$a84f8d7a6b866582).Error) return {
        type: $8c8b54d97f00ef0b$export$1808bbb04470ca2c.Invalid,
        hostname: hostname,
        errors: sanitizationResult.errors
    };
    if (sanitizationResult.type === (0, $98b7f7041de863f1$export$a84f8d7a6b866582).ValidIp) return {
        type: $8c8b54d97f00ef0b$export$1808bbb04470ca2c.Ip,
        hostname: sanitizationResult.ip,
        ipVersion: sanitizationResult.ipVersion
    };
    const { labels: labels, domain: domain } = sanitizationResult;
    if (hostname === "" || $8c8b54d97f00ef0b$export$47de78fc237165d8.includes(labels[labels.length - 1])) return {
        type: $8c8b54d97f00ef0b$export$1808bbb04470ca2c.Reserved,
        hostname: domain,
        labels: labels
    };
    // Parse the serialized trie lazily
    $8c8b54d97f00ef0b$var$parsedIcannTrie = $8c8b54d97f00ef0b$var$parsedIcannTrie !== null && $8c8b54d97f00ef0b$var$parsedIcannTrie !== void 0 ? $8c8b54d97f00ef0b$var$parsedIcannTrie : (0, $475490fb2d51796a$export$2a3eda41008947a3)((0, (/*@__PURE__*/$parcel$interopDefault($1475fcca6d28e4b3$exports))));
    $8c8b54d97f00ef0b$var$parsedPrivateTrie = $8c8b54d97f00ef0b$var$parsedPrivateTrie !== null && $8c8b54d97f00ef0b$var$parsedPrivateTrie !== void 0 ? $8c8b54d97f00ef0b$var$parsedPrivateTrie : (0, $475490fb2d51796a$export$2a3eda41008947a3)((0, (/*@__PURE__*/$parcel$interopDefault($4c1e41cfee030721$exports))));
    const icannTlds = (0, $8e493016ce105ef2$export$4ecf1803c40ca846)(labels, $8c8b54d97f00ef0b$var$parsedIcannTrie);
    const privateTlds = (0, $8e493016ce105ef2$export$4ecf1803c40ca846)(labels, $8c8b54d97f00ef0b$var$parsedPrivateTrie);
    if (icannTlds.length === 0 && privateTlds.length === 0) return {
        type: $8c8b54d97f00ef0b$export$1808bbb04470ca2c.NotListed,
        hostname: domain,
        labels: labels
    };
    const indexOfPublicSuffixDomain = labels.length - Math.max(privateTlds.length, icannTlds.length) - 1;
    const indexOfIcannDomain = labels.length - icannTlds.length - 1;
    return Object.assign({
        type: $8c8b54d97f00ef0b$export$1808bbb04470ca2c.Listed,
        hostname: domain,
        labels: labels,
        icann: $8c8b54d97f00ef0b$var$splitLabelsIntoDomains(labels, indexOfIcannDomain)
    }, $8c8b54d97f00ef0b$var$splitLabelsIntoDomains(labels, indexOfPublicSuffixDomain));
};


var $4202a5939499f6a1$require$parseDomain = $8c8b54d97f00ef0b$export$294ead44cbc289a5;
var $139d6bd5d144bf6f$exports = {};
function $139d6bd5d144bf6f$var$isPlansIntegrationEnabled() {
    return false;
}
function $139d6bd5d144bf6f$var$isFrenchLanguageSupportEnabled() {
    return false;
}
// feature flags passed to front end via window.SERVER_DATA object, can be accessed via window.SERVER_DATA.featureFlags
const $139d6bd5d144bf6f$var$flags = {
    planIntegrationEnabled: $139d6bd5d144bf6f$var$isPlansIntegrationEnabled(),
    frenchLanguageSupportEnabled: $139d6bd5d144bf6f$var$isFrenchLanguageSupportEnabled(),
    isGoogleAnalyticsEnabled: undefined,
    isHeapAnalyticsEnabled: undefined,
    googleId: undefined
};
$139d6bd5d144bf6f$exports = {
    flags: $139d6bd5d144bf6f$var$flags,
    isPlansIntegrationEnabled: $139d6bd5d144bf6f$var$isPlansIntegrationEnabled,
    isFrenchLanguageSupportEnabled: $139d6bd5d144bf6f$var$isFrenchLanguageSupportEnabled
};


//TODO add fr if we get the french domain
function $4202a5939499f6a1$var$getSubdomainFromLanguage(lang) {
    switch(lang){
        case "en-GB":
            return "co.uk";
        case "de":
            return "de";
        default:
            return "com";
    }
}
function $4202a5939499f6a1$var$updateUrlForLanguage(languageFromBrowser) {
    const currentUrl = window.location.href;
    const currentSubdomain = $4202a5939499f6a1$require$parseDomain(currentUrl).tld;
    const subdomain = $4202a5939499f6a1$var$getSubdomainFromLanguage(languageFromBrowser);
    window.location.href = currentUrl.replace(currentSubdomain, subdomain);
}
const $4202a5939499f6a1$var$supportedLanguages = {
    de: "Deutsch",
    en: "English (US)",
    "en-GB": "English (UK)",
    svk: "Slovak",
    pol: "Polish",
    nld: "Dutch",
    col: "Spanish"
};
let $4202a5939499f6a1$var$frenchLanguageSupportEnabled;
if (typeof window !== "undefined") $4202a5939499f6a1$var$frenchLanguageSupportEnabled = window.SERVER_DATA.featureFlags.frenchLanguageSupportEnabled;
else $4202a5939499f6a1$var$frenchLanguageSupportEnabled = $139d6bd5d144bf6f$exports.isFrenchLanguageSupportEnabled();
if ($4202a5939499f6a1$var$frenchLanguageSupportEnabled) $4202a5939499f6a1$var$supportedLanguages.fr = "Fran\xe7ais (France)";
$4202a5939499f6a1$exports = {
    supportedLanguages: $4202a5939499f6a1$var$supportedLanguages,
    getSubdomainFromLanguage: $4202a5939499f6a1$var$getSubdomainFromLanguage,
    updateUrlForLanguage: $4202a5939499f6a1$var$updateUrlForLanguage
};


var $b8cd368031f674c5$require$updateUrlForLanguage = $4202a5939499f6a1$exports.updateUrlForLanguage;

var $b8cd368031f674c5$require$parseDomain = $8c8b54d97f00ef0b$export$294ead44cbc289a5;
/* Custom domain detector. Reads the ccTLD from the URL and returns a country code.
   Both the server side and the client side use this domain detector, although the client side is
   only supposed to use this as a failsafe, in case something goes wrong with cookie detection.
   The server side uses this to determine what language the app should initially display in,
   based on the URL's ccTLD (and the browser language, for British English ".com".  Later, the user
   can edit this language by choosing a different language with the LanguageSelector dropdown. */ function $b8cd368031f674c5$var$getLanguageCode(url) {
    const domainObj = $b8cd368031f674c5$require$parseDomain(url);
    if (domainObj === null) return "en";
    switch(domainObj.tld){
        case "co.uk":
            return "en-GB";
        case "com":
            return "en";
        case "de":
            return "de";
        case "fr":
            return "fr";
        case "at":
            return "de";
        case "sk":
            return "svk";
        case "hu":
            return "hun";
        case "pl":
            return "pol";
        default:
            return "en";
    }
}
function $b8cd368031f674c5$var$initDomainDetector(lngDetector, type) {
    lngDetector.addDetector({
        name: "domainDetectorCustom",
        lookup: (req)=>{
            let url;
            if (type === "server") url = req.get("host"); // server gets URL from req
            else url = window.location.href; // client gets URL from window
            return $b8cd368031f674c5$var$getLanguageCode(url);
        }
    });
}
function $b8cd368031f674c5$var$getBrowserLanguageDetector() {
    // TODO: uncomment this when we have the appropriate domains
    // let languageFromBrowser = navigator.language;
    // if (languageFromBrowser === 'en-US') languageFromBrowser = 'en';
    // const languageFromUrl = getLanguageCode(window.location.href);
    // if (languageFromUrl !== languageFromBrowser) {
    //   updateUrlForLanguage(languageFromBrowser);
    // }
    const lngDetector = new $b8cd368031f674c5$require$BrowserLngDetector();
    $b8cd368031f674c5$var$initDomainDetector(lngDetector, "browser");
    return lngDetector;
}
function $b8cd368031f674c5$var$getServerLanguageDetector() {
    const lngDetector = new $ec141a35d03dcff3$export$36df6eadd61c72e4();
    $b8cd368031f674c5$var$initDomainDetector(lngDetector, "server");
    return lngDetector;
}
const $b8cd368031f674c5$var$detectionOptions = {
    // The order in which language detection should look for a language; cookie first, for user preference prioritization
    order: [
        "cookie",
        "domainDetectorCustom"
    ],
    // Cache the cookie so that it persists (necessary for persisting user language)
    caches: [
        "cookie"
    ],
    // The cookie to store and lookup the language from
    lookupCookie: "i18next"
};
$b8cd368031f674c5$exports = {
    getBrowserLanguageDetector: $b8cd368031f674c5$var$getBrowserLanguageDetector,
    getServerLanguageDetector: $b8cd368031f674c5$var$getServerLanguageDetector,
    detectionOptions: $b8cd368031f674c5$var$detectionOptions,
    updateUrlForLanguage: $b8cd368031f674c5$require$updateUrlForLanguage
};


var $19549b141cd31dce$exports = {};
$19549b141cd31dce$exports = {
    // LandingPageHero
    landingPageHeroTitle: "Let us help you plan for the workplace of the future and find the right amount of space for your next office.",
    landingPageHeroSubtitle: "The world of workplace is changing due to the recent pandemic - receive your custom space recommendation using our free tool",
    landingPageHeroImgAlt: "Preview of a results page space program from the homepage of Spacer by CBRE",
    landingPageImage: "/png/homepage-results-page-in-browser-spacer-by-cbre.png",
    // LandingPageContent
    landingPageContentTitle: "How it works",
    // StepsSummary
    stepsSummarySubtitle1: "Step 1 \u2014",
    stepsSummaryTitle1: "Tell us about your company",
    stepsSummaryText1: "Help us to get to know your goals and objectives as a company so we can make recommendations specific to you.",
    stepsSummaryImgAlt1: "Illustration of people standing on a giant laptop on the Home page of Spacer by CBRE",
    stepsSummarySubtitle2: "Step 2 \u2014",
    stepsSummaryTitle2: "Get your results",
    stepsSummaryText2: "Based on your responses, you will receive a recommended office size and a list of individual space types with quantities of each. You can even view example floor plans.",
    stepsSummaryImgAlt2: "Illustration of a neighborhood block on the Home page of Spacer by CBRE",
    stepsSummarySubtitle3: "Step 3 \u2014",
    stepsSummaryTitle3: "Find your perfect office",
    stepsSummaryText3: "Save your results to refer back to during the office search, or contact the Spacer team to connect with one of our leasing professionals who can assist in finding your perfect office.",
    stepsSummaryImgAlt3: "Illustration of a girl working at a desk on the Home page of Spacer by CBRE",
    // LandingPageSecondaryHero
    landingPageSecondaryHeroImgAlt: "Illustration of people building space recommendations on the Home page of Spacer by CBRE",
    landingPageSecondaryHeroTitle: "Tell us a little about your company. We\u2019ll tell you how much office space you need."
};


var $bbf7aad4e4fb7b6e$exports = {};
$bbf7aad4e4fb7b6e$exports = {
    // Navbar
    spacerLogoAlt: "Spacer by CBRE",
    linkToAboutPageText: "About",
    linkToBlogPageText: "Insights",
    referrals: "Referrals",
    // TakeOfficeSpaceQuizButton
    sizeMyOfficeButtonDefaultLinkText: "Take office space quiz",
    flooredPlanRequestLinkText: "Request a Plan",
    // Footer
    footerCBRELogoAlt: "CBRE logo for Spacer by CBRE",
    footerFacebookIconAlt: "Facebook\u2019s social icon for Spacer by CBRE",
    footerTwitterIconAlt: "Twitter\u2019s social icon for Spacer by CBRE",
    footerLinkedinIconAlt: "Linkedin\u2019s social icon for Spacer by CBRE",
    footerHeaderQuestionsText: "Questions?",
    footerHeaderAboutText: "Resources",
    footerHeaderMoreText: "More",
    footerHeaderBrokersText: "For Brokers",
    footerLinkWhatIsSpacerText: "About",
    footerLinkBlogText: "Insights",
    footerLinkWorkplaceText: "Who is CBRE Workplace?",
    footerLinkTermsText: "Terms of Service",
    footerLinkPrivacyText: "Privacy Policy",
    footerLinkedinLink: "https://www.linkedin.com/showcase/cbre-workplace-strategy/",
    footerLinkReferralText: "Referrals",
    footerWorkplaceLink: "http://www.cbre.us/real-estate-services/occupier/workplace",
    footerPrivacyLink: "https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy",
    // Contact (contact.js)
    spacerSupportEmail: "spacersupport@cbre.com",
    // ErrorPage
    errorOopsText: "Oops!",
    error404Text: "We can\u2019t find the page you\u2019re looking for.",
    error500Text: "Something went wrong on our end.",
    errorText: "Error",
    errorReturnText: "Return to Spacer",
    errorAltText: "Illustration of a spilled coffee cup for Spacer by CBRE",
    // Measurement Units (units.js)
    SF: "SF",
    SM: "SM",
    USF: "USF",
    USM: "USM",
    RSF: "RSF",
    RSM: "RSM",
    NSF: "NSF",
    NSM: "NSM",
    NIA: "NIA",
    foot: "foot",
    feet: "feet",
    footage: "footage",
    "sqft.": "sqft.",
    meter: "meter",
    meters: "meters",
    "sqm.": "sqm.",
    Tsubo: "tsubo",
    // SF Types Adjectives (calculator.js)
    Usable: "Usable",
    Rentable: "Rentable",
    Net: "Net",
    // Page Titles (documentDataCopy.js)
    landingPageTitle: "Plan Your Perfect Office in 15 Minutes - Spacer by CBRE",
    aboutPageTitle: "Learn How Our Office Sizing Tool Works - Spacer by CBRE",
    termsPageTitle: "Terms of Service - Spacer by CBRE",
    quizPageTitle: "Size Your Office in 15 Minutes - Spacer by CBRE",
    resultsPageTitle: "View Your Custom Office Recommendation - Spacer by CBRE",
    profileComparisonPageTitle: "Compare Your Office Needs - Spacer by CBRE",
    blogHomePageTitle: "Office Planning Insights - Spacer By CBRE",
    referralPageTitle: "Referral Link for CBRE Brokers - Spacer By CBRE",
    referralRetrievePageTitle: "Retrieve Referral Link for CBRE Brokers - Spacer By CBRE",
    // Meta Tags (documentDataCopy.js)
    landingPageMetaTagText: "Planning your next office? Let Spacer by CBRE help you quickly and easily determine the right amount of office space needed to support your business goals. It only takes 15 minutes!",
    aboutPageMetaTagText: "The size of your office can help you attract talent, reduce costs, and even keep your employees healthy. Learn more about how Spacer can quickly recommend the right office size to support your company\u2019s goals.",
    termsPageMetaTagText: "More than a decade of industry expertise and experience has gone into Spacer by CBRE, which makes informed office size recommendations in minutes.",
    quizPageMetaTagText: "Take Spacer\u2019s 15-minute quiz to determine how much office space you need to support your company\u2019s goals and priorities. Customized programming has never been this fast.",
    resultsPageMetaTagText: "Spacer\u2019s custom space results save you time searching for offices by giving you the exact office size your company needs, along with suggested furniture types and floor plan layouts.",
    profileComparisonPageMetaTagText: "Understand how your unique office needs compare to others using Spacer by CBRE",
    blogHomePageMetaTagText: "Calculating how much office space a business needs is not a perfect science, but these office planning insights and resources can help. Learn more here.",
    referralPageMetaTagText: "Use this referral link to send Spacer to clients and ensure their space results are sent directly to your email. Learn more here.",
    referralRetrieveMetaTagText: "Retrieve your referral link for Spacer.",
    // Form title
    formLabel: "Your information"
};


var $d25197544d693ff7$exports = {};
$d25197544d693ff7$exports = {
    // Results
    resultsWarningMessage: "Are you sure you want to leave this page? You may lose data you haven\u2019t saved.",
    // ResultsHeader
    resultsHeaderExportPDFButtonText: "Export PDF",
    resultsHeaderSendButtonText: "Send results",
    resultsHeaderClipboardBoxDescription: "Anyone with a link can view and edit results",
    resultsHeaderContactButtonText: "Connect with an advisor",
    // EmailWallSection
    emailWallTitle: "There\u2019s more waiting for you",
    emailWallSubtitle: "Enter your name and email below to view a complete space recommendation and customize your results.",
    emailWallFirstNamePlaceholder: "First Name",
    emailWallLastNamePlaceholder: "Last Name",
    emailWallEmailPlaceholder: "Your email",
    emailWallCBREEmailPlaceholder: "Your CBRE professional\u2019s email (optional)",
    emailWallLeasingProfessionalPlaceholder: "Your CBRE leasing professional",
    emailWallConnectMeText: "Connect me with a personal real estate advisor. No email newsletters or spam, we promise!",
    emailWallContactNoticeText: "The Spacer team might contact you to help you get the most out of your program. No spam, we promise!",
    emailWallResultsButtonText: "View complete results",
    emailWallImgAltText: "Preview of a results page space program from the email wall of Spacer by CBRE.",
    emailWallFirstNameInvalid: "Please enter your first name.",
    emailWallLastNameInvalid: "Please enter your last name.",
    emailWallEmailInvalid: "Please enter a valid email address.",
    // CopyToClipboardBox
    clipboardBoxCopyText: "Copy",
    clipboardBoxCopiedText: "Copied",
    // FormModal
    formModalFindSpaceHeader: "Start the office search",
    formModalFindSpaceBody: "Spacer is a quick and easy tool for workplace analysis, but if you need something more customized, let CBRE Workplace help. Fill out this form, and a Workplace professional will reach out to you within 48 hours to schedule a time to speak.",
    formModalFindSpaceSuccessMessage: "Your request was sent.",
    // SuccessModal
    successModalTitle: "Success!",
    // ContactForm
    contactFormFirstNameLabel: "First Name",
    contactFormLastNameLabel: "Last Name",
    contactFormEmailLabel: "Work Email",
    contactFormPhoneLabel: "Phone Number",
    contactFormMessageLabel: "Tell us more about what you\u2019re looking for",
    contactFormSubmitText: "Submit",
    // AcceptTermsText
    acceptTermsText: "I accept the <1>Terms and Conditions</1>. For more information on how your data will be used, please refer to the <3>CBRE Privacy Policy</3>.",
    privacyPolicyLink: "https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy",
    // Form
    formErrorText: "Oops, that didn\u2019t go through. Please try again!",
    formEmailInvalid: "Please enter a valid email address.",
    // FormInput
    formInputOptionalText: " (optional)",
    // LegalForm
    legalFormCheckboxText: "CBRE may contact me with offers and information related to my use of Spacer.",
    legalFormContactWarningText: "The Spacer team might contact you to help you get the most out of your program. No spam, we promise!",
    // NextStepsSection
    nextStepsSectionSubtitle: "Ready to take the next step?",
    nextStepsSectionTitle: "Find the perfect office.",
    nextStepsSectionButtonText: "Connect with an advisor",
    nextStepsSectionImgAlt: "Illustration of people conversing on the Results page of Spacer by CBRE",
    // Profile
    resultsProfileSummaryTitle: "Your office \u2014",
    resultsProfileTooltipText: "Each profile is a composite of real organizations and workplaces, and the details were checked against industry guidelines and market knowledge unique to CBRE Workplace.",
    // Program
    programSaveConfirmationBoxText: "You\u2019re all set. We emailed a link to your results. Enjoy!",
    programExamplePlansTitle: "Example Plans",
    programExamplePlansSubtitle: "Play with interactive floor plans that match your profile. You can even explore them in 3D!",
    programTooMuchTinkerWarning: "Whoa there! Looks like you\u2019re out of the recommended range based on your profile. Consider <1>retaking the quiz</1>, or contacting support at <3>{{email}}</3>.",
    programDisclaimer: "Spacer by CBRE is provided \u201Cas is\u201C and \u201Cas available\u201C with no warranties. All results generated from your use of Spacer are for illustrative purposes only, and do not reflect actual space recommendations or suggested lease terms. Actual space recommendations may vary greatly and will depend on many factors which Spacer does not take into account. By using Spacer or any report generated by the use of Spacer, you accept our Terms of Service and Privacy Policy located respectively at the urls https://workplace.cbre.com/termsOfService and https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy. \xa9 2018 CBRE, Inc. All rights reserved.",
    programMetricsTitle: "Program Metrics",
    programMetricsSubtitle: "These numbers summarize your work environment",
    programDetailsSectionTitle: "Customize Your Program",
    programDetailsSectionSubtitle: "Adjust the fields below to fine-tune your space needs.",
    programRevertButtonText: "Revert",
    programSaveButtonText: "Save Changes",
    programSavedButtonText: "Saved",
    // ProgramAssumptions
    programAssumptionsRecommendedOfficeSizeText: "Recommended Office Size",
    programAssumptionsProfileText: "Profile",
    programAssumptionsHeadcountText: "Headcount",
    programAssumptionsHeadcountFollowingText: "people",
    programAssumptionsCollabText: "Collaboration",
    programAssumptionsCirculationText: "Circulation",
    programAssumptionsAvgDaysText: "Average days in office",
    programAssumptionsAvgDaysFollowingText: "per week",
    programAssumptionsAvgDaysPerWeekText: "Average days in office per week",
    // ProgramHeroForPrint
    printNIAText: "Net Internal Area",
    printUSFText: "Usable Square Feet",
    printRSFText: "Rentable Square Feet",
    printDescText: "Based on your details, and a {{lossFactorPercentage}}% {{factorType}} in {{city}}, we recommend a total of-",
    printFitFactorText: "fit factor",
    printLossFactorText: "loss factor",
    // BarChart
    barChartIndivSubtitle: "Individual Space",
    barChartGroupSubtitle: "Group Space",
    barChartAmenitySubtitle: "Amenity Space",
    // TabbedProgramBarChart
    tabbedBarChartMeSubtitle: "Individual",
    tabbedBarChartGroupSubtitle: "Group",
    tabbedBarChartAmenitySubtitle: "Amenities",
    // SpaceCategoryBreakdown
    spaceCatBreakdownSubtitle: "Select a space type to customize",
    // SpaceCategoryBreakdownMobile
    spaceCatBreakdownMobileMeTitle: "Individual Space",
    spaceCatBreakdownMobileWeTitle: "Group Space",
    spaceCatBreakdownMobileAmenityTitle: "Amenity Space",
    spaceCatBreakdownMobileMeSubtitle: "for working solo",
    spaceCatBreakdownMobileWeSubtitle: "for working together",
    spaceCatBreakdownMobileAmenitySubtitle: "for everything else",
    spaceCatBreakdownMobileNIATotalTitle: "Total Net Internal Area",
    spaceCatBreakdownMobileTotalTitle: "Total {{sfType}} Square {{unitCapitalized}}",
    spaceCatBreakdownMobileCirculationText: "Circulation",
    // SpaceCategoryDropdown
    spaceCatDropdownMeText: "Individual Space",
    spaceCatDropdownWeText: "Group Space",
    spaceCatDropdownAmenityText: "Amenity Space",
    // SidebarInfo
    sidebarInfoMeTitle: "Individual",
    sidebarInfoWeTitle: "Group",
    sidebarInfoAmenityTitle: "Amenities",
    // Space Category Descriptions (spaceCategoryDescription.js)
    spaceCatMeDesc: "Space for individual work. Offering choice in where and how your employees work leads to greater employee satisfaction.",
    spaceCatWeDesc: "Space for collaboration and teaming up. In an era when work can happen anywhere, it\u2019s important to provide a variety of spaces to suit a variety of tasks.",
    spaceCatAmenityDesc: "Space that supports work. Great amenities will make your office somewhere your employees \u2014 and recruits \u2014 look forward to spending their time.",
    // Suggested Custom Amenities (suggestedCustomAmenityUnitMap.js)
    audioVisualCustom: "Audio / Visual",
    dataCenterCustom: "Data Center",
    buildingSupportCustom: "Building Support Services",
    foodServiceCustom: "Full Food Service",
    kitchenCustom: "Kitchen",
    serveryCustom: "Servery",
    execDiningCustom: "Executive Dining",
    grabNGoCustom: "Grab-N-Go",
    juiceCoffeeBarCustom: "Juice Bar / Coffee Bar",
    childCareCustom: "Child Care",
    fitnessCenterCustom: "Fitness Center",
    healthCenterCustom: "Health Center",
    mailCenterCustom: "Mail Center",
    commercialPrintCustom: "Commercial Print Room",
    centralCafeCustom: "Central Caf\xe9",
    securityCtrlCustom: "Security Control Room",
    auditoriumCustom: "Auditorium",
    dryCleaningLaundryCustom: "Dry Cleaning / Laundry",
    confCenterCustom: "Conference Center",
    multiPurpTrainingCustom: "Multi-Purpose / Training",
    informalCollabCustom: "Informal Collaboration",
    touchdownTeamCustom: "Touchdown / Team",
    // Suggested Custom Amenity Units (spaceUnit.js)
    seats: "seat",
    seats_plural: "seats",
    rooms: "room",
    rooms_plural: "rooms",
    areas: "area",
    areas_plural: "areas",
    units: "unit",
    units_plural: "units",
    // Predefined Amenities (spaceUnitMap.js) - Shared Space Units
    focusRoomDefined: "Focus Room",
    fileRoomDefined: "File Room",
    centralReceptionHubDefined: "Central Reception Hub",
    smOfficeDefined: "Small Office",
    regOfficeDefined: "Regular Office",
    benchDesk5Defined: "5\u2019 Bench Desk",
    benchDesk6Defined: "6\u2019 Bench Desk",
    meetingRoom4Defined: "Meeting Room (4 people)",
    meetingRoom6Defined: "Meeting Room (6 people)",
    meetingRoom8Defined: "Meeting Room (8 people)",
    meetingRoom12Defined: "Meeting Room (12 people)",
    meetingRoom15Defined: "Meeting Room (15 people)",
    semiEnclosedMeetingBooth4Defined: "Semi-Enclosed Meeting Booth (4 people)",
    openCollabSpace4to6Defined: "Open Collaboration Space (4-6 people)",
    contemplationSpaceDefined: "Contemplation Space",
    mainITEquipRoomDefined: "Main IT Server / Equipment Room",
    receptionAreaDefined: "Reception Area",
    cafeFoodServiceDefined: "Caf\xe9 / Food Service",
    teamStorageDefined: "Team Storage",
    coatClosetsDefined: "Coat Closets",
    genStorageDefined: "General Storage (stores and goods in/out)",
    centralisedCopyPrintMailDefined: "Centralised Copy, Print & Mail",
    specialResourceAreaDefined: "Special Resource Area",
    personalStorageDefined: "Personal Storage (lockers)",
    storageITSpaceDefined: "IT Storage Space",
    secondaryServerRoomDefined: "Secondary Server / Telecom Room",
    mothersRoomDefined: "Mothers\u2019 Room",
    buildITSpaceDefined: "IT Build Space",
    workerCouncilOffice2Defined: "Worker Council Office (2 people)",
    securityCtrlRoomDefined: "Security Control Room",
    centralisedMailDefined: "Centralised Mail",
    visitorCoatLuggageRoomDefined: "Visitor Coat / Luggage Room",
    wellnessRoomDefined: "Wellness Room",
    internalStairDefined: "Internal Stair",
    commercialPrintRoomDefined: "Commercial Print Room",
    buildingSupportServicesAreaDefined: "Building Support Services Area",
    // Predefined Amenities (spaceUnitMap.js) - US_SMALL and US_REGULAR
    officeDefined: "Office",
    lgOfficeDefined: "Office (large)",
    smWorkstationDefined: "Workstation (small)",
    mdWorkstationDefined: "Workstation (medium)",
    lgWorkstationDefined: "Workstation (large)",
    huddleRoomDefined: "Huddle Room",
    dispersedCopyPrintAreaDefined: "Dispersed Copy / Print Area",
    smMeetingRoomDefined: "Small Meeting Room",
    mdMeetingRoomDefined: "Medium Meeting Room",
    lgMeetingRoomDefined: "Large Meeting Room",
    xlMeetingRoomDefined: "X-Large Meeting Room / Boardroom",
    multiPurpTrainingDefined: "Multi-Purpose / Training",
    informalCollabDefined: "Informal Collaboration Area",
    touchdownTeamDefined: "Touchdown / Team Area",
    pantryVendingCoffeeAreaDefined: "Pantry / Vending / Coffee Area",
    workplaceStorageRoomDefined: "Workplace Storage Room",
    employeeCoatAreaDefined: "Employee Coat Area",
    dispersedMailAreaDefined: "Dispersed Mail Area",
    lockerUnitDefined: "Locker Unit",
    serverRoomDefined: "Server Room",
    frontDeskAreaDefined: "Front Desk Area",
    centralCafeAreaDefined: "Central Caf\xe9 Area",
    mailCenterAreaDefined: "Mail Center Area",
    kitchenAreaDefined: "Kitchen Area",
    drawerLateralFileUnitDefined: "3 Drawer Lateral File Unit",
    serveryAreaDefined: "Servery Area",
    juiceBarCoffeeShopAreaDefined: "Juice Bar / Coffee Shop Area",
    diningSupportAreaDefined: "Dining Support Space Area",
    diningAreaDefined: "Dining Area",
    grabNGoAreaDefined: "Grab-N-Go Area",
    focusRoomSharedFocus: "Focus Room",
    // Predefined Amenities (spaceUnitMap.js) - UK_REGULAR
    fullFoodServiceDefined: "Full Food Service",
    // Predefined Amenities (spaceUnitMap.js) - APAC_REGULAR
    officeWorkMeetDefined: "Office (Work/Meet)",
    lgOfficeWorkMeetDefined: "Large Office (Work/Meet)",
    focusDefined: "Focus",
    bench1pt6Defined: "1.6 Bench",
    bench1pt8Defined: "1.8 Bench",
    bench1pt8LDefined: "1.8 \u2018L\u2019 Workstation",
    banquetWorkMeetDefined: "Banquet - Work/Meet (2p)",
    cafeTable4Defined: "Caf\xe9 Table (4p)",
    kitchenTable8to10Defined: "Kitchen Table (8-10p)",
    standingWhiteboardDefined: "Standing Whiteboard",
    huddleRoom3Defined: "Huddle Room (3p)",
    smMeetingRoom5Defined: "Sm Meeting Room (5p)",
    mdMeetingRoom8Defined: "M Meeting Room (8p)",
    lgMeetingRoom20Defined: "L Meeting Room (20p)",
    xlBoardroom: "X-Large / Boardroom",
    wellnessRoomsDefined: "Wellness Rooms",
    employeeCoatsGymLockersDefined: "Employee Coats / Gym Lockers",
    lockersDefined: "Lockers",
    dispersedCopyPrintScanAreaDefined: "Dispersed Copy / Print / Scan Area",
    hydrationPointDefined: "Hydration Point (Water / Tea / Coffee)",
    centralHighDensityStorageDefined: "Central High Density Storage",
    wellnessMothersRoomDefined: "Wellness / Mothers\u2019 Room",
    serverHubRoomsDefined: "Server / Hub Rooms",
    buildITStoreRoomDefined: "IT Build / Store Room",
    simpleReceptionWaitDefined: "Simple Reception + Wait",
    centralCafeSocialHubDefined: "Central Caf\xe9 Social Hub",
    mailCentreDefined: "Mail Centre",
    utilityStoreRoomDefined: "Utility Store Room",
    drawerLateralFileDefined: "3 Drawer Lateral File",
    juiceBarCoffeeShopDefined: "Juice Bar / Coffee Shop",
    buildingSupportServicesDefined: "Building Support Services",
    // Space Unit Map Descriptions (spaceUnitMap.js) - Shared Descriptions
    focusRoomDesc: "Focus Rooms are enclosed spaces intended to support focused and/or confidential work for typically one or two people. Acoustic privacy is paramount in these spaces. Focus Rooms are usually unassigned and can be booked temporarily on an as-needed basis for relevant work.",
    fileRoomDesc: "This is paper file storage for individuals and teams. As a result of most offices digitization efforts, the need for both individual and team file storage is diminishing greatly. Still, this is a central space for legally required document copies or long term project materials, especially with most open office desks containing little storage.",
    centralReceptionHubDesc: "The reception area is your company\u2019s first opportunity to make an impression on employees, clients and other visitors. It should consistently convey the company\u2019s brand and project the desired appearance. The concierge desk should comfortably house a concierge; soft-seating should be inviting to visitors.",
    officeDesc: "Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.",
    benchDeskDesc: "Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.",
    meetingRoomDesc: "Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).",
    meetingRoomDesc6: "Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).",
    meetingRoomDesc8: "Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).",
    meetingRoomDesc12: "Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).",
    meetingRoomDesc15: "Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).",
    openCollabSpace4to6Desc: "These areas are meant to support small groups (4-6 person) collaborative activities such as brainstorming and informal conversations between colleagues and with clients. ",
    cafeFoodServiceDesc: "The central cafe is intended to be an area for eating, social interaction, individual work and small meetings. Functional eating furniture and a branded color palette should be considered in the design of this space.",
    coatClosetsDesc: "Employees need a place to store their coats and other bulky items, especially when an office has an open layout with limited personal storage at the desk. These should be dispersed throughout the office, perhaps located by exits and along main corridors. There is usually a shelf about the hanging portion for hats and other equipment with storage or suitcases at the base of the closet.",
    copyPrintDesc: "Spread across the floor in open workspace, copy/print areas give employees quick access to multi-function devices from all neighborhoods. Bins for recycling should always be collocated with copy/print areas, as well as small cabinets to house extra paper and supplies. These spaces are for drop-in purposes only and are not intended to double as social/work areas.",
    specialResourceBuildingSupportAreaDesc: "This is a catch all for additional support spaces that might occur in an office. One could be a security desk or facilities while another could be a utilities space. This varies across organizations, but as the size of the office increases, ancillary spaces like this become more likely and necessary.",
    secondaryServerRoomDesc: "Secondary Server (technology) room to house and secure IT equipment and to terminate low voltage cabling. The rooms need to have 24 hour air and needs to be at a constant 72 Degrees Fahrenheit with 50% relative humidity.",
    mothersRoomDesc: "Mothers rooms are intended to support extremely private individual time\u2014whether for nursing mothers or any individuals seeking respite from the office for a short interval. Mothers rooms are a usually a requirement for all new offices, regardless of size or headcount.",
    visitorCoatLuggageRoomDesc: "Visitors need a place to store their coats and other bulky items. These should be dispersed throughout the office, perhaps located by exits and along main corridors. There is usually a shelf about the hanging portion for hats and other equipment with storage or suitcases at the base of the closet.",
    wellnessRoomDesc: "Wellness rooms (formerly referred to as Mother\u2019s Rooms) are intended to support extremely private individual time\u2014whether for nursing mothers or any individuals seeking respite from the office for a short interval. Wellness rooms are usually a requirement for all new offices, regardless of size or headcount, and should contain a lounge chair, a refrigerator, and ideally a sink. ",
    internalStairDesc: "Internal stairs can be activated stairwells in the core that provide access between floors, or it can be additional feature elements that connect floors of an office. Can often be a gather space within the office and can be centralized for cafe, reception, or meeting spaces.",
    commercialPrintRoomDesc: "Often combined with the mailroom, companies provide in house capabilities to print, bind, and compile presentations in the print room. There will be several printers, and might include large format printers. Spaces will include storage space for supplies, and will also include counter space for smaller equipment but also space to layout prints.",
    pantryVendingCoffeeDesc: "Unlike the central cafe, the pantry/vending/coffee area is meant for employees to grab the quick food and drink essentials need. Buzz and conversation is naturally found in areas with food, but these spaces usually do not contain seating causing people to come and go quickly within spending an extending amount of time socializing.",
    storageDesc: "Storage rooms are intended to hold miscellaneous items such as large equipment, extra furniture, bulk storage, holiday supplies, etc. They can also be used for visitor coat and luggage storage. There should be small storage located near the concierge for convenience.",
    centralisedDispersedMailAreaDesc: "For larger companies, a mail center is required for organizing incoming and outgoing mail. These space hold specialty production and mail equipment. There are also many surfaces for organizing paper and other materials. Usually manned by a full time staff member.",
    lockerDesc: "Lockers are provided as another form of individual storage. They give employees a space to lock their valuables, personal effects and working files. Lockers may be assigned to individuals or used on a first come, first served basis.",
    mainITandServerRoomDesc: "Primary Server (technology) room to house and secure IT equipment and to terminate low voltage cabling. The rooms need to have 24 hour air and needs to be at a constant 72 Degrees Fahrenheit with 50% relative humidity.",
    drawerLateralFileDesc: "Personal storage for individuals at desks or offices. Contents are usually personal or active project materials.",
    juiceBarCoffeeShopDesc: "While a company might not have a full kitchen and servery, it may provide a coffee shop or juice bar as part of the food/drink amenities in the space. An organization might also have this kind of space in addition to its main dining services, especially if the office is large. This space will likely look like your local Starbucks with a working area for a staffer person separated by a serving counter.",
    grabNGoDesc: "A small convenience area with several fridges, shelves for chips and snacks, and a checkout machine. These Grab-N-Go spaces are typically monitored for security by camera. These spaces are often combined with a small pantry with fridges and freezers and prep area for food.",
    smMeetingConferenceRoomDesc: "A small conference room is an enclosed meeting space intended to comfortably accommodate 2-6 people at the table. These rooms can be used for both internal and client-facing meetings and should therefore be very user friendly with easy access to power and A/V capabilities.",
    mdMeetingConferenceRoomDesc: "A medium conference room is an enclosed meeting space intended to comfortably accommodate 6-10 people at the table. These rooms are used for both internal and client-facing meetings and should therefore be very user friendly with easy access to power and A/V capabilities.",
    lgMeetingConferenceRoomDesc: "A large conference room is an enclosed meeting space intended to comfortably accommodate 12-14 people at the table, overflow seating along the perimeter of the room is desirable. These rooms can be used for both internal and client-facing meetings and are likely to be used for presentations. Furniture should be movable to allow the space to be used for other purposes, such as yoga classes for employees.",
    xlMeetingRoomDesc: "A boardroom conference room is intended to comfortably accommodate 14-18 people at the table, with overflow seating along the perimeter of the room for at least 10 more. These rooms will most likely be used for large internal formal meetings and large client-facing meetings. As such, they should be equipped with robust A/V technology and should be branded as client facing-space.",
    // Space Unit Map Descriptions (spaceUnitMap.js) - US_SMALL and US_REGULAR
    lgOfficeDesc: "Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy. This slightly larger office might be a partner office or might double as a huddle room.",
    smWorkstationDesc: "Workstations are open individual work seats. Smaller workstations can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open workstations are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open workstations have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.",
    mdWorkstationDesc: "Workstations are open individual work seats. The benefits of a slightly larger space includes more desk storage and privacy. This likely means the larger a desk, the most likely it is to assigned instead of free address. Some advantages of open workstations are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open workstations have plenty of focus and huddle rooms. You will likely find additional communal storage and filing located throughout the floor.",
    lgWorkstationDesc: "Workstations are open individual work seats. The benefits of a slightly larger space includes more desk storage and privacy. Desks this size are most likely assigned instead of free address. Some advantages of open workstations are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open workstations have plenty of focus and huddle rooms. You will likely find additional communal storage and filing located throughout the floor.",
    huddleRoomDesc: "Huddle Rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).",
    multiPurpTrainingDesc: "Multi-purpose rooms are meant to accommodate a large number of people (20+). This space is appropriately named since many different activities can happen here including training, company events, and large presentations. The fit and finish of this space is functional/durable with many people coming and going but client facing as well. This space must have the appropriate A/V support - typically much more than the average conference room.",
    informalCollabDesc: "These areas are meant to support small groups (4-6 person) collaborative activities such as brainstorming and informal conversations between colleagues and with clients. ",
    touchdownTeamDesc: "Touchdowns are individual or small internal team work spaces that are spread throughout the office for employee and visitor use. Touchdowns can be a variety of heights, shapes and sizes but are meant to stand out from individual workstations as a unique place to work for a short period of time. These should be plug-and-play spaces: easy to find and use.",
    frontDeskAreaDesc: "This is first stop when employees and visitors come to the office. The desk should be able to accommodate at least one person with person workspace and storage. There will likely be vistor storage nearby as well. The front desk is placed within the larger reception hub where there will likely be seating and other accommodations.",
    mailCenterAreaDesc: "For larger organizations, a mail center is required to centralize all mail services. This will include large sorting and organization space, along with space for charts and equipment. This space likely looks very different for each organization since it is often fit between other program items.",
    kitchenAreaDesc: "For spaces that will have an in-office dining service, a kitchen is required to support this amenity. The requirements of a kitchen will vary from organization to organization, but you can expect to find cooking appliances and refrigerator storage. There will also be dry goods and equipment storage. The kitchen will be adjacent to the servery and likely the conferencing/client amenities center.",
    serveryAreaDesc: "The servery is the area where people get their food. It is likely connected to the kitchen and a dining area with tables and seating. The planning of a servery is very precise to manage queues and traffic. This size and shape of this space will likely vary between organizations.",
    diningSupportAreaDesc: "An organization that has robust dining services will likely have additional support spaces like storage in other parts of the building that need to be accounted for in the overall program. The space will vary between organizations.",
    diningAreaDesc: "Dining near kitchen should provide a variety of choice for people to sit and eat lunch. Providing several different types of seating also allows the space to be utilized for meetings and collaboration outside of lunch time. Providing soft and hard seating along with bar and seated height settings gives users choice.",
    // Space Unit Map Descriptions (spaceUnitMap.js) - UK_REGULAR
    fullFoodServiceDesc: "When providing an in-office dining service, there are multiple functions that come together to support this amenity including a kitchen, servery, dining room (seating), and dining support (storage). The kitchen and servery work together to prepare and serve the food made in-house. Dining is the place where employees and guests can sit and eat but often this space acts as a social and collaboration hub. Just like at home, there is a lot of equipment and food storage required to provide dining services, which is why dining support is included in the Full Food Service space type.",
    // SpaceUnitRow
    spaceUnitRowDeleteTitle: "Delete Space Type",
    spaceUnitRowDeleteText: "Are you sure you want to delete this space type?",
    spaceUnitRowConfirmDeleteText: "Yes, delete",
    spaceUnitRowCancelDeleteText: "No, keep it",
    // CustomAmenityAdder
    customAmenityAddText: "Add an amenity",
    customAmenityPlaceholder: "Amenity type",
    // SpaceUnitTotals
    spaceUnitTotalsTitleNIA: "Total Net Internal Area",
    spaceUnitTotalsTitle: "Total {{sfTypeAdj}} Square {{unitCapitalized}}",
    spaceUnitTotalsCirculation: "Circulation",
    spaceUnitTotalsCirculationTooltip: 'The "space between spaces." Corridors, the space behind your chair, the space around cabinets and doors, and around corners. Without circulation, you would have nowhere to walk! Usually comprises around 35% of the total Usable Square {{unitCapitalized}} in your program, but this varies depending on your profile and ultimate building selection.',
    spaceUnitTotalsREBNY: "REBNY Factor",
    spaceUnitTotalsNYCText: "NYC ",
    spaceUnitTotalsREBNYTooltip: "For programs in NYC, we increase {{sfType}} by 15% to account for the REBNY measurement standard. Space measured per the REBNY measurement standard includes bathrooms, elevator lobbies, and the thickness of exterior walls (among other things).",
    spaceUnitTotalsLossFactor: "Loss Factor ",
    spaceUnitTotalsLossFactorTooltip: "Usable square {{unit}} is how much space you have in your office. Rentable square {{unit}} is the space you pay for, which can include columns, lobbies, and other common areas. The difference between usable and rentable is called the loss factor, and how you calculate it varies by location.",
    // CollaborationDropdown
    collabDropdownLevelLowText: "a little (0-25%)",
    collabDropdownLevelMedText: "some (26-50%)",
    collabDropdownLevelHighText: "most (51-100%)",
    //DensityDropdown
    sameDensityText: "Same density as pre-Covid-19",
    lowerDensityText: "Lower density (more SF per person)",
    notSureDensityText: "Not sure",
    //CirculationDropdown
    preCovidText: "Pre-Covid-19 (45% open / 25% enclosed)",
    higherText: "Higher circulation (50% open / 30% enclosed)",
    notSureText: "Not sure (45% open / 25% enclosed)",
    // ExamplePlans
    examplePlanButtonText: "View Example Plan",
    examplePlanFullFloorText: "full floor",
    examplePlanPartialFloorText: "partial floor",
    examplePlanFullImgAlt: "{{size}} square {{unit}} floor plan showing a {{profileName}} profile layout from Spacer by CBRE",
    examplePlanPartialImgAlt: "{{size}} square {{unit}} partial floor plan showing a {{profileName}} profile layout from Spacer by CBRE",
    examplePlanTooltipText: "If you are larger than {{size}} {{unit}}, you might need more than one floor.",
    // ProgramStats
    programStatsDensitySubtitleTsubo: "Net Tsubo",
    programStatsDensitySubtitle: "{{adjective}} Square {{unitUppercase}}",
    programStatsIndivTitle: "Individual Seats",
    programStatsWorkstationsSubtitle: "Workstations",
    programStatsOfficesSubtitle: "Offices",
    programStatsCollabTitle: "Collaboration",
    programStatsEnclosedSubtitle: "Enclosed Group Seats",
    programStatsIndivSeatSubtitle: "Individual Seat",
    programStatsSeatsTitle: "Seats Per Person",
    programStatsIndivSeatsSubtitle: "Individual Seats",
    programStatsPersonSubtitle: "Person",
    programStatsDensityTitle: "Density",
    programStatsFullDensitySubtitle: "{{density}} per Individual Seat",
    // Profile Display Names (profileNames.js)
    efficientName: "The Optimizer",
    whiteCollarName: "The Accommodator",
    whiteGloveName: "The Enhancer",
    openOfficeName: "The Producer",
    workplace360Name: "The Connector",
    campusName: "The Differentiator",
    startupName: "The Incubator",
    engCreativeName: "The Creator",
    // Profile Descriptions (profileDescriptions.js)
    efficientDesc: 'The Optimizer office is a no-nonsense, no-frills environment with a "get the work done" mindset. The space is focused on enabling individuals with all the required tools at their desks. Collaboration and team-oriented work occurs less frequently. Employee desks are standardized and assigned with only basic support spaces provided within the office. True to its name, these environments are almost always open in order to maximize efficiency.',
    whiteCollarDesc: "As an Accommodator office, you aren\u2019t alone - this is one of the most popular profiles for corporate workplaces. Accommodator offices prefer not to rock the boat with radical space design, but often invest in new technology and furniture to make the space productive and engaging. With a balance of individual and collaborative spaces, employees will find themselves mostly at their desks with occasional meetings and team sessions. Perfect for getting your 9 to 5 on.",
    whiteGloveDesc: "Enter the lobby of an Enhancer office, and you might feel like you\u2019ve made it big. This workplace caters deeply to the needs of employees, as well as clients, who are frequent visitors of the workplace. More than any other workplace profile, offices and enclosed spaces are common. Most employees earn their office space through performance or tenure, and hierarchy likely plays an important role in how the organization functions. Climb the corporate ladder in style.",
    openOfficeDesc: "The Producer office knows what you need to succeed. It is all about giving people the foundational spaces required based on the type of activity happening in the office. Not only are these diverse space types available, but we find they are highly utilized - way to stay efficient! There is an even mix between individual and team-based work, which probably means you are moving around the office a lot during the day. Perfect for an office on the go!",
    workplace360Desc: "Just like your favorite yoga pose, The Connector office prides itself on balance. With the right mix of productivity oriented space and social connection space, The Connector office provides all the essentials for focus while encouraging choice with a variety of other spaces. True to its name, The Connector office locates it\u2019s communal areas like kitchens and open meeting areas centrally. This helps bring people together and creates a sense of community.",
    campusDesc: "The Differentiator office makes it hard to leave at the end of the day. That\u2019s because it thrives on providing a work experience that is above and beyond the rest. You will find enhanced amenities around wellness or food to help save employees time and feel comfortable. Did someone say snacks?! Employees are encouraged to take breaks, socialize, and relax while in the workplace.",
    startupDesc: "Speed and ideation are the name of the game when it comes to the Incubator office. Employees work in highly collaborative teams and think like owners. This office environment is constantly changing, which means most of the spaces have flexibility built-in. Moving furniture and make shift solutions are common. A mixture of fun social activities and intense work sessions, such as ping-pong and hackathons, are used to build camaraderie as a team.",
    engCreativeDesc: "We think of the Creator office as a place that is full of specialists - not your typical mix of department types. Just like all great creative efforts, The Creator office frequently features working together and teaming. Specialized equipment or physical materials are likely part of the day to day work activities. Employees are given the space they need to do their jobs effectively, and while more of a rare office type, a unique job calls for a unique workplace.",
    // Profile Key Traits: Shared Names (profileTraitMap.js)
    social: "Social",
    efficient: "Efficient",
    flexible: "Flexible",
    enabled: "Enabled",
    productive: "Productive",
    inclusive: "Inclusive",
    clientFocused: "Client-Focused",
    standardized: "Standardized",
    // Profile Key Traits (profileTraitMap.js)
    social1Desc: "Relationships in and out of the office are important",
    social2Desc: "Many community building events",
    social3Desc: "Employees like to spend time together",
    social4Desc: "More open and community driven",
    efficient1Desc: "Company stays lean and budget conscious",
    efficient2Desc: "Company stays lean and productive",
    flexible1Desc: "People have choice in how they work",
    flexible2Desc: "Employees have a lot of freedom",
    flexible3Desc: "Build the space you need",
    enabled1Desc: "Employees have what they need at their desks",
    enabled2Desc: "Employees have robust services and amenities",
    enabled3Desc: "People can get what they need to do their jobs",
    enabled4Desc: "Have access to the right tech and equipment",
    enabled5Desc: "Specialized equipment is available",
    productive1Desc: "Functional and intuitive office design",
    productive2Desc: "Business oriented and financially conscious",
    productive3Desc: "Centered around unique product/service offering",
    inclusive1Desc: "Multiple types of space available",
    inclusive2Desc: "You can find everything you need at the office",
    inclusive3Desc: "Many different styles of working are acceptable",
    clientFocused1Desc: "First impressions with clients mean everything",
    clientFocused2Desc: "Office is welcoming for clients and new recruits",
    clientFocused3Desc: "Office is polished for clients and new recruits",
    standardized1Desc: "Processes and systems are streamlined",
    standardized2Desc: "Organizational norms around space allocation",
    standardized3Desc: "Modular sizes for flexibility",
    standardized4Desc: "Streamlined processes and deliverables",
    // SpaceSummary
    spaceSummaryBarHeader: "Recommended Office Size",
    spaceSummaryMeasurementTypeText: "measurement type",
    spaceSummaryUnitTypeText: "units",
    spaceSummaryLossFactorSectionLabel: "{{factor}} Details",
    spaceSummaryFitFactorText: "Fit Factor",
    spaceSummaryLossFactorText: "Loss Factor",
    spaceSummaryRSFLossFactorHelperText: "Based on a {{percentage}}% loss factor for real estate in {{place}}, you should search for spaces between {{min}} and {{max}} rentable square {{units}}.",
    spaceSummaryNIAFitFactorHelperText: "Based on a {{percentage}}% fit factor for real estate in {{place}}, you should search for spaces with {{amt}} NIA of space.",
    spaceSummaryNIATooltipText: "Net Internal Area (NIA) is the usable area within a building measured to the internal face of the perimeter walls at each floor level with certain specified areas excluded.",
    // SFTypeRadioInput
    sfRadioInputUsableAreaTooltipText: "This measurement includes all rooms, furniture and circulation space. It\u2019s sometimes referred to as carpetable area.",
    sfRadioInputRentableAreaTooltipText: "This is typically the Usable Square {{unitUppercase}} plus a portion of the building\u2019s common spaces. Though you can\u2019t use all of it, it\u2019s the square {{unit}} that you pay for when you rent.",
    sfRadioInputUsableSquareText: "Usable Square {{unitUppercase}}",
    sfRadioInputRentableSquareText: "Rentable Square {{unitUppercase}}",
    //floored plan request block
    flooredTitle: "Don't leave us just yet!",
    flooredSubTitle: "Redefine how clients explore space",
    flooredSubText: "See your Spacer results in a floor plan and tour them in 3d!",
    flooredParagraphText1: "Immersive experience allows tenants to imagine possibilities, experiment with space, and turn ideas into reality.",
    flooredParagraphText2: "Tangible, customised vision for every possible space",
    flooredVideoHeading: "Watch a sample experience",
    flooredFreeText: "What's more, it is free!",
    flooredIconText1: "Share available floor plans",
    flooredIconSubText1: "AutoCAD files for pdfs",
    flooredIconText2: "Allow processing time",
    flooredIconSubText2: "One to two weeks",
    flooredIconText3: "Receive sharable experience",
    flooredIconSubText3: "Custom 2D and 3D experiences",
    // MeasurementSystemRadioInput
    measurementSystemSqFeetText: "Sq feet",
    measurementSystemSqMetersText: "Sq meters",
    measurementSystemTsuboText: "Tsubo",
    // ProfileHero
    resultsProfileHeroAnnouncementTitle: "Your office is",
    resultsProfileHeroImgAlt: "3D floor plan showing the office layout of the {{profileName}} profile from Spacer by CBRE",
    // ProfileComparison
    profileCompModalTitle: "Change Your Profile?",
    profileCompModalText: "You will lose any unsaved changes on your current space program.",
    profileCompModalConfirmText: "Yes, change profile",
    profileCompModalCancelText: "No, keep current profile",
    profileCompNavbarCancelButtonText: "Cancel",
    profileCompNavbarUseButtonText: "Use This Profile",
    profileCompCompareTitle: "Compare Your Closest Profile Matches",
    // ProfileComparisonColumn
    profileCompColumnSelectedText: "Selected Profile",
    profileCompColumnSelectText: "Select",
    profileCompColumnRecommendedText: " (Recommended)",
    profileCompColumnImgAltText: "3D floor plan showing the office layout of the {{profileName}} profile from Spacer by CBRE",
    // Test Fit Form
    testFitTitle: "See your results as a floor\nplan and tour them in 3D",
    testFitSubtitle: "Want to get an idea of how your space program will look and\nfeel? We'll turn your results into a custom floor plan that you\ncan explore and share.",
    requestTestFitButtonText: "Request a custom floor plan",
    company: "Company Name",
    emptyCompanyError: "Please enter a company name",
    radioQ2yes: "Great! We'll follow up via email to request the file from you.",
    radioQ2no: "Not a problem, we'll follow up to discuss your options.",
    testFitFormTitle: "Request your Custom\nFloor Plan",
    testFitFormSubtitle: "Share a few pieces of information and we'll get\nstarted. Out team typically delivers finished floor\nplans in 3 business days.",
    testFitFormCompleted: "Your request has been submitted. One of\nour reps will follow up with you via email.",
    testFitFormYes: "yes",
    testFitFormNo: "no",
    testFitFormQ1: "Do you have a floor plate to work with?",
    testFitFormQ1No: "Not a problem! We can provide one for you to use.",
    testFitFormQ2: "Do you have a floor plate drawing (PDF, AutoCAD)?",
    testFitTermsConditions: "By checking this box you agree to participate in this beta program.\nYou'll receive one free floor plan in exchange for your participation\nin a brief survey about your experience.",
    testFitSubmitButtonText: "Submit floor plan request",
    backendError: "Oops! Something went wrong - please try again."
};


var $af197e51be5389e5$exports = {};
$af197e51be5389e5$exports = {
    // TermsOfService
    TermsTitle: "Terms Of Service",
    TermsIntroText: "This is a legal agreement between you and CBRE, Inc. (\u201CCBRE\u201D) regarding access to and use of the application known as Spacer\xae.  By using or accessing any of the information or services on this web-based application, you acknowledge that you have read, understood and agree to the terms and conditions set forth in this Terms of Use (the \u201CAgreement\u201D or \u201CTOU\u201D). The terms \u201Cyou\u201D, \u201Cyour\u201D or \u201CUser\u201D refers, collectively, to the person and any entity on whose behalf such person may be acting.",
    TermsLimitationsTitle: "Limitations.",
    TermsLimitationsA: "User understands and agrees that User\u2019s access to Spacer\xae is non-exclusive, non-sublicensable, non-transferable, freely revocable and can be suspended or terminated at any time for any reason by CBRE.",
    TermsLimitationsB: "User further understands and agrees that the grant of access to Spacer\xae shall not confer in User any rights of ownership in Spacer\xae or any related documentation (including in any new releases, modifications or enhancements), all of which shall be and remain the exclusive property of CBRE, including without limitation, the copyrights thereto, associated patents, design patents, trademarks, trade dress, trade secrets and other proprietary rights arising under applicable law or international conventions (collectively, \u201CProprietary Rights\u201D).  See Section 2 (Ownership) below. CBRE hereby expressly reserves all rights in Spacer\xae which are not expressly granted to User hereunder.",
    TermsLimitationsC: "Except as provided herein or as expressly authorized by CBRE to User in writing, User will not: (i) modify, translate, reverse engineer, decompile, disassemble, attempt to reconstruct, identify, or discover any source code, underlying ideas, underlying user interface techniques or algorithms, or create derivative works of or copy Spacer\xae; (ii) remove, alter, or cover any copyright or trademark notices or other proprietary rights notices contained in Spacer\xae; (iii) assign, sublicense, or otherwise transfer its access, use or other  rights or delegate its obligations under this Agreement; or (iv) without limiting any of the foregoing, use Spacer\xae for the purpose of building a competitive product or service, or for any purpose other than legitimate business purposes relating to User\u2019s business.",
    TermsLimitationsD: "User agrees to notify CBRE promptly in writing if any unauthorized use of Spacer\xae, or any possible infringement of Proprietary Rights, comes to its attention.",
    TermsLimitationsE: "At no time during or after the term of this Agreement shall User apply for any registration of any copyright, trademark or other designation which would affect the ownership of Proprietary Rights nor file any documents with any governmental authority to take any action which would affect the ownership of Proprietary Rights, including CBRE\u2019s ownership of Spacer\xae, the mark Spacer\xae, and other application components. Spacer\xae is a trademark and service mark of CBRE.",
    TermsLimitationsF: "User represents and agrees that User has the right to provide all materials posted on, or information used in connection with, Spacer\xae, and hereby grants to CBRE a non-exclusive, royalty-free, worldwide, irrevocable, perpetual right and license to use, reproduce, modify, distribute, create derivative works of, and display such materials and information in CBRE\u2019s discretion.  User acknowledges that User is responsible for whatever material and information is submitted by User, including its legality, reliability, appropriateness, originality, and copyright. The license grants by User to CBRE hereunder will survive any termination of User\u2019s use of Spacer\xae.  Any material and information submitted by User will be considered non-confidential and non-proprietary, and treated as such by CBRE, and may be used by CBRE in accordance with this Agreement without notice to User and without any liability to CBRE.",
    TermsOwnershipTitle: "Ownership.",
    TermsOwnershipText: "Spacer\xae, programming language, software and documentation and all other material or content made available on Spacer\xae or any improvements, modifications, derivative works, enhancements or changes to Spacer\xae and all copies thereof are proprietary to CBRE and title thereto remains solely in CBRE under all circumstances, including without limitation all rights to patents, copyrights, trademarks and trade secrets in Spacer\xae and the improvements, modifications, derivative works, and changes thereto. User understands that the foregoing includes trade secrets and information that is confidential and proprietary to CBRE and agrees to take all necessary actions to protect the confidentiality of such information. User shall not sell, transfer, publish, disclose, display or otherwise make available Spacer\xae or create or make available any improvements, modifications, enhancements, derivative works, or changes thereto or copies thereof to others.  Termination of this Agreement shall be in addition to and not in lieu of any remedies available to CBRE both in law and equity. The obligations hereunder shall survive the termination of this Agreement.",
    TermsTerminationTitle: "Termination; Effect of Termination; Remedies.",
    TermsTerminationA: "Without limiting any other remedies, CBRE may modify, limit, suspend, discontinue or terminate this Agreement and/or User\u2019s use of all or any part of Spacer\xae, with immediate effect, automatically, with or without notice and without recourse to the courts or other tribunals, for any reason or for no reason.  User agrees that CBRE is under no obligation to provide Spacer\xae and that CBRE shall not be liable to User or to any other party for any limitation, suspension, discontinuance, termination or modification of Spacer\xae.",
    TermsTerminationB: "User acknowledges that the obligations made hereunder to CBRE are of a unique and irreplaceable nature, the loss of which shall irreparably harm CBRE and which cannot be replaced by monetary damages alone so that CBRE shall be entitled to injunctive or other equitable relief (without the obligations of posting any bond or surety) in the event of any breach or anticipatory breach by User. User irrevocably waives all rights to seek injunctive or other equitable relief.",
    TermsDisclaimerTitle: "Disclaimers and Limitation of Liability.",
    TermsDisclaimerA: "Spacer\xae is provided to User \u201CAS IS\u201D and \u201CAS AVAILABLE\u201D with no warranties.  CBRE DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. CBRE DOES NOT WARRANT IN ANY WAY THAT Spacer\xae WILL MEET USER\u2019S REQUIREMENTS OR ANY PARTICULAR STANDARD. SOME STATES DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES, SO THE ABOVE EXCLUSION MAY NOT APPLY TO USER. In such event the liability of cbre will be limited to the maximum extent possible under applicable law. NO ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY CBRE, ITS AGENTS OR EMPLOYEES, SHALL CREATE A WARRANTY IN ANY WAY WHATSOEVER. NO WARRANTY IS GIVEN THAT Spacer\xae OR ANY INFORMATION PROVIDED TO USER ARE ERROR FREE OR THAT THE USE OF Spacer\xae WILL BE UNINTERRUPTED, UP-TO-DATE, COMPLETE OR FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS, AND NO WARRANTY IS GIVEN THAT ANY OF THE FOREGOING WILL BE CORRECTED. CBRE DOES NOT WARRANT OR MAKE ANY REPRESENTATIONS REGARDING THE USE OF, OR THE RESULTS FROM THE USE OF, Spacer\xae.  CBRE SHALL NOT BE LIABLE FOR ANY INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, PUNITIVE OR EXEMPLARY DAMAGES (INCLUDING WITHOUT LIMITATION DAMAGES FOR LOSS OF BUSINESS, LOSS OF PROFITS, LOST REVENUE, LOST SAVINGS, COMPUTER INTERRUPTION, GOODWILL, USE, DATA OR OTHER INTANGIBLE LOSSES), WHETHER BASED ON BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE), PRODUCT LIABILITY OR OTHERWISE, EVEN IF CBRE OR ITS REPRESENTATIVES HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES AND EVEN IF A REMEDY SET FORTH HEREIN IS FOUND TO HAVE FAILED OF ITS ESSENTIAL PURPOSE.",
    TermsDisclaimerB: "CBRE\u2019S TOTAL LIABILITY FOR DAMAGES FOR ANY CAUSE WHATSOEVER SHALL NOT EXCEED THE FEE PAID BY USER FOR Spacer\xae DURING THE TWELVE (12) MONTH PERIOD PRIOR TO THE EVENT THAT ALLEGEDLY CAUSED SUCH DAMAGE.  USER AGREES THAT ANY CAUSE OF ACTION ARISING OUT OF OR RELATED TO Spacer\xae OR OTHERWISE RELATED TO THIS AGREEMENT MUST COMMENCE WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES. OTHERWISE, SUCH CAUSE OF ACTION IS PERMANENTLY BARRED.",
    TermsDisclaimerC: "SOME JURISDICTIONS MAY NOT ALLOW THE LIMITATION ON LIABILITY OR EXCLUSIONS OF LIABILITY SET FORTH ABOVE, SO THE ABOVE LIMITATION OR EXCLUSION MAY NOT APPLY TO USER. In such event the liability of CBRE will be limited to the maximum extent possible under applicable law.  The waiver of warranty, exclusive remedies and limited liability set forth above are fundamental elements of the basis for this Agreement between CBRE and USER. CBRE would not be able to provide Spacer\xae on an economic basis, and would not have entered into this Agreement, without such limitations. These limitations shall survive any termination of this Agreement.",
    TermsIndemnificationTitle: "User Indemnification.",
    TermsIndemnificationText: "At CBRE\u2019s option and request, User shall, at its own expense, indemnify and hold harmless CBRE and its subsidiaries, affiliates, officers, employees, agents, co-branders, associations, and other partners harmless from and against any losses, costs, damages, liabilities, settlements and expenses (including without limitation costs and attorneys\u2019 fees), arising out of or related to any third-party claim, action or allegation related to or arising from: (a) any transaction or dispute between User and any third party; (b) facts or alleged facts that would constitute a breach of any of User\u2019s representations, warranties, or covenants under this Agreement or of any applicable law, rule or regulation, whether or not referenced herein; (c) any User materials, information or content submitted in or on Spacer\xae; (d) User\u2019s violation of any rights of any third party, (e) User\u2019s use or misuse of Spacer\xae; or (f) the negligence or willful misconduct of User.  CBRE shall have the right to exclusively direct and control its defense and hire counsel of its choice, at User\u2019s expense.",
    TermsGeneralTitle: "General.",
    TermsGeneralA: "<0>Entire Agreement/No Unintentional Waiver.</0> This Agreement constitutes the entire agreement between CBRE and User with respect to Spacer\xae and all subject matter of this Agreement, and supersedes all prior agreements between CBRE and User related to Spacer\xae if any. CBRE\u2019s failure to enforce any provision of this Agreement will not be construed as a waiver of any provision or right.",
    TermsGeneralB: "<0>Notices.</0> Notices to you shall be in writing and may be made via email or posting such notices on Spacer\xae or at www.cbre.com/spacer. You will provide notices to us via email to spacersupport@cbre.com, with a copy sent via certified U.S. mail to CBRE at 400 S. Hope Street, 25th Floor, Los Angeles, CA 90071, Attention:  General Counsel\u2019s Office. Notices will be deemed given one (1) business day after being sent via email (unless the sender receives a response indicating that the message was undeliverable) or three business days after being posted on the CBRE website (in the case of CBRE), whether or not received.",
    TermsGeneralC: "<0>Governing Law.</0> This Agreement shall be governed by and construed in accordance with the laws of the State of California without regard to the conflicts of laws provisions thereof.  CBRE and User hereby subject themselves exclusively to venues within the State of California.  The United Nations Convention on Contracts for the International Sale of Goods (1980) is hereby excluded in its entirety from application to this Agreement. User hereby agrees that Spacer\xae shall be deemed solely based in California and a passive service that does not give rise to personal jurisdiction over CBRE, either specific or general, in jurisdictions other than the State of California.",
    TermsGeneralD: "<0>Dispute Resolution.</0> Any dispute, claim or controversy arising out of or relating to this Agreement, or the breach, enforcement, interpretation or validity thereof, including the determination of the scope or applicability of arbitration with respect to this Agreement, shall be determined by arbitration.\xa0 The arbitration shall be administered by the Judicial Arbitration and Mediation Service (JAMS), and the arbitration shall be conducted with a single arbitrator.\xa0 Furthermore, User agrees that neither User nor CBRE will join any claim with the claim of any other person or entity in arbitration; that no claim will be resolved on a class-wide basis; and that neither User nor CBRE will assert any claim in a representative capacity on behalf of anyone else.\xa0 Notwithstanding the foregoing, User agrees that CBRE shall be allowed to apply for injunctive remedies (or an equivalent type of urgent legal relief) in any jurisdiction.\xa0 If User files an arbitration complaint against CBRE, CBRE agrees to pay for any portion of the initial filing fee that exceeds $250; after the initial filing fees, the parties will share the costs of arbitration equally.\xa0 User agrees not to commence or prosecute any action against CBRE other than by filing an arbitration complaint in accordance with this paragraph.\xa0 IMPORTANTLY, BY AGREEING TO BE BOUND BY THIS AGREEMENT, USER IS WAIVING ANY RIGHT USER HAS TO SEEK RELIEF IN A COURT OF LAW AND ANY RIGHT USER HAS TO A TRIAL BY JURY.",
    TermsGeneralE: "<0>Severability.</0> In the event that a portion of this Agreement is held unenforceable, the unenforceable portion shall be modified only to the extent necessary to make it enforceable, and the remainder of the provisions will remain in full force and effect.",
    TermsGeneralF: "<0>Assignment.</0> This Agreement may not be assigned by User without CBRE\u2019s prior written consent. Any attempted assignment without CBRE\u2019s consent shall be void. CBRE reserves the right to assign this Agreement to any third party. This Agreement and the rights and obligations of each of us under it will be binding on our respective successors and assigns.",
    TermsGeneralG: "<0>Modification.</0> CBRE may modify any of the terms and conditions contained in this Agreement, at any time and in CBRE\u2019s sole and exclusive discretion, by posting a change notice or a new agreement on Spacer\xae\u2019s site at the url www.cbre.com/spacer or by providing an alert or similar notification in Spacer\xae.  If any modification is unacceptable to User, User\u2019s only recourse is to terminate User\u2019s use of Spacer\xae.",
    TermsGeneralH: "<0>Conflicts.</0> In the event there is any conflict between the terms of this Agreement and any fully executed license agreement between User and CBRE with respect to Spacer\xae, the terms of such license agreement shall control with respect to such conflicting terms."
};


var $322c47945fe34a0b$exports = {};
$322c47945fe34a0b$exports = {
    // Quiz
    exitQuizButtonTitle: "Exit Quiz",
    // QuizProgressLabel
    progressLabelText: "complete",
    // QuizNavigationButton
    quizNavBackButtonShortenedText: "Previous",
    quizNavBackButtonFullLengthText: "Previous Question",
    quizNavNextButtonShortenedText: "Next",
    quizNavNextButtonFullLengthText: "Next Question",
    // QuizExitSlide
    quizExitSubtitle: "We are now using your answers to define the perfect workplace for your company.",
    quizExitImgAlt: "Illustration of two people high fiving on the Quiz page of Spacer by CBRE",
    // Question Unit Text (questionUnitMap.js)
    question1Text: "To start \u2014 How would you describe the purpose of your future office?",
    question2Text: "What about your organization do you think is most attractive to candidates?",
    question3Text: "What are the most important things you look for when hiring new team members?",
    question4Text: "How do you see the size of your organization changing in the next five years?",
    question5Text: "What\u2019s the work schedule like for your employees?",
    question6Text: "What do you think about individual desks?",
    question7Text: "While in the office, where will people spend their time working?",
    question8Text: "What will people wear in your office?",
    question9Text: "Where will your work happen?",
    question10Text: "What should your office atmosphere be like?",
    question11Text: "Besides space for work, what would you like to provide in your workspace?",
    question12Text: "Which of these best describes you?",
    // Quiz Answers (questionUnitMap.js)
    pickOnePlaceholder: "pick one...",
    selectFromListPlaceholder: "select from list...",
    firstResponseTooltipText: "Select your first response",
    locatedSomewhereElseLabel: "I\u2019m currently located somewhere else.",
    q1AnswerText1: "We think of our office first as",
    q1AnswerText2: "second as",
    q1AnswerText3: "and third as",
    q1Option1Text: "a second home for our people",
    q1Option2Text: "a driver of an organizational change",
    q1Option3Text: "a place for focus work",
    q1Option4Text: "an incubator for the next big idea",
    q1Option5Text: "a tool to acquire great talent",
    q1Option6Text: "a showcase for our brand",
    q1Option7Text: "a space for growth and learning",
    q1Option8Text: "a place for people to meet and come together",
    q1Option9Text: "a necessary cost we try to minimize",
    q2AnswerText1: "People join us first because of our",
    q2AnswerText2: "second because of our",
    q2AnswerText3: "and third because of our",
    q2Option1Text: "company culture",
    q2Option2Text: "competitive salaries",
    q2Option3Text: "company reputation",
    q2Option4Text: "benefits and perks",
    q2Option5Text: "flexible work schedules",
    q2Option6Text: "people and leadership",
    q2Option7Text: "office environment",
    q2Option8Text: "purpose and mission",
    q3AnswerText1: "We hire employees first for",
    q3AnswerText2: "second for",
    q3AnswerText3: "and third for",
    q3Option1Text: "skills",
    q3Option2Text: "experience",
    q3Option3Text: "cultural fit",
    q3Option4Text: "credentials",
    q3Option5Text: "relationships",
    q3Option6Text: "curiosity / inquisitiveness",
    q4AnswerText: "We will",
    q4Option1Text: "grow slightly each year",
    q4Option2Text: "grow significantly each year",
    q4Option3Text: "stay about the same",
    q4Option4Text: "shrink slightly each year",
    q4Option5Text: "hard to say - it\u2019s unpredictable",
    q5AnswerText: "We\u2019re usually working",
    q5Option1Text: "from 9-5",
    q5Option2Text: "from morning until...late",
    q5Option3Text: "whenever they want, as long as it\u2019s a certain amount",
    q5Option4Text: "whenever they want, as often as they want",
    q6AnswerText: "We think",
    q6Option1Text: "everyone should have their own",
    q6Option2Text: "it can be better to share unassigned desks",
    q7Option1Text: "Always from an individual desk",
    q7Option2Text: "Primarily from an individual desk with some meetings or other activities",
    q7Option3Text: "Even split between a desk and somewhere else in the office",
    q7Option4Text: "Primarily moving from space to space with occasional touchdowns at desks",
    q7Option5Text: "Always moving from space to space",
    q8Option1Text: "Business professional",
    q8Option2Text: "Mostly professional except for special occasions",
    q8Option3Text: "Business casual, with some days dressier and some days not",
    q8Option4Text: "Mostly casual except for special occasions",
    q8Option5Text: "Casual",
    q9Option1Text: "Always from the office",
    q9Option2Text: "Mostly from the office",
    q9Option3Text: "Split our time between the office and remote",
    q9Option4Text: "Mostly work remote",
    q9Option5Text: "Always work remote",
    q10Option1Text: "Dynamic and energetic",
    q10Option2Text: "Energetic, with pockets of quiet",
    q10Option3Text: "It depends - a mix of both",
    q10Option4Text: "Quiet, with some dynamic times",
    q10Option5Text: "Quiet and tranquil",
    q11Option1Text: "Just the basics, enough to keep people going",
    q11Option2Text: "The basics plus a few upgrades",
    q11Option3Text: "The basics and a place where people can gather socially",
    q11Option4Text: "Something really nice, a destination within the office",
    q11Option5Text: "Something cool and differentiating - the first thing you show a visitor",
    q12AnswerText: "I\u2019m",
    q12OptionClientText: "an existing CBRE client",
    q12OptionProfessionalText: "a CBRE professional",
    q12OptionLeadText: "someone else",
    q13AnswerText1: "We will have",
    q13AnswerText2: "employees in our office.",
    q13AnswerHelperText: "*Hint: This is usually the midpoint of your lease or about 2-5 years from now.",
    q14AnswerText1: "We will spend",
    q14AnswerText2: "of our time working in teams.",
    q15AnswerText1: "On average, we plan to spend",
    q15AnswerText2: "days per week in the office.",
    q16AnswerText1: "Our office will be in the city of",
    q16AnswerText2: ".",
    q17AnswerText1: "We work primarily in the",
    q17AnswerText2: "sector.",
    q18AnswerText1: "I\u2019m currently located in",
    q18AnswerText2: ".",
    q19AnswerText1: "We imagine our office density (SF per person) to be",
    q19AnswerText2: "in the future.",
    // Quiz Responses (questionUnitMap.js)
    q1ResponseText: "We\u2019ll define an office that matches your vision.",
    q2ResponseText: "Attractive mix!",
    q3ResponseText: "Sounds nice - where do we apply?",
    q4ResponseText: "Great! We will make sure the office fits.",
    q5Response1Text: "Sounds good!",
    q5Response2Text: "We tend to work overtime, too.",
    q5Response3Text: "Sounds great!",
    q5Response4Text: "Sounds awesome!",
    q6Response1Text: "We\u2019ll define a space that prioritizes personal space.",
    q6Response2Text: "We\u2019ll define a space that\u2019s flexible.",
    q12ResponseLeadText: "You came to the right place.",
    q12ResponseClientText: "Perfect!",
    q12ResponseProfessionalText: "Thanks!",
    // Industry Codes (industryCodes.js)
    animalProd: "Animal production and aquaculture",
    forestry: "Forestry and logging",
    fishingHunting: "Fishing, hunting and trapping",
    agForestSupport: "Agriculture and forestry support activities",
    oilGas: "Oil and gas extraction",
    energy: "Energy (Gas, Oil, etc.)",
    mining: "Mining, except oil and gas",
    supportMining: "Support activities for mining",
    utilities: "Utilities",
    buildingConstruct: "Construction of buildings",
    heavyCivilConstruct: "Heavy and civil engineering construction",
    specialtyContract: "Specialty trade contractors",
    foodManufac: "Food Manufacturing",
    beverageTobaccoManufac: "Beverage and tobacco product manufacturing",
    textile: "Textile mills",
    textileProduct: "Textile product mills",
    apparelManufac: "Apparel manufacturing",
    leatherManufac: "Leather and allied product manufacturing",
    woodManufac: "Wood product manufacturing",
    paperManufac: "Paper manufacturing",
    printingSupport: "Printing and related support activities",
    printingReproduc: "Printing/Reproductions",
    petroleumCoal: "Petroleum and coal products manufacturing",
    chemicalManufac: "Chemical manufacturing",
    chemicals: "Chemicals",
    pharma: "Pharmaceuticals",
    cleaningManufac: "Cleaning Manufacturing",
    plasticsRubberManufac: "Plastics and rubber products manufacturing",
    nonmetallicManufac: "Nonmetallic mineral product manufacturing",
    primaryMetalManufac: "Primary metal manufacturing",
    fabricatedMetalManufac: "Fabricated metal product manufacturing",
    machineryManufac: "Machinery manufacturing",
    manufac: "Manufacturing",
    computerElectronicManufac: "Computer and electronic product manufacturing",
    electricalApplianceManufac: "Electrical equipment and appliance mfg.",
    transportEquipManufac: "Transportation equipment manufacturing",
    aerospaceDefense: "Aerospace/Defense",
    furnitureManufac: "Furniture and related product manufacturing",
    miscManufac: "Miscellaneous manufacturing",
    merchantWholesaleDurable: "Merchant wholesalers, durable goods",
    merchantWholesaleNondurable: "Merchant wholesalers, nondurable goods",
    electronicMarket: "Electronic markets and agents and brokers",
    motorVehiclePartsDealers: "Motor vehicle and parts dealers",
    furnitureFurnishingStores: "Furniture and home furnishings stores",
    electronicApplianceStores: "Electronics and appliance stores",
    electronics: "Electronics",
    buildingGardenSupplyStores: "Building material and garden supply stores",
    foodBeverageStores: "Food and beverage stores",
    groceryStores: "Grocery Stores",
    beerWineLiquorStores: "Beer, Wine, and Liquor Stores",
    healthCareStores: "Health and personal care stores",
    gasStations: "Gasoline stations",
    clothingAccessoriesStores: "Clothing and clothing accessories stores",
    clothingTextiles: "Clothing/Textiles",
    jewelryFurs: "Jewelry & Furs",
    sportsHobbyMusicBookStores: "Sports, hobby, music instrument, book stores",
    genMerchandiseStores: "General merchandise stores",
    miscStoreRetailers: "Miscellaneous store retailers",
    officeProducts: "Office Products",
    retailSales: "Retail Sales",
    nonstoreRetails: "Nonstore retailers",
    airTransport: "Air transportation",
    travelRelated: "Travel Related (Airlines, Agents, Mass Transit)",
    railTransport: "Rail transportation",
    waterTransport: "Water transportation",
    truckTransport: "Truck transportation",
    transitTransport: "Transit and ground passenger transportation",
    pipelineTransport: "Pipeline transportation",
    scenicTransport: "Scenic and sightseeing transportation",
    supportTransport: "Support activities for transportation",
    postalService: "Postal service",
    courierMessenger: "Couriers and messengers",
    shippingDelivery: "Shipping/Delivery",
    warehousingStorage: "Warehousing and storage",
    warehouseDistrib: "Warehouse/Distribution",
    publishingNoInternet: "Publishing industries, except Internet",
    publishing: "Publishing",
    motionPicSoundRecordingIndustries: "Motion picture and sound recording industries",
    entertainment: "Entertainment (Film, TV, Music, etc.)",
    infoServicesMarketResearch: "Information Services/Market Research",
    broadcastingNoInternet: "Broadcasting, except Internet",
    telecom: "Telecommunications",
    tech: "Technology",
    dataProcessingHostingServices: "Data processing, hosting and related services",
    otherInfoServices: "Other information services",
    financeInsurance: "Finance and Insurance",
    monetaryAuthorities: "Monetary authorities-central bank",
    creditIntermediation: "Credit intermediation and related activities",
    banking: "Banking",
    securitiesContractsInvestments: "Securities, commodity contracts, investments",
    financialServicesNoBanking: "Financial Services (Non-banking)",
    insuranceCarriersRelated: "Insurance carriers and related activities",
    insurance: "Insurance",
    fundsTrustsFinancialVehicles: "Funds, trusts, and other financial vehicles",
    realEstate: "Real Estate",
    rentalLeasingServices: "Rental and leasing services",
    automotive: "Automotive",
    consumerGoods: "Consumer Goods",
    lessorsNonfinancialIntangible: "Lessors of nonfinancial intangible assets",
    professionalTechnicalServices: "Professional and technical services",
    legalServices: "Legal Services",
    accounting: "Accounting",
    architectureEngineering: "Architecture/Engineering",
    specializedDesignServices: "Specialized Design Services",
    compRelatedServices: "Computer Related Services",
    mgmtConsulting: "Management Consulting",
    scientificResearch: "Scientific Research",
    adsMarketingPR: "Advertising/Marketing/Public Relations",
    otherProfSciTechServices: "Other Professional, Scientific, and Technical Services",
    companyEnterpriseMgmt: "Management of companies and enterprises",
    adminSupportServices: "Administrative and support services",
    employmentAgencyRecruiters: "Employment Agency/Recruiters",
    securityPrivateInvestigation: "Security/Private Investigation",
    wasteMgmtRemediationServices: "Waste management and remediation services",
    educationServices: "Educational services",
    education: "Education",
    ambulatoryHealthCareServices: "Ambulatory health care services",
    healthCareRelated: "Health Care Related",
    hospitals: "Hospitals",
    nursingResidentialCareFacilities: "Nursing and residential care facilities",
    socialAssistance: "Social assistance",
    performingArtsSpectatorSports: "Performing arts and spectator sports",
    museumsHistoricalSitesZoosParks: "Museums, historical sites, zoos, and parks",
    fineArtsGalleriesMuseums: "Fine Arts (Galleries, Museums)",
    amusementsGamblingRec: "Amusements, gambling, and recreation",
    accommodation: "Accommodation",
    foodDrinkingServices: "Food services and drinking places",
    restaurantHotel: "Restaurant/Hotel",
    repairMaintenance: "Repair and maintenance",
    industrialProductsHeavy: "Industrial Products (Heavy Industry)",
    personalLaundryServices: "Personal and laundry services",
    membershipAssocOrgs: "Membership associations and organizations",
    nonprofit: "Non-profit",
    privateHouseholds: "Private households",
    execLegisGenGvt: "Executive, legislative and general government",
    gvt: "Government",
    justicePublicOrderSafetyActivities: "Justice, public order, and safety activities",
    hrAdminPrograms: "Administration of human resource programs",
    environmentAdminPrograms: "Administration of environmental programs",
    environmental: "Environmental",
    communityHousingProgramAdmin: "Community and housing program administration",
    econProgramAdmin: "Administration of economic programs",
    spaceResearchTech: "Space research and technology",
    natlSecurityIntlAffairs: "National security and international affairs"
};


var $e3606b3900259f73$exports = {};
$e3606b3900259f73$exports = {
    // AboutPageHero
    aboutPageHeroImgAlt: "Illustration of people moving into an office on the About page of Spacer by CBRE",
    aboutPageHeroTitle: "What can Spacer do for you?",
    // AboutPageContent
    aboutPageContentEndSectionTitle: "Ready to get started?",
    aboutPageProgramPreviewImgAlt: "Preview of a results page space program from the homepage of Spacer by CBRE",
    aboutPageVideoTitle: "How it works",
    // About Page Content (aboutPageContent.js)
    aboutPageContent1Title: "Define the perfect office",
    aboutPageContent1Text: "The perfect office space can help you hire competitive talent, keep your employees healthy, reduce operating costs, or create conditions for the next big idea. Spacer is the perfect place to begin any real estate decision because it helps you prioritize your goals as an organization, and see space recommendations based on those goals.\n Spacer was created by taking the expertise of CBRE\u2019s Workplace team, a group with over twenty years of experience helping companies plan the perfect office, and combining it with a free, internet-based technology that is available to anyone.",
    aboutPageContent1ImgAlt: "Illustration of people talking on the About page of Spacer by CBRE",
    aboutPageSpacerSupportLink: "spacersupport@cbre.com",
    aboutPageContent2Title: "Spacer is easy to use:",
    aboutPageContent2List1: "Start by answering a 17-question quiz about your organizational goals and values. These answers will inform the office profile we categorize you as.",
    aboutPageContent2List2: "Receive a recommended list of space types and sizes that meet your unique needs, also known as a space program.",
    aboutPageContent2List3: "Visualize a space similar to yours in 2D and 3D with Floored Plans.",
    aboutPageContent2List4: "Save your program to use as you search for the perfect office on the market.",
    aboutPageContent2List5: "Let a CBRE professional hunt down an office space that matches your program, a service that is free of charge!",
    aboutPageContent2Text: "For more questions about how Spacer can jump start your office search process, contact us at ",
    aboutPageContent2ImgAlt: "Illustration of a girl working at a desk on the About page of Spacer by CBRE"
};


var $fd75154848e061f9$exports = {};
$fd75154848e061f9$exports = {
    referralStep: "Step {{step}} of 4",
    forgotReferralLink: "Forgot your referral link?",
    howReferralLinksWorkTitle: "How Referral Links Work",
    enterYourInformation: "Enter your Information",
    confirmYourInformation: "Confirm your Information",
    referralLinkStep1: "To create a referral link we\u2019ll need:",
    referralLinkReq1: "- Your name",
    referralLinkReq2: "- Your CBRE-issued email address",
    referralLinkStep2: "After a prospect completes the quiz using your referral link, we\u2019ll send a copy of their results to your inbox.",
    next: "Next",
    firstName: "First Name",
    lastName: "Last Name",
    emptyNameError: "Please enter a name",
    email: "Your CBRE email address",
    emptyEmailError: "Please enter a CBRE email",
    emailTakenError: "That email address is already linked to {{takenLink}}",
    emailExample: "ex: jane.smith@cbre.com",
    editReferralInfo: "Edit name and email information entered",
    noLaterChanges: "You won\u2019t be able to change this later.",
    somethingWrong: "Oops, something went wrong on our end. Please try again.",
    contentLoading: "Content is Loading",
    linkReady: "Your Link is Ready",
    storeLinkInstructions: "Store this link in a safe place, you\u2019ll want to use it whenever you share Spacer with clients. We\u2019ve also emailed a copy of this link to the address that you provided.",
    yourLink: "Your referral link",
    copyLink: "Copy referral link",
    copiedLink: "Copied to clipboard",
    linkNeverExpires: "Reminder: this link will never expire.",
    linkFound: "We Found your Link",
    emailNotAssociated: "We couldn\u2019t find a referral link associated with that email address.",
    createLink: "Create one?"
};


var $1865ba2a1eb59826$exports = {};
$1865ba2a1eb59826$exports = {
    blogHomeTitle: "Office Planning Insights",
    // blog tags
    blogTagAllArticles: "All Articles",
    blogTagSizeAndFit: "Size & Fit",
    blogTagOfficeCulture: "Office Culture",
    blogTagSpaceAndDesign: "Space & Design",
    blogTagWorkplaceTrends: "Workplace Trends"
};


var $f6de330988d28a32$exports = {};
$f6de330988d28a32$exports = {
    title: "Why Defining Your Perfect Office Matters",
    pageTitle: "Why Defining Your Perfect Office Matters \u2014 Spacer by CBRE",
    metaTagText: "Having the appropriate office space can impact employee satisfaction, productivity, growth, culture, and company success. Learn more here.",
    preview: `
    If you have moved offices before, then you know just how challenging it can be.
    A move is one reason (but not the only reason) you may need help understanding
    how much space your company needs. Perhaps you are looking to reduce your office
    footprint or open up an office in a new location. Any real estate change you
    make will require you to answer this one question: how much space do you
    need? We realize that question is not an easy one to answer, and we want to
    help.
  `,
    content: `
    <p>
    If you have moved offices before, then you know just how challenging it can be.
    A move is one reason (but not the only reason) you may need help understanding
    how much space your company needs. Perhaps you are looking to reduce your office
    footprint or open up an office in a new location. Any real estate change you
    make will require you to answer this one question: <em>how much space do you
    need?</em> We realize that question is not an easy one to answer, and we want to
    help.
    </p>
    <p>
    If you\u{2019}ve never thought about space before, then your instinct might be to think
    about your apartment. You might know that your studio is about 500 square feet,
    and you know about how much furniture can fit in there. You have probably
    learned that there is a difference between having enough space to get by and
    having enough space to support the lifestyle you want. Once your significant
    other moves in, the amount of space you need changes because the people and
    activities in the space have also changed.
    </p>
    <p>
    Your office can be thought of the same way. You might be able to fit 50 people
    in 5,000 square feet, but it doesn\u{2019}t mean it will meet your needs or feel like a
    place you want to work. New research now shows that the workplace is more than
    just a place to keep desks. The environment can have a big impact on your
    employee\u{2019}s satisfaction, which impacts productivity and health. We know that
    successful companies have great culture, which we think about as a combination
    of two things: 1. The policies that dictate behavior in the office, and 2. The
    environment the people work in. With that in mind, companies should be paying
    attention to the kind of office environments they want to create for their
    employees.
    </p>
    <p>
    Which leads us back to square footage. You see, every decision you make about
    your office environment has a direct impact on how much space you need to
    support that decision. For example, if you want to create an environment that
    promotes health and wellness, you might decide to create an onsite gym facility
    or provide healthy snacks in the kitchen. By adding a gym and room for snacks,
    you\u{2019}ve just increased your square footage. if you want to create an environment
    that is efficient, you might decide to implement a seat sharing model and reduce
    square footage while increasing utilization. Every decision will impact the size
    in a big or small way.
    </p>
    <p>
    Now you might be thinking, I know the kind of office environment I want, but I
    don\u{2019}t know how those decisions will affect the amount of space I need. It is
    here that we arrive at the goal of Spacer. In the past, in order to get help
    with your office, you would have had to hire a Workplace Strategist - an expert
    in the area of offices - to do this analysis for you. The process involves
    visioning sessions, utilization studies, interviews, surveys, and focus groups
    in order to understand the needs of your company and to make a customized
    recommendation about the space. It can take months and is usually only
    affordable for large organizations.
    </p>
    <p>
    Don\u{2019}t get us wrong, Workplace Strategy is an incredibly useful service,
    especially for complex companies. It has just been inaccessible to many
    companies because of time and cost. That is, until Spacer came along.
    </p>
    <p>
    We took the process perfected by CBRE\u{2019}s Workplace Strategy team and packaged it
    into an online tool that is free for anyone. Instead of being interviewed over
    many months, you simply answer a series of targeted questions online. We then
    analyze your responses and assign you a profile. With the profile, you have the
    ability to see an exact square footage recommendation, along with a list of
    every space type you should include in your office. This space program includes
    sizes and quantities of every desk, office, and conference room.
    </p>
    <p>
    With this program, you can hand it over to your broker and start searching for
    the perfect office space that will fit your requirements. Architects use
    programs to build out offices as well, so you can give this to your design team
    for a quicker turnaround once you move in.
    </p>
    <p>
    In the end, you spent 15 minutes defining an office environment that meets your
    goals and shortened your office search process by weeks. Impressive. Have you
    considered asking for a raise?
    </p>
    <p>
    Learn more about how CBRE is helping companies define office space with Spacer
    by emailing us at <a href="mailto:spacersupport@cbre.com">spacersupport@cbre.com</a>.
    </p>
  `
};


var $db833de2608468fa$exports = {};
$db833de2608468fa$exports = {
    title: "How Does Spacer Work?",
    pageTitle: "How Does Spacer Work? \u2014 Spacer by CBRE",
    metaTagText: "Use this free tool to generate custom recommendations and start planning your new office space. Learn more here.",
    preview: `
    The workplace is the home of your organization. People meet, focus, socialize,
    strategize, sell, think, make, and do at the office. It is where your
    organization happens. It should accommodate you as you grow and as your work
    changes. It should be convenient. It should reflect your brand and the values
    that make your organization special.
  `,
    content: `
    <h2>The Philosophy</h2>
    <p>
    The workplace is the home of your organization. People meet, focus, socialize,
    strategize, sell, think, make, and do at the office. It is where your
    organization happens. It should accommodate you as you grow and as your work
    changes. It should be convenient. It should reflect your brand and the values
    that make your organization special.
    </p>
    <p>
    In the work-anywhere age, having an office asserts that being near is better
    than being far, and it must make good on that idea by providing real advantage
    to the people who use it.
    </p>
    <p>
    <strong>We know that planning a good workplace is not easy.</strong> That\u{2019}s why
    we created Spacer.
    </p>
    <p>
    Spacer starts with a solid understanding of your organization, through a
    16-question quiz we call Profiler. We get to know you with a dialogue aimed at
    defining your priorities, your values, and the way you work. Think of it like a
    personality quiz for your workplace. This tool doesn\u{2019}t base its logic on
    industry - there is no single \u{201C}tech\u{201D} or \u{201C}banking\u{201D} workplace \u{2013} and you may find
    that you have a different profile than companies that are, in other ways, your
    peers. That is how it is supposed to be. We want to uncover the unique aspects
    of your organization and design your office around them.
    </p>
    <p>
    With a few more details, we are able to convert your profile into a list of the
    spaces you need in your future office. We provide spaces for the jobs people
    will be doing, the events and rituals that make your office special, and the
    diverse needs and preferences of your people. We also take care of all the
    particulars, like circulation, sizing, seat ratios, and modularity - meaning
    this is an architect-ready space program. This is YOUR space program. After
    selecting a building, we hope that it becomes your office.
    </p>
    <p>
    Ratios and metrics reflected in Spacer are the result of years of workplace
    consulting experience. Each profile is a composite of real organizations and
    workplaces, and the details were checked against industry guidelines and market
    knowledge sourced from the wide reach of CBRE. Our algorithms are built for the
    long haul and designed to be flexible. We can even work together to make your
    profile even more tailored and exclusively yours.
    </p>
    <p>
    Spacer is a great starting point for any workplace discussion, but if you need
    more customization, or help with the tool, please get in touch at <a
    href="mailto:spacersupport@cbre.com">spacersupport@cbre.com</a>. We would be
    happy to help.
    </p>
  `
};


var $3438254d7f900ffe$exports = {};
$3438254d7f900ffe$exports = {
    title: "What\u2019s the Difference Between Rentable and Usable Square Feet?",
    pageTitle: "What\u2019s the Difference Between Rentable and Usable Square Feet? \u2014 Spacer by CBRE",
    metaTagText: "As a business, it is important to know the difference between rentable vs usable square feet. Learn more here",
    preview: `
    A foot is a foot, right?
    It is not so simple in commercial real estate. Several \u{201C}players\u{201D} in the real
    estate market have a stake in how space is measured. Architects and interior
    designs need to know how much space there is available for placing furniture.
    Engineers and regulatory bodies need to know how much space there is for code
    compliance and construction. And Landlords need to know how much space there is
    so they can charge rent for it.
  `,
    content: `
    <h2>A foot is a foot, right? </h2>
    <p>
    It is not so simple in commercial real estate. Several \u{201C}players\u{201D} in the real
    estate market have a stake in how space is measured. Architects and interior
    designs need to know how much space there is available for placing furniture.
    Engineers and regulatory bodies need to know how much space there is for code
    compliance and construction. And Landlords need to know how much space there is
    so they can charge rent for it.
    </p>
    <p>
    Measurement conventions have emerged to fulfill these different needs.
    </p>
    <h2>A few of them are easy:</h2>
    <p>
    SF \u{2013} a square foot, 12 inches by 12 inches.
    </p>
    <p>
    NSF \u{2013} Net Square Feet, the amount of space a thing itself occupies. A chair with
    a 2x2 footprint would be a 4 NSF item.
    </p>
    <p>
    Not too bad.
    </p>
    <p>
    Now, the trickier ones:
    </p>
    <h2>USF \u{2013} Usable Square Feet</h2>
    <p>
    Each thing in an interior space has to have some area around it \u{2013} think
    hallways, door swings, space for chairs to move away from a desk (and for you to
    spin around in them) \u{2013} this space is called circulation. When you add up the NSF
    all of the things in an area (all of the desks, rooms, file cabinets, etc.) and
    all of the circulation that is needed to accommodate those items in an actual
    layout, you end up with USF. In simplest terms, USF = NSF + Circulation.
    </p>
    <p>
    USF is used in interior design and space planning, since it is a direct measure
    for how much space an architect or space planner has to design within. Although
    not a technical term, you might also hear the USF referred to as Carpetable
    Area, since this is the amount of space you could apply carpet to. For example,
    you couldn\u{2019}t carpet the area that is occupied by a column or window sill, so
    even though you pay for this space in your rent, USF does not include these
    non-carpetable areas.
    </p>
    <h2>RSF \u{2013} Rentable Square Feet</h2>
    <p>
    In office buildings, there are many areas that you use but aren\u{2019}t necessarily
    \u{201C}yours\u{201D}. The building lobby, elevator lobbies, and fitness center in the
    basement, for example, aren\u{2019}t a part of your office suite, but the landlord
    still wants you to pay for your portion of those spaces. In fact, when you rent
    space, you are paying for more \u{201C}square feet\u{201D} than just the USF you will be able
    to occupy on your floors. Rentable Square Feet is the metric that you pay for.
    It includes USF and a portion of building-common spaces. In some cities, RSF is
    just an inflated USF number, multiplied by a number called the building \u{201C}load
    factor.\u{201D} In a case where USF time 1.15 = RSF, the load factor would be 15%. In
    other cities, notably New York City, the calculation is slightly different, and
    market-driven. This means the RSF you pay for could shrink or expand in the long
    run, even if nothing in the actual building changes!
    </p>
    <p>
    At any rate, a Real Estate Professional can help you navigate the peculiarities
    of your market (we haven\u{2019}t even mentioned International standards!). All you
    need to know is RSF is what you pay and search for in the market. USF is some
    portion of that and most helpful for your architect.
    </p>
    <p>
    Got more questions about your office space? Email us at <a
    href="mailto:spacersupport@cbre.com">spacersupport@cbre.com</a>.
    </p>
  `
};


var $b9f824257026abb6$exports = {};
$b9f824257026abb6$exports = {
    // LandingPageHero
    landingPageHeroTitle: "Let us help you plan for the workplace of the future and find the right amount of space for your next office.",
    landingPageHeroSubtitle: "The world of workplace is changing due to the recent pandemic \u2013 receive your custom space recommendation using our free tool.",
    landingPageHeroImgAlt: "Preview of a results page space programme from the homepage of Spacer by CBRE",
    landingPageImage: "/png/homepage-results-page-in-browser-spacer-by-cbre.png",
    // LandingPageContent
    landingPageContentTitle: "How it works",
    // StepsSummary
    stepsSummarySubtitle1: "Step 1 \u2014",
    stepsSummaryTitle1: "Tell us about your company",
    stepsSummaryText1: "Help us to get to know your goals and objectives as a company so we can make recommendations specific to you.",
    stepsSummaryImgAlt1: "Illustration of people standing on a giant laptop on the Home page of Spacer by CBRE",
    stepsSummarySubtitle2: "Step 2 \u2014",
    stepsSummaryTitle2: "Get your results",
    stepsSummaryText2: "Based on your responses, you will receive a recommended office size and a list of individual space types with quantities of each. You can even view example floor plans.",
    stepsSummaryImgAlt2: "Illustration of a neighborhood block on the Home page of Spacer by CBRE",
    stepsSummarySubtitle3: "Step 3 \u2014",
    stepsSummaryTitle3: "Find your perfect office",
    stepsSummaryText3: "Save your results to refer back to during the office search, or contact the Spacer team to connect with one of our leasing professionals who can assist in finding your perfect office.",
    stepsSummaryImgAlt3: "Illustration of a girl working at a desk on the Home page of Spacer by CBRE",
    // LandingPageSecondaryHero
    landingPageSecondaryHeroImgAlt: "Illustration of people building space recommendations on the Home page of Spacer by CBRE",
    landingPageSecondaryHeroTitle: "Tell us a little about your company. We\u2019ll tell you how much office space you need."
};


var $1c35b94398f71352$exports = {};
$1c35b94398f71352$exports = {
    // Navbar
    spacerLogoAlt: "Spacer by CBRE logo",
    linkToAboutPageText: "About",
    linkToBlogPageText: "Insights",
    // TakeOfficeSpaceQuizButton
    sizeMyOfficeButtonDefaultLinkText: "Take office space quiz",
    flooredPlanRequestLinkText: "Request a Plan",
    // Footer
    footerCBRELogoAlt: "CBRE logo for Spacer by CBRE",
    footerFacebookIconAlt: "Facebook\u2019s social icon for Spacer by CBRE",
    footerTwitterIconAlt: "Twitter\u2019s social icon for Spacer by CBRE",
    footerLinkedinIconAlt: "Linkedin\u2019s social icon for Spacer by CBRE",
    footerHeaderQuestionsText: "Questions?",
    footerHeaderAboutText: "Resources",
    footerHeaderMoreText: "More",
    footerLinkWhatIsSpacerText: "About",
    footerLinkBlogText: "Insights",
    footerLinkWorkplaceText: "Who is CBRE Workplace?",
    footerLinkTermsText: "Terms of Service",
    footerLinkPrivacyText: "Privacy Policy",
    footerLinkedinLink: "https://www.linkedin.com/showcase/cbre-workplace-strategy/",
    footerWorkplaceLink: "http://www.cbre.us/real-estate-services/occupier/workplace",
    footerPrivacyLink: "https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy",
    // Contact (contact.js)
    spacerSupportEmail: "spacersupport@cbre.com",
    // ErrorPage
    errorOopsText: "Oops!",
    error404Text: "We can\u2019t find the page you\u2019re looking for.",
    error500Text: "Something went wrong on our end.",
    errorText: "Error",
    errorReturnText: "Return to Spacer",
    errorAltText: "Illustration of a spilled coffee cup for Spacer by CBRE",
    // Measurement Units (units.js)
    SF: "SF",
    SM: "SM",
    USF: "USF",
    USM: "USM",
    RSF: "RSF",
    RSM: "RSM",
    NSF: "NSF",
    NSM: "NSM",
    NIA: "NIA",
    foot: "foot",
    feet: "feet",
    footage: "footage",
    "sqft.": "sqft.",
    meter: "meter",
    meters: "meters",
    "sqm.": "sqm.",
    Tsubo: "tsubo",
    // SF Types Adjectives (calculator.js)
    Usable: "Usable",
    Rentable: "Rentable",
    Net: "Net"
};


var $4def54bfc9087558$exports = {};
$4def54bfc9087558$exports = {
    // ResultsHeader
    resultsHeaderExportPDFButtonText: "Export PDF",
    resultsHeaderSendButtonText: "Send results",
    resultsHeaderClipboardBoxDescription: "Anyone with a link can view and edit results",
    resultsHeaderContactButtonText: "Connect with an adviser",
    // EmailWallSection
    emailWallTitle: "There\u2019s more waiting for you",
    emailWallSubtitle: "Enter your name and email below to view a complete space recommendation and customise your results.",
    emailWallFirstNamePlaceholder: "First Name",
    emailWallLastNamePlaceholder: "Last Name",
    emailWallEmailPlaceholder: "Your email",
    emailWallCBREEmailPlaceholder: "Your CBRE professional\u2019s email (optional)",
    emailWallLeasingProfessionalPlaceholder: "Your CBRE leasing professional",
    emailWallConnectMeText: "Connect me with a personal real estate adviser. No email newsletters or spam, we promise!",
    emailWallContactNoticeText: "The Spacer team might contact you to help you get the most out of your programme. No spam, we promise!",
    emailWallResultsButtonText: "View complete results",
    emailWallImgAltText: "Preview of a results page space programme from the email wall of Spacer by CBRE.",
    emailWallFirstNameInvalid: "Please enter your first name.",
    emailWallLastNameInvalid: "Please enter your last name.",
    emailWallEmailInvalid: "Please enter a valid email address.",
    // CopyToClipboardBox
    clipboardBoxCopyText: "Copy",
    clipboardBoxCopiedText: "Copied",
    // FormModal
    formModalFindSpaceHeader: "Start the office search",
    formModalFindSpaceBody: "Spacer is a quick and easy tool for workplace analysis, but if you need something more customised, let CBRE Workplace help. Fill out this form, and a Workplace professional will reach out to you within 48 hours to schedule a time to speak.",
    formModalFindSpaceSuccessMessage: "Your request was sent.",
    // SuccessModal
    successModalTitle: "Success!",
    // ContactForm
    contactFormFirstNameLabel: "First Name",
    contactFormLastNameLabel: "Last Name",
    contactFormEmailLabel: "Work Email",
    contactFormPhoneLabel: "Phone Number",
    contactFormMessageLabel: "Tell us more about what you\u2019re looking for",
    contactFormSubmitText: "Submit",
    // AcceptTermsText
    acceptTermsText: "I accept the <1>Terms and Conditions</1>. For more information on how your data will be used, please refer to the <3>CBRE Privacy Policy</3>.",
    privacyPolicyLink: "https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy",
    // Form
    formErrorText: "Oops, that didn\u2019t go through. Please try again!",
    formEmailInvalid: "Please enter a valid email address.",
    // NextStepsSection
    nextStepsSectionSubtitle: "Ready to take the next step?",
    nextStepsSectionTitle: "Find the perfect office.",
    nextStepsSectionButtonText: "Connect with an adviser",
    // Profile
    resultsProfileSummaryTitle: "Your office \u2014",
    resultsProfileTooltipText: "Each profile is a composite of real organisations and workplaces, and the details were checked against industry guidelines and market knowledge unique to CBRE Workplace.",
    // Program
    programSaveConfirmationBoxText: "You\u2019re all set. We emailed a link to your results. Enjoy!",
    programExamplePlansTitle: "Example Plans",
    programExamplePlansSubtitle: "Play with interactive floor plans that match your profile. You can even explore them in 3D!",
    programTooMuchTinkerWarning: "Whoa there! Looks like you\u2019re out of the recommended range based on your profile. Consider <1>retaking the quiz</1>, or contacting support at <3>{{email}}</3>.",
    programDisclaimer: "Spacer by CBRE is provided \u201Cas is\u201C and \u201Cas available\u201C with no warranties. All results generated from your use of Spacer are for illustrative purposes only, and do not reflect actual space recommendations or suggested lease terms. Actual space recommendations may vary greatly and will depend on many factors which Spacer does not take into account. By using Spacer or any report generated by the use of Spacer, you accept our Terms of Service and Privacy Policy located respectively at the urls https://workplace.cbre.com/termsOfService and https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy. \xa9 2018 CBRE, Inc. All rights reserved.",
    programMetricsTitle: "Programme Metrics",
    programMetricsSubtitle: "These numbers summarise your work environment",
    programDetailsSectionTitle: "Customise Your Programme",
    programDetailsSectionSubtitle: "Adjust the fields below to fine-tune your space needs.",
    programRevertButtonText: "Revert",
    programSaveButtonText: "Save Changes",
    programSavedButtonText: "Saved",
    // ProgramAssumptions
    programAssumptionsRecommendedOfficeSizeText: "Recommended Office Size",
    programAssumptionsProfileText: "Profile",
    programAssumptionsHeadcountText: "Headcount",
    programAssumptionsHeadcountFollowingText: "people",
    programAssumptionsCollabText: "Collaboration",
    programAssumptionsAvgDaysText: "Average days in office",
    programAssumptionsAvgDaysFollowingText: "per week",
    programAssumptionsAvgDaysPerWeekText: "Average days in office per week",
    // ProgramHeroForPrint
    printNIAText: "Net Internal Area",
    printUSFText: "Usable Square Feet",
    printRSFText: "Rentable Square Feet",
    printDescText: "Based on your details, and a {{lossFactorPercentage}}% {{factorType}} in {{city}}, we recommend a total of-",
    printFitFactorText: "fit factor",
    printLossFactorText: "loss factor",
    // BarChart
    barChartIndivSubtitle: "Individual Space",
    barChartGroupSubtitle: "Group Space",
    barChartAmenitySubtitle: "Amenity Space",
    // SpaceCategoryBreakdown
    spaceCatBreakdownSubtitle: "Select a space type to customise",
    // SpaceCategoryDropdown
    spaceCatDropdownMeText: "Individual Space",
    spaceCatDropdownWeText: "Group Space",
    spaceCatDropdownAmenityText: "Amenity Space",
    // SidebarInfo
    sidebarInfoMeTitle: "Individual",
    sidebarInfoWeTitle: "Group",
    sidebarInfoAmenityTitle: "Amenities",
    // Space Category Descriptions (spaceCategoryDescription.js)
    spaceCatMeDesc: "Space for individual work. Offering choice in where and how your employees work leads to greater employee satisfaction.",
    spaceCatWeDesc: "Space for collaboration and teaming up. In an era when work can happen anywhere, it\u2019s important to provide a variety of spaces to suit a variety of tasks.",
    spaceCatAmenityDesc: "Space that supports work. Great amenities will make your office somewhere your employees \u2014 and recruits \u2014 look forward to spending their time.",
    // Suggested Custom Amenities (suggestedCustomAmenityUnitMap.js)
    audioVisualCustom: "Audio / Visual",
    dataCenterCustom: "Data Center",
    buildingSupportCustom: "Building Support Services",
    foodServiceCustom: "Full Food Service",
    kitchenCustom: "Kitchen",
    serveryCustom: "Servery",
    execDiningCustom: "Executive Dining",
    grabNGoCustom: "Grab-N-Go",
    juiceCoffeeBarCustom: "Juice Bar / Coffee Bar",
    childCareCustom: "Child Care",
    fitnessCenterCustom: "Fitness Center",
    healthCenterCustom: "Health Center",
    mailCenterCustom: "Mail Center",
    commercialPrintCustom: "Commercial Print Room",
    centralCafeCustom: "Central Caf\xe9",
    securityCtrlCustom: "Security Control Room",
    auditoriumCustom: "Auditorium",
    dryCleaningLaundryCustom: "Dry Cleaning / Laundry",
    confCenterCustom: "Conference Center",
    multiPurpTrainingCustom: "Multi-Purpose / Training",
    informalCollabCustom: "Informal Collaboration",
    touchdownTeamCustom: "Touchdown / Team",
    // Suggested Custom Amenity Units (spaceUnit.js)
    seats: "seat",
    seats_plural: "seats",
    rooms: "room",
    rooms_plural: "rooms",
    areas: "area",
    areas_plural: "areas",
    units: "unit",
    units_plural: "units",
    // Predefined Amenities (spaceUnitMap.js) - Shared Space Units
    focusRoomDefined: "Focus Room",
    fileRoomDefined: "File Room",
    centralReceptionHubDefined: "Central Reception Hub",
    smOfficeDefined: "Small Office",
    regOfficeDefined: "Regular Office",
    benchDesk5Defined: "5\u2019 Bench Desk",
    benchDesk6Defined: "6\u2019 Bench Desk",
    meetingRoom4Defined: "Meeting Room (4 people)",
    meetingRoom6Defined: "Meeting Room (6 people)",
    meetingRoom8Defined: "Meeting Room (8 people)",
    meetingRoom12Defined: "Meeting Room (12 people)",
    meetingRoom15Defined: "Meeting Room (15 people)",
    semiEnclosedMeetingBooth4Defined: "Semi-Enclosed Meeting Booth (4 people)",
    openCollabSpace4to6Defined: "Open Collaboration Space (4-6 people)",
    contemplationSpaceDefined: "Contemplation Space",
    mainITEquipRoomDefined: "Main IT Server / Equipment Room",
    receptionAreaDefined: "Reception Area",
    cafeFoodServiceDefined: "Caf\xe9 / Food Service",
    teamStorageDefined: "Team Storage",
    coatClosetsDefined: "Coat Closets",
    genStorageDefined: "General Storage (stores and goods in/out)",
    centralisedCopyPrintMailDefined: "Centralised Copy, Print & Mail",
    specialResourceAreaDefined: "Special Resource Area",
    personalStorageDefined: "Personal Storage (lockers)",
    storageITSpaceDefined: "IT Storage Space",
    secondaryServerRoomDefined: "Secondary Server / Telecom Room",
    mothersRoomDefined: "Mothers\u2019 Room",
    buildITSpaceDefined: "IT Build Space",
    workerCouncilOffice2Defined: "Worker Council Office (2 people)",
    securityCtrlRoomDefined: "Security Control Room",
    centralisedMailDefined: "Centralised Mail",
    visitorCoatLuggageRoomDefined: "Visitor Coat / Luggage Room",
    wellnessRoomDefined: "Wellness Room",
    internalStairDefined: "Internal Stair",
    commercialPrintRoomDefined: "Commercial Print Room",
    buildingSupportServicesAreaDefined: "Building Support Services Area",
    // Predefined Amenities (spaceUnitMap.js) - US_SMALL and US_REGULAR
    officeDefined: "Office",
    lgOfficeDefined: "Office (large)",
    smWorkstationDefined: "Workstation (small)",
    mdWorkstationDefined: "Workstation (medium)",
    lgWorkstationDefined: "Workstation (large)",
    huddleRoomDefined: "Huddle Room",
    dispersedCopyPrintAreaDefined: "Dispersed Copy / Print Area",
    smMeetingRoomDefined: "Small Meeting Room",
    mdMeetingRoomDefined: "Medium Meeting Room",
    lgMeetingRoomDefined: "Large Meeting Room",
    xlMeetingRoomDefined: "X-Large Meeting Room / Boardroom",
    multiPurpTrainingDefined: "Multi-Purpose / Training",
    informalCollabDefined: "Informal Collaboration Area",
    touchdownTeamDefined: "Touchdown / Team Area",
    pantryVendingCoffeeAreaDefined: "Pantry / Vending / Coffee Area",
    workplaceStorageRoomDefined: "Workplace Storage Room",
    employeeCoatAreaDefined: "Employee Coat Area",
    dispersedMailAreaDefined: "Dispersed Mail Area",
    lockerUnitDefined: "Locker Unit",
    serverRoomDefined: "Server Room",
    frontDeskAreaDefined: "Front Desk Area",
    centralCafeAreaDefined: "Central Caf\xe9 Area",
    mailCenterAreaDefined: "Mail Center Area",
    kitchenAreaDefined: "Kitchen Area",
    drawerLateralFileUnitDefined: "3 Drawer Lateral File Unit",
    serveryAreaDefined: "Servery Area",
    juiceBarCoffeeShopAreaDefined: "Juice Bar / Coffee Shop Area",
    diningSupportAreaDefined: "Dining Support Space Area",
    diningAreaDefined: "Dining Area",
    grabNGoAreaDefined: "Grab-N-Go Area",
    focusRoomSharedFocus: "Focus Room",
    // Predefined Amenities (spaceUnitMap.js) - UK_REGULAR
    fullFoodServiceDefined: "Full Food Service",
    // Predefined Amenities (spaceUnitMap.js) - APAC_REGULAR
    officeWorkMeetDefined: "Office (Work/Meet)",
    lgOfficeWorkMeetDefined: "Large Office (Work/Meet)",
    focusDefined: "Focus",
    bench1pt6Defined: "1.6 Bench",
    bench1pt8Defined: "1.8 Bench",
    bench1pt8LDefined: "1.8 \u2018L\u2019 Workstation",
    banquetWorkMeetDefined: "Banquet - Work/Meet (2p)",
    cafeTable4Defined: "Caf\xe9 Table (4p)",
    kitchenTable8to10Defined: "Kitchen Table (8-10p)",
    standingWhiteboardDefined: "Standing Whiteboard",
    huddleRoom3Defined: "Huddle Room (3p)",
    smMeetingRoom5Defined: "Sm Meeting Room (5p)",
    mdMeetingRoom8Defined: "M Meeting Room (8p)",
    lgMeetingRoom20Defined: "L Meeting Room (20p)",
    xlBoardroom: "X-Large / Boardroom",
    wellnessRoomsDefined: "Wellness Rooms",
    employeeCoatsGymLockersDefined: "Employee Coats / Gym Lockers",
    lockersDefined: "Lockers",
    dispersedCopyPrintScanAreaDefined: "Dispersed Copy / Print / Scan Area",
    hydrationPointDefined: "Hydration Point (Water / Tea / Coffee)",
    centralHighDensityStorageDefined: "Central High Density Storage",
    wellnessMothersRoomDefined: "Wellness / Mothers\u2019 Room",
    serverHubRoomsDefined: "Server / Hub Rooms",
    buildITStoreRoomDefined: "IT Build / Store Room",
    simpleReceptionWaitDefined: "Simple Reception + Wait",
    centralCafeSocialHubDefined: "Central Caf\xe9 Social Hub",
    mailCentreDefined: "Mail Centre",
    utilityStoreRoomDefined: "Utility Store Room",
    drawerLateralFileDefined: "3 Drawer Lateral File",
    juiceBarCoffeeShopDefined: "Juice Bar / Coffee Shop",
    buildingSupportServicesDefined: "Building Support Services",
    // Space Unit Map Descriptions (spaceUnitMap.js) - Shared Descriptions
    focusRoomDesc: "Focus Rooms are enclosed spaces intended to support focused and/or confidential work for typically one or two people. Acoustic privacy is paramount in these spaces. Focus Rooms are usually unassigned and can be booked temporarily on an as-needed basis for relevant work.",
    fileRoomDesc: "This is paper file storage for individuals and teams. As a result of most offices digitization efforts, the need for both individual and team file storage is diminishing greatly. Still, this is a central space for legally required document copies or long term project materials, especially with most open office desks containing little storage.",
    centralReceptionHubDesc: "The reception area is your company\u2019s first opportunity to make an impression on employees, clients and other visitors. It should consistently convey the company\u2019s brand and project the desired appearance. The concierge desk should comfortably house a concierge; soft-seating should be inviting to visitors.",
    officeDesc: "Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy.",
    benchDeskDesc: "Bench desks are open individual work seats. Smaller bench desks can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open bench desks are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open bench desks have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.",
    meetingRoomDesc: "Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).",
    meetingRoomDesc6: "Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).",
    meetingRoomDesc8: "Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).",
    meetingRoomDesc12: "Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).",
    meetingRoomDesc15: "Meeting rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).",
    openCollabSpace4to6Desc: "These areas are meant to support small groups (4-6 person) collaborative activities such as brainstorming and informal conversations between colleagues and with clients. ",
    cafeFoodServiceDesc: "The central cafe is intended to be an area for eating, social interaction, individual work and small meetings. Functional eating furniture and a branded color palette should be considered in the design of this space.",
    coatClosetsDesc: "Employees need a place to store their coats and other bulky items, especially when an office has an open layout with limited personal storage at the desk. These should be dispersed throughout the office, perhaps located by exits and along main corridors. There is usually a shelf about the hanging portion for hats and other equipment with storage or suitcases at the base of the closet.",
    copyPrintDesc: "Spread across the floor in open workspace, copy/print areas give employees quick access to multi-function devices from all neighborhoods. Bins for recycling should always be collocated with copy/print areas, as well as small cabinets to house extra paper and supplies. These spaces are for drop-in purposes only and are not intended to double as social/work areas.",
    specialResourceBuildingSupportAreaDesc: "This is a catch all for additional support spaces that might occur in an office. One could be a security desk or facilities while another could be a utilities space. This varies across organisations, but as the size of the office increases, ancillary spaces like this become more likely and necessary.",
    secondaryServerRoomDesc: "Secondary Server (technology) room to house and secure IT equipment and to terminate low voltage cabling. The rooms need to have 24 hour air and needs to be at a constant 72 Degrees Fahrenheit with 50% relative humidity.",
    mothersRoomDesc: "Mothers rooms are intended to support extremely private individual time\u2014whether for nursing mothers or any individuals seeking respite from the office for a short interval. Mothers rooms are a usually a requirement for all new offices, regardless of size or headcount.",
    visitorCoatLuggageRoomDesc: "Visitors need a place to store their coats and other bulky items. These should be dispersed throughout the office, perhaps located by exits and along main corridors. There is usually a shelf about the hanging portion for hats and other equipment with storage or suitcases at the base of the closet.",
    wellnessRoomDesc: "Wellness rooms (formerly referred to as Mother\u2019s Rooms) are intended to support extremely private individual time\u2014whether for nursing mothers or any individuals seeking respite from the office for a short interval. Wellness rooms are a usually a requirement for all new offices, regardless of size or headcount, and should contain a lounge chair, a refrigerator, and ideally a sink.",
    internalStairDesc: "Internal stairs can be activated stairwells in the core that provide access between floors, or it can be additional feature elements that connect floors of an office. Can often be a gather space within the office and can be centralised for cafe, reception, or meeting spaces.",
    commercialPrintRoomDesc: "Often combined with the mailroom, companies provide in house capabilities to print, bind, and compile presentations in the print room. There will be several printers, and might include large format printers. Spaces will include storage space for supplies, and will also include counter space for smaller equipment but also space to layout prints.",
    pantryVendingCoffeeDesc: "Unlike the central cafe, the pantry/vending/coffee area is meant for employees to grab the quick food and drink essentials need. Buzz and conversation is naturally found in areas with food, but these spaces usually do not contain seating causing people to come and go quickly within spending an extending amount of time socializing.",
    storageDesc: "Storage rooms are intended to hold miscellaneous items such as large equipment, extra furniture, bulk storage, holiday supplies, etc. They can also be used for visitor coat and luggage storage. There should be small storage located near the concierge for convenience.",
    centralisedDispersedMailAreaDesc: "For larger companies, a mail center is required for organizing incoming and outgoing mail. These space hold specialty production and mail equipment. There are also many surfaces for organizing paper and other materials. Usually manned by a full time staff member.",
    lockerDesc: "Lockers are provided as another form of individual storage. They give employees a space to lock their valuables, personal effects and working files. Lockers may be assigned to individuals or used on a first come, first served basis.",
    mainITandServerRoomDesc: "Primary Server (technology) room to house and secure IT equipment and to terminate low voltage cabling. The rooms need to have 24 hour air and needs to be at a constant 72 Degrees Fahrenheit with 50% relative humidity.",
    drawerLateralFileDesc: "Personal storage for individuals at desks or offices. Contents are usually personal or active project materials.",
    juiceBarCoffeeShopDesc: "While a company might not have a full kitchen and servery, it may provide a coffee shop or juice bar as part of the food/drink amenities in the space. An organisation might also have this kind of space in addition to its main dining services, especially if the office is large. This space will likely look like your local Starbucks with a working area for a staffer person separated by a serving counter.",
    grabNGoDesc: "A small convenience area with several fridges, shelves for chips and snacks, and a checkout machine. These Grab-N-Go spaces are typically monitored for security by camera. These spaces are often combined with a small pantry with fridges and freezers and prep area for food.",
    smMeetingConferenceRoomDesc: "A small conference room is an enclosed meeting space intended to comfortably accommodate 2-6 people at the table. These rooms can be used for both internal and client-facing meetings and should therefore be very user friendly with easy access to power and A/V capabilities.",
    mdMeetingConferenceRoomDesc: "A medium conference room is an enclosed meeting space intended to comfortably accommodate 6-10 people at the table. These rooms are used for both internal and client-facing meetings and should therefore be very user friendly with easy access to power and A/V capabilities.",
    lgMeetingConferenceRoomDesc: "A large conference room is an enclosed meeting space intended to comfortably accommodate 12-14 people at the table, overflow seating along the perimeter of the room is desirable. These rooms can be used for both internal and client-facing meetings and are likely to be used for presentations. Furniture should be movable to allow the space to be used for other purposes, such as yoga classes for employees.",
    xlMeetingRoomDesc: "A boardroom conference room is intended to comfortably accommodate 14-18 people at the table, with overflow seating along the perimeter of the room for at least 10 more. These rooms will most likely be used for large internal formal meetings and large client-facing meetings. As such, they should be equipped with robust A/V technology and should be branded as client facing-space.",
    // Space Unit Map Descriptions (spaceUnitMap.js) - US_SMALL and US_REGULAR
    lgOfficeDesc: "Offices are private enclosed individual work spaces for employees. They are great for reducing distraction and where focus work can take place. Offices are typically equipped with a desk and work seat along with guest seats for visitors. You will find varying amounts of personal storage and filing in offices. The size of the space can also vary depending on activities that take place in the room (e.g. regular meetings) or employee status/hierarchy. This slightly larger office might be a partner office or might double as a huddle room.",
    smWorkstationDesc: "Workstations are open individual work seats. Smaller workstations can be used by full time employees either temporarily (in a free address space) or permanently. These desks are also great for visiting employees or contractors who are not at the office all the time. Some advantages of open workstations are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open workstations have plenty of focus and huddle rooms. Filing at the desk is limited with communal filing likely located throughout the floor.",
    mdWorkstationDesc: "Workstations are open individual work seats. The benefits of a slightly larger space includes more desk storage and privacy. This likely means the larger a desk, the most likely it is to assigned instead of free address. Some advantages of open workstations are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open workstations have plenty of focus and huddle rooms. You will likely find additional communal storage and filing located throughout the floor.",
    lgWorkstationDesc: "Workstations are open individual work seats. The benefits of a slightly larger space includes more desk storage and privacy. Desks this size are most likely assigned instead of free address. Some advantages of open workstations are the office visibility and inherent collaboration. One disadvantage can be the noise distraction, which is why it is recommended that offices with open workstations have plenty of focus and huddle rooms. You will likely find additional communal storage and filing located throughout the floor.",
    huddleRoomDesc: "Huddle Rooms are enclosed spaces intended to support small group meetings of 2-4 people. They should be equipped with A/V equipment and white boards to facilitate knowledge sharing and should be acoustically private (people sitting immediately outside of the room should not be able to hear conversations going on inside).",
    multiPurpTrainingDesc: "Multi-purpose rooms are meant to accommodate a large number of people (20+). This space is appropriately named since many different activities can happen here including training, company events, and large presentations. The fit and finish of this space is functional/durable with many people coming and going but client facing as well. This space must have the appropriate A/V support - typically much more than the average conference room.",
    informalCollabDesc: "These areas are meant to support small groups (4-6 person) collaborative activities such as brainstorming and informal conversations between colleagues and with clients. ",
    touchdownTeamDesc: "Touchdowns are individual or small internal team work spaces that are spread throughout the office for employee and visitor use. Touchdowns can be a variety of heights, shapes and sizes but are meant to stand out from individual workstations as a unique place to work for a short period of time. These should be plug-and-play spaces: easy to find and use.",
    frontDeskAreaDesc: "This is first stop when employees and visitors come to the office. The desk should be able to accommodate at least one person with person workspace and storage. There will likely be vistor storage nearby as well. The front desk is placed within the larger reception hub where there will likely be seating and other accommodations.",
    mailCenterAreaDesc: "For larger organisations, a mail center is required to centralise all mail services. This will include large sorting and organisation space, along with space for charts and equipment. This space likely looks very different for each organisation since it is often fit between other programme items.",
    kitchenAreaDesc: "For spaces that will have an in-office dining service, a kitchen is required to support this amenity. The requirements of a kitchen will vary from organisation to organisation, but you can expect to find cooking appliances and refrigerator storage. There will also be dry goods and equipment storage. The kitchen will be adjacent to the servery and likely the conferencing/client amenities center.",
    serveryAreaDesc: "The servery is the area where people get their food. It is likely connected to the kitchen and a dining area with tables and seating. The planning of a servery is very precise to manage queues and traffic. This size and shape of this space will likely vary between organisations.",
    diningSupportAreaDesc: "An organisation that has robust dining services will likely have additional support spaces like storage in other parts of the building that need to be accounted for in the overall programme. The space will vary between organisations.",
    diningAreaDesc: "Dining near kitchen should provide a variety of choice for people to sit and eat lunch. Providing several different types of seating also allows the space to be utilised for meetings and collaboration outside of lunch time. Providing soft and hard seating along with bar and seated height settings gives users choice.",
    // Space Unit Map Descriptions (spaceUnitMap.js) - UK_REGULAR
    fullFoodServiceDesc: "When providing an in-office dining service, there are multiple functions that come together to support this amenity including a kitchen, servery, dining room (seating), and dining support (storage). The kitchen and servery work together to prepare and serve the food made in-house. Dining is the place where employees and guests can sit and eat but often this space acts as a social and collaboration hub. Just like at home, there is a lot of equipment and food storage required to provide dining services, which is why dining support is included in the Full Food Service space type.",
    // SpaceUnitRow
    spaceUnitRowDeleteTitle: "Delete Space Type",
    spaceUnitRowDeleteText: "Are you sure you want to delete this space type?",
    spaceUnitRowConfirmDeleteText: "Yes, delete",
    spaceUnitRowCancelDeleteText: "No, keep it",
    // CustomAmenityAdder
    customAmenityAddText: "Add an amenity",
    customAmenityPlaceholder: "Amenity type",
    // SpaceUnitTotals
    spaceUnitTotalsTitleNIA: "Total Net Internal Area",
    spaceUnitTotalsTitle: "Total {{sfTypeAdj}} Square {{unitCapitalized}}",
    spaceUnitTotalsCirculation: "Circulation",
    spaceUnitTotalsCirculationTooltip: 'The "space between spaces." Corridors, the space behind your chair, the space around cabinets and doors, and around corners. Without circulation, you would have nowhere to walk! Usually comprises around 35% of the total Usable Square {{unitCapitalized}} in your programme, but this varies depending on your profile and ultimate building selection.',
    spaceUnitTotalsREBNY: "REBNY Factor",
    spaceUnitTotalsREBNYTooltip: "For programmes in NYC, we increase {{sfType}} by 15% to account for the REBNY measurement standard. Space measured per the REBNY measurement standard includes bathrooms, elevator lobbies, and the thickness of exterior walls (among other things).",
    spaceUnitTotalsLossFactor: "Loss Factor ",
    spaceUnitTotalsLossFactorTooltip: "Usable square {{unit}} is how much space you have in your office. Rentable square {{unit}} is the space you pay for, which can include columns, lobbies, and other common areas. The difference between usable and rentable is called the loss factor, and how you calculate it varies by location.",
    // CollaborationDropdown
    collabDropdownLevelLowText: "a little (0-25%)",
    collabDropdownLevelMedText: "some (26-50%)",
    collabDropdownLevelHighText: "most (51-100%)",
    // ExamplePlans
    examplePlanButtonText: "View Example Plan",
    examplePlanFullFloorText: "full floor",
    examplePlanPartialFloorText: "partial floor",
    examplePlanFullImgAlt: "{{size}} square {{unit}} floor plan showing a {{profileName}} profile layout from Spacer by CBRE",
    examplePlanPartialImgAlt: "{{size}} square {{unit}} partial floor plan showing a {{profileName}} profile layout from Spacer by CBRE",
    examplePlanTooltipText: "If you are larger than {{size}} {{unit}}, you might need more than one floor.",
    // ProgramStats
    programStatsDensitySubtitleTsubo: "Net Tsubo",
    programStatsDensitySubtitle: "{{adjective}} Square {{unitUppercase}}",
    programStatsIndivTitle: "Individual Seats",
    programStatsWorkstationsSubtitle: "Workstations",
    programStatsOfficesSubtitle: "Offices",
    programStatsCollabTitle: "Collaboration",
    programStatsEnclosedSubtitle: "Enclosed Group Seats",
    programStatsIndivSeatSubtitle: "Individual Seat",
    programStatsSeatsTitle: "Seats Per Person",
    programStatsIndivSeatsSubtitle: "Individual Seats",
    programStatsPersonSubtitle: "Person",
    programStatsDensityTitle: "Density",
    programStatsFullDensitySubtitle: "{{density}} per Individual Seat",
    // Profile Display Names (profileNames.js)
    efficientName: "The Optimiser",
    whiteCollarName: "The Accommodator",
    whiteGloveName: "The Enhancer",
    openOfficeName: "The Producer",
    workplace360Name: "The Connector",
    campusName: "The Differentiator",
    startupName: "The Incubator",
    engCreativeName: "The Creator",
    // Profile Descriptions (profileDescriptions.js)
    efficientDesc: 'The Optimiser office is a no-nonsense, no-frills environment with a "get the work done" mindset. Open work environments are focused on enabling individuals with all the required tools at their desk. Basic support spaces are provided and collaboration spaces are more traditional in nature - by way of enclosed rooms. True to its name, these environments are all about maximizing efficiency.',
    whiteCollarDesc: "The Accommodator office provides all the essentials while incorporating flexibility for future change. Space offerings tend to be standardised with dual functionality built in. In this environment, meeting rooms and private office footprints are interchangeable, larger meeting spaces are built with adaptability and cafe-style spaces designed with collaboration in mind. As the name suggests, this profile is all about change with minimal impact.",
    whiteGloveDesc: "The Enhancer office caters deeply to the needs of employees, as well as clients, who are frequent visitors of the workplace. The space offering provides a range of foundational work settings to suit activity based working. Most staff and spaces are technology enabled allowing ease of movement in and out of the office. Whether a formal agile programme is in place or not, this office environment sets the stage for flexible working now and in the future.",
    openOfficeDesc: "The Producer office is all about giving people the foundational spaces required based on the type of activity happening in the office. A variety of spaces are expected in this environment, including individual, group and support spaces which are geared towards both focused and collaborative workmodes. As it allows for the most efficient use of space, flexible working and desk sharing are commonly seen accompanying this style of office.",
    workplace360Desc: "As the name states, the Connector office is designed to support meaningful connections. Planning with a neighbourhood concept in mind, all support spaces and amenities are close at hand. We see a higher population of alternative worksettings and spaces to collaborate, which are strategically located to support serendipitous connections. Employees are empowered to work where and how they need in order to perform at their best.",
    campusDesc: "The Differentiator office makes it hard to leave at the end of the day. That\u2019s because it thrives on providing a work experience that is above and beyond the rest. You will find enhanced amenities around wellness or food to help save employees time and feel comfortable. Employees are encouraged to take breaks and relax while in the workplace.",
    startupDesc: "Speed and ideation are the name of the game when it comes to the Incubator office. Employees work in highly collaborative teams and think like owners. This office environment is constantly changing, which means most of the spaces have flexibility built-in. Moving furniture and make-shift solutions are common. A mixture of fun social activities and intense work sessions are used to build camaraderie as a team.",
    // Profile Key Traits: Shared Names (profileTraitMap.js)
    social: "Social",
    efficient: "Efficient",
    flexible: "Flexible",
    enabled: "Enabled",
    productive: "Productive",
    inclusive: "Inclusive",
    clientFocused: "Client-Focused",
    standardized: "Standardised",
    // Profile Key Traits (profileTraitMap.js)
    social1Desc: "Relationships in and out of the office are important",
    social2Desc: "Many community building events",
    social3Desc: "Employees like to spend time together",
    social4Desc: "More open and community driven",
    efficient1Desc: "Company stays lean and budget conscious",
    efficient2Desc: "Company stays lean and productive",
    flexible1Desc: "People have choice in how they work",
    flexible2Desc: "Employees have a lot of freedom",
    flexible3Desc: "Build the space you need",
    enabled1Desc: "Employees have what they need at their desks",
    enabled2Desc: "Employees have robust services and amenities",
    enabled3Desc: "People can get what they need to do their jobs",
    enabled4Desc: "Have access to the right tech and equipment",
    enabled5Desc: "Specialised equipment is available",
    productive1Desc: "Functional and intuitive office design",
    productive2Desc: "Business oriented and financially conscious",
    productive3Desc: "Centered around unique product/service offering",
    inclusive1Desc: "Multiple types of space available",
    inclusive2Desc: "You can find everything you need at the office",
    inclusive3Desc: "Many different styles of working are acceptable",
    clientFocused1Desc: "First impressions with clients mean everything",
    clientFocused2Desc: "Office is welcoming for clients and new recruits",
    clientFocused3Desc: "Office is polished for clients and new recruits",
    standardized1Desc: "Processes and systems are streamlined",
    standardized2Desc: "Organisational norms around space allocation",
    standardized3Desc: "Modular sizes for flexibility",
    standardized4Desc: "Streamlined processes and deliverables",
    // SpaceSummary
    spaceSummaryBarHeader: "Recommended Office Size",
    spaceSummaryMeasurementTypeText: "measurement type",
    spaceSummaryUnitTypeText: "units",
    spaceSummaryLossFactorSectionLabel: "{{factor}} Details",
    spaceSummaryFitFactorText: "Fit Factor",
    spaceSummaryLossFactorText: "Loss Factor",
    spaceSummaryRSFLossFactorHelperText: "Based on a {{percentage}}% loss factor for real estate in {{place}}, you should search for spaces between {{min}} and {{max}} rentable square {{units}}.",
    spaceSummaryNIAFitFactorHelperText: "Based on a {{percentage}}% fit factor for real estate in {{place}}, you should search for spaces with {{amt}} NIA of space.",
    spaceSummaryNIATooltipText: "Net Internal Area (NIA) is the usable area within a building measured to the internal face of the perimeter walls at each floor level with certain specified areas excluded.",
    // SFTypeRadioInput
    sfRadioInputUsableAreaTooltipText: "This measurement includes all rooms, furniture and circulation space. It\u2019s sometimes referred to as carpetable area.",
    sfRadioInputRentableAreaTooltipText: "This is typically the Usable Square {{unitUppercase}} plus a portion of the building\u2019s common spaces. Though you can\u2019t use all of it, it\u2019s the square {{unit}} that you pay for when you rent.",
    sfRadioInputUsableSquareText: "Usable Square {{unitUppercase}}",
    sfRadioInputRentableSquareText: "Rentable Square {{unitUppercase}}",
    //floored plan request block
    flooredTitle: "Don't leave us just yet!",
    flooredSubTitle: "Redefine how clients explore space",
    flooredSubText: "See your Spacer results in a floor plan and tour them in 3d!",
    flooredParagraphText1: "Immersive experience allows tenants to imagine possibilities, experiment with space, and turn ideas into reality.",
    flooredParagraphText2: "Tangible, customised vision for every possible space",
    flooredVideoHeading: "Watch a sample experience",
    flooredFreeText: "What's more, it is free!",
    flooredIconText1: "Share available floor plans",
    flooredIconSubText1: "AutoCAD files for pdfs",
    flooredIconText2: "Allow processing time",
    flooredIconSubText2: "One to two weeks",
    flooredIconText3: "Receive sharable experience",
    flooredIconSubText3: "Custom 2D and 3D experiences",
    // MeasurementSystemRadioInput
    measurementSystemSqFeetText: "Sq feet",
    measurementSystemSqMetersText: "Sq meters",
    measurementSystemTsuboText: "Tsubo",
    // ProfileHero
    resultsProfileHeroAnnouncementTitle: "Your office is",
    resultsProfileHeroImgAlt: "3D floor plan showing the office layout of the {{profileName}} profile from Spacer by CBRE",
    // ProfileComparison
    profileCompModalTitle: "Change Your Profile?",
    profileCompModalText: "You will lose any unsaved changes on your current space programme.",
    profileCompModalConfirmText: "Yes, change profile",
    profileCompModalCancelText: "No, keep current profile",
    profileCompNavbarCancelButtonText: "Cancel",
    profileCompNavbarUseButtonText: "Use This Profile",
    profileCompCompareTitle: "Compare Your Closest Profile Matches",
    // ProfileComparisonColumn
    profileCompColumnSelectedText: "Selected Profile",
    profileCompColumnSelectText: "Select",
    profileCompColumnRecommendedText: " (Recommended)",
    profileCompColumnImgAltText: "3D floor plan showing the office layout of the {{profileName}} profile from Spacer by CBRE"
};


var $8e9a0cb3fc2d34e0$exports = {};
$8e9a0cb3fc2d34e0$exports = {
    // TermsOfService
    TermsTitle: "Terms Of Service",
    TermsIntroText: "This is a legal agreement between you and CBRE, Inc. (\u201CCBRE\u201D) regarding access to and use of the application known as Spacer\xae.  By using or accessing any of the information or services on this web-based application, you acknowledge that you have read, understood and agree to the terms and conditions set forth in this Terms of Use (the \u201CAgreement\u201D or \u201CTOU\u201D). The terms \u201Cyou\u201D, \u201Cyour\u201D or \u201CUser\u201D refers, collectively, to the person and any entity on whose behalf such person may be acting.",
    TermsLimitationsTitle: "Limitations.",
    TermsLimitationsA: "User understands and agrees that User\u2019s access to Spacer\xae is non-exclusive, non-sublicensable, non-transferable, freely revocable and can be suspended or terminated at any time for any reason by CBRE.",
    TermsLimitationsB: "User further understands and agrees that the grant of access to Spacer\xae shall not confer in User any rights of ownership in Spacer\xae or any related documentation (including in any new releases, modifications or enhancements), all of which shall be and remain the exclusive property of CBRE, including without limitation, the copyrights thereto, associated patents, design patents, trademarks, trade dress, trade secrets and other proprietary rights arising under applicable law or international conventions (collectively, \u201CProprietary Rights\u201D).  See Section 2 (Ownership) below. CBRE hereby expressly reserves all rights in Spacer\xae which are not expressly granted to User hereunder.",
    TermsLimitationsC: "Except as provided herein or as expressly authorised by CBRE to User in writing, User will not: (i) modify, translate, reverse engineer, decompile, disassemble, attempt to reconstruct, identify, or discover any source code, underlying ideas, underlying user interface techniques or algorithms, or create derivative works of or copy Spacer\xae; (ii) remove, alter, or cover any copyright or trademark notices or other proprietary rights notices contained in Spacer\xae; (iii) assign, sublicense, or otherwise transfer its access, use or other  rights or delegate its obligations under this Agreement; or (iv) without limiting any of the foregoing, use Spacer\xae for the purpose of building a competitive product or service, or for any purpose other than legitimate business purposes relating to User\u2019s business.",
    TermsLimitationsD: "User agrees to notify CBRE promptly in writing if any unauthorised use of Spacer\xae, or any possible infringement of Proprietary Rights, comes to its attention.",
    TermsLimitationsE: "At no time during or after the term of this Agreement shall User apply for any registration of any copyright, trademark or other designation which would affect the ownership of Proprietary Rights nor file any documents with any governmental authority to take any action which would affect the ownership of Proprietary Rights, including CBRE\u2019s ownership of Spacer\xae, the mark Spacer\xae, and other application components. Spacer\xae is a trademark and service mark of CBRE.",
    TermsLimitationsF: "User represents and agrees that User has the right to provide all materials posted on, or information used in connection with, Spacer\xae, and hereby grants to CBRE a non-exclusive, royalty-free, worldwide, irrevocable, perpetual right and license to use, reproduce, modify, distribute, create derivative works of, and display such materials and information in CBRE\u2019s discretion.  User acknowledges that User is responsible for whatever material and information is submitted by User, including its legality, reliability, appropriateness, originality, and copyright. The license grants by User to CBRE hereunder will survive any termination of User\u2019s use of Spacer\xae.  Any material and information submitted by User will be considered non-confidential and non-proprietary, and treated as such by CBRE, and may be used by CBRE in accordance with this Agreement without notice to User and without any liability to CBRE.",
    TermsOwnershipTitle: "Ownership.",
    TermsOwnershipText: "Spacer\xae, programming language, software and documentation and all other material or content made available on Spacer\xae or any improvements, modifications, derivative works, enhancements or changes to Spacer\xae and all copies thereof are proprietary to CBRE and title thereto remains solely in CBRE under all circumstances, including without limitation all rights to patents, copyrights, trademarks and trade secrets in Spacer\xae and the improvements, modifications, derivative works, and changes thereto. User understands that the foregoing includes trade secrets and information that is confidential and proprietary to CBRE and agrees to take all necessary actions to protect the confidentiality of such information. User shall not sell, transfer, publish, disclose, display or otherwise make available Spacer\xae or create or make available any improvements, modifications, enhancements, derivative works, or changes thereto or copies thereof to others.  Termination of this Agreement shall be in addition to and not in lieu of any remedies available to CBRE both in law and equity. The obligations hereunder shall survive the termination of this Agreement.",
    TermsTerminationTitle: "Termination; Effect of Termination; Remedies.",
    TermsTerminationA: "Without limiting any other remedies, CBRE may modify, limit, suspend, discontinue or terminate this Agreement and/or User\u2019s use of all or any part of Spacer\xae, with immediate effect, automatically, with or without notice and without recourse to the courts or other tribunals, for any reason or for no reason.  User agrees that CBRE is under no obligation to provide Spacer\xae and that CBRE shall not be liable to User or to any other party for any limitation, suspension, discontinuance, termination or modification of Spacer\xae.",
    TermsTerminationB: "User acknowledges that the obligations made hereunder to CBRE are of a unique and irreplaceable nature, the loss of which shall irreparably harm CBRE and which cannot be replaced by monetary damages alone so that CBRE shall be entitled to injunctive or other equitable relief (without the obligations of posting any bond or surety) in the event of any breach or anticipatory breach by User. User irrevocably waives all rights to seek injunctive or other equitable relief.",
    TermsDisclaimerTitle: "Disclaimers and Limitation of Liability.",
    TermsDisclaimerA: "Spacer\xae is provided to User \u201CAS IS\u201D and \u201CAS AVAILABLE\u201D with no warranties.  CBRE DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. CBRE DOES NOT WARRANT IN ANY WAY THAT Spacer\xae WILL MEET USER\u2019S REQUIREMENTS OR ANY PARTICULAR STANDARD. SOME STATES DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES, SO THE ABOVE EXCLUSION MAY NOT APPLY TO USER. In such event the liability of cbre will be limited to the maximum extent possible under applicable law. NO ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY CBRE, ITS AGENTS OR EMPLOYEES, SHALL CREATE A WARRANTY IN ANY WAY WHATSOEVER. NO WARRANTY IS GIVEN THAT Spacer\xae OR ANY INFORMATION PROVIDED TO USER ARE ERROR FREE OR THAT THE USE OF Spacer\xae WILL BE UNINTERRUPTED, UP-TO-DATE, COMPLETE OR FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS, AND NO WARRANTY IS GIVEN THAT ANY OF THE FOREGOING WILL BE CORRECTED. CBRE DOES NOT WARRANT OR MAKE ANY REPRESENTATIONS REGARDING THE USE OF, OR THE RESULTS FROM THE USE OF, Spacer\xae.  CBRE SHALL NOT BE LIABLE FOR ANY INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, PUNITIVE OR EXEMPLARY DAMAGES (INCLUDING WITHOUT LIMITATION DAMAGES FOR LOSS OF BUSINESS, LOSS OF PROFITS, LOST REVENUE, LOST SAVINGS, COMPUTER INTERRUPTION, GOODWILL, USE, DATA OR OTHER INTANGIBLE LOSSES), WHETHER BASED ON BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE), PRODUCT LIABILITY OR OTHERWISE, EVEN IF CBRE OR ITS REPRESENTATIVES HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES AND EVEN IF A REMEDY SET FORTH HEREIN IS FOUND TO HAVE FAILED OF ITS ESSENTIAL PURPOSE.",
    TermsDisclaimerB: "CBRE\u2019S TOTAL LIABILITY FOR DAMAGES FOR ANY CAUSE WHATSOEVER SHALL NOT EXCEED THE FEE PAID BY USER FOR Spacer\xae DURING THE TWELVE (12) MONTH PERIOD PRIOR TO THE EVENT THAT ALLEGEDLY CAUSED SUCH DAMAGE.  USER AGREES THAT ANY CAUSE OF ACTION ARISING OUT OF OR RELATED TO Spacer\xae OR OTHERWISE RELATED TO THIS AGREEMENT MUST COMMENCE WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES. OTHERWISE, SUCH CAUSE OF ACTION IS PERMANENTLY BARRED.",
    TermsDisclaimerC: "SOME JURISDICTIONS MAY NOT ALLOW THE LIMITATION ON LIABILITY OR EXCLUSIONS OF LIABILITY SET FORTH ABOVE, SO THE ABOVE LIMITATION OR EXCLUSION MAY NOT APPLY TO USER. In such event the liability of CBRE will be limited to the maximum extent possible under applicable law.  The waiver of warranty, exclusive remedies and limited liability set forth above are fundamental elements of the basis for this Agreement between CBRE and USER. CBRE would not be able to provide Spacer\xae on an economic basis, and would not have entered into this Agreement, without such limitations. These limitations shall survive any termination of this Agreement.",
    TermsIndemnificationTitle: "User Indemnification.",
    TermsIndemnificationText: "At CBRE\u2019s option and request, User shall, at its own expense, indemnify and hold harmless CBRE and its subsidiaries, affiliates, officers, employees, agents, co-branders, associations, and other partners harmless from and against any losses, costs, damages, liabilities, settlements and expenses (including without limitation costs and attorneys\u2019 fees), arising out of or related to any third-party claim, action or allegation related to or arising from: (a) any transaction or dispute between User and any third party; (b) facts or alleged facts that would constitute a breach of any of User\u2019s representations, warranties, or covenants under this Agreement or of any applicable law, rule or regulation, whether or not referenced herein; (c) any User materials, information or content submitted in or on Spacer\xae; (d) User\u2019s violation of any rights of any third party, (e) User\u2019s use or misuse of Spacer\xae; or (f) the negligence or willful misconduct of User.  CBRE shall have the right to exclusively direct and control its defense and hire counsel of its choice, at User\u2019s expense.",
    TermsGeneralTitle: "General.",
    TermsGeneralA: "<0>Entire Agreement/No Unintentional Waiver.</0> This Agreement constitutes the entire agreement between CBRE and User with respect to Spacer\xae and all subject matter of this Agreement, and supersedes all prior agreements between CBRE and User related to Spacer\xae if any. CBRE\u2019s failure to enforce any provision of this Agreement will not be construed as a waiver of any provision or right.",
    TermsGeneralB: "<0>Notices.</0> Notices to you shall be in writing and may be made via email or posting such notices on Spacer\xae or at www.cbre.com/spacer. You will provide notices to us via email to spacersupport@cbre.com, with a copy sent via certified U.S. mail to CBRE at 400 S. Hope Street, 25th Floor, Los Angeles, CA 90071, Attention:  General Counsel\u2019s Office. Notices will be deemed given one (1) business day after being sent via email (unless the sender receives a response indicating that the message was undeliverable) or three business days after being posted on the CBRE website (in the case of CBRE), whether or not received.",
    TermsGeneralC: "<0>Governing Law.</0> This Agreement shall be governed by and construed in accordance with the laws of the State of California without regard to the conflicts of laws provisions thereof.  CBRE and User hereby subject themselves exclusively to venues within the State of California.  The United Nations Convention on Contracts for the International Sale of Goods (1980) is hereby excluded in its entirety from application to this Agreement. User hereby agrees that Spacer\xae shall be deemed solely based in California and a passive service that does not give rise to personal jurisdiction over CBRE, either specific or general, in jurisdictions other than the State of California.",
    TermsGeneralD: "<0>Dispute Resolution.</0> Any dispute, claim or controversy arising out of or relating to this Agreement, or the breach, enforcement, interpretation or validity thereof, including the determination of the scope or applicability of arbitration with respect to this Agreement, shall be determined by arbitration.\xa0 The arbitration shall be administered by the Judicial Arbitration and Mediation Service (JAMS), and the arbitration shall be conducted with a single arbitrator.\xa0 Furthermore, User agrees that neither User nor CBRE will join any claim with the claim of any other person or entity in arbitration; that no claim will be resolved on a class-wide basis; and that neither User nor CBRE will assert any claim in a representative capacity on behalf of anyone else.\xa0 Notwithstanding the foregoing, User agrees that CBRE shall be allowed to apply for injunctive remedies (or an equivalent type of urgent legal relief) in any jurisdiction.\xa0 If User files an arbitration complaint against CBRE, CBRE agrees to pay for any portion of the initial filing fee that exceeds $250; after the initial filing fees, the parties will share the costs of arbitration equally.\xa0 User agrees not to commence or prosecute any action against CBRE other than by filing an arbitration complaint in accordance with this paragraph.\xa0 IMPORTANTLY, BY AGREEING TO BE BOUND BY THIS AGREEMENT, USER IS WAIVING ANY RIGHT USER HAS TO SEEK RELIEF IN A COURT OF LAW AND ANY RIGHT USER HAS TO A TRIAL BY JURY.",
    TermsGeneralE: "<0>Severability.</0> In the event that a portion of this Agreement is held unenforceable, the unenforceable portion shall be modified only to the extent necessary to make it enforceable, and the remainder of the provisions will remain in full force and effect.",
    TermsGeneralF: "<0>Assignment.</0> This Agreement may not be assigned by User without CBRE\u2019s prior written consent. Any attempted assignment without CBRE\u2019s consent shall be void. CBRE reserves the right to assign this Agreement to any third party. This Agreement and the rights and obligations of each of us under it will be binding on our respective successors and assigns.",
    TermsGeneralG: "<0>Modification.</0> CBRE may modify any of the terms and conditions contained in this Agreement, at any time and in CBRE\u2019s sole and exclusive discretion, by posting a change notice or a new agreement on Spacer\xae\u2019s site at the url www.cbre.com/spacer or by providing an alert or similar notification in Spacer\xae.  If any modification is unacceptable to User, User\u2019s only recourse is to terminate User\u2019s use of Spacer\xae.",
    TermsGeneralH: "<0>Conflicts.</0> In the event there is any conflict between the terms of this Agreement and any fully executed license agreement between User and CBRE with respect to Spacer\xae, the terms of such license agreement shall control with respect to such conflicting terms."
};


var $923af5276166d41b$exports = {};
$923af5276166d41b$exports = {
    // Quiz
    exitQuizButtonTitle: "Exit Quiz",
    // QuizProgressLabel
    progressLabelText: "complete",
    // QuizNavigationButton
    quizNavBackButtonShortenedText: "Previous",
    quizNavBackButtonFullLengthText: "Previous Question",
    quizNavNextButtonShortenedText: "Next",
    quizNavNextButtonFullLengthText: "Next Question",
    // QuizExitSlide
    quizExitSubtitle: "We are now using your answers to define the perfect workplace for your company.",
    quizExitImgAlt: "Illustration of two people high fiving on the Quiz page of Spacer by CBRE",
    // Question Unit Text (questionUnitMap.js)
    question1Text: "To start \u2014 How would you describe the purpose of your future office?",
    question2Text: "What about your organisation do you think is most attractive to candidates?",
    question3Text: "What are the most important things you look for when hiring new team members?",
    question4Text: "How do you see the size of your organisation changing in the next five years?",
    question5Text: "What\u2019s the work schedule like for your employees?",
    question6Text: "What do you think about individual desks?",
    question7Text: "While in the office, where will people spend their time working?",
    question8Text: "What will people wear in your office?",
    question9Text: "Where will your work happen?",
    question10Text: "What should your office atmosphere be like?",
    question11Text: "Besides space for work, what would you like to provide in your workspace?",
    question12Text: "Which of these best describes you?",
    // Quiz Answers (questionUnitMap.js)
    pickOnePlaceholder: "pick one...",
    selectFromListPlaceholder: "select from list...",
    firstResponseTooltipText: "Select your first response",
    locatedSomewhereElseLabel: "I\u2019m currently located somewhere else.",
    q1AnswerText1: "We think of our office first as",
    q1AnswerText2: "second as",
    q1AnswerText3: "and third as",
    q1Option1Text: "a second home for our people",
    q1Option2Text: "a driver of an organisational change",
    q1Option3Text: "a place for focus work",
    q1Option4Text: "an incubator for the next big idea",
    q1Option5Text: "a tool to acquire great talent",
    q1Option6Text: "a showcase for our brand",
    q1Option7Text: "a space for growth and learning",
    q1Option8Text: "a place for people to meet and come together",
    q1Option9Text: "a necessary cost we try to minimise",
    q2AnswerText1: "People join us first because of our",
    q2AnswerText2: "second because of our",
    q2AnswerText3: "and third because of our",
    q2Option1Text: "company culture",
    q2Option2Text: "competitive salaries",
    q2Option3Text: "company reputation",
    q2Option4Text: "benefits and perks",
    q2Option5Text: "flexible work schedules",
    q2Option6Text: "people and leadership",
    q2Option7Text: "office environment",
    q2Option8Text: "purpose and mission",
    q3AnswerText1: "We hire employees first for",
    q3AnswerText2: "second for",
    q3AnswerText3: "and third for",
    q3Option1Text: "skills",
    q3Option2Text: "experience",
    q3Option3Text: "cultural fit",
    q3Option4Text: "credentials",
    q3Option5Text: "relationships",
    q3Option6Text: "curiosity / inquisitiveness",
    q4AnswerText: "We will",
    q4Option1Text: "grow slightly each year",
    q4Option2Text: "grow significantly each year",
    q4Option3Text: "stay about the same",
    q4Option4Text: "shrink slightly each year",
    q4Option5Text: "hard to say - it\u2019s unpredictable",
    q5AnswerText: "We\u2019re usually working",
    q5Option1Text: "from 9-5",
    q5Option2Text: "from morning until...late",
    q5Option3Text: "whenever they want, as long as it\u2019s a certain amount",
    q5Option4Text: "whenever they want, as often as they want",
    q6AnswerText: "We think",
    q6Option1Text: "everyone should have their own",
    q6Option2Text: "it can be better to share unassigned desks",
    q7Option1Text: "Always from an individual desk",
    q7Option2Text: "Primarily from an individual desk with some meetings or other activities",
    q7Option3Text: "Even split between a desk and somewhere else in the office",
    q7Option4Text: "Primarily moving from space to space with occasional touchdowns at desks",
    q7Option5Text: "Always moving from space to space",
    q8Option1Text: "Business professional",
    q8Option2Text: "Mostly professional except for special occasions",
    q8Option3Text: "Business casual, with some days dressier and some days not",
    q8Option4Text: "Mostly casual except for special occasions",
    q8Option5Text: "Casual",
    q9Option1Text: "Always from the office",
    q9Option2Text: "Mostly from the office",
    q9Option3Text: "Split our time between the office and remote",
    q9Option4Text: "Mostly work remote",
    q9Option5Text: "Always work remote",
    q10Option1Text: "Dynamic and energetic",
    q10Option2Text: "Energetic, with pockets of quiet",
    q10Option3Text: "It depends - a mix of both",
    q10Option4Text: "Quiet, with some dynamic times",
    q10Option5Text: "Quiet and tranquil",
    q11Option1Text: "Just the basics, enough to keep people going",
    q11Option2Text: "The basics plus a few upgrades",
    q11Option3Text: "The basics and a place where people can gather socially",
    q11Option4Text: "Something really nice, a destination within the office",
    q11Option5Text: "Something cool and differentiating - the first thing you show a visitor",
    q12AnswerText: "I\u2019m",
    q12OptionClientText: "an existing CBRE client",
    q12OptionProfessionalText: "a CBRE professional",
    q12OptionLeadText: "someone else",
    q13AnswerText1: "We will have",
    q13AnswerText2: "employees in our office.",
    q13AnswerHelperText: "*Hint: This is usually the midpoint of your lease or about 2-5 years from now.",
    q14AnswerText1: "We will spend",
    q14AnswerText2: "of our time working in teams.",
    q15AnswerText1: "On average, we plan to spend",
    q15AnswerText2: "days per week in the office.",
    q16AnswerText1: "Our office will be in the city of",
    q16AnswerText2: ".",
    q17AnswerText1: "We work primarily in the",
    q17AnswerText2: "sector.",
    q18AnswerText1: "I\u2019m currently located in",
    q18AnswerText2: ".",
    // Quiz Responses (questionUnitMap.js)
    q1ResponseText: "We\u2019ll define an office that matches your vision.",
    q2ResponseText: "Attractive mix!",
    q3ResponseText: "Sounds nice - where do we apply?",
    q4ResponseText: "Great! We will make sure the office fits.",
    q5Response1Text: "Sounds good!",
    q5Response2Text: "We tend to work overtime, too.",
    q5Response3Text: "Sounds great!",
    q5Response4Text: "Sounds awesome!",
    q6Response1Text: "We\u2019ll define a space that prioritises personal space.",
    q6Response2Text: "We\u2019ll define a space that\u2019s flexible.",
    q12ResponseLeadText: "You came to the right place.",
    q12ResponseClientText: "Perfect!",
    q12ResponseProfessionalText: "Thanks!",
    // Industry Codes (industryCodes.js)
    animalProd: "Animal production and aquaculture",
    forestry: "Forestry and logging",
    fishingHunting: "Fishing, hunting and trapping",
    agForestSupport: "Agriculture and forestry support activities",
    oilGas: "Oil and gas extraction",
    energy: "Energy (Gas, Oil, etc.)",
    mining: "Mining, except oil and gas",
    supportMining: "Support activities for mining",
    utilities: "Utilities",
    buildingConstruct: "Construction of buildings",
    heavyCivilConstruct: "Heavy and civil engineering construction",
    specialtyContract: "Specialty trade contractors",
    foodManufac: "Food Manufacturing",
    beverageTobaccoManufac: "Beverage and tobacco product manufacturing",
    textile: "Textile mills",
    textileProduct: "Textile product mills",
    apparelManufac: "Apparel manufacturing",
    leatherManufac: "Leather and allied product manufacturing",
    woodManufac: "Wood product manufacturing",
    paperManufac: "Paper manufacturing",
    printingSupport: "Printing and related support activities",
    printingReproduc: "Printing/Reproductions",
    petroleumCoal: "Petroleum and coal products manufacturing",
    chemicalManufac: "Chemical manufacturing",
    chemicals: "Chemicals",
    pharma: "Pharmaceuticals",
    cleaningManufac: "Cleaning Manufacturing",
    plasticsRubberManufac: "Plastics and rubber products manufacturing",
    nonmetallicManufac: "Nonmetallic mineral product manufacturing",
    primaryMetalManufac: "Primary metal manufacturing",
    fabricatedMetalManufac: "Fabricated metal product manufacturing",
    machineryManufac: "Machinery manufacturing",
    manufac: "Manufacturing",
    computerElectronicManufac: "Computer and electronic product manufacturing",
    electricalApplianceManufac: "Electrical equipment and appliance mfg.",
    transportEquipManufac: "Transportation equipment manufacturing",
    aerospaceDefense: "Aerospace/Defense",
    furnitureManufac: "Furniture and related product manufacturing",
    miscManufac: "Miscellaneous manufacturing",
    merchantWholesaleDurable: "Merchant wholesalers, durable goods",
    merchantWholesaleNondurable: "Merchant wholesalers, nondurable goods",
    electronicMarket: "Electronic markets and agents and brokers",
    motorVehiclePartsDealers: "Motor vehicle and parts dealers",
    furnitureFurnishingStores: "Furniture and home furnishings stores",
    electronicApplianceStores: "Electronics and appliance stores",
    electronics: "Electronics",
    buildingGardenSupplyStores: "Building material and garden supply stores",
    foodBeverageStores: "Food and beverage stores",
    groceryStores: "Grocery Stores",
    beerWineLiquorStores: "Beer, Wine, and Liquor Stores",
    healthCareStores: "Health and personal care stores",
    gasStations: "Gasoline stations",
    clothingAccessoriesStores: "Clothing and clothing accessories stores",
    clothingTextiles: "Clothing/Textiles",
    jewelryFurs: "Jewelry & Furs",
    sportsHobbyMusicBookStores: "Sports, hobby, music instrument, book stores",
    genMerchandiseStores: "General merchandise stores",
    miscStoreRetailers: "Miscellaneous store retailers",
    officeProducts: "Office Products",
    retailSales: "Retail Sales",
    nonstoreRetails: "Nonstore retailers",
    airTransport: "Air transportation",
    travelRelated: "Travel Related (Airlines, Agents, Mass Transit)",
    railTransport: "Rail transportation",
    waterTransport: "Water transportation",
    truckTransport: "Truck transportation",
    transitTransport: "Transit and ground passenger transportation",
    pipelineTransport: "Pipeline transportation",
    scenicTransport: "Scenic and sightseeing transportation",
    supportTransport: "Support activities for transportation",
    postalService: "Postal service",
    courierMessenger: "Couriers and messengers",
    shippingDelivery: "Shipping/Delivery",
    warehousingStorage: "Warehousing and storage",
    warehouseDistrib: "Warehouse/Distribution",
    publishingNoInternet: "Publishing industries, except Internet",
    publishing: "Publishing",
    motionPicSoundRecordingIndustries: "Motion picture and sound recording industries",
    entertainment: "Entertainment (Film, TV, Music, etc.)",
    infoServicesMarketResearch: "Information Services/Market Research",
    broadcastingNoInternet: "Broadcasting, except Internet",
    telecom: "Telecommunications",
    tech: "Technology",
    dataProcessingHostingServices: "Data processing, hosting and related services",
    otherInfoServices: "Other information services",
    financeInsurance: "Finance and Insurance",
    monetaryAuthorities: "Monetary authorities-central bank",
    creditIntermediation: "Credit intermediation and related activities",
    banking: "Banking",
    securitiesContractsInvestments: "Securities, commodity contracts, investments",
    financialServicesNoBanking: "Financial Services (Non-banking)",
    insuranceCarriersRelated: "Insurance carriers and related activities",
    insurance: "Insurance",
    fundsTrustsFinancialVehicles: "Funds, trusts, and other financial vehicles",
    realEstate: "Real Estate",
    rentalLeasingServices: "Rental and leasing services",
    automotive: "Automotive",
    consumerGoods: "Consumer Goods",
    lessorsNonfinancialIntangible: "Lessors of nonfinancial intangible assets",
    professionalTechnicalServices: "Professional and technical services",
    legalServices: "Legal Services",
    accounting: "Accounting",
    architectureEngineering: "Architecture/Engineering",
    specializedDesignServices: "Specialised Design Services",
    compRelatedServices: "Computer Related Services",
    mgmtConsulting: "Management Consulting",
    scientificResearch: "Scientific Research",
    adsMarketingPR: "Advertising/Marketing/Public Relations",
    otherProfSciTechServices: "Other Professional, Scientific, and Technical Services",
    companyEnterpriseMgmt: "Management of companies and enterprises",
    adminSupportServices: "Administrative and support services",
    employmentAgencyRecruiters: "Employment Agency/Recruiters",
    securityPrivateInvestigation: "Security/Private Investigation",
    wasteMgmtRemediationServices: "Waste management and remediation services",
    educationServices: "Educational services",
    education: "Education",
    ambulatoryHealthCareServices: "Ambulatory health care services",
    healthCareRelated: "Health Care Related",
    hospitals: "Hospitals",
    nursingResidentialCareFacilities: "Nursing and residential care facilities",
    socialAssistance: "Social assistance",
    performingArtsSpectatorSports: "Performing arts and spectator sports",
    museumsHistoricalSitesZoosParks: "Museums, historical sites, zoos, and parks",
    fineArtsGalleriesMuseums: "Fine Arts (Galleries, Museums)",
    amusementsGamblingRec: "Amusements, gambling, and recreation",
    accommodation: "Accommodation",
    foodDrinkingServices: "Food services and drinking places",
    restaurantHotel: "Restaurant/Hotel",
    repairMaintenance: "Repair and maintenance",
    industrialProductsHeavy: "Industrial Products (Heavy Industry)",
    personalLaundryServices: "Personal and laundry services",
    membershipAssocOrgs: "Membership associations and organisations",
    nonprofit: "Non-profit",
    privateHouseholds: "Private households",
    execLegisGenGvt: "Executive, legislative and general government",
    gvt: "Government",
    justicePublicOrderSafetyActivities: "Justice, public order, and safety activities",
    hrAdminPrograms: "Administration of human resource programmes",
    environmentAdminPrograms: "Administration of environmental programmes",
    environmental: "Environmental",
    communityHousingProgramAdmin: "Community and housing programme administration",
    econProgramAdmin: "Administration of economic programmes",
    spaceResearchTech: "Space research and technology",
    natlSecurityIntlAffairs: "National security and international affairs"
};


var $21c0d238768267d5$exports = {};
$21c0d238768267d5$exports = {
    // AboutPageHero
    aboutPageHeroImgAlt: "Illustration of people moving into an office on the About page of Spacer by CBRE",
    aboutPageHeroTitle: "What can Spacer do for you?",
    // AboutPageContent
    aboutPageContentEndSectionTitle: "Ready to get started?",
    aboutPageProgramPreviewImgAlt: "Preview of a results page space programme from the homepage of Spacer by CBRE",
    aboutPageVideoTitle: "How it works",
    // About Page Content (aboutPageContent.js)
    aboutPageContent1Title: "Define the perfect office",
    aboutPageContent1Text: "The perfect office space can help you hire competitive talent, keep your employees healthy, reduce operating costs, or create conditions for the next big idea. Spacer is the perfect place to begin any real estate decision because it helps you prioritise your goals as an organisation, and see space recommendations based on those goals.\n Spacer was created by taking the expertise of CBRE\u2019s Workplace team, a group with over twenty years of experience helping companies plan the perfect office, and combining it with a free, internet-based technology that is available to anyone.",
    aboutPageContent1ImgAlt: "Illustration of people talking on the About page of Spacer by CBRE",
    aboutPageSpacerSupportLink: "spacersupport@cbre.com",
    aboutPageContent2Title: "Spacer is easy to use:",
    aboutPageContent2List1: "Start by answering a 17-question quiz about your organisational goals and values. These answers will inform the office profile we categorise you as.",
    aboutPageContent2List2: "Receive a recommended list of space types and sizes that meet your unique needs, also known as a space programme.",
    aboutPageContent2List3: "Visualise a space similar to yours in 2D and 3D with Floored Plans.",
    aboutPageContent2List4: "Save your programme to use as you search for the perfect office on the market.",
    aboutPageContent2List5: "Let a CBRE professional hunt down an office space that matches your programme, a service that is free of charge!",
    aboutPageContent2Text: "For more questions about how Spacer can jump start your office search process, contact us at ",
    aboutPageContent2ImgAlt: "Illustration of a girl working at a desk on the About page of Spacer by CBRE"
};


var $8dc68379caf7b1ed$exports = {};
$8dc68379caf7b1ed$exports = {
};


var $8e89b822f11fff00$exports = {};
$8e89b822f11fff00$exports = {
    blogHomeTitle: "Office Planning Insights",
    // blog tags
    blogTagAllArticles: "All Articles",
    blogTagSizeAndFit: "Size & Fit",
    blogTagOfficeCulture: "Office Culture",
    blogTagSpaceAndDesign: "Space & Design",
    blogTagWorkplaceTrends: "Workplace Trends"
};


var $5febac30b9780ab5$exports = {};
$5febac30b9780ab5$exports = {
    // LandingPageHero
    landingPageHeroTitle: "Bestimmen Sie den Fl\xe4chenbedarf Ihrer k\xfcnftigen Arbeitsumgebung.",
    landingPageHeroSubtitle: "Die Arbeitswelt ver\xe4ndert sich kontinuierlich. Mit unserem kostenlosen Tool ermitteln Sie in wenigen Minuten ihr individuelles Fl\xe4chenprogramm.",
    // landingPageHeroImgAlt: no translation yet
    landingPageImage: "/png/homepage-results-page-in-browser-spacer-by-cbre.png",
    // LandingPageContent
    landingPageContentTitle: "Und so funktioniert\xb4s",
    // StepsSummary
    stepsSummarySubtitle1: "Schritt 1 -",
    stepsSummaryTitle1: "Erz\xe4hlen Sie uns von Ihrem Unternehmen",
    stepsSummaryText1: "Helfen Sie uns Aufgaben und Ziele Ihres Unternehmens zu verstehen, damit wir Sie optimal beraten k\xf6nnen.",
    // stepsSummaryImgAlt1: no translation yet
    stepsSummarySubtitle2: "Schritt 2 -",
    stepsSummaryTitle2: "Zu Ihren Ergebnissen",
    stepsSummaryText2: "Basierend auf Ihren Eingaben, erhalten Sie eine empfohlene Fl\xe4chenangabe sowie eine Aufstellung passender Raumtypen.",
    // stepsSummaryImgAlt2: no translation yet
    stepsSummarySubtitle3: "Schritt 3 -",
    stepsSummaryTitle3: "Finden Sie Ihren perfekten B\xfcrotyp",
    stepsSummaryText3: "Speichern Sie Ihre Ergebnisse, um darauf zur\xfcckgreifen zu k\xf6nnen. Gerne k\xf6nnen Sie das CBRE-Team kontaktieren, damit unsere Workplace-Spezialisten Sie bei der Suche nach Ihrem perfekten B\xfcro unterst\xfctzen k\xf6nnen.",
    // stepsSummaryImgAlt3: no translation yet
    // LandingPageSecondaryHero
    // landingPageSecondaryHeroImgAlt: no translation yet
    landingPageSecondaryHeroTitle: "Erz\xe4hlen Sie uns ein wenig \xfcber Ihr Unternehmen und wir sagen Ihnen, wie viel Fl\xe4che Sie ben\xf6tigen."
};


var $a0628406fef2231a$exports = {};
$a0628406fef2231a$exports = {
    // Navbar
    // spacerLogoAlt: no translation yet
    linkToAboutPageText: "\xdcber",
    linkToBlogPageText: "Einblicke",
    // TakeOfficeSpaceQuizButton
    sizeMyOfficeButtonDefaultLinkText: "Starten Sie hier",
    flooredPlanRequestLinkText: "Grundriss anfordern",
    // Footer
    // footerCBRELogoAlt: no translation yet
    // footerFacebookIconAlt: no translation yet
    // footerTwitterIconAlt: no translation yet
    // footerLinkedinIconAlt: no translation yet
    footerHeaderQuestionsText: "Haben Sie noch Fragen?",
    footerHeaderAboutText: "Was ist Spacer?",
    footerHeaderMoreText: "Mehr",
    footerLinkBlogText: "Einblicke",
    footerLinkWhatIsSpacerText: "\xdcber",
    footerLinkWorkplaceText: "Entdecken Sie unsere Workplace Services in Deutschland",
    footerLinkWorkplaceTextForDE: "Entdecken Sie unsere Workplace Services in \xd6sterreich",
    footerLinkTermsText: "Nutzungsbedingungen",
    footerLinkPrivacyText: "Datenschutzbestimmungen",
    footerWorkplaceLink: "https://www.cbre.de/de-de/dienstleistungen/nutzer/arbeitswelten-und-raumkonzepte",
    footerWorkplaceLinkForDE: "https://www.cbre.at/de-at/dienstleistungen/sektoren/bueros",
    footerPrivacyLink: "https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy",
    footerLinkedinLink: "https://www.linkedin.com/showcase/cbre-workplace-strategy/",
    // Contact (contact.js)
    spacerSupportEmail: "spacersupport@cbre.com",
    // ErrorPage
    errorOopsText: "Uups!",
    error404Text: "Wir k\xf6nnen die gesuchte Seite nicht finden.",
    error500Text: "Es ist etwas schief gelaufen.",
    errorText: "Error",
    errorReturnText: "Zur\xfcck zu Spacer",
    errorAltText: "",
    // Measurement Units (units.js)
    SF: "ft \xb2",
    SM: "m\xb2",
    USF: "NFft\xb2",
    USM: "NFm\xb2",
    RSF: "MFft\xb2",
    RSM: "MFm\xb2",
    NSF: "Netto ft\xb2",
    NSM: "Netto m\xb2",
    NIA: "Netto Innenfl\xe4che",
    foot: "fu\xdf",
    feet: "fu\xdf",
    footage: "Aufnahme",
    "sqft.": "Quadratfu\xdf",
    meter: "meter",
    meters: "meter",
    "sqm.": "qm",
    Tsubo: "Tsubo",
    // SF Types Adjectives (calculator.js)
    Usable: "Differenz",
    Rentable: "Mietfl\xe4che",
    Net: "netto",
    // documentDataCopy needs translation: page titles and metatag texts
    landingPageTitle: "Planen Sie Ihr perfektes B\xfcro in 15 Minuten - Spacer von CBRE",
    aboutPageTitle: "Erfahren Sie, wie unser Fl\xe4chenermittlungstool fuktioniert - Spacer von CBRE",
    termsPageTitle: "Allgemeine Gesch\xe4ftsbedingungen - Spacer von CBRE",
    quizPageTitle: "Bestimmen Sie die Gr\xf6\xdfe Ihres B\xfcros in 15 Minuten - Spacer von CBRE",
    resultsPageTitle: "Schauen Sie sich die Empfehlung f\xfcr Ihr B\xfcro an - Spacer von CBRE",
    profileComparisonPageTitle: "Vergleichen Sie Ihre Anforderungen - Spacer von CBRE"
};


var $5848716b615c4cac$exports = {};
$5848716b615c4cac$exports = {
    // Results
    resultsWarningMessage: "Sind Sie sicher, dass Sie die Seite verlassen m\xf6chten ? Sie k\xf6nnen Daten verlieren, die Sie nicht gespeichert haben.",
    // ResultsHeader
    resultsHeaderExportPDFButtonText: "PDF exportieren",
    resultsHeaderSendButtonText: "Ergebnisse zusenden",
    resultsHeaderClipboardBoxDescription: "Ergebnisse k\xf6nnen per Link angesehen und bearbeiten werden",
    resultsHeaderContactButtonText: "Einen Workplace-Experten kontaktieren",
    // EmailWallSection
    emailWallTitle: "Wir haben noch mehr f\xfcr Sie.",
    emailWallSubtitle: "Teilen Sie uns Ihre Kontaktdaten mit, damit wir Ihnen eine vollst\xe4ndige Fl\xe4chenberechnung erstellen k\xf6nnen.",
    emailWallFirstNamePlaceholder: "Vorname",
    emailWallLastNamePlaceholder: "Nachname",
    emailWallEmailPlaceholder: "E-Mail",
    emailWallCBREEmailPlaceholder: "E-Mail Ihres CBRE-Experten (wahlweise)",
    // emailWallLeasingProfessionalPlaceholder: no translation yet,
    emailWallConnectMeText: "Nehmen Sie Kontakt mit einem CBRE Workplace Spezialisten auf. Keine E-Mail-Newsletter oder Spam, versprochen!",
    emailWallContactNoticeText: "Das Spacer Team wird Sie vielleicht kontaktieren, damit Sie unseren Service bestm\xf6glich nutzen k\xf6nnen. Kein Spam, versprochen!",
    emailWallResultsButtonText: "Vollst\xe4ndige Ergebnisse ansehen",
    // emailWallImgAltText: no translation yet
    emailWallFirstNameInvalid: "Bitte geben Sie Ihren Vornamen ein.",
    emailWallLastNameInvalid: "Bitte geben Sie Ihren Nachnamen ein.",
    emailWallEmailInvalid: "Bitte geben Sie Ihre E-Mail Adresse ein.",
    // CopyToClipboardBox
    clipboardBoxCopyText: "Kopieren",
    clipboardBoxCopiedText: "Kopiert",
    // FormModal
    formModalFindSpaceHeader: "Mit der B\xfcrosuche beginnen",
    formModalFindSpaceBody: "Spacer ist ein schnelles und einfaches Tool, um Ihr B\xfcroumfeld zu analysieren. Wenn Sie spezifischere Beratung w\xfcnschen, unterst\xfctzt Sie das CBRE Worklpace Team gerne. F\xfcllen Sie das Formular aus und ein Workplace Experte wird innerhalb der n\xe4chsten 48 Stunden einen Termin mit Ihnen vereinbaren.",
    formModalFindSpaceSuccessMessage: "Ihre Anfrage wurde versendet.",
    // SuccessModal
    successModalTitle: "Erfolg",
    // ContactForm
    contactFormFirstNameLabel: "Vorname",
    contactFormLastNameLabel: "Nachname",
    contactFormEmailLabel: "Email B\xfcro",
    contactFormPhoneLabel: "Telefonnummer",
    contactFormMessageLabel: "Wonach suchen Sie genau?",
    contactFormSubmitText: "Einreichen",
    // AcceptTermsText
    acceptTermsText: "Ich akzeptiere die Nutzungsbedingungen. F\xfcr mehr Informationen \xfcber die Verwendung Ihrer Daten verweisen wir auf die CBRE Datenschutzbestimmungen.",
    privacyPolicyLink: "https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy",
    // Form
    formErrorText: "Uups, das ist nicht durchgegangen. Bitte versuchen Sie es noch einmal.",
    formEmailInvalid: "Bitte geben Sie Ihre E-Mail Adresse an.",
    // FormInput
    formInputOptionalText: " (wahlweise)",
    // LegalForm
    legalFormCheckboxText: "CBRE darf mich im Zusammenhang mit meiner Nutzung von Spacer kontaktieren.",
    legalFormContactWarningText: "Das Spacer Team wird Sie vielleicht kontaktieren, damit Sie unseren Service bestm\xf6glich nutzen k\xf6nnen. Kein Spam, versprochen!",
    // NextStepsSection
    nextStepsSectionSubtitle: "Sind Sie bereit f\xfcr den n\xe4chsten Schritt?",
    nextStepsSectionTitle: "Finden Sie Ihr perfektes B\xfcro.",
    nextStepsSectionButtonText: "Setzen Sie sich mit einem unserer Workplace-Experten in Verbindung",
    // Profile
    resultsProfileSummaryTitle: "Ihr B\xfcro ist...",
    resultsProfileTooltipText: "Jedes Profil basiert auf Annahmen zu Unternehmensdaten und g\xe4ngigen Branchenrichtlinien. Die Details m\xfcssen durch das CBRE Workplace Team an die jeweilige Unternehmensstruktur angepasst werden.",
    // Program
    programSaveConfirmationBoxText: "Schon fertig! Wir haben Ihnen per Email einen Link zu Ihren Ergebnissen geschickt. Viel Spa\xdf!",
    programExamplePlansTitle: "Beispiel Grundriss",
    programExamplePlansSubtitle: "Spielen Sie mit interaktiven Grundrissen, die Ihrem Profil entsprechen. Sie k\xf6nnen sie sogar in 3D erkunden!",
    programTooMuchTinkerWarning: "Uups! Es sieht so aus, als w\xfcrden Sie sich au\xdferhalb der Profilauswahl bewegen. Vielleicht sollten Sie <1>das Quiz wiederholen</1>, oder das CBRE Workplace Team kontaktieren <3>{{email}}</3>.",
    programDisclaimer: 'Spacer" von CBRE wird wie gesehen in der bereitgestellten Form (\u201Eas is\u201C und \u201Eas available\u201C) ohne \xdcbernahme einer Gew\xe4hr zur Verf\xfcgung gestellt. Alle Ergebnisse, die durch Ihre Nutzung von "Spacer" erzeugt werden, dienen nur der Veranschaulichung und spiegeln keine individuellen Empfehlungen f\xfcr Raumgestaltungen oder Mietvertragslaufzeiten wider. Die jeweiligen Empfehlungen f\xfcr Raumgestaltungen k\xf6nnen stark variieren und h\xe4ngen von vielen Faktoren ab, die "Spacer" nicht ber\xfccksichtigt. Mit der Nutzung von "Spacer" oder eines Reports, der durch die Nutzung von "Spacer" generiert wird, akzeptieren Sie unsere Nutzungsbedingungen (\u201ETerms of Service\u201C) sowie unsere Datenschutzerkl\xe4rung (\u201EPrivacy Policy\u201C) , auf die sie unten folgenden Links abrufen k\xf6nnen: https://workplace.cbre.com/termsOfService und https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy. 2018 CBRE, Inc. Alle Rechte bleiben CBRE vorbehalten.',
    programMetricsTitle: "Programm-Messwerte",
    programMetricsSubtitle: "Diese Zahlen beschreiben Ihr Arbeitsumfeld.",
    programDetailsSectionTitle: "Passen Sie Ihren Bedarf an",
    programDetailsSectionSubtitle: "Sie k\xf6nnen Ihre Angaben manuell anpassen.",
    programRevertButtonText: "Zur\xfcck",
    programSaveButtonText: "\xc4nderungen speichern",
    programSavedButtonText: "Saved",
    // ProgramAssumptions
    programAssumptionsRecommendedOfficeSizeText: "Indikative B\xfcrogr\xf6\xdfe",
    programAssumptionsProfileText: "Profil",
    programAssumptionsHeadcountText: "Mitarbeiterzahl",
    programAssumptionsHeadcountFollowingText: "Mitarbeiter",
    programAssumptionsCollabText: "Kollaboration",
    programAssumptionsCirculationText: "Verkehrsfl\xe4che",
    programAssumptionsAvgDaysText: "Durchschnittliche Tage im B\xfcro",
    programAssumptionsAvgDaysFollowingText: "pro Woche",
    programAssumptionsAvgDaysPerWeekText: "Durchschnittliche Tage im B\xfcro pro Woche",
    // ProgramHeroForPrint
    printNIAText: "Netto-Innenfl\xe4che",
    printUSFText: "Nutzbare Quadratmeter",
    printRSFText: "Vermietbare Quadratmeter",
    printDescText: "Basierend auf Ihren Angaben {{lossFactorPercentage}}% {{factorType}} in {{city}}, empfehlen wir insgesamt-",
    printFitFactorText: "Eignungsfaktor",
    printLossFactorText: "Verlustfaktor",
    // BarChart
    barChartIndivSubtitle: "Einzelarbeitsplatz",
    barChartGroupSubtitle: "Gruppenarbeitsplatz",
    barChartAmenitySubtitle: "Sonderfl\xe4che",
    // TabbedProgramBarChart
    tabbedBarChartMeSubtitle: "Einzelarbeitspl\xe4tze",
    tabbedBarChartGroupSubtitle: "Gruppenarbeitspl\xe4tze",
    tabbedBarChartAmenitySubtitle: "Komfortbereich",
    // SpaceCategoryBreakdown
    spaceCatBreakdownSubtitle: "Eine Fl\xe4chenart zur Anpassung ausw\xe4hlen",
    // SpaceCategoryBreakdownMobile
    spaceCatBreakdownMobileMeTitle: "Einzelarbeitsplatz",
    spaceCatBreakdownMobileWeTitle: "Gruppenarbeitsplatz",
    spaceCatBreakdownMobileAmenityTitle: "Sonderfl\xe4che",
    spaceCatBreakdownMobileMeSubtitle: "f\xfcr Einzelarbeit",
    spaceCatBreakdownMobileWeSubtitle: "f\xfcr die Zusammenarbeit",
    spaceCatBreakdownMobileAmenitySubtitle: "f\xfcr alles andere",
    spaceCatBreakdownMobileNIATotalTitle: "Gesamt Netto-Innenfl\xe4che",
    spaceCatBreakdownMobileTotalTitle: "Gesamtfl\xe4che",
    spaceCatBreakdownMobileCirculationText: "Verkehrsfl\xe4che",
    // SpaceCategoryDropdown
    spaceCatDropdownMeText: "Einzelarbeitsplatz",
    spaceCatDropdownWeText: "Gruppenarbeitsplatz",
    spaceCatDropdownAmenityText: "Sonderfl\xe4che",
    // SidebarInfo
    sidebarInfoMeTitle: "Einzelarbeitspl\xe4tze",
    sidebarInfoWeTitle: "Gruppenarbeitspl\xe4tze",
    sidebarInfoAmenityTitle: "Komfortbereich",
    // Space Category Descriptions (spaceCategoryDescription.js)
    spaceCatMeDesc: "Fl\xe4chen f\xfcr Einzelarbeit. Lassen Sie Ihre Mitarbeiter entscheiden, wo und wie sie arbeiten m\xf6chten und erh\xf6hen Sie so die Mitarbeiterzufriedenheit.",
    spaceCatWeDesc: "Raum f\xfcr Kollaboration und Teamarbeit. In einer Zeit in der Arbeit \xfcberall stattfinden kann, ist es wichtig, verschiedene Bereiche f\xfcr verschiedene Aufgaben anzubieten.",
    spaceCatAmenityDesc: "Eine Fl\xe4che, die das Arbeiten unterst\xfctzt. Komfortbereiche sind Orte zur Entspannung und f\xfcr den sozialen Austausch. Aber auch notwendige Raumelemente wie Lagerfl\xe4chen sind unter dieser Kategorie zusammengefasst. Hochwertige Komfortbereiche verwandeln Ihr B\xfcro in einen Ort, an dem Ihre Angestellten - sowohl heute als auch zuk\xfcnftig - gerne ihre Zeit verbringen.",
    // Suggested Custom Amenities (suggestedCustomAmenityUnitMap.js)
    audioVisualCustom: "Audio / Visuell",
    dataCenterCustom: "Data Center",
    buildingSupportCustom: "Geb\xe4udedienste - Sicherheit und Versorgung",
    foodServiceCustom: "Vollst\xe4ndiger Gastronomieservice",
    kitchenCustom: "K\xfcche",
    serveryCustom: "Speisenausgabe",
    execDiningCustom: "Casino",
    grabNGoCustom: '"To Go" - kleine Verkaufsfl\xe4che',
    juiceCoffeeBarCustom: "Saftbar/Caf\xe9",
    childCareCustom: "Kinderbetreuung",
    fitnessCenterCustom: "Fitnesscenter",
    healthCenterCustom: "Gesundheitszentrum",
    mailCenterCustom: "Poststelle",
    commercialPrintCustom: "Druckerei",
    centralCafeCustom: "Caf\xe9",
    securityCtrlCustom: "Security Raum",
    auditoriumCustom: "H\xf6rsaal",
    dryCleaningLaundryCustom: "Chemische Reinigung / W\xe4scherei",
    confCenterCustom: "Konferenzzentrum",
    multiPurpTrainingCustom: "Mehrzweck-/Schulungsraum",
    informalCollabCustom: "Informelle Kollaboration",
    touchdownTeamCustom: "Touchdown/Teambereiche",
    // Suggested Custom Amenity Units (spaceUnit.js)
    seats: "Arbeitsplatz",
    seats_plural: "Arbeitspl\xe4tze",
    rooms: "Raum",
    rooms_plural: "R\xe4ume",
    areas: "Bereich",
    areas_plural: "Bereiche",
    units: "Einheit",
    units_plural: "Einheiten",
    // Predefined Amenities (spaceUnitMap.js) - Shared Space Units
    focusRoomDefined: "Fokus-Raum",
    fileRoomDefined: "Archiv/Aktenraum",
    centralReceptionHubDefined: "Zentraler Empfangsbereich",
    smOfficeDefined: "B\xfcro klein",
    regOfficeDefined: "B\xfcro normal",
    benchDesk5Defined: "160 cm Schreibtisch",
    benchDesk6Defined: "180 cm Schreibtisch",
    meetingRoom4Defined: "Besprechungsraum (4 Personen)",
    meetingRoom6Defined: "Besprechungsraum (6 Personen)",
    meetingRoom8Defined: "Besprechungsraum (8 Personen)",
    meetingRoom12Defined: "Besprechungsraum (12 Personen)",
    meetingRoom15Defined: "Besprechungsraum (15 Personen)",
    semiEnclosedMeetingBooth4Defined: "Halboffene Besprechungszone (4 Personen)",
    openCollabSpace4to6Defined: "Offene Kollaborationsfl\xe4che (4 - 6 Personen)",
    contemplationSpaceDefined: "Ruhe-/Gebetsraum",
    mainITEquipRoomDefined: "Hauptserverraum",
    receptionAreaDefined: "Empfangsbereich",
    cafeFoodServiceDefined: "Caf\xe9 / Gastronomie",
    teamStorageDefined: "Lager / Archiv",
    coatClosetsDefined: "Garderobe",
    genStorageDefined: "Lagerraum allgemein",
    centralisedCopyPrintMailDefined: "Kopierraum",
    specialResourceAreaDefined: "Sonderfl\xe4che",
    personalStorageDefined: "pers\xf6nliche Schlie\xdff\xe4cher (Locker)",
    storageITSpaceDefined: "IT Lagerraum",
    secondaryServerRoomDefined: "Zweitraum Server/Telekommunikation",
    mothersRoomDefined: "Eltern / Kind Raum",
    buildITSpaceDefined: "IT Fl\xe4che",
    workerCouncilOffice2Defined: "Betriebsrat-B\xfcro (2 Personen)",
    securityCtrlRoomDefined: "Security Raum",
    centralisedMailDefined: "Postraum",
    visitorCoatLuggageRoomDefined: "Besucher Garderobe / Gep\xe4ckraum",
    wellnessRoomDefined: "Wellness Raum",
    internalStairDefined: "Innentreppe",
    commercialPrintRoomDefined: "Druckerei",
    buildingSupportServicesAreaDefined: "Geb\xe4udedienste - Sicherheit und Versorgung",
    // Predefined Amenities (spaceUnitMap.js) - US_SMALL and US_REGULAR
    officeDefined: "Standardb\xfcro",
    lgOfficeDefined: "Gr\xf6\xdferes B\xfcro",
    smWorkstationDefined: "Bench klein",
    mdWorkstationDefined: "Bench normal",
    lgWorkstationDefined: "Bench gro\xdf",
    huddleRoomDefined: "Huddle Raum",
    dispersedCopyPrintAreaDefined: "Kopieren/Drucken",
    smMeetingRoomDefined: "Kleiner Besprechungsraum",
    mdMeetingRoomDefined: "Mittelgro\xdfer Besprechungsraum",
    lgMeetingRoomDefined: "Gro\xdfer Besprechungsraum",
    xlMeetingRoomDefined: "XL-Besprechungsraum/Boardroom",
    multiPurpTrainingDefined: "Mehrzweck-/Schulungsraum",
    informalCollabDefined: "Informelle Kollaboration",
    touchdownTeamDefined: "Touchdown/Teambereiche",
    pantryVendingCoffeeAreaDefined: "Vorratsraum/Vending/Kaffee",
    workplaceStorageRoomDefined: "Lagerraum",
    employeeCoatAreaDefined: "Mitarbeiter-Garderobe",
    dispersedMailAreaDefined: "Postverteilerraum",
    lockerUnitDefined: "Schlie\xdff\xe4cher/Lockerschr\xe4nke",
    serverRoomDefined: "Hauptserverraum",
    frontDeskAreaDefined: "Empfangsbereich",
    centralCafeAreaDefined: "Caf\xe9",
    mailCenterAreaDefined: "Poststelle",
    kitchenAreaDefined: "K\xfcche",
    drawerLateralFileUnitDefined: "Rollcontainer/Apothekerschrank",
    serveryAreaDefined: "Speisenausgabe",
    juiceBarCoffeeShopAreaDefined: "Saftbar/Caf\xe9",
    diningSupportAreaDefined: "Vorbereitungsk\xfcche",
    diningAreaDefined: "Essbereich",
    grabNGoAreaDefined: '"To Go" - kleine Verkaufsfl\xe4che',
    focusRoomSharedFocus: "Fokus-Raum",
    // Predefined Amenities (spaceUnitMap.js) - UK_REGULAR
    fullFoodServiceDefined: "Vollst\xe4ndiger Gastronomieservice",
    // Predefined Amenities (spaceUnitMap.js) - APAC_REGULAR
    officeWorkMeetDefined: "Standardb\xfcro",
    lgOfficeWorkMeetDefined: "Gr\xf6\xdferes B\xfcro",
    focusDefined: "Fokus Raum",
    bench1pt6Defined: "Bench 160x80",
    bench1pt8Defined: "Bench 180x80",
    bench1pt8LDefined: "Tisch 180x80",
    banquetWorkMeetDefined: "Bank - (2p)",
    cafeTable4Defined: "Kaffeetisch (4p)",
    kitchenTable8to10Defined: "K\xfcchentisch (8-10p)",
    standingWhiteboardDefined: "Whiteboard",
    huddleRoom3Defined: "Aufenthaltsraum (3p)",
    smMeetingRoom5Defined: "kleiner Besprechungsraum (5p)",
    mdMeetingRoom8Defined: "mittlerer Besprechungsraum (8p)",
    lgMeetingRoom20Defined: "gro\xdfer Besprechungsraum (20p)",
    xlBoardroom: "XL-Besprechungsraum/Boardroom",
    wellnessRoomsDefined: "Wellness Raum",
    employeeCoatsGymLockersDefined: "Mitarbeiter-Garderobe",
    lockersDefined: "Schlie\xdff\xe4cher/Lockerschr\xe4nke",
    dispersedCopyPrintScanAreaDefined: "Kopieren/Drucken",
    hydrationPointDefined: "Versorgungsspunkt (Wasser/Tee/Kaffee)",
    centralHighDensityStorageDefined: "Zentraler Lagerraum",
    wellnessMothersRoomDefined: "Wellness Raum",
    serverHubRoomsDefined: "Server-/Patchr\xe4ume",
    buildITStoreRoomDefined: "IT-Geb\xe4ude/Lagerraum",
    simpleReceptionWaitDefined: "Empfang und Wartebereich",
    centralCafeSocialHubDefined: "Zentrales Caf\xe9",
    mailCentreDefined: "Poststelle",
    utilityStoreRoomDefined: "Lagerraum allgemein.",
    drawerLateralFileDefined: "Rollcontainer/Apothekerschrank",
    juiceBarCoffeeShopDefined: "Saftbar/Caf\xe9",
    buildingSupportServicesDefined: "Geb\xe4udedienste - Sicherheit und Versorgung",
    // Space Unit Map Descriptions (spaceUnitMap.js) - Shared Descriptions
    focusRoomDesc: "Fokus R\xe4ume sind geschlossene R\xe4ume, die dazu bestimmt sind, konzentrierte und/oder vertrauliche Arbeit f\xfcr ein bis zwei Personen zu erm\xf6glichen. Ein akustischer Schutz f\xfcr Privatsph\xe4re ist in diesen R\xe4umen von gr\xf6\xdfter Bedeutung. Fokus-R\xe4ume sind keiner Person zugeordnet und k\xf6nnen in der Regel bei Bedarf vor\xfcbergehend f\xfcr relevante Arbeiten gebucht werden.",
    fileRoomDesc: "Dieser Raum dient der Ablage von Papierakten f\xfcr Einzelpersonen und Teams. Infolge der Digitalisierung der meisten B\xfcros nimmt der Bedarf an Einzel- und Teamarchiven stark ab. Dennoch ist dies ein zentraler Ort f\xfcr gesetzlich vorgeschriebene Dokumentenkopien oder langfristige Projektunterlagen, insbesondere bei den meisten offenen B\xfcroarbeitspl\xe4tzen auf kleinem Raum.",
    centralReceptionHubDesc: "Der Empfangsbereich beinhaltet nebem dem Empfangstresen auch den Wartebereich und eine Interaktionszone sowohl f\xfcr G\xe4ste als auch f\xfcr Mitarbeiter des Unetrnehmens. Er sollte die Marke des Unternehmens einheitlich vermitteln und das gew\xfcnschte Erscheinungsbild projizieren.",
    officeDesc: "Standardb\xfcro sind private, geschlossene Arbeitsr\xe4ume f\xfcr Mitarbeiter. Sie sind ideal, um Ablenkungen zu reduzieren und den Fokus auf die Arbeit zu legen. B\xfcros sind typischerweise mit einem Schreibtisch und einem B\xfcrostuhl ausgestattet. Sie bieten unterschiedlich viel Platz f\xfcr die Aufbewahrung und Ablage pers\xf6nlicher Dinge. Die Gr\xf6\xdfe des Raumes kann je nach den dort ausge\xfcbten T\xe4tigkeiten (z. B. regelm\xe4\xdfige Besprechungen) oder Mitarbeiterstatus/Hierarchien variieren.",
    benchDeskDesc: "Benches sind offene Arbeitspl\xe4tze. Kleinere Schreibtische k\xf6nnen von Vollzeitbesch\xe4ftigten entweder vor\xfcbergehend ( in einem freien Raum) oder dauerhaft genutzt werden. Diese Arbeitspl\xe4tze sind ideal f\xfcr Mitarbeiter oder Freie Mitarbeiter geeignet, die nicht st\xe4ndig im B\xfcro sind. Einige Vorteile von diesen Arbeitspl\xe4tzen ist die offene Atmosph\xe4re im B\xfcro und die damit verbundene Zusammenarbeit. Ein Nachteil kann die L\xe4rmabstrahlung sein, wehsalb es empfohlen wird, dass offenen Arbeitsbereiche \xfcber gen\xfcgend Fokus- und Aufenthaltsr\xe4ume verf\xfcgen. Die Ablage am Arbeitsplatz ist begrenzt, da sich die Stauraumm\xf6glichkeiten auf der Fl\xe4che verteilen.",
    meetingRoomDesc: "Besprechungsr\xe4ume sind geschlossene R\xe4ume, die f\xfcr Besprechungen in Kleingruppen von 2-4 Personen vorgesehen sind. Sie sollten mit A/V-Ger\xe4ten und Whiteboards ausgestattet sein, um den Austausch zu erleichtern und akustisch gesch\xfctzt zu sein (Personen, die unmittelbar au\xdferhalb des Raumes sitzen, sollten nicht in der Lage sein, Gespr\xe4che zu h\xf6ren, die im Raum stattfinden).",
    meetingRoomDesc6: "Besprechungsr\xe4ume sind geschlossene R\xe4ume, die f\xfcr Besprechungen in Kleingruppen von 2-4 Personen vorgesehen sind. Sie sollten mit A/V-Ger\xe4ten und Whiteboards ausgestattet sein, um den Austausch zu erleichtern und akustisch gesch\xfctzt zu sein (Personen, die unmittelbar au\xdferhalb des Raumes sitzen, sollten nicht in der Lage sein, Gespr\xe4che zu h\xf6ren, die im Raum stattfinden).",
    meetingRoomDesc8: "Besprechungsr\xe4ume sind geschlossene R\xe4ume, die f\xfcr Besprechungen in Kleingruppen von 2-4 Personen vorgesehen sind. Sie sollten mit A/V-Ger\xe4ten und Whiteboards ausgestattet sein, um den Austausch zu erleichtern und akustisch gesch\xfctzt zu sein (Personen, die unmittelbar au\xdferhalb des Raumes sitzen, sollten nicht in der Lage sein, Gespr\xe4che zu h\xf6ren, die im Raum stattfinden).",
    meetingRoomDesc12: "Besprechungsr\xe4ume sind geschlossene R\xe4ume, die f\xfcr Besprechungen in Kleingruppen von 2-4 Personen vorgesehen sind. Sie sollten mit A/V-Ger\xe4ten und Whiteboards ausgestattet sein, um den Austausch zu erleichtern und akustisch gesch\xfctzt zu sein (Personen, die unmittelbar au\xdferhalb des Raumes sitzen, sollten nicht in der Lage sein, Gespr\xe4che zu h\xf6ren, die im Raum stattfinden).",
    meetingRoomDesc15: "Besprechungsr\xe4ume sind geschlossene R\xe4ume, die f\xfcr Besprechungen in Kleingruppen von 2-4 Personen vorgesehen sind. Sie sollten mit A/V-Ger\xe4ten und Whiteboards ausgestattet sein, um den Austausch zu erleichtern und akustisch gesch\xfctzt zu sein (Personen, die unmittelbar au\xdferhalb des Raumes sitzen, sollten nicht in der Lage sein, Gespr\xe4che zu h\xf6ren, die im Raum stattfinden).",
    openCollabSpace4to6Desc: "Diese Bereiche sollen kleine Gruppen (4 - 6 Personen) bei gemeinsamen Aktivit\xe4ten wie Brainstorming und zwanglosen Gespr\xe4chen zwischen Kollegen und mit Kunden unterst\xfctzen.",
    cafeFoodServiceDesc: "Das zentrale Caf\xe9 soll ein Bereich zum Essen, f\xfcr soziale Interaktion, individuelles Arbeiten und kleine Meetings sein. Funktionelle Essm\xf6bel und die Corporate Identity sollten bei der Gestaltung dieses Raumes ber\xfccksichtigt werden.",
    coatClosetsDesc: "Mitarbeiter ben\xf6tigen einen Platz, um ihre M\xe4ntel und andere sperrige Gegenst\xe4nde zu lagern, insbesondere wenn ein B\xfcro offen gestaltet ist und pers\xf6nlicher Stauraum am Schreibtisch nur begrenzt vorhanden ist. Die Garderoben sollten im gesamten B\xfcro verteilt sein, etwa an den Ausg\xe4ngen und entlang der Hauptg\xe4nge. \xdcblicherweise gibt es neben Haken zum Aufh\xe4ngen von Jacken eine Ablage f\xfcr H\xfcte etc. und eine Aufbewahrungsm\xf6glichkeit f\xfcr Koffer an der Unterseite des Wandschranks.",
    copyPrintDesc: "In einem offenen Arbeitsbereich \xfcber die gesamte Etage verteilt, erm\xf6glichen Kopier-/Druckbereiche den Mitarbeitern aus allen Bereichen einen schnellen Zugriff auf Multifunktionsger\xe4te. Die Recyclingbeh\xe4lter sollten immer bei den Kopier-/Druckbereichen aufgestellt werden, wie auch kleine Schr\xe4nke f\xfcr zus\xe4tzliches Papier und Verbrauchsmaterial.",
    specialResourceBuildingSupportAreaDesc: "Je nach Sicherheitsbed\xfcrfnisse des Unternehmens kann dies ein separierter Raum sein, in dem die Security Mitarbeiter untergebracht sind.",
    secondaryServerRoomDesc: "Serverr\xe4ume dienen zur Unterbringung der Hauptserver-Anlagen und sind unternehmensspezifisch zu bestimmen.",
    mothersRoomDesc: "Wellnessr\xe4ume (fr\xfcher Mutter-Kind-Raum genannt) bieten private R\xfcckzugsm\xf6glichkeiten. Sei es f\xfcr stillende M\xfctter oder f\xfcr Personen, die sich f\xfcr kurze Zeit aus der Arbeitsfl\xe4che zur\xfcckziehen m\xf6chten. Wellnessr\xe4ume sind in der Regel eine Notwendigkeit f\xfcr alle neuen B\xfcros, unabh\xe4ngig von Gr\xf6\xdfe und Mitarbeiterzahl.",
    visitorCoatLuggageRoomDesc: "Mitarbeiter ben\xf6tigen einen Platz, um ihre M\xe4ntel und andere sperrige Gegenst\xe4nde zu lagern, insbesondere wenn ein B\xfcro offen gestaltet ist und pers\xf6nlicher Stauraum am Schreibtisch nur begrenzt vorhanden ist. Die Garderoben sollten im gesamten B\xfcro verteilt sein, etwa an den Ausg\xe4ngen und entlang der Hauptg\xe4nge. \xdcblicherweise gibt es neben Haken zum Aufh\xe4ngen von Jacken eine Ablage f\xfcr H\xfcte etc. und eine Aufbewahrungsm\xf6glichkeit f\xfcr Koffer an der Unterseite des Wandschranks.",
    wellnessRoomDesc: "Wellnessr\xe4ume (fr\xfcher Mutter-Kind-Raum genannt) bieten private R\xfcckzugsm\xf6glichkeiten. Sei es f\xfcr stillende M\xfctter oder f\xfcr Personen, die sich f\xfcr kurze Zeit aus der Arbeitsfl\xe4che zur\xfcckziehen m\xf6chten. Wellnessr\xe4ume sind in der Regel eine Notwendigkeit f\xfcr alle neuen B\xfcros, unabh\xe4ngig von Gr\xf6\xdfe und Mitarbeiterzahl.",
    internalStairDesc: "Interne Treppe als zus\xe4tzliche Verbindung zwischen mehreren Etagen.",
    commercialPrintRoomDesc: "Oftmals ist die Druckerei angeschlossen an die Poststelle. Dieser Raum bietet Unternehmen die M\xf6glichkeit, Pr\xe4sentationen im B\xfcro auszudrucken, zu binden und zusammenzustellen. Es gibt mehrere Drucker, darunter auch Gro\xdfformatdrucker. Die R\xe4umlichkeiten umfassen Lagerr\xe4ume f\xfcr Verbrauchsmaterial, aber auch Thekenfl\xe4chen f\xfcr kleinere Ger\xe4te und Platz f\xfcr die Gestaltung von Drucken.",
    pantryVendingCoffeeDesc: "Im Gegensatz zum zentralen Caf\xe9 ist der Vorrats-, Verkaufsautomaten-, Kaffee- und Getr\xe4nkebereich f\xfcr die Mitarbeiter gedacht, um die wichtigsten Dinge f\xfcr den schnellen Essens- und Getr\xe4nkebedarf bereitzustellen. Smalltalk und Konversationen werden nat\xfcrlich in Bereichen, in denen es Essen gibt, immer gef\xfchrt, aber diese R\xe4ume bieten in der Regel keine Sitzgelegenheiten, weshalb dort ein reges Kommen und Gehen herrscht und keine l\xe4ngeren Unterhaltungen stattfinden.",
    storageDesc: "Lagerr\xe4ume sind f\xfcr verschiedene Gegenst\xe4nde wie z. B. Gro\xdfger\xe4te, Zusatzm\xf6bel, Gro\xdfraumlager, Feiertagsbedarf usw. vorgesehen. Sie k\xf6nnen auch als Garderobe f\xfcr Besucher und f\xfcr die Gep\xe4ckaufbewahrung verwendet werden.",
    centralisedDispersedMailAreaDesc: "F\xfcr gr\xf6\xdfere Unternehmen ist ein Postverteilerraum f\xfcr die Organisation der ein- und ausgehenden Post erforderlich. In diesen R\xe4umen befinden sich spezialisierte Fertigungs- und Postger\xe4te. Diese Fl\xe4chen bieten viel Platz f\xfcr das Sortieren von Papier und anderen Materialien. In der Regel ist dieser Raum mit Vollzeitmitarbeitern besetzt.",
    lockerDesc: 'Schlie\xdff\xe4cher/Lockerschr\xe4nke werden als zus\xe4tzliche bzw. einzige Form der individuellen Aufbewahrung angeboten. Sie geben den Mitarbeitern die M\xf6glichkeit, ihre Wertsachen, pers\xf6nliche Gegenst\xe4nde und Arbeitsunterlagen zu sichern. Schlie\xdff\xe4cher k\xf6nnen Einzelpersonen zugewiesen oder nach dem "Wer-zuerst-kommt"-Prinzip genutzt werden.',
    mainITandServerRoomDesc: "Serverr\xe4ume dienen zur Unterbringung der Hauptserver-Anlagen und sind unternehmensspezifisch zu bestimmen.",
    drawerLateralFileDesc: "Der Rollcontainer/Apothekerschrank direkt am Arbeitsplatz dient der Aufbewahrung. In der Regel werden dort pers\xf6nliche Gegenst\xe4nde oder aktuelle Projektmaterialien aufbewahrt.",
    juiceBarCoffeeShopDesc: "W\xe4hrend ein Unternehmen m\xf6glicherweise nicht \xfcber eine vollst\xe4ndige K\xfcche und Bedienung verf\xfcgt, kann es hier ein Caf\xe9 oder eine Saftbar anbieten. Diese Art von Raum k\xf6nnte auch in die Hauptgastronomieleistungen des Unternehmens integriert werden. Dieser Bereich k\xf6nnte wie eine Caf\xe9-Filiale aussehen, mit einem Arbeitsbereich f\xfcr eine/n Mitarbeiter/in, der \xfcber einen Tresen die Bestellung aufnimmt und bedient.",
    grabNGoDesc: "Eine kleine Verkaufsfl\xe4che mit mehreren K\xfchlschr\xe4nken, Regalen f\xfcr Chips und Snacks und einem Kassenautomaten. Diese Verkaufsfl\xe4chen werden in der Regel von Sicherheitskameras \xfcberwacht. Die Fl\xe4chen werden oft mit einer kleinen Speisekammer mit K\xfchl- und Gefrierschr\xe4nken und einem Zubereitungsbereich f\xfcr Speisen kombiniert.",
    smMeetingConferenceRoomDesc: "Ein kleiner Besprechungsraum (2 - 4 Personen) ist ein geschlossener Raum, in dem ein kleiner Personenkreis bequem am selben Tisch arbeiten kann. Diese R\xe4ume k\xf6nnen sowohl f\xfcr interne als auch f\xfcr externe Meetings genutzt werden und sollten daher sehr benutzerfreundlich sein wie auch \xfcber einen einfachen Zugang zu Strom und A/V-Funktionen verf\xfcgen.",
    mdMeetingConferenceRoomDesc: "Ein mittelgro\xdfer Besprechungsraum (4 - 8 Personen) ist ein geschlossener Raum, der einen Personengruppe von mittlerer Gr\xf6\xdfe am Tisch Platz bietet. Diese R\xe4ume werden sowohl f\xfcr interne Besprechungen als auch f\xfcr Kundenmeetings genutzt und sind daher sehr benutzerfreundlich und verf\xfcgen wie \xfcber einen einfachen Zugang zu Strom und A/V-Funktionen.",
    lgMeetingConferenceRoomDesc: "Ein gro\xdfer Besprechungsraum (8 - 14 Personen) ist ein geschlossener Raum, der f\xfcr eine gr\xf6\xdfere Anzahl an Personen ausgelegt ist. Diese R\xe4ume k\xf6nnen sowohl f\xfcr interne Besprechungen als auch f\xfcr Kundentermine genutzt werden.",
    xlMeetingRoomDesc: "Ein XL-Besprechungsraum/Boardroom ist ein Raum, der f\xfcr eine gr\xf6\xdfere Anzahl an Personen (14+) ausgelegt ist. Diese R\xe4ume werden in der Regel f\xfcr gro\xdfe interne formelle Meetings und gro\xdfe Kundentermine genutzt. In den R\xe4umen befindet sich hochwertiges und modernes IT Equipment, welches diverse M\xf6glichkeiten f\xfcr digitales Arbeiten bietet.",
    // Space Unit Map Descriptions (spaceUnitMap.js) - US_SMALL and US_REGULAR
    lgOfficeDesc: "Standardb\xfcro sind private, geschlossene Arbeitsr\xe4ume f\xfcr Mitarbeiter. Sie sind ideal, um Ablenkungen zu reduzieren und den Fokus auf die Arbeit zu legen. B\xfcros sind typischerweise mit einem Schreibtisch und einem B\xfcrostuhl ausgestattet. Sie bieten unterschiedlich viel Platz f\xfcr die Aufbewahrung und Ablage pers\xf6nlicher Dinge. Die Gr\xf6\xdfe des Raumes kann je nach den dort ausge\xfcbten T\xe4tigkeiten (z. B. regelm\xe4\xdfige Besprechungen) oder Mitarbeiterstatus/Hierarchien variieren.",
    smWorkstationDesc: "Diese Einzelarbeitspl\xe4tze bestehen aus kleinen Arbeitstischen, die f\xfcr tempor\xe4re Arbeit geeignet sind. Der Arbeitsplatz wird keinem Mitarbeiter zugeordnet. Die Arbeitspl\xe4tze befinden sich meist in offenen Fl\xe4chen.",
    mdWorkstationDesc: "Hierbei handelt es sich um den standardisierten Arbeitsplatz. Dieser wird sowohl in der offenen Fl\xe4che als auch in geschlossenen B\xfcros eingesetzt und kann sowohl fest zugeordnet sein oder zur freien Verf\xfcgung stehen.",
    lgWorkstationDesc: "Hierbei handelt es sich um den standardisierten Arbeitsplatz. Dieser wird sowohl in der offenen Fl\xe4che als auch in geschlossenen B\xfcros eingesetzt und kann sowohl fest zugeordnet sein oder zur freien Verf\xfcgung stehen.",
    huddleRoomDesc: "Huddle R\xe4ume sind geschlossene R\xe4ume, die darauf ausgerichtet sind, Treffen eines kleinen Personenkreises zu erm\xf6glichen. Im Fokus steht der Wissensaustausch. Die Besprechungen sind spontan, schnell, unb\xfcrokratisch und teamorientiert. Die R\xe4ume verf\xfcgen \xfcber gute Akustikwerte und einen einfachen Zugang zu Strom und A/V-Funktionen.",
    multiPurpTrainingDesc: "Mehrzweck-/Schulungsr\xe4ume sind f\xfcr eine gro\xdfe Anzahl von Personen ausgelegt. Dieser Raum ist entsprechend benannt, da hier viele verschiedene Aktivit\xe4ten wie Schulungen, Firmenveranstaltungen und gro\xdfe Pr\xe4sentationen stattfinden k\xf6nnen. Der Schnitt der Fl\xe4chen und die Ausstattung dieses Raumes ist funktionell/langlebig, da dieser auf unterschiedlichste Weise genutzt wird und somit diverse Anforderungen unterst\xfctzen muss. Dieser Bereich muss \xfcber die entsprechende A/V-Anlage und -Support verf\xfcgen \u2013 in der Regel weitaus mehr als der durchschnittliche Konferenzraum.",
    informalCollabDesc: "Diese Bereiche sollen kleine Gruppen (4 - 6 Personen) bei gemeinsamen Aktivit\xe4ten wie Brainstorming und zwanglosen Gespr\xe4chen zwischen Kollegen und mit Kunden unterst\xfctzen.",
    touchdownTeamDesc: "Touchdowns sind individuelle, kleine interne Teamarbeitsbereiche, die \xfcber die gesamte B\xfcrofl\xe4che verteilt sind und von den Mitarbeitern genutzt werden. Touchdowns k\xf6nnen in H\xf6he, Form und Gr\xf6\xdfe variieren, sollen sich aber von einzelnen Arbeitspl\xe4tzen als gesonderter Arbeitsort f\xfcr kurze Arbeiten abheben. Dies sollten Plug-and-Play-R\xe4ume sein: einfach zu finden und zu nutzen.",
    frontDeskAreaDesc: "Empfangstresen f\xfcr G\xe4ste und Mitarbeiter. Gleichzeitig handelt es sich hierbei um die zentrale Anlauf- und Informationsstelle.",
    mailCenterAreaDesc: "Gr\xf6\xdfere Unternehmen ben\xf6tigen eine Poststelle, um alle Postdienste zu b\xfcndeln. Dazu geh\xf6ren gro\xdfe Sortier- und Organisationsfl\xe4chen sowie Platz f\xfcr Charts und andere Ger\xe4te. Dieser Bereich sieht bei jedem Unternehmen unterschiedlich aus, da er oft zwischen anderen Elemente eingepasst wird.",
    kitchenAreaDesc: "K\xfcchenzeile bzw. ein K\xfcchenraum, je nach Anforderungen des Unternehmens. In Abh\xe4ngigkeit von der Gr\xf6\xdfe und der Ausstattung kann die K\xfcche \xfcber die Getr\xe4nkeversorgung bis hin zur Essensvorbereitung anbieten.",
    serveryAreaDesc: "Die Ausgabe ist der Bereich, in dem die Menschen ihr Essen bekommen. Sie ist in der Regel mit der K\xfcche und dem Essbereich mit Tischen und Sitzgelegenheiten verbunden. Die Planung einer Speisenausgabe muss sehr pr\xe4zise sein, um Warteschlangen intelligent zu handhaben. Die Gr\xf6\xdfe und Form dieses Raumes variieren in der Regel von Unternehmen zu Unternehmen.",
    diningSupportAreaDesc: "Ein separierter K\xfcchenraum f\xfcr aufw\xe4rmen bzw. Vorbereitung von Speisen f\xfcr eigene Mitarbeiter bzw. separate Lieferanten.",
    diningAreaDesc: "Der Essbereich sollte mehrere Sitzgelegenheiten und Platz zum Mittagsessen bieten. Durch verschiedene Bestuhlungsvarianten kann der Raum auch au\xdferhalb der Mittagspause f\xfcr Besprechungen und Zusammenarbeit genutzt werden. Die Mischung von weichen und h\xe4rteren Sitzm\xf6glichkeiten sowie unterschiedlichen Theken- und Sitzh\xf6heneinstellungen gibt den Nutzern die Wahl.",
    // Space Unit Map Descriptions (spaceUnitMap.js) - UK_REGULAR
    fullFoodServiceDesc: "Wenn Sie einen Gastronomieservice anbieten, gibt es mehrere R\xe4ume, die n\xf6tig sind, einschlie\xdflich einer K\xfcche, Ausgabe, Essbereich (Sitzgelegenheiten) und Lagerung. Die K\xfcche und die Ausgabe sind miteinander verbunden, damit die im Haus zubereiteten Speisen serviert werden k\xf6nnen. Der Essbereich ist der Ort, an dem Mitarbeiter und G\xe4ste sitzen und essen k\xf6nnen, meist fungiert dieser Raum vielmehr als Zentrum f\xfcr soziale Kontakte und Zusammenarbeit. Genau wie in jeder Privatwohnung bedarf es einer Vielzahl an Ger\xe4ten und Stauraum, die erforderlich sind, um Gastronomieservices anzubieten, weshalb die Vorbereitungs- und Zusatzr\xe4ume bei diesem Raumtyp vorab eingeplant sind.",
    // SpaceUnitRow
    spaceUnitRowDeleteTitle: "Fl\xe4chentyp l\xf6schen",
    spaceUnitRowDeleteText: "M\xf6chten Sie diesen Fl\xe4chentyp l\xf6schen?",
    spaceUnitRowConfirmDeleteText: "Ja",
    spaceUnitRowCancelDeleteText: "Nein",
    // CustomAmenityAdder
    customAmenityAddText: "Service hinzuf\xfcgen",
    customAmenityPlaceholder: "Ausstattungsart",
    // SpaceUnitTotals
    spaceUnitTotalsTitleNIA: "Gesamt Netto-Innenfl\xe4che",
    spaceUnitTotalsTitle: "Nutzfl\xe4che in Quadratfu\xdf/-metern",
    spaceUnitTotalsCirculation: "Verkehrsfl\xe4chen",
    spaceUnitTotalsCirculationTooltip: "Flure, Aufzugsvorr\xe4ume, Foyers, die Fl\xe4che hinter den Sitzpl\xe4tzen oder die Fl\xe4chen um T\xfcren und Schr\xe4nke. Ohne Verkehrfl\xe4chen h\xe4tten Sie keine Bewegungsm\xf6glichkeit. Diese Fl\xe4chen machen in der Regel einen hohen Anteil der Gesamtnutzfl\xe4che aus und variieren je nach Profil und Geb\xe4udearchitektur.",
    spaceUnitTotalsREBNY: "Real Estate Board of NY",
    spaceUnitTotalsREBNYTooltip: "F\xfcr Fl\xe4chenermittlung in New York erh\xf6hen wirden REBNY-Ma\xdfstab um 15 %. Die nach REBNY-Messnorm gemessene Fl\xe4che umfasst Toiletten, Aufzugshallen und die Au\xdfenw\xe4nde.",
    spaceUnitTotalsLossFactor: "Verlustfaktor",
    spaceUnitTotalsLossFactorTooltip: "Differenz zwischen der Miet- und Nutzfl\xe4che, die je nach Fl\xe4chenermittlungsart (z.B. GIF, NF, BGF) unterschiedlich ausf\xe4llt.",
    // CollaborationDropdown
    collabDropdownLevelLowText: "wenig (0-25%)",
    collabDropdownLevelMedText: "einige (26-50%)",
    collabDropdownLevelHighText: "die meiste (51-100%)",
    //DensityDropdown
    sameDensityText: "gleich wie vor der Covid-19 Zeit bleiben wird",
    lowerDensityText: "niedriger wird mit mehr m2 pro Person",
    notSureDensityText: "da sind wir uns noch nicht sicher",
    //CirculationDropdown
    preCovidText: "Wie vor der Covid-19 Zeit",
    higherText: "Mehr Fl\xe4che (d.h. +5% bei offenen B\xfcroformen als auch geschlossenen R\xe4umen)",
    notSureText: "Noch nicht sicher",
    // ExamplePlans
    examplePlanButtonText: "Ansicht Beispielplan",
    examplePlanFullFloorText: "Vollgeschoss",
    examplePlanPartialFloorText: "Teilgeschoss",
    // examplePlanFullImgAlt: no translation yet
    // examplePlanPartialImgAlt: no translation yet
    examplePlanTooltipText: "Ab einer bestimmten Gr\xf6\xdfenordnung, die auch von der Geb\xe4udearchitektur abh\xe4ngig ist, werden Sie ggf. mehr als ein Stockwerk ben\xf6tigen.",
    // ProgramStats
    programStatsDensitySubtitleTsubo: "Tsubo",
    programStatsDensitySubtitle: "quadratisch",
    programStatsIndivTitle: "Einzelsitzpl\xe4tze",
    programStatsWorkstationsSubtitle: "offen",
    programStatsOfficesSubtitle: "geschlossen",
    programStatsCollabTitle: "Kollaboration",
    programStatsEnclosedSubtitle: "Kollaborationsm\xf6glichkeiten",
    programStatsIndivSeatSubtitle: "Einzelarbeitsplatz",
    programStatsSeatsTitle: "Arbeitspl\xe4tze pro Person",
    programStatsIndivSeatsSubtitle: "Einzelsitzpl\xe4tze",
    programStatsPersonSubtitle: "Person",
    programStatsDensityTitle: "Effizienz",
    programStatsFullDensitySubtitle: "pro Einzelarbeitsplatz",
    // Profile Display Names (profileNames.js)
    efficientName: "The Optimizer",
    whiteCollarName: "The Accommodator",
    whiteGloveName: "The Enhace",
    openOfficeName: "The Producer",
    workplace360Name: "The Connector",
    campusName: "The Differentiator",
    startupName: "The Incubator",
    engCreativeName: "The Creator",
    // Profile Descriptions (profileDescriptions.js)
    efficientDesc: 'Das "Optimiser-B\xfcro" bietet eine sachliche, schlichte Arbeitsumgebung, die es erm\xf6glicht, die Arbeit zu erledigen. Offen konzipierte Fl\xe4chen unterst\xfctzen individuelles Arbeiten am Schreibtisch, ausgestattet mit allen notwendigen Tools. Das B\xfcro verf\xfcgt \xfcber konventionelle Support-Bereiche. Die Gruppenarbeitsbereiche sind traditionell als separate R\xe4ume gestaltet. Wie der Name schon sagt, diese Arbeitsumgebung ist auf maximale Effizienz ausgelegt.',
    whiteCollarDesc: "Als Accommodator B\xfcro sind Sie nicht alleine - dies ist eines der beliebtesten Profile f\xfcr Firmenarbeitspl\xe4tze. Accommodator B\xfcros ziehen es vor, die Fl\xe4chen nicht mit radikalem Raumdesign zu ersch\xfcttern, sondern investieren oft in neue Technologien und M\xf6beln, um den Raum produktiv und ansprechend zu gestalten. In einem ausgewogenen Verh\xe4ltnis von individuellen und gemeinschaftlichen R\xe4umen befinden sie die Mitarbeiter meist an ihren Schreibtischen mit gelegentlichen Meetings und Teambesprechungen.",
    whiteGloveDesc: 'Das "Enhancer-B\xfcro" ist besonders stark auf die Bed\xfcrfnisse der Mitarbeiter und Kunden ausgelegt, welche h\xe4ufig gesehene Besucher des B\xfcros sind. Die Fl\xe4chen bieten verschiedenste Arbeitsmodule, die Activity-Based-Working erm\xf6glichen. Die technische Ausstattung der Mitarbeiter und Fl\xe4chen f\xf6rdert die Mobilit\xe4t sowohl innerhalb als auch au\xdferhalb des B\xfcros. Unabh\xe4ngig davon, ob formal ein "Agile Program" bereits implementiert ist oder nicht: Dieses B\xfcromodell schafft die Grundlagen f\xfcr flexibles Arbeiten - gegenw\xe4rtig und mit Blick in die Zukunft.',
    openOfficeDesc: 'Die Fl\xe4chen des "Producer-B\xfcros" sind optimal auf die verschiedenen T\xe4tigkeiten der Mitarbeiter abgestimmt. Bei diesem Profil stehen mehrere Raumtypen zur Verf\xfcgung, darunter Einzel-, Gruppen- und Supportbereiche, die sowohl das konzentrierte wie auch das kollaborative Arbeiten unterst\xfctzen. Flexibles Arbeiten und Desksharing sorgen f\xfcr eine h\xf6chst effiziente Nutzung der Fl\xe4che.',
    workplace360Desc: "Genau wie Ihre Lieblings-Yogastellung, ist das Connector B\xfcro stolz auf seine Ausgewogenheit. Mit der richtigen Mischung aus produktivit\xe4tsorientiertem Raum und sozialem Verbindungsraum bietet das Connector B\xfcro alle wesentlichen Voraussetzungen f\xfcr die Fokussierung und f\xf6rdert gleichzeitig die Auswahl mit einer Vielzahl anderer R\xe4ume. Getreu seinem Namen befindet sich das Connector B\xfcro in einer Zentralen Lage mit Gemeinschaftsr\xe4umen wie K\xfcchen und offenen Besprechungsr\xe4umen. Das hilft, Menschen zusammenzubringen und schafft ein Gef\xfchl der Gemeinschaft.",
    campusDesc: 'Das "Differentiator-B\xfcro" m\xf6chte man bei Feierabend am liebsten gar nicht verlassen. Dieses Konzept bietet eine erstklassige Arbeitsumgebung und Atmosph\xe4re an, die sich in jeder Hinsicht vom Standard abhebt. Es beinhaltet verschiedene Einrichtungen und Annehmlichkeiten rund um das Thema Wellness, Fitness und Ern\xe4hrung, so dass den Mitarbeitern der h\xf6chstm\xf6gliche Komfort angeboten wird.',
    startupDesc: 'Schnelligkeit und Ideenfindung pr\xe4gen das "Incubator-B\xfcro". Die Mitarbeiter arbeiten in hoch kollaborativen Teams und denken unternehmerisch. Dieses B\xfcroumfeld befindet sich in einem st\xe4ndigen Wandel, deswegen ist bei einem Gro\xdfteil der Fl\xe4chen die Flexibilit\xe4t gleich Teil des Designs. Die Einrichtung des B\xfcros ist mobil und l\xe4sst schnelle Ver\xe4nderungen zu. Durch ein Mix von geselligen Aktivit\xe4ten und intensiven Arbeitsphasen wird das Gemeinschaftsgef\xfchl im Team gest\xe4rkt.',
    engCreativeDesc: 'Wir verstehen das "Creator-B\xfcro" als eine Arbeitsumgebung der Experten ihrer Branche. Wie jedes gro\xdfartige kreative Unterfangen, lebt das "Creator-B\xfcro" von Zusammenarbeit und Teamwork. Teamwork kann dabei sowohl in dezitierten R\xe4umen, als auch im Open-Space Bereich stattfinden. Interaktives Arbeiten, Aktivit\xe4ten zur Ideenfindung und das richtige Equipment sind mit dieser Art des Arbeitens fest verbunden. Mitarbeitern wird daf\xfcr der Raum geschaffen, den sie ben\xf6tigen, um effektiv arbeiten zu k\xf6nnen.',
    // Profile Key Traits: Shared Names (profileTraitMap.js)
    social: "Sozial",
    efficient: "Effizienz",
    flexible: "Flexibel",
    enabled: "Effektiv",
    productive: "Produktiv",
    inclusive: "Inkludiert",
    clientFocused: "Kundenorientiert",
    standardized: "Einheitlich",
    // Profile Key Traits (profileTraitMap.js)
    social1Desc: "Zwischenmenschliche Beziehungen bei der Arbeit und auch au\xdferhalb sind wichtig",
    social2Desc: "Viele teambildende Ma\xdfnahmen",
    social3Desc: "Die Mitarbeiter verbringen gerne Zeit miteinander",
    social4Desc: "offen und gemeinschaftsorientiert",
    efficient1Desc: "eine schlanke Organisationsstrukur mit einem kostenbewussten Budget",
    efficient2Desc: "eine schlanke Organisationsstrukur mit einem kostenbewussten Budget",
    flexible1Desc: "Mitarbeiter k\xf6nnen ihre Arbeit aktiv gestalten",
    flexible2Desc: "Mitarbeiter haben viel Freiraum",
    flexible3Desc: "Schaffen Sie den Raum, den Sie brauchen",
    enabled1Desc: "Mitarbeiter finden an ihren Arbeitspl\xe4tzen das N\xf6tigste vor",
    enabled2Desc: "Mitarbeitern stehen verl\xe4ssliche Services und Komfort zur Verf\xfcgung",
    enabled3Desc: "Mitarbeiter sind gut gut ausgestattet",
    enabled4Desc: "Hochwertiges und gut abgestimmtes Equipment",
    enabled5Desc: "Spezielles und vielf\xe4ltiges Equipment ist vorhanden",
    productive1Desc: "Funktionales und schlichtes B\xfcrodesign",
    productive2Desc: "Business orientiert und kostenbewusst",
    productive3Desc: "Zugeschnitten auf ein spezielles Produkt/Serviceangebot",
    inclusive1Desc: "Vielf\xe4ltige Arbeitsmodule sind verf\xfcgbar",
    inclusive2Desc: "Das B\xfcro ist bestens ausgestattet",
    inclusive3Desc: "Verschiedene Arbeitsstile sind umsetzbar",
    clientFocused1Desc: "Der erste Eindruck z\xe4hlt",
    clientFocused2Desc: "Das B\xfcro wirkt einladend f\xfcr Kunden und neue Mitarbeiter",
    clientFocused3Desc: "Das B\xfcro wirkt hochwertig auf Kunden und Mitarbeiter",
    standardized1Desc: "Systeme und Arbeitsprozesse sind optimiert",
    standardized2Desc: "Feste Standards f\xfcr die B\xfcrofl\xe4chen",
    standardized3Desc: "Modulare Fl\xe4chen sorgen f\xfcr Flexibilit\xe4t",
    standardized4Desc: "Optimierte Prozesse und Arbeitsergebnisse",
    // SpaceSummary
    spaceSummaryBarHeader: "Indikative B\xfcrogr\xf6\xdfe",
    spaceSummaryMeasurementTypeText: "Fl\xe4chenart",
    spaceSummaryUnitTypeText: "Einheiten",
    spaceSummaryLossFactorSectionLabel: "{{factor}} Details \xfcber",
    spaceSummaryFitFactorText: "Anpassungsfaktor",
    spaceSummaryLossFactorText: "Verlustfaktoren",
    spaceSummaryRSFLossFactorHelperText: "Basierend auf einem {{percentage}}% Eignungsfaktor f\xfcr Immobilien, sollten Sie nach B\xfcrofl\xe4chen mit{{amt}} NIA Fl\xe4che suchen.",
    spaceSummaryNIAFitFactorHelperText: "Die Netto-Innenfl\xe4che (NIA) ist die nutzbare Fl\xe4che innerhalb eines Geb\xe4udes, gemessen an der Innenfl\xe4che der Au\xdfenw\xe4nde in jeder Etage, wobei bestimmte spezifizierte Bereiche ausgeschlossen sind.",
    spaceSummaryNIATooltipText: "Diese Messmethode umfasst alle R\xe4ume, M\xf6bel und Verkehrsfl\xe4chen.",
    // SFTypeRadioInput
    sfRadioInputUsableAreaTooltipText: "reine B\xfcronutzfl\xe4che",
    sfRadioInputRentableAreaTooltipText: "Gesamtnutzfl\xe4che inkl. sonstigen Nutzfl\xe4chen, Verkehrs- und Gemeinschaftsfl\xe4chen",
    sfRadioInputUsableSquareText: "Nutzfl\xe4che {{unitUppercase}}",
    sfRadioInputRentableSquareText: "Mietfl\xe4che {{unitUppercase}}",
    //floored plan request block
    flooredTitle: "Bitte geh\u2018 noch nicht!",
    flooredSubTitle: "Erfinde die Art, Raum zu erkunden, v\xf6llig neu !",
    flooredSubText: "Lass\u2018 Dir die Ergebnisse in einem Grundriss und in 3D anzeigen",
    flooredParagraphText1: "Realit\xe4tsnahe Visualisierungen machen es m\xf6glich, verschiedene Varianten durchzuspielen, mit Raum zu experimentieren und Ideen in Realit\xe4t umzusetzen.",
    flooredParagraphText2: "Erlebe konkrete, ma\xdfgeschneiderte Vorschl\xe4ge f\xfcr deine k\xfcnftige B\xfcrofl\xe4che.",
    flooredVideoHeading: "She\u2019 Dir ein Beispiel an.",
    flooredFreeText: "Und noch dazu \u2026 es kostet nichts!",
    flooredIconText1: "Teile Deine verf\xfcgbaren Grundrisse",
    flooredIconSubText1: "AutoCAD-Dateien oder PDFs",
    flooredIconText2: "Erlaube uns etwas Verarbeitungszeit",
    flooredIconSubText2: "Ein bis zwei Wochen",
    flooredIconText3: "Teile Deine virtuelle Planung mit anderen",
    flooredIconSubText3: "Individuelle 2D- und 3D-Pl\xe4ne",
    // MeasurementSystemRadioInput
    measurementSystemSqFeetText: "Quadratfu\xdf",
    measurementSystemSqMetersText: "Quadratmeter",
    measurementSystemTsuboText: "Tsubo",
    // ProfileHero
    resultsProfileHeroAnnouncementTitle: "Ihr B\xfcro ist",
    resultsProfileHeroImgAlt: "3D floor plan showing the office layout of the {{profileName}} profile from Spacer by CBRE",
    // ProfileComparison
    profileCompModalTitle: "Ihr Profil \xe4ndern ?",
    profileCompModalText: "Sie verlieren alle nicht gespeicherten \xc4nderungen in Ihrem aktuellen Raumfahrtprogramm",
    profileCompModalConfirmText: "Ja, Profil \xe4ndern",
    profileCompModalCancelText: "Nein, aktuelles Profil beibehalten",
    profileCompNavbarCancelButtonText: "Abbrechen",
    profileCompNavbarUseButtonText: "Dieses Profil verwenden",
    profileCompCompareTitle: "Die f\xfcr Sie am n\xe4chsten passenden errechneten Profile vergleichen",
    // ProfileComparisonColumn
    profileCompColumnSelectedText: "Ausgew\xe4hltes Profil",
    profileCompColumnSelectText: "Ausw\xe4hlen",
    profileCompColumnRecommendedText: " (empfohlen)",
    profileCompColumnImgAltText: ""
};


var $6d92b4d2e52e1edf$exports = {};
$6d92b4d2e52e1edf$exports = {
    // TermsOfService
    TermsTitle: "Nutzungsbedingungen",
    TermsIntroText: 'Dies ist eine rechtliche Vereinbarung zwischen Ihnen und CBRE, Inc. "("CBRE") \xfcber den Zugang zu und die Nutzung der als Spacer\xae bekannten Anwendung. Durch die Nutzung oder den Zugriff auf Informationen oder Dienstleistungen in dieser webbasierten Anwendung best\xe4tigen Sie, dass Sie die in diesen Nutzungsbedingungen dargelegten Bedingungen (die \u201EVereinbarung\u201D oder \u201ETOU\u201D) gelesen, verstanden und akzeptiert haben. Die Begriffe \u201ESie\u201D, \u201EIhr\u201D oder \u201EBenutzer\u201D beziehen sich zusammenfassend auf die Person und jedes Unternehmen, in dessen Namen diese Person handeln kann.',
    TermsLimitationsTitle: "Einschr\xe4nkungen.",
    TermsLimitationsA: "Der Nutzer versteht und stimmt zu, dass der Zugang des Nutzers zu Spacer\xae nicht exklusiv, nicht unterlizenzierbar, nicht \xfcbertragbar und frei widerruflich ist, sowie jederzeit und ohne Angabe von Gr\xfcnden von CBRE ausgesetzt oder beendet werden kann.",
    TermsLimitationsB: 'Der Nutzer versteht und stimmt ferner zu, dass die Gew\xe4hrung des Zugangs zu Spacer\xae dem Nutzer keine Eigentumsrechte an Spacer\xae oder zugeh\xf6rigen Dokumenten (einschlie\xdflich neuer Versionen, \xc4nderungen oder Erweiterungen) \xfcbertr\xe4gt, die ausschlie\xdfliches Eigentum von CBRE sind und bleiben, einschlie\xdflich, aber nicht beschr\xe4nkt auf die Urheberrechte an diesen, zugeh\xf6rigen Patenten, Designpatenten, Marken, Handelsaufmachung, Gesch\xe4ftsgeheimnissen und anderen Eigentumsrechten, die sich aus geltendem Recht oder internationalen \xdcbereinkommen ergeben (zusammen "Eigentumsrechte"). Siehe Abschnitt 2 (Eigentum) unten. CBRE beh\xe4lt sich hiermit ausdr\xfccklich alle Rechte an Spacer\xae vor, die dem Nutzer nach diesem Vertrag nicht ausdr\xfccklich gew\xe4hrt werden.',
    TermsLimitationsC: "Mit Ausnahme der hierin enthaltenen Bestimmungen oder der ausdr\xfccklichen schriftlichen Genehmigung durch CBRE an den Benutzer wird der Benutzer folgendes nicht tun: (i) \xc4ndern, \xdcbersetzen, Reverse Engineering, Dekompilieren, Disassemblieren, Versuchen, den Quellcode, zugrunde liegende Ideen, zugrunde liegende Techniken oder Algorithmen der Benutzeroberfl\xe4che zu rekonstruieren, zu identifizieren oder zu entdecken, oder abgeleitete Werke von Spacer\xae zu erstellen oder zu kopieren; (ii) Entfernen, \xc4ndern oder Abdecken von Urheberrechts- oder Markenhinweisen oder anderen in Spacer\xae enthaltenen Schutzrechtshinweisen; (iii) Zugangs-, Nutzungs- oder sonstigen Rechte abzutreten, Unterlizenzen zu vergeben oder anderweitig zu \xfcbertragen oder seine Verpflichtungen aus dieser Vereinbarung zu \xfcbertragen; oder (iv) Spacer\xae ohne eine der vorangehenden Bestimmungen einzuschr\xe4nken, zum Zwecke des Aufbaus eines wettbewerbsf\xe4higen Produkts beziehungsweise einer wettbewerbsf\xe4higen Dienstleistung oder f\xfcr einen anderen Zweck als legitime Gesch\xe4ftszwecke im Zusammenhang mit dem Gesch\xe4ft des Benutzers zu verwenden.",
    TermsLimitationsD: "Der Nutzer verpflichtet sich, CBRE unverz\xfcglich schriftlich zu informieren, wenn ihm eine unbefugte Nutzung von Spacer\xae oder eine m\xf6gliche Verletzung von Schutzrechten bekannt wird.",
    TermsLimitationsE: "Der Nutzer wird zu keinem Zeitpunkt w\xe4hrend oder nach Ablauf dieser Vereinbarung eine Registrierung von Urheberrechten, Marken oder anderen Bezeichnungen beantragen, die das Eigentum an Eigentumsrechten beeintr\xe4chtigen w\xfcrden, noch wird er Dokumente bei einer Regierungsbeh\xf6rde einreichen, um Ma\xdfnahmen zu ergreifen, die die Eigentumsrechte beeintr\xe4chtigen w\xfcrden, einschlie\xdflich des Eigentums von CBRE an Spacer\xae, der Marke Spacer\xae und anderen Anwendungskomponenten. Spacer\xae ist eine Marke und Dienstleistungsmarke von CBRE.",
    TermsLimitationsF: "Der Nutzer erkl\xe4rt sich damit einverstanden, dass der Nutzer das Recht hat, alle auf Spacer\xae ver\xf6ffentlichten Materialien oder Informationen, die in Verbindung mit Spacer\xae verwendet werden, zur Verf\xfcgung zu stellen, und gew\xe4hrt CBRE hiermit ein nicht ausschlie\xdfliches, geb\xfchrenfreies, weltweites, unwiderrufliches, unbefristetes Recht sowie die Lizenz zur Nutzung, Vervielf\xe4ltigung, \xc4nderung, Verbreitung, Erstellung abgeleiteter Werke und Anzeige dieser Materialien und Informationen nach Ermessen von CBRE. Der Nutzer erkennt an, dass er f\xfcr alle Materialien und Informationen, die er zur Verf\xfcgung stellt, verantwortlich ist, einschlie\xdflich deren Rechtm\xe4\xdfigkeit, Zuverl\xe4ssigkeit, Angemessenheit, Originalit\xe4t und Urheberrecht. Die vom Nutzer an CBRE gew\xe4hrte Lizenz gilt auch nach Beendigung der Nutzung von Spacer\xae durch den Nutzer. Alle vom Nutzer \xfcbermittelten Materialien und Informationen gelten als nicht vertraulich und nicht urheberrechtlich gesch\xfctzt und werden von CBRE als solche behandelt. Sie k\xf6nnen von CBRE in \xdcbereinstimmung mit dieser Vereinbarung ohne Benachrichtigung des Nutzers und ohne jegliche Haftung seitens CBRE verwendet werden.",
    TermsOwnershipTitle: "Eigentum.",
    TermsOwnershipText: "Spacer\xae, Programmiersprache, Software und Dokumentation und alle anderen Materialien oder Inhalte, die auf Spacer\xae zur Verf\xfcgung gestellt werden, oder alle Verbesserungen, Modifikationen, abgeleiteten Arbeiten, Verbesserungen oder \xc4nderungen an Spacer\xae und alle Kopien davon sind Eigentum von CBRE. Das Eigentum daran verbleibt unter allen Umst\xe4nden ausschlie\xdflich bei CBRE, einschlie\xdflich und ohne Einschr\xe4nkung aller Rechte an Patenten, Urheberrechten, Marken und Gesch\xe4ftsgeheimnissen in Spacer\xae und den Verbesserungen, Modifikationen, abgeleiteten Werken und \xc4nderungen daran. Der Nutzer nimmt zur Kenntnis, dass das Vorstehende Gesch\xe4ftsgeheimnisse und Informationen beinhaltet, die vertraulich und urheberrechtlich gesch\xfctzt sind, und verpflichtet sich, alle erforderlichen Ma\xdfnahmen zum Schutz der Vertraulichkeit dieser Informationen zu ergreifen. Der Nutzer darf Spacer\xae weder verkaufen, \xfcbertragen, ver\xf6ffentlichen, offenlegen, anzeigen oder anderweitig zur Verf\xfcgung stellen noch Verbesserungen, Modifikationen, Erweiterungen, abgeleitete Werke oder \xc4nderungen daran erstellen oder zur Verf\xfcgung stellen oder diese kopieren. Eine Vertragsaufhebung erfolgt zus\xe4tzlich und nicht anstelle von Rechtsbehelfen, die CBRE sowohl rechtlich als auch wirtschaftlich zur Verf\xfcgung stehen. Die Verpflichtungen aus diesem Vertrag gelten auch nach Beendigung dieses Vertrages.",
    TermsTerminationTitle: "K\xfcndigung; Wirksamkeit der K\xfcndigung; Rechtsbehelfe.",
    TermsTerminationA: "Ohne Einschr\xe4nkung anderer Rechtsbehelfe kann CBRE diese Vereinbarung und/oder die Nutzung von Spacer\xae durch den Benutzer mit sofortiger Wirkung automatisch, mit oder ohne Vorank\xfcndigung und ohne Inanspruchnahme von Gerichten oder anderen zust\xe4ndigen Instanzen aus jeglichem Grund oder ohne Angabe von Gr\xfcnden \xe4ndern, einschr\xe4nken, aussetzen, aufheben oder beenden. Der Nutzer stimmt zu, dass CBRE nicht verpflichtet ist, Spacer\xae zur Verf\xfcgung zu stellen, und dass CBRE gegen\xfcber dem Nutzer oder einer anderen Partei nicht f\xfcr eine Einschr\xe4nkung, Aussetzung, Einstellung, Unterbrechung, Beendigung oder \xc4nderung von Spacer\xae haftet.",
    TermsTerminationB: "Der Nutzer erkennt an, dass die Verpflichtungen, die er CBRE gegen\xfcber eingegangen ist, einzigartig und unersetzlich sind, ein Vertragsbruch CBRE irreparablen Schaden zuf\xfcgt und nicht allein durch monet\xe4re Entsch\xe4digungen ersetzt werden kann, sodass CBRE im Falle einer Verletzung oder vors\xe4tzlichen Verletzung durch den Nutzer Anspruch auf eine Unterlassungserkl\xe4rung oder einen anderen angemessenen Rechtsbehelf (ohne die Verpflichtung zur Stellung einer Kaution oder B\xfcrgschaft) hat. Der Nutzer verzichtet unwiderruflich auf alle Rechte, Unterlassungsanspruch oder andere angemessene Rechtsmittel zu beantragen.",
    TermsDisclaimerTitle: "Haftungsausschluss und Haftungsbeschr\xe4nkung.",
    TermsDisclaimerA: "Spacer\xae wird dem Benutzer \u201EWIE BESEHEN\u201D und \u201EWIE VERF\xdcGBAR\u201D ohne Gew\xe4hr zur Verf\xfcgung gestellt. CBRE LEHNT ALLE AUSDR\xdcCKLICHEN ODER STILLSCHWEIGENDEN GEW\xc4HRLEISTUNGEN AB, EINSCHLIE\u1E9ELICH, ABER NICHT BESCHR\xc4NKT AUF DIE STILLSCHWEIGENDEN GEW\xc4HRLEISTUNGEN DER MARKTG\xc4NGIGKEIT, DER EIGNUNG F\xdcR EINEN BESTIMMTEN ZWECK UND DER NICHTVERLETZUNG VON RECHTEN. CBRE garantiert nicht, dass Spacer\xae die Anforderungen des Benutzers oder einen bestimmten Standard erf\xfcllt. EINIGE STAATEN ERLAUBEN DEN AUSSCHLUSS STILLSCHWEIGENDER GARANTIEN NICHT, SODASS DER OBEN GENANNTE AUSSCHLUSS M\xd6GLICHERWEISE NICHT F\xdcR DEN BENUTZER GILT. In diesem Fall wird die Haftung von CBRE auf das nach geltendem Recht maximal m\xf6gliche Ma\xdf beschr\xe4nkt. KEINE M\xdcNDLICHEN ODER SCHRIFTLICHEN INFORMATIONEN ODER RATSCHL\xc4GE VON CBRE, SEINEN VERTRETERN ODER MITARBEITERN BEGR\xdcNDEN EINE GARANTIE IN IRGENDEINER WEISE. KEINE GEW\xc4HRLEISTUNG WIRD GEGEBEN, dass Spacer\xae ODER JEGLICHE INFORMATIONEN, die dem Benutzer zur Verf\xfcgung gestellt werden, fehlerfrei sind ODER dass die Verwendung von Spacer\xae nicht unterbrochen wird, aktuell, vollst\xe4ndig oder frei von Viren oder anderen gef\xe4hrlichen Komponenten sein wird. ES WIRD KEINE GEW\xc4HRLEISTUNG GEGEBEN, dass einer der vorgenannten Punkte korrigiert wird. CBRE gibt keine Garantien und macht keine Aussagen bez\xfcglich der Verwendung von Spacer\xae oder der Ergebnisse aus der Verwendung von Spacer\xae. CBRE HAFTET NICHT F\xdcR INDIREKTE, SPEZIELLE, ZUF\xc4LLIGE, FOLGE-, STRAF- ODER EXEMPLARISCHE SCH\xc4DEN (EINSCHLIE\u1E9ELICH, ABER NICHT BESCHR\xc4NKT AUF SCH\xc4DEN AUS EINEM GESCH\xc4FTSVERLUST), SEI ES AUFGRUND VON VERTRAGSBRUCH, UNERLAUBTER HANDLUNG (EINSCHLIE\u1E9ELICH FAHRL\xc4SSIGKEIT), PRODUKTHAFTUNG ODER ANDERWEITIGE, SELBST WENN CBRE ODER SEINE VERTRETER \xdcBER DIE M\xd6GLICHKEIT SOLCHER SCH\xc4DEN INFORMIERT WURDEN UND SELBST WENN FESTGESTELLT WIRD, DASS EIN IN DIESEN NUTZUNGSBEDINGUNGEN DARGELEGTES RECHTSMITTEL SEINEN WESENTLICHEN ZWECK NICHT ERREICHT HAT.",
    TermsDisclaimerB: "Die Gesamthaftung von CBRE f\xfcr Sch\xe4den aus jeglicher Ursache, soll nicht \xfcber die Geb\xfchr hinausgehen, die der Nutzer f\xfcr Spacer\xae w\xe4hrend der zw\xf6lf (12) Monate vor dem Ereignis, das einen solchen Schaden verursacht haben soll, bezahlt hat. Der NUTZER erkl\xe4rt sich damit einverstanden, dass jede Handlung, die sich aus oder im Zusammenhang mit Spacer\xae ergibt oder damit zusammenh\xe4ngt, innerhalb eines (1) Jahres, nachdem der Handlungsanlass auftritt, erfolgen muss. ANDERNFALLS IST DIESER KLAGEGRUND DAUERHAFT AUSGESCHLOSSEN.",
    // TermsDisclaimerC: no translation yet
    TermsIndemnificationTitle: "Entsch\xe4digungszahlungen an den Benutzer.",
    TermsIndemnificationText: "Nach Ermessen und Aufforderung von CBRE soll der Nutzer CBRE und seine Tochtergesellschaften, verbundene Unternehmen, F\xfchrungskr\xe4fte, Mitarbeiter, Vertreter, Co-Marken, Assoziierte und andere Partner auf eigene Kosten schadlos halten und von jeglichen Verlusten, Kosten, Sch\xe4den, Verbindlichkeiten, Vergleichen und Ausgaben (einschlie\xdflich, aber nicht beschr\xe4nkt auf Kosten und Anwaltskosten) freistellen, die sich aus oder im Zusammenhang mit Anspr\xfcchen, Klagen oder Behauptungen Dritter im Zusammenhang mit oder aus diesen ergeben: (a) jede Transaktion oder Streitigkeit zwischen dem Nutzer und einem Dritten; (b) Tatsachen oder mutma\xdfliche Tatsachen, die einen Versto\xdf gegen eine der Zusicherungen, Garantien oder Zusicherungen des Nutzers im Rahmen dieser Vereinbarung oder gegen geltende Gesetze, Regeln oder Vorschriften darstellen w\xfcrden, unabh\xe4ngig davon, ob sie hierin erw\xe4hnt werden oder nicht; (c) alle Benutzermaterialien, Informationen oder Inhalte, die in oder auf Spacer\xae eingereicht werden; (d) die Verletzung von Rechten Dritter durch den Nutzer, (e) die Nutzung oder den Missbrauch von Spacer\xae durch den Nutzer; oder (f) die Fahrl\xe4ssigkeit oder das vors\xe4tzliche Fehlverhalten des Nutzers. CBRE hat das Recht, auf Kosten des Nutzers seine Verteidigung und die Beauftragung eines Rechtsbeistandes seiner Wahl ausschlie\xdflich zu leiten und zu kontrollieren.",
    TermsGeneralTitle: "Allgemeines.",
    TermsGeneralA: "<0>Gesamtvereinbarung / Kein unbeabsichtigter Verzicht.</0> Diese Vereinbarung stellt die gesamte Vereinbarung zwischen CBRE und dem Nutzer in Bezug auf Spacer\xae und alle Gegenst\xe4nde dieser Vereinbarung dar und ersetzt alle fr\xfcheren Vereinbarungen zwischen CBRE und dem Nutzer in Bezug auf Spacer\xae, falls vorhanden. Das Vers\xe4umnis von CBRE, eine Bestimmung dieser Vereinbarung durchzusetzen, wird nicht als Verzicht auf eine Bestimmung oder ein Recht ausgelegt.",
    TermsGeneralB: "<0>Hinweise.</0> Die Mitteilungen an Sie erfolgen schriftlich und k\xf6nnen per E-Mail, durch Ver\xf6ffentlichung auf Spacer\xae oder unter www.cbre.com/spacer erfolgen. Sie k\xf6nnen uns Mitteilungen per E-Mail an spacersupport@cbre.com zukommen lassen, wobei eine Kopie per Einschreiben an \u201ECBRE, 400 S. Hope Street, 25th Floor, Los Angeles, CA 90071, Attention: General Counsel's Office geschickt wird. Mitteilungen gelten einen (1) Werktag nach dem Versand per E-Mail (es sei denn, der Absender erh\xe4lt eine Antwort, aus der hervorgeht, dass die Mitteilung unzustellbar ist) oder drei Werktage nach ihrer Ver\xf6ffentlichung auf der CBRE-Website (im Falle von CBRE) als zugestellt, unabh\xe4ngig davon, ob sie empfangen wurden oder nicht.",
    TermsGeneralC: "<0>Geltendes Recht.</0> Diese Vereinbarung unterliegt den Gesetzen des Staates Kalifornien und wird in \xdcbereinstimmung mit diesen ausgelegt, ohne R\xfccksicht auf kollidierende gesetzliche Bestimmungen. CBRE und der Nutzer unterwerfen sich hiermit ausschlie\xdflich den Institutionen des Staates Kalifornien. Das \xdcbereinkommen der Vereinten Nationen \xfcber Vertr\xe4ge \xfcber den internationalen Warenkauf (1980) wird hiermit in seiner Gesamtheit von der Anwendung dieses Vertrages ausgeschlossen. Der Nutzer stimmt hiermit zu, dass Spacer\xae als ausschlie\xdflich in Kalifornien ans\xe4ssiger und ein passiver Dienst angesehen wird, der keine pers\xf6nliche Zust\xe4ndigkeit f\xfcr CBRE, weder spezifisch noch allgemein, in anderen Rechtsordnungen als dem Staat Kalifornien begr\xfcndet.",
    TermsGeneralD: "<0>Beilegung von Streitigkeiten.</0> Alle Streitigkeiten, Anspr\xfcche oder Konflikte, die sich aus oder im Zusammenhang mit dieser Vereinbarung ergeben, oder die Verletzung, Durchsetzung, Auslegung oder G\xfcltigkeit derselben, einschlie\xdflich der Bestimmung des Umfangs oder der Anwendbarkeit des Schiedsverfahrens in Bezug auf diese Vereinbarung, werden durch ein Schiedsverfahren entschieden. Das Schiedsverfahren wird vom Judicial Arbitration and Mediation Service (JAMS) mit einem einzigen Schiedsrichter durchgef\xfchrt. Dar\xfcber hinaus erkl\xe4rt sich der Nutzer damit einverstanden, dass weder der Nutzer noch CBRE eine Forderung mit der Forderung einer anderen nat\xfcrlichen oder juristischen Person im Schiedsverfahren verbinden, dass keine Forderung auf einer klassenweiten Basis gel\xf6st wird und dass weder der Nutzer noch CBRE eine Forderung in repr\xe4sentativer Funktion im Namen einer anderen Person geltend machen werden. Ungeachtet des Vorangehenden erkl\xe4rt sich der Nutzer damit einverstanden, dass CBRE bei jeder Gerichtsbarkeit Unterlassungsanspr\xfcche (oder eine gleichwertige Art von dringendem Rechtsschutz) geltend machen kann. Wenn der Nutzer eine Schiedsklage gegen CBRE einreicht, verpflichtet sich CBRE, einen Teil der anf\xe4nglichen Anmeldegeb\xfchr, der 250 US-Dollar \xfcbersteigt, zu zahlen; nach den anf\xe4nglichen Anmeldegeb\xfchren teilen sich die Parteien die Kosten des Schiedsverfahrens zu gleichen Teilen. Der Nutzer verpflichtet sich, keine weiteren Schritte gegen CBRE einzuleiten oder zu verfolgen, es sei denn, er reicht eine Schiedsklage in \xdcbereinstimmung mit diesem Absatz ein. WICHTIGER NOCH, INDEM ER SICH DAMIT EINVERSTANDEN ERKL\xc4RT, AN DIESE VEREINBARUNG GEBUNDEN ZU SEIN, VERZICHTET DER BENUTZER AUF ALLE RECHTE, DIE ER HAT, UM VOR GERICHT RECHTSBEHELFE EINZULEGEN, UND ALLE RECHTE, DIE DER BENUTZER HAT, AUF EIN GESCHWORENENVERFAHREN.",
    TermsGeneralE: "<0>Trennbarkeit.</0> F\xfcr den Fall, dass ein Teil dieser Vereinbarung nicht durchsetzbar ist, wird der nicht durchsetzbare Teil nur in dem Umfang ge\xe4ndert, der erforderlich ist, um ihn durchsetzbar zu machen, und der Rest der Bestimmungen bleibt in vollem Umfang in Kraft und Wirkung.",
    TermsGeneralF: "<0>Zuordnung.</0> Diese Vereinbarung darf vom Nutzer ohne die vorherige schriftliche Zustimmung von CBRE nicht \xfcbertragen werden. Jeder \xdcbertragungsversuch ohne Zustimmung von CBRE ist ung\xfcltig. CBRE beh\xe4lt sich das Recht vor, diese Vereinbarung an Dritte abzutreten. Diese Vereinbarung und die hier dargelegten Rechte und Pflichten eines jeden von uns sind f\xfcr unsere jeweiligen Nachfolger und Bevollm\xe4chtigten verbindlich.",
    TermsGeneralG: "<0>Ab\xe4nderung.</0> CBRE kann jede der in dieser Vereinbarung enthaltenen Bedingungen jederzeit und nach eigenem und alleinigem Ermessen \xe4ndern, indem CBRE eine \xc4nderungsmitteilung oder eine neue Vereinbarung auf der Website von Spacer\xae unter der URL www.cbre.com/spacer ver\xf6ffentlicht, eine Mitteilung oder eine \xe4hnliche Benachrichtigung \xfcber Spacer\xae ausgibt. Wenn eine \xc4nderung f\xfcr den Nutzer unzumutbar ist, besteht die einzige M\xf6glichkeit f\xfcr diesen darin, die Nutzung von Spacer\xae eigens zu beenden.",
    TermsGeneralH: "<0>Konflikte.</0> Im Falle eines Widerspruchs zwischen den Bedingungen dieser Vereinbarung und einer vollst\xe4ndig ausgef\xfchrten Lizenzvereinbarung zwischen dem Benutzer und CBRE in Bezug auf Spacer\xae gelten die Bedingungen der Lizenzvereinbarung in Bezug auf diese widerspr\xfcchlichen Bedingungen."
};


var $8a7d5e2f162aefe7$exports = {};
$8a7d5e2f162aefe7$exports = {
    // Quiz
    // exitQuizButtonTitle: no translation yet
    // QuizProgressLabel
    progressLabelText: "vollst\xe4ndig",
    // QuizNavigationButton
    quizNavBackButtonShortenedText: "Vorherige",
    quizNavBackButtonFullLengthText: "Vorherige Frage",
    quizNavNextButtonShortenedText: "N\xe4chste",
    quizNavNextButtonFullLengthText: "N\xe4chste Frage",
    // QuizExitSlide
    quizExitSubtitle: "Mithilfe Ihrer Angaben entwerfen wir jetzt das perfekte B\xfcro f\xfcr Ihr Unternehmen.",
    // quizExitImgAlt: no translation yet
    // Question Unit Text (questionUnitMap.js)
    question1Text: "Wie w\xfcrden Sie ihr zuk\xfcnftiges B\xfcro beschreiben?",
    question2Text: "Was an Ihrem Unternehmen ist f\xfcr Bewerber am attraktivsten?",
    question3Text: "Worauf achten Sie beim Einstellen neuer Mitarbeiter besonders?",
    question4Text: "Wie wird sich Ihr Unternehmen in den n\xe4chsten Jahren entwickeln?",
    question5Text: "Wie sind die Arbeitszeiten Ihrer Mitarbeiter?",
    question6Text: "Was halten Sie von individuellen Arbeitspl\xe4tzen?",
    question7Text: "Wie soll im neuen B\xfcro gearbeitet werden?",
    question8Text: "Wie ist der Dresscode in Ihrem B\xfcro?",
    question9Text: "Von wo aus arbeiten Sie?",
    question10Text: "Welche Arbeitsatmosph\xe4re im B\xfcro w\xfcrden sie sich w\xfcnschen?",
    question11Text: "Neben den klassischen Arbeitspl\xe4tzen, was w\xfcrden Sie sich in der zuk\xfcnftigen Arbeitsumgebung w\xfcnschen?",
    question12Text: "Wer sind Sie?",
    // Quiz Answers (questionUnitMap.js)
    pickOnePlaceholder: "ausw\xe4hlen...",
    selectFromListPlaceholder: "Aus der Liste w\xe4hlen",
    firstResponseTooltipText: "W\xe4hlen Sie Ihre Antwort aus",
    locatedSomewhereElseLabel: "Ich befinde mich derzeit an einem anderen Ort.",
    q1AnswerText1: "Wir betrachten unser B\xfcro erstens als",
    q1AnswerText2: "zweitens als",
    q1AnswerText3: "drittens als",
    q1Option1Text: "ein zweites Zuhause f\xfcr unsere Mitarbeiter",
    q1Option2Text: "einen Treiber des organisatorischen Wandels",
    q1Option3Text: "einen Ort f\xfcr konzentriertes Arbeiten",
    q1Option4Text: "den Entstehungsort f\xfcr die n\xe4chste gro\xdfartige Idee",
    q1Option5Text: "ein Tool, um Talente anzuwerben",
    q1Option6Text: "ein Showcase f\xfcr unser Unternehmen",
    q1Option7Text: "einen Ort der Weiterentwicklung und des Lernens",
    q1Option8Text: "einen Ort f\xfcr die Gemeinschaft",
    q1Option9Text: "einen Kostenpunkt, den wir minimieren wollen",
    q2AnswerText1: "Bewerber kommen zu uns erstens aufgrund",
    q2AnswerText2: "zweitens aufgrund",
    q2AnswerText3: "drittens aufgrund",
    q2Option1Text: "der Unternehmenskultur",
    q2Option2Text: "der wettbewerbsf\xe4higen Geh\xe4lter",
    q2Option3Text: "des Ansehens des Unternehmens",
    q2Option4Text: "der Vorteile und Verg\xfcnstigungen",
    q2Option5Text: "der flexiblen Arbeitszeiten",
    q2Option6Text: "der Mitarbeiter und F\xfchrung",
    q2Option7Text: "der Arbeitswelt",
    q2Option8Text: "der Ziele und der Vision des Unternehmens",
    q3AnswerText1: "Wir stellen Mitarbeiter ein erstens aufgrund ihrer",
    q3AnswerText2: "zweitens aufgrund ihrer",
    q3AnswerText3: "drittens aufgrund ihrer",
    q3Option1Text: "F\xe4higkeiten",
    q3Option2Text: "Erfahrung",
    q3Option3Text: "Unternehmenskultur",
    q3Option4Text: "Referenzen",
    q3Option5Text: "Vernetzung",
    q3Option6Text: "Neugier/Wissbegierde",
    q4AnswerText: "Wir werden",
    q4Option1Text: "jedes Jahr ein wenig wachsen",
    q4Option2Text: "jedes Jahr erheblich wachsen",
    q4Option3Text: "in etwa unsere Gr\xf6\xdfe beibehalten",
    q4Option4Text: "jedes Jahr ein wenig kleiner werden",
    q4Option5Text: "schwer zu sagen - das ist nicht abzusehen",
    q5AnswerText: "Normalerweise arbeiten wir",
    q5Option1Text: "zu fest definierten Zeiten, z.B. \u201Efrom 9 to 5",
    q5Option2Text: "viel, von fr\xfch bis sp\xe4t",
    q5Option3Text: "die vorgegeben Stunden, allerdings zu flexiblen Zeiten",
    q5Option4Text: "wann und so oft wir wollen",
    q6AnswerText: "Wir finden",
    q6Option1Text: "dass jede/r einen pers\xf6nlich zugewiesenen Arbeitsplatz haben sollte",
    q6Option2Text: "es kann von Vorteil sein, Arbeitspl\xe4tze zu teilen",
    q7Option1Text: "Immer an einem pers\xf6nlich zugewiesenen Arbeitsplatz",
    q7Option2Text: "Meist am pers\xf6nlich zugewiesenen Arbeitsplatz, gelegentlich in Meeting- oder anderen R\xe4umen",
    q7Option3Text: "Gleicherma\xdfen am Schreibtisch und in anderen Bereichen",
    q7Option4Text: "Meist in anderen Bereichen, gelegentlich am Schreibtisch",
    q7Option5Text: "An st\xe4ndig wechselnden Arbeitsorten",
    q8Option1Text: "Immer Business professional",
    q8Option2Text: "Haupts\xe4chlich professional, ab und zu Business casual",
    q8Option3Text: "Business casual, an bestimmten Tagen professional",
    q8Option4Text: "Haupts\xe4chlich casual, mit gelegentlichen Ausnahmen",
    q8Option5Text: "Casual",
    q9Option1Text: "Immer vom B\xfcro aus",
    q9Option2Text: "Haupts\xe4chlich vom B\xfcro aus",
    q9Option3Text: "Teils vom B\xfcro aus und teils von au\xdferhalb",
    q9Option4Text: "Haupts\xe4chlich von au\xdferhalb des B\xfcros",
    q9Option5Text: "Immer von au\xdferhalb des B\xfcros",
    q10Option1Text: "Dynamisch und voller Energie",
    q10Option2Text: "Voller Energie mit einzelnen ruhigen Bereichen",
    q10Option3Text: "Es kommt darauf an - eine Mischung aus beidem",
    q10Option4Text: "Ruhig, mit einzelnen dynamischen Phasen",
    q10Option5Text: "Leise und ruhig",
    q11Option1Text: "nur das N\xf6tigste, genug um arbeiten zu k\xf6nnen",
    q11Option2Text: "das N\xf6tigste mit ein paar Extras",
    q11Option3Text: "das N\xf6tigste und einen Ort zum sozialen Netzwerken",
    q11Option4Text: "eine wirklich attraktive Fl\xe4che",
    q11Option5Text: "einen echten Hingucker - einen Ort, den man Besuchern zeigen m\xf6chte",
    q12AnswerText: "Ich bin",
    q12OptionClientText: "ein Kunde von CBRE",
    q12OptionProfessionalText: "ein CBRE Mitarbeiter",
    q12OptionLeadText: "kein Kunde von CBRE",
    q13AnswerText1: "In unserem B\xfcro werden",
    q13AnswerText2: "Mitarbeiter arbeiten.",
    q13AnswerHelperText: "Hinweis: Dies ist normalerweise zur H\xe4lfte Ihrer Mietlaufzeit oder der Zeitpunkt in 2-5 Jahren ab heute.",
    q14AnswerText1: "Wir verbringen",
    q14AnswerText2: "Zeit mit Teamarbeit.",
    q15AnswerText1: "Wir gehen davon aus, dass wir zuk\xfcnftig",
    q15AnswerText2: "Tage pro Woche im B\xfcro arbeiten werden.",
    q16AnswerText1: "Unser B\xfcro soll in",
    q16AnswerText2: "sein.",
    q17AnswerText1: "Wir sind haupts\xe4chlich im Bereich",
    q17AnswerText2: "t\xe4tig.",
    q18AnswerText1: "Ich befinde mich derzeit in",
    q18AnswerText2: ".",
    q19AnswerText1: "Wir denken, dass die zuk\xfcnftige Belegungsdichte in unserem B\xfcro",
    q19AnswerText2: "",
    // Quiz Responses (questionUnitMap.js)
    q1ResponseText: "Wir entwerfen ein B\xfcro, das Ihren Vorstellungen entspricht.",
    q2ResponseText: "Eine gute Auswahl!",
    q3ResponseText: "Das klingt super! Wo d\xfcrfen wir uns bewerben?",
    q4ResponseText: "Alles klar! Wir sorgen daf\xfcr, dass das B\xfcro zu Ihnen passt.",
    q5Response1Text: "Das klingt gut!",
    q5Response2Text: "Wir machen auch oft \xdcberstunden.",
    q5Response3Text: "Das klingt sehr gut!",
    q5Response4Text: "H\xf6rt sich toll an!",
    q6Response1Text: "Wir schaffen eine Fl\xe4che, die pers\xf6nliche Arbeitsbereiche priorisiert.",
    q6Response2Text: "Wir entwerfen ein flexibles B\xfcro f\xfcr Sie.",
    q12ResponseLeadText: "Bei uns sind Sie an der richtigen Adresse.",
    q12ResponseClientText: "Perfekt!",
    q12ResponseProfessionalText: "Vielen Dank!",
    // Industry Codes (industryCodes.js)
    animalProd: "Tierproduktion und Aquakultur",
    forestry: "Forst- und Holzeinschlagwirtschaft",
    fishingHunting: "Fischfang, Jagd und Fangen",
    agForestSupport: "Unterst\xfctzungsaktivit\xe4ten f\xfcr Land- und Forstwirtschaft",
    oilGas: "\xd6l- und Gasf\xf6rderung",
    energy: "Energie (Gas, \xd6l, etc.)",
    mining: "Bergbau au\xdfgenommen \xd6l und Gas",
    supportMining: "Unterst\xfctzungsaktivit\xe4ten f\xfcr den Bergbau",
    utilities: "Dienstprogramme",
    buildingConstruct: "Geb\xe4udekonstruktionen",
    heavyCivilConstruct: "Schwer- und Tiefbau",
    specialtyContract: "Fachhandel",
    foodManufac: "Lebensmittelherstellung",
    beverageTobaccoManufac: "Herstellung von Getr\xe4nken und Tabakwaren",
    textile: "Textilunternehmen",
    textileProduct: "Textilproduktionsunternehmen",
    apparelManufac: "Bekleidungsherstellung",
    leatherManufac: "Herstellung von Leder und Verbundprodukten",
    woodManufac: "Herstellung von Holzprodukten",
    paperManufac: "Papierherstellung",
    printingSupport: "Drucken und damit verbundene Unterst\xfctzungsaktivit\xe4ten",
    printingReproduc: "Druck / Reproduktionen",
    petroleumCoal: "Herstellung von Erd\xf6l- und Kohleprodukten",
    chemicalManufac: "Chemische Industrie",
    chemicals: "Chemieindustrie",
    pharma: "Pharmazeutika",
    cleaningManufac: "Reinigungsindustrie",
    plasticsRubberManufac: "Herstellung von Kunststoff- und Gummiprodukten",
    nonmetallicManufac: "Herstellung von nichtmetallischen Mineralprodukten",
    primaryMetalManufac: "Prim\xe4rmetallherstellung",
    fabricatedMetalManufac: "Herstellung von Metallerzeugnissen",
    machineryManufac: "Maschinenbau",
    manufac: "Herstellung",
    computerElectronicManufac: "Herstellung von Computern und elektronischen Produkten",
    electricalApplianceManufac: "Elektrische Ausr\xfcstung sowie Ger\xe4te",
    transportEquipManufac: "Herstellung von Transportmitteln",
    aerospaceDefense: "Luft- und Raumfahrt / Verteidigung",
    furnitureManufac: "Herstellung von M\xf6beln und zusammenh\xe4ngenden Produkten",
    miscManufac: "Sonstige Herstellung",
    merchantWholesaleDurable: "Gro\xdfh\xe4ndler, langlebige G\xfcter",
    merchantWholesaleNondurable: "Gro\xdfh\xe4ndler, Verbrauchsg\xfcter",
    electronicMarket: "Elektronische M\xe4rkte, Vermttler und Makler",
    motorVehiclePartsDealers: "KFZ- und Ersatzteilh\xe4ndler",
    furnitureFurnishingStores: "M\xf6bel- und Einrichtungsgesch\xe4fte",
    electronicApplianceStores: "Elektronik und Haushaltsger\xe4te",
    electronics: "Elektronik",
    buildingGardenSupplyStores: "Baumaterial- und Gartenbedarfsl\xe4den",
    foodBeverageStores: "Lebensmittel- und Getr\xe4nkeh\xe4ndler",
    groceryStores: "Lebensmittelgesch\xe4fte",
    beerWineLiquorStores: "Bier, Wein und Spirituosengesch\xe4fte",
    healthCareStores: "Gesch\xe4fte f\xfcr Gesundheit und K\xf6rperpflege",
    gasStations: "Tankstellen",
    clothingAccessoriesStores: "Bekleidungsgesch\xe4fte und Bekleidungszubeh\xf6r",
    clothingTextiles: "Kleidung / Textilien",
    jewelryFurs: "Schmuck &amp; Pelze",
    sportsHobbyMusicBookStores: "Sport, Hobby, Musikinstrument, Buchhandlungen",
    genMerchandiseStores: "Allgemeine Warenh\xe4user",
    miscStoreRetailers: "Sonstiges Einzelhandel",
    officeProducts: "B\xfcroprodukte",
    retailSales: "Einzelhandelsums\xe4tze",
    nonstoreRetails: "Nicht-Filialisten",
    airTransport: "Lufttransport",
    travelRelated: "Reisebezogen (Fluggesellschaften, Reiseb\xfcros, Nahverkehr)",
    railTransport: "Bahntransport",
    waterTransport: "Wassertransport",
    truckTransport: "LKW-Transport",
    transitTransport: "Transit- und Bodenverkehr",
    pipelineTransport: "Rohrleitungstansport",
    scenicTransport: "Verkehrs- und Tourismustransport",
    supportTransport: "Transportunterst\xfctzung",
    postalService: "Postdienst",
    courierMessenger: "Kuriere und Boten",
    shippingDelivery: "Versand &amp; Lieferung",
    warehousingStorage: "Lagerung",
    warehouseDistrib: "Lager / Vertrieb",
    publishingNoInternet: "Verlagsbranche (papierbasiert)",
    publishing: "Verlagswesen",
    motionPicSoundRecordingIndustries: "Film- und Tontr\xe4gerindustrie",
    entertainment: "Unterhaltung (Film, Fernsehen, Musik usw.)",
    infoServicesMarketResearch: "Informationsdienste / Marktforschung",
    broadcastingNoInternet: "Rundfunk",
    telecom: "Telekommunikation",
    tech: "Technologie",
    dataProcessingHostingServices: "Datenverarbeitung, Hosting und damit verbundene Dienstleistungen",
    otherInfoServices: "Andere Informationsdienste",
    financeInsurance: "Finanz- und Versicherungswesen",
    monetaryAuthorities: "W\xe4hrungsbeh\xf6rden - Zentralbank",
    creditIntermediation: "Kreditvermittlung und damit verbundene T\xe4tigkeiten",
    banking: "Bankgesch\xe4fte",
    securitiesContractsInvestments: "Wertpapiere, Warenvertr\xe4ge, Investitionen",
    financialServicesNoBanking: "Finanzdienstleistungen (keine Bankgesch\xe4fte)",
    insuranceCarriersRelated: "Versicherungstr\xe4ger und damit verbundene T\xe4tigkeiten",
    insurance: "Versicherung",
    fundsTrustsFinancialVehicles: "Fonds, Treuhand und andere Finanzinstrumente",
    realEstate: "Immobilien",
    rentalLeasingServices: "Vermietung und Leasing",
    automotive: "Automobilindustrie",
    consumerGoods: "Konsumg\xfcter",
    lessorsNonfinancialIntangible: "Leasinggeber von nicht finanziellen immateriellen Verm\xf6genswerten",
    professionalTechnicalServices: "Professionelle und technische Dienstleistungen",
    legalServices: "Rechtsberatung",
    accounting: "Buchhaltung",
    architectureEngineering: "Architektur / Ingenieurwesen",
    specializedDesignServices: "Spezialisierte Konstruktions-Services",
    compRelatedServices: "Computerbezogene Dienstleistungen",
    mgmtConsulting: "Unternehmensberatung",
    scientificResearch: "Wissenschaftliche Forschung",
    adsMarketingPR: "Werbung / Marketing / \xd6ffentlichkeitsarbeit",
    otherProfSciTechServices: "Andere professionelle, wissenschaftliche und technische Dienstleistungen",
    companyEnterpriseMgmt: "Management von Unternehmen und Konzernen",
    adminSupportServices: "Verwaltungs- und Unterst\xfctzungsdienste",
    employmentAgencyRecruiters: "Personalvermittler / Recruiter",
    securityPrivateInvestigation: "Sicherheit / Privatuntersuchung",
    wasteMgmtRemediationServices: "Abfallbewirtschaftung und Sanierung",
    educationServices: "Bildungsservice",
    education: "Bildung",
    ambulatoryHealthCareServices: "Ambulante Gesundheitsdienste",
    healthCareRelated: "Gesundheitswesen",
    hospitals: "Krankenh\xe4user",
    nursingResidentialCareFacilities: "Pflege- und Wohneinrichtungen",
    socialAssistance: "Soziale Unterst\xfctzung",
    performingArtsSpectatorSports: "Darstellende Kunst und Zuschauersport",
    museumsHistoricalSitesZoosParks: "Museen, historische St\xe4tten, Zoos und Parks",
    fineArtsGalleriesMuseums: "Bildende Kunst (Galerien, Museen)",
    amusementsGamblingRec: "Vergn\xfcgungen, Gl\xfccksspiele und Erholung",
    accommodation: "Unterkunft",
    foodDrinkingServices: "Verpflegungsdienstleistungen",
    restaurantHotel: "Restaurant / Hotel",
    repairMaintenance: "Reparatur und Wartung",
    industrialProductsHeavy: "Industrieprodukte (Schwerindustrie)",
    personalLaundryServices: "Personen- und W\xe4scheservice",
    membershipAssocOrgs: "Mitgliedsverb\xe4nde und -organisationen",
    nonprofit: "Soziale Einrichtung",
    privateHouseholds: "Private Haushalte",
    execLegisGenGvt: "Exekutive, Legislative und staatliche Verwaltung",
    gvt: "Regierung",
    justicePublicOrderSafetyActivities: "Justiz, \xf6ffentliche Ordnung und Sicherheitsaktivit\xe4ten",
    hrAdminPrograms: "Personalverwaltung",
    environmentAdminPrograms: "Verwaltung von Umweltprogrammen",
    environmental: "Umwelt",
    communityHousingProgramAdmin: "Gemeinschafts- und Wohnungsprogrammverwaltung",
    econProgramAdmin: "Verwaltung von Wirtschaftsprogrammen",
    spaceResearchTech: "Weltraumforschung und Technologie",
    natlSecurityIntlAffairs: "Nationale Sicherheit und internationale Angelegenheiten"
};


var $706363a497ebf106$exports = {};
$706363a497ebf106$exports = {
    // AboutPageHero
    aboutPageHeroImgAlt: "Darstellung von Personen, die in ein B\xfcro einziehen, auf der Infopage von Spacer by CBRE",
    aboutPageHeroTitle: "Warum Spacer?",
    // AboutPageContent
    aboutPageContentEndSectionTitle: "Sind Sie bereit loszulegen?",
    // aboutPageProgramPreviewImgAlt: no translation yet
    aboutPageVideoTitle: "So funktioniert\xb4s",
    // About Page Content (aboutPageContent.js)
    aboutPageContent1Title: "Definieren Sie das perfekte B\xfcro",
    aboutPageContent1Text: "Das perfekte B\xfcro hilft Ihnen dabei, Talente einzustellen, f\xfcr die Gesundheit Ihrer Mitarbeiter zu sorgen, Betriebskosten zu senken und beste Voraussetzungen f\xfcr gro\xdfartige Ideen zu schaffen. Spacer ist das ideale Tool, um den Entscheidungsprozess rund um Ihre Immobilie zu starten. Denn Spacer hilft Ihnen, Ihre Ziele als Unternehmen zu priorisieren und Ihren Raumbedarf an diesen Zielen zu orientieren. Spacer entstand aus der Expertise des CBRE Workplace-Teams, einer weltweit agierenden Abteilung mit \xfcber zwanzig Jahren Erfahrung. Mit dieser kostenlosen, internetbasierten Technologie, die jedem zug\xe4nglich ist, unterst\xfctzen wir Sie bei der Planung Ihres B\xfcros.",
    aboutPageContent1ImgAlt: "Darstellung von sprechenden Personen auf der Infopage von Spacer by CBRE",
    aboutPageSpacerSupportLink: "spacersupport@cbre.com",
    aboutPageContent2Title: "Spacer ist einfach zu bedienen:",
    aboutPageContent2List1: "Beginnen Sie mit der Beantwortung von 17 Fragen zu Ihren Unternehmenszielen und -werten. Ihre Antworten liefern die Informationen f\xfcr das B\xfcroprofil, in das wir Sie einstufen.",
    aboutPageContent2List2: "Erhalten Sie eine Liste mit Indikationen zu Raumtypen und -gr\xf6\xdfen, die Ihren individuellen Anforderungen entsprechen, auch bekannt als Space-Programm.",
    aboutPageContent2List3: "Visualisieren Sie einen beispielhaften Raum in 2D und 3D mit Floored Plans.",
    aboutPageContent2List4: "Speichern Sie Ihr Profil, um sp\xe4ter darauf zur\xfcckgreifen zu k\xf6nnen.",
    aboutPageContent2List5: "Lassen Sie sich von einem CBRE Workplace Experten bei der Suche nach Ihrem perfekten B\xfcro beraten.",
    aboutPageContent2Text: "F\xfcr weitere Fragen zu Spacer kontaktieren Sie ",
    aboutPageContent2ImgAlt: "Darstellung einer Frau, die an einem Schreibtisch arbeitet auf der Infopage von Spacer by CBRE."
};


var $3a4da95c94dc9afa$exports = {};
$3a4da95c94dc9afa$exports = {
};


var $245511775c20e878$exports = {};
$245511775c20e878$exports = {
};


var $9c868375bbef3594$exports = {};
$9c868375bbef3594$exports = {
    // LandingPageHero
    landingPageHeroTitle: "Laissez-nous vous aider \xe0 planifier vos am\xe9nagements futurs et \xe0 trouver la surface correcte de vos prochains bureaux.",
    landingPageHeroSubtitle: "Le monde du travail change avec la r\xe9cente pand\xe9mie. Recevez votre recommandation personnalis\xe9e en utilisant notre outil gratuit.",
    landingPageHeroImgAlt: "Pr\xe9visualisation des r\xe9sultats directement sur la page d'accueil de Spacer by CBRE.",
    landingPageImage: "/png/homepage-results-page-in-browser-spacer-by-cbre-Fr.png",
    // LandingPageContent
    landingPageContentTitle: "Comment cela marche",
    // StepsSummary
    stepsSummarySubtitle1: "Etape \u20141 ",
    stepsSummaryTitle1: "Dites-nous en plus sur votre soci\xe9t\xe9",
    stepsSummaryText1: "Aidez-nous \xe0 conna\xeetre vos objectifs afin que nous puissions vous faire des recommandations pertinentes.",
    stepsSummaryImgAlt1: "Illustration d'une personne post\xe9e sur un PC portable g\xe9ant sur la page d'accueil de Spacer by CBRE",
    stepsSummarySubtitle2: "Illustration d'un quartier sur la page d'accueil de Spacer by CBRE",
    stepsSummaryTitle2: "Obtenez vos r\xe9sultats",
    stepsSummaryText2: "Gr\xe2ce aux r\xe9ponses que vous nous avez fournies, vous allez recevoir notre recommandation quant \xe0 la taille de votre espace, et une liste de types d'espace. Vous pourrez aussi avoir acc\xe8s \xe0 des exemples de plans d'am\xe9nagement.",
    stepsSummaryImgAlt2: "Illustration d'un quartier sur la page d'accueil de Spacer by CBRE",
    stepsSummarySubtitle3: "Etape \u20143 ",
    stepsSummaryTitle3: "Trouvez votre espace id\xe9al",
    stepsSummaryText3: "Sauvegardez vos r\xe9sultats afin de pouvoir y revenir pendant votre recherche de locaux, ou contactez l'\xe9quipe Spacer afin d'\xe9changer avec nos experts pour qu'ils vous accompagnent sur votre projet.",
    stepsSummaryImgAlt3: "Illustration d'une femme travaillant \xe0 son bureau sur la page d'accueil de Spacer by CBRE",
    // LandingPageSecondaryHero
    landingPageSecondaryHeroImgAlt: "Illustration de personnes travaillant \xe0 construire des recommandations d'espace de bureaux sur la page d'accueil de Spacer by CBRE",
    landingPageSecondaryHeroTitle: "Dites-nous en plus sur votre soci\xe9t\xe9, nous vous dirons de quels espaces vous avez besoin."
};


var $1b03595e375c4b10$exports = {};
$1b03595e375c4b10$exports = {
    // Navbar
    spacerLogoAlt: "Logo Spacer by CBRE",
    linkToAboutPageText: "\xc0 propos",
    linkToBlogPageText: "Id\xe9es",
    // TakeOfficeSpaceQuizButton
    sizeMyOfficeButtonDefaultLinkText: "Quiz",
    flooredPlanRequestLinkText: "Obtenez un Plan",
    // Footer
    footerCBRELogoAlt: "Logo CBRE pour Spacer by CBRE",
    footerFacebookIconAlt: "Icon Facebook pour Spacer by CBRE",
    footerTwitterIconAlt: "Icon Twitter pour Spacer by CBRE",
    footerLinkedinIconAlt: "Icon LinkedIn pour Spacer by CBRE",
    footerHeaderQuestionsText: "Des questions ?",
    footerHeaderAboutText: "A propos de Spacer",
    footerHeaderMoreText: "Plus",
    footerLinkBlogText: "Aper\xe7u",
    footerLinkWhatIsSpacerText: "A propos",
    footerLinkWorkplaceText: "Qu'est-ce que Design & Project?",
    footerLinkTermsText: "Conditions d'utilisation",
    footerLinkPrivacyText: "Politique de confidentialit\xe9",
    footerLinkedinLink: "https://www.linkedin.com/showcase/cbre-workplace-strategy/",
    footerWorkplaceLink: "http://www.cbre.us/real-estate-services/occupier/workplace",
    footerPrivacyLink: "https://www.cbre.fr/fr-fr/a-propos-de-cbre/mention-legales#policy",
    // Contact (contact.js)
    spacerSupportEmail: "spacersupport@cbre.com",
    // ErrorPage
    errorOopsText: "Ooups",
    error404Text: "Cette page n'existe pas ou n'existe plus. Nous vous prions de nous excuser pour la g\xeane occasionn\xe9e.",
    error500Text: "Une erreur s'est produite\u2026",
    errorText: "Erreur",
    errorReturnText: "Revenir \xe0 Spacer",
    errorAltText: "Illustration d'une tasse de caf\xe9 renvers\xe9e pour Spacer by CBRE",
    // Measurement Units (units.js)
    SF: "SF",
    SM: "m\xb2",
    USF: "USF",
    USM: "m\xb2 utiles",
    RSF: "RSF",
    RSM: "m\xb2 louables",
    NSF: "NSF",
    NSM: "m\xb2 nets",
    NIA: "NIA",
    foot: "pied",
    feet: "pieds",
    footage: "m\xe9trage",
    "sqft.": "pieds carr\xe9s",
    meter: "m\xe8tre",
    meters: "m\xe8tres",
    "sqm.": "m\xb2",
    Tsubo: "tsubo",
    // SF Types Adjectives (calculator.js)
    Usable: "Utile",
    Rentable: "Louable",
    Net: "Net",
    // documentDataCopy needs translation: page titles and metatag texts
    landingPageTitle: "Configurez votre espace en 15 minutes - Spacer by CBRE",
    aboutPageTitle: "Comprenez comment notre outil fonctionne - Spacer by CBRE",
    termsPageTitle: "Conditions d'utilisation - Spacer by CBRE",
    quizPageTitle: "D\xe9finissez la taille de votre espace en 15 minutes' - Spacer by CBRE",
    resultsPageTitle: "Visualisez nos recommandations pour votre espace - Spacer by CBRE",
    profileComparisonPageTitle: "Comparez vos besoins d'espace - Spacer by CBRE",
    // blogHomePageTitle: no translation yet,
    // Meta Tags (documentDataCopy.js)
    landingPageMetaTagText: "Vous r\xe9fl\xe9chissez \xe0 vos prochains bureaux ? Laissez Spacer by CBRE vous aider \xe0 d\xe9terminer rapidement et facilement la surface dont vous avez besoin pour atteindre vos objectifs Business. Cela ne prend que 15 minutes !",
    aboutPageMetaTagText: "La taille de vos bureaux peut vous aider \xe0 attirer les talents, r\xe9duire les co\xfbts, et m\xeame maintenir vos salari\xe9s en bonne sant\xe9 ! Voyez comment Spacer peut vous conseiller rapidement la taille de bureaux qui vous convient pour atteindre vos objectifs.",
    termsPageMetaTagText: "Plus de 10 ans d'exp\xe9rience et d'expertise industrielles ont \xe9t\xe9 incorpor\xe9es \xe0 Spacer by CBRE afin de produire de vraies recommandations de tailles de bureaux en quelques minutes.",
    quizPageMetaTagText: "D\xe9roulez le questionnaire Spacer en seulement 15 minutes pour conna\xeetre l'espace de bureaux dont vous avez besoin conform\xe9ment aux priorit\xe9s et aux objectifs de votre entreprise. Obtenir une r\xe9ponse personnalis\xe9e n'a jamais \xe9t\xe9 aussi rapide !",
    resultsPageMetaTagText: "Les r\xe9sultats personnalis\xe9s fournis par Spacer vous font \xe9conomiser du temps en vous indiquant la taille exacte de bureaux dont votre soci\xe9t\xe9 a besoin, agr\xe9ment\xe9e d'une proposition de mobiliers et de plans d'am\xe9nagements.",
    profileComparisonPageMetaTagText: "Appr\xe9hendez comment vos propres besoins peuvent se comparer \xe0 d'autres en utilisant Spacer by CBRE."
};


var $ba0bd9adb44a622a$exports = {};
$ba0bd9adb44a622a$exports = {
    // Results
    resultsWarningMessage: "Etes-vous s\xfbr que vous souhaitez quitter cette page? Toute donn\xe9e non sauvegard\xe9e sera perdue.",
    // ResultsHeader
    resultsHeaderExportPDFButtonText: "Export PDF",
    resultsHeaderSendButtonText: "Envoyer les r\xe9sultats",
    resultsHeaderClipboardBoxDescription: "Tout lien permet de voir et \xe9diter les r\xe9sultats",
    resultsHeaderContactButtonText: "Prenez contact avec un consultant",
    // EmailWallSection
    emailWallTitle: "Encore plus pour vous",
    emailWallSubtitle: "Veuillez saisir votre nom et email ci-dessous pour consulter une pr\xe9conisation compl\xe8te de vos locaux et adapter les r\xe9sultats",
    emailWallFirstNamePlaceholder: "Pr\xe9nom",
    emailWallLastNamePlaceholder: "Nom",
    emailWallEmailPlaceholder: "Votre email",
    emailWallCBREEmailPlaceholder: "Votre email professionnel CBRE (optionnel)",
    // emailWallLeasingProfessionalPlaceholder: no translation yet,
    emailWallConnectMeText: "Merci de me mettre en contact avec un consultant d\xe9di\xe9. Promis, sans newsletter, mail ou spam!",
    emailWallContactNoticeText: "L'\xe9quipe Spacer pourra vous contacter pour profiter encore plus de votre projet. Promis, pas de spam!",
    emailWallResultsButtonText: "Voir les r\xe9sultats complets",
    emailWallImgAltText: "Pr\xe9visualisation des r\xe9sultats directement sur la page d'email de Spacer by CBRE.",
    emailWallFirstNameInvalid: "Merci de saisir votre pr\xe9nom",
    emailWallLastNameInvalid: "Merci de saisir votre nom",
    emailWallEmailInvalid: "Merci d'entrer une adresse email valide",
    // CopyToClipboardBox
    clipboardBoxCopyText: "Copier",
    clipboardBoxCopiedText: "Copi\xe9",
    // FormModal
    formModalFindSpaceHeader: "Lancer la recherche de bureaux",
    formModalFindSpaceBody: "Spacer est un outil rapide et simple pour une \xe9tude d'espaces de travail, mais si vous avez un besoin plus complexe, CBRE Design & Projcet peut vous aider. Remplissez ce formulaire, et un consultant sp\xe9cialis\xe9 vous rappellera dans les 48 heures pour convneir d'un rendez-vous.",
    formModalFindSpaceSuccessMessage: "Votre demande a \xe9t\xe9 envoy\xe9e.",
    // SuccessModal
    successModalTitle: "Termin\xe9!",
    // ContactForm
    contactFormFirstNameLabel: "Pr\xe9nom",
    contactFormLastNameLabel: "Nom",
    contactFormEmailLabel: "Email professionnel",
    contactFormPhoneLabel: "Num\xe9ro de t\xe9l\xe9phone",
    contactFormMessageLabel: "Dites-nous plus sur votre recherche",
    contactFormSubmitText: "Envoyer",
    // AcceptTermsText
    acceptTermsText: "J'accepte les <1>Conditions G\xe9n\xe9rales d'Utilisation</1>. Pour de plus amples informations sur la fa\xe7on dont vos donn\xe9es sont utilis\xe9es, merci de vous r\xe9f\xe9rer \xe0 nos <3>Mentions L\xe9gales</3>.",
    privacyPolicyLink: "https://www.cbre.fr/fr-fr/a-propos-de-cbre/mention-legales#policy",
    // Form
    formErrorText: "Oups, nous avons rencontr\xe9 un probl\xe8me. Merci de r\xe9essayer!",
    formEmailInvalid: "Merci de saisir une adresse mail valide.",
    // FormInput
    formInputOptionalText: "(optionnel)",
    // LegalForm
    legalFormCheckboxText: "CBRE peut me contacter avec des informations et offres en relation avec mon usage de Spacer.",
    legalFormContactWarningText: "L\xe9quipe Spacer pourra vous contacter pour vous aider \xe0 obtenir le meilleur de votre projet. Pas de spam, promis!",
    // NextStepsSection
    nextStepsSectionSubtitle: "Pr\xeat \xe0 passer \xe0 l'\xe9tape suivante?",
    nextStepsSectionTitle: "Trouver le bureau id\xe9al.",
    nextStepsSectionButtonText: "Entrez en contact avec un consultant",
    nextStepsSectionImgAlt: "Illustration de personnes discutant sur la page des r\xe9sultats de Spacer by CBRE",
    // Profile
    resultsProfileSummaryTitle: "Vos locaux \u2014",
    resultsProfileTooltipText: "Chaque profil est inspir\xe9 d'environnements et d'organisations r\xe9elles, les d\xe9tails sont le r\xe9sultats des bonnes pratiques et expertises de CBRE Design & Project.",
    // Program
    programSaveConfirmationBoxText: "C'est parti. Nous vous avons envoy\xe9 un lien vers vos r\xe9sultats. Profitez-en d\xe8s maintenant!",
    programExamplePlansTitle: "Exemples de plans",
    programExamplePlansSubtitle: "Jouez avec des plans interactifs adapt\xe9s \xe0 votre demande. Vous pouvez m\xeame les manipuler en 3D!",
    programTooMuchTinkerWarning: "Attention ! Il semble que vous \xeates en dehors des marges recommand\xe9es pour vous. Envisagez de <1>refaire le Quiz</1>, or contacter notre support via <3>{{email}}</3>.",
    programDisclaimer: 'Spacer by CBRE fonctionne "en l\'\xe9tat" et "tel que disponible", sans garantie de quelque nature que ce soit, ni expresse ni tacite. Tous les r\xe9sultats sont fournis \xe0 titre illustratif et ne consittuent pas une recommandation de locaux ou de bail fermes.   Des recommandations fremes peuvent varier de fa\xe7on importante, et d\xe9pendent de beaucoup de facteurs que Spacer ne peut prendre en compte. En utilisant Spacer ou tout rapport g\xe9n\xe9r\xe9 par l\'utilisation de Spacer, vous acceptez les Conditions de Service et Mentions L\xe9gales visibles sur les adresses internet https://workplace.cbre.com/termsOfService et https://www.cbre.fr/fr-fr/a-propos-de-cbre/mention-legales#policy. \xa9 2018 CBRE, Inc. All rights reserved.',
    programMetricsTitle: "M\xe9triques du programme",
    programMetricsSubtitle: "Ces chiffres r\xe9sument votre environnement de travail",
    programDetailsSectionTitle: "Customisez votre programme",
    programDetailsSectionSubtitle: "Ajustez les variables ci-dessous pour affiner votre besoin.",
    programRevertButtonText: "Reprendre",
    programSaveButtonText: "Sauvegarder",
    programSavedButtonText: "Enregistr\xe9",
    // ProgramAssumptions
    programAssumptionsRecommendedOfficeSizeText: "Taille de bureau pr\xe9conis\xe9e",
    programAssumptionsProfileText: "Profil",
    programAssumptionsHeadcountText: "Nombre de collaborateurs",
    programAssumptionsHeadcountFollowingText: "Collaborateurs",
    programAssumptionsCollabText: "Cooperation",
    programAssumptionsCirculationText: "Densit\xe9 de personnes",
    programAssumptionsAvgDaysText: "Nombre de jours moyen dans les locaux",
    programAssumptionsAvgDaysFollowingText: "par semaine",
    programAssumptionsAvgDaysPerWeekText: "Nombre de jours moyen par semaine dans les locaux",
    // ProgramHeroForPrint
    printNIAText: "Surface nette",
    printUSFText: "M\xe8tres carr\xe9s utiles",
    printRSFText: "M\xe8tres carr\xe9s lou\xe9s",
    printDescText: "Bas\xe9 sur vos donn\xe9es, avec un {{lossFactorPercentage}}% {{factorType}} \xe0 {{city}}, nous pr\xe9conisons un total de-",
    printFitFactorText: "facteur d'ajustement",
    printLossFactorText: "coefficient de perte",
    // BarChart
    barChartIndivSubtitle: "Espace Individuel",
    barChartGroupSubtitle: "Espace Collectif",
    barChartAmenitySubtitle: "Espace d'agr\xe9ment",
    // TabbedProgramBarChart
    tabbedBarChartMeSubtitle: "Individuel",
    tabbedBarChartGroupSubtitle: "Groupe",
    tabbedBarChartAmenitySubtitle: "Equipements collectifs",
    // SpaceCategoryBreakdown
    spaceCatBreakdownSubtitle: "Selectionnez un type d'espace \xe0 adapter",
    // SpaceCategoryBreakdownMobile
    spaceCatBreakdownMobileMeTitle: "Espace individuel",
    spaceCatBreakdownMobileWeTitle: "Espace Collectif",
    spaceCatBreakdownMobileAmenityTitle: "Espace d'agr\xe9ment",
    spaceCatBreakdownMobileMeSubtitle: "pour un travail en solo",
    spaceCatBreakdownMobileWeSubtitle: "pour un travail en groupe",
    spaceCatBreakdownMobileAmenitySubtitle: "pour une autre activit\xe9",
    spaceCatBreakdownMobileNIATotalTitle: "Surface nette totale",
    spaceCatBreakdownMobileTotalTitle: "Total {{sfType}} M\xe8tres {{unitCapitalized}}",
    spaceCatBreakdownMobileCirculationText: "Circulation",
    // SpaceCategoryDropdown
    spaceCatDropdownMeText: "Espace Individuel",
    spaceCatDropdownWeText: "Espace Collectif",
    spaceCatDropdownAmenityText: "Espace d'agr\xe9ment",
    // SidebarInfo
    sidebarInfoMeTitle: "Individuel",
    sidebarInfoWeTitle: "Group",
    sidebarInfoAmenityTitle: "Equipements collectifs",
    // Space Category Descriptions (spaceCategoryDescription.js)
    spaceCatMeDesc: "Espace pour un travail individuel. Offrant la possibilit\xe9 de choisir o\xf9 et comment vos collaborateurs travaillent pour leur amener plus de satisfaction.",
    spaceCatWeDesc: "Espace de collaboration et travail d'\xe9quipe. Maintenant que nous pouvons travailler n'importe o\xf9, il est important de fournir des espaces diff\xe9rents selon les activit\xe9s.",
    spaceCatAmenityDesc: "Espace qui facilite le travail. De tels espaces de confort font de vos bureaux des endroits o\xf9 vos collaborateurs - actuels et potentiels - appr\xe9cient passer du temps.",
    // Suggested Custom Amenities (suggestedCustomAmenityUnitMap.js)
    audioVisualCustom: "Audiovisuel",
    dataCenterCustom: "Data center",
    buildingSupportCustom: "Services techniques",
    foodServiceCustom: "Service de restauration",
    kitchenCustom: "Cuisine",
    serveryCustom: "Comptoirs",
    execDiningCustom: "Salons de direction",
    grabNGoCustom: "Vente \xe0 emporter",
    juiceCoffeeBarCustom: "Bar \xe0 jus de fruits / Caf\xe9",
    childCareCustom: "Garderie",
    fitnessCenterCustom: "Salle de fitness",
    healthCenterCustom: "Centre m\xe9dical",
    mailCenterCustom: "Service courrier",
    commercialPrintCustom: "Local d'impression",
    centralCafeCustom: "Caf\xe9t\xe9ria",
    securityCtrlCustom: "PC S\xe9curit\xe9",
    auditoriumCustom: "Auditorium",
    dryCleaningLaundryCustom: "Pressing / Buanderie",
    confCenterCustom: "Centre de conf\xe9rence",
    multiPurpTrainingCustom: "Salle multi-activit\xe9s",
    informalCollabCustom: "Collaboration informelle",
    touchdownTeamCustom: "Point de rassemblement",
    // Suggested Custom Amenity Units (spaceUnit.js)
    seats: "si\xe8ge",
    seats_plural: "si\xe8ges",
    rooms: "salle",
    rooms_plural: "salles",
    areas: "surface",
    areas_plural: "surfaces",
    units: "unit\xe9",
    units_plural: "unit\xe9s",
    // Predefined Amenities (spaceUnitMap.js) - Shared Space Units
    focusRoomDefined: "Salle Focus",
    fileRoomDefined: "Archives",
    centralReceptionHubDefined: "R\xe9ception",
    smOfficeDefined: "Petit bureau",
    regOfficeDefined: "Bureau standard",
    benchDesk5Defined: "Bureau \xe9largi",
    benchDesk6Defined: "Tr\xe8s grand bureau",
    meetingRoom4Defined: "Salle de r\xe9union (4 personnes)",
    meetingRoom6Defined: "Salle de r\xe9union (6 personnes)",
    meetingRoom8Defined: "Salle de r\xe9union (8 personnes)",
    meetingRoom12Defined: "Salle de r\xe9union (12 personnes)",
    meetingRoom15Defined: "Salle de r\xe9union (15 personnes)",
    semiEnclosedMeetingBooth4Defined: "Box semi-ferm\xe9 (4 personnes)",
    openCollabSpace4to6Defined: "Espace de collaboration ouvert (4-6 personnes)",
    contemplationSpaceDefined: "Espace de repos",
    mainITEquipRoomDefined: "Salle informatique principale",
    receptionAreaDefined: "Salle de r\xe9ception",
    cafeFoodServiceDefined: "Caf\xe9 / restauration",
    teamStorageDefined: "Stockage d'\xe9quipe",
    coatClosetsDefined: "Penderies",
    genStorageDefined: "Espace de stockage/ d\xe9chargement",
    centralisedCopyPrintMailDefined: "Salle courrier / impression centrale",
    specialResourceAreaDefined: "Surface de stockage sp\xe9ciale",
    personalStorageDefined: "Casiers individuels",
    storageITSpaceDefined: "Stockage informatique",
    secondaryServerRoomDefined: "Salle informatique secondaire / Salle telecom",
    mothersRoomDefined: "Chambre d'allaitement",
    buildITSpaceDefined: "Atelier informatique",
    workerCouncilOffice2Defined: "Bureau d\xe9di\xe9 aux repr\xe9sentants du personnel",
    securityCtrlRoomDefined: "PC S\xe9curit\xe9",
    centralisedMailDefined: "Salle courrier",
    visitorCoatLuggageRoomDefined: "Bagagerie",
    wellnessRoomDefined: "Salle de bien-\xeatre",
    internalStairDefined: "Escalier int\xe9rieur",
    commercialPrintRoomDefined: "Local d'impression",
    buildingSupportServicesAreaDefined: "Espace pour services techniques",
    // Predefined Amenities (spaceUnitMap.js) - US_SMALL and US_REGULAR
    officeDefined: "Bureau",
    lgOfficeDefined: "Grand bureau",
    smWorkstationDefined: "Workstation (petite)",
    mdWorkstationDefined: "Workstation (moyenne)",
    lgWorkstationDefined: "Workstation (grande)",
    huddleRoomDefined: "Huddle room",
    dispersedCopyPrintAreaDefined: "Local de reprographie / impression",
    smMeetingRoomDefined: "Petite salle de r\xe9union",
    mdMeetingRoomDefined: "Salle de r\xe9union moyenne",
    lgMeetingRoomDefined: "Grande salle de r\xe9union",
    xlMeetingRoomDefined: "Tr\xe8s grande salle de r\xe9union / Boardroom",
    multiPurpTrainingDefined: "Salle multi-activit\xe9s",
    informalCollabDefined: "Espace de collaboration informelle",
    touchdownTeamDefined: "Point de rassemblement",
    pantryVendingCoffeeAreaDefined: "Espace caf\xe9 / office / distributeurs",
    workplaceStorageRoomDefined: "Salle de stockage am\xe9nagement",
    employeeCoatAreaDefined: "Vestiaire collaborateur",
    dispersedMailAreaDefined: "Espace de tri courrier",
    lockerUnitDefined: "Casier",
    serverRoomDefined: "Salle serveur",
    frontDeskAreaDefined: "Espace accueil",
    centralCafeAreaDefined: "Caf\xe9t\xe9ria",
    mailCenterAreaDefined: "Espace courrier",
    kitchenAreaDefined: "Espace cuisine",
    drawerLateralFileUnitDefined: "Classeur 3 tiroirs",
    serveryAreaDefined: "Comptoir",
    juiceBarCoffeeShopAreaDefined: "Bar \xe0 jus de fruits / Caf\xe9",
    diningSupportAreaDefined: "Espace de pr\xe9paration repas",
    diningAreaDefined: "Espace repas",
    grabNGoAreaDefined: "Espace vente \xe0 emporter",
    // Predefined Amenities (spaceUnitMap.js) - UK_REGULAR
    fullFoodServiceDefined: "Service restauration",
    // Predefined Amenities (spaceUnitMap.js) - APAC_REGULAR
    officeWorkMeetDefined: "Bureau de passage standard",
    lgOfficeWorkMeetDefined: "Grand bureau de passage",
    focusDefined: "Focus",
    bench1pt6Defined: "Petit bureau",
    bench1pt8Defined: "Bureau standard",
    bench1pt8LDefined: "Grand bureau",
    banquetWorkMeetDefined: "Banquette (2 places)",
    cafeTable4Defined: "Table caf\xe9 (4 places)",
    kitchenTable8to10Defined: "Table de repas (8-10 places)",
    standingWhiteboardDefined: "Tableau blanc",
    huddleRoom3Defined: "Huddle",
    smMeetingRoom5Defined: "Petite salle de r\xe9union (5 places)",
    mdMeetingRoom8Defined: "Salle de r\xe9union moyenne (8 places)",
    lgMeetingRoom20Defined: "Grande salle de r\xe9union (20 places)",
    xlBoardroom: "Tr\xe8s grande salle de r\xe9union / Boardroom",
    wellnessRoomsDefined: "Salles bien-\xeatre",
    employeeCoatsGymLockersDefined: "Vestiaires collaborateurs",
    lockersDefined: "Casiers",
    dispersedCopyPrintScanAreaDefined: "Local reprographie / impression",
    hydrationPointDefined: "Espace boissons",
    centralHighDensityStorageDefined: "Centre de stockage",
    wellnessMothersRoomDefined: "Bien-\xeatre",
    serverHubRoomsDefined: "Local serveur informatique / t\xe9l\xe9communications",
    buildITStoreRoomDefined: "Atelier / Stockage informatique",
    simpleReceptionWaitDefined: "Salon d'attente",
    centralCafeSocialHubDefined: "Caf\xe9t\xe9ria",
    mailCentreDefined: "Local courrier",
    utilityStoreRoomDefined: "Stockage technique",
    drawerLateralFileDefined: "Classeur 3 tiroirs",
    juiceBarCoffeeShopDefined: "Bar \xe0 jus de fruits / Caf\xe9",
    buildingSupportServicesDefined: "Services techniques",
    // Space Unit Map Descriptions (spaceUnitMap.js) - Shared Descriptions
    focusRoomDesc: "Les Focus sont des espaces clos con\xe7us pour une \xe0 deux personnes et d\xe9di\xe9s \xe0 des activit\xe9s o\xf9 confidentialit\xe9 et/ou concentration sont indispensables. L'isolement acoustique est un pr\xe9requis de ces espaces. Ils sont g\xe9n\xe9ralement non attribu\xe9s et peuvent \xeatre r\xe9serv\xe9s temporairement selon les besoins.",
    fileRoomDesc: "C'est un espace de stockage pour archives papier destin\xe9 \xe0 un collaborateur ou \xe0 une \xe9quipe. En raison des progr\xe8s de la digitalisation, ces espaces sont en forte diminution. Cependant, cela reste un espace indispensable pour des pr\xe9rogatives l\xe9gales ou des projets de longue haleine, particuli\xe8rement alors que les bureaux ouverts proposent peu de stockage.",
    centralReceptionHubDesc: "L'accueil et la r\xe9ception participent de la premi\xe8re impression que vos collaborateurs, clients et visiteurs ont de votre soci\xe9t\xe9. C'est un v\xe9hicule important de votre marque et de l'image que vous souhaitez donner. Les personnels d'accueil doivent \xeatre confortablement install\xe9s, des fauteuils accueillants doivent \xeatre disponibles pour vos visiteurs.",
    officeDesc: "Les bureaux ferm\xe9s sont des espaces individuels de travail clos destin\xe9s \xe0 vos collaborateurs. Ils sont parfaits pour diminuer les distractions et permettre un travail de concentration. Ils sont g\xe9n\xe9ralement \xe9quip\xe9s d'un bureau, d'une fauteuil ainsi que de si\xe8ges pour les visiteurs. Vous trouverez des volumes de stockages variables selon les bureaux. La taille de ces bureaux peut varier selon les activit\xe9s qui y sont men\xe9es (par exemple des r\xe9unions r\xe9guli\xe8res) ou selon le statut des collaborateurs.",
    benchDeskDesc: "Les bureaux ouverts sont des bureaux ouverts individuels. Ils peuvent \xeatre utilis\xe9s par des collaborateurs soit temporairement (par exemple dans des espaces non occup\xe9s) soit de fa\xe7on permanente. Ces bureaux sont aussi tr\xe8s adapt\xe9s pour des collaborateurs de passage ou des prestataires qui ne sont pas toujours pr\xe9sents. Collaboration et ouverture de l'espace sont parmi les avantages de ces bureaux. Un inconv\xe9nient peut \xeatre le bruit induit par cette disposition, c'est pourquoi il est recommand\xe9 de mixer ces bureaux avec des Focus ou Huddle. Le stockage dans ces bureaux est r\xe9duit et limit\xe9 souvent aux abords des plateaux ou \xe9tages.",
    meetingRoomDesc: "Ces salles de r\xe9unions sont des espaces clos pr\xe9vus pour accueillir des r\xe9unions limit\xe9es entre 2 et 4 personnes. Elles contiennent des \xe9quipements audiovisuels et tableaux blancs afin de faciliter le partage d'informations et doivent \xeatre acoustiquement isol\xe9es (les personnes proches hors de la salle ne doivent pas entendre les conversations se d\xe9roulant hors de la salle). Les grandes salles de r\xe9unions pourraient \xeatre \xe9quip\xe9s avec un mobilier flexible de fa\xe7on \xe0 simplifier d\u2019\xe9ventuels changements de destinations (exemple : Salle de Yoga).",
    meetingRoomDesc6: "Ces salles de r\xe9unions sont des espaces clos pr\xe9vus pour accueillir des r\xe9unions limit\xe9es entre 2 et 4 personnes. Elles contiennent des \xe9quipements audiovisuels et tableaux blancs afin de faciliter le partage d'informations et doivent \xeatre acoustiquement isol\xe9es (les personnes proches hors de la salle ne doivent pas entendre les conversations se d\xe9roulant hors de la salle). Les grandes salles de r\xe9unions pourraient \xeatre \xe9quip\xe9s avec un mobilier flexible de fa\xe7on \xe0 simplifier d\u2019\xe9ventuels changements de destinations (exemple : Salle de Yoga).",
    meetingRoomDesc8: "Ces salles de r\xe9unions sont des espaces clos pr\xe9vus pour accueillir des r\xe9unions limit\xe9es entre 2 et 4 personnes. Elles contiennent des \xe9quipements audiovisuels et tableaux blancs afin de faciliter le partage d'informations et doivent \xeatre acoustiquement isol\xe9es (les personnes proches hors de la salle ne doivent pas entendre les conversations se d\xe9roulant hors de la salle). Les grandes salles de r\xe9unions pourraient \xeatre \xe9quip\xe9s avec un mobilier flexible de fa\xe7on \xe0 simplifier d\u2019\xe9ventuels changements de destinations (exemple : Salle de Yoga).",
    meetingRoomDesc12: "Ces salles de r\xe9unions sont des espaces clos pr\xe9vus pour accueillir des r\xe9unions limit\xe9es entre 2 et 4 personnes. Elles contiennent des \xe9quipements audiovisuels et tableaux blancs afin de faciliter le partage d'informations et doivent \xeatre acoustiquement isol\xe9es (les personnes proches hors de la salle ne doivent pas entendre les conversations se d\xe9roulant hors de la salle). Les grandes salles de r\xe9unions pourraient \xeatre \xe9quip\xe9s avec un mobilier flexible de fa\xe7on \xe0 simplifier d\u2019\xe9ventuels changements de destinations (exemple : Salle de Yoga).",
    meetingRoomDesc15: "Ces salles de r\xe9unions sont des espaces clos pr\xe9vus pour accueillir des r\xe9unions limit\xe9es entre 2 et 4 personnes. Elles contiennent des \xe9quipements audiovisuels et tableaux blancs afin de faciliter le partage d'informations et doivent \xeatre acoustiquement isol\xe9es (les personnes proches hors de la salle ne doivent pas entendre les conversations se d\xe9roulant hors de la salle). Les grandes salles de r\xe9unions pourraient \xeatre \xe9quip\xe9s avec un mobilier flexible de fa\xe7on \xe0 simplifier d\u2019\xe9ventuels changements de destinations (exemple : Salle de Yoga).",
    openCollabSpace4to6Desc: "Ces espaces sont pr\xe9vus pour accueillir les activit\xe9s de groupes entre 4 et 6 personnes telles que les brainstormings, conversations informelles entre collaborateurs ou collaborateurs et clients.",
    cafeFoodServiceDesc: "La caf\xe9t\xe9ria est con\xe7ue comme un espace de restauration permettant aussi les \xe9changes et interactions sociales, le travail individuel et les petites r\xe9unions. Le design de cet espace doit incorporer une palette de couleurs conforme \xe0 la marque de l'entreprise et proposer des installations de restauration o\xf9 la praticit\xe9 est de mise.",
    coatClosetsDesc: "Les collaborateurs ont besoin d'endroits o\xf9 ranger leurs manteaux et autres objets volumineux, particuli\xe8rement dans les cas d'am\xe9nagements avec espaces ouverts o\xf9 les stockages individuels au niveau des bureaux sont limit\xe9s. Ils sont r\xe9partis sur les plateaux et pr\xe8s des sorties ou dans les trav\xe9es principales.",
    copyPrintDesc: "R\xe9partis au sein des \xe9tages dans le cas d'openspaces, les espaces d'impression donnent aux collaborateurs un acc\xe8s simple et rapide \xe0 des copieurs multifonctions. Ils sont toujours \xe9quip\xe9s de poubelles de recyclage et de petites armoires de rangement pour les consommables. Ces espaces ne sont pas destin\xe9s \xe0 servir d'espace d'\xe9changes ou de r\xe9unions.",
    specialResourceBuildingSupportAreaDesc: "Il s'agit d'un lieu secondaire qui peut \xeatre destin\xe9 \xe0 des fonctions diverses comme par exemple une annexe \xe0 un PC s\xe9curit\xe9, un espace de stockage technique ou tout autre prestation de service au sein de l'immeuble. Son utilisation varie selon les organisations, et \xe0 mesure que la taille des locaux grandit, ce type d'espace auxiliaire devient plus que probable et n\xe9cessaire.",
    secondaryServerRoomDesc: "Salle informatique secondaire assurant la haute disponibilit\xe9 et h\xe9bergeant les terminaisons de c\xe2blages courant faibles. Ce type de salle n\xe9cessite une a\xe9ration constante et une temp\xe9rature stabilis\xe9e de 22 degr\xe9s Celsius avec 50% d'humidit\xe9.",
    mothersRoomDesc: "Les espaces de repos / locaux d'allaitement sont destin\xe9s \xe0 celles et ceux qui recherchent un lieu de repos pour une courte p\xe9riode, ou un espace o\xf9 allaiter dans des conditions d'hygi\xe8ne et de calme optimales. Les locaux d'allaitement sont une recommandation forte pour toute entreprise de plus de 100 salari\xe9s.",
    visitorCoatLuggageRoomDesc: "Les collaborateurs ont besoin d'endroits o\xf9 ranger leurs manteaux et autres objets volumineux, particuli\xe8rement dans les cas d'am\xe9nagements avec espaces ouverts o\xf9 les stockages individuels au niveau des bureaux sont limit\xe9s. Ils sont r\xe9partis sur les plateaux et pr\xe8s des sorties ou dans les trav\xe9es principales.",
    wellnessRoomDesc: "Les espaces de bien-\xeatre sont destin\xe9s \xe0 celles et ceux qui recherchent un lieu de repos pour une courte p\xe9riode, ou un espace o\xf9 allaiter dans des conditions d'hygi\xe8ne et de calme optimales. Les salles de bien-\xeatre et les locaux d'allaitement sont une recommandation forte pour toute entreprise. Les salles de bien-\xeatre devront disposer d\u2019un r\xe9frig\xe9rateur pour les m\xe8res qui allaitent.",
    internalStairDesc: "Les escaliers int\xe9rieurs donnent acc\xe8s aux \xe9tages par des cages d'escaliers centrales adapt\xe9es ou peuvent \xeatre dispos\xe9s de fa\xe7on autre pour connecter les \xe9tages. Ils peuvent proposer des espaces am\xe9nag\xe9s pour machines \xe0 caf\xe9, r\xe9ception ou \xe9changes informels.",
    commercialPrintRoomDesc: "Souvent associ\xe9 \xe0 l'espace courrier, il offre la capacit\xe9 d'imprimer, relier et assembler des documents. Il met \xe0 disposition plusieurs imprimantes et peur proposer des imprimantes grand format et traceurs. Cet espace comprend un espace de stockage pour les fournitures, un comptoir pour les \xe9quipements plus petits et un lieu pour la mise en page des impressions.",
    pantryVendingCoffeeDesc: "Contrairement \xe0 la caf\xe9t\xe9ria, l'espace caf\xe9 / office / distributeurs est utilis\xe9 par les collaborateurs pour rapidement r\xe9cup\xe9rer nourriture et boissons. Les conversations \xe9tant monnaie courante dans ce type d'espace, ils ne proposent pas de si\xe8ge afin de permettre une circulation optimale tout en facilitant les \xe9changes et discussions.",
    storageDesc: "Les salles de stockage sont destin\xe9es \xe0 contenir divers articles tels que de gros \xe9quipements, des meubles suppl\xe9mentaires, un stockage en vrac, des fournitures de vacances, etc. Elles peuvent \xe9galement \xeatre utilis\xe9es pour le vestiaire des visiteurs et le stockage des bagages. Il est pr\xe9f\xe9rable de pr\xe9voir un petit stockage situ\xe9 pr\xe8s du concierge pour plus de commodit\xe9.",
    centralisedDispersedMailAreaDesc: "Pour les plus grandes soci\xe9t\xe9s, un service/espace courrier est n\xe9cessaire pour organiser le traitement des courriers entrants et sortants. Cet espace propose tout le mat\xe9riel utile \xe0 la gestion et \xe0 la production du courrier, ainsi que de nombreuses surfaces de traitement du papier et autres supports. Il accueille tr\xe8s souvent un collaborateur \xe0 temps plein en charge de la gestion du courrier.",
    lockerDesc: "Les casiers sont \xe0 disposition comme une autre forme de stockage individuel. Ils donnent aux employ\xe9s un espace pour s\xe9curiser leurs objets de valeur, leurs effets personnels et leurs documents professionnels. Les casiers peuvent \xeatre attribu\xe9s \xe0 des collaborateurs ou utilis\xe9s selon le principe du premier arriv\xe9, premier servi.",
    mainITandServerRoomDesc: "Salle informatique principale assurant la haute disponibilit\xe9 et h\xe9bergeant les terminaisons de c\xe2blages courant faibles. Ce type de salle n\xe9cessite une a\xe9ration constante et une temp\xe9rature stabilis\xe9e de 22 degr\xe9s Celsius avec 50% d'humidit\xe9.",
    drawerLateralFileDesc: "Bien qu'une entreprise ne dispose peut-\xeatre pas d'une cuisine et d'un comptoir de service complets, elle peut fournir un caf\xe9 ou un bar \xe0 jus de fruits dans le cadre des \xe9quipements de restauration dans cet espace. Une entreprise peut \xe9galement avoir ce genre d'espace en plus de ses principaux services de restauration, surtout si les locaux sont grands. Cet espace ressemblera probablement \xe0 votre Starbucks local avec un espace de travail pour un membre du personnel de service, s\xe9par\xe9 par un comptoir.",
    grabNGoDesc: "Une petite zone de commodit\xe9 avec plusieurs r\xe9frig\xe9rateurs, des \xe9tag\xe8res pour le snack et les collations, et une machine \xe0 commander. La s\xe9curit\xe9 de ces espaces Grab-N-Go est g\xe9n\xe9ralement surveill\xe9e par cam\xe9ra. Ces espaces sont souvent combin\xe9s avec un petit garde-manger avec des r\xe9frig\xe9rateurs, des cong\xe9lateurs et une zone de pr\xe9paration des aliments.",
    smMeetingConferenceRoomDesc: "Une petite salle de conf\xe9rence est un espace de r\xe9union ferm\xe9 destin\xe9 \xe0 accueillir confortablement 2 \xe0 6 personnes assises \xe0 une table. Ces salles peuvent \xeatre utilis\xe9es \xe0 la fois pour des r\xe9unions internes et pour des r\xe9unions avec les clients. Elles doivent donc \xeatre tr\xe8s conviviales avec un acc\xe8s facile \xe0 l'alimentation \xe9lectrique et aux \xe9quipements audiovisuels.",
    mdMeetingConferenceRoomDesc: "Une salle de conf\xe9rence moyenne est un espace de r\xe9union ferm\xe9 destin\xe9 \xe0 accueillir confortablement 6 \xe0 10 personnes assises \xe0 une table. Ces salles sont utilis\xe9es \xe0 la fois pour des r\xe9unions internes et des r\xe9unions avec les clients. Elles doivent donc \xeatre tr\xe8s conviviales avec un acc\xe8s facile \xe0 l'alimentation \xe9lectrique et aux \xe9quipements audiovisuels.",
    lgMeetingConferenceRoomDesc: "Une grande salle de conf\xe9rence est un espace de r\xe9union ferm\xe9 destin\xe9 \xe0 accueillir confortablement 12 \xe0 14 personnes assises \xe0 une table. Ces salles sont utilis\xe9es \xe0 la fois pour des r\xe9unions internes et des r\xe9unions avec les clients. Elles doivent donc \xeatre tr\xe8s conviviales avec un acc\xe8s facile \xe0 l'alimentation \xe9lectrique et aux \xe9quipements audiovisuels. Les grandes salles de r\xe9unions pourraient \xeatre \xe9quip\xe9s avec un mobilier flexible de fa\xe7on \xe0 simplifier d\u2019\xe9ventuels changements de destinations (exemple : Salle de Yoga).",
    xlMeetingRoomDesc: 'Une salle de conf\xe9rence de type "boardroom" est pr\xe9vue pour accueillir confortablement 14 \xe0 18 personnes, avec la possibilit\xe9 de recevoir au moins 10 personnes suppl\xe9mentaires assises en p\xe9riph\xe9rie de la pi\xe8ce. Cette salle est pr\xe9vue pour de grandes r\xe9unions formelles en interne et pour des r\xe9unions de grande ampleur avec des clients. Pour ce faire, elles sont \xe9quip\xe9es de technologies audiovisuelles de pointe et sont d\xe9cor\xe9es selon des codes orient\xe9s clients.',
    // Space Unit Map Descriptions (spaceUnitMap.js) - US_SMALL and US_REGULAR
    lgOfficeDesc: "Les bureaux sont des espaces de travail individuels ferm\xe9s destin\xe9s aux collaborateurs. Ils sont parfaits pour isoler des nuisances sonores et permettre un travail de concentration. Ils sont g\xe9n\xe9ralement \xe9quip\xe9s d'un bureau et d'un fauteuil ainsi que de si\xe8ges invit\xe9s pour les visiteurs. Ils proposent diff\xe9rentes quantit\xe9s de stockage personnel et de classement. La taille de l'espace peut  varier en fonction des activit\xe9s qui ont lieu dans la salle (par exemple, des r\xe9unions r\xe9guli\xe8res) ou du statut des collaborateurs. Ce bureau l\xe9g\xe8rement plus grand peut \xeatre un bureau pour deux collaborateurs ou peut servir de salle de r\xe9union.",
    smWorkstationDesc: "Les workstations sont des postes de travail individuels ouverts. Des postes de travail plus petits peuvent \xeatre utilis\xe9s par des collaborateurs \xe0 temps plein soit temporairement (en acc\xe8s libre) soit de fa\xe7on permanente. Ces bureaux sont \xe9galement parfaits pour collaborateurs de passage ou des prestataires qui ne sont pas au bureau de fa\xe7on permanente. Collaboration et ouverture de l'espace sont parmi les avantages de ces bureaux. Un inconv\xe9nient peut \xeatre le bruit induit par cette disposition, c'est pourquoi il est recommand\xe9 de mixer ces bureaux avec des Focus ou Huddle. Le stockage dans ces bureaux est r\xe9duit et limit\xe9 souvent aux abords des plateaux ou \xe9tages.",
    mdWorkstationDesc: "Les workstations sont des postes de travail individuels ouverts. Ces espaces plus larges induisent une meilleure capacit\xe9 de stockage de confidentialit\xe9. Ces bureaux sont de fa\xe7on g\xe9n\xe9rale attribu\xe9s \xe0 des collaborateurs plut\xf4t qu'en acc\xe8s libre. Collaboration et ouverture de l'espace sont parmi les avantages de ces bureaux. Un inconv\xe9nient peut \xeatre le bruit induit par cette disposition, c'est pourquoi il est recommand\xe9 de mixer ces bureaux avec des Focus ou Huddle. Des stockages suppl\xe9mentaires se situent souvent aux abords des plateaux ou \xe9tages.",
    lgWorkstationDesc: "Les workstations sont des postes de travail individuels ouverts. Ces espaces plus larges induisent une meilleure capacit\xe9 de stockage de confidentialit\xe9. Ces bureaux sont de fa\xe7on g\xe9n\xe9rale attribu\xe9s \xe0 des collaborateurs plut\xf4t qu'en acc\xe8s libre. Collaboration et ouverture de l'espace sont parmi les avantages de ces bureaux. Un inconv\xe9nient peut \xeatre le bruit induit par cette disposition, c'est pourquoi il est recommand\xe9 de mixer ces bureaux avec des Focus ou Huddle. Des stockages suppl\xe9mentaires se situent souvent aux abords des plateaux ou \xe9tages.",
    huddleRoomDesc: "Les Huddles sont des espaces de travail ferm\xe9s d\xe9di\xe9s aux r\xe9unions de 2 \xe0 4 personnes. Ils proposent des \xe9quipements audiovisuels et tableaux blancs afin de faciliter le partage d'informations et de connaissances. Ils sont isol\xe9s acoustiquement de fa\xe7on \xe0 ce que les personnes install\xe9es \xe0 proximit\xe9 ext\xe9rieure du Huddle ne soient pas capables d'entendre les conversations qui s'y d\xe9roulent.",
    multiPurpTrainingDesc: "Les salles multi-activit\xe9s sont con\xe7ues pour accueillir un grand nombre de personnes (plus de 20). Ces espace permettent de prendre en charge de multiples activit\xe9s telles que des formations, des \xe9v\xe9nements corporate, des pr\xe9sentations pour de larges auditoires. L'am\xe9nagement se doit d'\xeatre r\xe9sistant vues les all\xe9es-venues en grand nombre, mais reste cependant d\xe9cor\xe9 selon des codes orient\xe9s clients.",
    informalCollabDesc: "Ces espaces sont pr\xe9vus pour accueillir les activit\xe9s de petits groupes entre 4 et 6 personnes, telles que des brainstormings, des \xe9changes informels entre collaborateurs ou avec des clients.",
    touchdownTeamDesc: 'Les points de rassemblement ("Touchdowns") sont des espaces de travail individuels ou en petites \xe9quipes dispers\xe9s \xe7a et l\xe0 dans les locaux, utilisables par les collaborateurs et les visiteurs. Ils peuvent \xeatre de diverses hauteurs, tailles et formes et sont utilis\xe9s pour de courtes p\xe9riodes de temps. Ils doivent \xeatre "plug and play", c\'est-\xe0-dire faciles \xe0 trouver et \xe0 utiliser.',
    frontDeskAreaDesc: "C'est le premier arr\xeat possible quand un collaborateur ou un visiteur arrivent dans les locaux. Le bureau doit pourvoir accueillir une personne et son \xe9quipement, une capacit\xe9 de rangement pour les visiteurs se trouvant \xe0 proximit\xe9 autant que faire se peut. Le bureau se trouve non loin de l'accueil, o\xf9 des si\xe8ges et autres am\xe9nagements sont disponibles.",
    mailCenterAreaDesc: "Pour des plus grandes entreprises, un service courrier est n\xe9cessaire pour centraliser les activit\xe9s correspondantes. Cela inclut de grandes espaces de tri et de gestion, associ\xe9s \xe0 des espaces pour le fret et les \xe9quipements. Cet espace varie souvent d'une entreprise \xe0 l'autre, \xe9tant inclus dans d'autres \xe9l\xe9ments d'organisation des locaux.",
    kitchenAreaDesc: "Pour les locaux qui proposent un service de restauration, une cuisine est n\xe9cessaire pour soutenir cette activit\xe9. Les exigences d'une cuisine varient d'une entreprise \xe0 une autre, mais l'on retrouve souvent des appareils de cuisson et un r\xe9frig\xe9rateur. Elle propose \xe9galement un stockage des marchandises s\xe8ches et du mat\xe9riel. La cuisine sera adjacente au possible comptoire de service, et probablement au centre de conf\xe9rence / services aux clients.",
    serveryAreaDesc: "Le comptoir de service est l'endroit o\xf9 les personnes r\xe9cup\xe8rent leur nourriture. Il est  reli\xe9 \xe0 la cuisine et \xe0 un coin repas avec des tables et des si\xe8ges. La planification est tr\xe8s pr\xe9cise pour g\xe9rer les files d'attente et le trafic. La taille et la forme de cet espace varient d'une organisation \xe0 l'autre.",
    diningSupportAreaDesc: "Une entreprise qui offre des services de restauration importants dispose d'espaces techniques suppl\xe9mentaires comme le stockage dans d'autres parties du b\xe2timent qui doivent \xeatre pris en compte dans le programme global. L'espace variera selon les entreprises.",
    diningAreaDesc: "Manger \xe0 proximit\xe9 de la cuisine offre une vari\xe9t\xe9 de choix aux personnes pour s'asseoir et d\xe9jeuner. Fournir plusieurs types de si\xe8ges diff\xe9rents permet \xe9galement d'utiliser l'espace pour les r\xe9unions et la collaboration en dehors de l'heure du d\xe9jeuner. Fournir des si\xe8ges doux et durs ainsi que des r\xe9glages de barre et de hauteur assise donne aux utilisateurs une palette de choix int\xe9ressante.",
    // Space Unit Map Descriptions (spaceUnitMap.js) - UK_REGULAR
    fullFoodServiceDesc: "Dans le cadre d'une prestation d'un service de restauration, plusieurs fonctions sont r\xe9unies pour soutenir cette activit\xe9, notamment une cuisine, un comptoir de service, une salle \xe0 manger (si\xe8ges) et un ou des espaces de stockage. La cuisine et le comptoir de service travaillent ensemble pour pr\xe9parer et servir les plats faits maison. La salle \xe0 manger est l'endroit o\xf9 les collaborateurs et les invit\xe9s peuvent s'asseoir et manger, mais souvent cet espace agit comme un centre social et de collaboration. Comme \xe0 la maison, il y a beaucoup d'\xe9quipements et de stockage de nourriture requis pour fournir des services de restauration, c'est pourquoi les espaces correspondants sont inclus dans l'espace Service de Restauration.",
    // SpaceUnitRow
    spaceUnitRowDeleteTitle: "Supprimer le type d'espace",
    spaceUnitRowDeleteText: "Etes-vous certain que vous souhaitez supprimer ce type d'espace ?",
    spaceUnitRowConfirmDeleteText: "Oui, supprimer",
    spaceUnitRowCancelDeleteText: "Non, conserver",
    // CustomAmenityAdder
    customAmenityAddText: "Ajouter une commodit\xe9 / am\xe9nagement",
    customAmenityPlaceholder: "Type d'am\xe9nagement",
    // SpaceUnitTotals
    spaceUnitTotalsTitleNIA: "Surface nette totale",
    spaceUnitTotalsTitle: "Total {{sfTypeAdj}} Carr\xe9s {{unitCapitalized}}",
    spaceUnitTotalsCirculation: "Circulation",
    spaceUnitTotalsCirculationTooltip: "L' \"espace entre les espaces\". Couloirs, l'espace derri\xe8re votre chaise, l'espace autour des armoires et des portes, ainsi qu'autour des coins. Sans la circulation, vous n'auriez nulle part o\xf9 marcher ! Le plus souvent autour de 35% du total de {{unitCapitalized}} carr\xe9s utiles dans votre programme, cependant variable en fonction de votre profil et de l'immeuble s\xe9lectionn\xe9.",
    spaceUnitTotalsREBNY: "Facteur REBNY",
    spaceUnitTotalsNYCText: "New York City",
    spaceUnitTotalsREBNYTooltip: "Pour les programmes \xe0 New York, nous augmentons le {{sfType}} de 15% pour prendre en compte les mesures REBNY standards. L'espace mesur\xe9 selon les mesures REBNY standards comprennent les sanitaires, cages d'ascenseurs, et l'\xe9paisseur des murs ext\xe9rieurs (entre autres choses).",
    spaceUnitTotalsLossFactor: "Facteur de perte",
    spaceUnitTotalsLossFactorTooltip: "les {{unit}} carr\xe9s utiles repr\xe9sentent combien d'espace vous avez dans vos locaux. Les {{unit}} carr\xe9s louables repr\xe9sentent la surface pour laquelle vous payez, incluant les pilonnes, halls, et autres parties communes. La diff\xe9rence entre surface utile et surface louable repr\xe9sente le facteur de perte, et son calcul varie selon les endroits.",
    // CollaborationDropdown
    collabDropdownLevelLowText: "Minime (0-25%)",
    collabDropdownLevelMedText: "Moyen (26-50%)",
    collabDropdownLevelHighText: "Important (51-100%)",
    //DensityDropdown
    sameDensityText: "Une densit\xe9 identique \xe0 celle d\u2019avant COVID-19",
    lowerDensityText: "Une densit\xe9 plus faible (soit davantage de m\xe8tres carr\xe9s par personne)",
    notSureDensityText: "Je ne sais pas",
    //CirculationDropdown
    preCovidText: "Pre-Covid-19 (45% bureaux ouverts / 25% ferm\xe9s)",
    higherText: "Densit\xe9 diminu\xe9e (50% bureaux ouverts / 30% ferm\xe9s)",
    notSureText: "Je ne sais pas (45% bureaux ouverts / 25% ferm\xe9s)",
    // ExamplePlans
    examplePlanButtonText: "Visualisez un exemple de plan",
    examplePlanFullFloorText: "Etage complet",
    examplePlanPartialFloorText: "Etage partiel",
    examplePlanFullImgAlt: "Plan d'un \xe9tage de {{size}} {{unit}} carr\xe9s illustrant un profil {{profileName}} issu de Spacer by CBRE",
    examplePlanPartialImgAlt: "Plan d'un \xe9tage partiel de {{size}} {{unit}} carr\xe9s illustrant un profil {{profileName}} issu de Spacer by CBRE",
    examplePlanTooltipText: "Si vous avez plus de {{size}} {{unit}}, vous aurez besoin de plus d'un \xe9tage.",
    // ProgramStats
    programStatsDensitySubtitleTsubo: "Tsubo net",
    programStatsDensitySubtitle: "{{adjective}} Carr\xe9s {{unitUppercase}}",
    programStatsIndivTitle: "Postes de Travail",
    programStatsWorkstationsSubtitle: "Workstations",
    programStatsOfficesSubtitle: "Bureaux",
    programStatsCollabTitle: "Places d\u2019\xe9changes",
    programStatsEnclosedSubtitle: "Si\xe8ges de groupe",
    programStatsIndivSeatSubtitle: "Si\xe8ge individuel",
    programStatsSeatsTitle: "Positions par personne",
    programStatsIndivSeatsSubtitle: "Si\xe8ges individuels",
    programStatsPersonSubtitle: "Personne",
    programStatsDensityTitle: "Densit\xe9",
    programStatsFullDensitySubtitle: "{{density}} par Si\xe8ge individuel",
    // Profile Display Names (profileNames.js)
    efficientName: "L'Optimiseur",
    whiteCollarName: "L'Accomodateur",
    whiteGloveName: "L'Amplificateur",
    openOfficeName: "Le Producteur",
    workplace360Name: "Le Connecteur",
    campusName: "Le Diff\xe9renciateur",
    startupName: "L'Incubateur",
    engCreativeName: "Le Cr\xe9ateur",
    // Profile Descriptions (profileDescriptions.js)
    efficientDesc: "Le r\xe9sultat de type Optimizer est un environnement sans fioriture avec un \xe9tat d'esprit ax\xe9 sur \"faire le travail\". L'espace est ax\xe9 sur la mise \xe0 disposition des collaborateurs avec tous les outils n\xe9cessaires disponibles \xe0 leur bureau. La collaboration et le travail en \xe9quipe sont moins fr\xe9quents. Les bureaux des collaborateurs sont normalis\xe9s et attribu\xe9s avec seulement des espaces de support basiques fournis. Fid\xe8le \xe0 son nom, ces environnements sont presque toujours ouverts afin de maximiser l'efficacit\xe9.",
    whiteCollarDesc: "Pour le type Accomodateur, vous n'\xeates pas seul - c'est l'un des profils les plus populaires pour les lieux de travail en entreprise. Les bureaux des Accomodateurs pr\xe9f\xe8rent ne pas bousculer les habitudes avec une conception d'espace radicale, mais investissent souvent dans de nouvelles technologies et de nouveaux meubles pour rendre l'espace productif et attrayant. Avec un \xe9quilibre des espaces individuels et collaboratifs, les employ\xe9s se retrouveront principalement \xe0 leur bureau avec des r\xe9unions occasionnelles et des sessions d'\xe9quipe. Parfait pour une activit\xe9 traditionnelle.",
    whiteGloveDesc: "Entrez dans le hall d'un immeuble Enhancer et vous vous sentirez peut-\xeatre devenu grand. Ce lieu de travail r\xe9pond profond\xe9ment aux besoins des collaborateurs, ainsi que des clients, qui visitent fr\xe9quemment les locaux. Plus que tout autre profil de lieu de travail, les bureaux et les espaces clos sont communs. La plupart des employ\xe9s gagnent leur espace de bureau gr\xe2ce \xe0 la performance ou \xe0 l'anciennet\xe9, et la hi\xe9rarchie joue probablement un r\xf4le important dans le fonctionnement de l'organisation. Grimpez l'\xe9chelle de l'entreprise avec style.",
    openOfficeDesc: "Le bureau de type Producteur sait ce dont vous avez besoin pour r\xe9ussir. Il s'agit de donner aux gens les espaces fondamentaux n\xe9cessaires en fonction du type d'activit\xe9 qui se d\xe9roule dans les locaux. Non seulement ces diff\xe9rents types d'espace sont disponibles, mais nous constatons qu'ils sont tr\xe8s utilis\xe9s - un moyen de rester efficace ! Il existe un m\xe9lange homog\xe8ne entre le travail individuel et le travail en \xe9quipe, ce qui signifie probablement que vous vous d\xe9placez beaucoup au bureau pendant la journ\xe9e. Parfait pour un bureau en d\xe9placement !",
    workplace360Desc: "Tout comme votre pose de yoga pr\xe9f\xe9r\xe9e, le Connecteur est fier de l'\xe9quilibre. Avec la bonne combinaison d'espace ax\xe9 sur la productivit\xe9 et d'espace de connexion sociale, le bureau Connector fournit tous les \xe9l\xe9ments essentiels pour la concentration tout en encourageant le choix avec une vari\xe9t\xe9 d'autres espaces. Fid\xe8le \xe0 son nom, le bureau du Connecteur localise ses zones communes comme les cuisines et les espaces de r\xe9union ouverts de mani\xe8re centralis\xe9e. Cela aide \xe0 rassembler les gens et cr\xe9e un sentiment de communaut\xe9.",
    campusDesc: "Le Diff\xe9renciateur rend difficile le d\xe9part en fin de journ\xe9e. C'est parce qu'il se caract\xe9rise par la fourniture d'une exp\xe9rience de travail qui est au-dessus et au-del\xe0 du reste. Vous trouverez des \xe9quipements am\xe9lior\xe9s autour du bien-\xeatre ou de la restauration pour aider les employ\xe9s \xe0 gagner du temps et \xe0 se sentir \xe0 l'aise. Quelqu'un a-t-il dit des collations ? Les employ\xe9s sont encourag\xe9s \xe0 prendre des pauses, \xe0 socialiser et \xe0 se d\xe9tendre sur le lieu de travail.",
    startupDesc: "La vitesse et l'id\xe9ation sont les ma\xeetres-mots en ce qui concerne l'Incubateur. Les employ\xe9s travaillent dans des \xe9quipes hautement collaboratives et pensent comme des propri\xe9taires. Cet environnement de bureau est en constante \xe9volution, ce qui signifie que la plupart des espaces a une flexibilit\xe9 int\xe9gr\xe9e. Le d\xe9placement de meubles et le changement sont courants. Un m\xe9lange d'activit\xe9s sociales amusantes et de sessions de travail intenses, comme le ping-pong et les hackathons, sont utilis\xe9s pour renforcer la camaraderie en \xe9quipe.",
    engCreativeDesc: "Nous consid\xe9rons le Createur comme un endroit rempli de sp\xe9cialistes - pas votre m\xe9lange typique de services. Comme pour tous les grands efforts cr\xe9atifs, l'espace de type Createur propose souvent de travailler ensemble et de faire \xe9quipe. L'\xe9quipement sp\xe9cialis\xe9 ou les mat\xe9riaux \xe0 manipuler font probablement partie des activit\xe9s de travail quotidiennes. Les collaborateurs disposent de l'espace dont ils ont besoin pour faire leur travail efficacement, et bien qu'il s'agisse plut\xf4t d'un type d'espace rare, un job unique n\xe9cessite un lieu de travail unique.",
    // Profile Key Traits: Shared Names (profileTraitMap.js)
    social: "Social",
    efficient: "Efficace",
    flexible: "Flexible",
    enabled: "Activ\xe9",
    productive: "Productif",
    inclusive: "Inclusif",
    clientFocused: "Orient\xe9 Client",
    standardized: "Standardis\xe9",
    // Profile Key Traits (profileTraitMap.js)
    social1Desc: "Les relations en dehors et \xe0 l'int\xe9rieur du bureau sont importantes",
    social2Desc: "Beaucoup d'\xe9v\xe9nements de coh\xe9sion d'\xe9quipe",
    social3Desc: "Les collaborateurs appr\xe9cient passer du temps ensemble",
    social4Desc: "Plus ouvert et collectif",
    efficient1Desc: "L'entreprise demeure \xe9conome et soucieuse de son budget",
    efficient2Desc: "L'entreprise demeure \xe9conome et productive",
    flexible1Desc: "Les gens choisissent comment travailler",
    flexible2Desc: "Les collaborateurs ont beaucoup de libert\xe9",
    flexible3Desc: "Construisez l'espace dont vous avez besoin",
    enabled1Desc: "Les collaborateurs ont ce dont ils ont besoin \xe0 leur bureau",
    enabled2Desc: "Les collaborateurs disposent de services et commodit\xe9s de qualit\xe9",
    enabled3Desc: "Les collaborateurs peuvent avoir tout ce dont ils ont besoin pour travailler",
    enabled4Desc: "Avoir acc\xe8s au bon \xe9quipement et \xe0 la technologie ad\xe9quate",
    enabled5Desc: "De l'\xe9quipement sp\xe9cialis\xe9 est disponible",
    productive1Desc: "Design fonctionnel et intuitif",
    productive2Desc: "Orient\xe9 Client et responsable financi\xe8rement",
    productive3Desc: "Centr\xe9 sur un produit unique ou sur une seule offre de service",
    inclusive1Desc: "Diff\xe9rents type d'espaces disponibles",
    inclusive2Desc: "Vous pouvez trouver tout ce dont vous avez besoin dans les locaux",
    inclusive3Desc: "Beaucoup de fa\xe7ons diff\xe9rentes de travailler sont possibles",
    clientFocused1Desc: "La premi\xe8re impression des clients est primordiale",
    clientFocused2Desc: "Les locaux sont accueillants pour les clients et les nouveaux collaborateurs",
    clientFocused3Desc: "Les locaux sont soign\xe9s pour les clients et les nouveaux collaborateurs",
    standardized1Desc: "Les processus et les syst\xe8mes sont rationnels",
    standardized2Desc: "Normes organisationnelles en ce qui concerne l'allocation d'espaces",
    standardized3Desc: "Tailles modulaires pour la flexibilit\xe9",
    standardized4Desc: "Processus et livrables rationalis\xe9s",
    // SpaceSummary
    spaceSummaryBarHeader: "Taille de locaux recommand\xe9e",
    spaceSummaryMeasurementTypeText: "Type de mesures",
    spaceSummaryUnitTypeText: "unit\xe9s",
    spaceSummaryLossFactorSectionLabel: "{{factor}} D\xe9tails",
    spaceSummaryFitFactorText: "Facteur d'ajustement",
    spaceSummaryLossFactorText: "Facteur de perte",
    spaceSummaryRSFLossFactorHelperText: "Bas\xe9 sur un facteur de perte de {{percentage}}% pour {{place}}, vous devriez rechercher des locaux entre {{min}} et {{max}} {{units}} de surface louable.",
    spaceSummaryNIAFitFactorHelperText: "Bas\xe9 sur un facteur de perte de {{percentage}}% pour {{place}}, vous devriez rechercher des locaux avec {{amt}} de surface nette utile.",
    spaceSummaryNIATooltipText: "La Surface Nette Utile est la surface obtenue en \xf4tant la surface de certains espaces \xe0 la surface totale d'un immeuble ou d'un \xe9tage.",
    // SFTypeRadioInput
    sfRadioInputUsableAreaTooltipText: "Cette mesure inclut toutes les salles, meubles et espaces de circulation.",
    sfRadioInputRentableAreaTooltipText: "C'est typiquement le {{unitUppercase}} Carr\xe9 Utilisable plus un partie des espaces communs de l'immeuble. Bien que vous ne puissiez tout utiliser, c'est le {{unit}} Carr\xe9 que vous payer quand vous louez.",
    sfRadioInputUsableSquareText: "{{unitUppercase}} Carr\xe9 Utile",
    sfRadioInputRentableSquareText: "{{unitUppercase}} Carr\xe9 Louable",
    //floored plan request block
    flooredTitle: "Ne partez pas tout de suite !",
    flooredSubTitle: "Revoir la mani\xe8re dont les clients explorent l\u2019espace",
    flooredSubText: "Voir les r\xe9sultats sur un plan d\u2019\xe9tage et basculez en 3D !",
    flooredParagraphText1: "Exp\xe9rience immersive permettant aux utilisateurs d\u2019imaginer des possibilit\xe9s, d\u2019exp\xe9rimenter de nouveaux espaces et de transformer les id\xe9es en r\xe9alit\xe9s",
    flooredParagraphText2: "Vision concr\xe8te et personnalis\xe9e pour chaque espace potentiel",
    flooredVideoHeading: "Voir un exemple d\u2019exp\xe9rience immersive",
    flooredFreeText: "Quoi de plus, c\u2019est gratuit !",
    flooredIconText1: "Partagez les plans librement",
    flooredIconSubText1: "Exportez les sur des Formats Autocad ou PDF",
    flooredIconText2: "Temps de production estim\xe9",
    flooredIconSubText2: "Une \xe0 deux semaines",
    flooredIconText3: "Recevez une exp\xe9rience partageable",
    flooredIconSubText3: "Exp\xe9riences 2D et 3D personnalis\xe9es",
    // MeasurementSystemRadioInput
    measurementSystemSqFeetText: "Pied carr\xe9",
    measurementSystemSqMetersText: "M\xe8tre carr\xe9",
    measurementSystemTsuboText: "Tsubo",
    // ProfileHero
    resultsProfileHeroAnnouncementTitle: "Votre espace est",
    resultsProfileHeroImgAlt: "Plan 3D montrant un aper\xe7u des bureaux pour le profil {{profileName}} g\xe9n\xe9r\xe9 par Spacer by CBRE",
    // ProfileComparison
    profileCompModalTitle: "Changer votre Profil ?",
    profileCompModalText: "Vous predrez toute modification non sauvegard\xe9e sur votre programme actuel.",
    profileCompModalConfirmText: "Oui, changer mon Profil",
    profileCompModalCancelText: "Non, garder mon Profil actuel",
    profileCompNavbarCancelButtonText: "Annuler",
    profileCompNavbarUseButtonText: "Utiliser ce Profil",
    profileCompCompareTitle: "Comparez vos correspondances de Profils les plus proches",
    // ProfileComparisonColumn
    profileCompColumnSelectedText: "Profil s\xe9lectionn\xe9",
    profileCompColumnSelectText: "Selectionner",
    profileCompColumnRecommendedText: "(Recommand\xe9)",
    profileCompColumnImgAltText: "Plan 3D montrant un aper\xe7u des bureaux pour le profil {{profileName}} g\xe9n\xe9r\xe9 par Spacer by CBRE"
};


var $1162e5242ea498da$exports = {};
$1162e5242ea498da$exports = {
    // TermsOfService
    TermsTitle: "Conditions d'utilisation",
    TermsIntroText: "Il s'agit d'un accord entre vous et CBRE, Inc. (\xabCBRE\xbb) concernant l'acc\xe8s \xe0 et l'utilisation de l'application connue sous le nom de Spacer\xae. En utilisant ou en acc\xe9dant \xe0 l'une des informations ou des services de cette application Web, vous reconnaissez avoir lu, compris et accept\xe9 les conditions g\xe9n\xe9rales \xe9nonc\xe9es dans les pr\xe9sentes conditions d'utilisation (l '\xabAccord\xbb ou les \xabCGU\xbb). Les termes \xabvous\xbb, \xabvotre\xbb ou \xabUtilisateur\xbb d\xe9signent, collectivement, la personne et toute entit\xe9 au nom de laquelle cette personne peut agir.",
    TermsLimitationsTitle: "Limites",
    TermsLimitationsA: "L'utilisateur comprend et accepte que l'acc\xe8s de l'utilisateur \xe0 Spacer\xae est non exclusif, non sous-licenciable, non transf\xe9rable, librement r\xe9vocable et peut \xeatre suspendu ou r\xe9sili\xe9 \xe0 tout moment pour quelque raison que ce soit par CBRE.",
    TermsLimitationsB: "L'Utilisateur comprend et accepte en outre que l'octroi de l'acc\xe8s \xe0 Spacer\xae ne conf\xe8re \xe0 l'Utilisateur aucun droit de propri\xe9t\xe9 sur Spacer\xae ou toute documentation connexe (y compris dans les nouvelles versions, modifications ou am\xe9liorations), qui seront et resteront exclusivement la propri\xe9t\xe9 de CBRE, y compris, sans s'y limiter, les droits d'auteur y aff\xe9rents, les brevets associ\xe9s, les brevets de conception, les marques, l'habillage commercial, les secrets commerciaux et autres droits de propri\xe9t\xe9 d\xe9coulant de la loi applicable ou des conventions internationales (collectivement, les \xabdroits de propri\xe9t\xe9\xbb). Voir la section 2 (Propri\xe9t\xe9) ci-dessous. Par la pr\xe9sente, CBRE se r\xe9serve express\xe9ment tous les droits sur Spacer\xae qui ne sont pas express\xe9ment accord\xe9s \xe0 l'utilisateur en vertu des pr\xe9sentes.",
    TermsLimitationsC: "Sauf disposition contraire des pr\xe9sentes ou autorisation expresse par CBRE \xe0 l'utilisateur par \xe9crit, l'utilisateur ne doit pas: (i) modifier, traduire, r\xe9troconcevoir, d\xe9compiler, d\xe9sassembler, tenter de reconstruire, identifier ou d\xe9couvrir tout code source, id\xe9es sous-jacentes, utilisateur sous-jacent, interfaces utilisateur ou algorithmes, ou cr\xe9er des \u0153uvres d\xe9riv\xe9es ou copier Spacer\xae; (ii) supprimer, modifier ou reproduire tout avis de droit d'auteur ou de marque ou tout autre droit de propri\xe9t\xe9 contenus dans Spacer\xae; (iii) c\xe9der, sous-licencier ou autrement transf\xe9rer son acc\xe8s, son utilisation ou d'autres droits ou d\xe9l\xe9guer ses obligations en vertu du pr\xe9sent Accord; ou (iv) sans limiter ce qui pr\xe9c\xe8de, utiliser Spacer\xae dans le but de cr\xe9er un produit ou un service concurrent, ou \xe0 toute autre fin que les fins commerciales l\xe9gitimes li\xe9es aux activit\xe9s de l'utilisateur.",
    TermsLimitationsD: "L'Utilisateur s'engage \xe0 informer rapidement CBRE par \xe9crit si toute utilisation non autoris\xe9e de Spacer\xae, ou toute violation \xe9ventuelle des Droits de Propri\xe9t\xe9, lui est signal\xe9e.",
    TermsLimitationsE: "\xc0 aucun moment pendant ou apr\xe8s la dur\xe9e du pr\xe9sent Accord, l'Utilisateur ne doit demander un enregistrement de tout droit d'auteur, marque de commerce ou autre d\xe9signation qui affecterait la propri\xe9t\xe9 des Droits de Propri\xe9t\xe9 ni d\xe9poser aucun document aupr\xe8s d'une autorit\xe9 gouvernementale pour entreprendre une action qui affecterait les droits de propri\xe9t\xe9, y compris la propri\xe9t\xe9 par CBRE de Spacer\xae, de la marque Spacer\xae et d'autres composants d'application. Spacer\xae est une marque commerciale et un service de CBRE.",
    TermsLimitationsF: "L'Utilisateur d\xe9clare et accepte que l'Utilisateur a le droit de fournir tous les documents publi\xe9s ou les informations utilis\xe9es en relation avec Spacer\xae, et accorde par la pr\xe9sente \xe0 CBRE un droit et une licence non exclusifs, libres de droits, mondiaux, irr\xe9vocables, perp\xe9tuels et une licence d'utilisation, de reproduction, modification, distribution, cr\xe9ation des \u0153uvres d\xe9riv\xe9es et affiche ces documents et informations \xe0 la discr\xe9tion de CBRE. L'Utilisateur reconna\xeet que l'Utilisateur est responsable de tout mat\xe9riel et information soumis par l'Utilisateur, y compris sa l\xe9galit\xe9, fiabilit\xe9, pertinence, originalit\xe9 et copyright. Les licences accord\xe9es par l'utilisateur \xe0 CBRE en vertu des pr\xe9sentes survivront \xe0 toute r\xe9siliation de l'utilisation de Spacer\xae par l'utilisateur. Tout mat\xe9riel et information soumis par l'utilisateur sera consid\xe9r\xe9 comme non confidentiel et non exclusif, trait\xe9 comme tel par CBRE, et pourra \xeatre utilis\xe9 par CBRE conform\xe9ment au pr\xe9sent accord sans pr\xe9avis \xe0 l'utilisateur et sans aucune responsabilit\xe9 envers CBRE.",
    TermsOwnershipTitle: "Propri\xe9t\xe9",
    TermsOwnershipText: "Spacer\xae, son langage de programmation, son logiciel et sa documentation et tout autre mat\xe9riel ou contenu mis \xe0 disposition sur Spacer\xae ou toutes am\xe9liorations, modifications, travaux d\xe9riv\xe9s, am\xe9liorations ou changements apport\xe9s \xe0 Spacer\xae et toutes leurs copies sont la propri\xe9t\xe9 de CBRE et leur titre reste uniquement propri\xe9t\xe9 de CBRE en toutes circonstances, y compris, sans s'y limiter, tous les droits sur les brevets, droits d'auteur, marques et secrets commerciaux inclus dans Spacer\xae et les am\xe9liorations, modifications, \u0153uvres d\xe9riv\xe9es et changements correspondants. L'utilisateur comprend que ce qui pr\xe9c\xe8de inclut des secrets commerciaux et des informations confidentielles et exclusives \xe0 CBRE et s'engage \xe0 prendre toutes les mesures n\xe9cessaires pour prot\xe9ger la confidentialit\xe9 de ces informations. L'utilisateur ne doit pas vendre, transf\xe9rer, publier, divulguer, afficher ou autrement rendre disponible Spacer\xae ou cr\xe9er ou rendre disponible des am\xe9liorations, des modifications, des travaux d\xe9riv\xe9s, ou des changements \xe0 ceux-ci ou des copies de ceux-ci \xe0 des tiers. La r\xe9siliation du pr\xe9sent accord s'ajoute et ne remplace pas les recours dont CBRE dispose \xe0 la fois en droit et en \xe9quit\xe9. Les obligations ci-apr\xe8s survivront \xe0 la r\xe9siliation du pr\xe9sent accord.",
    TermsTerminationTitle: "R\xe9siliation ; Effet de la r\xe9siliation ; Recours.",
    TermsTerminationA: "Sans se limiter \xe0 d'autre recours, CBRE peut modifier, limiter, suspendre, interrompre ou r\xe9silier le pr\xe9sent Accord et / ou l'utilisation par l'utilisateur de tout ou partie de Spacer\xae, avec effet imm\xe9diat, automatiquement, avec ou sans pr\xe9avis et sans recours aux tribunaux, pour quelque raison que ce soit ou sans raison. L'Utilisateur accepte que CBRE n'a aucune obligation de fournir Spacer\xae et que CBRE ne sera pas responsable envers l'Utilisateur ou envers toute autre partie de toute limitation, suspension, interruption, r\xe9siliation ou modification de Spacer\xae. ",
    TermsTerminationB: "L'utilisateur reconna\xeet que les obligations contract\xe9es aux termes de CBRE en vertu de la pr\xe9sente sont de nature unique et irrempla\xe7able, dont la perte causera un pr\xe9judice irr\xe9parable \xe0 CBRE et qui ne peut pas \xeatre remplac\xe9e par des dommages-int\xe9r\xeats p\xe9cuniaires seulement, de sorte que CBRE aura droit \xe0 une injonction ou autre r\xe9paration \xe9quitable (sans les obligations de toute caution ou caution) en cas de violation ou de violation anticip\xe9e par l'Utilisateur. L'utilisateur renonce irr\xe9vocablement \xe0 tout droit de demander une injonction ou autre r\xe9paration \xe9quitable. ",
    TermsDisclaimerTitle: "Clauses de non-responsabilit\xe9 et limitation de responsabilit\xe9.",
    TermsDisclaimerA: "Spacer\xae est fourni \xe0 l'utilisateur \xabTEL QUEL\xbb et \xabTEL QUE DISPONIBLE\xbb sans aucune garantie. CBRE D\xc9CLINE TOUTES LES GARANTIES, EXPRESSES OU IMPLICITES, Y COMPRIS, MAIS SANS S'Y LIMITER, LES GARANTIES IMPLICITES DE QUALIT\xc9, D'AD\xc9QUATION \xc0 UN USAGE PARTICULIER ET DE NON-CONTREFA\xc7ON. CBRE NE GARANTIT EN AUCUNE MANI\xc8RE QUE Spacer\xae R\xc9PONDRA AUX EXIGENCES DE L'UTILISATEUR OU \xc0 TOUTE NORME PARTICULI\xc8RE. CERTAINS \xc9TATS N'AUTORISENT PAS L'EXCLUSION DES GARANTIES IMPLICITES, DONC L'EXCLUSION CI-DESSUS PEUT NE PAS S'APPLIQUER \xc0 L'UTILISATEUR. Dans ce cas, la responsabilit\xe9 de CBRE sera limit\xe9e dans toute la mesure possible en vertu de la loi applicable. AUCUNE INFORMATION OU CONSEIL ORAL OU \xc9CRIT DONN\xc9 PAR CBRE, SES AGENTS OU SES EMPLOY\xc9S, NE CR\xc9ERA UNE GARANTIE DE QUELQUE MANI\xc8RE QUE CE SOIT. AUCUNE GARANTIE N'EST DONN\xc9E QUE Spacer\xae OU TOUTE INFORMATION FOURNIE \xc0 L'UTILISATEUR SONT SANS ERREUR OU QUE L'UTILISATION DE Spacer\xae SERA ININTERROMPUE, \xc0 JOUR, COMPL\xc8TE OU EXEMPT DE VIRUS OU D'AUTRES COMPOSANTS NOCIFS, ET AUCUNE GARANTIE N'EST DONN\xc9E QUE TOUT CE QUI PR\xc9C\xc8DE SERA CORRIG\xc9. CBRE NE GARANTIT NI NE FAIT AUCUNE REPR\xc9SENTATION CONCERNANT L'UTILISATION OU LES R\xc9SULTATS DE L'UTILISATION DE Spacer\xae. CBRE NE SAURAIT \xcaTRE TENU RESPONSABLE DES DOMMAGES INDIRECTS, SP\xc9CIAUX, ACCESSOIRES, CONS\xc9CUTIFS, PUNITIFS OU EXEMPLAIRES (Y COMPRIS SANS LIMITATION LES DOMMAGES LI\xc9S \xc0 LA PERTE D'AFFAIRES, LA PERTE DE PROFITS, LA PERTE DE RECETTES, LES \xc9CONOMIES PERDUES, L'INTERRUPTION INFORMATIQUE, LA BONNE VOLONT\xc9, L'UTILISATION, LES DONN\xc9ES OU AUTRES PERTES INCORPORELLES), QU'ELLES SOIENT BAS\xc9ES SUR LA VIOLATION DU CONTRAT, LE TORT (Y COMPRIS LA N\xc9GLIGENCE), LA RESPONSABILIT\xc9 DU PRODUIT OU AUTREMENT, M\xcaME SI CBRE OU SES REPR\xc9SENTANTS ONT \xc9T\xc9 AVIS\xc9S DE LA POSSIBILIT\xc9 DE TELS DOMMAGES ET M\xcaME SI UN RECOURS D\xc9FINI PAR LES PR\xc9SENTES ECHOUE.",
    TermsDisclaimerB: "LA RESPONSABILIT\xc9 TOTALE DE CBRE POUR LES DOMMAGES POUR QUELQUE CAUSE QUE CE SOIT N'EXC\xc9DERA PAS LES FRAIS PAY\xc9S PAR L'UTILISATEUR POUR Spacer\xae PENDANT LES DOUZE (12) MOIS AVANT L'\xc9V\xc9NEMENT CENSE AVOIR CAUSE LES DOMMAGES. L'UTILISATEUR CONVIENT QUE TOUTE CAUSE D'UNE ACTION D\xc9COULANT DE OU LI\xc9E \xc0 Spacer\xae OU AUTREMENT LI\xc9E AU PR\xc9SENT CONTRAT DOIT COMMENCER DANS UN (1) AN APR\xc8S LA CAUSE DES ACTIONS SURVENUES. AUTREMENT, UNE TELLE CAUSE D'ACTION EST DEFINITIVEMENT INVALIDE. \xbb",
    TermsDisclaimerC: "CERTAINES JURIDICTIONS PEUVENT NE PAS PERMETTRE LA LIMITATION DE RESPONSABILIT\xc9 OU LES EXCLUSIONS DE RESPONSABILIT\xc9 \xc9NONC\xc9ES CI-DESSUS, DONC LA LIMITATION OU L'EXCLUSION CI-DESSUS PEUT NE PAS S'APPLIQUER \xc0 L'UTILISATEUR. Dans un tel cas, la responsabilit\xe9 de CBRE sera limit\xe9e dans toute la mesure possible en vertu de la loi applicable. La renonciation \xe0 la garantie, les recours exclusifs et la responsabilit\xe9 limit\xe9e \xe9nonc\xe9s ci-dessus sont des \xe9l\xe9ments fondamentaux de la base de cet accord entre CBRE et l'UTILISATEUR. CBRE ne serait pas en mesure de fournir Spacer\xae sur une base \xe9conomique et n'aurait pas conclu cet accord sans de telles limitations. Ces limitations survivront \xe0 toute r\xe9siliation du pr\xe9sent accord.",
    TermsIndemnificationTitle: "Indemnisation de l'utilisateur.",
    TermsIndemnificationText: "Au choix et \xe0 la demande de CBRE, l'Utilisateur doit, \xe0 ses frais, indemniser et d\xe9gager CBRE et ses filiales, soci\xe9t\xe9s affili\xe9es, dirigeants, employ\xe9s, agents, co-marques, associations et autres partenaires de toute responsabilit\xe9 contre et contre toute perte, co\xfbt, dommage, responsabilit\xe9s, r\xe8glements et d\xe9penses (y compris, sans s'y limiter, les frais et honoraires d'avocat), d\xe9coulant de ou li\xe9s \xe0 toute r\xe9clamation, action ou all\xe9gation de tiers li\xe9es ou r\xe9sultant de: (a) toute transaction ou litige entre l'Utilisateur et tout tiers; (b) des faits ou des faits all\xe9gu\xe9s qui constitueraient une violation des d\xe9clarations, garanties ou engagements de l\u2019Utilisateur en vertu du pr\xe9sent Contrat ou de toute loi, r\xe8gle ou r\xe9glementation applicable, r\xe9f\xe9renc\xe9e ou non dans les pr\xe9sentes; (c) tout mat\xe9riel, information ou contenu utilisateur soumis dans ou sur Spacer\xae; (d) violation par l\u2019utilisateur de tous droits de tiers, (e) utilisation ou mauvaise utilisation de Spacer\xae par l\u2019utilisateur; ou (f) la n\xe9gligence ou la faute intentionnelle de l'utilisateur. CBRE a le droit de diriger et de contr\xf4ler exclusivement sa d\xe9fense et d'engager un avocat de son choix, aux frais de l'utilisateur.",
    TermsGeneralTitle: "G\xe9n\xe9ral",
    TermsGeneralA: "<0> Int\xe9gralit\xe9 de l'accord / pas de renonciation involontaire. </0> Cet accord constitue l'int\xe9gralit\xe9 de l'accord entre CBRE et l'utilisateur en ce qui concerne Spacer\xae et tout l'objet du pr\xe9sent accord, et remplace tous les accords ant\xe9rieurs entre CBRE et l'utilisateur li\xe9s \xe0 Spacer\xae. L'incapacit\xe9 de CBRE \xe0 appliquer une disposition du pr\xe9sent accord ne sera pas interpr\xe9t\xe9e comme une renonciation \xe0 une disposition ou \xe0 un droit.",
    TermsGeneralB: "<0> Notifications. </0> Les notifications doivent \xeatre \xe9crites et peuvent \xeatre faites par e-mail ou en affichant ces notifications sur Spacer\xae ou sur www.cbre.com/spacer. Vous nous enverrez des notifications par e-mail \xe0 spacersupport@cbre.com, avec une copie envoy\xe9e par courrier am\xe9ricain certifi\xe9 \xe0 CBRE au 400 S. Hope Street, 25th Floor, Los Angeles, CA 90071, \xe0 l'attention du General Counsel\u2019s Office. Les avis seront r\xe9put\xe9s donn\xe9s un (1) jour ouvrable apr\xe8s leur envoi par e-mail (sauf si l'exp\xe9diteur re\xe7oit une r\xe9ponse indiquant que le message n'a pas \xe9t\xe9 remis) ou trois jours ouvrables apr\xe8s avoir \xe9t\xe9 publi\xe9s sur le site Web de CBRE (dans le cas de CBRE), que cela ait \xe9t\xe9 re\xe7u ou non. ",
    TermsGeneralC: "<0> Loi applicable. </0> Le pr\xe9sent Accord sera r\xe9gi et interpr\xe9t\xe9 conform\xe9ment aux lois de l'\xc9tat de Californie, sans \xe9gard aux conflits de lois. CBRE et l'Utilisateur se soumettent par la pr\xe9sente exclusivement aux sites de l'\xc9tat de Californie. La Convention des Nations Unies sur les contrats de vente internationale de marchandises (1980) est par les pr\xe9sentes exclue dans son int\xe9gralit\xe9 de l'application du pr\xe9sent accord. L'utilisateur accepte par les pr\xe9sentes que Spacer\xae sera r\xe9put\xe9 \xeatre bas\xe9 uniquement en Californie et un service passif qui ne donne pas lieu \xe0 une juridiction personnelle sur CBRE, sp\xe9cifique ou g\xe9n\xe9rale, dans des juridictions autres que l'\xc9tat de Californie.",
    TermsGeneralD: "<0> R\xe8glement des diff\xe9rends. </0> Tout diff\xe9rend, r\xe9clamation ou controverse d\xe9coulant du pr\xe9sent accord ou s'y rapportant, ou de sa violation, de son application, de son interpr\xe9tation ou de sa validit\xe9, y compris la d\xe9termination de la port\xe9e ou de l'applicabilit\xe9 de l'arbitrage \xe0 cet \xe9gard sera d\xe9termin\xe9 par arbitrage. L'arbitrage sera administr\xe9 par le Service d'arbitrage et de m\xe9diation judiciaire (JAMS), et l'arbitrage sera men\xe9 avec un seul arbitre. En outre, l'Utilisateur accepte que ni l'Utilisateur ni CBRE ne joindra une r\xe9clamation \xe0 la r\xe9clamation d'une autre personne ou entit\xe9 en arbitrage; qu'aucune r\xe9clamation ne sera r\xe9solue \xe0 l'\xe9chelle de la classe; et que ni l'Utilisateur ni CBRE ne fera valoir aucune r\xe9clamation \xe0 titre repr\xe9sentatif au nom de quelqu'un d'autre. Nonobstant ce qui pr\xe9c\xe8de, l'utilisateur accepte que CBRE soit autoris\xe9 \xe0 demander des recours en injonction (ou un type \xe9quivalent de r\xe9paration judiciaire urgente) dans n'importe quelle juridiction. Si l'utilisateur d\xe9pose une plainte d'arbitrage contre CBRE, CBRE accepte de payer toute partie des frais de d\xe9p\xf4t initial qui d\xe9passe 250 $; apr\xe8s les frais de d\xe9p\xf4t initiaux, les parties partageront \xe9galement les frais d'arbitrage. L'Utilisateur s'engage \xe0 ne pas entreprendre ou poursuivre toute action contre CBRE autrement qu'en d\xe9posant une plainte d'arbitrage conform\xe9ment au pr\xe9sent paragraphe. IMPORTANT, EN ACCEPTANT D'\xcaTRE LI\xc9 PAR LE PR\xc9SENT CONTRAT, L'UTILISATEUR RENONCE \xc0 TOUT DROIT UTILISATEUR DOIT RECHERCHER UN RECOURS EN JUSTICE ET TOUT DROIT UTILISATEUR DOIT \xcaTRE JUG\xc9 PAR LE JURY.",
    TermsGeneralE: "<0> Divisibilit\xe9. </0> Dans le cas o\xf9 une partie du pr\xe9sent accord est jug\xe9e inapplicable, la partie inapplicable ne sera modifi\xe9e que dans la mesure n\xe9cessaire pour la rendre ex\xe9cutoire, et le reste des dispositions restera en vigueur et effet.",
    TermsGeneralF: "<0> Cession. </0> Le pr\xe9sent Contrat ne peut \xeatre c\xe9d\xe9 par l'Utilisateur sans l'accord \xe9crit pr\xe9alable de CBRE. Toute tentative de cession sans le consentement de CBRE sera nulle. CBRE se r\xe9serve le droit de c\xe9der le pr\xe9sent accord \xe0 tout tiers. Le pr\xe9sent accord et les droits et obligations de chacun d'entre nous en vertu de celui-ci lieront nos successeurs et ayants droit respectifs.",
    TermsGeneralG: "<0> Modification. </0> CBRE peut modifier les termes et conditions contenus dans le pr\xe9sent accord, \xe0 tout moment et \xe0 la seule et enti\xe8re discr\xe9tion de CBRE, en affichant un avis de changement ou un nouvel accord sur le site de Spacer\xae \xe0 l'adresse l'url www.cbre.com/spacer ou en fournissant une alerte ou une notification similaire dans Spacer\xae. Si une modification est inacceptable pour l'utilisateur, le seul recours de 'utilisateur est de mettre fin \xe0 l'utilisation de Spacer\xae par l'utilisateur.",
    TermsGeneralH: "<0> Conflits. </0> En cas de conflit entre les termes du pr\xe9sent Accord et tout accord de licence enti\xe8rement ex\xe9cut\xe9 entre l'Utilisateur et CBRE en ce qui concerne Spacer\xae, les termes de cet accord de licence pr\xe9vaudront en ce qui concerne ces termes contradictoires."
};


var $fb0aaa47f75ac15a$exports = {};
$fb0aaa47f75ac15a$exports = {
    // Quiz
    exitQuizButtonTitle: "Sortir du quiz",
    // QuizProgressLabel
    progressLabelText: "Termin\xe9",
    // QuizNavigationButton
    quizNavBackButtonShortenedText: "Pr\xe9c\xe9dent",
    quizNavBackButtonFullLengthText: "Questions pr\xe9c\xe9dente",
    quizNavNextButtonShortenedText: "Suivant",
    quizNavNextButtonFullLengthText: "Question suivante",
    // QuizExitSlide
    quizExitSubtitle: "Nous utilisons maintenant vos r\xe9ponses pour d\xe9finir l'espace id\xe9al pour votre soci\xe9t\xe9.",
    quizExitImgAlt: "Illustration de deux personnes se tapant dans la main sur la page Quiz de Spacer by CBRE",
    // Question Unit Text (questionUnitMap.js)
    question1Text: "Pour commencer : Quel est le but de votre espace futur?",
    question2Text: "Qu'est-ce qui dans votre organisation vous semble le plus attractif pour des candidats?",
    question3Text: "Qu'est-ce qui attire le plus votre attention lorsque vous recrutez de nouveaux collaborateurs?",
    question4Text: "Comment voyez-vous l'\xe9volution de la taille de votre organisation dans les 5 prochaines ann\xe9es?",
    question5Text: "Quelle est l'organisation du temps de travail de vos collaborateurs?",
    question6Text: "Que pensez-vous des bureaux individuels?",
    question7Text: "Une fois dans les bureaux, o\xf9 vos collaborateurs travailleront-ils?",
    question8Text: "Quel sera le code vestimentaire dans vos espaces de bureaux?",
    question9Text: "\xa0O\xf9 votre activit\xe9 se d\xe9roulera elle?",
    question10Text: "A quoi ressemble l'ambiance de vos bureaux?",
    question11Text: "Mis \xe0 part les espaces de travail purs, que voulez-vous proposer dans vos locaux?",
    question12Text: "Qu'est-ce qui vous d\xe9crit le mieux?",
    // Quiz Answers (questionUnitMap.js)
    pickOnePlaceholder: "Choissisez parmi\u2026",
    selectFromListPlaceholder: "Selectionnez dans la liste\u2026",
    firstResponseTooltipText: "Selectionnez votre premi\xe8re r\xe9ponse",
    locatedSomewhereElseLabel: "Je suis localis\xe9 ailleurs.",
    q1AnswerText1: "Nous pensons votre espace d'abord comme",
    q1AnswerText2: "en deuxi\xe8me approche comme",
    q1AnswerText3: "et en troisi\xe8me comme",
    q1Option1Text: "un second foyer pour nos collaborateurs",
    q1Option2Text: "un levier de changement organisationnel",
    q1Option3Text: "un espace productif et de travail cibl\xe9",
    q1Option4Text: "un incubateur de votre prochaine grande id\xe9e",
    q1Option5Text: "un moyen de recruter de grands talents",
    q1Option6Text: "un espace de valorisation de notre marque",
    q1Option7Text: "un espace d'\xe9panouissement et d'apprentissage",
    q1Option8Text: "\xa0un lieu de rencontres et d\u2019\xe9changes",
    q1Option9Text: "un co\xfbt n\xe9cessaire que nous tentons de minimiser",
    q2AnswerText1: "On nous rejoint d'abord pour",
    q2AnswerText2: "ensuite pour",
    q2AnswerText3: "et enfin pour",
    q2Option1Text: "culture d'entreprise",
    q2Option2Text: "salaires motivants",
    q2Option3Text: "attractivit\xe9 de l'entreprise",
    q2Option4Text: "avantages",
    q2Option5Text: "temps de travail flexibles",
    q2Option6Text: "collaborateurs et leadership",
    q2Option7Text: "environnement de travail",
    q2Option8Text: "but et mission",
    q3AnswerText1: "Nous recrutons d'abord pour",
    q3AnswerText2: "puis pour",
    q3AnswerText3: "et enfin pour",
    q3Option1Text: "comp\xe9tences",
    q3Option2Text: "exp\xe9rience",
    q3Option3Text: "Ad\xe9quation \xe0 la culture d'entreprise",
    q3Option4Text: "qualifications",
    q3Option5Text: "relations",
    q3Option6Text: "curiosit\xe9",
    q4AnswerText: "Nous",
    q4Option1Text: "pr\xe9voyons de cro\xeetre raisonnablement chaque ann\xe9e",
    q4Option2Text: "pr\xe9voyons de cro\xeetre significativement chaque ann\xe9e",
    q4Option3Text: "pr\xe9voyons de rester globalement \xe0 l'identique",
    q4Option4Text: "pr\xe9voyons une l\xe9g\xe8re diminution chaque ann\xe9e",
    q4Option5Text: "Difficile \xe0 dire, c'est incertain",
    q5AnswerText: "Habituellement nous travaillons",
    q5Option1Text: "de 9h00 \xe0 17h00",
    q5Option2Text: "d\xe8s le matin, jusque tard dans la journ\xe9e",
    q5Option3Text: "Quand ils le souhaitent, pour autant que cela atteigne un certain seuil",
    q5Option4Text: "Quand ils le souhaitent, aussi souvent qu'ils le souhaitent",
    q6AnswerText: "Nous pensons",
    q6Option1Text: "que chacun devrait avoir un bureau",
    q6Option2Text: "qu'il est pr\xe9f\xe9rable de fonctionner en bureau partag\xe9",
    q7Option1Text: "Toujours \xe0 un bureau individuel",
    q7Option2Text: "Toujours \xe0 un bureau individuel, et minoritairement en r\xe9union ou sur d'autres activit\xe9s",
    q7Option3Text: "Partag\xe9 entre un bureau individuel et ailleurs dans les locaux",
    q7Option4Text: "Mobile dans les locaux, avec quelques moments \xe0 un bureau individuel",
    q7Option5Text: "Toujours mobile dans les locaux",
    q8Option1Text: "Professionnel",
    q8Option2Text: "Professionnel, sauf en certaines occasions",
    q8Option3Text: "Business casual, parfois plus habill\xe9",
    q8Option4Text: "Majoritairement d\xe9contract\xe9, sauf en certaines occasions",
    q8Option5Text: "D\xe9contract\xe9",
    q9Option1Text: "Toujours au bureau",
    q9Option2Text: "La plupart du temps au bureau",
    q9Option3Text: "Temps partag\xe9 entre bureua et t\xe9l\xe9travail",
    q9Option4Text: "Majoritairement en t\xe9l\xe9travail",
    q9Option5Text: "Toujours en t\xe9l\xe9travail",
    q10Option1Text: "Dynamique et intense",
    q10Option2Text: "Intense, parfois plus calme",
    q10Option3Text: "Cela d\xe9pend",
    q10Option4Text: "Calme, avec plus d'intensit\xe9 parfois",
    q10Option5Text: "Calme et tranquille",
    q11Option1Text: "Standard, suffisant pour le quotidien",
    q11Option2Text: "Standard, avec quelques am\xe9nagements",
    q11Option3Text: "Standard, avec un espace d'\xe9change convivial",
    q11Option4Text: "Quelque chose de vraiment attractif, le lieu o\xf9 travailler",
    q11Option5Text: "Quelque chose de cool et diff\xe9rentiant, la premi\xe8re chose \xe0 montrer \xe0 un visiteur",
    q12AnswerText: "Je suis",
    q12OptionClientText: "un coll\xe8gue de CBRE",
    q12OptionProfessionalText: "un client de CBRE",
    q12OptionLeadText: "quelqu'un d'autre",
    q13AnswerText1: "Nous aurons",
    q13AnswerText2: "des salari\xe9s dans nos bureaux.",
    q13AnswerHelperText: "Astuce : Vous \xeates \xe0 mi-chemin de la dur\xe9e de votre bail, ou avec une expiration d'ici 2 \xe0 5 ans.",
    q14AnswerText1: "Nous passerons",
    q14AnswerText2: "de notre temps \xe0 travailler en \xe9quipe.",
    q15AnswerText1: "En moyenne, nous pr\xe9voyons de passer",
    q15AnswerText2: "jour(s) par semaine au bureau.",
    q16AnswerText1: "Nos bureaux seront dans la ville de",
    q16AnswerText2: ".",
    q17AnswerText1: "Nous travaillons en premier lieu dans",
    q17AnswerText2: "secteur",
    q18AnswerText1: "Je suis actuellement bas\xe9 \xe0",
    q18AnswerText2: ".",
    q19AnswerText1: "Nous imaginons nos bureaux en termes de densit\xe9 de personne (m\xe8tres carr\xe9s par personne) seront",
    q19AnswerText2: "dans le futur",
    // Quiz Responses (questionUnitMap.js)
    q1ResponseText: "Nous allons d\xe9finir l'espace qui correspond \xe0 votre vision.",
    q2ResponseText: "Un m\xe9lange s\xe9duisant!",
    q3ResponseText: "Int\xe9ressant - Comment fait-on pour signer?",
    q4ResponseText: "Parfait ! Nous allons faire en sorte que l'espace convienne.",
    q5Response1Text: "Cela semble convenir!",
    q5Response2Text: "Nous avons tendance \xe0 faire des heures suppl\xe9mentaires.",
    q5Response3Text: "Cela a l'air tr\xe8s bien!",
    q5Response4Text: "Cela a l'air fantastique!",
    q6Response1Text: "Nous allons d\xe9finir un espace qui privil\xe9gie les bureaux individuels",
    q6Response2Text: "Nous allons d\xe9finir un espace de type Flex",
    q12ResponseLeadText: "Vous \xeates au bon endroit.",
    q12ResponseClientText: "Parfait!",
    q12ResponseProfessionalText: "Merci!",
    // Industry Codes (industryCodes.js)
    animalProd: "Production animale",
    forestry: "Sylviculture et exploitation foresti\xe8re",
    fishingHunting: "P\xeache et aquaculture",
    agForestSupport: "Sylviculture et autres activit\xe9s foresti\xe8res",
    oilGas: "Extration d'hydrocarbures",
    energy: "Energie",
    mining: "Industries extractives",
    supportMining: "Services de soutien aux industries extractives",
    utilities: "Services publics",
    buildingConstruct: "Construction de b\xe2timents",
    heavyCivilConstruct: "G\xe9nie civil",
    specialtyContract: "Entrepreneurs sp\xe9cialis\xe9s",
    foodManufac: "Industries alimentaires",
    beverageTobaccoManufac: "Fabrication de boissons et de produits \xe0 base de tabac",
    textile: "Fabrication de textiles",
    textileProduct: "Industrie de l'habillement",
    apparelManufac: "Fabrication de v\xeatements",
    leatherManufac: "Fabrication de v\xeatements en cuir",
    woodManufac: "Fabrication d'articles en bois",
    paperManufac: "Industrie du papier et du carton",
    printingSupport: "Imprimerie",
    printingReproduc: "Reproduction",
    petroleumCoal: "Cok\xe9faction et raffinage",
    chemicalManufac: "Industrie chimique",
    chemicals: "Fabrication de produits chimiques",
    pharma: "Industrie pharmaceutique",
    cleaningManufac: "Activit\xe9s de nettoyage",
    plasticsRubberManufac: "Fabrication de produits en caoutchouc et en plastique",
    nonmetallicManufac: "Fabrication d'autres produits min\xe9raux non m\xe9talliques",
    primaryMetalManufac: "Fabrication d'autres produits de premi\xe8re transformation de l'acier",
    fabricatedMetalManufac: "Fabrication de produits m\xe9talliques, \xe0 l\u2019exception des machines et des \xe9quipements",
    machineryManufac: "Fabrication de machines",
    manufac: "Fabrication",
    computerElectronicManufac: "Fabrication de produits informatiques, \xe9lectroniques et optiques",
    electricalApplianceManufac: "Fabrication d'\xe9quipements \xe9lectriques",
    transportEquipManufac: "Fabrication de mat\xe9riels de transport",
    aerospaceDefense: "A\xe9rospatial / D\xe9fense",
    furnitureManufac: "Fabrication de meubles",
    miscManufac: "Autres industries manufacturi\xe8res",
    merchantWholesaleDurable: "Commerces de gros",
    merchantWholesaleNondurable: "Commerces de gros",
    electronicMarket: "Commerce de gros d'\xe9quipements de l'information et de la communication ",
    motorVehiclePartsDealers: "Commerce et r\xe9paration d'automobiles et de motocycles",
    furnitureFurnishingStores: "Commerce de d\xe9tail de meubles, appareils d'\xe9clairage et autres articles de m\xe9nage en magasin sp\xe9cialis\xe9",
    electronicApplianceStores: "Commerce de d\xe9tail d'\xe9quipements de l'information et de la communication en magasin sp\xe9cialis\xe9",
    electronics: "Electronique",
    buildingGardenSupplyStores: "Commerce de gros de bois, de mat\xe9riaux de construction et d'appareils sanitaires / Jardinerie",
    foodBeverageStores: "Commerce de d\xe9tail alimentaire en magasin sp\xe9cialis\xe9",
    groceryStores: "Epiceries",
    beerWineLiquorStores: "Commerce de d\xe9tail de boissons en magasin sp\xe9cialis\xe9",
    healthCareStores: "Magasins de produits de sant\xe9 et soins corporels",
    gasStations: "Stations services",
    clothingAccessoriesStores: "Commerce de d\xe9tail d'habillement en magasin sp\xe9cialis\xe9",
    clothingTextiles: "Textile / Habillement",
    jewelryFurs: "Joaillerie / Fourrures",
    sportsHobbyMusicBookStores: "Sports, loisirs cr\xe9atifs, instruments de musique, librairies",
    genMerchandiseStores: "Magasins de marchandises diverses",
    miscStoreRetailers: "Commerces de d\xe9tail divers",
    officeProducts: "Articles de bureau",
    retailSales: "Ventes au d\xe9tail",
    nonstoreRetails: "Commerces de d\xe9tail hors magasin, \xe9ventaires ou march\xe9s",
    airTransport: "Transports a\xe9riens",
    travelRelated: "Transports (Compagnies a\xe9riennes, agences de voyages, transports en commun)",
    railTransport: "Transports ferroviaires",
    waterTransport: "Transports maritimes",
    truckTransport: "Transports par camions",
    transitTransport: "Transports en commun et transports terrestres de voyageurs",
    pipelineTransport: "Transports par conduites",
    scenicTransport: "Transports de tourisme et d'agr\xe9ment",
    supportTransport: "Services auxiliaires des transports",
    postalService: "Activit\xe9s de poste et de courrier",
    courierMessenger: "Autres activit\xe9s de poste et de courrier",
    shippingDelivery: "Exp\xe9dition / Livraison",
    warehousingStorage: "Entreposage et stockage",
    warehouseDistrib: "Entreposage et services auxiliaires des transports",
    publishingNoInternet: "Edition (hors internet)",
    publishing: "Edition",
    motionPicSoundRecordingIndustries: "Production de films cin\xe9matographiques, de vid\xe9o et de programmes de t\xe9l\xe9vision ; enregistrement sonore et \xe9dition musicale",
    entertainment: "Divertissement (Cin\xe9ma, TV, musique, etc\u2026)",
    infoServicesMarketResearch: "Etudes de march\xe9 et sondages",
    broadcastingNoInternet: "Programmation et diffusion",
    telecom: "T\xe9l\xe9communications",
    tech: "Technologies",
    dataProcessingHostingServices: "Traitement de donn\xe9es, h\xe9bergement et activit\xe9s connexes",
    otherInfoServices: "Autres activit\xe9s informatiques",
    financeInsurance: "Activit\xe9s financi\xe8res et d'assurances",
    monetaryAuthorities: "Activit\xe9s de banque centrale",
    creditIntermediation: "Interm\xe9diation mon\xe9taire",
    banking: "Activit\xe9 bancaire",
    securitiesContractsInvestments: "Courtage de valeurs mobili\xe8res et de marchandises",
    financialServicesNoBanking: "Autres activit\xe9s des services financiers, hors assurance et caisses de retraite",
    insuranceCarriersRelated: "Activit\xe9s auxiliaires de services financiers et d'assurance",
    insurance: "Assurances",
    fundsTrustsFinancialVehicles: "Fonds de placement et entit\xe9s financi\xe8res similaires",
    realEstate: "Activit\xe9s immobili\xe8res",
    rentalLeasingServices: "Location et exploitation de biens immobiliers propres ou lou\xe9s",
    automotive: "Industrie automobile",
    consumerGoods: "Biens de consommation",
    lessorsNonfinancialIntangible: "Location-bail de propri\xe9t\xe9 intellectuelle et de produits similaires, \xe0 l'exception des \u0153uvres soumises \xe0 copyright",
    professionalTechnicalServices: "Activit\xe9s sp\xe9cialis\xe9es, scientifiques et techniques",
    legalServices: "Activit\xe9s juridiques",
    accounting: "Activit\xe9s comptables",
    architectureEngineering: "Activit\xe9s d'architecture et d'ing\xe9nierie",
    specializedDesignServices: "Activit\xe9s sp\xe9cialis\xe9es de design",
    compRelatedServices: "Programmation, conseil et autres activit\xe9s informatiques",
    mgmtConsulting: "Consulting en management",
    scientificResearch: "Recherche-d\xe9veloppement scientifique",
    adsMarketingPR: "Conseil en relations publiques et communication / Publicit\xe9",
    otherProfSciTechServices: "Autres activit\xe9s sp\xe9cialis\xe9es, scientifiques et techniques",
    companyEnterpriseMgmt: "Gestion d'entreprises",
    adminSupportServices: "Administration publique",
    employmentAgencyRecruiters: "Activit\xe9s li\xe9es \xe0 l'emploi",
    securityPrivateInvestigation: "Enqu\xeates et s\xe9curit\xe9",
    wasteMgmtRemediationServices: "Collecte, traitement et \xe9limination des d\xe9chets ; r\xe9cup\xe9ration",
    educationServices: "Enseignement",
    education: "Enseignement",
    ambulatoryHealthCareServices: "Activit\xe9s hospitali\xe8res ambulatoires",
    healthCareRelated: "Autres activit\xe9s pour la sant\xe9 humaine",
    hospitals: "Activit\xe9s hospitali\xe8res",
    nursingResidentialCareFacilities: "H\xe9bergement m\xe9dico-social et social",
    socialAssistance: "Action sociale",
    performingArtsSpectatorSports: "Arts, spectacles et activit\xe9s r\xe9cr\xe9atives",
    museumsHistoricalSitesZoosParks: "Biblioth\xe8ques, archives, mus\xe9es et autres activit\xe9s culturelles",
    fineArtsGalleriesMuseums: "Cr\xe9ation artistique relevant des arts plastiques",
    amusementsGamblingRec: "Organisation de jeux de hasard et d'argent",
    accommodation: "H\xe9bergement",
    foodDrinkingServices: "Restauration et d\xe9bits de boissons",
    restaurantHotel: "H\xf4tels et h\xe9bergement similaire",
    repairMaintenance: "R\xe9paration et maintenance",
    industrialProductsHeavy: "Industrie lourde",
    personalLaundryServices: "Autres services personnels / Blanchisserie-Teinturerie",
    membershipAssocOrgs: "Activit\xe9s des organisations \xe9conomiques, patronales et professionnelles",
    nonprofit: "Organisations \xe0 but non lucratif",
    privateHouseholds: "Activit\xe9s des m\xe9nages",
    execLegisGenGvt: "Administration publique",
    gvt: "Gouvernement",
    justicePublicOrderSafetyActivities: "Services de pr\xe9rogative publique",
    hrAdminPrograms: "Administration g\xe9n\xe9rale, \xe9conomique et sociale",
    environmentAdminPrograms: "Administration de programmes environnementaux",
    environmental: "Ecologie",
    communityHousingProgramAdmin: "Administration de logements collectifs",
    econProgramAdmin: "Administration publique (tutelle) des activit\xe9s \xe9conomiques",
    spaceResearchTech: "Recherche spatiale",
    natlSecurityIntlAffairs: "S\xe9curit\xe9 nationale et affaires \xe9trang\xe8res"
};


var $3c42e6a82282860f$exports = {};
$3c42e6a82282860f$exports = {
    // AboutPageHero
    aboutPageHeroImgAlt: "Illustration d'une personne entrant dans un bureau sur la page A Propos de Spacer par CBRE",
    aboutPageHeroTitle: "Que peut faire Spacer pour vous?",
    // AboutPageContent
    aboutPageContentEndSectionTitle: "Pr\xeat \xe0 d\xe9marrer?",
    // aboutPageProgramPreviewImgAlt:
    aboutPageVideoTitle: "Comment cela fonctionne",
    // About Page Content (aboutPageContent.js)
    aboutPageContent1Title: "D\xe9finissez votre espace de travail id\xe9al",
    aboutPageContent1Text: "Un espace de travail id\xe9al vous aide \xe0 recruter les meilleurs talents, pr\xe9serve le bien-\xeatre de vos collaborateurs, r\xe9duit les co\xfbts fixes, cr\xe9e des conditions pour la cr\xe9ation de nouvelles grandes id\xe9es. Spacer est l'outil parfait pour d\xe9marrer le process de d\xe9cision en vous aidant \xe0 prioriser vos objectifs et en proposant des recommandations conform\xe9ment \xe0 vos objectifs.\n Spacer a \xe9t\xe9 con\xe7u gr\xe2ce \xe0 l'expertise des \xe9quipes Design & Project de CBRE avec plus de 20 ans d'exp\xe9rience \xe0 aider les entreprises pour concevoir leurs espaces au mieux, et met \xe0 disposition ce savoir-faire via internet au travers d'un outil gratuit accessible \xe0 tous.",
    aboutPageContent1ImgAlt: "Illustration d'une personne discutant sur la page A Propos de Spacer par CBRE",
    aboutPageSpacerSupportLink: "spacersupport@cbre.com",
    aboutPageContent2Title: "Spacer est tr\xe8s simple \xe0 utiliser.",
    aboutPageContent2List1: "D\xe9marrez en commen\xe7ant par r\xe9pondre \xe0 ce quizz de 17 questions concernant vos objectifs et les valeurs qui sont les v\xf4tres. Les r\xe9ponses permettront de d\xe9finir le type d'espace qui vous d\xe9finit.",
    aboutPageContent2List2: "Recevez une liste de natures d'espaces et tailles d'espaces correspondant \xe0 votre besoin (appel\xe9 \"Programme\")",
    aboutPageContent2List3: "Visualisez un espace similaire au v\xf4tre en 2D et 3D avec Floored Plans.",
    aboutPageContent2List4: "Sauvegardez votre Programme pour la recherche de votre espace de travail id\xe9al disponible sur le march\xe9.",
    aboutPageContent2List5: "Laissez un professionnel de CBRE rechercher un espace correspondant \xe0 votre programme. Un service gratuit !",
    aboutPageContent2Text: "Pour plus d'informations sur la fa\xe7on dont Spacer peut vous aider sur votre recherche d'espace, contactez-nous sur ",
    aboutPageContent2ImgAlt: "Illustration d'une femme travaillant \xe0 son bureau sur la page A Propos de Spacer par CBRE"
};


var $daab58ba16d91076$exports = {};
$daab58ba16d91076$exports = {
};


var $3d59146587b97528$exports = {};
$3d59146587b97528$exports = {
    blogHomeTitle: "Aper\xe7u de la disposition des bureaux",
    // blog tags
    blogTagAllArticles: "Tous les articles",
    blogTagSizeAndFit: "Dimensionner et adapter",
    blogTagOfficeCulture: "Culture d'entreprise",
    blogTagSpaceAndDesign: "Espace & Design",
    blogTagWorkplaceTrends: "Tendances pour les espaces de travail"
};


var $85afdc1c7d675f63$exports = {};
$85afdc1c7d675f63$exports = {
    // LandingPageHero
    landingPageHeroTitle: "Dovo\u013Ete n\xe1m napl\xe1nova\u0165 va\u0161e pracovisko bud\xfacnosti a n\xe1js\u0165 ten spr\xe1vny priestor pre va\u0161u kancel\xe1riu.",
    landingPageHeroSubtitle: "Svet kancel\xe1rskych priestorov sa v d\xf4sledku pand\xe9mie men\xed. Z\xedskajte odpor\xfa\u010Dania t\xfdkaj\xface sa priestoru pomocou n\xe1\u0161ho bezplatn\xe9ho n\xe1stroja.",
    landingPageHeroImgAlt: "Uk\xe1\u017Eka v\xfdsledkov Space programu z domovskej str\xe1nky programu Spacer od CBRE",
    landingPageImage: "/png/homepage-results-page-in-browser-spacer-by-cbre.png",
    // LandingPageContent
    landingPageContentTitle: "Ako to funguje?",
    // StepsSummary
    stepsSummarySubtitle1: "Krok 1 \u2014",
    stepsSummaryTitle1: "Povedzte n\xe1m viac o svojej spolo\u010Dnosti",
    stepsSummaryText1: "Pom\xf4\u017Ete n\xe1m spozna\u0165 va\u0161e ciele a z\xe1mery, aby sme mohli vytvori\u0165 odpor\xfa\u010Dania priamo pre v\xe1s.",
    stepsSummaryImgAlt1: "Ilustr\xe1cia \u013Eud\xed stojacich na obrovskom notebooku na domovskej str\xe1nke programu Spacer od spolo\u010Dnosti CBRE",
    stepsSummarySubtitle2: "Krok 2 \u2014",
    stepsSummaryTitle2: "Z\xedskajte svoje v\xfdsledky",
    stepsSummaryText2: "Na z\xe1klade va\u0161ich odpoved\xed dostanete odpor\xfa\u010Dan\xfa ve\u013Ekos\u0165 kancel\xe1rie a zoznam jednotliv\xfdch typov priestorov. M\xf4\u017Eete si dokonca pozrie\u0165 uk\xe1\u017Eky p\xf4dorysov.",
    stepsSummaryImgAlt2: "Ilustr\xe1cia susedskej \u0161tvrte na domovskej str\xe1nke programu Spacer od spolo\u010Dnosti CBRE",
    stepsSummarySubtitle3: "Krok 3 \u2014",
    stepsSummaryTitle3: "N\xe1jdite si svoju dokonal\xfa kancel\xe1riu",
    stepsSummaryText3: "Ulo\u017Ete svoje v\xfdsledky, ku ktor\xfdm sa m\xf4\u017Eete vr\xe1ti\u0165 po\u010Das h\u013Eadania kancel\xe1rie, alebo kontaktujte t\xedm Spacer a spojte sa s jedn\xfdm z na\u0161ich leasingov\xfdch profesion\xe1lov, ktor\xed v\xe1m m\xf4\u017Eu pom\xf4c\u0165 n\xe1js\u0165 va\u0161u dokonal\xfa kancel\xe1riu.",
    stepsSummaryImgAlt3: "Ilustr\xe1cia \u017Eeny pracuj\xfacej za stolom na domovskej str\xe1nke Spacer od spolo\u010Dnosti CBRE",
    // LandingPageSecondaryHero
    landingPageSecondaryHeroImgAlt: "Ilustr\xe1cia \u013Eud\xed navrhuj\xfacich priestorov\xe9 odpor\xfa\u010Dania na domovskej str\xe1nke programu Spacer od spolo\u010Dnosti CBRE",
    landingPageSecondaryHeroTitle: "Povedzte n\xe1m nie\u010Do o svojej spolo\u010Dnosti a my v\xe1m povieme, ko\u013Eko kancel\xe1rskeho priestoru potrebujete."
};


var $4a0b11b183665d0d$exports = {};
$4a0b11b183665d0d$exports = {
    // Navbar
    spacerLogoAlt: "Spacer od CBRE",
    linkToAboutPageText: "O projekte",
    linkToBlogPageText: "Postrehy",
    referrals: "Referencie",
    // TakeOfficeSpaceQuizButton
    sizeMyOfficeButtonDefaultLinkText: "Vypl\u0148te dotazn\xedk o kancel\xe1rskych priestoroch",
    flooredPlanRequestLinkText: "Vy\u017Eiada\u0165 pl\xe1n",
    // Footer
    footerCBRELogoAlt: "CBRE logo pre Spacer od CBRE",
    footerFacebookIconAlt: "Ikona Facebook pre Spacer od CBRE",
    footerTwitterIconAlt: "TIkona Twitter pre Spacer od CBRE",
    footerLinkedinIconAlt: "LIkona LinkedIn pre Spacer od CBRE",
    footerLinkedinLink: "https://www.linkedin.com/showcase/cbre-workplace-strategy/",
    footerHeaderQuestionsText: "Ot\xe1zky?",
    footerHeaderAboutText: "Zdroje",
    footerHeaderMoreText: "Viac",
    footerHeaderBrokersText: "Pre makl\xe9rov",
    footerLinkWhatIsSpacerText: "Viac o projekte Spacer",
    footerLinkBlogText: "Postrehy",
    footerLinkWorkplaceText: "\u010Co je CBRE Workplace?",
    footerLinkTermsText: "Podmienky vyu\u017E\xedvania slu\u017Eieb",
    footerLinkPrivacyText: "Z\xe1sady ochrany osobn\xfdch \xfadajov",
    footerLinkReferralText: "Referencie",
    footerWorkplaceLink: "http://www.cbre.us/real-estate-services/occupier/workplace",
    footerPrivacyLink: "https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy",
    // Contact (contact.js)
    spacerSupportEmail: "spacersupport@cbre.com",
    // ErrorPage
    errorOopsText: "Ups!",
    error404Text: "Nevieme n\xe1js\u0165 str\xe1nku, ktor\xfa h\u013Ead\xe1te.",
    error500Text: "ST\xe1to chyba je na na\u0161ej strane.",
    errorText: "Chyba",
    errorReturnText: "RVr\xe1ti\u0165 sa na Spacer",
    errorAltText: "Ilustr\xe1cia rozliatej k\xe1vy na Spacer od CBRE",
    // Measurement Units (units.js)
    SF: "ft\xb2",
    SM: "m\xb2",
    USF: "ft\xb2",
    USM: "m\xb2",
    RSF: "ft\xb2",
    RSM: "m\xb2",
    NSF: "Net ft\xb2",
    NSM: "Net m\xb2",
    NIA: "N/A",
    foot: "stopa",
    feet: "stopy",
    footage: "ft",
    "sqft.": "ft\xb2",
    meter: "m",
    meters: "m",
    "sqm.": "m\xb2",
    Tsubo: "tsubo",
    // SF Types Adjectives (calculator.js)
    Usable: "\xda\u017Eitkov\xe9",
    Rentable: "Prenaj\xedmate\u013En\xe9",
    Net: "Net",
    // Page Titles (documentDataCopy.js)
    landingPageTitle: "Napl\xe1nuj si dokonal\xfa kancel\xe1riu za 15 min\xfat - Spacer od CBRE",
    aboutPageTitle: "Zistite, ako funguje n\xe1\u0161 n\xe1stroj na v\xfdpo\u010Det ve\u013Ekosti kancel\xe1rie - Spacer od CBRE",
    termsPageTitle: "Podmienky u\u017E\xedvania - Spacer od CBRE",
    quizPageTitle: "Zistite ve\u013Ekos\u0165 svojej kancel\xe1rie za 15 min\xfat - Spacer od CBRE",
    resultsPageTitle: "Zobrazi\u0165 n\xe1vrh va\u0161ej novej kancel\xe1rie - Spacer od CBRE",
    profileComparisonPageTitle: "Porovnajte svoje kancel\xe1rske potreby - Spacer od CBRE",
    blogHomePageTitle: "Postrehy z pl\xe1novania priestorov - Spacer od CBRE",
    referralPageTitle: "Referen\u010Dn\xfd odkaz na CBRE profesion\xe1lov - Spacer od CBRE",
    referralRetrievePageTitle: "Pl\xe1nujete svoju \u010Fal\u0161iu kancel\xe1riu? Nechajte Spacer od CBRE, aby v\xe1m r\xfdchlo a jednoducho ur\u010Dil spr\xe1vnu ve\u013Ekos\u0165 kancel\xe1rskeho priestoru potrebn\xe9ho na realiz\xe1ciu va\u0161ich obchodn\xfdch cie\u013Eov. Iba za 15 min\xfat!",
    // Meta Tags (documentDataCopy.js)
    landingPageMetaTagText: "Pl\xe1nujete svoju \u010Fal\u0161iu kancel\xe1riu? Nechajte Spacer od CBRE, aby v\xe1m r\xfdchlo a jednoducho ur\u010Dil spr\xe1vnu ve\u013Ekos\u0165 kancel\xe1rskeho priestoru potrebn\xe9ho na realiz\xe1ciu va\u0161ich obchodn\xfdch cie\u013Eov. Iba za 15 min\xfat!",
    aboutPageMetaTagText: "Spr\xe1vna ve\u013Ekos\u0165 va\u0161ej kancel\xe1rie v\xe1m m\xf4\u017Ee pom\xf4c\u0165 pril\xe1ka\u0165 talentovan\xfdch \u013Eud\xed, zn\xed\u017Ei\u0165 n\xe1klady a dokonca ochr\xe1ni\u0165 zdravie va\u0161ich zamestnancov. Z\xedskajte viac inform\xe1ci\xed o tom, ako m\xf4\u017Ee Spacer r\xfdchlo odporu\u010Di\u0165 spr\xe1vnu ve\u013Ekos\u0165 kancel\xe1rie na realiz\xe1ciu cie\u013Eov va\u0161ej spolo\u010Dnosti.",
    termsPageMetaTagText: "Viac ako desa\u0165 rokov odborn\xfdch znalost\xed a sk\xfasenost\xed v odbore je obsiahnut\xfdch v programe Spacer od CBRE, ktor\xfd v priebehu nieko\u013Ek\xfdch min\xfat vytvor\xed informat\xedvne odpor\xfa\u010Dania t\xfdkaj\xface sa spr\xe1vnej ve\u013Ekosti kancel\xe1rie.",
    quizPageMetaTagText: "Vypl\u0148te 15-min\xfatov\xfd dotazn\xedk Spacer a ur\u010Dite, ko\u013Eko kancel\xe1rskeho priestoru potrebujete na realiz\xe1ciu cie\u013Eov a prior\xedt va\u0161ej spolo\u010Dnosti. Prisp\xf4sobite\u013En\xe9 programovanie nikdy nebolo tak\xe9 r\xfdchle.",
    resultsPageMetaTagText: "V\xfdsledky programu Spacer v\xe1m u\u0161etria \u010Das pri h\u013Eadan\xed novej kancel\xe1rie tak, \u017Ee v\xe1m vypo\u010D\xedtaj\xfa orienta\u010Dn\xfa ve\u013Ekos\u0165 kancel\xe1rie pre va\u0161u firmu, spolu s navrhovan\xfdmi typmi n\xe1bytku a usporiadan\xedm p\xf4dorysu.",
    profileComparisonPageMetaTagText: "V\u010Faka programu Spacer od CBRE pochop\xedte jedine\u010Dnos\u0165 va\u0161ich kancel\xe1rskych potrieb v porovnan\xed s ostatn\xfdmi kancel\xe1riami.",
    blogHomePageMetaTagText: "V\xfdpo\u010Det toho, ko\u013Eko kancel\xe1rskeho priestoru va\u0161a spolo\u010Dnos\u0165 potrebuje, nie je \u017Eiadna veda, ale tieto poznatky a postrehy m\xf4\u017Eu pom\xf4c\u0165. Viac inform\xe1ci\xed n\xe1jdete tu.",
    referralPageMetaTagText: "Pomocou tohto referen\u010Dn\xe9ho odkazu m\xf4\u017Eete odosla\u0165 Spacer klientom a zabezpe\u010Di\u0165, aby sa ich v\xfdsledky odosielali priamo na v\xe1\u0161 e-mail. Viac inform\xe1ci\xed n\xe1jdete tu.",
    referralRetrieveMetaTagText: "Z\xedskajte svoj referen\u010Dn\xfd link na Spacer.",
    // Form title
    formLabel: "Va\u0161e inform\xe1cie"
};


var $6fc6e3fd44cfaab5$exports = {};
$6fc6e3fd44cfaab5$exports = {
    // Results
    resultsWarningMessage: "Naozaj chcete opusti\u0165 t\xfato str\xe1nku? M\xf4\u017Eete strati\u0165 neulo\u017Een\xe9 \xfadaje.",
    // ResultsHeader
    resultsHeaderExportPDFButtonText: "Exportova\u0165 do PDF",
    resultsHeaderSendButtonText: "Posla\u0165 v\xfdsledky",
    resultsHeaderClipboardBoxDescription: "V\xfdsledky m\xf4\u017Eu prezera\u0165 a upravova\u0165 pou\u017E\xedvatelia s odkazom",
    resultsHeaderContactButtonText: "Spojte sa s poradcom",
    // EmailWallSection
    emailWallTitle: "M\xe1me pre v\xe1s viac",
    emailWallSubtitle: "Uve\u010Fte svoje meno a e-mail, aby ste mohli prezera\u0165 kompletn\xe9 odpor\xfa\u010Danie o navrhovanom priestore a upravova\u0165 svoje v\xfdsledky.",
    emailWallFirstNamePlaceholder: "Krstn\xe9 meno",
    emailWallLastNamePlaceholder: "Priezvisko",
    emailWallEmailPlaceholder: "V\xe1\u0161 e-mail",
    emailWallCBREEmailPlaceholder: "E-mail v\xe1\u0161ho experta CBRE (dobrovo\u013En\xe9)",
    emailWallLeasingProfessionalPlaceholder: "V\xe1\u0161 CBRE leasing expert",
    emailWallConnectMeText: "Spojte ma s moj\xedm osobn\xfdm realitn\xfdm poradcom. \u017Diadne newsletter ani spam, s\u013Eubujeme!",
    emailWallContactNoticeText: "Spacer t\xedm v\xe1s m\xf4\u017Ee kontaktova\u0165, aby v\xe1m pomohol vy\u0165a\u017Ei\u0165 z v\xe1\u0161ho programu maximum. \u017Diadny spam, s\u013Eubujeme!",
    emailWallResultsButtonText: "Zobrazi\u0165 \xfapln\xe9 v\xfdsledky",
    emailWallImgAltText: "Uk\xe1\u017Eka v\xfdsledkov space programu z e-mailovej schr\xe1nky Spacer od CBRE.",
    emailWallFirstNameInvalid: "Zadajte svoje krstn\xe9 meno, pros\xedm.",
    emailWallLastNameInvalid: "Zadajte svoje priezvisko, pros\xedm.",
    emailWallEmailInvalid: "Zadajte svoju platn\xfa e-mailov\xfa adresu, pros\xedm.",
    // CopyToClipboardBox
    clipboardBoxCopyText: "Kop\xedrova\u0165",
    clipboardBoxCopiedText: "Skop\xedrovan\xe9",
    // FormModal
    formModalFindSpaceHeader: "Za\u010Dnite h\u013Eada\u0165 kancel\xe1riu",
    formModalFindSpaceBody: "Spacer je r\xfdchly a \u013Eahk\xfd n\xe1stroj na anal\xfdzu pracoviska, no ak potrebujete nie\u010Do presnej\u0161ie, nechajte si pom\xf4c\u0165 t\xedmom CBRE Workplace. Vypl\u0148te tento formul\xe1r a expert z oddelenia Workplace sa s vami spoj\xed do 48 hod\xedn a dohodne si s vami konzult\xe1ciu.",
    formModalFindSpaceSuccessMessage: "Va\u0161a po\u017Eiadavka bola odoslan\xe1.",
    // SuccessModal
    successModalTitle: "Podarilo sa!",
    // ContactForm
    contactFormFirstNameLabel: "Krstn\xe9 meno",
    contactFormLastNameLabel: "Priezvisko",
    contactFormEmailLabel: "Pracovn\xfd e-mail",
    contactFormPhoneLabel: "Telef\xf3nne \u010D\xedslo",
    contactFormMessageLabel: "Povedzte n\xe1m viac o tom, \u010Do h\u013Ead\xe1te",
    contactFormSubmitText: "Podvrdi\u0165",
    // AcceptTermsText
    acceptTermsText: "Prij\xedmam <1> zmluvn\xe9 podmienky </1>. \u010Eal\u0161ie inform\xe1cie o tom, ako bud\xfa va\u0161e \xfadaje pou\u017Eit\xe9, n\xe1jdete v <3> pravidl\xe1ch ochrany osobn\xfdch \xfadajov CBRE </3>.",
    privacyPolicyLink: "https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy",
    // Form
    formErrorText: "Ups, va\u0161a po\u017Eiadavka nepre\u0161la. Pros\xedm, sk\xfaste znova!",
    formEmailInvalid: "Pros\xedm zadajte platn\xfa emailov\xfa adresu.",
    // FormInput
    formInputOptionalText: " (dobrovo\u013En\xe9)",
    // LegalForm
    legalFormCheckboxText: "Spolo\u010Dnos\u0165 CBRE ma m\xf4\u017Ee kontaktova\u0165 s ponukami a inform\xe1ciami s\xfavisiacimi s moj\xedm u\u017E\xedvan\xedm programu Spacer.",
    legalFormContactWarningText: "T\xedm Spacer v\xe1s m\xf4\u017Ee kontaktova\u0165, aby v\xe1m pomohol vy\u0165a\u017Ei\u0165 z v\xe1\u0161ho programu maximum. \u017Diadny spam, s\u013Eubujeme!",
    // NextStepsSection
    nextStepsSectionSubtitle: "Ste pripraven\xed urobi\u0165 \u010Fal\u0161\xed krok?",
    nextStepsSectionTitle: "N\xe1jdite dokonal\xfa kancel\xe1riu.",
    nextStepsSectionButtonText: "Spojte sa s poradcom",
    nextStepsSectionImgAlt: "Ilustr\xe1cia \u013Eud\xed, ktor\xed komunikuj\xfa na str\xe1nke V\xfdsledky Spacer od spolo\u010Dnosti CBRE",
    // Profile
    resultsProfileSummaryTitle: "Va\u0161a kancel\xe1ria -",
    resultsProfileTooltipText: "Ka\u017Ed\xfd profil je zlo\u017Een\xfd zo skuto\u010Dn\xfdch organiz\xe1ci\xed a pracov\xedsk. Podrobnosti boli skontrolovan\xe9 pod\u013Ea technick\xfdch pokynov a znalost\xed trhu, ktor\xe9 s\xfa jedine\u010Dn\xe9 pre CBRE Workplace.",
    // Program
    programSaveConfirmationBoxText: "M\xe1te to tam. Odkaz na va\u0161e v\xfdsledky sme poslali e-mailom. Enjoy!",
    programExamplePlansTitle: "Vzorov\xe9 pl\xe1ny",
    programExamplePlansSubtitle: "Pohrajte sa s interakt\xedvnymi p\xf4dorysmi, ktor\xe9 zodpovedaj\xfa v\xe1\u0161mu profilu. M\xf4\u017Eete ich presk\xfama\u0165 aj v 3D!",
    programTooMuchTinkerWarning: "F\xedha! Na z\xe1klade v\xe1\u0161ho profilu to vyzer\xe1, \u017Ee ste mimo odpor\xfa\u010Dan\xe9ho rozsahu. Zv\xe1\u017Ete <1> op\xe4tovn\xe9 absolvovanie kv\xedzu </1> alebo kontaktujte podporu na \u010D\xedsle <3> {{email}} </3>.",
    programDisclaimer: "Spacer od CBRE je poskytovan\xfd bez ak\xfdchko\u013Evek z\xe1ruk. V\u0161etky v\xfdsledky generovan\xe9 z v\xe1\u0161ho pou\u017E\xedvania programu Spacer maj\xfa iba ilustra\u010Dn\xfd charakter a neodr\xe1\u017Eaj\xfa skuto\u010Dn\xe9 odpor\xfa\u010Dania t\xfdkaj\xface sa priestoru alebo navrhovan\xe9 podmienky pren\xe1jmu. Skuto\u010Dn\xe9 odpor\xfa\u010Dania sa m\xf4\u017Eu v\xfdrazne l\xed\u0161i\u0165 a bud\xfa z\xe1visie\u0165 od mnoh\xfdch faktorov, ktor\xe9 Spacer nezoh\u013Ead\u0148uje. Pou\u017E\xedvan\xedm programu Spacer alebo \u013Eubovo\u013En\xe9ho hl\xe1senia vygenerovan\xe9ho pri pou\u017E\xedvan\xed programu Spacer vyjadrujete s\xfahlas s na\u0161imi podmienkami slu\u017Eby a z\xe1sadami ochrany osobn\xfdch \xfadajov, ktor\xe9 sa nach\xe1dzaj\xfa na webov\xfdch adres\xe1ch https://workplace.cbre.com/termsOfService a https://www.cbre.us/about /z\xe1sady ochrany osobn\xfdch \xfadajov. \xa9 2018 CBRE, Inc. V\u0161etky pr\xe1va vyhraden\xe9.",
    programMetricsTitle: "Programov\xe9 metriky",
    programMetricsSubtitle: "Tieto \u010D\xedsla sumarizuj\xfa va\u0161e pracovn\xe9 prostredie",
    programDetailsSectionTitle: "Prisp\xf4sobte si svoj program",
    programDetailsSectionSubtitle: "Upravte polia ni\u017E\u0161ie a dola\u010Fte svoje priestorov\xe9 po\u017Eiadavky.",
    programRevertButtonText: "Zru\u0161i\u0165 zmeny",
    programSaveButtonText: "Ulo\u017Ei\u0165 zmeny",
    programSavedButtonText: "Ulo\u017Een\xe9",
    // ProgramAssumptions
    programAssumptionsRecommendedOfficeSizeText: "Odpor\xfa\u010Dan\xe1 ve\u013Ekos\u0165 kancel\xe1rie",
    programAssumptionsProfileText: "Profil",
    programAssumptionsHeadcountText: "Po\u010Det zamestnancov",
    programAssumptionsHeadcountFollowingText: "\u013Eud\xed",
    programAssumptionsCollabText: "Spolupr\xe1ca",
    programAssumptionsCirculationText: "Cirkul\xe1cia",
    programAssumptionsAvgDaysText: "Priemern\xfd po\u010Det dn\xed v kancel\xe1rii",
    programAssumptionsAvgDaysFollowingText: "t\xfd\u017Edenne",
    programAssumptionsAvgDaysPerWeekText: "Priemern\xfd po\u010Det dn\xed v kancel\xe1rii za t\xfd\u017Ede\u0148",
    // ProgramHeroForPrint
    printNIAText: "Celkov\xe1 ve\u013Ekos\u0165 interi\xe9ru",
    printUSFText: "\xda\u017Eitkov\xe9 m\xb2",
    printRSFText: "Prenaj\xedmate\u013En\xe9 m\xb2",
    printDescText: "Na z\xe1klade va\u0161ich podrobnost\xed a {{lossFactorPercentage}}% {{factorType}} v {{city}}, odpor\xfa\u010Dame celkom-",
    printFitFactorText: "stratov\xfd faktor",
    printLossFactorText: "faktor straty",
    // BarChart
    barChartIndivSubtitle: "Individu\xe1lny priestor",
    barChartGroupSubtitle: "Skupinov\xfd priestor",
    barChartAmenitySubtitle: "Priestor na vybavenie",
    // TabbedProgramBarChart
    tabbedBarChartMeSubtitle: "Osobn\xfd",
    tabbedBarChartGroupSubtitle: "Skupinov\xfd",
    tabbedBarChartAmenitySubtitle: "Vybavenie",
    // SpaceCategoryBreakdown
    spaceCatBreakdownSubtitle: "Vyberte typ priestoru, ktor\xfd chcete prisp\xf4sobi\u0165",
    // SpaceCategoryBreakdownMobile
    spaceCatBreakdownMobileMeTitle: "Individu\xe1lny priestor",
    spaceCatBreakdownMobileWeTitle: "Skupinov\xfd priestor",
    spaceCatBreakdownMobileAmenityTitle: "Priestor na vybavenie",
    spaceCatBreakdownMobileMeSubtitle: "na samostatn\xfa pr\xe1cu",
    spaceCatBreakdownMobileWeSubtitle: "na skupinov\xfa pr\xe1cu",
    spaceCatBreakdownMobileAmenitySubtitle: "na v\u0161etko ostatn\xe9",
    spaceCatBreakdownMobileNIATotalTitle: "Celkov\xe1 v\xfdmera priestoru v interi\xe9ri",
    spaceCatBreakdownMobileTotalTitle: "Celkovo {{sfType}} Metrov \u0161tvorcov\xfdch {{unitCapitalized}}",
    spaceCatBreakdownMobileCirculationText: "Cirkul\xe1cia",
    // SpaceCategoryDropdown
    spaceCatDropdownMeText: "Individu\xe1lny priestor",
    spaceCatDropdownWeText: "Skupinov\xfd priestor",
    spaceCatDropdownAmenityText: "Priestor na vybavenie",
    // SidebarInfo
    sidebarInfoMeTitle: "Osobn\xfd",
    sidebarInfoWeTitle: "Skupinov\xfd",
    sidebarInfoAmenityTitle: "Vybavenie",
    // Space Category Descriptions (spaceCategoryDescription.js)
    spaceCatMeDesc: "Priestor na samostatn\xfa pr\xe1cu. Pon\xfaka r\xf4zne mo\u017Enosti, kde a ako m\xf4\u017Eu va\u0161i zamestnanci pracova\u0165, \u010Do vedie k ich v\xe4\u010D\u0161ej spokojnosti.",
    spaceCatWeDesc: "Priestor pre spolupr\xe1cu a t\xedmov\xfa pr\xe1cu. V dobe, ke\u010F sa d\xe1 pracova\u0165 kdeko\u013Evek, je d\xf4le\u017Eit\xe9 disponova\u0165 r\xf4znym typom priestorov, vhodn\xfdm na r\xf4zne \xfalohy.",
    spaceCatAmenityDesc: "Priestor, ktor\xfd u\u013Eah\u010Duje pr\xe1cu. V\u010Faka skvel\xe9mu vybaveniu sa va\u0161a kancel\xe1ria stane miestom, kam sa va\u0161i zamestnanci - aj t\xed novope\u010Den\xed - bud\xfa te\u0161i\u0165.",
    // Suggested Custom Amenities (suggestedCustomAmenityUnitMap.js)
    audioVisualCustom: "Audiovizu\xe1lne zariadenia",
    dataCenterCustom: "D\xe1tov\xe9 centrum",
    buildingSupportCustom: "Podpora stavebn\xedctva",
    foodServiceCustom: "Kompletn\xe9 stravovacie slu\u017Eby",
    kitchenCustom: "Kuchy\u0148a",
    serveryCustom: "Obsluha",
    execDiningCustom: "Korpor\xe1tne ve\u010Dere",
    grabNGoCustom: "Grab-N-Go",
    juiceCoffeeBarCustom: "D\u017E\xfasov\xfd bar / kaviare\u0148",
    childCareCustom: "Child CareStarostlivos\u0165 o deti",
    fitnessCenterCustom: "Fitness centrum",
    healthCenterCustom: "Zdravotn\xe9 centrum",
    mailCenterCustom: "Po\u0161tov\xe9 centrum",
    commercialPrintCustom: "Komer\u010Dn\xe1 tla\u010D",
    centralCafeCustom: "Centr\xe1lna kaviare\u0148",
    securityCtrlCustom: "Bezpe\u010Dnostn\xe1 miestnos\u0165",
    auditoriumCustom: "Audit\xf3rium",
    dryCleaningLaundryCustom: "\u010Cistiare\u0148 / pr\xe1\u010Dov\u0148a",
    confCenterCustom: "Konferen\u010Dn\xe9 centrum",
    multiPurpTrainingCustom: "Viac\xfa\u010Delov\xe1 miestnos\u0165 / \u0160kolenia",
    informalCollabCustom: "Neform\xe1lna spolupr\xe1ca",
    touchdownTeamCustom: "Priestor pre t\xedmov\xfa pr\xe1cu",
    // Suggested Custom Amenity Units (spaceUnit.js)
    seats: "pracovn\xe9 miesto",
    seats_plural: "pracovn\xfdch miest",
    rooms: "miestnos\u0165",
    rooms_plural: "miestnosti",
    areas: "priestor",
    areas_plural: "priesstory",
    units: "\u010Das\u0165",
    units_plural: "\u010Dasti",
    // Predefined Amenities (spaceUnitMap.js) - Shared Space Units
    focusRoomDefined: "Miestnos\u0165 na s\xfastredenie",
    fileRoomDefined: "Arch\xedv / miestnos\u0165 na dokumenty",
    centralReceptionHubDefined: "\xdastredn\xe1 recepcia",
    smOfficeDefined: "Mal\xe1 kancel\xe1ria",
    regOfficeDefined: "Be\u017En\xe1 kancel\xe1ria",
    benchDesk5Defined: "pracovn\xfd st\xf4l - 1,6 m",
    benchDesk6Defined: "pracovn\xfd st\xf4l - 1,8 m",
    meetingRoom4Defined: "Konferen\u010Dn\xe1 miestnos\u0165 (4 osoby)",
    meetingRoom6Defined: "Konferen\u010Dn\xe1 miestnos\u0165 (6 os\xf4b)",
    meetingRoom8Defined: "Konferen\u010Dn\xe1 miestnos\u0165 (8 os\xf4b)",
    meetingRoom12Defined: "Konferen\u010Dn\xe1 miestnos\u0165 (12 os\xf4b)",
    meetingRoom15Defined: "Konferen\u010Dn\xe1 miestnos\u0165 (15 os\xf4b)",
    semiEnclosedMeetingBooth4Defined: "Polouzavret\xe1 konferen\u010Dn\xe1 miestnos\u0165 (4 osoby)",
    openCollabSpace4to6Defined: "Otvoren\xfd priestor na spolupr\xe1cu (4 a\u017E 6 os\xf4b)",
    contemplationSpaceDefined: "Priestor na rozj\xedmanie",
    mainITEquipRoomDefined: "Hlavn\xe1 serverov\u0148a",
    receptionAreaDefined: "Recepcia",
    cafeFoodServiceDefined: "Kaviare\u0148 / re\u0161taur\xe1cia",
    teamStorageDefined: "T\xedmov\xfd sklad",
    coatClosetsDefined: "Skrinky na kab\xe1ty",
    genStorageDefined: "Skladovanie v\u0161eobecn\xfdch polo\u017Eiek (vstupy a v\xfdstupy tovaru)",
    centralisedCopyPrintMailDefined: "Centralizovan\xe9 kop\xedrovanie, tla\u010D a po\u0161ta",
    specialResourceAreaDefined: "\u0160peci\xe1lne zdroje",
    personalStorageDefined: "Osobn\xe9 \xfalo\u017Eisko (skrinky)",
    storageITSpaceDefined: "\xdalo\u017En\xfd priestor pre IT",
    secondaryServerRoomDefined: "Sekund\xe1rny server / telekomunika\u010Dn\xe1 miestnos\u0165",
    mothersRoomDefined: "Matersk\xe1 izba",
    buildITSpaceDefined: "IT Build Space",
    workerCouncilOffice2Defined: "Kancel\xe1ria pracovnej rady (2 osoby)",
    securityCtrlRoomDefined: "Bezpe\u010Dnostn\xe1 miestnos\u0165",
    centralisedMailDefined: "\xdastredn\xe1 po\u0161ta",
    visitorCoatLuggageRoomDefined: "\u0160at\u0148a / \xfalo\u017Eisko bato\u017Einy pre n\xe1v\u0161tevn\xedkov",
    wellnessRoomDefined: "Wellness miestnos\u0165",
    internalStairDefined: "Vn\xfatorn\xe9 schodisko",
    commercialPrintRoomDefined: "Komer\u010Dn\xe1 tla\u010Diare\u0148",
    buildingSupportServicesAreaDefined: "Stavebn\xe1 \xfadr\u017Eba",
    // Predefined Amenities (spaceUnitMap.js) - US_SMALL and US_REGULAR
    officeDefined: "Kancel\xe1ria",
    lgOfficeDefined: "Kancel\xe1ria (ve\u013Ek\xe1)",
    smWorkstationDefined: "Pracovn\xe1 stanica (mal\xe1)",
    mdWorkstationDefined: "Pracovn\xe1 stanica (stredn\xe1)",
    lgWorkstationDefined: "Pracovn\xe1 stanica (ve\u013Ek\xe1)",
    huddleRoomDefined: "Mal\xe1 pracovn\xe1 miestnos\u0165",
    dispersedCopyPrintAreaDefined: "Vo\u013En\xe1 tla\u010Diare\u0148 / tla\u010Diarne",
    smMeetingRoomDefined: "Mal\xe1 konferen\u010Dn\xe1 miestnos\u0165",
    mdMeetingRoomDefined: "Stredn\xe1 konferen\u010Dn\xe1 miestnos\u0165",
    lgMeetingRoomDefined: "Ve\u013Ek\xe1 konferen\u010Dn\xe1 miestnos\u0165",
    xlMeetingRoomDefined: "X-Large konferen\u010Dn\xe1 miestnos\u0165",
    multiPurpTrainingDefined: "Viac\xfa\u010Delov\xe1 miestnos\u0165 / \u0161kolenia",
    informalCollabDefined: "Priestor na neform\xe1lnu spolupr\xe1cu",
    touchdownTeamDefined: "Touchdown / priestor pre t\xedm",
    pantryVendingCoffeeAreaDefined: "\u0160pajza / Automat na jedlo / Automat na k\xe1vu",
    workplaceStorageRoomDefined: "Pracovn\xe1 \xfaschov\u0148a",
    employeeCoatAreaDefined: "\u0160at\u0148a na odkladanie kab\xe1tov zamestnancov",
    dispersedMailAreaDefined: "Po\u0161tov\xfd k\xfatik",
    lockerUnitDefined: "Skrinky",
    serverRoomDefined: "Serverov\u0148a",
    frontDeskAreaDefined: "Recepcia",
    centralCafeAreaDefined: "Priestor na pitie k\xe1vy",
    mailCenterAreaDefined: "Mailov\xe9 centrum",
    kitchenAreaDefined: "Kuchy\u0148a",
    drawerLateralFileUnitDefined: "Troj\u0161ufl\xedkov\xe1 bo\u010Dn\xe1 skri\u0148a na dokumenty",
    serveryAreaDefined: "Kuchynka",
    juiceBarCoffeeShopAreaDefined: "D\u017E\xfasov\xfd bar / kaviare\u0148",
    diningSupportAreaDefined: "Pr\xeddavn\xfd priestor pre stravovanie",
    diningAreaDefined: "Jed\xe1le\u0148",
    grabNGoAreaDefined: "Grab-N-Go Area",
    focusRoomSharedFocus: "Miestnos\u0165 na s\xfastredenie",
    // Predefined Amenities (spaceUnitMap.js) - UK_REGULAR
    fullFoodServiceDefined: "Kompletn\xe9 stravovacie slu\u017Eby",
    // Predefined Amenities (spaceUnitMap.js) - APAC_REGULAR
    officeWorkMeetDefined: "Kancel\xe1ria (pr\xe1ca a stretnutia)",
    lgOfficeWorkMeetDefined: "Ve\u013Ek\xe1 kancel\xe1ria (pr\xe1ca a stretnutia)",
    focusDefined: "Focus",
    bench1pt6Defined: "pracovn\xfd st\xf4l - 1,6 m",
    bench1pt8Defined: "pracovn\xfd st\xf4l - 1,8 m",
    bench1pt8LDefined: "pracovn\xfd st\xf4l v tvare L - 1,8 m",
    banquetWorkMeetDefined: "Banquet - pr\xe1ca a stretnutie (2 osoby)",
    cafeTable4Defined: "Kaviarensk\xfd st\xf4l (4 osoby)",
    kitchenTable8to10Defined: "Kuchynsk\xfd st\xf4l (8-10 os\xf4b)",
    standingWhiteboardDefined: "Stojaca tabu\u013Ea",
    huddleRoom3Defined: "Mal\xe1 pracov\u0148a (3 osoby)",
    smMeetingRoom5Defined: "Mal\xe1 konferen\u010Dn\xfd miestnos\u0165 (5 os\xf4b)",
    mdMeetingRoom8Defined: "Stredn\xe1 konferen\u010Dn\xe1 miestnos\u0165 (8 os\xf4b)",
    lgMeetingRoom20Defined: "Ve\u013Ek\xe1 konferen\u010Dn\xe1 miestnos\u0165 (20 os\xf4b)",
    xlBoardroom: "Konferen\u010Dn\xe1 miestnos\u0165 ve\u013Ekosti L",
    wellnessRoomsDefined: "Wellness miestnosti",
    employeeCoatsGymLockersDefined: "Skrinky pre zamestnancov",
    lockersDefined: "Skrinky",
    dispersedCopyPrintScanAreaDefined: "Kop\xedrka, tla\u010Diare\u0148, skener",
    hydrationPointDefined: "N\xe1poje (voda / \u010Daj / k\xe1va)",
    centralHighDensityStorageDefined: "Centr\xe1lny sklad",
    wellnessMothersRoomDefined: "Wellness / Matersk\xe1 izba",
    serverHubRoomsDefined: "Serverov\u0148a",
    buildITStoreRoomDefined: "IT vybavenie / \xfalo\u017Eisko",
    simpleReceptionWaitDefined: "Jednoduch\xe1 recepcia + \u010Dakacia z\xf3na",
    centralCafeSocialHubDefined: "Centr\xe1lny spolo\u010Densk\xfd k\xfatik / k\xe1va",
    mailCentreDefined: "Po\u0161tov\xe9 centrum",
    utilityStoreRoomDefined: "Skladovanie spotrebn\xe9ho tovaru",
    drawerLateralFileDefined: "Troj\u0161ufl\xedkov\xe1 bo\u010Dn\xe1 skri\u0148a na dokumenty",
    juiceBarCoffeeShopDefined: "D\u017E\xfasov\xfd bar / kaviare\u0148",
    buildingSupportServicesDefined: "Slu\u017Eby budovy",
    // Space Unit Map Descriptions (spaceUnitMap.js) - Shared Descriptions
    focusRoomDesc: "Focus miestnosti s\xfa uzavret\xe9 priestory ur\u010Den\xe9 na stimul\xe1ciu, s\xfastredenie sa na pr\xe1cu a rie\u0161enie d\xf4vern\xfdch pracovn\xfdch z\xe1le\u017Eitost\xed, pre jednu alebo dve osoby. S\xfakromie a odhlu\u010Dnenie miestnosti je v t\xfdchto priestoroch prvorad\xe9. Focusov\xe9 miestnosti s\xfa zvy\u010Dajne pre v\u0161etk\xfdch a je mo\u017En\xe9 rezervova\u0165 si ich pod\u013Ea potreby.",
    fileRoomDesc: "Toto je sklad dokumentov pre zamestnancov a t\xedmy. V d\xf4sledku \xfasilia o digitaliz\xe1ciu v\xe4\u010D\u0161iny kancel\xe1ri\xed sa potreba ukladania individu\xe1lnych aj t\xedmov\xfdch s\xfaborov v\xfdrazne zni\u017Euje. No st\xe1le je to d\xf4le\u017Eit\xfd priestor pre uskladnenie z\xe1konom povinn\xfdch k\xf3pi\xed dokumentov alebo materi\xe1lov dlhodob\xfdch projektov, najm\xe4 ak v\xe4\u010D\u0161ina open officov disponuje stolmi s mal\xfdm \xfalo\u017En\xfdm priestorom.",
    centralReceptionHubDesc: "Recepcia vo va\u0161ej firme je prv\xfdm priestorom, ktor\xfd m\xe1 \u0161ancu urobi\u0165 dojem na zamestnancov, klientov a n\xe1v\u0161tevn\xedkov. Mal by d\xf4sledne reprezentova\u0165 zna\u010Dku spolo\u010Dnosti a prezentova\u0165 po\u017Eadovan\xfd vzh\u013Ead. Na recepcii by malo by\u0165 k dispoz\xedcii pre n\xe1v\u0161tevn\xedkov komfortn\xe9 sedenie.",
    officeDesc: "Kancel\xe1rie s\xfa \u200B\u200Buzavret\xe9 individu\xe1lne pracovn\xe9 priestory pre zamestnancov. S\xfa skvel\xe9 na s\xfastreden\xfa pr\xe1cu bez rozpt\xfdlen\xed. Kancel\xe1rie s\xfa zvy\u010Dajne vybaven\xe9 pracovn\xfdm stolom a pracovn\xfdm sedadlom pre host\xed. V kancel\xe1ri\xe1ch n\xe1jdete mno\u017Estvo osobn\xfdch \xfadajov a dokumentov. Ve\u013Ekos\u0165 priestoru sa m\xf4\u017Ee l\xed\u0161i\u0165 v z\xe1vislosti od aktiv\xedt, ktor\xe9 sa v miestnosti vykon\xe1vaj\xfa (napr. pravideln\xe9 stretnutia), alebo od postavenia / hierarchie zamestnancov.",
    benchDeskDesc: "Bench-desky s\xfa jednotliv\xe9 pracovn\xe9 miesta. Men\u0161ie pracovn\xe9 stoly m\xf4\u017Eu zamestnanci pou\u017E\xedva\u0165 bu\u010F do\u010Dasne (v zdie\u013Eanom priestore) alebo trvalo. Tieto stoly s\xfa vynikaj\xface aj pre zamestnancov alebo dod\xe1vate\u013Eov, ktor\xed nie s\xfa v kancel\xe1rii st\xe1le.  V\xfdhody otvoren\xfdch pracovn\xfdch stolov zah\u0155\u0148aj\xfa dobr\xfa vidite\u013Enos\u0165 kancel\xe1rie a mo\u017Enos\u0165 spolupr\xe1ce. Jednou z nev\xfdhod m\xf4\u017Ee by\u0165 zv\xfd\u0161en\xfd hluk, a preto sa odpor\xfa\u010Da, aby kancel\xe1rie s otvoren\xfdmi pracovn\xfdmi stolmi mali dos\u0165 priestoru na s\xfastreden\xfa pr\xe1cu v s\xfakrom\xed.",
    meetingRoomDesc: "Konferen\u010Dn\xe9 miestnosti s\xfa uzavret\xe9 priestory ur\u010Den\xe9 na mal\xe9 skupinov\xe9 stretnutia 2-4 os\xf4b. Mali by by\u0165 vybaven\xe9 audiovizu\xe1lnym zariaden\xedm a bielymi tabu\u013Eami, ktor\xe9 u\u013Eah\u010Duj\xfa komunik\xe1ciu. Mali by by\u0165 tie\u017E odhlu\u010Dnen\xe9 \u200B\u200B(\u013Eudia sediaci bezprostredne mimo miestnosti by nemali po\u010Du\u0165 rozhovory, ktor\xe9 sa ved\xfa vo vn\xfatri).",
    meetingRoomDesc6: "Konferen\u010Dn\xe9 miestnosti s\xfa uzavret\xe9 priestory ur\u010Den\xe9 na mal\xe9 skupinov\xe9 stretnutia 2-4 os\xf4b. Mali by by\u0165 vybaven\xe9 audiovizu\xe1lnym zariaden\xedm a bielymi tabu\u013Eami, ktor\xe9 u\u013Eah\u010Duj\xfa komunik\xe1ciu. Mali by by\u0165 tie\u017E odhlu\u010Dnen\xe9 \u200B\u200B(\u013Eudia sediaci bezprostredne mimo miestnosti by nemali po\u010Du\u0165 rozhovory, ktor\xe9 sa ved\xfa vo vn\xfatri).",
    meetingRoomDesc8: "Konferen\u010Dn\xe9 miestnosti s\xfa uzavret\xe9 priestory ur\u010Den\xe9 na mal\xe9 skupinov\xe9 stretnutia 2-4 os\xf4b. Mali by by\u0165 vybaven\xe9 audiovizu\xe1lnym zariaden\xedm a bielymi tabu\u013Eami, ktor\xe9 u\u013Eah\u010Duj\xfa komunik\xe1ciu. Mali by by\u0165 tie\u017E odhlu\u010Dnen\xe9 \u200B\u200B(\u013Eudia sediaci bezprostredne mimo miestnosti by nemali po\u010Du\u0165 rozhovory, ktor\xe9 sa ved\xfa vo vn\xfatri).",
    meetingRoomDesc12: "Konferen\u010Dn\xe9 miestnosti s\xfa uzavret\xe9 priestory ur\u010Den\xe9 na mal\xe9 skupinov\xe9 stretnutia 2-4 os\xf4b. Mali by by\u0165 vybaven\xe9 audiovizu\xe1lnym zariaden\xedm a bielymi tabu\u013Eami, ktor\xe9 u\u013Eah\u010Duj\xfa komunik\xe1ciu. Mali by by\u0165 tie\u017E odhlu\u010Dnen\xe9 \u200B\u200B(\u013Eudia sediaci bezprostredne mimo miestnosti by nemali po\u010Du\u0165 rozhovory, ktor\xe9 sa ved\xfa vo vn\xfatri).",
    meetingRoomDesc15: "Konferen\u010Dn\xe9 miestnosti s\xfa uzavret\xe9 priestory ur\u010Den\xe9 na mal\xe9 skupinov\xe9 stretnutia 2-4 os\xf4b. Mali by by\u0165 vybaven\xe9 audiovizu\xe1lnym zariaden\xedm a bielymi tabu\u013Eami, ktor\xe9 u\u013Eah\u010Duj\xfa komunik\xe1ciu. Mali by by\u0165 tie\u017E odhlu\u010Dnen\xe9 \u200B\u200B(\u013Eudia sediaci bezprostredne mimo miestnosti by nemali po\u010Du\u0165 rozhovory, ktor\xe9 sa ved\xfa vo vn\xfatri).",
    openCollabSpace4to6Desc: "Tieto priestory s\xfa ur\u010Den\xe9 pre mal\xe9 skupiny (4 a\u017E 6 os\xf4b) a spolupr\xe1cu, napr\xedklad na brainstorming a neform\xe1lne rozhovory medzi kolegami a s klientmi. ",
    cafeFoodServiceDesc: "Centr\xe1lna kaviare\u0148 m\xe1 by\u0165 priestorom na stravovanie, osobn\xfa interakciu, individu\xe1lnu pr\xe1cu a mal\xe9 stretnutia. Pri dizajne tohto priestoru by malo by\u0165 zoh\u013Eadnen\xe9 funk\u010Dn\xe9 stravovacie zariadenie a paleta farieb zna\u010Dky.",
    coatClosetsDesc: "Zamestnanci potrebuj\xfa miesto, kde si odlo\u017Eia bundy a in\xe9 objemn\xe9 predmety, najm\xe4 ak m\xe1 kancel\xe1ria otvoren\xe9 usporiadanie s obmedzen\xfdm osobn\xfdm priestorom pri stoloch. Skrine by mali by\u0165 umiestnen\xe9 po celej kancel\xe1rii, najlep\u0161ie pri v\xfdchodoch a pozd\u013A\u017E hlavn\xfdch chodieb. Na spodnej \u010Dasti skrinky je zvy\u010Dajne umiestnen\xe1 polica s ve\u0161iakom na \u010Diapky a \xfalo\u017En\xfd priestor na ta\u0161ky a kufre.",
    copyPrintDesc: "K\xfatik s kop\xedrkami a tla\u010Diar\u0148ami rozmiestnen\xfd v\xa0otvorenom pracovnom priestore poskytuje zamestnancom r\xfdchly pr\xedstup k multifunk\u010Dn\xfdm zariadeniam zo v\u0161etk\xfdch \u010Dast\xed kancel\xe1rie. Ko\u0161e na recykl\xe1ciu by mali by\u0165 v\u017Edy pri tla\u010Diar\u0148ach a miestach, kde sa uklad\xe1 papier a pom\xf4cky. Tieto priestory sl\xfa\u017Eia iba na kr\xe1tke n\xe1v\u0161tevy a nie s\xfa definovan\xe9 ako pracovn\xfd/spolo\u010Densk\xfd priestor.",
    specialResourceBuildingSupportAreaDesc: "Toto je univerz\xe1lny priestor, ktor\xfd sa d\xe1 prisp\xf4sobi\u0165 pre potreby kancel\xe1rie. Jedna miestnos\u0165 by mohla ma\u0165 bezpe\u010Dnostn\xfd pult, zatia\u013E \u010Do in\xfdm by mohol posl\xfa\u017Ei\u0165 priestor technickej slu\u017Eby. Ich vyu\u017Eitie sa v jednotliv\xfdch firm\xe1ch l\xed\u0161i, ale s prib\xfadaj\xfacimi kancel\xe1riami s\xfa tak\xe9to priestory \u010Doraz popul\xe1rnej\u0161ie a potrebnej\u0161ie.",
    secondaryServerRoomDesc: "Sekund\xe1rna serverov\u0148a (technol\xf3gie) na umiestnenie IT zariaden\xed a n\xedzkonap\xe4\u0165ovej kabel\xe1\u017Ee. V miestnostiach mus\xed by\u0165 zabezpe\u010Den\xfd nepretr\u017Eit\xfd pr\xedvod vzduchu, ktor\xfd mus\xed by\u0165 udr\u017Eiavan\xfd v kon\u0161tantnej teplote 22 stup\u0148ov Celzia s relat\xedvnou vlhkos\u0165ou 50%.",
    mothersRoomDesc: "Matersk\xe9 izby poskytuj\xfa s\xfakromie  - \u010Di u\u017E pre doj\u010Diace matky alebo pre jednotlivcov h\u013Eadaj\xfacich kr\xe1tkodob\xfd oddych. Matersk\xe9 izby s\xfa v\xe4\u010D\u0161inou potrebn\xe9 vo v\u0161etk\xfdch nov\xfdch kancel\xe1ri\xe1ch, bez oh\u013Eadu na ve\u013Ekos\u0165 alebo po\u010Det zamestnancov.",
    visitorCoatLuggageRoomDesc: "N\xe1v\u0161tevn\xedci si potrebuj\xfa odlo\u017Ei\u0165 bundy a in\xe9 objemn\xe9 predmety. \u0160atn\xedky by mali by by\u0165 rozmiestnen\xe9 po celej kancel\xe1rii, najlep\u0161ie pri v\xfdchodoch a pozd\u013A\u017E hlavn\xfdch chodieb. V \u0161atn\xedkoch by mal by\u0165 aj priestor na \u010Diapky a kufre.",
    wellnessRoomDesc: "\xda\u010Delom wellness miestnost\xed (predt\xfdm tie\u017E ozna\u010Dovan\xfdch ako Matersk\xe9 izby) je tr\xe1venie mimoriadneho individu\xe1lneho \u010Dasu - \u010Di u\u017E pre doj\u010Diace matky alebo pre jednotlivcov, ktor\xed h\u013Eadaj\xfa kr\xe1tkodob\xfd odpo\u010Dinok v kancel\xe1rii. Wellness miestnosti s\xfa zvy\u010Dajne nutnou s\xfa\u010Das\u0165ou v\u0161etk\xfdch nov\xfdch kancel\xe1ri\xed bez oh\u013Eadu na ve\u013Ekos\u0165 a po\u010Det zamestnancov. Mali by obsahova\u0165 kreslo, chladni\u010Dku a aj um\xfdvadlo.",
    internalStairDesc: "Vn\xfatorn\xe9 schodisko m\xf4\u017Ee by\u0165 v centre priestoru, poskytuj\xfac prechod medzi poschodiami, alebo to m\xf4\u017Eu by\u0165 in\xe9 prvky, ktor\xe9 sp\xe1jaj\xfa poschodia kancel\xe1rie. M\xf4\u017Ee to by\u0165 spolo\u010Densk\xfd priestor alebo miesto pre kaviarne, recepcie alebo konferen\u010Dn\xe9 priestory.",
    commercialPrintRoomDesc: "\u010Casto kombinovan\xe9 s podate\u013E\u0148ou, intern\xe9 tla\u010Diarne poskytuj\xfa mo\u017Enos\u0165 tla\u010De, v\xe4zby a kompil\xe1cie dokumentov. Existuje nieko\u013Eko typov, napr\xedklad aj ve\u013Ekoform\xe1tov\xe9 tla\u010Diarne. Priestory bud\xfa obsahova\u0165 \xfalo\u017En\xfd priestor pre spotrebn\xfd materi\xe1l a pulty pre men\u0161ie zariadenia, takisto aj miesto na rozlo\u017Eenie v\xfdtla\u010Dkov.",
    pantryVendingCoffeeDesc: "Na rozdiel od centr\xe1lnej kaviarne je miesto \u0161pajze / predajn\xfdch automatov / k\xe1vov\xfdch automatov ur\u010Den\xfd na pr\xedpravu r\xfdchlych jed\xe1l a n\xe1pojov. Rozhovory a konverz\xe1cie sa prirodzene s\xfastre\u010Fuj\xfa v priestoroch s jedlom, no zvy\u010Dajne neobsahuj\xfa miesta na sedenie, \u010Do sp\xf4sobuje, \u017Ee \u013Eudia r\xfdchlo odch\xe1dzaj\xfa a netr\xe1via dlh\xfd \u010Das socializ\xe1ciou.",
    storageDesc: "Skladov\xe9 priestory s\xfa ur\u010Den\xe9 na uskladnenie r\xf4znych predmetov, ako napr\xedklad doplnkov\xfd n\xe1bytok, bal\xedky, rekrea\u010Dn\xe9 vybavenie, at\u010F. M\xf4\u017Eu sa tie\u017E pou\u017Ei\u0165 na uschovanie kab\xe1tov n\xe1v\u0161tevn\xedkov a ich bato\u017Einy. Mal\xfd sklad by mal by\u0165 pre va\u0161e pohodlie v bl\xedzkosti recepcie.",
    centralisedDispersedMailAreaDesc: "Pre v\xe4\u010D\u0161ie spolo\u010Dnosti je pre evidovanie prich\xe1dzaj\xfacej a odch\xe1dzaj\xfacej po\u0161ty potrebn\xe9 po\u0161tov\xe9 stredisko. Tieto priestory obsahuj\xfa \u0161peci\xe1lne vyroben\xe9 po\u0161tov\xe9 zariadenia. Existuje tie\u017E ve\u013Ea pom\xf4cok na usporiadanie papiera a in\xfdch materi\xe1lov. Spravidla je priestor spravovan\xfd zamestnancom na pln\xfd \xfav\xe4zok.",
    lockerDesc: "Skrinky s\xfa vo forme osobn\xe9ho \xfalo\u017Eiska. Poskytuj\xfa zamestnancom priestor na uzamknutie cennost\xed, osobn\xfdch vec\xed a pracovn\xfdch dokumentov. Skrinky m\xf4\u017Eu by\u0165 pridelen\xe9 jednotlivcom alebo pou\u017Eit\xe9 na z\xe1klade princ\xedpu \u201Ekto prv pr\xedde, berie\u201C.",
    mainITandServerRoomDesc: "Hlavn\xe1 serverov\u0148a (technologick\xe1) je miestnos\u0165 na umiestnenie, zabezpe\u010Denie IT vybavenia a na vy\xfastenie n\xedzkonap\xe4\u0165ovej kabel\xe1\u017Ee. V miestnostiach mus\xed by\u0165 zabezpe\u010Den\xe9 nepretr\u017Eit\xe9 vetranie vzduchu a mus\xed by\u0165 udr\u017Eiavan\xe1 teplota na kon\u0161tantnej \xfarovni 22 stup\u0148ov Celzia, s relat\xedvnou vlhkos\u0165ou 50%.",
    drawerLateralFileDesc: "Hlavn\xe1 serverov\u0148a (technick\xe1) je miestnos\u0165 na umiestnenie, zabezpe\u010Denie IT vybavenia a na vy\xfastenie n\xedzkonap\xe4\u0165ovej kabel\xe1\u017Ee. V miestnostiach mus\xed by\u0165 zabezpe\u010Den\xe9 nepretr\u017Eit\xe9 vetranie vzduchu a mus\xed by\u0165 udr\u017Eiavan\xe1 teplota na kon\u0161tantnej \xfarovni 22 stup\u0148ov Celzia, s relat\xedvnou vlhkos\u0165ou 50%.",
    juiceBarCoffeeShopDesc: "Aj ke\u010F spolo\u010Dnos\u0165 nemus\xed ma\u0165 samostatn\xfa kuchy\u0148u, m\xf4\u017Ee disponova\u0165 kaviar\u0148ou alebo d\u017E\xfasov\xfdm barom. Firma m\xf4\u017Ee ma\u0165 tento typ priestoru ako dodatok k svojim hlavn\xfdm stravovac\xedm slu\u017Eb\xe1m, najm\xe4 ak je kancel\xe1ria dostato\u010Dne ve\u013Ek\xe1. Tento priestor bude pravdepodobne vyzera\u0165 ako miestny Starbucks, s pracovn\xfdm priestorom pre zamestnanca oddelen\xfdm obslu\u017En\xfdm pultom.",
    grabNGoDesc: "Mal\xfd pohodln\xfd priestor s chladni\u010Dkami, policami na sladkosti a ob\u010Derstvenie, platobn\xfd automat. Priestory Grab-N-Go s\xfa zvy\u010Dajne zabezpe\u010Den\xe9 kamerou. Tieto miesta s\xfa \u010Dasto kombinovan\xe9 s malou \u0161pajzou s chladni\u010Dkami a mrazni\u010Dkami, ako aj priestorom na pr\xedpravu jedla.",
    smMeetingConferenceRoomDesc: "Mal\xe1 konferen\u010Dn\xe1 miestnos\u0165 je uzavret\xfd  priestor ur\u010Den\xfd na pohodln\xe9 stretnutie 2 a\u017E 6 os\xf4b pri jednom stole. Tieto miestnosti m\xf4\u017Eu by\u0165 pou\u017Eit\xe9 na intern\xe9 aj klientske stretnutia, a preto by mali by\u0165 u\u017E\xedvate\u013Esky ve\u013Emi pr\xedjemn\xe9, s \u013Eahk\xfdm pr\xedstupom k nap\xe1janiu a audiovizu\xe1lnym funkci\xe1m.",
    mdMeetingConferenceRoomDesc: "Stredn\xe1 konferen\u010Dn\xe1 miestnos\u0165 je uzavret\xfd priestor ur\u010Den\xfd na pohodln\xe9 stretnutie 6 a\u017E 10 os\xf4b pri jednom stole. Tieto miestnosti sa pou\u017E\xedvaj\xfa na intern\xe9 aj klientske stretnutia, a preto by mali by\u0165 u\u017E\xedvate\u013Esky ve\u013Emi pr\xedjemn\xe9 s \u013Eahk\xfdm pr\xedstupom k nap\xe1janiu a audiovizu\xe1lnym funkci\xe1m.",
    lgMeetingConferenceRoomDesc: "Ve\u013Ek\xe1 konferen\u010Dn\xe1 miestnos\u0165 je uzavret\xfd konferen\u010Dn\xfd priestor ur\u010Den\xfd na pohodln\xe9 stretnutie 12 a\u017E 14 os\xf4b pri jednom stole, so seden\xedm po obvode miestnosti. Tieto miestnosti m\xf4\u017Eu by\u0165 pou\u017Eit\xe9 na intern\xe9 aj klientske stretnutia a na prezent\xe1cie. N\xe1bytok by mal by\u0165 pres\xfavate\u013En\xfd, aby sa mohol priestor vyu\u017Ei\u0165 aj na in\xe9 \xfa\u010Dely, napr\xedklad na kurzy jogy pre zamestnancov.",
    xlMeetingRoomDesc: "Zasadacia miestnos\u0165 je ur\u010Den\xe1 na pohodln\xe9 stretnutia 14 a\u017E 18 os\xf4b pri jednom stole. Sedenie je umiestnen\xe9 po obvode miestnosti pre najmenej 10 \u010Fal\u0161\xedch os\xf4b. Tieto miestnosti bud\xfa s najv\xe4\u010D\u0161ou pravdepodobnos\u0165ou pou\u017Eit\xe9 na ve\u013Ek\xe9 intern\xe9 a klientske stretnutia. Preto by mali by\u0165 vybaven\xe9 robustnou audiovizu\xe1lnou technol\xf3giou a mali by by\u0165 orientovan\xe9 na potreby klientov.",
    // Space Unit Map Descriptions (spaceUnitMap.js) - US_SMALL and US_REGULAR
    lgOfficeDesc: "Kancel\xe1rie s\xfa \u200B\u200Buzavret\xe9 pracovn\xe9 priestory pre zamestnancov. S\xfa skvel\xfdmi miestami na s\xfastreden\xfa pr\xe1cu bez rozpt\xfdlen\xed. Kancel\xe1rie s\xfa zvy\u010Dajne vybaven\xe9 pracovn\xfdm stolom a seden\xedm pre host\xed. V kancel\xe1ri\xe1ch n\xe1jdete r\xf4zne mno\u017Estvo osobn\xfdch \xfadajov a dokumentov. Ve\u013Ekos\u0165 priestoru sa tie\u017E m\xf4\u017Ee l\xed\u0161i\u0165 v z\xe1vislosti od aktiv\xedt, ktor\xe9 sa v miestnosti vykon\xe1vaj\xfa (napr. stretnutia), alebo od postavenia / hierarchie zamestnancov. T\xe1to o nie\u010Do v\xe4\u010D\u0161ia kancel\xe1ria m\xf4\u017Ee by\u0165 partnersk\xe1 kancel\xe1ria alebo sa m\xf4\u017Ee ve\u013Ekos\u0165ou zdvojn\xe1sobi\u0165 a sl\xfa\u017Ei\u0165 ako miestnos\u0165 na zhroma\u017Edenie.",
    smWorkstationDesc: "Pracovn\xe9 stanice s\xfa otvoren\xe9 pracovn\xe9 miesta. Men\u0161ie pracovn\xe9 stanice m\xf4\u017Eu zamestnanci pou\u017E\xedva\u0165 bu\u010F do\u010Dasne (vo vo\u013Enom priestore) alebo trvalo. Tieto stoly s\xfa vynikaj\xface aj na n\xe1v\u0161tevu zamestnancov alebo dod\xe1vate\u013Eov, ktor\xed nie s\xfa v kancel\xe1rii permanentne. V\xfdhody otvoren\xfdch pracovn\xfdch stan\xedc s\xfa dobr\xe1 vidite\u013Enos\u0165 kancel\xe1rie a mo\u017Enos\u0165 spolupr\xe1ce. Jednou z nev\xfdhod m\xf4\u017Ee by\u0165 nadmern\xfd hluk, a preto sa odpor\xfa\u010Da, aby kancel\xe1rie s otvoren\xfdmi pracovn\xfdmi stanicami disponovali aj tich\xfdmi miestami na s\xfastreden\xfa pr\xe1cu.",
    mdWorkstationDesc: "Pracovn\xe9 stanice s\xfa otvoren\xe9 jednotliv\xe9 pracovn\xe9 miesta. Medzi v\xfdhody o nie\u010Do v\xe4\u010D\u0161ieho priestoru patr\xed viac \xfalo\u017En\xe9ho priestoru na stole a s\xfakromie. To znamen\xe1, \u017Ee \u010D\xedm je st\xf4l v\xe4\u010D\u0161\xed, t\xfdm je pravdepodobnej\u0161ie je, \u017Ee bude niekomu pridelen\xfd. V\xfdhody otvoren\xfdch pracovn\xfdch stan\xedc s\xfa dobr\xe1 vidite\u013Enos\u0165 kancel\xe1rie a mo\u017Enos\u0165 spolupr\xe1ce. Jednou z nev\xfdhod m\xf4\u017Ee by\u0165 nadmern\xfd hluk, a preto sa odpor\xfa\u010Da, aby kancel\xe1rie s otvoren\xfdmi pracovn\xfdmi stanicami disponovali aj tich\xfdmi miestami na s\xfastreden\xfa pr\xe1cu.",
    lgWorkstationDesc: "Pracovn\xe9 stanice s\xfa otvoren\xe9 jednotliv\xe9 pracovn\xe9 miesta. Medzi v\xfdhody o nie\u010Do v\xe4\u010D\u0161ieho priestoru patr\xed viac \xfalo\u017En\xe9ho priestoru na stole a s\xfakromie. To znamen\xe1, \u017Ee \u010D\xedm je st\xf4l v\xe4\u010D\u0161\xed, t\xfdm je pravdepodobnej\u0161ie je, \u017Ee bude niekomu pridelen\xfd. V\xfdhody otvoren\xfdch pracovn\xfdch stan\xedc s\xfa dobr\xe1 vidite\u013Enos\u0165 kancel\xe1rie a mo\u017Enos\u0165 spolupr\xe1ce. Jednou z nev\xfdhod m\xf4\u017Ee by\u0165 nadmern\xfd hluk, a preto sa odpor\xfa\u010Da, aby kancel\xe1rie s otvoren\xfdmi pracovn\xfdmi stanicami disponovali aj tich\xfdmi miestami na s\xfastreden\xfa pr\xe1cu.",
    huddleRoomDesc: "Huddle Rooms s\xfa uzavret\xe9 priestory ur\u010Den\xe9 na mal\xe9 skupinov\xe9 stretnutia 2 a\u017E 4 os\xf4b. Mali by by\u0165 vybaven\xe9 audiovizu\xe1lnym zariaden\xedm a bielymi tabu\u013Eami, ktor\xe9 u\u013Eah\u010Duj\xfa komunik\xe1ciu. Mali by by\u0165 odhlu\u010Dnen\xe9 \u200B\u200B(\u013Eudia sediaci mimo miestnosti by nemali po\u010Du\u0165 rozhovory, ktor\xe9 sa ved\xfa vo vn\xfatri).",
    multiPurpTrainingDesc: "Viac\xfa\u010Delov\xe9 miestnosti s\xfa ur\u010Den\xe9 pre ve\u013Ek\xfd po\u010Det \u013Eud\xed (20 a viac). V tomto pristore sa m\xf4\u017Ee s\xfastre\u010Fova\u0165 ve\u013Ea r\xf4znych aktiv\xedt, vr\xe1tane \u0161kolen\xed, firemn\xfdch akci\xed a ve\u013Ek\xfdch prezent\xe1ci\xed. Dizajn a povrchov\xe1 \xfaprava tohto priestoru je funk\u010Dn\xe1. Mnoho \u013Eud\xed m\xf4\u017Ee prich\xe1dza\u0165 a odch\xe1dza\u0165, no aj sedie\u0165 \u010Delom ku klientom. Tento priestor mus\xed ma\u0165 zodpovedaj\xfacu audiovizu\xe1lnu v\xfdbavu, zvy\u010Dajne ove\u013Ea v\xe4\u010D\u0161iu ako priemern\xe1 konferen\u010Dn\xe1 miestnos\u0165.",
    informalCollabDesc: "Tieto miestnosti s\xfa ur\u010Den\xe9 pre mal\xe9 skupiny (4 a\u017E 6 os\xf4b) a spolupr\xe1cu, napr\xedklad brainstorming a neform\xe1lne rozhovory medzi kolegami a s klientmi. ",
    touchdownTeamDesc: "Touchdowny s\xfa mal\xe9 t\xedmov\xe9 priestory, ktor\xe9 s\xfa rozmiestnen\xe9 po celej kancel\xe1rii pre potreby zamestnancov a n\xe1v\u0161tevn\xedkov. Touchdowny m\xf4\u017Eu ma\u0165 r\xf4zne v\xfd\u0161ky, tvary a ve\u013Ekosti, no maj\xfa sa l\xed\u0161i\u0165 od jednotliv\xfdch pracovn\xfdch stan\xedc ako jedine\u010Dn\xe9 miesto na kr\xe1tkodob\xfa pr\xe1cu. Mali by to by\u0165 priestory typu plug-and-play.",
    frontDeskAreaDesc: "Toto je prv\xe1 zast\xe1vka vo va\u0161ej firme. Pri stole by malo by\u0165 mo\u017En\xe9 umiestni\u0165 najmenej jednu osobu so svoj\xedm pracovn\xfdm a \xfalo\u017En\xfdm priestorom. V bl\xedzkosti by mal by\u0165 aj odkladac\xed priestor pre n\xe1v\u0161tevn\xedkov. Recepcia je umiestnen\xe1 vo v\xe4\u010D\u0161om prij\xedmacom priestore, kde je viac miesta na sedenie.",
    mailCenterAreaDesc: "Pre v\xe4\u010D\u0161ie firmy je pre evidenciu v\u0161etk\xfdch po\u0161tov\xfdch slu\u017Eieb potrebn\xe9 po\u0161tov\xe9 stredisko. To bude obsahova\u0165 ve\u013Ek\xfd triediaci a organiza\u010Dn\xfd priestor spolu s priestorom pre mapy. Tento priestor sa l\xed\u0161i s ka\u017Edou firmou, preto\u017Ee sa \u010Dasto zara\u010Fuje medzi in\xe9 polo\u017Eky.",
    kitchenAreaDesc: "V pr\xedpade priestorov, kde bude k dispoz\xedcii stravovanie, je potrebn\xe1 kuchy\u0148a. Po\u017Eiadavky na kuchy\u0148u sa bud\xfa l\xed\u0161i\u0165 od firmy k firme, ale predpokladom je, \u017Ee tu n\xe1jdete kuchynsk\xe9 spotrebi\u010De a chladni\u010Dky. Nebud\xfa ch\xfdba\u0165 ani su\u0161en\xe9 potraviny a miesto na odkladanie kuchynsk\xe9ho n\xe1\u010Dinia. Kuchy\u0148a bude susedi\u0165 s v\xfddaj\u0148ou jed\xe1l a pravdepodobne s konferen\u010Dn\xfdm centrom / centrom vybavenia klientov.",
    serveryAreaDesc: "V\xfddaj\u0148a je miestnos\u0165, kde si \u013Eudia ber\xfa jedlo. Zvy\u010Dajne je spojen\xe1 s kuchy\u0148ou a jed\xe1lensk\xfdm k\xfatom so stolmi a seden\xedm. Pl\xe1novanie v\xfddajne je ve\u013Emi citliv\xe9 na presnos\u0165. Ve\u013Ekos\u0165 a tvar tohto priestoru sa bude v rozdielnych firm\xe1ch l\xed\u0161i\u0165.",
    diningSupportAreaDesc: "Firma, ktor\xe1 m\xe1 \u0161irok\xfa ponuku stravovac\xedch slu\u017Eieb, bude pravdepodobne ma\u0165 \u010Fal\u0161ie pridru\u017Een\xe9 priestory, ako napr\xedklad sklady v in\xfdch \u010Dastiach budovy. Tieto je potrebn\xe9 zoh\u013Eadni\u0165 v celkovom programe. Charakter priestoru sa bude l\xed\u0161i\u0165 od firmy k firme.",
    diningAreaDesc: "Stolovanie v bl\xedzkosti kuchyne m\xe1 \u013Eu\u010Fom sprostredkova\u0165 mo\u017Enosti sedenia a obedovania. R\xf4zne typy sedenia  umo\u017E\u0148uj\xfa vyu\u017Ei\u0165 priestor na stretnutia a spolupr\xe1cu mimo obedn\xe9ho \u010Dasu. N\xe1v\u0161tevn\xedci si m\xf4\u017Eu vybra\u0165 z m\xe4kk\xe9ho a tvrd\xe9ho sedenia, s mo\u017Enos\u0165ou prisp\xf4sobi\u0165 si v\xfd\u0161ku sedadla.",
    // Space Unit Map Descriptions (spaceUnitMap.js) - UK_REGULAR
    fullFoodServiceDesc: "Stravovacie slu\u017Eby vo firme zah\u0155\u0148aj\xfa nieko\u013Eko r\xf4znych typov priestorov, vr\xe1tane kuchyne, v\xfddajne, jed\xe1lne (sedenie) a stolovac\xedch z\xe1sob (skladovanie). Kuchy\u0148a a v\xfddaj\u0148a pracuj\xfa koordinovane na pr\xedprave a serv\xedrovan\xed dom\xe1cich jed\xe1l. Jed\xe1le\u0148 je miestom, kde m\xf4\u017Eu zamestnanci a hostia sedie\u0165 a jes\u0165, no tento priestor \u010Dasto funguje aj ako centrum socializ\xe1cie a spolupr\xe1ce. Rovnako ako doma, aj pri stravovac\xedch slu\u017Eb\xe1ch vo firme je potrebn\xe9 mno\u017Estvo vybavenia. Potrebn\xfd je aj sklad potrav\xedn, preto je do priestoru typu Full Food Service zahrnut\xe1 aj t\xe1to jednotka.",
    // SpaceUnitRow
    spaceUnitRowDeleteTitle: "Odstr\xe1ni\u0165 typ priestoru",
    spaceUnitRowDeleteText: "Ste si ist\xfd, \u017Ee chcete odstr\xe1ni\u0165 tento typ priestoru?",
    spaceUnitRowConfirmDeleteText: "\xc1no, odstr\xe1ni\u0165",
    spaceUnitRowCancelDeleteText: "Nie, ponecha\u0165",
    // CustomAmenityAdder
    customAmenityAddText: "Prida\u0165 vybavenie",
    customAmenityPlaceholder: "Typ vybavenia",
    // SpaceUnitTotals
    spaceUnitTotalsTitleNIA: "Celkov\xfd vn\xfatorn\xfd priestor",
    spaceUnitTotalsTitle: "Celkovo {{sfTypeAdj}} m2 {{unitCapitalized}}",
    spaceUnitTotalsCirculation: "Cirkul\xe1cia",
    spaceUnitTotalsCirculationTooltip: "\u201EPriestor medzi priestormi\u201C. Chodby, priestor za stoli\u010Dkami, priestor okolo skriniek, dver\xed a okolo rohov. Bez neho by ste nemali kadia\u013E kr\xe1\u010Da\u0165! Spravidla predstavuje okolo 35% z celkov\xe9ho objemu \u0161tvorcov\xfdch metrov {{unitCapitalized}} vo va\u0161om priestore, ale l\xed\u0161i sa v z\xe1vislosti od v\xe1\u0161ho profilu a kone\u010Dn\xe9ho v\xfdberu budovy.",
    spaceUnitTotalsREBNY: "REBNY faktor",
    spaceUnitTotalsNYCText: "NYC ",
    spaceUnitTotalsREBNYTooltip: "V pr\xedpade programov v New Yorku zvy\u0161ujeme {{sfType}} o 15%, aby sme zoh\u013Eadnili \u0161tandard merania REBNY. Priestor meran\xfd pod\u013Ea \u0161tandardu  REBNY zah\u0155\u0148a okrem in\xe9ho k\xfape\u013Ene, predsiene v\xfd\u0165ahov a hr\xfabku vonkaj\u0161\xedch stien.",
    spaceUnitTotalsLossFactor: "Stratov\xfd faktor",
    spaceUnitTotalsLossFactorTooltip: "Pou\u017Eite\u013En\xfd objem metrov \u0161tvorcov\xfdch {{unit}} predstavuje ko\u013Eko miesta m\xe1te v kancel\xe1rii. Prenaj\xedmate\u013En\xfd meter \u0161tvorcov\xfd {{unit}} je priestor, za ktor\xfd plat\xedte. M\xf4\u017Ee obsahova\u0165 st\u013Apy, lobby a \u010Fal\u0161ie spolo\u010Dn\xe9 priestory. Rozdiel medzi pou\u017Eite\u013En\xfdm a prenaj\xedmate\u013En\xfdm sa naz\xfdva stratov\xfd faktor a sp\xf4sob jeho v\xfdpo\u010Dtu sa l\xed\u0161i pod\u013Ea miesta.",
    // CollaborationDropdown
    collabDropdownLevelLowText: "m\xe1lo (0-25%)",
    collabDropdownLevelMedText: "\u010Das\u0165 (26-50%)",
    collabDropdownLevelHighText: "v\xe4\u010D\u0161inu (51-100%)",
    //DensityDropdown
    sameDensityText: "Rovnak\xe1 hustota ako pred pand\xe9miou Covid-19",
    lowerDensityText: "Ni\u017E\u0161ia hustota (viac metrov \u0161tvorcov\xfdch na osobu)",
    notSureDensityText: "Neur\u010Dit\xe9",
    //CirculationDropdown
    preCovidText: "Pred pand\xe9miou Covid-19 (45% otvoren\xfd / 25% uzavret\xfd)",
    higherText: "Vy\u0161\u0161ia cirkul\xe1cia (50% otvoren\xfd / 30% uzavret\xfd)",
    notSureText: "Neur\u010Dit\xe9 (45% otvoren\xfd / 25% uzavret\xfd)",
    // ExamplePlans
    examplePlanButtonText: "Zobrazi\u0165 p\xf4dorys navrhnut\xfdch priestorov",
    examplePlanFullFloorText: "cel\xe9 poschodie",
    examplePlanPartialFloorText: "\u010Das\u0165 poschodia",
    examplePlanFullImgAlt: "P\xf4dorys {{size}} \u0161tvorec {{unit}} zobrazuj\xfaci rozlo\u017Eenie profilu {{profileName}} Spacer od CBRE",
    examplePlanPartialImgAlt: "\u010Ciasto\u010Dn\xfd p\xf4dorys ({{size}} \u0161tvorec) {{unit}} zobrazuj\xfaci rozlo\u017Eenie profilu {{profileName}} Spacer od CBRE",
    examplePlanTooltipText: "Ak ste presiahli {{size}} {{unit}}, mo\u017Eno budete potrebova\u0165 viac ako jedno poschodie.",
    // ProgramStats
    programStatsDensitySubtitleTsubo: "Net Tsubo",
    programStatsDensitySubtitle: "{{adjective}} \u0160tvorec {{unitUppercase}}",
    programStatsIndivTitle: "Individu\xe1lne pracovn\xe9 miesta",
    programStatsWorkstationsSubtitle: "Pracovn\xe9 miesta",
    programStatsOfficesSubtitle: "Kancel\xe1rie",
    programStatsCollabTitle: "Spolupr\xe1ca",
    programStatsEnclosedSubtitle: "Uzatvoren\xe9 skupinov\xe9 sedenie",
    programStatsIndivSeatSubtitle: "Individu\xe1lne pracovn\xe9 miesto",
    programStatsSeatsTitle: "Pracovn\xe9 miesto na osobu",
    programStatsIndivSeatsSubtitle: "Individu\xe1lne pracovn\xe9 miesta",
    programStatsPersonSubtitle: "Osoba",
    programStatsDensityTitle: "Hustota",
    programStatsFullDensitySubtitle: "{{density}} na individu\xe1lne pracovn\xe9 miesto",
    // Profile Display Names (profileNames.js)
    efficientName: "The Optimizer",
    whiteCollarName: "The Accommodator",
    whiteGloveName: "The Enhancer",
    openOfficeName: "The Producer",
    workplace360Name: "The Connector",
    campusName: "The Differentiator",
    startupName: "The Incubator",
    engCreativeName: "The Creator",
    // Profile Descriptions (profileDescriptions.js)
    efficientDesc: "Kancel\xe1ria typu Optimizer nem\xe1 \u010Das na nezmysly, s ment\xe1lnym nastaven\xedm \u201Edosiahni svoj cie\u013E\u201C. Priestor umo\u017E\u0148uje jednotlivcom ma\u0165 pri stole v\u0161etky potrebn\xe9 n\xe1stroje. K spolupr\xe1ci a t\xedmovo orientovanej pr\xe1ci doch\xe1dza zriedkavej\u0161ie. Pracovn\xe9 stoly s\xfa \u0161tandardizovan\xe9 a maj\xfa pridelen\xfd iba z\xe1kladn\xfd priestor v kancel\xe1rii. N\xe1zov tohto prostredia je takmer v\u017Edy otvoren\xfd, pre \u010Do najv\xe4\u010D\u0161iu efektivitu.",
    whiteCollarDesc: "V kancel\xe1rii typu Accommodator nie ste nikdy sami - je jedn\xfdm z najpopul\xe1rnej\u0161\xedch profilov. Kancel\xe1rie typu Accommodator d\xe1vaj\xfa prednos\u0165 neradik\xe1lnym zmen\xe1m, ale \u010Dasto investuj\xfa do novej technol\xf3gie a n\xe1bytku, aby bol priestor produkt\xedvny a p\xfatav\xfd. V\u010Faka rovnov\xe1he medzi priestormi na spolupr\xe1cu sa zamestnanci ocitn\xfa v\xe4\u010D\u0161inou pri svojich stoloch s pr\xedle\u017Eitostn\xfdmi stretnutiami v t\xedmoch. Ide\xe1lne na 9 to 5.",
    whiteGloveDesc: "Vst\xfapte do lobby kancel\xe1rie typu Enhancer a budete ma\u0165 pocit, \u017Ee ste pri\u0161li na v\xfdslnie. Toto pracovisko pokr\xfdva potreby zamestnancov, ako aj klientov, ktor\xed s\xfa \u010Dast\xfdmi n\xe1v\u0161tevn\xedkmi pracoviska. Viac ako v ktoromko\u013Evek inom profile  s\xfa be\u017En\xe9 kancel\xe1rie a uzavret\xe9 priestory. V\xe4\u010D\u0161ina zamestnancov si zasl\xfa\u017Ei svoj kancel\xe1rsky priestor na v\xfdkon alebo zotrvanie vo firme, hierarchia pravdepodobne hr\xe1 d\xf4le\u017Eit\xfa \xfalohu pri jej fungovan\xed. R\xfdchlo hore po kari\xe9rnom rebr\xedku!",
    openOfficeDesc: "Kancel\xe1ria typu Producer vie, \u010Do potrebujete k \xfaspechu. V\u0161etko je to o tom, \u017Ee \u013Eu\u010Fom d\xe1te potrebn\xfd z\xe1klad pod\u013Ea typu \u010Dinnosti. Nielen\u017Ee s\xfa tieto rozmanit\xe9 typy priestorov k dispoz\xedcii, ale zis\u0165ujeme, \u017Ee s\xfa aj ve\u013Emi vyu\u017E\xedvan\xe9 ako sp\xf4sob, ako zosta\u0165 efekt\xedvny! Medzi individu\xe1lnou a t\xedmovou pr\xe1cou je rovnomern\xfd pomer, \u010Do pravdepodobne znamen\xe1, \u017Ee sa po\u010Das d\u0148a ve\u013Ea pres\xfavate po kancel\xe1rii. Ide\xe1lne pre mobiln\xfa kancel\xe1riu.",
    workplace360Desc: "Rovnako ako va\u0161a ob\u013E\xfaben\xe1 poz\xedcia na joge, aj kancel\xe1ria typu Connector prioritizuje rovnov\xe1hu. So spr\xe1vnou kombin\xe1ciou priestoru zameran\xe9ho na produktivitu a priestoru na socializ\xe1ciu obsahuje kancel\xe1ria Connector v\u0161etko potrebn\xe9 pre s\xfastredenie a podporuje mo\u017Enos\u0165 v\xfdberu medzi \u010Fal\u0161\xedmi typmi priestorov. Kancel\xe1ria Connector, vern\xe1 svojmu n\xe1zvu, umiest\u0148uje spolo\u010Dne priestory, ako s\xfa kuchy\u0148a a konferen\u010Dn\xe9 priestory do stredu kancel\xe1rie. To pom\xe1ha \u013Eud\xed sp\xe1ja\u0165 a vytv\xe1ra pocit spolo\u010Denstva.",
    campusDesc: "Z kancel\xe1rie typu Differentiator je na konci d\u0148a \u0165a\u017Ek\xe9 od\xeds\u0165. Je to preto, lebo pr\xe1ca v nej je \xfaplne inou sk\xfasenos\u0165ou, prevy\u0161uj\xfacou tie ostatn\xe9. N\xe1jdete tu vylep\u0161en\xe9 mo\u017Enosti wellnessu a stravy, ktor\xe9 zamestnancom u\u0161etria \u010Das a poskytn\xfa im pohodlie. Spom\xednal niekto ob\u010Derstvenie ?! Zamestnancom odpor\xfa\u010Dame, aby si na pracovisku robili prest\xe1vky, socializovali sa a relaxovali.",
    startupDesc: "R\xfdchlos\u0165 a n\xe1pady s\xfa cie\u013Eom hry, teda pokia\u013E ide o kancel\xe1riu typu Incubator. Zamestnanci pracuj\xfa v t\xedmoch a myslia ako vlastn\xedci firmy. Toto kancel\xe1rske prostredie sa neust\xe1le men\xed, \u010Do znamen\xe1, \u017Ee v\xe4\u010D\u0161ina priestorov m\xe1 v sebe navrhnut\xfa flexibilitu. S\u0165ahovanie n\xe1bytku a\xa0\u010Fal\u0161ie zmeny s\xfa be\u017En\xe9. Kamar\xe1tstva vznikaj\xfa v kombin\xe1cii z\xe1bavn\xfdch spolo\u010Densk\xfdch aktiv\xedt a intenz\xedvnych pracovn\xfdch stretnut\xed.",
    engCreativeDesc: "Kancel\xe1riu typu Creator pova\u017Eujeme za miesto pln\xe9 odborn\xedkov - nie za typick\xfa kombin\xe1ciu oddelen\xed. Rovnako ako v\u0161etky tvoriv\xe9 snahy, aj kancel\xe1ria typu Creator d\xe1va priestor t\xedmovej pr\xe1ci. \u0160pecializovan\xe9 vybavenie a materi\xe1ly s\xfa zvy\u010Dajne s\xfa\u010Das\u0165ou ka\u017Edodennej pracovnej \u010Dinnosti. Zamestnancom je dan\xfd priestor, ktor\xfd vy\u017Eaduj\xfa na efekt\xedvne vykon\xe1vanie svojej pr\xe1ce, a hoci je tento kancel\xe1rsky typ  vz\xe1cny, jedine\u010Dn\xe1 firma potrebuje jedine\u010Dn\xfa kancel\xe1riu.",
    // Profile Key Traits: Shared Names (profileTraitMap.js)
    social: "Spolo\u010Densk\xfd",
    efficient: "Efekt\xedvny",
    flexible: "Flexibiln\xfd",
    enabled: "Umo\u017Enuj\xfaci",
    productive: "Produkt\xedvny",
    inclusive: "Inkluz\xedvny",
    clientFocused: "Orientovan\xfd na klienta",
    standardized: "\u0160tandardizovan\xfd",
    // Profile Key Traits (profileTraitMap.js)
    social1Desc: "Vz\u0165ahy v pr\xe1ci a mimo nej s\xfa d\xf4le\u017Eit\xe9",
    social2Desc: "Mnoho podujat\xed zameran\xfdch na budovanie komunity",
    social3Desc: "Zamestnanci tu bud\xfa radi spolu tr\xe1vi\u0165 \u010Das",
    social4Desc: "Otvorenej\u0161\xed priestor s d\xf4razom na komunitu",
    efficient1Desc: "Spolo\u010Dnos\u0165 zost\xe1va \u0161etrnej\u0161ia, s d\xf4razom na rozpo\u010Det",
    efficient2Desc: "Spolo\u010Dnos\u0165 zost\xe1va \u0161etrnej\u0161ia a produkt\xedvna",
    flexible1Desc: "Zamestnanci maj\xfa na v\xfdber, ako bud\xfa pracova\u0165",
    flexible2Desc: "Zamestnanci maj\xfa ve\u013Ek\xfa slobodu",
    flexible3Desc: "Vybudujte si priestor, ak\xfd potrebujete",
    enabled1Desc: "Zamestnanci maj\xfa pri svojich pracovn\xfdch stoloch to, \u010Do potrebuj\xfa",
    enabled2Desc: "Zamestnanci maj\xfa rozsiahle slu\u017Eby a vybavenie",
    enabled3Desc: "Zamestnanci maj\xfa to, \u010Do potrebuj\xfa na v\xfdkon svojej pr\xe1ce",
    enabled4Desc: "Pr\xedstup k spr\xe1vnej technike a vybaveniu",
    enabled5Desc: "K dispoz\xedcii je \u0161pecializovan\xe9 vybavenie",
    productive1Desc: "Funk\u010Dn\xfd a intuit\xedvny kancel\xe1rsky dizajn",
    productive2Desc: "Biznisov\xfd a finan\u010Dne uvedomel\xfd",
    productive3Desc: "S\xfastreden\xfd na jedine\u010Dn\xfa ponuku produktov / slu\u017Eieb",
    inclusive1Desc: "K dispoz\xedcii je viac druhov priestoru",
    inclusive2Desc: "V kancel\xe1rii n\xe1jdete v\u0161etko, \u010Do potrebujete",
    inclusive3Desc: "Ve\u013Ea r\xf4znych \u0161t\xfdlov pr\xe1ce je prijate\u013En\xfdch",
    clientFocused1Desc: "Prv\xfd dojem na klienta je najd\xf4le\u017Eitej\u0161\xed",
    clientFocused2Desc: "Kancel\xe1ria je pr\xedvetiv\xe1 pre klientov a nov\xfdch zamestnancov",
    clientFocused3Desc: "Kancl\xe1riou sa blisnete pred klientmi a nov\xfdmi zamestnancami",
    standardized1Desc: "Procesy a syst\xe9my s\xfa zjednodu\u0161en\xe9",
    standardized2Desc: "Organiza\u010Dn\xe9 normy t\xfdkaj\xface sa pride\u013Eovania priestoru",
    standardized3Desc: "Modul\xe1rne ve\u013Ekosti pre flexibilitu",
    standardized4Desc: "Zjednodu\u0161en\xe9 procesy a v\xfdstupy",
    // SpaceSummary
    spaceSummaryBarHeader: "Odpor\xfa\u010Dan\xe1 ve\u013Ekos\u0165 kancel\xe1rie",
    spaceSummaryMeasurementTypeText: "Typ v\xfdmery",
    spaceSummaryUnitTypeText: "Jednotky",
    spaceSummaryLossFactorSectionLabel: "{{factor}} Detaily",
    spaceSummaryFitFactorText: "Faktor zhody",
    spaceSummaryLossFactorText: "Faktor straty",
    spaceSummaryRSFLossFactorHelperText: "Na z\xe1klade {{percentage}}% stratov\xe9ho faktora pre nehnute\u013Enosti v meste {{place}} by ste mali h\u013Eada\u0165 priestory medzi {{min}} a {{max}} prenaj\xedmate\u013En\xfdm \u0161tvorcov\xfdmi metrami {{units}}.",
    spaceSummaryNIAFitFactorHelperText: "Na z\xe1klade {{percentage}}% faktora zhody pre nehnute\u013Enos\u0165 v {{place}}, by ste mali h\u013Eada\u0165 priestory s {{amt}} NIA priestoru.",
    spaceSummaryNIATooltipText: "\u010Cist\xe1 vn\xfatorn\xe1 plocha (Net Internal Area - NIA) je vyu\u017Eite\u013En\xe1 plocha v budove meran\xe1 k vn\xfatornej stene obvodov\xfdch stien na ka\u017Edom podla\u017E\xed, s v\xfdnimkou ur\u010Dit\xfdch \u0161pecifikovan\xfdch pl\xf4ch.",
    // SFTypeRadioInput
    sfRadioInputUsableAreaTooltipText: "T\xe1to v\xfdmera zah\u0155\u0148a v\u0161etky miestnosti, n\xe1bytok a obehov\xfd priestor.",
    sfRadioInputRentableAreaTooltipText: "Toto je zvy\u010Dajne \xfa\u017Eitkov\xe1 plocha {{unitUppercase}} plus \u010Das\u0165 spolo\u010Dn\xfdch priestorov budovy. Aj ke\u010F nem\xf4\u017Eete vyu\u017Ei\u0165 cel\xfd priestor, je to plocha {{unit}}, za ktor\xfa plat\xedte pri pren\xe1jme.",
    sfRadioInputUsableSquareText: "U\u017Eitkov\xe1 plocha",
    sfRadioInputRentableSquareText: "Prenaj\xedmate\u013En\xe1 plocha",
    //floored plan request block
    flooredTitle: "E\u0161te neodch\xe1dzajte/ E\u0161te n\xe1s neop\xfa\u0161tajte",
    flooredSubTitle: "Zme\u0148te ako klienti vn\xedmaj\xfa priestor",
    flooredSubText: "Pozrite si svoje v\xfdsledky z aplik\xe1cie Spacer v 3D virtu\xe1lnej prehliadke",
    flooredParagraphText1: "Pohlcuj\xfaci z\xe1\u017Eitok umo\u017En\xed n\xe1jomcom predstavi\u0165 si v\u0161etky dostupn\xe9 mo\u017Enosti, experimentova\u0165 s priestorom a premeni\u0165 n\xe1pady na skuto\u010Dnos\u0165.",
    flooredParagraphText2: "Hmatate\u013En\xe1, osobn\xe1 v\xedzia pre ka\u017Ed\xfd priestor",
    flooredVideoHeading: "Sledujte uk\xe1\u017Eku",
    flooredFreeText: "\u010Co?",
    flooredIconText1: "Zdie\u013Ea\u0165 dostupn\xe9 p\xf4dorysy podla\u017E\xed",
    flooredIconSubText1: "S\xfabory AutoCAD pre s\xfabory PDF",
    flooredIconText2: "Nechajte n\xe1m \u010Das na spracovanie",
    flooredIconSubText2: "Jeden a\u017E dva t\xfd\u017Edne",
    flooredIconText3: "Z\xedskajte zdie\u013Eate\u013En\xfd z\xe1\u017Eitok",
    flooredIconSubText3: "Prisp\xf4soben\xe9 z\xe1\u017Eitky 2D a 3D",
    // MeasurementSystemRadioInput
    measurementSystemSqFeetText: "ft\xb2",
    measurementSystemSqMetersText: "m\xb2",
    measurementSystemTsuboText: "Tsubo",
    // ProfileHero
    resultsProfileHeroAnnouncementTitle: "Va\u0161a kancel\xe1ria je",
    resultsProfileHeroImgAlt: "3D p\xf4dorys zobrazuj\xfaci n\xe1vrh kancel\xe1rsk\xe9ho priestoru {{profileName}} Spacer od CBRE",
    // ProfileComparison
    profileCompModalTitle: "Chcete zmeni\u0165 svoj profil?",
    profileCompModalText: "Strat\xedte v\u0161etky neulo\u017Een\xe9 zmeny v tomto programe.",
    profileCompModalConfirmText: "\xc1no, zmeni\u0165 profil",
    profileCompModalCancelText: "Nie, ponecha\u0165 tento profil",
    profileCompNavbarCancelButtonText: "Zru\u0161i\u0165",
    profileCompNavbarUseButtonText: "Pou\u017Ei\u0165 tento profil",
    profileCompCompareTitle: "Porovnajte svoje najbli\u017E\u0161ie profilov\xe9 zhody",
    // ProfileComparisonColumn
    profileCompColumnSelectedText: "Vybran\xfd profil",
    profileCompColumnSelectText: "Vybra\u0165",
    profileCompColumnRecommendedText: " (Odpor\xfa\u010Dan\xe9)",
    profileCompColumnImgAltText: "3D p\xf4dorys zobrazuj\xfaci rozlo\u017Eenie kancel\xe1rie profilu {{profileName}} na Spacer od CBRE",
    // Test Fit Form
    testFitTitle: "Zobrazte svoje v\xfdsledky ako p\xf4dorys / pl\xe1n a zobrazte ich v 3D",
    testFitSubtitle: "Chcete ma\u0165 predstavu ako V\xe1\u0161 program bude vyzera\u0165 a p\xf4sobi\u0165? Premen\xedme Va\u0161e v\xfdsledky na p\xf4doris, ktor\xfd m\xf4\u017Eete presk\xfamava\u0165 a zdiela\u0165",
    requestTestFitButtonText: "Vy\u017Eiadajte si vlastn\xfd p\xf4dorys",
    company: "N\xe1zov spolo\u010Dnosti",
    emptyCompanyError: "Pros\xedm, uve\u010Fte n\xe1zov spolo\u010Dnosti",
    radioQ2yes: "V\xfdborne! Budeme V\xe1s kontaktova\u0165 emailom pre obdr\u017Eanie dokument\xe1cie",
    radioQ2no: "\u017Diadny probl\xe9m, budeme V\xe1s kontaktova\u0165 ohladom \u010Fal\u0161\xedch mo\u017Enost\xed.",
    testFitFormTitle: "Vy\u017Eiadajte si svoj vlastn\xfd \nP\xf4dorys",
    testFitFormSubtitle: "Uve\u010Fte zop\xe1r inform\xe1ci\xed a my sa do toho pust\xedme (my za\u010Dneme). N\xe1\u0161 t\xedm zvy\u010Dajne dod\xe1va hotov\xe9 p\xf4dorisy do troch pracovn\xfdch dn\xed.",
    testFitFormCompleted: "Va\u0161a \u017Eiados\u0165 bola odoslan\xe1. N\xe1\u0161 expert v\xe1s bude kontaktova\u0165 e-mailom.",
    testFitFormYes: "\xe1no",
    testFitFormNo: "nie",
    testFitFormQ1: "M\xe1te p\xf4dorys, ktor\xfd m\xf4\u017Eete pou\u017Ei\u0165?",
    testFitFormQ1No: "\u017Diadny probl\xe9m! D\xe1me v\xe1m ho my.",
    testFitFormQ2: "M\xe1te n\xe1kres p\xf4dorysu (PDF, AutoCAD)?",
    testFitTermsConditions: "Za\u010Diarknut\xedm tohto pol\xed\u010Dka vyjadrujete s\xfahlas s \xfa\u010Das\u0165ou v tomto beta programe.",
    testFitSubmitButtonText: "Odo\u0161lite \u017Eiados\u0165 o p\xf4dorys",
    backendError: "Ups! Niekde sa stala chyba - pros\xedm, sk\xfaste e\u0161te raz."
};


var $ae6faa232cc8f70e$exports = {};
$ae6faa232cc8f70e$exports = {
    // TermsOfService
    TermsTitle: "Podmienky u\u017E\xedvania",
    TermsIntroText: "Toto je pr\xe1vna dohoda medzi vami a spolo\u010Dnos\u0165ou CBRE, Inc. (\u201ECBRE\u201C), ktor\xe1 sa t\xfdka pr\xedstupu k aplik\xe1cii zn\xe1mej ako Spacer\xae a jej pou\u017E\xedvania. Pou\u017E\xedvan\xedm alebo pr\xedstupom k niektorej z inform\xe1ci\xed alebo slu\u017Eieb v tejto webovej aplik\xe1cii potvrdzujete, \u017Ee ste si pre\u010D\xedtali, porozumeli a s\xfahlas\xedte s podmienkami stanoven\xfdmi v t\xfdchto podmienkach pou\u017E\xedvania (\u201Ezmluva\u201C alebo \u201ETOU\u201C). Pojmy \u201Evy\u201C, \u201Ev\xe1\u0161\u201C alebo \u201Epou\u017E\xedvate\u013E\u201C sa spolo\u010Dne vz\u0165ahuj\xfa na osobu a ak\xfdko\u013Evek subjekt, v mene ktor\xe9ho m\xf4\u017Ee t\xe1to osoba kona\u0165.",
    TermsLimitationsTitle: "Obmedzenia.",
    TermsLimitationsA: "Pou\u017E\xedvate\u013E rozumie a s\xfahlas\xed s t\xfdm, \u017Ee pr\xedstup pou\u017E\xedvate\u013Ea k produktu Spacer\xae je nev\xfdhradn\xfd, nesublicencovate\u013En\xfd, neprenosn\xfd, kedyko\u013Evek odvolate\u013En\xfd a spolo\u010Dnos\u0165 CBRE ho m\xf4\u017Ee z ak\xe9hoko\u013Evek d\xf4vodu kedyko\u013Evek pozastavi\u0165 alebo ukon\u010Di\u0165.",
    TermsLimitationsB: "U\u017E\xedvate\u013E \u010Falej rozumie a s\xfahlas\xed s t\xfdm, \u017Ee udelenie pr\xedstupu k produktu Spacer\xae mu nebude ude\u013Eova\u0165 \u017Eiadne vlastn\xedcke pr\xe1va produktu Spacer\xae ani k akejko\u013Evek s\xfavisiacej dokument\xe1cii (vr\xe1tane ak\xfdchko\u013Evek nov\xfdch vydan\xed, \xfaprav alebo vylep\u0161en\xed), pri\u010Dom v\u0161etky tieto pr\xe1va musia by\u0165 a zostan\xfa v\xfdhradn\xfdm majetok spolo\u010Dnosti CBRE, okrem in\xe9ho aj autorsk\xe9 pr\xe1va k nim, s\xfavisiace patenty, patenty na dizajny, ochrann\xe9 zn\xe1mky, obchodn\xe9 \xfapravy, obchodn\xe9 tajomstv\xe1 a \u010Fal\u0161ie vlastn\xedcke pr\xe1va vypl\xfdvaj\xface z platn\xfdch pr\xe1vnych predpisov alebo medzin\xe1rodn\xfdch dohovorov (s\xfahrnne \u201Evlastn\xedcke pr\xe1va\u201C). Pozri oddiel 2 (Vlastn\xedctvo) ni\u017E\u0161ie. CBRE si t\xfdmto v\xfdslovne vyhradzuje v\u0161etky pr\xe1va na produkt Spacer\xae, ktor\xe9 nie s\xfa u\u017E\xedvate\u013Eovi v\xfdslovne udelen\xe9 pod\u013Ea t\xfdchto ustanoven\xed.",
    TermsLimitationsC: "Pokia\u013E nie je zo strany CBRE v tomto dokumente p\xedsomne povolen\xe9, pou\u017E\xedvate\u013E nebude: (i) upravova\u0165, preklada\u0165, sp\xe4tne analyzova\u0165, dekompilova\u0165, rozobera\u0165, pok\xfa\u0161a\u0165 sa rekon\u0161truova\u0165, identifikova\u0165 alebo h\u013Eada\u0165 ak\xfdko\u013Evek zdrojov\xfd k\xf3d, zdrojov\xe9 n\xe1pady, techniku z\xe1kazn\xedckeho panelu alebo algoritmy, alebo vytv\xe1ra\u0165 odvoden\xe9 diela a kop\xedrova\u0165 Spacer\xae; (ii) odstra\u0148ova\u0165, upravova\u0165 alebo zakr\xfdva\u0165 ak\xe9ko\u013Evek ozn\xe1menia o autorsk\xfdch pr\xe1vach alebo ochrann\xfdch zn\xe1mkach alebo in\xe9 ozn\xe1menia o vlastn\xedckych pr\xe1vach obsiahnut\xe9 v Spacer\xae; (iii) post\xfapi\u0165, sublicencova\u0165 alebo inak previes\u0165 svoj pr\xedstup, pou\u017Eitie alebo in\xe9 pr\xe1va alebo delegova\u0165 svoje povinnosti pod\u013Ea tejto dohody; alebo (iv) bez obmedzenia ktor\xe9hoko\u013Evek z vy\u0161\u0161ie uveden\xe9ho, \u200B\u200Bpou\u017E\xedva\u0165 Spacer\xae na \xfa\u010Dely budovania konkuren\u010Dn\xe9ho produktu alebo slu\u017Eby alebo na ak\xfdko\u013Evek in\xfd \xfa\u010Del, okrem legit\xedmnych obchodn\xfdch \xfa\u010Delov s\xfavisiace s podnikan\xedm pou\u017E\xedvate\u013Ea.",
    TermsLimitationsD: "U\u017E\xedvate\u013E s\xfahlas\xed s t\xfdm, \u017Ee bezodkladne p\xedsomne \u200B\u200Binformuje spolo\u010Dnos\u0165 CBRE, ak mu bude ozn\xe1men\xe9 ak\xe9ko\u013Evek neopr\xe1vnen\xe9 pou\u017Eitie produktu Spacer\xae alebo ak\xe9ko\u013Evek mo\u017En\xe9 poru\u0161enie vlastn\xedckych pr\xe1v.",
    TermsLimitationsE: "U\u017E\xedvate\u013E nikdy po\u010Das trvania alebo po skon\u010Den\xed platnosti tejto dohody nebude \u017Eiada\u0165 o registr\xe1ciu ak\xfdchko\u013Evek autorsk\xfdch pr\xe1v, ochrann\xfdch zna\u010Diek alebo in\xfdch ozna\u010Den\xed, ktor\xe9 by ovplyv\u0148ovali vlastn\xedctvo, ani odosiela\u0165 dokumenty, ktor\xe9 by mali vplyv na vlastn\xedctvo Spacer\xae spolo\u010Dnos\u0165ou CBRE, zna\u010Dku Spacer\xae a \u010Fal\u0161\xedch komponentov aplik\xe1cie. Spacer\xae je ochrann\xe1 zn\xe1mka a servisn\xe1 zna\u010Dka spolo\u010Dnosti CBRE.",
    TermsLimitationsF: "U\u017E\xedvate\u013E prehlasuje a s\xfahlas\xed s t\xfdm, \u017Ee m\xe1 pr\xe1vo poskytn\xfa\u0165 v\u0161etky materi\xe1ly alebo inform\xe1cie pou\u017Eit\xe9 v s\xfavislosti so Spacer\xae, a t\xfdmto ude\u013Euje spolo\u010Dnosti CBRE nev\xfdhradn\xe9, bezlicen\u010Dn\xe9, univerz\xe1lne, neodvolate\u013En\xe9, trval\xe9 pr\xe1vo a licenciu na pou\u017Eitie , reprodukovanie, upravovanie, distribuovanie, vytv\xe1ranie odvoden\xe9ho diela a zobrazovanie t\xfdchto materi\xe1lov a inform\xe1ci\xed pod\u013Ea uv\xe1\u017Eenia spolo\u010Dnosti CBRE. U\u017E\xedvate\u013E berie na vedomie, \u017Ee je zodpovedn\xfd za ak\xfdko\u013Evek materi\xe1l a inform\xe1cie, ktor\xe9 po\u0161le, vr\xe1tane ich z\xe1konnosti, spo\u013Eahlivosti, vhodnosti, originality a autorsk\xfdch pr\xe1v. Licencie udelen\xe9 pou\u017E\xedvate\u013Eom spolo\u010Dnosti CBRE pod\u013Ea tejto zmluvy zostan\xfa v platnosti aj po ukon\u010Den\xed pou\u017E\xedvania produktu Spacer\xae pou\u017E\xedvate\u013Eom. Ak\xfdko\u013Evek materi\xe1l a inform\xe1cie predlo\u017Een\xe9 pou\u017E\xedvate\u013Eom bud\xfa pova\u017Eovan\xe9 za ned\xf4vern\xe9 a nechr\xe1nen\xe9 a tak s nimi bude nakladan\xe9 zo strany CBRE, a m\xf4\u017Eu by\u0165 pou\u017Eit\xe9 spolo\u010Dnos\u0165ou CBRE v s\xfalade s touto dohodou bez upozornenia pou\u017E\xedvate\u013Ea a bez akejko\u013Evek n\xe1rokovate\u013Enosti vo\u010Di CBRE.",
    TermsOwnershipTitle: "Vlastn\xedctvo.",
    TermsOwnershipText: "Spacer\xae, programovac\xed jazyk, softv\xe9r a dokument\xe1cia a v\u0161etok \u010Fal\u0161\xed materi\xe1l a obsah spr\xedstupnen\xfd na serveri Spacer\xae, alebo ak\xe9ko\u013Evek vylep\u0161enia, \xfapravy, odvoden\xe9 diela, vylep\u0161enia alebo zmeny programu Spacer\xae so v\u0161etk\xfdmi k\xf3piami, s\xfa vlastn\xedctvom spolo\u010Dnosti CBRE a jeho n\xe1zov zost\xe1va v\xfdhradne v spolo\u010Dnosti CBRE za ka\u017Ed\xfdch okolnost\xed vr\xe1tane, bez obmedzenia, v\u0161etky pr\xe1va na patenty, autorsk\xe9 pr\xe1va, ochrann\xe9 zn\xe1mky a obchodn\xe9 tajomstv\xe1 v aplik\xe1cii Spacer\xae, ako aj vylep\u0161enia, \xfapravy, diela odvoden\xe9 od \xfaprav a zmien. U\u017E\xedvate\u013E berie na vedomie, \u017Ee vy\u0161\u0161ie uveden\xe9 zah\u0155\u0148a obchodn\xe9 tajomstv\xe1 a inform\xe1cie, ktor\xe9 s\xfa d\xf4vern\xe9 a vo vlastn\xedctve spolo\u010Dnosti CBRE, a zav\xe4zuje sa, \u017Ee podnikne v\u0161etky potrebn\xe9 kroky na ochranu d\xf4vernosti t\xfdchto inform\xe1ci\xed. U\u017E\xedvate\u013E nesmie pred\xe1va\u0165, prev\xe1dza\u0165, publikova\u0165, zverej\u0148ova\u0165, zobrazova\u0165 alebo inak spr\xedstup\u0148ova\u0165 Spacer\xae ani vytv\xe1ra\u0165 ani spr\xedstup\u0148ova\u0165 \u017Eiadne vylep\u0161enia, \xfapravy, vylep\u0161enia, odvoden\xe9 diela alebo ich zmeny a k\xf3pie. Ukon\u010Denie tejto dohody bude doplnkom a nie namiesto ak\xfdchko\u013Evek opravn\xfdch prostriedkov, ktor\xe9 m\xe1 CBRE k dispoz\xedcii z\xe1konne ani v spravodlivosti. Z\xe1v\xe4zky z tejto dohody zost\xe1vaj\xfa v platnosti aj po ukon\u010Den\xed platnosti tejto dohody.",
    TermsTerminationTitle: "V\xfdpove\u010F; \xda\u010Dinok ukon\u010Denia; Oprava",
    TermsTerminationA: "Bez obmedzenia ak\xfdchko\u013Evek \u010Fal\u0161\xedch n\xe1pravn\xfdch opatren\xed m\xf4\u017Ee spolo\u010Dnos\u0165 CBRE s okam\u017Eitou platnos\u0165ou, automaticky, s upozornen\xedm alebo bez neho a bez mo\u017Enosti obr\xe1ti\u0165 sa na s\xfad, upravi\u0165 alebo obmedzi\u0165, pozastavi\u0165, alebo ukon\u010Di\u0165  t\xfato dohodu a / alebo u\u017E\xedvate\u013Eovo pou\u017E\xedvanie Spacer\xae, alebo akejko\u013Evek jeho \u010Dasti s okam\u017Eitou platnos\u0165ou, automaticky, s upozornen\xedm alebo bez neho. U\u017E\xedvate\u013E s\xfahlas\xed s t\xfdm, \u017Ee spolo\u010Dnos\u0165 CBRE nie je povinn\xe1 poskytova\u0165 Spacer\xae a \u017Ee CBRE nenesie zodpovednos\u0165 vo\u010Di pou\u017E\xedvate\u013Eovi ani vo\u010Di akejko\u013Evek inej strane za ak\xe9ko\u013Evek obmedzenie, pozastavenie, preru\u0161enie, ukon\u010Denie alebo \xfapravu Spacer\xae.",
    TermsTerminationB: "Pou\u017E\xedvate\u013E berie na vedomie, \u017Ee povinnosti vypl\xfdvaj\xface z tejto zmluvy vo\u010Di CBRE maj\xfa jedine\u010Dn\xfd a nenahradite\u013En\xfd charakter, ktor\xe9ho poru\u0161enie nen\xe1vratne po\u0161kod\xed CBRE a ktor\xfd nemo\u017Eno nahradi\u0165 samotnou pe\u0148a\u017Enou sumou, tak\u017Ee CBRE bude ma\u0165 n\xe1rok na zdr\u017Eanie sa konania alebo in\xfa spravodliv\xfa n\xe1pravu (bez z\xe1v\xe4zkov vystavenia akejko\u013Evek zmluvy alebo z\xe1ruky) v pr\xedpade ak\xe9hoko\u013Evek poru\u0161enia alebo predpokladan\xe9ho poru\u0161enia zo strany U\u017E\xedvate\u013Ea. Pou\u017E\xedvate\u013E sa neodvolate\u013Ene vzd\xe1va v\u0161etk\xfdch pr\xe1v na dom\xe1hanie sa s\xfadneho pr\xedkazu alebo inej spravodlivej pomoci.",
    TermsDisclaimerTitle: "Zrieknutie sa zodpovednosti a obmedzenie zodpovednosti.",
    TermsDisclaimerA: "Spacer\xae je poskytovan\xfd pou\u017E\xedvate\u013Eovi \u201ETAK, AKO JE\u201C a \u201EAKO JE K DISPOZ\xcdCII\u201C, bez ak\xfdchko\u013Evek z\xe1ruk. CBRE ODMIETA V\u0160ETKY Z\xc1RUKY, V\xddSLOVN\xc9 ALEBO PREDPOKLADAN\xc9, VR\xc1TANE, ALE NIE OBMEDZEN\xc9 NA PREDPOKLADAN\xc9 Z\xc1RUKY PREDAJNOSTI, VHODNOSTI NA KONKR\xc9TNY \xda\u010CEL A PORU\u0160ENIE PR\xc1V. Spolo\u010Dnos\u0165 CBRE NERU\u010C\xcd \u017DIADNYM SP\xd4SOBOM ZA TO, \u017DE SPACER\xae SPLN\xcd PO\u017DIADAVKY U\u017D\xcdVATE\u013DA ALEBO \u0160PECIFICK\xdd \u0160TANDARD. NIEKTOR\xc9 \u0160T\xc1TY NEPOVO\u013DUJ\xda VYL\xda\u010CENIE PREDPOKLADAN\xddCH Z\xc1RUK, TAK\u017DE SA VY\u0160\u0160IE UVEDEN\xc9 VYL\xda\u010CENIE NEMUS\xcd VZ\u0164AHOVA\u0164 NA POU\u017D\xcdVATE\u013DA. V takom pr\xedpade bude zodpovednos\u0165 spolo\u010Dnosti CBRE obmedzen\xe1 v maxim\xe1lnom mo\u017Enom rozsahu pod\u013Ea platn\xfdch pr\xe1vnych predpisov. \u017DIADNE \xdaSTNE ALEBO P\xcdSOMN\xc9 INFORM\xc1CIE ALEBO PORADENSTVO, KTOR\xc9 POSKYTUJE CBRE, JEJ AGENTI ALEBO ZAMESTNANCI, NEVYTV\xc1RAJ\xda AK\xdaKO\u013DVEK Z\xc1RUKU . CBRE NEPOSKYTUJE \u017DIADNU Z\xc1RUKU, \u017DE SPACER\xae ALEBO AK\xc9KO\u013DVEK INFORM\xc1CIE POSKYTNUT\xc9 U\u017D\xcdVATE\u013DOVI S\xda BEZCHYBN\xc9, ALEBO BUDE POU\u017D\xcdVANIE SPACERU NEPRERU\u0160OVAN\xc9, AKTU\xc1LNE, KOMPLETN\xc9 ALEBO BEZ V\xcdRUSOV ALEBO IN\xddCH \u0160KODLIV\xddCH KOMPONENTOV; \u017DIADNA Z\xc1RUKA SA NEPOSKYTUJE NA OPRAVU VY\u015A\u0160IE UVEDEN\xddCH IN\u0160TANCI\xcd. Spolo\u010Dnos\u0165 CBRE NEZARU\u010CUJE A NEVYD\xc1VA \u017DIADNE VYHL\xc1SENIA T\xddKAJ\xdaCE SA POU\u017D\xcdVANIA Spacer\xae ALEBO V\xddSLEDKOV Z POU\u017DITIA SPACER. CBRE NENESIE ZODPOVEDNOS\u0164 ZA \u017DIADNE NEPRIAME, \u0160PECI\xc1LNE, N\xc1HODN\xc9, N\xc1SLEDN\xc9, TRESTN\xc9 ALEBO PR\xcdKLADN\xc9 \u0160KODY (VR\xc1TANE BEZ \u0160K\xd4D ZA STRATU PODNIKANIA, STRATU ZISKOV, STRATY PR\xcdJMOV, STRATU DOBREJ V\xf4le, STRATY OBRATOV, STRATY \xdaSPOR, STRATY D\xc1T), \u010CI U\u017D KV\xd4LI PORU\u0160ENIU ZMLUVY, TRESTU (VR\xc1TANE ZANEDBANIA), ZODPOVEDNOSTI ZA V\xddROBKY ALEBO INAK, AJ KE\u010E BOLI Z\xc1STUPCOVIA CBRE VOPRED UPOZORNEN\xcd O MO\u017DNOSTI \u0160KODY, AJ V PR\xcdPADE, \u017DE S\xda OPRAVN\xc9 OPATRENIA NE\xda\u010CINN\xc9 \u201C\u201C",
    TermsDisclaimerB: "CELKOV\xc1 ZODPOVEDNOS\u0164 SPOLO\u010CNOSTI CBRE ZA \u0160KODY ZA AK\xdaKO\u013EVEK PR\xcd\u010CINU NIKDY NEPREKRO\u010C\xcd POPLATOK UPLATNEN\xdd U\u017D\xcdVATE\u013DOM ZA Spacer\xae PO\u010CAS DVAN\xc1S\u0164 (12) MESA\u010CN\xc9HO OBDOBIA PRED AKCIOU, KTOR\xc1 ZAPR\xcd\u010CINILA TOTO PO\u0160KODENIE. U\u017D\xcdVATE\u013D S\xdaHLAS\xcd S T\xddM, \u017DE AK\xc1KO\u013DVEK PR\xcd\u010CINA \u010CINNOSTI VYPL\xddVAJ\xdaCA ZO Spacer\xae ALEBO S\xdaVISIACA S TOUTO DOHODOU, MUS\xcd ZA\u010CA\u0164 DO JEDN\xc9HO (1) ROKU PO PR\xcd\u010CINE. INAK TAK\xc1TO PR\xcd\u010CINA \u010CINNOSTI OST\xc1VA NAV\u017DDY BEZPREDMETNOU.",
    TermsDisclaimerC: "NIEKTOR\xc9 PR\xc1VNE \xdaPRAVY NEMUSIA POVOLI\u0164 OBMEDZENIE ZODPOVEDNOSTI ALEBO VYL\xda\u010CENIA ZODPOVEDNOSTI UVEDEN\xc9 VY\u0160\u0160IE, TAK\u017DE SA VY\u0160\u0160IE UVEDEN\xc9 OBMEDZENIE ALEBO VYL\xda\u010CENIE NEMUSIA VZ\u0164AHOVA\u0164 NA POU\u017D\xcdVATE\u013DA. V takom pr\xedpade bude zodpovednos\u0165 spolo\u010Dnosti CBRE obmedzen\xe1 v maxim\xe1lnom mo\u017Enom rozsahu pod\u013Ea platn\xfdch pr\xe1vnych predpisov. Zrieknutie sa z\xe1ruky, v\xfdhradn\xe9 opravn\xe9 prostriedky a obmedzen\xe1 zodpovednos\u0165 uveden\xe9 vy\u0161\u0161ie s\xfa z\xe1kladn\xfdmi prvkami tejto dohody medzi CBRE a U\u017D\xcdVATE\u013DOM. Spolo\u010Dnos\u0165 CBRE by nebola schopn\xe1 poskytn\xfa\u0165 Spacer\xae na ekonomickom z\xe1klade a bez t\xfdchto obmedzen\xed by neuzavrela t\xfato dohodu. Tieto obmedzenia zostan\xfa v platnosti aj po ukon\u010Den\xed tejto dohody.",
    TermsIndemnificationTitle: "Od\u0161kodnenie pou\u017E\xedvate\u013Ea.",
    TermsIndemnificationText: "Pou\u017E\xedvate\u013E, pod\u013Ea uv\xe1\u017Eenia a na \u017Eiados\u0165 CBRE, na svoje vlastn\xe9 n\xe1klady, od\u0161kodn\xed a zaist\xed nezranite\u013Enos\u0165 CBRE a jej dc\xe9rskych spolo\u010Dnost\xed, pridru\u017Een\xfdch spolo\u010Dnost\xed, \xfaradn\xedkov, zamestnancov, agentov, pridru\u017Een\xfdch zna\u010Diek, asoci\xe1ci\xed a \u010Fal\u0161\xedch partnerov, aby boli plne nerizikov\xe9 vo\u010Di strat\xe1m, n\xe1kladom, \u0161kod\xe1m , z\xe1v\xe4zkom, vyrovnaniam a v\xfddavkom(vr\xe1tane (ale aj n\xe1kladom a poplatkom za pr\xe1vne zast\xfapenie), ktor\xe9 vznikaj\xfa alebo s\xfavisia s ak\xfdmko\u013Evek n\xe1rokom, konan\xedm alebo tvrden\xedm tretej strany s\xfavisiacim alebo vypl\xfdvaj\xfacim z: (a) akejko\u013Evek transakcie alebo sporu medzi pou\u017E\xedvate\u013Eom a tre\u0165ou stranou; (b) skuto\u010Dnosti alebo \xfadajnej skuto\u010Dnosti, ktor\xe9 by predstavovali poru\u0161enie ak\xfdchko\u013Evek vyhl\xe1sen\xed, z\xe1ruk alebo z\xe1v\xe4zkov pou\u017E\xedvate\u013Ea pod\u013Ea tejto dohody alebo ak\xfdchko\u013Evek platn\xfdch z\xe1konov, pravidiel alebo nariaden\xed, \u010Di u\u017E s\xfa tu uveden\xe9 alebo na ne nie je odkazovan\xe9; (c) ak\xfdchko\u013Evek materi\xe1lov, inform\xe1ci\xed alebo obsahu pou\u017E\xedvate\u013Ea predlo\u017Een\xfdch prostredn\xedctvom Spacer\xae; (d) poru\u0161enia ak\xfdchko\u013Evek pr\xe1v tret\xedch str\xe1n pou\u017E\xedvate\u013Eom, (e) pou\u017Eitia alebo zneu\u017Eitia Spaceru\xae pou\u017E\xedvate\u013Eom; alebo (f) nedbanlivosti alebo \xfamyseln\xe9ho zneu\u017Eitia \xfaradnej moci Pou\u017E\xedvate\u013Eom. CBRE m\xe1 pr\xe1vo v\xfdhradne riadi\u0165 a ovl\xe1da\u0165 svoju obranu a naj\xedma\u0165 pr\xe1vnych z\xe1stupcov pod\u013Ea svojho v\xfdberu na n\xe1klady pou\u017E\xedvate\u013Ea.",
    TermsGeneralTitle: "V\u0161eobecn\xe9.",
    TermsGeneralA: "T\xe1to zmluva predstavuje pln\xfa dohodu medzi CBRE a pou\u017E\xedvate\u013Eom, vo vz\u0165ahu k Spacer\xae, a v\u0161etk\xfdm predmetom tejto dohody, a nahr\xe1dza v\u0161etky predch\xe1dzaj\xface dohody medzi CBRE a pou\u017E\xedvate\u013Eom t\xfdkaj\xface sa Spacer\xae, Ak nejak\xe9 existovali. Neschopnos\u0165 spolo\u010Dnosti CBRE presadi\u0165 ktor\xe9ko\u013Evek ustanovenie tejto dohody sa nebude vyklada\u0165 ako vzdanie sa svojich pr\xe1v.",
    TermsGeneralB: "<0> Ozn\xe1menia. </0> Ozn\xe1menia, ktor\xe9 budete dost\xe1va\u0165, musia ma\u0165 p\xedsomn\xfa formu a m\xf4\u017Eu by\u0165 zaslan\xe9 e-mailom alebo zverejnen\xedm t\xfdchto ozn\xe1men\xed na serveri Spacer\xae alebo na adrese www.cbre.com/spacer. Vy n\xe1m budete ozn\xe1menia  posiela\u0165 e-mailom na adresu spacersupport@cbre.com a k\xf3pia bude odoslan\xe1 certifikovanou po\u0161tou cez USA 400 S. Hope Street, 25. poschodie, Los Angeles, CA 90071. Attention: General Counsel\xb4s Office. Ozn\xe1menia sa bud\xfa pova\u017Eova\u0165 za poskytnut\xe9 jeden (1) pracovn\xfd de\u0148 po odoslan\xed e-mailom (pokia\u013E odosielate\u013E nedostane odpove\u010F nazna\u010Duj\xfacu, \u017Ee spr\xe1va nebola doru\u010Dite\u013En\xe1), alebo tri pracovn\xe9 dni po zverejnen\xed na webovej str\xe1nke CBRE (v pr\xedpade CBRE), s alebo bez obd\u0155\u017Eania.",
    TermsGeneralC: "<0>\u0160t\xe1tne pr\xe1vo.</0> T\xe1to dohoda je riaden\xe1 a kon\u0161truovan\xe1 v s\xfalade s pr\xe1vnymi predpismi \u0161t\xe1tu Kalifornia bez oh\u013Eadu na ustanovenia o konflikte z\xe1konov. CBRE a pou\u017E\xedvate\u013E sa t\xfdmto podrobuj\xfa v\xfdlu\u010Dne in\u0161tit\xfaci\xe1m v \u0161t\xe1te Kalifornia. Dohovor OSN o zmluv\xe1ch o medzin\xe1rodnej k\xfape tovaru (1980) je t\xfdmto v celom rozsahu vyl\xfa\u010Den\xfd z uplat\u0148ovania tejto dohody. U\u017E\xedvate\u013E t\xfdmto s\xfahlas\xed, \u017Ee Spacer\xae je v\xfdlu\u010Dne so s\xeddlom spolo\u010Dnosti v Kalifornii a za pas\xedvnu slu\u017Ebu, ktor\xe1 nevyvol\xe1 samostatn\xe9 konania v r\xe1mci jurisdikcie nad r\xe1mec CBRE, \u010Di u\u017E konkr\xe9tne alebo v\u0161eobecn\xe9, v jurisdikcii inej ako v \u0161t\xe1te Kalifornia. \u201C",
    TermsGeneralD: "<0> Rie\u0161enie sporov. </0> Ak\xfdko\u013Evek spor, n\xe1rok alebo kontroverzia vypl\xfdvaj\xface z tejto dohody alebo s\xfavisiaca s touto dohodou, s poru\u0161en\xedm, vyn\xfaten\xedm, interpret\xe1ciou alebo platnos\u0165ou tejto dohody vr\xe1tane ur\u010Denia rozsahu alebo pou\u017Eite\u013Enosti tejto dohody bude adresovan\xfd arbitr\xe1\u017Eou. Arbitr\xe1\u017E bude spravova\u0165 S\xfadna arbitr\xe1\u017Ena a media\u010Dn\xe1 slu\u017Eba (JAMS) a arbitr\xe1\u017E sa bude vies\u0165 s jedn\xfdm arbitrom. U\u017E\xedvate\u013E \u010Falej s\xfahlas\xed s t\xfdm, \u017Ee ani pou\u017E\xedvate\u013E, ani CBRE sa v arbitr\xe1\u017Ei neprihl\xe1sia k \u017Eiadnemu n\xe1roku akejko\u013Evek inej osoby alebo subjektu; \u017Ee \u017Eiadny n\xe1rok nebude vyrie\u0161en\xfd na \xfarovni kateg\xf3rie; a \u017Ee Pou\u017E\xedvate\u013E ani CBRE neuplatn\xed \u017Eiadny n\xe1rok v zast\xfapen\xed v mene nikoho in\xe9ho. Bez oh\u013Eadu na vy\u0161\u0161ie uveden\xe9, pou\u017E\xedvate\u013E s\xfahlas\xed s t\xfdm, \u017Ee CBRE bude m\xf4c\u0165 v akejko\u013Evek jurisdikcii po\u017Eiada\u0165 o pr\xedkazn\xe9 opravn\xe9 prostriedky (alebo rovnocenn\xfd typ naliehavej pr\xe1vnej pomoci). Ak Pou\u017E\xedvate\u013E pod\xe1 arbitr\xe1\u017Enu s\u0165a\u017Enos\u0165 proti CBRE, CBRE sa zav\xe4zuje zaplati\u0165 za ak\xfako\u013Evek \u010Das\u0165 po\u010Diato\u010Dn\xe9ho poplatku presahuj\xfaceho 250 dol\xe1rov; po po\u010Diato\u010Dn\xfdch poplatkoch za podanie si strany rovnomerne rozdelia n\xe1klady na arbitr\xe1\u017E. U\u017E\xedvate\u013E sa zav\xe4zuje, \u017Ee proti CBRE neza\u010Dne ani nebude st\xedha\u0165 \u017Eiadne in\xe9 kroky ako podanie arbitr\xe1\u017Enej s\u0165a\u017Enosti v s\xfalade s t\xfdmto odsekom. Predov\u0161etk\xfdm, S\xdaHLASOM K ZAVIAZANIU SA K TEJTO ZMLUVE, SA U\u017D\xcdVATE\u013D VZD\xc1VA PR\xc1VA OBR\xc1TIT SA NA S\xdaD A AKEHOKO\u013DVEK PR\xc1VA VYPL\xddVAJ\xdaCEHO ZO S\xdaDU POROTOU:",
    TermsGeneralE: "<0> Preru\u0161enie. </0> V pr\xedpade, \u017Ee sa \u010Das\u0165 tejto dohody bude pova\u017Eova\u0165 za nevym\xe1hate\u013En\xfa, nevym\xe1hate\u013En\xe1 \u010Das\u0165 sa uprav\xed iba v rozsahu nevyhnutnom na zabezpe\u010Denie jej vykonate\u013Enosti a zvy\u0161ok ustanoven\xed zostane v plnej platnosti a \xfa\u010Dinku.",
    TermsGeneralF: "<0> Post\xfapenie. </0> T\xfato dohodu nem\xf4\u017Ee pou\u017E\xedvate\u013E post\xfapi\u0165 bez predch\xe1dzaj\xfaceho p\xedsomn\xe9ho s\xfahlasu spolo\u010Dnosti CBRE. Ak\xfdko\u013Evek pokus o post\xfapenie bez s\xfahlasu CBRE bude neplatn\xfd. CBRE si vyhradzuje pr\xe1vo post\xfapi\u0165 t\xfato dohodu ktorejko\u013Evek tretej strane. T\xe1to dohoda a pr\xe1va a povinnosti ka\u017Ed\xe9ho z n\xe1s pod\u013Ea nej bud\xfa z\xe1v\xe4zn\xe9 pre na\u0161ich n\xe1stupcov a postupn\xedkov.",
    TermsGeneralG: "<0> \xdapravy. </0> Spolo\u010Dnos\u0165 CBRE m\xf4\u017Ee kedyko\u013Evek a na z\xe1klade v\xfdlu\u010Dn\xe9ho a v\xfdhradn\xe9ho uv\xe1\u017Eenia spolo\u010Dnosti CBRE upravi\u0165 ktor\xe9ko\u013Evek z podmienok uveden\xfdch v tejto zmluve zverejnen\xedm ozn\xe1menia o zmene alebo novej dohody na str\xe1nkach Spacer\xae, na adrese adresa www.cbre.com/spacer alebo poskytnut\xedm upozornenia alebo podobn\xe9ho ozn\xe1menia v aplik\xe1cii Spacer\xae. Ak je pre pou\u017E\xedvate\u013Ea ak\xe1ko\u013Evek \xfaprava neprijate\u013En\xe1, m\xf4\u017Ee pou\u017E\xedvate\u013E ukon\u010Di\u0165 t\xfato dohodu skon\u010Den\xedm pou\u017E\xedvania  Spacer\xae.",
    TermsGeneralH: "<0> Konflikty. </0> V pr\xedpade konfliktu medzi podmienkami tejto zmluvy a akejko\u013Evek plne vykonanej licen\u010Dnej zmluvy medzi pou\u017E\xedvate\u013Eom a CBRE vo vz\u0165ahu k Spacer\xae, bud\xfa podmienky takejto licen\u010Dnej zmluvy ur\u010Duj\xface vo vz\u0165ahu k tak\xfdmto protichodn\xfdm podmienkam. \u201C\u201C"
};


var $4ab9959164770e8e$exports = {};
$4ab9959164770e8e$exports = {
    // Quiz
    exitQuizButtonTitle: "Ukon\u010Di\u0165 dotazn\xedk",
    // QuizProgressLabel
    progressLabelText: "Hotovo",
    // QuizNavigationButton
    quizNavBackButtonShortenedText: "Nasp\xe4\u0165",
    quizNavBackButtonFullLengthText: "Predch\xe1dzaj\xfaca ot\xe1zka",
    quizNavNextButtonShortenedText: "\u010Ealej",
    quizNavNextButtonFullLengthText: "\u010Eal\u0161ia ot\xe1zka",
    // QuizExitSlide
    quizExitSubtitle: "Teraz pou\u017Eijeme va\u0161e odpovede na definovanie dokonal\xe9ho pracoviska pre va\u0161u spolo\u010Dnos\u0165.",
    quizExitImgAlt: 'Ilustr\xe1cia dvoch \u013Eud\xed, ktor\xed si d\xe1vaj\xfa "high-five" na str\xe1nke dotazn\xedku Spacer od CBRE',
    // Question Unit Text (questionUnitMap.js)
    question1Text: "Na za\u010Diatok - Ako by ste op\xedsali \xfa\u010Del svojej bud\xfacej kancel\xe1rie?",
    question2Text: "\u010Co je na va\u0161ej spolo\u010Dnosti pod\u013Ea v\xe1s najatrakt\xedvnej\u0161ie pre nov\xfdch uch\xe1dza\u010Dov.",
    question3Text: "\u010Co je pre v\xe1s najd\xf4le\u017Eitej\u0161ie pri prij\xedman\xed nov\xfdch \u010Dlenov t\xedmu?",
    question4Text: "Ak\xfd rast predpoved\xe1te va\u0161ej firme v nasleduj\xfacich piatich rokoch?",
    question5Text: "Ak\xfd je pracovn\xfd \u010Das va\u0161ich zamestnancov?",
    question6Text: "\u010Co si mysl\xedte o zdie\u013Ean\xfdch pracovn\xfdch miestach?",
    question7Text: "Kde bud\xfa \u013Eudia v kancel\xe1rii naj\u010Dastej\u0161ie pracova\u0165?",
    question8Text: "Ak\xfd je dresscode vo va\u0161ej kancel\xe1rii?",
    question9Text: "Odkia\u013E budete pracova\u0165?",
    question10Text: "Ak\xe1 by mala by\u0165 atmosf\xe9ra va\u0161ej kancel\xe1rie?",
    question11Text: "\u010Co by mala poskytova\u0165 va\u0161a kancel\xe1ria okrem pracovn\xe9ho priestoru?",
    question12Text: "\u010Co v\xe1s najlep\u0161ie vystihuje?",
    // Quiz Answers (questionUnitMap.js)
    pickOnePlaceholder: "Vyberte jedno...",
    selectFromListPlaceholder: "Vyberte z mo\u017Enost\xed...",
    firstResponseTooltipText: "Vyberte svoju prv\xfa odpove\u010F",
    locatedSomewhereElseLabel: "Moment\xe1lne s\xeddlime niekde inde.",
    q1AnswerText1: "V prvom rade rozm\xfd\u0161\u013Eame o na\u0161ej kancel\xe1rii ako o",
    q1AnswerText2: "po druh\xe9 ako o",
    q1AnswerText3: "po tretie ako o",
    q1Option1Text: "druhom domove pre na\u0161ich \u013Eud\xed",
    q1Option2Text: "hnacej sile organiza\u010Dnej zmeny",
    q1Option3Text: "mieste pre s\xfastreden\xfa pr\xe1cu",
    q1Option4Text: "inkub\xe1tore pre \u010Fal\u0161\xed ve\u013Ek\xfd n\xe1pad",
    q1Option5Text: "n\xe1stroji na z\xedskanie ve\u013Ek\xe9ho talentu",
    q1Option6Text: "v\xfdkladnej skrini pre na\u0161u zna\u010Dku",
    q1Option7Text: "priestore pre rast a vzdel\xe1vanie",
    q1Option8Text: "mieste, kde sa m\xf4\u017Eu \u013Eudia stret\xe1va\u0165",
    q1Option9Text: "nevyhnutn\xfdch n\xe1kladoch, ktor\xe9 sa sna\u017E\xedme minimalizova\u0165",
    q2AnswerText1: "Nov\xfd uch\xe1dza\u010Di sa k n\xe1m prid\xe1vaj\xfa predov\u0161etk\xfdm kv\xf4li",
    q2AnswerText2: "po druh\xe9 kv\xf4li",
    q2AnswerText3: "po tretie kv\xf4li",
    q2Option1Text: "firemnej kult\xfare",
    q2Option2Text: "konkuren\u010Dn\xfdm platom",
    q2Option3Text: "reput\xe1cii firmy",
    q2Option4Text: "benefitom",
    q2Option5Text: "flexibilnej pracovnej dobe",
    q2Option6Text: "kolegom a vedeniu",
    q2Option7Text: "kancel\xe1rskemu priestoru",
    q2Option8Text: "\xfa\u010Delu a poslaniu",
    q3AnswerText1: "Nov\xfdch \u010Dlenov pr\xedjmame v prvom rade pre ich",
    q3AnswerText2: "po druh\xe9 pre ich",
    q3AnswerText3: "po tretie pre ich",
    q3Option1Text: "zru\u010Dnosti",
    q3Option2Text: "sk\xfasenosti",
    q3Option3Text: "kult\xfarnu adaptabilitu",
    q3Option4Text: "sp\xf4sobilos\u0165",
    q3Option5Text: "vz\u0165ahy",
    q3Option6Text: "zvedavos\u0165",
    q4AnswerText: "Vyberte mo\u017Enos\u0165",
    q4Option1Text: "Mierny rast ka\u017Ed\xfd rok.",
    q4Option2Text: "Zna\u010Dn\xfd rast ka\u017Ed\xfd rok.",
    q4Option3Text: "Zostaneme rovnak\xed.",
    q4Option4Text: "Mierny pokles ka\u017Ed\xfd rok.",
    q4Option5Text: "\u0164a\u017Eko poveda\u0165 - je to nepredv\xeddate\u013En\xe9.",
    q5AnswerText: "Zvy\u010Dajne pracujeme",
    q5Option1Text: "od 9:00 do 17:00.",
    q5Option2Text: "od r\xe1na do ve\u010Dera.",
    q5Option3Text: "kedyko\u013Evek chceme v ur\u010Dit\xfa dobu.",
    q5Option4Text: "kedyko\u013Evek a akoko\u013Evek \u010Dasto chceme.",
    q6AnswerText: "Mysl\xedme si, \u017Ee",
    q6Option1Text: "ka\u017Ed\xfd by mal ma\u0165 svoje vlastn\xe9 pracovn\xe9 miesto.",
    q6Option2Text: "je lep\u0161ie zdie\u013Ea\u0165 pracovn\xe9 miesta, ktor\xe9 nebud\xfa priraden\xe9.",
    q7Option1Text: "V\u017Edy zo svojho pracovn\xe9ho miesta",
    q7Option2Text: "Prim\xe1rne sa pracuje zo svojho pracovn\xe9ho miesta okrem sch\xf4dzok a in\xfdch aktiv\xedt",
    q7Option3Text: "Polovicu \u010Dasu sa pracuje zo svojho pracovn\xe9ho miesta a polovicu \u010Dasu z in\xe9ho priestoru v kancel\xe1rii",
    q7Option4Text: "Prim\xe1rne sa pohybova\u0165 na r\xf4znych pracovn\xfdch miestach s ob\u010Dasn\xfdmi zast\xe1vkami pri pracovn\xfdch stoloch",
    q7Option5Text: "Neust\xe1ly pohyb medzi r\xf4znymi pracovn\xfdmi miestami",
    q8Option1Text: "Business professional",
    q8Option2Text: "Business professional s ob\u010Dasn\xfdmi v\xfdnimkami",
    q8Option3Text: "Business casual, pod\u013Ea situ\xe1cie",
    q8Option4Text: "Casual, okrem \u0161peci\xe1lnych pr\xedle\u017Eitost\xed",
    q8Option5Text: "Uvolnen\xfd",
    q9Option1Text: "V\u017Edy z kancel\xe1rie",
    q9Option2Text: "Zvy\u010Dajne z kancel\xe1rie",
    q9Option3Text: "Striedavo v kancel\xe1rii a dia\u013Ekovo",
    q9Option4Text: "Preva\u017Ene dia\u013Ekovo",
    q9Option5Text: "V\u017Edy dia\u013Ekovo",
    q10Option1Text: "Dynamick\xe1 a energick\xe1",
    q10Option2Text: "Energick\xe1 s tich\xfdmi miestami na s\xfastredenie",
    q10Option3Text: "Z\xe1le\u017E\xed od situ\xe1cie - kombin\xe1cia ticha a dynamiky",
    q10Option4Text: "Tich\xe1, s ob\u010Dasn\xfdmi dynamick\xfdmi situ\xe1ciami",
    q10Option5Text: "Tich\xe1 a pokojn\xe1",
    q11Option1Text: "Iba z\xe1kladn\xe9 vybavenie, posta\u010Duj\xface urd\u017Ea\u0165 \u013Eud\xed v pracovnom chode",
    q11Option2Text: "Z\xe1kladn\xe9 vybavenie a nieko\u013Eko inov\xe1ci\xed",
    q11Option3Text: "Z\xe1kladn\xe9 vybavenie a miesto, kde sa \u013Eudia m\xf4\u017Eu spolo\u010Densky zhroma\u017E\u010Fova\u0165",
    q11Option4Text: "Nie\u010Do skuto\u010Dne pekn\xe9, zauj\xedmav\xfd priestor v r\xe1mci kancel\xe1rie",
    q11Option5Text: "Nie\u010Do cool a odli\u0161n\xe9 - prv\xe1 vec, ktor\xfa uk\xe1\u017Eete n\xe1v\u0161tevn\xedkovi",
    q12AnswerText: "Som",
    q12OptionClientText: "existuj\xfaci klient CBRE",
    q12OptionProfessionalText: "CBRE profesion\xe1l",
    q12OptionLeadText: "niekto in\xfd",
    q13AnswerText1: "Budeme ma\u0165",
    q13AnswerText2: "zamestnancov v na\u0161ej kancel\xe1rii",
    q13AnswerHelperText: "Pom\xf4cka: Toto je zvy\u010Dajne stred va\u0161eho pren\xe1jmu, alebo 2-5 rokov odteraz.",
    q14AnswerText1: "Str\xe1vime",
    q14AnswerText2: "n\xe1\u0161ho \u010Dasu pr\xe1cou v t\xedmoch.",
    q15AnswerText1: "V priemere pl\xe1nujeme str\xe1vi\u0165",
    q15AnswerText2: "dn\xed pr\xe1cou z kancel\xe1rie.",
    q16AnswerText1: "Na\u0161a kancel\xe1ria bude v meste...",
    q16AnswerText2: ".",
    q17AnswerText1: "Podnik\xe1me prim\xe1rne v ",
    q17AnswerText2: "sektore.",
    q18AnswerText1: "Moment\xe1lne s\xeddlime v ",
    q18AnswerText2: ".",
    q19AnswerText1: "Hustotu vyu\u017Eitia na\u0161ej kancel\xe1rie odhadujeme na (osoba na m2)",
    q19AnswerText2: "v bud\xfacnosti.",
    // Quiz Responses (questionUnitMap.js)
    q1ResponseText: "Zadefinujeme kancel\xe1riu, ktor\xe1 zodpovie va\u0161ej v\xedzii.",
    q2ResponseText: "Atrakt\xedvna kombin\xe1cia!",
    q3ResponseText: "Znie to dobre - kam sa m\xf4\u017Eeme hl\xe1si\u0165?",
    q4ResponseText: "Skvel\xe9! Zaist\xedme, aby kancel\xe1ria splnila po\u017Eiadavky.",
    q5Response1Text: "Znie to dobre!",
    q5Response2Text: "My tak isto zvykneme pracova\u0165 aj nad\u010Dasy.",
    q5Response3Text: "Znie to v\xfdborne!",
    q5Response4Text: "Znie to \xfa\u017Easne!",
    q6Response1Text: "Definujeme miesto, ktor\xe9 uprednost\u0148uje osobn\xfd priestor.",
    q6Response2Text: "Definujeme miesto, ktor\xe9 je flexibiln\xe9",
    q12ResponseLeadText: "Pri\u0161li ste na spr\xe1vne miesto!",
    q12ResponseClientText: "Perfektn\xe9!",
    q12ResponseProfessionalText: "V\u010Faka!",
    // Industry Codes (industryCodes.js)
    animalProd: "\u017Divo\u010D\xed\u0161na v\xfdroba a akvakult\xfara",
    forestry: "Lesn\xedctvo a \u0165a\u017Eba dreva",
    fishingHunting: "Rybolov, lov a pasce",
    agForestSupport: "\u010Cinnosti na podporu po\u013Enohospod\xe1rstva a lesn\xe9ho hospod\xe1rstva",
    oilGas: "\u0164a\u017Eba ropy a zemn\xe9ho plynu",
    energy: "Energetika (plyn, ropa at\u010F.)",
    mining: "\u0164a\u017Eba, okrem ropy a plynu",
    supportMining: "Podporn\xe9 \u010Dinnosti pre \u0165a\u017Ebu",
    utilities: "Verejn\xe9 slu\u017Eby",
    buildingConstruct: "V\xfdstavba budov",
    heavyCivilConstruct: "\u0164a\u017Ek\xe9 a in\u017Einierske stavby",
    specialtyContract: "\u0160pecializovan\xed obchodn\xed dod\xe1vatelia",
    foodManufac: "V\xfdroba potrav\xedn",
    beverageTobaccoManufac: "V\xfdroba n\xe1pojov a tabakov\xfdch v\xfdrobkov",
    textile: "Textiln\xfd z\xe1vod",
    textileProduct: "Z\xe1vod textiln\xfdch v\xfdrobkov",
    apparelManufac: "V\xfdroba odevov",
    leatherManufac: "V\xfdroba ko\u017Ee a pridru\u017Een\xfdch v\xfdrobkov",
    woodManufac: "V\xfdroba dreven\xfdch v\xfdrobkov",
    paperManufac: "V\xfdroba papiera",
    printingSupport: "Tla\u010D a s\xfavisiace podporn\xe9 \u010Dinnosti",
    printingReproduc: "Tla\u010D / reprodukcie",
    petroleumCoal: "V\xfdroba ropy a uho\u013En\xfdch v\xfdrobkov",
    chemicalManufac: "Chemick\xe1 v\xfdroba",
    chemicals: "Chemik\xe1lie",
    pharma: "Farmaceutik\xe1",
    cleaningManufac: "V\xfdroba \u010Distiacich prostriedkov",
    plasticsRubberManufac: "V\xfdroba plastov a gumov\xfdch v\xfdrobkov",
    nonmetallicManufac: "V\xfdroba nekovov\xfdch miner\xe1lnych v\xfdrobkov",
    primaryMetalManufac: "Prvotn\xe9 spracovanie kovov",
    fabricatedMetalManufac: "V\xfdroba kovov\xfdch v\xfdrobkov",
    machineryManufac: "V\xfdroba strojov",
    manufac: "V\xfdroba",
    computerElectronicManufac: "V\xfdroba po\u010D\xedta\u010Dov a elektronick\xfdch v\xfdrobkov",
    electricalApplianceManufac: "V\xfdroba elektrick\xfdch zariaden\xed a pr\xedstrojov",
    transportEquipManufac: "V\xfdroba dopravn\xfdch zariaden\xed",
    aerospaceDefense: "Letectvo a obrana",
    furnitureManufac: "V\xfdroba n\xe1bytku a s\xfavisiacich v\xfdrobkov",
    miscManufac: "V\xfdroby r\xf4znych produktov",
    merchantWholesaleDurable: "Ve\u013Ekoobchod - tovar dlhodobej spotreby",
    merchantWholesaleNondurable: "Ve\u013Ekoobchod - tovar kr\xe1tkodobej spotreby",
    electronicMarket: "Elektronick\xe9 trhy, agenti a makl\xe9ri",
    motorVehiclePartsDealers: "Predajcovia motorov\xfdch vozidiel a n\xe1hradn\xfdch dielov",
    furnitureFurnishingStores: "Obchody s n\xe1bytkom a bytov\xfdm zariaden\xedm",
    electronicApplianceStores: "Obchody s elektronikou a spotrebi\u010Dmi",
    electronics: "Elektronika",
    buildingGardenSupplyStores: "Predaj stavebn\xe9ho materi\xe1lu a z\xe1hradn\xfdch potrieb",
    foodBeverageStores: "Predaj potrav\xedn a alkoholick\xfdch n\xe1pojov",
    groceryStores: "Potraviny",
    beerWineLiquorStores: "Predaj piva, v\xedna a alkoholu",
    healthCareStores: "Obchody so zdravotnou a osobnou starostlivos\u0165ou",
    gasStations: "\u010Cerpacie stanice",
    clothingAccessoriesStores: "Obchody s odevmi a odevn\xfdmi doplnkami",
    clothingTextiles: "Oble\u010Denie / textil",
    jewelryFurs: "\u0160perky a ko\u017Eu\u0161iny",
    sportsHobbyMusicBookStores: "\u0160port, hobby, hudobn\xe9 n\xe1stroje, kn\xedhkupectv\xe1",
    genMerchandiseStores: "Obchody so zmie\u0161an\xfdm tovarom",
    miscStoreRetailers: "Maloobchodn\xedci so zmie\u0161an\xfdm tovarom",
    officeProducts: "Kancel\xe1rske produkty",
    retailSales: "Maloobchodn\xfd predaj",
    nonstoreRetails: "Maloobchodn\xfd predaj mimo predajne",
    airTransport: "Leteck\xe1 preprava",
    travelRelated: "Cestovanie (leteck\xe9 spolo\u010Dnosti, agenti, hromadn\xe1 doprava)",
    railTransport: "\u017Delezni\u010Dn\xe1 doprava",
    waterTransport: "Vodn\xe1 doprava",
    truckTransport: "Kami\xf3nov\xe1 doprava",
    transitTransport: "Tranzitn\xe1 a pozemn\xe1 osobn\xe1 doprava",
    pipelineTransport: "Potrubn\xe1 preprava",
    scenicTransport: "V\xfdletn\xe1 a z\xe1\u017Eitkov\xe1 doprava",
    supportTransport: "Podporn\xe9 \u010Dinnosti v doprave",
    postalService: "Po\u0161tov\xe9 slu\u017Eby",
    courierMessenger: "Kuri\xe9ri a doru\u010Dovanie spr\xe1v",
    shippingDelivery: "Preprava a doru\u010Denie",
    warehousingStorage: "Skladovanie",
    warehouseDistrib: "Skladovanie/Distrib\xfacia",
    publishingNoInternet: "Vydavate\u013Esk\xfd priemysel, okrem internetu",
    publishing: "Vydavate\u013Estvo",
    motionPicSoundRecordingIndustries: "Filmov\xe9 a hudobn\xe9 nahr\xe1vacie \u0161t\xfadi\xe1",
    entertainment: "Z\xe1bava (film, telev\xedzia, hudba at\u010F.)",
    infoServicesMarketResearch: "Informa\u010Dn\xe9 slu\u017Eby / Prieskum trhu",
    broadcastingNoInternet: "Vysielanie, okrem internetu",
    telecom: "Telekomunik\xe1cie",
    tech: "Technol\xf3gie",
    dataProcessingHostingServices: "Spracovanie d\xe1t, hosting a s\xfavisiace slu\u017Eby",
    otherInfoServices: "In\xe9 informa\u010Dn\xe9 slu\u017Eby",
    financeInsurance: "Finan\u010Dn\xedctvo a poistenie",
    monetaryAuthorities: "Menov\xe9 org\xe1ny - centr\xe1lna banka",
    creditIntermediation: "Sprostredkovanie \xfaverov a s\xfavisiace \u010Dinnosti",
    banking: "Bankovn\xedctvo",
    securitiesContractsInvestments: "Cenn\xe9 papiere, komoditn\xe9 zmluvy, invest\xedcie",
    financialServicesNoBanking: "Finan\u010Dn\xe9 slu\u017Eby (nebankov\xe9)",
    insuranceCarriersRelated: "Pois\u0165ovn\xedctvo a s\xfavisiace \u010Dinnosti",
    insurance: "Pois\u0165ovn\xedctvo",
    fundsTrustsFinancialVehicles: "Fondy a \u010Fal\u0161ie finan\u010Dn\xe9 kan\xe1ly",
    realEstate: "Nehnute\u013Enosti",
    rentalLeasingServices: "Pren\xe1jom a l\xedzing",
    automotive: "Automobilov\xfd priemysel",
    consumerGoods: "Spotrebn\xfd tovar",
    lessorsNonfinancialIntangible: "Prenaj\xedmatelia nefinan\u010Dn\xfdch nehmotn\xfdch akt\xedv",
    professionalTechnicalServices: "Profesion\xe1lne a technick\xe9 slu\u017Eby",
    legalServices: "Pr\xe1vne slu\u017Eby",
    accounting: "\xda\u010Dtnovn\xedctvo",
    architectureEngineering: "Architekt\xfara/In\u017Einierstvo",
    specializedDesignServices: "\u0160pecializovan\xe9 dizajnov\xe9 slu\u017Eby",
    compRelatedServices: "Po\u010D\xedta\u010Dov\xe9 slu\u017Eby",
    mgmtConsulting: "Poradenstvo v oblasti mana\u017Ementu",
    scientificResearch: "Vedeck\xfd v\xfdskum",
    adsMarketingPR: "Reklama / Marketing / Vz\u0165ahy s verejnos\u0165ou",
    otherProfSciTechServices: "In\xe9 profesion\xe1lne, vedeck\xe9 a technick\xe9 slu\u017Eby",
    companyEnterpriseMgmt: "Riadenie spolo\u010Dnost\xed a podnikov",
    adminSupportServices: "Administrat\xedvne a podporn\xe9 slu\u017Eby",
    employmentAgencyRecruiters: "Pracovn\xe1 agent\xfara/n\xe1bor",
    securityPrivateInvestigation: "Bezpe\u010Dnos\u0165 / s\xfakromn\xe9 vy\u0161etrovanie",
    wasteMgmtRemediationServices: "Nakladanie s odpadom a sana\u010Dn\xe9 slu\u017Eby",
    educationServices: "Vzdel\xe1vacie slu\u017Eby",
    education: "Vzdel\xe1vanie",
    ambulatoryHealthCareServices: "Ambulantn\xe9 slu\u017Eby zdravotnej starostlivosti",
    healthCareRelated: "Slu\u017Eby s\xfavisiace so zdravotnou starostlivos\u0165ou",
    hospitals: "Nemocnice",
    nursingResidentialCareFacilities: "O\u0161etrovate\u013Esk\xe9 a \xfastavn\xe9 zariadenia",
    socialAssistance: "Soci\xe1lna pomoc",
    performingArtsSpectatorSports: "M\xfazick\xe9 umenie a div\xe1cke \u0161porty",
    museumsHistoricalSitesZoosParks: "M\xfaze\xe1, historick\xe9 pamiatky, zoologick\xe9 z\xe1hrady a parky",
    fineArtsGalleriesMuseums: "Kr\xe1sne umenia",
    amusementsGamblingRec: "Z\xe1bava, hazard a rekre\xe1cia",
    accommodation: "Ubytovanie",
    foodDrinkingServices: "Stravovacie slu\u017Eby a pitie",
    restaurantHotel: "Re\u0161taur\xe1cia/hotel",
    repairMaintenance: "Opravy a \xfadr\u017Eba",
    industrialProductsHeavy: "Priemyseln\xe9 v\xfdrobky (\u0165a\u017Ek\xfd priemysel)",
    personalLaundryServices: "Pr\xe1\u010Dovne",
    membershipAssocOrgs: "\u010Clensk\xe9 zdru\u017Eenia a organiz\xe1cie",
    nonprofit: "Neziskov\xe9",
    privateHouseholds: "Dom\xe1cnosti",
    execLegisGenGvt: "V\xfdkonn\xe1, legislat\xedvna a verejn\xe1 spr\xe1va",
    gvt: "Vl\xe1da",
    justicePublicOrderSafetyActivities: "\u010Cinnosti v oblasti spravodlivosti, verejn\xe9ho poriadku a bezpe\u010Dnosti",
    hrAdminPrograms: "Spr\xe1va programov \u013Eudsk\xfdch zdrojov",
    environmentAdminPrograms: "Spr\xe1va environment\xe1lnych programov",
    environmental: "\u017Divotn\xe9 prostredie",
    communityHousingProgramAdmin: "Spr\xe1va komunit\xe1rneho a bytov\xe9ho programu",
    econProgramAdmin: "Spr\xe1va ekonomick\xfdch programov",
    spaceResearchTech: "Vesm\xedrny v\xfdskum a technol\xf3gie",
    natlSecurityIntlAffairs: "N\xe1rodn\xe1 bezpe\u010Dnos\u0165 a medzin\xe1rodn\xe9 z\xe1le\u017Eitosti"
};


var $13e107e6be9f3ead$exports = {};
$13e107e6be9f3ead$exports = {
    // AboutPageHero
    aboutPageHeroImgAlt: "Ilustr\xe1cia \u013Eud\xed, ktor\xed sa s\u0165ahuj\xfa do kancel\xe1rie na str\xe1nke About Page of Spacer od CBRE",
    aboutPageHeroTitle: "\u010Co pre v\xe1s m\xf4\u017Ee urobi\u0165 Spacer?",
    // AboutPageContent
    aboutPageContentEndSectionTitle: "Ste pripraven\xed za\u010Da\u0165?",
    aboutPageProgramPreviewImgAlt: "Uk\xe1\u017Eka programu str\xe1nky s v\xfdsledkami z domovskej str\xe1nky programu Spacer od CBRE",
    aboutPageVideoTitle: "Ako to funguje",
    // About Page Content (aboutPageContent.js)
    aboutPageContent1Title: "Definujte va\u0161u dokonal\xfa kancel\xe1riu",
    aboutPageContent1Text: "Perfektn\xe9 kancel\xe1rske priestory v\xe1m m\xf4\u017Eu pom\xf4c\u0165 zamestna\u0165 talentovan\xfdch \u013Eud\xed, ochr\xe1ni\u0165 zdravie va\u0161ich zamestnancov, zn\xed\u017Ei\u0165 prev\xe1dzkov\xe9 n\xe1klady alebo vytvori\u0165 podmienky pre \u010Fal\u0161\xed ve\u013Ek\xfd n\xe1pad. Spacer je dokonal\xfdm miestom na za\u010Dapo\u010Datie ka\u017Ed\xe9ho rozhodnutia v oblasti nehnute\u013Enost\xed, preto\u017Ee v\xe1m pom\xe1ha uprednostni\u0165 va\u0161e ciele  a na z\xe1klade t\xfdchto cie\u013Eov vytvor\xed odpor\xfa\u010Dania t\xfdkaj\xface sa pracovn\xe9ho priestoru. Spacer bol vytvoren\xfd na z\xe1klade odborn\xfdch znalost\xed t\xedmu CBRE Workplace, skupiny s viac ako dvadsiatimi rokmi sk\xfasenost\xed, ktor\xe1 pom\xe1ha firm\xe1m navrhova\u0165 dokonal\xe9 kancel\xe1rie a kombinuje ich s bezplatnou internetovou technol\xf3giou dostupnou pre v\u0161etk\xfdch.",
    aboutPageContent1ImgAlt: "Ilustr\xe1cia \u013Eud\xed rozpr\xe1vaj\xfacich sa v O str\xe1nke Spacer od CBRE",
    aboutPageSpacerSupportLink: "spacersupport@cbre.com",
    aboutPageContent2Title: "Je to ve\u013Emi jednoduch\xe9",
    aboutPageContent2List1: "Za\u010Dnite t\xfdm, \u017Ee odpoviete na 17 dotazn\xedkov\xfdch ot\xe1zok t\xfdkaj\xfacich sa va\u0161ich organiza\u010Dn\xfdch cie\u013Eov a hodn\xf4t. Tieto odpovede bud\xfa formova\u0165 profil va\u0161ej ide\xe1lnej kancel\xe1rie.",
    aboutPageContent2List2: "Z\xedskate zoznam odpor\xfa\u010Dan\xfdch typov a ve\u013Ekost\xed priestorov, ktor\xe9 zodpovedaj\xfa va\u0161im vlastn\xfdm potreb\xe1m.",
    aboutPageContent2List3: "Vizualizujte si priestor podobn\xfd tomu v\xe1\u0161mu v 2D a 3D pomocou aplik\xe1cie Plans.",
    aboutPageContent2List4: "Ulo\u017Ete si svoj program na pou\u017Eitie pri h\u013Eadan\xed dokonalej kancel\xe1rie na trhu.",
    aboutPageContent2List5: "Nechajte profesion\xe1lov z CBRE, aby vyh\u013Eadali kancel\xe1rsky priestor zodpovedaj\xfaci v\xe1\u0161mu programu - bezplatne!",
    aboutPageContent2Text: "Ak m\xe1te \u010Fal\u0161ie ot\xe1zky ako ur\xfdchli\u0165 h\u013Eadanie kancel\xe1rskych priestorov prostredn\xedctvom programu Spacer kontaktujte n\xe1s na adrese",
    aboutPageContent2ImgAlt: "Ilustr\xe1cia diev\u010Da\u0165a pracuj\xfaceho za stolom na str\xe1nke Spacer od CBRE"
};


var $c017e2c03c549f9f$exports = {};
$c017e2c03c549f9f$exports = {
    referralStep: " Krok {{step}} 4",
    forgotReferralLink: "Stratili ste svoj referen\u010Dn\xfd odkaz?",
    howReferralLinksWorkTitle: "Ako funguje referen\u010Dn\xfd odkaz?",
    enterYourInformation: "Uve\u010Fte svoje \xfadaje",
    confirmYourInformation: "Potvr\u010Fte svoje \xfadaje",
    referralLinkStep1: "Na vytvorenie referen\u010Dn\xe9ho odkazu je potrebn\xe9:",
    referralLinkReq1: "- Va\u0161e meno",
    referralLinkReq2: "- Va\u0161u e-mailovu adresu od CBRE",
    referralLinkStep2: "Ke\u010F z\xe1ujemca vypln\xed dotazn\xedk prostredn\xedctvom referen\u010Dn\xe9ho odkazu, po\u0161leme v\xe1m emailom k\xf3piu jeho v\xfdsledkov.",
    next: "\u010Ealej",
    firstName: "Krstn\xe9 meno",
    lastName: "Priezvisko",
    emptyNameError: "Pros\xedm, uve\u010Fte meno",
    email: "Va\u0161a e-mailov\xe1 adresa CBRE",
    emptyEmailError: "Zadajte e-mail CBRE",
    emailTakenError: "T\xe1to e-mailov\xe1 adresa je u\u017E prepojen\xe1 s {{takenLink}}",
    emailExample: "ex: jane.smith@cbre.com",
    editReferralInfo: "Upravte zadan\xe9 meno a e-mailov\xe9 inform\xe1cie",
    noLaterChanges: "Nesk\xf4r to u\u017E nebudete m\xf4c\u0165 upravova\u0165.",
    somethingWrong: "Ups, na na\u0161ej strane nastala chyba. Sk\xfaste to, pros\xedm, nesk\xf4r.",
    contentLoading: "Obsah sa na\u010D\xedtava",
    linkReady: "V\xe1\u0161 odkaz je pripraven\xfd",
    storeLinkInstructions: "Ulo\u017Ete si tento odkaz na bezpe\u010Dn\xe9 miesto. Odkaz m\xf4\u017Eete pou\u017E\xedva\u0165 pri ka\u017Edom zdie\u013Ean\xed aplik\xe1cie Spacer klientom. K\xf3piu tohto odkazu sme tie\u017E poslali e-mailom na adresu, ktor\xfa ste uviedli.",
    yourLink: "V\xe1s referen\u010Dn\xfd odkaz",
    copyLink: "Kop\xedrova\u0165 referen\u010Dn\xfd odkaz",
    copiedLink: "Skop\xedrovan\xe9 do schr\xe1nky",
    linkNeverExpires: "Pripomienka: Platnos\u0165 tohto odkazu nikdy nevypr\u0161\xed.",
    linkFound: "Na\u0161li sme v\xe1\u0161 odkaz",
    emailNotAssociated: "Nena\u0161li sme referen\u010Dn\xfd odkaz spojen\xfd s touto e-mailovou adresou.",
    createLink: "Chcete vytvori\u0165 nov\xfd?"
};


var $365e600af8b73d91$exports = {};
$365e600af8b73d91$exports = {
    blogHomeTitle: "Poh\u013Ead do pl\xe1novania kancel\xe1rie",
    // blog tags
    blogTagAllArticles: "V\u0161etk\xfd \u010Dl\xe1nky",
    blogTagSizeAndFit: "Ve\u013Ekos\u0165 a prisp\xf4sobenie",
    blogTagOfficeCulture: "Kult\xfara pracoviska",
    blogTagSpaceAndDesign: "Kancel\xe1rska kult\xfara",
    blogTagWorkplaceTrends: "Workplace trendy"
};


var $b4d2b7fdb3caac06$exports = {};
$b4d2b7fdb3caac06$exports = {
    // LandingPageHero
    landingPageHeroTitle: "Pomo\u017Cemy Ci zaplanowa\u0107 miejsce pracy przysz\u0142o\u015Bci i znale\u017A\u0107 odpowiedni\u0105 powierzchni\u0119 na Twoje nowe biuro.",
    landingPageHeroSubtitle: "Niedawna pandemia sprawi\u0142a, \u017Ce miejsca pracy zmieniaj\u0105 si\u0119 \u2013 skorzystaj z naszego nieodp\u0142atnego narz\u0119dzia i wygeneruj zalecenia dopasowane do Twoich potrzeb w zakresie planowania przestrzeni biurowej.",
    landingPageHeroImgAlt: "Podgl\u0105d wynik\xf3w kwestionariusza dotycz\u0105cego projektu przestrzeni znajduj\u0105cego si\u0119 na stronie g\u0142\xf3wnej aplikacji CBRE Spacer",
    landingPageImage: "/png/homepage-results-page-in-browser-spacer-by-cbre.png",
    // LandingPageContent
    landingPageContentTitle: "Jak to dzia\u0142a",
    // StepsSummary
    stepsSummarySubtitle1: "Krok 1 \u2014",
    stepsSummaryTitle1: "Opowiedz nam o swojej organizacji",
    stepsSummaryText1: "Pom\xf3\u017C nam pozna\u0107 cele i zadania Twojej organizacji, tak aby\u015Bmy mogli przedstawi\u0107 Ci dostosowane do Twoich potrzeb zalecenia.",
    stepsSummaryImgAlt1: "Grafika przedstawiaj\u0105ca ludzi stoj\u0105cych na ogromnym laptopie znajduj\u0105ca si\u0119 na stronie g\u0142\xf3wnej aplikacji CBRE Spacer",
    stepsSummarySubtitle2: "Krok 2 \u2014",
    stepsSummaryTitle2: "Przejd\u017A do wynik\xf3w",
    stepsSummaryText2: "Na podstawie udzielonych odpowiedzi otrzymasz zalecenia co do wielko\u015Bci potrzebnego Ci biura wraz z liczbowym wyszczeg\xf3lnieniem poszczeg\xf3lnych rodzaj\xf3w powierzchni, kt\xf3re powinny znale\u017A\u0107 si\u0119 w Twojej przestrzeni biurowej. B\u0119dziesz mie\u0107 r\xf3wnie\u017C mo\u017Cliwo\u015B\u0107 przyjrzenia si\u0119 przyk\u0142adowym rzutom Twojego biura.",
    stepsSummaryImgAlt2: "Grafika przedstawiaj\u0105ca miejsk\u0105 dzielnic\u0119 znajduj\u0105ca si\u0119 na stronie g\u0142\xf3wnej aplikacji CBRE Spacer",
    stepsSummarySubtitle3: "Krok 3 \u2014",
    stepsSummaryTitle3: "Znajd\u017A swoje idealne biuro",
    stepsSummaryText3: "Zapisz swoje wyniki, tak aby m\xf3c wr\xf3ci\u0107 do nich podczas poszukiwa\u0144 biura, lub skontaktuj si\u0119 z zespo\u0142em Spacer i porozmawiaj z jednym z naszych ekspert\xf3w ds. najmu, kt\xf3ry wesprze Ci\u0119 w procesie poszukiwania Twojego idealnego biura.",
    stepsSummaryImgAlt3: "Grafika przedstawiaj\u0105ca kobiet\u0119 pracuj\u0105c\u0105 przy biurku znajduj\u0105ca si\u0119 na stronie g\u0142\xf3wnej aplikacji CBRE Spacer",
    // LandingPageSecondaryHero
    landingPageSecondaryHeroImgAlt: "Grafika przedstawiaj\u0105ca ludzi tworz\u0105cych zalecenia co do przestrzeni biurowej znajduj\u0105ca si\u0119 na stronie g\u0142\xf3wnej aplikacji CBRE Spacer",
    landingPageSecondaryHeroTitle: "Opowiedz nam troch\u0119 o swojej organizacji. A my powiemy Ci, jak du\u017Cej powierzchni biurowej potrzebujesz."
};


var $bdae1622ec799987$exports = {};
$bdae1622ec799987$exports = {
    // Navbar
    spacerLogoAlt: "Aplikacja CBRE Spacer",
    linkToAboutPageText: "Wi\u0119cej o aplikacji Spacer",
    linkToBlogPageText: "Aktualno\u015Bci",
    referrals: "Polecenia",
    // TakeOfficeSpaceQuizButton
    sizeMyOfficeButtonDefaultLinkText: "Wype\u0142nij kwestionariusz",
    flooredPlanRequestLinkText: "Wygeneruj Projekt",
    // Footer
    footerCBRELogoAlt: "Logo CBRE dla aplikacji CBRE Spacer",
    footerFacebookIconAlt: "Ikona Facebook\u2122 dla aplikacji CBRE Spacer",
    footerTwitterIconAlt: "Ikona Twitter\u2122 dla aplikacji CBRE Spacer",
    footerLinkedinIconAlt: "Ikona Linkedin\u2122 dla aplikacji CBRE Spacer",
    footerLinkedinLink: "https://www.linkedin.com/showcase/cbre-workplace-strategy/",
    footerHeaderQuestionsText: "Masz jakie\u015B pytania?",
    footerHeaderAboutText: "Materia\u0142y",
    footerHeaderMoreText: "Dodatkowe informacje",
    footerHeaderBrokersText: "Dla agent\xf3w",
    footerLinkWhatIsSpacerText: "Informacje o aplikacji Spacer",
    footerLinkBlogText: "Aktualno\u015Bci",
    footerLinkWorkplaceText: "Zesp\xf3\u0142 CBRE Workplace?",
    footerLinkTermsText: "Regulamin",
    footerLinkPrivacyText: "Polityka prywatno\u015Bci",
    footerLinkReferralText: "Polecenia",
    footerWorkplaceLink: "http://www.cbre.us/real-estate-services/occupier/workplace",
    footerPrivacyLink: "https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy",
    // Contact (contact.js)
    spacerSupportEmail: "spacersupport@cbre.com",
    // ErrorPage
    errorOopsText: "Ups!",
    error404Text: "Nie mo\u017Cemy znale\u017A\u0107 strony, kt\xf3rej szukasz.",
    error500Text: "Co\u015B posz\u0142o nie tak po naszej stronie.",
    errorText: "B\u0142\u0105d",
    errorReturnText: "Wr\xf3\u0107 do aplikacji Spacer",
    errorAltText: "Grafika przedstawiaj\u0105ca rozlan\u0105 kaw\u0119 dla aplikacji CBRE Spacer",
    // Measurement Units (units.js)
    SF: "ft\xb2",
    SM: "m\xb2",
    USF: "ft\xb2 PU",
    USM: "m\xb2 PU",
    RSF: "ft\xb2 PN",
    RSM: "m\xb2 PN",
    NSF: "powierzchnia netto (ft\xb2)",
    NSM: "powierzchnia netto (m\xb2)",
    NIA: "PWN",
    foot: "stopa",
    feet: "ft\xb2",
    footage: "powierzchnia",
    "sqft.": "stopa kwadratowa",
    meter: "metr",
    meters: "m\xb2",
    "sqm.": "m kw.",
    Tsubo: "tsubo",
    // SF Types Adjectives (calculator.js)
    Usable: "Powierzchnia U\u017Cytkowa",
    Rentable: "Powierzchnia Najmu",
    Net: "Netto",
    // Page Titles (documentDataCopy.js)
    landingPageTitle: "Zaplanuj swoje idealne biuro w zaledwie 15 minut \u2013 aplikacja CBRE Spacer",
    aboutPageTitle: "Dowiedz si\u0119, jak dzia\u0142a nasze narz\u0119dzie, kt\xf3re pozwoli Ci na obliczenie, jak du\u017Cej powierzchni biura potrzebujesz \u2013 aplikacja CBRE Spacer",
    termsPageTitle: "Regulamin \u2013 aplikacja CBRE Spacer",
    quizPageTitle: "Okre\u015Bl wymiary swojego biura w zaledwie 15 minut \u2013 aplikacja CBRE Spacer",
    resultsPageTitle: "Pobierz zalecenia co do typu i wielko\u015Bci przestrzeni biurowej dostosowanej do Twoich potrzeb \u2013 aplikacja CBRE Spacer",
    profileComparisonPageTitle: "Por\xf3wnaj swoje potrzeby w zakresie przestrzeni biurowej \u2013 aplikacja CBRE Spacer",
    blogHomePageTitle: "Aktualno\u015Bci z obszaru planowania przestrzeni biurowej \u2013 aplikacja CBRE Spacer",
    referralPageTitle: "Link polecaj\u0105cy dla agent\xf3w CBRE \u2013 aplikacja CBRE Spacer",
    referralRetrievePageTitle: "Pobierz link polecaj\u0105cy dla agent\xf3w CBRE \u2013 aplikacja CBRE Spacer",
    // Meta Tags (documentDataCopy.js)
    landingPageMetaTagText: "Planujesz swoje nowe biuro? Aplikacja CBRE Spacer pomo\u017Ce Ci szybko i \u0142atwo okre\u015Bli\u0107 wielko\u015B\u0107 powierzchni biurowej niezb\u0119dn\u0105 do realizacji Twoich cel\xf3w biznesowych. To zajmie tylko 15 minut!",
    aboutPageMetaTagText: "Biuro odpowiedniej wielko\u015Bci mo\u017Ce pom\xf3c Ci przyci\u0105gn\u0105\u0107 talenty, obni\u017Cy\u0107 koszty, a nawet sprawi\u0107, \u017Ce Twoi pracownicy b\u0119d\u0105 cieszy\u0107 si\u0119 dobrym zdrowiem. Sprawd\u017A, jak dzi\u0119ki aplikacji Spacer mo\u017Cesz szybko i sprawnie uzyska\u0107 zalecenia co do wielko\u015Bci biura, kt\xf3ra umo\u017Cliwi Ci realizacj\u0119 cel\xf3w Twojej organizacji.",
    termsPageMetaTagText: "Aplikacja CBRE Spacer powsta\u0142a w oparciu o wiedz\u0119 bran\u017Cow\u0105 i ponad dziesi\u0119cioletnie do\u015Bwiadczenie rynkowe, w efekcie czego w ci\u0105gu zaledwie kilku minut mo\u017Cliwe jest wygenerowanie rzetelnych zalece\u0144 w zakresie wymaganej wielko\u015Bci biura.",
    quizPageMetaTagText: "Wype\u0142nij 15-minutowy kwestionariusz aplikacji Spacer i dowiedz si\u0119, jak du\u017Cej powierzchni biurowej potrzebujesz, aby skutecznie wspiera\u0107 cele i priorytety Twojej organizacji. To najszybsze na rynku oprogramowanie oferuj\u0105ce spersonalizowane us\u0142ugi.",
    resultsPageMetaTagText: "Dostosowane do Twoich potrzeb zalecenia dotycz\u0105ce przestrzeni biurowej wygenerowane przez aplikacj\u0119 Spacer to ogromna oszcz\u0119dno\u015B\u0107 czasu po\u015Bwi\u0119conego na poszukiwania odpowiedniego biura \u2013 dzi\u0119ki niej dowiesz si\u0119 dok\u0142adnie, jak du\u017Cego biura potrzebuje Twoja organizacja i jaki rodzaj mebli b\u0119dzie dla Ciebie najodpowiedniejszy, a tak\u017Ce uzyskasz rzuty zalecanej powierzchni.",
    profileComparisonPageMetaTagText: "Dowiedz si\u0119, jak Twoje indywidualne potrzeby biurowe prezentuj\u0105 si\u0119 na tle wymaga\u0144 okre\u015Blonych przez innych u\u017Cytkownik\xf3w aplikacji CBRE Spacer",
    blogHomePageMetaTagText: "Wyliczenie, jak du\u017Cej powierzchni biurowej potrzebuje dana organizacja, nie jest wy\u017Csz\u0105 matematyk\u0105, jednak\u017Ce informacje i materia\u0142y zwi\u0105zane z planowaniem biura udost\u0119pniane w ramach aplikacji Spacer mog\u0105 okaza\u0107 si\u0119 naprawd\u0119 pomocne. Aby dowiedzie\u0107 si\u0119 wi\u0119cej, kliknij tutaj.",
    referralPageMetaTagText: "U\u017Cyj linku polecaj\u0105cego, aby udost\u0119pni\u0107 aplikacj\u0119 Spacer klientom. Uzyskasz w ten spos\xf3b pewno\u015B\u0107, \u017Ce wyniki wype\u0142nionego przez nich kwestionariusza dotycz\u0105cego projektu przestrzeni zostan\u0105 wys\u0142ane bezpo\u015Brednio na Tw\xf3j adres e-mail. Aby dowiedzie\u0107 si\u0119 wi\u0119cej, kliknij tutaj.",
    referralRetrieveMetaTagText: "Pobierz sw\xf3j link polecaj\u0105cy do aplikacji CBRE Spacer.",
    // Form title
    formLabel: "Twoje dane"
};


var $d987930d6e19f88e$exports = {};
$d987930d6e19f88e$exports = {
    // Results
    resultsWarningMessage: "Czy na pewno chcesz opu\u015Bci\u0107 t\u0119 stron\u0119? W ten spos\xf3b mo\u017Cesz utraci\u0107 niezapisane dane.",
    // ResultsHeader
    resultsHeaderExportPDFButtonText: "Eksportuj PDF",
    resultsHeaderSendButtonText: "Prze\u015Blij podsumowanie odpowiedzi",
    resultsHeaderClipboardBoxDescription: "Ka\u017Cdy u\u017Cytkownik, dla kt\xf3rego zosta\u0142 wygenerowany link, ma mo\u017Cliwo\u015B\u0107 przegl\u0105dania i wprowadzania zmian w odpowiedziach",
    resultsHeaderContactButtonText: "Nawi\u0105\u017C kontakt z doradc\u0105",
    // EmailWallSection
    emailWallTitle: "To jeszcze nie wszystko! Mamy dla Ciebie wi\u0119cej informacji",
    emailWallSubtitle: "Wprowad\u017A poni\u017Cej swoje imi\u0119 i nazwisko oraz adres e-mail, aby wy\u015Bwietli\u0107 pe\u0142ne zalecenia dotycz\u0105ce Twojej przestrzeni biurowej i dostosowa\u0107 wyniki do Twoich potrzeb.",
    emailWallFirstNamePlaceholder: "Imi\u0119",
    emailWallLastNamePlaceholder: "Nazwisko",
    emailWallEmailPlaceholder: "Tw\xf3j adres e-mail",
    emailWallCBREEmailPlaceholder: "Adres e-mail przypisany Twojemu doradcy w CBRE (opcjonalnie)",
    emailWallLeasingProfessionalPlaceholder: "Tw\xf3j doradca w CBRE ds. najmu",
    emailWallConnectMeText: "Chc\u0119 nawi\u0105za\u0107 kontakt z osobistym doradc\u0105 ds. nieruchomo\u015Bci. \u017Badnych e-biuletyn\xf3w ani spamu, obiecujemy!",
    emailWallContactNoticeText: "Zesp\xf3\u0142 Spacer mo\u017Ce si\u0119 z Tob\u0105 skontaktowa\u0107, aby umo\u017Cliwi\u0107 Ci korzystanie z Twojego programu projektowego w jak najpe\u0142niejszym zakresie. Bez spamu, obiecujemy!",
    emailWallResultsButtonText: "Podgl\u0105d podsumowania odpowiedzi",
    emailWallImgAltText: "Podgl\u0105d wynik\xf3w kwestionariusza dotycz\u0105cego projektu przestrzeni wygenerowanych w aplikacji CBRE Spacer i przes\u0142anych za po\u015Brednictwem poczty elektronicznej",
    emailWallFirstNameInvalid: "Prosz\u0119 wprowadzi\u0107 swoje imi\u0119.",
    emailWallLastNameInvalid: "Prosz\u0119 wprowadzi\u0107 swoje nazwisko.",
    emailWallEmailInvalid: "Prosz\u0119 wprowadzi\u0107 aktualny adres e-mail.",
    // CopyToClipboardBox
    clipboardBoxCopyText: "Kopiuj",
    clipboardBoxCopiedText: "Skopiowane",
    // FormModal
    formModalFindSpaceHeader: "Rozpocznij wyszukiwanie przestrzeni biurowej",
    formModalFindSpaceBody: "Aplikacja Spacer to szybkie i \u0142atwe w obs\u0142udze narz\u0119dzie stworzone do analizy potrzeb w zakresie \u015Brodowiska pracy, je\u017Celi jednak poszukujesz bardziej spersonalizowanej us\u0142ugi, skorzystaj z pomocy zespo\u0142u CBRE Workplace. Wype\u0142nij niniejszy formularz, a jeden z naszych ekspert\xf3w skontaktuje si\u0119 z Tob\u0105 w przeci\u0105gu 48 godzin, aby um\xf3wi\u0107 si\u0119 na rozmow\u0119.",
    formModalFindSpaceSuccessMessage: "Twoja pro\u015Bba zosta\u0142a wys\u0142ana.",
    // SuccessModal
    successModalTitle: "Uda\u0142o si\u0119!",
    // ContactForm
    contactFormFirstNameLabel: "Imi\u0119",
    contactFormLastNameLabel: "Nazwisko",
    contactFormEmailLabel: "S\u0142u\u017Cbowy adres e-mail",
    contactFormPhoneLabel: "Numer telefonu",
    contactFormMessageLabel: "Opowiedz nam troch\u0119 wi\u0119cej o przestrzeni, kt\xf3rej szukasz",
    contactFormSubmitText: "Zatwierd\u017A",
    // AcceptTermsText
    acceptTermsText: "Akceptuj\u0119 <1>Regulamin</1>. Aby uzyska\u0107 wi\u0119cej informacji na temat sposobu wykorzystywania Twoich danych, zapoznaj si\u0119 z <3>Polityk\u0105 prywatno\u015Bci CBRE</3>.",
    privacyPolicyLink: "https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy",
    // Form
    formErrorText: "Ups, nie uda\u0142o si\u0119. Prosz\u0119 spr\xf3bowa\u0107 ponownie!",
    formEmailInvalid: "Prosz\u0119 wprowadzi\u0107 aktualny adres e-mail.",
    // FormInput
    formInputOptionalText: " (opcjonalnie)",
    // LegalForm
    legalFormCheckboxText: "Wyra\u017Cam zgod\u0119 na kontakt ze strony CBRE w sprawie ofert i informacji zwi\u0105zanych z korzystaniem przeze mnie z aplikacji Spacer.",
    legalFormContactWarningText: "Zesp\xf3\u0142 Spacer mo\u017Ce si\u0119 z Tob\u0105 skontaktowa\u0107, aby umo\u017Cliwi\u0107 Ci korzystanie z Twojego programu projektowego w jak najpe\u0142niejszym zakresie. Bez spamu, obiecujemy!",
    // NextStepsSection
    nextStepsSectionSubtitle: "Gotowy na kolejny krok?",
    nextStepsSectionTitle: "Znajd\u017A idealne biuro.",
    nextStepsSectionButtonText: "Nawi\u0105\u017C kontakt z doradc\u0105",
    nextStepsSectionImgAlt: "Grafika przedstawiaj\u0105ca rozmawiaj\u0105cych ze sob\u0105 ludzi znajduj\u0105ca si\u0119 na stronie Informacje o aplikacji CBRE Spacer",
    // Profile
    resultsProfileSummaryTitle: "Twoje biuro",
    resultsProfileTooltipText: "Ka\u017Cdy profil generowany jest w oparciu o dane pochodz\u0105ce z prawdziwych i funkcjonuj\u0105cych na rynku organizacji i miejsc pracy. Zosta\u0142y one zweryfikowane zgodnie z obowi\u0105zuj\u0105cymi dla naszej bran\u017Cy wytycznymi i unikaln\u0105 wiedz\u0105 rynkow\u0105 zespo\u0142u CBRE Workplace.",
    // Program
    programSaveConfirmationBoxText: "Gotowe. Wys\u0142ali\u015Bmy link do Twoich wynik\xf3w. Mi\u0142ej lektury!",
    programExamplePlansTitle: "Przyk\u0142adowe rzuty",
    programExamplePlansSubtitle: "Przegl\u0105daj interaktywne rzuty powierzchni, kt\xf3re pasuj\u0105 do Twojego profilu. Mo\u017Cesz je te\u017C przegl\u0105da\u0107 w wersji 3D!",
    programTooMuchTinkerWarning: "Zwolnij! Wygl\u0105da na to, \u017Ce wyszed\u0142e\u015B poza wyliczone w oparciu o Tw\xf3j profil wielko\u015Bci. Rozwa\u017C <1>ponowne wype\u0142nienie kwestionariusza</1> lub skontaktuj si\u0119 z dzia\u0142em obs\u0142ugi klienta pod adresem <3>{{email}}</3>.",
    programDisclaimer: "Aplikacja CBRE Spacer jest udost\u0119pniana u\u017Cytkownikom na zasadzie \u201Etak jak jest\u201D i \u201Ew miar\u0119 dost\u0119pno\u015Bci\u201D bez udzielania \u017Cadnych gwarancji. Wszelkie zalecenia wygenerowane w wyniku skorzystania z aplikacji Spacer maj\u0105 charakter wy\u0142\u0105cznie pogl\u0105dowy i nie stanowi\u0105 faktycznych zalece\u0144 dotycz\u0105cych powierzchni lub warunk\xf3w najmu. Rzeczywiste zalecenia dotycz\u0105ce powierzchni mog\u0105 si\u0119 znacznie r\xf3\u017Cni\u0107, jako \u017Ce zale\u017Ce\u0107 b\u0119d\u0105 od wielu czynnik\xf3w, kt\xf3rych aplikacja Spacer mo\u017Ce nie uwzgl\u0119dnia\u0107. Korzystanie z aplikacji Spacer i wykorzystanie jakiegokolwiek zestawienia wygenerowanego przy jej u\u017Cyciu oznacza akceptacj\u0119 naszego Regulaminu oraz Polityki Prywatno\u015Bci, kt\xf3re znajduj\u0105 si\u0119 odpowiednio pod: https://workplace.cbre.com/termsOfService i https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy. \xa9 2018 CBRE, Inc. Wszelkie prawa zastrze\u017Cone.",
    programMetricsTitle: "Parametry Projektu",
    programMetricsSubtitle: "Przedstawione liczby s\u0105 parametrami wyliczonymi dla Twojego \u015Brodowiska pracy",
    programDetailsSectionTitle: "Spersonalizuj Sw\xf3j Projekt",
    programDetailsSectionSubtitle: "Dostosuj poni\u017Csze pola, aby dok\u0142adnie okre\u015Bli\u0107 swoje potrzeby w zakresie powierzchni biurowej.",
    programRevertButtonText: "Przywr\xf3\u0107",
    programSaveButtonText: "Zapisz zmiany",
    programSavedButtonText: "Zapisano",
    // ProgramAssumptions
    programAssumptionsRecommendedOfficeSizeText: "Zalecana Wielko\u015B\u0107 Biura",
    programAssumptionsProfileText: "Profil",
    programAssumptionsHeadcountText: "Liczba pracownik\xf3w",
    programAssumptionsHeadcountFollowingText: "os\xf3b",
    programAssumptionsCollabText: "Przestrze\u0144 do pracy zespo\u0142owej",
    programAssumptionsCirculationText: "Przestrze\u0144 komunikacyjna",
    programAssumptionsAvgDaysText: "\u015Arednia liczba dni w biurze",
    programAssumptionsAvgDaysFollowingText: "tygodniowo",
    programAssumptionsAvgDaysPerWeekText: "\u015Arednia liczba dni w biurze tygodniowo",
    // ProgramHeroForPrint
    printNIAText: "Powierzchnia wewn\u0119trzna netto",
    printUSFText: "Powierzchnia u\u017Cytkowa w metrach kwadratowych",
    printRSFText: "Powierzchnia najmu w metrach kwadratowych",
    printDescText: "W oparciu o podane przez Ciebie informacje i {{lossFactorPercentage}}% {{factorType}} w {{city}}, zalecamy powierzchni\u0119 o \u0142\u0105cznej wielko\u015Bci \u2013 \u2026",
    printFitFactorText: "wsp\xf3\u0142czynnik dopasowania",
    printLossFactorText: "wsp\xf3\u0142czynnik strat",
    // BarChart
    barChartIndivSubtitle: "Strefa pracy indywidualnej",
    barChartGroupSubtitle: "Strefa pracy zespo\u0142owej",
    barChartAmenitySubtitle: "Strefa udogodnie\u0144 socjalnych",
    // TabbedProgramBarChart
    tabbedBarChartMeSubtitle: "Praca indywidualna",
    tabbedBarChartGroupSubtitle: "Praca zespo\u0142owa",
    tabbedBarChartAmenitySubtitle: "Udogodnienia socjalne",
    // SpaceCategoryBreakdown
    spaceCatBreakdownSubtitle: "Wybierz stref\u0119, kt\xf3r\u0105 chcesz spersonalizowa\u0107",
    // SpaceCategoryBreakdownMobile
    spaceCatBreakdownMobileMeTitle: "Strefa pracy indywidualnej",
    spaceCatBreakdownMobileWeTitle: "Strefa pracy zespo\u0142owej",
    spaceCatBreakdownMobileAmenityTitle: "Strefa udogodnie\u0144 socjalnych",
    spaceCatBreakdownMobileMeSubtitle: "do pracy indywidualnej",
    spaceCatBreakdownMobileWeSubtitle: "do pracy zespo\u0142owej",
    spaceCatBreakdownMobileAmenitySubtitle: "do wszystkiego innego",
    spaceCatBreakdownMobileNIATotalTitle: "Ca\u0142kowita powierzchnia wewn\u0119trzna netto",
    spaceCatBreakdownMobileTotalTitle: "Ca\u0142kowita {{sfType}} w {{unitCapitalized}} wynosi",
    spaceCatBreakdownMobileCirculationText: "Przestrze\u0144 komunikacyjna",
    // SpaceCategoryDropdown
    spaceCatDropdownMeText: "Strefa pracy indywidualnej",
    spaceCatDropdownWeText: "Strefa pracy zespo\u0142owej",
    spaceCatDropdownAmenityText: "Strefa udogodnie\u0144 socjalnych",
    // SidebarInfo
    sidebarInfoMeTitle: "Praca indywidualna",
    sidebarInfoWeTitle: "Praca zespo\u0142owa",
    sidebarInfoAmenityTitle: "Udogodnienia socjalne",
    // Space Category Descriptions (spaceCategoryDescription.js)
    spaceCatMeDesc: "Przestrze\u0144 do pracy indywidualnej. Zapewnienie pracownikom mo\u017Cliwo\u015Bci wyboru miejsca i sposobu pracy zwi\u0119ksza poziom ich zadowolenia.",
    spaceCatWeDesc: "Przestrze\u0144 do wsp\xf3\u0142pracy i pracy zespo\u0142owej. W czasach, kiedy pracowa\u0107 mo\u017Cna z dowolnego miejsca, wa\u017Cne jest, aby zapewni\u0107 pracownikom zr\xf3\u017Cnicowan\u0105 przestrze\u0144 do wykonywania r\xf3\u017Cnych zada\u0144.",
    spaceCatAmenityDesc: "Przestrze\u0144 wspomagaj\u0105ca prac\u0119. Odpowiednie udogodnienia socjalne sprawi\u0105, \u017Ce Twoje biuro b\u0119dzie miejscem, w kt\xf3rym czas b\u0119d\u0105 chcieli sp\u0119dza\u0107 zar\xf3wno Twoi pracownicy, jak i kandydaci do pracy w Twojej organizacji.",
    // Suggested Custom Amenities (suggestedCustomAmenityUnitMap.js)
    audioVisualCustom: "Audio / Wizualne",
    dataCenterCustom: "Centrum danych",
    buildingSupportCustom: "Obs\u0142uga techniczna budynku",
    foodServiceCustom: "Restauracja",
    kitchenCustom: "Kuchnia",
    serveryCustom: "Lada wydawcza",
    execDiningCustom: "Jadalnia dla kadry kierowniczej",
    grabNGoCustom: "Grab-N-Go",
    juiceCoffeeBarCustom: "Bar z sokami / Kawiarnia",
    childCareCustom: "Przedszkole",
    fitnessCenterCustom: "Centrum fitness",
    healthCenterCustom: "Przychodnia",
    mailCenterCustom: "Sortownia poczty",
    commercialPrintCustom: "Punkt \u015Bwiadcz\u0105cy us\u0142ugi poligraficzne",
    centralCafeCustom: "G\u0142\xf3wna kafeteria",
    securityCtrlCustom: "Pomieszczenie sterowania systemem bezpiecze\u0144stwa i ochrony budynku",
    auditoriumCustom: "Aula",
    dryCleaningLaundryCustom: "Pralnia chemiczna / Pralnia",
    confCenterCustom: "Centrum konferencyjne",
    multiPurpTrainingCustom: "Pomieszczenie wielofunkcyjne / Sala szkoleniowa",
    informalCollabCustom: "Strefa wsp\xf3\u0142pracy nieformalnej",
    touchdownTeamCustom: "Strefa spotka\u0144 / pracy zespo\u0142owej",
    // Suggested Custom Amenity Units (spaceUnit.js)
    seats: "miejsce",
    seats_plural: "miejsce",
    rooms: "pomieszczenie",
    rooms_plural: "pomieszczenie",
    areas: "strefa",
    areas_plural: "strefa",
    units: "jednostka miary",
    units_plural: "jednostki",
    // Predefined Amenities (spaceUnitMap.js) - Shared Space Units
    focusRoomDefined: "Focus room / Sala do pracy w ciszy i skupieniu",
    fileRoomDefined: "Archiwum",
    centralReceptionHubDefined: "G\u0142\xf3wna recepcja",
    smOfficeDefined: "Ma\u0142y gabinet",
    regOfficeDefined: "Standardowy gabinet",
    benchDesk5Defined: "Biurko o d\u0142ugo\u015Bci 60 cali",
    benchDesk6Defined: "Biurko o d\u0142ugo\u015Bci 72 cali",
    meetingRoom4Defined: "Sala konferencyjna (4 os.)",
    meetingRoom6Defined: "Sala konferencyjna (6 os.)",
    meetingRoom8Defined: "Sala konferencyjna (8 os.)",
    meetingRoom12Defined: "Sala konferencyjna (12 os.)",
    meetingRoom15Defined: "Sala konferencyjna (15 os.)",
    semiEnclosedMeetingBooth4Defined: "P\xf3\u0142zamkni\u0119ta kabina do spotka\u0144 (4 os.)",
    openCollabSpace4to6Defined: "Otwarta przestrze\u0144 do pracy zespo\u0142owej (4-6 os.)",
    contemplationSpaceDefined: "Pok\xf3j wycisze\u0144",
    mainITEquipRoomDefined: "G\u0142\xf3wna serwerownia / Pomieszczenie technologiczne",
    receptionAreaDefined: "Strefa Recepcji",
    cafeFoodServiceDefined: "Kafeteria / Kantyna",
    teamStorageDefined: "Magazynek dla zespo\u0142u",
    coatClosetsDefined: "Szafy na ubrania",
    genStorageDefined: "Magazyn og\xf3lny",
    centralisedCopyPrintMailDefined: "G\u0142\xf3wna strefa ze sprz\u0119tem ksero, drukarkami i sortowni\u0105 poczty",
    specialResourceAreaDefined: "Strefa zasob\xf3w specjalnych",
    personalStorageDefined: "Szafki pracownicze (lockers)",
    storageITSpaceDefined: "Magazyn IT",
    secondaryServerRoomDefined: "Zapasowa serwerownia / pomieszczenie telekomunikacyjne",
    mothersRoomDefined: "Pok\xf3j matki z dzieckiem",
    buildITSpaceDefined: "Pomieszczenie mieszcz\u0105ce sprz\u0119t IT",
    workerCouncilOffice2Defined: "Biuro rady pracownik\xf3w (2 os.)",
    securityCtrlRoomDefined: "Dy\u017Curka ochrony",
    centralisedMailDefined: "G\u0142\xf3wna sortownia poczty",
    visitorCoatLuggageRoomDefined: "Szafy dla go\u015Bci",
    wellnessRoomDefined: "Pok\xf3j wellness",
    internalStairDefined: "Schody wewn\u0119trzne",
    commercialPrintRoomDefined: "Punkt \u015Bwiadcz\u0105cy us\u0142ugi ksero",
    buildingSupportServicesAreaDefined: "Strefa obs\u0142ugi technicznej budynku",
    // Predefined Amenities (spaceUnitMap.js) - US_SMALL and US_REGULAR
    officeDefined: "Gabinet",
    lgOfficeDefined: "Gabinet (du\u017Cy)",
    smWorkstationDefined: "Stanowisko pracy (ma\u0142e)",
    mdWorkstationDefined: "Stanowisko pracy (\u015Brednie)",
    lgWorkstationDefined: "Stanowisko pracy (du\u017Ce)",
    huddleRoomDefined: "Salka do spotka\u0144 ad hoc",
    dispersedCopyPrintAreaDefined: "Jedna z przestrzeni ze sprz\u0119tem ksero / drukarkami",
    smMeetingRoomDefined: "Ma\u0142a sala konferencyjna",
    mdMeetingRoomDefined: "\u015Arednia sala konferencyjna",
    lgMeetingRoomDefined: "Du\u017Ca sala konferencyjna",
    xlMeetingRoomDefined: "Bardzo du\u017Ca sala konferencyjna / Sala posiedze\u0144",
    multiPurpTrainingDefined: "Pomieszczenie wielofunkcyjne / Sala szkoleniowa",
    informalCollabDefined: "Strefa wsp\xf3\u0142pracy nieformalnej",
    touchdownTeamDefined: "Strefa spotka\u0144 / pracy zespo\u0142owej",
    pantryVendingCoffeeAreaDefined: "Automaty z przek\u0105skami i napojami / K\u0105cik kawowy",
    workplaceStorageRoomDefined: "Pomieszczenie magazynowe",
    employeeCoatAreaDefined: "Garderoba pracownik\xf3w",
    dispersedMailAreaDefined: "Strefa odbioru poczty",
    lockerUnitDefined: "Szafki pracownicze (lockers)",
    serverRoomDefined: "Serwerownia",
    frontDeskAreaDefined: "Strefa recepcyjna",
    centralCafeAreaDefined: "G\u0142\xf3wna kafeteria",
    mailCenterAreaDefined: "Sortownia poczty",
    kitchenAreaDefined: "Strefa kuchenna",
    drawerLateralFileUnitDefined: "Szafa kartotekowa z 3 szufladami na dokumenty uk\u0142adane poziomo",
    serveryAreaDefined: "Lada wydawcza",
    juiceBarCoffeeShopAreaDefined: "Bar z sokami / Kawiarnia",
    diningSupportAreaDefined: "Strefa przygotowywania posi\u0142k\xf3w",
    diningAreaDefined: "Strefa jadalna",
    grabNGoAreaDefined: "Strefa Grab-N-Go",
    focusRoomSharedFocus: "Focus room / Sala do pracy w ciszy i skupieniu",
    // Predefined Amenities (spaceUnitMap.js) - UK_REGULAR
    fullFoodServiceDefined: "Restauracja",
    // Predefined Amenities (spaceUnitMap.js) - APAC_REGULAR
    officeWorkMeetDefined: "Biuro (praca/spotkania)",
    lgOfficeWorkMeetDefined: "Du\u017Ce biuro (praca/spotkania)",
    focusDefined: "Praca w ciszy i skupieniu",
    bench1pt6Defined: "Biurko o d\u0142ugo\u015Bci 1,6 m",
    bench1pt8Defined: "Biurko o d\u0142ugo\u015Bci 1,8 m",
    bench1pt8LDefined: "Stanowisko pracy o d\u0142ugo\u015Bci 1,8 m (rozmiar L)",
    banquetWorkMeetDefined: "St\xf3\u0142 / Sala spotka\u0144 (2os)",
    cafeTable4Defined: "Stolik kawowy (4 os.)",
    kitchenTable8to10Defined: "St\xf3\u0142 kuchenny (8-10 os.)",
    standingWhiteboardDefined: "Bia\u0142a tablica stoj\u0105ca (whiteboard)",
    huddleRoom3Defined: "Salka konferencyjna (3 os.)",
    smMeetingRoom5Defined: "Ma\u0142a sala konferencyjna (5 os.)",
    mdMeetingRoom8Defined: "\u015Arednia sala konferencyjna (8 os.)",
    lgMeetingRoom20Defined: "Du\u017Ca sala konferencyjna (20 os.)",
    xlBoardroom: "Bardzo du\u017Ca sala konferencyjna / Sala posiedze\u0144",
    wellnessRoomsDefined: "Pokoje wellness",
    employeeCoatsGymLockersDefined: "P\u0142aszcze pracownicze / Szafki na akcesoria gimnastyczne",
    lockersDefined: "Szafki pracownicze (lockersy)",
    dispersedCopyPrintScanAreaDefined: "Jedna z przestrzeni ze sprz\u0119tem ksero / drukarkami / skanerami",
    hydrationPointDefined: "Punkt nawadniania (woda / herbata / kawa)",
    centralHighDensityStorageDefined: "G\u0142\xf3wny magazyn o du\u017Cej pojemno\u015Bci",
    wellnessMothersRoomDefined: "Pok\xf3j wellness / Pok\xf3j matki z dzieckiem",
    serverHubRoomsDefined: "Serwerownia / Centrala",
    buildITStoreRoomDefined: "Pomieszczenie mieszcz\u0105ce sprz\u0119t IT / Sk\u0142adzik sprz\u0119tu IT",
    simpleReceptionWaitDefined: "Podstawowa recepcja + poczekalnia",
    centralCafeSocialHubDefined: "G\u0142\xf3wna kafeteria i miejsce spotka\u0144 towarzyskich",
    mailCentreDefined: "Sortownia poczty",
    utilityStoreRoomDefined: "Pomieszczenie gospodarcze",
    drawerLateralFileDefined: "Szafa kartotekowa z 3 szufladami na dokumenty uk\u0142adane poziomo",
    juiceBarCoffeeShopDefined: "Bar z sokami / Kawiarnia",
    buildingSupportServicesDefined: "Obs\u0142uga techniczna budynku",
    // Space Unit Map Descriptions (spaceUnitMap.js) - Shared Descriptions
    focusRoomDesc: "Focus room to zamkni\u0119ta przestrze\u0144 przeznaczona do pracy w skupieniu lub nad projektami wymagaj\u0105cymi poufno\u015Bci. Zazwyczaj zaprojektowana tak, aby pomie\u015Bci\u0107 jedn\u0105 lub dwie osoby. Odpowiednia adaptacja akustyczna, czyli wyciszenie umo\u017Cliwiaj\u0105ce zachowanie prywatno\u015Bci, jest tu kluczowa. Salki te najcz\u0119\u015Bciej nie s\u0105 przypisane konkretnym pracownikom i mog\u0105 by\u0107 rezerwowane czasowo w zale\u017Cno\u015Bci od potrzeb.",
    fileRoomDesc: "Jest to miejsce przechowywania papierowych wersji dokument\xf3w, z kt\xf3rego korzystaj\u0105 zar\xf3wno pojedynczy pracownicy, jak i ca\u0142e zespo\u0142y. W wyniku digitalizacji proces\xf3w w wi\u0119kszo\u015Bci biur zapotrzebowanie na tak\u0105 przestrze\u0144 znacznie si\u0119 zmniejszy\u0142a w ostatnim czasie. Zgodnie z przepisami prawa organizacje nadal zobowi\u0105zane s\u0105 do przechowywania kopii dokument\xf3w i materia\u0142\xf3w, dotycz\u0105cych d\u0142ugoterminowych projekt\xf3w. Tak\u0105 w\u0142a\u015Bnie funkcj\u0119 spe\u0142nia ta przestrze\u0144, zw\u0142aszcza \u017Ce biurka w przestrzeniach typu open space, nie oferuj\u0105 zbyt wiele miejsca na przechowywanie dokument\xf3w.",
    centralReceptionHubDesc: "Recepcja jest pierwszym miejscem, dzi\u0119ki kt\xf3remu organizacja mo\u017Ce wywrze\u0107 wra\u017Cenie na pracownikach, klientach i innych odwiedzaj\u0105cych. Powinna konsekwentnie odzwierciedla\u0107 to\u017Csamo\u015B\u0107 marki, a tym samym odpowiednio wygl\u0105da\u0107. Lada recepcyjna musi zapewni\u0107 wygodne stanowisko pracy dla recepcjonisty/-ki, a go\u015Bci powinny przyci\u0105ga\u0107 mi\u0119kkie siedziska/sofy.",
    officeDesc: "Gabinety s\u0105 prywatnymi, zamkni\u0119tymi, indywidualnymi przestrzeniami do pracy dla pracownik\xf3w. \u015Awietnie nadaj\u0105 si\u0119 do koncentracji uwagi na pracy bez niepotrzebnych rozpraszaczy. Zazwyczaj wyposa\u017Cone w biurko i krzes\u0142o z dodatkowymi krzes\u0142ami dla go\u015Bci. Wielko\u015B\u0107 tej przestrzeni mo\u017Ce si\u0119 r\xf3\u017Cni\u0107 w zale\u017Cno\u015Bci od zada\u0144, kt\xf3re s\u0105 tutaj realizowane (np. regularne spotkania) lub statusu/pozycji pracownika w hierarchii organizacji.",
    benchDeskDesc: "Biurka to indywidualne, otwarte miejsca do pracy. Mniejsze z nich mog\u0105 by\u0107 wykorzystywane przez pracownik\xf3w etatowych zar\xf3wno okresowo (w og\xf3lnodost\u0119pnej przestrzeni), jak i na sta\u0142e. Takie biurka s\u0105 r\xf3wnie\u017C doskona\u0142ym rozwi\u0105zaniem dla pracownik\xf3w czasowo oddelegowanych z innych oddzia\u0142\xf3w i wykonawc\xf3w, kt\xf3rzy nie przebywaj\u0105 w biurze przez ca\u0142y czas. Zalety takich otwartych biurek to m.in. widoczno\u015B\u0107 biura i integralna wsp\xf3\u0142praca. Jedn\u0105 z wad mo\u017Ce by\u0107 rozpraszaj\u0105cy ha\u0142as, dlatego te\u017C zaleca si\u0119, aby biura, w kt\xf3rych pracuje si\u0119 przy tego rodzaju biurkach oferowa\u0142y te\u017C wystarczaj\u0105c\u0105 liczb\u0119 pomieszcze\u0144 do pracy w ciszy i skupieniu i salek konferencyjnych. Przy biurkach tego rodzaju mamy do czynienia z ograniczonymi mo\u017Cliwo\u015Bciami archiwizacji dokument\xf3w, dlatego te\u017C na terenie biura najprawdopodobniej znajdowa\u0107 b\u0119dzie si\u0119 kilka przeznaczonych do tego stref.",
    meetingRoomDesc: "Sale konferencyjne to zamkni\u0119te przestrzenie przeznaczone do spotka\u0144 w ma\u0142ych grupach licz\u0105cych od 2 do 4 os\xf3b. Dla usprawnienia procesu wymiany informacji powinny by\u0107 wyposa\u017Cone w sprz\u0119t audio-wideo i bia\u0142e tablice. Powinny by\u0107 te\u017C wyciszone (osoby przebywaj\u0105ce w bezpo\u015Brednim s\u0105siedztwie na zewn\u0105trz takiego pomieszczenia nie powinny s\u0142ysze\u0107 rozm\xf3w tocz\u0105cych si\u0119 w \u015Brodku).",
    meetingRoomDesc6: "Sale konferencyjne to zamkni\u0119te przestrzenie przeznaczone do spotka\u0144 w ma\u0142ych grupach licz\u0105cych od 2 do 4 os\xf3b. Dla usprawnienia procesu wymiany informacji powinny by\u0107 wyposa\u017Cone w sprz\u0119t audio-wideo i bia\u0142e tablice. Powinny by\u0107 te\u017C wyciszone (osoby przebywaj\u0105ce w bezpo\u015Brednim s\u0105siedztwie na zewn\u0105trz takiego pomieszczenia nie powinny s\u0142ysze\u0107 rozm\xf3w tocz\u0105cych si\u0119 w \u015Brodku).",
    meetingRoomDesc8: "Sale konferencyjne to zamkni\u0119te przestrzenie przeznaczone do spotka\u0144 w ma\u0142ych grupach licz\u0105cych od 2 do 4 os\xf3b. Dla usprawnienia procesu wymiany informacji powinny by\u0107 wyposa\u017Cone w sprz\u0119t audio-wideo i bia\u0142e tablice. Powinny by\u0107 te\u017C wyciszone (osoby przebywaj\u0105ce w bezpo\u015Brednim s\u0105siedztwie na zewn\u0105trz takiego pomieszczenia nie powinny s\u0142ysze\u0107 rozm\xf3w tocz\u0105cych si\u0119 w \u015Brodku).",
    meetingRoomDesc12: "Sale konferencyjne to zamkni\u0119te przestrzenie przeznaczone do spotka\u0144 w ma\u0142ych grupach licz\u0105cych od 2 do 4 os\xf3b. Dla usprawnienia procesu wymiany informacji powinny by\u0107 wyposa\u017Cone w sprz\u0119t audio-wideo i bia\u0142e tablice. Powinny by\u0107 te\u017C wyciszone (osoby przebywaj\u0105ce w bezpo\u015Brednim s\u0105siedztwie na zewn\u0105trz takiego pomieszczenia nie powinny s\u0142ysze\u0107 rozm\xf3w tocz\u0105cych si\u0119 w \u015Brodku).",
    meetingRoomDesc15: "Sale konferencyjne to zamkni\u0119te przestrzenie przeznaczone do spotka\u0144 w ma\u0142ych grupach licz\u0105cych od 2 do 4 os\xf3b. Dla usprawnienia procesu wymiany informacji powinny by\u0107 wyposa\u017Cone w sprz\u0119t audio-wideo i bia\u0142e tablice. Powinny by\u0107 te\u017C wyciszone (osoby przebywaj\u0105ce w bezpo\u015Brednim s\u0105siedztwie na zewn\u0105trz takiego pomieszczenia nie powinny s\u0142ysze\u0107 rozm\xf3w tocz\u0105cych si\u0119 w \u015Brodku).",
    openCollabSpace4to6Desc: "Powierzchnie te maj\u0105 na celu wspieranie ma\u0142ych grup (od 4 do 6 os\xf3b) we wsp\xf3lnych dzia\u0142aniach, takich jak burze m\xf3zg\xf3w i nieformalne rozmowy mi\u0119dzy wsp\xf3\u0142pracownikami oraz z klientami.",
    cafeFoodServiceDesc: "G\u0142\xf3wna kafeteria ma by\u0107 miejscem spo\u017Cywania posi\u0142k\xf3w, interakcji spo\u0142ecznych, pracy indywidualnej i spotka\u0144 w ma\u0142ych grupach. W projekcie tej przestrzeni nale\u017Cy uwzgl\u0119dni\u0107 funkcjonalne meble do spo\u017Cywania posi\u0142k\xf3w oraz kolorystyk\u0119 marki.",
    coatClosetsDesc: "Pracownicy potrzebuj\u0105 miejsca do przechowywania swoich okry\u0107 wierzchnich i innych wi\u0119kszych przedmiot\xf3w, zw\u0142aszcza gdy biuro ma otwarty uk\u0142ad z ograniczon\u0105 liczb\u0105 osobistych schowk\xf3w przy biurkach. Garderoby powinny by\u0107 rozmieszczone na terenie ca\u0142ego biura np. przy wej\u015Bciach/wyj\u015Bciach i w g\u0142\xf3wnych korytarzach. Zazwyczaj nad dr\u0105\u017Ckiem z wieszakami znajduje si\u0119 p\xf3\u0142ka na nakrycia g\u0142owy, a na dole miejsce do przechowywania innych przedmiot\xf3w i walizek.",
    copyPrintDesc: "Usytuowane w kilku miejscach w otwartej przestrzeni biurowej k\u0105ciki ze sprz\u0119tem ksero/drukarkami zapewniaj\u0105 pracownikom szybki dost\u0119p do tych wielofunkcyjnych urz\u0105dze\u0144 z ka\u017Cdej cz\u0119\u015Bci biura. W strefach tych zawsze powinny znajdowa\u0107 si\u0119 pojemniki do segregacji \u015Bmieci oraz ma\u0142e szafki na zapasowy papier i materia\u0142y biurowe. Przestrzenie te s\u0105 przeznaczone wy\u0142\u0105cznie do u\u017Cytku wewn\u0119trznego i nie powinny by\u0107 wykorzystywane jako miejsca spotka\u0144/pracy.",
    specialResourceBuildingSupportAreaDesc: "To uniwersalna nazwa dla wszelkich przestrzeni pe\u0142ni\u0105cych funkcje wspomagaj\u0105ce, kt\xf3re mog\u0105 znajdowa\u0107 si\u0119 w biurze. Mo\u017Ce to by\u0107 np. dy\u017Curka ochrony lub zaplecze techniczne, a nawet r\xf3\u017Cnorakie sk\u0142adziki i schowki. Ich wielko\u015B\u0107 i dok\u0142adne przeznaczenie b\u0119d\u0105 si\u0119 r\xf3\u017Cni\u0107 w zale\u017Cno\u015Bci od organizacji. Jednak\u017Ce czym wi\u0119ksze biuro, tym wyst\u0119powanie takich przestrzeni wspomagaj\u0105cych b\u0119dzie cz\u0119stsze, a nawet konieczne.",
    secondaryServerRoomDesc: "Pomieszczenie mieszcz\u0105ce i zabezpieczaj\u0105ce serwer zapasowy, urz\u0105dzenia IT oraz ko\u0144c\xf3wki okablowania niskonapi\u0119ciowego (pomieszczenie technologiczne). W pomieszczeniach tego rodzaju konieczna jest 24-godzinna cyrkulacja powietrza oraz sta\u0142a temperatura na poziomie 22,3\xb0 C przy wilgotno\u015Bci wzgl\u0119dnej 50%.",
    mothersRoomDesc: "Pok\xf3j matki z dzieckiem jest przeznaczony dla os\xf3b potrzebuj\u0105cych dost\u0119pu do odosobnionej, prywatnej przestrzeni \u2013 czy to dla matek karmi\u0105cych, czy dla pracownik\xf3w szukaj\u0105cych chwili wytchnienia od zgie\u0142ku biura. Pok\xf3j matki z dzieckiem to obecnie ju\u017C element konieczny we wszystkich nowych biurach, niezale\u017Cnie od ich wielko\u015Bci, czy liczby os\xf3b zatrudnionych w organizacji.",
    visitorCoatLuggageRoomDesc: "Go\u015Bcie potrzebuj\u0105 miejsca do przechowywania swoich okry\u0107 wierzchnich i innych wi\u0119kszych przedmiot\xf3w. Garderoby powinny by\u0107 rozmieszczone na terenie ca\u0142ego biura np. przy wej\u015Bciach/wyj\u015Bciach i w g\u0142\xf3wnych korytarzach. Zazwyczaj nad dr\u0105\u017Ckiem z wieszakami znajduje si\u0119 p\xf3\u0142ka na nakrycia g\u0142owy, a na dole miejsce do przechowywania innych przedmiot\xf3w i walizek.",
    wellnessRoomDesc: "Pokoje wellness (dawniej nazywane pokojami matki z dzieckiem) s\u0105 przeznaczone dla os\xf3b potrzebuj\u0105cych dost\u0119pu do odosobnionej, prywatnej przestrzeni \u2013 czy to dla matek karmi\u0105cych, czy dla pracownik\xf3w szukaj\u0105cych chwili wytchnienia od zgie\u0142ku biura. Pok\xf3j wellness to obecnie ju\u017C element konieczny we wszystkich nowych biurach, niezale\u017Cnie od ich wielko\u015Bci, czy liczby os\xf3b zatrudnionych w organizacji. Powinny si\u0119 w nim znajdowa\u0107 fotel wypoczynkowy, lod\xf3wka, a tak\u017Ce (je\u015Bli to mo\u017Cliwe) umywalka.",
    internalStairDesc: "Na potrzeb\u0119 schod\xf3w wewn\u0119trznych mo\u017Cna adaptowa\u0107 klatk\u0119 schodow\u0105 w trzonie budynku, w ten spos\xf3b zapewniaj\u0105c komunikacj\u0119 mi\u0119dzy pi\u0119trami. Schody te mog\u0105 by\u0107 r\xf3wnie\u017C dodatkowym elementem aran\u017Cacji przestrzeni \u0142\u0105cz\u0105cym pi\u0119tra biura. Cz\u0119sto s\u0105 wykorzystywane jako miejsce spotka\u0144, a wok\xf3\u0142 nich urz\u0105dza si\u0119 kafeteri\u0119, recepcj\u0119 lub k\u0105ciki wypoczynkowe.",
    commercialPrintRoomDesc: "Organizacje cz\u0119sto udost\u0119pniaj\u0105 pracownikom pomieszczenia po\u0142\u0105czone z sortowni\u0105 poczty, w kt\xf3rych istnieje mo\u017Cliwo\u015B\u0107 skorzystania z urz\u0105dze\u0144 ksero i drukarek, bindowania czy te\u017C oprawy dokument\xf3w bez potrzeby korzystania z us\u0142ug podmiot\xf3w zewn\u0119trznych. Najcz\u0119\u015Bciej znajdowa\u0107 b\u0119dzie si\u0119 tam kilka drukarek, a by\u0107 mo\u017Ce i drukarek wielkoformatowych. Przestrze\u0144 ta powinna mie\u015Bci\u0107 te\u017C miejsce do przechowywania materia\u0142\xf3w biurowych, a tak\u017Ce lad\u0119 na mniejszy sprz\u0119t i do uk\u0142adania wydruk\xf3w.",
    pantryVendingCoffeeDesc: "W przeciwie\u0144stwie do g\u0142\xf3wnej kafeterii strefa mieszcz\u0105ca automaty z przek\u0105skami i napojami oraz k\u0105cik kawowy jest przeznaczona dla pracownik\xf3w, kt\xf3rzy chc\u0105 zje\u015B\u0107 i wypi\u0107 co\u015B na szybko. Naturalnie w strefach przeznaczonych do konsumpcji \u017Cywno\u015Bci i napoj\xf3w panuje gwar, ale te przestrzenie zazwyczaj nie oferuj\u0105 miejsc siedz\u0105cych, co powoduje, \u017Ce ludzie szybko przychodz\u0105 i wychodz\u0105, nie sp\u0119dzaj\u0105c zbyt wiele czasu na rozmowach towarzyskich.",
    storageDesc: "Pomieszczenia magazynowe s\u0105 przeznaczone do przechowywania r\xf3\u017Cnych przedmiot\xf3w takich jak: du\u017Cy sprz\u0119t, dodatkowe meble, ozdoby \u015Bwi\u0105teczne itp. Mog\u0105 by\u0107 r\xf3wnie\u017C wykorzystywane do przechowywania okry\u0107 wierzchnich i baga\u017Cy go\u015Bci. Dla wygody ma\u0142y schowek powinien by\u0107 umiejscowiony tak\u017Ce w pobli\u017Cu recepcji.",
    centralisedDispersedMailAreaDesc: "W przypadku wi\u0119kszych firm sortownia poczty jest niezb\u0119dna do sprawnego zarz\u0105dzania poczt\u0105 przychodz\u0105c\u0105 i wychodz\u0105c\u0105. W takich pomieszczeniach znajduj\u0105 si\u0119 specjalistyczne urz\u0105dzenia s\u0142u\u017C\u0105ce do przygotowywania i wysy\u0142ania przesy\u0142ek. Najcz\u0119\u015Bciej mieszcz\u0105 si\u0119 tam r\xf3wnie\u017C r\xf3\u017Cnego rodzaju lady i blaty umo\u017Cliwiaj\u0105ce sortowanie dokument\xf3w i innych materia\u0142\xf3w. Sortownia poczty jest zazwyczaj obs\u0142ugiwana przez pe\u0142noetatowego pracownika.",
    lockerDesc: "Szafki s\u0105 dodatkowym miejscem, w kt\xf3rym pracownicy mog\u0105 przechowywa\u0107 swoje rzeczy osobiste, warto\u015Bciowe, a tak\u017Ce dokumenty. Mog\u0105 by\u0107 one przypisane konkretnej osobie lub u\u017Cywane na zasadzie \u201Ekto pierwszy, ten lepszy\u201D.",
    mainITandServerRoomDesc: "Pomieszczenie mieszcz\u0105ce i zabezpieczaj\u0105ce serwer g\u0142\xf3wny i urz\u0105dzenia IT oraz ko\u0144c\xf3wki okablowania niskonapi\u0119ciowego (pomieszczenie technologiczne). W pomieszczeniach tego rodzaju konieczna jest 24-godzinny cyrkulacja powietrza oraz sta\u0142a temperatura na poziomie 22,3\xb0 C przy wilgotno\u015Bci wzgl\u0119dnej 50%.",
    drawerLateralFileDesc: "Osobisty schowek dla poszczeg\xf3lnych pracownik\xf3w umiejscowiony przy biurku lub w gabinecie. Jego zawarto\u015B\u0107 to zazwyczaj przedmioty osobiste lub materia\u0142y dotycz\u0105ce bie\u017C\u0105cych projekt\xf3w.",
    juiceBarCoffeeShopDesc: "Nawet gdy w biurze nie znajdzie si\u0119 miejsce na pe\u0142n\u0105 stref\u0119 kuchenn\u0105 lub lad\u0119 wydawcz\u0105, organizacja \u2013  w ramach udogodnie\u0144 gastronomicznych \u2013 mo\u017Ce zapewni\u0107 pracownikom dost\u0119p do kawiarni lub baru sokowego. Tego rodzaju przestrze\u0144 mo\u017Ce by\u0107 dodatkiem do g\u0142\xf3wnej strefy kuchennej/jadalnej, zw\u0142aszcza je\u015Bli mamy do czynienia z biurem o du\u017Cej powierzchni. Przestrze\u0144 ta b\u0119dzie prawdopodobnie wygl\u0105da\u0107 jak lokalny Starbucks z miejscem dla obs\u0142ugi, oddzielonym od g\u0142\xf3wnej strefy lad\u0105.",
    grabNGoDesc: "Niewielka przestrze\u0144 z kilkoma lod\xf3wkami, ladami z chipsami i przek\u0105skami oraz kas\u0105. Strefy typu Grab-N-Go s\u0105 zazwyczaj monitorowane za pomoc\u0105 kamer. Cz\u0119sto po\u0142\u0105czone z ma\u0142\u0105 przestrzeni\u0105 z lod\xf3wkami i zamra\u017Carkami oraz miejscem do przygotowywania \u017Cywno\u015Bci.",
    smMeetingConferenceRoomDesc: "Ma\u0142a sala konferencyjna jest zamkni\u0119t\u0105 przestrzeni\u0105 przeznaczon\u0105 do spotka\u0144, w kt\xf3rej przy stole mo\u017Ce wygodnie usi\u0105\u015B\u0107 od 2 do 6 os\xf3b. Pomieszczenia tego rodzaju mog\u0105 by\u0107 wykorzystywane zar\xf3wno do spotka\u0144 wewn\u0119trznych, jak i do takich z klientami, dlatego powinny by\u0107 zaaran\u017Cowane w spos\xf3b przyjazny dla u\u017Cytkownika i zapewnia\u0107 \u0142atwy dost\u0119p do gniazd zasilaj\u0105cych i wyposa\u017Cenia audio-wideo.",
    mdMeetingConferenceRoomDesc: "\u015Arednia sala konferencyjna jest zamkni\u0119t\u0105 przestrzeni\u0105 przeznaczon\u0105 do spotka\u0144, w kt\xf3rej przy stole mo\u017Ce wygodnie usi\u0105\u015B\u0107 od 6 do 10 os\xf3b. Pomieszczenia tego rodzaju mog\u0105 by\u0107 wykorzystywane zar\xf3wno do spotka\u0144 wewn\u0119trznych, jak i do takich z klientami, dlatego powinny by\u0107 zaaran\u017Cowane w spos\xf3b przyjazny dla u\u017Cytkownika i zapewnia\u0107 \u0142atwy dost\u0119p do gniazd zasilaj\u0105cych oraz wyposa\u017Cenia audio-wideo.",
    lgMeetingConferenceRoomDesc: "Du\u017Ca sala konferencyjna jest zamkni\u0119t\u0105 przestrzeni\u0105, w kt\xf3rej przy stole mo\u017Ce wygodnie usi\u0105\u015B\u0107 od 12 do 14 os\xf3b, gdzie po\u017C\u0105dane b\u0119dzie te\u017C zapewnienie miejsc siedz\u0105cych dla wi\u0119kszej liczby os\xf3b pod \u015Bcianami. Pomieszczenia tego rodzaju mog\u0105 by\u0107 wykorzystywane zar\xf3wno do spotka\u0144 wewn\u0119trznych, jak i do takich z klientami i najprawdopodobniej b\u0119d\u0105 wykorzystywane do przeprowadzania prezentacji. Meble powinny by\u0107 ruchome, aby umo\u017Cliwi\u0107 wykorzystanie przestrzeni do innych cel\xf3w, takich jak zaj\u0119cia jogi dla pracownik\xf3w.",
    xlMeetingRoomDesc: "Sala konferencyjna dla zarz\u0105du ma wygodnie pomie\u015Bci\u0107 od 14 do 18 os\xf3b przy stole i posiada\u0107 dodatkowe miejsca siedz\u0105ce pod \u015Bcianami dla co najmniej 10 os\xf3b. Pomieszczenia tego rodzaju b\u0119d\u0105 najprawdopodobniej wykorzystywane na potrzeby du\u017Cych i oficjalnych spotka\u0144 wewn\u0119trznych oraz du\u017Cych spotka\u0144 z klientami. Powinny wi\u0119c by\u0107 wyposa\u017Cone w niezawodny sprz\u0119t audio-wideo i traktowane jako przestrze\u0144 przeznaczona na spotkania z klientami.",
    // Space Unit Map Descriptions (spaceUnitMap.js) - US_SMALL and US_REGULAR
    lgOfficeDesc: "Gabinety s\u0105 prywatnymi, zamkni\u0119tymi, indywidualnymi przestrzeniami do pracy dla pracownik\xf3w. \u015Awietnie nadaj\u0105 si\u0119 do koncentracji uwagi na pracy bez niepotrzebnych rozpraszaczy. Zazwyczaj wyposa\u017Cone w biurko i krzes\u0142o z dodatkowymi krzes\u0142ami dla go\u015Bci. Gabinet b\u0119dzie te\u017C mie\u015Bci\u0142 r\xf3\u017Cn\u0105 liczb\u0119 szafek przeznaczonych do przechowywania rzeczy osobistych i dokument\xf3w. Wielko\u015B\u0107 tej przestrzeni mo\u017Ce si\u0119 r\xf3\u017Cni\u0107 w zale\u017Cno\u015Bci od zada\u0144, kt\xf3re s\u0105 tutaj realizowane (np. regularne spotkania) lub statusu/pozycji pracownika w hierarchii organizacji. Nieco wi\u0119ksze z nich b\u0119d\u0105 zajmowane przez kadr\u0119 zarz\u0105dzaj\u0105c\u0105 lub pe\u0142ni\u0107 funkcj\u0119 salki konferencyjnej.",
    smWorkstationDesc: "Stanowiska pracy to indywidualne, otwarte miejsca do pracy. Mniejsze z nich mog\u0105 by\u0107 wykorzystywane przez pracownik\xf3w etatowych zar\xf3wno okresowo (w og\xf3lnodost\u0119pnej przestrzeni), jak i na sta\u0142e. S\u0105 one r\xf3wnie\u017C doskona\u0142ym rozwi\u0105zaniem dla pracownik\xf3w czasowo oddelegowanych z innych oddzia\u0142\xf3w i wykonawc\xf3w, kt\xf3rzy nie przebywaj\u0105 w biurze przez ca\u0142y czas. Ich zalety to m.in. widoczno\u015B\u0107 biura i integralna wsp\xf3\u0142praca. Jedn\u0105 z wad mo\u017Ce by\u0107 rozpraszaj\u0105cy ha\u0142as, dlatego te\u017C zaleca si\u0119, aby biura, w kt\xf3rych pracuje si\u0119 przy tego rodzaju stanowiskach oferowa\u0142y te\u017C wystarczaj\u0105c\u0105 liczb\u0119 pomieszcze\u0144 do pracy w ciszy i skupieniu i salek konferencyjnych. Przy stanowiskach tego rodzaju mamy do czynienia z ograniczonymi mo\u017Cliwo\u015Bciami archiwizacji dokument\xf3w, dlatego te\u017C na terenie biura najprawdopodobniej znajdowa\u0107 b\u0119dzie si\u0119 kilka przeznaczonych do tego stref.",
    mdWorkstationDesc: "Stanowiska pracy to indywidualne, otwarte miejsca do pracy. Korzy\u015Bci p\u0142yn\u0105ce z nieco wi\u0119kszej przestrzeni obejmuj\u0105 wi\u0119cej miejsca na przechowywanie rzeczy osobistych i zapewnienie wi\u0119kszej prywatno\u015Bci. Oznacza to prawdopodobnie, \u017Ce im wi\u0119ksze biurko, tym wi\u0119ksze prawdopodobie\u0144stwo, \u017Ce zostanie ono przydzielone konkretnej osobie. Ich zalety to m.in. widoczno\u015B\u0107 biura i integralna wsp\xf3\u0142praca. Jedn\u0105 z wad mo\u017Ce by\u0107 rozpraszaj\u0105cy ha\u0142as, dlatego te\u017C zaleca si\u0119, aby biura, w kt\xf3rych pracuje si\u0119 przy tego rodzaju stanowiskach oferowa\u0142y te\u017C wystarczaj\u0105c\u0105 liczb\u0119 pomieszcze\u0144 do pracy w ciszy i skupieniu i salek konferencyjnych. Na terenie biura najprawdopodobniej znajdowa\u0107 b\u0119dzie si\u0119 kilka wsp\xf3lnych stref przeznaczonych do przechowywania rzeczy osobistych i dokument\xf3w.",
    lgWorkstationDesc: "Stanowiska pracy to indywidualne, otwarte miejsca do pracy. Korzy\u015Bci p\u0142yn\u0105ce z nieco wi\u0119kszej przestrzeni obejmuj\u0105 wi\u0119cej miejsca na przechowywanie rzeczy osobistych i zapewnienie wi\u0119kszej prywatno\u015Bci. Biurko tej wielko\u015Bci b\u0119dzie najprawdopodobniej przydzielone konkretnej osobie. Ich zalety to m.in. widoczno\u015B\u0107 biura i integralna wsp\xf3\u0142praca. Jedn\u0105 z wad mo\u017Ce by\u0107 rozpraszaj\u0105cy ha\u0142as, dlatego te\u017C zaleca si\u0119, aby biura, w kt\xf3rych pracuje si\u0119 przy tego rodzaju stanowiskach oferowa\u0142y te\u017C wystarczaj\u0105c\u0105 liczb\u0119 pomieszcze\u0144 do pracy w ciszy i skupieniu i salek konferencyjnych. Na terenie biura najprawdopodobniej znajdowa\u0107 b\u0119dzie si\u0119 kilka wsp\xf3lnych stref przeznaczonych do przechowywania rzeczy osobistych i dokument\xf3w.",
    huddleRoomDesc: "Salki konferencyjne to zamkni\u0119te przestrzenie przeznaczone do spotka\u0144 w ma\u0142ych grupach licz\u0105cych od 2 do 4 os\xf3b. Dla usprawnienia procesu wymiany informacji powinny by\u0107 wyposa\u017Cone w sprz\u0119t audio-wideo i bia\u0142e tablice. Powinny by\u0107 te\u017C wyciszone (osoby przebywaj\u0105ce w bezpo\u015Brednim s\u0105siedztwie na zewn\u0105trz takiego pomieszczenia nie powinny s\u0142ysze\u0107 rozm\xf3w tocz\u0105cych si\u0119 w \u015Brodku).",
    multiPurpTrainingDesc: "Sale wielofunkcyjne przeznaczone s\u0105 dla du\u017Cej liczby os\xf3b (20+). Przestrzenie tego rodzaju zosta\u0142y tak nazwane ze wzgl\u0119du na zr\xf3\u017Cnicowany charakter dzia\u0142a\u0144, kt\xf3re mo\u017Cna w nich realizowa\u0107, np. szkolenia, imprezy firmowe i prowadzenie prezentacji. Spos\xf3b aran\u017Cacji tej przestrzeni jest funkcjonalny i trwa\u0142y zar\xf3wno z perspektywy potrzeb u\u017Cytkownik\xf3w wewn\u0105trz organizacji, jak i klient\xf3w. Sale te musz\u0105 by\u0107 wyposa\u017Cone w odpowiedni sprz\u0119t audio-wideo, zazwyczaj w znacznie wi\u0119kszej mierze ni\u017C przeci\u0119tna sala konferencyjna.",
    informalCollabDesc: "Powierzchnie te maj\u0105 na celu wspieranie ma\u0142ych grup (od 4 do 6 os\xf3b) we wsp\xf3lnych dzia\u0142aniach, takich jak burze m\xf3zg\xf3w i nieformalne rozmowy mi\u0119dzy wsp\xf3\u0142pracownikami oraz z klientami.",
    touchdownTeamDesc: "Indywidualne lub ma\u0142e przestrzenie przeznaczone do wewn\u0119trznej pracy zespo\u0142owej rozmieszczone na terenie ca\u0142ego biura do u\u017Cytku pracownik\xf3w i go\u015Bci. Przestrzenie te mog\u0105 mie\u0107 r\xf3\u017Cne wysoko\u015Bci, kszta\u0142ty i rozmiary, jednak\u017Ce maj\u0105 wyr\xf3\u017Cnia\u0107 si\u0119 na tle indywidualnych stanowisk pracy jako wyj\u0105tkowe miejsca do pracy przez kr\xf3tki czas. Przestrze\u0144 taka powinna by\u0107 zagospodarowana na zasadzie \u201Epod\u0142\u0105cz i u\u017Cywaj\u201D.",
    frontDeskAreaDesc: "To pierwsze miejsce, w kt\xf3rym pracownicy i go\u015Bcie maj\u0105 kontakt z biurem. Lada recepcyjna powinna by\u0107 w stanie pomie\u015Bci\u0107 co najmniej jedn\u0105 osob\u0119 zapewniaj\u0105c jej wygodne stanowisko pracy i miejsce na przechowywanie rzeczy osobistych i dokument\xf3w. Prawdopodobnie w pobli\u017Cu b\u0119dzie znajdowa\u0142o si\u0119 miejsce do przechowywania okry\u0107 wierzchnich go\u015Bci. Recepcja umiejscowiona jest w wi\u0119kszej strefie recepcyjnej z miejscami siedz\u0105cymi i innymi udogodnieniami.",
    mailCenterAreaDesc: "W przypadku wi\u0119kszych firm sortownia poczty jest niezb\u0119dna dla scentralizowanego zarz\u0105dzania wszystkimi procesami zwi\u0105zanymi z przesy\u0142kami. W takich pomieszczeniach znajdowa\u0107 b\u0119d\u0105 si\u0119 r\xf3\u017Cnego rodzaju obszerne lady i blaty umo\u017Cliwiaj\u0105ce sortowanie dokument\xf3w i innych materia\u0142\xf3w, a tak\u017Ce miejsce na tablice i inny sprz\u0119t. Ta przestrze\u0144 b\u0119dzie najprawdopodobniej wygl\u0105da\u0107 odmiennie w zale\u017Cno\u015Bci od organizacji, jako \u017Ce najcz\u0119\u015Bciej b\u0119dzie ona spe\u0142nia\u0107 te\u017C inne funkcje w ramach jej dzia\u0142alno\u015Bci.",
    kitchenAreaDesc: "W przypadku powierzchni oferuj\u0105cych us\u0142ugi gastronomiczne na terenie biura strefa kuchenna b\u0119dzie niezb\u0119dnym elementem je wspomagaj\u0105cym. Wymagania co do wielko\u015Bci, aran\u017Cacji i sprz\u0119tu b\u0119d\u0105 si\u0119 r\xf3\u017Cni\u0107 w zale\u017Cno\u015Bci od organizacji, ale na pewno znajd\u0105 si\u0119 tam urz\u0105dzenia do gotowania oraz lod\xf3wki. Nie mo\u017Ce tam r\xf3wnie\u017C zabrakn\u0105\u0107 miejsca do przechowywania produkt\xf3w sypkich i sprz\u0119tu. Kuchnia b\u0119dzie s\u0105siadowa\u0107 z lad\u0105 wydawcz\u0105 i najprawdopodobniej stref\u0105 konferencyjn\u0105/udogodnie\u0144.",
    serveryAreaDesc: "Lada wydawcza to miejsce zamawiania i wydawania posi\u0142k\xf3w. B\u0119dzie ona prawdopodobnie po\u0142\u0105czona z kuchni\u0105 i jadalni\u0105 ze sto\u0142ami i miejscami do siedzenia. Aran\u017Cacja tej przestrzeni musi by\u0107 niezwykle precyzyjna, tak aby sprawnie zarz\u0105dza\u0107 kolejkami i ruchem. Jej rozmiar i kszta\u0142t b\u0119d\u0105 si\u0119 r\xf3\u017Cni\u0107 w zale\u017Cno\u015Bci od organizacji.",
    diningSupportAreaDesc: "Organizacja oferuj\u0105ca pe\u0142nowymiarowe us\u0142ugi gastronomiczne prawdopodobnie b\u0119dzie musia\u0142a uwzgl\u0119dni\u0107 te\u017C dodatkowe przestrzenie wspomagaj\u0105ce, takie jak magazyny/spi\u017Carnie w innych cz\u0119\u015Bciach budynku. Nale\u017Cy to zrobi\u0107 na etapie planowania ca\u0142o\u015Bci powierzchni. Przestrze\u0144 ta b\u0119dzie si\u0119 r\xf3\u017Cni\u0107 w zale\u017Cno\u015Bci od organizacji.",
    diningAreaDesc: "Jadalnia w pobli\u017Cu kuchni powinna zapewnia\u0107 pracownikom r\xf3\u017Cnorodne opcje w zakresie wyboru miejsc do siedzenia i spo\u017Cywania posi\u0142k\xf3w. Zapewnienie kilku r\xf3\u017Cnych rodzaj\xf3w miejsc siedz\u0105cych umo\u017Cliwia r\xf3wnie\u017C wykorzystanie przestrzeni do spotka\u0144 i wsp\xf3\u0142pracy poza por\u0105 lunchu. W przestrzeni tej powinny znale\u017A\u0107 si\u0119 krzes\u0142a i fotele (z mi\u0119kkimi i twardymi obiciami), a tak\u017Ce hokery z mo\u017Cliwo\u015Bci\u0105 regulacji wysoko\u015Bci siedziska.",
    // Space Unit Map Descriptions (spaceUnitMap.js) - UK_REGULAR
    fullFoodServiceDesc: "Oferowanie pe\u0142nowymiarowych us\u0142ug restauracyjnych w przestrzeni biurowej wymaga zaplanowania wielu innych funkcji, kt\xf3re \u0142\u0105cznie umo\u017Cliwi\u0105 sprawne funkcjonowanie tej strefy, w tym kuchni\u0119, lad\u0119 wydawcz\u0105, jadalni\u0119 (z miejscami siedz\u0105cymi) i przestrze\u0144 wspomagaj\u0105c\u0105 (przechowywanie). Kuchnia i lada wydawcza wsp\xf3\u0142pracuj\u0105 ze sob\u0105, aby przygotowa\u0107 i poda\u0107 jedzenie przygotowywane na miejscu. Jadalnia to miejsce, w kt\xf3rym pracownicy i go\u015Bcie mog\u0105 usi\u0105\u015B\u0107 i zje\u015B\u0107 posi\u0142ek, ale cz\u0119sto przestrze\u0144 ta pe\u0142ni te\u017C rol\u0119 miejsca spotka\u0144 towarzyskich i wsp\xf3\u0142pracy. Podobnie jak w domu do \u015Bwiadczenia us\u0142ug gastronomicznych potrzebna jest du\u017Ca ilo\u015B\u0107 sprz\u0119tu i miejsca na jego przechowywanie, a tak\u017Ce przechowywanie \u017Cywno\u015Bci, dlatego przestrze\u0144 ta przynale\u017Ce\u0107 b\u0119dzie do kategorii powierzchni restauracyjnej.",
    // SpaceUnitRow
    spaceUnitRowDeleteTitle: "Usu\u0144 typ przestrzeni",
    spaceUnitRowDeleteText: "Czy na pewno chcesz usun\u0105\u0107 ten typ przestrzeni?",
    spaceUnitRowConfirmDeleteText: "Tak, usu\u0144",
    spaceUnitRowCancelDeleteText: "Nie, zachowaj",
    // CustomAmenityAdder
    customAmenityAddText: "Dodaj udogodnienie socjalne",
    customAmenityPlaceholder: "Rodzaj udogodnie\u0144 socjalnych",
    // SpaceUnitTotals
    spaceUnitTotalsTitleNIA: "Ca\u0142kowita Powierzchnia Wewn\u0119trzna Netto",
    spaceUnitTotalsTitle: "Ca\u0142kowita {{sfTypeAdj}} w {{unitCapitalized}} wynosi  ",
    spaceUnitTotalsCirculation: "Przestrze\u0144 komunikacyjna",
    spaceUnitTotalsCirculationTooltip: "\u201EPrzestrze\u0144 pomi\u0119dzy przestrzeniami\u201D. Korytarze, przestrze\u0144 za krzes\u0142em, przestrze\u0144 wok\xf3\u0142 szafek i drzwi oraz w rogach pomieszcze\u0144. Bez przestrzeni komunikacyjnej nie m\xf3g\u0142by\u015B porusza\u0107 si\u0119 po biurze! Zwykle stanowi oko\u0142o 35% ca\u0142kowitej powierzchni u\u017Cytkowej wyra\u017Conej w {{unitCapitalized}}  wyliczonej dla Twojego projektu \u2013 jednak\u017Ce ostateczna warto\u015B\u0107 zale\u017Ce\u0107 b\u0119dzie od Twojego profilu i budynku, na kt\xf3ry si\u0119 zdecydujesz.",
    spaceUnitTotalsREBNY: "Wsp\xf3\u0142czynnik REBNY",
    spaceUnitTotalsNYCText: "Nowy Jork",
    spaceUnitTotalsREBNYTooltip: "W przypadku projekt\xf3w przygotowywanych dla powierzchni biurowych w Nowym Jorku dodajemy {{sfType}} 15%, czyli tzw. wsp\xf3\u0142czynnik REBNY. Powierzchnia mierzona z uwzgl\u0119dnieniem wsp\xf3\u0142czynnika REBNY obejmuje m.in. \u0142azienki, hole windowe oraz grubo\u015B\u0107 \u015Bcian zewn\u0119trznych.",
    spaceUnitTotalsLossFactor: "Wsp\xf3\u0142czynnik strat ",
    spaceUnitTotalsLossFactorTooltip: "Powierzchnia u\u017Cytkowa wyra\u017Cona w {{unit}} to ilo\u015B\u0107 miejsca, kt\xf3re masz w swoim biurze. Powierzchnia najmu wyra\u017Cona w {{unit}} to powierzchnia, za kt\xf3r\u0105 p\u0142acisz, kt\xf3ra mo\u017Ce obejmowa\u0107 filary, hole i inne cz\u0119\u015Bci wsp\xf3lne w budynku. R\xf3\u017Cnica mi\u0119dzy powierzchni\u0105 u\u017Cytkow\u0105 a najmu nazywana jest wsp\xf3\u0142czynnikiem strat, a spos\xf3b jej obliczania r\xf3\u017Cni si\u0119 w zale\u017Cno\u015Bci od lokalizacji.",
    // CollaborationDropdown
    collabDropdownLevelLowText: "niewiele (0-25%)",
    collabDropdownLevelMedText: "cz\u0119\u015B\u0107 (26-50%)",
    collabDropdownLevelHighText: "wi\u0119kszo\u015B\u0107 (51-100%)",
    //DensityDropdown
    sameDensityText: "takie samo jak przed Covid-19",
    lowerDensityText: "mniejsze (wi\u0119ksza liczba mkw./os.)",
    notSureDensityText: "nie jeste\u015Bmy pewni",
    //CirculationDropdown
    preCovidText: "Na poziomie sprzed Covid-19 (45% przestrze\u0144 otwarta / 25% przestrze\u0144 zamkni\u0119ta)",
    higherText: "Zwi\u0119kszona przestrze\u0144 komunikacyjna (50% przestrze\u0144 otwarta / 30% przestrze\u0144 zamkni\u0119ta)",
    notSureText: "Nie jeste\u015Bmy pewni (45% przestrze\u0144 otwarta / 25% przestrze\u0144 zamkni\u0119ta)",
    // ExamplePlans
    examplePlanButtonText: "Podgl\u0105d przyk\u0142adowego rzutu",
    examplePlanFullFloorText: "ca\u0142e pi\u0119tro",
    examplePlanPartialFloorText: "cz\u0119\u015B\u0107 pi\u0119tra",
    examplePlanFullImgAlt: "Rzut przedstawiaj\u0105cy przestrze\u0144 biurow\u0105 o wielko\u015Bci {{size}} {{unit}} kwadratowych obejmuj\u0105c\u0105 ca\u0142e pi\u0119tro wygenerowany dla profilu {{profileName}} w aplikacji CBRE Spacer",
    examplePlanPartialImgAlt: "Rzut przedstawiaj\u0105cy przestrze\u0144 biurow\u0105 o wielko\u015Bci {{size}} {{unit}} kwadratowych obejmuj\u0105c\u0105 cz\u0119\u015B\u0107 pi\u0119tra wygenerowany dla profilu {{profileName}} w aplikacji CBRE Spacer",
    examplePlanTooltipText: "Je\u017Celi powierzchnia Twojego biura przekracza wielko\u015B\u0107 {{size}} {{unit}} kwadratowych, mo\u017Ce okaza\u0107 si\u0119, \u017Ce b\u0119dziesz musia\u0142 zaj\u0105\u0107 wi\u0119cej ni\u017C jedno pi\u0119tro.",
    // ProgramStats
    programStatsDensitySubtitleTsubo: "Tsubo netto",
    programStatsDensitySubtitle: "{{adjective}} w {{unitUppercase}}",
    programStatsIndivTitle: "Stanowiska do pracy indywidualnej",
    programStatsWorkstationsSubtitle: "Stanowiska pracy",
    programStatsOfficesSubtitle: "Gabinety",
    programStatsCollabTitle: "Przestrze\u0144 do pracy zespo\u0142owej",
    programStatsEnclosedSubtitle: "Zamkni\u0119te stanowiska do pracy zespo\u0142owej",
    programStatsIndivSeatSubtitle: "Stanowisko do pracy indywidualnej",
    programStatsSeatsTitle: "Liczba miejsc na osob\u0119",
    programStatsIndivSeatsSubtitle: "Stanowiska do pracy indywidualnej",
    programStatsPersonSubtitle: "Osoba",
    programStatsDensityTitle: "Zag\u0119szczenie",
    programStatsFullDensitySubtitle: "{{density}} na stanowisko do pracy indywidualnej",
    // Profile Display Names (profileNames.js)
    efficientName: "\u201EOptymalizator\u201D",
    whiteCollarName: "\u201EGospodarz\u201D",
    whiteGloveName: "\u201EMobilizator\u201D",
    openOfficeName: "\u201ERealizator\u201D",
    workplace360Name: "\u201EIntegrator\u201D",
    campusName: "\u201EWyr\xf3\u017Cnik\u201D",
    startupName: "\u201EInkubator\u201D",
    engCreativeName: "\u201EKreator\u201D",
    // Profile Descriptions (profileDescriptions.js)
    efficientDesc: "Biuro \u201EOptymalizator\u201D to konkretne i rzeczowe podej\u015Bcie do kwestii \u015Brodowiska pracy z czystym nastawieniem na jej wykonanie. W tej przestrzeni chodzi o zaopatrzenie pracownik\xf3w we wszystkie wymagane narz\u0119dzia przy w\u0142asnych biurkach. Wsp\xf3\u0142praca i praca zespo\u0142owa nie zdarzaj\u0105 si\u0119 tutaj cz\u0119sto. Biurka s\u0105 ustandaryzowane i przyporz\u0105dkowane konkretnym pracownikom, a w obr\u0119bie biura dost\u0119pne s\u0105 tylko podstawowe udogodnienia i przestrzenie wspomagaj\u0105ce. Zgodnie ze swoj\u0105 nazw\u0105 biuro to prawie zawsze funkcjonuje w przestrzeni otwartej w celu maksymalizacji wydajno\u015Bci.",
    whiteCollarDesc: "Je\u017Celi Twoim biurem jest \u201EGospodarz\u201D, to nie jeste\u015B sam. To jeden z najpopularniejszych profili wybieranych przez organizacje. Biura tego typu raczej nie wprowadzaj\u0105 zb\u0119dnego zamieszania za pomoc\u0105 rewolucyjnych rozwi\u0105za\u0144 w zakresie aran\u017Cacji przestrzeni i wystroju, jednak\u017Ce cz\u0119sto inwestuj\u0105 w nowe technologie i meble, tak aby stworzy\u0107 przyjazn\u0105 i produktywn\u0105 przestrze\u0144. Dzi\u0119ki zachowaniu r\xf3wnowagi pomi\u0119dzy przestrzeni\u0105 indywidualn\u0105 a wsp\xf3ln\u0105 pracownicy sp\u0119dzaj\u0105 wi\u0119ksz\u0105 cz\u0119\u015B\u0107 swojego dnia pracy przy biurkach, okazjonalnie bior\u0105c udzia\u0142 spotkaniach lub sesjach zespo\u0142owych. Idealne miejsce pracy od 9.00 do 17.00.",
    whiteGloveDesc: "Wejd\u017A do lobby biura \u201EMobilizator\u201D, a poczujesz si\u0119, jakby\u015B naprawd\u0119 osi\u0105gn\u0105\u0142 w \u017Cyciu sukces. To miejsce pracy zaspokaja wszystkie potrzeby zar\xf3wno pracownik\xf3w, jak i klient\xf3w, kt\xf3rzy s\u0105 cz\u0119stymi go\u015B\u0107mi. Indywidualne gabinety i zamkni\u0119te przestrzenie do pracy s\u0105 tu zjawiskiem bardziej powszechnym ni\u017C w jakimkolwiek innym \u015Brodowisku pracy. Dla wi\u0119kszo\u015Bci pracownik\xf3w ich w\u0142asna przestrze\u0144 do pracy jest nagrod\u0105 za wydajno\u015B\u0107 lub sta\u017C, a hierarchia prawdopodobnie odgrywa wa\u017Cn\u0105 rol\u0119 w funkcjonowaniu ca\u0142ej organizacji.",
    openOfficeDesc: "Biuro \u201ERealizator\u201D dok\u0142adnie wie, czego potrzebujesz, aby odnie\u015B\u0107 sukces. Chodzi o to, aby zapewni\u0107 pracownikom wszystkie rodzaje przestrzeni, konieczne do realizacji wszelkich dzia\u0142a\u0144 podejmowanych w biurze. Te r\xf3\u017Cnorodne typy przestrzeni s\u0105 tu nie tylko dost\u0119pne, ale te\u017C skutecznie wykorzystywane w pe\u0142nym zakresie. To najlepszy spos\xf3b na wydajno\u015B\u0107! Ten profil biura to idealna r\xf3wnowaga pomi\u0119dzy prac\u0105 indywidualn\u0105 a zespo\u0142ow\u0105, co prawdopodobnie oznacza, \u017Ce \u200B\u200Bw ci\u0105gu dnia pracownicy cz\u0119sto przemieszczaj\u0105 si\u0119 w ramach biura. To najlepsze rozwi\u0105zanie dla dynamicznej organizacji!",
    workplace360Desc: "Podobnie jak w jodze, w biurze \u201EIntegrator\u201D najwa\u017Cniejsza jest r\xf3wnowaga. Dzi\u0119ki odpowiedniemu po\u0142\u0105czeniu \u2013 przestrzeni ukierunkowanej na produktywno\u015B\u0107 i dbaj\u0105cej o relacje spo\u0142eczne \u2013 ten profil zapewnia wszystkie niezb\u0119dne elementy do skupienia i pracy w ciszy. Jednocze\u015Bnie zach\u0119ca do korzystania z wielu innych przestrzeni. Jak sama nazwa wskazuje, w biurze \u201EIntegrator\u201D przestrzenie wsp\xf3lne, takie jak kuchnie i otwarte miejsca spotka\u0144, s\u0105 niezb\u0119dne dla odpowiedniego funkcjonowania ca\u0142o\u015Bci. Zbli\u017Ca pracownik\xf3w i pomaga tworzy\u0107 poczucie wsp\xf3lnoty.",
    campusDesc: "Biuro \u201EWyr\xf3\u017Cnik\u201D sprawia, \u017Ce na koniec dnia nie chce si\u0119 z niego wychodzi\u0107. Tutaj nadrz\u0119dnym celem jest stworzenie wyj\u0105tkowej atmosfery. Znajdziesz w nim niepowtarzalne przestrzenie wellness i udogodnienia kuchenno-jadalne, kt\xf3re pozwalaj\u0105 pracownikom zaoszcz\u0119dzi\u0107 czas i sprawiaj\u0105, \u017Ce czuj\u0105 si\u0119  komfortowo. Czy kto\u015B wspomnia\u0142 o przek\u0105skach?! Pracownik\xf3w wr\u0119cz zach\u0119ca si\u0119 do przerw, spotka\u0144 towarzyskich i relaksu w miejscu pracy.",
    startupDesc: "Je\u015Bli chodzi o biuro \u201EIntegrator\u201D, liczy si\u0119 szybko\u015B\u0107 i pomys\u0142owo\u015B\u0107. Ludzie pracuj\u0105 w \u015Bci\u015Ble wsp\xf3\u0142pracuj\u0105cych zespo\u0142ach, a ich postaw\u0119 wyr\xf3\u017Cnia odpowiedzialno\u015B\u0107 za wynik i dba\u0142o\u015B\u0107 o ka\u017Cdy szczeg\xf3\u0142 procesu.To \u015Brodowisko biurowe nieustannie si\u0119 zmienia, co oznacza, \u017Ce wi\u0119kszo\u015B\u0107 przestrzeni funkcjonuje w oparciu o wbudowan\u0105 w nie elastyczno\u015B\u0107. Przenoszenie mebli oraz tworzenie tymczasowych i prostych rozwi\u0105za\u0144 to zjawisko powszechne. Po\u0142\u0105czenie rozrywki i intensywnych sesji pracowniczych, takich jak ping-pong oraz hackathony, pozwala na zbudowanie prawdziwej wsp\xf3lnoty i odpowiedzialno\u015B\u0107 zbiorow\u0105 za wykonywan\u0105 prac\u0119.",
    engCreativeDesc: "Dla nas \u201EKreator\u201D jest biurem pe\u0142nym prawdziwych ekspert\xf3w \u2013 to nie jest typowe po\u0142\u0105czenie pojedynczych dzia\u0142\xf3w. Podobnie jak w przypadku wszystkich wybitnych dzia\u0142a\u0144 tw\xf3rczych w tym biurze wsp\xf3\u0142praca i praca zespo\u0142owa s\u0105 norm\u0105. Specjalistyczny sprz\u0119t i materia\u0142y s\u0105 prawdopodobnie cz\u0119\u015Bci\u0105 codziennej pracy. Pracownicy otrzymuj\u0105 przestrze\u0144, kt\xf3rej potrzebuj\u0105 do efektywnego realizacji swoich zada\u0144, i chocia\u017C jest to rzadszy typ biura, to przecie\u017C wyj\u0105tkowa praca wymaga wyj\u0105tkowego miejsca.",
    // Profile Key Traits: Shared Names (profileTraitMap.js)
    social: "Spo\u0142eczne",
    efficient: "Wydajne",
    flexible: "Elastyczne",
    enabled: "Post\u0119powe",
    productive: "Produktywne",
    inclusive: "Integracyjne",
    clientFocused: "Ukierunkowane na klienta",
    standardized: "Ustandaryzowane",
    // Profile Key Traits (profileTraitMap.js)
    social1Desc: "Relacje, zar\xf3wno te w biurze, jak i poza nim, s\u0105 wa\u017Cne",
    social2Desc: "Organizowane jest wiele wydarze\u0144 buduj\u0105cych wi\u0119zi spo\u0142eczne",
    social3Desc: "Pracownicy lubi\u0105 wsp\xf3lnie sp\u0119dza\u0107 czas",
    social4Desc: "Bardziej otwarte, tu nacisk k\u0142adziony jest na spo\u0142eczno\u015B\u0107",
    efficient1Desc: "Nacisk na oszcz\u0119dno\u015Bci i realizacj\u0119 bud\u017Cetu",
    efficient2Desc: "Nacisk na oszcz\u0119dno\u015Bci i produktywno\u015B\u0107",
    flexible1Desc: "Pracownicy maj\u0105 wyb\xf3r co do stylu pracy",
    flexible2Desc: "Pracownicy maj\u0105 du\u017C\u0105 swobod\u0119",
    flexible3Desc: "Stw\xf3rz przestrze\u0144 spe\u0142niaj\u0105c\u0105 Twoje wymagania",
    enabled1Desc: "Pracownicy maj\u0105 przy swoich biurkach wszystko, czego mog\u0105 potrzebowa\u0107",
    enabled2Desc: "Pracownicy maj\u0105 dost\u0119p do szerokiej gamy us\u0142ug i udogodnie\u0144",
    enabled3Desc: "Pracownicy maj\u0105 wszystko, co jest im potrzebne do wykonywania swojej pracy",
    enabled4Desc: "Zapewniony dost\u0119p do odpowiedniej technologii i sprz\u0119tu",
    enabled5Desc: "Dost\u0119p do specjalistycznego sprz\u0119tu",
    productive1Desc: "Funkcjonalna i intuicyjna aran\u017Cacja biura",
    productive2Desc: "Zorientowanie na potrzeby organizacji i kwestie finansowe",
    productive3Desc: "Wyj\u0105tkowa oferta produkt\xf3w/us\u0142ug jest tu najwa\u017Cniejsza",
    inclusive1Desc: "Dost\u0119pno\u015B\u0107 wielu typ\xf3w przestrzeni w ramach jednej powierzchni",
    inclusive2Desc: "To biuro oferuje wszystko, czego pracownik mo\u017Ce potrzebowa\u0107",
    inclusive3Desc: "Tu akceptuje si\u0119 r\xf3\u017Cne style pracy",
    clientFocused1Desc: "Pierwsze wra\u017Cenie klienta jest najwa\u017Cniejsze",
    clientFocused2Desc: "Biuro jest przyjazne dla klient\xf3w i nowych pracownik\xf3w",
    clientFocused3Desc: "Biuro jest dopracowane w ka\u017Cdym calu pod k\u0105tem potrzeb klient\xf3w i nowych pracownik\xf3w ",
    standardized1Desc: "Usprawnione procesy i systemy",
    standardized2Desc: "Normy organizacyjne dotycz\u0105ce przeznaczenia przestrzeni",
    standardized3Desc: "Modu\u0142owa elastyczno\u015B\u0107",
    standardized4Desc: "Usprawnione procesy i wyniki",
    // SpaceSummary
    spaceSummaryBarHeader: "Zalecana wielko\u015B\u0107 biura",
    spaceSummaryMeasurementTypeText: "rodzaj pomiaru",
    spaceSummaryUnitTypeText: "jednostki",
    spaceSummaryLossFactorSectionLabel: "{{factor}}",
    spaceSummaryFitFactorText: "Wsp\xf3\u0142czynnik Dopasowania",
    spaceSummaryLossFactorText: "Wsp\xf3\u0142czynnik Strat",
    spaceSummaryRSFLossFactorHelperText: "W oparciu o wsp\xf3\u0142czynnik strat, kt\xf3ry dla nieruchomo\u015Bci w miejscowo\u015Bci {{place}} wynosi {{percentage}}%, zalecamy poszukiwanie biura o powierzchni najmu od {{min}} do {{max}} {{units}}.",
    spaceSummaryNIAFitFactorHelperText: "W oparciu o wsp\xf3\u0142czynnik dopasowania, kt\xf3ry dla nieruchomo\u015Bci w {{place}} wynosi {{percentage}}%, zalecamy poszukiwanie biura o powierzchni wewn\u0119trznej netto wynosz\u0105cej {{amt}}.",
    spaceSummaryNIATooltipText: "Powierzchnia wewn\u0119trzna netto (PWN, ang. Net Internal Area) to powierzchnia u\u017Cytkowa w budynku mierzona po wewn\u0119trznym obwodzie \u015Bcian zewn\u0119trznych dla ka\u017Cdej kondygnacji, z wy\u0142\u0105czeniem pewnych okre\u015Blnych element\xf3w w niej zawartych.",
    // SFTypeRadioInput
    sfRadioInputUsableAreaTooltipText: "Powierzchnia ta obejmuje wszystkie pomieszczenia, meble i przestrze\u0144 komunikacyjn\u0105. Czasami okre\u015Bla si\u0119 j\u0105 mianem powierzchni dywanowej.",
    sfRadioInputRentableAreaTooltipText: "Jest to powierzchnia u\u017Cytkowa wyra\u017Cona w {{unitUppercase}} oraz cz\u0119\u015B\u0107 powierzchni wsp\xf3lnych budynku. Chocia\u017C nie masz mo\u017Cliwo\u015Bci korzystania z niej w ca\u0142o\u015Bci, jest to przestrze\u0144, za kt\xf3r\u0105 p\u0142acisz poczas najmu.",
    sfRadioInputUsableSquareText: "Powierzchnia U\u017Cytkowa (PU)",
    sfRadioInputRentableSquareText: "Powierzchnia Najmu (PN)",
    //floored plan request block
    flooredTitle: "Nie opuszczaj nas jeszcze!",
    flooredSubTitle: "Spraw, aby klienci na nowo odkryli przestrze\u0144.",
    flooredSubText: "Sprawd\u017A uzyskane wyniki w formie rzutu powierzchni i obejrzyj je w 3D!",
    flooredParagraphText1: "Spacer pokazuje najemcom r\xf3\u017Cne mo\u017Cliwo\u015Bci i pozwala eksperymentowa\u0107 z przestrzeni\u0105. Pomaga przekszta\u0142ci\u0107 pomys\u0142y w rzeczywisto\u015B\u0107.",
    flooredParagraphText2: "Konkretna wizja dostosowana do potrzeb klienta i ka\u017Cdego rodzaju przestrzeni.",
    flooredVideoHeading: "Zobacz przyk\u0142adow\u0105 prezentacj\u0119",
    flooredFreeText: "Nic za to nie p\u0142acisz!",
    flooredIconText1: "Udost\u0119pnij rzuty",
    flooredIconSubText1: "Konwersja plik\xf3w AutoCAD do pdf",
    flooredIconText2: "Uwzgl\u0119dnij czas realizacji",
    flooredIconSubText2: "Od jednego do dw\xf3ch tygodni",
    flooredIconText3: "Podziel si\u0119 do\u015Bwiadczeniem z innymi",
    flooredIconSubText3: "Spersonalizowane rzuty w wersji 2D i 3D",
    // MeasurementSystemRadioInput
    measurementSystemSqFeetText: "ft\xb2",
    measurementSystemSqMetersText: "m\xb2",
    measurementSystemTsuboText: "Tsubo",
    // ProfileHero
    resultsProfileHeroAnnouncementTitle: "Twoje biuro to",
    resultsProfileHeroImgAlt: "Rzut w wersji 3D przedstawiaj\u0105cy uk\u0142ad przestrzeni biurowej wygenerowany dla profilu {{profileName}} w aplikacji CBRE Spacer",
    // ProfileComparison
    profileCompModalTitle: "Chcesz wprowadzi\u0107 zmiany w swoim profilu?",
    profileCompModalText: "Utracisz wszystkie zmiany niezapisane jeszcze w aktualnym projekcie przestrzeni.",
    profileCompModalConfirmText: "Tak, chc\u0119 wprowadzi\u0107 zmiany w moim profilu",
    profileCompModalCancelText: "Nie, zachowaj m\xf3j aktualny profil",
    profileCompNavbarCancelButtonText: "Anuluj",
    profileCompNavbarUseButtonText: "U\u017Cyj tego profilu",
    profileCompCompareTitle: "Por\xf3wnaj profile, kt\xf3re w najwi\u0119kszym stopniu spe\u0142niaj\u0105 okre\u015Blone przez Ciebie kryteria",
    // ProfileComparisonColumn
    profileCompColumnSelectedText: "Wybrany profil",
    profileCompColumnSelectText: "Wybierz",
    profileCompColumnRecommendedText: " (Zalecane)",
    profileCompColumnImgAltText: "Rzut w wersji 3D przedstawiaj\u0105cy uk\u0142ad przestrzeni biurowej wygenerowany dla profilu {{profileName}} w aplikacji CBRE Spacer",
    // Test Fit Form
    testFitTitle: "Wygeneruj zestawienie Twoich wynik\xf3w w formie rzutu i obejrzyj je w wersji 3D",
    testFitSubtitle: "Chcesz si\u0119 dowiedzie\u0107, co dla Ciebie zrobimy w ramach tego programu? Przekszta\u0142cimy Twoje wyniki w niestandardowy plan pi\u0119tra, kt\xf3ry mo\u017Cesz przegl\u0105da\u0107 i udost\u0119pnia\u0107.",
    requestTestFitButtonText: "Wygeneruj spersonalizowany rzut",
    company: "Nazwa firmy",
    emptyCompanyError: "Prosz\u0119 wprowadzi\u0107 nazw\u0119 firmy",
    radioQ2yes: "\u015Awietnie! Plik wy\u015Blemy na otrzymany od Ciebie adres mailowy.",
    radioQ2no: "\u017Baden problem, spotkajmy si\u0119 i porozmawiajmy o Twoich opcjach.",
    testFitFormTitle: "Wygeneruj spersonalizowany rzut",
    testFitFormSubtitle: "Podziel si\u0119 z nami kilkoma informacjami, a my zaczniemy. Nasz zesp\xf3\u0142 zazwyczaj dostarcza gotowe plany pi\u0119ter w ci\u0105gu 3 dni roboczych.",
    testFitFormCompleted: "Twoja pro\u015Bba zosta\u0142a wys\u0142ana. Jeden z naszych przedstawicieli skontaktuje si\u0119 z Tob\u0105 za po\u015Brednictwem poczty elektronicznej.",
    testFitFormYes: "tak",
    testFitFormNo: "nie",
    testFitFormQ1: "Czy dysponujesz rzutem powierzchni, na kt\xf3rym mogliby\u015Bmy oprze\u0107 Tw\xf3j projekt?",
    testFitFormQ1No: "Nie ma problemu! Udost\u0119pnimy Ci go.",
    testFitFormQ2: "Czy dysponujesz rzutem powierzchni w formacie PDF, AutoCAD lub innym?",
    testFitTermsConditions: "Zaznaczaj\u0105c to pole, wyra\u017Casz zgod\u0119 na udzia\u0142 w tym programie wersji beta. W zamian za udzia\u0142 otrzymasz jeden bezp\u0142atny plan pi\u0119tra w kr\xf3tkiej ankiecie na temat Twoich wra\u017Ce\u0144.",
    testFitSubmitButtonText: "Wy\u015Blij pro\u015Bb\u0119 o rzut powierzchni",
    backendError: "Ups! Co\u015B posz\u0142o nie tak. Prosz\u0119 spr\xf3bowa\u0107 ponownie."
};


var $550bb4ccfffbdb32$exports = {};
$550bb4ccfffbdb32$exports = {
    // TermsOfService
    TermsTitle: "Regulamin",
    TermsIntroText: "Niniejsza umowa stanowi prawnie wi\u0105\u017C\u0105c\u0105 umow\u0119 mi\u0119dzy U\u017Cytkownikiem a firm\u0105 CBRE, Inc. (\u201ECBRE\u201D) dotycz\u0105c\u0105 dost\u0119pu do aplikacji znanej jako Spacer\xae i korzystania z niej. Uzyskanie dost\u0119pu do i skorzystanie z jakichkolwiek informacji lub us\u0142ug zawartych w niniejszej aplikacji internetowej, jest r\xf3wnoznaczne z o\u015Bwiadczeniem, \u017Ce U\u017Cytkownik zapozna\u0142 si\u0119, zrozumia\u0142 i akceptuje warunki okre\u015Blone w niniejszym Regulaminie (\u201EUmowa\u201D lub \u201ERegulamin\u201D). Terminy \u201ETy\u201D, \u201ETw\xf3j\u201D lub \u201EU\u017Cytkownik\u201D odnosz\u0105 si\u0119 \u0142\u0105cznie do danej osoby i dowolnego podmiotu, w imieniu kt\xf3rego taka osoba mo\u017Ce dzia\u0142a\u0107.",
    TermsLimitationsTitle: "Wy\u0142\u0105czenie odpowiedzialno\u015Bci.",
    TermsLimitationsA: "U\u017Cytkownik rozumie i potwierdza, \u017Ce prawo dost\u0119pu U\u017Cytkownika do Spacer\xae jest niewy\u0142\u0105czne, niepodlegaj\u0105ce sublicencjonowaniu, niezbywalne, odwo\u0142alne i mo\u017Ce zosta\u0107 zawieszone lub cofni\u0119te przez CBRE w dowolnym momencie i z dowolnego powodu.",
    TermsLimitationsB: "U\u017Cytkownik ponadto rozumie i potwierdza, \u017Ce uzyskanie dost\u0119pu do Spacer\xae nie oznacza przyznania U\u017Cytkownikowi \u017Cadnych praw w\u0142asno\u015Bci do Spacer\xae lub jakiejkolwiek powi\u0105zanej dokumentacji (w tym wszelkich nowych wyda\u0144, modyfikacji lub ulepsze\u0144), kt\xf3ra w ca\u0142o\u015Bci pozostaje i pozostanie wy\u0142\u0105czn\u0105 w\u0142asno\u015Bci\u0105 CBRE, co obejmuje mi\u0119dzy innymi prawa autorskie do niej, powi\u0105zane patenty, patenty na wz\xf3r, znaki towarowe, wizerunek handlowy, tajemnice handlowe i inne prawa w\u0142asno\u015Bci wynikaj\u0105ce z obowi\u0105zuj\u0105cego prawa lub konwencji mi\u0119dzynarodowych (\u0142\u0105cznie \u201EPrawa W\u0142asno\u015Bci\u201D). Zob. Artyku\u0142 2 (W\u0142asno\u015B\u0107) poni\u017Cej. CBRE niniejszym wyra\u017Anie zastrzega wszelkie prawa do Spacer\xae, kt\xf3re nie s\u0105 wyra\u017Anie przyznane U\u017Cytkownikowi na mocy niniejszej Umowy.",
    TermsLimitationsC: "Z wyj\u0105tkiem przypadk\xf3w przewidzianych w niniejszej umowie lub wyra\u017Anego upowa\u017Cnienia udzielonego U\u017Cytkownikowi przez CBRE na pi\u015Bmie, U\u017Cytkownik nie b\u0119dzie: (i) modyfikowa\u0107, t\u0142umaczy\u0107, odtwarza\u0107 kodu \u017Ar\xf3d\u0142owego, dekompilowa\u0107, demontowa\u0107, podejmowa\u0107 pr\xf3b rekonstrukcji, identyfikacji ani wykrycia jakiegokolwiek kodu \u017Ar\xf3d\u0142owego, le\u017C\u0105cych u podstaw aplikacji koncepcji, le\u017C\u0105cych u podstaw aplikacji rozwi\u0105za\u0144 technologicznych lub algorytm\xf3w interfejsu u\u017Cytkownika, tworzy\u0107 prac pochodnych ani kopiowa\u0107 Spacer\xae; (ii) usuwa\u0107, zmienia\u0107 ani zakrywa\u0107 jakichkolwiek informacji o prawach autorskich lub znakach towarowych lub innych informacji o prawach w\u0142asno\u015Bci zawartych w Spacer\xae; (iii) dokonywa\u0107 cesji, udziela\u0107 sublicencji lub w inny spos\xf3b przekazywa\u0107 swoich praw dost\u0119pu, u\u017Cytkowania lub innych praw ani delegowa\u0107 swoich obowi\u0105zk\xf3w wynikaj\u0105cych z niniejszej Umowy; ani (iv) bez uszczerbku dla powy\u017Cszego, wykorzystywa\u0107 Spacer\xae do tworzenia konkurencyjnych produkt\xf3w lub us\u0142ug lub w jakimkolwiek celu innym ni\u017C uzasadnione cele biznesowe zwi\u0105zane z dzia\u0142alno\u015Bci\u0105 U\u017Cytkownika.",
    TermsLimitationsD: "W przypadku powzi\u0119cia wiadomo\u015Bci o jakimkolwiek nieautoryzowanym u\u017Cyciu Spacer\xae lub jakimkolwiek mo\u017Cliwym naruszeniu Praw W\u0142asno\u015Bci, U\u017Cytkownik zobowi\u0105zuje si\u0119 do niezw\u0142ocznego powiadomienia o tym CBRE w formie pisemnej.",
    TermsLimitationsE: "W \u017Cadnym momencie w trakcie lub po okresie obowi\u0105zywania niniejszej Umowy U\u017Cytkownik nie z\u0142o\u017Cy wniosku o zarejestrowanie jakichkolwiek praw autorskich, znak\xf3w towarowych lub innych oznacze\u0144, kt\xf3re mog\u0142yby wp\u0142yn\u0105\u0107 na w\u0142asno\u015B\u0107 Prawa W\u0142asno\u015Bci, ani nie z\u0142o\u017Cy \u017Cadnych dokument\xf3w do jakiegokolwiek organu w\u0142adzy publicznej w celu podj\u0119cia jakichkolwiek dzia\u0142a\u0144, kt\xf3re mia\u0142yby wp\u0142yw na w\u0142asno\u015B\u0107 Praw W\u0142asno\u015Bci, w tym prawa w\u0142asno\u015Bci do Spacer\xae, znaku Spacer\xae i innych sk\u0142adnik\xf3w aplikacji nale\u017C\u0105cych do CBRE. Spacer\xae jest znakiem towarowym i us\u0142ugowym CBRE.",
    TermsLimitationsF: "U\u017Cytkownik o\u015Bwiadcza i potwierdza, \u017Ce ma prawo do przekazania wszelkich materia\u0142\xf3w publikowanych w ramach Spacer\xae lub informacji wykorzystywanych w zwi\u0105zku z Spacer\xae i niniejszym udziela CBRE niewy\u0142\u0105cznego, bezp\u0142atnego, og\xf3lno\u015Bwiatowego, nieodwo\u0142alnego, wieczystego prawa i licencji na u\u017Cytkowanie, powielanie, modyfikowanie, rozpowszechnianie, tworzenie dzie\u0142 pochodnych i publikacj\u0119 takich materia\u0142\xf3w i informacji wed\u0142ug uznania CBRE. U\u017Cytkownik przyjmuje do wiadomo\u015Bci, \u017Ce jest odpowiedzialny za wszelkie materia\u0142y i informacje przekazane przez U\u017Cytkownika, w tym za ich legalno\u015B\u0107, wiarygodno\u015B\u0107, stosowno\u015B\u0107, oryginalno\u015B\u0107 i prawa autorskie. Licencja udzielona CBRE przez U\u017Cytkownika na mocy niniejszej Umowy obowi\u0105zuje po zako\u0144czeniu korzystania przez U\u017Cytkownika ze Spacer\xae. Wszelkie materia\u0142y i informacje przekazane przez U\u017Cytkownika b\u0119d\u0105 uwa\u017Cane za jawne i niezastrze\u017Cone oraz traktowane jako takie przez CBRE i mog\u0105 by\u0107 wykorzystywane przez CBRE zgodnie z niniejsz\u0105 Umow\u0105 bez powiadomienia U\u017Cytkownika i bez \u017Cadnej odpowiedzialno\u015Bci ze strony CBRE.",
    TermsOwnershipTitle: "W\u0142asno\u015B\u0107.",
    TermsOwnershipText: "Spacer\xae, j\u0119zyk programowania, oprogramowanie i dokumentacja oraz wszelkie inne materia\u0142y lub tre\u015Bci udost\u0119pniane w ramach Spacer\xae, a tak\u017Ce wszelkie ulepszenia, modyfikacje, prace pochodne, aktualizacje lub zmiany Spacer\xae i wszystkie ich kopie s\u0105 zastrze\u017Cone na rzecz CBRE i pozostaj\u0105 one wy\u0142\u0105czn\u0105 w\u0142asno\u015Bci\u0105 CBRE bez wzgl\u0119du na okoliczno\u015Bci, co obejmuje mi\u0119dzy innymi wszelkie prawa do patent\xf3w, prawa autorskie, znaki towarowe i tajemnice handlowe powi\u0105zane z Spacer\xae oraz ulepsze\u0144, modyfikacji, prac pochodnych i ich zmian. U\u017Cytkownik rozumie, \u017Ce powy\u017Csze obejmuje tajemnice handlowe oraz informacje, kt\xf3re s\u0105 poufne i zastrze\u017Cone na rzecz CBRE i wyra\u017Ca zgod\u0119 na podj\u0119cie wszelkich niezb\u0119dnych dzia\u0142a\u0144 w celu ochrony poufno\u015Bci takich informacji. U\u017Cytkownik nie ma prawa sprzedawa\u0107, przenosi\u0107, publikowa\u0107, ujawnia\u0107, wy\u015Bwietla\u0107 ani w inny spos\xf3b udost\u0119pnia\u0107 Spacer\xae, ani te\u017C tworzy\u0107, ani udost\u0119pnia\u0107 jakichkolwiek ulepsze\u0144, modyfikacji, aktualizacji, prac pochodnych lub ich zmian lub kopii innym osobom. Wypowiedzenie niniejszej Umowy stanowi uzupe\u0142nienie i nie zast\u0119puje jakichkolwiek \u015Brodk\xf3w prawnych przys\u0142uguj\u0105cych CBRE zar\xf3wno z mocy przepis\xf3w prawa, jak i na zasadzie s\u0142uszno\u015Bci. Zobowi\u0105zania wynikaj\u0105ce z niniejszej Umowy pozostaj\u0105 w mocy po rozwi\u0105zaniu niniejszej Umowy.",
    TermsTerminationTitle: "Wypowiedzenie; Skutek Wypowiedzenia; \u015Arodki Zaradcze.",
    TermsTerminationA: "Bez uszczerbku dla jakichkolwiek innych \u015Brodk\xf3w, CBRE ma prawo zmieni\u0107, ograniczy\u0107, zawiesi\u0107, przerwa\u0107 lub wypowiedzie\u0107 niniejsz\u0105 Umow\u0119 i/lub u\u017Cytkowanie przez U\u017Cytkownika ca\u0142o\u015Bci lub cz\u0119\u015Bci Spacer\xae, ze skutkiem natychmiastowym, automatycznie, za uprzednim powiadomieniem lub bez takiego powiadomienia i z wy\u0142\u0105czeniem prawa do przed\u0142o\u017Cenia sprawy do rozstrzygni\u0119cia przez s\u0105dy lub trybuna\u0142y, z jakiegokolwiek powodu lub bez powodu. U\u017Cytkownik potwierdza, \u017Ce CBRE nie ma obowi\u0105zku dostarczania Spacer\xae i \u017Ce CBRE nie ponosi odpowiedzialno\u015Bci wobec U\u017Cytkownika ani \u017Cadnej innej strony za jakiekolwiek ograniczenia, zawieszenie, przerwanie, rozwi\u0105zanie lub modyfikacj\u0119 Spacer\xae.",
    TermsTerminationB: "U\u017Cytkownik przyjmuje do wiadomo\u015Bci, \u017Ce zobowi\u0105zania przyj\u0119te przez U\u017Cytkownika wobec CBRE na mocy niniejszej Umowy maj\u0105 wyj\u0105tkowy i niezast\u0105piony charakter, kt\xf3rych utrata przyniesie nieodwracaln\u0105 szkod\u0119 CBRE i kt\xf3rych nie mo\u017Cna zast\u0105pi\u0107 samym odszkodowaniem pieni\u0119\u017Cnym, ze wzgl\u0119du na co, w przypadku jakiegokolwiek naruszenia lub przewidywanego naruszenia przez U\u017Cytkownika, CBRE b\u0119dzie uprawniona do wyst\u0105pienia o wydanie przez s\u0105d zarz\u0105dzenia tymczasowego lub do innego godziwego zado\u015B\u0107uczynienia (bez konieczno\u015Bci z\u0142o\u017Cenia jakiejkolwiek kaucji lub por\u0119czenia). U\u017Cytkownik nieodwo\u0142alnie zrzeka si\u0119 wszelkiego prawa do wyst\u0105pienia o wydanie przez s\u0105d zarz\u0105dzenia tymczasowego lub do innego godziwego zado\u015B\u0107uczynienia.",
    TermsDisclaimerTitle: "Nota Prawna i Wy\u0142\u0105czenie Odpowiedzialno\u015Bci.",
    TermsDisclaimerA: "Spacer\xae jest udost\u0119pniany U\u017Cytkownikowi na zasadzie \u201Etak jak jest\u201D i \u201Ew miar\u0119 dost\u0119pno\u015Bci\u201D bez udzielania \u017Cadnych gwarancji. CBRE WY\u0141\u0104CZA SWOJ\u0104 ODPOWIEDZIALNO\u015A\u0106 Z TYTU\u0141U WSZELKICH GWARANCJI, WYRA\u0179NYCH LUB DOROZUMIANYCH, W TYM MI\u0118DZY INNYMI DOROZUMIANYCH GWARANCJI WARTO\u015ACI HANDLOWEJ, PRZYDATNO\u015ACI DO OKRE\u015ALONEGO CELU I NIENARUSZANIA PRZEPIS\xd3W PRAWA. CBRE W \u017BADEN SPOS\xd3B NIE GWARANTUJE, \u017BE Spacer\xae SPE\u0141NI WYMAGANIA U\u017BYTKOWNIKA LUB JAK\u0104KOLWIEK SZCZEG\xd3LN\u0104 NORM\u0118. NIEKT\xd3RE PA\u0143STWA NIE ZEZWALAJ\u0104 NA WY\u0141\u0104CZENIE GWARANCJI DOROZUMIANYCH, WI\u0118C POWY\u017BSZE WY\u0141\u0104CZENIE MO\u017BE NIE MIE\u0106 ZASTOSOWANIA DO DANEGO U\u017BYTKOWNIKA. W takim przypadku odpowiedzialno\u015B\u0107 CBRE zostanie ograniczona w maksymalnym zakresie dopuszczalnym na mocy obowi\u0105zuj\u0105cych przepis\xf3w prawa. \u017BADNE USTNE ANI PISEMNE INFORMACJE ANI PORADY UDZIELANE PRZEZ CBRE, JEJ PRZEDSTAWICIELI LUB PRACOWNIK\xd3W NIE STANOWI\u0104 JAKIEGOKOLWIEK RODZAJU GWARANCJI. NIE UDZIELA SI\u0118 \u017BADNEJ GWARANCJI, \u017BE Spacer\xae LUB JAKIEKOLWIEK INFORMACJE DOSTARCZANE U\u017BYTKOWNIKOWI S\u0104 WOLNE OD B\u0141\u0118D\xd3W LUB \u017BE KORZYSTANIE ZE Spacer\xae B\u0118DZIE ODBYWA\u0141O SI\u0118 W SPOS\xd3B NIEPRZERWANY, NA BIE\u017B\u0104CO, KOMPLETNY LUB WOLNY OD WIRUS\xd3W LUB INNYCH SZKODLIWYCH KOMPONENT\xd3W I NIE UDZIELA SI\u0118 \u017BADNEJ GWARANCJI, \u017BE POWY\u017BSZE ZOSTANIE NAPRAWIONE. CBRE NIE GWARANTUJE ANI NIE SK\u0141ADA \u017BADNYCH O\u015AWIADCZE\u0143 DOTYCZ\u0104CYCH KORZYSTANIA LUB EFEKT\xd3W KORZYSTANIA ZE Spacer\xae. CBRE NIE PONOSI ODPOWIEDZIALNO\u015ACI ZA JAKIEKOLWIEK SZKODY PO\u015AREDNIE, SZCZEG\xd3LNE, UBOCZNE, NAST\u0118PCZE LUB STRATY MORALNE (W TYM MI\u0118DZY INNYMI SZKODY Z TYTU\u0141U UTRATY UDZIA\u0141U W RYNKU, UTRATY ZYSK\xd3W, UTRATY DOCHOD\xd3W, UTRATY OSZCZ\u0118DNO\u015ACI, PRZERW W DZIA\u0141ANIU SYSTEMU KOMPUTEROWEGO, UTRATY WARTO\u015ACI FIRMY, UTRATY MO\u017BLIWO\u015ACI U\u017BYTKOWANIA, UTRATY DANYCH LUB INNYCH STRAT NIEMATERIALNYCH), CZY TO W WYNIKU NARUSZENIA UMOWY, CZYN\xd3W NIEDOZWOLONYCH (W TYM ZANIEDBANIA), NA PODSTAWIE ODPOWIEDZIALNO\u015ACI ZA PRODUKT LUB W INNY SPOS\xd3B, NAWET JE\u015ALI CBRE LUB JEJ PRZEDSTAWICIELE ZOSTALI POINFORMOWANI O MO\u017BLIWO\u015ACI WYST\u0104PIENIA TAKICH SZK\xd3D, A TAK\u017BE W PRZYPADKU GDY OKRE\u015ALONY W NINIEJSZEJ UMOWIE \u015ARODEK ZARADCZY NIE SPE\u0141NI\u0141 SWOJEGO ZASADNICZEGO CELU.",
    TermsDisclaimerB: "CA\u0141KOWITA ODPOWIEDZIALNO\u015A\u0106 CBRE ZA SZKODY Z JAKICHKOLWIEK PRZYCZYN NIE PRZEKROCZY OP\u0141ATY ZAP\u0141ACONEJ PRZEZ U\u017BYTKOWNIKA ZA Spacer\xae W OKRESIE DWUNASTU (12) MIESI\u0118CY PRZED ZDARZENIEM, KT\xd3RE RZEKOMO SPOWODOWA\u0141O TAKIE SZKODY. U\u017BYTKOWNIK POTWIERDZA, \u017BE WSZELKIE ROSZCZENIA WYNIKAJ\u0104CE LUB ZWI\u0104ZANE Z Spacer\xae LUB W INNY SPOS\xd3B ZWI\u0104ZANE Z NINIEJSZ\u0104 UMOW\u0104 MUSZ\u0104 ZOSTA\u0106 WNIESIONE W CI\u0104GU JEDNEGO (1) ROKU OD MOMENTU ZAISTNIENIA PRZYCZYNY WNIESIENIA TAKIEGO ROSZCZENIA. W PRZECIWNYM WYPADKU ROSZCZENIE TO ULEGNIE PRZEDAWNIENIU.",
    TermsDisclaimerC: "NIEKT\xd3RE JURYSDYKCJE MOG\u0104 NIE ZEZWALA\u0106 NA OGRANICZENIE LUB WY\u0141\u0104CZENIE ODPOWIEDZIALNO\u015ACI OKRE\u015ALONE POWY\u017BEJ, DLATEGO TE\u017B POWY\u017BSZE OGRANICZENIE LUB WY\u0141\u0104CZENIE MO\u017BE NIE ZNAJDOWA\u0106 ZASTOSOWANIA DO DANEGO U\u017BYTKOWNIKA. W takim przypadku odpowiedzialno\u015B\u0107 CBRE zostanie ograniczona w maksymalnym zakresie dopuszczalnym na mocy obowi\u0105zuj\u0105cych przepis\xf3w prawa. Wy\u0142\u0105czenie odpowiedzialno\u015Bci, wy\u0142\u0105czne \u015Brodki zaradcze i ograniczenie odpowiedzialno\u015Bci, o kt\xf3rych mowa powy\u017Cej stanowi\u0105 zasadnicze elementy, na kt\xf3rych opiera si\u0119 niniejsza Umowa pomi\u0119dzy CBRE a U\u017BYTKOWNIKIEM. CBRE nie by\u0142aby w stanie zapewni\u0107 Spacer\xae na zasadach komercyjnych i nie zawar\u0142aby niniejszej Umowy bez takich ogranicze\u0144. Ograniczenia te b\u0119d\u0105 obowi\u0105zywa\u0107 r\xf3wnie\u017C po wyga\u015Bni\u0119ciu niniejszej Umowy.",
    TermsIndemnificationTitle: "Zwolnienie z odpowiedzialno\u015Bci.",
    TermsIndemnificationText: "Zgodnie z wyborem i \u017C\u0105daniem CBRE U\u017Cytkownik na w\u0142asny koszt zwolni CBRE i jej sp\xf3\u0142ki zale\u017Cne, powi\u0105zane, kierownictwo, pracownik\xf3w, agent\xf3w, podmioty dzia\u0142aj\u0105ce pod wsp\xf3ln\u0105 mark\u0105, podmioty z ni\u0105 zrzeszone i innych partner\xf3w handlowych z odpowiedzialno\u015Bci z tytu\u0142u wszelkich strat, koszt\xf3w, odszkodowa\u0144, zobowi\u0105za\u0144, rozlicze\u0144 i wydatk\xf3w (w tym mi\u0119dzy innymi koszt\xf3w i honorari\xf3w prawnik\xf3w), wynikaj\u0105cych lub zwi\u0105zanych z jakimkolwiek roszczeniem, pozwem lub zarzutem strony trzeciej zwi\u0105zanym lub wynikaj\u0105cym z: (a) jakiejkolwiek transakcji lub sporu mi\u0119dzy U\u017Cytkownikiem a jak\u0105kolwiek osob\u0105 trzeci\u0105; (b) fakt\xf3w lub domniemanych fakt\xf3w, kt\xf3re stanowi\u0142yby naruszenie kt\xf3regokolwiek z o\u015Bwiadcze\u0144, zapewnie\u0144 lub zobowi\u0105za\u0144 U\u017Cytkownika wynikaj\u0105cych z niniejszej Umowy lub wszelkich obowi\u0105zuj\u0105cych przepis\xf3w prawa, zasad lub regulacji, nawet w przypadku gdy niniejsza Umowa do nich nie nawi\u0105zuje; (c) wszelkich materia\u0142\xf3w U\u017Cytkownika, informacji lub tre\u015Bci przekazanych za po\u015Brednictwem lub w ramach Spacer\xae; (d) naruszenia przez U\u017Cytkownika jakichkolwiek praw os\xf3b trzecich; (e) u\u017Cycia lub niew\u0142a\u015Bciwego u\u017Cycia Spacer\xae przez U\u017Cytkownika; lub (f) zaniedbania lub winy umy\u015Blnej U\u017Cytkownika. CBRE ma prawo jednostronnie przeprowadzi\u0107 i zarz\u0105dza\u0107 swoj\u0105 obron\u0105 oraz zatrudni\u0107 wybranego przez siebie obro\u0144c\u0119 na koszt U\u017Cytkownika.",
    TermsGeneralTitle: "Postanowienia og\xf3lne.",
    TermsGeneralA: "Ca\u0142a umowa/Brak Niezamierzonego Zrzeczenia Si\u0119. Niniejsza Umowa stanowi ca\u0142o\u015B\u0107 umowy mi\u0119dzy CBRE a U\u017Cytkownikiem w odniesieniu do Spacer\xae i wszystkich kwestii b\u0119d\u0105cych przedmiotem niniejszej Umowy oraz zast\u0119puje wszystkie wcze\u015Bniejsze umowy mi\u0119dzy CBRE a U\u017Cytkownikiem dotycz\u0105ce Spacer\xae, je\u015Bli takie istnia\u0142y. Niewyegzekwowanie przez CBRE jakiegokolwiek postanowienia niniejszej Umowy nie b\u0119dzie interpretowane jako odst\u0105pienie od takiego postanowienia lub zrzeczenie si\u0119 jakiegokolwiek prawa.",
    TermsGeneralB: "Powiadomienia. Powiadomienia na rzecz U\u017Cytkownika b\u0119d\u0105 mia\u0142y form\u0119 pisemn\u0105 i mog\u0105 by\u0107 dostarczane za po\u015Brednictwem poczty elektronicznej lub poprzez publikacj\u0119 takiego powiadomienia na stronie aplikacji Spacer\xae lub na stronie www.cbre.com/spacer. Powiadomienia na rzecz CBRE b\u0119d\u0105 przesy\u0142ane do nas za po\u015Brednictwem poczty elektronicznej na adres spacersupport@cbre.com, a ich kopia zostanie wys\u0142ana polecon\u0105 poczt\u0105 ameryka\u0144sk\u0105 na nast\u0119puj\u0105cy adres siedziby CBRE: 400 S. Hope Street, 25th Floor, Los Angeles, CA 90071, z dopiskiem: General Counsel\u2019s Office. Zawiadomienia b\u0119d\u0105 uwa\u017Cane za dor\u0119czone jeden (1) dzie\u0144 roboczy po wys\u0142aniu poczt\u0105 elektroniczn\u0105 (chyba \u017Ce nadawca otrzyma odpowied\u017A wskazuj\u0105c\u0105, \u017Ce wiadomo\u015Bci nie mo\u017Cna by\u0142o dostarczy\u0107) lub trzy dni robocze po publikacji powiadomienia na stronie CBRE (w przypadku CBRE), bez wzgl\u0119du na to, czy zostanie ono odebrane lub nie.",
    TermsGeneralC: "Prawo w\u0142a\u015Bciwe. Niniejsza Umowa podlega i b\u0119dzie interpretowana zgodnie z prawem stanu Kalifornia, z wy\u0142\u0105czeniem mocy obowi\u0105zuj\u0105cej przepis\xf3w kolizyjnych. CBRE i U\u017Cytkownik niniejszym poddaj\u0105 si\u0119 wy\u0142\u0105cznie jurysdykcji s\u0105d\xf3w w stanie Kalifornia. Zastosowanie Konwencji Narod\xf3w Zjednoczonych o umowach mi\u0119dzynarodowej sprzeda\u017Cy towar\xf3w (1980) do niniejszej Umowy zostaje niniejszym w ca\u0142o\u015Bci wy\u0142\u0105czone. U\u017Cytkownik niniejszym potwierdza, \u017Ce za siedzib\u0119 Spacer\xae uznaje si\u0119 wy\u0142\u0105cznie stan Kalifornia i \u017Ce stanowi on us\u0142ug\u0119 pasywn\u0105, kt\xf3ra nie daje podstaw do jurysdykcji osobowej w stosunku do CBRE, ani szczeg\xf3lnej, ani og\xf3lnej, w jurysdykcjach innych ni\u017C stan Kalifornia.",
    TermsGeneralD: "Rozstrzyganie spor\xf3w. Wszelkie spory, roszczenia lub kontrowersje wynikaj\u0105ce lub zwi\u0105zane z niniejsz\u0105 Umow\u0105 lub jej naruszeniem, wykonaniem, interpretacj\u0105 lub wa\u017Cno\u015Bci\u0105, w tym okre\u015Blenie zakresu lub mo\u017Cliwo\u015Bci zastosowania arbitra\u017Cu w odniesieniu do niniejszej Umowy zostan\u0105 rozstrzygni\u0119te w drodze arbitra\u017Cu. Post\u0119powanie arbitra\u017Cowe b\u0119dzie zarz\u0105dzane przez Judicial Arbitration and Mediation Service (JAMS) i b\u0119dzie prowadzone przez jednego arbitra. Ponadto U\u017Cytkownik potwierdza, \u017Ce ani U\u017Cytkownik, ani CBRE nie po\u0142\u0105cz\u0105 w post\u0119powaniu arbitra\u017Cowym \u017Cadnego roszczenia z roszczeniem jakiejkolwiek innej osoby lub podmiotu; \u017Ce roszczenia nie b\u0119d\u0105 rozstrzygane w ramach pow\xf3dztwa grupowego; oraz \u017Ce ani U\u017Cytkownik, ani CBRE nie b\u0119d\u0105 dochodzi\u0107 \u017Cadnych roszcze\u0144 w charakterze przedstawiciela w imieniu jakiegokolwiek podmiotu. Niezale\u017Cnie od powy\u017Cszego, U\u017Cytkownik potwierdza, \u017Ce CBRE ma prawo wyst\u0105pi\u0107 o zabezpieczenie roszcze\u0144 w drodze nakazu lub zakazu s\u0105dowego (lub r\xf3wnowa\u017Cnego tymczasowego \u015Brodka prawnego w trybie pilnym) w dowolnej jurysdykcji. W przypadku gdy U\u017Cytkownik podda sp\xf3r z CBRE pod rozstrzygni\u0119cie s\u0105du arbitra\u017Cowego, CBRE zgadza si\u0119 zap\u0142aci\u0107 cz\u0119\u015B\u0107 pocz\u0105tkowej op\u0142aty za z\u0142o\u017Cenie takiego wniosku przekraczaj\u0105c\u0105 kwot\u0119 250 USD; po dokonaniu pocz\u0105tkowej op\u0142aty za z\u0142o\u017Cenie wniosku do s\u0105du arbitra\u017Cowego strony po r\xf3wno podziel\u0105 si\u0119 kosztami post\u0119powania arbitra\u017Cowego. U\u017Cytkownik zobowi\u0105zuje si\u0119 nie wszczyna\u0107 ani nie prowadzi\u0107 \u017Cadnego post\u0119powania przeciwko CBRE poza z\u0142o\u017Ceniem poddaniem sporu z CBRE pod rozstrzygni\u0119cie s\u0105du arbitra\u017Cowego zgodnie z niniejszym artyku\u0142em. WA\u017BNE: WYRA\u017BANIE PRZEZ U\u017BYTKOWNIKA ZGODY NA ZWI\u0104ZANIE NINIEJSZ\u0104 UMOW\u0104 OZNACZA ZRZECZENIE SI\u0118 PRZEZ NIEGO PRZYS\u0141UGUJ\u0104CEGO MU PRAWA DO DOCHODZENIA SWOICH ROSZCZE\u0143 NA DRODZE S\u0104DOWEJ ORAZ DO PROCESU.",
    TermsGeneralE: "Klauzula salwatoryjna. W przypadku gdy cz\u0119\u015B\u0107 niniejszej Umowy zostanie uznana za niewykonaln\u0105, niewykonalna cz\u0119\u015B\u0107 zostanie zmieniona tylko w zakresie niezb\u0119dnym do zapewnienia jej wykonalno\u015Bci, a pozosta\u0142e postanowienia niniejszej Umowy pozostan\u0105 w mocy.",
    TermsGeneralF: "Cesja. U\u017Cytkownik nie ma prawa dokona\u0107 cesji niniejszej Umowy bez uzyskania uprzedniej zgody CBRE na pi\u015Bmie. Wszelkie pr\xf3by dokonania cesji podj\u0119te bez zgody CBRE b\u0119d\u0105 niewa\u017Cne. CBRE zastrzega prawo do przeniesienia niniejszej Umowy na dowoln\u0105 osob\u0119 trzeci\u0105. Niniejsza Umowa oraz wynikaj\u0105ce z niej prawa i obowi\u0105zki ka\u017Cdej ze stron b\u0119d\u0105 wi\u0105\u017C\u0105ce dla ich odpowiednich nast\u0119pc\xf3w prawnych i cesjonariuszy.",
    TermsGeneralG: "Zmiany. CBRE ma prawo zmieni\u0107 brzmienie dowolnego z warunk\xf3w okre\u015Blonych w niniejszej Umowie w dowolnym czasie i wed\u0142ug wy\u0142\u0105cznego uznania CBRE poprzez publikacj\u0119 powiadomienia o takiej zmianie lub nowej wersji umowy na stronie aplikacji Spacer\xae pod adresem www.cbre.com/spacer lub umieszczaj\u0105c odpowiedni komunikat lub podobne powiadomienie w aplikacji Spacer\xae. W przypadku gdy wprowadzona zmiana oka\u017Ce si\u0119 by\u0107 nie do przyj\u0119cia dla U\u017Cytkownika, jedynym \u015Brodkiem prawnym przys\u0142uguj\u0105cym U\u017Cytkownikowi b\u0119dzie zaprzestanie korzystania przez U\u017Cytkownika z aplikacji Spacer\xae",
    TermsGeneralH: "Rozbie\u017Cno\u015Bci. W przypadku zaistnienia jakichkolwiek rozbie\u017Cno\u015Bci pomi\u0119dzy warunkami okre\u015Blonymi w niniejszej Umowie a jak\u0105kolwiek obowi\u0105zuj\u0105c\u0105 umow\u0105 licencyjn\u0105 zawart\u0105 pomi\u0119dzy U\u017Cytkownikiem a CBRE w odniesieniu do aplikacji Spacer\xae, warunki takiej umowy licencyjnej b\u0119d\u0105 mia\u0142y pierwsze\u0144stwo przed rozbie\u017Cnymi warunkami okre\u015Blonymi w niniejszej Umowie."
};


var $18425fd0bb528346$exports = {};
$18425fd0bb528346$exports = {
    // Quiz
    exitQuizButtonTitle: "Wyjd\u017A z kwestionariusza",
    // QuizProgressLabel
    progressLabelText: "uko\u0144czono",
    // QuizNavigationButton
    quizNavBackButtonShortenedText: "Wr\xf3\u0107",
    quizNavBackButtonFullLengthText: "Poprzednie pytanie",
    quizNavNextButtonShortenedText: "Dalej",
    quizNavNextButtonFullLengthText: "Nast\u0119pne pytanie",
    // QuizExitSlide
    quizExitSubtitle: "Analizujemy Twoje odpowiedzi, aby m\xf3c przedstawi\u0107 Ci zalecenia co do idealnego miejsca pracy dla Twojej organizacji.",
    quizExitImgAlt: "Grafika przedstawiaj\u0105ca dwie osoby przybijaj\u0105ce pi\u0105tk\u0119 znajduj\u0105ca si\u0119 na stronie Kwestionariusz aplikacji CBRE Spacer",
    // Question Unit Text (questionUnitMap.js)
    question1Text: "Zaczynamy\u2026 Jak opisa\u0142by\u015B przeznaczenie swojego przysz\u0142ego biura?",
    question2Text: "Jak my\u015Blisz, co w Twojej organizacji jest najbardziej atrakcyjne dla kandydat\xf3w staraj\u0105cych si\u0119 o prac\u0119?",
    question3Text: "Jakie s\u0105 najwa\u017Cniejsze rzeczy, na kt\xf3re zwracasz uwag\u0119 przy zatrudnianiu nowych cz\u0142onk\xf3w zespo\u0142u?",
    question4Text: "Jak w ci\u0105gu najbli\u017Cszych pi\u0119ciu lat b\u0119dzie zmienia\u0107 si\u0119 wielko\u015B\u0107 Twojej organizacji?",
    question5Text: "Jak wygl\u0105da typowy dzie\u0144 pracy Twoich pracownik\xf3w?",
    question6Text: "Co my\u015Blisz o w\u0142asnych biurkach?",
    question7Text: "Gdzie faktycznie pracownicy b\u0119d\u0105 wykonywa\u0107 swoj\u0105 prac\u0119 podczas pracy w biurze?",
    question8Text: "Jaki str\xf3j obowi\u0105zuje Twoich pracownik\xf3w podczas pracy w biurze?",
    question9Text: "Gdzie b\u0119dzie wykonywana praca?",
    question10Text: "Jak\u0105 atmosfer\u0119 chcia\u0142by\u015B stworzy\u0107 w Twoim biurze?",
    question11Text: "Co, poza samym \u201Emiejscem do pracy\u201D, chcia\u0142by\u015B zapewni\u0107 swoim pracownikom?",
    question12Text: "Kt\xf3re z poni\u017Cszych okre\u015Ble\u0144 najlepiej do Ciebie pasuje?",
    // Quiz Answers (questionUnitMap.js)
    pickOnePlaceholder: "Wybierz jedno...",
    selectFromListPlaceholder: "Wybierz z listy...",
    firstResponseTooltipText: "Wybierz swoj\u0105 pierwsz\u0105 odpowied\u017A",
    locatedSomewhereElseLabel: "Obecnie nasze biuro mie\u015Bci si\u0119 w innej lokalizacji.",
    q1AnswerText1: "Uwa\u017Camy, \u017Ce nasze biuro to po pierwsze",
    q1AnswerText2: "po drugie",
    q1AnswerText3: "i po trzecie",
    q1Option1Text: "drugi dom dla naszych pracownik\xf3w",
    q1Option2Text: "motor zmian organizacyjnych",
    q1Option3Text: "miejsce pozwalaj\u0105ce na skupienie si\u0119",
    q1Option4Text: "inkubator prze\u0142omowych pomys\u0142\xf3w",
    q1Option5Text: "narz\u0119dzie przyci\u0105gaj\u0105ce najwi\u0119ksze talenty",
    q1Option6Text: "wizyt\xf3wka naszej marki",
    q1Option7Text: "przestrze\u0144 umo\u017Cliwiaj\u0105ca rozw\xf3j i nauk\u0119",
    q1Option8Text: "miejsce spotka\u0144 i przebywania z innymi lud\u017Ami",
    q1Option9Text: "niezb\u0119dny koszt, kt\xf3ry staramy si\u0119 zredukowa\u0107 do koniecznego minimum",
    q2AnswerText1: "Powody, dla kt\xf3rych ludzie do\u0142\u0105czaj\u0105 do naszej organizacji, to po pierwsze",
    q2AnswerText2: "po drugie",
    q2AnswerText3: "i po trzecie",
    q2Option1Text: "kultura organizacyjna",
    q2Option2Text: "konkurencyjne wynagrodzenie",
    q2Option3Text: "reputacja firmy",
    q2Option4Text: "atrakcyjne \u015Bwiadczenia pracownicze i dodatki",
    q2Option5Text: "elastyczne godziny pracy",
    q2Option6Text: "pracuj\u0105cy w niej ludzie i kadra zarz\u0105dzaj\u0105ca",
    q2Option7Text: "atmosfera panuj\u0105ca w biurze",
    q2Option8Text: "nasze cele i misja",
    q3AnswerText1: "Cechy, kt\xf3rych poszukujemy u zatrudnianych pracownik\xf3w, to po pierwsze",
    q3AnswerText2: "po drugie",
    q3AnswerText3: "i po trzecie",
    q3Option1Text: "umiej\u0119tno\u015Bci",
    q3Option2Text: "do\u015Bwiadczenie",
    q3Option3Text: "dopasowanie kulturowe",
    q3Option4Text: "kwalifikacje",
    q3Option5Text: "sie\u0107 kontakt\xf3w",
    q3Option6Text: "ciekawo\u015B\u0107 / dociekliwo\u015B\u0107",
    q4AnswerText: "B\u0119dziemy",
    q4Option1Text: "nieznacznie rosn\u0105\u0107 ka\u017Cdego roku",
    q4Option2Text: "znacznie rosn\u0105\u0107 ka\u017Cdego roku",
    q4Option3Text: "utrzymywa\u0107 wielko\u015B\u0107 naszej organizacji mniej wi\u0119cej na tym samym poziomie",
    q4Option4Text: "redukowa\u0107 nieznacznie liczb\u0119 pracownik\xf3w ka\u017Cdego roku",
    q4Option5Text: "trudno powiedzie\u0107 \u2013 tego nie da si\u0119 przewidzie\u0107",
    q5AnswerText: "Zwykle pracujemy",
    q5Option1Text: "od 9.00 do 17.00",
    q5Option2Text: "od rana do...p\xf3\u017Ana",
    q5Option3Text: "w dowolnych godzinach \u2013 pod warunkiem, \u017Ce zostaje przepracowana odpowiednia liczba godzin",
    q5Option4Text: "w dowolnych godzinach, a liczba przepracowanych godzin nie ma znaczenia",
    q6AnswerText: "Uwa\u017Camy, \u017Ce",
    q6Option1Text: "ka\u017Cdy pracownik powinien mie\u0107 w\u0142asne biurko",
    q6Option2Text: "lepszym rozwi\u0105zaniem mo\u017Ce by\u0107 praca przy r\xf3\u017Cnych biurkach, nieprzypisanych konkretnym pracownikom",
    q7Option1Text: "Zawsze przy w\u0142asnym biurku",
    q7Option2Text: "Przede wszystkim przy w\u0142asnym biurku. Cz\u0119\u015Bciowo na spotkaniach lub podczas innych czynno\u015Bci",
    q7Option3Text: "Czas b\u0119dzie r\xf3wno podzielony pomi\u0119dzy prac\u0119 przy biurku a prac\u0119 w innym miejscu w biurze",
    q7Option4Text: "Przede wszystkim przemieszczaj\u0105c si\u0119 pomi\u0119dzy r\xf3\u017Cnymi strefami biura, okazjonalnie przy biurku",
    q7Option5Text: "Zawsze przemieszczaj\u0105c si\u0119 pomi\u0119dzy r\xf3\u017Cnymi strefami biura",
    q8Option1Text: "Elegancki str\xf3j biznesowy",
    q8Option2Text: "Najcz\u0119\u015Bciej str\xf3j biznesowy, z wyj\u0105tkiem specjalnych okazji",
    q8Option3Text: "Swobodny str\xf3j biznesowy, czasami z wi\u0119kszym naciskiem na elegancj\u0119",
    q8Option4Text: "Najcz\u0119\u015Bciej swobodny, z wyj\u0105tkiem specjalnych okazji",
    q8Option5Text: "Swobodny",
    q9Option1Text: "Zawsze w biurze",
    q9Option2Text: "Najcz\u0119\u015Bciej w biurze",
    q9Option3Text: "Czas b\u0119dzie podzielony pomi\u0119dzy prac\u0119 w biurze a zdaln\u0105",
    q9Option4Text: "Najcz\u0119\u015Bciej zdalnie",
    q9Option5Text: "Zawsze zdalnie",
    q10Option1Text: "Dynamiczn\u0105 i energiczn\u0105",
    q10Option2Text: "Energiczn\u0105 z cichymi strefami",
    q10Option3Text: "To zale\u017Cy \u2013 mieszank\u0119 obydwu",
    q10Option4Text: "Cich\u0105, z dynamicznymi elementami",
    q10Option5Text: "Cich\u0105 i spokojn\u0105",
    q11Option1Text: "Tylko miejsce do pracy, umo\u017Cliwiaj\u0105ce pracownikom wykonywanie zada\u0144",
    q11Option2Text: "Miejsce do pracy z paroma uatrakcyjnieniami",
    q11Option3Text: "Miejsce do pracy i przestrze\u0144, w kt\xf3rej pracownicy mog\u0105 si\u0119 spotyka\u0107, tworz\u0105c relacje spo\u0142eczne",
    q11Option4Text: "Co\u015B naprawd\u0119 atrakcyjnego, biuro b\u0119d\u0105ce celem samym w sobie",
    q11Option5Text: "Co\u015B atrakcyjnego i wyr\xf3\u017Cniaj\u0105cego nasz\u0105 organizacj\u0119 \u2013 biuro, kt\xf3re z dum\u0105 b\u0119dziemy pokazywa\u0107 osobom odwiedzaj\u0105cym",
    q12AnswerText: "Jestem",
    q12OptionClientText: "obecnym klientem CBRE",
    q12OptionProfessionalText: "pracownikiem CBRE",
    q12OptionLeadText: "\u017Cadne z powy\u017Cszych",
    q13AnswerText1: "Licza os\xf3b, kt\xf3re b\u0119d\u0105 pracowa\u0107 w naszym biurze:",
    q13AnswerText2: "",
    q13AnswerHelperText: "*Wskaz\xf3wka: zazwyczaj jest to po\u0142owa okresu najmu lub oko\u0142o 2-5 lat od teraz.",
    q14AnswerText1: "Na pracy zespo\u0142owej sp\u0119dzamy",
    q14AnswerText2: "naszego czasu.",
    q15AnswerText1: "\u015Arednia liczba dni w tygodniu, kt\xf3r\u0105 zamierzamy sp\u0119dza\u0107 w biurze:",
    q15AnswerText2: "",
    q16AnswerText1: "Nasze biuro b\u0119dzie zlokalizowane w",
    q16AnswerText2: ".",
    q17AnswerText1: "Sektor, na kt\xf3rym przede wszystkim skupia si\u0119 nasza praca to:",
    q17AnswerText2: "",
    q18AnswerText1: "Obecnie nasze biuro mie\u015Bci si\u0119 w",
    q18AnswerText2: ".",
    q19AnswerText1: "Zak\u0142adamy, \u017Ce w przysz\u0142o\u015Bci zag\u0119szczenie pracownik\xf3w (liczba mkw./os.) w naszym biurze b\u0119dzie",
    q19AnswerText2: "",
    // Quiz Responses (questionUnitMap.js)
    q1ResponseText: "Przedstawimy Ci pomys\u0142 na biuro pasuj\u0105ce do Twojej wizji.",
    q2ResponseText: "Interesuj\u0105ce!",
    q3ResponseText: "Brzmi nie\u017Ale \u2013 gdzie mo\u017Cemy przes\u0142a\u0107 nasze CV?",
    q4ResponseText: "Wspaniale! A teraz my zadbamy o to, \u017Ceby biuro spe\u0142nia\u0142o Twoje potrzeby.",
    q5Response1Text: "Brzmi dobrze!",
    q5Response2Text: "Nam te\u017C czasami zdarza si\u0119 pracowa\u0107 w godzinach nadliczbowych.",
    q5Response3Text: "Brzmi wspaniale!",
    q5Response4Text: "Brzmi \u015Bwietnie!",
    q6Response1Text: "Przedstawimy Ci pomys\u0142 na biuro, w kt\xf3rym przestrze\u0144 osobista b\u0119dzie najwa\u017Cniejsza.",
    q6Response2Text: "Przedstawimy Ci pomys\u0142 na elastyczn\u0105 przestrze\u0144 biurow\u0105.",
    q12ResponseLeadText: "Trafi\u0142e\u015B we w\u0142a\u015Bciwe miejsce.",
    q12ResponseClientText: "Idealnie!",
    q12ResponseProfessionalText: "Dzi\u0119kujemy!",
    // Industry Codes (industryCodes.js)
    animalProd: "Ch\xf3w i hodowla zwierz\u0105t, w tym ryb oraz pozosta\u0142ych organizm\xf3w wodnych ",
    forestry: "Le\u015Bnictwo i pozyskiwanie drewna",
    fishingHunting: "Rybo\u0142\xf3wstwo, \u0142owiectwo i pozyskiwanie zwierz\u0105t \u0142ownych",
    agForestSupport: "Dzia\u0142alno\u015B\u0107 us\u0142ugowa wspomagaj\u0105ca rolnictwo i le\u015Bnictwo",
    oilGas: "G\xf3rnictwo ropy naftowej i gazu ziemnego",
    energy: "Energetyka (gaz ziemny, ropa naftowa itp.)",
    mining: "G\xf3rnictwo, z wyj\u0105tkiem ropy naftowej i gazu ziemnego",
    supportMining: "Dzia\u0142alno\u015B\u0107 us\u0142ugowa wspomagaj\u0105ca g\xf3rnictwo",
    utilities: "Us\u0142ugi komunalne",
    buildingConstruct: "Roboty budowlane zwi\u0105zane ze wznoszeniem budynk\xf3w",
    heavyCivilConstruct: "Roboty zwi\u0105zane z budow\u0105 obiekt\xf3w in\u017Cynierii l\u0105dowej i wodnej",
    specialtyContract: "Specjalistyczne us\u0142ugi budowlane",
    foodManufac: "Produkcja artyku\u0142\xf3w spo\u017Cywczych",
    beverageTobaccoManufac: "Produkcja napoj\xf3w i wyrob\xf3w tytoniowych",
    textile: "Zak\u0142ady w\u0142\xf3kiennicze",
    textileProduct: "Produkcja wyrob\xf3w tekstylnych",
    apparelManufac: "Produkcja odzie\u017Cy",
    leatherManufac: "Produkcja wyrob\xf3w sk\xf3rzanych i pokrewnych",
    woodManufac: "Produkcja wyrob\xf3w z drewna",
    paperManufac: "Produkcja papieru",
    printingSupport: "Drukowanie i dzia\u0142alno\u015B\u0107 us\u0142ugowa zwi\u0105zana z poligrafi\u0105",
    printingReproduc: "Poligrafia/Reprodukcja",
    petroleumCoal: "Wytwarzanie i przetwarzanie produkcji rafinacji ropy naftowej i w\u0119gla kamiennego",
    chemicalManufac: "Produkcja chemikali\xf3w i wyrob\xf3w chemicznych",
    chemicals: "Chemikalia i wyroby chemiczne",
    pharma: "Substancje farmaceutyczne",
    cleaningManufac: "Produkcja \u015Brodk\xf3w myj\u0105cych i czyszcz\u0105cych",
    plasticsRubberManufac: "Produkcja wyrob\xf3w z gumy i tworzyw sztucznych",
    nonmetallicManufac: "Produkcja wyrob\xf3w z mineralnych surowc\xf3w niemetalicznych",
    primaryMetalManufac: "Produkcja metali",
    fabricatedMetalManufac: "Produkcja metalowych wyrob\xf3w gotowych",
    machineryManufac: "Produkcja maszyn",
    manufac: "Przetw\xf3rstwo przemys\u0142owe",
    computerElectronicManufac: "Produkcja komputer\xf3w i wyrob\xf3w elektronicznych",
    electricalApplianceManufac: "Produkcja urz\u0105dze\u0144 elektrycznych",
    transportEquipManufac: "Produkcja sprz\u0119tu transportowego",
    aerospaceDefense: "Lotnictwo i kosmonautyka / Obronno\u015B\u0107",
    furnitureManufac: "Produkcja mebli i produkt\xf3w powi\u0105zanych",
    miscManufac: "Pozosta\u0142a produkcja wyrob\xf3w",
    merchantWholesaleDurable: "Handel hurtowy, towary trwa\u0142ego u\u017Cytku",
    merchantWholesaleNondurable: "Handel hurtowy, towary nietrwa\u0142ego u\u017Cytku",
    electronicMarket: "Rynki elektroniczne oraz agenci i brokerzy",
    motorVehiclePartsDealers: "Obr\xf3t pojazdami samochodowymi i ich cz\u0119\u015Bciami",
    furnitureFurnishingStores: "Sprzeda\u017C mebli i artyku\u0142\xf3w wyposa\u017Cenia wn\u0119trz",
    electronicApplianceStores: "Sprzeda\u017C artyku\u0142\xf3w RTV i AGD",
    electronics: "Artyku\u0142y elektroniczne",
    buildingGardenSupplyStores: "Sprzeda\u017C materia\u0142\xf3w budowlanych i artyku\u0142\xf3w ogrodniczych",
    foodBeverageStores: "Sprzeda\u017C \u017Cywno\u015Bci i napoj\xf3w",
    groceryStores: "Sprzeda\u017C artyku\u0142\xf3w spo\u017Cywczych",
    beerWineLiquorStores: "Sprzeda\u017C piwa, wina i alkoholi wysokoprocentowych",
    healthCareStores: "Sprzeda\u017C artyku\u0142\xf3w ochrony zdrowia i higieny osobistej",
    gasStations: "Sprzeda\u017C paliw do pojazd\xf3w silnikowych na stacjach paliw",
    clothingAccessoriesStores: "Sprzeda\u017C odzie\u017Cy i akcesori\xf3w odzie\u017Cowych",
    clothingTextiles: "Odzie\u017C / Wyroby tekstylne",
    jewelryFurs: "Bi\u017Cuteria i wyroby futrzarskie",
    sportsHobbyMusicBookStores: "Sprzeda\u017C artyku\u0142\xf3w sportowych, hobbystycznych, instrument\xf3w muzycznych oraz ksi\u0105\u017Cek",
    genMerchandiseStores: "Sprzeda\u017C wielobran\u017Cowa / wyrob\xf3w og\xf3lnego u\u017Cytku",
    miscStoreRetailers: "Pozosta\u0142a sprzeda\u017C",
    officeProducts: "Sprzeda\u017C artyku\u0142\xf3w biurowych",
    retailSales: "Sprzeda\u017C detaliczna",
    nonstoreRetails: "Sprzeda\u017C prowadzona poza sieci\u0105 sklepow\u0105",
    airTransport: "Transport lotniczy",
    travelRelated: "Dzia\u0142alno\u015B\u0107 zwi\u0105zana z turystyk\u0105 (linie lotnicze, agenci, transport masowy)",
    railTransport: "Transport kolejowy",
    waterTransport: "Transport wodny",
    truckTransport: "Transport ci\u0119\u017Carowy",
    transitTransport: "Transport l\u0105dowy pasa\u017Cerski, miejski i podmiejski",
    pipelineTransport: "Transport ruroci\u0105gowy",
    scenicTransport: "Transport turystyczny",
    supportTransport: "Dzia\u0142alno\u015B\u0107 us\u0142ugowa wspomagaj\u0105ca transport",
    postalService: "Dzia\u0142alno\u015B\u0107 pocztowa",
    courierMessenger: "Kurierzy i dostarczyciele przesy\u0142ek",
    shippingDelivery: "Wysy\u0142ka i dor\u0119czanie towar\xf3w",
    warehousingStorage: "Magazynowanie i przechowywanie towar\xf3w",
    warehouseDistrib: "Magazynowanie / Dystrybucja towar\xf3w",
    publishingNoInternet: "Bran\u017Ce wydawnicze, poza Internetem",
    publishing: "Dzia\u0142alno\u015B\u0107 wydawnicza",
    motionPicSoundRecordingIndustries: "Dzia\u0142alno\u015B\u0107 zwi\u0105zana z produkcj\u0105 film\xf3w i nagra\u0144 d\u017Awi\u0119kowych",
    entertainment: "Dzia\u0142alno\u015B\u0107 rozrywkowa (film, telewizja, muzyka itp.)",
    infoServicesMarketResearch: "Dzia\u0142alno\u015B\u0107 us\u0142ugowa w zakresie informacji / bada\u0144 rynku",
    broadcastingNoInternet: "Nadawanie program\xf3w og\xf3lnodost\u0119pnych i abonamentowych, poza Internetem",
    telecom: "Telekomunikacja",
    tech: "Technologia",
    dataProcessingHostingServices: "Przetwarzanie danych, zarz\u0105dzanie stronami internetowymi i podobna dzia\u0142alno\u015B\u0107",
    otherInfoServices: "Pozosta\u0142a dzia\u0142alno\u015B\u0107 us\u0142ugowa w zakresie informacji",
    financeInsurance: "Dzia\u0142alno\u015B\u0107 finansowa i ubezpieczeniowa",
    monetaryAuthorities: "W\u0142adze monetarne \u2013 dzia\u0142alno\u015B\u0107 banku centralnego",
    creditIntermediation: "Po\u015Brednictwo kredytowe i dzia\u0142alno\u015B\u0107 powi\u0105zana",
    banking: "Bankowo\u015B\u0107",
    securitiesContractsInvestments: "Dzia\u0142alno\u015B\u0107 zwi\u0105zana z rynkiem papier\xf3w warto\u015Bciowych, towar\xf3w gie\u0142dowych i inwestycjami",
    financialServicesNoBanking: "Us\u0142ugi finansowe (pozabankowe)",
    insuranceCarriersRelated: "Dzia\u0142alno\u015B\u0107 ubezpieczeniowa i z ni\u0105 powi\u0105zana",
    insurance: "Ubezpieczenia",
    fundsTrustsFinancialVehicles: "Fundusze, fundusze powiernicze i inne narz\u0119dzia finansowe",
    realEstate: "Dzia\u0142alno\u015B\u0107 zwi\u0105zana z obs\u0142ug\u0105 rynku nieruchomo\u015Bci",
    rentalLeasingServices: "Wynajem nieruchomo\u015Bci",
    automotive: "Rynek motoryzacyjny",
    consumerGoods: "Dobra konsumpcyjne",
    lessorsNonfinancialIntangible: "Leasingodawcy niefinansowych warto\u015Bci niematerialnych i prawnych",
    professionalTechnicalServices: "Dzia\u0142alno\u015B\u0107 profesjonalna i techniczna",
    legalServices: "Dzia\u0142alno\u015B\u0107 prawnicza",
    accounting: "Dzia\u0142alno\u015B\u0107 rachunkowo-ksi\u0119gowa",
    architectureEngineering: "Dzia\u0142alno\u015B\u0107 w zakresie architektury i in\u017Cynierii",
    specializedDesignServices: "Dzia\u0142alno\u015B\u0107 w zakresie specjalistycznego projektowania",
    compRelatedServices: "Dzia\u0142alno\u015B\u0107 us\u0142ugowa w zakresie technologii komputerowych ",
    mgmtConsulting: "Doradztwo zwi\u0105zane z zarz\u0105dzaniem",
    scientificResearch: "Badania naukowe",
    adsMarketingPR: "Dzia\u0142alno\u015B\u0107 zwi\u0105zana z reklam\u0105 / marketingiem / stosunkami mi\u0119dzyludzkimi",
    otherProfSciTechServices: "Pozosta\u0142a dzia\u0142alno\u015B\u0107 profesjonalna, naukowa i techniczna",
    companyEnterpriseMgmt: "Zarz\u0105dzanie firmami i przedsi\u0119biorstwami",
    adminSupportServices: "Dzia\u0142alno\u015B\u0107 w zakresie us\u0142ug administrowania i dzia\u0142alno\u015B\u0107 wspieraj\u0105ca",
    employmentAgencyRecruiters: "Dzia\u0142alno\u015B\u0107 zwi\u0105zana z wyszukiwaniem miejsc pracy i pozyskiwaniem pracownik\xf3w",
    securityPrivateInvestigation: "Dzia\u0142alno\u015B\u0107 detektywistyczna i ochroniarska",
    wasteMgmtRemediationServices: "Gospodarowanie \u015Bciekami i odpadami oraz dzia\u0142alno\u015B\u0107 zwi\u0105zana z rekultywacj\u0105",
    educationServices: "Dzia\u0142alno\u015B\u0107 zwi\u0105zana z edukacj\u0105",
    education: "Edukacja",
    ambulatoryHealthCareServices: "Ambulatoryjna opieka zdrowotna",
    healthCareRelated: "Dzia\u0142alno\u015B\u0107 zwi\u0105zana z opiek\u0105 zdrowotn\u0105",
    hospitals: "Dzia\u0142alno\u015B\u0107 szpitali",
    nursingResidentialCareFacilities: "Pomoc spo\u0142eczna z zakwaterowaniem zapewniaj\u0105ca opiek\u0119 piel\u0119gniarsk\u0105",
    socialAssistance: "Pomoc spo\u0142eczna",
    performingArtsSpectatorSports: "Dzia\u0142alno\u015B\u0107 zwi\u0105zana z wystawianiem przedstawie\u0144 artystycznych i sportami widowiskowymi ",
    museumsHistoricalSitesZoosParks: "Dzia\u0142alno\u015B\u0107 muze\xf3w, miejsc historycznych, ogrod\xf3w zoologicznych i park\xf3w",
    fineArtsGalleriesMuseums: "Dzia\u0142alno\u015B\u0107 zwi\u0105zana ze sztukami pi\u0119knymi (galerie, muzea)",
    amusementsGamblingRec: "Dzia\u0142alno\u015B\u0107 rozrywkowa i rekreacyjna oraz zwi\u0105zana z grami losowymi",
    accommodation: "Zakwaterowanie",
    foodDrinkingServices: "Dzia\u0142alno\u015B\u0107 us\u0142ugowa zwi\u0105zana z wy\u017Cywieniem",
    restaurantHotel: "Restauracje / Hotele",
    repairMaintenance: "Naprawa i konserwacja",
    industrialProductsHeavy: "Wyroby przemys\u0142owe (przemys\u0142 ci\u0119\u017Cki)",
    personalLaundryServices: "Indywidualna dzia\u0142alno\u015B\u0107 us\u0142ugowa i us\u0142ugi zwi\u0105zane z praniem i czyszczeniem",
    membershipAssocOrgs: "Dzia\u0142alno\u015B\u0107 organizacji i stowarzysze\u0144 cz\u0142onkowskich",
    nonprofit: "Dzia\u0142alno\u015B\u0107 organizacji non-profit",
    privateHouseholds: "Prywatne gospodarstwa domowe",
    execLegisGenGvt: "Dzia\u0142alno\u015B\u0107 organ\xf3w wykonawczych, ustawodawczych oraz instytucji rz\u0105dowych i samorz\u0105dowych",
    gvt: "Dzia\u0142alno\u015B\u0107 rz\u0105du",
    justicePublicOrderSafetyActivities: "Wymiar sprawiedliwo\u015Bci, porz\u0105dek i bezpiecze\u0144stwo publiczne",
    hrAdminPrograms: "Administrowanie programami kadrowymi",
    environmentAdminPrograms: "Administrowanie programami \u015Brodowiskowymi",
    environmental: "Dzia\u0142alno\u015B\u0107 zwi\u0105zana ze \u015Brodowiskiem",
    communityHousingProgramAdmin: "Administracja wsp\xf3lnotowa i mieszkaniowa",
    econProgramAdmin: "Administrowanie programami ekonomicznymi",
    spaceResearchTech: "Badania i rozw\xf3j technologiczny w zakresie przestrzeni kosmicznej",
    natlSecurityIntlAffairs: "Bezpiecze\u0144stwo pa\u0144stwa i sprawy zagraniczne"
};


var $a82891e8b593609a$exports = {};
$a82891e8b593609a$exports = {
    // AboutPageHero
    aboutPageHeroImgAlt: "Grafika przedstawiaj\u0105ca ludzi wprowadzaj\u0105cych si\u0119 do biura znajduj\u0105ca si\u0119 na stronie Informacje o aplikacji CBRE Spacer",
    aboutPageHeroTitle: "Jak aplikacja Spacer mo\u017Ce Ci pom\xf3c?",
    // AboutPageContent
    aboutPageContentEndSectionTitle: "Zaczynamy?",
    aboutPageProgramPreviewImgAlt: "Podgl\u0105d wynik\xf3w kwestionariusza dotycz\u0105cego projektu przestrzeni znajduj\u0105cego si\u0119 na stronie g\u0142\xf3wnej aplikacji CBRE Spacer",
    aboutPageVideoTitle: "Jak to dzia\u0142a",
    // About Page Content (aboutPageContent.js)
    aboutPageContent1Title: "Czym jest idealne biuro?",
    aboutPageContent1Text: "Idealna przestrze\u0144 biurowa przyci\u0105gnie i pomo\u017Ce Ci w zatrudnieniu najlepszych talent\xf3w. Sprawi, \u017Ce Twoi pracownicy b\u0119d\u0105 cieszy\u0107 si\u0119 dobrym zdrowiem, pozwoli obni\u017Cy\u0107 koszty operacyjne Twojej organizacji i umo\u017Cliwi stworzenie warunk\xf3w sprzyjaj\u0105cych innowacyjnym pomys\u0142om.\nAplikacja Spacer jest narz\u0119dziem, dzi\u0119ki kt\xf3remu skutecznie okre\u015Blisz hierarchi\u0119 cel\xf3w Twojej organizacji, a na ich podstawie uzyskasz konkretne zalecenia. To w\u0142a\u015Bnie tutaj powinny rozpoczyna\u0107 si\u0119 wszelkie decyzje w kwestiach nieruchomo\u015Bci!\nAplikacja Spacer zosta\u0142a stworzona z po\u0142\u0105czenia bezp\u0142atnej, dost\u0119pnej dla ka\u017Cdego, nowoczesnej technologii internetowej oraz wiedzy zespo\u0142u CBRE Workplace, kt\xf3ry mo\u017Ce pochwali\u0107 si\u0119 ponad dwudziestoletnim do\u015Bwiadczeniem w zakresie wspierania firm w planowaniu i projektowaniu idealnych biur. ",
    aboutPageContent1ImgAlt: "Grafika przedstawiaj\u0105ca rozmawiaj\u0105cych ze sob\u0105 ludzi znajduj\u0105ca si\u0119 na stronie Informacje o aplikacji CBRE Spacer",
    aboutPageSpacerSupportLink: "spacersupport@cbre.com",
    aboutPageContent2Title: "Aplikacja Spacer jest \u0142atwa w u\u017Cyciu:",
    aboutPageContent2List1: "Zacznij od udzielenia odpowiedzi na 17 pyta\u0144 dotycz\u0105cych cel\xf3w i warto\u015Bci Twojej organizacji. Odpowiedzi te pozwol\u0105 nam na okre\u015Blenie charakteru Twojej idealnej przestrzeni biurowej.",
    aboutPageContent2List2: "Dzi\u0119ki funkcji Projekt Przestrzeni uzyskasz zalecenia co do typu i wielko\u015Bci przestrzeni biurowej dostosowanej do Twoich potrzeb.",
    aboutPageContent2List3: "Funkcja Rzuty da Ci mo\u017Cliwo\u015B\u0107 stworzenia wizualizacji przestrzeni odpowiadaj\u0105cej Twoim potrzebom w wersji 2D oraz 3D.",
    aboutPageContent2List4: "Zapisz sw\xf3j projekt i wykorzystaj go podczas poszukiwa\u0144 Twojego idealnego biura.",
    aboutPageContent2List5: "Pozw\xf3l ekspertom CBRE znale\u017A\u0107 przestrze\u0144 biurow\u0105 spe\u0142niaj\u0105c\u0105 Twoje kryteria \u2013 t\u0119 us\u0142ug\u0119 \u015Bwiadczymy nieodp\u0142atnie!",
    aboutPageContent2Text: "Je\u017Celi masz jakiekolwiek dodatkowe pytania co do tego, jak aplikacja Spacer mo\u017Ce przy\u015Bpieszy\u0107 proces poszukiwania Twojego nowego biura, skontaktuj si\u0119 z nami pod adresem",
    aboutPageContent2ImgAlt: "Grafika przedstawiaj\u0105ca kobiet\u0119 pracuj\u0105c\u0105 przy biurku znajduj\u0105ca si\u0119 na stronie Informacje o aplikacji CBRE Spacer"
};


var $8e26deba20238011$exports = {};
$8e26deba20238011$exports = {
    referralStep: "Krok {{step}} z 4",
    forgotReferralLink: "Zapomnia\u0142e\u015B swojego linku polecaj\u0105cego?",
    howReferralLinksWorkTitle: "Jak dzia\u0142aj\u0105 linki polecaj\u0105ce?",
    enterYourInformation: "Wprowad\u017A swoje dane",
    confirmYourInformation: "Potwierd\u017A swoje dane",
    referralLinkStep1: "Do wygenerowania linku polecaj\u0105cego potrzebujemy:",
    referralLinkReq1: "- Twojego imienia i nazwiska",
    referralLinkReq2: "- Twojego adresu e-mail przypisanego Ci przez CBRE",
    referralLinkStep2: "Po wype\u0142nieniu kwestionariusza przez potencjalnego klienta przy wykorzystaniu Twojego linku polecaj\u0105cego prze\u015Blemy Ci podsumowanie jego odpowiedzi na podany adres e-mail.",
    next: "Dalej",
    firstName: "Imi\u0119",
    lastName: "Nazwisko",
    emptyNameError: "Prosz\u0119 wprowadzi\u0107 imi\u0119 / Prosz\u0119 wprowadzi\u0107 nazwisko",
    email: "Tw\xf3j adres e-mail przypisany Ci przez CBRE",
    emptyEmailError: "Prosz\u0119 wprowadzi\u0107 adres e-mail przypisany Ci przez CBRE",
    emailTakenError: "Podany adres e-mail jest ju\u017C powi\u0105zany z {{takenLink}}",
    emailExample: "np.: jane.smith@cbre.com",
    editReferralInfo: "Edytuj wprowadzone imi\u0119 i nazwisko oraz adres e-mail",
    noLaterChanges: "Wprowadzonych danych nie b\u0119dzie mo\u017Cna p\xf3\u017Aniej ju\u017C zmieni\u0107.",
    somethingWrong: "Ups, co\u015B posz\u0142o nie tak po naszej stronie. Prosz\u0119 spr\xf3bowa\u0107 ponownie.",
    contentLoading: "\u0141adowanie tre\u015Bci",
    linkReady: "Tw\xf3j link jest gotowy",
    storeLinkInstructions: "Przechowuj wygenerowany link w bezpiecznym miejscu, b\u0119dziesz z niego korzysta\u0107 za ka\u017Cdym razem, gdy b\u0119dziesz chcia\u0142 udost\u0119pni\u0107 aplikacj\u0119 Spacer klientom. Kopi\u0119 linku wys\u0142ali\u015Bmy r\xf3wnie\u017C na podany przez Ciebie adres e-mail.",
    yourLink: "Tw\xf3j link polecaj\u0105cy",
    copyLink: "Skopiuj link polecaj\u0105cy",
    copiedLink: "Link zosta\u0142 skopiowany do schowka",
    linkNeverExpires: "Przypomnienie: wygenerowany link nigdy nie wyga\u015Bnie.",
    linkFound: "Znale\u017Ali\u015Bmy Tw\xf3j link",
    emailNotAssociated: "Nie mogli\u015Bmy znale\u017A\u0107 linku polecaj\u0105cego, powi\u0105zanego z podanym adresem e-mail.",
    createLink: "Czy wygenerowa\u0107 link?"
};


var $bb92cd76fa085c30$exports = {};
$bb92cd76fa085c30$exports = {
    blogHomeTitle: "Aktualno\u015Bci z obszaru planowania przestrzeni biurowej",
    // blog tags
    blogTagAllArticles: "Wszystkie artyku\u0142y",
    blogTagSizeAndFit: "Wielko\u015B\u0107 i dopasowanie",
    blogTagOfficeCulture: "Kultura organizacyjna",
    blogTagSpaceAndDesign: "Przestrze\u0144 & Projekt",
    blogTagWorkplaceTrends: "Trendy w zakresie \u015Arodowiska Pracy"
};


var $5cef28aea58a47db$exports = {};
$5cef28aea58a47db$exports = {
    // LandingPageHero
    landingPageHeroTitle: "Seg\xedt\xfcnk megtervezni \xe9s megtal\xe1lni a k\xf6vetkez\u0151 irod\xe1d megfelel\u0151 t\xe9r ig\xe9ny\xe9t.",
    landingPageHeroSubtitle: "Az irodat\xe9r v\xe1ltoz\xf3ban van a pand\xe9mi\xe1s helyzet k\xf6vetkezt\xe9ben. Szerezz be testre szabott javaslatokat a Spacer seg\xedts\xe9g\xe9vel.",
    landingPageHeroImgAlt: "Az eredm\xe9nyek oldal el\u0151n\xe9zete a Spacer a CBRE-t\xf3l holnapj\xe1n",
    landingPageImage: "/png/homepage-results-page-in-browser-spacer-by-cbre.png",
    // LandingPageContent
    landingPageContentTitle: "Hogyan m\u0171k\xf6dik",
    // StepsSummary
    stepsSummarySubtitle1: "Els\u0151 l\xe9p\xe9s \u2014",
    stepsSummaryTitle1: "Mes\xe9lj a c\xe9gedr\u0151l",
    stepsSummaryText1: "Mondd el, hogy milyen irod\xe1t k\xe9pzelt\xe9l el c\xe9ged sz\xe1m\xe1ra, \xe9s mi testreszabott javaslattal seg\xedt\xfcnk.",
    stepsSummaryImgAlt1: "Illusztr\xe1ci\xf3 emberekr\u0151l akik egy hatalmas laptopon \xe1llnad a Spacer a CBRE-t\xf3l Honlapj\xe1n",
    stepsSummarySubtitle2: "M\xe1sodik l\xe9p\xe9s \u2014",
    stepsSummaryTitle2: "Kapd k\xe9zhez az eredm\xe9nyeidet",
    stepsSummaryText2: "A v\xe1laszaidat alapul v\xe9ve k\xe9sz\xedtett\xfcnk neked egy iroda m\xe9ret javaslatot \xe9s egy list\xe1t a t\xe9r t\xedpusokr\u0151l \xe9s azok javasolt m\xe9ret\xe9r\u0151l. M\xe9g p\xe9lda alaprajzokat is megn\xe9zhetsz.",
    stepsSummaryImgAlt2: "Illusztr\xe1ci\xf3 egy \xe9p\xfcletegy\xfcttesr\u0151l a Space a CBRE-t\xf3l honlapj\xe1n",
    stepsSummarySubtitle3: "Harmadik l\xe9p\xe9s \u2014",
    stepsSummaryTitle3: "Tal\xe1ld meg t\xf6k\xe9letes irod\xe1d",
    stepsSummaryText3: "Mentsd el az eredm\xe9nyeket amelyekre hivatkozhatsz majd irodakeres\xe9sed sor\xe1n vagy l\xe9pj kapcsolatba a Spacer csapat\xe1val, akik \xf6sszek\xf6tnek egy tan\xe1csad\xf3 szak\xe9rt\u0151vel, hogy egy\xfctt megtal\xe1lj\xe1tok a t\xf6k\xe9letes irod\xe1tokat.",
    stepsSummaryImgAlt3: "Illusztr\xe1ci\xf3 egy h\xf6lgyr\u0151l akik egy irodaasztaln\xe1l dolgozik a Spacer a CBRE-t\xf3l honlapj\xe1n",
    // LandingPageSecondaryHero
    landingPageSecondaryHeroImgAlt: "Illusztr\xe1ci\xf3 emberekr\u0151l akik irodat\xe9rjavaslaton dolgoznak a Spacer a CBRE-t\xf3l honlapj\xe1n",
    landingPageSecondaryHeroTitle: "Mes\xe9lj a c\xe9gedr\u0151l. Mi pedig megmondjuk mekkora irodat\xe9rre van sz\xfcks\xe9ged."
};


var $c9c5c955d0bd7c67$exports = {};
$c9c5c955d0bd7c67$exports = {
    // Navbar
    spacerLogoAlt: "Spacer a CBRE-t\xf3l",
    linkToAboutPageText: "R\xf3lunk",
    linkToBlogPageText: "Tippek",
    referrals: "Javaslatok",
    // TakeOfficeSpaceQuizButton
    sizeMyOfficeButtonDefaultLinkText: "Felm\xe9r\xe9s elkezd\xe9se",
    flooredPlanRequestLinkText: "Terv ig\xe9nyl\xe9se",
    // Footer
    footerCBRELogoAlt: "CBRE logo a Spacer a CBRE-t\xf3l sz\xe1m\xe1ra",
    footerFacebookIconAlt: "Facebook k\xf6z\xf6ss\xe9gi m\xe9dia ikon a Spacer a CBRE-t\xf3l sz\xe1m\xe1ra",
    footerTwitterIconAlt: "Twitter k\xf6z\xf6ss\xe9gi m\xe9dia ikon a Spacer a CBRE-t\xf3l sz\xe1m\xe1ra",
    footerLinkedinIconAlt: "LinkenIn k\xf6z\xf6ss\xe9gi m\xe9dia ikon a Spacer a CBRE-t\xf3l sz\xe1m\xe1ra",
    footerLinkedinLink: "https://www.linkedin.com/company/cbre-hungary",
    footerHeaderQuestionsText: "K\xe9rd\xe9sed van?",
    footerHeaderAboutText: "Hasznos linkek, forr\xe1sok",
    footerHeaderMoreText: "Adatv\xe9delem",
    footerHeaderBrokersText: "Tan\xe1csad\xf3 r\xe9sz\xe9re",
    footerLinkWhatIsSpacerText: "R\xf3lunk",
    footerLinkBlogText: "Tippek",
    footerLinkWorkplaceText: "A CBRE munkak\xf6rnyezeti tan\xe1csad\xf3 csapat\xe1r\xf3l",
    footerLinkTermsText: "Szolg\xe1ltat\xe1si Felt\xe9telek",
    footerLinkPrivacyText: "Adatv\xe9delmi Szab\xe1lyzat",
    footerLinkReferralText: "Javaslatok",
    footerWorkplaceLink: "http://www.cbre.us/real-estate-services/occupier/workplace",
    footerPrivacyLink: "https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy",
    // Contact (contact.js)
    spacerSupportEmail: "spacersupport@cbre.com",
    // ErrorPage
    errorOopsText: "Hopp\xe1!",
    error404Text: "Nem tal\xe1ljuk azt az oldalt amit keresel.",
    error500Text: "Valami nem m\u0171k\xf6dik a mi oldalunkon.",
    errorText: "Hiba",
    errorReturnText: "Vissza a Spacer-hez",
    errorAltText: "Illusztr\xe1c\xf3 egy ki\xf6ml\xf6tt k\xe1v\xe9scs\xe9sz\xe9r\u0151l a Spacer a CBRE-t\xf3l sz\xe1m\xe1ra",
    // Measurement Units (units.js)
    SF: "NL",
    SM: "NM",
    USF: "HNL",
    USM: "HNM",
    RSF: "KNL",
    RSM: "KNM",
    NSF: "NNL",
    NSM: "NNM",
    NIA: "NBT",
    foot: "l\xe1b",
    feet: "l\xe1b",
    footage: "terjedelem",
    "sqft.": "n\xe9gyzetl\xe1b",
    meter: "m\xe9ter",
    meters: "m\xe9ter",
    "sqm.": "nm",
    Tsubo: "bek\xf6lt\xf6z\xe9sig h\xe1tral\xe9v\u0151 id\u0151",
    // SF Types Adjectives (calculator.js)
    Usable: "Haszn\xe1lhat\xf3",
    Rentable: "Kiadhat\xf3",
    Net: "Nett\u0151",
    // Page Titles (documentDataCopy.js)
    landingPageTitle: "Tervezd meg a t\xf6k\xe9letes irod\xe1d 15 perc alatt - Spacer - CBRE",
    aboutPageTitle: "Tanuld meg, hogyan m\u0171k\xf6dik az irodat\xe9r tervez\u0151 eszk\xf6z\xfcnk - Spacer - CBRE",
    termsPageTitle: "Szolg\xe1ltat\xe1si Felt\xe9telek - Spacer - CBRE",
    quizPageTitle: "Ide\xe1lis Irodam\xe9ret 15 perc alatt - Spacer - CBRE",
    resultsPageTitle: "N\xe9zd meg az egy\xe9ni iroda javaslatodat - Spacer - CBRE",
    profileComparisonPageTitle: "Hasonl\xedtsd \xf6ssze az irodaig\xe9nyeidet - Spacer - CBRE",
    blogHomePageTitle: "Iroda Tervez\xe9si Tippek - Spacer - CBRE",
    referralPageTitle: "Javaslat link CBRE tan\xe1csad\xf3k sz\xe1m\xe1ra - Spacer - CBRE",
    referralRetrievePageTitle: "Javaslat link beszerz\xe9se CBRE tan\xe1csad\xf3k sz\xe1m\xe1ra - Spacer - CBRE",
    // Meta Tags (documentDataCopy.js)
    landingPageMetaTagText: "\xdaj irod\xe1t tervezel? A Spacer a CBRE-t\xf3l seg\xedt gyorsan \xe9s k\xf6nnyed\xe9n meghat\xe1rozni a megfelel\u0151 iroda t\xe9r ig\xe9nyedet, amely seg\xedti az \xfczleti c\xe9ljaidat. Csak 15 percet vesz ig\xe9nybe!",
    aboutPageMetaTagText: "A irod\xe1d m\xe9rete seg\xedthet a tehets\xe9gek bevonz\xe1s\xe1ban, a k\xf6lts\xe9gek cs\xf6kkent\xe9s\xe9ben s\u0151t m\xe9g a dolgoz\xf3k eg\xe9szs\xe9g\xe9nek meg\u0151rz\xe9s\xe9ben is. Tudj meg t\xf6bbet arr\xf3l, hogyan tud a Spacer gyorsan megfelel\u0151 m\xe9ret\u0171 irod\xe1t javasolni az \xfczleti c\xe9ljaid el\xe9r\xe9s\xe9hez.",
    termsPageMetaTagText: "A Spacer-ben, t\xf6bb mint egy \xe9vtizednyi ipar\xe1gi tapsztalat \xe9s szak\xe9rtelem cs\xfacsosodik ki, \xedgy tud javasolni percek alatt iroda m\xe9retet.",
    quizPageMetaTagText: "A Spacer 15 perces kv\xedze seg\xedt meghat\xe1rozni a c\xe9ged c\xe9ljait \xe9s priorit\xe1sait t\xe1mogat\xf3 irodat\xe9r ir\xe1nti ig\xe9nyedet. A ig\xe9nyre szabott ig\xe9nyfelm\xe9r\xe9s m\xe9g sosem volt ilyen gyors.",
    resultsPageMetaTagText: "A Spacer ig\xe9nyre szabott irodat\xe9r eredm\xe9nyeivel id\u0151t takar\xedthatsz meg irodakeres\xe9sed sor\xe1n, megadja a c\xe9ged sz\xe1m\xe1ra ide\xe1lis m\xe9retet. Mindezt irodab\xfator \xe9s elrendez\xe9s javasttal egy\xfctt.",
    profileComparisonPageMetaTagText: "Hasonl\xedtsd \xf6ssze hogyan viszonyul az egyedi iroda ig\xe9nyed m\xe1sok\xe9hoz a Spacer a CBRE-t\xf3l seg\xedts\xe9g\xe9vel",
    blogHomePageMetaTagText: "Az irodat\xe9r ir\xe1nti ig\xe9ny sz\xe1m\xedt\xe1sa nem exakt tudom\xe1ny, de ezek a tippek \xe9s javaslatok seg\xedthetnek. Tudj meg t\xf6bbet itt.",
    referralPageMetaTagText: "Haszn\xe1ld ezt a linket, hogy a Spacer az \xfcgyfeledt\u0151l k\xf6zvetlen\xfcl neked jutassa el az eredm\xe9nyeket. Tudj meg t\xf6bbet itt.",
    referralRetrieveMetaTagText: "Szerezd meg egy\xe9ni tan\xe1csad\xf3i Spacer linkedet.",
    // Form title
    formLabel: "Infrom\xe1ci\xf3 R\xf3lad"
};


var $2b175f4550938cfe$exports = {};
$2b175f4550938cfe$exports = {
    // Results
    resultsWarningMessage: "Biztos, hogy elakarod hagyni ezt az oldalt? Azok az adatok elvesznek amiket nem mentett\xe9l el.",
    // ResultsHeader
    resultsHeaderExportPDFButtonText: "PDF export\xe1l\xe1sa",
    resultsHeaderSendButtonText: "Eredm\xe9nyek elk\xfcld\xe9se",
    resultsHeaderClipboardBoxDescription: "B\xe1rki a link birtok\xe1ban megn\xe9zheti \xe9s szerkesztheti az eredm\xe9nyeket",
    resultsHeaderContactButtonText: "L\xe9pj kapcsolatba a tan\xe1csad\xf3nkkal",
    // EmailWallSection
    emailWallTitle: "M\xe9g t\xf6bb minden v\xe1r r\xe1d",
    emailWallSubtitle: "Add meg a neved \xe9s az email c\xedmed, hogy megtekintsd a teljes \xe9rt\xe9kel\xe9st a javaslatainkkal. Itt szerkeszteni is tudod majd az eredm\xe9nyeidet.",
    emailWallFirstNamePlaceholder: "Keresztn\xe9v",
    emailWallLastNamePlaceholder: "Vezet\xe9kn\xe9v",
    emailWallEmailPlaceholder: "Email c\xedm",
    emailWallCBREEmailPlaceholder: "A CBRE-s email c\xedmed (opcion\xe1lis)",
    emailWallLeasingProfessionalPlaceholder: "A CBRE-s l\xedzingszak\xe9rt\u0151d",
    emailWallConnectMeText: "K\xf6ss\xf6n \xf6ssze egy szem\xe9lyes ingatlan szak\xe9rt\u0151vel. \xcdg\xe9rj\xfck, hogy nem k\xfcld\xfcnk h\xedrlevelet vagy spam \xfczenetet",
    emailWallContactNoticeText: "A Spacer csapat megkereshet t\xe9ged, hogy az eredm\xe9nyeidb\u0151l a legt\xf6bbet kihozhass\xe1tok. \xcdg\xe9rj\xfck, hogy nem spamel\xfcnk felesleges emailekkel.",
    emailWallResultsButtonText: "Tekintsd meg a teljes eredm\xe9nyt",
    emailWallImgAltText: "Az eredm\xe9nyek oldal el\u0151n\xe9zete a Spacer a CBRE-t\xf3l e-mail fal\xe1n",
    emailWallFirstNameInvalid: "K\xe9rlek add meg a keresztneved.",
    emailWallLastNameInvalid: "K\xe9rlek add meg a vezet\xe9kneved.",
    emailWallEmailInvalid: "K\xe9rlek adj meg egy l\xe9tez\u0151 email c\xedmet.",
    // CopyToClipboardBox
    clipboardBoxCopyText: "M\xe1sol\xe1s",
    clipboardBoxCopiedText: "M\xe1solva",
    // FormModal
    formModalFindSpaceHeader: "Kezd el az iroda keres\xe9st",
    formModalFindSpaceBody: "A Spacer egy gyors \xe9s k\xe9zenfekv\u0151 eszk\xf6z az irodai t\xe9r elemz\xe9s k\xe9sz\xedt\xe9s\xe9hez, azonban ha szem\xe9lyreszabotabb eredm\xe9nyre van sz\xfcks\xe9ged akkor hagyd, hogy a CBRE Workplace seg\xedtsen. T\xf6ltsd ki ezt az \u0171rlapot \xe9s a Workplace szakemberei felveszik veled a kapcsolatot 48 \xf3r\xe1n bel\xfcl.",
    formModalFindSpaceSuccessMessage: "A k\xe9r\xe9sedet sikeresen elk\xfcldted.",
    // SuccessModal
    successModalTitle: "Siker!",
    // ContactForm
    contactFormFirstNameLabel: "Keresztn\xe9v",
    contactFormLastNameLabel: "Vezet\xe9kn\xe9v",
    contactFormEmailLabel: "C\xe9ges email c\xedm",
    contactFormPhoneLabel: "Mobil",
    contactFormMessageLabel: "\xc1rulj el t\xf6bbet arr\xf3l, hogy mi \xe9rdekel t\xe9ged",
    contactFormSubmitText: "Bek\xfcld\xe9s",
    // AcceptTermsText
    acceptTermsText: "Elfogadom az \xc1ltal\xe1nos Szerz\u0151d\xe9si Felt\xe9teleket. Tov\xe1bbi inform\xe1ci\xf3\xe9rt az adatainak felhaszn\xe1l\xe1s\xe1r\xf3l olvassa el a CBRE adatv\xe9delmi ir\xe1nyelveket.",
    privacyPolicyLink: "https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy",
    // Form
    formErrorText: "Hopp\xe1, sajnos valami f\xe9lrement. K\xe9rlek pr\xf3b\xe1ld meg \xfajra!",
    formEmailInvalid: "K\xe9rlek adj meg egy l\xe9tez\u0151 email c\xedmet.",
    // FormInput
    formInputOptionalText: " (opcion\xe1lis)",
    // LegalForm
    legalFormCheckboxText: "CBRE megkereshet engem aj\xe1nlatokkal \xe9s a Spacer-hez kapcsol\xf3d\xf3 inform\xe1cival.",
    legalFormContactWarningText: "A Spacer csapat megkereshet t\xe9ged, hogy az eredm\xe9nyeidb\u0151l a legt\xf6bbet kihozhass\xe1tok. \xcdg\xe9rj\xfck, hogy nem spamel\xfcnk felesleges emailekkel.",
    // NextStepsSection
    nextStepsSectionSubtitle: "K\xe9szen \xe1llsz a k\xf6vetkez\u0151 l\xe9p\xe9sre?",
    nextStepsSectionTitle: "Tal\xe1ld meg a t\xf6k\xe9letes irod\xe1d.",
    nextStepsSectionButtonText: "L\xe9pj kapcsolatba a tan\xe1csad\xf3nkkal",
    nextStepsSectionImgAlt: "Illusztr\xe1ci\xf3 besz\xe9l\u0151 emberekr\u0151l a Space a CBRE-t\xf3l Eredm\xe9nyek oldal\xe1n",
    // Profile
    resultsProfileSummaryTitle: "A te irod\xe1d \u2014",
    resultsProfileTooltipText: "Minden profil val\xf3di szervezetekb\u0151l \xe9s munkahelyekb\u0151l \xe1ll, \xe9s a r\xe9szleteket az ipar\xe1gi ir\xe1nyelvek \xe9s a CBRE Workplace egyedi piaci ismeretei alapj\xe1n ellen\u0151rizt\xe9k.",
    // Program
    programSaveConfirmationBoxText: "Minden k\xe9szen \xe1ll! Elk\xfcdt\xfck emailben az eredm\xe9nyeidet.",
    programExamplePlansTitle: "Minta Tervek",
    programExamplePlansSubtitle: "K\xeds\xe9rletezz interakt\xedv alaprajzokkal, amelyek megfelelnek az ig\xe9nyeidnek. Ak\xe1r 3D-ben is felfedezheted \u0151ket!",
    programTooMuchTinkerWarning: "Ajjaj! \xdagy t\u0171nik, hogy a profilod alapj\xe1n a javasolt s\xe1von k\xedv\xfcl vagy. Fontold meg hogy <1>\xfajrakezded a k\xe9rd\u0151\xedvet</1> vagy seg\xedts\xe9get k\xe9rsz ezen az e-mail c\xedmen: <3>{{email}}</3>.",
    programDisclaimer: "A CBRE Spacer funkci\xf3j\xe1hoz nem kapcsol\xf3dik j\xf3t\xe1ll\xe1s. Az elk\xe9sz\xfclt eredm\xe9nyek az \xe1ltalad megadott adatokb\xf3l k\xf6vetkeznek csup\xe1n bemutat\xf3 jelleggel \xe9s nem t\xfckr\xf6znek val\xf3s t\xe9rjavaslatot vagy tartalmaznak javasolt b\xe9rleti felt\xe9teleket. A val\xf3di javaslatok nagyban elt\xe9rhetnek a k\xe9rd\u0151\xedv eredm\xe9nyeit\u0151l, hiszen azok sz\xe1mos olyan t\xe9nyez\u0151n m\xfalnak, amelyet a Spacer nem tud sz\xe1m\xedt\xe1sba venni. A Spacer haszn\xe1lat\xe1val vagy az abb\xf3l gener\xe1lt b\xe1rmely riporttal elfogadod a Felhaszn\xe1l\xe1si Felt\xe9teleinket \xe9s az Adatv\xe9delmi Szab\xe1lyzatot, amelyek a k\xf6vetkez\u0151 oldalakon tal\xe1lhat\xf3ak https://workplace.cbre.com/termsOfService, https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy. 2021 CBRE, Inc. All rights reserved.",
    programMetricsTitle: "Program metrik\xe1k",
    programMetricsSubtitle: "Ezek a metrik\xe1k hat\xe1rozz\xe1k meg a munkak\xf6rnyezeted",
    programDetailsSectionTitle: "Szabd saj\xe1t ig\xe9nyeidre a programod",
    programDetailsSectionSubtitle: "\xc1ll\xedtsd be az al\xe1bbi mez\u0151ket az irodai helyig\xe9nyed finomhangol\xe1s\xe1hoz.",
    programRevertButtonText: "Vissza\xe1ll\xedt\xe1s",
    programSaveButtonText: "M\xf3dos\xedt\xe1sok ment\xe9se",
    programSavedButtonText: "Mentve",
    // ProgramAssumptions
    programAssumptionsRecommendedOfficeSizeText: "Javasolt irodam\xe9ret",
    programAssumptionsProfileText: "Profil",
    programAssumptionsHeadcountText: "Alkalmazottak sz\xe1ma",
    programAssumptionsHeadcountFollowingText: "Emberek",
    programAssumptionsCollabText: "Kollabor\xe1ci\xf3",
    programAssumptionsCirculationText: "Forg\xe1si sebess\xe9g",
    programAssumptionsAvgDaysText: "\xc1tlagban az irod\xe1ban t\xf6lt\xf6tt napok sz\xe1ma",
    programAssumptionsAvgDaysFollowingText: "hetente",
    programAssumptionsAvgDaysPerWeekText: "Hetente az irod\xe1ban t\xf6lt\xf6tt napok sz\xe1ma (\xe1tlagban)",
    // ProgramHeroForPrint
    printNIAText: "Nett\xf3 bels\u0151 ter\xfclet",
    printUSFText: "Felhaszn\xe1lhat\xf3 nett\xf3 n\xe9gyzetl\xe1b",
    printRSFText: "B\xe9relhet\u0151 n\xe9gyzetl\xe1b",
    printDescText: "A megadott r\xe9szletek alapj\xe1n, \xe9s a {{lossFactorPercentage}}% {{factorType}} {{city}}en, \xf6sszesen ennyi irodaterek javasolunk-",
    printFitFactorText: "egyez\xe9si t\xe9nyez\u0151",
    printLossFactorText: "vesztes\xe9gi t\xe9nyez\u0151",
    // BarChart
    barChartIndivSubtitle: "Egy\xe9ni t\xe9r",
    barChartGroupSubtitle: "Csoportos t\xe9r",
    barChartAmenitySubtitle: "K\xe9nyelmi t\xe9r",
    // TabbedProgramBarChart
    tabbedBarChartMeSubtitle: "Egy\xe9n",
    tabbedBarChartGroupSubtitle: "Csoport",
    tabbedBarChartAmenitySubtitle: "Szolg\xe1ltat\xe1sok",
    // SpaceCategoryBreakdown
    spaceCatBreakdownSubtitle: "V\xe1lassz egy iroda t\xedpust a testreszab\xe1shoz",
    // SpaceCategoryBreakdownMobile
    spaceCatBreakdownMobileMeTitle: "Egy\xe9ni t\xe9r",
    spaceCatBreakdownMobileWeTitle: "K\xf6z\xf6ss\xe9gi t\xe9r",
    spaceCatBreakdownMobileAmenityTitle: "K\xe9nyelmi t\xe9r",
    spaceCatBreakdownMobileMeSubtitle: "egy\xe9ni munk\xe1hoz",
    spaceCatBreakdownMobileWeSubtitle: "kollabor\xe1ci\xf3s munk\xe1hoz",
    spaceCatBreakdownMobileAmenitySubtitle: "minden m\xe1shoz",
    spaceCatBreakdownMobileNIATotalTitle: "Teljes nett\xf3 bels\u0151 ter\xfclet",
    spaceCatBreakdownMobileTotalTitle: "Teljes {{sfType}} n\xe9gyzet {{unitCapitalized}}",
    spaceCatBreakdownMobileCirculationText: "Forg\xe1si sebess\xe9g",
    // SpaceCategoryDropdown
    spaceCatDropdownMeText: "Egy\xe9ni t\xe9r",
    spaceCatDropdownWeText: "K\xf6z\xf6ss\xe9gi t\xe9r",
    spaceCatDropdownAmenityText: "K\xe9nyelmi t\xe9r",
    // SidebarInfo
    sidebarInfoMeTitle: "Egy\xe9n",
    sidebarInfoWeTitle: "Csoport",
    sidebarInfoAmenityTitle: "Szolg\xe1ltat\xe1sok",
    // Space Category Descriptions (spaceCategoryDescription.js)
    spaceCatMeDesc: "Irodat\xe9r az egy\xe9ni munk\xe1hoz. A munkav\xe9gz\xe9s hely\xe9nek \xe9s m\u0171k\xf6d\xe9s\xe9nek v\xe1laszt\xe1si lehet\u0151s\xe9ge nagyobb munkav\xe1llal\xf3i el\xe9gedetts\xe9ghez vezet.",
    spaceCatWeDesc: "Irodat\xe9r a hat\xe9kony egy\xfcttm\u0171k\xf6d\xe9shez. Egy olyan korszakban, amikor a munka b\xe1rhol t\xf6rt\xe9nhet, fontos, hogy sokf\xe9le helyet biztos\xedtsunk a k\xfcl\xf6nb\xf6z\u0151 feladatok elv\xe9gz\xe9s\xe9hez.",
    spaceCatAmenityDesc: "A munk\xe1t t\xe1mogat\xf3 irodat\xe9r. A nagyszer\u0171 k\xe9nyelmi szolg\xe1ltat\xe1sok miatt az irod\xe1d egy olyan helly\xe9 v\xe1lhat ahol a munkav\xe1llal\xf3k sz\xedvesen t\xf6ltik az idej\xfcket.",
    // Suggested Custom Amenities (suggestedCustomAmenityUnitMap.js)
    audioVisualCustom: "Audio / Vizu\xe1lis",
    dataCenterCustom: "Adatk\xf6zpont",
    buildingSupportCustom: "\xc9p\xfclet-t\xe1mogat\xf3 szolg\xe1ltat\xe1sok",
    foodServiceCustom: "Teljesk\xf6r\u0171 \xe9tkez\xe9si szolg\xe1ltat\xe1s",
    kitchenCustom: "Konyha",
    serveryCustom: "Szolg\xe1lat",
    execDiningCustom: "Fels\u0151vezet\u0151 \xe9tkez\u0151",
    grabNGoCustom: "\xc9tel \xe9s ital automata",
    juiceCoffeeBarCustom: "K\xe1v\xe9z\xf3",
    childCareCustom: "Gyermekgondoz\xe1s",
    fitnessCenterCustom: "Fitneszk\xf6zpont",
    healthCenterCustom: "Eg\xe9szs\xe9g\xfcgyi k\xf6zpont",
    mailCenterCustom: "Posta / Postak\xf6zpont",
    commercialPrintCustom: "Kereskedelmi nyomtat\xf3 \xfczlet",
    centralCafeCustom: "K\xf6zponti k\xe1v\xe9z\xf3",
    securityCtrlCustom: "Biztons\xe1gi szoba",
    auditoriumCustom: "El\u0151ad\xf3terem",
    dryCleaningLaundryCustom: "Vegytiszt\xedt\xe1s / Mosoda",
    confCenterCustom: "Konferencia k\xf6zpont",
    multiPurpTrainingCustom: "T\xf6bb-c\xe9l\xfa / K\xe9pz\xe9s",
    informalCollabCustom: "Inform\xe1lis egy\xfcttm\u0171k\xf6d\xe9s",
    touchdownTeamCustom: "Touchdown / Csapat",
    // Suggested Custom Amenity Units (spaceUnit.js)
    seats: "\xfcl\xe9s",
    seats_plural: "\xfcl\xe9sek",
    rooms: "t\xe1rgyal",
    rooms_plural: "t\xe1rgyal\xf3k",
    areas: "ter\xfclet",
    areas_plural: "ter\xfcletek",
    units: "m\xe9rt\xe9kegys\xe9g",
    units_plural: "m\xe9rt\xe9kegys\xe9gek",
    // Predefined Amenities (spaceUnitMap.js) - Shared Space Units
    focusRoomDefined: "F\xf3kusz t\xe1rgyal\xf3",
    fileRoomDefined: "Iratszoba",
    centralReceptionHubDefined: "K\xf6zponti recepci\xf3",
    smOfficeDefined: "Kis iroda",
    regOfficeDefined: "Norm\xe1l iroda",
    benchDesk5Defined: "5\u2019 \xedr\xf3asztal",
    benchDesk6Defined: "6\u2019 \xedr\xf3asztal",
    meetingRoom4Defined: "T\xe1rgyal\xf3 (4 f\u0151)",
    meetingRoom6Defined: "T\xe1rgyal\xf3 (6 f\u0151)",
    meetingRoom8Defined: "T\xe1rgyal\xf3 (8 f\u0151)",
    meetingRoom12Defined: "T\xe1rgyal\xf3 (12 f\u0151)",
    meetingRoom15Defined: "T\xe1rgyal\xf3 (15 f\u0151)",
    semiEnclosedMeetingBooth4Defined: "F\xe9lig z\xe1rt t\xe1rgyal\xf3 (4 f\u0151)",
    openCollabSpace4to6Defined: "Nyitott kollabor\xe1ci\xf3s t\xe9r (4-6 f\u0151)",
    contemplationSpaceDefined: "Csendes t\xe1rgyal\xf3",
    mainITEquipRoomDefined: "Informatikai szerver szoba",
    receptionAreaDefined: "Recepci\xf3",
    cafeFoodServiceDefined: "K\xe1v\xe9z\xf3 / \xc9tkez\xe9si szolg\xe1ltat\xe1s",
    teamStorageDefined: "Csapat t\xe1rol\xf3helys\xe9ge",
    coatClosetsDefined: "Kab\xe1t t\xe1rol\xf3",
    genStorageDefined: "Rakt\xe1r",
    centralisedCopyPrintMailDefined: "K\xf6zpontos\xedtott Nyomtat\xe1s, m\xe1sol\xe1s \xe9s iratt\xe1rol\xe1s",
    specialResourceAreaDefined: "K\xfcl\xf6nleges eszk\xf6z\xf6k helys\xe9ge",
    personalStorageDefined: "Szem\xe9lyes t\xe1rol\xf3 (szekr\xe9ny)",
    storageITSpaceDefined: "IT eszk\xf6z\xf6k t\xe1rol\xf3ja",
    secondaryServerRoomDefined: "M\xe1sodlagos szerver / telekommunik\xe1ci\xf3s szoba",
    mothersRoomDefined: "Kismama szoba",
    buildITSpaceDefined: "IT \xc9p\xedtett ter\xfclet",
    workerCouncilOffice2Defined: "Munka\xfcgyi tan\xe1csad\xf3 iroda (2 f\u0151)",
    securityCtrlRoomDefined: "Biztons\xe1gi szolg\xe1lati helyis\xe9g",
    centralisedMailDefined: "K\xf6zpontos\xedtott postaeloszt\xf3",
    visitorCoatLuggageRoomDefined: "Csomagmeg\u0151rz\u0151",
    wellnessRoomDefined: "Wellnes szoba",
    internalStairDefined: "Bels\u0151 l\xe9pcs\u0151",
    commercialPrintRoomDefined: "Kereskedelmi nyomtat\xf3szoba",
    buildingSupportServicesAreaDefined: "\xc9p\xfclet-t\xe1mogat\xe1si szolg\xe1ltat\xe1sok",
    // Predefined Amenities (spaceUnitMap.js) - US_SMALL and US_REGULAR
    officeDefined: "Iroda",
    lgOfficeDefined: "Iroda (nagy m\xe9ret\u0171)",
    smWorkstationDefined: "Munka\xe1llom\xe1s (kicsi)",
    mdWorkstationDefined: "Munka\xe1llom\xe1s (norm\xe1l)",
    lgWorkstationDefined: "Munka\xe1llom\xe1s (nagy)",
    huddleRoomDefined: "Kis t\xe1rgyal\xf3szoba",
    dispersedCopyPrintAreaDefined: "Nyomtat\xe1si \xe9s m\xe1sol\xe1si eloszt\xf3 helyis\xe9g",
    smMeetingRoomDefined: "Kist\xe1rgyal\xf3",
    mdMeetingRoomDefined: "Norm\xe1l t\xe1rgyal\xf3",
    lgMeetingRoomDefined: "Nagyt\xe1rgyal\xf3",
    xlMeetingRoomDefined: "Extra Nagyt\xe1rgyal\xf3 / Tan\xe1csterem",
    multiPurpTrainingDefined: "T\xf6bb c\xe9l\xfa / Oktat\xe1s",
    informalCollabDefined: "Inform\xe1lis kollabor\xe1ci\xf3s ter\xfclet",
    touchdownTeamDefined: "Touchdown / Csapat ter\xfclet",
    pantryVendingCoffeeAreaDefined: "Kamra / K\xe1v\xe9z\xf3",
    workplaceStorageRoomDefined: "Munkahelyi t\xe1rol\xf3",
    employeeCoatAreaDefined: "Kab\xe1t t\xe1rol\xf3",
    dispersedMailAreaDefined: "Posta eloszt\xf3",
    lockerUnitDefined: "Szekr\xe9ny",
    serverRoomDefined: "Szerver szoba",
    frontDeskAreaDefined: "Recepci\xf3",
    centralCafeAreaDefined: "K\xf6z\xf6ss\xe9gi ter\xfcl",
    mailCenterAreaDefined: "Iratt\xe1rol\xf3 ter\xfclet",
    kitchenAreaDefined: "Konyha",
    drawerLateralFileUnitDefined: "3 fi\xf3kos kis iratt\xe1rol\xf3",
    serveryAreaDefined: "Kiszolg\xe1l\xf3 ter\xfclet",
    juiceBarCoffeeShopAreaDefined: "K\xe1v\xe9z\xf3",
    diningSupportAreaDefined: "Hinterland",
    diningAreaDefined: "\xc9tkez\u0151",
    grabNGoAreaDefined: "\xc9tel \xe9s ital automata",
    focusRoomSharedFocus: "F\xf3kusz t\xe1rgyal\xf3",
    // Predefined Amenities (spaceUnitMap.js) - UK_REGULAR
    fullFoodServiceDefined: "Teljesk\xf6r\u0171 meleg\xe9tel szolg\xe1ltat\xe1s",
    // Predefined Amenities (spaceUnitMap.js) - APAC_REGULAR
    officeWorkMeetDefined: "Iroda (Munkatev\xe9kenys\xe9g/Kollabor\xe1ci\xf3)",
    lgOfficeWorkMeetDefined: "Nagy iroda (Munkatev\xe9kenys\xe9g/Kollabor\xe1ci\xf3)",
    focusDefined: "F\xf3kusz",
    bench1pt6Defined: "1.6 m-es\xa0asztal",
    bench1pt8Defined: "1.8 m-es asztal",
    bench1pt8LDefined: "1.8 m-es\xa0\xa0L-alak\xfa munka\xe1llom\xe1s",
    banquetWorkMeetDefined: "Banket asztal - Munka/t\xe1rgyal\xf3 (2 f\u0151s)",
    cafeTable4Defined: "K\xe1v\xe9z\xf3 asztal (8-10 f\u0151)",
    kitchenTable8to10Defined: "Konyhai asztal (8-10 f\u0151)",
    standingWhiteboardDefined: "\xc1ll\xf3 t\xe1bla",
    huddleRoom3Defined: "Kis t\xe1rgyal\xf3szoba",
    smMeetingRoom5Defined: "kis\xa0t\xe1rgyal\xf3 (5 f\u0151)",
    mdMeetingRoom8Defined: "k\xf6zepes\xa0t\xe1rgyal\xf3 (8 f\u0151)",
    lgMeetingRoom20Defined: "nagy\xa0t\xe1rgyal\xf3 (20 f\u0151)",
    xlBoardroom: "extra nagy\xa0t\xe1rgyal\xf3 / vezet\u0151i t\xe1rgyal\xf3",
    wellnessRoomsDefined: "Wellness szob\xe1k",
    employeeCoatsGymLockersDefined: "Kab\xe1t t\xe1rol\xf3k / \xd6lt\xf6z\u0151 szekr\xe9nyek",
    lockersDefined: "Szekr\xe9nyek",
    dispersedCopyPrintScanAreaDefined: "M\xe1sol\xe1s/ Nyomtat\xe1s / Scannel\xe9s eloszt\xf3 helyis\xe9g",
    hydrationPointDefined: "Hidrat\xe1ci\xf3s ter\xfclet (V\xedz, tea, k\xe1v\xe9)",
    centralHighDensityStorageDefined: "K\xf6zponti nagy s\u0171r\u0171s\xe9g\u0171 t\xe1rol\xf3",
    wellnessMothersRoomDefined: "Wellness / Kismama szoba",
    serverHubRoomsDefined: "Szerver szob\xe1k",
    buildITStoreRoomDefined: "IT t\xe1rhely terem",
    simpleReceptionWaitDefined: "Recepci\xf3 \xe9s v\xe1rakoz\xf3",
    centralCafeSocialHubDefined: "K\xf6z\xf6ss\xe9gi k\xf6zpont",
    mailCentreDefined: "Postak\xf6zpont",
    utilityStoreRoomDefined: "H\xe1ztart\xe1si helyis\xe9g",
    drawerLateralFileDefined: "3 fi\xf3kos kis iratt\xe1rol\xf3",
    juiceBarCoffeeShopDefined: "K\xe1v\xe9z\xf3",
    buildingSupportServicesDefined: "\xc9p\xfclet-t\xe1mogat\xf3 szolg\xe1ltat\xe1sok",
    // Space Unit Map Descriptions (spaceUnitMap.js) - Shared Descriptions
    focusRoomDesc: "A F\xf3kusz Szob\xe1k olyan elz\xe1rt helyis\xe9gek, melyek a f\xf3kusz\xe1lt, \xe9s/vagy bizalmas munka elv\xe9gz\xe9s\xe9nek t\xe1mogat\xe1s\xe1ra hivatottak tipikusan egy, vagy k\xe9t f\u0151 r\xe9sz\xe9re. Az akusztikus\xa0elszigetel\xe9s a legf\u0151bb ezekben a szob\xe1kban. A F\xf3kusz Szob\xe1k \xe1ltal\xe1ban nincsenek megjel\xf6lve vagy elnevezve, \xe9s sz\xfcks\xe9g szerint ideiglenesen foglalhat\xf3k a relev\xe1ns feladatok elv\xe9gz\xe9s\xe9re.",
    fileRoomDesc: "Ez egy dokumentum t\xe1rol\xf3 egy\xe9nek \xe9s csoportok sz\xe1m\xe1ra. A legt\xf6bb iroda digitaliz\xe1ci\xf3s t\xf6rekv\xe9seinek k\xf6sz\xf6nhet\u0151en az egy\xe9ni \xe9s a csoportos dokumentum t\xe1rol\xf3ra egyar\xe1nt jelent\u0151sen cs\xf6kken az ig\xe9ny. M\xe9gis, ez a k\xf6zponti hely a jogi dokumentumok m\xe1solatainak, vagy a hossz\xfat\xe1v\xfa projektek anyagainak t\xe1rol\xe1s\xe1ra, k\xfcl\xf6n\xf6sen az\xe9rt, mert a legt\xf6bb nyitott irodat\xe9r asztalai kev\xe9s hellyel rendelkeznek. ",
    centralReceptionHubDesc: "A recepci\xf3s ter\xfclet a c\xe9ged els\u0151sz\xe1m\xfa lehet\u0151s\xe9ge, hogy benyom\xe1st adjon a dolgoz\xf3knak, \xfcgyfeleknek, \xe9s a t\xf6bbi l\xe1togat\xf3nak. Folyamatosan a c\xe9g brandj\xe9t kell k\xf6zvet\xedtenie, \xe9s v\xe9deni a k\xedv\xe1nt megjelen\xe9st. A recepci\xf3s pultnak komfortos helyet kell biztos\xedtania a recepci\xf3s sz\xe1m\xe1ra, \xe9s k\xe9nyelmes \xfcl\u0151butor kell hogy v\xe1rtja a l\xe1togat\xf3kat.",
    officeDesc: "Az irod\xe1k priv\xe1t, elz\xe1rt terek a munkav\xe1llal\xf3k sz\xe1m\xe1ra. Kiv\xe1l\xf3an cs\xf6kkenti a zavar\xf3 t\xe9nyez\u0151ket, \xedgy a f\xf3kusz\xe1ltan v\xe9gezhet\u0151 a munka. Az irod\xe1k \xe1ltal\xe1ban asztallal \xe9s munkahelyi sz\xe9kkel felszereltek, tov\xe1bb\xe1 vend\xe9g sz\xe9kekkel a l\xe1togat\xf3k sz\xe1m\xe1ra. Az iratt\xe1rol\xf3 \xe9s szem\xe9lyes t\xe1rol\xf3helyek m\xe9rete azonban elt\xe9r\u0151. A helyis\xe9g m\xe9rete, a munkav\xe9gz\xe9st\u0151l, vagy a st\xe1tuszt\xf3l/hierarchi\xe1t\xf3l f\xfcgg\u0151en v\xe1ltoz\xf3 lehet.",
    benchDeskDesc: "A munkaasztalok egy\xe9nileg szabadon elfoglalhat\xf3 helyek a munkav\xe9gz\xe9shez. A kisebb munkaasztalok a teljes munkaid\u0151ben dolgoz\xf3k sz\xe1m\xe1ra elfoglalhat\xf3k, ideiglenesen (szabad munka\xe1llom\xe1s), vagy \xe1lland\xf3 haszn\xe1latra. Ezek az asztalok egyar\xe1nt kiv\xe1l\xf3ak a l\xe1togat\xf3 alkalmazottak, vagy a kivitelez\u0151k sz\xe1m\xe1ra, akik nem \xe1lland\xf3 jelleggel tart\xf3zkodnak az irod\xe1ban. A nyitott irodat\xe9r el\u0151nyei k\xf6z\xe9 tartozik az iroda \xe1tl\xe1that\xf3s\xe1ga, \xe9s a vele j\xe1r\xf3 g\xf6rd\xfcl\xe9keny egy\xfcttm\u0171k\xf6d\xe9s. H\xe1tr\xe1ny lehet a figyelmet megzavar\xf3 zaj, ami\xe9rt aj\xe1nlott a nyitott irodaterek mell\xe9 t\xf6bb f\xf3kusz \xe9s priv\xe1t t\xe1rgyal\xf3 kialak\xedt\xe1sa. Az asztaln\xe1l t\xf6rt\xe9n\u0151\xa0iratt\xe1rol\xe1s korl\xe1tozott, a k\xf6z\xf6s\xa0iratt\xe1rol\xf3k a folyos\xf3n helyezkednek el.",
    meetingRoomDesc: "A t\xe1rgyal\xf3k elz\xe1rt helyis\xe9gek, melyek kisebb csoportmegbesz\xe9l\xe9sek (2-4 f\u0151) t\xe1mogat\xe1s\xe1ra hivatottak. A/V felszerel\xe9ssel \xe9s feh\xe9r t\xe1bl\xe1kkal kell rendelkezni\xfck, hogy megk\xf6nny\xedts\xe9k a tud\xe1smegoszt\xe1st, valamint akusztikusan\xa0elszigeteltnek kell lenni\xfck (a t\xe1rgyal\xf3n k\xedv\xfcl tart\xf3zkod\xf3 szem\xe9lyeknek nem szabad hallaniuk a bent elhangzottakat).",
    meetingRoomDesc6: "A t\xe1rgyal\xf3k elz\xe1rt helyis\xe9gek, melyek kisebb csoportmegbesz\xe9l\xe9sek (2-4 f\u0151) t\xe1mogat\xe1s\xe1ra hivatottak. A/V felszerel\xe9ssel \xe9s feh\xe9r t\xe1bl\xe1kkal kell rendelkezni\xfck, hogy megk\xf6nny\xedts\xe9k a tud\xe1smegoszt\xe1st, valamint akusztikusan\xa0elszigeteltnek kell lenni\xfck (a t\xe1rgyal\xf3n k\xedv\xfcl tart\xf3zkod\xf3 szem\xe9lyeknek nem szabad hallaniuk a bent elhangzottakat).",
    meetingRoomDesc8: "A t\xe1rgyal\xf3k elz\xe1rt helyis\xe9gek, melyek kisebb csoportmegbesz\xe9l\xe9sek (2-4 f\u0151) t\xe1mogat\xe1s\xe1ra hivatottak. A/V felszerel\xe9ssel \xe9s feh\xe9r t\xe1bl\xe1kkal kell rendelkezni\xfck, hogy megk\xf6nny\xedts\xe9k a tud\xe1smegoszt\xe1st, valamint akusztikusan\xa0elszigeteltnek kell lenni\xfck (a t\xe1rgyal\xf3n k\xedv\xfcl tart\xf3zkod\xf3 szem\xe9lyeknek nem szabad hallaniuk a bent elhangzottakat).",
    meetingRoomDesc12: "A t\xe1rgyal\xf3k elz\xe1rt helyis\xe9gek, melyek kisebb csoportmegbesz\xe9l\xe9sek (2-4 f\u0151) t\xe1mogat\xe1s\xe1ra hivatottak. A/V felszerel\xe9ssel \xe9s feh\xe9r t\xe1bl\xe1kkal kell rendelkezni\xfck, hogy megk\xf6nny\xedts\xe9k a tud\xe1smegoszt\xe1st, valamint akusztikusan\xa0elszigeteltnek kell lenni\xfck (a t\xe1rgyal\xf3n k\xedv\xfcl tart\xf3zkod\xf3 szem\xe9lyeknek nem szabad hallaniuk a bent elhangzottakat).",
    meetingRoomDesc15: "A t\xe1rgyal\xf3k elz\xe1rt helyis\xe9gek, melyek kisebb csoportmegbesz\xe9l\xe9sek (2-4 f\u0151) t\xe1mogat\xe1s\xe1ra hivatottak. A/V felszerel\xe9ssel \xe9s feh\xe9r t\xe1bl\xe1kkal kell rendelkezni\xfck, hogy megk\xf6nny\xedts\xe9k a tud\xe1smegoszt\xe1st, valamint akusztikusan\xa0elszigeteltnek kell lenni\xfck (a t\xe1rgyal\xf3n k\xedv\xfcl tart\xf3zkod\xf3 szem\xe9lyeknek nem szabad hallaniuk a bent elhangzottakat).",
    openCollabSpace4to6Desc: "Ezek a ter\xfcletek a kisebb csoportok (4-6 f\u0151) t\xe1mogat\xe1s\xe1ra hivatottak, mint p\xe9ld\xe1ul csoportos \xf6tletel\xe9s, \xe9s inform\xe1lis besz\xe9lget\xe9s kolleg\xe1k \xe9s \xfcgyfelek k\xf6z\xf6tt.",
    cafeFoodServiceDesc: "A k\xf6zponti k\xe1v\xe9z\xf3 az \xe9tkez\xe9s, szoci\xe1lis interakci\xf3k, egy\xe9ni munka \xe9s kisebb t\xe1rgyal\xe1sok lebonyol\xedt\xe1s\xe1ra hivatottak. A helyis\xe9g funkcion\xe1lis \xe9tkez\u0151b\xfatorait \xe9s a brandnek megfelel\u0151 sz\xednpalett\xe1t a helyisg\xe9g tervez\xe9sekor figyelembe kell venni.",
    coatClosetsDesc: "Az alkalmazottaknak a kab\xe1tok \xe9s a nagyobb ruhadarabok t\xe1rol\xe1s\xe1ra sz\xfcks\xe9g\xfck van egy erre kijel\xf6lt helyre, f\u0151k\xe9nt a nyitott irodat\xe9r kialak\xedt\xe1sban, hiszen az asztalokon a t\xe1rol\xe1si lehet\u0151s\xe9gek limit\xe1ltak. Ezeknek sz\xe9tsz\xf3rtan kell elhelyezkedni\xfck az iroda eg\xe9sz ter\xfclet\xe9n, a kij\xe1ratokn\xe1l \xe9s a f\u0151 folyos\xf3kn\xe1l. \xc1ltal\xe1ban van egy polc az akaszt\xf3s r\xe9szn\xe9l a kalapoknak \xe9s egy\xe9b felszerel\xe9seknek, t\xe1rol\xf3kkal vagy b\u0151r\xf6nd\xf6kkel a szekr\xe9ny belsej\xe9ben.",
    copyPrintDesc: "Az irod\xe1ban sz\xe9tsz\xf3rtan m\xe1sol\xf3/nyomtat\xf3 lehet\u0151s\xe9gek, tov\xe1bb\xe1 minden ir\xe1nyb\xf3l gyors el\xe9r\xe9s a multifunkci\xf3s eszk\xf6z\xf6kh\xf6z. A m\xe1sol\xf3/nyomtat\xf3 k\xf6rny\xe9k\xe9n kuk\xe1k az \xfajrahasznos\xedt\xe1shoz, valamint kis szekr\xe9nyek a plusz pap\xedr \xe9s egy\xe9b eszk\xf6z\xf6k t\xe1rol\xe1s\xe1ra. Ezeket a ter\xfcleteket kiz\xe1r\xf3lag az eszk\xf6z\xf6k haszn\xe1lata erej\xe9ig lehet haszn\xe1lni, nem a szoci\xe1lis/munkat\xe9r b\u0151v\xedt\xe9s\xe9t szolg\xe1lj\xe1k.",
    specialResourceBuildingSupportAreaDesc: "Ebbe beletartozik minden plusz ter\xfclet, ami egy irod\xe1hoz tartozhat. Az egyik lehet a biztons\xe1gi asztal, vagy a felszerel\xe9sek, de ak\xe1r t\xe1rol\xf3 t\xe9r is lehet. Ez szervezetekt\u0151l f\xfcgg\u0151en v\xe1ltozhat, de ahogy az iroda n\xf6vekszik, ezek a kieg\xe9sz\xedt\u0151 helyis\xe9gek egyre gyakoribb\xe1 \xe9s fontosabb\xe1 v\xe1lnak.",
    secondaryServerRoomDesc: "M\xe1sodlagos szerver (technol\xf3gia) szoba az IT felszerel\xe9s t\xe1rol\xe1s\xe1ra \xe9s v\xe9delm\xe9re, tov\xe1bb\xe1 a gyenge\xe1ram\xfa fesz\xfclts\xe9g elhat\xe1rol\xe1sa. A szob\xe1knak 24 \xf3r\xe1s szell\u0151z\xe9s mellett folyamatos 22 Celsius fokon, 50%-os relat\xedv p\xe1ratartalomban kell lenni\xfck.",
    mothersRoomDesc: "A kismama szob\xe1k a rendk\xedv\xfcli priv\xe1tszf\xe9ra t\xe1mogat\xe1s\xe1t szolg\xe1lj\xe1k, ak\xe1r szoptat\xf3 any\xe1knak, ak\xe1r csak az irod\xe1b\xf3l r\xf6vid id\u0151re nyugalomra v\xe1gy\xf3knak. A kismama szob\xe1k az \xfaj irod\xe1k t\xf6bbs\xe9g\xe9ben nagys\xe1gt\xf3l \xe9s l\xe9tsz\xe1mt\xf3l f\xfcggetlen\xfcl felt\xe9telnek sz\xe1m\xedtanak.",
    visitorCoatLuggageRoomDesc: "A l\xe1togat\xf3knak a kab\xe1tok \xe9s a nagyobb ruhadarabok t\xe1rol\xe1s\xe1ra sz\xfcks\xe9g\xfck van egy erre kijel\xf6lt helyre. Ezeknek sz\xe9tsz\xf3rtan kell elhelyezkedni\xfck az iroda eg\xe9sz ter\xfclet\xe9n, a kij\xe1ratokn\xe1l \xe9s a f\u0151 folyos\xf3kn\xe1l. \xc1ltal\xe1ban van egy polc az akaszt\xf3s r\xe9szn\xe9l a kalapoknak \xe9s egy\xe9b felszerel\xe9seknek, t\xe1rol\xf3kkal vagy b\u0151r\xf6nd\xf6kkel a szekr\xe9ny belsej\xe9ben.",
    wellnessRoomDesc: "A wellness szob\xe1k (kor\xe1bban kismama szob\xe1k) a rendk\xedv\xfcli priv\xe1tszf\xe9ra t\xe1mogat\xe1s\xe1t szolg\xe1lj\xe1k, ak\xe1r szoptat\xf3 any\xe1knak, ak\xe1r csak az irod\xe1b\xf3l r\xf6vid id\u0151re nyugalomra v\xe1gy\xf3knak. A wellness szob\xe1k az \xfaj irod\xe1k t\xf6bbs\xe9g\xe9ben nagys\xe1gt\xf3l \xe9s l\xe9tsz\xe1mt\xf3l f\xfcggetlen\xfcl felt\xe9telnek sz\xe1m\xedtanak, \xe9s tartalmazniuk kell egy pihen\u0151fotelt, h\u0171t\u0151t \xe9s ide\xe1lis esetben egy mosd\xf3kagyl\xf3t.",
    internalStairDesc: "A bels\u0151 l\xe9pcs\u0151k a l\xe9pcs\u0151h\xe1z r\xe9szek\xe9nt akt\xedv szerepet t\xf6ltenek be a emeletek \xf6sszek\xf6ttet\xe9s\xe9ben, vagy kieg\xe9sz\xedt\u0151 elemk\xe9nt szolg\xe1lhatnak az iroda bels\u0151 r\xe9sz\xe9ben. Sokszor ez az irod\xe1ban az \xf6sszek\xf6t\u0151 hely, vagy a k\xe1v\xe9z\xf3, recepci\xf3 \xe9s a t\xe1rgyal\xf3k k\xf6zponti helyek\xe9nt szolg\xe1l.",
    commercialPrintRoomDesc: "Sokszor ez a post\xe1z\xf3val egybek\xf6t\xf6tt helyis\xe9g, a c\xe9gek biztos\xedtj\xe1k a v\xe1llalaton bel\xfcli nyomtat\xe1st, \xf6sszef\u0171z\xe9st \xe9s prezent\xe1ci\xf3 \xf6ssze\xe1ll\xedt\xe1st a nyomtat\xf3 szob\xe1n bel\xfcl. Sok nyomtat\xf3 tal\xe1lhot\xf3 itt, \xe9s nagyobb form\xe1tum\xfa nyomtat\xf3kat is tartalmazhatnak. Ezekben a helyis\xe9gekben t\xe1rol\xf3 is tal\xe1lhat\xf3 a felszerel\xe9seknek \xe9s pult a kisebb eszk\xf6z\xf6knek, tov\xe1bb\xe1 hely a tervrajzok sz\xe1m\xe1ra.",
    pantryVendingCoffeeDesc: "A k\xf6zpotni k\xe1v\xe9z\xf3val ellent\xe9tben a kamra/automata/k\xe1v\xe9z\xf3 ter\xfclet az alkalmazottaknak lett kialak\xedtva, hogy gyorsan be tudj\xe1k szerezni a sz\xfcks\xe9ges \xe9telt, vagy italt. A ny\xfczsg\xe9s \xe9s a besz\xe9lget\xe9sek term\xe9szetesen az \xe9tel mellett t\xf6rt\xe9nik, de ezeken a helyeken nincsenek kihelyzve sz\xe9kek, hogy min\xe9l gyorsabban v\xe9gezhessenek, \xe9s ne legyen elny\xfajtott a t\xe1rsalg\xe1s.",
    storageDesc: "A t\xe1rol\xf3 szob\xe1k k\xfcl\xf6nf\xe9le dolgok, mint a nagyobb felszerel\xe9sek, plusz b\xfator, nagyobb ruh\xe1zat, nyaral\xe1shoz sz\xfcks\xe9ges holmik t\xe1rol\xe1s\xe1t szolg\xe1lj\xe1k. Ezek egyar\xe1nt vend\xe9g kab\xe1tok \xe9s b\u0151r\xf6nd\xf6k t\xe1rol\xe1s\xe1ra is alkalmasak. A k\xe9nyelem kedv\xe9\xe9rt egy kisebb t\xe1rol\xf3nak a recepci\xf3 mellett is kell lennie.",
    centralisedDispersedMailAreaDesc: "Nagyobb c\xe9gek eset\xe9ben sz\xfcks\xe9ges post\xe1z\xf3 k\xf6zpont a kimen\u0151 \xe9s bej\xf6v\u0151 levelek rendszerez\xe9s\xe9re. Ezeken a helyeken k\xfcl\xf6nleges gy\xe1rt\xe1si \xe9s levelez\xe9si felszerel\xe9sek tal\xe1lhat\xf3k. Ezen fel\xfcl nagyobb ter\xfclet van az iratok \xe9s egy\xe9b anyagok iktat\xe1s\xe1ra. Erre a feladatra \xe1ltal\xe1ban egy szem\xe9ly van kijel\xf6lve teljes munkaid\u0151ben.",
    lockerDesc: "A szekr\xe9nyek is pakol\xe1si lehet\u0151s\xe9get biztos\xedtanak az egy\xe9nek sz\xe1m\xe1ra. A dolgoz\xf3k ide z\xe1rhatj\xe1k be az \xe9rt\xe9keiket, a szem\xe9lyes t\xe1rgyaikat, \xe9s a sz\xfcks\xe9ges f\xe1jlokat. A szekr\xe9nyek lehetnek szem\xe9lyenk\xe9nt kijel\xf6lve, vagy \xe9rkez\xe9si sorrendben.",
    mainITandServerRoomDesc: "Els\u0151dleges szerver (technol\xf3gia) szoba az IT felszerel\xe9s t\xe1rol\xe1s\xe1ra \xe9s v\xe9delm\xe9re, tov\xe1bb\xe1 a gyenge\xe1ram\xfa fesz\xfclts\xe9g elhat\xe1rol\xe1sa. A szob\xe1knak 24 \xf3r\xe1s szell\u0151z\xe9s mellett folyamatos\xa022 Celsius\xa0fokon, 50%-os relat\xedv p\xe1ratartalomban kell lenni\xfck.",
    drawerLateralFileDesc: "Szem\xe9lyes t\xe1rol\xf3k az egy\xe9nek sz\xe1m\xe1ra az asztalokon, vagy az iroda egy\xe9b ter\xfcletein. Ezek tartalma \xe1ltal\xe1ban szem\xe9lyes, vagy egy fut\xf3 projekthez kapcsol\xf3d\xf3 anyagok.",
    juiceBarCoffeeShopDesc: "Egy c\xe9gnek lehet hogy nincs egy teljesen felszerelt konyh\xe1ja, de rendelkezhet k\xe1v\xe9z\xf3val, vagy juice b\xe1rral. Egy szervezetnek akkor is lehetnek ilyen alkalmatoss\xe1gai, ha van f\u0151 \xe9tkez\u0151 szolg\xe1ltat\xe1sa, f\u0151k\xe9nt, ha az adott iroda nagyobb m\xe9ret\u0171. Ez a ter\xfclet val\xf3sz\xedn\u0171leg egy Starbucks-ra is hasonl\xedthat munka\xe1llom\xe1ssal az ott dolgoz\xf3k sz\xe1m\xe1ra, elk\xfcl\xf6n\xedtve a felszolg\xe1l\xf3 pult mellett.",
    grabNGoDesc: "A kisebb pihen\u0151t\xe9rben tal\xe1lhat\xf3 t\xf6bb h\u0171t\u0151, polcok a chipsnek \xe9s r\xe1gcs\xe1lnival\xf3knak, \xe9s egy p\xe9nzt\xe1r. Ezek az \xf6nkiszolg\xe1l\xf3k \xe1ltal\xe1ban kamer\xe1val felszerelt helyis\xe9gek. Kieg\xe9sz\xedthet\u0151k egy kisebb kamr\xe1val, mely felszerelt h\u0171t\u0151vel, fagyaszt\xf3val, \xe9s \xe9tel el\u0151k\xe9sz\xedt\xe9s\xe9re alkalmas ter\xfclettel.",
    smMeetingConferenceRoomDesc: "A kisebb konferencia szoba egy elk\xfcl\xf6n\xfcl\u0151 t\xe1rgyal\xf3t\xe9r, melyben k\xe9nyelmesen 2-6 ember is elf\xe9rhet az asztaln\xe1l. Ezek a szob\xe1k egyar\xe1nt bels\u0151s, \xe9s \xfcgyf\xe9lmegbesz\xe9l\xe9sekre is alkalmasak, ez\xe9rt kifejezetten felhaszn\xe1l\xf3 bar\xe1t kialak\xedt\xe1ssal kell rendelkeznie az \xe1ram \xe9s A/V csatlakoz\xf3k tekintet\xe9ben.",
    mdMeetingConferenceRoomDesc: "A k\xf6zepes konferencia szoba egy elk\xfcl\xf6n\xfcl\u0151 t\xe1rgyal\xf3t\xe9r, melyben k\xe9nyelmesen 6-10 ember is elf\xe9rhet az asztaln\xe1l. Ezek a szob\xe1k egyar\xe1nt bels\u0151s, \xe9s \xfcgyf\xe9lmegbesz\xe9l\xe9sekre is alkalmasak, ez\xe9rt kifejezetten felhaszn\xe1l\xf3 bar\xe1t kialak\xedt\xe1ssal kell rendelkeznie az \xe1ram \xe9s A/V csatlakoz\xf3k tekintet\xe9ben.",
    lgMeetingConferenceRoomDesc: "A nagy konferencia szoba egy elk\xfcl\xf6n\xfcl\u0151 t\xe1rgyal\xf3t\xe9r, melyben k\xe9nyelmesen 12-14 ember is elf\xe9rhet az asztaln\xe1l, ig\xe9ny szerint elny\xfal\xf3 \xfcl\u0151helyekkel. Ezek a szob\xe1k egyar\xe1nt bels\u0151s, \xe9s \xfcgyf\xe9lmegbesz\xe9l\xe9sekre is alkalmasak, tov\xe1bb\xe1 prezent\xe1l\xe1sra. A b\xfatoroknak mozgathat\xf3nak kell lenni\xfck, hogy a helyis\xe9get m\xe1s c\xe9lokra is haszn\xe1lni lehessen, mint p\xe9ld\xe1ul j\xf3ga \xf3r\xe1k a munkav\xe1llal\xf3k sz\xe1m\xe1ra.",
    xlMeetingRoomDesc: "A tan\xe1csteremben 14-18 f\u0151 is elf\xe9rhet az asztaln\xe1l, legal\xe1bb 10 t\xfalny\xfal\xf3 \xfcl\u0151hellyel. Ezek a termek legink\xe1bb nagy m\xe9ret\u0171 form\xe1lis bels\u0151s \xe9rtekezletekre, \xe9s \xfcgyf\xe9l\xe9rtekezletekre haszn\xe1lhat\xf3k. Felszerelts\xe9g\xfcket tekintve terjedelmes A/V technol\xf3gi\xe1val \xe9s \xfcgyf\xe9lbar\xe1t megjelen\xe9ssel kell rendelkezni\xfck.",
    // Space Unit Map Descriptions (spaceUnitMap.js) - US_SMALL and US_REGULAR
    lgOfficeDesc: "Az irod\xe1k priv\xe1t, elz\xe1rt terek a munkav\xe1llal\xf3k sz\xe1m\xe1ra. Kiv\xe1l\xf3an cs\xf6kkenti a zavar\xf3 t\xe9nyez\u0151ket, \xedgy a f\xf3kusz\xe1ltan v\xe9gezhet\u0151 a munka. Az irod\xe1k \xe1ltal\xe1ban felszereltek asztallal \xe9s munkahelyi sz\xe9kkel, tov\xe1bb\xe1 vend\xe9g sz\xe9kekkel a l\xe1togat\xf3k sz\xe1m\xe1ra. Az iratt\xe1rol\xf3 \xe9s szem\xe9lyes t\xe1rol\xf3helyek m\xe9rete azonban elt\xe9r\u0151. A helyis\xe9g m\xe9rete, a munkav\xe9gz\xe9st\u0151l (p\xe9ld\xe1ul rendszeres \xe9rtekezletek), vagy a st\xe1tuszt\xf3l/hierarchi\xe1t\xf3l f\xfcgg\u0151en v\xe1ltoz\xf3 lehet. A kiss\xe9 nagyobb iroda partnerk\xe9nt, vagy priv\xe1t t\xe1rgyal\xf3k\xe9nt m\u0171k\xf6dhet.",
    smWorkstationDesc: "A munka\xe1llom\xe1sok nyitott, egy\xe9neknek kialak\xedtott munkaterek. A kisebb munka\xe1llom\xe1sok a teljes munkaid\u0151ben dolgoz\xf3k sz\xe1m\xe1ra elfoglalhat\xf3k, ideiglenesen (szabad munka\xe1llom\xe1s), vagy \xe1lland\xf3 haszn\xe1latra. Ezek az asztalok egyar\xe1nt kiv\xe1l\xf3ak a l\xe1togat\xf3 alkalmazottak, vagy a kivitelez\u0151k sz\xe1m\xe1ra, akik nem \xe1lland\xf3 jelleggel tart\xf3zkodnak az irod\xe1ban. A nyitott irodat\xe9r el\u0151nyei k\xf6z\xe9 tartozik az iroda \xe1tl\xe1that\xf3s\xe1ga, \xe9s a vele j\xe1r\xf3 g\xf6rd\xfcl\xe9keny egy\xfcttm\u0171k\xf6d\xe9s. H\xe1tr\xe1ny lehet a figyelmet megzavar\xf3 zaj, ami\xe9rt aj\xe1nlott a nyitott irodaterek mell\xe9 t\xf6bb f\xf3kusz \xe9s priv\xe1t t\xe1rgyal\xf3 kialak\xedt\xe1sa. Az asztaln\xe1l t\xf6rt\xe9n\u0151 iktat\xe1s korl\xe1tozott, tekintve, hogy a k\xf6z\xf6ss\xe9gi iktat\xe1s a folyos\xf3n tal\xe1lhat\xf3.",
    mdWorkstationDesc: "A munka\xe1llom\xe1sok nyitott, egy\xe9neknek kialak\xedtott munkaterek. Az el\u0151nyei ezeknek a kiss\xe9 nagyobb tereknek, a nagyobb asztali f\xe9r\u0151hely, \xe9s a mag\xe1nszf\xe9ra. Ez nagy val\xf3sz\xedn\u0171s\xe9ggel azt jelenti, hogy ezeket a tereket el\u0151nyben r\xe9szes\xedtik a t\xf6bbi, szabadon elfoglalhat\xf3 \xe1llom\xe1shoz k\xe9pest. A nyitott irodat\xe9r el\u0151nyei k\xf6z\xe9 tartozik az iroda \xe1tl\xe1that\xf3s\xe1ga, \xe9s a vele j\xe1r\xf3 g\xf6rd\xfcl\xe9keny egy\xfcttm\u0171k\xf6d\xe9s. H\xe1tr\xe1ny lehet a figyelmet megzavar\xf3 zaj, ami\xe9rt aj\xe1nlott a nyitott irodaterek mell\xe9 t\xf6bb f\xf3kusz \xe9s priv\xe1t t\xe1rgyal\xf3 kialak\xedt\xe1sa. Nagy es\xe9llyel tal\xe1lsz kieg\xe9sz\xedt\u0151 k\xf6z\xf6ss\xe9gi t\xe1rol\xe1st, \xe9s iktat\xe1st a folyos\xf3n.",
    lgWorkstationDesc: "A munka\xe1llom\xe1sok nyitott, egy\xe9neknek kialak\xedtott munkaterek. Az el\u0151nyei ezeknek a kiss\xe9 nagyobb tereknek, a nagyobb asztali f\xe9r\u0151hely, \xe9s a mag\xe1nszf\xe9ra. Az ilyen m\xe9ret\u0171 asztalokat nagyobb es\xe9llyel foglalj\xe1k el, mint a t\xf6bbi munka\xe1llom\xe1st. A nyitott irodat\xe9r el\u0151nyei k\xf6z\xe9 tartozik az iroda \xe1tl\xe1that\xf3s\xe1ga, \xe9s a vele j\xe1r\xf3 g\xf6rd\xfcl\xe9keny egy\xfcttm\u0171k\xf6d\xe9s. H\xe1tr\xe1ny lehet a figyelmet megzavar\xf3 zaj, ami\xe9rt aj\xe1nlott a nyitott irodaterek mell\xe9 t\xf6bb f\xf3kusz \xe9s priv\xe1t t\xe1rgyal\xf3 kialak\xedt\xe1sa. Nagy es\xe9llyel tal\xe1lsz kieg\xe9sz\xedt\u0151 k\xf6z\xf6ss\xe9gi t\xe1rol\xe1st, \xe9s iktat\xe1st a folyos\xf3n.",
    huddleRoomDesc: "A priv\xe1t t\xe1rgyal\xf3k k\xf6r\xfclz\xe1rt terek, melyek 2-4 f\u0151s csoportos t\xe1rgyal\xe1sok t\xe1mogat\xe1s\xe1ra lettek tervezve. A/V felszerel\xe9ssel \xe9s feh\xe9r t\xe1bl\xe1kkal kell rendelkezni\xfck, hogy megk\xf6nny\xedts\xe9k a tud\xe1smegoszt\xe1st, valamint akusztikusan priv\xe1tnak kell lenni\xfck (a t\xe1rgyal\xf3n k\xedv\xfcl tart\xf3zkod\xf3 szem\xe9lyeknek nem szabad hallaniuk a bent elhangzottakat).",
    multiPurpTrainingDesc: "A t\xf6bbfunkci\xf3s szob\xe1k 20, vagy ann\xe1l t\xf6bb f\u0151 befogad\xe1s\xe1ra lettek tervezve. A nev\xe9b\u0151l ad\xf3dik, hogy t\xf6bb k\xfcl\xf6nb\xf6z\u0151 tev\xe9kenys\xe9g, mint tov\xe1bbk\xe9pz\xe9sek, c\xe9ges esem\xe9nyek, illetve nagyobb prezent\xe1ci\xf3k lebonyol\xedt\xe1s\xe1ra lett kialak\xedtva. A terem kialak\xedt\xe1sa funkcion\xe1lis sz\xe1mos vend\xe9g befogad\xe1s\xe1ra, \xe9s \xfcgyf\xe9lmegbesz\xe9l\xe9sekre is alkalmasak. A teret megfelel\u0151 A/V felszerelts\xe9ggel kell ell\xe1tni - nagyobb sz\xe1mban, mint egy \xe1tlagos t\xe1rgyal\xf3termet.",
    informalCollabDesc: "Ezek a helyek a kisebb csoportok (4-6 f\u0151) kollabor\xe1ci\xf3s tev\xe9kenys\xe9geit l\xe1tja el, mint a k\xf6z\xf6s \xf6tletel\xe9s \xe9s inform\xe1lis besz\xe9lget\xe9sek a kolleg\xe1k \xe9s az \xfcgyf\xe9l k\xf6z\xf6tt.",
    touchdownTeamDesc: 'A "touchdown" ter\xfcletek az egy\xe9nek sz\xe1m\xe1ra, vagy kisebb bels\u0151s csapatmunk\xe1k elv\xe9gz\xe9s\xe9re alkalmas helyek, melyek sz\xe9tsz\xf3rtan tal\xe1lhat\xf3ak az irodat\xe9rben, az alkalmazottak \xe9s vend\xe9gek sz\xe1m\xe1ra. Sz\xe1mos m\xe9retben \xe9s form\xe1ban tal\xe1lkozhatunk vel\xfck, \xe9s a hagyom\xe1nyos munka\xe1llom\xe1sokt\xf3l elt\xe9r\u0151, egyedi helyet biztos\xedtanak r\xf6videbb id\u0151re a munka elv\xe9gz\xe9s\xe9re. Ezeknek haszn\xe1latra k\xe9sz ter\xfcleteknek kell lenni\xfck.',
    frontDeskAreaDesc: "Ez az els\u0151 \xe1llom\xe1s az alkalmazottak \xe9s a vend\xe9gek irod\xe1ba \xe9rkez\xe9s\xe9t k\xf6vet\u0151en. Az asztalnak egy f\u0151re el\xe9g munka\xe1llom\xe1s, \xe9s t\xe1rol\xf3 lehet\u0151s\xe9get kell biztos\xedtania. A vend\xe9geknek val\xf3sz\xedn\u0171leg a k\xf6zelben lesz t\xe1rol\xe1si lehet\u0151s\xe9g\xfck. Az el\xfcls\u0151 asztal a nagyobb recepci\xf3s t\xe9rben helyezkedik el, ahol val\xf3sz\xedn\u0171leg egy\xe9b \xfcl\u0151helyek is tal\xe1lhat\xf3ak.",
    mailCenterAreaDesc: "Nagyobb c\xe9gek eset\xe9ben sz\xfcks\xe9ges post\xe1z\xf3 k\xf6zpont a lev\xe9l szolg\xe1ltat\xe1sok \xf6sszes\xedt\xe9s\xe9re. Ide tartozik a nagyobb szort\xedroz\xe1s, \xe9s rendszerez\xe9s, valamint a feh\xe9r t\xe1bl\xe1k (flipchart) \xe9s az eszk\xf6z\xf6k t\xe1rol\xe1sa. Ez a helyis\xe9g szervezetenk\xe9nt jelent\u0151sen elt\xe9r\u0151 lehet, mivel m\xe1s helyis\xe9g t\xedpusok k\xf6z\xf6tt helyezkedik el.",
    kitchenAreaDesc: "Azok a helyek, melyek rendelkeznek irod\xe1n bel\xfcli \xe9tkez\xe9si szolg\xe1ltat\xe1ssal, k\xf6telez\u0151 a konyhai t\xe1mogat\xe1s megl\xe9te. A konyh\xe1ra ir\xe1nyul\xf3 el\u0151\xedr\xe1sok szervezetenk\xe9nt elt\xe9r\u0151ek, de biztosan tal\xe1lhat\xf3 benn\xfck f\u0151z\xe9si lehet\u0151s\xe9g, valamint h\u0171t\u0151. Ezen fel\xfcl sz\xe1raz \xe9tel- \xe9s eszk\xf6zt\xe1rol\xf3. A konyha szomsz\xe9dos az kiszolg\xe1l\xf3 hellyel, \xe9s val\xf3sz\xedn\u0171, hogy a a konferencia/\xfcgyf\xe9l centerrel.",
    serveryAreaDesc: "Az kiszolg\xe1l\xf3 helyn\xe9l vehetik \xe1t az emberek az \xe9teleiket. Ez kapcsol\xf3dik a konyh\xe1hoz, valamint az \xe9tkez\u0151 r\xe9szhez, ahol sz\xe9kek \xe9s asztalok tal\xe1lhat\xf3k. A kiszolg\xe1l\xf3 kialak\xedt\xe1sakor prec\xedzen meg kell tervezni, hogy a sort \xe9s torl\xf3d\xe1st hogyan kezelhetj\xfck. A helyis\xe9g m\xe9rete \xe9s kialak\xedt\xe1sa szervezetenk\xe9nt v\xe1ltoz\xf3 lehet.",
    diningSupportAreaDesc: "A hatalmas \xe9tkez\u0151vel rendelkez\u0151 szervezeteknek nagy val\xf3sz\xedn\u0171s\xe9ggel vannak tov\xe1bbi t\xe1mogat\xf3 terei az \xe9p\xfcletben, mint a t\xe1rol\xf3k, melyeket  az \xe1tfog\xf3 programban fel kell t\xfcntetni.A ter\xfclet param\xe9terei szervezetenk\xe9nt v\xe1ltoz\xf3 lehet.",
    diningAreaDesc: "Az \xe9tkez\u0151nek a konyh\xe1hoz k\xf6zel, sz\xe9les v\xe1laszt\xe9kkal kell rendelkeznie, \xe9s biztos\xedtani kell \xfcl\u0151helyet az \xe9tkez\xe9sre. A sz\xe1mos, \xe9s k\xfcl\xf6nb\xf6z\u0151 \xfcl\u0151hely biztos\xedt\xe1sa az \xe9tkez\xe9sen fel\xfcl lehet\u0151v\xe9 teszi a t\xe1rgyal\xe1sokat \xe9s kollabor\xe1ci\xf3kat. A b\xe1r mellett a puha \xe9s kem\xe9ny anyagb\xf3l k\xe9sz\xfclt sz\xe9kek, valamint az \xfcl\xe9sek \xe1ll\xedthat\xf3s\xe1g\xe1nak biztos\xedt\xe1sa lehet\u0151s\xe9geket k\xedn\xe1l a haszn\xe1l\xf3ja sz\xe1m\xe1ra.",
    // Space Unit Map Descriptions (spaceUnitMap.js) - UK_REGULAR
    fullFoodServiceDesc: "Amikor biztos\xedtott az irod\xe1n bel\xfcli \xe9tkez\xe9si szolg\xe1ltat\xe1s, t\xf6bb funkci\xf3 \xf6sszess\xe9ge t\xe1mogatja a k\xe9nyelmet, mint a konyha, kiszolg\xe1l\xf3, \xe9tkez\u0151, \xe9s \xe9tkez\xe9st kiseg\xedt\u0151 helyis\xe9g (t\xe1rol\xf3). A konyha \xe9s a kiszolg\xe1l\xe1s egy\xfcttm\u0171k\xf6dik az \xe9telek elk\xe9sz\xedt\xe9s\xe9ben, valamint a helyben k\xe9sz\xfclt \xe9telek felszolg\xe1l\xe1s\xe1ban.  Az \xe9tkez\u0151 az a helyis\xe9g, ahol a munkav\xe1llal\xf3k \xe9s a vend\xe9gek \xfclhetnek \xe9s \xe9tkezhetnek, de legt\xf6bbsz\xf6r ez a helyis\xe9g egy szoci\xe1lis \xe9s kollabor\xe1ci\xf3s csom\xf3pontk\xe9nt szolg\xe1l. Csak\xfagy mint otthon, itt is t\xf6bb eszk\xf6z, \xe9s \xe9tel rakt\xe1roz\xe1si hely sz\xfcks\xe9ges az \xe9tkez\xe9si szolg\xe1ltat\xe1sok biztos\xedt\xe1s\xe1hoz, ez\xe9rt a teljesk\xf6r\u0171 \xe9tkez\xe9si szolg\xe1ltat\xe1s r\xe9sz\xe9t k\xe9pezi.",
    // SpaceUnitRow
    spaceUnitRowDeleteTitle: "Irodat\xe9r t\xedpus t\xf6rl\xe9se",
    spaceUnitRowDeleteText: "Biztos vagy benne, hogy kit\xf6rl\xf6d ezt az irodat\xe9r t\xedpust?",
    spaceUnitRowConfirmDeleteText: "Igen, t\xf6rl\xf6m",
    spaceUnitRowCancelDeleteText: "M\xe9gsem, ink\xe1bb megtartom",
    // CustomAmenityAdder
    customAmenityAddText: "Szolg\xe1ltat\xe1s hozz\xe1ad\xe1sa",
    customAmenityPlaceholder: "Szolg\xe1ltat\xe1s t\xedpusa",
    // SpaceUnitTotals
    spaceUnitTotalsTitleNIA: "Teljes nett\xf3 bels\u0151 ter\xfclet",
    spaceUnitTotalsTitle: "Teljes {{sfTypeAdj}} n\xe9gyzet {{unitCapitalized}}",
    spaceUnitTotalsCirculation: "Forg\xe1si sebess\xe9g",
    spaceUnitTotalsCirculationTooltip: 'A "t\xe9r a terek k\xf6z\xf6tt". Folyos\xf3k, a sz\xe9ked m\xf6g\xf6tt hely, a szekr\xe9nyek \xe9s ajt\xf3k k\xf6r\xfcli hely and a fordul\xf3k. Ezek n\xe9lk\xfcl a helyek n\xe9lk\xfcl lehetetlen a k\xf6zleked\xe9s. \xc1ltal\xe1ban 35%-\xe1t teszi ki a teljes Felhaszn\xe1lnat\xf3 N\xe9gyzet {{unitCapitalized}, de v\xe1ltozhat a profilod, illetve a v\xe1lasztott \xe9p\xfclet alaprajza alapj\xe1n is.',
    spaceUnitTotalsREBNY: "REBNY Factor",
    spaceUnitTotalsNYCText: "NYC ",
    spaceUnitTotalsREBNYTooltip: "For programs in NYC, we increase {{sfType}} by 15% to account for the REBNY measurement standard. Space measured per the REBNY measurement standard includes bathrooms, elevator lobbies, and the thickness of exterior walls (among other things).",
    spaceUnitTotalsLossFactor: "Vesztes\xe9gi t\xe9nyez\u0151 ",
    spaceUnitTotalsLossFactorTooltip: "A felhaszn\xe1lhat\xf3 n\xe9gyzet {{unit}} az amennyi helyed lesz az irod\xe1ban. A b\xe9relt n\xe9gyzet {{unit}} pedig az amennyi ut\xe1n fizetni fogsz, ez tartalmazhat oszlopokat, el\u0151tereket \xe9s egy\xe9b k\xf6z\xf6s ter\xfcleteket. A felhaszn\xe1lhat\xf3 \xe9s a b\xe9relt irodat\xe9r k\xf6z\xf6tti k\xfcl\xf6nbs\xe9get vesztes\xe9gi t\xe9nyez\u0151nek h\xedvj\xe1k \xe9s a sz\xe1m\xedt\xe1sa helysz\xednenk\xe9nt elt\xe9r.",
    // CollaborationDropdown
    collabDropdownLevelLowText: "0-25%",
    collabDropdownLevelMedText: "26-50%",
    collabDropdownLevelHighText: "51-100%",
    //DensityDropdown
    sameDensityText: "Hasonl\xf3 tel\xedtetts\xe9g mint a Covid-19 el\u0151tt",
    lowerDensityText: "Alacsonyabb tel\xedtetts\xe9g",
    notSureDensityText: "Nem vagyok benne biztos",
    //CirculationDropdown
    preCovidText: "Covid-19 el\u0151tt (45% nyitott / 25% z\xe1rt)",
    higherText: "Gyakran cser\xe9l\u0151d\u0151 (50% nyitott / 30% z\xe1rt)",
    notSureText: "Nem vagyok benne biztos (45% nyitott / 25% z\xe1rt)",
    // ExamplePlans
    examplePlanButtonText: "Mintaterv megtekint\xe9se",
    examplePlanFullFloorText: "teljes emelet",
    examplePlanPartialFloorText: "r\xe9szleges emelet",
    examplePlanFullImgAlt: "{{size}} n\xe9gyzet {{unit}} alaprajz, amely {{profileName}} profil\xfa elrendez\xe9st mutat a Spacer-t\u0151l",
    examplePlanPartialImgAlt: "{{size}} n\xe9gyzet {{unit}} r\xe9szleges alaprajz mutat egy {{profileName}} elrendez\xe9st a Spacer-t\u0151l",
    examplePlanTooltipText: "Amennyiben az irodat\xe9r ig\xe9nyed nagyobb, mint  {{size}} {{unit}}, val\xf3sz\xedn\u0171leg t\xf6bb szintre lesz sz\xfcks\xe9ged.",
    // ProgramStats
    programStatsDensitySubtitleTsubo: "bek\xf6lt\xf6z\xe9sig h\xe1tral\xe9v\u0151 id\u0151",
    programStatsDensitySubtitle: "{{adjective}} N\xe9gyzet {{unitUppercase}}",
    programStatsIndivTitle: "Egy\xe9ni \xfcl\u0151helyek",
    programStatsWorkstationsSubtitle: "Munka\xe1llom\xe1sok",
    programStatsOfficesSubtitle: "Irod\xe1k",
    programStatsCollabTitle: "Kollabor\xe1ci\xf3",
    programStatsEnclosedSubtitle: "Z\xe1rt, csoportos \xfcl\u0151helyek",
    programStatsIndivSeatSubtitle: "Egy\xe9ni \xfcl\u0151hely",
    programStatsSeatsTitle: "Szem\xe9lyenk\xe9nti \xfcl\u0151helyek",
    programStatsIndivSeatsSubtitle: "Egy\xe9ni \xfcl\u0151helyek",
    programStatsPersonSubtitle: "Szem\xe9lyenk\xe9nti \xfcl\u0151helyek",
    programStatsDensityTitle: "Tel\xedtetts\xe9g",
    programStatsFullDensitySubtitle: "{{density}} egy\xe9ni \xfcl\u0151helyenk\xe9nt",
    // Profile Display Names (profileNames.js)
    efficientName: "Az Optimaliz\xe1l\xf3",
    whiteCollarName: "Az Alkalmazkod\xf3",
    whiteGloveName: "A Teljes\xedtm\xe9nyfokoz\xf3",
    openOfficeName: "A Produkt\xedv",
    workplace360Name: "A Kapcsolatteremt\u0151",
    campusName: "A Megk\xfcl\xf6nb\xf6ztet\u0151",
    startupName: "Az Inkub\xe1tor",
    engCreativeName: "A Kreat\xedv",
    // Profile Descriptions (profileDescriptions.js)
    efficientDesc: "Az Optimaliz\xe1l\xf3 iroda a c\xe9ltudatos munkak\xf6rnyezetet t\xe1mogatja. Biztos\xedtja az \xf6sszes sz\xfcks\xe9ges eszk\xf6zt az alkalmazottak \xedr\xf3asztal\xe1n\xe1l mivel ebben a k\xf6rnyezetben kev\xe9sb\xe9 fordul el\u0151 a csapat-orient\xe1lt munka. Az \xedr\xf3asztalok szabv\xe1nyos\xedtottak \xe9s a hat\xe9kony munk\xe1hoz az alapvet\u0151 t\xe1rgyal\xf3k \xe9s terek adottak. Nev\xe9hez h\xedven ezek a irodaterek szinte mindig nyitottak a hat\xe9konys\xe1g maximaliz\xe1l\xe1sa \xe9rdek\xe9ben.",
    whiteCollarDesc: "Az Alkalmazkod\xf3 irod\xe1ban soha sem fogod egyed\xfcl \xe9rezni magad - ez az egyik legn\xe9pszer\u0171bb irodat\xe9r profil a nagyv\xe1llalatok k\xf6r\xe9ben. Az Alkalmazkod\xf3 irod\xe1k mell\u0151zik a radik\xe1lis diz\xe1jnt de a produktivit\xe1s \xe9s elk\xf6telezetts\xe9g jav\xedt\xe1s \xe9rdek\xe9ben gyakran inveszt\xe1lnak az el\xe9rhet\u0151 technol\xf3gi\xe1ba \xe9s b\xfatorokba. A kialak\xedt\xe1st tekintve, egyens\xfalyt biztos\xedt az egy\xe9ni \xe9s a k\xf6z\xf6s munka k\xf6rnyezet k\xf6z\xf6tt, az alkalmazottak legt\xf6bbsz\xf6r az \xedr\xf3asztalukn\xe1l t\xf6ltik az idej\xfcket amit n\xe9h\xe1ny meeting szak\xedt meg. T\xf6k\xe9letes v\xe1laszt\xe1s a 9-t\u0151l d\xe9lut\xe1n 5-ig v\xe9gzend\u0151 munkak\xf6rnyezethez.",
    whiteGloveDesc: "Amikor bel\xe9psz az irod\xe1ba, a Teljes\xedtm\xe9nyfokoz\xf3 irodat\xe9r egyb\u0151l \xe1mulatba ejt. Ez a munkahely kiel\xe9g\xedti azoknak az alkalmazottaknak, valamint az \xfcgyfeleknek ig\xe9nyeit, akik gyakran l\xe1togatj\xe1k a munkahelyet. Minden m\xe1s t\xedpus\xfa irodat\xe9rn\xe9l t\xf6bb z\xe1rt teret \xe9s egy\xe9b helys\xe9get tartalmaz. A legt\xf6bb alkalmazott, teljes\xedtm\xe9ny vagy megb\xedzat\xe1s r\xe9v\xe9n szerzi meg a ter\xfclet\xe9t \xe9s \xedgy a hierarchia val\xf3sz\xedn\u0171leg fontos szerepet j\xe1tszik a szervezet m\u0171k\xf6d\xe9s\xe9ben. M\xe1szd meg st\xedlusosan a v\xe1llalati l\xe9tr\xe1t!",
    openOfficeDesc: "A Produkt\xedv iroda tudja, hogy mire van sz\xfcks\xe9ged a sikerhez. Biztos\xedtja az emberek sz\xe1m\xe1ra a munkatev\xe9kenys\xe9g\xfckt\u0151l f\xfcgg\u0151 alapvet\u0151 sz\xfcks\xe9gleteket. A k\xfcl\xf6nf\xe9le, diverz tereket pedig tapasztalataink alapj\xe1n ki is haszn\xe1lj\xe1k a munkav\xe1llal\xf3k annak \xe9rdek\xe9ben, hogy hat\xe9konyak maradjanak. Egy eg\xe9szs\xe9ges egyens\xfalyt biztos\xedt az egy\xe9ni \xe9s a csapat f\xf3kusz\xfa feladatok elv\xe9gz\xe9s\xe9hez, \xedgy t\xf6k\xe9letes azok sz\xe1m\xe1ra akik sokat forognak az irod\xe1ban egy nap.",
    workplace360Desc: "Csak mint a kedvenc j\xf3ga p\xf3zod, A Kapcsolatteremt\u0151 irodat\xe9r az egyens\xfalyra \xf6sszpontos\xedt. A produktiv\xedt orient\xe1lt t\xe9rre \xe9s kapcsolat\xe9p\xedt\xe9sre f\xf3kusz\xe1lva egy eg\xe9szs\xe9get mixet biztos\xedt. Minden adott a hat\xe9kony munkav\xe9gz\xe9shez mik\xf6zben az alkalmazottak k\xfcl\xf6nb\xf6z\u0151 terek k\xf6z\xfcl v\xe1laszthatnak a mindennapok sor\xe1n. Nev\xe9hez h\xedven, A Kapcsolat\xe9p\xedt\u0151 iroda k\xf6zponti helyeket azonos\xedt a k\xf6z\xf6ss\xe9gi terekben, mint a konyh\xe1ban \xe9s nyitott t\xe1rgyal\xf3kban. \xcdgy seg\xedt \xf6sszehozni az embereket \xe9s megteremti a k\xf6z\xf6ss\xe9g \xe9rzet\xe9t.",
    campusDesc: "A Megk\xfcl\xf6nb\xf6ztet\u0151 irod\xe1t neh\xe9z otthagyni a nap v\xe9g\xe9n. Mi\xe9rt? Az\xe9rt mert olyan \xe9lm\xe9nyeket ny\xfajt munka k\xf6zben amivel nem k\xf6nny\u0171 felvenni a versenyt. Az \xe9teleken \xe9s a wellnesen k\xedv\xfcl tov\xe1bbfejlesztett k\xe9nyelmi szolg\xe1ltat\xe1sokat k\xedn\xe1l amelyek seg\xedtenek abban, hogy az alkalmazottak j\xf3l \xe9rezz\xe9k magukat mik\xf6zben id\u0151t is sp\xf3rolhatnak.",
    startupDesc: "A gyorsas\xe1g \xe9s az \xf6tletek b\xf6lcs\u0151je az Inkub\xe1tor irodat\xe9r ahol a munkav\xe1llal\xf3k szorosan egy\xfcttm\u0171k\xf6d\u0151 csapatokban dolgoznak. Ez az irodai k\xf6rnezet folyamatosan v\xe1ltozik, ebb\u0151l ad\xf3d\xf3an legt\xf6bb tere rugalmasan v\xe1ltoztathat\xf3 - gyakran el\u0151fordul a b\xfatorok \xe1tmozgat\xe1sa. Eg\xe9szs\xe9ges egyens\xfalyt biztos\xedt a sz\xf3rakoztat\xf3 k\xf6z\xf6ss\xe9gi tev\xe9kenys\xe9gek \xe9s az intenz\xedvebb munkav\xe9gz\xe9s k\xf6z\xf6tt. P\xe9ld\xe1ul a hackathon a ping-pongal felv\xe1ltva alkalmazhat\xf3, hogy n\xf6velj\xfck \xe9s \xe9p\xedts\xfck a csapat bajt\xe1rsiass\xe1g \xe9rzet\xe9t.",
    engCreativeDesc: "A Kreat\xedv irodateret a specialist\xe1kra szabt\xe1k. Ebben a k\xf6rnyezetben gyakori a k\xf6z\xf6s munka \xe9s az egy\xfcttm\u0171k\xf6d\xe9s a kreat\xedv energi\xe1k megfelel\u0151 kiakn\xe1z\xe1s\xe1hoz. A speci\xe1lis felszerel\xe9sek vagy fizikai eszk\xf6z\xf6k a mindennapi munka oszlopos r\xe9sz\xe9t k\xe9pezik. Az alkalmazottak a hat\xe9kony munkav\xe9gz\xe9shez megkapj\xe1k a sz\xfcks\xe9ges teret, \xe9s b\xe1r nem gyakran fordul el\u0151 ez az irodat\xe9r t\xedpus, az itt elv\xe9gzend\u0151 speci\xe1lis feladatok k\xfcl\xf6nleges munkahely\xe9rt ki\xe1ltanak.",
    // Profile Key Traits: Shared Names (profileTraitMap.js)
    social: "Szoci\xe1lis",
    efficient: "Hat\xe9kony",
    flexible: "Rugalmas",
    enabled: "Felszerelt",
    productive: "Produkt\xedv",
    inclusive: "Inkluz\xedv",
    clientFocused: "\xdcgyf\xe9lk\xf6zpont\xfa",
    standardized: "Standardiz\xe1lt",
    // Profile Key Traits (profileTraitMap.js)
    social1Desc: "Fontosak a kapcsolatok az irod\xe1n bel\xfcl \xe9s k\xedv\xfcl is",
    social2Desc: "Sok k\xf6z\xf6ss\xe9g\xe9p\xedt\u0151 rendezv\xe9ny",
    social3Desc: "Az alkalmazottak szeretnek id\u0151t egy\xfctt t\xf6lteni",
    social4Desc: "Nyitotabb \xe9s k\xf6z\xf6ss\xe9gbar\xe1tabb",
    efficient1Desc: "A v\xe1llalat k\xf6lts\xe9gtudatosabb marad",
    efficient2Desc: "A v\xe1llalat hat\xe9kony marad",
    flexible1Desc: "Az emberek v\xe1laszthatnak, hogy honnan dolgoznak",
    flexible2Desc: "Az alkalmazottak sz\xe1m\xe1ra biztos\xedtott a rugalmas munkav\xe9gz\xe9s",
    flexible3Desc: "Tervezd meg a saj\xe1t irodatered",
    enabled1Desc: "Az alkalmazottak az \xedr\xf3asztalukn\xe1l megtal\xe1lj\xe1k azt amire sz\xfcks\xe9g\xfck van a munk\xe1juk sor\xe1n",
    enabled2Desc: "Az alkalmazottak sz\xe1mos szolg\xe1ltat\xe1s k\xf6z\xfcl v\xe1laszthatnak",
    enabled3Desc: "Az emberek megkaphatj\xe1k a munk\xe1juk megfelel\u0151 elv\xe9gz\xe9s\xe9hez sz\xfcks\xe9ges eszk\xf6z\xf6ket",
    enabled4Desc: "Hozz\xe1f\xe9rhet a megfelel\u0151 technik\xe1hoz \xe9s felszerel\xe9shez",
    enabled5Desc: "Speci\xe1lis felszerel\xe9s rendelkez\xe9sre \xe1ll",
    productive1Desc: "Funkcion\xe1lis \xe9s intuit\xedv irodai tervez\xe9s",
    productive2Desc: "\xdczletk\xf6zpont\xfa \xe9s p\xe9nz\xfcgyileg tudatos",
    productive3Desc: "\xd6szpontos\xedtva az egyedi term\xe9k/szolg\xe1ltat\xe1s k\xedn\xe1lat\xe1ra",
    inclusive1Desc: "T\xf6bbf\xe9le t\xedpus\xfa irodat\xe9r \xe1ll rendelkez\xe9sre",
    inclusive2Desc: "Megtal\xe1lsz mindent az irod\xe1ban amire sz\xfcks\xe9ged lehet",
    inclusive3Desc: "Sokf\xe9le munkav\xe9gz\xe9s elfogadott",
    clientFocused1Desc: "Az \xfcgyfelek els\u0151 benyom\xe1sa a legfontosabb dolog",
    clientFocused2Desc: "Az iroda hivogat\xf3 az \xfcgyfelek \xe9s \xfaj tehets\xe9gek sz\xe1m\xe1ra ",
    clientFocused3Desc: " Az iroda eleg\xe1ns benyom\xe1st kelt az \xfcgyfelek \xe9s \xfaj tehets\xe9gek sz\xe1m\xe1ra ",
    standardized1Desc: "A folyamatok \xe9s rendszerek \xf6sszhangban vannak",
    standardized2Desc: "A szervezeti norm\xe1k a kialak\xedtott irodat\xe9rre \xe9p\xfclnek",
    standardized3Desc: "Modul\xe1lis m\xe9retek a rugalmass\xe1ghoz",
    standardized4Desc: "\xd6sszehangolt folyamatok \xe9s teljes\xedt\xe9sek",
    // SpaceSummary
    spaceSummaryBarHeader: "Aj\xe1nlott irodai m\xe9ret",
    spaceSummaryMeasurementTypeText: "m\xe9r\xe9s t\xedpusa",
    spaceSummaryUnitTypeText: "egys\xe9gek",
    spaceSummaryLossFactorSectionLabel: "{{factor}} r\xe9szletek",
    spaceSummaryFitFactorText: "egyez\xe9si t\xe9nyez\u0151",
    spaceSummaryLossFactorText: "vesztes\xe9gi t\xe9nyez\u0151",
    spaceSummaryRSFLossFactorHelperText: "A vesztes\xe9gi faktor {{percentage}}% \xe9s az ingatlan elhelyezked\xe9se {{place}} alapj\xe1n, olyan irod\xe1t kellene keresned amely {{min}} \xe9s {{max}} b\xe9relhet\u0151 n\xe9gyzet {{units}} k\xf6z\xf6tt van.",
    spaceSummaryNIAFitFactorHelperText: "A egyez\xe9si faktor {{percentage}}% \xe9s az ingatlan elhelyezked\xe9se {{place}} alapj\xe1n, {{amt}} NIA m\xe9ret\u0171 irod\xe1t kellene keresned.",
    spaceSummaryNIATooltipText: "A Nett\xf3 Bels\u0151 Ter\xfclet az \xe9p\xfclet azon ter\xfclete amit a bels\u0151 falak.",
    // SFTypeRadioInput
    sfRadioInputUsableAreaTooltipText: "Ez a m\xe9r\xe9s mag\xe1ba foglalja az \xf6sszes t\xe1rgyal\xf3t, b\xfatorokat, bej\xe1rhat\xf3 ter\xfcletet. Egyes esetekben k\xe1rpitozott ter\xfcletnek is nevezik.",
    sfRadioInputRentableAreaTooltipText: "\xc1ltal\xe1ban ez a Felhaszn\xe1lhat\xf3 n\xe9gyzet {{unitUppercase}}, plusz az \xe9p\xfclet k\xf6z\xf6s tereinek egy r\xe9sze. Hab\xe1r nem lehets\xe9ges a t\xe9nyleges teljes ter\xfclet kihaszn\xe1l\xe1sa, ez az a n\xe9gyzet {{unit}} ami\xe9rt b\xe9rl\xe9skor fizetsz.",
    sfRadioInputUsableSquareText: "Felhaszn\xe1lhat\xf3 n\xe9gyzet {{unitUppercase}}",
    sfRadioInputRentableSquareText: "B\xe9relhet\u0151 n\xe9gyzet {{unitUppercase}}",
    //floored plan request block
    flooredTitle: "M\xe9g ne hagyj itt minket!",
    flooredSubTitle: "Fogalmazd \xe1t, hogy az \xfcgyfelek hogyan fedezik fel a bels\u0151 irodai teret",
    flooredSubText: "Fedezd fel a Spacer eredm\xe9nyeidet egy 3D-s alaprajz bebarangol\xe1s\xe1n kereszt\xfcl",
    flooredParagraphText1: "A \xe9leth\u0171 \xe9lm\xe9ny el\xe9rhet\u0151v\xe9 teszi a b\xe9rl\u0151k sz\xe1m\xe1ra, hogy vizu\xe1lisan megjelen\xedts\xe9k \xf6tleteiket, k\xeds\xe9rletezzenek a k\xfcl\xf6nb\xf6z\u0151 tervekkel \xe9s megval\xf3s\xedts\xe1k a koncepci\xf3ikat.",
    flooredParagraphText2: "K\xe9zzel foghat\xf3, szem\xe9lyre szabott koncepci\xf3 minden irodat\xe9r t\xedpusra",
    flooredVideoHeading: "Tekints meg egy mint\xe1t",
    flooredFreeText: "Mi t\xf6bb, ingyenes!",
    flooredIconText1: "El\xe9rhet\u0151 alaprajzok megoszt\xe1sa",
    flooredIconSubText1: "AutoCAD f\xe1jlok PDF-ekhez",
    flooredIconText2: "Feldolgoz\xe1si id\u0151 enged\xe9lyez\xe9se",
    flooredIconSubText2: "1-2 h\xe9t",
    flooredIconText3: "Kapj k\xe9zhez egy m\xe1sokkal is megoszthat\xf3 \xe9lm\xe9nyt",
    flooredIconSubText3: "Egyedi 2D \xe9s 3D koncepci\xf3k",
    // MeasurementSystemRadioInput
    measurementSystemSqFeetText: "n\xe9gyzetl\xe1b",
    measurementSystemSqMetersText: "n\xe9gyzetm\xe9ter",
    measurementSystemTsuboText: "bek\xf6lt\xf6z\xe9sig h\xe1tral\xe9v\u0151 id\u0151",
    // ProfileHero
    resultsProfileHeroAnnouncementTitle: "Az irod\xe1d",
    resultsProfileHeroImgAlt: "3D alaprajz p\xe9lda amely {{profileName}} profil\xfa irodateret mutat a Spacer a CBRE-t\xf3l",
    // ProfileComparison
    profileCompModalTitle: "M\xf3dos\xedtod a profilod?",
    profileCompModalText: "A ment\xe9s n\xe9lk\xfcli m\xf3dos\xedt\xe1sok elvesznek a jelenlegi tervez\xe9sben",
    profileCompModalConfirmText: "Igen, profil m\xf3dos\xedt\xe1sa",
    profileCompModalCancelText: "Nem, profil megtart\xe1sa",
    profileCompNavbarCancelButtonText: "M\xe9gsem",
    profileCompNavbarUseButtonText: "Haszn\xe1ld ezt a profilt",
    profileCompCompareTitle: "Hasonl\xedtsd \xf6ssze a legaktu\xe1lisabb profilegyez\xe9seket",
    // ProfileComparisonColumn
    profileCompColumnSelectedText: "Kiv\xe1lasztott profil",
    profileCompColumnSelectText: "Kiv\xe1laszt\xe1s",
    profileCompColumnRecommendedText: " (Javasolt)",
    profileCompColumnImgAltText: "3D floor plan showing the office layout of the {{profileName}} profile from Spacer by CBRE",
    // Test Fit Form
    testFitTitle: "N\xe9zd meg a szinti\nterv eredm\xe9nyedet \xe9s j\xe1rd be 3D-ben",
    testFitSubtitle: "K\xedv\xe1ncsi vagy arra, hogyan n\xe9z majd ki az irodatered? Az itt kapott eredm\xe9nyeidet testreszabott alaprajzz\xe1 v\xe1ltoztatjuk amit felfedezhetsz \xe9s megoszthatsz.",
    requestTestFitButtonText: "K\xe9rj egyedi alaprajzot",
    company: "C\xe9gn\xe9v",
    emptyCompanyError: "K\xe9rlek add meg a c\xe9g nevet",
    radioQ2yes: "Kiv\xe1l\xf3! E-mailen kapcsolatba l\xe9p\xfcnk veled \xe9s bek\xe9rj\xfck a f\xe1jlt.",
    radioQ2no: "Nem probl\xe9ma, hamarosan jelentkez\xfcnk, hogy \xe1tbesz\xe9lj\xfck a lehet\u0151s\xe9geket.",
    testFitFormTitle: "K\xe9rj egyedi alaprajzot",
    testFitFormSubtitle: "Ossz meg vel\xfcnk n\xe9h\xe1ny inform\xe1ci\xf3t \xe9s m\xe1r kezdhetj\xfck is. A csapatunk \xe1ltal\xe1ban 3 munkanap alatt k\xe9sz\xedt el a v\xe9gleges \xfcltet\xe9si terv.",
    testFitFormCompleted: "A k\xe9r\xe9sed sikeresen meg\xe9rkezett hozz\xe1nk. Kollg\xe9g\xe1nk hamarosan emailben felveszi veled a kapcsolatot.",
    testFitFormYes: "igen",
    testFitFormNo: "nem",
    testFitFormQ1: "Van alaprajzod amivel dolgozhatunk?",
    testFitFormQ1No: "Nem probl\xe9ma! Biztos\xedtunk neked egyet amit haszn\xe1lhatsz.",
    testFitFormQ2: "Van szerkeszthet\u0151 alaprajzod (PDF, AutoCAD)?",
    testFitTermsConditions: "Ennek a kis doboznak a kipip\xe1l\xe1s\xe1val a beta programunkban val\xf3 r\xe9szv\xe9telre egyezel bele. Egy ingyenes \xfcltet\xe9si terv a jutalmad az\xe9rt, hogy v\xe1laszolsz n\xe9h\xe1ny k\xe9rd\xe9sre a tapasztalataidr\xf3l.",
    testFitSubmitButtonText: "Alaprajz k\xe9relem beny\xfajt\xe1sa",
    backendError: "Hopp\xe1! Valami f\xe9lre ment a folyamat sor\xe1n - k\xe9rlek pr\xf3b\xe1ld meg \xfajra."
};


var $ca5a427bfbf28d83$exports = {};
$ca5a427bfbf28d83$exports = {
    // TermsOfService
    TermsTitle: "Szolg\xe1ltat\xe1si felt\xe9telek",
    TermsIntroText: 'Ez egy jogi meg\xe1llapod\xe1s k\xf6zted \xe9s a CBRE Kft. ("CBRE") k\xf6z\xf6tt a Spacer\xae-k\xe9nt ismert alkalmaz\xe1shoz val\xf3 hozz\xe1f\xe9r\xe9s \xe9s haszn\xe1lata kapcs\xe1n. Ezen web alap\xfa alkalmaz\xe1s inform\xe1ci\xf3nak vagy szolg\xe1ltat\xe1sainak a haszn\xe1lat\xe1val vagy hozz\xe1f\xe9r\xe9ssel azokhoz, elismered, hogy meg\xe9rtetted \xe9s beleegyezt\xe9l az \xc1ltal\xe1nos Szolg\xe1ltat\xe1si Felt\xe9telekbe ("\xc1SZF") amelyek itt r\xf6gz\xedt\xe9sre ker\xfclnek. A "Te", "Tied" vagy "Felhaszn\xe1l\xf3" kifejez\xe9sek kollekt\xedven arra a szem\xe9lyre vagy jogi entit\xe1sra utalnak akinek a nev\xe9ben az adott szem\xe9ly elj\xe1r.',
    TermsLimitationsTitle: "Korl\xe1toz\xe1sok.",
    TermsLimitationsA: "A felhaszn\xe1l\xf3 meg\xe9rti \xe9s beleegyezik abba, hogy a Felhaszn\xe1l\xf3 hozz\xe1f\xe9r\xe9se a Spacer\xae-hez nem exkl\xfaz\xedv, nem allicenszelhet\u0151 \xe9s nem \xe1truh\xe1zhat\xf3, szabadon visszavonhat\xf3 \xe9s felf\xfcggeszthet\u0151 vagy megsz\xfcntethet\u0151 b\xe1rmikor b\xe1rmely okb\xf3l a CBRE \xe1ltal.",
    TermsLimitationsB: 'A Felhaszn\xe1l\xf3 meg\xe9rti \xe9s beleegyezik, hogy a Spacer\xae-hez val\xf3 hozz\xe1f\xe9r\xe9s nem ruh\xe1z \xe1t semmilyen tulajdonjogot a Spacer\xae  vagy b\xe1rmely vonatkoz\xf3 dokumentum kapcs\xe1n (bele\xe9rtve sajt\xf3k\xf6zlem\xe9nyek, m\xf3dos\xedt\xe1sok vagy jav\xedt\xe1sok), minden esetben a CBRE ekl\xfaz\xedv tulajdon\xe1ban marad, bele\xe9rtve korl\xe1toz\xe1sok n\xe9lk\xfcl a szerz\u0151i jogot azonk\xedv\xfcl a csatlakoz\xf3 szabadalmakat, diz\xe1jn szabadalmakat, v\xe9djegyeket, term\xe9k megjelen\xe9st, kereskedelmi titkokat \xe9s m\xe1s tulajdonhoz kapcsol\xf3d\xf3 jogokat amelyek a vonatkoz\xf3 vagy nemzetk\xf6zi konvenci\xf3k (egy\xfcttesen, "Szellemi tulajdonjogok") szab\xe1lyoznak. L\xe1sd 2. Szekci\xf3 (Tulajdonjog) lentebb. A CBRE ez \xfaton kifejezetten minden jogot fenntart a Spacer\xae kapcs\xe1n \xe9s kifejezetten nem biztos\xedt a Felhaszn\xe1l\xf3nak a tov\xe1bbiakban.',
    TermsLimitationsC: "Kiv\xe9ve az itt meghat\xe1rozottakon k\xedv\xfcl vagy a CBRE a Felhaszn\xe1l\xf3nak \xedr\xe1sban adott kifejezett enged\xe9ly\xe9vel, a felhaszn\xe1l\xf3 nem fog (i) m\xf3dos\xedtani, ford\xedtnai, visszafejteni, visszaford\xedtani, sz\xe9tszedni, megpr\xf3b\xe1lni \xfajra \xf6sszerakni, meghat\xe1rozni vagy kidert\xedteni b\xe1rmilyen forr\xe1sk\xf3dot, alap\xf6tletet, m\xf6g\xf6ttes felhaszn\xe1l\xf3 fel\xfclet technik\xe1t vagy algoritmust, vagy a Spacer\xae-nek b\xe1rmilyen kivonat\xe1t vagy m\xe1solat\xe1t elk\xe9sz\xedteni; (ii) t\xf6r\xf6lni, m\xf3dos\xedt vagy m\xe1sol b\xe1rmilyen szerz\u0151i jog, v\xe9djegyjog vagy m\xe1s szellemi tulajdon al\xe1 es\u0151 r\xe9szt a Spacer\xae kapcs\xe1n, (iii) hozz\xe1rendel, allicenszel, vagy m\xe1s m\xf3don \xe1truh\xe1z hozz\xe1f\xe9r\xe9st, haszn\xe1lati vagy egy\xe9b jogot vagy deleg\xe1l egy\xe9b k\xf6telezetts\xe9get ezen Meg\xe1llapod\xe1s hat\xe1lya alatt; vagy (iv) a tov\xe1bbiak korl\xe1toz\xe1sa n\xe9lk\xfcl haszn\xe1lja a Spacer\xae-t egy versenyt\xe1rs term\xe9k vagy szolg\xe1ltat\xe1s meg\xe9p\xedt\xe9s\xe9re, vagy m\xe1s c\xe9lra azon a legitim haszn\xe1laton \xfczleti haszn\xe1laton k\xedv\xfcl amely a Felhaszn\xe1l\xf3 \xfczlet\xe9hez sz\xfcks\xe9ges.",
    TermsLimitationsD: "A Felhaszn\xe1l\xf3 beleegyezik abba, hogy \xedr\xe1sben azonnal a CBRE tudom\xe1s\xe1ra hozza, ha aSpacer\xae-t \xe9rtint\u0151 b\xe1rmely jogosultatlan felhaszn\xe1l\xe1s vagy a Szellemi jog b\xe1rmely megs\xe9rt\xe9se a tudom\xe1s\xe1ra jut.",
    TermsLimitationsE: "Ezen Meg\xe1llapod\xe1s hat\xe1lya alatt a Felhaszn\xe1l\xf3 beleegyezik abba, hogy folyamodik semmilyen szerz\u0151i jogi, v\xe9djegy vagy m\xe1s megjel\xf6l\xe9s bejegyz\xe9s\xe9re amely hat\xe1ssal lenne a Szellemi Jogokra \xe9s nem ny\xfajt be semmilyen dokumentumot egyetlen korm\xe1ny sz\xe1m\xe1ra sem amely hat\xe1ssal lenne a Szellemi Jogokra, bele\xe9rtve a CBRE tulajdon\xe1t a Spacer\xae kapcs\xe1n, a Spacer\xae v\xe9djegyet \xe9s az alkalmaz\xe1s m\xe1s elem\xe9re sem. Spacer\xae a CBRE kiz\xe1r\xf3lagos v\xe9djegye \xe9s szolg\xe1ltat\xe1s jegye.",
    TermsLimitationsF: "A Felhaszn\xe1l\xf3 bemutat \xe9s beleegyezik abba, hogy a Felhaszn\xe1l\xf3 \xe1ltal megadott adatok vagy anyagok a Spacer\xae-el kapcsolatban a CBRE sz\xe1m\xe1ra nem ekl\xfaz\xedv, jogd\xedjmentes, vil\xe1gszerte, visszavonhatatlan, \xf6r\xf6kk\xe9 tart\xf3 jogokat \xe9s felhaszn\xe1l\xe1si, lem\xe1sol\xe1si, m\xf3dos\xedt\xe1si, terjeszt\xe9si, kivonatol\xe1si enged\xe9lyt biztos\xedt \xe9s a CBRE meg\xedt\xe9l\xe9se szerint megjelen\xedtheti ezt az inform\xe1ci\xf3t vagy anyagokat. A Felhaszn\xe1l\xf3 beleegyezik abba, hogy a Felhaszn\xe1l\xf3 felel\u0151s a Felhaszn\xe1l\xf3 \xe1ltal beny\xfajtott b\xe1rmely anyag\xe9rt, bele\xe9rtve a jogszer\u0171s\xe9g\xe9t, helyess\xe9g\xe9t, eredetis\xe9g\xe9t vagy szerz\u0151i jog\xe1t. A Felhaszn\xe1l\xf3 \xe1ltal a CBRE-nak adott enged\xe9ly meghaladja a Felhaszn\xe1l\xf3 Spacer\xae-hez k\xf6thet\u0151 haszn\xe1lat\xe1t. B\xe1rmely a Felhaszn\xe1l\xf3 \xe1ltal megadott anyag \xe9s inform\xe1ci\xf3 nem tekinthet\u0151 bizalmasnak \xe9s ily m\xf3don is kezelend\u0151 a CBRE \xe1ltal \xe9s felhaszn\xe1lhat\xf3 a CBRE \xe1ltal a Felhaszn\xe1l\xf3 enged\xe9lye n\xe9lk\xfcl minden k\xf6telezetts\xe9g n\xe9lk\xfcl.",
    TermsOwnershipTitle: "Tulajdonl\xe1s.",
    TermsOwnershipText: "A Spacer\xae, a programoz\xe1si nyelv, a szoftware \xe9s a dokument\xe1ci\xf3 \xe9s minden m\xe1s anyag vagy tartalom amely a Spacer\xae vagy egy\xe9b jav\xedt\xe1s, m\xf3dos\xedt\xe1s, kivonatol\xe1s vagy v\xe1ltozat\xe1s amely a Spacer\xae kapcs\xe1n j\xf6n l\xe9tre \xe9s annak minden m\xe1solata a CBRE jogtulajdona \xe9s csakis a CBRE jogtulajdona marad minden k\xf6r\xfclm\xe9nyek k\xf6z\xf6tt, bele\xe9rtve korl\xe1toz\xe1sok n\xe9lk\xfcl a szabadalmi, szerz\u0151i jogi, v\xe9djegy vagy kereskedelmi titkokat a Spacer\xae kapcs\xe1n \xe9s jav\xedt\xe1sai, m\xf3dos\xedt\xe1sai, kivonatol\xe1sai vagy v\xe1ltoztat\xe1sai kapcs\xe1n. A Felhaszn\xe1l\xf3 tudom\xe1sul veszi, hogy az el\u0151bbiekben \xe9rtend\u0151ek a kereskedelmi titkok \xe9s inform\xe1ci\xf3k amelyek bizalmasak \xe9s kiz\xe1r\xf3lagosak a CBRE sz\xe1m\xe1ra \xe9s beleegyezik, hogy minden sz\xfcks\xe9geset megtesz hogy megv\xe9dje ezen inform\xe1ci\xf3k bizalmass\xe1g\xe1t. A Felhaszn\xe1l\xf3 nem adja el, ruh\xe1zza \xe1t, teszi k\xf6zz\xe9, fedi fel, mutat be vagy m\xe1s m\xf3don el\xe9rhet\u0151v\xe9 teszi a Spacer\xae-t vagy b\xe1rmely kapcsol\xf3d jav\xedt\xe1s\xe1t, m\xf3dos\xedt\xe1s\xe1t, kivonat\xe1t vagy egy\xe9b v\xe1ltozat\xe1t \xe9s annak m\xe1solatait sem. Ezen Meg\xe1llapod\xe1s megsz\u0171n\xe9se nem ad jogalapot arra, hogy b\xe1rmilyen jogi vagy anyagi orvoslatot ny\xfajtson be a CBRE fele. A k\xf6telezetts\xe9gek meghaladj\xe1k ezen Meg\xe1llapod\xe1s megsz\u0171n\xe9s\xe9t.",
    TermsTerminationTitle: "Felmond\xe1s; A felmond\xe1s hat\xe1sa; Jogorvoslatok.",
    TermsTerminationA: "B\xe1rmilyen jogorvoslat n\xe9lk\xfcl a CBRE m\xf3dos\xedthajat, korl\xe1tozhatja, felf\xfcggesztheti, megszak\xedthatja vagy megsz\u0171ntetheti ez a Meg\xe1llapod\xe1st \xe9s/vagy a Felhaszn\xe1l\xf3 a Spacer\xae-hez kapcsol\xf3d\xf3 minden vagy r\xe9szleges haszn\xe1lati jog\xe1t, azonnal hat\xe1llyal, automatikusa, \xe9rtes\xedt\xe9s vagy \xe9rtes\xedt\xe9s n\xe9lk\xfcl b\xe1rmilyen b\xedr\xf3s\xe1gi vagy egy\xe9b folyamodv\xe1ny n\xe9lk\xfcl, b\xe1rmely okb\xf3l vagy ok n\xe9lk\xfcl is. A Felhaszn\xe1l\xf3 beleegyezik, hogy a CBRE k\xf6telezetts\xe9g n\xe9lk\xfcl szolg\xe1ltatja a Spacer\xae-t \xe9s a CBRE nem felel\u0151s a Felhaszn\xe1l\xf3 vagy b\xe1rmely m\xe1s f\xe9l sz\xe1m\xe1ra a Spacer\xae-b\u0151l ad\xf3d\xf3 korl\xe1toz\xe1sok\xe9rt, felf\xfcggeszt\xe9sek\xe9rt, megszak\xedt\xe1sok\xe9rt, megsz\xfcntet\xe9sek\xe9rt vagy m\xf3dos\xedt\xe1sok\xe9rt.",
    TermsTerminationB: "A Felhaszn\xe1l\xf3 tudom\xe1sul veszi, hogy a CBRE sz\xe1m\xe1ra a k\xf6vetkez\u0151kben adott k\xf6telezetts\xe9gei egyediek \xe9s nem helyettes\xedthet\u0151 term\xe9szet\u0171ek, a j\xf3v\xe1tehetetlen vesztes\xe9g amely a CBRE-t \xe9ri nem helyettes\xedthet\u0151ek csup\xe1n anyagi k\xe1rk\xe9nt \xe9s ily m\xf3don a CBRE jogosult k\xe1rt\xe9r\xedt\xe9sre vagy m\xe1s anyagi term\xe9szet\u0171 jogorvoslatra (k\xf6tv\xe9ny vagy egy\xe9b biztos\xedt\xe9k kibocs\xe1t\xe1s\xe1nak k\xf6telezetts\xe9ge n\xe9lk\xfcl) abban az esetben, ha a Felhaszn\xe1l\xf3 b\xe1rmilyen szerz\u0151d\xe9sszeg\xe9st vagy v\xe1rhat\xf3 szerz\u0151d\xe9sszeg\xe9st k\xf6vet el. A Felhaszn\xe1l\xf3 visszavonhatatlanul lemond minden jogr\xf3l hogy k\xe1rt\xe9r\xedt\xe9si vagy m\xe1s anyagi term\xe9szet\u0171 k\xe1rt\xe9r\xedt\xe9st k\xf6veteljen.",
    TermsDisclaimerTitle: "Felel\u0151ss\xe9g kiz\xe1r\xe1sa \xe9s a felel\u0151ss\xe9g korl\xe1toz\xe1sa.",
    TermsDisclaimerA: "Spacer\xae is provided to User \u201CAS IS\u201D and \u201CAS AVAILABLE\u201D with no warranties.  CBRE DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT. CBRE DOES NOT WARRANT IN ANY WAY THAT Spacer\xae WILL MEET USER\u2019S REQUIREMENTS OR ANY PARTICULAR STANDARD. SOME STATES DO NOT ALLOW THE EXCLUSION OF IMPLIED WARRANTIES, SO THE ABOVE EXCLUSION MAY NOT APPLY TO USER. In such event the liability of cbre will be limited to the maximum extent possible under applicable law. NO ORAL OR WRITTEN INFORMATION OR ADVICE GIVEN BY CBRE, ITS AGENTS OR EMPLOYEES, SHALL CREATE A WARRANTY IN ANY WAY WHATSOEVER. NO WARRANTY IS GIVEN THAT Spacer\xae OR ANY INFORMATION PROVIDED TO USER ARE ERROR FREE OR THAT THE USE OF Spacer\xae WILL BE UNINTERRUPTED, UP-TO-DATE, COMPLETE OR FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS, AND NO WARRANTY IS GIVEN THAT ANY OF THE FOREGOING WILL BE CORRECTED. CBRE DOES NOT WARRANT OR MAKE ANY REPRESENTATIONS REGARDING THE USE OF, OR THE RESULTS FROM THE USE OF, Spacer\xae.  CBRE SHALL NOT BE LIABLE FOR ANY INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL, PUNITIVE OR EXEMPLARY DAMAGES (INCLUDING WITHOUT LIMITATION DAMAGES FOR LOSS OF BUSINESS, LOSS OF PROFITS, LOST REVENUE, LOST SAVINGS, COMPUTER INTERRUPTION, GOODWILL, USE, DATA OR OTHER INTANGIBLE LOSSES), WHETHER BASED ON BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE), PRODUCT LIABILITY OR OTHERWISE, EVEN IF CBRE OR ITS REPRESENTATIVES HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES AND EVEN IF A REMEDY SET FORTH HEREIN IS FOUND TO HAVE FAILED OF ITS ESSENTIAL PURPOSE.",
    TermsDisclaimerB: "CBRE\u2019S TOTAL LIABILITY FOR DAMAGES FOR ANY CAUSE WHATSOEVER SHALL NOT EXCEED THE FEE PAID BY USER FOR Spacer\xae DURING THE TWELVE (12) MONTH PERIOD PRIOR TO THE EVENT THAT ALLEGEDLY CAUSED SUCH DAMAGE.  USER AGREES THAT ANY CAUSE OF ACTION ARISING OUT OF OR RELATED TO Spacer\xae OR OTHERWISE RELATED TO THIS AGREEMENT MUST COMMENCE WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES. OTHERWISE, SUCH CAUSE OF ACTION IS PERMANENTLY BARRED.",
    TermsDisclaimerC: "SOME JURISDICTIONS MAY NOT ALLOW THE LIMITATION ON LIABILITY OR EXCLUSIONS OF LIABILITY SET FORTH ABOVE, SO THE ABOVE LIMITATION OR EXCLUSION MAY NOT APPLY TO USER. In such event the liability of CBRE will be limited to the maximum extent possible under applicable law.  The waiver of warranty, exclusive remedies and limited liability set forth above are fundamental elements of the basis for this Agreement between CBRE and USER. CBRE would not be able to provide Spacer\xae on an economic basis, and would not have entered into this Agreement, without such limitations. These limitations shall survive any termination of this Agreement.",
    TermsIndemnificationTitle: "Felhaszn\xe1l\xf3 azonos\xedt\xe1s.",
    TermsIndemnificationText: "At CBRE\u2019s option and request, User shall, at its own expense, indemnify and hold harmless CBRE and its subsidiaries, affiliates, officers, employees, agents, co-branders, associations, and other partners harmless from and against any losses, costs, damages, liabilities, settlements and expenses (including without limitation costs and attorneys\u2019 fees), arising out of or related to any third-party claim, action or allegation related to or arising from: (a) any transaction or dispute between User and any third party; (b) facts or alleged facts that would constitute a breach of any of User\u2019s representations, warranties, or covenants under this Agreement or of any applicable law, rule or regulation, whether or not referenced herein; (c) any User materials, information or content submitted in or on Spacer\xae; (d) User\u2019s violation of any rights of any third party, (e) User\u2019s use or misuse of Spacer\xae; or (f) the negligence or willful misconduct of User.  CBRE shall have the right to exclusively direct and control its defense and hire counsel of its choice, at User\u2019s expense.",
    TermsGeneralTitle: "\xc1ltal\xe1nos.",
    TermsGeneralA: "<0>Teljes Meg\xe1llapod\xe1st/Nincs \xd6nk\xe9ntelen lemond\xe1s.</0> Ez a Meg\xe1llapod\xe1s alkotja a teljes meg\xe1llapod\xe1st a CBRE \xe9s a Felhaszn\xe1l\xf3 k\xf6z\xf6tt amely a Spacer\xae illeti \xe9s mindent ami ennek a Meg\xe1llapod\xe1snak a t\xe1rgya, \xe9s hat\xe1lytalan\xedt minden kor\xe1bbi meg\xe1llapod\xe1st a CBRE \xe9s Felhaszn\xe1l\xf3 k\xf6z\xf6tt amely Spacer\xae-re vonatkozik, ha volt is ilyen. A CBRE mulaszt\xe1sa, hogy \xe9rv\xe9ny\xe9t szerezzen a Meg\xe1llapod\xe1s b\xe1rmely rendelkez\xe9s\xe9nek nem min\u0151s\xfcl lemond\xe1snak arr\xf3l a jogr\xf3l.",
    TermsGeneralB: "<0>K\xf6zl\xe9sek.</0> A K\xf6zl\xe9sek \xedr\xe1sos form\xe1ban kell, hogy megsz\xfclessenek \xe9s esetleg e-mail-ben vagy postai \xfaton, illetve a Spacer\xae honlapj\xe1n www.cbre.com/spacer. A Felhaszn\xe1l\xf3 k\xf6zl\xe9seket a Spacer\xae sz\xe1m\xe1ra a spacersupport@cbre.com e-mail c\xedmen tehet meg, m\xe1solattal aj\xe1nlott lev\xe9lk\xfcldem\xe9nyk\xe9nt a CBRE sz\xe1m\xe1ra a 400 S. Hope Street, 25th Floor, Los Angeles, CA 90071, C\xedmz\xe9s: Jogtan\xe1csosi Iroda. K\xf6zl\xe9sek amennyiben e-mailben \xe9rkeznek egy (1) munka napos hat\xe1rid\u0151vel kezelend\u0151ek (kiv\xe9ve ha a k\xfcld\u0151 \xe9rtes\xedt\xe9st kap arr\xf3l, hogy az lev\xe9l nem ker\xfclt k\xe9zbes\xedt\xe9stre) vagy 3 munkanapos hat\xe1rid\u0151vel amennyiben a CBRE website-on ker\xfcl k\xf6zl\xe9sre (a CBRE eset\xe9ben).",
    TermsGeneralC: "<0>Alkalmazand\xf3 jog \xe9s joghat\xf3s\xe1g.</0> Ezen meg\xe1llapod\xe1st Kalifornia \xc1llam t\xf6rv\xe9nyeinek szellem\xe9ben kell \xe9rtelmezni \xe9s annak joga ir\xe1nyad\xf3 minden m\xe1s jog rendelkez\xe9seinek kiz\xe1r\xe1s\xe1val. A CBRE \xe9s a felhaszn\xe1l\xf3 kiz\xe1r\xf3lagosan al\xe1veti mag\xe1t Kalifornia \xc1llam joghat\xf3s\xe1g\xe1nak. Az Egyes\xfclt Nemzetek Nemzetk\xf6zi Az \xe1ruk nemzetk\xf6zi kereskedelm\xe9r\u0151l sz\xf3l\xf3 konvenci\xf3j\xe1nak (1980) szerz\u0151d\xe9sekre vonatkoz\xf3 r\xe9sze teljes m\xe9rt\xe9kben kiz\xe1rand\xf3 ezen meg\xe1llapod\xe1s alkalmaz\xe1sa sor\xe1n.  A Felhaszn\xe1l\xf3 ez\xfaton beleegyezik, hogy a Spacer\xae kiz\xe1r\xf3lagos Kaliforni\xe1hoz k\xf6thet\u0151 \xe9s passz\xedv szolg\xe1ltat\xe1sa nem enged teret egy\xe9ni jogorvoslatra a CBRE-n t\xfal, legyen az specifikus vagy \xe1ltal\xe1nos, Kalifornia \xc1llam joghat\xf3s\xe1g\xe1n k\xedv\xfcl.",
    TermsGeneralD: "<0>Dispute Resolution.</0> Any dispute, claim or controversy arising out of or relating to this Agreement, or the breach, enforcement, interpretation or validity thereof, including the determination of the scope or applicability of arbitration with respect to this Agreement, shall be determined by arbitration.\xa0 The arbitration shall be administered by the Judicial Arbitration and Mediation Service (JAMS), and the arbitration shall be conducted with a single arbitrator.\xa0 Furthermore, User agrees that neither User nor CBRE will join any claim with the claim of any other person or entity in arbitration; that no claim will be resolved on a class-wide basis; and that neither User nor CBRE will assert any claim in a representative capacity on behalf of anyone else.\xa0 Notwithstanding the foregoing, User agrees that CBRE shall be allowed to apply for injunctive remedies (or an equivalent type of urgent legal relief) in any jurisdiction.\xa0 If User files an arbitration complaint against CBRE, CBRE agrees to pay for any portion of the initial filing fee that exceeds $250; after the initial filing fees, the parties will share the costs of arbitration equally.\xa0 User agrees not to commence or prosecute any action against CBRE other than by filing an arbitration complaint in accordance with this paragraph.\xa0 IMPORTANTLY, BY AGREEING TO BE BOUND BY THIS AGREEMENT, USER IS WAIVING ANY RIGHT USER HAS TO SEEK RELIEF IN A COURT OF LAW AND ANY RIGHT USER HAS TO A TRIAL BY JURY.",
    TermsGeneralE: "<0>Elk\xfcl\xf6n\xedthet\u0151s\xe9g.</0> Abban az esetben ha ezen meg\xe1llapod\xe1s b\xe1rmely r\xe9szlete \xe9rv\xe9nytelen, az elk\xfcl\xf6n\xedthet\u0151 r\xe9sz m\xf3dos\xedtand\xf3 a sz\xfcks\xe9ges m\xe9rt\xe9kig, annak \xe9rdek\xe9ben, hogy \xe9rv\xe9nyess\xe9 v\xe1ljon m\xedg a t\xf6bbi rendelkez\xe9se teljes joger\u0151ben \xe9s hat\xe1lyban marad.",
    TermsGeneralF: "<0>\xc1truh\xe1z\xe1s.</0> Ez a Meg\xe1llapods\xe1 nem \xe1truh\xe1zhat\xf3 a Felhaszn\xe1l\xf3 \xe1tlal a CBRE megel\u0151z\u0151 \xedr\xe1sos enged\xe9lye n\xe9lk\xfcl. A CBRE beleegyez\xe9se n\xe9k\xfcli b\xe1rmilyen megk\xeds\xe9relt \xe1truh\xe1z\xe1s \xe9rv\xe9nytelen. A CBRE fenntartja a jog\xe1t a szerz\u0151d\xe9s \xe1truh\xe1z\xe1s\xe1ra b\xe1rmely harmadik szem\xe9ly r\xe9sz\xe9re. Ezen meg\xe1llapod\xe1s \xe9s a jogok \xe9s k\xf6telezetts\xe9gek k\xf6telez\u0151 hat\xe1ly\xfaak \xf6r\xf6k\xf6seink \xe9s megb\xedzottjaink sz\xe1m\xe1ra.",
    TermsGeneralG: "<0>M\xf3dos\xedt\xe1sok.</0> A CBRE-nak b\xe1rmikor jog\xe1ban \xe1ll m\xf3dos\xedtani ezen meg\xe1llapod\xe1s felt\xe9teleit \xe9s ez a CBRE egyed\xfcl\xe1ll\xf3 \xe9s el nem idegen\xedthet\u0151 joga, amelyet egy v\xe1ltozat\xe1si jegyzet vagy egy \xfaj meg\xe1llapod\xe1s k\xf6zl\xe9s\xe9vel thet meg a Spacer\xae\u2019s weboldal\xe1n a k\xf6vetkez\u0151 oldalon www.cbre.com/spacer vagy egy ezzel egyen egyen\xe9rt\xe9k\u0171 jelz\xe9s megt\xe9tel\xe9vel a Spacer\xae alkalmaz\xe1sban. Abban az esetben, ha b\xe1rmely m\xf3dos\xedt\xe1s nem elfogadhat\xf3 a Felhaszn\xe1l\xf3 sz\xe1m\xe1ra a Felhaszn\xe1l\xf3 egyetlen visszkereseti joga a  Spacer\xae haszn\xe1lat\xe1nak megsz\u0171ntet\xe9se.",
    TermsGeneralH: "<0>Konfliktusok.</0> Ezen Meg\xe1llapod\xe1s kapcs\xe1n l\xe9trej\xf6v\u0151 konfliktus eset\xe9n \xe9s b\xe1mely a Felhaszn\xe1l\xf3 \xe9s a CBRE k\xf6z\xf6tt l\xe9trej\xf6tt teljesen v\xe9grehajtott enged\xe9ly eset\xe9ben Spacer\xae kapcs\xe1n, ennek a enged\xe9lynek a r\xe9szletei szab\xe1lyozz\xe1k a konfliktusos eseteket."
};


var $96da515567b8581f$exports = {};
$96da515567b8581f$exports = {
    // Quiz
    exitQuizButtonTitle: "Kil\xe9p\xe9s a kv\xedzb\u0151l",
    // QuizProgressLabel
    progressLabelText: "",
    // QuizNavigationButton
    quizNavBackButtonShortenedText: "El\u0151z\u0151",
    quizNavBackButtonFullLengthText: "El\u0151z\u0151 k\xe9rd\xe9s",
    quizNavNextButtonShortenedText: "K\xf6vetkez\u0151",
    quizNavNextButtonFullLengthText: "K\xf6vetkez\u0151 k\xe9rd\xe9s",
    // QuizExitSlide
    quizExitSubtitle: "Most a v\xe1laszaid alapj\xe1n megadjuk a c\xe9ged sz\xe1m\xe1ra t\xf6k\xe9letes irodateret.",
    quizExitImgAlt: "Illusztr\xe1ci\xf3 k\xe9t emberr\u0151l akik pacsiznak a Spacer a CBRE-t\xf3l kv\xedz oldal\xe1n",
    // Question Unit Text (questionUnitMap.js)
    question1Text: "Kezdetnek. Hogyan jellemezn\xe9d a j\xf6v\u0151beni irod\xe1d c\xe9lj\xe1t?",
    question2Text: "Szerinted mi az ami vonz\xf3 a szervezetedben az \xfaj jel\xf6ltek sz\xe1m\xe1ra?",
    question3Text: "Mik a legfontosabb szempontok amiket figyelembe veszel amikor \xfaj csapattagokat veszel fel?",
    question4Text: "El\u0151rel\xe1that\xf3lag hogyan v\xe1ltozik a c\xe9gedm\xe9rete a k\xf6vetkez\u0151 5 \xe9vben?",
    question5Text: "Milyen id\u0151beoszt\xe1sban dolgoztok?",
    question6Text: "Mit gondolsz az egy\xe9ni, dedik\xe1lt asztalokr\xf3l?",
    question7Text: "Amikor az irod\xe1ban tart\xf3zkodnak a munkat\xe1rsak, hol t\xf6ltik a munkaidej\xfck nagy r\xe9sz\xe9t?",
    question8Text: "Mi a dresscode az irod\xe1ban?",
    question9Text: "Honnan dolgozol \xe1ltal\xe1ban?",
    question10Text: "Milyen irodai l\xe9gk\xf6r uralkodik n\xe1latok?",
    question11Text: "A munka\xe1llom\xe1sokon k\xedv\xfcl m\xe9g milyen ter\xfcleteket szeretn\xe9l biztos\xedtani a munkav\xe1llal\xf3knak?",
    question12Text: "Ezek k\xf6z\xfcl melyik \xedr le t\xe9ged a legjobban?",
    // Quiz Answers (questionUnitMap.js)
    pickOnePlaceholder: "v\xe1lassz egyet...",
    selectFromListPlaceholder: "v\xe1lassz ebb\u0151l a list\xe1b\xf3l...",
    firstResponseTooltipText: "V\xe1laszd ki az els\u0151 v\xe1laszod",
    locatedSomewhereElseLabel: "Jelenleg m\xe1s helysz\xednen dolgozom.",
    q1AnswerText1: "Az irod\xe1nkr\xf3l el\u0151sz\xf6r ezek jutnak eszembe",
    q1AnswerText2: "m\xe1sodj\xe1ra",
    q1AnswerText3: "\xe9s harmadj\xe1ra",
    q1Option1Text: "a munkatarsak m\xe1sodik otthona",
    q1Option2Text: "a szervezeti v\xe1ltoz\xe1sok kataliz\xe1tora",
    q1Option3Text: "\xf6szpontos\xedt\xe1st ig\xe9nyl\u0151 munka tere",
    q1Option4Text: "a k\xf6vetkez\u0151 nagy \xf6tlet inkub\xe1tora",
    q1Option5Text: "eszk\xf6z a tehets\xe9gek bevonz\xe1s\xe1ra",
    q1Option6Text: "a m\xe1rka bemutat\xe1s\xe1nak eszk\xf6ze",
    q1Option7Text: "a n\xf6veked\xe9s \xe9s a tanul\xe1s helysz\xedne",
    q1Option8Text: "k\xf6z\xf6ss\xe9gi t\xe9r, ahol a kolleg\xe1k tal\xe1lkozhatnak, \xf6sszegy\u0171lhetnek",
    q1Option9Text: "sz\xfcks\xe9ges k\xf6lts\xe9gt\xe9tel, amelyet minimaliz\xe1lni kell",
    q2AnswerText1: "Els\u0151sorban az\xe9rt csatlakoznak hozz\xe1nk, mert",
    q2AnswerText2: "m\xe1sodsorban",
    q2AnswerText3: "\xe9s v\xe9g\xfcl",
    q2Option1Text: "c\xe9ges kult\xfara",
    q2Option2Text: "versenyk\xe9pes fizet\xe9sek",
    q2Option3Text: "a c\xe9g h\xedrneve",
    q2Option4Text: "fizet\xe9sen k\xedv\xfcli juttat\xe1sok",
    q2Option5Text: "rugalmas munkaid\u0151",
    q2Option6Text: "emberek \xe9s vezet\xe9s",
    q2Option7Text: "irodai k\xf6rnyezet",
    q2Option8Text: "c\xe9lok \xe9s k\xfcldet\xe9s",
    q3AnswerText1: "A legfontosabb szempont",
    q3AnswerText2: "m\xe1sodsorban",
    q3AnswerText3: "v\xe9g\xfcl pedig",
    q3Option1Text: "k\xe9szs\xe9gek",
    q3Option2Text: "tapasztalat",
    q3Option3Text: "illeszked\xe9s a c\xe9gkult\xfar\xe1ba",
    q3Option4Text: "referenci\xe1k",
    q3Option5Text: "kapcsolatok",
    q3Option6Text: "k\xedv\xe1ncsis\xe1g",
    q4AnswerText: "A j\xf6v\u0151ben",
    q4Option1Text: "picit n\xf6veked\xfcnk minden \xe9vben",
    q4Option2Text: "jelent\u0151sen n\xf6veked\xfcnk minden \xe9vben",
    q4Option3Text: "nagyj\xe1b\xf3l ugyanakkor\xe1k maradunk",
    q4Option4Text: "kicsit cs\xf6kken\xfcnk minden \xe9vben",
    q4Option5Text: "neh\xe9z megmondani, megj\xf3solhatatlan",
    q5AnswerText: "\xcdgy dolgozunk \xe1ltal\xe1ban:",
    q5Option1Text: "9-t\u0151l 5-ig",
    q5Option2Text: "reggelt\u0151l...sok\xe1ig",
    q5Option3Text: "a munkaid\u0151 rugalmasan beoszthat\xf3",
    q5Option4Text: "amikor szeretn\xe9nk, amilyen gyakran szeretn\xe9nk",
    q6AnswerText: "\xdagy gondoljuk, hogy",
    q6Option1Text: "mindenkinek saj\xe1t j\xe1r",
    q6Option2Text: "jobb megosztani az asztalokat",
    q7Option1Text: "Mindig saj\xe1t munka\xe1llom\xe1son",
    q7Option2Text: "Els\u0151sorban saj\xe1t munka\xe1llom\xe1son, ahonnan lebonyol\xedtanak n\xe9h\xe1ny megb\xe9sz\xe9l\xe9st \xe9s befejeznek n\xe9h\xe1ny egy\xe9b feladatot",
    q7Option3Text: "Egyenl\u0151 eloszl\xe1sban a munka\xe1llom\xe1son \xe9s valahol m\xe1shol az irod\xe1ban",
    q7Option4Text: "\xc1ltal\xe1ban helys\xe9gr\u0151l helys\xe9gre j\xe1rva valahol le\xfclve ahol hely van",
    q7Option5Text: "Mindig helys\xe9gr\u0151l helys\xe9gre j\xe1rva",
    q8Option1Text: "\xdczleti megjelen\xe9s",
    q8Option2Text: "\xc1ltal\xe1ban \xfczleti \xf6lt\xf6zet kiv\xe9ve n\xe9h\xe1ny k\xfcl\xf6nleges alkalmat",
    q8Option3Text: "\xc1ltal\xe1ban lezser \xfczleti, de van n\xe9h\xe1ny olyan nap amikor alkalmi, illetve n\xe9h\xe1ny esetben h\xe9tk\xf6znapi \xf6lt\xf6zet is el\u0151fordul",
    q8Option4Text: "Lezser \xf6lt\xf6zet n\xe9h\xe1ny k\xfcl\xf6nleges alkalomt\xf3l eltekintve",
    q8Option5Text: "Lezser",
    q9Option1Text: "Mindig az irod\xe1b\xf3l",
    q9Option2Text: "Legink\xe1bb otthonr\xf3l",
    q9Option3Text: "Az irod\xe1b\xf3l \xe9s otthonr\xf3l is",
    q9Option4Text: "Legink\xe1bb irod\xe1n k\xedv\xfcl",
    q9Option5Text: "Mindig irod\xe1n k\xedv\xfcl",
    q10Option1Text: "Dinamikus \xe9s energikus",
    q10Option2Text: "Energikus, r\xf6vid csendesebb id\u0151szakokkal",
    q10Option3Text: "Att\xf3l f\xfcgg, a kett\u0151 egyvelege",
    q10Option4Text: "Csendes, kev\xe9s dinamikus peri\xf3dussal",
    q10Option5Text: "Csendes \xe9s nyugalmas",
    q11Option1Text: "Csak a felt\xe9tlen\xfcl sz\xfcks\xe9ges helyis\xe9geket",
    q11Option2Text: "Az alapok \xe9s n\xe9h\xe1ny extra",
    q11Option3Text: "Az alapok \xe9s olyan helys\xe9g ahol az emberek \xf6sszegy\u0171lhetnek",
    q11Option4Text: "Valami nagyon j\xf3 c\xe9l\xe1llom\xe1s az irod\xe1n bel\xfcl",
    q11Option5Text: "Valami szuper, kiemelked\u0151, amit szeretn\xe9l megmutatni egy l\xe1togat\xf3nak",
    q12AnswerText: "\xc9n egy",
    q12OptionClientText: "jelenlegi CBRE \xfcgyf\xe9l vagyok",
    q12OptionProfessionalText: "CBRE kollega vagyok",
    q12OptionLeadText: "valaki m\xe1s",
    q13AnswerText1: "N\xe1lunk",
    q13AnswerText2: "alkalmazott lesz az irod\xe1ban",
    q13AnswerHelperText: "*Tipp: Ez \xe1ltal\xe1ban a b\xe9rleti szerz\u0151d\xe9sed k\xf6z\xe9ppontja vagy kb. 2-5 \xe9v mostant\xf3l sz\xe1m\xedtva.",
    q14AnswerText1: "Az id\u0151nk",
    q14AnswerText2: "r\xe9sz\xe9t csapatmunk\xe1ban dolgozzuk.",
    q15AnswerText1: "\xc1tlagosan",
    q15AnswerText2: "napot tervez\xfcnk t\xf6lteni az irod\xe1ban.",
    q16AnswerText1: "Az irod\xe1nk itt lesz",
    q16AnswerText2: ".",
    q17AnswerText1: "Els\u0151sorban a",
    q17AnswerText2: "szektorban dolgozunk.",
    q18AnswerText1: "Most innen dolgozom",
    q18AnswerText2: ".",
    q19AnswerText1: "Az \xfcltet\xe9si s\u0171r\u0171s\xe9get (egy f\u0151re jut\xf3 nm)",
    q19AnswerText2: "tervezz\xfck.",
    // Quiz Responses (questionUnitMap.js)
    q1ResponseText: "Meghat\xe1rozunk egy irod\xe1t amely egyezik az elk\xe9pzel\xe9seddel.",
    q2ResponseText: "Megnyer\u0151 \xf6sszet\xe9tel!",
    q3ResponseText: "\xc9rdekesen hangzik hova f\xe9r\xfcnk be?",
    q4ResponseText: "Nagyszer\u0171! Mi biztos\xedtjuk, hogy az iroda m\xe9rete j\xf3 legyen.",
    q5Response1Text: "J\xf3l hangzik!",
    q5Response2Text: "Mi is hajlamosak vagyunk t\xfal\xf3r\xe1zni.",
    q5Response3Text: "Nagyon j\xf3l hangzik!",
    q5Response4Text: "Kiv\xe1l\xf3an hangzik!",
    q6Response1Text: "Egy olyan teret hat\xe1rozunk meg amelyben az els\u0151dleges a szem\xe9lyes t\xe9r.",
    q6Response2Text: "Egy olyan teret hat\xe1rozunk meg amely rugalmas.",
    q12ResponseLeadText: "A megfelel\u0151 helyre j\xf6tt\xe9l.",
    q12ResponseClientText: "Kiv\xe1l\xf3!",
    q12ResponseProfessionalText: "K\xf6sz\xf6nj\xfck!",
    // Industry Codes (industryCodes.js)
    animalProd: "N\xf6v\xe9nytermeszt\xe9s, \xe1llatteny\xe9szt\xe9s",
    forestry: "Erd\u0151gazd\xe1lkod\xe1s",
    fishingHunting: "Hal\xe1szat, halgazd\xe1lkod\xe1s, vadgazd\xe1lkod\xe1s \xe9s kapcsol\xf3d\xf3 szolg\xe1ltat\xe1sok",
    agForestSupport: "Mez\u0151gazdas\xe1g \xe9s kapcsol\xf3d\xf3 szolg\xe1ltat\xe1sok",
    oilGas: "Olaj \xe9s g\xe1z kitermel\xe9s",
    energy: "Energia ipar (G\xe1z, olaj stb.)",
    mining: "B\xe1ny\xe1szat, kiv\xe9ve olaj \xe9s g\xe1z",
    supportMining: "B\xe1ny\xe1szathoz kapcsol\xf3d\xf3 szolg\xe1ltat\xe1sok",
    utilities: "K\xf6zm\u0171vek",
    buildingConstruct: "\xc9p\xfcletek \xe9p\xedt\xe9se",
    heavyCivilConstruct: "Magas- \xe9s m\xe9ly \xe9p\xedt\xe9szet",
    specialtyContract: "Speci\xe1lis szak\xe9p\xedt\xe9s",
    foodManufac: "\xc9lelmiszer gy\xe1rt\xe1s",
    beverageTobaccoManufac: "Ital \xe9s doh\xe1ny\xe1r\xfa gy\xe1rt\xe1s",
    textile: "Text\xedlia gy\xe1rt\xe1sa",
    textileProduct: "Text\xedl\xe1r\xfa gy\xe1rt\xe1sa",
    apparelManufac: "Ruh\xe1zatgy\xe1rt\xe1sa",
    leatherManufac: "B\u0151r \xe9s b\u0151rterm\xe9k gy\xe1rt\xe1sa",
    woodManufac: "Fa\xe1ru gy\xe1rt\xe1sa",
    paperManufac: "Pap\xedr\xe1r\xfa gy\xe1rt\xe1sa",
    printingSupport: "Nyomtat\xe1s \xe9s kapcsol\xf3d\xf3 szolg\xe1ltat\xe1sok",
    printingReproduc: "Nyomdai \xe9s egy\xe9b reprodukci\xf3s tev\xe9kenys\xe9g",
    petroleumCoal: "K\u0151olaj \xe9s sz\xe9n term\xe9kek gy\xe1rt\xe1sa",
    chemicalManufac: "Vegyi anyag, term\xe9k gy\xe1rt\xe1sa",
    chemicals: "Vegyialapanyag gy\xe1rt\xe1s",
    pharma: "Gy\xf3gyszeripar",
    cleaningManufac: "Tiszt\xedt\xf3berendez\xe9sek gy\xe1rt\xe1sa",
    plasticsRubberManufac: "Gumi-, m\u0171anyag term\xe9k gy\xe1rt\xe1sa",
    nonmetallicManufac: "Nemf\xe9m \xe1sv\xe1nyi term\xe9k gy\xe1rt\xe1sa",
    primaryMetalManufac: "F\xe9malapanyag gy\xe1rt\xe1sa",
    fabricatedMetalManufac: "F\xe9mfeldolgoz\xe1si term\xe9k gy\xe1rt\xe1sa",
    machineryManufac: "G\xe9p, g\xe9pi berendez\xe9s gy\xe1rt\xe1sa",
    manufac: "G\xe9pgy\xe1rt\xe1s",
    computerElectronicManufac: "Sz\xe1m\xedt\xf3g\xe9p, elektronikai, optikai term\xe9k gy\xe1rt\xe1sa",
    electricalApplianceManufac: "Villamos berendez\xe9s gy\xe1rt\xe1sa",
    transportEquipManufac: "K\xf6z\xfati j\xe1rm\u0171 gy\xe1rt\xe1sa",
    aerospaceDefense: "L\xe9gi \xe9s honv\xe9delmi term\xe9k gy\xe1rt\xe1sa",
    furnitureManufac: "B\xfatorgy\xe1rt\xe1s",
    miscManufac: "Egy\xe9b g\xe9pgy\xe1rt\xe1s",
    merchantWholesaleDurable: "Nagykereskedelem, tart\xf3s \xe1r\xfak",
    merchantWholesaleNondurable: "Nagykereskedelem, nem tart\xf3s \xe1ruk",
    electronicMarket: "Elektronikai piac, \xfcgyn\xf6k\xf6k \xe9s br\xf3kerek",
    motorVehiclePartsDealers: "G\xe9pj\xe1rm\u0171, motorker\xe9kp\xe1r kereskedelme, jav\xedt\xe1sa",
    furnitureFurnishingStores: "B\xfator \xe9s lakberendez\xe9s keresked\xe9s",
    electronicApplianceStores: "Elektornikai \xe9s h\xe1ztart\xe1si berendez\xe9s keresked\xe9s",
    electronics: "Elektronika",
    buildingGardenSupplyStores: "\xc9p\xedt\u0151anyag \xe9s kert\xe9szeti cikk keresked\xe9s",
    foodBeverageStores: "\xc9lelmiszer \xe9s ital keresked\xe9s",
    groceryStores: "\xc9lelmiszer bolt",
    beerWineLiquorStores: "S\xf6r, bor \xe9s r\xf6vidital keresked\xe9s",
    healthCareStores: "Gy\xf3gy\xe1szati \xe9s illatszer keresked\xe9s",
    gasStations: "Benzinkutak",
    clothingAccessoriesStores: "Ruh\xe1zati \xe9s ruh\xe1zati kieg\xe9sz\xedt\u0151 \xfczletek",
    clothingTextiles: "Ruh\xe1zat/text\xedli\xe1k",
    jewelryFurs: "\xc9kszerek \xe9s sz\u0151rm\xe9k",
    sportsHobbyMusicBookStores: "Sport, hobby, hangszer, k\xf6nyv \xfczletek",
    genMerchandiseStores: "\xc1ltal\xe1nos kiskeresked\u0151k",
    miscStoreRetailers: "Egy\xe9b kiskeresked\u0151k",
    officeProducts: "Irodai term\xe9kek",
    retailSales: "Kiskereskedelmi \xe9rt\xe9kes\xedt\xe9s",
    nonstoreRetails: "\xdczleti helys\xe9g n\xe9lk\xfcli keresked\xe9s",
    airTransport: "L\xe9gi sz\xe1ll\xedt\xe1s",
    travelRelated: "Utaz\xe1ssal kapcsolatos (l\xe9git\xe1rsas\xe1gok, \xfcgyn\xf6k\xf6k, t\xf6megk\xf6zleked\xe9s)",
    railTransport: "Vas\xfati sz\xe1ll\xedt\xe1s",
    waterTransport: "V\xedzi sz\xe1ll\xedt\xe1s",
    truckTransport: "K\xf6z\xfati sz\xe1ll\xedt\xe1s",
    transitTransport: "Tranzit \xe9s f\xf6ldi szem\xe9lysz\xe1ll\xedt\xe1s",
    pipelineTransport: "Cs\u0151vezet\xe9kes sz\xe1ll\xedt\xe1s",
    scenicTransport: "Turisztikai jelleg\u0171 sz\xe1ll\xedt\xe1s",
    supportTransport: "Sz\xe1ll\xedt\xe1st t\xe1mogat\xf3 tev\xe9kenys\xe9gek",
    postalService: "Postai szolg\xe1ltat\xe1s",
    courierMessenger: "Fut\xe1rok",
    shippingDelivery: "Sz\xe1ll\xedt\xe1s",
    warehousingStorage: "Rakz\xe1roz\xe1s \xe9s t\xe1rol\xe1s",
    warehouseDistrib: "Rakz\xe1roz\xe1s/Forgalmaz\xe1s",
    publishingNoInternet: "Kiad\xf3i ipar\xe1gak, az online kiv\xe9tel\xe9vel",
    publishing: "Kiad\xe1s",
    motionPicSoundRecordingIndustries: "Mozg\xf3k\xe9p- \xe9s hangfelv\xe9teli ipar",
    entertainment: "Sz\xf3rakoztat\xe1s (Film, TV, Zene, stb)",
    infoServicesMarketResearch: "Inform\xe1ci\xf3s szolg\xe1ltat\xe1sok/Piackutat\xe1s",
    broadcastingNoInternet: "M\u0171sorsz\xf3r\xe1s, az online kiv\xe9tel\xe9vel",
    telecom: "Telekommunik\xe1ci\xf3",
    tech: "Technol\xf3gia",
    dataProcessingHostingServices: "Adatfeldolgoz\xe1s, t\xe1rhely \xe9s kapcsol\xf3d\xf3 szolg\xe1ltat\xe1sok",
    otherInfoServices: "Egy\xe9b inform\xe1ci\xf3s szolg\xe1ltat\xe1sok",
    financeInsurance: "P\xe9nz\xfcgy \xe9s biztos\xedt\xe1s",
    monetaryAuthorities: "P\xe9nz\xfcgyi hat\xf3s\xe1gok-k\xf6zponti bank",
    creditIntermediation: "Hitelk\xf6zvet\xedt\xe9s \xe9s kapcsol\xf3d\xf3 tev\xe9kenys\xe9gek",
    banking: "Bank",
    securitiesContractsInvestments: "\xc9rt\xe9kpap\xedrok, \xe1ruszerz\u0151d\xe9sek, befektet\xe9sek",
    financialServicesNoBanking: "P\xe9nz\xfcgyi szolg\xe1ltat\xe1sok (bankon k\xedv\xfcli)",
    insuranceCarriersRelated: "Biztos\xedt\xe1si fuvaroz\xf3k \xe9s a kapcsol\xf3d\xf3 tev\xe9kenys\xe9gek",
    insurance: "Biztos\xedt\xe1s",
    fundsTrustsFinancialVehicles: "Alapok, tr\xf6szt\xf6k \xe9s egy\xe9b p\xe9nz\xfcgyi eszk\xf6z\xf6k",
    realEstate: "Ingatlan",
    rentalLeasingServices: "B\xe9rleti \xe9s l\xedzingszolg\xe1ltat\xe1sok",
    automotive: "Aut\xf3ipar",
    consumerGoods: "Fogyaszt\xe1si cikkek",
    lessorsNonfinancialIntangible: "Nem p\xe9nz\xfcgyi immateri\xe1lis javak l\xedzingbead\xf3i",
    professionalTechnicalServices: "Szakmai \xe9s m\u0171szaki szolg\xe1ltat\xe1sok",
    legalServices: "Jogi szolg\xe1ltat\xe1sok",
    accounting: "K\xf6nyvel\xe9s",
    architectureEngineering: "\xc9p\xedt\xe9szet / G\xe9pipar",
    specializedDesignServices: "Speci\xe1lis diz\xe1jn szolg\xe1ltat\xe1sok",
    compRelatedServices: "Sz\xe1m\xedt\xf3g\xe9ppel kapcsolatos szolg\xe1ltat\xe1sok",
    mgmtConsulting: "Vezet\xe9si tan\xe1csad\xe1s",
    scientificResearch: "Tudom\xe1nyos kutat\xe1s",
    adsMarketingPR: "Hirdet\xe9s/Marketing/PR",
    otherProfSciTechServices: "Egy\xe9b szakmai, tudom\xe1nyos \xe9s m\u0171szaki szolg\xe1ltat\xe1sok",
    companyEnterpriseMgmt: "V\xe1llalatok \xe9s v\xe1llalkoz\xe1sok ir\xe1ny\xedt\xe1sa, menedzsmentje",
    adminSupportServices: "Adminisztrat\xedv \xe9s t\xe1mogat\xf3 szolg\xe1ltat\xe1sok",
    employmentAgencyRecruiters: "Munkaer\u0151 foglalkoztat\xe1si \xfcgyn\xf6ks\xe9g/toborz\xf3k",
    securityPrivateInvestigation: "Biztons\xe1g/Mag\xe1n nyomoz\xe1s",
    wasteMgmtRemediationServices: "Hullad\xe9kkezel\xe9si \xe9s k\xe1rmentes\xedt\xe9si szolg\xe1ltat\xe1sok",
    educationServices: "Oktat\xe1si szolg\xe1ltat\xe1sok",
    education: "Oktat\xe1s",
    ambulatoryHealthCareServices: "Ambul\xe1ns eg\xe9szs\xe9g\xfcgyi szolg\xe1ltat\xe1sok",
    healthCareRelated: "Eg\xe9szs\xe9g\xfcgyh\xf6z kapcsol\xf3d\xf3 szolg\xe1ltat\xe1sok",
    hospitals: "K\xf3rh\xe1zak",
    nursingResidentialCareFacilities: "\xc1pol\xe1si \xe9s bentlak\xe1sos gondoz\xe1si int\xe9zm\xe9nyek",
    socialAssistance: "Szoci\xe1lis t\xe1mogat\xe1s",
    performingArtsSpectatorSports: "El\u0151ad\xf3m\u0171v\xe9szet \xe9s l\xe1tv\xe1ny sportok",
    museumsHistoricalSitesZoosParks: "M\xfazeumok, t\xf6rt\xe9nelmi helysz\xednek, \xe1llatkertek \xe9s parkok",
    fineArtsGalleriesMuseums: "K\xe9pz\u0151m\u0171v\xe9szet (gal\xe9ri\xe1k, m\xfazeumok)",
    amusementsGamblingRec: "Sz\xf3rakoztat\xe1s, szerencsej\xe1t\xe9k \xe9s szabadid\u0151s tev\xe9kenys\xe9gek",
    accommodation: "Sz\xe1ll\xe1s",
    foodDrinkingServices: "\xc9lelmiszeri szolg\xe1ltat\xe1sok \xe9s sz\xf3rakoz\xf3helyek",
    restaurantHotel: "\xc9tterem/Hotel",
    repairMaintenance: "Jav\xedt\xe1s \xe9s karbantart\xe1s",
    industrialProductsHeavy: "Ipari term\xe9kek (neh\xe9zipar)",
    personalLaundryServices: "Szem\xe9lyes \xe9s mosodai szolg\xe1ltat\xe1sok",
    membershipAssocOrgs: "Tags\xe1gi egyes\xfcletek \xe9s szervezetek",
    nonprofit: "Non-profit",
    privateHouseholds: "Mag\xe1nh\xe1ztart\xe1sok",
    execLegisGenGvt: "V\xe9grehajt\xf3, t\xf6rv\xe9nyhoz\xf3 \xe9s \xe1llamh\xe1ztart\xe1s",
    gvt: "Korm\xe1ny",
    justicePublicOrderSafetyActivities: "Igazs\xe1gszolg\xe1ltat\xe1si, k\xf6zrendi \xe9s biztons\xe1gi tev\xe9kenys\xe9gek",
    hrAdminPrograms: "Hum\xe1n er\u0151forr\xe1s programok adminisztr\xe1ci\xf3ja",
    environmentAdminPrograms: "K\xf6rnyezetv\xe9delmi programok adminisztr\xe1ci\xf3ja",
    environmental: "K\xf6rnyezeti",
    communityHousingProgramAdmin: "K\xf6z\xf6ss\xe9gi \xe9s lakhat\xe1si programok adminisztr\xe1ci\xf3ja",
    econProgramAdmin: "Gazdas\xe1gi programok igazgat\xe1sa",
    spaceResearchTech: "\u0170rkutat\xe1s \xe9s technol\xf3gia",
    natlSecurityIntlAffairs: "Nemzetbiztons\xe1gi \xe9s nemzetk\xf6zi \xfcgyek"
};


var $381de4ffdc6b46d6$exports = {};
$381de4ffdc6b46d6$exports = {
    // AboutPageHero
    aboutPageHeroImgAlt: "Illusztr\xe1ci\xf3 emberekr\u0151l akik irod\xe1ba k\xf6lt\xf6znek a Spacer a CBRE-t\xf3l R\xf3lunk oldal\xe1n",
    aboutPageHeroTitle: "Mit tehet a Spacer \xe9rted?",
    // AboutPageContent
    aboutPageContentEndSectionTitle: "Kezdhetj\xfck?",
    aboutPageProgramPreviewImgAlt: "Az eredm\xe9nyek oldal el\u0151n\xe9zete a Spacer a CBRE-t\xf3l holnapj\xe1n",
    aboutPageVideoTitle: "Hogyan m\u0171k\xf6dik",
    // About Page Content (aboutPageContent.js)
    aboutPageContent1Title: "Hat\xe1rozd meg a t\xf6k\xe9letes irod\xe1t",
    aboutPageContent1Text: "A t\xf6k\xe9letes irodat\xe9r seg\xedthet a tehets\xe9g\xe9rt folytatott versenyben, a munkav\xe1llal\xf3id eg\xe9szs\xe9g\xe9nek meg\u0151rz\xe9s\xe9ben, az \xfczemeltet\xe9si k\xf6lts\xe9gek cs\xf6kkent\xe9s\xe9ben vagy olyan felt\xe9telek megteremt\xe9s\xe9ben amelyben megsz\xfcletik a k\xf6vetkez\u0151 nagy \xf6tlet. A Spacer a legjobb eszk\xf6z arra, hogy megalapozd az ingatlannal kapcsolatos d\xf6nt\xe9seidet. Seg\xedt prioriz\xe1lni a szervezeti c\xe9ljaidat \xe9s seg\xedt a c\xe9lok ment\xe9n javaslatokat megfogalmazni a sz\xfcks\xe9ges ter\xfclet ir\xe1nt.\nA Spacer l\xe9trehoz\xe1s\xe1ban seg\xedtett a CBRE m\xe9rn\xf6ki csapata, akik t\xf6bb mint 20 \xe9vnyi tapasztalattal a h\xe1tuk m\xf6g\xf6tt sz\xe1mos c\xe9gnek seg\xedtettek a t\xf6k\xe9letes irod\xe1juk megtervez\xe9s\xe9ben.",
    aboutPageContent1ImgAlt: "Illusztr\xe1ci\xf3 besz\xe9l\u0151 emberekr\u0151l a Space a CBRE-t\xf3l R\xf3lunk oldal\xe1n",
    aboutPageSpacerSupportLink: "spacersupport@cbre.com",
    aboutPageContent2Title: "A Spacer k\xf6nnyen haszn\xe1lhat\xf3:",
    aboutPageContent2List1: "Kezd azzal, hogy egy 17 k\xe9rd\xe9ses kv\xedzt t\xf6ltessz ki a szervezeted c\xe9ljair\xf3l \xe9s \xe9rt\xe9keir\u0151l. Ezek a v\xe1laszok hat\xe1rozz\xe1k meg majd a hozz\xe1tok ill\u0151 iroda profilj\xe1t.",
    aboutPageContent2List2: "Juss hozz\xe1 az egy\xe9ni ig\xe9nyeidnek megfelel\u0151 javaslati list\xe1hoz, amely a terek t\xedpus\xe1t \xe9s m\xe9ret\xe9t mutatja.",
    aboutPageContent2List3: "A Floored Plans seg\xedts\xe9g\xe9vel vizualiz\xe1ld az ig\xe9nyeidhez hasonl\xf3 irodatereket 2D-ben vagy 3D-ben.",
    aboutPageContent2List4: "Mentsd el a javaslatokat, hogy felhaszn\xe1lhasd az iroda keres\xe9sed sor\xe1n.",
    aboutPageContent2List5: "Vedd ig\xe9nybe a CBRE szak\xe9rt\u0151inek ingyenes seg\xedts\xe9g\xe9t az irodakeres\xe9sed sor\xe1n!",
    aboutPageContent2Text: "\xcdrj nek\xfcnk az al\xe1bbi e-mail c\xedmre ha tov\xe1bbi k\xe9rd\xe9sed van azzal kapcsolatban, hogy a Spacer hogyan seg\xedthet az irodakeres\xe9sedben:",
    aboutPageContent2ImgAlt: "Illusztr\xe1ci\xf3 egy h\xf6lgyr\u0151l akik egy irodaasztaln\xe1l dolgozik a Spacer a CBRE-t\xf3l R\xf3lunk oldal\xe1n"
};


var $9a8eeca4413eaf45$exports = {};
$9a8eeca4413eaf45$exports = {
    referralStep: "{{step}}. l\xe9p\xe9s a 4-b\u0151l",
    forgotReferralLink: "Elfelejtetted az aj\xe1nl\xf3i linkedet?",
    howReferralLinksWorkTitle: "Hogyan m\u0171k\xf6dnek az aj\xe1nl\xf3i linkek",
    enterYourInformation: "K\xe9rj\xfck add meg a sz\xfcks\xe9ges inform\xe1ci\xf3t",
    confirmYourInformation: "Er\u0151s\xedtsd meg az adataid",
    referralLinkStep1: "Az aj\xe1nl\xf3i link k\xe9sz\xedt\xe9shez sz\xfcks\xe9g\xfcnk lesz:",
    referralLinkReq1: "A nevedre",
    referralLinkReq2: "A CBRE-s email c\xedmedre",
    referralLinkStep2: "Miut\xe1n egy potenci\xe1lis \xfcgyf\xe9l kit\xf6lt\xf6tte a kv\xedzt a hivatkoz\xe1si linked seg\xedts\xe9g\xe9vel, elk\xfcldj\xfck az eredm\xe9nyeik m\xe1solat\xe1t a be\xe9rkez\u0151 leveleid mapp\xe1j\xe1b.",
    next: "K\xf6vetkez\u0151",
    firstName: "Keresztn\xe9v",
    lastName: "Vezet\xe9kn\xe9v",
    emptyNameError: "K\xe9rlek add meg a neved",
    email: "A CBRE-s email c\xedmed",
    emptyEmailError: "K\xe9rlek add meg a CBRE-s email c\xedmed",
    emailTakenError: "Ez az email c\xedm m\xe1r hozz\xe1 lett kapcsolva {{takenLink}}",
    emailExample: "pl: jane.smith@cbre.com",
    editReferralInfo: "N\xe9v \xe9s email c\xedm szerkeszt\xe9se",
    noLaterChanges: "K\xe9s\u0151bb nem fogod tudni ezt m\xf3dos\xedtani.",
    somethingWrong: "Hopp\xe1, valami f\xe9lrement a rendszer\xfcnkben. K\xe9rlek pr\xf3b\xe1ld meg \xfajra.",
    contentLoading: "Bet\xf6lt\xe9s",
    linkReady: "A linked elk\xe9sz\xfclt",
    storeLinkInstructions: "\u0150r\xedzd meg ezt a linket egy biztons\xe1gos helyen, hogy a Spacer-t a saj\xe1t aj\xe1nl\xf3i linkeddel tudd megosztani az \xfcgyfelekkel. Ezt a linket elk\xfcldt\xfck a megadott email c\xedmre is.",
    yourLink: "Az aj\xe1nl\xf3i linked",
    copyLink: "M\xe1sold ki az aj\xe1nl\xf3i linket",
    copiedLink: "V\xe1g\xf3lapra m\xe1solva",
    linkNeverExpires: "Eml\xe9keztet\u0151: ez a link soha nem j\xe1r le",
    linkFound: "Megtal\xe1ltuk a linkedet",
    emailNotAssociated: "Sajnos ehhez az email c\xedmhez nem tal\xe1ltunk megl\xe9v\u0151 aj\xe1nl\xf3i linket",
    createLink: "K\xe9sz\xedten\xe9l egy aj\xe1nl\xf3i linket?"
};


var $b64bc75c35f8c166$exports = {};
$b64bc75c35f8c166$exports = {
    blogHomeTitle: "Iroda Tervez\xe9si Tippek",
    // blog tags
    blogTagAllArticles: "Minden cikk",
    blogTagSizeAndFit: "M\xe9ret \xe9s Megfelel\u0151s\xe9g",
    blogTagOfficeCulture: "Irodai kult\xfara",
    blogTagSpaceAndDesign: "T\xe9r \xe9s Diz\xe1jn",
    blogTagWorkplaceTrends: "Irodaberendez\xe9si trendek"
};


var $532d1625f399479c$exports = {};
$532d1625f399479c$exports = {
    // LandingPageHero
    landingPageHeroTitle: "Een toekomstbestendige hybride werkplek ontwikkelen? Maak een vliegende start met Spacer.",
    landingPageHeroSubtitle: "Binnen een paar minuten breng je de ruimtebehoeften van je organisatie in kaart \u2013\xa0geheel op maat \xe9n kosteloos.",
    landingPageHeroImgAlt: "Voorbeeld van de resultaten van CBRE's Spacer",
    landingPageImage: "/png/homepage-results-page-in-browser-spacer-by-cbre.png",
    // LandingPageContent
    landingPageContentTitle: "Zo werkt Spacer",
    // StepsSummary
    stepsSummarySubtitle1: "Stap 1",
    stepsSummaryTitle1: "Vertel ons over je bedrijf",
    stepsSummaryText1: "Hoe meer we weten over je organisatie, hoe beter onze aanbevelingen bij jullie passen.",
    stepsSummaryImgAlt1: "Illustratie van mensen die op een reusachtige laptop staan op de pagina Home van Spacer by CBRE",
    stepsSummarySubtitle2: "Stap 2",
    stepsSummaryTitle2: "Neem je resultaten goed door",
    stepsSummaryText2: "Op basis van je antwoorden stellen we een ruimteprogramma op: hierin staat precies wat voor kantoorprofiel het beste bij je organisatie, mensen en doelen past.",
    stepsSummaryImgAlt2: "Illustratie van een huizenblok op de pagina Home van Spacer by CBRE",
    stepsSummarySubtitle3: "Stap 3",
    stepsSummaryTitle3: "Ga op zoek naar de beste werkplek",
    stepsSummaryText3: "Of je nu een nieuw kantoor of een effectieve hybride werkplekstrategie nodig hebt: je Spacer-resultaten zijn het ideale vertrekpunt. De deskundige adviseurs van CBRE Workplace helpen je aan een passende oplossing.",
    stepsSummaryImgAlt3: "Illustratie van een jonge vrouw die werkt aan een bureau op de pagina Home van Spacer by CBRE",
    // LandingPageSecondaryHero
    landingPageSecondaryHeroImgAlt: "Illustratie van mensen die ruimteaanbevelingen samenstellen op de pagina Home van Spacer by CBRE",
    landingPageSecondaryHeroTitle: "Laten we beginnen: wat voor sfeer wil je op kantoor?"
};


var $7168839dc5137750$exports = {};
$7168839dc5137750$exports = {
    // Navbar
    spacerLogoAlt: "Spacer by CBRE",
    linkToAboutPageText: "Over",
    linkToBlogPageText: "Inzichten",
    referrals: "Doorverwijzingen",
    // TakeOfficeSpaceQuizButton
    sizeMyOfficeButtonDefaultLinkText: "Beantwoord de vragen over kantoorruimte",
    flooredPlanRequestLinkText: "Een plattegrond aanvragen",
    // Footer
    footerCBRELogoAlt: "CBRE-logo voor Spacer by CBRE",
    footerFacebookIconAlt: "Pictogram Facebook voor Spacer by CBRE",
    footerTwitterIconAlt: "Pictogram Twitter voor Spacer by CBRE",
    footerLinkedinIconAlt: "Pictogram LinkedIn voor Spacer by CBRE",
    footerHeaderQuestionsText: "Vragen?",
    footerHeaderAboutText: "Informatiemateriaal",
    footerHeaderMoreText: "Meer",
    footerHeaderBrokersText: "Voor makelaars",
    footerLinkWhatIsSpacerText: "Over",
    footerLinkBlogText: "Inzichten",
    footerLinkWorkplaceText: "Het team van CBRE Workplace",
    footerLinkTermsText: "Servicevoorwaarden",
    footerLinkPrivacyText: "Privacybeleid",
    footerLinkedinLink: "https://www.linkedin.com/showcase/cbre-workplace-strategy/",
    footerLinkReferralText: "Doorverwijzingen",
    footerWorkplaceLink: "https://www.cbre.nl/diensten/huisvesting-en-locatiekeuze/werkplek-concept-ontwikkelen",
    footerPrivacyLink: "https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy",
    // Contact (contact.js)
    spacerSupportEmail: "spacersupport@cbre.com",
    // ErrorPage
    errorOopsText: "Oeps!",
    error404Text: "We kunnen de gezochte pagina niet vinden.",
    error500Text: "Er is bij ons iets misgegaan.",
    errorText: "Fout",
    errorReturnText: "Terug naar Spacer",
    errorAltText: "Illustratie van een kopje met gemorste koffie voor Spacer by CBRE",
    // Measurement Units (units.js)
    SF: "SF",
    SM: "m2",
    USF: "USF",
    USM: "FNO",
    RSF: "RSF",
    RSM: "VVO",
    NSF: "NSF",
    NSM: "NVM",
    NIA: "NIA",
    foot: "foot",
    feet: "feet",
    footage: "lengte in feet",
    "sqft.": "sqft.",
    meter: "meter",
    meters: "meter",
    "sqm.": "m2",
    Tsubo: "tsubo",
    // SF Types Adjectives (calculator.js)
    Usable: "Bruikbaar",
    Rentable: "Verhuurbaar",
    Net: "Netto",
    // Page Titles (documentDataCopy.js)
    landingPageTitle: "Plan je perfecte kantoor in 15 minuten \u2013 Spacer by CBRE",
    aboutPageTitle: "Ontdek hoe onze meettool voor kantoren werkt \u2013 Spacer by CBRE",
    termsPageTitle: "Servicevoorwaarden \u2013 Spacer by CBRE",
    quizPageTitle: "Meet je kantoor in 15 minuten \u2013 Spacer by CBRE",
    resultsPageTitle: "Bekijk onze kantooraanbevelingen op maat \u2013 Spacer by CBRE",
    profileComparisonPageTitle: "Vergelijk je kantoorbehoeften \u2013 Spacer by CBRE",
    blogHomePageTitle: "Inzichten kantoorplanning \u2013 Spacer by CBRE",
    referralPageTitle: "Doorverwijzingslink voor CBRE-makelaars \u2013 Spacer by CBRE",
    referralRetrievePageTitle: "Doorverwijzingslink voor CBRE-makelaars ophalen \u2013 Spacer by CBRE",
    // Meta Tags (documentDataCopy.js)
    landingPageMetaTagText: "Aan de slag met het perfecte kantoor of een toekomstbestendige hybride werkplekstrategie? Met Spacer van CBRE maak je in nog geen 15 minuten een vliegende start!",
    aboutPageMetaTagText: "Je kantoor is een belangrijke voorwaarde voor talenten werven, kosten besparen en effectief hybride werken. Met Spacer ontdek je hoe jouw ideale kantoor eruitziet \u2013\xa0en hier ontdek je hoe dat werkt.",
    termsPageMetaTagText: "Meer dan tien jaar expertise en ervaring in de branche komen samen in Spacer by CBRE, een service die in een paar minuten deskundige aanbevelingen doet voor de grootte van je kantoor.",
    quizPageMetaTagText: "Beantwoord de vragen van Spacer, dan weet je in 15 minuten hoeveel kantoorruimte je nodig hebt om de doelen en prioriteiten van je onderneming te ondersteunen. Een programma op maat was nog nooit zo snel.",
    resultsPageMetaTagText: "De ruimteadviezen op maat van Spacer besparen je tijd bij het zoeken naar kantoren, want ze vertellen je precies hoeveel kantoorruimte je bedrijf nodig heeft, compleet met voorstellen voor typen meubels en indelingen.",
    profileComparisonPageMetaTagText: "Krijg inzicht in hoe jouw unieke kantoorbehoeften zich verhouden tot die van anderen door Spacer by CBRE te gebruiken",
    blogHomePageMetaTagText: "Berekenen hoeveel kantoorruimte een onderneming nodig heeft is geen exacte wetenschap, maar deze inzichten en informatiematerialen over kantoorplanning zullen zeker helpen. Meer informatie vind je hier.",
    referralPageMetaTagText: "Gebruik deze doorverwijzingslink om Spacer naar klanten te sturen. Je ontvangt dan hun ruimteadviezen rechtstreeks via e-mail. Meer informatie vind je hier.",
    referralRetrieveMetaTagText: "Haal je doorverwijzingslink voor Spacer op.",
    // Form title
    formLabel: "Jouw informatie"
};


var $909bcf1b18c89f14$exports = {};
$909bcf1b18c89f14$exports = {
    // Results
    resultsWarningMessage: "Weet je zeker dat je deze pagina wilt verlaten? Niet opgeslagen gegevens gaan mogelijk verloren.",
    // ResultsHeader
    resultsHeaderExportPDFButtonText: "PDF exporteren",
    resultsHeaderSendButtonText: "Resultaten verzenden",
    resultsHeaderClipboardBoxDescription: "Iedereen met een link kan de resultaten zien en bewerken",
    resultsHeaderContactButtonText: "Kom in contact met een adviseur",
    // EmailWallSection
    emailWallTitle: "Er staat nog meer voor je klaar",
    emailWallSubtitle: "Je volledige werkplekadvies kosteloos ontvangen? Vul hieronder je gegevens in.",
    emailWallFirstNamePlaceholder: "Voornaam",
    emailWallLastNamePlaceholder: "Achternaam",
    emailWallEmailPlaceholder: "Je e-mailadres",
    emailWallCBREEmailPlaceholder: "Je e-mailadres als CBRE-deskundige (optioneel)",
    emailWallLeasingProfessionalPlaceholder: "Je CBRE-verhuurspecialist",
    emailWallConnectMeText: "Ik ontvang graag de resultaten (in pdf) per e-mail.",
    emailWallContactNoticeText: "Het team van Spacer kan contact met je opnemen om je te helpen het programma optimaal te benutten. Geen spam, dat beloven we!",
    emailWallResultsButtonText: "Volledige resultaten bekijken",
    emailWallImgAltText: "Voorbeeld van resultatenpagina ruimteprogramma van de e-mailmuur van Spacer by CBRE",
    emailWallFirstNameInvalid: "Vul je voornaam in.",
    emailWallLastNameInvalid: "Vul je achternaam in.",
    emailWallEmailInvalid: "Vul je mailadres in.",
    // CopyToClipboardBox
    clipboardBoxCopyText: "Kopi\xebren",
    clipboardBoxCopiedText: "Gekopieerd",
    // FormModal
    formModalFindSpaceHeader: "Begin de zoektocht naar je ideale werkplek",
    formModalFindSpaceBody: "Spacer is een snel en gratis hulpmiddel om je ruimtebehoeften in kaart te brengen. Wil je meer advies op maat? De adviseurs van CBRE Workplace helpen je graag. Vul dit formulier in, dan nemen we binnen twee werkdagen contact met je op.",
    formModalFindSpaceSuccessMessage: "Je verzoek is verzonden.",
    // SuccessModal
    successModalTitle: "Gelukt!",
    // ContactForm
    contactFormFirstNameLabel: "Voornaam",
    contactFormLastNameLabel: "Achternaam",
    contactFormEmailLabel: "e-mailadres",
    contactFormPhoneLabel: "Telefoonnummer",
    contactFormMessageLabel: "Vertel meer over wat je precies zoekt",
    contactFormSubmitText: "Versturen",
    // AcceptTermsText
    acceptTermsText: "Ik ga akkoord met de <1>Algemene voorwaarden</1>. Raadpleeg voor meer informatie over het gebruik van je gegevens het <3>Privacybeleid van CBRE</3>.",
    privacyPolicyLink: "https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy",
    // Form
    formErrorText: "Oeps, dat ging niet goed. Probeer het nog eens.",
    formEmailInvalid: "Voer een geldig e-mailadres in.",
    // FormInput
    formInputOptionalText: " (optioneel)",
    // LegalForm
    legalFormCheckboxText: "CBRE mag contact met mij opnemen met aanbiedingen en informatie met betrekking tot mijn gebruik van Spacer.",
    legalFormContactWarningText: "Het team van Spacer kan contact met je opnemen om je te helpen het programma optimaal te benutten. Geen spam, dat beloven we!",
    // NextStepsSection
    nextStepsSectionSubtitle: "Klaar voor de volgende stap?",
    nextStepsSectionTitle: "Zet de zoektocht naar het ideale kantoor voort.",
    nextStepsSectionButtonText: "Kom in contact met een adviseur",
    nextStepsSectionImgAlt: "Illustratie van pratende mensen op de pagina Resultaten van Spacer by CBRE",
    // Profile
    resultsProfileSummaryTitle: "Jouw kantoor",
    resultsProfileTooltipText: "Alle 8 profielen zijn gebaseerd op echte organisaties en werkruimten. We hebben de gegevens vergeleken met brancherichtlijnen en de diepgaande marktkennis van CBRE Workplace.",
    // Program
    programSaveConfirmationBoxText: "Je bent helemaal klaar. We hebben een link naar je resultaten naar je e-mailadres gestuurd. Veel plezier!",
    programExamplePlansTitle: "Voorbeeldplattegronden",
    programExamplePlansSubtitle: "Bekijk de interactieve plattegronden die bij je profiel passen, in 2D \xf3f 3D!",
    programTooMuchTinkerWarning: "Let op: je zit nu buiten de ruimte die bij je profiel past. Overweeg <1>de vragenlijst opnieuw in te vullen</1> of contact op te nemen met de klantenservice via <3>{{email}}</3>.",
    programDisclaimer: "Spacer by CBRE wordt geleverd \u2019zoals het is\u2019 en \u2019op voorwaarde van beschikbaarheid\u2019, zonder garanties. Alle resultaten die worden gegenereerd op basis van je gebruik van Spacer dienen uitsluitend ter illustratie en vormen geen daadwerkelijke ruimteaanbevelingen of voorgestelde huurvoorwaarden. De daadwerkelijke ruimteaanbevelingen kunnen aanzienlijk afwijken en zijn afhankelijk van een groot aantal factoren waarmee Spacer geen rekening houdt. Door Spacer of enig verslag dat wordt gegenereerd door het gebruik van Spacer te gebruiken, ga je akkoord met onze Servicevoorwaarden en ons Privacybeleid, respectievelijk te vinden op https://workplace.cbre.com/termsOfService en https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy. \xc2\xa9 2018 CBRE, Inc. Alle rechten voorbehouden.",
    programMetricsTitle: "Je kantoorprofiel in cijfers",
    programMetricsSubtitle: "Deze getallen geven een overzicht van je werkomgeving",
    programDetailsSectionTitle: "Je ruimteprogramma aanpassen",
    programDetailsSectionSubtitle: "Pas de velden hieronder aan om je ruimtebehoeften te verfijnen.",
    programRevertButtonText: "Ongedaan maken",
    programSaveButtonText: "Wijzigingen opslaan",
    programSavedButtonText: "Opgeslagen",
    // ProgramAssumptions
    programAssumptionsRecommendedOfficeSizeText: "Aanbevolen kantoorgrootte",
    programAssumptionsProfileText: "Profiel",
    programAssumptionsHeadcountText: "Bezetting",
    programAssumptionsHeadcountFollowingText: "mensen",
    programAssumptionsCollabText: "Samenwerking",
    programAssumptionsCirculationText: "Circulatie",
    programAssumptionsAvgDaysText: "Gemiddeld aantal dagen op kantoor",
    programAssumptionsAvgDaysFollowingText: "per week",
    programAssumptionsAvgDaysPerWeekText: "Gemiddeld aantal dagen op kantoor per week",
    // ProgramHeroForPrint
    printNIAText: "Netto binnenoppervlakte",
    printUSFText: "Functioneel Nuttig Oppervlak ",
    printRSFText: "Huurbare vierkante meters",
    printDescText: "Op basis van je gegevens en een {{factorType}} van {{lossFactorPercentage}}% in {{city}}, adviseren we in totaal-",
    printFitFactorText: "pasfactor",
    printLossFactorText: "verliesfactor",
    // BarChart
    barChartIndivSubtitle: "Individuele ruimte",
    barChartGroupSubtitle: "Groepsruimte",
    barChartAmenitySubtitle: "Voorzieningenruimte",
    // TabbedProgramBarChart
    tabbedBarChartMeSubtitle: "Individueel",
    tabbedBarChartGroupSubtitle: "Groep",
    tabbedBarChartAmenitySubtitle: "Voorzieningen",
    // SpaceCategoryBreakdown
    spaceCatBreakdownSubtitle: "Selecteer een ruimte om aan te passen",
    // SpaceCategoryBreakdownMobile
    spaceCatBreakdownMobileMeTitle: "Individuele ruimte",
    spaceCatBreakdownMobileWeTitle: "Groepsruimte",
    spaceCatBreakdownMobileAmenityTitle: "Voorzieningenruimte",
    spaceCatBreakdownMobileMeSubtitle: "om alleen te werken",
    spaceCatBreakdownMobileWeSubtitle: "om samen te werken",
    spaceCatBreakdownMobileAmenitySubtitle: "voor al het andere",
    spaceCatBreakdownMobileNIATotalTitle: "Totale netto binnenoppervlakte",
    spaceCatBreakdownMobileTotalTitle: "Totaal {{sfType}} vierkante {{unitCapitalized}}",
    spaceCatBreakdownMobileCirculationText: "Circulatie",
    // SpaceCategoryDropdown
    spaceCatDropdownMeText: "Individuele ruimte",
    spaceCatDropdownWeText: "Groepsruimte",
    spaceCatDropdownAmenityText: "Voorzieningenruimte",
    // SidebarInfo
    sidebarInfoMeTitle: "Individueel",
    sidebarInfoWeTitle: "Groep",
    sidebarInfoAmenityTitle: "Voorzieningen",
    // Space Category Descriptions (spaceCategoryDescription.js)
    spaceCatMeDesc: "Ruimte voor individueel werk. Als je je medewerkers de keuze geeft waar en hoe ze werken, leidt dat tot meer tevredenheid.",
    spaceCatWeDesc: "Ruimte voor samenwerking en teamvorming. In een tijd waarin werken overal kan, is het belangrijk om verschillende ruimten aan te bieden die passen bij uiteenlopende taken.",
    spaceCatAmenityDesc: "Ruimte die het werk ondersteunt. Goede voorzieningen maken je kantoor tot een plek waar (toekomstige) werknemers graag hun tijd doorbrengen.",
    // Suggested Custom Amenities (suggestedCustomAmenityUnitMap.js)
    audioVisualCustom: "Audio / Visueel",
    dataCenterCustom: "Datacenter",
    buildingSupportCustom: "Ondersteuningsdiensten",
    foodServiceCustom: "restaurant",
    kitchenCustom: "Keuken",
    serveryCustom: "Buffet",
    execDiningCustom: "Directie-eetruimte",
    grabNGoCustom: "Snelle snacks",
    juiceCoffeeBarCustom: "pantry",
    childCareCustom: "Kinderopvang",
    fitnessCenterCustom: "Fitnesscentrum",
    healthCenterCustom: "EHBO-ruimte",
    mailCenterCustom: "Postkamer",
    commercialPrintCustom: "Commerci\xeble printvoorziening",
    centralCafeCustom: "cafe",
    securityCtrlCustom: "Bewakingsruimte",
    auditoriumCustom: "auditorium",
    dryCleaningLaundryCustom: "Stomerij/wasserij",
    confCenterCustom: "Congrescentrum",
    multiPurpTrainingCustom: "Multifunctionele ruimte/cursusruimte",
    informalCollabCustom: "Informele samenwerking",
    touchdownTeamCustom: "aanlandtafel",
    // Suggested Custom Amenity Units (spaceUnit.js)
    seats: "zitplaats",
    seats_plural: "zitplaatsen",
    rooms: "ruimte",
    rooms_plural: "kamers",
    areas: "ruimte",
    areas_plural: "ruimten",
    units: "eenheid",
    units_plural: "eenheden",
    // Predefined Amenities (spaceUnitMap.js) - Shared Space Units
    focusRoomDefined: "Focusruimte",
    fileRoomDefined: "Archiefruimte",
    centralReceptionHubDefined: "Centrale receptie",
    smOfficeDefined: "Klein kantoor",
    regOfficeDefined: "Normaal kantoor",
    benchDesk5Defined: "Open Werkplek",
    benchDesk6Defined: "Open Werkplek",
    meetingRoom4Defined: "Vergaderruimte (4 personen)",
    meetingRoom6Defined: "Vergaderruimte (6 personen)",
    meetingRoom8Defined: "Vergaderruimte (8 personen)",
    meetingRoom12Defined: "Vergaderruimte (12 personen)",
    meetingRoom15Defined: "Vergaderruimte (15 personen)",
    semiEnclosedMeetingBooth4Defined: "Half open informeel overleg (4 personen)",
    openCollabSpace4to6Defined: "Open samenwerkingsruimte (4-6 mensen)",
    contemplationSpaceDefined: "Bezinningsruimte",
    mainITEquipRoomDefined: "Hoofdserverruimte(MER) ",
    receptionAreaDefined: "Receptie",
    cafeFoodServiceDefined: "Restaurant/cafe",
    teamStorageDefined: "Opslagruimte team",
    coatClosetsDefined: "Garderobe",
    genStorageDefined: "Algemene opslagruimte (voorraden en goederen in/uit)",
    centralisedCopyPrintMailDefined: "Gecentraliseerde kopieer-, print- en postfaciliteiten",
    specialResourceAreaDefined: "Speciale bergruimte",
    personalStorageDefined: "Persoonlijke bergruimte (kluisjes)",
    storageITSpaceDefined: "Bergruimte IT",
    secondaryServerRoomDefined: "Secundaire server-/telecomruimte",
    mothersRoomDefined: "Kolfruimte",
    buildITSpaceDefined: "Installatieruimte IT(SER) ",
    workerCouncilOffice2Defined: "Werkoverlegruimte (2 personen)",
    securityCtrlRoomDefined: "Bewakingsruimte",
    centralisedMailDefined: "Gecentraliseerde postruimte",
    visitorCoatLuggageRoomDefined: "Bezoekersgarderobe",
    wellnessRoomDefined: "Welzijnsruimte",
    internalStairDefined: "Interne trap",
    commercialPrintRoomDefined: "Commerci\xeble printvoorziening",
    buildingSupportServicesAreaDefined: "Gebied voor ondersteuningsdiensten",
    // Predefined Amenities (spaceUnitMap.js) - US_SMALL and US_REGULAR
    officeDefined: "Kantoor",
    lgOfficeDefined: "Kantoor (groot)",
    smWorkstationDefined: "Werkstation (klein)",
    mdWorkstationDefined: "Werkstation (gemiddeld)",
    lgWorkstationDefined: "Werkstation (groot)",
    huddleRoomDefined: "Huddle room",
    dispersedCopyPrintAreaDefined: "Verspreid kopieer-/printgebied",
    smMeetingRoomDefined: "Kleine vergaderruimte",
    mdMeetingRoomDefined: "Middelgrote vergaderruimte",
    lgMeetingRoomDefined: "Grote vergaderruimte",
    xlMeetingRoomDefined: "Extra grote vergaderruimte/directiekamer",
    multiPurpTrainingDefined: "Multifunctionele ruimte/cursusruimte",
    informalCollabDefined: "Informele samenwerkingsruimte",
    touchdownTeamDefined: "Touchdown-/teamruimte",
    pantryVendingCoffeeAreaDefined: "Pantry/automaten",
    workplaceStorageRoomDefined: "Bergruimte werkplekken",
    employeeCoatAreaDefined: "Personeelsgarderobe",
    dispersedMailAreaDefined: "Verspreid postgebied",
    lockerUnitDefined: "Kluisjes",
    serverRoomDefined: "Serverruimte",
    frontDeskAreaDefined: "Gebied ontvangstbalie",
    centralCafeAreaDefined: "Gebied centrale koffiehoek",
    mailCenterAreaDefined: "Postkamergebied",
    kitchenAreaDefined: "Keukengebied",
    drawerLateralFileUnitDefined: "Dossierkast met drie laden",
    serveryAreaDefined: "Buffetruimte",
    juiceBarCoffeeShopAreaDefined: "Gebied sapbar/koffiebar",
    diningSupportAreaDefined: "Ondersteuningsruimte kantine",
    diningAreaDefined: "Kantine",
    grabNGoAreaDefined: "Gebied snelle snacks",
    focusRoomSharedFocus: "Focusruimte",
    // Predefined Amenities (spaceUnitMap.js) - UK_REGULAR
    fullFoodServiceDefined: "Volledige maaltijdservice",
    // Predefined Amenities (spaceUnitMap.js) - APAC_REGULAR
    officeWorkMeetDefined: "Kantoor (werken/vergaderen)",
    lgOfficeWorkMeetDefined: "Groot kantoor (werken/vergaderen)",
    focusDefined: "Focus",
    bench1pt6Defined: "1.6 bench",
    bench1pt8Defined: "1.8 bench",
    bench1pt8LDefined: "1.8 werkstation \u2018L\u2019",
    banquetWorkMeetDefined: "Muurbank - werken/vergaderen (2 p)",
    cafeTable4Defined: "Caf\xe9tafel (4 p)",
    kitchenTable8to10Defined: "Keukentafel (8-10 p)",
    standingWhiteboardDefined: "Staand whiteboard",
    huddleRoom3Defined: "Huddle room (3 p)",
    smMeetingRoom5Defined: "Vergaderruimte S (5 p)",
    mdMeetingRoom8Defined: "Vergaderruimte M (8 p)",
    lgMeetingRoom20Defined: "Vergaderruimte L (20 p)",
    xlBoardroom: "Extra groot/directiekamer",
    wellnessRoomsDefined: "Welzijnsruimten",
    employeeCoatsGymLockersDefined: "Personeelsgarderobe/sportkluisjes",
    lockersDefined: "Kluisjes",
    dispersedCopyPrintScanAreaDefined: "Verspreid kopieer-/print-/scangebied",
    hydrationPointDefined: "Hydratatiepunt (water/thee/koffie)",
    centralHighDensityStorageDefined: "Centrale opslag hoge dichtheid",
    wellnessMothersRoomDefined: "Welzijnsruimte",
    serverHubRoomsDefined: "Server-/hubruimten",
    buildITStoreRoomDefined: "Opberg- en installatieruimte IT",
    simpleReceptionWaitDefined: "Eenvoudige receptie + wachtruimte",
    centralCafeSocialHubDefined: "Centrale koffie- en ontmoetingsplek",
    mailCentreDefined: "Postkamer",
    utilityStoreRoomDefined: "Bergruimte voorzieningen",
    drawerLateralFileDefined: "Dossierkast met drie laden",
    juiceBarCoffeeShopDefined: "Sapbar/koffiehoek",
    buildingSupportServicesDefined: "Ondersteuningsdiensten",
    // Space Unit Map Descriptions (spaceUnitMap.js) - Shared Descriptions
    focusRoomDesc: "Focusruimten zijn afgesloten ruimten die bedoeld zijn voor geconcentreerd en/of vertrouwelijk werk, meestal door \xe9\xe9n of twee personen. Akoestische privacy is essentieel in zulke ruimten. Focusruimten zijn doorgaans niet aan iemand toegewezen en kunnen tijdelijk worden geboekt als dat nodig is voor relevante werkzaamheden.",
    fileRoomDesc: "Dit is een bergruimte voor papieren archieven voor individuen en teams. Als gevolg van de digitaliseringsinspanningen neemt bij de meeste kantoren de vraag naar individuele en teambergruimte sterk af. Toch hebben sommige bedrijven behoefte aan een centrale ruimte voor wettelijk vereiste documenten of materialen voor langlopende projecten. Deze ruimte is vooral nuttig omdat de meeste open werkplekken weinig bergruimte hebben.",
    centralReceptionHubDesc: "Het receptiegebied is belangrijk voor de eerste indruk die werknemers, klanten en andere bezoekers van je bedrijf krijgen. Het moet het merk van het bedrijf op een consistente manier presenteren en de gewenste uitstraling hebben. De balie van de bewaker moet comfortabel zijn; zachte zitplaatsen moeten uitnodigend zijn voor bezoekers.",
    officeDesc: "Kantoren zijn afgesloten Individuele Werkplekken voor medewerkers. Ze zijn heel geschikt om afleiding te beperken en geconcentreerd te kunnen werken. Kantoren zijn doorgaans voorzien van een bureau met bureaustoel en bezoekersstoelen. De hoeveelheid persoonlijke bergruimte en archiefkastruimte in kantoren varieert. De grootte van de ruimte kan ook vari\xebren afhankelijk van de activiteiten die in de ruimte plaatsvinden (bijv. regelmatige vergaderingen) of de status/hi\xebrarchie van de medewerker.",
    benchDeskDesc: "Benches zijn open individuele werkplekken. Kleinere benches kunnen tijdelijk (in een ruimte zonder eigen werkplekken) of permanent door fulltimemedewerkers worden gebruikt. Deze werkplekken zijn ook heel geschikt voor bezoekende werknemers of ingehuurde krachten die niet vast op kantoor werken. Enkele voordelen van open benches zijn de zichtbaarheid in het kantoor en de samenwerking die daarbij hoort. Een nadeel kan de afleiding door geluiden zijn. Daarom wordt aangeraden in kantoren met open benches voldoende focusruimten en huddle rooms te cre\xebren. De hoeveelheid bergruimte voor documenten op de werkplek is beperkt omdat er op de verdieping waarschijnlijk gemeenschappelijke bergruimte is.",
    meetingRoomDesc: "Vergaderruimten zijn afgesloten ruimten bedoeld voor vergaderingen van kleine groepjes van 2-4 personen. Ze moeten voorzien zijn van audio- en videoapparatuur en whiteboards om kennisoverdracht te ondersteunen en ze moeten akoestische privacy bieden: mensen die direct buiten de kamer zitten, mogen niet horen wat er binnen wordt gezegd.",
    meetingRoomDesc6: "Vergaderruimten zijn afgesloten ruimten bedoeld voor vergaderingen van kleine groepjes van 6 personen. Ze moeten voorzien zijn van audio- en videoapparatuur en whiteboards om kennisoverdracht te ondersteunen en ze moeten akoestische privacy bieden (d.w.z. mensen die direct buiten de kamer zitten mogen niet horen wat er in de kamer wordt gezegd).",
    meetingRoomDesc8: "Vergaderruimten zijn afgesloten ruimten bedoeld voor vergaderingen van kleine groepjes van 8 personen. Ze moeten voorzien zijn van audio- en videoapparatuur en whiteboards om kennisoverdracht te ondersteunen en ze moeten akoestische privacy bieden (d.w.z. mensen die direct buiten de kamer zitten mogen niet horen wat er in de kamer wordt gezegd).",
    meetingRoomDesc12: "Vergaderruimten zijn afgesloten ruimten bedoeld voor vergaderingen van kleine groepjes van 12 personen. Ze moeten voorzien zijn van audio- en videoapparatuur en whiteboards om kennisoverdracht te ondersteunen en ze moeten akoestische privacy bieden (d.w.z. mensen die direct buiten de kamer zitten mogen niet horen wat er in de kamer wordt gezegd).",
    meetingRoomDesc15: "Vergaderruimten zijn afgesloten ruimten bedoeld voor vergaderingen van kleine groepjes van 15 personen. Ze moeten voorzien zijn van audio- en videoapparatuur en whiteboards om kennisoverdracht te ondersteunen en ze moeten akoestische privacy bieden (d.w.z. mensen die direct buiten de kamer zitten mogen niet horen wat er in de kamer wordt gezegd).",
    openCollabSpace4to6Desc: "Deze ruimten zijn bestemd voor gezamenlijke activiteiten van kleine groepen (4-6 personen), zoals brainstormen en informele gesprekken met collega's en klanten.",
    cafeFoodServiceDesc: "De centrale koffiehoek is bedoeld als een plek om te eten, elkaar te ontmoeten, individueel te werken en kleine besprekingen te houden. Voor de inrichting van deze ruimte moet worden gedacht aan functionele eettafels en een kleurpalet dat past bij het merk.",
    coatClosetsDesc: "Werknemers hebben een plek nodig om hun jas op te hangen en andere grote spullen op te bergen, vooral als een kantoor een open indeling heeft met beperkte persoonlijke bergruimte bij de werkplek. Deze kunnen verspreid door het kantoor worden gecre\xeberd, bijvoorbeeld bij uitgangen en in de hoofdgangen. Er is meestal een plank boven het hanggedeelte voor hoeden en andere accessoires en bergruimte voor koffers onder in de kast.",
    copyPrintDesc: "Kopieer- en printgebieden verspreid over verdiepingen met open werkruimten geven werknemers snel toegang tot multifunctionele apparaten. Kopieer- en printgebieden moeten altijd worden voorzien van papierbakken voor recycling en kleine kasten om extra papier en voorraden op te bergen. Deze ruimten zijn uitsluitend bedoeld om binnen te lopen als dat nodig is, niet als ontmoetings- of werkplek.",
    specialResourceBuildingSupportAreaDesc: "Dit is een verzamelnaam voor aanvullende ondersteuningsruimten die in een kantoor aanwezig kunnen zijn. Voorbeelden hiervan zijn een beveiligingsbalie of een ruimte met bepaalde voorzieningen. Dit varieert per organisatie, maar naarmate het kantoor groter wordt, zullen vaker dit soort aanvullende ruimten nodig zijn.",
    secondaryServerRoomDesc: "Secundaire serverruimte (technologieruimte) waar IT-apparatuur veilig is opgesteld en waar laagspanningskabels uitkomen. De ruimte moet 24 uur per dag worden geventileerd en op een constante temperatuur van 22\xa0\xb0C worden gehouden, met een relatieve luchtvochtigheid van 50%.",
    mothersRoomDesc: "Kolfruimtes zijn bedoeld voor individuele momenten met absolute privacy, voor moeders die borstvoeding geven. Kolfruimtes zijn meestal verplicht voor alle nieuwe kantoren, ongeacht de grootte of het aantal mensen dat er werkt.",
    visitorCoatLuggageRoomDesc: "Bezoekers hebben een plek nodig om hun jas op te hangen en andere grote spullen op te bergen. Deze kunnen verspreid door het kantoor worden gecre\xeberd, bijvoorbeeld bij uitgangen en in de hoofdgangen. Er is meestal een plank boven het hanggedeelte voor hoeden en andere accessoires en bergruimte voor koffers onder in de kast.",
    wellnessRoomDesc: "Welzijnsruimten zijn bedoeld voor individuele momenten met absolute privacy, voor mensen die een korte adempauze nodig hebben. ",
    internalStairDesc: "Interne trappen kunnen centrale trappenhuizen zijn die toegang geven tot de verschillende verdiepingen, of aanvullende designelementen die de verdiepingen van een kantoor met elkaar verbinden. Het zijn vaak verzamelplekken binnen het kantoor en kunnen worden gecentraliseerd voor de koffiehoek, receptie of vergaderruimten.",
    commercialPrintRoomDesc: "Veel bedrijven bieden mogelijkheden om intern presentaties af te drukken en in te binden en te bundelen in de printruimte, die vaak wordt gecombineerd met de postkamer. Er staan meerdere printers, waaronder mogelijk grootformaatprinters. Er is opbergruimte aanwezig voor voorraden en een werkblad voor kleinere apparatuur, maar ook ruimte om het drukwerk uit te spreiden.",
    pantryVendingCoffeeDesc: "In tegenstelling tot de centrale koffiehoek is de pantry/automatenruimte bedoeld voor medewerkers die snel even iets te eten of te drinken willen pakken. Op plekken waar eten is, wordt meestal ook gepraat, maar er is doorgaans geen zitgelegenheid in deze ruimten, dus mensen zullen binnenkomen, snel weer weggaan en niet lang blijven praten.",
    storageDesc: "Opslagruimten zijn bedoeld voor het opbergen van allerlei spullen, zoals grote apparatuur, extra meubels, bulkvoorraden, feestversiering e.d. Ze kunnen ook worden gebruikt om jassen en tassen van bezoekers op te bergen. Het is handig om een kleine opbergruimte in de buurt van de huismeester te hebben.",
    centralisedDispersedMailAreaDesc: "Grotere bedrijven hebben een postkamer nodig om de binnenkomende en uitgaande post te organiseren. In deze ruimte is speciale apparatuur voor postverwerking aanwezig. Er zijn ook oppervlakken voor het sorteren van papier en andere materialen. Meestal is hier \xe9\xe9n medewerker fulltime werkzaam.",
    lockerDesc: "Kluisjes worden aangeboden als een vorm van persoonlijke opbergruimte. Ze geven medewerkers een plek om hun kostbaarheden, persoonlijke eigendommen en werkdocumenten te bewaren. Kluisjes kunnen vast worden toegewezen of worden gebruikt op basis van 'wie het eerst komt, het eerst maalt'.",
    mainITandServerRoomDesc: "Primaire serverruimte (technologieruimte) waar IT-apparatuur veilig is opgesteld en waar laagspanningskabels uitkomen. De ruimte moet 24 uur per dag worden geventileerd en op een constante temperatuur van 22\xa0\xb0C worden gehouden, met een relatieve luchtvochtigheid van 50%.",
    drawerLateralFileDesc: "Persoonlijke individuele bergruimte bij werkplekken of in kantoren. Meestal gebruikt voor persoonlijke spullen of materialen van het project waaraan wordt gewerkt.",
    juiceBarCoffeeShopDesc: "Niet elk bedrijf heeft een volledige keuken en een buffet, maar er kan een koffiehoek of sapbar worden aangeboden als onderdeel van de eet- en drinkvoorzieningen in de ruimte. Zo\u2019n ruimte kan ook een aanvulling zijn op de hoofdkantine, vooral als het kantoor groot is. Deze ruimte ziet er waarschijnlijk uit zoals een filiaal van Starbucks, met werkruimte voor een medewerker achter een toonbank.",
    grabNGoDesc: "Een kleine gemaksruimte met een aantal koelkasten, planken voor chips en snacks en een betaalautomaat. Deze ruimten zijn meestal voorzien van camerabewaking. Ze worden vaak gecombineerd met een kleine pantry met koelkasten, vriezers en een aanrecht.",
    smMeetingConferenceRoomDesc: "Een kleine overlegruimte is een afgesloten ruimte waar 2-6 mensen comfortabel aan een tafel kunnen zitten. Deze ruimten kunnen zowel voor intern overleg als voor gesprekken met klanten worden gebruikt en moeten daarom zeer gebruiksvriendelijk zijn, met eenvoudige toegang tot stopcontacten en audio- en videoapparatuur.",
    mdMeetingConferenceRoomDesc: "Een middelgrote overlegruimte is een afgesloten ruimte waar 6-10 mensen comfortabel aan een tafel kunnen zitten. Deze ruimten worden zowel voor intern overleg als voor gesprekken met klanten gebruikt en moeten daarom zeer gebruiksvriendelijk zijn, met eenvoudige toegang tot stopcontacten en audio- en videoapparatuur.",
    lgMeetingConferenceRoomDesc: "Een grote overlegruimte is een afgesloten ruimte waar 12-14 mensen comfortabel aan een tafel kunnen zitten. Extra stoelen langs de wanden zijn aan te bevelen. Deze ruimten kunnen zowel voor intern overleg als voor gesprekken met klanten worden gebruikt en zullen waarschijnlijk worden gebruikt voor presentaties. De meubels moeten verplaatsbaar zijn om de ruimte ook voor andere doeleinden te kunnen gebruiken, zoals yogasessies voor werknemers.",
    xlMeetingRoomDesc: "Een bestuurskamer is een ruimte waar 14-18 mensen comfortabel aan een tafel kunnen zitten, met extra stoelen langs de wanden voor minstens nog 10 mensen. Deze ruimten worden waarschijnlijk gebruikt voor grote interne formele vergaderingen en grote besprekingen met klanten. Ze moeten daarom voorzien zijn van hoogwaardige audio- en videotechnologie en worden ingericht met de klant in gedachten.",
    // Space Unit Map Descriptions (spaceUnitMap.js) - US_SMALL and US_REGULAR
    lgOfficeDesc: "Kantoren zijn afgesloten individuele werkplekken voor medewerkers. Ze zijn heel geschikt om afleiding te beperken en geconcentreerd te kunnen werken. Kantoren zijn doorgaans voorzien van een bureau met bureaustoel en bezoekersstoelen. De hoeveelheid persoonlijke bergruimte en archiefkastruimte in kantoren varieert. De grootte van de ruimte kan ook vari\xebren, afhankelijk van de activiteiten die in de ruimte plaatsvinden (bijv. regelmatige vergaderingen) of de status/hi\xebrarchie van de medewerker. Dit wat grotere kantoor kan het kantoor van een partner zijn of dienstdoen als huddle room.",
    smWorkstationDesc: "Werkstations zijn open individuele werkplekken. Kleinere werkstations kunnen tijdelijk (in een ruimte zonder eigen werkplekken) of permanent door fulltimemedewerkers worden gebruikt. Deze werkplekken zijn ook heel geschikt voor bezoekende werknemers of ingehuurde krachten die niet vast op kantoor werken. Enkele voordelen van open werkstations zijn de zichtbaarheid in het kantoor en de samenwerking die daarbij hoort. Een nadeel kan de afleiding door geluiden zijn. Daarom wordt aangeraden in kantoren met open werkstations voldoende focusruimten en huddle rooms te cre\xebren. De hoeveelheid bergruimte voor documenten op de werkplek is beperkt omdat er op de verdieping waarschijnlijk gemeenschappelijke bergruimte is.",
    mdWorkstationDesc: "Werkstations zijn open individuele werkplekken. De voordelen van deze wat grotere ruimte zijn onder meer extra bergruimte en privacy. Meestal geldt: hoe groter het bureau, hoe waarschijnlijker het is dat het vast aan iemand is toegewezen en niet voor algemeen gebruik is. Enkele voordelen van open werkstations zijn de zichtbaarheid in het kantoor en de samenwerking die daarbij hoort. Een nadeel kan de afleiding door geluiden zijn. Daarom wordt aangeraden in kantoren met open werkstations voldoende focusruimten en huddle rooms te cre\xebren. Op de verdieping zullen waarschijnlijk aanvullende gezamenlijke bergruimten en archiefkasten zijn.",
    lgWorkstationDesc: "Werkstations zijn open individuele werkplekken. De voordelen van deze wat grotere ruimte zijn onder meer extra bergruimte en privacy. Bureaus van dit formaat zijn meestal aan iemand toegewezen en niet voor algemeen gebruik. Enkele voordelen van open werkstations zijn de zichtbaarheid in het kantoor en de samenwerking die daarbij hoort. Een nadeel kan de afleiding door geluiden zijn. Daarom wordt aangeraden in kantoren met open werkstations voldoende focusruimten en huddle rooms te cre\xebren. Op de verdieping zullen waarschijnlijk aanvullende gezamenlijke bergruimten en archiefkasten zijn.",
    huddleRoomDesc: "Huddle rooms zijn afgesloten ruimten bedoeld voor vergaderingen van kleine groepjes van 2-4 personen. Ze moeten voorzien zijn van audio- en videoapparatuur en whiteboards om kennisoverdracht te ondersteunen en ze moeten akoestische privacy bieden: mensen die direct buiten de kamer zitten, mogen niet horen wat er binnen wordt gezegd.",
    multiPurpTrainingDesc: "Multifunctionele ruimten zijn bedoeld om plaats te bieden aan een groot aantal mensen (meer dan 20). De benaming van deze ruimte is passend, aangezien hier veel verschillende activiteiten kunnen plaatsvinden, waaronder workshops, bedrijfsevenementen en grote presentaties. De afwerking van deze ruimte is functioneel/duurzaam, want er komen veel mensen, maar er kunnen ook klanten worden ontvangen. Deze ruimte moet passende audio- en videofaciliteiten hebben \u2013 doorgaans veel meer dan de gemiddelde overlegruimte.",
    informalCollabDesc: "Deze ruimten zijn bestemd voor gezamenlijke activiteiten van kleine groepen (4-6 personen), zoals brainstormen en informele gesprekken tussen collega\u2019s en met klanten.",
    touchdownTeamDesc: "Touchdowns zijn individuele werkplekken of kleine interne teamwerkplekken die verspreid zijn door het kantoor en door medewerkers en bezoekers kunnen worden gebruikt. Touchdowns kunnen verschillende hoogtes, vormen en maten hebben, maar ze onderscheiden zich van individuele werkstations als unieke plekken om gedurende korte tijd te werken. Deze ruimten moeten plug-and-play zijn.",
    frontDeskAreaDesc: "Dit is het eerste wat werknemers en bezoekers zien als ze het kantoor binnenkomen. De balie moet plaats bieden aan ten minste \xe9\xe9n persoon met persoonlijke werkruimte en opbergruimte. Waarschijnlijk is er ook opbergruimte voor bezoekers in de buurt. De ontvangstbalie bevindt zich in het grotere receptiegebied waar waarschijnlijk ook zitplaatsen en andere voorzieningen zijn.",
    mailCenterAreaDesc: "Grotere organisaties hebben een postkamer nodig om alle postdiensten te centraliseren. Hier moet veel ruimte zijn om te sorteren en daarnaast ruimte voor tabellen en apparatuur. Deze ruimte ziet er waarschijnlijk bij elke organisatie anders uit, want hij wordt vaak ingepast tussen andere elementen.",
    kitchenAreaDesc: "Als er in het kantoor een kantine aanwezig is, is er een keuken nodig om deze te ondersteunen. De vereisten voor zo\u2019n keuken vari\xebren per organisatie, maar er zullen in elk geval keukenapparaten en koelkasten zijn. Er is ook bergruimte nodig voor houdbare producten en kookgerei. De keuken wordt aangrenzend aan het restaurant en waarschijnlijk de overlegruimten/ruimten voor klantenontvangst gesitueerd.",
    serveryAreaDesc: "Het buffet is de plek waar de mensen hun eten halen. Het is waarschijnlijk verbonden met de keuken en een eetruimte met tafels en stoelen. Bij de plaatsing van het buffet moet goed rekening worden gehouden met rijen en looproutes. De vorm en grootte van deze ruimte varieert waarschijnlijk per organisatie.",
    diningSupportAreaDesc: "Een organisatie met een uitgebreide kantine heeft waarschijnlijk ook aanvullende ruimten zoals opslag in andere delen van het gebouw, waarmee rekening moet worden gehouden bij de algehele planning. De ruimte varieert per organisatie.",
    diningAreaDesc: "Een eetruimte bij de keuken moet mensen verschillende opties bieden om te gaan zitten en hun lunch te eten. Als er verschillende soorten stoelen zijn, maakt dat de ruimte ook geschikt om buiten de lunchtijden om te worden gebruikt voor vergaderingen en samenwerking. Als er harde en zachte stoelen van verschillende hoogtes worden aangeboden, kunnen de gebruikers kiezen.",
    // Space Unit Map Descriptions (spaceUnitMap.js) - UK_REGULAR
    fullFoodServiceDesc: "Als er een kantine aanwezig is in het kantoor, zijn er diverse functies nodig om deze faciliteit te ondersteunen, waaronder een keuken, buffet, eetruimte (met tafels en stoelen) en ondersteunende ruimte (opslag). De keuken en het buffet werken samen voor het bereiden en serveren van huisgemaakte etenswaren. De kantine is de plek waar werknemers en gasten kunnen eten, maar vaak is dit ook een ontmoetingsplek voor sociale contacten en samenwerking. Net als thuis is er veel keukengerei en opslagruimte nodig om maaltijden te kunnen aanbieden en daarom bevat het ruimtetype Volledige maaltijdservice ook ondersteunende ruimte.",
    // SpaceUnitRow
    spaceUnitRowDeleteTitle: "Ruimtetype verwijderen",
    spaceUnitRowDeleteText: "Weet je zeker dat je dit ruimtetype wilt verwijderen?",
    spaceUnitRowConfirmDeleteText: "Ja, ik weet het zeker",
    spaceUnitRowCancelDeleteText: "Nee, ik wil het ruimtetype toch houden",
    // CustomAmenityAdder
    customAmenityAddText: "Een faciliteit toevoegen",
    customAmenityPlaceholder: "Type faciliteit",
    // SpaceUnitTotals
    spaceUnitTotalsTitleNIA: "Totale netto binnenoppervlakte",
    spaceUnitTotalsTitle: "Totaal {{sfTypeAdj}} vierkante {{unitCapitalized}}",
    spaceUnitTotalsCirculation: "Circulatie",
    spaceUnitTotalsCirculationTooltip: "De ruimte tussen ruimten: denk aan gangen, de ruimte achter je stoel en de ruimte rondom kasten, deuren en hoeken. Zonder deze ruimte kun je nergens lopen. Beslaat meestal ongeveer 35% van het totale aantal bruikbare {{unitCapitalized}} in je programma, maar dat varieert afhankelijk van je profiel en het uiteindelijk gekozen gebouw.",
    spaceUnitTotalsREBNY: "REBNY-factor",
    spaceUnitTotalsNYCText: "New York City ",
    spaceUnitTotalsREBNYTooltip: "Voor programma\u2019s in New York City verhogen we {{sfType}} met 15% om rekening te houden met de meetnorm REBNY. Ruimten die worden gemeten volgens de REBNY-norm omvatten onder andere toiletten, liftlobby\u2019s en de dikte van de buitenmuren.",
    spaceUnitTotalsLossFactor: "Verliesfactor ",
    spaceUnitTotalsLossFactorTooltip: "De bruikbare vierkante {{unit}} geven aan hoeveel ruimte je in je kantoor hebt. De verhuurbare vierkante {{unit}} zijn de ruimte waarvoor je betaalt, inclusief eventuele pilaren, lobby\u2019s en andere gebruikelijke gedeelten. Het verschil tussen bruikbaar en verhuurbaar noemen we de verliesfactor en hoe die wordt berekent, varieert per locatie.",
    // CollaborationDropdown
    collabDropdownLevelLowText: "een beetje (0-25%)",
    collabDropdownLevelMedText: "een deel (26-50%)",
    collabDropdownLevelHighText: "het meeste (51-100%)",
    //DensityDropdown
    sameDensityText: "Dezelfde dichtheid als v\xf3\xf3r corona",
    lowerDensityText: "Lagere dichtheid (meer m2 per persoon)",
    notSureDensityText: "Weet niet zeker",
    //CirculationDropdown
    preCovidText: "V\xf3\xf3r corona",
    higherText: "Grotere circulatie (50% open/30% afgesloten)",
    notSureText: "Weet niet zeker (45% open/25% afgesloten)",
    // ExamplePlans
    examplePlanButtonText: "Voorbeeldplattegrond bekijken",
    examplePlanFullFloorText: "volledige verdieping",
    examplePlanPartialFloorText: "deel verdieping",
    examplePlanFullImgAlt: "Plattegrond {{size}} vierkante {{unit}} met een {{profileName}}-profiel van Spacer by CBRE",
    examplePlanPartialImgAlt: "Gedeeltelijke plattegrond {{size}} vierkante {{unit}} met een {{profileName}}-profiel van Spacer by CBRE",
    examplePlanTooltipText: "Als je bedrijf groter is dan {{size}} {{unit}}, heb je misschien meer dan \xe9\xe9n verdieping nodig.",
    // ProgramStats
    programStatsDensitySubtitleTsubo: "Netto tsubo",
    programStatsDensitySubtitle: "{{adjective}} vierkante {{unitUppercase}}",
    programStatsIndivTitle: "Individuele Werkplekken",
    programStatsWorkstationsSubtitle: "Open Werkplekken",
    programStatsOfficesSubtitle: "Gesloten Werkplekken (kantoor)",
    programStatsCollabTitle: "Samenwerking",
    programStatsEnclosedSubtitle: "Vergaderstoel (In afgesloten vergaderruimte)",
    programStatsIndivSeatSubtitle: "Individuele werkplek",
    programStatsSeatsTitle: "Werkplekken per persoon",
    programStatsIndivSeatsSubtitle: "Individuele Werkplekken",
    programStatsPersonSubtitle: "Persoon",
    programStatsDensityTitle: "Dichtheid",
    programStatsFullDensitySubtitle: "Vierkante meter VVO per individuele werkplek",
    // Profile Display Names (profileNames.js)
    efficientName: "De Optimalisator",
    whiteCollarName: "De Facilitator",
    whiteGloveName: "De Uitblinker",
    openOfficeName: "De Producent",
    workplace360Name: "De Verbinder",
    campusName: "De Onderscheider",
    startupName: "De Broedplaats",
    engCreativeName: "De Maker",
    // Profile Descriptions (profileDescriptions.js)
    efficientDesc: "Het Optimalisator-kantoor is een no-nonsenseomgeving: zonder toeters en bellen, m\xe9t alle benodigdheden om de klus te klaren. Dit kantoor is in basis een plek om geconcentreerd en zelfstandig te werken. Om de beschikbare ruimte optimaal te benutten, is er een open vloerplan. Samenwerking en teammeetings komen weinig voor; collega\u2019s werken het liefst individueel, aan hun eigen bureau. Werkplekken zijn gestandaardiseerd en bieden precies wat medewerkers nodig hebben, zonder overbodige en afleidende functionaliteiten. Werkzaamheden vinden voornamelijk plaats op kantoor.",
    whiteCollarDesc: "Als je een Facilitator-kantoor zoekt, ben je niet de enige: dit is een van de populairste profielen. Het valt op \u2013 niet vanwege radicaal ruimtedesign, maar door technische snufjes en moderne meubels. Zo stimuleert het kantoor productiviteit en is het uitnodigend, als een soort tweede thuis. Zo is het niet alleen een plek om te werken, maar ook om de bedrijfsidentiteit uit te dragen, talent aan te trekken, en te leren en ontwikkelen. Collega\u2019s werken veel aan hun eigen bureau en nemen af en toe deel aan teamsessies en andere groepsactiviteiten. Hybride werken is mogelijk, maar medewerkers zijn vooral op kantoor te vinden.",
    whiteGloveDesc: "Zodra je een Uitblinker-kantoor binnenstapt, voel je het meteen: the sky is the limit. Dit kantoortype is helemaal afgestemd op de behoeften van werknemers \xe9n klanten, die vaak langskomen. Hoofddoelen? Gefocust werken, talent aantrekken en de bedrijfsidentiteit uitdragen. Meer dan bij alle andere profielen ligt de nadruk op afgesloten vergaderruimtes en werkplekken. Veel medewerkers hebben hun kantoorruimte verdiend dankzij prestaties of aantal arbeidsjaren. Onder collega\u2019s speelt hi\xebrarchie meestal een belangrijke rol. Ze zijn dan ook vooral op kantoor te vinden \u2013 remote werken is minder gebruikelijk.",
    openOfficeDesc: "Een Producent-kantoor biedt alles wat medewerkers nodig hebben om hun werk zo goed mogelijk te doen. De verschillende ruimtes en functionaliteiten worden intensief gebruikt en dragen bij aan een effici\xebnt proces. Collega\u2019s werken ongeveer even vaak alleen als samen, en verplaatsen zich tijdens een werkdag regelmatig door het kantoor. Medewerkers zijn dus veel in beweging, wat een dynamische werksfeer oplevert. Die past perfect bij de rol van het kantoor: verandering aanjagen binnen de organisatie. Remote werken k\xe1n, en komt dus soms voor, maar de meeste werkzaamheden vinden plaats op locatie.",
    workplace360Desc: "Een Verbinder-kantoor staat evenwicht centraal: het biedt precies de juiste mix voor concentratie en connectie. Er is genoeg plek om in alle rust te werken, maar er zijn ook voldoende opties om met collega\u2019s te overleggen. Gemeenschappelijke ruimtes als keukens en open vergaderzalen nemen een centrale plek in. Dit brengt medewerkers samen en zorgt voor een gemeenschapsgevoel. Werkplekken zijn vooral gedeeld \u2013 mensen zitten regelmatig ergens anders of werken remote. Al deze elementen samen maken dit kantoor tot een broedplaats voor nieuwe idee\xebn, waar je graag naartoe gaat om je collega\u2019s te ontmoeten.",
    campusDesc: "Medewerkers hebben moeite om een Onderscheider-kantoor te verlaten aan het eind van de werkdag. Het biedt namelijk een werkervaring waar geen enkele andere werkplek aan kan tippen. Zo zijn er uitgebreide faciliteiten die collega\u2019s helpen om productief te zijn, tijd te besparen en op te laden. Snacks, spelletjes en comfortabele zitplekken: hier wordt iedereen aangemoedigd om regelmatig pauzes te nemen, sociaal te zijn en te ontspannen. Dit zorgt ervoor dat collega\u2019s elkaar graag op kantoor ontmoeten, ook als ze vaak remote werken.",
    startupDesc: "Dynamiek en creativiteit, daar gaat het om in een Broedplaats. Collega\u2019s werken nauw met elkaar samen en voelen zich sterk verantwoordelijk. Omdat deze kantooromgeving constant verandert, zijn de meeste ruimtes flexibel opgezet. Met meubels schuiven en ad hoc-oplossingen verzinnen, komt daarom regelmatig voor. Om een saamhorigheidsgevoel binnen het team te versterken, is er genoeg ruimte om intensieve werksessies en leuke sociale activiteiten te organiseren \u2013 denk aan pingpongwedstrijden en hackathons. Het kantoor voelt als een tweede thuis, ook voor collega\u2019s die vaak remote werken.",
    engCreativeDesc: "Elk Maker-kantoor\xa0is uniek in z\u2019n soort. Je vindt hier voornamelijk specialisten die met elkaar aan uitdagende, creatieve projecten werken. Op dit kantoor vinden ze alles wat ze nodig hebben om hun werk goed uit te voeren, zoals gespecialiseerde apparatuur of fysieke materialen. Collega\u2019s schieten elkaar bij vragen makkelijk even aan, maar kunnen zich ook terugtrekken om geconcentreerd te werken. Het kantoor is een plek om idee\xebn uit te wisselen, talent aan te trekken, en te leren en ontwikkelen.",
    // Profile Key Traits: Shared Names (profileTraitMap.js)
    social: "Sociaal",
    efficient: "Effici\xebnt",
    flexible: "Flexibel",
    enabled: "Goed uitgerust",
    productive: "Productief",
    inclusive: "Inclusief",
    clientFocused: "Klantgericht",
    standardized: "Gestandaardiseerd",
    // Profile Key Traits (profileTraitMap.js)
    social1Desc: "Relaties binnen en buiten het kantoor zijn belangrijk",
    social2Desc: "Veel gemeenschapsversterkende evenementen",
    social3Desc: "Medewerkers brengen graag tijd met elkaar door",
    social4Desc: "Meer open en gericht op de gemeenschap",
    efficient1Desc: "Bedrijf blijft slank en geldbewust",
    efficient2Desc: "Bedrijf blijft slank en productief",
    flexible1Desc: "Mensen kunnen kiezen hoe ze willen werken",
    flexible2Desc: "Werknemers hebben veel vrijheid",
    flexible3Desc: "Bouw de ruimte die je nodig hebt",
    enabled1Desc: "Werknemers hebben wat ze nodig hebben op hun werkplek",
    enabled2Desc: "Werknemers hebben uitgebreide diensten en faciliteiten tot hun beschikking",
    enabled3Desc: "Mensen kunnen krijgen wat ze nodig hebben om hun werk te doen",
    enabled4Desc: "Toegang tot de juiste technologie en apparatuur",
    enabled5Desc: "Gespecialiseerde apparatuur is beschikbaar",
    productive1Desc: "Functioneel en intu\xeftief kantoorontwerp",
    productive2Desc: "Bedrijfsgericht en geldbewust",
    productive3Desc: "Draait om een uniek product-/dienstenaanbod",
    inclusive1Desc: "Meerdere typen ruimten beschikbaar",
    inclusive2Desc: "Je vindt alles wat je nodig hebt in dit kantoor",
    inclusive3Desc: "Veel verschillende werkstijlen zijn acceptabel",
    clientFocused1Desc: "Eerste indrukken van klanten zijn alles",
    clientFocused2Desc: "Het kantoor is uitnodigend voor klanten en nieuwe medewerkers",
    clientFocused3Desc: "Het kantoor is piekfijn in orde voor klanten en nieuwe medewerkers",
    standardized1Desc: "Processen en systemen zijn gestroomlijnd",
    standardized2Desc: "Organisatienormen rondom ruimteverdeling",
    standardized3Desc: "Modulaire afmetingen voor flexibiliteit",
    standardized4Desc: "Gestroomlijnde processen en deliverables",
    // SpaceSummary
    spaceSummaryBarHeader: "Aanbevolen kantoorgrootte",
    spaceSummaryMeasurementTypeText: "type meting",
    spaceSummaryUnitTypeText: "eenheden",
    spaceSummaryLossFactorSectionLabel: "Details {{factor}}",
    spaceSummaryFitFactorText: "Pasfactor",
    spaceSummaryLossFactorText: "Verliesfactor",
    spaceSummaryRSFLossFactorHelperText: "Op basis van een verliesfactor van {{percentage}}% voor vastgoed in {{place}} moet je zoeken naar ruimten van {{min}} tot {{max}} verhuurbare vierkante {{units}}.",
    spaceSummaryNIAFitFactorHelperText: "Op basis van een pasfactor van {{percentage}}% voor vastgoed in {{place}} moet je zoeken naar ruimten met {{amt}} netto binnenoppervlakte.",
    spaceSummaryNIATooltipText: "Netto binnenoppervlakte is het bruikbare oppervlak binnen een gebouw, gemeten vanaf de binnenkant van de buitenmuren op elke verdieping, waarbij bepaalde gedeelten niet worden meegeteld.",
    // SFTypeRadioInput
    sfRadioInputUsableAreaTooltipText: "Deze meting omvat alle ruimten, meubels en circulatieruimte. Het wordt ook wel de \u201Bcarpetable\u2019 oppervlakte genoemd.",
    sfRadioInputRentableAreaTooltipText: "Dit zijn normaliter de bruikbare vierkante {{unitUppercase}} plus een deel van de algemene ruimten van een gebouw. Hoewel je die oppervlakte niet volledig kunt gebruiken, zijn dat de vierkante {{unit}} waarvoor je huur betaalt.",
    sfRadioInputUsableSquareText: "Functioneel Nuttig Oppervlak {{unitUppercase}}",
    sfRadioInputRentableSquareText: "Verhuurbaar Vloeroppervlak {{unitUppercase}}",
    //floored plan request block
    flooredTitle: "Je bent er bijna.",
    flooredSubTitle: "Bepaal hoe klanten je ruimten zien.",
    flooredSubText: "Loop door je Spacer-resultaten heen in een 3D-plattegrond!",
    flooredParagraphText1: "Duik in je nieuwe werkplek. Zo zie je de mogelijkheden voor je, kun je experimenteren met de ruimte en zet je idee\xebn om in werkelijkheid.",
    flooredParagraphText2: "Tastbare, persoonlijke visie voor elke mogelijke ruimte",
    flooredVideoHeading: "Bekijk een voorbeeld",
    flooredFreeText: "En het is ook nog gratis!",
    flooredIconText1: "Beschikbare plattegronden delen",
    flooredIconSubText1: "AutoCAD-bestanden voor pdf\u2019s",
    flooredIconText2: "Houd rekening met verwerkingstijd",
    flooredIconSubText2: "E\xe9n \xe0 twee weken",
    flooredIconText3: "Ontvang een ervaring die je kunt delen",
    flooredIconSubText3: "2D- en 3D-ervaringen op maat",
    // MeasurementSystemRadioInput
    measurementSystemSqFeetText: "Square feet",
    measurementSystemSqMetersText: "Vierkante Meter",
    measurementSystemTsuboText: "Tsubo",
    // ProfileHero
    resultsProfileHeroAnnouncementTitle: "Jouw kantoor is",
    resultsProfileHeroImgAlt: "3D-plattegrond van de kantoorindeling van het profiel {{profileName}} van Spacer by CBRE",
    // ProfileComparison
    profileCompModalTitle: "Profiel wijzigen?",
    profileCompModalText: "Eventuele niet-opgeslagen wijzigingen in je huidige ruimteprogramma gaan verloren.",
    profileCompModalConfirmText: "Ja, profiel wijzigen",
    profileCompModalCancelText: "Nee, huidig profiel behouden",
    profileCompNavbarCancelButtonText: "Annuleren",
    profileCompNavbarUseButtonText: "Dit profiel gebruiken",
    profileCompCompareTitle: "Vergelijk de profielen met de meeste overeenkomsten",
    // ProfileComparisonColumn
    profileCompColumnSelectedText: "Geselecteerd profiel",
    profileCompColumnSelectText: "Selecteren",
    profileCompColumnRecommendedText: " (Aanbevolen)",
    profileCompColumnImgAltText: "3D-plattegrond van de kantoorindeling van het profiel {{profileName}} van Spacer by CBRE",
    // Test Fit Form
    testFitTitle: "Bekijk je resultaten in een plattegrond en loop er in 3D doorheen",
    testFitSubtitle: "Wil je een indruk krijgen van hoe jouw ruimteprogramma eruitziet? We zetten de resultaten om naar een aangepaste plattegrond die je kunt verkennen en delen.",
    requestTestFitButtonText: "Een plattegrond op maat aanvragen",
    company: "Bedrijfsnaam",
    emptyCompanyError: "Voer een bedrijfsnaam in",
    radioQ2yes: "Geweldig! We nemen contact op via e-mail om het bestand op te vragen.",
    radioQ2no: "Geen probleem. We nemen contact op om de mogelijkheden te bespreken.",
    testFitFormTitle: "Plattegrond op maat aanvragen",
    testFitFormSubtitle: "Als je ons wat informatie geeft, gaan we aan de slag. Ons team levert de plattegronden doorgaans binnen drie werkdagen.",
    testFitFormCompleted: "Je verzoek is ingediend. Je ontvangt een e-mail van een van onze vertegenwoordigers.",
    testFitFormYes: "ja",
    testFitFormNo: "nee",
    testFitFormQ1: "Heb je een plattegrond om mee te werken?",
    testFitFormQ1No: "Geen probleem! Wij kunnen er een verstrekken die je kunt gebruiken.",
    testFitFormQ2: "Heb je een tekening van het vloerplan (pdf, AutoCAD)?",
    testFitTermsConditions: "Door dit vakje aan te vinken, ga je akkoord met deelname aan ons b\xe8taprogramma. Je ontvangt \xe9\xe9n gratis plattegrond van ons. In ruil daarvoor vul je een korte enqu\xeate in over je ervaringen.",
    testFitSubmitButtonText: "Verzoek plattegrond indienen",
    backendError: "Oeps! Er is iets misgegaan. Probeer het nog eens."
};


var $dd5ce2ea99edecbe$exports = {};
$dd5ce2ea99edecbe$exports = {
    // TermsOfService
    TermsTitle: "Servicevoorwaarden",
    TermsIntroText: 'Dit is een wettelijke overeenkomst tussen jou en CBRE, Inc. (\u201CCBRE\u201D) met betrekking tot toegang tot en gebruik van een toepassing met de naam Spacer\xae.  Door gegevens of diensten in deze online toepassing te bekijken of gebruiken, verklaar je de in deze Gebruiksvoorwaarden (de "Overeenkomst") vastgelegde voorwaarden en bepalingen te hebben gelezen en begrepen en daarmee akkoord te gaan. De termen "jij", "jou(w)" en "Gebruiker" verwijzen collectief naar de persoon en de eventuele entiteit namens welke de betreffende persoon optreedt.',
    TermsLimitationsTitle: "Beperkingen.",
    TermsLimitationsA: "De Gebruiker begrijpt en gaat ermee akkoord dat de toegang van de Gebruiker tot Spacer\xae niet exclusief is, niet in sublicentie kan worden gegeven, niet overdraagbaar is, vrijelijk kan worden ingetrokken en op elk gewenst moment kan worden be\xebindigd door CBRE, om wat voor reden dan ook.",
    TermsLimitationsB: 'De Gebruiker begrijpt en gaat ermee akkoord dat het verkrijgen van toegang tot Spacer\xae de Gebruiker geen enkel eigendomsrecht verleent op Spacer\xae of enige daarmee verband houdende documentatie (waaronder eventuele nieuwe uitgaven, aanpassingen of verbeteringen), die allemaal het exclusieve eigendom zijn en blijven van CBRE waaronder, maar niet beperkt tot het auteursrecht daarop, bijbehorende octrooien, ontwerppatenten, handelsmerken, handelsuitingen en andere eigendomsrechten die gelden op grond van de toepasselijke wetgeving of internationale verdragen (gezamenlijk te noemen "Eigendomsrechten").  Zie artikel 2 (Eigendom) hieronder. CBRE behoudt zicht hierbij uitdrukkelijk alle rechten op Spacer\xae voor die niet uitdrukkelijk aan de Gebruiker zijn verleend op grond van de onderhavige Overeenkomst.',
    TermsLimitationsC: "Behalve voor zover bepaald in de onderhavige Overeenkomst of voor zover CBRE de Gebruiker hiervoor uitdrukkelijk schriftelijk toestemming heeft gegeven, is het de Gebruiker niet toegestaan: (i) Spacer\xae aan te passen, te vertalen, te onderwerpen aan reverse engineering, te decompileren, te demonteren, te proberen enig deel van de broncode te reconstrueren, identificeren of ontdekken of afgeleide werken of kopie\xebn te maken van Spacer\xae; (ii) enige aanduidingen van auteursrechten of handelsmerken of andere aanduidingen van eigendomsrechten in Spacer\xae te verwijderen, aan te passen of te bedekken; (iii) zijn toegangs-, gebruiks- of andere rechten toe te wijzen, in sublicentie te geven of anderszins over te dragen of zijn plichten op grond van deze Overeenkomst te delegeren; of (iv) onverminderd het voorgaande, Spacer\xae te gebruiken voor het bouwen van een concurrerend product of een concurrerende dienst, of voor enig doel anders dan de legitieme zakelijke doeleinden met betrekking tot de onderneming van de Gebruiker.",
    TermsLimitationsD: "De gebruiker belooft CBRE onverwijld schriftelijk op de hoogte te stellen zodra hij enig ongeautoriseerd gebruik van Spacer\xae of een mogelijke schending van eigendomsrechten constateert.",
    TermsLimitationsE: "De Gebruiker zal op geen enkel moment gedurende of na de looptijd van deze Overeenkomst een aanvraag indienen voor het registreren van enig auteursrecht, handelsmerk of ander predicaat dat van invloed is op het bezit van eigendomsrechten of enige documenten indienen bij enige overheidsinstantie om enige handeling te verrichten die van invloed is op het bezit van eigendomsrechten, waaronder de eigendomsrechten van CBRE op Spacer\xae, het merk Spacer\xae en andere onderdelen van de toepassing. Spacer\xae is een handelsmerk en dienstmerk van CBRE.",
    TermsLimitationsF: "De Gebruiker verklaart en stemt ermee in dat de Gebruiker gerechtigd is om alle materialen die gepost zijn op of alle informatie die gebruikt is in verband met Spacer\xae te verstrekken en verleent CBRE hierbij een niet-exclusief, royaltyvrij, wereldwijd, onherroepelijk, eeuwigdurend recht en licentie om deze materialen en informatie naar goeddunken van CBRE te gebruiken, te reproduceren, aan te passen, te verspreiden, weer te geven en er afgeleide werken van te maken.  De Gebruiker verklaart aansprakelijk te zijn voor alle materialen en gegevens die door de Gebruiker worden verstrekt, inclusief de wettigheid, betrouwbaarheid, passendheid, oorspronkelijkheid en auteursrechten daarvan. De op grond van deze Overeenkomst door de Gebruiker aan CBRE verleende licentie blijft bestaan na eventuele be\xebindiging van het gebruik van Spacer\xae door de Gebruiker.  Alle door de Gebruiker verstrekte materialen en gegevens worden geacht niet-vertrouwelijk te zijn en niet beschermd te zijn voor eigendomsrechten en zullen als zodanig worden behandeld door CBRE, en kunnen door CBRE worden gebruikt in overeenstemming met deze Overeenkomst zonder kennisgeving aan de Gebruiker en zonder dat CBRE hier op enige wijze aansprakelijk voor is.",
    TermsOwnershipTitle: "Eigendom.",
    TermsOwnershipText: "Spacer\xae, de programmeertaal, software en documentatie en alle andere op Spacer\xae beschikbaar gemaakte materialen of inhoud of eventuele verbeteringen, aanpassingen, afgeleide werken, uitbreidingen of veranderingen van Spacer\xae en alle exemplaren daarvan zijn eigendom van CBRE en uitsluitend CBRE mag er aanspraak op maken in alle omstandigheden, waaronder, maar niet beperkt tot alle rechten op octrooien, auteursrechten, handelsmerken en handelsgeheimen in Spacer\xae en de verbeteringen, aanpassingen, afgeleide werken en wijzigingen daarvan. De Gebruiker begrijpt dat het voorgaande ook van toepassing is op handelsgeheimen en informatie die vertrouwelijk is en eigendom is van CBRE en belooft alle noodzakelijke maatregelen te nemen om de vertrouwelijkheid van dergelijke informatie te beschermen. De Gebruiker mag Spacer\xae niet verkopen, overdragen, publiceren, openbaar maken, weergeven of anderszins beschikbaar maken of enige verbeteringen, aanpassingen, uitbreidingen, afgeleide werken of wijzigingen ervan of kopie\xebn daarvan maken of beschikbaar stellen aan anderen.  Be\xebindiging van deze Overeenkomst zal plaatsvinden als aanvulling op en niet in plaats van enige rechtsmiddelen die CBRE op grond van recht en billijkheid ter beschikking staan. De verplichtingen op grond van de onderhavige Overeenkomst blijven na be\xebindiging van deze Overeenkomst bestaan.",
    TermsTerminationTitle: "Be\xebindiging; inwerkingtreding van be\xebindiging; rechtsmiddelen.",
    TermsTerminationA: "Onverminderd enige andere rechtsmiddelen kan CBRE deze Overeenkomst en/of het gebruik van Spacer\xae en delen daarvan door de Gebruiker met onmiddellijke ingang, automatisch, met of zonder kennisgeving en zonder tussenkomst van rechtbanken of andere justiti\xeble instanties, om wat voor reden dan ook of zonder reden, aanpassen, beperken, opschorten, staken of be\xebindigen.  De Gebruiker gaat ermee akkoord dat CBRE niet verplicht is Spacer\xae te leveren en dat CBRE niet aansprakelijk is jegens de Gebruiker of enige andere partij voor eventuele beperking, opschorting, staking, be\xebindiging of aanpassing van Spacer\xae.",
    TermsTerminationB: "De Gebruiker erkent dat de verplichtingen jegens CBRE op grond van de onderhavige Overeenkomst een uniek en onvervangbaar karakter hebben en dat het verlies daarvan CBRE onherstelbare schade kan berokkenen die niet uitsluitend kan worden gecompenseerd met een financi\xeble schadevergoeding, wat inhoudt dat CBRE recht heeft op rechterlijke en andere billijke schadeloosstelling (zonder de verplichting om enige schuldbekentenis of zekerheid af te geven) in het geval van een overtreding of te verwachten overtreding door de Gebruiker. De Gebruiker doet onherroepelijk afstand van alle rechten op het vorderen van rechterlijke of andere billijke schadeloosstelling.",
    TermsDisclaimerTitle: "Schadeloosstelling door Gebruiker.",
    TermsDisclaimerA: "Spacer\xae wordt aan de Gebruiker verstrekt \u201CZOALS HET IS\u201D en \u201COP VOORWAARDE VAN BESCHIKBAARHEID\u201D, zonder garanties.  CBRE WIJST ALLE EXPLICIETE EN IMPLICIETE GARANTIES AF, WAARONDER, MAAR NIET BEPERKT TOT DE IMPLICIETE GARANTIES VAN VERHANDELBAARHEID, GESCHIKTHEID VOOR EEN BEPAALD DOEL EN NIET-SCHENDING VAN RECHTEN VAN DERDEN. CBRE GARANDEERT OP GEEN ENKELE WIJZE DAT Spacer\xae ZAL VOLDOEN AAN DE EISEN VAN DE GEBRUIKER OF ENIGE SPECIFIEKE NORM. SOMMIGE RECHTSGEBIEDEN STAAN HET UITSLUITEN VAN IMPLICIETE GARANTIES NIET TOE, DUS HET BOVENSTAANDE IS MOGELIJK NIET VAN TOEPASSING OP DE GEBRUIKER. In een dergelijk geval is de aansprakelijkheid van CBRE beperkt voor zover de geldende wet dat toestaat. GEEN ENKELE MONDELINGE OF SCHRIFTELIJKE INFORMATIE OF RAAD DIE WORDT GEGEVEN DOOR CBRE OF ZIJN VERTEGENWOORDIGERS OF MEDEWERKERS MAG WORDEN OPGEVAT ALS EEN GARANTIE OP WAT VOOR MANIER DAN OOK. ER WORDT GEEN GARANTIE GEGEVEN DAT Spacer\xae OF ENIGE AAN DE GEBRUIKER VERSTREKTE INFORMATIE VRIJ IS VAN FOUTEN OF DAT HET GEBRUIK VAN Spacer\xae ONONDERBROKEN, UP-TO-DATE, VOLLEDIG OF VRIJ VAN VIRUSSEN OF ANDERE SCHADELIJKE ELEMENTEN ZAL ZIJN EN ER WORDT GEEN GARANTIE GEGEVEN DAT EEN VAN DE VOORNOEMDE SITUATIES ZAL WORDEN RECHTGEZET. CBRE GEEFT GEEN GARANTIES OF VERKLARINGEN MET BETREKKING TOT HET GEBRUIK VAN OF DE RESULTATEN VAN HET GEBRUIK VAN Spacer\xae.  CBRE KAN NIET AANSPRAKELIJK WORDEN GESTELD VOOR ENIGE INDIRECTE, SPECIALE, INCIDENTELE, VOORTVLOEIENDE, PUNITIEVE OF MORELE SCHADE (WAARONDER, MAAR NIET BEPERKT TOT SCHADES ALS GEVOLG VAN VERLIES VAN BEDRIJFSACTIVITEITEN, VERLIES VAN WINSTEN, VERLIES VAN OMZET, VERLIES VAN SPAARGELD, COMPUTERSTORING OF SCHADE AAN GOODWILL, GEBRUIK, GEGEVENS OF ANDERE IMMATERI\xcbLE SCHADE), ONGEACHT OF DEZE VOORTKOMT UIT CONTRACTBREUK, EEN ONRECHTMATIGE DAAD (WAARONDER NALATIGHEID), PRODUCTAANSPRAKELIJKHEID OF ANDERSZINS, ZELFS ALS CBRE OF ZIJN VERTEGENWOORDIGERS VAN DE MOGELIJKHEID VAN DERGELIJKE SCHADES OP DE HOOGTE ZIJN GESTELD EN ZELFS ALS IS GEBLEKEN DAT EEN IN DEZE OVEREENKOMST VASTGELEGD RECHTSMIDDEL NIET HET BEOOGDE EFFECT HEEFT GEHAD.",
    TermsDisclaimerB: "DE TOTALE AANSPRAKELIJKHEID VAN CBRE VOOR SCHADES MET WAT VOOR OORZAAK DAN OOK IS NIET HOGER DAN DE VERGOEDING DIE DE GEBRUIKER VOOR Spacer\xae HEEFT BETAALD GEDURENDE DE PERIODE VAN TWAALF (12) MAANDEN VOORAFGAAND AAN DE GEBEURTENIS DIE TOT DE SCHADE ZOU HEBBEN GELEID.  DE GEBRUIKER GAAT ERMEE AKKOORD DAT ENIGE RECHTSHANDELING DIE VOORTKOMT UIT OF VERBAND HOUDT MET Spacer\xae OF ANDERSZINS VERBAND HOUDT MET DEZE OVEREENKOMST MOET BEGINNEN BINNEN \xc9\xc9N (1) JAAR NADAT DE REDEN DAARTOE IS ONTSTAAN. GEBEURT DIT NIET, DAN IS DE BETREFFENDE RECHTSHANDELING DEFINITIEF UITGESLOTEN.",
    TermsDisclaimerC: "SOMMIGE RECHTSGEBIEDEN STAAN HET BEPERKEN OF UITSLUITEN VAN AANSPRAKELIJKHEID MOGELIJK NIET TOE, DUS DE BOVENSTAANDE BEPERKING OF UITSLUITING IS MOGELIJK NIET VAN TOEPASSING OP DE GEBRUIKER. In een dergelijk geval is de aansprakelijkheid van CBRE beperkt voor zover de geldende wet dat toestaat.  De hierboven beschreven afwijzing van garantie, exclusieve rechtsmiddelen en beperkte aansprakelijkheid zijn fundamentele elementen die de basis vormen van deze Overeenkomst tussen CBRE en de Gebruiker. Zonder dergelijke beperkingen zou CBRE Spacer\xae niet op een economische wijze kunnen aanbieden en zou het deze Overeenkomst niet zijn aangegaan. Deze beperkingen blijven bestaan na be\xebindiging van deze Overeenkomst.",
    TermsIndemnificationTitle: "Schadeloosstelling door Gebruiker.",
    TermsIndemnificationText: "Op initiatief en verzoek van CBRE zal de Gebruiker, op eigen kosten, CBRE en zijn dochterondernemingen, gelieerde bedrijven, functionarissen, werknemers, vertegenwoordigers, merkpartners, relaties en andere partners schadeloos stellen en vrijwaren van enige verliezen, kosten, schades, aansprakelijkheden, schikkingen en uitgaven (waaronder, maar niet beperkt tot advocatenkosten) die voortkomen uit of verband houden met enige vordering, rechtshandeling of aantijging van een derde partij met betrekking tot of voortkomend uit: (a) enige transactie of enig geschil tussen de Gebruiker en de derde partij; (b) feiten of beweringen die een schending zouden vormen van enige verklaringen, garanties of afspraken van de Gebruiker op grond van deze Overeenkomst of enige toepasselijke wet, regel of verordening, al dan niet genoemd in deze Overeenkomst; (c) enige materialen, informatie of inhoud van de Gebruiker, ingediend in of op Spacer\xae; (d) schending van enige rechten van enige derde partij door de Gebruiker; (e) het gebruik of misbruik van Spacer\xae door de Gebruiker; of (f) nalatigheid of opzettelijke misdragingen door de Gebruiker.  CBRE heeft het exclusieve recht om zijn verdediging te leiden en beheren en naar eigen keus juridische bijstand in te schakelen op kosten van de Gebruiker.",
    TermsGeneralTitle: "Algemeen.",
    TermsGeneralA: "<0>Volledige overeenkomst/Geen onopzettelijke verklaring van afstand.</0> Deze Overeenkomst vormt de volledige overeenkomst tussen CBRE en de Gebruiker met betrekking tot Spacer\xae en de volledige inhoud van deze Overeenkomst, en vervangt alle eventuele eerdere overeenkomsten tussen CBRE en de Gebruiker met betrekking tot Spacer\xae. Indien CBRE enige bepaling van deze Overeenkomst niet kan uitvoeren, mag dit niet worden gezien als een verklaring van afstand van enige bepaling of enig recht.",
    TermsGeneralB: "<0>Kennisgevingen.</0> Kennisgevingen aan de Gebruiker worden schriftelijk gedaan en kunnen via e-mail worden verzonden of worden geplaatst op Spacer\xae of op www.cbre.com/spacer. Kennisgevingen aan ons dien je via e-mail te verzenden aan spacersupport@cbre.com, waarbij een kopie via aangetekende post moet worden verzonden aan CBRE, 400 S. Hope Street, 25th Floor, Los Angeles, CA 90071, Verenigde Staten ter attentie van: General Counsel\u2019s Office. Kennisgevingen worden geacht te zijn gedaan \xe9\xe9n (1) werkdag nadat ze via e-mail zijn verzonden (tenzij de verzender een melding krijgt waaruit blijkt dat het bericht niet is aangekomen) of drie (3) werkdagen nadat ze op de website van CBRE zijn geplaatst (in het geval van CBRE), ongeacht of ze zijn ontvangen of niet.",
    TermsGeneralC: "<0>Toepasselijk recht.</0> Op deze Overeenkomst is het recht van de staat Californi\xeb van toepassing, onverminderd eventuele conflicterende rechtsbeginselen.  CBRE en de Gebruiker verklaren zich hierbij exclusief gehouden aan de rechtbanken van de staat Californi\xeb.  Het Verdrag der Verenigde Naties inzake internationale koopovereenkomsten betreffende roerende zaken (1980) wordt bij dezen in zijn geheel niet van toepassing verklaard op deze Overeenkomst. De Gebruiker gaat er bij dezen mee akkoord dat Spacer\xae zal worden geacht uitsluitend in Californi\xeb gevestigd te zijn en een passieve dienst te vormen die andere rechtsgebieden dan de staat Californi\xeb geen rechtsbevoegdheid geeft over CBRE, specifiek of algemeen.",
    TermsGeneralD: "<0>Oplossing van geschillen.</0> Enig geschil, enige vordering of enige onenigheid die voortkomt uit of verband houdt met deze Overeenkomst of de schending, uitvoering, interpretatie of geldigheid daarvan, waaronder de bepaling van het toepassingsgebied of de toepasselijkheid van arbitrage met betrekking tot deze Overeenkomst, zal worden bepaald door middel van arbitrage.\xa0 De arbitrage zal worden verzorgd door de Judicial Arbitration and Mediation Service (JAMS) en worden uitgevoerd door \xe9\xe9n bemiddelaar.\xa0 Daarnaast stemt de Gebruiker ermee in dat noch de Gebruiker, noch CBRE een vordering zal samenvoegen met een vordering van enige andere persoon of rechtspersoon bij arbitrage, dat geen enkele vordering zal worden beslecht door een collectief proces en dat noch de Gebruiker, noch CBRE in de hoedanigheid van vertegenwoordiger een vordering zal indienen namens iemand anders.\xa0 Onverminderd het voorgaande gaat de Gebruiker ermee akkoord dat CBRE het recht heeft om te verzoeken tot voorlopige voorzieningen (of een vergelijkbaar urgent rechtsmiddel) in elk rechtsgebied.\xa0 Als de Gebruiker een klacht indient tegen CBRE waarvoor arbitrage noodzakelijk is, stemt CBRE ermee in het eventuele deel van de initi\xeble kosten boven $\xa0250 te betalen; na de initi\xeble kosten verdelen de partijen de kosten voor de arbitrage gelijkelijk.\xa0 De Gebruiker gaat ermee akkoord geen andere rechtszaken tegen CBRE te starten anders dan het indienen van een arbitrageverzoek in overeenstemming met dit artikel.\xa0 BELANGRIJK: DOOR ZICH GEBONDEN TE VERKLAREN AAN DEZE OVEREENKOMST, DOET DE GEBRUIKER AFSTAND VAN ENIGE RECHTEN DIE DE GEBRUIKER HEEFT OM GENOEGDOENING TE EISEN VOOR DE RECHTBANK EN VAN ENIG RECHT OP EEN JURYRECHTSZAAK.",
    TermsGeneralE: "<0>Scheidbaarheid.</0> In het geval dat een deel van deze Overeenkomst onuitvoerbaar blijkt, zal het onuitvoerbare deel uitsluitend worden aangepast voor zover dat nodig is om het uitvoerbaar te maken en blijven de overige bepalingen onverminderd volledig van kracht.",
    TermsGeneralF: "<0>Overdracht.</0> Deze Overeenkomst mag niet door de Gebruiker worden overgedragen zonder voorafgaande schriftelijke toestemming van CBRE. Enige poging tot overdracht zonder toestemming van CBRE is nietig. CBRE behoudt zich het recht voor deze Overeenkomst over te dragen aan een derde partij. Deze Overeenkomst en de rechten en plichten die wij beiden op grond daarvan hebben, is bindend voor onze respectieve opvolgers en partijen aan wie wij de Overeenkomst overdragen.",
    TermsGeneralG: "<0>Aanpassing.</0> CBRE kan alle voorwaarden en bepalingen in deze Overeenkomst te allen tijde en naar eigen inzicht aanpassen door een kennisgeving van wijziging of een nieuwe overeenkomst te publiceren op de website van Spacer\xae, te vinden op www.cbre.com/spacer, of door een waarschuwing of soortgelijke kennisgeving te plaatsen in Spacer\xae.  Als de Gebruiker een aanpassing onacceptabel vindt, heeft de Gebruiker geen andere verhaalmogelijkheden dan be\xebindiging van het gebruik van Spacer\xae.",
    TermsGeneralH: "<0>Conflicten.</0> In het geval dat er een conflict bestaat tussen de bepalingen van deze Overeenkomst en een eventuele volledig uitgevoerde licentieovereenkomst tussen de Gebruiker en CBRE met betrekking tot Spacer\xae, zijn de bepalingen van de betreffende licentieovereenkomst leidend met betrekking tot de conflicterende bepalingen."
};


var $8c0601727c39c197$exports = {};
$8c0601727c39c197$exports = {
    // Quiz
    exitQuizButtonTitle: "Vragenlijst afsluiten",
    // QuizProgressLabel
    progressLabelText: "voltooid",
    // QuizNavigationButton
    quizNavBackButtonShortenedText: "Vorige",
    quizNavBackButtonFullLengthText: "Vorige vraag",
    quizNavNextButtonShortenedText: "Volgende",
    quizNavNextButtonFullLengthText: "Volgende vraag",
    // QuizExitSlide
    quizExitSubtitle: "Wij gebruiken nu jouw antwoorden om de ideale werkplek voor jouw bedrijf te bepalen.",
    quizExitImgAlt: "Illustratie van twee mensen die elkaar een high five geven op de pagina Over ons van Spacer by CBRE",
    // Question Unit Text (questionUnitMap.js)
    question1Text: "Eerste vraag: wat is de belangrijkste functie van het kantoor?",
    question2Text: "Wat waarderen sollicitanten volgens jou het meeste aan je organisatie?",
    question3Text: "Waar let je het meeste op als je nieuwe teamleden aanneemt?",
    question4Text: "Wat verwacht je dat er de komende vijf jaar met de omvang van je organisatie gebeurt?",
    question5Text: "Wanneer werken je medewerkers doorgaans?",
    question6Text: "Wat vind je van eigen bureaus?",
    question7Text: "Waar werken mensen als ze op kantoor zijn?",
    question8Text: "Hoe zijn medewerkers gekleed op kantoor?",
    question9Text: "Waar werken je medewerkers?",
    question10Text: "Wat voor sfeer wil je op kantoor?",
    question11Text: "Wat voor faciliteiten moet je kantoor bieden?",
    question12Text: "Welke omschrijving past het beste bij jou?",
    // Quiz Answers (questionUnitMap.js)
    pickOnePlaceholder: "Maak je keuze",
    selectFromListPlaceholder: "Kies uit de lijst",
    firstResponseTooltipText: "Kies je eerste antwoord",
    locatedSomewhereElseLabel: "We zitten op dit moment ergens anders.",
    q1AnswerText1: "We zien ons kantoor vooral als",
    q1AnswerText2: "maar ook als",
    q1AnswerText3: "en tenslotte als",
    q1Option1Text: "een tweede thuis voor onze mensen",
    q1Option2Text: "een katalysator van verandering",
    q1Option3Text: "een plek om geconcentreerd te werken",
    q1Option4Text: "een creatieve broedplaats voor grote idee\xebn",
    q1Option5Text: "een hulpmiddel om toptalent binnen te halen",
    q1Option6Text: "een visitekaartje voor ons merk",
    q1Option7Text: "een ruimte om te groeien en te leren",
    q1Option8Text: "een plek waar mensen elkaar ontmoeten",
    q1Option9Text: "een plek waarvan de kosten vooral zo laag mogelijk moeten blijven",
    q2AnswerText1: "Mensen komen met name bij ons werken vanwege",
    q2AnswerText2: "ook waarderen ze",
    q2AnswerText3: "net als",
    q2Option1Text: "onze bedrijfscultuur",
    q2Option2Text: "het salaris",
    q2Option3Text: "onze reputatie",
    q2Option4Text: "de secundaire arbeidsvoorwaarden",
    q2Option5Text: "de flexibele werktijden",
    q2Option6Text: "onze mensen en leidinggevenden",
    q2Option7Text: "de kantooromgeving",
    q2Option8Text: "het doel en de missie",
    q3AnswerText1: "We selecteren kandidaten vooral op basis van",
    q3AnswerText2: "maar kijken ook naar",
    q3AnswerText3: "en letten op",
    q3Option1Text: "vaardigheden",
    q3Option2Text: "ervaring",
    q3Option3Text: "match met onze bedrijfscultuur",
    q3Option4Text: "referenties",
    q3Option5Text: "relaties",
    q3Option6Text: "nieuws- en leergierigheid",
    q4AnswerText: "Waarschijnlijk zullen we",
    q4Option1Text: "elk jaar een beetje groeien",
    q4Option2Text: "elk jaar aanzienlijk groeien",
    q4Option3Text: "ongeveer even groot blijven",
    q4Option4Text: "elk jaar een beetje krimpen",
    q4Option5Text: "moeilijk te zeggen, dat is onvoorspelbaar",
    q5AnswerText: "We werken meestal",
    q5Option1Text: "van 9 tot 5",
    q5Option2Text: "van 's ochtends tot laat",
    q5Option3Text: "wanneer we willen, zolang het werk maar af komt",
    q5Option4Text: "wanneer we willen, zo vaak als we willen",
    q6AnswerText: "Wij denken dat",
    q6Option1Text: "iedereen een eigen bureau moet hebben",
    q6Option2Text: "we prima bureaus kunnen delen",
    q7Option1Text: "Altijd aan een bureau",
    q7Option2Text: "Vooral aan een bureau, behalve tijdens vergadering of andere activiteiten",
    q7Option3Text: "De ene helft van de tijd aan een bureau, de andere helft ergens anders",
    q7Option4Text: "Dat wisselt een groot deel van de tijd, maar af en toe aan een bureau",
    q7Option5Text: "Dat wisselt voortdurend, ze zijn altijd ergens anders",
    q8Option1Text: "Professioneel en zakelijk",
    q8Option2Text: "Vooral professioneel, behalve bij uitzonderingen",
    q8Option3Text: "Casual zakelijk; soms formeel, soms wat informeler",
    q8Option4Text: "Vooral casual, behalve bij speciale gelegenheden",
    q8Option5Text: "Casual",
    q9Option1Text: "Altijd op kantoor",
    q9Option2Text: "Meestal op kantoor",
    q9Option3Text: "We verdelen onze tijd tussen kantoor en elders",
    q9Option4Text: "We werken voornamelijk op andere plekken dan het kantoor",
    q9Option5Text: "We werken nooit op kantoor",
    q10Option1Text: "Dynamisch en energiek",
    q10Option2Text: "Energiek, met rustige momenten",
    q10Option3Text: "Dat verschilt; een combinatie van beide",
    q10Option4Text: "Rustig, met af en toe dynamische momenten",
    q10Option5Text: "Rustig en kalm",
    q11Option1Text: "Alleen de basisvoorzieningen, genoeg om alles draaiende te houden",
    q11Option2Text: "De basisvoorzieningen plus een paar upgrades",
    q11Option3Text: "De basisvoorzieningen en een plek waar mensen elkaar kunnen ontmoeten",
    q11Option4Text: "Iets heel prettigs waar je vanuit het kantoor graag naartoe gaat",
    q11Option5Text: "Iets cools en onderscheidends; het eerste wat je een bezoeker laat zien",
    q12AnswerText: "Ik ben",
    q12OptionClientText: "een bestaande klant van CBRE",
    q12OptionProfessionalText: "een deskundige van CBRE",
    q12OptionLeadText: "iemand anders",
    q13AnswerText1: "Wij verwachten",
    q13AnswerText2: "medewerkers in ons kantoor te hebben.",
    q13AnswerHelperText: "Tip, om groei of krimp mee te wegen: gebruik het verwachte aantal medewerkers tijdens het middelpunt  van je huurovereenkomst, of verwachte aantal medewerkers over 2-5 jaar",
    q14AnswerText1: "Wij verwachten",
    q14AnswerText2: "van onze tijd in teams te werken.",
    q15AnswerText1: "We verwachten gemiddeld",
    q15AnswerText2: "dagen per week op kantoor te werken.",
    q16AnswerText1: "Ons kantoor komt in de stad",
    q16AnswerText2: ".",
    q17AnswerText1: "Wij zijn vooral actief in de sector",
    q17AnswerText2: "sector.",
    q18AnswerText1: "We zitten op dit moment in",
    q18AnswerText2: ".",
    q19AnswerText1: "Wij verwachten dat onze kantoordichtheid (m2 per persoon) in de toekomst",
    q19AnswerText2: "zal zijn.",
    // Quiz Responses (questionUnitMap.js)
    q1ResponseText: "Duidelijk, dankjewel!",
    q2ResponseText: "Dat klinkt als een mooi bedrijf.",
    q3ResponseText: "Nemen we mee in het ontwerp voor je kantoor!",
    q4ResponseText: "Wij zorgen ervoor dat het kantoor daarbij past.",
    q5Response1Text: "Klinkt goed!",
    q5Response2Text: "Kan natuurlijk gebeuren.",
    q5Response3Text: "Top!",
    q5Response4Text: "Super!",
    q6Response1Text: "Ok\xe9, houden we rekening mee.",
    q6Response2Text: "Ok\xe9, houden we rekening mee.",
    q12ResponseLeadText: "Je bent bij ons aan het juiste adres.",
    q12ResponseClientText: "Fijn!",
    q12ResponseProfessionalText: "Dag collega!",
    // Industry Codes (industryCodes.js)
    animalProd: "Dierhouderij en visteelt",
    forestry: "Bosbouw en houtproductie",
    fishingHunting: "Visserij en jacht",
    agForestSupport: "Land- en bosbouw ondersteunende activiteiten",
    oilGas: "Olie- en gaswinning",
    energy: "Energie (gas, olie enz.)",
    mining: "Mijnbouw, met uitzondering van olie- en gaswinning",
    supportMining: "Mijnbouw ondersteunende activiteiten",
    utilities: "Nutsvoorzieningen",
    buildingConstruct: "Bouw",
    heavyCivilConstruct: "Weg- en waterbouw",
    specialtyContract: "Gespecialiseerde aannemers",
    foodManufac: "Levensmiddelenproductie",
    beverageTobaccoManufac: "Productie van dranken en tabaksproducten",
    textile: "Textielfabrieken",
    textileProduct: "Textielproductfabrieken",
    apparelManufac: "Kledingproductie",
    leatherManufac: "Productie van leer en aanverwante producten",
    woodManufac: "Fabricage van houtproducten",
    paperManufac: "Papierproductie",
    printingSupport: "Drukwerk en bijbehorende ondersteunende activiteiten",
    printingReproduc: "Drukwerk/reproducties",
    petroleumCoal: "Fabricage van petrochemische producten",
    chemicalManufac: "Chemische productie",
    chemicals: "Chemische stoffen",
    pharma: "Farmaceutische producten",
    cleaningManufac: "Vervaardiging van schoonmaakproducten",
    plasticsRubberManufac: "Vervaardiging van kunststof- en rubberproducten",
    nonmetallicManufac: "Vervaardiging van niet-metaalhoudende minerale producten",
    primaryMetalManufac: "Productie van primaire metalen",
    fabricatedMetalManufac: "Vervaardiging van bewerkte metaalproducten",
    machineryManufac: "Vervaardiging van machines",
    manufac: "Productie",
    computerElectronicManufac: "Vervaardiging van computer- en elektronicaproducten",
    electricalApplianceManufac: "Productie van elektronische apparaten",
    transportEquipManufac: "Productie van transportmiddelen",
    aerospaceDefense: "Ruimtevaart/defensie",
    furnitureManufac: "Vervaardiging van meubels en aanverwante producten",
    miscManufac: "Diverse productie",
    merchantWholesaleDurable: "Groothandel, duurzame goederen",
    merchantWholesaleNondurable: "Groothandel, niet-duurzame goederen",
    electronicMarket: "Elektronische markten en agenten en makelaars",
    motorVehiclePartsDealers: "Dealers van motorvoertuigen en onderdelen",
    furnitureFurnishingStores: "Winkels voor meubels en woninginrichting",
    electronicApplianceStores: "Elektronica- en witgoedwinkels",
    electronics: "Elektronica",
    buildingGardenSupplyStores: "Verkoop van bouw- en tuinmaterialen",
    foodBeverageStores: "Levensmiddelen- en drankenhandel",
    groceryStores: "Levensmiddelenhandel",
    beerWineLiquorStores: "Bier, wijn en sterkedrank",
    healthCareStores: "Winkels voor gezondheid en persoonlijke verzorging",
    gasStations: "Tankstations",
    clothingAccessoriesStores: "Kleding- en accessoirewinkels",
    clothingTextiles: "Kleding/textiel",
    jewelryFurs: "Sieraden en bont",
    sportsHobbyMusicBookStores: "Sport-, hobby-, muziekinstrument- en boekwinkels",
    genMerchandiseStores: "Algemene winkels",
    miscStoreRetailers: "Diverse winkels",
    officeProducts: "Kantoorartikelen",
    retailSales: "Detailhandel",
    nonstoreRetails: "Detailhandel zonder winkel",
    airTransport: "Luchtvervoer",
    travelRelated: "Reisbranche (luchtvaartmaatschappijen, agenten, openbaar vervoer)",
    railTransport: "Spoorvervoer",
    waterTransport: "Vervoer over water",
    truckTransport: "Vrachtwagentransport",
    transitTransport: "Openbaar personenvervoer",
    pipelineTransport: "Pijplijntransport",
    scenicTransport: "Toeristenvervoer",
    supportTransport: "Transport ondersteunende activiteiten",
    postalService: "Postdiensten",
    courierMessenger: "Koeriersdiensten",
    shippingDelivery: "Goederenvervoer en -bezorging",
    warehousingStorage: "Opslag",
    warehouseDistrib: "Opslag en distributie",
    publishingNoInternet: "Uitgeverijen, behalve internet",
    publishing: "Uitgeverij",
    motionPicSoundRecordingIndustries: "Film en geluidsopnamen",
    entertainment: "Entertainment (film, tv, muziek enz.)",
    infoServicesMarketResearch: "Informatiediensten/marktonderzoek",
    broadcastingNoInternet: "Televisie en radio (geen internet)",
    telecom: "Telecommunicatie",
    tech: "Technologie",
    dataProcessingHostingServices: "Dataverwerking, hosting en aanverwante diensten",
    otherInfoServices: "Overige informatiediensten",
    financeInsurance: "Financi\xebn en verzekeringen",
    monetaryAuthorities: "Monetaire autoriteiten - centrale bank",
    creditIntermediation: "Kredietbemiddeling en aanverwante activiteiten",
    banking: "Bankwezen",
    securitiesContractsInvestments: "Effecten, grondstoffenovereenkomsten, investeringen",
    financialServicesNoBanking: "Financi\xeble diensten (geen banken)",
    insuranceCarriersRelated: "Verzekeraars en aanverwante activiteiten",
    insurance: "Verzekering",
    fundsTrustsFinancialVehicles: "Fondsen, trusts en andere financi\xeble instrumenten",
    realEstate: "Vastgoed",
    rentalLeasingServices: "Verhuurdiensten",
    automotive: "Automotive",
    consumerGoods: "Consumentengoederen",
    lessorsNonfinancialIntangible: "Verpachters van niet-financi\xeble immateri\xeble activa",
    professionalTechnicalServices: "Professionele en technische diensten",
    legalServices: "Juridische dienstverlening",
    accounting: "Accounting",
    architectureEngineering: "Architectuur/techniek",
    specializedDesignServices: "Gespecialiseerde ontwerpdiensten",
    compRelatedServices: "Computerdienstverlening",
    mgmtConsulting: "Managementconsulting",
    scientificResearch: "Wetenschappelijk onderzoek",
    adsMarketingPR: "Reclame/marketing/public relations",
    otherProfSciTechServices: "Overige professionele, wetenschappelijke en technische diensten",
    companyEnterpriseMgmt: "Management van ondernemingen",
    adminSupportServices: "Administratieve en ondersteunende dienstverlening",
    employmentAgencyRecruiters: "Uitzendbureaus/recruiters",
    securityPrivateInvestigation: "Beveiliging/priv\xe9detectives",
    wasteMgmtRemediationServices: "Afvalverwerking en sanering",
    educationServices: "Onderwijsdiensten",
    education: "Onderwijs",
    ambulatoryHealthCareServices: "Ambulante gezondheidszorg",
    healthCareRelated: "Zorggerelateerde diensten",
    hospitals: "Ziekenhuizen",
    nursingResidentialCareFacilities: "Verpleging en woonzorglocaties",
    socialAssistance: "Sociale bijstand",
    performingArtsSpectatorSports: "Uitvoerende kunsten en publiekssport",
    museumsHistoricalSitesZoosParks: "Musea, monumenten, dierentuinen en parken",
    fineArtsGalleriesMuseums: "Galerie\xebn/musea",
    amusementsGamblingRec: "Amusement, kansspelen en recreatie",
    accommodation: "Huisvesting",
    foodDrinkingServices: "Gastronomie",
    restaurantHotel: "Restaurant/hotel",
    repairMaintenance: "Reparatie en onderhoud",
    industrialProductsHeavy: "Industri\xeble producten (zware industrie)",
    personalLaundryServices: "Wasserijen",
    membershipAssocOrgs: "Ledenorganisaties",
    nonprofit: "Non-profit",
    privateHouseholds: "Particuliere huishoudens",
    execLegisGenGvt: "Uitvoerende, wetgevende en algemene overheid",
    gvt: "Overheid",
    justicePublicOrderSafetyActivities: "Justitie, openbare orde en veiligheidsactiviteiten",
    hrAdminPrograms: "Beheer van personeelsprogramma\u2019s",
    environmentAdminPrograms: "Beheer van milieuprogramma\u2019s",
    environmental: "Milieu",
    communityHousingProgramAdmin: "Beheer van gemeenschaps- en huisvestingsprogramma\u2019s",
    econProgramAdmin: "Beheer van economische programma\u2019s",
    spaceResearchTech: "Ruimteonderzoek en -technologie",
    natlSecurityIntlAffairs: "Nationale veiligheid en internationale zaken"
};


var $fc90146d79b5d37b$exports = {};
$fc90146d79b5d37b$exports = {
    // AboutPageHero
    aboutPageHeroImgAlt: "Illustratie van mensen die in een kantoor trekken op de pagina Over ons van Spacer by CBRE",
    aboutPageHeroTitle: "De kracht van Spacer",
    // AboutPageContent
    aboutPageContentEndSectionTitle: "Klaar om te beginnen?",
    aboutPageProgramPreviewImgAlt: "Voorbeeld van resultatenpagina ruimteprogramma van de homepage van Spacer by CBRE",
    aboutPageVideoTitle: "Zo werkt Spacer",
    // About Page Content (aboutPageContent.js)
    aboutPageContent1Title: "De eerste stap naar h\xe9t kantoor \u2013\xa0en hybride werken",
    aboutPageContent1Text: "Gewild talent binnenhalen, collega's gezond houden, kosten verlagen en productiviteit verhogen: het perfecte kantoor doet alles voor je. Er hangt veel af van een huisvestingsbeslissing. Gelukkig helpt Spacer je aan een vliegende start. De toegankelijke en kosteloze online tool \u2013 ontworpen door het deskundige Workplace-team van CBRE \u2013 helpt je de ruimtebehoefte van je organisatie inventariseren, en geeft je kantoor een profiel met uitgebreide data-inzichten, nuttige benchmarks \xe9n praktische aanbevelingen. Hier kun je direct mee aan de slag. Bovendien is het de eerste stap op weg naar een toekomstbestendige hybride werkplekstrategie: inzicht over je vastgoed (bricks) is het ideale vertrekpunt om ook de behoeften rond technologie (bytes) en mensen (behavior) in kaart te brengen.",
    aboutPageContent1ImgAlt: "Illustratie van pratende mensen op de pagina Over ons van Spacer by CBRE",
    aboutPageSpacerSupportLink: "spacersupport@cbre.com",
    aboutPageContent2Title: "Zo gebruik je Spacer",
    aboutPageContent2List1: "Beantwoord 17 vragen over de doelen en waarden van je organisatie. Op basis van je antwoorden, krijgt je kantoor een profiel.",
    aboutPageContent2List2: "Je krijgt van ons een ruimteprogramma: een lijst met kantoorkenmerken die passen bij je organisatie en behoeften.",
    aboutPageContent2List3: "Visualiseer je ideale ruimte met 2D- \xe9n 3D-plattegronden.",
    aboutPageContent2List4: "Sla je programma op: zo kun je het gebruiken bij je zoektocht naar een ideaal kantoor en passende hybride werkplekstrategie.",
    aboutPageContent2List5: "Schakel de expertise in van een professional van CBRE. Deze kan je helpen aan een passende kantoorruimte of je begeleiden naar een toekomstbestendige en breedgedragen hybride werkplekstrategie.",
    aboutPageContent2Text: "Meer weten over de rol die Spacer kan spelen voor jouw perfecte kantoor? Neem contact met ons op via ",
    aboutPageContent2ImgAlt: "Illustratie van een jonge vrouw die werkt aan een bureau op de pagina Over ons van Spacer by CBRE"
};


var $7ce6a0456b28a1aa$exports = {};
$7ce6a0456b28a1aa$exports = {
    referralStep: " Stap {{step}} van 4",
    forgotReferralLink: "Doorverwijzingslink vergeten?",
    howReferralLinksWorkTitle: "Zo werken doorverwijzingslinks",
    enterYourInformation: "Vul je gegevens in",
    confirmYourInformation: "Bevestig je gegevens",
    referralLinkStep1: "Om een doorverwijzingslink te maken, hebben we het volgende nodig:",
    referralLinkReq1: "- Je naam",
    referralLinkReq2: " - Het mailadres dat je van CBRE hebt gehad",
    referralLinkStep2: "Als een opdrachtgever de vragenlijst via jouw doorverwijzingslink invult, mailen we jou een kopie van de resultaten.",
    next: "Volgende",
    firstName: "Voornaam",
    lastName: "Achternaam",
    emptyNameError: "Voer een naam in",
    email: "Je CBRE-e-mailadres",
    emptyEmailError: "Voer een CBRE-e-mailadres in",
    emailTakenError: "Dat e-mailadres is al gekoppeld aan {{takenLink}}",
    emailExample: "bijv. jane.smith@cbre.com",
    editReferralInfo: "Bewerk de opgegeven naam- en e-mailgegevens",
    noLaterChanges: "Je kunt dit later niet meer wijzigen.",
    somethingWrong: "Oeps. Er is bij ons iets misgegaan. Probeer het nog eens.",
    contentLoading: "Inhoud wordt geladen",
    linkReady: "Je link is klaar",
    storeLinkInstructions: "Bewaar deze link op een veilige plek, zodat je hem steeds kunt gebruiken om Spacer met klanten te delen. We hebben deze link ook naar het door jou opgegeven e-mailadres gestuurd.",
    yourLink: "Jouw doorverwijzingslink",
    copyLink: "Doorverwijzingslink kopi\xebren",
    copiedLink: "Gekopieerd naar klembord",
    linkNeverExpires: "Denk eraan: deze link verloopt nooit.",
    linkFound: "We hebben je link gevonden",
    emailNotAssociated: "We konden geen doorverwijzingslink vinden die aan dat e-mailadres is gekoppeld.",
    createLink: "Wil je er een maken?"
};


var $1587cf7de52e9d32$exports = {};
$1587cf7de52e9d32$exports = {
    blogHomeTitle: "Inzichten kantoorplanning",
    // blog tags
    blogTagAllArticles: "Alle artikelen",
    blogTagSizeAndFit: "Passende grootte",
    blogTagOfficeCulture: "Kantoorcultuur",
    blogTagSpaceAndDesign: "Ruimte en ontwerp",
    blogTagWorkplaceTrends: "Trends op de werkplek"
};


var $26b5f5598ab567c1$exports = {};
$26b5f5598ab567c1$exports = {
    // LandingPageHero
    landingPageHeroTitle: "Perm\xedtanos ayudarle a planificar el lugar de trabajo del futuro y a encontrar el espacio adecuado para su pr\xf3xima oficina",
    landingPageHeroSubtitle: "El mundo del trabajo est\xe1 cambiando debido a la reciente pandemia- reciba su recomendaci\xf3n de espacios personalizados con nuestra herramienta gratuita",
    landingPageHeroImgAlt: "Vista previa de un programa espacial de la p\xe1gina de resultados de Spacer por CBRE",
    landingPageImage: "/png/homepage-results-page-in-browser-spacer-by-cbre.png",
    // LandingPageContent
    landingPageContentTitle: "\xbfC\xf3mo funciona?",
    // StepsSummary
    stepsSummarySubtitle1: "Paso 1 -",
    stepsSummaryTitle1: "Cu\xe9ntenos sobre su empresa",
    stepsSummaryText1: "Ay\xfadenos a conocer sus metas y objetivos como empresa para que podamos hacer recomendaciones espec\xedficas para usted.",
    stepsSummaryImgAlt1: "Ilustraci\xf3n de personas de pie sobre un port\xe1til gigante en la p\xe1gina de inicio de Spacer por CBRE",
    stepsSummarySubtitle2: "Paso 2 -",
    stepsSummaryTitle2: "Obtenga sus resultados",
    stepsSummaryText2: "En funci\xf3n de sus respuestas, recibir\xe1 un tama\xf1o de oficina recomendado y una lista de tipos de espacios individuales con cantidades de cada uno. Incluso puede ver planos del dise\xf1o de la planta como ejemplo.",
    stepsSummaryImgAlt2: "Ilustraci\xf3n de un bloque de un barrio en la p\xe1gina de inicio de Spacer por CBRE",
    stepsSummarySubtitle3: "Paso 3 -",
    stepsSummaryTitle3: "Encuentre su oficina perfecta",
    stepsSummaryText3: "Guarde sus resultados para consultarlos durante la b\xfasqueda de oficinas o contacte el equipo de Spacer para que uno de nuestros consultores lo pueda ayudar a encontrar su oficina perfecta",
    stepsSummaryImgAlt3: "Ilustraci\xf3n de una mujer trabajando en un escritorio en la p\xe1gina de inicio de Spacer de CBRE",
    // LandingPageSecondaryHero
    landingPageSecondaryHeroImgAlt: "Ilustraci\xf3n de personas construyendo recomendaciones de espacio en la p\xe1gina de inicio de Spacer de CBRE",
    landingPageSecondaryHeroTitle: "Cu\xe9ntenos un poco m\xe1s de su compa\xf1\xeda. Nosotros le contaremos cu\xe1nto espacio de oficinas necesita."
};


var $c7c85b93866b8b85$exports = {};
$c7c85b93866b8b85$exports = {
    // Navbar
    spacerLogoAlt: "Spacer de CBRE.",
    linkToAboutPageText: "Acerca ",
    linkToBlogPageText: "Perspectivas",
    referrals: "Referencias",
    // TakeOfficeSpaceQuizButton
    sizeMyOfficeButtonDefaultLinkText: "Realice el cuestionario sobre los espacios de la oficina",
    flooredPlanRequestLinkText: "Solicite su plano",
    // Footer
    footerCBRELogoAlt: "Logotipo de CBRE para Spacer de CBRE",
    footerFacebookIconAlt: "\xcdcono social de Facebook para Spacer de CBRE",
    footerTwitterIconAlt: "\xcdcono social de Twitter para Spacer de CBRE",
    footerLinkedinIconAlt: "\xcdcono social de LinkedIn para Spacer de CBRE",
    footerHeaderQuestionsText: "\xbfPreguntas?",
    footerHeaderAboutText: "Recursos ",
    footerHeaderMoreText: "M\xe1s ",
    footerHeaderBrokersText: "Para los corredores ",
    footerLinkWhatIsSpacerText: "Acerca de",
    footerLinkBlogText: "Perspectivas",
    footerLinkWorkplaceText: "\xbfQui\xe9n es el Centro de Trabajo de CBRE?",
    footerLinkTermsText: "Condiciones de Servicio ",
    footerLinkPrivacyText: "Pol\xedtica de privacidad ",
    footerLinkedinLink: "https://www.linkedin.com/showcase/cbre-workplace-strategy/",
    footerLinkReferralText: "Referencias ",
    footerWorkplaceLink: "http://www.cbre.us/real-estate-services/occupier/workplace",
    footerPrivacyLink: "https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy",
    // Contact (contact.js)
    spacerSupportEmail: "spacersupport@cbre.com",
    // ErrorPage
    errorOopsText: "\xa1Ups!",
    error404Text: "\xa1No podemos encontrar la p\xe1gina que est\xe1 buscando!",
    error500Text: "Algo sali\xf3 mal por parte nuestra",
    errorText: "Error",
    errorReturnText: "Volver al Spacer",
    errorAltText: "Ilustraci\xf3n de una taza de caf\xe9 derramada por Spacer de CBRE",
    // Measurement Units (units.js)
    SF: "SF",
    SM: "m\xb2",
    USF: "USF",
    USM: "USM",
    RSF: "RSF",
    RSM: "RSM",
    NSF: "NSF",
    NSM: "NSM",
    NIA: "NIA",
    foot: "pie",
    feet: "pies",
    footage: "metraje",
    "sqft.": "pies cuadrados (ft2).",
    meter: "metro",
    meters: "metros ",
    "sqm.": "metros cuadrados (m\xb2)",
    Tsubo: "tsubo",
    // SF Types Adjectives (calculator.js)
    Usable: "Usable",
    Rentable: "Rentable",
    Net: "Neta",
    // Page Titles (documentDataCopy.js)
    landingPageTitle: "Planifique su oficina perfecta en 15 minutos - Spacer de CBRE",
    aboutPageTitle: "Conozca c\xf3mo funciona nuestra herramienta de dimensionamiento de oficinas - Spacer de CBRE",
    termsPageTitle: "Condiciones de servicio - Spacer de CBRE",
    quizPageTitle: "Dimensione su oficina en 15 minutos - Spacer de CBRE",
    resultsPageTitle: "Ver recomendaciones de oficina personalizada - Spacer de CBRE",
    profileComparisonPageTitle: "Compare sus necesidades de oficina - Spacer por CBRE",
    blogHomePageTitle: "Ideas para la planificaci\xf3n de oficinas - Spacer por CBRE",
    referralPageTitle: "Enlace de referencia para corredores de CBRE - Spacer por CBRE",
    referralRetrievePageTitle: "Recuperar enlace de referencia para los corredores de CBRE - Spacer por CBRE",
    // Meta Tags (documentDataCopy.js)
    landingPageMetaTagText: "\xbfEst\xe1 planeando su pr\xf3xima oficina? Deje que Spacer por CBRE le ayude a determinar de forma r\xe1pida y sencilla la cantidad de espacio de oficina que necesita para alcanzar sus objetivos empresariales. S\xf3lo le llevar\xe1 15 minutos.",
    aboutPageMetaTagText: "El tama\xf1o de su oficina puede ayudarle a atraer talento, reducir costos e incluso mantener a sus empleados sanos. Conozca m\xe1s sobre c\xf3mo Spacer puede recomendar r\xe1pidamente el tama\xf1o de oficina adecuado para apoyar los objetivos de su empresa.",
    termsPageMetaTagText: "M\xe1s de una d\xe9cada de conocimientos y experiencia en el sector se ha invertido en la creaci\xf3n de Spacer por CBRE, el cual hace recomendaciones informadas sobre el tama\xf1o de las oficinas en cuesti\xf3n de minutos.",
    quizPageMetaTagText: "Realice el test de 15 minutos de Spacer para determinar cu\xe1nto espacio de oficina necesita para apoyar los objetivos y prioridades de su empresa. La programaci\xf3n personalizada nunca ha sido tan r\xe1pida.",
    resultsPageMetaTagText: "Los resultados de los espacios personalizados de Spacer le ahorran tiempo en la b\xfasqueda de oficinas, ya que le dan el tama\xf1o exacto de oficina que su empresa necesita, junto con los tipos de muebles y dise\xf1os sugeridos para la distribuci\xf3n de la planta.",
    profileComparisonPageMetaTagText: "Comprenda sus necesidades \xfanicas de oficina en comparaci\xf3n con las de otros utilizando Spacer por CBRE",
    blogHomePageMetaTagText: "Calcular el espacio de oficina que necesita una empresa no es una ciencia perfecta, pero estas ideas y recursos de planificaci\xf3n de oficinas pueden ayudar. Obtenga m\xe1s informaci\xf3n aqu\xed.",
    referralPageMetaTagText: "Utilice este link de enlace para enviar Spacer a los clientes y asegurarse de que los resultados de su espacio se env\xedan directamente a su correo electr\xf3nico. Obtenga m\xe1s informaci\xf3n aqu\xed.",
    referralRetrieveMetaTagText: "Recupere su enlace de referencia para Spacer.",
    // Form title
    formLabel: "Su informaci\xf3n"
};


var $0a636378a48da627$exports = {};
$0a636378a48da627$exports = {
    // Results
    resultsWarningMessage: "\xbfEst\xe1 seguro de que quiere abandonar esta p\xe1gina? Puede perder la informaci\xf3n que no haya guardado.",
    // ResultsHeader
    resultsHeaderExportPDFButtonText: "Exportar a PDF",
    resultsHeaderSendButtonText: "Enviar resultados",
    resultsHeaderClipboardBoxDescription: "Cualquiera con este enlace puede ver y editar los resultados",
    resultsHeaderContactButtonText: "Contactar a un consultor",
    // EmailWallSection
    emailWallTitle: "Hay m\xe1s esperando por usted",
    emailWallSubtitle: "Ingrese su nombre y correo electr\xf3nico abajo para ver una recomendaci\xf3n completa de espacio y personalizar sus resultados",
    emailWallFirstNamePlaceholder: "Nombre",
    emailWallLastNamePlaceholder: "Apellido",
    emailWallEmailPlaceholder: "Su correo electr\xf3nico",
    emailWallCBREEmailPlaceholder: "Su correo corporativo de CBRE (opcional)",
    emailWallLeasingProfessionalPlaceholder: "Su profesional de CBRE",
    emailWallConnectMeText: "Contactar me con un consultor inmobiliario personal.  Si newsletters ni spam, \xa1lo prometemos!",
    emailWallContactNoticeText: "El equipo de Spacer se contactar\xe1 con usted para obtener lo mejor de su programa. Sin spam, \xa1lo prometemos!",
    emailWallResultsButtonText: "Ver resultados completos",
    emailWallImgAltText: "Vista previa de una p\xe1gina de resultados de programa del muro de Spacer de CBRE",
    emailWallFirstNameInvalid: "Por favor ingrese su nombre.",
    emailWallLastNameInvalid: "Por favor ingrese su apellido.",
    emailWallEmailInvalid: "Por favor ingrese una direcci\xf3n de correo v\xe1lida.",
    // CopyToClipboardBox
    clipboardBoxCopyText: "Copiar",
    clipboardBoxCopiedText: "Copiado",
    // FormModal
    formModalFindSpaceHeader: "Empezar la b\xfasqueda de oficina",
    formModalFindSpaceBody: "Spacer es una herramienta r\xe1pida y f\xe1cil para el an\xe1lisis del espacio de trabajo, sin embargo, si usted requiere algo m\xe1s personalizado, permita que CBRE Workplace le ayude. Diligencie este formato y un profesional de Workplace lo contactar\xe1 dentro de las pr\xf3ximas 48 horas para hablar.",
    formModalFindSpaceSuccessMessage: "Su solicitud ha sido enviada.",
    // SuccessModal
    successModalTitle: "\xa1\xc9xito!",
    // ContactForm
    contactFormFirstNameLabel: "Nombre",
    contactFormLastNameLabel: "Apellido",
    contactFormEmailLabel: "Correo electr\xf3nico corporativo",
    contactFormPhoneLabel: "N\xfamero de tel\xe9fono",
    contactFormMessageLabel: "Cu\xe9ntenos m\xe1s sobre lo que est\xe1 buscando",
    contactFormSubmitText: "Enviar",
    // AcceptTermsText
    acceptTermsText: "Yo acepto el <1> T\xe9rminos y condiciones . </1>. Para mayor informaci\xf3n en el uso de sus datos, por favor refi\xe9rase a la <3>Pol\xedtica de Privacidad de CBRE.</3>.",
    privacyPolicyLink: "https://www.cbre.com/about-us/global-web-privacy-and-cookie-policy",
    // Form
    formErrorText: "Ups, ocurri\xf3 un error. \xa1Por favor trate nuevamente!",
    formEmailInvalid: "Por favor ingrese una direcci\xf3n de correo v\xe1lida.",
    // FormInput
    formInputOptionalText: "  (opcional)",
    // LegalForm
    legalFormCheckboxText: "CBRE puede ponerse en contacto con usted para ofertas e informaci\xf3n relacionada con el uso de Spacer.",
    legalFormContactWarningText: "El equipo de Spacer se contactar\xe1 con usted para obtener lo mejor de su programa. Sin spam, \xa1lo prometemos!",
    // NextStepsSection
    nextStepsSectionSubtitle: "\xbfListo para dar el siguiente paso?",
    nextStepsSectionTitle: "Encuentre la oficina perfecta.",
    nextStepsSectionButtonText: "Cont\xe1ctese con un consultor",
    nextStepsSectionImgAlt: "Ilustraci\xf3n de personas conversando en la p\xe1gina de resultado de Spacer de CBRE",
    // Profile
    resultsProfileSummaryTitle: "Su oficina \u2014",
    resultsProfileTooltipText: "Cada perfil es una combinaci\xf3n de organizaciones y lugares de trabajo reales; los detalles se compararon con los par\xe1metros de la industria y el conocimiento del mercado exclusivo de CBRE Workplace.",
    // Program
    programSaveConfirmationBoxText: "Est\xe1 listo. V\xeda correo electr\xf3nico le enviamos un enlace a sus resultados. \xa1Disfrute!",
    programExamplePlansTitle: "Planos ejemplo",
    programExamplePlansSubtitle: "Disfrute los planos de planta interactivos que coinciden con su perfil. \xa1Incluso puede explorarlos en 3D!",
    programTooMuchTinkerWarning: "\xa1Alto ah\xed! Parece que est\xe1 fuera del rango recomendado seg\xfan su perfil. Considere la posibilidad de <1>volver a realizar el cuestionario</1> o ponerse en contacto con el servicio de asistencia t\xe9cnica en <3>{{email}}</3>..",
    programDisclaimer: 'Spacer de CBRE se proporciona "tal cual" y "seg\xfan disponibilidad" sin garant\xedas. Todos los resultados generados a partir de su uso de Spacer son solo para fines ilustrativos y no reflejan recomendaciones de espacio reales ni t\xe9rminos de arrendamiento sugeridos. Las recomendaciones de espacio reales pueden variar mucho y depender\xe1n de muchos factores que Spacer no tiene en cuenta. Al usar Spacer, o cualquier informe generado por el uso de Spacer, usted acepta nuestros T\xe9rminos de servicio y Pol\xedtica de privacidad ubicados respectivamente en las URL https://workplace.cbre.com/termsOfService y https://www.cbre.us/about /pol\xedtica de privacidad. \xa9 2018 CBRE, Inc. Todos los derechos reservados.',
    programMetricsTitle: "M\xe9tricas del programa",
    programMetricsSubtitle: "Estos n\xfameros resumen su entorno de trabajo",
    programDetailsSectionTitle: "Personalice su programa",
    programDetailsSectionSubtitle: "Ajuste los campos a continuaci\xf3n para perfeccionar sus necesidades de espacio.",
    programRevertButtonText: "Revierta",
    programSaveButtonText: "Guardar cambios",
    programSavedButtonText: "Guardado",
    // ProgramAssumptions
    programAssumptionsRecommendedOfficeSizeText: "Tama\xf1o de oficina recomendado",
    programAssumptionsProfileText: "Perfil",
    programAssumptionsHeadcountText: "N\xfamero de empleados",
    programAssumptionsHeadcountFollowingText: "personas",
    programAssumptionsCollabText: "Colaboraci\xf3n",
    programAssumptionsCirculationText: "Circulaci\xf3n",
    programAssumptionsAvgDaysText: "Promedio de d\xedas en la oficina",
    programAssumptionsAvgDaysFollowingText: "Por semana",
    programAssumptionsAvgDaysPerWeekText: "Promedio de d\xedas en la oficina por semana",
    // ProgramHeroForPrint
    printNIAText: "\xc1rea Interna Neta",
    printUSFText: "Pies Cuadrados usables",
    printRSFText: "Pies Cuadrados rentables",
    printDescText: "Seg\xfan sus datos y un {{lossFactorPercentage}}% {{factorType}} en {{city}}, recomendamos un total de:",
    printFitFactorText: "Factor de ajuste",
    printLossFactorText: "Factor de p\xe9rdida",
    // BarChart
    barChartIndivSubtitle: "Espacio individual",
    barChartGroupSubtitle: "Espacio grupal",
    barChartAmenitySubtitle: "Espacio de comodidad",
    // TabbedProgramBarChart
    tabbedBarChartMeSubtitle: "Individual",
    tabbedBarChartGroupSubtitle: "Grupo",
    tabbedBarChartAmenitySubtitle: "Servicios",
    // SpaceCategoryBreakdown
    spaceCatBreakdownSubtitle: "Seleccione un tipo de espacio para personalizar",
    // SpaceCategoryBreakdownMobile
    spaceCatBreakdownMobileMeTitle: "Espacio individual",
    spaceCatBreakdownMobileWeTitle: "Espacio grupal",
    spaceCatBreakdownMobileAmenityTitle: "Espacio de comodidad",
    spaceCatBreakdownMobileMeSubtitle: "Para trabajar solo",
    spaceCatBreakdownMobileWeSubtitle: "Para trabajar juntos",
    spaceCatBreakdownMobileAmenitySubtitle: "Para todo lo dem\xe1s",
    spaceCatBreakdownMobileNIATotalTitle: "\xc1rea Interna Neta Total",
    spaceCatBreakdownMobileTotalTitle: "Total {{sfType}} Cuadrado {{unitCapitalized}}",
    spaceCatBreakdownMobileCirculationText: "Circulaci\xf3n",
    // SpaceCategoryDropdown
    spaceCatDropdownMeText: "Espacio individual",
    spaceCatDropdownWeText: "Espacio grupal",
    spaceCatDropdownAmenityText: "Espacio de servicios",
    // SidebarInfo
    sidebarInfoMeTitle: "Individual",
    sidebarInfoWeTitle: "Grupal",
    sidebarInfoAmenityTitle: "Servicios",
    // Space Category Descriptions (spaceCategoryDescription.js)
    spaceCatMeDesc: "Espacio para trabajo individual. Ofrecer opciones sobre d\xf3nde y c\xf3mo trabajan sus empleados conduce a una mayor satisfacci\xf3n de los empleados.",
    spaceCatWeDesc: "Espacio para colaboraci\xf3n y trabajo en equipo. En una era en la que el trabajo puede realizarse en cualquier lugar, es importante proporcionar diferentes espacios que se adapten a una variedad de tareas.",
    spaceCatAmenityDesc: "Espacio que apoya el trabajo. Excelentes comodidades har\xe1n que su oficina sea un lugar en el que sus empleados (y reclutas) deseen pasar tiempo.",
    // Suggested Custom Amenities (suggestedCustomAmenityUnitMap.js)
    audioVisualCustom: "Audio / Visual",
    dataCenterCustom: "Data Center",
    buildingSupportCustom: "Servicios de apoyo a la construcci\xf3n",
    foodServiceCustom: "Completo Servicio de comida",
    kitchenCustom: "Cocina",
    serveryCustom: "Servidor",
    execDiningCustom: "Comedor ejecutivo",
    grabNGoCustom: "Para llevar",
    juiceCoffeeBarCustom: "Barra de jugos / Barra de caf\xe9",
    childCareCustom: "Cuidado de los ni\xf1os",
    fitnessCenterCustom: "Gimnasio",
    healthCenterCustom: "Centro de salud",
    mailCenterCustom: "Centro de correo",
    commercialPrintCustom: "Sala de impresi\xf3n comercial",
    centralCafeCustom: "Cafeter\xeda central",
    securityCtrlCustom: "Sala de control de seguridad",
    auditoriumCustom: "Auditorio",
    dryCleaningLaundryCustom: "Lavander\xeda",
    confCenterCustom: "Centro de conferencias",
    multiPurpTrainingCustom: "Multiusos/Entrenamiento",
    informalCollabCustom: "Colaboraci\xf3n Informal",
    touchdownTeamCustom: "Anotaci\xf3n / Equipo",
    // Suggested Custom Amenity Units (spaceUnit.js)
    seats: "silla",
    seats_plural: "sillas",
    rooms: "sala",
    rooms_plural: "salas",
    areas: "\xe1rea",
    areas_plural: "\xe1reas",
    units: "unidad",
    units_plural: "unidades",
    // Predefined Amenities (spaceUnitMap.js) - Shared Space Units
    focusRoomDefined: "Sala de concentraci\xf3n",
    fileRoomDefined: "Cuarto de archivo",
    centralReceptionHubDefined: "Centro de recepci\xf3n central",
    smOfficeDefined: "Oficina peque\xf1a",
    regOfficeDefined: "Oficina regular",
    benchDesk5Defined: "5\u2019  Escritorio",
    benchDesk6Defined: "6\u2019  Escritorio",
    meetingRoom4Defined: "Sala de Reuniones (4 personas)",
    meetingRoom6Defined: "Sala de Reuniones (6 personas)",
    meetingRoom8Defined: "Sala de Reuniones (8 personas)",
    meetingRoom12Defined: "Sala de Reuniones (12 personas)",
    meetingRoom15Defined: "Sala de Reuniones (15 personas)",
    semiEnclosedMeetingBooth4Defined: "Cabina de Reuniones semicerrada (4 personas)",
    openCollabSpace4to6Defined: "Espacio abierto de colaboraci\xf3n (4-6 personas)",
    contemplationSpaceDefined: "Espacio de contemplaci\xf3n",
    mainITEquipRoomDefined: "Servidor principal de TI/Sala de equipos",
    receptionAreaDefined: "\xc1rea de recepci\xf3n",
    cafeFoodServiceDefined: "Cafeter\xeda / Servicio de comida",
    teamStorageDefined: "Almacenamiento de equipo",
    coatClosetsDefined: "Armarios para abrigos",
    genStorageDefined: "Almacenamiento general (almacenes y entrada/salida de mercanc\xedas)",
    centralisedCopyPrintMailDefined: "Copia, impresi\xf3n y correo centralizados",
    specialResourceAreaDefined: "\xc1rea de recursos especiales",
    personalStorageDefined: "Almacenamiento Personal (Lockers)",
    storageITSpaceDefined: "Espacio de Almacenamiento TI",
    secondaryServerRoomDefined: "Servidor Secundario / Cuarto de Telecomunicaciones",
    mothersRoomDefined: "Sala de Lactancia",
    buildITSpaceDefined: "Cuarto de TI",
    workerCouncilOffice2Defined: "Oficina de Consejo a Trabajador (2 personas)",
    securityCtrlRoomDefined: "Cuarto de Control de Seguridad",
    centralisedMailDefined: "Centralizaci\xf3n de Correo",
    visitorCoatLuggageRoomDefined: "Armario de Abrigos / Equipaje Visitantes",
    wellnessRoomDefined: "Cuarto de Bienestar",
    internalStairDefined: "Escalera interna",
    commercialPrintRoomDefined: "Cuarto de Impresi\xf3n Comercial",
    buildingSupportServicesAreaDefined: "\xc1rea de servicios de apoyo al edificio",
    // Predefined Amenities (spaceUnitMap.js) - US_SMALL and US_REGULAR
    officeDefined: "Oficina",
    lgOfficeDefined: "Oficina (grande)",
    smWorkstationDefined: "Puesto de Trabajo (peque\xf1o)",
    mdWorkstationDefined: "Puesto de Trabajo (mediano)",
    lgWorkstationDefined: "Puesto de Trabajo (grande)",
    huddleRoomDefined: "Sala de reuniones",
    dispersedCopyPrintAreaDefined: "\xc1rea de Copiado / Impresi\xf3n",
    smMeetingRoomDefined: "Sala de Reuniones Peque\xf1a",
    mdMeetingRoomDefined: "Sala de Reuniones Mediana",
    lgMeetingRoomDefined: "Sala de Reuniones Grande",
    xlMeetingRoomDefined: "Sala de Reuniones Extragrande / Sala de Juntas",
    multiPurpTrainingDefined: "Multi prop\xf3sito / Entrenamiento",
    informalCollabDefined: "\xc1rea de Colaboraci\xf3n Informal",
    touchdownTeamDefined: "\xc1rea de Equipo",
    pantryVendingCoffeeAreaDefined: "Punto de Caf\xe9",
    workplaceStorageRoomDefined: "Sala de Almacenamiento en espacio de trabajo",
    employeeCoatAreaDefined: "\xc1rea de Abrigos para Empleados",
    dispersedMailAreaDefined: "\xc1rea de Correos",
    lockerUnitDefined: "Unidad de Locker",
    serverRoomDefined: "Cuarto de Servidor",
    frontDeskAreaDefined: "\xc1rea de Recepci\xf3n",
    centralCafeAreaDefined: "\xc1rea Central de Caf\xe9",
    mailCenterAreaDefined: "\xc1rea de Centralizaci\xf3n de Correos",
    kitchenAreaDefined: "\xc1rea de Cocina",
    drawerLateralFileUnitDefined: "Archivador Lateral de 3 Cajones",
    serveryAreaDefined: "\xc1rea de Servicio",
    juiceBarCoffeeShopAreaDefined: "Barra de Jugos / Caf\xe9",
    diningSupportAreaDefined: "Espacio Soporte de Comedor",
    diningAreaDefined: "\xc1rea de Comedor",
    grabNGoAreaDefined: "\xc1rea de Snacks",
    focusRoomSharedFocus: "Cuarto de Enfoque / Concentraci\xf3n",
    // Predefined Amenities (spaceUnitMap.js) - UK_REGULAR
    fullFoodServiceDefined: "Servicio Completo de Comida",
    // Predefined Amenities (spaceUnitMap.js) - APAC_REGULAR
    officeWorkMeetDefined: "Oficina (Trabajo/Reuni\xf3n)",
    lgOfficeWorkMeetDefined: "Oficina Grande (Trabajo/Reuni\xf3n)",
    focusDefined: "Concentraci\xf3n / Enfoque",
    bench1pt6Defined: "Banca de 1.6",
    bench1pt8Defined: "Banca de 1.8",
    bench1pt8LDefined: 'Puesto de Trabajo 1.8  en "L"',
    banquetWorkMeetDefined: "Mesa Trabajo/Reuni\xf3n (2p)",
    cafeTable4Defined: "Mesa de Caf\xe9 (4p)",
    kitchenTable8to10Defined: "Mesa de Cocina (8-10p)",
    standingWhiteboardDefined: "Tablero / Pizarra",
    huddleRoom3Defined: "Sala de Reuniones (3p)",
    smMeetingRoom5Defined: "Sala de Reuniones Peque\xf1a (5p)",
    mdMeetingRoom8Defined: "Sala de Reuniones Mediana (8p)",
    lgMeetingRoom20Defined: "Sala de Reuniones Grande (20p)",
    xlBoardroom: "Extragrande / Sala de Juntas",
    wellnessRoomsDefined: "Salas de Bienestar",
    employeeCoatsGymLockersDefined: "Abrigos de Empleados / Lockers del Gimnasio",
    lockersDefined: "Lockers",
    dispersedCopyPrintScanAreaDefined: "\xc1rea de Copiado / Impresi\xf3n / Esc\xe1ner",
    hydrationPointDefined: "Punto de Hidrataci\xf3n (Agua / T\xe9 / Caf\xe9)",
    centralHighDensityStorageDefined: "Almacenamiento Central de Alta Densidad",
    wellnessMothersRoomDefined: "Bienestar / Sala de Lactancia",
    serverHubRoomsDefined: "Servidor / Sala Central",
    buildITStoreRoomDefined: "Cuarto de TI / Almacenamiento",
    simpleReceptionWaitDefined: "Recepci\xf3n + Sala de Espera",
    centralCafeSocialHubDefined: "Caf\xe9 Central - Zona Social",
    mailCentreDefined: "Centro de Correos",
    utilityStoreRoomDefined: "Cuarto de Servicios",
    drawerLateralFileDefined: "Archivador Lateral de 3 Cajones",
    juiceBarCoffeeShopDefined: "Bar de Jugos / Caf\xe9",
    buildingSupportServicesDefined: "Servicios de Soporte del Edificio",
    // Space Unit Map Descriptions (spaceUnitMap.js) - Shared Descriptions
    focusRoomDesc: "Las Salas de Enfoque son espacios cerrados destinados a apoyar el trabajo concentrado y/o confidencial normalmente para una o dos personas. La privacidad ac\xfastica es primordial en estos espacios. Las salas de enfoque generalmente no est\xe1n asignadas y se pueden reservar temporalmente seg\xfan sea necesario para el trabajo relevante.",
    fileRoomDesc: "Este es el cuarto de almacenamiento de archivos para individuos y equipos. Como resultado de los esfuerzos de digitalizaci\xf3n de la mayor\xeda de las oficinas la necesidad de almacenamiento de archivos, tanto individuales como de equipo, est\xe1 disminuyendo considerablemente. A\xfan as\xed, este es un espacio central para copias de documentos requeridos legalmente o materiales de proyectos a largo plazo, especialmente con la mayor\xeda de los escritorios de oficina abiertos que contienen poco espacio de almacenamiento.",
    centralReceptionHubDesc: "El \xe1rea de recepci\xf3n es la primera oportunidad de su empresa para impresionar a los empleados, clientes y otros visitantes. Debe reflejar consistentemente la marca de la empresa y proyectar la apariencia deseada. El mostrador de la recepci\xf3n debe acomodar c\xf3modamente a un recepcionista; los asientos suaves deben invitar a los visitantes.",
    officeDesc: "Las oficinas son espacios de trabajo individuales, cerrados y privados para los empleados. Son excelentes para reducir la distracci\xf3n y permiten llevar a cabo el trabajo de concentraci\xf3n. Las oficinas suelen estar equipadas con un escritorio y un asiento de trabajo junto con asientos para invitados. Encontrar\xe1 cantidades variables de almacenamiento personal y archivo en las oficinas. El tama\xf1o del espacio tambi\xe9n puede variar seg\xfan las actividades que se realicen en la sala (p. ej., reuniones peri\xf3dicas) o el estado/jerarqu\xeda de los empleados.",
    benchDeskDesc: 'Los "escritorios de banco" son asientos de trabajo individuales abiertos. Los empleados de tiempo completo pueden usar "escritorios de banco" m\xe1s peque\xf1os, ya sea temporalmente (en un espacio de direcci\xf3n libre) o permanentemente. Estos escritorios tambi\xe9n son excelentes para los empleados o contratistas visitantes que no est\xe1n en la oficina todo el tiempo. Algunas ventajas de los escritorios abiertos son la visibilidad de la oficina y la colaboraci\xf3n inherente. Una desventaja puede ser la distracci\xf3n del ruido, por lo que se recomienda que las oficinas con "escritorios de banco" abiertos tengan muchas salas de concentraci\xf3n y reuni\xf3n. La presentaci\xf3n en el escritorio se limita a la presentaci\xf3n comunitaria probablemente ubicada en todo el piso.',
    meetingRoomDesc: "Las salas de reuniones son espacios cerrados destinados a reuniones de grupos peque\xf1os de 2 a 4 personas. Deben estar equipados con equipos de A/V y pizarras blancas para facilitar el intercambio de conocimientos y deben ser ac\xfasticamente privados (las personas que se sientan inmediatamente fuera de la sala no deben poder escuchar las conversaciones que se desarrollan en el interior).",
    meetingRoomDesc6: "Las salas de reuniones son espacios cerrados destinados a reuniones de grupos peque\xf1os de 2 a 4 personas. Deben estar equipados con equipos de A/V y pizarras blancas para facilitar el intercambio de conocimientos y deben ser ac\xfasticamente privados (las personas que se sientan inmediatamente fuera de la sala no deben poder escuchar las conversaciones que se desarrollan en el interior).",
    meetingRoomDesc8: "Las salas de reuniones son espacios cerrados destinados a reuniones de grupos peque\xf1os de 2 a 4 personas. Deben estar equipados con equipos de A/V y pizarras blancas para facilitar el intercambio de conocimientos y deben ser ac\xfasticamente privados (las personas que se sientan inmediatamente fuera de la sala no deben poder escuchar las conversaciones que se desarrollan en el interior).",
    meetingRoomDesc12: "Las salas de reuniones son espacios cerrados destinados a reuniones de grupos peque\xf1os de 2 a 4 personas. Deben estar equipados con equipos de A/V y pizarras blancas para facilitar el intercambio de conocimientos y deben ser ac\xfasticamente privados (las personas que se sientan inmediatamente fuera de la sala no deben poder escuchar las conversaciones que se desarrollan en el interior).",
    meetingRoomDesc15: "Las salas de reuniones son espacios cerrados destinados a reuniones de grupos peque\xf1os de 2 a 4 personas. Deben estar equipados con equipos de A/V y pizarras blancas para facilitar el intercambio de conocimientos y deben ser ac\xfasticamente privados (las personas que se sientan inmediatamente fuera de la sala no deben poder escuchar las conversaciones que se desarrollan en el interior).",
    openCollabSpace4to6Desc: "Estas \xe1reas est\xe1n destinadas a apoyar actividades colaborativas de grupos peque\xf1os (4 a 6 personas), como lluvias de ideas y conversaciones informales entre colegas y con clientes. ",
    cafeFoodServiceDesc: "La cafeter\xeda central est\xe1 destinado a ser un \xe1rea para comer, interacci\xf3n social, trabajo individual y peque\xf1as reuniones. Muebles funcionales para comer y una paleta de colores de marca deben considerarse en el dise\xf1o de este espacio.",
    coatClosetsDesc: "Los empleados necesitan un lugar para guardar sus abrigos y otros art\xedculos voluminosos, especialmente cuando una oficina tiene un dise\xf1o abierto con almacenamiento personal limitado en el escritorio. Estos deben estar dispersos por toda la oficina, tal vez ubicados junto a las salidas y a lo largo de los pasillos principales. Por lo general, hay un estante sobre la parte colgante para sombreros y otros equipos con almacenamiento o maletas en la base del armario.",
    copyPrintDesc: "Repartidas por todo el piso en un espacio de trabajo abierto, los espacios de copia/impresi\xf3n brindan a los empleados acceso r\xe1pido a dispositivos multifunci\xf3n desde todas las \xe1reas. Los contenedores para reciclar siempre deben ubicarse junto con las \xe1reas de copia/impresi\xf3n, as\xed como peque\xf1os gabinetes para almacenar papel y suministros adicionales. Estos espacios son solo para visitas y no est\xe1n destinados a funcionar como \xe1reas sociales/de trabajo.",
    specialResourceBuildingSupportAreaDesc: "Este es un complemento para los espacios de apoyo adicionales que pueden ocurrir en una oficina. Uno podr\xeda ser un mostrador de seguridad o instalaciones, mientras que otro podr\xeda ser un espacio de servicios p\xfablicos. Esto var\xeda seg\xfan las organizaciones, pero a medida que aumenta el tama\xf1o de la oficina, los espacios auxiliares como este se vuelven m\xe1s probables y necesarios.",
    secondaryServerRoomDesc: "Sala de servidor secundario (tecnolog\xeda) para albergar y proteger el equipo de TI y para terminar el cableado de bajo voltaje. Las habitaciones deben tener aire las 24 horas y deben estar a una temperatura constante de 72 grados Fahrenheit con un 50% de humedad relativa.",
    mothersRoomDesc: "Las salas de lactancia o amigas est\xe1n destinadas a brindar tiempo individual extremadamente privado, ya sea para madres lactantes o cualquier persona que busque un respiro de la oficina por un per\xedodo corto. Estas salas suelen ser un requisito para todas las oficinas nuevas, independientemente del tama\xf1o o el n\xfamero de empleados.",
    visitorCoatLuggageRoomDesc: "Los visitantes necesitan un lugar para guardar sus abrigos y otros art\xedculos voluminosos. Estos deben estar dispersos por toda la oficina, tal vez ubicados junto a las salidas y a lo largo de los pasillos principales. Por lo general, hay un estante sobre la parte colgante para sombreros y otros equipos con almacenamiento o maletas en la base del armario.",
    wellnessRoomDesc: "Las salas de bienestar (anteriormente denominadas Salas de Maternidad) est\xe1n destinadas a brindar tiempo individual extremadamente privado, ya sea para madres lactantes o cualquier persona que busque un respiro de la oficina por un breve intervalo. Las salas de bienestar suelen ser un requisito para todas las oficinas nuevas, independientemente del tama\xf1o o el n\xfamero de empleados, y deben contener un sill\xf3n, un refrigerador e, idealmente, un fregadero. ",
    internalStairDesc: "Las escaleras internas pueden ser huecos de escalera activados en el n\xfacleo que brindan acceso entre pisos, o pueden ser elementos adicionales que conectan los pisos de una oficina. A menudo puede ser un espacio de reuni\xf3n dentro de la oficina y puede centralizarse para caf\xe9, recepci\xf3n o espacios de reuni\xf3n.",
    commercialPrintRoomDesc: "A menudo combinadas con la sala de correo, las empresas brindan capacidades internas para imprimir, encuadernar y compilar presentaciones en la sala de impresi\xf3n. Habr\xe1 varias impresoras y podr\xeda incluir impresoras de gran formato. Los espacios incluir\xe1n espacio de almacenamiento para suministros y tambi\xe9n incluir\xe1n espacio de mostrador para equipos m\xe1s peque\xf1os, pero tambi\xe9n espacio para dise\xf1ar impresiones.",
    pantryVendingCoffeeDesc: "A diferencia de la cafeter\xeda central, el \xe1rea de despensa/venta/caf\xe9 est\xe1 dise\xf1ada para que los empleados tomen la comida y bebida r\xe1pida que necesitan. El bullicio y la conversaci\xf3n se encuentran naturalmente en \xe1reas con comida, pero estos espacios generalmente no contienen asientos, lo que hace que las personas entren y salgan r\xe1pidamente y pasen una gran cantidad de tiempo socializando.",
    storageDesc: "Las salas de almacenamiento est\xe1n destinadas a almacenar art\xedculos diversos, como equipos grandes, muebles adicionales, almacenamiento a granel, suministros para las vacaciones, etc. Tambi\xe9n se pueden usar para el almacenamiento de abrigos y equipaje de visitantes. Debe haber un peque\xf1o espacio de almacenamiento ubicado cerca del conserje para mayor comodidad.",
    centralisedDispersedMailAreaDesc: "Para empresas m\xe1s grandes, se requiere un centro de correo para organizar el correo entrante y saliente. Estos espacios albergan equipos especiales de producci\xf3n y correo. Tambi\xe9n hay muchas superficies para organizar papel y otros materiales. Por lo general, est\xe1 a cargo de un miembro del personal a tiempo completo.",
    lockerDesc: "Los casilleros se proporcionan como otra forma de almacenamiento individual. Brindan a los empleados un espacio para guardar bajo llave sus objetos de valor, efectos personales y archivos de trabajo. Los casilleros pueden asignarse a individuos o usarse por orden de llegada.",
    mainITandServerRoomDesc: "Sala de servidores primarios (tecnolog\xeda) para albergar y proteger el equipo de TI y para terminar el cableado de bajo voltaje. Las habitaciones deben tener aire las 24 horas y deben estar a una temperatura constante de 72 grados Fahrenheit con un 50% de humedad relativa.",
    drawerLateralFileDesc: "Almacenamiento personal para personas en escritorios u oficinas. Los contenidos suelen ser materiales de proyectos personales o activos.",
    juiceBarCoffeeShopDesc: "Si bien es posible que una empresa no tenga una cocina y un servicio completos, puede proporcionar una cafeter\xeda o una barra de jugos como parte de los servicios de comidas y bebidas en el espacio. Una organizaci\xf3n tambi\xe9n puede tener este tipo de espacio adem\xe1s de sus principales servicios de comedor, especialmente si la oficina es grande. Es probable que este espacio se parezca a su Starbucks local con un \xe1rea de trabajo para un miembro del personal separada por un mostrador de servicio.",
    grabNGoDesc: "Una peque\xf1a \xe1rea de conveniencia con varios refrigeradores, estantes para papas fritas y bocadillos, y una m\xe1quina de pago. Estos espacios Grab-N-Go generalmente son monitoreados por seguridad por c\xe1mara. Estos espacios a menudo se combinan con una peque\xf1a despensa con refrigeradores y congeladores y un \xe1rea de preparaci\xf3n de alimentos.",
    smMeetingConferenceRoomDesc: "Una sala de conferencias peque\xf1a es un espacio de reuni\xf3n cerrado destinado a acomodar c\xf3modamente de 2 a 6 personas en la mesa. Estas salas se pueden utilizar tanto para reuniones internas como para reuniones de cara al cliente y, por lo tanto, deben ser muy f\xe1ciles de usar con f\xe1cil acceso a las capacidades de energ\xeda y A/V.",
    mdMeetingConferenceRoomDesc: "Una sala de conferencias mediana es un espacio de reuni\xf3n cerrado destinado a acomodar c\xf3modamente de 6 a 10 personas en la mesa. Estas salas se utilizan tanto para reuniones internas como para reuniones de cara al cliente y, por lo tanto, deben ser muy f\xe1ciles de usar con f\xe1cil acceso a las capacidades de energ\xeda y A/V.",
    lgMeetingConferenceRoomDesc: "Una sala de conferencias grande es un espacio de reuni\xf3n cerrado destinado a acomodar c\xf3modamente de 12 a 14 personas en la mesa; es deseable disponer de asientos adicionales a lo largo del per\xedmetro de la sala. Estas salas se pueden utilizar tanto para reuniones internas como para reuniones de cara al cliente y es probable que se utilicen para presentaciones. Los muebles deben ser m\xf3viles para permitir que el espacio se utilice para otros fines, como clases de yoga para los empleados.",
    xlMeetingRoomDesc: "Una sala de conferencias de la sala de juntas est\xe1 dise\xf1ada para acomodar c\xf3modamente de 14 a 18 personas en la mesa, con asientos adicionales a lo largo del per\xedmetro de la sala para al menos 10 m\xe1s. Lo m\xe1s probable es que estas salas se utilicen para grandes reuniones formales internas y grandes reuniones de cara al cliente. Como tales, deben estar equipados con tecnolog\xeda A/V robusta y deben tener la marca como espacio orientado al cliente.",
    // Space Unit Map Descriptions (spaceUnitMap.js) - US_SMALL and US_REGULAR
    lgOfficeDesc: "Las oficinas son espacios de trabajo individuales, cerrados y privados para los empleados. Son excelentes para reducir la distracci\xf3n y donde se puede llevar a cabo el trabajo de concentraci\xf3n. Las oficinas suelen estar equipadas con un escritorio y un asiento de trabajo junto con asientos para invitados. Encontrar\xe1 cantidades variables de almacenamiento personal y archivo en las oficinas. El tama\xf1o del espacio tambi\xe9n puede variar seg\xfan las actividades que se realicen en la sala (p. ej., reuniones peri\xf3dicas) o el estado/jerarqu\xeda de los empleados. Esta oficina un poco m\xe1s grande podr\xeda ser una oficina asociada o podr\xeda funcionar tambi\xe9n como una sala de reuni\xf3n.",
    smWorkstationDesc: "Las estaciones de trabajo son asientos de trabajo individuales abiertos. Las estaciones de trabajo m\xe1s peque\xf1as pueden ser utilizadas por empleados a tiempo completo, ya sea de forma temporal (en un espacio de direcci\xf3n libre) o de forma permanente. Estos escritorios tambi\xe9n son excelentes para los empleados o contratistas visitantes que no est\xe1n en la oficina todo el tiempo. Algunas ventajas de las estaciones de trabajo abiertas son la visibilidad de la oficina y la colaboraci\xf3n inherente. Una desventaja puede ser la distracci\xf3n del ruido, por lo que se recomienda que las oficinas con estaciones de trabajo abiertas tengan muchas salas de concentraci\xf3n y reuni\xf3n. La presentaci\xf3n en el escritorio se limita a la presentaci\xf3n comunitaria probablemente ubicada en todo el piso.",
    mdWorkstationDesc: "Las estaciones de trabajo son asientos de trabajo individuales abiertos. Los beneficios de un espacio un poco m\xe1s grande incluyen m\xe1s almacenamiento en el escritorio y privacidad. Esto probablemente significa que cuanto m\xe1s grande sea un escritorio, es m\xe1s probable que se le asigne una direcci\xf3n en lugar de libre. Algunas ventajas de las estaciones de trabajo abiertas son la visibilidad de la oficina y la colaboraci\xf3n inherente. Una desventaja puede ser la distracci\xf3n del ruido, por lo que se recomienda que las oficinas con estaciones de trabajo abiertas tengan muchas salas de concentraci\xf3n y reuni\xf3n. Es probable que encuentre almacenamiento y archivos comunes adicionales ubicados en todo el piso.",
    lgWorkstationDesc: "Las estaciones de trabajo son asientos de trabajo individuales abiertos. Los beneficios de un espacio un poco m\xe1s grande incluyen m\xe1s almacenamiento en el escritorio y privacidad. Lo m\xe1s probable es que los escritorios de este tama\xf1o se asignen en lugar de una direcci\xf3n libre. Algunas ventajas de las estaciones de trabajo abiertas son la visibilidad de la oficina y la colaboraci\xf3n inherente. Una desventaja puede ser la distracci\xf3n del ruido, por lo que se recomienda que las oficinas con estaciones de trabajo abiertas tengan muchas salas de concentraci\xf3n y reuni\xf3n. Es probable que encuentre almacenamiento y archivos comunes adicionales ubicados en todo el piso.",
    huddleRoomDesc: "Las salas de reuniones peque\xf1as son espacios cerrados destinados a albergar reuniones de grupos peque\xf1os de 2 a 4 personas. Deben estar equipados con equipos de A/V y pizarras blancas para facilitar el intercambio de conocimientos y deben ser ac\xfasticamente privados (las personas que se sientan inmediatamente fuera de la sala no deben poder escuchar las conversaciones que se desarrollan en el interior).",
    multiPurpTrainingDesc: "Las salas de usos m\xfaltiples est\xe1n dise\xf1adas para acomodar a un gran n\xfamero de personas (20+). Este espacio tiene un nombre apropiado, ya que aqu\xed se pueden realizar muchas actividades diferentes, incluidas capacitaciones, eventos de la empresa y grandes presentaciones. El ajuste y acabado de este espacio es funcional/duradero con mucha gente yendo y viniendo pero tambi\xe9n de cara al cliente. Este espacio debe tener el soporte A/V adecuado, generalmente mucho m\xe1s que la sala de conferencias promedio.",
    informalCollabDesc: "Estas \xe1reas est\xe1n destinadas a apoyar actividades colaborativas de grupos peque\xf1os (4 a 6 personas), como lluvia de ideas y conversaciones informales entre colegas y con clientes. ",
    touchdownTeamDesc: "Los touchdowns son espacios de trabajo internos individuales o de peque\xf1os equipos que se distribuyen por toda la oficina para uso de empleados y visitantes. Los puntos de contacto pueden tener una variedad de alturas, formas y tama\xf1os, pero est\xe1n destinados a destacarse de las estaciones de trabajo individuales como un lugar \xfanico para trabajar durante un per\xedodo corto de tiempo. Estos deben ser espacios plug-and-play",
    frontDeskAreaDesc: "Esta es la primera parada cuando los empleados y visitantes llegan a la oficina. El escritorio debe poder acomodar al menos a una persona con espacio de trabajo y almacenamiento personal. Es probable que tambi\xe9n haya almacenamiento de visitantes cerca. La recepci\xf3n est\xe1 ubicada dentro del centro de recepci\xf3n m\xe1s grande, donde probablemente habr\xe1 asientos y otros alojamientos.",
    mailCenterAreaDesc: "Para organizaciones m\xe1s grandes, se requiere un centro de correo para centralizar todos los servicios de correo. Esto incluir\xe1 un gran espacio de clasificaci\xf3n y organizaci\xf3n, junto con espacio para gr\xe1ficos y equipos. Es probable que este espacio se vea muy diferente para cada organizaci\xf3n, ya que a menudo encaja entre otros elementos del programa.",
    kitchenAreaDesc: "Para los espacios que tendr\xe1n un servicio de comedor en la oficina, se requiere una cocina para respaldar este servicio. Los requisitos de una cocina variar\xe1n de una organizaci\xf3n a otra, pero puede esperar encontrar electrodom\xe9sticos para cocinar y almacenamiento en el refrigerador. Tambi\xe9n habr\xe1 almacenamiento de productos secos y equipos. La cocina estar\xe1 junto al servidor y probablemente el centro de servicios para conferencias/clientes.",
    serveryAreaDesc: "El servidor es el \xe1rea donde la gente obtiene su comida. Es probable que est\xe9 conectado a la cocina y a un comedor con mesas y asientos. La planificaci\xf3n de un servidor es muy precisa para gestionar colas y tr\xe1fico. Es probable que el tama\xf1o y la forma de este espacio var\xeden entre organizaciones.",
    diningSupportAreaDesc: "Una organizaci\xf3n que tiene servicios de comedor s\xf3lidos probablemente tendr\xe1 espacios de apoyo adicionales, como almacenamiento en otras partes del edificio, que deben tenerse en cuenta en el programa general. El espacio variar\xe1 entre las organizaciones.",
    diningAreaDesc: "Comer cerca de la cocina debe proporcionar una variedad de opciones para que las personas se sienten y almuercen. Proporcionar varios tipos diferentes de asientos tambi\xe9n permite que el espacio se utilice para reuniones y colaboraci\xf3n fuera de la hora del almuerzo. Proporcionar asientos blandos y duros junto con la barra y la configuraci\xf3n de la altura del asiento brinda opciones a los usuarios.",
    // Space Unit Map Descriptions (spaceUnitMap.js) - UK_REGULAR
    fullFoodServiceDesc: "Cuando se proporciona un servicio de comedor en la oficina, existen m\xfaltiples funciones que se unen para respaldar este servicio, que incluyen una cocina, un servicio, un comedor (asientos) y un comedor de apoyo (almacenamiento). La cocina y el servicio trabajan juntos para preparar y servir la comida hecha en casa. El comedor es el lugar donde los empleados y los invitados pueden sentarse y comer, pero a menudo este espacio act\xfaa como un centro social y de colaboraci\xf3n. Al igual que en el hogar, se requiere una gran cantidad de equipos y almacenamiento de alimentos para brindar servicios de comedor, por lo que el soporte de comedor se incluye en el tipo de espacio de Servicio de Alimentos Completo.",
    // SpaceUnitRow
    spaceUnitRowDeleteTitle: "Eliminar tipo de espacio",
    spaceUnitRowDeleteText: "\xbfEst\xe1 seguro de que desea eliminar este tipo de espacio?",
    spaceUnitRowConfirmDeleteText: "S\xed, eliminar",
    spaceUnitRowCancelDeleteText: "No, mantener",
    // CustomAmenityAdder
    customAmenityAddText: "A\xf1adir un servicio",
    customAmenityPlaceholder: "Tipo de servicio",
    // SpaceUnitTotals
    spaceUnitTotalsTitleNIA: "\xc1rea neta interna total",
    spaceUnitTotalsTitle: "Total {{sfTypeAdj}} metros {{unitCapitalized}} cuadrados",
    spaceUnitTotalsCirculation: "Circulaci\xf3n",
    spaceUnitTotalsCirculationTooltip: 'El "espacio entre espacios". Pasillos, el espacio detr\xe1s de su silla, el espacio alrededor de los gabinetes y las puertas, y alrededor de las esquinas. \xa1Sin circulaci\xf3n, no tendr\xedas ad\xf3nde caminar! Por lo general, comprende alrededor del 35 % del total de metros cuadrados utilizables en su programa, pero esto var\xeda seg\xfan su perfil y la selecci\xf3n final de edificios.',
    spaceUnitTotalsREBNY: "Factor REBNY",
    spaceUnitTotalsNYCText: "NYC ",
    spaceUnitTotalsREBNYTooltip: "Para los programas en NYC, aumentamos los metros cuadrados en un 15 % para tener en cuenta el est\xe1ndar de medici\xf3n REBNY. El espacio medido seg\xfan el est\xe1ndar de medici\xf3n REBNY incluye ba\xf1os, vest\xedbulos de ascensores y el grosor de las paredes exteriores (entre otras cosas).",
    spaceUnitTotalsLossFactor: "Factor de p\xe9rdida ",
    spaceUnitTotalsLossFactorTooltip: "La {{unit}} cuadrada utilizable es la cantidad de espacio que tiene en su oficina. Rentable square {{unit}} es el espacio por el que paga, que puede incluir columnas, vest\xedbulos y otras \xe1reas comunes. La diferencia entre usable y rentable se llama factor de p\xe9rdida, y la forma de calcularlo var\xeda seg\xfan la ubicaci\xf3n.",
    // CollaborationDropdown
    collabDropdownLevelLowText: "Pocos (0-25%)",
    collabDropdownLevelMedText: "Algunos (26-50%)",
    collabDropdownLevelHighText: "La mayor\xeda (51-100%)",
    //DensityDropdown
    sameDensityText: "Misma densidad antes de Covid-19",
    lowerDensityText: "Menor densidad ( M\xe1s huella por persona)",
    notSureDensityText: "No estoy seguro",
    //CirculationDropdown
    preCovidText: "Pre-Covid-19 (45% abierto / 25% cerrado)",
    higherText: "Mayor circulaci\xf3n (50% abierto / 30% cerrado)",
    notSureText: "No estoy seguro (45% abierta / 25% cerrada)",
    // ExamplePlans
    examplePlanButtonText: "Ver plan de ejemplo",
    examplePlanFullFloorText: "Piso completo",
    examplePlanPartialFloorText: "Piso parcial",
    examplePlanFullImgAlt: "Plano de planta de {{size}} cuadrado {{unit}} que muestra un dise\xf1o de perfil de {{profileName}} de Spacer by CBRE",
    examplePlanPartialImgAlt: "{{size}} square {{unit}} partial floor plan showing a {{profileName}} profile layout from Spacer by CBRE",
    examplePlanTooltipText: "Si tiene m\xe1s de {{size}} {{unit}}, es posible que necesite m\xe1s de un piso.",
    // ProgramStats
    programStatsDensitySubtitleTsubo: "Tsubo neto",
    programStatsDensitySubtitle: "{{adjetive}} Cuadrado {{unitUppercase}}",
    programStatsIndivTitle: "Asientos individuales",
    programStatsWorkstationsSubtitle: "Estaciones de trabajo",
    programStatsOfficesSubtitle: "Oficinas",
    programStatsCollabTitle: "Colaboraci\xf3n",
    programStatsEnclosedSubtitle: "Asientos de grupo cerrados",
    programStatsIndivSeatSubtitle: "Silla individual",
    programStatsSeatsTitle: "Sillas por persona",
    programStatsIndivSeatsSubtitle: "Sillas individuales",
    programStatsPersonSubtitle: "Persona",
    programStatsDensityTitle: "Densidad",
    programStatsFullDensitySubtitle: "{{density}} por asiento individual",
    // Profile Display Names (profileNames.js)
    efficientName: "El optimizador",
    whiteCollarName: "El acomodador",
    whiteGloveName: "El catalizador",
    openOfficeName: "El productor",
    workplace360Name: "El conector",
    campusName: "El diferenciador",
    startupName: "El incubador",
    engCreativeName: "El creador",
    // Profile Descriptions (profileDescriptions.js)
    efficientDesc: 'La oficina de The Optimizer es un entorno sencillo con una mentalidad de "hacer el trabajo". El espacio se centra en permitir que las personas tengan todas las herramientas necesarias en sus escritorios. La colaboraci\xf3n y el trabajo en equipo ocurren con menos frecuencia. Los escritorios de los empleados est\xe1n estandarizados y asignados con solo espacios de apoyo b\xe1sicos proporcionados dentro de la oficina. Fiel a su nombre, estos entornos casi siempre est\xe1n abiertos para maximizar la eficiencia.',
    whiteCollarDesc: "Como una oficina de The Accommodator, no est\xe1 sola: este es uno de los perfiles m\xe1s populares para los lugares de trabajo corporativos. Las oficinas de The Accommodator prefieren no sacudir el barco con un dise\xf1o de espacio radical sino que a menudo invierten en nueva tecnolog\xeda y mobiliario para hacer que el espacio sea productivo y atractivo. Con un equilibrio de espacios individuales y colaborativos, los empleados se encontrar\xe1n principalmente en sus escritorios con reuniones ocasionales y sesiones de equipo. Perfecto para ponerse de 9 a 5.",
    whiteGloveDesc: "Ingrese al vest\xedbulo de una oficina de The Enhancer y es posible que sienta que ha triunfado. Este lugar de trabajo satisface profundamente las necesidades de los empleados, as\xed como de los clientes, que son visitantes frecuentes del lugar de trabajo. M\xe1s que cualquier otro perfil de lugar de trabajo, las oficinas y los espacios cerrados son comunes. La mayor\xeda de los empleados ganan su espacio de oficina a trav\xe9s del desempe\xf1o o la antig\xfcedad, y la jerarqu\xeda probablemente juega un papel importante en el funcionamiento de la organizaci\xf3n. Sube la escalera corporativa con estilo.",
    openOfficeDesc: "La oficina de The Producer sabe lo que necesita para tener \xe9xito. Se trata de brindar a las personas los espacios b\xe1sicos necesarios en funci\xf3n del tipo de actividad que se lleva a cabo en la oficina. Estos diversos tipos de espacio no solo est\xe1n disponibles, sino que tambi\xe9n encontramos que son muy utilizados, \xa1una forma de mantenerse eficiente! Hay una combinaci\xf3n uniforme entre el trabajo individual y el trabajo en equipo, lo que probablemente signifique que te mueves mucho por la oficina durante el d\xeda. \xa1Perfecto para una oficina en movimiento!",
    workplace360Desc: "Al igual que su postura de yoga favorita, la oficina de The Connector se caracteriza del equilibrio. Con la combinaci\xf3n correcta de espacio orientado a la productividad y espacio de conexi\xf3n social, la oficina de The Connector proporciona todos los elementos esenciales para el enfoque al tiempo que fomenta la elecci\xf3n con una variedad de otros espacios. Fiel a su nombre, la oficina de The Connector ubica sus \xe1reas comunes como cocinas y \xe1reas de reuni\xf3n abiertas en el centro. Esto ayuda a unir a las personas y crea un sentido de comunidad.",
    campusDesc: "La oficina The Differentiator hace que sea dif\xedcil irse al final del d\xeda. Esto se debe a que se esfuerza por brindar una experiencia laboral que est\xe1 por encima y m\xe1s all\xe1 del resto. Encontrar\xe1 comodidades mejoradas en torno al bienestar o la comida para ayudar a los empleados a ahorrar tiempo y sentirse c\xf3modos. \xbfAlguien dijo bocadillos? Se alienta a los empleados a tomar descansos, socializar y relajarse en el lugar de trabajo.",
    startupDesc: "La velocidad y la ideaci\xf3n son el nombre del juego cuando se trata de la oficina de The Incubator. Los empleados trabajan en equipos altamente colaborativos y piensan como propietarios. Este entorno de oficina cambia constantemente, lo que significa que la mayor\xeda de los espacios tienen flexibilidad incorporada. Mover muebles y hacer turnos son comunes. Se utiliza una combinaci\xf3n de actividades sociales divertidas y sesiones de trabajo intensas, como ping-pong y hack\xe1thones, para crear camarader\xeda como equipo.",
    engCreativeDesc: "Pensamos en la oficina de The Creator como un lugar lleno de especialistas, no la combinaci\xf3n t\xedpica de tipos de departamentos. Al igual que todos los grandes esfuerzos creativos, la oficina de The Creator presenta con frecuencia el trabajo conjunto y en equipo. Es probable que el equipo especializado o los materiales f\xedsicos formen parte de las actividades laborales diarias. A los empleados se les da el espacio que necesitan para hacer su trabajo de manera efectiva y, aunque es un tipo de oficina poco com\xfan, un trabajo \xfanico requiere un lugar de trabajo \xfanico.",
    // Profile Key Traits: Shared Names (profileTraitMap.js)
    social: "Social",
    efficient: "Eficiente",
    flexible: "Flexible",
    enabled: "Habilitado",
    productive: "Productivo",
    inclusive: "Inclusivo",
    clientFocused: "Enfocado en el cliente",
    standardized: "Estandarizado ",
    // Profile Key Traits (profileTraitMap.js)
    social1Desc: "Las relaciones dentro y fuera de la oficina son importantes",
    social2Desc: "Muchos eventos de construcci\xf3n de comunidad",
    social3Desc: "A los empleados les gusta pasar tiempo juntos",
    social4Desc: "M\xe1s abierto y enfocado en la comunidad",
    efficient1Desc: "La empresa cumple y es consciente de su presupuesto",
    efficient2Desc: "La empresa cumple y es productiva ",
    flexible1Desc: "Las personas pueden decidir c\xf3mo trabajan",
    flexible2Desc: "Los empleados tienen mucha libertad",
    flexible3Desc: "Construye el espacio que necesita",
    enabled1Desc: "Los empleados tienen lo que requieren en sus escritorios",
    enabled2Desc: "Los empleados cuentan con servicios robustos y amenidades",
    enabled3Desc: "Las personas pueden obtener lo que necesitan para ejecutar sus trabajos",
    enabled4Desc: "Tienen acceso a la tecnologia correcta y a los equipos",
    enabled5Desc: "Equipos especializados est\xe1n disponibles",
    productive1Desc: "Dise\xf1o de oficina funcional e intuitivo",
    productive2Desc: "Orientado al negocio y financieramente consciente ",
    productive3Desc: "Centrado alrededor de productos \xfanicos/oferta de servicios",
    inclusive1Desc: "Diferentes tipos de espacios disponibles",
    inclusive2Desc: "Puede encontrar lo que necesite en la oficina",
    inclusive3Desc: "Muchos estilos de trabajo son aceptados",
    clientFocused1Desc: "Las primeras impresiones con clientes significan todo",
    clientFocused2Desc: "La oficina es acogedora para clientes y nuevos empleados",
    clientFocused3Desc: "La oficina esta impecable para clientes y nuevos empleados",
    standardized1Desc: "Procesos y sistemas son aerodin\xe1micos ",
    standardized2Desc: "Reglas organizacionales sobre el espacio",
    standardized3Desc: "Tama\xf1os modulares para flexibilidad",
    standardized4Desc: "Procesos y entregables simplificados",
    // SpaceSummary
    spaceSummaryBarHeader: "\xc1rea recomendada de oficina",
    spaceSummaryMeasurementTypeText: "Tipo de medida",
    spaceSummaryUnitTypeText: "Unidades",
    spaceSummaryLossFactorSectionLabel: "{{factor}} Detalles",
    spaceSummaryFitFactorText: "Factor de ajuste",
    spaceSummaryLossFactorText: "Factor de p\xe9rdida",
    spaceSummaryRSFLossFactorHelperText: "Basados en un {{percentage}}% de factor de p\xe9rdida para propiedad ra\xedz en {{place}}, usted deber\xe1 buscar espacios entre {{min}} y {{mas}} metros cuadrados rentables {{units}}",
    spaceSummaryNIAFitFactorHelperText: "Basados en un ({{percentage}}% de factor de ajuste para propiedad ra\xedz en {{place}}, usted deber\xe1 buscar espacios con {{amt}} de espacio de \xc1rea Interna Neta (AIN).",
    spaceSummaryNIATooltipText: "\xc1rea Interna Neta (AIN) es el \xe1rea usable dentro de un edificio, medida desde la cara externa del per\xedmetro de las paredes de cada piso, con algunas \xe1reas especificas excluidas.",
    // SFTypeRadioInput
    sfRadioInputUsableAreaTooltipText: "Esta medida incluye todos los cuartos, mobiliario y circulaci\xf3n del espacio. Muchas veces es referida como \xe1rea de alfombra.",
    sfRadioInputRentableAreaTooltipText: "Por lo general, se trata del Cuadrado utilizable {{unitUppercase}} m\xe1s una parte de los espacios comunes del edificio. Aunque no puedes usarlo todo, es la {{unit}} cuadrada que pagas cuando alquilas.",
    sfRadioInputUsableSquareText: "Metros cuadrados usables {{unitUppercase}}",
    sfRadioInputRentableSquareText: "Metros cuadrados rentables {{unitUppercase}}",
    //floored plan request block
    flooredTitle: "\xa1No nos deje todav\xeda!",
    flooredSubTitle: "Redefina c\xf3mo sus clientes exploran el espacio",
    flooredSubText: "\xa1Mire sus resultados en Spacer en un plano y haga un tour en 3D!",
    flooredParagraphText1: "Experiencia inmersiva que permite a los arrendatarios imaginar posibilidades, experimentar el espacio y convertir ideas en realidades.",
    flooredParagraphText2: "Tangible, visi\xf3n personalizada para cada espacio posible ",
    flooredVideoHeading: "Mire una experiencia de ejemplo",
    flooredFreeText: "Aun m\xe1s, \xa1es gratis!",
    flooredIconText1: "Compartir planos disponibles ",
    flooredIconSubText1: "Archivos AutoCAD o PDF",
    flooredIconText2: "Permite un tiempo de procesamiento",
    flooredIconSubText2: "Una o dos semanas",
    flooredIconText3: "Recibe ",
    flooredIconSubText3: "Experiencias 2D y 3D personalizadas",
    // MeasurementSystemRadioInput
    measurementSystemSqFeetText: "Pie cuadrado ",
    measurementSystemSqMetersText: "Metros cuadrados",
    measurementSystemTsuboText: "Tsubo",
    // ProfileHero
    resultsProfileHeroAnnouncementTitle: "Su oficina es ",
    resultsProfileHeroImgAlt: "Plano 3D mostrando el dise\xf1o de la oficina del perfil de {{profileName}}} de Spacer de CBRE",
    // ProfileComparison
    profileCompModalTitle: "\xbfCambiar el perfil?",
    profileCompModalText: "Usted perder\xe1 los cambios no guardados de su actual trabajo en el espacio.",
    profileCompModalConfirmText: "S\xed, cambiar el perfil",
    profileCompModalCancelText: "No, conservar perfil actual",
    profileCompNavbarCancelButtonText: "Cancelar",
    profileCompNavbarUseButtonText: "Usar este perfil",
    profileCompCompareTitle: "Compare los perfiles cercanos que coinciden",
    // ProfileComparisonColumn
    profileCompColumnSelectedText: "Seleccionar perfil",
    profileCompColumnSelectText: "Seleccionar",
    profileCompColumnRecommendedText: " (Recomendado)",
    profileCompColumnImgAltText: "Plano 3D mostrando el dise\xf1o de la oficina del perfil de {{profileName}} de Spacer de CBRE",
    // Test Fit Form
    testFitTitle: "Mira los resultados de tu plano y haz un tour en 3D",
    testFitSubtitle: "\xbfQuiere tener una idea de c\xf3mo lucir\xeda su espacio dise\xf1ado? Nosotros convertiremos sus requerimientos en un plano personalizado el cual podr\xe1 explorar y compartir. ",
    requestTestFitButtonText: "Solicitar un plano personalizado",
    company: "Nombre de la Compa\xf1\xeda",
    emptyCompanyError: "Por favor ingrese el nombre de la compa\xf1\xeda",
    radioQ2yes: "\xa1Genial! Haremos seguimiento v\xeda correo electr\xf3nico para solicitar su plano.",
    radioQ2no: "No hay problema. Haremos seguimiento para discutir sus opciones.",
    testFitFormTitle: "Solicitar su plano personalizado",
    testFitFormSubtitle: "Comp\xe1rtanos alguna informaci\xf3n y empezaremos el proceso. Nuestro equipos t\xedpicamente realiza entrega de planos terminado en 3 d\xedas h\xe1biles.",
    testFitFormCompleted: "Su solicitud ha sido enviada. Uno de nuestros representantes se pondr\xe1 en contacto con usted v\xeda correo electr\xf3nico.",
    testFitFormYes: "s\xed",
    testFitFormNo: "no",
    testFitFormQ1: "\xbfTiene un plano sobre el cual trabajar?",
    testFitFormQ1No: "\xa1No hay problema! Podemos proveerle uno para su uso.",
    testFitFormQ2: "\xbfTiene un plano en PDF o AutoCAD?",
    testFitTermsConditions: "Al hacer click en el siguiente cuadro, usted acepta a participar en este programa Beta. Usted recibir\xe1 un plano gratis a cambio de su participaci\xf3n en una encuesta sobre su experiencia",
    testFitSubmitButtonText: "Enviar el plano solicitado ",
    backendError: "\xa1Ups! Algo sali\xf3 mal, por favor intente de nuevo."
};


var $b4a2645243ac6c50$exports = {};
$b4a2645243ac6c50$exports = {
    // TermsOfService
    TermsTitle: "T\xe9rminos del servicio ",
    TermsIntroText: 'Estos es un acuerdo legal entre usted y CBRE Inc. ("CBRE") con respecto al acceso y uso de la aplicaci\xf3n conocida como Spacer. Por usar o acceder a alguna informaci\xf3n o servicios en esta p\xe1gina de internet, usted reconoce que ha le\xeddo, entendido y acordado los t\xe9rminos y condiciones presentados en estos t\xe9rminos de uso. Los t\xe9rminos a los que "usted" "ustedes" o "Usuarios" se refiere colectivamente, o la persona o entidad en nombre de la que usted se encuentre representando.',
    TermsLimitationsTitle: "Limitaciones",
    TermsLimitationsA: "El usuario comprende y acepta que el acceso del usuario a Spacer\xae no es exclusivo, no se puede sublicenciar, no es transferible, es revocable libremente y CBRE puede suspenderlo o cancelarlo en cualquier momento y por cualquier motivo.",
    TermsLimitationsB: 'El usuario adem\xe1s comprende y acepta que la concesi\xf3n de acceso a Spacer\xae no le conferir\xe1 al usuario ning\xfan derecho de propiedad sobre Spacer\xae o cualquier documentaci\xf3n relacionada (incluidos los nuevos lanzamientos, modificaciones o mejoras), todo lo cual ser\xe1 y seguir\xe1 siendo propiedad exclusiva de CBRE, incluidos, entre otros, los derechos de autor, las patentes asociadas, las patentes de dise\xf1o, las marcas registradas, la imagen comercial, los secretos comerciales y otros derechos de propiedad derivados de la ley aplicable o las convenciones internacionales (colectivamente, "Derechos de propiedad"). Consulte la Secci\xf3n 2 (Propiedad) a continuaci\xf3n. CBRE se reserva expresamente todos los derechos sobre Spacer\xae que no se conceden expresamente al Usuario en virtud del presente.',
    TermsLimitationsC: "Salvo lo dispuesto en el presente o lo autorizado expresamente por CBRE al Usuario por escrito, el Usuario no: (i) modificar\xe1, traducir\xe1, realizar\xe1 ingenier\xeda inversa, descompilar\xe1, desensamblar\xe1, intentar\xe1 reconstruir, identificar\xe1 ni descubrir\xe1 ning\xfan c\xf3digo fuente, ideas subyacentes, t\xe9cnicas de interfaz o algoritmos, o crear trabajos derivados o copiar Spacer\xae; (ii) eliminar\xe1, alterar\xe1 o cubrir\xe1 cualquier aviso de derechos de autor o marca registrada u otros avisos de derechos de propiedad contenidos en Spacer\xae; (iii) ceder\xe1, sublicenciar\xe1 o transferir\xe1 su acceso, uso u otros derechos o delegar\xe1 sus obligaciones bajo este Acuerdo; o (iv) sin limitar ninguno de los anteriores, usar\xe1 Spacer\xae con el prop\xf3sito de crear un producto o servicio competitivo, o para cualquier otro prop\xf3sito que no sea un prop\xf3sito comercial leg\xedtimo relacionado con el negocio del Usuario.",
    TermsLimitationsD: "El usuario se compromete a notificar a CBRE de inmediato por escrito si llega a ser de su conocimiento cualquier uso no autorizado de Spacer\xae o cualquier posible infracci\xf3n de los derechos de propiedad.",
    TermsLimitationsE: "En ning\xfan momento durante o despu\xe9s de la vigencia de este Acuerdo, el Usuario deber\xe1 solicitar el registro de cualquier derecho de autor, marca comercial u otra designaci\xf3n que pueda afectar la propiedad de los derechos de propiedad ni presentar ning\xfan documento ante ninguna autoridad gubernamental para tomar medidas que puedan afectar la propiedad de derechos de propiedad intelectual, incluida la propiedad de CBRE de Spacer\xae, la marca Spacer\xae y otros componentes de la aplicaci\xf3n. Spacer\xae es una marca comercial y de servicio de CBRE.",
    TermsLimitationsF: "El usuario declara y acepta que tiene derecho a proporcionar todos los materiales publicados o la informaci\xf3n utilizada en relaci\xf3n con Spacer\xae, y por el presente otorga a CBRE un derecho y una licencia de uso no exclusivos, libres de regal\xedas, mundiales, irrevocables y perpetuos para usar, reproducir, modificar, distribuir, crear trabajos derivados y mostrar dichos materiales e informaci\xf3n a discreci\xf3n de CBRE. El usuario reconoce que el usuario es responsable de cualquier material e informaci\xf3n que env\xede, incluida su legalidad, confiabilidad, idoneidad, originalidad y derechos de autor. La licencia otorgada por el Usuario a CBRE en virtud del presente sobrevivir\xe1 a cualquier terminaci\xf3n del uso de Spacer\xae por parte del Usuario. Cualquier material e informaci\xf3n enviados por el Usuario se considerar\xe1n no confidenciales y no patentados, y CBRE los tratar\xe1 como tales, y CBRE podr\xe1 utilizarlos de conformidad con este Acuerdo sin previo aviso al Usuario y sin responsabilidad alguna para CBRE.",
    TermsOwnershipTitle: "Propiedad",
    TermsOwnershipText: "Spacer\xae, el lenguaje de programaci\xf3n, el software y la documentaci\xf3n y todo otro material o contenido disponible en Spacer\xae o cualquier mejora, modificaci\xf3n, trabajo derivado, mejoras o cambios en Spacer\xae y todas las copias de los mismos son propiedad de CBRE y la titularidad de los mismos permanece \xfanicamente en CBRE. bajo todas las circunstancias, incluidos, entre otros, todos los derechos de patentes, derechos de autor, marcas registradas y secretos comerciales en Spacer\xae y las mejoras, modificaciones, trabajos derivados y cambios a los mismos. El usuario comprende que lo anterior incluye secretos comerciales e informaci\xf3n que es confidencial y propiedad de CBRE y acepta tomar todas las medidas necesarias para proteger la confidencialidad de dicha informaci\xf3n. El usuario no vender\xe1, transferir\xe1, publicar\xe1, divulgar\xe1, exhibir\xe1 ni pondr\xe1 a disposici\xf3n Spacer\xae ni crear\xe1 o pondr\xe1 a disposici\xf3n mejoras, modificaciones, mejoras, trabajos derivados o cambios en el mismo o copias del mismo para otros. La rescisi\xf3n de este Acuerdo ser\xe1 adicional y no en lugar de cualquier recurso disponible para CBRE tanto en derecho como en equidad. Las obligaciones en virtud del presente sobrevivir\xe1n a la terminaci\xf3n de este Acuerdo",
    TermsTerminationTitle: "Terminaci\xf3n; efecto de la rescisi\xf3n; Remedios.",
    TermsTerminationA: "Sin limitar ning\xfan otro recurso, CBRE puede modificar, limitar, suspender, descontinuar o rescindir este Acuerdo y/o el uso del Usuario de la totalidad o parte de Spacer\xae, con efecto inmediato, autom\xe1ticamente, con o sin notificaci\xf3n y sin recurrir a los tribunales o otros tribunales, por cualquier motivo o sin motivo alguno. El usuario acepta que CBRE no tiene la obligaci\xf3n de proporcionar Spacer\xae y que CBRE no ser\xe1 responsable ante el usuario ni ante ninguna otra parte por ninguna limitaci\xf3n, suspensi\xf3n, interrupci\xf3n, rescisi\xf3n o modificaci\xf3n de Spacer\xae.",
    TermsTerminationB: "El usuario reconoce que las obligaciones contra\xeddas con CBRE en virtud del presente son de naturaleza \xfanica e irremplazable, cuya p\xe9rdida da\xf1ar\xe1 irremediablemente a CBRE y que no puede ser reemplazada \xfanicamente por da\xf1os monetarios, por lo que CBRE tendr\xe1 derecho a medidas cautelares u otras medidas equitativas (sin las obligaciones de prestar cualquier fianza o fianza) en caso de incumplimiento o incumplimiento anticipado por parte del Usuario. El usuario renuncia irrevocablemente a todos los derechos de buscar medidas cautelares u otras medidas equitativas.",
    TermsDisclaimerTitle: "Exenciones de responsabilidad y limitaci\xf3n de responsabilidad.",
    TermsDisclaimerA: 'Spacer\xae se proporciona al usuario "TAL CUAL" y "SEG\xdaN DISPONIBILIDAD" sin garant\xedas. CBRE RENUNCIA A TODAS LAS GARANT\xcdAS, EXPRESAS O IMPL\xcdCITAS, INCLUIDAS, ENTRE OTRAS, LAS GARANT\xcdAS IMPL\xcdCITAS DE COMERCIABILIDAD, IDONEIDAD PARA UN FIN DETERMINADO Y NO VIOLACI\xd3N. CBRE NO GARANTIZA DE NINGUNA MANERA QUE Spacer\xae CUMPLA CON LOS REQUISITOS DEL USUARIO O CUALQUIER EST\xc1NDAR EN PARTICULAR. ALGUNOS ESTADOS NO PERMITEN LA EXCLUSI\xd3N DE GARANT\xcdAS IMPL\xcdCITAS, POR LO QUE LA EXCLUSI\xd3N ANTERIOR PUEDE NO APLICAR AL USUARIO. En tal caso, la responsabilidad de cbre se limitar\xe1 al m\xe1ximo posible seg\xfan la ley aplicable. NINGUNA INFORMACI\xd3N ORAL O ESCRITA O CONSEJO DADO POR CBRE, SUS AGENTES O EMPLEADOS CONSTITUIR\xc1 UNA GARANT\xcdA DE NINGUNA MANERA. NO SE OTORGA NINGUNA GARANT\xcdA DE QUE Spacer\xae O CUALQUIER INFORMACI\xd3N PROPORCIONADA AL USUARIO EST\xc9 LIBRE DE ERRORES O QUE EL USO DE Spacer\xae SER\xc1 ININTERRUMPIDO, ACTUALIZADO, COMPLETO O LIBRE DE VIRUS U OTROS COMPONENTES DA\xd1INOS, Y NO SE OTORGA NINGUNA GARANT\xcdA DE QUE CUALQUIER DE LO ANTERIOR SER\xc1 CORREGIDO. CBRE NO GARANTIZA NI HACE NINGUNA DECLARACI\xd3N CON RESPECTO AL USO O LOS RESULTADOS DEL USO DE Spacer\xae. CBRE NO SER\xc1 RESPONSABLE DE NING\xdaN DA\xd1O INDIRECTO, ESPECIAL, INCIDENTAL, CONSECUENTE, PUNITIVO O EJEMPLAR (INCLUYENDO, ENTRE OTROS, DA\xd1OS POR P\xc9RDIDA DE NEGOCIOS, P\xc9RDIDA DE BENEFICIOS, P\xc9RDIDA DE INGRESOS, P\xc9RDIDA DE AHORROS, INTERRUPCI\xd3N INFORM\xc1TICA, FONDO DE COMERCIO, USO, DATOS U OTROS INTANGIBLES P\xc9RDIDAS), YA SEA POR INCUMPLIMIENTO DEL CONTRATO, AGRAVIO (INCLUIDA LA NEGLIGENCIA), RESPONSABILIDAD DEL PRODUCTO O DE CUALQUIER OTRO TIPO, INCLUSO SI CBRE O SUS REPRESENTANTES HAYAN SIDO ADVERTIDO DE LA POSIBILIDAD DE DICHOS DA\xd1OS E INCLUSO SI UNA SOLUCI\xd3N ESTABLECIDA EN EL PRESENTE DOCUMENTO NO HAYA SIDO SU PROP\xd3SITO ESENCIAL.',
    TermsDisclaimerB: "LA RESPONSABILIDAD TOTAL DE CBRE POR DA\xd1OS POR CUALQUIER CAUSA NO EXCEDER\xc1 LA TARIFA PAGADA POR EL USUARIO POR Spacer\xae DURANTE EL PER\xcdODO DE DOCE (12) MESES ANTERIOR AL EVENTO QUE SUPUESTAMENTE CAUS\xd3 DICHO DA\xd1O. EL USUARIO ACEPTA QUE CUALQUIER CAUSA DE ACCI\xd3N QUE SURJA O EST\xc9 RELACIONADA CON Spacer\xae O DE OTRO MODO RELACIONADA CON ESTE ACUERDO DEBE COMENZAR EN EL PLAZO DE UN (1) A\xd1O DESPU\xc9S DE QUE SE ACUMULA LA CAUSA DE LA ACCI\xd3N. DE LO CONTRARIO, DICHA CAUSA DE ACCI\xd3N SE PROHIBE PERMANENTEMENTE.",
    TermsDisclaimerC: "ALGUNAS JURISDICCIONES PUEDEN NO PERMITIR LA LIMITACI\xd3N DE RESPONSABILIDAD O LAS EXCLUSIONES DE RESPONSABILIDAD ESTABLECIDAS ANTERIORMENTE, POR LO QUE LA LIMITACI\xd3N O EXCLUSI\xd3N ANTERIOR PUEDE NO APLICAR AL USUARIO. En tal caso, la responsabilidad de CBRE se limitar\xe1 al m\xe1ximo posible seg\xfan la ley aplicable. La renuncia a la garant\xeda, los recursos exclusivos y la responsabilidad limitada establecidos anteriormente son elementos fundamentales de la base de este Acuerdo entre CBRE y el USUARIO. CBRE no podr\xeda proporcionar Spacer\xae sobre una base econ\xf3mica y no habr\xeda celebrado este Acuerdo sin tales limitaciones. Estas limitaciones sobrevivir\xe1n a cualquier rescisi\xf3n de este Acuerdo.",
    TermsIndemnificationTitle: "Identificaci\xf3n de usuario",
    TermsIndemnificationText: "A opci\xf3n y solicitud de CBRE, el Usuario deber\xe1, a su cargo, indemnizar y mantener indemne a CBRE y sus subsidiarias, afiliadas, funcionarios, empleados, agentes, marcas compartidas, asociaciones y otros socios de y contra cualquier p\xe9rdida, costo, da\xf1o , responsabilidades, liquidaciones y gastos (incluidos, entre otros, costos y honorarios de abogados), que surjan o est\xe9n relacionados con cualquier reclamo, acci\xf3n o alegaci\xf3n de terceros relacionados con o que surjan de: (a) cualquier transacci\xf3n o disputa entre el Usuario y cualquier tercero fiesta; (b) hechos o presuntos hechos que constituir\xedan un incumplimiento de cualquiera de las representaciones, garant\xedas o convenios del Usuario en virtud de este Acuerdo o de cualquier ley, regla o regulaci\xf3n aplicable, ya sea que se haga referencia o no en este documento; (c) cualquier material, informaci\xf3n o contenido del Usuario enviado en o sobre Spacer\xae; (d) la violaci\xf3n del usuario de cualquier derecho de cualquier tercero, (e) el uso o mal uso de Spacer\xae por parte del usuario; o (f) la negligencia o dolo del Usuario. CBRE tendr\xe1 derecho a dirigir y controlar exclusivamente su defensa y contratar abogado de su elecci\xf3n, a costa del Usuario.",
    TermsGeneralTitle: "General.",
    TermsGeneralA: "<0>Acuerdo completo/sin renuncia involuntaria.</0> Este Acuerdo constituye el acuerdo completo entre CBRE y el Usuario con respecto a Spacer\xae y todo el contenido de este Acuerdo, y reemplaza todos los acuerdos anteriores entre CBRE y el Usuario relacionados con Spacer\xae Si alguna. El hecho de que CBRE no haga cumplir alguna disposici\xf3n de este Acuerdo no se interpretar\xe1 como una renuncia a ninguna disposici\xf3n o derecho.",
    TermsGeneralB: "<0>Avisos.</0> Los avisos para usted se har\xe1n por escrito y se pueden enviar por correo electr\xf3nico o publicar dichos avisos en Spacer\xae o en www.cbre.com/spacer. Nos enviar\xe1 avisos por correo electr\xf3nico a spacersupport@cbre.com, con una copia enviada por correo postal certificado de EE. UU. a CBRE en 400 S. Hope Street, 25th Floor, Los \xc1ngeles, CA 90071, Atenci\xf3n: Oficina del Asesor Jur\xeddico. Las notificaciones se considerar\xe1n entregadas un (1) d\xeda h\xe1bil despu\xe9s de su env\xedo por correo electr\xf3nico (a menos que el remitente reciba una respuesta que indique que el mensaje no se pudo entregar) o tres d\xedas h\xe1biles despu\xe9s de su publicaci\xf3n en el sitio web de CBRE (en el caso de CBRE), ya sea o no recibido.",
    TermsGeneralC: "<0>Ley aplicable.</0> Este Acuerdo se regir\xe1 e interpretar\xe1 de conformidad con las leyes del Estado de California sin tener en cuenta los conflictos de las disposiciones legales del mismo. CBRE y el Usuario se sujetan exclusivamente a lugares dentro del Estado de California. La Convenci\xf3n de las Naciones Unidas sobre Contratos para la Venta Internacional de Mercader\xedas (1980) queda excluida en su totalidad de la aplicaci\xf3n de este Acuerdo. El usuario acepta que Spacer\xae se considerar\xe1 \xfanicamente con sede en California y un servicio pasivo que no da lugar a jurisdicci\xf3n personal sobre CBRE, ya sea espec\xedfica o general, en jurisdicciones distintas del estado de California.",
    TermsGeneralD: "<0>Resoluci\xf3n de disputas.</0> Cualquier disputa, reclamo o controversia que surja de o se relacione con este Acuerdo, o el incumplimiento, cumplimiento, interpretaci\xf3n o validez del mismo, incluida la determinaci\xf3n del alcance o la aplicabilidad del arbitraje con respecto a este Acuerdo, se determinar\xe1 mediante arbitraje. El arbitraje ser\xe1 administrado por el Servicio de Arbitraje y Mediaci\xf3n Judicial (JAMS), y el arbitraje se llevar\xe1 a cabo con un solo \xe1rbitro. Adem\xe1s, el Usuario acepta que ni el Usuario ni CBRE unir\xe1n ning\xfan reclamo con el reclamo de cualquier otra persona o entidad en el arbitraje; que ning\xfan reclamo se resolver\xe1 a nivel colectivo; y que ni el Usuario ni CBRE har\xe1n valer ning\xfan reclamo en calidad de representante en nombre de otra persona. No obstante lo anterior, el Usuario acepta que CBRE podr\xe1 solicitar medidas cautelares (o un tipo equivalente de medida legal urgente) en cualquier jurisdicci\xf3n. Si el Usuario presenta una queja de arbitraje contra CBRE, CBRE acepta pagar cualquier parte de la tarifa de presentaci\xf3n inicial que supere los $250; despu\xe9s de las tarifas iniciales de presentaci\xf3n, las partes compartir\xe1n los costos del arbitraje en partes iguales. El usuario acepta no iniciar ni enjuiciar ninguna acci\xf3n contra CBRE que no sea mediante la presentaci\xf3n de una demanda de arbitraje de conformidad con este p\xe1rrafo. IMPORTANTE, AL ACEPTAR ESTAR OBLIGADO POR ESTE ACUERDO, EL USUARIO RENUNCIA A CUALQUIER DERECHO QUE TIENE DE SOLICITAR COMPENSACI\xd3N EN UN TRIBUNAL Y A CUALQUIER DERECHO QUE TIENE A UN JUICIO POR JURADO.",
    TermsGeneralE: "<0>Divisibilidad.</0> En el caso de que una parte de este Acuerdo se considere inaplicable, la parte no exigible se modificar\xe1 solo en la medida necesaria para hacerla exigible, y el resto de las disposiciones permanecer\xe1n en pleno vigor y efecto.",
    TermsGeneralF: "<0>Cesi\xf3n.</0> Este Acuerdo no puede ser cedido por el Usuario sin el consentimiento previo por escrito de CBRE. Cualquier intento de cesi\xf3n sin el consentimiento de CBRE ser\xe1 nulo. CBRE se reserva el derecho de ceder este Acuerdo a cualquier tercero. Este Acuerdo y los derechos y obligaciones de cada uno de nosotros en",
    TermsGeneralG: "<0>Modificaci\xf3n.</0> CBRE puede modificar cualquiera de los t\xe9rminos y condiciones contenidos en este Acuerdo, en cualquier momento y a su sola y exclusiva discreci\xf3n, mediante la publicaci\xf3n de un aviso de cambio o un nuevo acuerdo en el sitio de Spacer\xae en la url www.cbre.com/spacer o proporcionando una alerta o notificaci\xf3n similar en Spacer\xae. Si alguna modificaci\xf3n es inaceptable para el Usuario, el \xfanico recurso del Usuario es cancelar el uso de Spacer\xae por parte del Usuario.",
    TermsGeneralH: "<0>Conflictos.</0> En caso de que exista alg\xfan conflicto entre los t\xe9rminos de este Acuerdo y cualquier acuerdo de licencia totalmente ejecutado entre el Usuario y CBRE con respecto a Spacer\xae, los t\xe9rminos de dicho acuerdo de licencia prevalecer\xe1n con respecto a dicho t\xe9rminos contradictorios."
};


var $6752c2715d81afbb$exports = {};
$6752c2715d81afbb$exports = {
    // Quiz
    exitQuizButtonTitle: "Salir del cuestionario",
    // QuizProgressLabel
    progressLabelText: "completar",
    // QuizNavigationButton
    quizNavBackButtonShortenedText: "Anterior",
    quizNavBackButtonFullLengthText: "Pregunta anterior",
    quizNavNextButtonShortenedText: "Siguiente",
    quizNavNextButtonFullLengthText: "Siguiente pregunta",
    // QuizExitSlide
    quizExitSubtitle: "Estamos usando sus respuestas para definir el espacio perfecto de trabajo para su compa\xf1\xeda",
    quizExitImgAlt: "Ilustraci\xf3n de dos personas chocando los cinco en la p\xe1gina del cuestionario de Spacer de CBRE",
    // Question Unit Text (questionUnitMap.js)
    question1Text: "Para empezar, \xbfc\xf3mo describir\xeda el prop\xf3sito de su futura oficina?",
    question2Text: "\xbfQu\xe9 puede hacer Spacer por usted?",
    question3Text: "\xbfQu\xe9 es lo m\xe1s importante que buscan cuando contratan nuevos miembros del equipo?",
    question4Text: "\xbfC\xf3mo se ve en 5 a\xf1os?",
    question5Text: "\xbfC\xf3mo es el horario para sus empleados?",
    question6Text: "\xbfQu\xe9 piensa de los escritorios individuales?",
    question7Text: "\xbfC\xf3mo gasta el tiempo la gente cu\xe1ndo est\xe1 en la oficina?",
    question8Text: "\xbfC\xf3mo se viste la gente en tu oficina?",
    question9Text: "\xbfD\xf3nde pasar\xe1 su trabajo?",
    question10Text: "\xbfC\xf3mo deber\xeda ser la atm\xf3sfera en su oficina?",
    question11Text: "\xbfQu\xe9 provee en su oficina adem\xe1s de espacios de trabajo?",
    question12Text: "\xbfCu\xe1l de estos lo describe mejor?",
    // Quiz Answers (questionUnitMap.js)
    pickOnePlaceholder: "Seleccione uno",
    selectFromListPlaceholder: "Seleccione de la lista",
    firstResponseTooltipText: "Seleccione su primera respuesta",
    locatedSomewhereElseLabel: "Actualmente estoy ubicado en otro lugar",
    q1AnswerText1: "Pensamos en nuestra oficina primero c\xf3mo",
    q1AnswerText2: "Segundo como",
    q1AnswerText3: "y tercero como",
    q1Option1Text: "Un segundo hogar para nuestra gente",
    q1Option2Text: "Un impulsor de cambio organizacional",
    q1Option3Text: "Un lugar para trabajo de concentraci\xf3n",
    q1Option4Text: "Un incubador para la siguiente gran idea",
    q1Option5Text: "Una herramienta para adquirir gran talento",
    q1Option6Text: "Una vitrina para nuestra marca",
    q1Option7Text: "Un espacio para crecer y aprender",
    q1Option8Text: "Un lugar para que la gente se conozca y se re\xfana",
    q1Option9Text: "Un costo necesario que intentamos minimizar",
    q2AnswerText1: "La gente se une a nosotros primero por nuestra",
    q2AnswerText2: "segundo por nuestra",
    q2AnswerText3: "y tercero por nuestra",
    q2Option1Text: "Cultura organizacional",
    q2Option2Text: "Salarios competitivos",
    q2Option3Text: "Reputaci\xf3n de compa\xf1\xeda",
    q2Option4Text: "Beneficios y ventajas",
    q2Option5Text: "Horarios de trabajo flexibles",
    q2Option6Text: "Gente y liderazgo",
    q2Option7Text: "Ambiente de oficina",
    q2Option8Text: "Prop\xf3sito y misi\xf3n",
    q3AnswerText1: "Nosotros contratamos empleados primero por",
    q3AnswerText2: "Segundo por",
    q3AnswerText3: "y tercero por",
    q3Option1Text: "Habilidades",
    q3Option2Text: "Experiencia",
    q3Option3Text: "Cultural Fit",
    q3Option4Text: "Credenciales",
    q3Option5Text: "Relaciones",
    q3Option6Text: "Curiosidad",
    q4AnswerText: "Nosotros",
    q4Option1Text: "Creceremos un poco cada a\xf1o",
    q4Option2Text: "Creceremos significantemente cada a\xf1o",
    q4Option3Text: "permaneceremos igual",
    q4Option4Text: "Encogeremos un poco cada a\xf1o",
    q4Option5Text: "Dif\xedcil de decir, impredecible",
    q5AnswerText: "Nosotros estamos trabajando generalmente",
    q5Option1Text: "De 9 a 5",
    q5Option2Text: "Desde la ma\xf1ana hasta \u2026 Tarde",
    q5Option3Text: "Cuando quieran, siempre que sea cierta cantidad",
    q5Option4Text: "Cuando quiera, tanto como quieran",
    q6AnswerText: "Nosotros pensamos",
    q6Option1Text: "Todo el mundo deber\xeda tener el suyo",
    q6Option2Text: "Puede ser mejor compartir escritorios sin asignaci\xf3n fija",
    q7Option1Text: "Siempre desde un escritorio individual",
    q7Option2Text: "Principalmente desde un escritorio individual con algunas reuniones y otras actividades",
    q7Option3Text: "Incluso dividido entre un escritorio y otro lugar de la oficina",
    q7Option4Text: "Principalmente movi\xe9ndose de espacio en espacio con paradas en escritorios",
    q7Option5Text: "Siempre movi\xe9ndose de espacio en espacio",
    q8Option1Text: "Profesional de negocios",
    q8Option2Text: "Principalmente profesional excepto por algunas ocasiones ",
    q8Option3Text: "Informal de negocios, con algunos d\xedas elegante otros no",
    q8Option4Text: "La mayor\xeda casual con algunas ocasiones especiales",
    q8Option5Text: "Casual",
    q9Option1Text: "Siempre desde la oficina",
    q9Option2Text: "Casi siempre desde la oficina",
    q9Option3Text: "Divido entre la oficina y remoto",
    q9Option4Text: "La mayor\xeda remoto",
    q9Option5Text: "Siempre remoto",
    q10Option1Text: "Din\xe1mico y energ\xe9tico",
    q10Option2Text: "Energ\xe9tico con algunos momentos de silencios",
    q10Option3Text: "Depende, una mezcla ambas",
    q10Option4Text: "Tranquilo, con algunos momentos din\xe1micos",
    q10Option5Text: "Tranquilo",
    q11Option1Text: "S\xf3lo lo b\xe1sico, suficiente para que la gente continue",
    q11Option2Text: "Lo b\xe1sico con algunas mejoras",
    q11Option3Text: "Lo b\xe1sico y un lugar donde la gente pueda socializar",
    q11Option4Text: "Algo muy lindo, una oficina como destino",
    q11Option5Text: "Algo lindo y diferenciador, la primera cosa que le muestro a un visitante",
    q12AnswerText: "I\u2019m",
    q12OptionClientText: "Un cliente existente de CBRE",
    q12OptionProfessionalText: "Un profesional de CBRE",
    q12OptionLeadText: "Alguien m\xe1s",
    q13AnswerText1: "Nosotros tendremos",
    q13AnswerText2: "Empleados en nuestra oficina",
    q13AnswerHelperText: "Este es usualmente el punto medio de tu contrato o m\xe1s o menos 2 a 5 a\xf1os desde hoy",
    q14AnswerText1: "Nosotros gastaremos",
    q14AnswerText2: "Nuestro tiempo trabajando en equipos",
    q15AnswerText1: "En promedio planeamos gastar",
    q15AnswerText2: "D\xedas por semana en la oficina",
    q16AnswerText1: "Nuestra oficina estar\xe1 en la ciudad de ",
    q16AnswerText2: ".",
    q17AnswerText1: "Nosotros trabajamos principalmente en el",
    q17AnswerText2: "sector.",
    q18AnswerText1: "Actualmente estoy ubicado en",
    q18AnswerText2: ".",
    q19AnswerText1: "Imaginamos que nuestra densidad de oficina ser\xe1 (SF por persona)",
    q19AnswerText2: "en el futuro.",
    // Quiz Responses (questionUnitMap.js)
    q1ResponseText: "Definiremos una oficina que se ajuste a su visi\xf3n.",
    q2ResponseText: "\xa1Combinaci\xf3n atractiva!",
    q3ResponseText: "Suena bien, \xbfd\xf3nde aplicamos?",
    q4ResponseText: "\xa1Genial! Nos aseguraremos de que la oficina se adapte.",
    q5Response1Text: "\xa1Suena bien!",
    q5Response2Text: "Tendemos a trabajar horas extra tambi\xe9n.",
    q5Response3Text: "\xa1Suena genial!",
    q5Response4Text: "\xa1Suena asombroso!",
    q6Response1Text: "Definiremos un espacio que priorice el espacio personal.",
    q6Response2Text: "Definiremos un espacio que sea flexible.",
    q12ResponseLeadText: "Vino al lugar correcto.",
    q12ResponseClientText: "\xa1Perfecto!",
    q12ResponseProfessionalText: "\xa1Gracias!",
    // Industry Codes (industryCodes.js)
    animalProd: "Producci\xf3n animal y acuicultura",
    forestry: "Silvicultura y explotaci\xf3n forestal",
    fishingHunting: "Pesca, caza y captura",
    agForestSupport: "Actividades de apoyo a la agricultura y la silvicultura",
    oilGas: "Extracci\xf3n de gas y aceite",
    energy: "Energ\xeda (gas, aceite, etc.)",
    mining: "Miner\xeda, excepto petr\xf3leo y gas",
    supportMining: "Actividades de apoyo a la miner\xeda",
    utilities: "Servicios p\xfablicos",
    buildingConstruct: "Construcci\xf3n de edificios",
    heavyCivilConstruct: "Construcci\xf3n pesada y de ingenier\xeda civil",
    specialtyContract: "Contratistas comerciales especializados",
    foodManufac: "Fabricaci\xf3n de alimentos",
    beverageTobaccoManufac: "Manufactura de bebidas y productos de tabaco",
    textile: "Manifactura textil",
    textileProduct: "F\xe1bricas de productos textiles",
    apparelManufac: "Manufactura de prendas de vestir",
    leatherManufac: "Manufactura de cuero y productos afines",
    woodManufac: "Manufactura de productos de madera",
    paperManufac: "Manufactura de papel",
    printingSupport: "Impresi\xf3n y actividades de apoyo relacionadas",
    printingReproduc: "Impresi\xf3n/Reproducciones",
    petroleumCoal: "Fabricaci\xf3n de productos derivados del petr\xf3leo y carb\xf3n",
    chemicalManufac: "Fabricaci\xf3n de productos qu\xedmicos",
    chemicals: "Qu\xedmicos",
    pharma: "Farmac\xe9uticas",
    cleaningManufac: "Fabricaci\xf3n de limpieza",
    plasticsRubberManufac: "Fabricaci\xf3n de pl\xe1sticos y productos de caucho",
    nonmetallicManufac: "Fabricaci\xf3n de productos minerales no met\xe1licos",
    primaryMetalManufac: "Fabricaci\xf3n de metales primarios",
    fabricatedMetalManufac: "Fabricaci\xf3n de productos met\xe1licos",
    machineryManufac: "Fabricaci\xf3n de maquinaria",
    manufac: "Fabricaci\xf3n",
    computerElectronicManufac: "Fabricaci\xf3n de productos inform\xe1ticos y electr\xf3nicos",
    electricalApplianceManufac: "Equipos el\xe9ctricos y electrodom\xe9sticos mfg.",
    transportEquipManufac: "Fabricaci\xf3n de equipos de transporte",
    aerospaceDefense: "Aeroespacial/Defensa",
    furnitureManufac: "Fabricaci\xf3n de muebles y productos relacionados",
    miscManufac: "Fabricaci\xf3n diversa",
    merchantWholesaleDurable: "Comerciantes mayoristas, bienes duraderos",
    merchantWholesaleNondurable: "Comerciantes mayoristas, bienes no duraderos",
    electronicMarket: "Mercados electr\xf3nicos y agentes y br\xf3keres",
    motorVehiclePartsDealers: "Concesionarios de veh\xedculos de motor y piezas",
    furnitureFurnishingStores: "Tiendas de muebles y muebles para el hogar",
    electronicApplianceStores: "Tiendas de electr\xf3nicos y electrodom\xe9sticos",
    electronics: "Electr\xf3nicos",
    buildingGardenSupplyStores: "Tiendas de materiales de construcci\xf3n y suministros de jardiner\xeda",
    foodBeverageStores: "Tiendas de alimentos y bebidas",
    groceryStores: "Supermercados",
    beerWineLiquorStores: "Tiendas de cerveza, vino y licores",
    healthCareStores: "Tiendas de salud y cuidado personal",
    gasStations: "Estaciones de gasolina",
    clothingAccessoriesStores: "Tiendas de ropa y accesorios de ropa",
    clothingTextiles: "Prendas de vestir/Textiles",
    jewelryFurs: "Joyer\xeda y pieles",
    sportsHobbyMusicBookStores: "Deportes, hobby, instrumentos musicales, librer\xedas",
    genMerchandiseStores: "Tiendas de mercanc\xeda general",
    miscStoreRetailers: "Tiendas miscel\xe1neas",
    officeProducts: "Productos de Office",
    retailSales: "Ventas minoristas",
    nonstoreRetails: "Minoristas que no son tiendas",
    airTransport: "Transporte a\xe9reo",
    travelRelated: "Relacionados con viajes (aerol\xedneas, agentes, transporte p\xfablico)",
    railTransport: "Transporte ferroviario",
    waterTransport: "Transporte acu\xe1tico",
    truckTransport: "Transporte en cami\xf3n",
    transitTransport: "Tr\xe1nsito y transporte terrestre de pasajeros",
    pipelineTransport: "Transporte por tuber\xedas",
    scenicTransport: "Transporte panor\xe1mico y tur\xedstico",
    supportTransport: "Actividades de apoyo para el transporte",
    postalService: "Servicio postal",
    courierMessenger: "Mensajeros y mensajeros",
    shippingDelivery: "Env\xedo/Entrega",
    warehousingStorage: "Almacenamiento y almacenamiento",
    warehouseDistrib: "Almac\xe9n/Distribuci\xf3n",
    publishingNoInternet: "Industrias editoriales, excepto Internet",
    publishing: "Editorial",
    motionPicSoundRecordingIndustries: "Industrias cinematogr\xe1ficas y de grabaci\xf3n de sonido",
    entertainment: "Entretenimiento (Cine, TV, M\xfasica, etc.)",
    infoServicesMarketResearch: "Servicios de Informaci\xf3n/Investigaci\xf3n de Mercado",
    broadcastingNoInternet: "Radiodifusi\xf3n, excepto Internet",
    telecom: "Telecomunicaciones",
    tech: "Tecnolog\xeda",
    dataProcessingHostingServices: "Procesamientos y alojamiento de datos, servicios relacionados",
    otherInfoServices: "Otros servicios de informaci\xf3n",
    financeInsurance: "Financieros y seguros",
    monetaryAuthorities: "Autoridades monetarias-bancos centrales",
    creditIntermediation: "Intermediaci\xf3n financiera y actividades relacionada",
    banking: "Bancos",
    securitiesContractsInvestments: "Seguridad, contratos de bienes, inversiones",
    financialServicesNoBanking: "Servicios Financieros (no bancarios)",
    insuranceCarriersRelated: "Compa\xf1\xedas de seguros y actividades relacionadas",
    insurance: "Seguros",
    fundsTrustsFinancialVehicles: "Fondos, fideicomisos y otros veh\xedculos financieros",
    realEstate: "Inmobiliario",
    rentalLeasingServices: "Servicios de arrendamiento y leasing",
    automotive: "Automotriz",
    consumerGoods: "Bienes de consumo",
    lessorsNonfinancialIntangible: "Arrendadores de bienes intangibles no financieros",
    professionalTechnicalServices: "Servicios profesionales y t\xe9cnicos",
    legalServices: "Servicios legales",
    accounting: "Contabilidad",
    architectureEngineering: "Arquitectura/Ingenier\xeda",
    specializedDesignServices: "Servicios especializados de dise\xf1o",
    compRelatedServices: "Servicios relacionados con la computaci\xf3n",
    mgmtConsulting: "Consultor\xeda de gesti\xf3n",
    scientificResearch: "Investigaci\xf3n cient\xedfica",
    adsMarketingPR: "Publicidad/Mercadeo/Relaciones P\xfablicas",
    otherProfSciTechServices: "Otros servicios profesionales, cient\xedficos y t\xe9cnicos",
    companyEnterpriseMgmt: "Gesti\xf3n de empresas y corporaciones",
    adminSupportServices: "Servicios de soporte administrativo",
    employmentAgencyRecruiters: "Agencia de empleo/Reclutadores",
    securityPrivateInvestigation: "Seguridad/Investigaci\xf3n privada",
    wasteMgmtRemediationServices: "Servicios de gesti\xf3n de residuos y remediaci\xf3n",
    educationServices: "Servicios educativos",
    education: "Educaci\xf3n",
    ambulatoryHealthCareServices: "Servicios ambulatorios de salud",
    healthCareRelated: "Salud",
    hospitals: "Hospitales",
    nursingResidentialCareFacilities: "Establecimientos de\xa0cuidados\xa0especializados de enfermer\xeda",
    socialAssistance: "Asistencia social",
    performingArtsSpectatorSports: "Artes esc\xe9nicas y deportes para espectadores",
    museumsHistoricalSitesZoosParks: "Museos, sitios hist\xf3ricos, zool\xf3gicos y parques",
    fineArtsGalleriesMuseums: "Bellas artes (galer\xedas, museos)",
    amusementsGamblingRec: "Diversiones, juegos de azar y recreaci\xf3n",
    accommodation: "Alojamiento",
    foodDrinkingServices: "Servicios de comida y bares",
    restaurantHotel: "Restaurante/Hotel",
    repairMaintenance: "Reparaci\xf3n y mantenimientos",
    industrialProductsHeavy: "Productos industriales (industria pesada)",
    personalLaundryServices: "Servicios personales y de lavander\xeda",
    membershipAssocOrgs: "Miembros de asociaciones y organizaciones",
    nonprofit: "Sin \xe1nimo de lucro",
    privateHouseholds: "Servicios dom\xe9sticos",
    execLegisGenGvt: "Ejecutivo, legislativo y gubernamental",
    gvt: "Gobierno",
    justicePublicOrderSafetyActivities: "Actividades de justicia, orden p\xfablico y seguridad",
    hrAdminPrograms: "Administraci\xf3n de programas de recursos humanos",
    environmentAdminPrograms: "Administraci\xf3n de programas medioambientales",
    environmental: "Medioambiente",
    communityHousingProgramAdmin: "Administraci\xf3n de programas comunitarios y de vivienda",
    econProgramAdmin: "Administraci\xf3n de programas econ\xf3micos",
    spaceResearchTech: "Investigaci\xf3n y tecnolog\xeda espacial",
    natlSecurityIntlAffairs: "Seguridad nacional y relaciones internacionales"
};


var $b421844c8c43bdd3$exports = {};
$b421844c8c43bdd3$exports = {
    // AboutPageHero
    aboutPageHeroImgAlt: "Ilustraci\xf3n de personas movi\xe9ndose a una oficina en la p\xe1gina de Acerca de Spacer de CBRE",
    aboutPageHeroTitle: "\xbfQu\xe9 puede hacer Spacer por usted?",
    // AboutPageContent
    aboutPageContentEndSectionTitle: "\xbfListo para empezar?",
    aboutPageProgramPreviewImgAlt: "Previsualizaci\xf3n de resultados de la p\xe1gina del programa de espacios desde la p\xe1gina de inicio de Spacer de CBRE",
    aboutPageVideoTitle: "C\xf3mo funciona",
    // About Page Content (aboutPageContent.js)
    aboutPageContent1Title: "Defina la oficina perfeta",
    aboutPageContent1Text: "El espacio de oficinas perfecto le puede ayudar a contratar talento competitivo, mantener los empleados saludables, reducir costos operativos o crear condiciones para la siguiente gran idea. Spacer es el lugar perfecto para iniciar cualquier decisi\xf3n inmobiliaria porque le ayuda a priorizar sus metas como organizaci\xf3n y a ver recomendaciones de espacio basadas en esas metas. Spacer fue creado con la experiencia del equipo de trabajo de CBRE, un grupo con m\xe1s de veinte a\xf1os de experiencia ayudando compa\xf1\xedas a planear la oficina perfecta, combinado con una herramienta tecnol\xf3gica gratuita al alcance de todos.",
    aboutPageContent1ImgAlt: "Ilustraci\xf3n de personas hablando en la p\xe1gina acerca de Spacer, creada por CBRE",
    aboutPageSpacerSupportLink: "spacersupport@cbre.com",
    aboutPageContent2Title: "Spacer es f\xe1cil de usar",
    aboutPageContent2List1: "Comience respondiendo un cuestionario de 17 preguntas sobre los objetivos y valores de su organizaci\xf3n. Estas respuestas nos informar\xe1n el perfil de su oficina donde lo categorizaremos.",
    aboutPageContent2List2: "Reciba una lista recomendada de espacio seg\xfan tipo y tama\xf1o que satisfagan sus necesidades espec\xedficas, tambi\xe9n conocido como programa espacial.",
    aboutPageContent2List3: "Visualice un espacio similar al suyo en 2D y 3D con Planos del Piso",
    aboutPageContent2List4: "Guarde su programa para usarlo mientras busca la oficina perfecta en el mercado",
    aboutPageContent2List5: "Deje que un profesional de CBRE busque un espacio de oficina que coincida con su programa. \xa1Un servicio gratuito!",
    aboutPageContent2Text: "Si tiene m\xe1s preguntas sobre c\xf3mo Spacer puede impulsar su proceso de b\xfasqueda de oficinas, cont\xe1ctenos en ",
    aboutPageContent2ImgAlt: "Ilustraci\xf3n de una mujer trabajando en un escritorio en la p\xe1gina Acerca de Spacer creador por CBRE"
};


var $1245b615d8599a82$exports = {};
$1245b615d8599a82$exports = {
    referralStep: " Paso {{step}} de 4",
    forgotReferralLink: "\xbfOlvido su enlace de referencia?",
    howReferralLinksWorkTitle: "C\xf3mo funcionan los enlaces de referencia",
    enterYourInformation: "Ingrese su informaci\xf3n",
    confirmYourInformation: "Confirme su informaci\xf3n",
    referralLinkStep1: "Para crear un enlace de referencia necesitaremos:",
    referralLinkReq1: "- Su nombre",
    referralLinkReq2: "- Su direcci\xf3n de correo electr\xf3nico asociada a CBRE",
    referralLinkStep2: "Una vez un prospecto complete el formulario usando su enlace de referencia, enviaremos una copia de sus resultados a su bandeja de entrada.",
    next: "Siguiente",
    firstName: "Nombre",
    lastName: "Apellido",
    emptyNameError: "Por favor ingrese un nombre",
    email: "Su correo electr\xf3nico de CBRE",
    emptyEmailError: "Por favor ingrese un correo de CBRE",
    emailTakenError: "La cuenta de correo ya est\xe1 asociada a {{takenLink}}",
    emailExample: "ej.: jane.smith@cbre.com",
    editReferralInfo: "Edite la informaci\xf3n de nombre y correo ingresada",
    noLaterChanges: "No podr\xe1 cambiar esto despu\xe9s.",
    somethingWrong: "Ups, ocurri\xf3 un error. Por favor trate nuevamente.",
    contentLoading: "Cargando contenido",
    linkReady: "Su enlace est\xe1 listo",
    storeLinkInstructions: "Guarde este enlace en un lugar seguro, necesitar\xe1 usarlo cada vez que comparta Spacer con cliente. Tambi\xe9n hemos enviado una copia de este enlace al correo electr\xf3nico registrado.",
    yourLink: "Su enlace de referencia",
    copyLink: "Copiar enlace de referencia",
    copiedLink: "Copiado al portapapeles",
    linkNeverExpires: "Recordatorio: este enlace no expira nunca.",
    linkFound: "Encontramos su enlace",
    emailNotAssociated: "No encontramos un enlace de referencia asociado a esa direcci\xf3n de correo.",
    createLink: "\xbfCrear uno?"
};


var $3c3e56a9ad855d62$exports = {};
$3c3e56a9ad855d62$exports = {
    blogHomeTitle: "Perspectivas y proyecciones de la oficina",
    // blog tags
    blogTagAllArticles: "Todos los art\xedculos ",
    blogTagSizeAndFit: "Tama\xf1o y ajuste ",
    blogTagOfficeCulture: "Cultura de la oficina / Cultura organizacional ",
    blogTagSpaceAndDesign: "Espacio y Dise\xf1o ",
    blogTagWorkplaceTrends: "Tendencias en el lugar de trabajo "
};


// Links namespace names to their files
const $0ac28f67a425659a$var$resources = {
    en: {
        landingPage: $19549b141cd31dce$exports,
        common: $bbf7aad4e4fb7b6e$exports,
        resultsPage: $d25197544d693ff7$exports,
        termsOfServicePage: $af197e51be5389e5$exports,
        quizPage: $322c47945fe34a0b$exports,
        aboutPage: $e3606b3900259f73$exports,
        blogPages: $1865ba2a1eb59826$exports,
        referrals: $fd75154848e061f9$exports,
        blogArticle20190621: $f6de330988d28a32$exports,
        blogArticle20190625: $db833de2608468fa$exports,
        blogArticle20190627: $3438254d7f900ffe$exports
    },
    "en-GB": {
        landingPage: $b9f824257026abb6$exports,
        common: $1c35b94398f71352$exports,
        resultsPage: $4def54bfc9087558$exports,
        termsOfServicePage: $8e9a0cb3fc2d34e0$exports,
        quizPage: $923af5276166d41b$exports,
        aboutPage: $21c0d238768267d5$exports,
        blogPages: $8e89b822f11fff00$exports,
        // todo: add GB versions of blog posts
        // blogArticle20190621: no translation yet,
        // blogArticle20190625: no translation yet,
        // blogArticle20190627: no translation yet
        referrals: $8dc68379caf7b1ed$exports
    },
    de: {
        landingPage: $5febac30b9780ab5$exports,
        common: $a0628406fef2231a$exports,
        resultsPage: $5848716b615c4cac$exports,
        termsOfServicePage: $6d92b4d2e52e1edf$exports,
        quizPage: $8a7d5e2f162aefe7$exports,
        aboutPage: $706363a497ebf106$exports,
        blogPages: $245511775c20e878$exports,
        // todo: add German versions of blog posts
        // blogArticle20190621: no translation yet,
        // blogArticle20190625: no translation yet,
        // blogArticle20190627: no translation yet
        referrals: $3a4da95c94dc9afa$exports
    },
    fr: {
        landingPage: $9c868375bbef3594$exports,
        common: $1b03595e375c4b10$exports,
        resultsPage: $ba0bd9adb44a622a$exports,
        termsOfServicePage: $1162e5242ea498da$exports,
        quizPage: $fb0aaa47f75ac15a$exports,
        aboutPage: $3c42e6a82282860f$exports,
        blogPages: $3d59146587b97528$exports,
        referrals: $daab58ba16d91076$exports
    },
    svk: {
        landingPage: $85afdc1c7d675f63$exports,
        common: $4a0b11b183665d0d$exports,
        resultsPage: $6fc6e3fd44cfaab5$exports,
        termsOfServicePage: $ae6faa232cc8f70e$exports,
        quizPage: $4ab9959164770e8e$exports,
        aboutPage: $13e107e6be9f3ead$exports,
        blogPages: $365e600af8b73d91$exports,
        referrals: $c017e2c03c549f9f$exports
    },
    pol: {
        landingPage: $b4d2b7fdb3caac06$exports,
        common: $bdae1622ec799987$exports,
        resultsPage: $d987930d6e19f88e$exports,
        termsOfServicePage: $550bb4ccfffbdb32$exports,
        quizPage: $18425fd0bb528346$exports,
        aboutPage: $a82891e8b593609a$exports,
        blogPages: $bb92cd76fa085c30$exports,
        referrals: $8e26deba20238011$exports
    },
    hun: {
        landingPage: $5cef28aea58a47db$exports,
        common: $c9c5c955d0bd7c67$exports,
        resultsPage: $2b175f4550938cfe$exports,
        termsOfServicePage: $ca5a427bfbf28d83$exports,
        quizPage: $96da515567b8581f$exports,
        aboutPage: $381de4ffdc6b46d6$exports,
        blogPages: $b64bc75c35f8c166$exports,
        referrals: $9a8eeca4413eaf45$exports
    },
    nld: {
        landingPage: $532d1625f399479c$exports,
        common: $7168839dc5137750$exports,
        resultsPage: $909bcf1b18c89f14$exports,
        termsOfServicePage: $dd5ce2ea99edecbe$exports,
        quizPage: $8c0601727c39c197$exports,
        aboutPage: $fc90146d79b5d37b$exports,
        blogPages: $1587cf7de52e9d32$exports,
        referrals: $7ce6a0456b28a1aa$exports
    },
    col: {
        landingPage: $26b5f5598ab567c1$exports,
        common: $c7c85b93866b8b85$exports,
        resultsPage: $0a636378a48da627$exports,
        termsOfServicePage: $b4a2645243ac6c50$exports,
        quizPage: $6752c2715d81afbb$exports,
        aboutPage: $b421844c8c43bdd3$exports,
        blogPages: $3c3e56a9ad855d62$exports,
        referrals: $1245b615d8599a82$exports
    }
};
// Custom language detector for backup client-side language (based on URL's ccTLD)
const $0ac28f67a425659a$var$lngDetector = $b8cd368031f674c5$exports.getBrowserLanguageDetector();
$0ac28f67a425659a$require$i18n.use($0ac28f67a425659a$require$initReactI18next).use($0ac28f67a425659a$var$lngDetector).init({
    resources: // Resources: Connects i18n instance to the namespaces
    $0ac28f67a425659a$var$resources,
    // Detection: Specifies detectionOptions (which specifies things like detection order, cache, cookie expiration, etc.)
    detection: $b8cd368031f674c5$exports.detectionOptions,
    // Fallbacklng: language to use in case detector fails
    fallbackLng: "en",
    // Keyseparator: from documentation - "We do not use keys in form namespace.token"
    keySeparator: false,
    interpolation: {
        // From documentation: "React already safes from xss"
        escapeValue: false
    }
}, (err)=>{
    if (err) console.log("error loading i18n module", err);
});
$0ac28f67a425659a$exports = $0ac28f67a425659a$require$i18n;


parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");
var $8924627178c725bd$require$createRoot = $aRPiL.createRoot;

var $lzNIT = parcelRequire("lzNIT");
var $8924627178c725bd$require$RouterProvider = $lzNIT.RouterProvider;

var $eShmq = parcelRequire("eShmq");
var $8924627178c725bd$require$createStore = $eShmq.createStore;
var $8924627178c725bd$require$applyMiddleware = $eShmq.applyMiddleware;

var $jHTLJ = parcelRequire("jHTLJ");
var $8924627178c725bd$require$Provider = $jHTLJ.Provider;

var $eNuyV = parcelRequire("eNuyV");
var $8924627178c725bd$require$thunk = $eNuyV.default;
var $a5750ebba6802e03$exports = {};

var $f1q41 = parcelRequire("f1q41");

var $7PjUE = parcelRequire("7PjUE");
var $dd1d3e43b4086c4d$exports = {};
/*
    The Program Calculator takes a kit of parts with multipliers, spaceUnit types required by that KOPwM, and
    user defined metrics to compute the finalized space program. Calculations found below are derived from this
    google sheet:
      https://docs.google.com/spreadsheets/d/1jdQB5GfQxfLmHhok5DuHv6k5eFAJdtQ_ht-1TwbVaQo/edit#gid=2081962167

    APAC-specific logic (all space units have a circulation of 30%) came from:
    https://docs.google.com/document/d/1ipkQpO9e_vvFNuF7iFAtUcOk2-r2LCEscN8NnKH47Ug/edit

    Here are some definitions of terms that are found in the calculator:

      SpaceUnit - A set of metadata (including size and seats) surrounding a specific type of space, such as office, workstation, or copy room.

      Kit Of Parts with Multipliers - A collection of space units, each having one of various multipliers that are used to
      determine the quantity and area of the space type in the final program.

      NSF (Net Square Feet) - The area of each identified space unit

      USF (Usable Square Feet) - Area of a floor occupiable by a tenant where personnel or furniture are normally housed (both in total and per space unit)

      Circulation Area = USF - NSF
*/ var $03fab2938eebb631$exports = {};
(function(window, factory) {
    $03fab2938eebb631$exports = factory();
})($03fab2938eebb631$exports, function() {
    var jStat = function(Math1, undefined1) {
        // For quick reference.
        var concat = Array.prototype.concat;
        var slice = Array.prototype.slice;
        var toString = Object.prototype.toString;
        // Calculate correction for IEEE error
        // TODO: This calculation can be improved.
        function calcRdx(n, m) {
            var val = n > m ? n : m;
            return Math1.pow(10, 17 - ~~(Math1.log(val > 0 ? val : -val) * Math1.LOG10E));
        }
        var isArray = Array.isArray || function isArray(arg) {
            return toString.call(arg) === "[object Array]";
        };
        function isFunction(arg) {
            return toString.call(arg) === "[object Function]";
        }
        function isNumber(num) {
            return typeof num === "number" ? num - num === 0 : false;
        }
        // Converts the jStat matrix to vector.
        function toVector(arr) {
            return concat.apply([], arr);
        }
        // The one and only jStat constructor.
        function jStat() {
            return new jStat._init(arguments);
        }
        // TODO: Remove after all references in src files have been removed.
        jStat.fn = jStat.prototype;
        // By separating the initializer from the constructor it's easier to handle
        // always returning a new instance whether "new" was used or not.
        jStat._init = function _init(args) {
            // If first argument is an array, must be vector or matrix.
            if (isArray(args[0])) {
                // Check if matrix.
                if (isArray(args[0][0])) {
                    // See if a mapping function was also passed.
                    if (isFunction(args[1])) args[0] = jStat.map(args[0], args[1]);
                    // Iterate over each is faster than this.push.apply(this, args[0].
                    for(var i = 0; i < args[0].length; i++)this[i] = args[0][i];
                    this.length = args[0].length;
                // Otherwise must be a vector.
                } else {
                    this[0] = isFunction(args[1]) ? jStat.map(args[0], args[1]) : args[0];
                    this.length = 1;
                }
            } else if (isNumber(args[0])) {
                this[0] = jStat.seq.apply(null, args);
                this.length = 1;
            // Handle case when jStat object is passed to jStat.
            } else if (args[0] instanceof jStat) // Duplicate the object and pass it back.
            return jStat(args[0].toArray());
            else {
                this[0] = [];
                this.length = 1;
            }
            return this;
        };
        jStat._init.prototype = jStat.prototype;
        jStat._init.constructor = jStat;
        // Utility functions.
        // TODO: for internal use only?
        jStat.utils = {
            calcRdx: calcRdx,
            isArray: isArray,
            isFunction: isFunction,
            isNumber: isNumber,
            toVector: toVector
        };
        jStat._random_fn = Math1.random;
        jStat.setRandom = function setRandom(fn) {
            if (typeof fn !== "function") throw new TypeError("fn is not a function");
            jStat._random_fn = fn;
        };
        // Easily extend the jStat object.
        // TODO: is this seriously necessary?
        jStat.extend = function extend(obj) {
            var i, j;
            if (arguments.length === 1) {
                for(j in obj)jStat[j] = obj[j];
                return this;
            }
            for(i = 1; i < arguments.length; i++)for(j in arguments[i])obj[j] = arguments[i][j];
            return obj;
        };
        // Returns the number of rows in the matrix.
        jStat.rows = function rows(arr) {
            return arr.length || 1;
        };
        // Returns the number of columns in the matrix.
        jStat.cols = function cols(arr) {
            return arr[0].length || 1;
        };
        // Returns the dimensions of the object { rows: i, cols: j }
        jStat.dimensions = function dimensions(arr) {
            return {
                rows: jStat.rows(arr),
                cols: jStat.cols(arr)
            };
        };
        // Returns a specified row as a vector or return a sub matrix by pick some rows
        jStat.row = function row(arr, index) {
            if (isArray(index)) return index.map(function(i) {
                return jStat.row(arr, i);
            });
            return arr[index];
        };
        // return row as array
        // rowa([[1,2],[3,4]],0) -> [1,2]
        jStat.rowa = function rowa(arr, i) {
            return jStat.row(arr, i);
        };
        // Returns the specified column as a vector or return a sub matrix by pick some
        // columns
        jStat.col = function col(arr, index) {
            if (isArray(index)) {
                var submat = jStat.arange(arr.length).map(function() {
                    return new Array(index.length);
                });
                index.forEach(function(ind, i) {
                    jStat.arange(arr.length).forEach(function(j) {
                        submat[j][i] = arr[j][ind];
                    });
                });
                return submat;
            }
            var column = new Array(arr.length);
            for(var i = 0; i < arr.length; i++)column[i] = [
                arr[i][index]
            ];
            return column;
        };
        // return column as array
        // cola([[1,2],[3,4]],0) -> [1,3]
        jStat.cola = function cola(arr, i) {
            return jStat.col(arr, i).map(function(a) {
                return a[0];
            });
        };
        // Returns the diagonal of the matrix
        jStat.diag = function diag(arr) {
            var nrow = jStat.rows(arr);
            var res = new Array(nrow);
            for(var row = 0; row < nrow; row++)res[row] = [
                arr[row][row]
            ];
            return res;
        };
        // Returns the anti-diagonal of the matrix
        jStat.antidiag = function antidiag(arr) {
            var nrow = jStat.rows(arr) - 1;
            var res = new Array(nrow);
            for(var i = 0; nrow >= 0; nrow--, i++)res[i] = [
                arr[i][nrow]
            ];
            return res;
        };
        // Transpose a matrix or array.
        jStat.transpose = function transpose(arr) {
            var obj = [];
            var objArr, rows, cols, j, i;
            // Make sure arr is in matrix format.
            if (!isArray(arr[0])) arr = [
                arr
            ];
            rows = arr.length;
            cols = arr[0].length;
            for(i = 0; i < cols; i++){
                objArr = new Array(rows);
                for(j = 0; j < rows; j++)objArr[j] = arr[j][i];
                obj.push(objArr);
            }
            // If obj is vector, return only single array.
            return obj.length === 1 ? obj[0] : obj;
        };
        // Map a function to an array or array of arrays.
        // "toAlter" is an internal variable.
        jStat.map = function map(arr, func, toAlter) {
            var row, nrow, ncol, res, col;
            if (!isArray(arr[0])) arr = [
                arr
            ];
            nrow = arr.length;
            ncol = arr[0].length;
            res = toAlter ? arr : new Array(nrow);
            for(row = 0; row < nrow; row++){
                // if the row doesn't exist, create it
                if (!res[row]) res[row] = new Array(ncol);
                for(col = 0; col < ncol; col++)res[row][col] = func(arr[row][col], row, col);
            }
            return res.length === 1 ? res[0] : res;
        };
        // Cumulatively combine the elements of an array or array of arrays using a function.
        jStat.cumreduce = function cumreduce(arr, func, toAlter) {
            var row, nrow, ncol, res, col;
            if (!isArray(arr[0])) arr = [
                arr
            ];
            nrow = arr.length;
            ncol = arr[0].length;
            res = toAlter ? arr : new Array(nrow);
            for(row = 0; row < nrow; row++){
                // if the row doesn't exist, create it
                if (!res[row]) res[row] = new Array(ncol);
                if (ncol > 0) res[row][0] = arr[row][0];
                for(col = 1; col < ncol; col++)res[row][col] = func(res[row][col - 1], arr[row][col]);
            }
            return res.length === 1 ? res[0] : res;
        };
        // Destructively alter an array.
        jStat.alter = function alter(arr, func) {
            return jStat.map(arr, func, true);
        };
        // Generate a rows x cols matrix according to the supplied function.
        jStat.create = function create(rows, cols, func) {
            var res = new Array(rows);
            var i, j;
            if (isFunction(cols)) {
                func = cols;
                cols = rows;
            }
            for(i = 0; i < rows; i++){
                res[i] = new Array(cols);
                for(j = 0; j < cols; j++)res[i][j] = func(i, j);
            }
            return res;
        };
        function retZero() {
            return 0;
        }
        // Generate a rows x cols matrix of zeros.
        jStat.zeros = function zeros(rows, cols) {
            if (!isNumber(cols)) cols = rows;
            return jStat.create(rows, cols, retZero);
        };
        function retOne() {
            return 1;
        }
        // Generate a rows x cols matrix of ones.
        jStat.ones = function ones(rows, cols) {
            if (!isNumber(cols)) cols = rows;
            return jStat.create(rows, cols, retOne);
        };
        // Generate a rows x cols matrix of uniformly random numbers.
        jStat.rand = function rand(rows, cols) {
            if (!isNumber(cols)) cols = rows;
            return jStat.create(rows, cols, jStat._random_fn);
        };
        function retIdent(i, j) {
            return i === j ? 1 : 0;
        }
        // Generate an identity matrix of size row x cols.
        jStat.identity = function identity(rows, cols) {
            if (!isNumber(cols)) cols = rows;
            return jStat.create(rows, cols, retIdent);
        };
        // Tests whether a matrix is symmetric
        jStat.symmetric = function symmetric(arr) {
            var size = arr.length;
            var row, col;
            if (arr.length !== arr[0].length) return false;
            for(row = 0; row < size; row++){
                for(col = 0; col < size; col++)if (arr[col][row] !== arr[row][col]) return false;
            }
            return true;
        };
        // Set all values to zero.
        jStat.clear = function clear(arr) {
            return jStat.alter(arr, retZero);
        };
        // Generate sequence.
        jStat.seq = function seq(min, max, length, func) {
            if (!isFunction(func)) func = false;
            var arr = [];
            var hival = calcRdx(min, max);
            var step = (max * hival - min * hival) / ((length - 1) * hival);
            var current = min;
            var cnt;
            // Current is assigned using a technique to compensate for IEEE error.
            // TODO: Needs better implementation.
            for(cnt = 0; current <= max && cnt < length; cnt++, current = (min * hival + step * hival * cnt) / hival)arr.push(func ? func(current, cnt) : current);
            return arr;
        };
        // arange(5) -> [0,1,2,3,4]
        // arange(1,5) -> [1,2,3,4]
        // arange(5,1,-1) -> [5,4,3,2]
        jStat.arange = function arange(start, end, step) {
            var rl = [];
            var i;
            step = step || 1;
            if (end === undefined1) {
                end = start;
                start = 0;
            }
            if (start === end || step === 0) return [];
            if (start < end && step < 0) return [];
            if (start > end && step > 0) return [];
            if (step > 0) for(i = start; i < end; i += step)rl.push(i);
            else for(i = start; i > end; i += step)rl.push(i);
            return rl;
        };
        // A=[[1,2,3],[4,5,6],[7,8,9]]
        // slice(A,{row:{end:2},col:{start:1}}) -> [[2,3],[5,6]]
        // slice(A,1,{start:1}) -> [5,6]
        // as numpy code A[:2,1:]
        jStat.slice = function() {
            function _slice(list, start, end, step) {
                // note it's not equal to range.map mode it's a bug
                var i;
                var rl = [];
                var length = list.length;
                if (start === undefined1 && end === undefined1 && step === undefined1) return jStat.copy(list);
                start = start || 0;
                end = end || list.length;
                start = start >= 0 ? start : length + start;
                end = end >= 0 ? end : length + end;
                step = step || 1;
                if (start === end || step === 0) return [];
                if (start < end && step < 0) return [];
                if (start > end && step > 0) return [];
                if (step > 0) for(i = start; i < end; i += step)rl.push(list[i]);
                else for(i = start; i > end; i += step)rl.push(list[i]);
                return rl;
            }
            function slice(list, rcSlice) {
                var colSlice, rowSlice;
                rcSlice = rcSlice || {};
                if (isNumber(rcSlice.row)) {
                    if (isNumber(rcSlice.col)) return list[rcSlice.row][rcSlice.col];
                    var row = jStat.rowa(list, rcSlice.row);
                    colSlice = rcSlice.col || {};
                    return _slice(row, colSlice.start, colSlice.end, colSlice.step);
                }
                if (isNumber(rcSlice.col)) {
                    var col = jStat.cola(list, rcSlice.col);
                    rowSlice = rcSlice.row || {};
                    return _slice(col, rowSlice.start, rowSlice.end, rowSlice.step);
                }
                rowSlice = rcSlice.row || {};
                colSlice = rcSlice.col || {};
                var rows = _slice(list, rowSlice.start, rowSlice.end, rowSlice.step);
                return rows.map(function(row) {
                    return _slice(row, colSlice.start, colSlice.end, colSlice.step);
                });
            }
            return slice;
        }();
        // A=[[1,2,3],[4,5,6],[7,8,9]]
        // sliceAssign(A,{row:{start:1},col:{start:1}},[[0,0],[0,0]])
        // A=[[1,2,3],[4,0,0],[7,0,0]]
        jStat.sliceAssign = function sliceAssign(A, rcSlice, B) {
            var nl, ml;
            if (isNumber(rcSlice.row)) {
                if (isNumber(rcSlice.col)) return A[rcSlice.row][rcSlice.col] = B;
                rcSlice.col = rcSlice.col || {};
                rcSlice.col.start = rcSlice.col.start || 0;
                rcSlice.col.end = rcSlice.col.end || A[0].length;
                rcSlice.col.step = rcSlice.col.step || 1;
                nl = jStat.arange(rcSlice.col.start, Math1.min(A.length, rcSlice.col.end), rcSlice.col.step);
                var m = rcSlice.row;
                nl.forEach(function(n, i) {
                    A[m][n] = B[i];
                });
                return A;
            }
            if (isNumber(rcSlice.col)) {
                rcSlice.row = rcSlice.row || {};
                rcSlice.row.start = rcSlice.row.start || 0;
                rcSlice.row.end = rcSlice.row.end || A.length;
                rcSlice.row.step = rcSlice.row.step || 1;
                ml = jStat.arange(rcSlice.row.start, Math1.min(A[0].length, rcSlice.row.end), rcSlice.row.step);
                var n = rcSlice.col;
                ml.forEach(function(m, j) {
                    A[m][n] = B[j];
                });
                return A;
            }
            if (B[0].length === undefined1) B = [
                B
            ];
            rcSlice.row.start = rcSlice.row.start || 0;
            rcSlice.row.end = rcSlice.row.end || A.length;
            rcSlice.row.step = rcSlice.row.step || 1;
            rcSlice.col.start = rcSlice.col.start || 0;
            rcSlice.col.end = rcSlice.col.end || A[0].length;
            rcSlice.col.step = rcSlice.col.step || 1;
            ml = jStat.arange(rcSlice.row.start, Math1.min(A.length, rcSlice.row.end), rcSlice.row.step);
            nl = jStat.arange(rcSlice.col.start, Math1.min(A[0].length, rcSlice.col.end), rcSlice.col.step);
            ml.forEach(function(m, i) {
                nl.forEach(function(n, j) {
                    A[m][n] = B[i][j];
                });
            });
            return A;
        };
        // [1,2,3] ->
        // [[1,0,0],[0,2,0],[0,0,3]]
        jStat.diagonal = function diagonal(diagArray) {
            var mat = jStat.zeros(diagArray.length, diagArray.length);
            diagArray.forEach(function(t, i) {
                mat[i][i] = t;
            });
            return mat;
        };
        // return copy of A
        jStat.copy = function copy(A) {
            return A.map(function(row) {
                if (isNumber(row)) return row;
                return row.map(function(t) {
                    return t;
                });
            });
        };
        // TODO: Go over this entire implementation. Seems a tragic waste of resources
        // doing all this work. Instead, and while ugly, use new Function() to generate
        // a custom function for each static method.
        // Quick reference.
        var jProto = jStat.prototype;
        // Default length.
        jProto.length = 0;
        // For internal use only.
        // TODO: Check if they're actually used, and if they are then rename them
        // to _*
        jProto.push = Array.prototype.push;
        jProto.sort = Array.prototype.sort;
        jProto.splice = Array.prototype.splice;
        jProto.slice = Array.prototype.slice;
        // Return a clean array.
        jProto.toArray = function toArray() {
            return this.length > 1 ? slice.call(this) : slice.call(this)[0];
        };
        // Map a function to a matrix or vector.
        jProto.map = function map(func, toAlter) {
            return jStat(jStat.map(this, func, toAlter));
        };
        // Cumulatively combine the elements of a matrix or vector using a function.
        jProto.cumreduce = function cumreduce(func, toAlter) {
            return jStat(jStat.cumreduce(this, func, toAlter));
        };
        // Destructively alter an array.
        jProto.alter = function alter(func) {
            jStat.alter(this, func);
            return this;
        };
        // Extend prototype with methods that have no argument.
        (function(funcs) {
            for(var i = 0; i < funcs.length; i++)(function(passfunc) {
                jProto[passfunc] = function(func) {
                    var self = this, results;
                    // Check for callback.
                    if (func) {
                        setTimeout(function() {
                            func.call(self, jProto[passfunc].call(self));
                        });
                        return this;
                    }
                    results = jStat[passfunc](this);
                    return isArray(results) ? jStat(results) : results;
                };
            })(funcs[i]);
        })("transpose clear symmetric rows cols dimensions diag antidiag".split(" "));
        // Extend prototype with methods that have one argument.
        (function(funcs) {
            for(var i = 0; i < funcs.length; i++)(function(passfunc) {
                jProto[passfunc] = function(index, func) {
                    var self = this;
                    // check for callback
                    if (func) {
                        setTimeout(function() {
                            func.call(self, jProto[passfunc].call(self, index));
                        });
                        return this;
                    }
                    return jStat(jStat[passfunc](this, index));
                };
            })(funcs[i]);
        })("row col".split(" "));
        // Extend prototype with simple shortcut methods.
        (function(funcs) {
            for(var i = 0; i < funcs.length; i++)(function(passfunc) {
                jProto[passfunc] = function() {
                    return jStat(jStat[passfunc].apply(null, arguments));
                };
            })(funcs[i]);
        })("create zeros ones rand identity".split(" "));
        // Exposing jStat.
        return jStat;
    }(Math);
    (function(jStat, Math1) {
        var isFunction = jStat.utils.isFunction;
        // Ascending functions for sort
        function ascNum(a, b) {
            return a - b;
        }
        function clip(arg, min, max) {
            return Math1.max(min, Math1.min(arg, max));
        }
        // sum of an array
        jStat.sum = function sum(arr) {
            var sum = 0;
            var i = arr.length;
            while(--i >= 0)sum += arr[i];
            return sum;
        };
        // sum squared
        jStat.sumsqrd = function sumsqrd(arr) {
            var sum = 0;
            var i = arr.length;
            while(--i >= 0)sum += arr[i] * arr[i];
            return sum;
        };
        // sum of squared errors of prediction (SSE)
        jStat.sumsqerr = function sumsqerr(arr) {
            var mean = jStat.mean(arr);
            var sum = 0;
            var i = arr.length;
            var tmp;
            while(--i >= 0){
                tmp = arr[i] - mean;
                sum += tmp * tmp;
            }
            return sum;
        };
        // sum of an array in each row
        jStat.sumrow = function sumrow(arr) {
            var sum = 0;
            var i = arr.length;
            while(--i >= 0)sum += arr[i];
            return sum;
        };
        // product of an array
        jStat.product = function product(arr) {
            var prod = 1;
            var i = arr.length;
            while(--i >= 0)prod *= arr[i];
            return prod;
        };
        // minimum value of an array
        jStat.min = function min(arr) {
            var low = arr[0];
            var i = 0;
            while(++i < arr.length)if (arr[i] < low) low = arr[i];
            return low;
        };
        // maximum value of an array
        jStat.max = function max(arr) {
            var high = arr[0];
            var i = 0;
            while(++i < arr.length)if (arr[i] > high) high = arr[i];
            return high;
        };
        // unique values of an array
        jStat.unique = function unique(arr) {
            var hash = {}, _arr = [];
            for(var i = 0; i < arr.length; i++)if (!hash[arr[i]]) {
                hash[arr[i]] = true;
                _arr.push(arr[i]);
            }
            return _arr;
        };
        // mean value of an array
        jStat.mean = function mean(arr) {
            return jStat.sum(arr) / arr.length;
        };
        // mean squared error (MSE)
        jStat.meansqerr = function meansqerr(arr) {
            return jStat.sumsqerr(arr) / arr.length;
        };
        // geometric mean of an array
        jStat.geomean = function geomean(arr) {
            var logs = arr.map(Math1.log);
            var meanOfLogs = jStat.mean(logs);
            return Math1.exp(meanOfLogs);
        };
        // median of an array
        jStat.median = function median(arr) {
            var arrlen = arr.length;
            var _arr = arr.slice().sort(ascNum);
            // check if array is even or odd, then return the appropriate
            return !(arrlen & 1) ? (_arr[arrlen / 2 - 1] + _arr[arrlen / 2]) / 2 : _arr[arrlen / 2 | 0];
        };
        // cumulative sum of an array
        jStat.cumsum = function cumsum(arr) {
            return jStat.cumreduce(arr, function(a, b) {
                return a + b;
            });
        };
        // cumulative product of an array
        jStat.cumprod = function cumprod(arr) {
            return jStat.cumreduce(arr, function(a, b) {
                return a * b;
            });
        };
        // successive differences of a sequence
        jStat.diff = function diff(arr) {
            var diffs = [];
            var arrLen = arr.length;
            var i;
            for(i = 1; i < arrLen; i++)diffs.push(arr[i] - arr[i - 1]);
            return diffs;
        };
        // ranks of an array
        jStat.rank = function(arr) {
            var i;
            var distinctNumbers = [];
            var numberCounts = {};
            for(i = 0; i < arr.length; i++){
                var number = arr[i];
                if (numberCounts[number]) numberCounts[number]++;
                else {
                    numberCounts[number] = 1;
                    distinctNumbers.push(number);
                }
            }
            var sortedDistinctNumbers = distinctNumbers.sort(ascNum);
            var numberRanks = {};
            var currentRank = 1;
            for(i = 0; i < sortedDistinctNumbers.length; i++){
                var number = sortedDistinctNumbers[i];
                var count = numberCounts[number];
                var first = currentRank;
                var last = currentRank + count - 1;
                var rank = (first + last) / 2;
                numberRanks[number] = rank;
                currentRank += count;
            }
            return arr.map(function(number) {
                return numberRanks[number];
            });
        };
        // mode of an array
        // if there are multiple modes of an array, return all of them
        // is this the appropriate way of handling it?
        jStat.mode = function mode(arr) {
            var arrLen = arr.length;
            var _arr = arr.slice().sort(ascNum);
            var count = 1;
            var maxCount = 0;
            var numMaxCount = 0;
            var mode_arr = [];
            var i;
            for(i = 0; i < arrLen; i++)if (_arr[i] === _arr[i + 1]) count++;
            else {
                if (count > maxCount) {
                    mode_arr = [
                        _arr[i]
                    ];
                    maxCount = count;
                    numMaxCount = 0;
                } else if (count === maxCount) {
                    mode_arr.push(_arr[i]);
                    numMaxCount++;
                }
                // resetting count for new value in array
                count = 1;
            }
            return numMaxCount === 0 ? mode_arr[0] : mode_arr;
        };
        // range of an array
        jStat.range = function range(arr) {
            return jStat.max(arr) - jStat.min(arr);
        };
        // variance of an array
        // flag = true indicates sample instead of population
        jStat.variance = function variance(arr, flag) {
            return jStat.sumsqerr(arr) / (arr.length - (flag ? 1 : 0));
        };
        // pooled variance of an array of arrays
        jStat.pooledvariance = function pooledvariance(arr) {
            var sumsqerr = arr.reduce(function(a, samples) {
                return a + jStat.sumsqerr(samples);
            }, 0);
            var count = arr.reduce(function(a, samples) {
                return a + samples.length;
            }, 0);
            return sumsqerr / (count - arr.length);
        };
        // deviation of an array
        jStat.deviation = function(arr) {
            var mean = jStat.mean(arr);
            var arrlen = arr.length;
            var dev = new Array(arrlen);
            for(var i = 0; i < arrlen; i++)dev[i] = arr[i] - mean;
            return dev;
        };
        // standard deviation of an array
        // flag = true indicates sample instead of population
        jStat.stdev = function stdev(arr, flag) {
            return Math1.sqrt(jStat.variance(arr, flag));
        };
        // pooled standard deviation of an array of arrays
        jStat.pooledstdev = function pooledstdev(arr) {
            return Math1.sqrt(jStat.pooledvariance(arr));
        };
        // mean deviation (mean absolute deviation) of an array
        jStat.meandev = function meandev(arr) {
            var mean = jStat.mean(arr);
            var a = [];
            for(var i = arr.length - 1; i >= 0; i--)a.push(Math1.abs(arr[i] - mean));
            return jStat.mean(a);
        };
        // median deviation (median absolute deviation) of an array
        jStat.meddev = function meddev(arr) {
            var median = jStat.median(arr);
            var a = [];
            for(var i = arr.length - 1; i >= 0; i--)a.push(Math1.abs(arr[i] - median));
            return jStat.median(a);
        };
        // coefficient of variation
        jStat.coeffvar = function coeffvar(arr) {
            return jStat.stdev(arr) / jStat.mean(arr);
        };
        // quartiles of an array
        jStat.quartiles = function quartiles(arr) {
            var arrlen = arr.length;
            var _arr = arr.slice().sort(ascNum);
            return [
                _arr[Math1.round(arrlen / 4) - 1],
                _arr[Math1.round(arrlen / 2) - 1],
                _arr[Math1.round(arrlen * 3 / 4) - 1]
            ];
        };
        // Arbitary quantiles of an array. Direct port of the scipy.stats
        // implementation by Pierre GF Gerard-Marchant.
        jStat.quantiles = function quantiles(arr, quantilesArray, alphap, betap) {
            var sortedArray = arr.slice().sort(ascNum);
            var quantileVals = [
                quantilesArray.length
            ];
            var n = arr.length;
            var i, p, m, aleph, k, gamma;
            if (typeof alphap === "undefined") alphap = 3 / 8;
            if (typeof betap === "undefined") betap = 3 / 8;
            for(i = 0; i < quantilesArray.length; i++){
                p = quantilesArray[i];
                m = alphap + p * (1 - alphap - betap);
                aleph = n * p + m;
                k = Math1.floor(clip(aleph, 1, n - 1));
                gamma = clip(aleph - k, 0, 1);
                quantileVals[i] = (1 - gamma) * sortedArray[k - 1] + gamma * sortedArray[k];
            }
            return quantileVals;
        };
        // Return the k-th percentile of values in a range, where k is in the range 0..1, inclusive.
        // Passing true for the exclusive parameter excludes both endpoints of the range.
        jStat.percentile = function percentile(arr, k, exclusive) {
            var _arr = arr.slice().sort(ascNum);
            var realIndex = k * (_arr.length + (exclusive ? 1 : -1)) + (exclusive ? 0 : 1);
            var index = parseInt(realIndex);
            var frac = realIndex - index;
            if (index + 1 < _arr.length) return _arr[index - 1] + frac * (_arr[index] - _arr[index - 1]);
            else return _arr[index - 1];
        };
        // The percentile rank of score in a given array. Returns the percentage
        // of all values in the input array that are less than (kind='strict') or
        // less or equal than (kind='weak') score. Default is weak.
        jStat.percentileOfScore = function percentileOfScore(arr, score, kind) {
            var counter = 0;
            var len = arr.length;
            var strict = false;
            var value, i;
            if (kind === "strict") strict = true;
            for(i = 0; i < len; i++){
                value = arr[i];
                if (strict && value < score || !strict && value <= score) counter++;
            }
            return counter / len;
        };
        // Histogram (bin count) data
        jStat.histogram = function histogram(arr, binCnt) {
            binCnt = binCnt || 4;
            var first = jStat.min(arr);
            var binWidth = (jStat.max(arr) - first) / binCnt;
            var len = arr.length;
            var bins = [];
            var i;
            for(i = 0; i < binCnt; i++)bins[i] = 0;
            for(i = 0; i < len; i++)bins[Math1.min(Math1.floor((arr[i] - first) / binWidth), binCnt - 1)] += 1;
            return bins;
        };
        // covariance of two arrays
        jStat.covariance = function covariance(arr1, arr2) {
            var u = jStat.mean(arr1);
            var v = jStat.mean(arr2);
            var arr1Len = arr1.length;
            var sq_dev = new Array(arr1Len);
            var i;
            for(i = 0; i < arr1Len; i++)sq_dev[i] = (arr1[i] - u) * (arr2[i] - v);
            return jStat.sum(sq_dev) / (arr1Len - 1);
        };
        // (pearson's) population correlation coefficient, rho
        jStat.corrcoeff = function corrcoeff(arr1, arr2) {
            return jStat.covariance(arr1, arr2) / jStat.stdev(arr1, 1) / jStat.stdev(arr2, 1);
        };
        // (spearman's) rank correlation coefficient, sp
        jStat.spearmancoeff = function(arr1, arr2) {
            arr1 = jStat.rank(arr1);
            arr2 = jStat.rank(arr2);
            //return pearson's correlation of the ranks:
            return jStat.corrcoeff(arr1, arr2);
        };
        // statistical standardized moments (general form of skew/kurt)
        jStat.stanMoment = function stanMoment(arr, n) {
            var mu = jStat.mean(arr);
            var sigma = jStat.stdev(arr);
            var len = arr.length;
            var skewSum = 0;
            for(var i = 0; i < len; i++)skewSum += Math1.pow((arr[i] - mu) / sigma, n);
            return skewSum / arr.length;
        };
        // (pearson's) moment coefficient of skewness
        jStat.skewness = function skewness(arr) {
            return jStat.stanMoment(arr, 3);
        };
        // (pearson's) (excess) kurtosis
        jStat.kurtosis = function kurtosis(arr) {
            return jStat.stanMoment(arr, 4) - 3;
        };
        var jProto = jStat.prototype;
        // Extend jProto with method for calculating cumulative sums and products.
        // This differs from the similar extension below as cumsum and cumprod should
        // not be run again in the case fullbool === true.
        // If a matrix is passed, automatically assume operation should be done on the
        // columns.
        (function(funcs) {
            for(var i = 0; i < funcs.length; i++)(function(passfunc) {
                // If a matrix is passed, automatically assume operation should be done on
                // the columns.
                jProto[passfunc] = function(fullbool, func) {
                    var arr = [];
                    var i = 0;
                    var tmpthis = this;
                    // Assignment reassignation depending on how parameters were passed in.
                    if (isFunction(fullbool)) {
                        func = fullbool;
                        fullbool = false;
                    }
                    // Check if a callback was passed with the function.
                    if (func) {
                        setTimeout(function() {
                            func.call(tmpthis, jProto[passfunc].call(tmpthis, fullbool));
                        });
                        return this;
                    }
                    // Check if matrix and run calculations.
                    if (this.length > 1) {
                        tmpthis = fullbool === true ? this : this.transpose();
                        for(; i < tmpthis.length; i++)arr[i] = jStat[passfunc](tmpthis[i]);
                        return arr;
                    }
                    // Pass fullbool if only vector, not a matrix. for variance and stdev.
                    return jStat[passfunc](this[0], fullbool);
                };
            })(funcs[i]);
        })("cumsum cumprod".split(" "));
        // Extend jProto with methods which don't require arguments and work on columns.
        (function(funcs) {
            for(var i = 0; i < funcs.length; i++)(function(passfunc) {
                // If a matrix is passed, automatically assume operation should be done on
                // the columns.
                jProto[passfunc] = function(fullbool, func) {
                    var arr = [];
                    var i = 0;
                    var tmpthis = this;
                    // Assignment reassignation depending on how parameters were passed in.
                    if (isFunction(fullbool)) {
                        func = fullbool;
                        fullbool = false;
                    }
                    // Check if a callback was passed with the function.
                    if (func) {
                        setTimeout(function() {
                            func.call(tmpthis, jProto[passfunc].call(tmpthis, fullbool));
                        });
                        return this;
                    }
                    // Check if matrix and run calculations.
                    if (this.length > 1) {
                        if (passfunc !== "sumrow") tmpthis = fullbool === true ? this : this.transpose();
                        for(; i < tmpthis.length; i++)arr[i] = jStat[passfunc](tmpthis[i]);
                        return fullbool === true ? jStat[passfunc](jStat.utils.toVector(arr)) : arr;
                    }
                    // Pass fullbool if only vector, not a matrix. for variance and stdev.
                    return jStat[passfunc](this[0], fullbool);
                };
            })(funcs[i]);
        })("sum sumsqrd sumsqerr sumrow product min max unique mean meansqerr geomean median diff rank mode range variance deviation stdev meandev meddev coeffvar quartiles histogram skewness kurtosis".split(" "));
        // Extend jProto with functions that take arguments. Operations on matrices are
        // done on columns.
        (function(funcs) {
            for(var i = 0; i < funcs.length; i++)(function(passfunc) {
                jProto[passfunc] = function() {
                    var arr = [];
                    var i = 0;
                    var tmpthis = this;
                    var args = Array.prototype.slice.call(arguments);
                    var callbackFunction;
                    // If the last argument is a function, we assume it's a callback; we
                    // strip the callback out and call the function again.
                    if (isFunction(args[args.length - 1])) {
                        callbackFunction = args[args.length - 1];
                        var argsToPass = args.slice(0, args.length - 1);
                        setTimeout(function() {
                            callbackFunction.call(tmpthis, jProto[passfunc].apply(tmpthis, argsToPass));
                        });
                        return this;
                    // Otherwise we curry the function args and call normally.
                    } else {
                        callbackFunction = undefined;
                        var curriedFunction = function curriedFunction(vector) {
                            return jStat[passfunc].apply(tmpthis, [
                                vector
                            ].concat(args));
                        };
                    }
                    // If this is a matrix, run column-by-column.
                    if (this.length > 1) {
                        tmpthis = tmpthis.transpose();
                        for(; i < tmpthis.length; i++)arr[i] = curriedFunction(tmpthis[i]);
                        return arr;
                    }
                    // Otherwise run on the vector.
                    return curriedFunction(this[0]);
                };
            })(funcs[i]);
        })("quantiles percentileOfScore".split(" "));
    })(jStat, Math);
    // Special functions //
    (function(jStat, Math1) {
        // Log-gamma function
        jStat.gammaln = function gammaln(x) {
            var j = 0;
            var cof = [
                76.18009172947146,
                -86.50532032941678,
                24.01409824083091,
                -1.231739572450155,
                0.1208650973866179e-2,
                -0.000005395239384953
            ];
            var ser = 1.000000000190015;
            var xx, y, tmp;
            tmp = (y = xx = x) + 5.5;
            tmp -= (xx + 0.5) * Math1.log(tmp);
            for(; j < 6; j++)ser += cof[j] / ++y;
            return Math1.log(2.5066282746310005 * ser / xx) - tmp;
        };
        /*
 * log-gamma function to support poisson distribution sampling. The
 * algorithm comes from SPECFUN by Shanjie Zhang and Jianming Jin and their
 * book "Computation of Special Functions", 1996, John Wiley & Sons, Inc.
 */ jStat.loggam = function loggam(x) {
            var x0, x2, xp, gl, gl0;
            var k, n;
            var a = [
                8.333333333333333e-02,
                -0.002777777777777778,
                7.936507936507937e-04,
                -0.0005952380952380952,
                8.417508417508418e-04,
                -0.001917526917526918,
                6.410256410256410e-03,
                -0.02955065359477124,
                1.796443723688307e-01,
                -1.3924322169059
            ];
            x0 = x;
            n = 0;
            if (x == 1.0 || x == 2.0) return 0.0;
            if (x <= 7.0) {
                n = Math1.floor(7 - x);
                x0 = x + n;
            }
            x2 = 1.0 / (x0 * x0);
            xp = 2 * Math1.PI;
            gl0 = a[9];
            for(k = 8; k >= 0; k--){
                gl0 *= x2;
                gl0 += a[k];
            }
            gl = gl0 / x0 + 0.5 * Math1.log(xp) + (x0 - 0.5) * Math1.log(x0) - x0;
            if (x <= 7.0) for(k = 1; k <= n; k++){
                gl -= Math1.log(x0 - 1.0);
                x0 -= 1.0;
            }
            return gl;
        };
        // gamma of x
        jStat.gammafn = function gammafn(x) {
            var p = [
                -1.716185138865495,
                24.76565080557592,
                -379.80425647094563,
                629.3311553128184,
                866.9662027904133,
                -31451.272968848367,
                -36144.413418691176,
                66456.14382024054
            ];
            var q = [
                -30.8402300119739,
                315.35062697960416,
                -1015.1563674902192,
                -3107.771671572311,
                22538.118420980151,
                4755.8462775278811,
                -134659.9598649693,
                -115132.2596755535
            ];
            var fact = false;
            var n = 0;
            var xden = 0;
            var xnum = 0;
            var y = x;
            var i, z, yi, res;
            if (x > 171.6243769536076) return Infinity;
            if (y <= 0) {
                res = y % 1 + 3.6e-16;
                if (res) {
                    fact = (!(y & 1) ? 1 : -1) * Math1.PI / Math1.sin(Math1.PI * res);
                    y = 1 - y;
                } else return Infinity;
            }
            yi = y;
            if (y < 1) z = y++;
            else z = (y -= n = (y | 0) - 1) - 1;
            for(i = 0; i < 8; ++i){
                xnum = (xnum + p[i]) * z;
                xden = xden * z + q[i];
            }
            res = xnum / xden + 1;
            if (yi < y) res /= yi;
            else if (yi > y) for(i = 0; i < n; ++i){
                res *= y;
                y++;
            }
            if (fact) res = fact / res;
            return res;
        };
        // lower incomplete gamma function, which is usually typeset with a
        // lower-case greek gamma as the function symbol
        jStat.gammap = function gammap(a, x) {
            return jStat.lowRegGamma(a, x) * jStat.gammafn(a);
        };
        // The lower regularized incomplete gamma function, usually written P(a,x)
        jStat.lowRegGamma = function lowRegGamma(a, x) {
            var aln = jStat.gammaln(a);
            var ap = a;
            var sum = 1 / a;
            var del = sum;
            var b = x + 1 - a;
            var c = 1 / 1.0e-30;
            var d = 1 / b;
            var h = d;
            var i = 1;
            // calculate maximum number of itterations required for a
            var ITMAX = -~(Math1.log(a >= 1 ? a : 1 / a) * 8.5 + a * 0.4 + 17);
            var an;
            if (x < 0 || a <= 0) return NaN;
            else if (x < a + 1) {
                for(; i <= ITMAX; i++)sum += del *= x / ++ap;
                return sum * Math1.exp(-x + a * Math1.log(x) - aln);
            }
            for(; i <= ITMAX; i++){
                an = -i * (i - a);
                b += 2;
                d = an * d + b;
                c = b + an / c;
                d = 1 / d;
                h *= d * c;
            }
            return 1 - h * Math1.exp(-x + a * Math1.log(x) - aln);
        };
        // natural log factorial of n
        jStat.factorialln = function factorialln(n) {
            return n < 0 ? NaN : jStat.gammaln(n + 1);
        };
        // factorial of n
        jStat.factorial = function factorial(n) {
            return n < 0 ? NaN : jStat.gammafn(n + 1);
        };
        // combinations of n, m
        jStat.combination = function combination(n, m) {
            // make sure n or m don't exceed the upper limit of usable values
            return n > 170 || m > 170 ? Math1.exp(jStat.combinationln(n, m)) : jStat.factorial(n) / jStat.factorial(m) / jStat.factorial(n - m);
        };
        jStat.combinationln = function combinationln(n, m) {
            return jStat.factorialln(n) - jStat.factorialln(m) - jStat.factorialln(n - m);
        };
        // permutations of n, m
        jStat.permutation = function permutation(n, m) {
            return jStat.factorial(n) / jStat.factorial(n - m);
        };
        // beta function
        jStat.betafn = function betafn(x, y) {
            // ensure arguments are positive
            if (x <= 0 || y <= 0) return undefined;
            // make sure x + y doesn't exceed the upper limit of usable values
            return x + y > 170 ? Math1.exp(jStat.betaln(x, y)) : jStat.gammafn(x) * jStat.gammafn(y) / jStat.gammafn(x + y);
        };
        // natural logarithm of beta function
        jStat.betaln = function betaln(x, y) {
            return jStat.gammaln(x) + jStat.gammaln(y) - jStat.gammaln(x + y);
        };
        // Evaluates the continued fraction for incomplete beta function by modified
        // Lentz's method.
        jStat.betacf = function betacf(x, a, b) {
            var fpmin = 1e-30;
            var m = 1;
            var qab = a + b;
            var qap = a + 1;
            var qam = a - 1;
            var c = 1;
            var d = 1 - qab * x / qap;
            var m2, aa, del, h;
            // These q's will be used in factors that occur in the coefficients
            if (Math1.abs(d) < fpmin) d = fpmin;
            d = 1 / d;
            h = d;
            for(; m <= 100; m++){
                m2 = 2 * m;
                aa = m * (b - m) * x / ((qam + m2) * (a + m2));
                // One step (the even one) of the recurrence
                d = 1 + aa * d;
                if (Math1.abs(d) < fpmin) d = fpmin;
                c = 1 + aa / c;
                if (Math1.abs(c) < fpmin) c = fpmin;
                d = 1 / d;
                h *= d * c;
                aa = -(a + m) * (qab + m) * x / ((a + m2) * (qap + m2));
                // Next step of the recurrence (the odd one)
                d = 1 + aa * d;
                if (Math1.abs(d) < fpmin) d = fpmin;
                c = 1 + aa / c;
                if (Math1.abs(c) < fpmin) c = fpmin;
                d = 1 / d;
                del = d * c;
                h *= del;
                if (Math1.abs(del - 1.0) < 3e-7) break;
            }
            return h;
        };
        // Returns the inverse of the lower regularized inomplete gamma function
        jStat.gammapinv = function gammapinv(p, a) {
            var j = 0;
            var a1 = a - 1;
            var EPS = 1e-8;
            var gln = jStat.gammaln(a);
            var x, err, t, u, pp, lna1, afac;
            if (p >= 1) return Math1.max(100, a + 100 * Math1.sqrt(a));
            if (p <= 0) return 0;
            if (a > 1) {
                lna1 = Math1.log(a1);
                afac = Math1.exp(a1 * (lna1 - 1) - gln);
                pp = p < 0.5 ? p : 1 - p;
                t = Math1.sqrt(-2 * Math1.log(pp));
                x = (2.30753 + t * 0.27061) / (1 + t * (0.99229 + t * 0.04481)) - t;
                if (p < 0.5) x = -x;
                x = Math1.max(1e-3, a * Math1.pow(1 - 1 / (9 * a) - x / (3 * Math1.sqrt(a)), 3));
            } else {
                t = 1 - a * (0.253 + a * 0.12);
                if (p < t) x = Math1.pow(p / t, 1 / a);
                else x = 1 - Math1.log(1 - (p - t) / (1 - t));
            }
            for(; j < 12; j++){
                if (x <= 0) return 0;
                err = jStat.lowRegGamma(a, x) - p;
                if (a > 1) t = afac * Math1.exp(-(x - a1) + a1 * (Math1.log(x) - lna1));
                else t = Math1.exp(-x + a1 * Math1.log(x) - gln);
                u = err / t;
                x -= t = u / (1 - 0.5 * Math1.min(1, u * ((a - 1) / x - 1)));
                if (x <= 0) x = 0.5 * (x + t);
                if (Math1.abs(t) < EPS * x) break;
            }
            return x;
        };
        // Returns the error function erf(x)
        jStat.erf = function erf(x) {
            var cof = [
                -1.3026537197817094,
                6.4196979235649026e-1,
                1.9476473204185836e-2,
                -0.00956151478680863,
                -0.000946595344482036,
                3.66839497852761e-4,
                4.2523324806907e-5,
                -0.000020278578112534,
                -0.000001624290004647,
                1.303655835580e-6,
                1.5626441722e-8,
                -0.000000085238095915,
                6.529054439e-9,
                5.059343495e-9,
                -0.000000000991364156,
                -0.000000000227365122,
                9.6467911e-11,
                2.394038e-12,
                -0.000000000006886027,
                8.94487e-13,
                3.13092e-13,
                -0.000000000000112708,
                3.81e-16,
                7.106e-15,
                -0.000000000000001523,
                -0.000000000000000094,
                1.21e-16,
                -0.000000000000000028
            ];
            var j = cof.length - 1;
            var isneg = false;
            var d = 0;
            var dd = 0;
            var t, ty, tmp, res;
            if (x < 0) {
                x = -x;
                isneg = true;
            }
            t = 2 / (2 + x);
            ty = 4 * t - 2;
            for(; j > 0; j--){
                tmp = d;
                d = ty * d - dd + cof[j];
                dd = tmp;
            }
            res = t * Math1.exp(-x * x + 0.5 * (cof[0] + ty * d) - dd);
            return isneg ? res - 1 : 1 - res;
        };
        // Returns the complmentary error function erfc(x)
        jStat.erfc = function erfc(x) {
            return 1 - jStat.erf(x);
        };
        // Returns the inverse of the complementary error function
        jStat.erfcinv = function erfcinv(p) {
            var j = 0;
            var x, err, t, pp;
            if (p >= 2) return -100;
            if (p <= 0) return 100;
            pp = p < 1 ? p : 2 - p;
            t = Math1.sqrt(-2 * Math1.log(pp / 2));
            x = -0.70711 * ((2.30753 + t * 0.27061) / (1 + t * (0.99229 + t * 0.04481)) - t);
            for(; j < 2; j++){
                err = jStat.erfc(x) - pp;
                x += err / (1.12837916709551257 * Math1.exp(-x * x) - x * err);
            }
            return p < 1 ? x : -x;
        };
        // Returns the inverse of the incomplete beta function
        jStat.ibetainv = function ibetainv(p, a, b) {
            var EPS = 1e-8;
            var a1 = a - 1;
            var b1 = b - 1;
            var j = 0;
            var lna, lnb, pp, t, u, err, x, al, h, w, afac;
            if (p <= 0) return 0;
            if (p >= 1) return 1;
            if (a >= 1 && b >= 1) {
                pp = p < 0.5 ? p : 1 - p;
                t = Math1.sqrt(-2 * Math1.log(pp));
                x = (2.30753 + t * 0.27061) / (1 + t * (0.99229 + t * 0.04481)) - t;
                if (p < 0.5) x = -x;
                al = (x * x - 3) / 6;
                h = 2 / (1 / (2 * a - 1) + 1 / (2 * b - 1));
                w = x * Math1.sqrt(al + h) / h - (1 / (2 * b - 1) - 1 / (2 * a - 1)) * (al + 5 / 6 - 2 / (3 * h));
                x = a / (a + b * Math1.exp(2 * w));
            } else {
                lna = Math1.log(a / (a + b));
                lnb = Math1.log(b / (a + b));
                t = Math1.exp(a * lna) / a;
                u = Math1.exp(b * lnb) / b;
                w = t + u;
                if (p < t / w) x = Math1.pow(a * w * p, 1 / a);
                else x = 1 - Math1.pow(b * w * (1 - p), 1 / b);
            }
            afac = -jStat.gammaln(a) - jStat.gammaln(b) + jStat.gammaln(a + b);
            for(; j < 10; j++){
                if (x === 0 || x === 1) return x;
                err = jStat.ibeta(x, a, b) - p;
                t = Math1.exp(a1 * Math1.log(x) + b1 * Math1.log(1 - x) + afac);
                u = err / t;
                x -= t = u / (1 - 0.5 * Math1.min(1, u * (a1 / x - b1 / (1 - x))));
                if (x <= 0) x = 0.5 * (x + t);
                if (x >= 1) x = 0.5 * (x + t + 1);
                if (Math1.abs(t) < EPS * x && j > 0) break;
            }
            return x;
        };
        // Returns the incomplete beta function I_x(a,b)
        jStat.ibeta = function ibeta(x, a, b) {
            // Factors in front of the continued fraction.
            var bt = x === 0 || x === 1 ? 0 : Math1.exp(jStat.gammaln(a + b) - jStat.gammaln(a) - jStat.gammaln(b) + a * Math1.log(x) + b * Math1.log(1 - x));
            if (x < 0 || x > 1) return false;
            if (x < (a + 1) / (a + b + 2)) // Use continued fraction directly.
            return bt * jStat.betacf(x, a, b) / a;
            // else use continued fraction after making the symmetry transformation.
            return 1 - bt * jStat.betacf(1 - x, b, a) / b;
        };
        // Returns a normal deviate (mu=0, sigma=1).
        // If n and m are specified it returns a object of normal deviates.
        jStat.randn = function randn(n, m) {
            var u, v, x, y, q;
            if (!m) m = n;
            if (n) return jStat.create(n, m, function() {
                return jStat.randn();
            });
            do {
                u = jStat._random_fn();
                v = 1.7156 * (jStat._random_fn() - 0.5);
                x = u - 0.449871;
                y = Math1.abs(v) + 0.386595;
                q = x * x + y * (0.19600 * y - 0.25472 * x);
            }while (q > 0.27597 && (q > 0.27846 || v * v > -4 * Math1.log(u) * u * u));
            return v / u;
        };
        // Returns a gamma deviate by the method of Marsaglia and Tsang.
        jStat.randg = function randg(shape, n, m) {
            var oalph = shape;
            var a1, a2, u, v, x, mat;
            if (!m) m = n;
            if (!shape) shape = 1;
            if (n) {
                mat = jStat.zeros(n, m);
                mat.alter(function() {
                    return jStat.randg(shape);
                });
                return mat;
            }
            if (shape < 1) shape += 1;
            a1 = shape - 1 / 3;
            a2 = 1 / Math1.sqrt(9 * a1);
            do {
                do {
                    x = jStat.randn();
                    v = 1 + a2 * x;
                }while (v <= 0);
                v = v * v * v;
                u = jStat._random_fn();
            }while (u > 1 - 0.331 * Math1.pow(x, 4) && Math1.log(u) > 0.5 * x * x + a1 * (1 - v + Math1.log(v)));
            // alpha > 1
            if (shape == oalph) return a1 * v;
            // alpha < 1
            do u = jStat._random_fn();
            while (u === 0);
            return Math1.pow(u, 1 / oalph) * a1 * v;
        };
        // making use of static methods on the instance
        (function(funcs) {
            for(var i = 0; i < funcs.length; i++)(function(passfunc) {
                jStat.fn[passfunc] = function() {
                    return jStat(jStat.map(this, function(value) {
                        return jStat[passfunc](value);
                    }));
                };
            })(funcs[i]);
        })("gammaln gammafn factorial factorialln".split(" "));
        (function(funcs) {
            for(var i = 0; i < funcs.length; i++)(function(passfunc) {
                jStat.fn[passfunc] = function() {
                    return jStat(jStat[passfunc].apply(null, arguments));
                };
            })(funcs[i]);
        })("randn".split(" "));
    })(jStat, Math);
    (function(jStat, Math1) {
        // generate all distribution instance methods
        (function(list) {
            for(var i = 0; i < list.length; i++)(function(func) {
                // distribution instance method
                jStat[func] = function f(a, b, c) {
                    if (!(this instanceof f)) return new f(a, b, c);
                    this._a = a;
                    this._b = b;
                    this._c = c;
                    return this;
                };
                // distribution method to be used on a jStat instance
                jStat.fn[func] = function(a, b, c) {
                    var newthis = jStat[func](a, b, c);
                    newthis.data = this;
                    return newthis;
                };
                // sample instance method
                jStat[func].prototype.sample = function(arr) {
                    var a = this._a;
                    var b = this._b;
                    var c = this._c;
                    if (arr) return jStat.alter(arr, function() {
                        return jStat[func].sample(a, b, c);
                    });
                    else return jStat[func].sample(a, b, c);
                };
                // generate the pdf, cdf and inv instance methods
                (function(vals) {
                    for(var i = 0; i < vals.length; i++)(function(fnfunc) {
                        jStat[func].prototype[fnfunc] = function(x) {
                            var a = this._a;
                            var b = this._b;
                            var c = this._c;
                            if (!x && x !== 0) x = this.data;
                            if (typeof x !== "number") return jStat.fn.map.call(x, function(x) {
                                return jStat[func][fnfunc](x, a, b, c);
                            });
                            return jStat[func][fnfunc](x, a, b, c);
                        };
                    })(vals[i]);
                })("pdf cdf inv".split(" "));
                // generate the mean, median, mode and variance instance methods
                (function(vals) {
                    for(var i = 0; i < vals.length; i++)(function(fnfunc) {
                        jStat[func].prototype[fnfunc] = function() {
                            return jStat[func][fnfunc](this._a, this._b, this._c);
                        };
                    })(vals[i]);
                })("mean median mode variance".split(" "));
            })(list[i]);
        })("beta centralF cauchy chisquare exponential gamma invgamma kumaraswamy laplace lognormal noncentralt normal pareto studentt weibull uniform binomial negbin hypgeom poisson triangular tukey arcsine".split(" "));
        // extend beta function with static methods
        jStat.extend(jStat.beta, {
            pdf: function pdf(x, alpha, beta) {
                // PDF is zero outside the support
                if (x > 1 || x < 0) return 0;
                // PDF is one for the uniform case
                if (alpha == 1 && beta == 1) return 1;
                if (alpha < 512 && beta < 512) return Math1.pow(x, alpha - 1) * Math1.pow(1 - x, beta - 1) / jStat.betafn(alpha, beta);
                else return Math1.exp((alpha - 1) * Math1.log(x) + (beta - 1) * Math1.log(1 - x) - jStat.betaln(alpha, beta));
            },
            cdf: function cdf(x, alpha, beta) {
                return x > 1 || x < 0 ? (x > 1) * 1 : jStat.ibeta(x, alpha, beta);
            },
            inv: function inv(x, alpha, beta) {
                return jStat.ibetainv(x, alpha, beta);
            },
            mean: function mean(alpha, beta) {
                return alpha / (alpha + beta);
            },
            median: function median(alpha, beta) {
                return jStat.ibetainv(0.5, alpha, beta);
            },
            mode: function mode(alpha, beta) {
                return (alpha - 1) / (alpha + beta - 2);
            },
            // return a random sample
            sample: function sample(alpha, beta) {
                var u = jStat.randg(alpha);
                return u / (u + jStat.randg(beta));
            },
            variance: function variance(alpha, beta) {
                return alpha * beta / (Math1.pow(alpha + beta, 2) * (alpha + beta + 1));
            }
        });
        // extend F function with static methods
        jStat.extend(jStat.centralF, {
            // This implementation of the pdf function avoids float overflow
            // See the way that R calculates this value:
            // https://svn.r-project.org/R/trunk/src/nmath/df.c
            pdf: function pdf(x, df1, df2) {
                var p, q, f;
                if (x < 0) return 0;
                if (df1 <= 2) {
                    if (x === 0 && df1 < 2) return Infinity;
                    if (x === 0 && df1 === 2) return 1;
                    return 1 / jStat.betafn(df1 / 2, df2 / 2) * Math1.pow(df1 / df2, df1 / 2) * Math1.pow(x, df1 / 2 - 1) * Math1.pow(1 + df1 / df2 * x, -(df1 + df2) / 2);
                }
                p = df1 * x / (df2 + x * df1);
                q = df2 / (df2 + x * df1);
                f = df1 * q / 2.0;
                return f * jStat.binomial.pdf((df1 - 2) / 2, (df1 + df2 - 2) / 2, p);
            },
            cdf: function cdf(x, df1, df2) {
                if (x < 0) return 0;
                return jStat.ibeta(df1 * x / (df1 * x + df2), df1 / 2, df2 / 2);
            },
            inv: function inv(x, df1, df2) {
                return df2 / (df1 * (1 / jStat.ibetainv(x, df1 / 2, df2 / 2) - 1));
            },
            mean: function mean(df1, df2) {
                return df2 > 2 ? df2 / (df2 - 2) : undefined;
            },
            mode: function mode(df1, df2) {
                return df1 > 2 ? df2 * (df1 - 2) / (df1 * (df2 + 2)) : undefined;
            },
            // return a random sample
            sample: function sample(df1, df2) {
                var x1 = jStat.randg(df1 / 2) * 2;
                var x2 = jStat.randg(df2 / 2) * 2;
                return x1 / df1 / (x2 / df2);
            },
            variance: function variance(df1, df2) {
                if (df2 <= 4) return undefined;
                return 2 * df2 * df2 * (df1 + df2 - 2) / (df1 * (df2 - 2) * (df2 - 2) * (df2 - 4));
            }
        });
        // extend cauchy function with static methods
        jStat.extend(jStat.cauchy, {
            pdf: function pdf(x, local, scale) {
                if (scale < 0) return 0;
                return scale / (Math1.pow(x - local, 2) + Math1.pow(scale, 2)) / Math1.PI;
            },
            cdf: function cdf(x, local, scale) {
                return Math1.atan((x - local) / scale) / Math1.PI + 0.5;
            },
            inv: function(p, local, scale) {
                return local + scale * Math1.tan(Math1.PI * (p - 0.5));
            },
            median: function median(local /*, scale*/ ) {
                return local;
            },
            mode: function mode(local /*, scale*/ ) {
                return local;
            },
            sample: function sample(local, scale) {
                return jStat.randn() * Math1.sqrt(1 / (2 * jStat.randg(0.5))) * scale + local;
            }
        });
        // extend chisquare function with static methods
        jStat.extend(jStat.chisquare, {
            pdf: function pdf(x, dof) {
                if (x < 0) return 0;
                return x === 0 && dof === 2 ? 0.5 : Math1.exp((dof / 2 - 1) * Math1.log(x) - x / 2 - dof / 2 * Math1.log(2) - jStat.gammaln(dof / 2));
            },
            cdf: function cdf(x, dof) {
                if (x < 0) return 0;
                return jStat.lowRegGamma(dof / 2, x / 2);
            },
            inv: function(p, dof) {
                return 2 * jStat.gammapinv(p, 0.5 * dof);
            },
            mean: function(dof) {
                return dof;
            },
            // TODO: this is an approximation (is there a better way?)
            median: function median(dof) {
                return dof * Math1.pow(1 - 2 / (9 * dof), 3);
            },
            mode: function mode(dof) {
                return dof - 2 > 0 ? dof - 2 : 0;
            },
            sample: function sample(dof) {
                return jStat.randg(dof / 2) * 2;
            },
            variance: function variance(dof) {
                return 2 * dof;
            }
        });
        // extend exponential function with static methods
        jStat.extend(jStat.exponential, {
            pdf: function pdf(x, rate) {
                return x < 0 ? 0 : rate * Math1.exp(-rate * x);
            },
            cdf: function cdf(x, rate) {
                return x < 0 ? 0 : 1 - Math1.exp(-rate * x);
            },
            inv: function(p, rate) {
                return -Math1.log(1 - p) / rate;
            },
            mean: function(rate) {
                return 1 / rate;
            },
            median: function(rate) {
                return 1 / rate * Math1.log(2);
            },
            mode: function mode() {
                return 0;
            },
            sample: function sample(rate) {
                return -1 / rate * Math1.log(jStat._random_fn());
            },
            variance: function(rate) {
                return Math1.pow(rate, -2);
            }
        });
        // extend gamma function with static methods
        jStat.extend(jStat.gamma, {
            pdf: function pdf(x, shape, scale) {
                if (x < 0) return 0;
                return x === 0 && shape === 1 ? 1 / scale : Math1.exp((shape - 1) * Math1.log(x) - x / scale - jStat.gammaln(shape) - shape * Math1.log(scale));
            },
            cdf: function cdf(x, shape, scale) {
                if (x < 0) return 0;
                return jStat.lowRegGamma(shape, x / scale);
            },
            inv: function(p, shape, scale) {
                return jStat.gammapinv(p, shape) * scale;
            },
            mean: function(shape, scale) {
                return shape * scale;
            },
            mode: function mode(shape, scale) {
                if (shape > 1) return (shape - 1) * scale;
                return undefined;
            },
            sample: function sample(shape, scale) {
                return jStat.randg(shape) * scale;
            },
            variance: function variance(shape, scale) {
                return shape * scale * scale;
            }
        });
        // extend inverse gamma function with static methods
        jStat.extend(jStat.invgamma, {
            pdf: function pdf(x, shape, scale) {
                if (x <= 0) return 0;
                return Math1.exp(-(shape + 1) * Math1.log(x) - scale / x - jStat.gammaln(shape) + shape * Math1.log(scale));
            },
            cdf: function cdf(x, shape, scale) {
                if (x <= 0) return 0;
                return 1 - jStat.lowRegGamma(shape, scale / x);
            },
            inv: function(p, shape, scale) {
                return scale / jStat.gammapinv(1 - p, shape);
            },
            mean: function(shape, scale) {
                return shape > 1 ? scale / (shape - 1) : undefined;
            },
            mode: function mode(shape, scale) {
                return scale / (shape + 1);
            },
            sample: function sample(shape, scale) {
                return scale / jStat.randg(shape);
            },
            variance: function variance(shape, scale) {
                if (shape <= 2) return undefined;
                return scale * scale / ((shape - 1) * (shape - 1) * (shape - 2));
            }
        });
        // extend kumaraswamy function with static methods
        jStat.extend(jStat.kumaraswamy, {
            pdf: function pdf(x, alpha, beta) {
                if (x === 0 && alpha === 1) return beta;
                else if (x === 1 && beta === 1) return alpha;
                return Math1.exp(Math1.log(alpha) + Math1.log(beta) + (alpha - 1) * Math1.log(x) + (beta - 1) * Math1.log(1 - Math1.pow(x, alpha)));
            },
            cdf: function cdf(x, alpha, beta) {
                if (x < 0) return 0;
                else if (x > 1) return 1;
                return 1 - Math1.pow(1 - Math1.pow(x, alpha), beta);
            },
            inv: function inv(p, alpha, beta) {
                return Math1.pow(1 - Math1.pow(1 - p, 1 / beta), 1 / alpha);
            },
            mean: function(alpha, beta) {
                return beta * jStat.gammafn(1 + 1 / alpha) * jStat.gammafn(beta) / jStat.gammafn(1 + 1 / alpha + beta);
            },
            median: function median(alpha, beta) {
                return Math1.pow(1 - Math1.pow(2, -1 / beta), 1 / alpha);
            },
            mode: function mode(alpha, beta) {
                if (!(alpha >= 1 && beta >= 1 && alpha !== 1 && beta !== 1)) return undefined;
                return Math1.pow((alpha - 1) / (alpha * beta - 1), 1 / alpha);
            },
            variance: function variance() {
                throw new Error("variance not yet implemented");
            // TODO: complete this
            }
        });
        // extend lognormal function with static methods
        jStat.extend(jStat.lognormal, {
            pdf: function pdf(x, mu, sigma) {
                if (x <= 0) return 0;
                return Math1.exp(-Math1.log(x) - 0.5 * Math1.log(2 * Math1.PI) - Math1.log(sigma) - Math1.pow(Math1.log(x) - mu, 2) / (2 * sigma * sigma));
            },
            cdf: function cdf(x, mu, sigma) {
                if (x < 0) return 0;
                return 0.5 + 0.5 * jStat.erf((Math1.log(x) - mu) / Math1.sqrt(2 * sigma * sigma));
            },
            inv: function(p, mu, sigma) {
                return Math1.exp(-1.4142135623730951 * sigma * jStat.erfcinv(2 * p) + mu);
            },
            mean: function mean(mu, sigma) {
                return Math1.exp(mu + sigma * sigma / 2);
            },
            median: function median(mu /*, sigma*/ ) {
                return Math1.exp(mu);
            },
            mode: function mode(mu, sigma) {
                return Math1.exp(mu - sigma * sigma);
            },
            sample: function sample(mu, sigma) {
                return Math1.exp(jStat.randn() * sigma + mu);
            },
            variance: function variance(mu, sigma) {
                return (Math1.exp(sigma * sigma) - 1) * Math1.exp(2 * mu + sigma * sigma);
            }
        });
        // extend noncentralt function with static methods
        jStat.extend(jStat.noncentralt, {
            pdf: function pdf(x, dof, ncp) {
                var tol = 1e-14;
                if (Math1.abs(ncp) < tol) return jStat.studentt.pdf(x, dof);
                if (Math1.abs(x) < tol) return Math1.exp(jStat.gammaln((dof + 1) / 2) - ncp * ncp / 2 - 0.5 * Math1.log(Math1.PI * dof) - jStat.gammaln(dof / 2));
                // formula for x != 0
                return dof / x * (jStat.noncentralt.cdf(x * Math1.sqrt(1 + 2 / dof), dof + 2, ncp) - jStat.noncentralt.cdf(x, dof, ncp));
            },
            cdf: function cdf(x, dof, ncp) {
                var tol = 1e-14;
                var min_iterations = 200;
                if (Math1.abs(ncp) < tol) return jStat.studentt.cdf(x, dof);
                // turn negative x into positive and flip result afterwards
                var flip = false;
                if (x < 0) {
                    flip = true;
                    ncp = -ncp;
                }
                var prob = jStat.normal.cdf(-ncp, 0, 1);
                var value = tol + 1;
                // use value at last two steps to determine convergence
                var lastvalue = value;
                var y = x * x / (x * x + dof);
                var j = 0;
                var p = Math1.exp(-ncp * ncp / 2);
                var q = Math1.exp(-ncp * ncp / 2 - 0.5 * Math1.log(2) - jStat.gammaln(1.5)) * ncp;
                while(j < min_iterations || lastvalue > tol || value > tol){
                    lastvalue = value;
                    if (j > 0) {
                        p *= ncp * ncp / (2 * j);
                        q *= ncp * ncp / (2 * (j + 0.5));
                    }
                    value = p * jStat.beta.cdf(y, j + 0.5, dof / 2) + q * jStat.beta.cdf(y, j + 1, dof / 2);
                    prob += 0.5 * value;
                    j++;
                }
                return flip ? 1 - prob : prob;
            }
        });
        // extend normal function with static methods
        jStat.extend(jStat.normal, {
            pdf: function pdf(x, mean, std) {
                return Math1.exp(-0.5 * Math1.log(2 * Math1.PI) - Math1.log(std) - Math1.pow(x - mean, 2) / (2 * std * std));
            },
            cdf: function cdf(x, mean, std) {
                return 0.5 * (1 + jStat.erf((x - mean) / Math1.sqrt(2 * std * std)));
            },
            inv: function(p, mean, std) {
                return -1.4142135623730951 * std * jStat.erfcinv(2 * p) + mean;
            },
            mean: function(mean /*, std*/ ) {
                return mean;
            },
            median: function median(mean /*, std*/ ) {
                return mean;
            },
            mode: function(mean /*, std*/ ) {
                return mean;
            },
            sample: function sample(mean, std) {
                return jStat.randn() * std + mean;
            },
            variance: function(mean, std) {
                return std * std;
            }
        });
        // extend pareto function with static methods
        jStat.extend(jStat.pareto, {
            pdf: function pdf(x, scale, shape) {
                if (x < scale) return 0;
                return shape * Math1.pow(scale, shape) / Math1.pow(x, shape + 1);
            },
            cdf: function cdf(x, scale, shape) {
                if (x < scale) return 0;
                return 1 - Math1.pow(scale / x, shape);
            },
            inv: function inv(p, scale, shape) {
                return scale / Math1.pow(1 - p, 1 / shape);
            },
            mean: function mean(scale, shape) {
                if (shape <= 1) return undefined;
                return shape * Math1.pow(scale, shape) / (shape - 1);
            },
            median: function median(scale, shape) {
                return scale * (shape * Math1.SQRT2);
            },
            mode: function mode(scale /*, shape*/ ) {
                return scale;
            },
            variance: function(scale, shape) {
                if (shape <= 2) return undefined;
                return scale * scale * shape / (Math1.pow(shape - 1, 2) * (shape - 2));
            }
        });
        // extend studentt function with static methods
        jStat.extend(jStat.studentt, {
            pdf: function pdf(x, dof) {
                dof = dof > 1e100 ? 1e100 : dof;
                return 1 / (Math1.sqrt(dof) * jStat.betafn(0.5, dof / 2)) * Math1.pow(1 + x * x / dof, -((dof + 1) / 2));
            },
            cdf: function cdf(x, dof) {
                var dof2 = dof / 2;
                return jStat.ibeta((x + Math1.sqrt(x * x + dof)) / (2 * Math1.sqrt(x * x + dof)), dof2, dof2);
            },
            inv: function(p, dof) {
                var x = jStat.ibetainv(2 * Math1.min(p, 1 - p), 0.5 * dof, 0.5);
                x = Math1.sqrt(dof * (1 - x) / x);
                return p > 0.5 ? x : -x;
            },
            mean: function mean(dof) {
                return dof > 1 ? 0 : undefined;
            },
            median: function median() {
                return 0;
            },
            mode: function mode() {
                return 0;
            },
            sample: function sample(dof) {
                return jStat.randn() * Math1.sqrt(dof / (2 * jStat.randg(dof / 2)));
            },
            variance: function variance(dof) {
                return dof > 2 ? dof / (dof - 2) : dof > 1 ? Infinity : undefined;
            }
        });
        // extend weibull function with static methods
        jStat.extend(jStat.weibull, {
            pdf: function pdf(x, scale, shape) {
                if (x < 0 || scale < 0 || shape < 0) return 0;
                return shape / scale * Math1.pow(x / scale, shape - 1) * Math1.exp(-Math1.pow(x / scale, shape));
            },
            cdf: function cdf(x, scale, shape) {
                return x < 0 ? 0 : 1 - Math1.exp(-Math1.pow(x / scale, shape));
            },
            inv: function(p, scale, shape) {
                return scale * Math1.pow(-Math1.log(1 - p), 1 / shape);
            },
            mean: function(scale, shape) {
                return scale * jStat.gammafn(1 + 1 / shape);
            },
            median: function median(scale, shape) {
                return scale * Math1.pow(Math1.log(2), 1 / shape);
            },
            mode: function mode(scale, shape) {
                if (shape <= 1) return 0;
                return scale * Math1.pow((shape - 1) / shape, 1 / shape);
            },
            sample: function sample(scale, shape) {
                return scale * Math1.pow(-Math1.log(jStat._random_fn()), 1 / shape);
            },
            variance: function variance(scale, shape) {
                return scale * scale * jStat.gammafn(1 + 2 / shape) - Math1.pow(jStat.weibull.mean(scale, shape), 2);
            }
        });
        // extend uniform function with static methods
        jStat.extend(jStat.uniform, {
            pdf: function pdf(x, a, b) {
                return x < a || x > b ? 0 : 1 / (b - a);
            },
            cdf: function cdf(x, a, b) {
                if (x < a) return 0;
                else if (x < b) return (x - a) / (b - a);
                return 1;
            },
            inv: function(p, a, b) {
                return a + p * (b - a);
            },
            mean: function mean(a, b) {
                return 0.5 * (a + b);
            },
            median: function median(a, b) {
                return jStat.mean(a, b);
            },
            mode: function mode() {
                throw new Error("mode is not yet implemented");
            },
            sample: function sample(a, b) {
                return a / 2 + b / 2 + (b / 2 - a / 2) * (2 * jStat._random_fn() - 1);
            },
            variance: function variance(a, b) {
                return Math1.pow(b - a, 2) / 12;
            }
        });
        // Got this from http://www.math.ucla.edu/~tom/distributions/binomial.html
        function betinc(x, a, b, eps) {
            var a0 = 0;
            var b0 = 1;
            var a1 = 1;
            var b1 = 1;
            var m9 = 0;
            var a2 = 0;
            var c9;
            while(Math1.abs((a1 - a2) / a1) > eps){
                a2 = a1;
                c9 = -(a + m9) * (a + b + m9) * x / (a + 2 * m9) / (a + 2 * m9 + 1);
                a0 = a1 + c9 * a0;
                b0 = b1 + c9 * b0;
                m9 = m9 + 1;
                c9 = m9 * (b - m9) * x / (a + 2 * m9 - 1) / (a + 2 * m9);
                a1 = a0 + c9 * a1;
                b1 = b0 + c9 * b1;
                a0 = a0 / b1;
                b0 = b0 / b1;
                a1 = a1 / b1;
                b1 = 1;
            }
            return a1 / a;
        }
        // extend uniform function with static methods
        jStat.extend(jStat.binomial, {
            pdf: function pdf(k, n, p) {
                return p === 0 || p === 1 ? n * p === k ? 1 : 0 : jStat.combination(n, k) * Math1.pow(p, k) * Math1.pow(1 - p, n - k);
            },
            cdf: function cdf(x, n, p) {
                var betacdf;
                var eps = 1e-10;
                if (x < 0) return 0;
                if (x >= n) return 1;
                if (p < 0 || p > 1 || n <= 0) return NaN;
                x = Math1.floor(x);
                var z = p;
                var a = x + 1;
                var b = n - x;
                var s = a + b;
                var bt = Math1.exp(jStat.gammaln(s) - jStat.gammaln(b) - jStat.gammaln(a) + a * Math1.log(z) + b * Math1.log(1 - z));
                if (z < (a + 1) / (s + 2)) betacdf = bt * betinc(z, a, b, eps);
                else betacdf = 1 - bt * betinc(1 - z, b, a, eps);
                return Math1.round((1 - betacdf) * (1 / eps)) / (1 / eps);
            }
        });
        // extend uniform function with static methods
        jStat.extend(jStat.negbin, {
            pdf: function pdf(k, r, p) {
                if (k !== k >>> 0) return false;
                if (k < 0) return 0;
                return jStat.combination(k + r - 1, r - 1) * Math1.pow(1 - p, k) * Math1.pow(p, r);
            },
            cdf: function cdf(x, r, p) {
                var sum = 0, k = 0;
                if (x < 0) return 0;
                for(; k <= x; k++)sum += jStat.negbin.pdf(k, r, p);
                return sum;
            }
        });
        // extend uniform function with static methods
        jStat.extend(jStat.hypgeom, {
            pdf: function pdf(k, N, m, n) {
                // Hypergeometric PDF.
                // A simplification of the CDF algorithm below.
                // k = number of successes drawn
                // N = population size
                // m = number of successes in population
                // n = number of items drawn from population
                if (k !== k | 0) return false;
                else if (k < 0 || k < m - (N - n)) // It's impossible to have this few successes drawn.
                return 0;
                else if (k > n || k > m) // It's impossible to have this many successes drawn.
                return 0;
                else if (m * 2 > N) {
                    // More than half the population is successes.
                    if (n * 2 > N) // More than half the population is sampled.
                    return jStat.hypgeom.pdf(N - m - n + k, N, N - m, N - n);
                    else // Half or less of the population is sampled.
                    return jStat.hypgeom.pdf(n - k, N, N - m, n);
                } else if (n * 2 > N) // Half or less is successes.
                return jStat.hypgeom.pdf(m - k, N, m, N - n);
                else if (m < n) // We want to have the number of things sampled to be less than the
                // successes available. So swap the definitions of successful and sampled.
                return jStat.hypgeom.pdf(k, N, n, m);
                else {
                    // If we get here, half or less of the population was sampled, half or
                    // less of it was successes, and we had fewer sampled things than
                    // successes. Now we can do this complicated iterative algorithm in an
                    // efficient way.
                    // The basic premise of the algorithm is that we partially normalize our
                    // intermediate product to keep it in a numerically good region, and then
                    // finish the normalization at the end.
                    // This variable holds the scaled probability of the current number of
                    // successes.
                    var scaledPDF = 1;
                    // This keeps track of how much we have normalized.
                    var samplesDone = 0;
                    for(var i = 0; i < k; i++){
                        // For every possible number of successes up to that observed...
                        while(scaledPDF > 1 && samplesDone < n){
                            // Intermediate result is growing too big. Apply some of the
                            // normalization to shrink everything.
                            scaledPDF *= 1 - m / (N - samplesDone);
                            // Say we've normalized by this sample already.
                            samplesDone++;
                        }
                        // Work out the partially-normalized hypergeometric PDF for the next
                        // number of successes
                        scaledPDF *= (n - i) * (m - i) / ((i + 1) * (N - m - n + i + 1));
                    }
                    for(; samplesDone < n; samplesDone++)// Apply all the rest of the normalization
                    scaledPDF *= 1 - m / (N - samplesDone);
                    // Bound answer sanely before returning.
                    return Math1.min(1, Math1.max(0, scaledPDF));
                }
            },
            cdf: function cdf(x, N, m, n) {
                // Hypergeometric CDF.
                // This algorithm is due to Prof. Thomas S. Ferguson, <tom@math.ucla.edu>,
                // and comes from his hypergeometric test calculator at
                // <http://www.math.ucla.edu/~tom/distributions/Hypergeometric.html>.
                // x = number of successes drawn
                // N = population size
                // m = number of successes in population
                // n = number of items drawn from population
                if (x < 0 || x < m - (N - n)) // It's impossible to have this few successes drawn or fewer.
                return 0;
                else if (x >= n || x >= m) // We will always have this many successes or fewer.
                return 1;
                else if (m * 2 > N) {
                    // More than half the population is successes.
                    if (n * 2 > N) // More than half the population is sampled.
                    return jStat.hypgeom.cdf(N - m - n + x, N, N - m, N - n);
                    else // Half or less of the population is sampled.
                    return 1 - jStat.hypgeom.cdf(n - x - 1, N, N - m, n);
                } else if (n * 2 > N) // Half or less is successes.
                return 1 - jStat.hypgeom.cdf(m - x - 1, N, m, N - n);
                else if (m < n) // We want to have the number of things sampled to be less than the
                // successes available. So swap the definitions of successful and sampled.
                return jStat.hypgeom.cdf(x, N, n, m);
                else {
                    // If we get here, half or less of the population was sampled, half or
                    // less of it was successes, and we had fewer sampled things than
                    // successes. Now we can do this complicated iterative algorithm in an
                    // efficient way.
                    // The basic premise of the algorithm is that we partially normalize our
                    // intermediate sum to keep it in a numerically good region, and then
                    // finish the normalization at the end.
                    // Holds the intermediate, scaled total CDF.
                    var scaledCDF = 1;
                    // This variable holds the scaled probability of the current number of
                    // successes.
                    var scaledPDF = 1;
                    // This keeps track of how much we have normalized.
                    var samplesDone = 0;
                    for(var i = 0; i < x; i++){
                        // For every possible number of successes up to that observed...
                        while(scaledCDF > 1 && samplesDone < n){
                            // Intermediate result is growing too big. Apply some of the
                            // normalization to shrink everything.
                            var factor = 1 - m / (N - samplesDone);
                            scaledPDF *= factor;
                            scaledCDF *= factor;
                            // Say we've normalized by this sample already.
                            samplesDone++;
                        }
                        // Work out the partially-normalized hypergeometric PDF for the next
                        // number of successes
                        scaledPDF *= (n - i) * (m - i) / ((i + 1) * (N - m - n + i + 1));
                        // Add to the CDF answer.
                        scaledCDF += scaledPDF;
                    }
                    for(; samplesDone < n; samplesDone++)// Apply all the rest of the normalization
                    scaledCDF *= 1 - m / (N - samplesDone);
                    // Bound answer sanely before returning.
                    return Math1.min(1, Math1.max(0, scaledCDF));
                }
            }
        });
        // extend uniform function with static methods
        jStat.extend(jStat.poisson, {
            pdf: function pdf(k, l) {
                if (l < 0 || k % 1 !== 0 || k < 0) return 0;
                return Math1.pow(l, k) * Math1.exp(-l) / jStat.factorial(k);
            },
            cdf: function cdf(x, l) {
                var sumarr = [], k = 0;
                if (x < 0) return 0;
                for(; k <= x; k++)sumarr.push(jStat.poisson.pdf(k, l));
                return jStat.sum(sumarr);
            },
            mean: function(l) {
                return l;
            },
            variance: function(l) {
                return l;
            },
            sampleSmall: function sampleSmall(l) {
                var p = 1, k = 0, L = Math1.exp(-l);
                do {
                    k++;
                    p *= jStat._random_fn();
                }while (p > L);
                return k - 1;
            },
            sampleLarge: function sampleLarge(l) {
                var lam = l;
                var k;
                var U, V, slam, loglam, a, b, invalpha, vr, us;
                slam = Math1.sqrt(lam);
                loglam = Math1.log(lam);
                b = 0.931 + 2.53 * slam;
                a = -0.059 + 0.02483 * b;
                invalpha = 1.1239 + 1.1328 / (b - 3.4);
                vr = 0.9277 - 3.6224 / (b - 2);
                while(true){
                    U = Math1.random() - 0.5;
                    V = Math1.random();
                    us = 0.5 - Math1.abs(U);
                    k = Math1.floor((2 * a / us + b) * U + lam + 0.43);
                    if (us >= 0.07 && V <= vr) return k;
                    if (k < 0 || us < 0.013 && V > us) continue;
                    /* log(V) == log(0.0) ok here */ /* if U==0.0 so that us==0.0, log is ok since always returns */ if (Math1.log(V) + Math1.log(invalpha) - Math1.log(a / (us * us) + b) <= -lam + k * loglam - jStat.loggam(k + 1)) return k;
                }
            },
            sample: function sample(l) {
                if (l < 10) return this.sampleSmall(l);
                else return this.sampleLarge(l);
            }
        });
        // extend triangular function with static methods
        jStat.extend(jStat.triangular, {
            pdf: function pdf(x, a, b, c) {
                if (b <= a || c < a || c > b) return NaN;
                else {
                    if (x < a || x > b) return 0;
                    else if (x < c) return 2 * (x - a) / ((b - a) * (c - a));
                    else if (x === c) return 2 / (b - a);
                    else return 2 * (b - x) / ((b - a) * (b - c));
                }
            },
            cdf: function cdf(x, a, b, c) {
                if (b <= a || c < a || c > b) return NaN;
                if (x <= a) return 0;
                else if (x >= b) return 1;
                if (x <= c) return Math1.pow(x - a, 2) / ((b - a) * (c - a));
                else return 1 - Math1.pow(b - x, 2) / ((b - a) * (b - c));
            },
            inv: function inv(p, a, b, c) {
                if (b <= a || c < a || c > b) return NaN;
                else {
                    if (p <= (c - a) / (b - a)) return a + (b - a) * Math1.sqrt(p * ((c - a) / (b - a)));
                    else return a + (b - a) * (1 - Math1.sqrt((1 - p) * (1 - (c - a) / (b - a))));
                }
            },
            mean: function mean(a, b, c) {
                return (a + b + c) / 3;
            },
            median: function median(a, b, c) {
                if (c <= (a + b) / 2) return b - Math1.sqrt((b - a) * (b - c)) / Math1.sqrt(2);
                else if (c > (a + b) / 2) return a + Math1.sqrt((b - a) * (c - a)) / Math1.sqrt(2);
            },
            mode: function mode(a, b, c) {
                return c;
            },
            sample: function sample(a, b, c) {
                var u = jStat._random_fn();
                if (u < (c - a) / (b - a)) return a + Math1.sqrt(u * (b - a) * (c - a));
                return b - Math1.sqrt((1 - u) * (b - a) * (b - c));
            },
            variance: function variance(a, b, c) {
                return (a * a + b * b + c * c - a * b - a * c - b * c) / 18;
            }
        });
        // extend arcsine function with static methods
        jStat.extend(jStat.arcsine, {
            pdf: function pdf(x, a, b) {
                if (b <= a) return NaN;
                return x <= a || x >= b ? 0 : 2 / Math1.PI * Math1.pow(Math1.pow(b - a, 2) - Math1.pow(2 * x - a - b, 2), -0.5);
            },
            cdf: function cdf(x, a, b) {
                if (x < a) return 0;
                else if (x < b) return 2 / Math1.PI * Math1.asin(Math1.sqrt((x - a) / (b - a)));
                return 1;
            },
            inv: function(p, a, b) {
                return a + (0.5 - 0.5 * Math1.cos(Math1.PI * p)) * (b - a);
            },
            mean: function mean(a, b) {
                if (b <= a) return NaN;
                return (a + b) / 2;
            },
            median: function median(a, b) {
                if (b <= a) return NaN;
                return (a + b) / 2;
            },
            mode: function mode() {
                throw new Error("mode is not yet implemented");
            },
            sample: function sample(a, b) {
                return (a + b) / 2 + (b - a) / 2 * Math1.sin(2 * Math1.PI * jStat.uniform.sample(0, 1));
            },
            variance: function variance(a, b) {
                if (b <= a) return NaN;
                return Math1.pow(b - a, 2) / 8;
            }
        });
        function laplaceSign(x) {
            return x / Math1.abs(x);
        }
        jStat.extend(jStat.laplace, {
            pdf: function pdf(x, mu, b) {
                return b <= 0 ? 0 : Math1.exp(-Math1.abs(x - mu) / b) / (2 * b);
            },
            cdf: function cdf(x, mu, b) {
                if (b <= 0) return 0;
                if (x < mu) return 0.5 * Math1.exp((x - mu) / b);
                else return 1 - 0.5 * Math1.exp(-(x - mu) / b);
            },
            mean: function(mu /*, b*/ ) {
                return mu;
            },
            median: function(mu /*, b*/ ) {
                return mu;
            },
            mode: function(mu /*, b*/ ) {
                return mu;
            },
            variance: function(mu, b) {
                return 2 * b * b;
            },
            sample: function sample(mu, b) {
                var u = jStat._random_fn() - 0.5;
                return mu - b * laplaceSign(u) * Math1.log(1 - 2 * Math1.abs(u));
            }
        });
        function tukeyWprob(w, rr, cc) {
            var nleg = 12;
            var ihalf = 6;
            var C1 = -30;
            var C2 = -50;
            var C3 = 60;
            var bb = 8;
            var wlar = 3;
            var wincr1 = 2;
            var wincr2 = 3;
            var xleg = [
                0.981560634246719250690549090149,
                0.904117256370474856678465866119,
                0.769902674194304687036893833213,
                0.587317954286617447296702418941,
                0.367831498998180193752691536644,
                0.125233408511468915472441369464
            ];
            var aleg = [
                0.047175336386511827194615961485,
                0.106939325995318430960254718194,
                0.160078328543346226334652529543,
                0.203167426723065921749064455810,
                0.233492536538354808760849898925,
                0.249147045813402785000562436043
            ];
            var qsqz = w * 0.5;
            // if w >= 16 then the integral lower bound (occurs for c=20)
            // is 0.99999999999995 so return a value of 1.
            if (qsqz >= bb) return 1.0;
            // find (f(w/2) - 1) ^ cc
            // (first term in integral of hartley's form).
            var pr_w = 2 * jStat.normal.cdf(qsqz, 0, 1, 1, 0) - 1; // erf(qsqz / M_SQRT2)
            // if pr_w ^ cc < 2e-22 then set pr_w = 0
            if (pr_w >= Math1.exp(C2 / cc)) pr_w = Math1.pow(pr_w, cc);
            else pr_w = 0.0;
            // if w is large then the second component of the
            // integral is small, so fewer intervals are needed.
            var wincr;
            if (w > wlar) wincr = wincr1;
            else wincr = wincr2;
            // find the integral of second term of hartley's form
            // for the integral of the range for equal-length
            // intervals using legendre quadrature.  limits of
            // integration are from (w/2, 8).  two or three
            // equal-length intervals are used.
            // blb and bub are lower and upper limits of integration.
            var blb = qsqz;
            var binc = (bb - qsqz) / wincr;
            var bub = blb + binc;
            var einsum = 0.0;
            // integrate over each interval
            var cc1 = cc - 1.0;
            for(var wi = 1; wi <= wincr; wi++){
                var elsum = 0.0;
                var a = 0.5 * (bub + blb);
                // legendre quadrature with order = nleg
                var b = 0.5 * (bub - blb);
                for(var jj = 1; jj <= nleg; jj++){
                    var j, xx;
                    if (ihalf < jj) {
                        j = nleg - jj + 1;
                        xx = xleg[j - 1];
                    } else {
                        j = jj;
                        xx = -xleg[j - 1];
                    }
                    var c = b * xx;
                    var ac = a + c;
                    // if exp(-qexpo/2) < 9e-14,
                    // then doesn't contribute to integral
                    var qexpo = ac * ac;
                    if (qexpo > C3) break;
                    var pplus = 2 * jStat.normal.cdf(ac, 0, 1, 1, 0);
                    var pminus = 2 * jStat.normal.cdf(ac, w, 1, 1, 0);
                    // if rinsum ^ (cc-1) < 9e-14,
                    // then doesn't contribute to integral
                    var rinsum = pplus * 0.5 - pminus * 0.5;
                    if (rinsum >= Math1.exp(C1 / cc1)) {
                        rinsum = aleg[j - 1] * Math1.exp(-(0.5 * qexpo)) * Math1.pow(rinsum, cc1);
                        elsum += rinsum;
                    }
                }
                elsum *= 2.0 * b * cc / Math1.sqrt(2 * Math1.PI);
                einsum += elsum;
                blb = bub;
                bub += binc;
            }
            // if pr_w ^ rr < 9e-14, then return 0
            pr_w += einsum;
            if (pr_w <= Math1.exp(C1 / rr)) return 0;
            pr_w = Math1.pow(pr_w, rr);
            if (pr_w >= 1) return 1;
            return pr_w;
        }
        function tukeyQinv(p, c, v) {
            var p0 = 0.322232421088;
            var q0 = 0.993484626060e-01;
            var p1 = -1;
            var q1 = 0.588581570495;
            var p2 = -0.342242088547;
            var q2 = 0.531103462366;
            var p3 = -0.204231210125;
            var q3 = 0.103537752850;
            var p4 = -0.0000453642210148;
            var q4 = 0.38560700634e-02;
            var c1 = 0.8832;
            var c2 = 0.2368;
            var c3 = 1.214;
            var c4 = 1.208;
            var c5 = 1.4142;
            var vmax = 120.0;
            var ps = 0.5 - 0.5 * p;
            var yi = Math1.sqrt(Math1.log(1.0 / (ps * ps)));
            var t = yi + ((((yi * p4 + p3) * yi + p2) * yi + p1) * yi + p0) / ((((yi * q4 + q3) * yi + q2) * yi + q1) * yi + q0);
            if (v < vmax) t += (t * t * t + t) / v / 4.0;
            var q = c1 - c2 * t;
            if (v < vmax) q += -c3 / v + c4 * t / v;
            return t * (q * Math1.log(c - 1.0) + c5);
        }
        jStat.extend(jStat.tukey, {
            cdf: function cdf(q, nmeans, df) {
                // Identical implementation as the R ptukey() function as of commit 68947
                var rr = 1;
                var cc = nmeans;
                var nlegq = 16;
                var ihalfq = 8;
                var eps1 = -30;
                var eps2 = 1.0e-14;
                var dhaf = 100.0;
                var dquar = 800.0;
                var deigh = 5000.0;
                var dlarg = 25000.0;
                var ulen1 = 1.0;
                var ulen2 = 0.5;
                var ulen3 = 0.25;
                var ulen4 = 0.125;
                var xlegq = [
                    0.989400934991649932596154173450,
                    0.944575023073232576077988415535,
                    0.865631202387831743880467897712,
                    0.755404408355003033895101194847,
                    0.617876244402643748446671764049,
                    0.458016777657227386342419442984,
                    0.281603550779258913230460501460,
                    0.950125098376374401853193354250e-1
                ];
                var alegq = [
                    0.271524594117540948517805724560e-1,
                    0.622535239386478928628438369944e-1,
                    0.951585116824927848099251076022e-1,
                    0.124628971255533872052476282192,
                    0.149595988816576732081501730547,
                    0.169156519395002538189312079030,
                    0.182603415044923588866763667969,
                    0.189450610455068496285396723208
                ];
                if (q <= 0) return 0;
                // df must be > 1
                // there must be at least two values
                if (df < 2 || rr < 1 || cc < 2) return NaN;
                if (!Number.isFinite(q)) return 1;
                if (df > dlarg) return tukeyWprob(q, rr, cc);
                // calculate leading constant
                var f2 = df * 0.5;
                var f2lf = f2 * Math1.log(df) - df * Math1.log(2) - jStat.gammaln(f2);
                var f21 = f2 - 1.0;
                // integral is divided into unit, half-unit, quarter-unit, or
                // eighth-unit length intervals depending on the value of the
                // degrees of freedom.
                var ff4 = df * 0.25;
                var ulen;
                if (df <= dhaf) ulen = ulen1;
                else if (df <= dquar) ulen = ulen2;
                else if (df <= deigh) ulen = ulen3;
                else ulen = ulen4;
                f2lf += Math1.log(ulen);
                // integrate over each subinterval
                var ans = 0.0;
                for(var i = 1; i <= 50; i++){
                    var otsum = 0.0;
                    // legendre quadrature with order = nlegq
                    // nodes (stored in xlegq) are symmetric around zero.
                    var twa1 = (2 * i - 1) * ulen;
                    for(var jj = 1; jj <= nlegq; jj++){
                        var j, t1;
                        if (ihalfq < jj) {
                            j = jj - ihalfq - 1;
                            t1 = f2lf + f21 * Math1.log(twa1 + xlegq[j] * ulen) - (xlegq[j] * ulen + twa1) * ff4;
                        } else {
                            j = jj - 1;
                            t1 = f2lf + f21 * Math1.log(twa1 - xlegq[j] * ulen) + (xlegq[j] * ulen - twa1) * ff4;
                        }
                        // if exp(t1) < 9e-14, then doesn't contribute to integral
                        var qsqz;
                        if (t1 >= eps1) {
                            if (ihalfq < jj) qsqz = q * Math1.sqrt((xlegq[j] * ulen + twa1) * 0.5);
                            else qsqz = q * Math1.sqrt((-(xlegq[j] * ulen) + twa1) * 0.5);
                            // call wprob to find integral of range portion
                            var wprb = tukeyWprob(qsqz, rr, cc);
                            var rotsum = wprb * alegq[j] * Math1.exp(t1);
                            otsum += rotsum;
                        }
                    // end legendre integral for interval i
                    // L200:
                    }
                    // if integral for interval i < 1e-14, then stop.
                    // However, in order to avoid small area under left tail,
                    // at least  1 / ulen  intervals are calculated.
                    if (i * ulen >= 1.0 && otsum <= eps2) break;
                    // end of interval i
                    // L330:
                    ans += otsum;
                }
                if (otsum > eps2) throw new Error("tukey.cdf failed to converge");
                if (ans > 1) ans = 1;
                return ans;
            },
            inv: function(p, nmeans, df) {
                // Identical implementation as the R qtukey() function as of commit 68947
                var rr = 1;
                var cc = nmeans;
                var eps = 0.0001;
                var maxiter = 50;
                // df must be > 1 ; there must be at least two values
                if (df < 2 || rr < 1 || cc < 2) return NaN;
                if (p < 0 || p > 1) return NaN;
                if (p === 0) return 0;
                if (p === 1) return Infinity;
                // Initial value
                var x0 = tukeyQinv(p, cc, df);
                // Find prob(value < x0)
                var valx0 = jStat.tukey.cdf(x0, nmeans, df) - p;
                // Find the second iterate and prob(value < x1).
                // If the first iterate has probability value
                // exceeding p then second iterate is 1 less than
                // first iterate; otherwise it is 1 greater.
                var x1;
                if (valx0 > 0.0) x1 = Math1.max(0.0, x0 - 1.0);
                else x1 = x0 + 1.0;
                var valx1 = jStat.tukey.cdf(x1, nmeans, df) - p;
                // Find new iterate
                var ans;
                for(var iter = 1; iter < maxiter; iter++){
                    ans = x1 - valx1 * (x1 - x0) / (valx1 - valx0);
                    valx0 = valx1;
                    // New iterate must be >= 0
                    x0 = x1;
                    if (ans < 0.0) {
                        ans = 0.0;
                        valx1 = -p;
                    }
                    // Find prob(value < new iterate)
                    valx1 = jStat.tukey.cdf(ans, nmeans, df) - p;
                    x1 = ans;
                    // If the difference between two successive
                    // iterates is less than eps, stop
                    var xabs = Math1.abs(x1 - x0);
                    if (xabs < eps) return ans;
                }
                throw new Error("tukey.inv failed to converge");
            }
        });
    })(jStat, Math);
    /* Provides functions for the solution of linear system of equations, integration, extrapolation,
 * interpolation, eigenvalue problems, differential equations and PCA analysis. */ (function(jStat, Math1) {
        var push = Array.prototype.push;
        var isArray = jStat.utils.isArray;
        function isUsable(arg) {
            return isArray(arg) || arg instanceof jStat;
        }
        jStat.extend({
            // add a vector/matrix to a vector/matrix or scalar
            add: function add(arr, arg) {
                // check if arg is a vector or scalar
                if (isUsable(arg)) {
                    if (!isUsable(arg[0])) arg = [
                        arg
                    ];
                    return jStat.map(arr, function(value, row, col) {
                        return value + arg[row][col];
                    });
                }
                return jStat.map(arr, function(value) {
                    return value + arg;
                });
            },
            // subtract a vector or scalar from the vector
            subtract: function subtract(arr, arg) {
                // check if arg is a vector or scalar
                if (isUsable(arg)) {
                    if (!isUsable(arg[0])) arg = [
                        arg
                    ];
                    return jStat.map(arr, function(value, row, col) {
                        return value - arg[row][col] || 0;
                    });
                }
                return jStat.map(arr, function(value) {
                    return value - arg;
                });
            },
            // matrix division
            divide: function divide(arr, arg) {
                if (isUsable(arg)) {
                    if (!isUsable(arg[0])) arg = [
                        arg
                    ];
                    return jStat.multiply(arr, jStat.inv(arg));
                }
                return jStat.map(arr, function(value) {
                    return value / arg;
                });
            },
            // matrix multiplication
            multiply: function multiply(arr, arg) {
                var row, col, nrescols, sum, nrow, ncol, res, rescols;
                // eg: arr = 2 arg = 3 -> 6 for res[0][0] statement closure
                if (arr.length === undefined && arg.length === undefined) return arr * arg;
                nrow = arr.length, ncol = arr[0].length, res = jStat.zeros(nrow, nrescols = isUsable(arg) ? arg[0].length : ncol), rescols = 0;
                if (isUsable(arg)) {
                    for(; rescols < nrescols; rescols++)for(row = 0; row < nrow; row++){
                        sum = 0;
                        for(col = 0; col < ncol; col++)sum += arr[row][col] * arg[col][rescols];
                        res[row][rescols] = sum;
                    }
                    return nrow === 1 && rescols === 1 ? res[0][0] : res;
                }
                return jStat.map(arr, function(value) {
                    return value * arg;
                });
            },
            // outer([1,2,3],[4,5,6])
            // ===
            // [[1],[2],[3]] times [[4,5,6]]
            // ->
            // [[4,5,6],[8,10,12],[12,15,18]]
            outer: function outer(A, B) {
                return jStat.multiply(A.map(function(t) {
                    return [
                        t
                    ];
                }), [
                    B
                ]);
            },
            // Returns the dot product of two matricies
            dot: function dot(arr, arg) {
                if (!isUsable(arr[0])) arr = [
                    arr
                ];
                if (!isUsable(arg[0])) arg = [
                    arg
                ];
                // convert column to row vector
                var left = arr[0].length === 1 && arr.length !== 1 ? jStat.transpose(arr) : arr, right = arg[0].length === 1 && arg.length !== 1 ? jStat.transpose(arg) : arg, res = [], row = 0, nrow = left.length, ncol = left[0].length, sum, col;
                for(; row < nrow; row++){
                    res[row] = [];
                    sum = 0;
                    for(col = 0; col < ncol; col++)sum += left[row][col] * right[row][col];
                    res[row] = sum;
                }
                return res.length === 1 ? res[0] : res;
            },
            // raise every element by a scalar
            pow: function pow(arr, arg) {
                return jStat.map(arr, function(value) {
                    return Math1.pow(value, arg);
                });
            },
            // exponentiate every element
            exp: function exp(arr) {
                return jStat.map(arr, function(value) {
                    return Math1.exp(value);
                });
            },
            // generate the natural log of every element
            log: function exp(arr) {
                return jStat.map(arr, function(value) {
                    return Math1.log(value);
                });
            },
            // generate the absolute values of the vector
            abs: function abs(arr) {
                return jStat.map(arr, function(value) {
                    return Math1.abs(value);
                });
            },
            // computes the p-norm of the vector
            // In the case that a matrix is passed, uses the first row as the vector
            norm: function norm(arr, p) {
                var nnorm = 0, i = 0;
                // check the p-value of the norm, and set for most common case
                if (isNaN(p)) p = 2;
                // check if multi-dimensional array, and make vector correction
                if (isUsable(arr[0])) arr = arr[0];
                // vector norm
                for(; i < arr.length; i++)nnorm += Math1.pow(Math1.abs(arr[i]), p);
                return Math1.pow(nnorm, 1 / p);
            },
            // computes the angle between two vectors in rads
            // In case a matrix is passed, this uses the first row as the vector
            angle: function angle(arr, arg) {
                return Math1.acos(jStat.dot(arr, arg) / (jStat.norm(arr) * jStat.norm(arg)));
            },
            // augment one matrix by another
            // Note: this function returns a matrix, not a jStat object
            aug: function aug(a, b) {
                var newarr = [];
                var i;
                for(i = 0; i < a.length; i++)newarr.push(a[i].slice());
                for(i = 0; i < newarr.length; i++)push.apply(newarr[i], b[i]);
                return newarr;
            },
            // The inv() function calculates the inverse of a matrix
            // Create the inverse by augmenting the matrix by the identity matrix of the
            // appropriate size, and then use G-J elimination on the augmented matrix.
            inv: function inv(a) {
                var rows = a.length;
                var cols = a[0].length;
                var b = jStat.identity(rows, cols);
                var c = jStat.gauss_jordan(a, b);
                var result = [];
                var i = 0;
                var j;
                //We need to copy the inverse portion to a new matrix to rid G-J artifacts
                for(; i < rows; i++){
                    result[i] = [];
                    for(j = cols; j < c[0].length; j++)result[i][j - cols] = c[i][j];
                }
                return result;
            },
            // calculate the determinant of a matrix
            det: function det(a) {
                if (a.length === 2) return a[0][0] * a[1][1] - a[0][1] * a[1][0];
                var determinant = 0;
                for(var i = 0; i < a.length; i++){
                    // build a sub matrix without column `i`
                    var submatrix = [];
                    for(var row = 1; row < a.length; row++){
                        submatrix[row - 1] = [];
                        for(var col = 0; col < a.length; col++){
                            if (col < i) submatrix[row - 1][col] = a[row][col];
                            else if (col > i) submatrix[row - 1][col - 1] = a[row][col];
                        }
                    }
                    // alternate between + and - between determinants
                    var sign = i % 2 ? -1 : 1;
                    determinant += det(submatrix) * a[0][i] * sign;
                }
                return determinant;
            },
            gauss_elimination: function gauss_elimination(a, b) {
                var i = 0, j = 0, n = a.length, m = a[0].length, factor = 1, sum = 0, x = [], maug, pivot, temp, k;
                a = jStat.aug(a, b);
                maug = a[0].length;
                for(i = 0; i < n; i++){
                    pivot = a[i][i];
                    j = i;
                    for(k = i + 1; k < m; k++)if (pivot < Math1.abs(a[k][i])) {
                        pivot = a[k][i];
                        j = k;
                    }
                    if (j != i) for(k = 0; k < maug; k++){
                        temp = a[i][k];
                        a[i][k] = a[j][k];
                        a[j][k] = temp;
                    }
                    for(j = i + 1; j < n; j++){
                        factor = a[j][i] / a[i][i];
                        for(k = i; k < maug; k++)a[j][k] = a[j][k] - factor * a[i][k];
                    }
                }
                for(i = n - 1; i >= 0; i--){
                    sum = 0;
                    for(j = i + 1; j <= n - 1; j++)sum = sum + x[j] * a[i][j];
                    x[i] = (a[i][maug - 1] - sum) / a[i][i];
                }
                return x;
            },
            gauss_jordan: function gauss_jordan(a, b) {
                var m = jStat.aug(a, b);
                var h = m.length;
                var w = m[0].length;
                var c = 0;
                var x, y, y2;
                // find max pivot
                for(y = 0; y < h; y++){
                    var maxrow = y;
                    for(y2 = y + 1; y2 < h; y2++)if (Math1.abs(m[y2][y]) > Math1.abs(m[maxrow][y])) maxrow = y2;
                    var tmp = m[y];
                    m[y] = m[maxrow];
                    m[maxrow] = tmp;
                    for(y2 = y + 1; y2 < h; y2++){
                        c = m[y2][y] / m[y][y];
                        for(x = y; x < w; x++)m[y2][x] -= m[y][x] * c;
                    }
                }
                // backsubstitute
                for(y = h - 1; y >= 0; y--){
                    c = m[y][y];
                    for(y2 = 0; y2 < y; y2++)for(x = w - 1; x > y - 1; x--)m[y2][x] -= m[y][x] * m[y2][y] / c;
                    m[y][y] /= c;
                    for(x = h; x < w; x++)m[y][x] /= c;
                }
                return m;
            },
            // solve equation
            // Ax=b
            // A is upper triangular matrix
            // A=[[1,2,3],[0,4,5],[0,6,7]]
            // b=[1,2,3]
            // triaUpSolve(A,b) // -> [2.666,0.1666,1.666]
            // if you use matrix style
            // A=[[1,2,3],[0,4,5],[0,6,7]]
            // b=[[1],[2],[3]]
            // will return [[2.666],[0.1666],[1.666]]
            triaUpSolve: function triaUpSolve(A, b) {
                var size = A[0].length;
                var x = jStat.zeros(1, size)[0];
                var parts;
                var matrix_mode = false;
                if (b[0].length != undefined) {
                    b = b.map(function(i) {
                        return i[0];
                    });
                    matrix_mode = true;
                }
                jStat.arange(size - 1, -1, -1).forEach(function(i) {
                    parts = jStat.arange(i + 1, size).map(function(j) {
                        return x[j] * A[i][j];
                    });
                    x[i] = (b[i] - jStat.sum(parts)) / A[i][i];
                });
                if (matrix_mode) return x.map(function(i) {
                    return [
                        i
                    ];
                });
                return x;
            },
            triaLowSolve: function triaLowSolve(A, b) {
                // like to triaUpSolve but A is lower triangular matrix
                var size = A[0].length;
                var x = jStat.zeros(1, size)[0];
                var parts;
                var matrix_mode = false;
                if (b[0].length != undefined) {
                    b = b.map(function(i) {
                        return i[0];
                    });
                    matrix_mode = true;
                }
                jStat.arange(size).forEach(function(i) {
                    parts = jStat.arange(i).map(function(j) {
                        return A[i][j] * x[j];
                    });
                    x[i] = (b[i] - jStat.sum(parts)) / A[i][i];
                });
                if (matrix_mode) return x.map(function(i) {
                    return [
                        i
                    ];
                });
                return x;
            },
            // A -> [L,U]
            // A=LU
            // L is lower triangular matrix
            // U is upper triangular matrix
            lu: function lu(A) {
                var size = A.length;
                //var L=jStat.diagonal(jStat.ones(1,size)[0]);
                var L = jStat.identity(size);
                var R = jStat.zeros(A.length, A[0].length);
                var parts;
                jStat.arange(size).forEach(function(t) {
                    R[0][t] = A[0][t];
                });
                jStat.arange(1, size).forEach(function(l) {
                    jStat.arange(l).forEach(function(i) {
                        parts = jStat.arange(i).map(function(jj) {
                            return L[l][jj] * R[jj][i];
                        });
                        L[l][i] = (A[l][i] - jStat.sum(parts)) / R[i][i];
                    });
                    jStat.arange(l, size).forEach(function(j) {
                        parts = jStat.arange(l).map(function(jj) {
                            return L[l][jj] * R[jj][j];
                        });
                        R[l][j] = A[parts.length][j] - jStat.sum(parts);
                    });
                });
                return [
                    L,
                    R
                ];
            },
            // A -> T
            // A=TT'
            // T is lower triangular matrix
            cholesky: function cholesky(A) {
                var size = A.length;
                var T = jStat.zeros(A.length, A[0].length);
                var parts;
                jStat.arange(size).forEach(function(i) {
                    parts = jStat.arange(i).map(function(t) {
                        return Math1.pow(T[i][t], 2);
                    });
                    T[i][i] = Math1.sqrt(A[i][i] - jStat.sum(parts));
                    jStat.arange(i + 1, size).forEach(function(j) {
                        parts = jStat.arange(i).map(function(t) {
                            return T[i][t] * T[j][t];
                        });
                        T[j][i] = (A[i][j] - jStat.sum(parts)) / T[i][i];
                    });
                });
                return T;
            },
            gauss_jacobi: function gauss_jacobi(a, b, x, r) {
                var i = 0;
                var j = 0;
                var n = a.length;
                var l = [];
                var u = [];
                var d = [];
                var xv, c, h, xk;
                for(; i < n; i++){
                    l[i] = [];
                    u[i] = [];
                    d[i] = [];
                    for(j = 0; j < n; j++){
                        if (i > j) {
                            l[i][j] = a[i][j];
                            u[i][j] = d[i][j] = 0;
                        } else if (i < j) {
                            u[i][j] = a[i][j];
                            l[i][j] = d[i][j] = 0;
                        } else {
                            d[i][j] = a[i][j];
                            l[i][j] = u[i][j] = 0;
                        }
                    }
                }
                h = jStat.multiply(jStat.multiply(jStat.inv(d), jStat.add(l, u)), -1);
                c = jStat.multiply(jStat.inv(d), b);
                xv = x;
                xk = jStat.add(jStat.multiply(h, x), c);
                i = 2;
                while(Math1.abs(jStat.norm(jStat.subtract(xk, xv))) > r){
                    xv = xk;
                    xk = jStat.add(jStat.multiply(h, xv), c);
                    i++;
                }
                return xk;
            },
            gauss_seidel: function gauss_seidel(a, b, x, r) {
                var i = 0;
                var n = a.length;
                var l = [];
                var u = [];
                var d = [];
                var j, xv, c, h, xk;
                for(; i < n; i++){
                    l[i] = [];
                    u[i] = [];
                    d[i] = [];
                    for(j = 0; j < n; j++){
                        if (i > j) {
                            l[i][j] = a[i][j];
                            u[i][j] = d[i][j] = 0;
                        } else if (i < j) {
                            u[i][j] = a[i][j];
                            l[i][j] = d[i][j] = 0;
                        } else {
                            d[i][j] = a[i][j];
                            l[i][j] = u[i][j] = 0;
                        }
                    }
                }
                h = jStat.multiply(jStat.multiply(jStat.inv(jStat.add(d, l)), u), -1);
                c = jStat.multiply(jStat.inv(jStat.add(d, l)), b);
                xv = x;
                xk = jStat.add(jStat.multiply(h, x), c);
                i = 2;
                while(Math1.abs(jStat.norm(jStat.subtract(xk, xv))) > r){
                    xv = xk;
                    xk = jStat.add(jStat.multiply(h, xv), c);
                    i = i + 1;
                }
                return xk;
            },
            SOR: function SOR(a, b, x, r, w) {
                var i = 0;
                var n = a.length;
                var l = [];
                var u = [];
                var d = [];
                var j, xv, c, h, xk;
                for(; i < n; i++){
                    l[i] = [];
                    u[i] = [];
                    d[i] = [];
                    for(j = 0; j < n; j++){
                        if (i > j) {
                            l[i][j] = a[i][j];
                            u[i][j] = d[i][j] = 0;
                        } else if (i < j) {
                            u[i][j] = a[i][j];
                            l[i][j] = d[i][j] = 0;
                        } else {
                            d[i][j] = a[i][j];
                            l[i][j] = u[i][j] = 0;
                        }
                    }
                }
                h = jStat.multiply(jStat.inv(jStat.add(d, jStat.multiply(l, w))), jStat.subtract(jStat.multiply(d, 1 - w), jStat.multiply(u, w)));
                c = jStat.multiply(jStat.multiply(jStat.inv(jStat.add(d, jStat.multiply(l, w))), b), w);
                xv = x;
                xk = jStat.add(jStat.multiply(h, x), c);
                i = 2;
                while(Math1.abs(jStat.norm(jStat.subtract(xk, xv))) > r){
                    xv = xk;
                    xk = jStat.add(jStat.multiply(h, xv), c);
                    i++;
                }
                return xk;
            },
            householder: function householder(a) {
                var m = a.length;
                var n = a[0].length;
                var i = 0;
                var w = [];
                var p = [];
                var alpha, r, k, j, factor;
                for(; i < m - 1; i++){
                    alpha = 0;
                    for(j = i + 1; j < n; j++)alpha += a[j][i] * a[j][i];
                    factor = a[i + 1][i] > 0 ? -1 : 1;
                    alpha = factor * Math1.sqrt(alpha);
                    r = Math1.sqrt((alpha * alpha - a[i + 1][i] * alpha) / 2);
                    w = jStat.zeros(m, 1);
                    w[i + 1][0] = (a[i + 1][i] - alpha) / (2 * r);
                    for(k = i + 2; k < m; k++)w[k][0] = a[k][i] / (2 * r);
                    p = jStat.subtract(jStat.identity(m, n), jStat.multiply(jStat.multiply(w, jStat.transpose(w)), 2));
                    a = jStat.multiply(p, jStat.multiply(a, p));
                }
                return a;
            },
            // A -> [Q,R]
            // Q is orthogonal matrix
            // R is upper triangular
            QR: function() {
                // x -> Q
                // find a orthogonal matrix Q st.
                // Qx=y
                // y is [||x||,0,0,...]
                // quick ref
                var sum = jStat.sum;
                var range = jStat.arange;
                function qr2(x) {
                    // quick impletation
                    // https://www.stat.wisc.edu/~larget/math496/qr.html
                    var n = x.length;
                    var p = x[0].length;
                    var r = jStat.zeros(p, p);
                    x = jStat.copy(x);
                    var i, j, k;
                    for(j = 0; j < p; j++){
                        r[j][j] = Math1.sqrt(sum(range(n).map(function(i) {
                            return x[i][j] * x[i][j];
                        })));
                        for(i = 0; i < n; i++)x[i][j] = x[i][j] / r[j][j];
                        for(k = j + 1; k < p; k++){
                            r[j][k] = sum(range(n).map(function(i) {
                                return x[i][j] * x[i][k];
                            }));
                            for(i = 0; i < n; i++)x[i][k] = x[i][k] - x[i][j] * r[j][k];
                        }
                    }
                    return [
                        x,
                        r
                    ];
                }
                return qr2;
            }(),
            lstsq: function() {
                // solve least squard problem for Ax=b as QR decomposition way if b is
                // [[b1],[b2],[b3]] form will return [[x1],[x2],[x3]] array form solution
                // else b is [b1,b2,b3] form will return [x1,x2,x3] array form solution
                function R_I(A) {
                    A = jStat.copy(A);
                    var size = A.length;
                    var I = jStat.identity(size);
                    jStat.arange(size - 1, -1, -1).forEach(function(i) {
                        jStat.sliceAssign(I, {
                            row: i
                        }, jStat.divide(jStat.slice(I, {
                            row: i
                        }), A[i][i]));
                        jStat.sliceAssign(A, {
                            row: i
                        }, jStat.divide(jStat.slice(A, {
                            row: i
                        }), A[i][i]));
                        jStat.arange(i).forEach(function(j) {
                            var c = jStat.multiply(A[j][i], -1);
                            var Aj = jStat.slice(A, {
                                row: j
                            });
                            var cAi = jStat.multiply(jStat.slice(A, {
                                row: i
                            }), c);
                            jStat.sliceAssign(A, {
                                row: j
                            }, jStat.add(Aj, cAi));
                            var Ij = jStat.slice(I, {
                                row: j
                            });
                            var cIi = jStat.multiply(jStat.slice(I, {
                                row: i
                            }), c);
                            jStat.sliceAssign(I, {
                                row: j
                            }, jStat.add(Ij, cIi));
                        });
                    });
                    return I;
                }
                function qr_solve(A, b) {
                    var array_mode = false;
                    if (b[0].length === undefined) {
                        // [c1,c2,c3] mode
                        b = b.map(function(x) {
                            return [
                                x
                            ];
                        });
                        array_mode = true;
                    }
                    var QR = jStat.QR(A);
                    var Q = QR[0];
                    var R = QR[1];
                    var attrs = A[0].length;
                    var Q1 = jStat.slice(Q, {
                        col: {
                            end: attrs
                        }
                    });
                    var R1 = jStat.slice(R, {
                        row: {
                            end: attrs
                        }
                    });
                    var RI = R_I(R1);
                    var Q2 = jStat.transpose(Q1);
                    if (Q2[0].length === undefined) Q2 = [
                        Q2
                    ]; // The confusing jStat.multifly implementation threat nature process again.
                    var x = jStat.multiply(jStat.multiply(RI, Q2), b);
                    if (x.length === undefined) x = [
                        [
                            x
                        ]
                    ]; // The confusing jStat.multifly implementation threat nature process again.
                    if (array_mode) return x.map(function(i) {
                        return i[0];
                    });
                    return x;
                }
                return qr_solve;
            }(),
            jacobi: function jacobi(a) {
                var condition = 1;
                var n = a.length;
                var e = jStat.identity(n, n);
                var ev = [];
                var b, i, j, p, q, maxim, theta, s;
                // condition === 1 only if tolerance is not reached
                while(condition === 1){
                    maxim = a[0][1];
                    p = 0;
                    q = 1;
                    for(i = 0; i < n; i++)for(j = 0; j < n; j++){
                        if (i != j) {
                            if (maxim < Math1.abs(a[i][j])) {
                                maxim = Math1.abs(a[i][j]);
                                p = i;
                                q = j;
                            }
                        }
                    }
                    if (a[p][p] === a[q][q]) theta = a[p][q] > 0 ? Math1.PI / 4 : -Math1.PI / 4;
                    else theta = Math1.atan(2 * a[p][q] / (a[p][p] - a[q][q])) / 2;
                    s = jStat.identity(n, n);
                    s[p][p] = Math1.cos(theta);
                    s[p][q] = -Math1.sin(theta);
                    s[q][p] = Math1.sin(theta);
                    s[q][q] = Math1.cos(theta);
                    // eigen vector matrix
                    e = jStat.multiply(e, s);
                    b = jStat.multiply(jStat.multiply(jStat.inv(s), a), s);
                    a = b;
                    condition = 0;
                    for(i = 1; i < n; i++){
                        for(j = 1; j < n; j++)if (i != j && Math1.abs(a[i][j]) > 0.001) condition = 1;
                    }
                }
                for(i = 0; i < n; i++)ev.push(a[i][i]);
                //returns both the eigenvalue and eigenmatrix
                return [
                    e,
                    ev
                ];
            },
            rungekutta: function rungekutta(f, h, p, t_j, u_j, order) {
                var k1, k2, u_j1, k3, k4;
                if (order === 2) while(t_j <= p){
                    k1 = h * f(t_j, u_j);
                    k2 = h * f(t_j + h, u_j + k1);
                    u_j1 = u_j + (k1 + k2) / 2;
                    u_j = u_j1;
                    t_j = t_j + h;
                }
                if (order === 4) while(t_j <= p){
                    k1 = h * f(t_j, u_j);
                    k2 = h * f(t_j + h / 2, u_j + k1 / 2);
                    k3 = h * f(t_j + h / 2, u_j + k2 / 2);
                    k4 = h * f(t_j + h, u_j + k3);
                    u_j1 = u_j + (k1 + 2 * k2 + 2 * k3 + k4) / 6;
                    u_j = u_j1;
                    t_j = t_j + h;
                }
                return u_j;
            },
            romberg: function romberg(f, a, b, order) {
                var i = 0;
                var h = (b - a) / 2;
                var x = [];
                var h1 = [];
                var g = [];
                var m, a1, j, k, I;
                while(i < order / 2){
                    I = f(a);
                    for(j = a, k = 0; j <= b; j = j + h, k++)x[k] = j;
                    m = x.length;
                    for(j = 1; j < m - 1; j++)I += (j % 2 !== 0 ? 4 : 2) * f(x[j]);
                    I = h / 3 * (I + f(b));
                    g[i] = I;
                    h /= 2;
                    i++;
                }
                a1 = g.length;
                m = 1;
                while(a1 !== 1){
                    for(j = 0; j < a1 - 1; j++)h1[j] = (Math1.pow(4, m) * g[j + 1] - g[j]) / (Math1.pow(4, m) - 1);
                    a1 = h1.length;
                    g = h1;
                    h1 = [];
                    m++;
                }
                return g;
            },
            richardson: function richardson(X, f, x, h) {
                function pos(X, x) {
                    var i = 0;
                    var n = X.length;
                    var p;
                    for(; i < n; i++)if (X[i] === x) p = i;
                    return p;
                }
                var h_min = Math1.abs(x - X[pos(X, x) + 1]);
                var i = 0;
                var g = [];
                var h1 = [];
                var y1, y2, m, a, j;
                while(h >= h_min){
                    y1 = pos(X, x + h);
                    y2 = pos(X, x);
                    g[i] = (f[y1] - 2 * f[y2] + f[2 * y2 - y1]) / (h * h);
                    h /= 2;
                    i++;
                }
                a = g.length;
                m = 1;
                while(a != 1){
                    for(j = 0; j < a - 1; j++)h1[j] = (Math1.pow(4, m) * g[j + 1] - g[j]) / (Math1.pow(4, m) - 1);
                    a = h1.length;
                    g = h1;
                    h1 = [];
                    m++;
                }
                return g;
            },
            simpson: function simpson(f, a, b, n) {
                var h = (b - a) / n;
                var I = f(a);
                var x = [];
                var j = a;
                var k = 0;
                var i = 1;
                var m;
                for(; j <= b; j = j + h, k++)x[k] = j;
                m = x.length;
                for(; i < m - 1; i++)I += (i % 2 !== 0 ? 4 : 2) * f(x[i]);
                return h / 3 * (I + f(b));
            },
            hermite: function hermite(X, F, dF, value) {
                var n = X.length;
                var p = 0;
                var i = 0;
                var l = [];
                var dl = [];
                var A = [];
                var B = [];
                var j;
                for(; i < n; i++){
                    l[i] = 1;
                    for(j = 0; j < n; j++)if (i != j) l[i] *= (value - X[j]) / (X[i] - X[j]);
                    dl[i] = 0;
                    for(j = 0; j < n; j++)if (i != j) dl[i] += 1 / (X[i] - X[j]);
                    A[i] = (1 - 2 * (value - X[i]) * dl[i]) * (l[i] * l[i]);
                    B[i] = (value - X[i]) * (l[i] * l[i]);
                    p += A[i] * F[i] + B[i] * dF[i];
                }
                return p;
            },
            lagrange: function lagrange(X, F, value) {
                var p = 0;
                var i = 0;
                var j, l;
                var n = X.length;
                for(; i < n; i++){
                    l = F[i];
                    for(j = 0; j < n; j++)// calculating the lagrange polynomial L_i
                    if (i != j) l *= (value - X[j]) / (X[i] - X[j]);
                    // adding the lagrange polynomials found above
                    p += l;
                }
                return p;
            },
            cubic_spline: function cubic_spline(X, F, value) {
                var n = X.length;
                var i = 0, j;
                var A = [];
                var B = [];
                var alpha = [];
                var c = [];
                var h = [];
                var b = [];
                var d = [];
                for(; i < n - 1; i++)h[i] = X[i + 1] - X[i];
                alpha[0] = 0;
                for(i = 1; i < n - 1; i++)alpha[i] = 3 / h[i] * (F[i + 1] - F[i]) - 3 / h[i - 1] * (F[i] - F[i - 1]);
                for(i = 1; i < n - 1; i++){
                    A[i] = [];
                    B[i] = [];
                    A[i][i - 1] = h[i - 1];
                    A[i][i] = 2 * (h[i - 1] + h[i]);
                    A[i][i + 1] = h[i];
                    B[i][0] = alpha[i];
                }
                c = jStat.multiply(jStat.inv(A), B);
                for(j = 0; j < n - 1; j++){
                    b[j] = (F[j + 1] - F[j]) / h[j] - h[j] * (c[j + 1][0] + 2 * c[j][0]) / 3;
                    d[j] = (c[j + 1][0] - c[j][0]) / (3 * h[j]);
                }
                for(j = 0; j < n; j++){
                    if (X[j] > value) break;
                }
                j -= 1;
                return F[j] + (value - X[j]) * b[j] + jStat.sq(value - X[j]) * c[j] + (value - X[j]) * jStat.sq(value - X[j]) * d[j];
            },
            gauss_quadrature: function gauss_quadrature() {
                throw new Error("gauss_quadrature not yet implemented");
            },
            PCA: function PCA(X) {
                var m = X.length;
                var n = X[0].length;
                var i = 0;
                var j, temp1;
                var u = [];
                var D = [];
                var result = [];
                var temp2 = [];
                var Y = [];
                var Bt = [];
                var B = [];
                var C = [];
                var V = [];
                var Vt = [];
                for(i = 0; i < m; i++)u[i] = jStat.sum(X[i]) / n;
                for(i = 0; i < n; i++){
                    B[i] = [];
                    for(j = 0; j < m; j++)B[i][j] = X[j][i] - u[j];
                }
                B = jStat.transpose(B);
                for(i = 0; i < m; i++){
                    C[i] = [];
                    for(j = 0; j < m; j++)C[i][j] = jStat.dot([
                        B[i]
                    ], [
                        B[j]
                    ]) / (n - 1);
                }
                result = jStat.jacobi(C);
                V = result[0];
                D = result[1];
                Vt = jStat.transpose(V);
                for(i = 0; i < D.length; i++){
                    for(j = i; j < D.length; j++)if (D[i] < D[j]) {
                        temp1 = D[i];
                        D[i] = D[j];
                        D[j] = temp1;
                        temp2 = Vt[i];
                        Vt[i] = Vt[j];
                        Vt[j] = temp2;
                    }
                }
                Bt = jStat.transpose(B);
                for(i = 0; i < m; i++){
                    Y[i] = [];
                    for(j = 0; j < Bt.length; j++)Y[i][j] = jStat.dot([
                        Vt[i]
                    ], [
                        Bt[j]
                    ]);
                }
                return [
                    X,
                    D,
                    Vt,
                    Y
                ];
            }
        });
        // extend jStat.fn with methods that require one argument
        (function(funcs) {
            for(var i = 0; i < funcs.length; i++)(function(passfunc) {
                jStat.fn[passfunc] = function(arg, func) {
                    var tmpthis = this;
                    // check for callback
                    if (func) {
                        setTimeout(function() {
                            func.call(tmpthis, jStat.fn[passfunc].call(tmpthis, arg));
                        }, 15);
                        return this;
                    }
                    if (typeof jStat[passfunc](this, arg) === "number") return jStat[passfunc](this, arg);
                    else return jStat(jStat[passfunc](this, arg));
                };
            })(funcs[i]);
        })("add divide multiply subtract dot pow exp log abs norm angle".split(" "));
    })(jStat, Math);
    (function(jStat, Math1) {
        var slice = [].slice;
        var isNumber = jStat.utils.isNumber;
        var isArray = jStat.utils.isArray;
        // flag==true denotes use of sample standard deviation
        // Z Statistics
        jStat.extend({
            // 2 different parameter lists:
            // (value, mean, sd)
            // (value, array, flag)
            zscore: function zscore() {
                var args = slice.call(arguments);
                if (isNumber(args[1])) return (args[0] - args[1]) / args[2];
                return (args[0] - jStat.mean(args[1])) / jStat.stdev(args[1], args[2]);
            },
            // 3 different paramter lists:
            // (value, mean, sd, sides)
            // (zscore, sides)
            // (value, array, sides, flag)
            ztest: function ztest() {
                var args = slice.call(arguments);
                var z;
                if (isArray(args[1])) {
                    // (value, array, sides, flag)
                    z = jStat.zscore(args[0], args[1], args[3]);
                    return args[2] === 1 ? jStat.normal.cdf(-Math1.abs(z), 0, 1) : jStat.normal.cdf(-Math1.abs(z), 0, 1) * 2;
                } else if (args.length > 2) {
                    // (value, mean, sd, sides)
                    z = jStat.zscore(args[0], args[1], args[2]);
                    return args[3] === 1 ? jStat.normal.cdf(-Math1.abs(z), 0, 1) : jStat.normal.cdf(-Math1.abs(z), 0, 1) * 2;
                } else {
                    // (zscore, sides)
                    z = args[0];
                    return args[1] === 1 ? jStat.normal.cdf(-Math1.abs(z), 0, 1) : jStat.normal.cdf(-Math1.abs(z), 0, 1) * 2;
                }
            }
        });
        jStat.extend(jStat.fn, {
            zscore: function zscore(value, flag) {
                return (value - this.mean()) / this.stdev(flag);
            },
            ztest: function ztest(value, sides, flag) {
                var zscore = Math1.abs(this.zscore(value, flag));
                return sides === 1 ? jStat.normal.cdf(-zscore, 0, 1) : jStat.normal.cdf(-zscore, 0, 1) * 2;
            }
        });
        // T Statistics
        jStat.extend({
            // 2 parameter lists
            // (value, mean, sd, n)
            // (value, array)
            tscore: function tscore() {
                var args = slice.call(arguments);
                return args.length === 4 ? (args[0] - args[1]) / (args[2] / Math1.sqrt(args[3])) : (args[0] - jStat.mean(args[1])) / (jStat.stdev(args[1], true) / Math1.sqrt(args[1].length));
            },
            // 3 different paramter lists:
            // (value, mean, sd, n, sides)
            // (tscore, n, sides)
            // (value, array, sides)
            ttest: function ttest() {
                var args = slice.call(arguments);
                var tscore;
                if (args.length === 5) {
                    tscore = Math1.abs(jStat.tscore(args[0], args[1], args[2], args[3]));
                    return args[4] === 1 ? jStat.studentt.cdf(-tscore, args[3] - 1) : jStat.studentt.cdf(-tscore, args[3] - 1) * 2;
                }
                if (isNumber(args[1])) {
                    tscore = Math1.abs(args[0]);
                    return args[2] == 1 ? jStat.studentt.cdf(-tscore, args[1] - 1) : jStat.studentt.cdf(-tscore, args[1] - 1) * 2;
                }
                tscore = Math1.abs(jStat.tscore(args[0], args[1]));
                return args[2] == 1 ? jStat.studentt.cdf(-tscore, args[1].length - 1) : jStat.studentt.cdf(-tscore, args[1].length - 1) * 2;
            }
        });
        jStat.extend(jStat.fn, {
            tscore: function tscore(value) {
                return (value - this.mean()) / (this.stdev(true) / Math1.sqrt(this.cols()));
            },
            ttest: function ttest(value, sides) {
                return sides === 1 ? 1 - jStat.studentt.cdf(Math1.abs(this.tscore(value)), this.cols() - 1) : jStat.studentt.cdf(-Math1.abs(this.tscore(value)), this.cols() - 1) * 2;
            }
        });
        // F Statistics
        jStat.extend({
            // Paramter list is as follows:
            // (array1, array2, array3, ...)
            // or it is an array of arrays
            // array of arrays conversion
            anovafscore: function anovafscore() {
                var args = slice.call(arguments), expVar, sample, sampMean, sampSampMean, tmpargs, unexpVar, i, j;
                if (args.length === 1) {
                    tmpargs = new Array(args[0].length);
                    for(i = 0; i < args[0].length; i++)tmpargs[i] = args[0][i];
                    args = tmpargs;
                }
                // Builds sample array
                sample = new Array();
                for(i = 0; i < args.length; i++)sample = sample.concat(args[i]);
                sampMean = jStat.mean(sample);
                // Computes the explained variance
                expVar = 0;
                for(i = 0; i < args.length; i++)expVar = expVar + args[i].length * Math1.pow(jStat.mean(args[i]) - sampMean, 2);
                expVar /= args.length - 1;
                // Computes unexplained variance
                unexpVar = 0;
                for(i = 0; i < args.length; i++){
                    sampSampMean = jStat.mean(args[i]);
                    for(j = 0; j < args[i].length; j++)unexpVar += Math1.pow(args[i][j] - sampSampMean, 2);
                }
                unexpVar /= sample.length - args.length;
                return expVar / unexpVar;
            },
            // 2 different paramter setups
            // (array1, array2, array3, ...)
            // (anovafscore, df1, df2)
            anovaftest: function anovaftest() {
                var args = slice.call(arguments), df1, df2, n, i;
                if (isNumber(args[0])) return 1 - jStat.centralF.cdf(args[0], args[1], args[2]);
                var anovafscore = jStat.anovafscore(args);
                df1 = args.length - 1;
                n = 0;
                for(i = 0; i < args.length; i++)n = n + args[i].length;
                df2 = n - df1 - 1;
                return 1 - jStat.centralF.cdf(anovafscore, df1, df2);
            },
            ftest: function ftest(fscore, df1, df2) {
                return 1 - jStat.centralF.cdf(fscore, df1, df2);
            }
        });
        jStat.extend(jStat.fn, {
            anovafscore: function anovafscore() {
                return jStat.anovafscore(this.toArray());
            },
            anovaftes: function anovaftes() {
                var n = 0;
                var i;
                for(i = 0; i < this.length; i++)n = n + this[i].length;
                return jStat.ftest(this.anovafscore(), this.length - 1, n - this.length);
            }
        });
        // Tukey's range test
        jStat.extend({
            // 2 parameter lists
            // (mean1, mean2, n1, n2, sd)
            // (array1, array2, sd)
            qscore: function qscore() {
                var args = slice.call(arguments);
                var mean1, mean2, n1, n2, sd;
                if (isNumber(args[0])) {
                    mean1 = args[0];
                    mean2 = args[1];
                    n1 = args[2];
                    n2 = args[3];
                    sd = args[4];
                } else {
                    mean1 = jStat.mean(args[0]);
                    mean2 = jStat.mean(args[1]);
                    n1 = args[0].length;
                    n2 = args[1].length;
                    sd = args[2];
                }
                return Math1.abs(mean1 - mean2) / (sd * Math1.sqrt((1 / n1 + 1 / n2) / 2));
            },
            // 3 different parameter lists:
            // (qscore, n, k)
            // (mean1, mean2, n1, n2, sd, n, k)
            // (array1, array2, sd, n, k)
            qtest: function qtest() {
                var args = slice.call(arguments);
                var qscore;
                if (args.length === 3) {
                    qscore = args[0];
                    args = args.slice(1);
                } else if (args.length === 7) {
                    qscore = jStat.qscore(args[0], args[1], args[2], args[3], args[4]);
                    args = args.slice(5);
                } else {
                    qscore = jStat.qscore(args[0], args[1], args[2]);
                    args = args.slice(3);
                }
                var n = args[0];
                var k = args[1];
                return 1 - jStat.tukey.cdf(qscore, k, n - k);
            },
            tukeyhsd: function tukeyhsd(arrays) {
                var sd = jStat.pooledstdev(arrays);
                var means = arrays.map(function(arr) {
                    return jStat.mean(arr);
                });
                var n = arrays.reduce(function(n, arr) {
                    return n + arr.length;
                }, 0);
                var results = [];
                for(var i = 0; i < arrays.length; ++i)for(var j = i + 1; j < arrays.length; ++j){
                    var p = jStat.qtest(means[i], means[j], arrays[i].length, arrays[j].length, sd, n, arrays.length);
                    results.push([
                        [
                            i,
                            j
                        ],
                        p
                    ]);
                }
                return results;
            }
        });
        // Error Bounds
        jStat.extend({
            // 2 different parameter setups
            // (value, alpha, sd, n)
            // (value, alpha, array)
            normalci: function normalci() {
                var args = slice.call(arguments), ans = new Array(2), change;
                if (args.length === 4) change = Math1.abs(jStat.normal.inv(args[1] / 2, 0, 1) * args[2] / Math1.sqrt(args[3]));
                else change = Math1.abs(jStat.normal.inv(args[1] / 2, 0, 1) * jStat.stdev(args[2]) / Math1.sqrt(args[2].length));
                ans[0] = args[0] - change;
                ans[1] = args[0] + change;
                return ans;
            },
            // 2 different parameter setups
            // (value, alpha, sd, n)
            // (value, alpha, array)
            tci: function tci() {
                var args = slice.call(arguments), ans = new Array(2), change;
                if (args.length === 4) change = Math1.abs(jStat.studentt.inv(args[1] / 2, args[3] - 1) * args[2] / Math1.sqrt(args[3]));
                else change = Math1.abs(jStat.studentt.inv(args[1] / 2, args[2].length - 1) * jStat.stdev(args[2], true) / Math1.sqrt(args[2].length));
                ans[0] = args[0] - change;
                ans[1] = args[0] + change;
                return ans;
            },
            significant: function significant(pvalue, alpha) {
                return pvalue < alpha;
            }
        });
        jStat.extend(jStat.fn, {
            normalci: function normalci(value, alpha) {
                return jStat.normalci(value, alpha, this.toArray());
            },
            tci: function tci(value, alpha) {
                return jStat.tci(value, alpha, this.toArray());
            }
        });
        // internal method for calculating the z-score for a difference of proportions test
        function differenceOfProportions(p1, n1, p2, n2) {
            if (p1 > 1 || p2 > 1 || p1 <= 0 || p2 <= 0) throw new Error("Proportions should be greater than 0 and less than 1");
            var pooled = (p1 * n1 + p2 * n2) / (n1 + n2);
            var se = Math1.sqrt(pooled * (1 - pooled) * (1 / n1 + 1 / n2));
            return (p1 - p2) / se;
        }
        // Difference of Proportions
        jStat.extend(jStat.fn, {
            oneSidedDifferenceOfProportions: function oneSidedDifferenceOfProportions(p1, n1, p2, n2) {
                var z = differenceOfProportions(p1, n1, p2, n2);
                return jStat.ztest(z, 1);
            },
            twoSidedDifferenceOfProportions: function twoSidedDifferenceOfProportions(p1, n1, p2, n2) {
                var z = differenceOfProportions(p1, n1, p2, n2);
                return jStat.ztest(z, 2);
            }
        });
    })(jStat, Math);
    jStat.models = function() {
        function sub_regress(exog) {
            var var_count = exog[0].length;
            var modelList = jStat.arange(var_count).map(function(endog_index) {
                var exog_index = jStat.arange(var_count).filter(function(i) {
                    return i !== endog_index;
                });
                return ols(jStat.col(exog, endog_index).map(function(x) {
                    return x[0];
                }), jStat.col(exog, exog_index));
            });
            return modelList;
        }
        // do OLS model regress
        // exog have include const columns ,it will not generate it .In fact, exog is
        // "design matrix" look at
        //https://en.wikipedia.org/wiki/Design_matrix
        function ols(endog, exog) {
            var nobs = endog.length;
            var df_model = exog[0].length - 1;
            var df_resid = nobs - df_model - 1;
            var coef = jStat.lstsq(exog, endog);
            var predict = jStat.multiply(exog, coef.map(function(x) {
                return [
                    x
                ];
            })).map(function(p) {
                return p[0];
            });
            var resid = jStat.subtract(endog, predict);
            var ybar = jStat.mean(endog);
            // constant cause problem
            // var SST = jStat.sum(endog.map(function(y) {
            //   return Math.pow(y-ybar,2);
            // }));
            var SSE = jStat.sum(predict.map(function(f) {
                return Math.pow(f - ybar, 2);
            }));
            var SSR = jStat.sum(endog.map(function(y, i) {
                return Math.pow(y - predict[i], 2);
            }));
            var SST = SSE + SSR;
            var R2 = SSE / SST;
            return {
                exog: exog,
                endog: endog,
                nobs: nobs,
                df_model: df_model,
                df_resid: df_resid,
                coef: coef,
                predict: predict,
                resid: resid,
                ybar: ybar,
                SST: SST,
                SSE: SSE,
                SSR: SSR,
                R2: R2
            };
        }
        // H0: b_I=0
        // H1: b_I!=0
        function t_test(model) {
            var subModelList = sub_regress(model.exog);
            //var sigmaHat=jStat.stdev(model.resid);
            var sigmaHat = Math.sqrt(model.SSR / model.df_resid);
            var seBetaHat = subModelList.map(function(mod) {
                var SST = mod.SST;
                var R2 = mod.R2;
                return sigmaHat / Math.sqrt(SST * (1 - R2));
            });
            var tStatistic = model.coef.map(function(coef, i) {
                return (coef - 0) / seBetaHat[i];
            });
            var pValue = tStatistic.map(function(t) {
                var leftppf = jStat.studentt.cdf(t, model.df_resid);
                return (leftppf > 0.5 ? 1 - leftppf : leftppf) * 2;
            });
            var c = jStat.studentt.inv(0.975, model.df_resid);
            var interval95 = model.coef.map(function(coef, i) {
                var d = c * seBetaHat[i];
                return [
                    coef - d,
                    coef + d
                ];
            });
            return {
                se: seBetaHat,
                t: tStatistic,
                p: pValue,
                sigmaHat: sigmaHat,
                interval95: interval95
            };
        }
        function F_test(model) {
            var F_statistic = model.R2 / model.df_model / ((1 - model.R2) / model.df_resid);
            var fcdf = function(x, n1, n2) {
                return jStat.beta.cdf(x / (n2 / n1 + x), n1 / 2, n2 / 2);
            };
            var pvalue = 1 - fcdf(F_statistic, model.df_model, model.df_resid);
            return {
                F_statistic: F_statistic,
                pvalue: pvalue
            };
        }
        function ols_wrap(endog, exog) {
            var model = ols(endog, exog);
            var ttest = t_test(model);
            var ftest = F_test(model);
            // Provide the Wherry / Ezekiel / McNemar / Cohen Adjusted R^2
            // Which matches the 'adjusted R^2' provided by R's lm package
            var adjust_R2 = 1 - (1 - model.R2) * ((model.nobs - 1) / model.df_resid);
            model.t = ttest;
            model.f = ftest;
            model.adjust_R2 = adjust_R2;
            return model;
        }
        return {
            ols: ols_wrap
        };
    }();
    //To regress, simply build X matrix
    //(append column of 1's) using
    //buildxmatrix and build the Y
    //matrix using buildymatrix
    //(simply the transpose)
    //and run regress.
    //Regressions
    jStat.extend({
        buildxmatrix: function buildxmatrix() {
            //Parameters will be passed in as such
            //(array1,array2,array3,...)
            //as (x1,x2,x3,...)
            //needs to be (1,x1,x2,x3,...)
            var matrixRows = new Array(arguments.length);
            for(var i = 0; i < arguments.length; i++){
                var array = [
                    1
                ];
                matrixRows[i] = array.concat(arguments[i]);
            }
            return jStat(matrixRows);
        },
        builddxmatrix: function builddxmatrix() {
            //Paramters will be passed in as such
            //([array1,array2,...]
            var matrixRows = new Array(arguments[0].length);
            for(var i = 0; i < arguments[0].length; i++){
                var array = [
                    1
                ];
                matrixRows[i] = array.concat(arguments[0][i]);
            }
            return jStat(matrixRows);
        },
        buildjxmatrix: function buildjxmatrix(jMat) {
            //Builds from jStat Matrix
            var pass = new Array(jMat.length);
            for(var i = 0; i < jMat.length; i++)pass[i] = jMat[i];
            return jStat.builddxmatrix(pass);
        },
        buildymatrix: function buildymatrix(array) {
            return jStat(array).transpose();
        },
        buildjymatrix: function buildjymatrix(jMat) {
            return jMat.transpose();
        },
        matrixmult: function matrixmult(A, B) {
            var i, j, k, result, sum;
            if (A.cols() == B.rows()) {
                if (B.rows() > 1) {
                    result = [];
                    for(i = 0; i < A.rows(); i++){
                        result[i] = [];
                        for(j = 0; j < B.cols(); j++){
                            sum = 0;
                            for(k = 0; k < A.cols(); k++)sum += A.toArray()[i][k] * B.toArray()[k][j];
                            result[i][j] = sum;
                        }
                    }
                    return jStat(result);
                }
                result = [];
                for(i = 0; i < A.rows(); i++){
                    result[i] = [];
                    for(j = 0; j < B.cols(); j++){
                        sum = 0;
                        for(k = 0; k < A.cols(); k++)sum += A.toArray()[i][k] * B.toArray()[j];
                        result[i][j] = sum;
                    }
                }
                return jStat(result);
            }
        },
        //regress and regresst to be fixed
        regress: function regress(jMatX, jMatY) {
            //print("regressin!");
            //print(jMatX.toArray());
            var innerinv = jStat.xtranspxinv(jMatX);
            //print(innerinv);
            var xtransp = jMatX.transpose();
            var next = jStat.matrixmult(jStat(innerinv), xtransp);
            return jStat.matrixmult(next, jMatY);
        },
        regresst: function regresst(jMatX, jMatY, sides) {
            var beta = jStat.regress(jMatX, jMatY);
            var compile = {};
            compile.anova = {};
            var jMatYBar = jStat.jMatYBar(jMatX, beta);
            compile.yBar = jMatYBar;
            var yAverage = jMatY.mean();
            compile.anova.residuals = jStat.residuals(jMatY, jMatYBar);
            compile.anova.ssr = jStat.ssr(jMatYBar, yAverage);
            compile.anova.msr = compile.anova.ssr / (jMatX[0].length - 1);
            compile.anova.sse = jStat.sse(jMatY, jMatYBar);
            compile.anova.mse = compile.anova.sse / (jMatY.length - (jMatX[0].length - 1) - 1);
            compile.anova.sst = jStat.sst(jMatY, yAverage);
            compile.anova.mst = compile.anova.sst / (jMatY.length - 1);
            compile.anova.r2 = 1 - compile.anova.sse / compile.anova.sst;
            if (compile.anova.r2 < 0) compile.anova.r2 = 0;
            compile.anova.fratio = compile.anova.msr / compile.anova.mse;
            compile.anova.pvalue = jStat.anovaftest(compile.anova.fratio, jMatX[0].length - 1, jMatY.length - (jMatX[0].length - 1) - 1);
            compile.anova.rmse = Math.sqrt(compile.anova.mse);
            compile.anova.r2adj = 1 - compile.anova.mse / compile.anova.mst;
            if (compile.anova.r2adj < 0) compile.anova.r2adj = 0;
            compile.stats = new Array(jMatX[0].length);
            var covar = jStat.xtranspxinv(jMatX);
            var sds, ts, ps;
            for(var i = 0; i < beta.length; i++){
                sds = Math.sqrt(compile.anova.mse * Math.abs(covar[i][i]));
                ts = Math.abs(beta[i] / sds);
                ps = jStat.ttest(ts, jMatY.length - jMatX[0].length - 1, sides);
                compile.stats[i] = [
                    beta[i],
                    sds,
                    ts,
                    ps
                ];
            }
            compile.regress = beta;
            return compile;
        },
        xtranspx: function xtranspx(jMatX) {
            return jStat.matrixmult(jMatX.transpose(), jMatX);
        },
        xtranspxinv: function xtranspxinv(jMatX) {
            var inner = jStat.matrixmult(jMatX.transpose(), jMatX);
            var innerinv = jStat.inv(inner);
            return innerinv;
        },
        jMatYBar: function jMatYBar(jMatX, beta) {
            var yBar = jStat.matrixmult(jMatX, beta);
            return new jStat(yBar);
        },
        residuals: function residuals(jMatY, jMatYBar) {
            return jStat.matrixsubtract(jMatY, jMatYBar);
        },
        ssr: function ssr(jMatYBar, yAverage) {
            var ssr = 0;
            for(var i = 0; i < jMatYBar.length; i++)ssr += Math.pow(jMatYBar[i] - yAverage, 2);
            return ssr;
        },
        sse: function sse(jMatY, jMatYBar) {
            var sse = 0;
            for(var i = 0; i < jMatY.length; i++)sse += Math.pow(jMatY[i] - jMatYBar[i], 2);
            return sse;
        },
        sst: function sst(jMatY, yAverage) {
            var sst = 0;
            for(var i = 0; i < jMatY.length; i++)sst += Math.pow(jMatY[i] - yAverage, 2);
            return sst;
        },
        matrixsubtract: function matrixsubtract(A, B) {
            var ans = new Array(A.length);
            for(var i = 0; i < A.length; i++){
                ans[i] = new Array(A[i].length);
                for(var j = 0; j < A[i].length; j++)ans[i][j] = A[i][j] - B[i][j];
            }
            return jStat(ans);
        }
    });
    // Make it compatible with previous version.
    jStat.jStat = jStat;
    return jStat;
});


var $dd1d3e43b4086c4d$require$jStat = $03fab2938eebb631$exports.jStat;

var $f1q41 = parcelRequire("f1q41");

var $fPryk = parcelRequire("fPryk");
var $dd1d3e43b4086c4d$require$profileMap = $fPryk.profileMap;
var $dd1d3e43b4086c4d$require$spaceUnitMap = $fPryk.spaceUnitMap;
var $dd1d3e43b4086c4d$require$suggestedCustomAmenityUnitMap = $fPryk.suggestedCustomAmenityUnitMap;

const { CATEGORY: $dd1d3e43b4086c4d$var$CATEGORY, CIRCULATION_TYPE: $dd1d3e43b4086c4d$var$CIRCULATION_TYPE, CATEGORY: $dd1d3e43b4086c4d$var$SPACE_UNIT_CATEGORY, STANDARD_CIRCULATION_MAP: $dd1d3e43b4086c4d$var$STANDARD_CIRCULATION_MAP, HIGH_CIRCULATION_MAP: $dd1d3e43b4086c4d$var$HIGH_CIRCULATION_MAP, COUNTRIES_CIRCULATION_MAP: $dd1d3e43b4086c4d$var$COUNTRIES_CIRCULATION_MAP } = (parcelRequire("aB89e")).shared.spaceUnit;

const $dd1d3e43b4086c4d$var$PROFILE_TYPE = (parcelRequire("aB89e")).spacerFree.calculator;

var $hjiT0 = parcelRequire("hjiT0");

var $jJqAQ = parcelRequire("jJqAQ");
// *************************************
//  Local Constants
// *************************************
// Maps spaceUnitIds to alternate functions to calculate quantity of units
// Currently only alternates are for support spaces
// NOTE: spaceUnits 21, 22, and 23 have duplicate versions for APAC KOPWMs; the duplicates don't use alternate quantity functions
const $dd1d3e43b4086c4d$var$alternateQuantityFunction = {
    21: function fileRoomQuantity({ expectedDailyHeadcount: expectedDailyHeadcount, multiplier: multiplier }) {
        return Math.round(expectedDailyHeadcount / multiplier);
    },
    22: function threeDrawerLateralFileQuantity({ headcount: headcount, multiplier: multiplier }) {
        return Math.round(headcount * multiplier);
    },
    23: function lockersQuantity({ headcount: headcount, sharingPopulation: sharingPopulation, multiplier: multiplier }) {
        return Math.round(sharingPopulation * headcount * multiplier);
    },
    30: function internalStairQuantity({ headcount: headcount }) {
        const estimatedSfPerPerson = 150;
        const estimatedSfPerFloor = 20000;
        return Math.floor(headcount * estimatedSfPerPerson / estimatedSfPerFloor);
    }
};
// *************************************
// *************************************
//  Metrics Calculations
// *************************************
// "Planning Population" is the portion of the headcount we expect to be in the office on a given day 95% of the time.
function $dd1d3e43b4086c4d$var$calculatePlanningPopulation(daysPerWeekInOffice) {
    const showupRate = daysPerWeekInOffice / 5;
    if (showupRate === 1) return 1;
    // *************************************************
    const standardDeviation = 0.08; // TODO -- Marked in spread sheet as an input, where does this come from
    const variance = standardDeviation ** 2;
    const alpha = ((1 - showupRate) / variance - 1 / showupRate) * showupRate ** 2;
    const beta = alpha * (1 / showupRate - 1);
    return $dd1d3e43b4086c4d$require$jStat.beta.inv(0.95, alpha, beta);
}
// "Sharing Population" is the portion of the headcount not assigned an individual seat
function $dd1d3e43b4086c4d$var$calculateSharingPopulation(daysPerWeekInOffice, profileType) {
    let threshold;
    if (profileType === $dd1d3e43b4086c4d$var$PROFILE_TYPE.UK_REGULAR || profileType === $dd1d3e43b4086c4d$var$PROFILE_TYPE.GERMANY_REGULAR || profileType === $dd1d3e43b4086c4d$var$PROFILE_TYPE.APAC_REGULAR || profileType === $dd1d3e43b4086c4d$var$PROFILE_TYPE.SPAIN_REGULAR || profileType === $dd1d3e43b4086c4d$var$PROFILE_TYPE.FRANCE_REGULAR || profileType === $dd1d3e43b4086c4d$var$PROFILE_TYPE.SLOVAKIA_REGULAR || profileType === $dd1d3e43b4086c4d$var$PROFILE_TYPE.POLAND_REGULAR || profileType === $dd1d3e43b4086c4d$var$PROFILE_TYPE.HUNGARY_REGULAR || profileType === $dd1d3e43b4086c4d$var$PROFILE_TYPE.COLOMBIA_REGULAR || profileType === $dd1d3e43b4086c4d$var$PROFILE_TYPE.NETHERLAND_REGULAR) threshold = 4;
    else threshold = 3.5;
    return daysPerWeekInOffice > threshold ? 0 : 1;
}
// "Workshare" is the number of work seats ("me seats") per member of the planning population.
// Currently always 1, but could be more complex in the future.
function $dd1d3e43b4086c4d$var$calculateWorkshare() {
    return 1;
}
// *************************************
// *************************************
//  Seat Count Calculations
// *************************************
// Workseats are used to determine me space quantities
// Non-sharing headcount gets one seat + 5% vacancy for moves, adds, and changes (for regular_US/UK)
function $dd1d3e43b4086c4d$var$calculateWorkSeats(headcount, expectedDailyHeadcount, sharingPopulation, workshare, profileType) {
    const nonSharingMultiplier = profileType !== $dd1d3e43b4086c4d$var$PROFILE_TYPE.US_SMALL ? 1.05 : 1;
    const nonSharingHeadcountSeats = (1 - sharingPopulation) * headcount * nonSharingMultiplier;
    const sharingHeadcountSeats = workshare * sharingPopulation * expectedDailyHeadcount;
    const typeBasedHeadcountBump = profileType === $dd1d3e43b4086c4d$var$PROFILE_TYPE.US_SMALL ? Math.ceil(headcount * 0.05) : 0;
    return Math.round(nonSharingHeadcountSeats + sharingHeadcountSeats + typeBasedHeadcountBump);
}
function $dd1d3e43b4086c4d$var$calculateGroupSeats(expectedDailyHeadcount, groupshare) {
    return Math.round(expectedDailyHeadcount * groupshare);
}
// *************************************
// *************************************
//  Square Foot Calculations
// *************************************
function $dd1d3e43b4086c4d$var$calculateCustomAmenitySF(customAmenity) {
    // NOTE: although we call these custom "amenities", we don't calculate NSF and USF as such, we use the "standard program part" calculation with an "amenity" type
    const { nsf: nsf, usf: usf } = $jJqAQ.calculateMeSharedFocusWeSupportProgramPartNSFAndUSF({
        // the quantity and SF are always "custom"
        quantity: customAmenity.customQuantity,
        unitSF: customAmenity.customSF,
        // since customAmentities don't have a corresponding space unit, just pass in AMENITY circulation type
        unitCircType: $dd1d3e43b4086c4d$var$CIRCULATION_TYPE.AMENITY
    });
    customAmenity.customNSF = nsf;
    customAmenity.customUSF = usf;
}
function $dd1d3e43b4086c4d$var$getLargestNumInArrayIndex(array) {
    return array.indexOf(Math.max.apply(Math, array));
}
function $dd1d3e43b4086c4d$var$roundPercentageTotals(numArr) {
    var total = numArr[0] + numArr[1] + numArr[2];
    var num1Percent = Math.round(numArr[0] / total * 100);
    var num2Percent = Math.round(numArr[1] / total * 100);
    var num3Percent = Math.round(numArr[2] / total * 100);
    var totalPercentage = num1Percent + num2Percent + num3Percent;
    if (totalPercentage != 100) {
        var index = $dd1d3e43b4086c4d$var$getLargestNumInArrayIndex(numArr);
        numArr[index] = numArr[index] - (totalPercentage - 100);
        return $dd1d3e43b4086c4d$var$roundPercentageTotals(numArr);
    }
    return {
        me: num1Percent + "%",
        we: num2Percent + "%",
        amenity: num3Percent + "%"
    };
}
// *************************************
// *************************************
//  Program Part Calculations
// *************************************
function $dd1d3e43b4086c4d$var$getCirculationTypeFromProgramPart(part) {
    return $dd1d3e43b4086c4d$require$spaceUnitMap[part.spaceUnitId].circulationType;
}
// for non-APAC programs and programs without customCirculationMap, the circulation percentage for BLENDED program parts is based on area
// totals of ENCLOSED and OPEN program parts
// note that ME and WE program parts have circulation types of either ENCLOSED or OPEN, and SUPPORT program parts may or may not have BLENDED circulation
// in order for BLENDED program parts to include circulation area, the following function needs to be called
//   - when an existing program is loaded
//   - during initial program calculation, after ME and WE program parts are calculated but before SUPPORT program parts are calculated
//   - after a ME or WE program parts get updated
function $dd1d3e43b4086c4d$var$calculateAndSetBlendedCirculationPercentage(program, updateBlendedSpaces, officeDensity, officeLocation) {
    let blendedCircPercentage = 0;
    // Calculate blended circulation percentage
    if (program) {
        const meAndWeProgramSpaces = [
            ...program[$dd1d3e43b4086c4d$var$SPACE_UNIT_CATEGORY.ME],
            ...program[$dd1d3e43b4086c4d$var$SPACE_UNIT_CATEGORY.WE]
        ];
        if (meAndWeProgramSpaces.length) {
            const nsfTotals = {
                [$dd1d3e43b4086c4d$var$CIRCULATION_TYPE.ENCLOSED]: 0,
                [$dd1d3e43b4086c4d$var$CIRCULATION_TYPE.OPEN]: 0
            };
            meAndWeProgramSpaces.forEach((part)=>{
                const circulationType = $dd1d3e43b4086c4d$var$getCirculationTypeFromProgramPart(part);
                nsfTotals[circulationType] += part.customNSF || part.nsf;
            });
            let enclosed = null;
            let open = null;
            const { country: country } = $hjiT0.getCityStateCountry(officeLocation);
            let high_circulation_map, standard_circulation_map;
            const circulation_map = $dd1d3e43b4086c4d$var$COUNTRIES_CIRCULATION_MAP[country];
            if (circulation_map) {
                high_circulation_map = circulation_map["HIGH_CIRCULATION_MAP"];
                standard_circulation_map = circulation_map["STANDARD_CIRCULATION_MAP"];
            } else {
                high_circulation_map = $dd1d3e43b4086c4d$var$HIGH_CIRCULATION_MAP;
                standard_circulation_map = $dd1d3e43b4086c4d$var$STANDARD_CIRCULATION_MAP;
            }
            if (officeDensity === 2) {
                enclosed = nsfTotals[$dd1d3e43b4086c4d$var$CIRCULATION_TYPE.ENCLOSED] * high_circulation_map[$dd1d3e43b4086c4d$var$CIRCULATION_TYPE.ENCLOSED];
                open = nsfTotals[$dd1d3e43b4086c4d$var$CIRCULATION_TYPE.OPEN] * high_circulation_map[$dd1d3e43b4086c4d$var$CIRCULATION_TYPE.OPEN];
            } else {
                enclosed = nsfTotals[$dd1d3e43b4086c4d$var$CIRCULATION_TYPE.ENCLOSED] * standard_circulation_map[$dd1d3e43b4086c4d$var$CIRCULATION_TYPE.ENCLOSED];
                open = nsfTotals[$dd1d3e43b4086c4d$var$CIRCULATION_TYPE.OPEN] * standard_circulation_map[$dd1d3e43b4086c4d$var$CIRCULATION_TYPE.OPEN];
            }
            const totalNSF = nsfTotals[$dd1d3e43b4086c4d$var$CIRCULATION_TYPE.ENCLOSED] + nsfTotals[$dd1d3e43b4086c4d$var$CIRCULATION_TYPE.OPEN];
            blendedCircPercentage = (enclosed + open) / totalNSF;
        }
    }
    // Set blended circulation percentage on local programMetrics
    $jJqAQ.updateProgramMetrics({
        blendedCircPercentage: blendedCircPercentage
    });
    // If requested, update existing BLENDED spaces
    // NOTE: all BLENDED spaces are in the SUPPORT category, but not all SUPPORT spaces are BLENDED
    if (updateBlendedSpaces) {
        const supportSpaces = program[$dd1d3e43b4086c4d$var$SPACE_UNIT_CATEGORY.SUPPORT];
        if (supportSpaces && supportSpaces.length) supportSpaces.forEach((progPart)=>{
            const circulationType = $dd1d3e43b4086c4d$var$getCirculationTypeFromProgramPart(progPart);
            if (circulationType === $dd1d3e43b4086c4d$var$CIRCULATION_TYPE.BLENDED) {
                const nsfToUseForUSFCalc = progPart.customNSF || progPart.nsf;
                const updatedUSF = $jJqAQ.calculateUSF(nsfToUseForUSFCalc, circulationType);
                if (progPart.customNSF) progPart.customUSF = updatedUSF;
                else progPart.usf = updatedUSF;
            }
        });
    }
}
function $dd1d3e43b4086c4d$var$updateBlendedCircAfterProgramPartUpdate(partCategory, program, officeDensity, officeLocation) {
    if (partCategory === $dd1d3e43b4086c4d$var$SPACE_UNIT_CATEGORY.ME || partCategory === $dd1d3e43b4086c4d$var$SPACE_UNIT_CATEGORY.WE) $dd1d3e43b4086c4d$var$calculateAndSetBlendedCirculationPercentage(program, true, officeDensity, officeLocation);
}
function $dd1d3e43b4086c4d$var$calculateMeProgramPart(partWithMultiplier) {
    const spaceUnit = $dd1d3e43b4086c4d$require$spaceUnitMap[partWithMultiplier.spaceUnitId];
    const programPart = $jJqAQ.calculateMeProgramPart({
        multiplier: partWithMultiplier.multiplier,
        unitSF: spaceUnit.sf,
        unitCircType: spaceUnit.circulationType
    });
    programPart.spaceUnitId = partWithMultiplier.spaceUnitId;
    return programPart;
}
function $dd1d3e43b4086c4d$var$calculateWeProgramPart(partWithMultiplier, groupSeats, profileType) {
    const spaceUnit = $dd1d3e43b4086c4d$require$spaceUnitMap[partWithMultiplier.spaceUnitId];
    const roundUpUnitIds = {
        [$dd1d3e43b4086c4d$var$PROFILE_TYPE.US_SMALL]: [
            "6",
            "7",
            "8",
            "9",
            "13",
            "14"
        ]
    };
    let programPart;
    if (roundUpUnitIds[profileType] && $f1q41.includes(roundUpUnitIds[profileType], partWithMultiplier.spaceUnitId)) {
        const quantity = Math.ceil(partWithMultiplier.multiplier * groupSeats / spaceUnit.seats);
        const { nsf: nsf, usf: usf } = $jJqAQ.calculateMeSharedFocusWeSupportProgramPartNSFAndUSF({
            quantity: quantity,
            unitSF: spaceUnit.sf,
            unitCircType: spaceUnit.circulationType
        });
        programPart = {
            quantity: quantity,
            nsf: nsf,
            usf: usf
        };
    } else programPart = $jJqAQ.calculateWeProgramPart({
        multiplier: partWithMultiplier.multiplier,
        unitSeats: spaceUnit.seats,
        unitSF: spaceUnit.sf,
        unitCircType: spaceUnit.circulationType
    });
    programPart.spaceUnitId = partWithMultiplier.spaceUnitId;
    return programPart;
}
function $dd1d3e43b4086c4d$var$calculateAmenityProgramPart(partWithMultiplier) {
    const spaceUnit = $dd1d3e43b4086c4d$require$spaceUnitMap[partWithMultiplier.spaceUnitId];
    const programPart = $jJqAQ.calculateAmenityProgramPart({
        multiplier: partWithMultiplier.multiplier,
        unitSF: spaceUnit.sf,
        unitCircType: spaceUnit.circulationType,
        unitMinSF: spaceUnit.minSF,
        unitMaxSF: spaceUnit.maxSF
    });
    programPart.spaceUnitId = partWithMultiplier.spaceUnitId;
    return programPart;
}
function $dd1d3e43b4086c4d$var$calculateSupportProgramPart(partWithMultiplier, headcount, expectedDailyHeadcount, sharingPopulation) {
    const spaceUnit = $dd1d3e43b4086c4d$require$spaceUnitMap[partWithMultiplier.spaceUnitId];
    let programPart;
    if ($dd1d3e43b4086c4d$var$alternateQuantityFunction[partWithMultiplier.spaceUnitId]) {
        const quantity = $dd1d3e43b4086c4d$var$alternateQuantityFunction[partWithMultiplier.spaceUnitId]({
            headcount: headcount,
            expectedDailyHeadcount: expectedDailyHeadcount,
            sharingPopulation: sharingPopulation,
            multiplier: partWithMultiplier.multiplier
        });
        const { usf: usf, nsf: nsf } = $jJqAQ.calculateMeSharedFocusWeSupportProgramPartNSFAndUSF({
            quantity: quantity,
            unitSF: spaceUnit.sf,
            unitCircType: spaceUnit.circulationType
        });
        programPart = {
            quantity: quantity,
            nsf: nsf,
            usf: usf
        };
    } else programPart = $jJqAQ.calculateSupportProgramPart({
        multiplier: partWithMultiplier.multiplier,
        unitSF: spaceUnit.sf,
        unitCircType: spaceUnit.circulationType
    });
    programPart.spaceUnitId = partWithMultiplier.spaceUnitId;
    return programPart;
}
function $dd1d3e43b4086c4d$var$calculateCustomAmenityProgramPart(dataKey) {
    const suggestedAmenitySpaceUnit = $f1q41.find($dd1d3e43b4086c4d$require$suggestedCustomAmenityUnitMap, [
        "dataKey",
        dataKey
    ]);
    if (!suggestedAmenitySpaceUnit) return null;
    const { quantity: quantity, nsf: nsf, usf: usf } = $jJqAQ.calculateAmenityProgramPart({
        multiplier: suggestedAmenitySpaceUnit.multiplier,
        unitSF: suggestedAmenitySpaceUnit.sf,
        unitCircType: suggestedAmenitySpaceUnit.circulationType,
        unitMinSF: suggestedAmenitySpaceUnit.minSF,
        unitMaxSF: suggestedAmenitySpaceUnit.maxSF
    });
    return {
        dataKey: dataKey,
        displayName: suggestedAmenitySpaceUnit.displayName,
        quantity: 0,
        nsf: 0,
        usf: 0,
        customQuantity: quantity,
        customSF: nsf,
        customNSF: nsf,
        customUSF: usf,
        displayUnit: suggestedAmenitySpaceUnit.displayUnit
    };
}
// *************************************
// *************************************
//  Program Space Totals Calculations
// *************************************
function $dd1d3e43b4086c4d$var$updateProgramWithSFTotals(program) {
    program.areaTotals = $jJqAQ.calculateCategoryUSFTotals({
        meSpaces: program[$dd1d3e43b4086c4d$var$CATEGORY.ME],
        weSpaces: program[$dd1d3e43b4086c4d$var$CATEGORY.WE],
        amenitySpaces: [
            ...program[$dd1d3e43b4086c4d$var$CATEGORY.SUPPORT],
            ...program[$dd1d3e43b4086c4d$var$CATEGORY.AMENITY],
            ...program[$dd1d3e43b4086c4d$var$CATEGORY.CUSTOM_AMENITY]
        ]
    });
    let areaTotals = program.areaTotals;
    let obj = {
        meSF: areaTotals.totalCustomMeSF ? areaTotals.totalCustomMeSF : areaTotals.totalMeSF,
        weSF: areaTotals.totalCustomWeSF ? areaTotals.totalCustomWeSF : areaTotals.totalWeSF,
        amenitySF: areaTotals.totalCustomAmenitySF ? areaTotals.totalCustomAmenitySF : areaTotals.totalAmenitySF
    };
    program.areaPercentage = $dd1d3e43b4086c4d$var$roundPercentageTotals([
        obj.meSF,
        obj.weSF,
        obj.amenitySF
    ]);
}
// *************************************
// *************************************
//  Program Final Stats Calculations
// *************************************
function $dd1d3e43b4086c4d$var$updateProgramWithFinalStats(program, headcount) {
    let spaceUnit;
    // Calculate actualWorkSeatTotal by summing total OPEN and ENCLOSED quantities
    // actualWorkSeatTotal might differ from program.metrics.workSeats (the original, recommended number of work seats)
    // this discepency might be due to
    //   - rounding errors
    //   - user customization
    let openTotal = 0;
    let enclosedTotal = 0;
    program[$dd1d3e43b4086c4d$var$CATEGORY.ME].forEach((space)=>{
        spaceUnit = $dd1d3e43b4086c4d$require$spaceUnitMap[space.spaceUnitId];
        if (spaceUnit.circulationType === $dd1d3e43b4086c4d$var$CIRCULATION_TYPE.OPEN) openTotal += space.customQuantity || space.quantity;
        else if (spaceUnit.circulationType === $dd1d3e43b4086c4d$var$CIRCULATION_TYPE.ENCLOSED) enclosedTotal += space.customQuantity || space.quantity;
    });
    const actualWorkSeatTotal = openTotal + enclosedTotal;
    // Count validCollabSeats (total seats in enclosed WE spaces with max 18 seats)
    let validCollabSeats = 0;
    program[$dd1d3e43b4086c4d$var$CATEGORY.WE].forEach((space)=>{
        spaceUnit = $dd1d3e43b4086c4d$require$spaceUnitMap[space.spaceUnitId];
        if (spaceUnit.circulationType === $dd1d3e43b4086c4d$var$CIRCULATION_TYPE.ENCLOSED && spaceUnit.seats <= 18) validCollabSeats += (space.customQuantity || space.quantity) * spaceUnit.seats;
    });
    program.finalStats = {
        collabSeatRatio: validCollabSeats / actualWorkSeatTotal,
        openPercentage: openTotal / actualWorkSeatTotal,
        sharingRatio: actualWorkSeatTotal / headcount,
        usfPerSeat: (program.areaTotals.totalCustomSF || program.areaTotals.totalSF) / actualWorkSeatTotal
    };
}
// *************************************
// *************************************
//  Shared Program Calculator Init
// *************************************
function $dd1d3e43b4086c4d$var$initSharedProgramCalculator(program, headcount, officeLocation, officeDensity) {
    // Initialize sharedProgramCalculator module
    $jJqAQ.init({
        officeLocation: officeLocation,
        getCirculationTypeFromProgramPart: (part)=>$dd1d3e43b4086c4d$var$getCirculationTypeFromProgramPart(part),
        headcount: headcount * program.metrics.planningPopulation,
        workSeats: program.metrics.workSeats,
        groupSeats: program.metrics.groupSeats,
        officeDensity: officeDensity
    });
}
// *************************************
// *************************************
//  Final Program Calculation
// *************************************
function $dd1d3e43b4086c4d$var$calculateProgram(profileId, profileType, { headcount: headcount, collaboration: collaboration, daysPerWeekInOffice: daysPerWeekInOffice, officeDensity: officeDensity }, customAmenitiesAdded = [], officeLocation) {
    // Define program structure
    const program = {
        [$dd1d3e43b4086c4d$var$CATEGORY.ME]: [],
        [$dd1d3e43b4086c4d$var$CATEGORY.WE]: [],
        [$dd1d3e43b4086c4d$var$CATEGORY.SUPPORT]: [],
        [$dd1d3e43b4086c4d$var$CATEGORY.AMENITY]: [],
        [$dd1d3e43b4086c4d$var$CATEGORY.CUSTOM_AMENITY]: [],
        finalStats: {},
        metrics: {}
    };
    // Get profile-related information
    const profile = $dd1d3e43b4086c4d$require$profileMap[profileId];
    const { me: me, we: we, support: support, amenity: amenity } = profile.kitOfPartsWithMultipliers[profileType];
    // Calculate metrics
    const planningPopulation = $dd1d3e43b4086c4d$var$calculatePlanningPopulation(daysPerWeekInOffice);
    const sharingPopulation = $dd1d3e43b4086c4d$var$calculateSharingPopulation(daysPerWeekInOffice, profileType);
    const expectedDailyHeadcount = headcount * planningPopulation;
    const workshare = $dd1d3e43b4086c4d$var$calculateWorkshare();
    const groupshare = profile.collaborationLevels[profileType][collaboration]; // "we seats" per member of planning population
    const workSeats = $dd1d3e43b4086c4d$var$calculateWorkSeats(headcount, expectedDailyHeadcount, sharingPopulation, workshare, profileType);
    const groupSeats = $dd1d3e43b4086c4d$var$calculateGroupSeats(expectedDailyHeadcount, groupshare);
    program.metrics = {
        planningPopulation: planningPopulation,
        sharingPopulation: sharingPopulation,
        workshare: workshare,
        groupshare: groupshare,
        workSeats: workSeats,
        groupSeats: groupSeats
    };
    // Initialize sharedProgramCalculator module
    $dd1d3e43b4086c4d$var$initSharedProgramCalculator(program, headcount, officeLocation, officeDensity);
    // Iterate through each cateogry in KOPWM to calculate and add program part
    let programPart;
    me.forEach((partWithMultiplier)=>{
        programPart = $dd1d3e43b4086c4d$var$calculateMeProgramPart(partWithMultiplier);
        program[$dd1d3e43b4086c4d$var$CATEGORY.ME].push(programPart);
    });
    we.forEach((partWithMultiplier)=>{
        programPart = $dd1d3e43b4086c4d$var$calculateWeProgramPart(partWithMultiplier, groupSeats, profileType);
        program[$dd1d3e43b4086c4d$var$CATEGORY.WE].push(programPart);
    });
    $dd1d3e43b4086c4d$var$calculateAndSetBlendedCirculationPercentage(program, null, officeDensity, officeLocation);
    amenity.forEach((partWithMultiplier)=>{
        programPart = $dd1d3e43b4086c4d$var$calculateAmenityProgramPart(partWithMultiplier);
        program[$dd1d3e43b4086c4d$var$CATEGORY.AMENITY].push(programPart);
    });
    support.forEach((partWithMultiplier)=>{
        programPart = $dd1d3e43b4086c4d$var$calculateSupportProgramPart(partWithMultiplier, headcount, expectedDailyHeadcount, sharingPopulation);
        program[$dd1d3e43b4086c4d$var$CATEGORY.SUPPORT].push(programPart);
    });
    customAmenitiesAdded.forEach((custom)=>{
        programPart = $dd1d3e43b4086c4d$var$calculateCustomAmenityProgramPart(custom.dataKey);
        // update initial states for the custom ones that are added and come from the suggestion list
        if (programPart) {
            programPart.id = custom.id;
            program[$dd1d3e43b4086c4d$var$CATEGORY.CUSTOM_AMENITY].push(programPart);
        // just keep the ones the user made up exactly as they are
        } else program[$dd1d3e43b4086c4d$var$CATEGORY.CUSTOM_AMENITY].push(custom);
    });
    $dd1d3e43b4086c4d$var$updateProgramWithSFTotals(program);
    $dd1d3e43b4086c4d$var$updateProgramWithFinalStats(program, headcount);
    let areaTotals = program.areaTotals;
    program.areaPercentage = $dd1d3e43b4086c4d$var$roundPercentageTotals([
        areaTotals.totalMeSF,
        areaTotals.totalWeSF,
        areaTotals.totalAmenitySF
    ]);
    return program;
}
// *************************************
// *************************************
//  updateProgramCalculations
// *************************************
function $dd1d3e43b4086c4d$var$updateSFTotalsAndStats(spaceData) {
    $dd1d3e43b4086c4d$var$updateProgramWithSFTotals(spaceData.program);
    $dd1d3e43b4086c4d$var$updateProgramWithFinalStats(spaceData.program, spaceData.assumptions.headcount);
}
function $dd1d3e43b4086c4d$var$updateProgramForMeWeOrSupportCustomQuantity(spaceData, spaceUnitId, customQuantity, officeLocation) {
    const program = spaceData.program;
    const spaceUnit = $dd1d3e43b4086c4d$require$spaceUnitMap[spaceUnitId];
    const programPart = $f1q41.find(program[spaceUnit.category], {
        spaceUnitId: spaceUnitId
    });
    // Update the program part with new quantity, NSF, and USF
    const { nsf: nsf, usf: usf } = $jJqAQ.calculateMeSharedFocusWeSupportProgramPartNSFAndUSF({
        quantity: customQuantity,
        unitSF: spaceUnit.sf,
        unitCircType: spaceUnit.circulationType
    });
    programPart.customQuantity = customQuantity;
    programPart.customNSF = nsf;
    programPart.customUSF = usf;
    $dd1d3e43b4086c4d$var$updateBlendedCircAfterProgramPartUpdate(spaceUnit.category, program, spaceData.assumptions.officeDensity, officeLocation);
    $dd1d3e43b4086c4d$var$updateSFTotalsAndStats(spaceData);
}
function $dd1d3e43b4086c4d$var$updateProgramForAmenityCustomSF(spaceData, spaceUnitId, customSF) {
    const spaceUnit = $dd1d3e43b4086c4d$require$spaceUnitMap[spaceUnitId];
    const category = spaceUnit.category;
    // Update the program part with the custom SF
    // NOTE: we allow users to set a customSF that is outside of the spaceUnit's minSF/maxSF
    const programPart = $f1q41.find(spaceData.program[category], {
        spaceUnitId: spaceUnitId
    });
    programPart.customSF = customSF;
    programPart.customNSF = customSF;
    programPart.customUSF = $jJqAQ.calculateUSF(customSF, spaceUnit.circulationType);
    $dd1d3e43b4086c4d$var$updateSFTotalsAndStats(spaceData);
}
function $dd1d3e43b4086c4d$var$addCustomAmenity(spaceData, customAmenity) {
    // Update custom amenity with USF and NSF
    $dd1d3e43b4086c4d$var$calculateCustomAmenitySF(customAmenity);
    spaceData.program[$dd1d3e43b4086c4d$var$CATEGORY.CUSTOM_AMENITY].push(customAmenity);
    $dd1d3e43b4086c4d$var$updateSFTotalsAndStats(spaceData);
}
function $dd1d3e43b4086c4d$var$updateProgramForCustomAmenity(spaceData, id, updateProperties) {
    // Find the custom amenity
    const customAmenity = $f1q41.find(spaceData.program[$dd1d3e43b4086c4d$var$CATEGORY.CUSTOM_AMENITY], [
        "id",
        id
    ]);
    // Update with new properties
    Object.assign(customAmenity, updateProperties);
    // Update custom amenity with USF and NSF
    $dd1d3e43b4086c4d$var$calculateCustomAmenitySF(customAmenity);
    $dd1d3e43b4086c4d$var$updateSFTotalsAndStats(spaceData);
}
function $dd1d3e43b4086c4d$var$removeProgramPart(spaceData, idToRemove) {
    const spaceUnit = $dd1d3e43b4086c4d$require$spaceUnitMap[idToRemove];
    if (spaceUnit) $f1q41.remove(spaceData.program[spaceUnit.category], [
        "spaceUnitId",
        idToRemove
    ]);
    else $f1q41.remove(spaceData.program[$dd1d3e43b4086c4d$var$CATEGORY.CUSTOM_AMENITY], [
        "id",
        idToRemove
    ]);
    $dd1d3e43b4086c4d$var$updateSFTotalsAndStats(spaceData);
}
$dd1d3e43b4086c4d$exports = {
    calculateProgram: $dd1d3e43b4086c4d$var$calculateProgram,
    calculateCustomAmenityProgramPart: $dd1d3e43b4086c4d$var$calculateCustomAmenityProgramPart,
    updateProgramForMeWeOrSupportCustomQuantity: $dd1d3e43b4086c4d$var$updateProgramForMeWeOrSupportCustomQuantity,
    updateProgramForAmenityCustomSF: $dd1d3e43b4086c4d$var$updateProgramForAmenityCustomSF,
    updateProgramForCustomAmenity: $dd1d3e43b4086c4d$var$updateProgramForCustomAmenity,
    addCustomAmenity: $dd1d3e43b4086c4d$var$addCustomAmenity,
    removeProgramPart: $dd1d3e43b4086c4d$var$removeProgramPart,
    initSharedProgramCalculator: $dd1d3e43b4086c4d$var$initSharedProgramCalculator,
    roundPercentageTotals: $dd1d3e43b4086c4d$var$roundPercentageTotals
};


var $e3ec1f29f8e2ec07$exports = {};

var $f1q41 = parcelRequire("f1q41");

var $aB89e = parcelRequire("aB89e");
var $e3ec1f29f8e2ec07$require$constants = $aB89e.spacerFree;

var $fPryk = parcelRequire("fPryk");
var $e3ec1f29f8e2ec07$require$questionUnitMap = $fPryk.questionUnitMap;

var $hjiT0 = parcelRequire("hjiT0");
// The Profile Calculator takes a user's quiz as input, and outputs a sorted array with profile ids and percentage "match"
// example output: [[1, 0.8], [2, 0.5], [3, 0.1], ...]
function $e3ec1f29f8e2ec07$var$incrementProfileScores(profileScores, profileIds, points) {
    profileIds.forEach((profileId)=>{
        if (!profileScores[profileId]) profileScores[profileId] = 0;
        profileScores[profileId] += points;
    });
}
// PICK QUESTION:
// for the selected option, increment the associated profileIds by questionUnit.points
function $e3ec1f29f8e2ec07$var$addPickQuestionProfileScore(profileScores, selectedOptionId, questionUnit) {
    const selectedOption = questionUnit.options[selectedOptionId];
    $e3ec1f29f8e2ec07$var$incrementProfileScores(profileScores, selectedOption.profileIds, questionUnit.points);
}
// RANK QUESTION:
// for each ranked option, increment the associated profileIds by the value at questionUnit.points[indexOfRankedOption]
function $e3ec1f29f8e2ec07$var$addRankQuestionProfileScore(profileScores, rankedOptionIds, questionUnit) {
    let pointsForRank;
    let selectedOption;
    rankedOptionIds.forEach((rankedOptionId, index)=>{
        pointsForRank = questionUnit.points[index];
        selectedOption = questionUnit.options[rankedOptionId];
        $e3ec1f29f8e2ec07$var$incrementProfileScores(profileScores, selectedOption.profileIds, pointsForRank);
    });
}
function $e3ec1f29f8e2ec07$var$calculateProfileScores(userQuizAnswers) {
    const profileScores = {};
    let questionUnit;
    let userResponse;
    let totalQuizPoints = 0;
    // USER QUIZ -> PROFILE POINTS
    Object.keys(userQuizAnswers).forEach((questionUnitId)=>{
        questionUnit = $e3ec1f29f8e2ec07$require$questionUnitMap.getQuestionUnitById(questionUnitId);
        userResponse = userQuizAnswers[questionUnitId];
        totalQuizPoints += Array.isArray(questionUnit.points) ? $f1q41.sum(questionUnit.points) : questionUnit.points;
        switch(questionUnit.answerType){
            case $e3ec1f29f8e2ec07$require$constants.questionUnit.PROFILE_ANSWER_TYPE.PICK:
                $e3ec1f29f8e2ec07$var$addPickQuestionProfileScore(profileScores, userResponse, questionUnit);
                break;
            case $e3ec1f29f8e2ec07$require$constants.questionUnit.PROFILE_ANSWER_TYPE.RANK:
                $e3ec1f29f8e2ec07$var$addRankQuestionProfileScore(profileScores, userResponse, questionUnit);
                break;
            default:
                console.log("What is this mystery question?", questionUnit);
                break;
        }
    });
    // PROFILE POINTS -> PROFILE PERCENTAGES (out of total quiz points)
    Object.keys(profileScores).forEach((profileId)=>{
        profileScores[profileId] /= totalQuizPoints;
    });
    return profileScores;
}
function $e3ec1f29f8e2ec07$var$calculateProfileType(officeLocation, headcount, userQuizAnswers) {
    const { country: country } = $hjiT0.getCityStateCountry(officeLocation);
    if ($hjiT0.isGermany(country)) return $e3ec1f29f8e2ec07$require$constants.calculator.PROFILE_TYPE.GERMANY_REGULAR;
    if ($hjiT0.isSpain(country)) return $e3ec1f29f8e2ec07$require$constants.calculator.PROFILE_TYPE.SPAIN_REGULAR;
    if ($hjiT0.isFrance(country)) return $e3ec1f29f8e2ec07$require$constants.calculator.PROFILE_TYPE.FRANCE_REGULAR;
    if ($hjiT0.isSlovakia(country)) return $e3ec1f29f8e2ec07$require$constants.calculator.PROFILE_TYPE.SLOVAKIA_REGULAR;
    if ($hjiT0.isPoland(country)) return $e3ec1f29f8e2ec07$require$constants.calculator.PROFILE_TYPE.POLAND_REGULAR;
    if ($hjiT0.isHungary(country)) return $e3ec1f29f8e2ec07$require$constants.calculator.PROFILE_TYPE.HUNGARY_REGULAR;
    if ($hjiT0.isColombia(country)) return $e3ec1f29f8e2ec07$require$constants.calculator.PROFILE_TYPE.COLOMBIA_REGULAR;
    if ($hjiT0.isNetherland(country)) return $e3ec1f29f8e2ec07$require$constants.calculator.PROFILE_TYPE.NETHERLAND_REGULAR;
    // Currently the UK Profiles and KOPs are more accurate for all regions in EMEA, so we assign it if the country is any of these regions
    if ($hjiT0.isEMEA(country)) return $e3ec1f29f8e2ec07$require$constants.calculator.PROFILE_TYPE.UK_REGULAR;
    if ($hjiT0.isAPAC(country)) return $e3ec1f29f8e2ec07$require$constants.calculator.PROFILE_TYPE.APAC_REGULAR;
    // If we have a headcount of less than 60, and the user answers 'Besides space for work, what would you like to provide in your workspace?'
    // with one of the three answers involving basic offerings, the profile should be given the US_SMALL type
    const deterministicQuestionForUSSMallProfileType = 11;
    const validAnswersForUSSmallProfileType = [
        "1",
        "2",
        "3"
    ];
    if (headcount < 60 && $f1q41.includes(validAnswersForUSSmallProfileType, userQuizAnswers[deterministicQuestionForUSSMallProfileType])) return $e3ec1f29f8e2ec07$require$constants.calculator.PROFILE_TYPE.US_SMALL;
    return $e3ec1f29f8e2ec07$require$constants.calculator.PROFILE_TYPE.US_REGULAR;
}
$e3ec1f29f8e2ec07$exports = {
    calculateProfileScores: $e3ec1f29f8e2ec07$var$calculateProfileScores,
    calculateProfileType: $e3ec1f29f8e2ec07$var$calculateProfileType
};


var $7f3ddf5ab2cb44f3$exports = {};
// Action Types
const $7f3ddf5ab2cb44f3$var$SET_PROFILE_AND_CALCULATE_PROGRAM = "SET_PROFILE_AND_CALCULATE_PROGRAM";
const $7f3ddf5ab2cb44f3$var$ADD_KEY_ASSUMPTION = "ADD_KEY_ASSUMPTION";
const $7f3ddf5ab2cb44f3$var$UPDATE_KEY_ASSUMPTION = "UPDATE_KEY_ASSUMPTION";
const $7f3ddf5ab2cb44f3$var$UPDATE_MEASUREMENT_SYSTEM = "UPDATE_MEASUREMENT_SYSTEM";
const $7f3ddf5ab2cb44f3$var$UPDATE_SF_TYPE = "UPDATE_SF_TYPE";
const $7f3ddf5ab2cb44f3$var$UPDATE_LOSS_FACTOR = "UPDATE_LOSS_FACTOR";
const $7f3ddf5ab2cb44f3$var$UPDATE_SPACE_UNIT_QUANTITY = "UPDATE_SPACE_UNIT_QUANTITY";
const $7f3ddf5ab2cb44f3$var$UPDATE_SPACE_UNIT_AMENITY_SF = "UPDATE_SPACE_UNIT_AMENITY_SF";
const $7f3ddf5ab2cb44f3$var$ADD_CUSTOM_AMENITY = "ADD_CUSTOM_AMENITY";
const $7f3ddf5ab2cb44f3$var$UPDATE_CUSTOM_AMENITY_QUANTITY = "UPDATE_CUSTOM_AMENITY_QUANTITY";
const $7f3ddf5ab2cb44f3$var$UPDATE_CUSTOM_AMENITY_SF = "UPDATE_CUSTOM_AMENITY_SF";
const $7f3ddf5ab2cb44f3$var$DELETE_SPACE_UNIT = "DELETE_SPACE_UNIT";
const $7f3ddf5ab2cb44f3$var$SET_PROGRAM_ID = "SET_PROGRAM_ID";
$7f3ddf5ab2cb44f3$exports = {
    SET_PROFILE_AND_CALCULATE_PROGRAM: // Action Types
    $7f3ddf5ab2cb44f3$var$SET_PROFILE_AND_CALCULATE_PROGRAM,
    ADD_KEY_ASSUMPTION: $7f3ddf5ab2cb44f3$var$ADD_KEY_ASSUMPTION,
    UPDATE_KEY_ASSUMPTION: $7f3ddf5ab2cb44f3$var$UPDATE_KEY_ASSUMPTION,
    UPDATE_MEASUREMENT_SYSTEM: $7f3ddf5ab2cb44f3$var$UPDATE_MEASUREMENT_SYSTEM,
    UPDATE_SF_TYPE: $7f3ddf5ab2cb44f3$var$UPDATE_SF_TYPE,
    UPDATE_LOSS_FACTOR: $7f3ddf5ab2cb44f3$var$UPDATE_LOSS_FACTOR,
    UPDATE_SPACE_UNIT_QUANTITY: $7f3ddf5ab2cb44f3$var$UPDATE_SPACE_UNIT_QUANTITY,
    UPDATE_SPACE_UNIT_AMENITY_SF: $7f3ddf5ab2cb44f3$var$UPDATE_SPACE_UNIT_AMENITY_SF,
    ADD_CUSTOM_AMENITY: $7f3ddf5ab2cb44f3$var$ADD_CUSTOM_AMENITY,
    UPDATE_CUSTOM_AMENITY_QUANTITY: $7f3ddf5ab2cb44f3$var$UPDATE_CUSTOM_AMENITY_QUANTITY,
    UPDATE_CUSTOM_AMENITY_SF: $7f3ddf5ab2cb44f3$var$UPDATE_CUSTOM_AMENITY_SF,
    DELETE_SPACE_UNIT: $7f3ddf5ab2cb44f3$var$DELETE_SPACE_UNIT,
    SET_PROGRAM_ID: $7f3ddf5ab2cb44f3$var$SET_PROGRAM_ID,
    // Action Creators
    setProfileAndCalculateProgram (profileId) {
        return {
            type: $7f3ddf5ab2cb44f3$var$SET_PROFILE_AND_CALCULATE_PROGRAM,
            profileId: profileId
        };
    },
    addKeyAssumption (assumptionType, value) {
        return {
            type: $7f3ddf5ab2cb44f3$var$ADD_KEY_ASSUMPTION,
            assumptionType: assumptionType,
            value: value
        };
    },
    updateKeyAssumption (assumptionType, value) {
        return {
            type: $7f3ddf5ab2cb44f3$var$UPDATE_KEY_ASSUMPTION,
            assumptionType: assumptionType,
            value: value
        };
    },
    updateMeasurementSystem (measurementSystem) {
        return {
            type: $7f3ddf5ab2cb44f3$var$UPDATE_MEASUREMENT_SYSTEM,
            measurementSystem: measurementSystem
        };
    },
    updateSFType (sfType) {
        return {
            type: $7f3ddf5ab2cb44f3$var$UPDATE_SF_TYPE,
            sfType: sfType
        };
    },
    updateLossFactor (lossFactor) {
        return {
            type: $7f3ddf5ab2cb44f3$var$UPDATE_LOSS_FACTOR,
            lossFactor: lossFactor
        };
    },
    updateSpaceUnitQuantity (spaceUnitId, value, officeLocation) {
        return {
            type: $7f3ddf5ab2cb44f3$var$UPDATE_SPACE_UNIT_QUANTITY,
            spaceUnitId: spaceUnitId,
            value: value,
            officeLocation: officeLocation
        };
    },
    updateSpaceUnitAmenitySF (spaceUnitId, value) {
        return {
            type: $7f3ddf5ab2cb44f3$var$UPDATE_SPACE_UNIT_AMENITY_SF,
            spaceUnitId: spaceUnitId,
            value: value
        };
    },
    addCustomAmenity (displayName, customQuantity, customSF, dataKey) {
        return {
            type: $7f3ddf5ab2cb44f3$var$ADD_CUSTOM_AMENITY,
            displayName: displayName,
            customQuantity: customQuantity,
            customSF: customSF,
            dataKey: dataKey
        };
    },
    updateCustomAmenityQuantity (id, quantity) {
        return {
            type: $7f3ddf5ab2cb44f3$var$UPDATE_CUSTOM_AMENITY_QUANTITY,
            id: id,
            quantity: quantity
        };
    },
    updateCustomAmenitySF (id, customSF) {
        return {
            type: $7f3ddf5ab2cb44f3$var$UPDATE_CUSTOM_AMENITY_SF,
            id: id,
            customSF: customSF
        };
    },
    deleteSpaceUnit (id) {
        return {
            type: $7f3ddf5ab2cb44f3$var$DELETE_SPACE_UNIT,
            id: id
        };
    },
    setProgramId (id) {
        return {
            type: $7f3ddf5ab2cb44f3$var$SET_PROGRAM_ID,
            id: id
        };
    }
};


var $3a61343632c866bc$exports = {};
$3a61343632c866bc$exports = JSON.parse('{"categories":{"quiz":"Quiz","result":"Result","language":"language","referals":"referals"},"actions":{"startQuiz":"Take office space quiz","finishQuiz":"Finish Quiz","completeResultBtn":"View Complete Result","exportPDFBtn":"Export PDF","sendResultBtn":"Send Results","connectAdvisorFormSubmit":"Connect With an Advisor","saveChangesBtn":"Save Changes","requestPlanBtn":"Request a Plan","examplePlansBtn":"View Example Plan","referal":"referal","de":"Deutsch","en":"English (US)","en-GB":"English (UK)","svk":"Slovak","pol":"Polish","nld":"Dutch","col":"Spanish"},"labels":{"startQuiz":"Take office space quiz","finishQuiz":"Finish Quiz","completeResultBtn":"View Complete Result","exportPDFBtn":"Export PDF","sendResultBtn":"Send Results","connectAdvisorFormSubmit":"Connect With an Advisor","saveChangesBtn":"Save Changes","requestPlanBtn":"Request a Plan","examplePlansBtn":"View Example Plan","referal":"referal","de":"Deutsch","en":"English (US)","en-GB":"English (UK)","svk":"Slovak","pol":"Polish","nld":"Dutch","col":"Spanish"}}');



var $3GYAO = parcelRequire("3GYAO");
var $0c5169fa3c108ac2$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $lzNIT = parcelRequire("lzNIT");
var $aphAM = parcelRequire("aphAM");
var $0c5169fa3c108ac2$require$Route = $aphAM.Route;
var $0c5169fa3c108ac2$require$createBrowserRouter = $lzNIT.createBrowserRouter;
var $0c5169fa3c108ac2$require$createRoutesFromElements = $aphAM.createRoutesFromElements;
var $2f32009932987788$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $ayMG0 = parcelRequire("ayMG0");
var $ec1629433a563c92$exports = {};
var $ec1629433a563c92$var$__create = Object.create;
var $ec1629433a563c92$var$__defProp = Object.defineProperty;
var $ec1629433a563c92$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $ec1629433a563c92$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $ec1629433a563c92$var$__getProtoOf = Object.getPrototypeOf;
var $ec1629433a563c92$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $ec1629433a563c92$var$__export = (target, all)=>{
    for(var name in all)$ec1629433a563c92$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $ec1629433a563c92$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $ec1629433a563c92$var$__getOwnPropNames(from))if (!$ec1629433a563c92$var$__hasOwnProp.call(to, key) && key !== except) $ec1629433a563c92$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $ec1629433a563c92$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $ec1629433a563c92$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $ec1629433a563c92$var$__create($ec1629433a563c92$var$__getProtoOf(mod)) : {}, $ec1629433a563c92$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $ec1629433a563c92$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $ec1629433a563c92$var$__toCommonJS = (mod)=>$ec1629433a563c92$var$__copyProps($ec1629433a563c92$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $ec1629433a563c92$var$src_exports = {};
$ec1629433a563c92$var$__export($ec1629433a563c92$var$src_exports, {
    default: ()=>$ec1629433a563c92$var$src_default
});
$ec1629433a563c92$exports = $ec1629433a563c92$var$__toCommonJS($ec1629433a563c92$var$src_exports);

var $ec1629433a563c92$var$import_players = $ec1629433a563c92$var$__toESM((parcelRequire("6CC1t")));
var $3969e7022d3f77c7$exports = {};
var $3969e7022d3f77c7$var$__create = Object.create;
var $3969e7022d3f77c7$var$__defProp = Object.defineProperty;
var $3969e7022d3f77c7$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $3969e7022d3f77c7$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $3969e7022d3f77c7$var$__getProtoOf = Object.getPrototypeOf;
var $3969e7022d3f77c7$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $3969e7022d3f77c7$var$__defNormalProp = (obj, key, value)=>key in obj ? $3969e7022d3f77c7$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3969e7022d3f77c7$var$__export = (target, all)=>{
    for(var name in all)$3969e7022d3f77c7$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $3969e7022d3f77c7$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $3969e7022d3f77c7$var$__getOwnPropNames(from))if (!$3969e7022d3f77c7$var$__hasOwnProp.call(to, key) && key !== except) $3969e7022d3f77c7$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $3969e7022d3f77c7$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $3969e7022d3f77c7$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $3969e7022d3f77c7$var$__create($3969e7022d3f77c7$var$__getProtoOf(mod)) : {}, $3969e7022d3f77c7$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $3969e7022d3f77c7$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var $3969e7022d3f77c7$var$__toCommonJS = (mod)=>$3969e7022d3f77c7$var$__copyProps($3969e7022d3f77c7$var$__defProp({}, "__esModule", {
        value: true
    }), mod);
var $3969e7022d3f77c7$var$__publicField = (obj, key, value)=>{
    $3969e7022d3f77c7$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
var $3969e7022d3f77c7$var$ReactPlayer_exports = {};
$3969e7022d3f77c7$var$__export($3969e7022d3f77c7$var$ReactPlayer_exports, {
    createReactPlayer: ()=>$3969e7022d3f77c7$var$createReactPlayer
});
$3969e7022d3f77c7$exports = $3969e7022d3f77c7$var$__toCommonJS($3969e7022d3f77c7$var$ReactPlayer_exports);

var $3969e7022d3f77c7$var$import_react = $3969e7022d3f77c7$var$__toESM((parcelRequire("acw62")));

var $3969e7022d3f77c7$var$import_deepmerge = $3969e7022d3f77c7$var$__toESM((parcelRequire("bc5yV")));

var $3969e7022d3f77c7$var$import_memoize_one = $3969e7022d3f77c7$var$__toESM((parcelRequire("jk22o")));

var $3969e7022d3f77c7$var$import_react_fast_compare = $3969e7022d3f77c7$var$__toESM((parcelRequire("ai2Pb")));

var $fri5W = parcelRequire("fri5W");

var $eRsTE = parcelRequire("eRsTE");

var $3969e7022d3f77c7$var$import_Player = $3969e7022d3f77c7$var$__toESM((parcelRequire("lTdXI")));

const $3969e7022d3f77c7$var$Preview = (0, $eRsTE.lazy)(()=>(parcelRequire("7Iwfb")));
const $3969e7022d3f77c7$var$IS_BROWSER = typeof window !== "undefined" && window.document && typeof document !== "undefined";
const $3969e7022d3f77c7$var$IS_GLOBAL = typeof $parcel$global !== "undefined" && $parcel$global.window && $parcel$global.window.document;
const $3969e7022d3f77c7$var$SUPPORTED_PROPS = Object.keys($fri5W.propTypes);
const $3969e7022d3f77c7$var$UniversalSuspense = $3969e7022d3f77c7$var$IS_BROWSER || $3969e7022d3f77c7$var$IS_GLOBAL ? $3969e7022d3f77c7$var$import_react.Suspense : ()=>null;
const $3969e7022d3f77c7$var$customPlayers = [];
const $3969e7022d3f77c7$var$createReactPlayer = (players, fallback)=>{
    var _a;
    return _a = class extends $3969e7022d3f77c7$var$import_react.Component {
        constructor(){
            super(...arguments);
            $3969e7022d3f77c7$var$__publicField(this, "state", {
                showPreview: !!this.props.light
            });
            // Use references, as refs is used by React
            $3969e7022d3f77c7$var$__publicField(this, "references", {
                wrapper: (wrapper)=>{
                    this.wrapper = wrapper;
                },
                player: (player)=>{
                    this.player = player;
                }
            });
            $3969e7022d3f77c7$var$__publicField(this, "handleClickPreview", (e)=>{
                this.setState({
                    showPreview: false
                });
                this.props.onClickPreview(e);
            });
            $3969e7022d3f77c7$var$__publicField(this, "showPreview", ()=>{
                this.setState({
                    showPreview: true
                });
            });
            $3969e7022d3f77c7$var$__publicField(this, "getDuration", ()=>{
                if (!this.player) return null;
                return this.player.getDuration();
            });
            $3969e7022d3f77c7$var$__publicField(this, "getCurrentTime", ()=>{
                if (!this.player) return null;
                return this.player.getCurrentTime();
            });
            $3969e7022d3f77c7$var$__publicField(this, "getSecondsLoaded", ()=>{
                if (!this.player) return null;
                return this.player.getSecondsLoaded();
            });
            $3969e7022d3f77c7$var$__publicField(this, "getInternalPlayer", (key = "player")=>{
                if (!this.player) return null;
                return this.player.getInternalPlayer(key);
            });
            $3969e7022d3f77c7$var$__publicField(this, "seekTo", (fraction, type, keepPlaying)=>{
                if (!this.player) return null;
                this.player.seekTo(fraction, type, keepPlaying);
            });
            $3969e7022d3f77c7$var$__publicField(this, "handleReady", ()=>{
                this.props.onReady(this);
            });
            $3969e7022d3f77c7$var$__publicField(this, "getActivePlayer", (0, $3969e7022d3f77c7$var$import_memoize_one.default)((url)=>{
                for (const player of [
                    ...$3969e7022d3f77c7$var$customPlayers,
                    ...players
                ]){
                    if (player.canPlay(url)) return player;
                }
                if (fallback) return fallback;
                return null;
            }));
            $3969e7022d3f77c7$var$__publicField(this, "getConfig", (0, $3969e7022d3f77c7$var$import_memoize_one.default)((url, key)=>{
                const { config: config } = this.props;
                return $3969e7022d3f77c7$var$import_deepmerge.default.all([
                    $fri5W.defaultProps.config,
                    $fri5W.defaultProps.config[key] || {},
                    config,
                    config[key] || {}
                ]);
            }));
            $3969e7022d3f77c7$var$__publicField(this, "getAttributes", (0, $3969e7022d3f77c7$var$import_memoize_one.default)((url)=>{
                return (0, $eRsTE.omit)(this.props, $3969e7022d3f77c7$var$SUPPORTED_PROPS);
            }));
            $3969e7022d3f77c7$var$__publicField(this, "renderActivePlayer", (url)=>{
                if (!url) return null;
                const player = this.getActivePlayer(url);
                if (!player) return null;
                const config = this.getConfig(url, player.key);
                return /* @__PURE__ */ $3969e7022d3f77c7$var$import_react.default.createElement($3969e7022d3f77c7$var$import_Player.default, {
                    ...this.props,
                    key: player.key,
                    ref: this.references.player,
                    config: config,
                    activePlayer: player.lazyPlayer || player,
                    onReady: this.handleReady
                });
            });
        }
        shouldComponentUpdate(nextProps, nextState) {
            return !(0, $3969e7022d3f77c7$var$import_react_fast_compare.default)(this.props, nextProps) || !(0, $3969e7022d3f77c7$var$import_react_fast_compare.default)(this.state, nextState);
        }
        componentDidUpdate(prevProps) {
            const { light: light } = this.props;
            if (!prevProps.light && light) this.setState({
                showPreview: true
            });
            if (prevProps.light && !light) this.setState({
                showPreview: false
            });
        }
        renderPreview(url) {
            if (!url) return null;
            const { light: light, playIcon: playIcon, previewTabIndex: previewTabIndex, oEmbedUrl: oEmbedUrl, previewAriaLabel: previewAriaLabel } = this.props;
            return /* @__PURE__ */ $3969e7022d3f77c7$var$import_react.default.createElement($3969e7022d3f77c7$var$Preview, {
                url: url,
                light: light,
                playIcon: playIcon,
                previewTabIndex: previewTabIndex,
                previewAriaLabel: previewAriaLabel,
                oEmbedUrl: oEmbedUrl,
                onClick: this.handleClickPreview
            });
        }
        render() {
            const { url: url, style: style, width: width, height: height, fallback: fallback2, wrapper: Wrapper } = this.props;
            const { showPreview: showPreview } = this.state;
            const attributes = this.getAttributes(url);
            const wrapperRef = typeof Wrapper === "string" ? this.references.wrapper : void 0;
            return /* @__PURE__ */ $3969e7022d3f77c7$var$import_react.default.createElement(Wrapper, {
                ref: wrapperRef,
                style: {
                    ...style,
                    width: width,
                    height: height
                },
                ...attributes
            }, /* @__PURE__ */ $3969e7022d3f77c7$var$import_react.default.createElement($3969e7022d3f77c7$var$UniversalSuspense, {
                fallback: fallback2
            }, showPreview ? this.renderPreview(url) : this.renderActivePlayer(url)));
        }
    }, $3969e7022d3f77c7$var$__publicField(_a, "displayName", "ReactPlayer"), $3969e7022d3f77c7$var$__publicField(_a, "propTypes", $fri5W.propTypes), $3969e7022d3f77c7$var$__publicField(_a, "defaultProps", $fri5W.defaultProps), $3969e7022d3f77c7$var$__publicField(_a, "addCustomPlayer", (player)=>{
        $3969e7022d3f77c7$var$customPlayers.push(player);
    }), $3969e7022d3f77c7$var$__publicField(_a, "removeCustomPlayers", ()=>{
        $3969e7022d3f77c7$var$customPlayers.length = 0;
    }), $3969e7022d3f77c7$var$__publicField(_a, "canPlay", (url)=>{
        for (const Player2 of [
            ...$3969e7022d3f77c7$var$customPlayers,
            ...players
        ]){
            if (Player2.canPlay(url)) return true;
        }
        return false;
    }), $3969e7022d3f77c7$var$__publicField(_a, "canEnablePIP", (url)=>{
        for (const Player2 of [
            ...$3969e7022d3f77c7$var$customPlayers,
            ...players
        ]){
            if (Player2.canEnablePIP && Player2.canEnablePIP(url)) return true;
        }
        return false;
    }), _a;
};


const $ec1629433a563c92$var$fallback = $ec1629433a563c92$var$import_players.default[$ec1629433a563c92$var$import_players.default.length - 1];
var $ec1629433a563c92$var$src_default = (0, $3969e7022d3f77c7$exports.createReactPlayer)($ec1629433a563c92$var$import_players.default, $ec1629433a563c92$var$fallback);



var $acw62 = parcelRequire("acw62");
var $81e115b62a8073a8$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");
function $81e115b62a8073a8$var$HeroSection(props) {
    const colorClass = $8g1PZ({
        "is-primary": props.hasPrimaryBackground,
        "is-light-pale-green": !props.hasPrimaryBackground && props.isLightColor,
        // 'is-pale-green': !props.hasPrimaryBackground && !props.isLightColor,
        "is-pale-green-new": !props.hasPrimaryBackground && props.isPaleGreenNew,
        "is-light-gray": !props.hasPrimaryBackground && !props.isLightColor
    });
    const heroClasses = $8g1PZ(`hero-section hero ${props.classes} ${props.sizeClass} ${colorClass}`, {
        "has-navbar-fixed-top": props.addTopNavbarSpace
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: heroClasses,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "hero-body",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "container",
                children: props.children
            })
        })
    });
}
$81e115b62a8073a8$var$HeroSection.propTypes = {
    children: $c9Z8w.node.isRequired,
    classes: $c9Z8w.string,
    addTopNavbarSpace: $c9Z8w.bool,
    isLightColor: $c9Z8w.bool,
    sizeClass: $c9Z8w.string,
    hasPrimaryBackground: $c9Z8w.bool
};
$81e115b62a8073a8$var$HeroSection.defaultProps = {
    classes: "",
    addTopNavbarSpace: false,
    isLightColor: false,
    sizeClass: "is-medium",
    hasPrimaryBackground: false
};
$81e115b62a8073a8$exports = $81e115b62a8073a8$var$HeroSection;


function $13f86dec8236346a$var$VideoPlayer(props) {
    const [vedioUrl, setVedioUrl] = $acw62.useState("https://cbre.qumucloud.com/asset/3PUdjadpXsaYoJzXQApkB2.mp4?delivery=CDN_DOWNLOAD&format=canonical");
    const videos = [
        {
            url: "https://cbre.qumucloud.com/asset/3PUdjadpXsaYoJzXQApkB2.mp4?delivery=CDN_DOWNLOAD&format=canonical",
            thumb: "https://cbre.qumucloud.com/kulu/SKAhntaWNAGy84HoARNAaj/thumbnail",
            title: "Bij 88% van de organisaties werkt hybride werken niet"
        },
        {
            url: "https://cbre.qumucloud.com/asset/UbS5g1Dy1ujB8PE5afJdxA.mp4?delivery=CDN_DOWNLOAD&format=canonical",
            thumb: "https://cbre.qumucloud.com/kulu/RVsB4tZwJ5duAN04rfSwPZ/thumbnail",
            title: "Op maandag en vrijdag een leeg kantoor en op dinsdag en donderdag geen plek?"
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)($81e115b62a8073a8$exports, {
        sizeClass: "is-small",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "columns",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "column is-two-thirds",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ec1629433a563c92$exports))), {
                        url: vedioUrl,
                        controls: true,
                        width: "100%",
                        height: "100%"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "column is-one-third",
                    children: videos.map((vedio, index)=>{
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "columns level has-padding-bottom-6",
                            onClick: ()=>setVedioUrl(vedio.url),
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "column is-half",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: vedio.thumb,
                                        alt: "Thumbnail",
                                        className: "video-thumbnail"
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "column is-half",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "has-padding-left-6",
                                        children: vedio.title
                                    })
                                })
                            ]
                        }, index);
                    })
                })
            ]
        })
    });
}
var $13f86dec8236346a$export$2e2bcd8739ae039 = $13f86dec8236346a$var$VideoPlayer;


parcelRequire("acw62");
var $2fb84f33f8bbcebd$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $a30d198abc11571e$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $lzNIT = parcelRequire("lzNIT");
var $a30d198abc11571e$require$Link = $lzNIT.Link;

var $a30d198abc11571e$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;


var $3GYAO = parcelRequire("3GYAO");
function $a30d198abc11571e$var$TakeOfficeSpaceQuizButton(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a30d198abc11571e$require$Link, {
        to: "/quiz-spacer-by-cbre",
        onClick: ()=>{
            $3GYAO.GAEvent($3a61343632c866bc$exports.categories.quiz, $3a61343632c866bc$exports.actions.startQuiz, $3a61343632c866bc$exports.labels.startQuiz);
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "button cta-button is-primary-filled has-min-width-narrow heap-size-my-office-button",
            children: props.t("sizeMyOfficeButtonDefaultLinkText")
        })
    });
}
$a30d198abc11571e$var$TakeOfficeSpaceQuizButton.propTypes = {
    t: $c9Z8w.func.isRequired
};
$a30d198abc11571e$exports = $a30d198abc11571e$require$withTranslation("common")($a30d198abc11571e$var$TakeOfficeSpaceQuizButton);




var $2fb84f33f8bbcebd$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $2fb84f33f8bbcebd$var$LandingPageHero(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($81e115b62a8073a8$exports, {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "secondary-hero has-padding-left-1 has-padding-right-1 has-padding-left-6-mobile has-padding-right-6-mobile",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "columns level",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "column is-half is-hidden-desktop is-hidden-tablet",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("figure", {
                            className: "image is-4by3",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: "/png/homepage-results-page-in-browser-spacer-by-cbre.png",
                                alt: props.t("landingPageHeroImgAlt")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "column is-two-fifths level-item",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                    className: "title is-financier-regular is-size-4-mobile has-padding-bottom-4 has-text-primary",
                                    children: props.t("landingPageHeroTitle")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "subtitle is-size-6-mobile is-calibre has-text-grey-darker has-padding-top-4 has-padding-bottom-4",
                                    children: props.t("landingPageHeroSubtitle")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($a30d198abc11571e$exports, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "column has-padding-left-3 is-three-fifths is-hidden-mobile",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("figure", {
                            className: "image is-4by3",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: props.t("landingPageImage"),
                                alt: props.t("landingPageHeroImgAlt")
                            })
                        })
                    })
                ]
            })
        })
    });
}
$2fb84f33f8bbcebd$var$LandingPageHero.propTypes = {
    t: $c9Z8w.func.isRequired
};
$2fb84f33f8bbcebd$exports = $2fb84f33f8bbcebd$require$withTranslation("landingPage")($2fb84f33f8bbcebd$var$LandingPageHero);


var $c47f6775379e994e$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $d14f53020f68f99a$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $2678138d824ce508$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
function $2678138d824ce508$var$IllustrationWithText(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "has-padding-left-4 has-padding-right-4 has-padding-top-7 has-padding-bottom-7",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("figure", {
                className: "image",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: props.imgSrc,
                    alt: props.imgAlt
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("h3", {
                className: "has-margin-bottom-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "is-sans-semibold has-margin-bottom-7 has-margin-top-7 has-text-link",
                        children: props.subtitle
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "title2 is-4",
                        children: props.title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: props.text
            })
        ]
    });
}
$2678138d824ce508$var$IllustrationWithText.propTypes = {
    subtitle: $c9Z8w.string.isRequired,
    title: $c9Z8w.string.isRequired,
    text: $c9Z8w.string.isRequired,
    imgSrc: $c9Z8w.string.isRequired,
    imgAlt: $c9Z8w.string.isRequired
};
$2678138d824ce508$exports = $2678138d824ce508$var$IllustrationWithText;



var $d14f53020f68f99a$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $d14f53020f68f99a$var$StepsSummary(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "columns steps-summary has-padding-left-6-mobile has-padding-right-6-mobile has-padding-bottom-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "column",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($2678138d824ce508$exports, {
                    subtitle: props.t("stepsSummarySubtitle1"),
                    title: props.t("stepsSummaryTitle1"),
                    text: props.t("stepsSummaryText1"),
                    imgSrc: "/svg/illustrations/landing-page/homepage-people-on-laptop-spacer-by-cbre.svg",
                    imgAlt: props.t("stepsSummaryImgAlt1")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "column",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($2678138d824ce508$exports, {
                    subtitle: props.t("stepsSummarySubtitle2"),
                    title: props.t("stepsSummaryTitle2"),
                    text: props.t("stepsSummaryText2"),
                    imgSrc: "/svg/illustrations/landing-page/homepage-neighborhood-block-spacer-by-cbre.svg",
                    imgAlt: props.t("stepsSummaryImgAlt2")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "column",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($2678138d824ce508$exports, {
                    subtitle: props.t("stepsSummarySubtitle3"),
                    title: props.t("stepsSummaryTitle3"),
                    text: props.t("stepsSummaryText3"),
                    imgSrc: "/svg/illustrations/landing-page/homepage-girl-working-at-desk-spacer-by-cbre.svg",
                    imgAlt: props.t("stepsSummaryImgAlt3")
                })
            })
        ]
    });
}
$d14f53020f68f99a$var$StepsSummary.propTypes = {
    t: $c9Z8w.func.isRequired
};
$d14f53020f68f99a$exports = $d14f53020f68f99a$require$withTranslation("landingPage")($d14f53020f68f99a$var$StepsSummary);



var $c47f6775379e994e$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $c47f6775379e994e$var$LandingPageContent(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "has-padding-3 has-no-padding-mobile container",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "columns has-no-padding-left-mobile has-no-padding-right-mobile has-no-margin-right-mobile",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "column",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                        className: "section",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "title is-4-mobile has-text-primary",
                            children: props.t("landingPageContentTitle")
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($d14f53020f68f99a$exports, {})
                ]
            })
        })
    });
}
$c47f6775379e994e$var$LandingPageContent.propTypes = {
    t: $c9Z8w.func.isRequired
};
$c47f6775379e994e$exports = $c47f6775379e994e$require$withTranslation("landingPage")($c47f6775379e994e$var$LandingPageContent);


var $4b371f38060119be$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9bd5e620d29e9898$exports = {};

var $jHTLJ = parcelRequire("jHTLJ");
var $9bd5e620d29e9898$require$connect = $jHTLJ.connect;

var $eShmq = parcelRequire("eShmq");
var $9bd5e620d29e9898$require$bindActionCreators = $eShmq.bindActionCreators;
var $91d5e1f7c4d12efe$exports = {};
// Action Types
const $91d5e1f7c4d12efe$var$ANSWER_PROFILE_QUESTION = "ANSWER_PROFILE_QUESTION";
const $91d5e1f7c4d12efe$var$CALCULATE_PROFILE_SCORES = "CALCULATE_PROFILE_SCORES";
$91d5e1f7c4d12efe$exports = {
    ANSWER_PROFILE_QUESTION: // Action Types
    $91d5e1f7c4d12efe$var$ANSWER_PROFILE_QUESTION,
    CALCULATE_PROFILE_SCORES: $91d5e1f7c4d12efe$var$CALCULATE_PROFILE_SCORES,
    // Action Creators
    answerProfileQuestion (questionUnitId, selectedOption) {
        return {
            type: $91d5e1f7c4d12efe$var$ANSWER_PROFILE_QUESTION,
            questionUnitId: questionUnitId,
            selectedOption: selectedOption
        };
    },
    calculateProfileScores () {
        return {
            type: $91d5e1f7c4d12efe$var$CALCULATE_PROFILE_SCORES
        };
    }
};


var $dc99b7806b365357$exports = {};

$dc99b7806b365357$exports = (parcelRequire("jcqzj"));


var $9bd5e620d29e9898$require$questionUnitUtil = $dc99b7806b365357$exports.questionUnit;

const $9bd5e620d29e9898$var$quizOrder = (parcelRequire("fPryk")).quizOrderInfo.quizOrder;
var $9f0ba92c10998254$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $3e58c681e2cb99b8$exports = {};

var $c9Z8w = parcelRequire("c9Z8w");

var $3EC2Q = parcelRequire("3EC2Q");
// ******************************************
// QUIZ & PROFILE RESULTS
// ******************************************
// TODO: write custom validator for questionOptionsObject?
const $3e58c681e2cb99b8$var$questionOptionsTypes = $c9Z8w.oneOfType([
    $c9Z8w.object,
    $c9Z8w.array
]);
const $3e58c681e2cb99b8$var$questionUnitShape = $c9Z8w.shape({
    // required
    id: $c9Z8w.string.isRequired,
    type: $c9Z8w.string.isRequired,
    // optional
    text: $c9Z8w.string,
    answerType: $c9Z8w.string,
    answerFormat: $c9Z8w.string,
    response: $c9Z8w.string,
    assumptionType: $c9Z8w.string,
    userDataProperty: $c9Z8w.string,
    options: $3e58c681e2cb99b8$var$questionOptionsTypes,
    optionOrder: $c9Z8w.arrayOf($3EC2Q.stringOrNumber)
});
const $3e58c681e2cb99b8$var$questionAnswerTypes = $c9Z8w.oneOfType([
    $c9Z8w.string,
    $c9Z8w.number,
    $c9Z8w.arrayOf($c9Z8w.string)
]);
const $3e58c681e2cb99b8$var$userQuizAnswersObject = $c9Z8w.objectOf($c9Z8w.oneOfType([
    $c9Z8w.string,
    $c9Z8w.number,
    $c9Z8w.arrayOf($c9Z8w.string)
]));
const $3e58c681e2cb99b8$var$userDataForQuizShape = $c9Z8w.shape({
    role: $c9Z8w.string,
    industryCode: $c9Z8w.string
});
const $3e58c681e2cb99b8$var$assumptionsForQuizShape = $c9Z8w.shape({
    collaboration: $c9Z8w.number,
    daysPerWeekInOffice: $c9Z8w.number,
    headcount: $c9Z8w.number
});
// ******************************************
// PROGRAM RESULTS
// ******************************************
const $3e58c681e2cb99b8$var$assumptionsShape = $c9Z8w.shape({
    collaboration: $c9Z8w.number,
    daysPerWeekInOffice: $c9Z8w.number,
    headcount: $c9Z8w.number
});
const $3e58c681e2cb99b8$var$areaTotalsShape = $c9Z8w.shape({
    totalMeSF: $c9Z8w.number,
    totalWeSF: $c9Z8w.number,
    totalAmenitySF: $c9Z8w.number,
    totalSF: $c9Z8w.number
});
const $3e58c681e2cb99b8$var$spaceUnitShape = $c9Z8w.shape({
    nsf: $c9Z8w.number.isRequired,
    quantity: $c9Z8w.number.isRequired,
    spaceUnitId: $c9Z8w.string.isRequired,
    usf: $c9Z8w.number.isRequired
});
const $3e58c681e2cb99b8$var$customAmenityUnitShape = $c9Z8w.shape({
    customNSF: $c9Z8w.number,
    customQuantity: $c9Z8w.number,
    customSF: $c9Z8w.number,
    customUSF: $c9Z8w.number,
    displayName: $c9Z8w.string,
    nsf: $c9Z8w.number,
    quantity: $c9Z8w.number,
    id: $c9Z8w.string,
    usf: $c9Z8w.number
});
const $3e58c681e2cb99b8$var$programShape = $c9Z8w.shape({
    me: $c9Z8w.array,
    we: $c9Z8w.array,
    amenity: $c9Z8w.array,
    support: $c9Z8w.array,
    finalStats: $c9Z8w.object,
    metrics: $c9Z8w.object,
    areaTotalsShape: $3e58c681e2cb99b8$var$areaTotalsShape
});
const $3e58c681e2cb99b8$var$deltaShape = $c9Z8w.shape({
    numericDelta: $c9Z8w.number,
    displayPercentDelta: $c9Z8w.string
});
$3e58c681e2cb99b8$exports = {
    userQuizAnswersObject: // quiz & profile results
    $3e58c681e2cb99b8$var$userQuizAnswersObject,
    userDataForQuizShape: $3e58c681e2cb99b8$var$userDataForQuizShape,
    assumptionsForQuizShape: $3e58c681e2cb99b8$var$assumptionsForQuizShape,
    questionOptionsTypes: $3e58c681e2cb99b8$var$questionOptionsTypes,
    questionUnitShape: $3e58c681e2cb99b8$var$questionUnitShape,
    questionAnswerTypes: $3e58c681e2cb99b8$var$questionAnswerTypes,
    assumptionsShape: // program results
    $3e58c681e2cb99b8$var$assumptionsShape,
    areaTotalsShape: $3e58c681e2cb99b8$var$areaTotalsShape,
    spaceUnitShape: $3e58c681e2cb99b8$var$spaceUnitShape,
    customAmenityUnitShape: $3e58c681e2cb99b8$var$customAmenityUnitShape,
    programShape: $3e58c681e2cb99b8$var$programShape,
    deltaShape: $3e58c681e2cb99b8$var$deltaShape
};


var $9dba7d2357a40545$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $f1q41 = parcelRequire("f1q41");

var $aB89e = parcelRequire("aB89e");
var $9dba7d2357a40545$require$constants = $aB89e.spacerFree;

var $3dea5c212b41ff4a$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
function $3dea5c212b41ff4a$var$QuestionText(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
        className: "title question-text",
        children: props.text
    });
}
$3dea5c212b41ff4a$var$QuestionText.propTypes = {
    text: $c9Z8w.string.isRequired
};
$3dea5c212b41ff4a$exports = $3dea5c212b41ff4a$var$QuestionText;


var $2a4aca759c03a70a$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
function $2a4aca759c03a70a$var$QuestionAnswer(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "question-answer",
        children: props.component
    });
}
$2a4aca759c03a70a$var$QuestionAnswer.propTypes = {
    component: $c9Z8w.node.isRequired
};
$2a4aca759c03a70a$exports = $2a4aca759c03a70a$var$QuestionAnswer;


var $e4cf000d7ca2f84e$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $3EC2Q = parcelRequire("3EC2Q");


var $aB89e = parcelRequire("aB89e");
var $e4cf000d7ca2f84e$require$constants = $aB89e.spacerFree;

var $c0bae42d849a79e8$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $3EC2Q = parcelRequire("3EC2Q");

var $3eec173b26edcc71$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $3EC2Q = parcelRequire("3EC2Q");


var $56juP = parcelRequire("56juP");
var $c65935c63c29746a$exports = {};
const $c65935c63c29746a$var$KEY_CODES = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    PAUSE: 19,
    CAPS_LOCK: 20,
    ESCAPE: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT_ARROW: 37,
    UP_ARROW: 38,
    RIGHT_ARROW: 39,
    DOWN_ARROW: 40,
    INSERT: 45,
    DELETE: 46,
    0: 48,
    1: 49,
    2: 50,
    3: 51,
    4: 52,
    5: 53,
    6: 54,
    7: 55,
    8: 56,
    9: 57,
    A: 65,
    B: 66,
    C: 67,
    D: 68,
    E: 69,
    F: 70,
    G: 71,
    H: 72,
    I: 73,
    J: 74,
    K: 75,
    L: 76,
    M: 77,
    N: 78,
    O: 79,
    P: 80,
    Q: 81,
    R: 82,
    S: 83,
    T: 84,
    U: 85,
    V: 86,
    W: 87,
    X: 88,
    Y: 89,
    Z: 90,
    LEFT_WINDOW_KEY: 91,
    RIGHT_WINDOW_KEY: 92,
    SELECT_KEY: 93,
    NUMPAD_0: 96,
    NUMPAD_1: 97,
    NUMPAD_2: 98,
    NUMPAD_3: 99,
    NUMPAD_4: 100,
    NUMPAD_5: 101,
    NUMPAD_6: 102,
    NUMPAD_7: 103,
    NUMPAD_8: 104,
    NUMPAD_9: 105,
    MULTIPLY: 106,
    ADD: 107,
    SUBTRACT: 109,
    DECIMAL_POINT: 110,
    DIVIDE: 111,
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,
    NUM_LOCK: 144,
    SCROLL_LOCK: 145,
    SEMICOLON: 186,
    EQUAL_SIGN: 187,
    EQUAL_SIGN_GECKO: 61,
    COMMA: 188,
    DASH: 189,
    DASH_GECKO: 173,
    PERIOD: 190,
    FORWARD_SLASH: 191,
    GRAVE_ACCENT: 192,
    OPEN_BRACKET: 219,
    BACK_SLASH: 220,
    CLOSE_BRACKET: 221,
    SINGLE_QUOTE: 222,
    LEFT_MOUSE: "leftButton",
    RIGHT_MOUSE: "rightButton",
    MOUSE_SCROLL: "wheel",
    DOUBLE_CLICK: "doubleClick",
    SINGLE_TOUCH: "singleTouch"
};
$c65935c63c29746a$exports = $c65935c63c29746a$var$KEY_CODES;


const $3eec173b26edcc71$var$DROPDOWN_PADDING = 25;
class $3eec173b26edcc71$var$DropdownInput extends $acw62.Component {
    constructor(props){
        super(props);
        // highlightedOptionId is what's currently highlighted and would be selected on hitting enter
        // that might either be what's hovered, or what has been selected via keyboard up + down arrows
        this.state = {
            highlightedOptionId: null,
            dropdownActive: false
        };
        this.optionElements = {};
        this.registerKeyPress = this.registerKeyPress.bind(this);
        this.mouseMoveOnOptionField = this.mouseMoveOnOptionField.bind(this);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        for(let i = 0, len = nextProps.optionOrder.length; i < len; i += 1)if ($f1q41.lowerCase(nextProps.options[nextProps.optionOrder[i]].text) === $f1q41.lowerCase(nextProps.value)) {
            this.setState({
                highlightedOptionId: nextProps.optionOrder[i]
            });
            break;
        }
    }
    setValue(value) {
        return (evt)=>{
            evt.preventDefault();
            this.props.onValueChange(value);
            this.toggleDropdown(false);
        };
    }
    scrollOptionIntoView() {
        if (!this.props.isInQuiz) return;
        if (this.state.highlightedOptionId && this.optionElements[this.state.highlightedOptionId]) this.optionElements[this.state.highlightedOptionId].scrollIntoView({
            block: "nearest"
        });
    }
    shiftHighlightedOptionDown() {
        this.setState((prevState)=>{
            const oldIndex = this.props.optionOrder.indexOf(prevState.highlightedOptionId);
            if (oldIndex === this.props.optionOrder.length - 1) return null;
            return {
                highlightedOptionId: this.props.optionOrder[oldIndex + 1]
            };
        }, this.scrollOptionIntoView);
    }
    shiftHighlightedOptionUp() {
        this.setState((prevState)=>{
            const oldIndex = this.props.optionOrder.indexOf(prevState.highlightedOptionId);
            if (oldIndex === 0) return null;
            // from nothing selected, go to bottom option
            const newIndex = oldIndex === -1 ? this.props.optionOrder.length - 1 : oldIndex - 1;
            return {
                highlightedOptionId: this.props.optionOrder[newIndex]
            };
        }, this.scrollOptionIntoView);
    }
    registerKeyPress(evt) {
        switch(evt.which){
            case $c65935c63c29746a$exports.ENTER:
                if (!this.state.dropdownActive) return null;
                evt.target.blur(); // so that the next "enter" can move you to the next slide
                evt.stopPropagation(); // so that, if this dropdown is in the quiz, this enter doesn't take you to the next slide yet
                if (this.state.highlightedOptionId) this.setValue(this.state.highlightedOptionId)(evt);
                else this.toggleDropdown(false);
                return null;
            case $c65935c63c29746a$exports.DOWN_ARROW:
                evt.preventDefault(); // to prevent scrolling on main page
                return this.shiftHighlightedOptionDown();
            case $c65935c63c29746a$exports.UP_ARROW:
                evt.preventDefault(); // to prevent scrolling on main page
                return this.shiftHighlightedOptionUp(true);
            default:
                this.setState({
                    dropdownActive: true
                });
                return null;
        }
    }
    // mousemove instead of mouseenter, to not trigger when things scroll due to arrow keypresses
    mouseMoveOnOptionField(value) {
        return ()=>{
            if (this.state.highlightedOptionId !== value) this.setState({
                highlightedOptionId: value
            });
        };
    }
    toggleDropdown(showDropdown) {
        this.setState({
            dropdownActive: showDropdown,
            highlightedOptionId: this.props.value
        }, ()=>{
            if (showDropdown) this.scrollOptionIntoView();
        });
        this.props.onClick();
    }
    render() {
        let dropdownMenuStyles;
        if (this.props.isInQuiz && this.dropdownInput) dropdownMenuStyles = {
            maxHeight: $56juP.getSpaceBelow(this.dropdownInput) - $3eec173b26edcc71$var$DROPDOWN_PADDING,
            overflow: "auto"
        };
        let dropdownWrapperClasses = "dropdown";
        if (this.state.dropdownActive) dropdownWrapperClasses += " is-active";
        const dropdownSelectionClasses = $8g1PZ({
            "is-space-category-dropdown": this.props.isSpaceCategoryDropdown,
            "underline-input": !this.props.isSpaceCategoryDropdown,
            "has-placeholder": !this.props.value,
            "is-primary": this.props.isDark,
            "is-large": this.props.isLarge,
            "is-inactive": this.props.isInactive
        });
        const dropdownElements = this.props.optionOrder.map((optionId)=>{
            const key = `option-${optionId}`;
            const selected = this.props.value === optionId;
            const dropdownItemClasses = $8g1PZ("dropdown-item-quiz", {
                "is-active": selected,
                "hover": this.state.highlightedOptionId === optionId,
                "space-category-dropdown-item": this.props.isSpaceCategoryDropdown
            });
            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "option",
                "aria-selected": selected,
                tabIndex: optionId,
                className: dropdownItemClasses,
                onMouseDown: this.setValue(optionId),
                onMouseMove: this.mouseMoveOnOptionField(optionId),
                ref: (option)=>{
                    this.optionElements[optionId] = option;
                },
                title: this.props.options[optionId].text,
                children: this.props.options[optionId].text
            }, key);
        });
        const dropdownContentClasses = $8g1PZ("dropdown-content", {
            "space-category-dropdown-content": this.props.isSpaceCategoryDropdown
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: dropdownWrapperClasses,
            role: "menu",
            tabIndex: "0",
            onBlur: ()=>this.toggleDropdown(false),
            onKeyDown: this.registerKeyPress,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: dropdownSelectionClasses,
                    role: "button",
                    tabIndex: "0",
                    "aria-haspopup": "true",
                    "aria-controls": "dropdown-menu",
                    onFocus: ()=>this.toggleDropdown(true),
                    onMouseDown: ()=>this.toggleDropdown(true),
                    ref: (node)=>{
                        this.dropdownInput = node;
                    },
                    children: this.props.inputField
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "dropdown-menu is-primary",
                    role: "button",
                    tabIndex: "0",
                    id: "dropdown-menu",
                    onMouseDown: (evt)=>evt.preventDefault(),
                    onMouseLeave: ()=>this.setState({
                            highlightedOptionId: null
                        }),
                    style: dropdownMenuStyles,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: dropdownContentClasses,
                        role: "listbox",
                        children: dropdownElements
                    })
                })
            ]
        });
    }
}
$3eec173b26edcc71$var$DropdownInput.propTypes = {
    value: $3EC2Q.stringOrNumber.isRequired,
    onValueChange: $c9Z8w.func.isRequired,
    options: $3e58c681e2cb99b8$exports.questionOptionsTypes.isRequired,
    optionOrder: $c9Z8w.arrayOf($3EC2Q.stringOrNumber).isRequired,
    inputField: $c9Z8w.oneOfType([
        $c9Z8w.node,
        $c9Z8w.arrayOf($c9Z8w.node)
    ]).isRequired,
    isDark: $c9Z8w.bool,
    isLarge: $c9Z8w.bool,
    isInactive: $c9Z8w.bool,
    isInQuiz: $c9Z8w.bool,
    isSpaceCategoryDropdown: $c9Z8w.bool,
    onClick: $c9Z8w.func
};
$3eec173b26edcc71$var$DropdownInput.defaultProps = {
    emptyAnswerPlaceholder: "",
    isDark: false,
    isLarge: false,
    isInactive: false,
    isInQuiz: false,
    isSpaceCategoryDropdown: false,
    onClick: $f1q41.noop
};
$3eec173b26edcc71$exports = $3eec173b26edcc71$var$DropdownInput;


function $c0bae42d849a79e8$var$DropdownSelectionInput(props) {
    const dropdownSelectionText = props.value ? props.options[props.value].text : props.emptyAnswerPlaceholder;
    let inputFieldClasses = "input";
    if (props.isSpaceCategoryDropdown) inputFieldClasses += " space-category-dropdown-input space-dropdown-width is-hidden-print is-hidden-mobile";
    const inputField = /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: inputFieldClasses,
                children: dropdownSelectionText
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "dropdown-triangle"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3eec173b26edcc71$exports, {
        ...props,
        inputField: inputField
    });
}
$c0bae42d849a79e8$var$DropdownSelectionInput.propTypes = {
    value: $3EC2Q.stringOrNumber.isRequired,
    options: $3e58c681e2cb99b8$exports.questionOptionsTypes.isRequired,
    emptyAnswerPlaceholder: $c9Z8w.string,
    isSpaceCategoryDropdown: $c9Z8w.bool
};
$c0bae42d849a79e8$var$DropdownSelectionInput.defaultProps = {
    emptyAnswerPlaceholder: "",
    isSpaceCategoryDropdown: false
};
$c0bae42d849a79e8$exports = $c0bae42d849a79e8$var$DropdownSelectionInput;


var $6cbed09b54427939$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $90d7625f2e6d2261$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $f1q41 = parcelRequire("f1q41");
class $90d7625f2e6d2261$var$NumberInput extends $acw62.Component {
    constructor(props){
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.increment = this.increment.bind(this);
        this.decrement = this.decrement.bind(this);
    }
    onChange(value) {
        this.props.onChange(parseFloat(value));
    }
    onBlur(evt) {
        this.props.onBlur(evt.target.value);
    }
    // floor and ceil to jump in full number increments cause that feels smoother (eg. 4.3 -> 5 instead of 4.3 -> 5.3)
    // NOTE: this will cause unexpected behavior if this.props.step is less than 1
    increment() {
        let value = !$f1q41.isNull(this.props.value) ? Math.floor(parseFloat(this.props.value)) + this.props.step : this.props.min;
        if (value > this.props.max) value = this.props.max;
        this.props.onChange(value);
    }
    decrement() {
        let value = !$f1q41.isNull(this.props.value) ? Math.ceil(parseFloat(this.props.value)) - this.props.step : this.props.min;
        if (value < this.props.min) value = this.props.min;
        this.props.onChange(value);
    }
    render() {
        let inputWrapperClasses = "underline-input";
        if (this.props.isDark) inputWrapperClasses += " is-primary";
        if (this.props.disabled) inputWrapperClasses += " is-disabled";
        if (this.props.isInactive) inputWrapperClasses += " is-inactive";
        if (this.props.isLarge) inputWrapperClasses += " is-large";
        if (this.props.isLossFactor) inputWrapperClasses += " has-text-light";
        if (this.props.hasXlargeArrows) inputWrapperClasses += " large-arrow-underline";
        if (this.props.hasShortUnderline) inputWrapperClasses += " shorter-underline-width";
        if (this.props.hasSpaceTypeColor) inputWrapperClasses += " space-type-color-input";
        if (this.props.isLossFactor) inputWrapperClasses += " is-loss-factor";
        let dropdownTriangleClass = "dropdown-triangle";
        let dropdownTriangleUpClass = "dropdown-triangle-up";
        if (this.props.hasXlargeArrows) {
            dropdownTriangleClass = "dropdown-triangle-xlarge";
            dropdownTriangleUpClass = "dropdown-triangle-up-xlarge";
        }
        const input = /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
            className: "input",
            type: "number",
            min: this.props.min,
            max: this.props.max,
            value: this.props.value,
            step: this.props.step,
            // onChange={this.onChange}
            onChange: (event)=>{
                const newValue = event.target.value;
                if (newValue > this.props.max) this.onChange(this.props.max);
                else if (newValue < 0) this.onChange(Math.abs(newValue));
                else this.onChange(newValue);
            },
            onBlur: this.onBlur,
            autoFocus: this.props.autoFocus,
            disabled: this.props.disabled ? "disabled" : ""
        });
        const dropdownArrows = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "number-arrow-icons",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: `${dropdownTriangleUpClass} fs-ignore-rage-clicks`,
                    "aria-hidden": "true",
                    onClick: this.increment
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: `${dropdownTriangleClass} fs-ignore-rage-clicks`,
                    "aria-hidden": "true",
                    onClick: this.decrement
                })
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: inputWrapperClasses,
            children: [
                input,
                !this.props.hideNumberArrows && dropdownArrows,
                this.props.isLossFactor && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "is-loss-factor-styles loss-factor-percent space-type-color-text",
                    children: "%"
                })
            ]
        });
    }
}
$90d7625f2e6d2261$var$NumberInput.propTypes = {
    min: $c9Z8w.number,
    max: $c9Z8w.number,
    value: $c9Z8w.oneOfType([
        $c9Z8w.number,
        $c9Z8w.string
    ]),
    step: $c9Z8w.number,
    onChange: $c9Z8w.func,
    onBlur: $c9Z8w.func,
    disabled: $c9Z8w.bool,
    hideNumberArrows: $c9Z8w.bool,
    isInactive: $c9Z8w.bool,
    isDark: $c9Z8w.bool,
    isLarge: $c9Z8w.bool,
    autoFocus: $c9Z8w.bool,
    isLossFactor: $c9Z8w.bool,
    hasXlargeArrows: $c9Z8w.bool,
    hasShortUnderline: $c9Z8w.bool,
    hasSpaceTypeColor: $c9Z8w.bool
};
$90d7625f2e6d2261$var$NumberInput.defaultProps = {
    min: 0,
    max: Infinity,
    step: 1,
    value: "",
    onBlur: $f1q41.noop,
    onChange: $f1q41.noop,
    disabled: false,
    hideNumberArrows: false,
    isInactive: false,
    isDark: false,
    isLarge: false,
    autoFocus: false,
    isLossFactor: false,
    hasXlargeArrows: false,
    hasShortUnderline: false,
    hasInputTypeText: false,
    hasSpaceTypeColor: false
};
$90d7625f2e6d2261$exports = $90d7625f2e6d2261$var$NumberInput;



var $3EC2Q = parcelRequire("3EC2Q");
function $6cbed09b54427939$var$HeadcountInput(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($90d7625f2e6d2261$exports, {
        max: $6cbed09b54427939$var$HeadcountInput.MAX_HEADCOUNT,
        onChange: props.onValueChange,
        hideNumberArrows: !props.value,
        hasXlargeArrows: props.hasXlargeArrows,
        value: props.value || "",
        isDark: props.isDark
    });
}
$6cbed09b54427939$var$HeadcountInput.MAX_HEADCOUNT = 5000;
$6cbed09b54427939$var$HeadcountInput.propTypes = {
    onValueChange: $c9Z8w.func.isRequired,
    value: $3EC2Q.stringOrNumber.isRequired,
    hasXlargeArrows: $c9Z8w.bool,
    isDark: $c9Z8w.bool
};
$6cbed09b54427939$var$HeadcountInput.defaultProps = {
    hasXlargeArrows: false,
    isDark: false
};
$6cbed09b54427939$exports = $6cbed09b54427939$var$HeadcountInput;


var $498ea781240bc624$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $3EC2Q = parcelRequire("3EC2Q");

var $aB89e = parcelRequire("aB89e");
var $498ea781240bc624$require$constants = $aB89e.spacerFree;


var $498ea781240bc624$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
const $498ea781240bc624$var$optionOrder = [
    $498ea781240bc624$require$constants.calculator.COLLABORATION_LEVEL.LOW,
    $498ea781240bc624$require$constants.calculator.COLLABORATION_LEVEL.MEDIUM,
    $498ea781240bc624$require$constants.calculator.COLLABORATION_LEVEL.HIGH
];
function $498ea781240bc624$var$CollaborationDropdown(props) {
    const dropdownOptions = {
        [$498ea781240bc624$require$constants.calculator.COLLABORATION_LEVEL.LOW]: {
            text: props.t("collabDropdownLevelLowText")
        },
        [$498ea781240bc624$require$constants.calculator.COLLABORATION_LEVEL.MEDIUM]: {
            text: props.t("collabDropdownLevelMedText")
        },
        [$498ea781240bc624$require$constants.calculator.COLLABORATION_LEVEL.HIGH]: {
            text: props.t("collabDropdownLevelHighText")
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c0bae42d849a79e8$exports, {
        options: dropdownOptions,
        optionOrder: $498ea781240bc624$var$optionOrder,
        ...props
    });
}
$498ea781240bc624$var$CollaborationDropdown.propTypes = {
    value: $3EC2Q.stringOrNumber.isRequired,
    onValueChange: $c9Z8w.func.isRequired,
    disabled: $c9Z8w.bool,
    isLarge: $c9Z8w.bool,
    t: $c9Z8w.func.isRequired
};
$498ea781240bc624$var$CollaborationDropdown.defaultProps = {
    disabled: false,
    isLarge: false
};
$498ea781240bc624$exports = $498ea781240bc624$require$withTranslation("resultsPage")($498ea781240bc624$var$CollaborationDropdown);


var $535eeb685e7404c1$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $3EC2Q = parcelRequire("3EC2Q");

var $5f15cdd5de4823b1$exports = {};
function $5f15cdd5de4823b1$var$decimalTo100PercentageRatioHelper(decimal, returnArray = false) {
    const percentage = Math.round(decimal * 100, 10);
    const oppositePercentage = 100 - percentage;
    if (returnArray) {
        if (percentage) return [
            `${percentage}%`,
            `${oppositePercentage}%`
        ];
        return [
            "\u2014%",
            "\u2014%"
        ];
    }
    if (percentage) return `${percentage}%:${oppositePercentage}%`;
    return "\u2014%:\u2014%";
}
let $5f15cdd5de4823b1$var$CURRENT_LANGUAGE = "en";
$5f15cdd5de4823b1$exports = {
    // adapted from http://jonisalonen.com/2012/converting-decimal-numbers-to-ratios/
    decimalToRatio (decimal) {
        // round decimal to nearest 100th for prettier ratios
        decimal = Math.round(decimal * 100, 10) / 100;
        const tolerance = 1.0E-6;
        let h1 = 1;
        let h2 = 0;
        let k1 = 0;
        let k2 = 1;
        let b = decimal;
        let a;
        let aux;
        do {
            a = Math.floor(b);
            aux = h1;
            h1 = a * h1 + h2;
            h2 = aux;
            aux = k1;
            k1 = a * k1 + k2;
            k2 = aux;
            b = 1 / (b - a);
        }while (Math.abs(decimal - h1 / k1) > decimal * tolerance);
        return `${h1}:${k1}`;
    },
    decimalTo100PercentageRatioStringFormat (decimal) {
        return $5f15cdd5de4823b1$var$decimalTo100PercentageRatioHelper(decimal);
    },
    decimalTo100PercentageRatioArrayFormat (decimal) {
        return $5f15cdd5de4823b1$var$decimalTo100PercentageRatioHelper(decimal, true);
    },
    decimalToPercentage (decimal) {
        return `${Math.round(decimal * 100, 10)}%`;
    },
    updateCurrentLanguage (lang) {
        if (lang) $5f15cdd5de4823b1$var$CURRENT_LANGUAGE = lang;
    },
    numberWithLocaleFormat (x) {
        return x.toLocaleString($5f15cdd5de4823b1$var$CURRENT_LANGUAGE);
    }
};


const $535eeb685e7404c1$var$dropdownOptionOrder = [
    5,
    4.5,
    4,
    3.5,
    3,
    2.5,
    2
];
function $535eeb685e7404c1$var$DaysInOfficeDropdown(props) {
    const dropdownOptions = {};
    for(let i = 0, len = $535eeb685e7404c1$var$dropdownOptionOrder.length; i < len; i += 1){
        const parsedOption = parseFloat($535eeb685e7404c1$var$dropdownOptionOrder[i]);
        dropdownOptions[$535eeb685e7404c1$var$dropdownOptionOrder[i]] = {
            text: $5f15cdd5de4823b1$exports.numberWithLocaleFormat(parsedOption)
        };
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c0bae42d849a79e8$exports, {
        options: dropdownOptions,
        optionOrder: $535eeb685e7404c1$var$dropdownOptionOrder,
        ...props
    });
}
$535eeb685e7404c1$var$DaysInOfficeDropdown.propTypes = {
    value: $3EC2Q.stringOrNumber.isRequired,
    onValueChange: $c9Z8w.func.isRequired,
    disabled: $c9Z8w.bool,
    isLarge: $c9Z8w.bool
};
$535eeb685e7404c1$var$DaysInOfficeDropdown.defaultProps = {
    disabled: false,
    isLarge: false
};
$535eeb685e7404c1$exports = $535eeb685e7404c1$var$DaysInOfficeDropdown;


var $649307af9327b144$exports = {};
/* global fetch */ 
var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $2b3a18db53b6e95a$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $f1q41 = parcelRequire("f1q41");

var $3EC2Q = parcelRequire("3EC2Q");


class $2b3a18db53b6e95a$var$AutocompleteInput extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            value: props.value,
            dropdownOptions: {},
            optionOrder: []
        };
        this.setValue = this.setValue.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.updateSearch = this.updateSearch.bind(this);
        this.updateDropdownOptions = this.updateDropdownOptions.bind(this);
    }
    onKeyDown(evt) {
        if (this.state.value === "" && evt.which === $c65935c63c29746a$exports.DOWN_ARROW) this.updateSearch("");
        else if (evt.which === $c65935c63c29746a$exports.ENTER && !this.props.allowValueNotInDropdown && this.state.value !== this.props.value) {
            // if a user hits enter AND are only allowed values that exist in the dropdown AND has changed their answer since last selecting a permitted value,
            // then reset to last permitted value they selected
            this.setState({
                value: this.props.value
            });
            this.updateSearch(this.props.value); // to update dropdown suggestions as well
        }
    }
    setValue(value) {
        this.setState({
            value: value
        });
        this.updateSearch(value); // to update dropdown suggestions as well
        this.props.onValueChange(value);
    }
    updateDropdownOptions(newOptions) {
        this.setState(newOptions);
    }
    updateSearch(evtOrValue) {
        const value = $f1q41.isString(evtOrValue) ? evtOrValue : evtOrValue.target.value;
        this.setState({
            value: value
        });
        if (value.length >= this.props.minSearchLength) this.props.getAutocompleteOptions(value, this.updateDropdownOptions);
        else {
            // if value is below this.props.minSearchLength but there are leftover suggestions from before, remove those suggestions
            if (this.state.optionOrder.length > 0) this.setState({
                dropdownOptions: {},
                optionOrder: []
            });
            // if value becomes empty, propagate changes to parent component in case it has conditions for empty values (e.g., disabling buttons)
            if (value === "") this.props.onValueChange(value);
        }
    }
    render() {
        const inputField = /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
            type: "text",
            className: "input",
            role: "combobox",
            "aria-haspopup": "true",
            "aria-controls": "dropdown-menu",
            "aria-expanded": this.state.optionOrder.length > 0,
            value: this.state.value,
            placeholder: this.props.placeholder,
            title: this.state.value,
            onChange: this.updateSearch,
            autoFocus: !this.props.isInactive,
            onKeyDown: this.onKeyDown
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)($3eec173b26edcc71$exports, {
            ...this.props,
            value: this.state.value,
            onValueChange: this.setValue,
            options: this.state.dropdownOptions,
            optionOrder: this.state.optionOrder,
            inputField: inputField
        });
    }
}
$2b3a18db53b6e95a$var$AutocompleteInput.propTypes = {
    value: $3EC2Q.stringOrNumber.isRequired,
    onValueChange: $c9Z8w.func.isRequired,
    isInactive: $c9Z8w.bool.isRequired,
    getAutocompleteOptions: $c9Z8w.func.isRequired,
    minSearchLength: $c9Z8w.number,
    allowValueNotInDropdown: $c9Z8w.bool,
    placeholder: $c9Z8w.string
};
$2b3a18db53b6e95a$var$AutocompleteInput.defaultProps = {
    minSearchLength: 0,
    allowValueNotInDropdown: false,
    placeholder: ""
};
$2b3a18db53b6e95a$exports = $2b3a18db53b6e95a$var$AutocompleteInput;


// ArcGIS Geocoding Suggest Documentation: https://developers.arcgis.com/rest/geocode/api-reference/geocoding-suggest.htm
// the following URL includes params to
//   - narrow search to City
//   - return results in JSON format
const $649307af9327b144$var$GEOCODE_URL = "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?category=City&f=json";
function $649307af9327b144$var$getGeocodeUrlWithUserInput(input) {
    const encodedInput = encodeURI(input);
    return `${$649307af9327b144$var$GEOCODE_URL}&text=${encodedInput}`;
}
function $649307af9327b144$var$LocationAutocompleteInput(props) {
    function getAutocompleteOptions(value, callback) {
        const urlWithUserInput = $649307af9327b144$var$getGeocodeUrlWithUserInput(value);
        fetch(urlWithUserInput, {
            cors: true,
            headers: {
                Accept: "application/json"
            }
        }).then((response)=>{
            response.json().then((jsonResponse)=>{
                const dropdownOptions = {};
                const optionOrder = [];
                jsonResponse.suggestions.forEach((locationSuggestion)=>{
                    const locationName = locationSuggestion.text;
                    dropdownOptions[locationName] = {
                        text: locationName
                    };
                    optionOrder.push(locationName);
                });
                callback({
                    dropdownOptions: dropdownOptions,
                    optionOrder: optionOrder
                });
            });
        }, (error)=>{
            // if there is an error reaching the geocode API, set the location to whatever the user has input
            console.log("Error reaching ArcGis API:", error);
            props.onValueChange(value);
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2b3a18db53b6e95a$exports, {
        ...props,
        getAutocompleteOptions: getAutocompleteOptions,
        minSearchLength: 3
    });
}
$649307af9327b144$var$LocationAutocompleteInput.propTypes = {
    onValueChange: $c9Z8w.func.isRequired
};
$649307af9327b144$exports = $649307af9327b144$var$LocationAutocompleteInput;


var $9bf10bd8a9087e7b$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $3EC2Q = parcelRequire("3EC2Q");

var $aB89e = parcelRequire("aB89e");
var $9bf10bd8a9087e7b$require$constants = $aB89e.spacerFree;


var $9bf10bd8a9087e7b$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
const $9bf10bd8a9087e7b$var$optionOrder = [
    $9bf10bd8a9087e7b$require$constants.calculator.DENSITY_LEVEL.SAME,
    $9bf10bd8a9087e7b$require$constants.calculator.DENSITY_LEVEL.LOW,
    $9bf10bd8a9087e7b$require$constants.calculator.DENSITY_LEVEL.NOT_SURE
];
function $9bf10bd8a9087e7b$var$DensityDropdown(props) {
    const dropdownOptions = {
        [$9bf10bd8a9087e7b$require$constants.calculator.DENSITY_LEVEL.SAME]: {
            text: props.t("sameDensityText")
        },
        [$9bf10bd8a9087e7b$require$constants.calculator.DENSITY_LEVEL.LOW]: {
            text: props.t("lowerDensityText")
        },
        [$9bf10bd8a9087e7b$require$constants.calculator.DENSITY_LEVEL.NOT_SURE]: {
            text: props.t("notSureDensityText")
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c0bae42d849a79e8$exports, {
        options: dropdownOptions,
        optionOrder: $9bf10bd8a9087e7b$var$optionOrder,
        ...props
    });
}
$9bf10bd8a9087e7b$var$DensityDropdown.propTypes = {
    value: $3EC2Q.stringOrNumber.isRequired,
    onValueChange: $c9Z8w.func.isRequired,
    disabled: $c9Z8w.bool,
    isLarge: $c9Z8w.bool,
    t: $c9Z8w.func.isRequired
};
$9bf10bd8a9087e7b$var$DensityDropdown.defaultProps = {
    disabled: false,
    isLarge: false
};
$9bf10bd8a9087e7b$exports = $9bf10bd8a9087e7b$require$withTranslation("resultsPage")($9bf10bd8a9087e7b$var$DensityDropdown);


var $c7413500643ab95d$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $f1q41 = parcelRequire("f1q41");

var $lQpt8 = parcelRequire("lQpt8");
var $a9ee39a026dc756f$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

class $a9ee39a026dc756f$var$AlphabetizedAutocompleteInput extends $acw62.Component {
    constructor(props){
        super(props);
        this.allDropdownOptions = {};
        this.allOptionOrder = [];
        props.dropdownOptions.forEach((option)=>{
            this.allDropdownOptions[option] = {
                text: option
            };
            this.allOptionOrder.push(option);
        });
        this.getAutocompleteOptions = this.getAutocompleteOptions.bind(this);
    }
    getAutocompleteOptions(value, callback) {
        let dropdownOptions = {};
        let optionOrder = [];
        this.props.dropdownOptions.forEach((option)=>{
            if ($f1q41.includes(option.toLowerCase(), value.toLowerCase())) {
                dropdownOptions[option] = {
                    text: option
                };
                optionOrder.push(option);
            }
        });
        if (optionOrder.length === 0) {
            dropdownOptions = this.allDropdownOptions;
            optionOrder = this.allOptionOrder;
        }
        optionOrder.sort();
        this.props.onValueChange(value); // user is allowed to type whatever they want
        callback({
            dropdownOptions: dropdownOptions,
            optionOrder: optionOrder
        });
    }
    render() {
        return /*#__PURE__*/ (0, $ayMG0.jsx)($2b3a18db53b6e95a$exports, {
            ...this.props,
            getAutocompleteOptions: this.getAutocompleteOptions,
            allowValueNotInDropdown: this.props.allowValueNotInDropdown,
            isInactive: this.props.isInactive,
            placeholder: this.props.placeholder
        });
    }
}
$a9ee39a026dc756f$var$AlphabetizedAutocompleteInput.propTypes = {
    dropdownOptions: $c9Z8w.arrayOf($c9Z8w.string).isRequired,
    placeholder: $c9Z8w.string,
    onValueChange: $c9Z8w.func.isRequired,
    allowValueNotInDropdown: $c9Z8w.bool,
    isInactive: $c9Z8w.bool
};
$a9ee39a026dc756f$var$AlphabetizedAutocompleteInput.defaultProps = {
    allowValueNotInDropdown: false,
    placeholder: "",
    isInactive: false
};
$a9ee39a026dc756f$exports = $a9ee39a026dc756f$var$AlphabetizedAutocompleteInput;



var $c7413500643ab95d$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
class $c7413500643ab95d$var$IndustryCodeAutocomplete extends $acw62.Component {
    constructor(props){
        super(props);
        this.industryCodeTokens = $lQpt8.industryCodeTokens;
        this.state = {
            industryInput: this.props.t(this.industryCodeTokens[props.value]) || ""
        };
        this.onIndustryInputChange = this.onIndustryInputChange.bind(this);
    }
    onIndustryInputChange(value) {
        this.setState({
            industryInput: value
        });
        const industryCode = $f1q41.findKey(this.industryCodeTokens, (industry)=>this.props.t(industry) === value);
        this.props.onValueChange(industryCode || "");
    }
    render() {
        const industryOptionsTokenized = Object.values(this.industryCodeTokens).map(this.props.t);
        return /*#__PURE__*/ (0, $ayMG0.jsx)($a9ee39a026dc756f$exports, {
            ...this.props,
            value: this.state.industryInput,
            onValueChange: this.onIndustryInputChange,
            dropdownOptions: industryOptionsTokenized
        });
    }
}
$c7413500643ab95d$var$IndustryCodeAutocomplete.propTypes = {
    value: $c9Z8w.string.isRequired,
    onValueChange: $c9Z8w.func.isRequired,
    t: $c9Z8w.func.isRequired
};
$c7413500643ab95d$exports = $c7413500643ab95d$require$withTranslation("quizPage")($c7413500643ab95d$var$IndustryCodeAutocomplete);



var $fhb9G = parcelRequire("fhb9G");
class $e4cf000d7ca2f84e$var$SentenceCompletionAnswer extends $acw62.Component {
    constructor(props){
        super(props);
        this.onAnswerChange = this.onAnswerChange.bind(this);
    }
    onAnswerChange(questionAnswer) {
        if (this.props.questionUnit.type === $e4cf000d7ca2f84e$require$constants.questionUnit.QUESTION_TYPE.ASSUMPTION) questionAnswer = parseFloat(questionAnswer);
        this.props.onAnswerChange(questionAnswer);
    }
    render() {
        const isGroupedQuestion = $dc99b7806b365357$exports.questionUnit.isGroupedQuestion(this.props.questionUnit);
        const isInputLarge = isGroupedQuestion && !this.props.isInactive;
        const answerInputProps = {
            isDark: true,
            isInQuiz: true,
            value: this.props.questionAnswer,
            onValueChange: this.onAnswerChange,
            isInactive: this.props.isInactive,
            isLarge: isInputLarge
        };
        let answerInput;
        if (this.props.questionUnit.type === $e4cf000d7ca2f84e$require$constants.questionUnit.QUESTION_TYPE.ASSUMPTION) switch(this.props.questionUnit.assumptionType){
            case $e4cf000d7ca2f84e$require$constants.questionUnit.ASSUMPTION_TYPE.HEADCOUNT:
                answerInput = /*#__PURE__*/ (0, $ayMG0.jsx)($6cbed09b54427939$exports, {
                    ...answerInputProps
                });
                break;
            case $e4cf000d7ca2f84e$require$constants.questionUnit.ASSUMPTION_TYPE.COLLABORATION:
                answerInput = /*#__PURE__*/ (0, $ayMG0.jsx)($498ea781240bc624$exports, {
                    ...answerInputProps
                });
                break;
            case $e4cf000d7ca2f84e$require$constants.questionUnit.ASSUMPTION_TYPE.DAYS_IN_OFFICE:
                answerInput = /*#__PURE__*/ (0, $ayMG0.jsx)($535eeb685e7404c1$exports, {
                    ...answerInputProps
                });
                break;
            case $e4cf000d7ca2f84e$require$constants.questionUnit.ASSUMPTION_TYPE.DENSITY:
                answerInput = /*#__PURE__*/ (0, $ayMG0.jsx)($9bf10bd8a9087e7b$exports, {
                    ...answerInputProps
                });
                break;
            default:
                break;
        }
        else switch(this.props.questionUnit.answerInputType){
            case $e4cf000d7ca2f84e$require$constants.questionUnit.ANSWER_INPUT_TYPE.DROPDOWN:
                answerInput = /*#__PURE__*/ (0, $ayMG0.jsx)($c0bae42d849a79e8$exports, {
                    ...answerInputProps,
                    options: this.props.questionUnit.options,
                    optionOrder: this.props.questionUnit.optionOrder,
                    emptyAnswerPlaceholder: this.props.questionUnit.emptyAnswerPlaceholder
                });
                break;
            case $e4cf000d7ca2f84e$require$constants.questionUnit.ANSWER_INPUT_TYPE.LOCATION_AUTOCOMPLETE:
                answerInput = /*#__PURE__*/ (0, $ayMG0.jsx)($649307af9327b144$exports, {
                    ...answerInputProps
                });
                break;
            case $e4cf000d7ca2f84e$require$constants.questionUnit.ANSWER_INPUT_TYPE.INDUSTRY_AUTOCOMPLETE:
                answerInput = /*#__PURE__*/ (0, $ayMG0.jsx)($c7413500643ab95d$exports, {
                    ...answerInputProps
                });
                break;
            default:
                break;
        }
        let classes = "sentence-complete-answer";
        if (isGroupedQuestion) classes += " title question-text";
        if (this.props.isInactive) classes += " is-inactive";
        let wordsClasses = "sentence-complete-words";
        if (this.props.questionUnit.assumptionType === $e4cf000d7ca2f84e$require$constants.questionUnit.ASSUMPTION_TYPE.HEADCOUNT) wordsClasses += " headcount-question";
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: classes,
                    children: this.props.questionUnit.answerText.map((componentText)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: componentText === $e4cf000d7ca2f84e$require$constants.questionUnit.INPUT_PLACEHOLDER ? answerInput : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: wordsClasses,
                                children: componentText
                            })
                        }, componentText))
                }),
                this.props.questionUnit.assumptionType === $e4cf000d7ca2f84e$require$constants.questionUnit.ASSUMPTION_TYPE.HEADCOUNT && !this.props.isInactive && /*#__PURE__*/ (0, $ayMG0.jsx)($fhb9G, {
                    min: $6cbed09b54427939$exports.MIN_HEADCOUNT,
                    max: $6cbed09b54427939$exports.MAX_HEADCOUNT,
                    onChange: this.onAnswerChange,
                    ...answerInputProps
                }),
                this.props.questionUnit.answerHelperText && !this.props.isInactive && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "has-text-primary-invert has-padding-top-7",
                    children: this.props.questionUnit.answerHelperText
                })
            ]
        });
    }
}
$e4cf000d7ca2f84e$var$SentenceCompletionAnswer.propTypes = {
    questionUnit: $3e58c681e2cb99b8$exports.questionUnitShape.isRequired,
    questionAnswer: $3EC2Q.stringOrNumber,
    onAnswerChange: $c9Z8w.func.isRequired,
    isInactive: $c9Z8w.bool
};
$e4cf000d7ca2f84e$var$SentenceCompletionAnswer.defaultProps = {
    questionAnswer: "",
    isInactive: false
};
$e4cf000d7ca2f84e$exports = $e4cf000d7ca2f84e$var$SentenceCompletionAnswer;


var $7aeefb8b36f84f82$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $aB89e = parcelRequire("aB89e");
var $7aeefb8b36f84f82$require$constants = $aB89e.spacerFree;

const $7aeefb8b36f84f82$var$quizOrder = (parcelRequire("fPryk")).quizOrderInfo.quizOrder;

var $7aeefb8b36f84f82$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
class $7aeefb8b36f84f82$var$RankSentenceCompletionAnswer extends $acw62.Component {
    constructor(props){
        super(props);
        this.addToActiveRanking = this.addToActiveRanking.bind(this);
        this.removeFromRanking = this.removeFromRanking.bind(this);
    }
    addToActiveRanking(optionId) {
        return ()=>{
            const questionAnswer = this.props.questionAnswer.slice();
            const activeRankIndex = questionAnswer.indexOf(null);
            questionAnswer[activeRankIndex] = optionId;
            this.props.onAnswerChange(questionAnswer);
        };
    }
    removeFromRanking(rankIndex) {
        return ()=>{
            const questionAnswer = this.props.questionAnswer.slice();
            questionAnswer[rankIndex] = null;
            this.props.onAnswerChange(questionAnswer);
        };
    }
    render() {
        const activeRankIndex = this.props.questionAnswer.indexOf(null); // first null in array
        // for this type of question, answerText is an array of arrays
        //    - the outer array represents sentence parts at corresponding rank positions
        //    - the inner array represents the words / input placeholder that make up each sentence part
        const sentenceElements = [];
        let hasRankingAtIndex;
        let isActiveRankIndex;
        let sentencePart;
        let sentencePartClasses;
        let sentencePartElements;
        let wordsOrInputPlaceholder;
        let fillInTheBlankWrapperClasses;
        let fillInTheBlankClasses;
        let fillInTheBlankContent;
        for(let i = 0, len = this.props.questionUnit.answerText.length; i < len; i += 1){
            hasRankingAtIndex = !!this.props.questionAnswer[i];
            isActiveRankIndex = activeRankIndex === i;
            sentencePart = this.props.questionUnit.answerText[i];
            sentencePartClasses = "sentence-complete-answer";
            if (!hasRankingAtIndex && !isActiveRankIndex) sentencePartClasses += " is-unselected";
            if (hasRankingAtIndex) {
                fillInTheBlankWrapperClasses = "";
                fillInTheBlankClasses = "";
                fillInTheBlankContent = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "tag tag-btn-width is-medium has-border",
                    title: this.props.questionUnit.options[this.props.questionAnswer[i]].text,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "flex-btn-ellipsis",
                            children: this.props.questionUnit.options[this.props.questionAnswer[i]].text
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "delete is-medium",
                                onClick: this.removeFromRanking(i),
                                "aria-label": "unselect this answer"
                            })
                        })
                    ]
                });
            } else {
                fillInTheBlankWrapperClasses = "underline-input no-pointer is-primary has-dashed-border";
                if (!isActiveRankIndex) fillInTheBlankWrapperClasses += " is-disabled";
                fillInTheBlankClasses = "input";
                fillInTheBlankContent = this.props.questionUnit.emptyAnswerPlaceholder;
            }
            sentencePartElements = [];
            for(let j = 0, jLen = sentencePart.length; j < jLen; j += 1){
                wordsOrInputPlaceholder = sentencePart[j];
                const keyForWordsOrInputPlaceholder = `${wordsOrInputPlaceholder}-${i}-${j}`;
                if (wordsOrInputPlaceholder === $7aeefb8b36f84f82$require$constants.questionUnit.INPUT_PLACEHOLDER) sentencePartElements.push(/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: fillInTheBlankWrapperClasses,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: fillInTheBlankClasses,
                        children: fillInTheBlankContent
                    })
                }, keyForWordsOrInputPlaceholder));
                else {
                    let classesForWords = "sentence-complete-words";
                    if (wordsOrInputPlaceholder === "," || wordsOrInputPlaceholder === ".") classesForWords += " is-hidden-mobile";
                    sentencePartElements.push(/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: classesForWords,
                        children: wordsOrInputPlaceholder
                    }, keyForWordsOrInputPlaceholder));
                }
            }
            sentenceElements.push(/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: sentencePartClasses,
                children: sentencePartElements
            }, sentencePart.join().substring(0, 25)));
        }
        const optionElements = Object.keys(this.props.questionUnit.options).map((optionId)=>/*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                className: `tag is-block is-medium btn-width ${this.props.questionAnswer.indexOf(optionId) > -1 ? "is-disabled" : "is-clickable"}`,
                disabled: this.props.questionAnswer.indexOf(optionId) > -1,
                onClick: this.addToActiveRanking(optionId),
                title: this.props.questionUnit.options[optionId].text,
                children: this.props.questionUnit.options[optionId].text
            }, optionId));
        // show tooltip if on the first question, first rank is active, and other ranks are not yet filled out
        const showTooltip = this.props.questionUnit.id === $7aeefb8b36f84f82$var$quizOrder[0] && activeRankIndex === 0 && !this.props.questionAnswer[1] && !this.props.questionAnswer[2];
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "columns is-gapless has-padding-top-6",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "column is-8",
                        children: sentenceElements
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "column is-4",
                        children: activeRankIndex > -1 && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `rank-question-tooltip tooltip is-tooltip-top is-tooltip-active is-tooltip-info is-hidden-mobile ${showTooltip ? "" : "is-invisible"}`,
                                    "data-tooltip": this.props.t("firstResponseTooltipText")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "tags is-block",
                                    children: optionElements
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
}
$7aeefb8b36f84f82$var$RankSentenceCompletionAnswer.propTypes = {
    questionUnit: $3e58c681e2cb99b8$exports.questionUnitShape.isRequired,
    questionAnswer: $c9Z8w.arrayOf($c9Z8w.string).isRequired,
    onAnswerChange: $c9Z8w.func.isRequired,
    t: $c9Z8w.func.isRequired
};
$7aeefb8b36f84f82$exports = $7aeefb8b36f84f82$require$withTranslation("quizPage")($7aeefb8b36f84f82$var$RankSentenceCompletionAnswer);


var $3a676e1754637682$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

class $3a676e1754637682$var$SpectrumAnswer extends $acw62.Component {
    constructor(props){
        super(props);
        this.onAnswerChange = this.onAnswerChange.bind(this);
    }
    onAnswerChange(optionId) {
        return ()=>{
            this.props.onAnswerChange(optionId);
        };
    }
    render() {
        let inputId;
        let classNames;
        let selected;
        const optionIds = Object.keys(this.props.questionUnit.options);
        const spectrumOptions = optionIds.map((optionId)=>{
            inputId = `question-option-${optionId}`;
            selected = this.props.questionAnswer === optionId;
            classNames = "radio-spectrum";
            if (selected) classNames += " is-active";
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                className: classNames,
                htmlFor: inputId,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "radio",
                        name: `question-${this.props.questionUnit.id}`,
                        id: inputId,
                        onChange: this.onAnswerChange(optionId),
                        value: optionId,
                        checked: selected
                    }),
                    this.props.questionUnit.options[optionId].text
                ]
            }, optionId);
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "radio-spectrum-container",
            children: spectrumOptions
        });
    }
}
$3a676e1754637682$var$SpectrumAnswer.propTypes = {
    questionUnit: $3e58c681e2cb99b8$exports.questionUnitShape.isRequired,
    questionAnswer: $c9Z8w.string.isRequired,
    onAnswerChange: $c9Z8w.func.isRequired
};
$3a676e1754637682$exports = $3a676e1754637682$var$SpectrumAnswer;


var $e6c0631edb47e18c$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


function $e6c0631edb47e18c$var$QuestionResponse(props) {
    let outerDivClasses = "question-response";
    outerDivClasses += props.showResponse ? " fade-in" : " is-invisible-to-be-faded-in";
    // for rank questions, don't hold space because the response will only appear once tags have disappeared
    // and while the tags are still visible, their list might be too long and push this placeholder off screen
    if ($dc99b7806b365357$exports.questionUnit.isRankQuestion(props.questionUnit) && !props.showResponse) outerDivClasses += " hide";
    const questionResponse = $dc99b7806b365357$exports.questionUnit.getQuestionResponse(props.questionUnit, props.questionAnswer);
    // preloading all possible response illustrations to avoid waiting time after response is picked
    const allResponseIllustrationNames = $dc99b7806b365357$exports.questionUnit.getAllResponseIllustrationNames(props.questionUnit);
    const illustrations = allResponseIllustrationNames.map((name)=>/*#__PURE__*/ (0, $ayMG0.jsx)("img", {
            src: `/svg/illustrations/quiz/${name}`,
            alt: "",
            className: name === questionResponse.illustrationName && props.showResponse ? "fade-in" : "is-invisible-to-be-faded-in"
        }, name));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: outerDivClasses,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "title is-4 is-5-mobile question-response-title",
                children: questionResponse.text
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "question-response-img",
                children: illustrations
            })
        ]
    });
}
$e6c0631edb47e18c$var$QuestionResponse.propTypes = {
    showResponse: $c9Z8w.bool,
    questionUnit: $3e58c681e2cb99b8$exports.questionUnitShape.isRequired,
    questionAnswer: $3e58c681e2cb99b8$exports.questionAnswerTypes
};
$e6c0631edb47e18c$var$QuestionResponse.defaultProps = {
    showResponse: false,
    questionAnswer: ""
};
$e6c0631edb47e18c$exports = $e6c0631edb47e18c$var$QuestionResponse;


var $cce78554523b012f$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");
function $cce78554523b012f$var$CheckboxInput(props) {
    const classes = $8g1PZ("checkbox", {
        "is-active": props.checked,
        "in-quiz": props.inQuiz
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
        className: classes,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                className: "visually-hidden",
                type: "checkbox",
                onChange: (evt)=>props.onChange(evt.target.checked),
                checked: props.checked,
                required: props.required
            }),
            props.label
        ]
    });
}
$cce78554523b012f$var$CheckboxInput.propTypes = {
    label: $c9Z8w.oneOfType([
        $c9Z8w.string,
        $c9Z8w.node
    ]).isRequired,
    checked: $c9Z8w.bool.isRequired,
    onChange: $c9Z8w.func.isRequired,
    required: $c9Z8w.bool,
    inQuiz: $c9Z8w.bool
};
$cce78554523b012f$var$CheckboxInput.defaultProps = {
    required: false,
    inQuiz: false
};
$cce78554523b012f$exports = $cce78554523b012f$var$CheckboxInput;



var $9dba7d2357a40545$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
class $9dba7d2357a40545$var$Question extends $acw62.Component {
    constructor(props){
        super(props);
        this.onAnswerChange = this.onAnswerChange.bind(this);
    }
    onAnswerChange(questionAnswer) {
        this.props.onAnswerChange(questionAnswer);
    }
    render() {
        const tokenizedQuestionUnit = $dc99b7806b365357$exports.questionUnit.tokenizeQuestionUnit(this.props.questionUnit, this.props.t);
        const questionAnswerComponentProps = {
            questionUnit: tokenizedQuestionUnit,
            questionAnswer: this.props.questionAnswer,
            onAnswerChange: this.onAnswerChange,
            isInactive: this.props.isInactive
        };
        let classes = "quiz-question";
        if (this.props.isInactive) classes += " inactive-quiz-question";
        let questionAnswerComponent = null;
        switch(this.props.questionUnit.answerFormat){
            case $9dba7d2357a40545$require$constants.questionUnit.ANSWER_FORMAT.SENTENCE_COMPLETION:
                if ($dc99b7806b365357$exports.questionUnit.isRankQuestion(this.props.questionUnit)) questionAnswerComponent = /*#__PURE__*/ (0, $ayMG0.jsx)($7aeefb8b36f84f82$exports, {
                    ...questionAnswerComponentProps
                });
                else {
                    classes += " sentence-completion-question";
                    questionAnswerComponent = /*#__PURE__*/ (0, $ayMG0.jsx)($e4cf000d7ca2f84e$exports, {
                        ...questionAnswerComponentProps
                    });
                }
                break;
            case $9dba7d2357a40545$require$constants.questionUnit.ANSWER_FORMAT.SPECTRUM:
                classes += " spectrum-question";
                questionAnswerComponent = /*#__PURE__*/ (0, $ayMG0.jsx)($3a676e1754637682$exports, {
                    ...questionAnswerComponentProps
                });
                break;
            default:
                break;
        }
        const hasQuestionResponse = $dc99b7806b365357$exports.questionUnit.hasQuestionResponse(this.props.questionUnit);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: classes,
            children: [
                this.props.questionUnit.text && /*#__PURE__*/ (0, $ayMG0.jsx)($3dea5c212b41ff4a$exports, {
                    text: this.props.t(this.props.questionUnit.text)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($2a4aca759c03a70a$exports, {
                    component: questionAnswerComponent
                }),
                hasQuestionResponse && /*#__PURE__*/ (0, $ayMG0.jsx)($e6c0631edb47e18c$exports, {
                    showResponse: this.props.showResponse,
                    questionUnit: tokenizedQuestionUnit,
                    questionAnswer: this.props.questionAnswer
                }),
                this.props.questionUnit.id === $9dba7d2357a40545$require$constants.quiz.officeLocationQuestionId && !this.props.isInactive && /*#__PURE__*/ (0, $ayMG0.jsx)($cce78554523b012f$exports, {
                    label: this.props.t("locatedSomewhereElseLabel"),
                    onChange: this.props.toggleSameOfficeAndPersonalLocation,
                    inQuiz: true,
                    checked: !this.props.isSameOfficeAndPersonalLocation
                })
            ]
        });
    }
}
$9dba7d2357a40545$var$Question.propTypes = {
    questionUnit: $3e58c681e2cb99b8$exports.questionUnitShape.isRequired,
    questionAnswer: $3e58c681e2cb99b8$exports.questionAnswerTypes,
    onAnswerChange: $c9Z8w.func,
    showResponse: $c9Z8w.bool,
    isInactive: $c9Z8w.bool,
    isSameOfficeAndPersonalLocation: $c9Z8w.bool,
    toggleSameOfficeAndPersonalLocation: $c9Z8w.func,
    t: $c9Z8w.func.isRequired
};
$9dba7d2357a40545$var$Question.defaultProps = {
    onAnswerChange: $f1q41.noop,
    questionAnswer: "",
    showResponse: false,
    isInactive: false,
    isSameOfficeAndPersonalLocation: true,
    toggleSameOfficeAndPersonalLocation: $f1q41.noop
};
$9dba7d2357a40545$exports = $9dba7d2357a40545$require$withTranslation("quizPage")($9dba7d2357a40545$var$Question);


function $9f0ba92c10998254$var$HeroProfileQuestion(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "hero-question",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($9dba7d2357a40545$exports, {
            questionUnit: props.questionUnit,
            questionAnswer: props.questionAnswer,
            onAnswerChange: props.onAnswerChange
        })
    });
}
$9f0ba92c10998254$var$HeroProfileQuestion.propTypes = {
    questionUnit: $3e58c681e2cb99b8$exports.questionUnitShape.isRequired,
    questionAnswer: $3e58c681e2cb99b8$exports.questionAnswerTypes,
    onAnswerChange: $c9Z8w.func.isRequired
};
$9f0ba92c10998254$exports = $9f0ba92c10998254$var$HeroProfileQuestion;


const $9bd5e620d29e9898$var$initialQuestionId = "10";
const $9bd5e620d29e9898$var$initialQuestionIndex = $9bd5e620d29e9898$var$quizOrder.indexOf($9bd5e620d29e9898$var$initialQuestionId);
// Map state to props
function $9bd5e620d29e9898$var$mapStateToProps(state) {
    return {
        // for determining previous answers
        questionUnit: $9bd5e620d29e9898$require$questionUnitUtil.getQuestionUnit($9bd5e620d29e9898$var$initialQuestionIndex),
        questionAnswer: state.profileQuiz.userQuizAnswers[$9bd5e620d29e9898$var$initialQuestionId]
    };
}
// Map dispatch to props
function $9bd5e620d29e9898$var$mapDispatchToProps(dispatch) {
    const answerProfileQuestion = $9bd5e620d29e9898$require$bindActionCreators($91d5e1f7c4d12efe$exports.answerProfileQuestion, dispatch);
    return {
        // answer question functions
        onAnswerChange: (updatedQuestionAnswer)=>answerProfileQuestion($9bd5e620d29e9898$var$initialQuestionId, updatedQuestionAnswer)
    };
}
$9bd5e620d29e9898$exports = $9bd5e620d29e9898$require$connect($9bd5e620d29e9898$var$mapStateToProps, $9bd5e620d29e9898$var$mapDispatchToProps)($9f0ba92c10998254$exports);




var $4b371f38060119be$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $4b371f38060119be$var$LandingPageSecondaryHero(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($81e115b62a8073a8$exports, {
        sizeClass: "is-small",
        isLightColor: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "columns level",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "column is-two-fifths has-padding-bottom-1 has-padding-top-1 is-hidden-mobile",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("figure", {
                        className: "image is-4by3 is-hidden-mobile",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: "/svg/illustrations/landing-page/homepage-building-results-spacer-by-cbre.svg",
                            alt: props.t("landingPageSecondaryHeroImgAlt")
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "column",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "title is-3 is-5-mobile has-text-primary has-padding-left-3 has-no-padding-mobile",
                            children: props.t("landingPageSecondaryHeroTitle")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($9bd5e620d29e9898$exports, {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "has-padding-left-3 has-padding-top-1 has-padding-top-3-mobile has-padding-bottom-3-mobile has-no-padding-left-mobile",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($a30d198abc11571e$exports, {})
                        })
                    ]
                })
            ]
        })
    });
}
$4b371f38060119be$var$LandingPageSecondaryHero.propTypes = {
    t: $c9Z8w.func.isRequired
};
$4b371f38060119be$exports = $4b371f38060119be$require$withTranslation("landingPage")($4b371f38060119be$var$LandingPageSecondaryHero);


var $d1dcc206415ef960$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $aB89e = parcelRequire("aB89e");
var $d1dcc206415ef960$require$constants = $aB89e.spacerFree;

var $lzNIT = parcelRequire("lzNIT");
var $d1dcc206415ef960$require$Link = $lzNIT.Link;
var $0d293be9728cb533$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
function $0d293be9728cb533$var$ExternalLink(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        href: props.href,
        target: "_blank",
        rel: "noopener noreferrer",
        onMouseDown: (evt)=>evt.stopPropagation(),
        children: props.children
    });
}
$0d293be9728cb533$var$ExternalLink.propTypes = {
    href: $c9Z8w.string.isRequired,
    children: $c9Z8w.oneOfType([
        $c9Z8w.string,
        $c9Z8w.node // link is an element (e.g., <img>)
    ]).isRequired
};
$0d293be9728cb533$exports = $0d293be9728cb533$var$ExternalLink;


var $65cd9dd502e03f27$exports = {};

var $ayMG0 = parcelRequire("ayMG0");


var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $56juP = parcelRequire("56juP");

var $65cd9dd502e03f27$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;

var $65cd9dd502e03f27$require$supportedLanguages = $4202a5939499f6a1$exports.supportedLanguages;

var $65cd9dd502e03f27$require$updateCurrentLanguage = $5f15cdd5de4823b1$exports.updateCurrentLanguage;
var $65cd9dd502e03f27$require$getCurrentLanguage = $5f15cdd5de4823b1$exports.getCurrentLanguage;

var $jHTLJ = parcelRequire("jHTLJ");
var $65cd9dd502e03f27$require$connect = $jHTLJ.connect;

var $eShmq = parcelRequire("eShmq");
var $65cd9dd502e03f27$require$bindActionCreators = $eShmq.bindActionCreators;


var $3GYAO = parcelRequire("3GYAO");
const $65cd9dd502e03f27$var$DROPDOWN_PADDING = 25;
const $65cd9dd502e03f27$var$optionOrder = Object.keys($65cd9dd502e03f27$require$supportedLanguages);
const $65cd9dd502e03f27$var$isInactive = false;
class $65cd9dd502e03f27$var$LanguageSelector extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            value: props.i18n.language,
            highlightedOptionId: null,
            dropdownActive: false
        };
        this.props.onLanguageChange(props.i18n.language);
        this.optionElements = {};
        this.registerKeyPress = this.registerKeyPress.bind(this);
        this.mouseMoveOnOptionField = this.mouseMoveOnOptionField.bind(this);
    }
    onValueChange(value) {
        this.props.onLanguageChange(value);
        this.props.i18n.changeLanguage(value);
        $65cd9dd502e03f27$require$updateCurrentLanguage(value);
        this.setState({
            value: value
        });
        window.scroll(0, 0);
    }
    setValue(value) {
        return (evt)=>{
            evt.preventDefault();
            this.onValueChange(value);
            $3GYAO.GAEvent($65cd9dd502e03f27$require$supportedLanguages[value], $65cd9dd502e03f27$require$supportedLanguages[value], $65cd9dd502e03f27$require$supportedLanguages[value]);
            this.toggleDropdown(false);
        };
    }
    scrollOptionIntoView() {
        if (this.state.highlightedOptionId && this.optionElements[this.state.highlightedOptionId]) this.optionElements[this.state.highlightedOptionId].scrollIntoView({
            block: "nearest"
        });
    }
    shiftHighlightedOptionDown() {
        this.setState((prevState)=>{
            const oldIndex = $65cd9dd502e03f27$var$optionOrder.indexOf(prevState.highlightedOptionId);
            if (oldIndex === $65cd9dd502e03f27$var$optionOrder.length - 1) return null;
            return {
                highlightedOptionId: $65cd9dd502e03f27$var$optionOrder[oldIndex + 1]
            };
        }, this.scrollOptionIntoView);
    }
    shiftHighlightedOptionUp() {
        this.setState((prevState)=>{
            const oldIndex = $65cd9dd502e03f27$var$optionOrder.indexOf(prevState.highlightedOptionId);
            if (oldIndex === 0) return null;
            const newIndex = oldIndex === -1 ? $65cd9dd502e03f27$var$optionOrder.length - 1 : oldIndex - 1;
            return {
                highlightedOptionId: $65cd9dd502e03f27$var$optionOrder[newIndex]
            };
        }, this.scrollOptionIntoView);
    }
    registerKeyPress(evt) {
        switch(evt.which){
            case $c65935c63c29746a$exports.ENTER:
                if (!this.state.dropdownActive) return this.toggleDropdown(true);
                evt.target.blur();
                evt.stopPropagation();
                if (this.state.highlightedOptionId) this.setValue(this.state.highlightedOptionId)(evt);
                else this.toggleDropdown(false);
                return null;
            case $c65935c63c29746a$exports.DOWN_ARROW:
                evt.preventDefault();
                if (!this.state.dropdownActive) return this.toggleDropdown(true);
                return this.shiftHighlightedOptionDown();
            case $c65935c63c29746a$exports.UP_ARROW:
                evt.preventDefault();
                return this.shiftHighlightedOptionUp(true);
            default:
                this.setState({
                    dropdownActive: true
                });
                return null;
        }
    }
    mouseMoveOnOptionField(value) {
        return ()=>{
            if (this.state.highlightedOptionId !== value) this.setState({
                highlightedOptionId: value
            });
        };
    }
    toggleDropdown(showDropdown) {
        this.setState({
            dropdownActive: showDropdown,
            highlightedOptionId: this.state.value
        }, ()=>{
            if (showDropdown) this.scrollOptionIntoView();
        });
    }
    render() {
        let dropdownMenuStyles;
        if (this.dropdownInput) dropdownMenuStyles = {
            maxHeight: $56juP.getSpaceBelow(this.dropdownInput) - $65cd9dd502e03f27$var$DROPDOWN_PADDING,
            overflow: "auto"
        };
        let dropdownWrapperClasses = "dropdown";
        if (this.state.dropdownActive) dropdownWrapperClasses += " is-active";
        let dropdownSelectionClasses = "underline-input";
        if ($65cd9dd502e03f27$var$isInactive) dropdownSelectionClasses += " is-inactive";
        const dropdownElements = $65cd9dd502e03f27$var$optionOrder.map((optionId)=>{
            const key = `option-${optionId}`;
            const selected = this.state.value === optionId;
            let dropdownItemClasses = "dropdown-item";
            if (selected) dropdownItemClasses += " is-active";
            if (this.state.highlightedOptionId === optionId) dropdownItemClasses += " hover";
            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "option",
                "aria-selected": selected,
                tabIndex: optionId,
                className: dropdownItemClasses,
                onMouseDown: this.setValue(optionId),
                onMouseMove: this.mouseMoveOnOptionField(optionId),
                ref: (option)=>{
                    this.optionElements[optionId] = option;
                },
                children: $65cd9dd502e03f27$require$supportedLanguages[optionId]
            }, key);
        });
        const dropdownContentClasses = "dropdown-content";
        const { currentLanguage: currentLanguage } = this.props;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: dropdownWrapperClasses,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "dropdown-button-wrapper",
                    role: "button",
                    tabIndex: "0",
                    "aria-haspopup": "true",
                    "aria-controls": "dropdown-menu",
                    onKeyDown: this.registerKeyPress,
                    onBlur: ()=>this.toggleDropdown(false),
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: dropdownSelectionClasses,
                        role: "button",
                        tabIndex: "-1",
                        "aria-haspopup": "true",
                        "aria-controls": "dropdown-menu",
                        onMouseDown: ()=>this.toggleDropdown(true),
                        ref: (node)=>{
                            this.dropdownInput = node;
                        },
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: $65cd9dd502e03f27$require$supportedLanguages[currentLanguage]
                            }),
                            this.state.dropdownActive ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "dropdown-triangle-up"
                            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "dropdown-triangle"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "dropdown-menu is-primary",
                    role: "button",
                    tabIndex: "-1",
                    id: "dropdown-menu",
                    onKeyDown: this.registerKeyPress,
                    onMouseLeave: ()=>this.setState({
                            highlightedOptionId: null
                        }),
                    style: dropdownMenuStyles,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: dropdownContentClasses,
                        role: "listbox",
                        children: dropdownElements
                    })
                })
            ]
        });
    }
}
$65cd9dd502e03f27$var$LanguageSelector.propTypes = {
    i18n: $c9Z8w.object.isRequired
};
function $65cd9dd502e03f27$var$mapStateToProps(state) {
    return {
        currentLanguage: state.userData.language
    };
}
function $65cd9dd502e03f27$var$mapDispatchToProps(dispatch) {
    const changeSLanguage = $65cd9dd502e03f27$require$bindActionCreators((0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).changeSLanguage, dispatch);
    return {
        onLanguageChange: (val)=>changeSLanguage(val)
    };
}
$65cd9dd502e03f27$exports = $65cd9dd502e03f27$require$withTranslation("common")($65cd9dd502e03f27$require$connect($65cd9dd502e03f27$var$mapStateToProps, $65cd9dd502e03f27$var$mapDispatchToProps)($65cd9dd502e03f27$var$LanguageSelector));



var $d1dcc206415ef960$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;


var $3GYAO = parcelRequire("3GYAO");
function $d1dcc206415ef960$var$Footer(props) {
    $acw62.useEffect(()=>{
        console.log(typeof window.OneTrust?.initializeCookiePolicyHtml);
        if (typeof window.OneTrust?.initializeCookiePolicyHtml === "function") window.OneTrust?.initializeCookiePolicyHtml();
    }, [
        window.OneTrust
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("footer", {
        role: "contentinfo",
        className: "footer content is-small",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "columns has-margin-top-2 has-no-margin-top-mobile",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "column is-one-quarter",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: "/",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: "/svg/logos/dark-cbre-logo-spacer-by-cbre.svg",
                                    alt: props.t("footerCBRELogoAlt"),
                                    className: "has-margin-bottom-2 has-padding-right-3 has-no-margin-bottom-mobile"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "social-media-icons",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($0d293be9728cb533$exports, {
                                        href: "https://www.facebook.com/cbre/",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "has-margin-right-4",
                                            src: "/svg/icons/social-media/facebook-social-icon-spacer-by-cbre.svg",
                                            alt: props.t("footerFacebookIconAlt")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($0d293be9728cb533$exports, {
                                        href: "https://twitter.com/CBREworkplace",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "has-margin-right-4",
                                            src: "/svg/icons/social-media/twitter-social-icon-spacer-by-cbre.svg",
                                            alt: props.t("footerTwitterIconAlt")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($0d293be9728cb533$exports, {
                                        href: props.t("footerLinkedinLink"),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            className: "has-margin-right-4",
                                            src: "/svg/icons/social-media/linkedin-social-icon-spacer-by-cbre.svg",
                                            alt: props.t("footerLinkedinIconAlt")
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "column is-three-quarters",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "columns is-mobile is-multiline",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "column is-one-quarter-desktop is-half-mobile",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "footer-header",
                                            children: props.t("footerHeaderQuestionsText")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                            href: `mailto:${props.t("spacerSupportEmail")}`,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "footer-link",
                                                children: $d1dcc206415ef960$require$constants.contact.SPACER_SUPPORT_EMAIL
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "column is-one-quarter-desktop is-half-mobile",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "footer-header",
                                            children: props.t("footerHeaderAboutText")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($d1dcc206415ef960$require$Link, {
                                            to: "/about-spacer-by-cbre",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "footer-link",
                                                children: props.t("footerLinkWhatIsSpacerText")
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($d1dcc206415ef960$require$Link, {
                                            to: "/insights-spacer-by-cbre",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "footer-link",
                                                children: props.t("footerLinkBlogText")
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($0d293be9728cb533$exports, {
                                            href: props.t("footerWorkplaceLink"),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "footer-link",
                                                children: props.t("footerLinkWorkplaceText")
                                            })
                                        }),
                                        props.lng == "de" && /*#__PURE__*/ (0, $ayMG0.jsx)($0d293be9728cb533$exports, {
                                            href: props.t("footerWorkplaceLinkForDE"),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "footer-link",
                                                children: props.t("footerLinkWorkplaceTextForDE")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "column is-one-quarter-desktop is-half-mobile terms-and-privacy-footer-section",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "footer-header",
                                            children: props.t("footerHeaderMoreText")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($65cd9dd502e03f27$exports, {}),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($d1dcc206415ef960$require$Link, {
                                            to: "/terms-spacer-by-cbre",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "footer-link",
                                                children: props.t("footerLinkTermsText")
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($0d293be9728cb533$exports, {
                                            href: props.t("footerPrivacyLink"),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "footer-link",
                                                children: props.t("footerLinkPrivacyText")
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            id: "ot-sdk-btn",
                                            className: "ot-sdk-show-settings footer-cookie-link",
                                            children: "Cookie Settings"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "column is-one-quarter-desktop is-half-mobile",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "footer-header",
                                            children: props.t("footerHeaderBrokersText")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($d1dcc206415ef960$require$Link, {
                                            to: "/referral",
                                            onClick: ()=>{
                                                $3GYAO.GAEvent($3a61343632c866bc$exports.categories.referals, $3a61343632c866bc$exports.actions.referal, $3a61343632c866bc$exports.labels.referal);
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "footer-link",
                                                children: props.t("footerLinkReferralText")
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
$d1dcc206415ef960$var$Footer.propTypes = {
    t: $c9Z8w.func.isRequired
};
$d1dcc206415ef960$exports = $d1dcc206415ef960$require$withTranslation("common")($d1dcc206415ef960$var$Footer);


var $8fd8dbed19be5bf4$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");
var $8fd8dbed19be5bf4$require$Link = $lzNIT.Link;

var $c9Z8w = parcelRequire("c9Z8w");

var $8fd8dbed19be5bf4$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;

var $56juP = parcelRequire("56juP");
var $4e7513a104520779$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $4e7513a104520779$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $4e7513a104520779$var$BasicNavbar(props) {
    let classes = `navbar ${props.isDark ? "is-tertiary" : "is-light-gray"}`;
    let logoUrl = props.isDark ? "/svg/logos/spacer_logo_white.svg" : "/svg/logos/spacer_logo.svg";
    if (props.isInQuiz) classes += " in-quiz";
    return /*#__PURE__*/ (0, $ayMG0.jsx)("header", {
        className: classes,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "navbar-brand",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        className: "navbar-item cbre-spacer-logo",
                        href: "/",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: logoUrl,
                            alt: "CBRE Spacer"
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("nav", {
                    "aria-label": "Main",
                    className: "navbar-menu",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                            className: "navbar-start",
                            children: props.navBarStartElements
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                            className: "navbar-end",
                            children: props.children
                        })
                    ]
                })
            ]
        })
    });
}
$4e7513a104520779$var$BasicNavbar.propTypes = {
    children: $c9Z8w.node,
    isDark: $c9Z8w.bool,
    isInQuiz: $c9Z8w.bool,
    navBarStartElements: $c9Z8w.arrayOf($c9Z8w.element),
    t: $c9Z8w.func.isRequired
};
$4e7513a104520779$var$BasicNavbar.defaultProps = {
    children: null,
    isDark: false,
    isInQuiz: false,
    navBarStartElements: []
};
$4e7513a104520779$exports = $4e7513a104520779$require$withTranslation("common")($4e7513a104520779$var$BasicNavbar);




function $8fd8dbed19be5bf4$var$BasicNavbarWithLinks(props) {
    const [hamburgerBarOpen, setHamburgerBarOpen] = $acw62.useState(false);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($4e7513a104520779$exports, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "navbar-item has-margin-right-4 language-dropdown-top",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($65cd9dd502e03f27$exports, {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "navbar-item has-margin-right-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($8fd8dbed19be5bf4$require$Link, {
                    to: "/about-spacer-by-cbre",
                    children: props.t("linkToAboutPageText")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "navbar-item has-margin-right-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($8fd8dbed19be5bf4$require$Link, {
                    to: "/insights-spacer-by-cbre",
                    children: props.t("linkToBlogPageText")
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "navbar-item is-mobile",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($a30d198abc11571e$exports, {})
            }),
            $56juP.isScreenMobileSize() && /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                className: "navbar-item is-mobile",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: `${hamburgerBarOpen ? "hamburger-bar-open" : "hamburger-bar"}`,
                        onClick: ()=>setHamburgerBarOpen(!hamburgerBarOpen)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: `flex flex-col hamburger-bar-menu ${hamburgerBarOpen ? "" : "is-hidden"}`,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($8fd8dbed19be5bf4$require$Link, {
                                to: "/about-spacer-by-cbre",
                                children: props.t("linkToAboutPageText")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($8fd8dbed19be5bf4$require$Link, {
                                to: "/insights-spacer-by-cbre",
                                children: props.t("linkToBlogPageText")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
$8fd8dbed19be5bf4$var$BasicNavbarWithLinks.propTypes = {
    t: $c9Z8w.func.isRequired
};
$8fd8dbed19be5bf4$exports = $8fd8dbed19be5bf4$require$withTranslation("common")($8fd8dbed19be5bf4$var$BasicNavbarWithLinks);


var $9f69955d1adfb55f$exports = {};

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $f01f96e978650835$exports = {};

var $aB89e = parcelRequire("aB89e");
var $f01f96e978650835$require$constants = $aB89e.spacerFree;
$f01f96e978650835$exports = {
    [$f01f96e978650835$require$constants.siteLocation.PAGE.LANDING]: {
        titleToken: "landingPageTitle",
        metaTagToken: "landingPageMetaTagText"
    },
    [$f01f96e978650835$require$constants.siteLocation.PAGE.ABOUT]: {
        titleToken: "aboutPageTitle",
        metaTagToken: "aboutPageMetaTagText"
    },
    [$f01f96e978650835$require$constants.siteLocation.PAGE.TERMS]: {
        titleToken: "termsPageTitle",
        metaTagToken: "termsPageMetaTagText"
    },
    [$f01f96e978650835$require$constants.siteLocation.PAGE.QUIZ]: {
        titleToken: "quizPageTitle",
        metaTagToken: "quizPageMetaTagText"
    },
    [$f01f96e978650835$require$constants.siteLocation.PAGE.RESULTS]: {
        titleToken: "resultsPageTitle",
        metaTagToken: "resultsPageMetaTagText"
    },
    [$f01f96e978650835$require$constants.siteLocation.PAGE.PROFILE_COMPARISON]: {
        titleToken: "profileComparisonPageTitle",
        metaTagToken: "profileComparisonPageMetaTagText"
    },
    [$f01f96e978650835$require$constants.siteLocation.PAGE.BLOG_HOME]: {
        titleToken: "blogHomePageTitle",
        metaTagToken: "blogHomePageMetaTagText"
    },
    [$f01f96e978650835$require$constants.siteLocation.PAGE.REFERRAL]: {
        titleToken: "referralPageTitle",
        metaTagToken: "referralPageMetaTagText"
    },
    [$f01f96e978650835$require$constants.siteLocation.PAGE.REFERRAL_RETRIEVE]: {
        titleToken: "referralRetrievePageTitle",
        metaTagToken: "referralRetrieveMetaTagText"
    },
    [$f01f96e978650835$require$constants.siteLocation.PAGE.BLOG_ARTICLE_20190621]: {
        titleToken: `${$f01f96e978650835$require$constants.siteLocation.PAGE.BLOG_ARTICLE_20190621}:pageTitle`,
        metaTagToken: `${$f01f96e978650835$require$constants.siteLocation.PAGE.BLOG_ARTICLE_20190621}:metaTagText`
    },
    [$f01f96e978650835$require$constants.siteLocation.PAGE.BLOG_ARTICLE_20190625]: {
        titleToken: `${$f01f96e978650835$require$constants.siteLocation.PAGE.BLOG_ARTICLE_20190625}:pageTitle`,
        metaTagToken: `${$f01f96e978650835$require$constants.siteLocation.PAGE.BLOG_ARTICLE_20190625}:metaTagText`
    },
    [$f01f96e978650835$require$constants.siteLocation.PAGE.BLOG_ARTICLE_20190627]: {
        titleToken: `${$f01f96e978650835$require$constants.siteLocation.PAGE.BLOG_ARTICLE_20190627}:pageTitle`,
        metaTagToken: `${$f01f96e978650835$require$constants.siteLocation.PAGE.BLOG_ARTICLE_20190627}:metaTagText`
    }
};



var $9f69955d1adfb55f$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
class $9f69955d1adfb55f$var$DocumentData extends $acw62.Component {
    componentDidMount() {
        const { titleToken: titleToken, metaTagToken: metaTagToken } = $f01f96e978650835$exports[this.props.siteLocation];
        document.title = this.props.t(titleToken);
        document.getElementById("dynamic-description").content = this.props.t(metaTagToken);
    }
    render() {
        return null;
    }
}
$9f69955d1adfb55f$var$DocumentData.propTypes = {
    siteLocation: $c9Z8w.string.isRequired,
    t: $c9Z8w.func.isRequired
};
$9f69955d1adfb55f$exports = $9f69955d1adfb55f$require$withTranslation("common")($9f69955d1adfb55f$var$DocumentData);



var $aB89e = parcelRequire("aB89e");
var $2f32009932987788$require$constants = $aB89e.spacerFree;

var $2f32009932987788$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $2f32009932987788$var$LandingPage(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "landing-page",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9f69955d1adfb55f$exports, {
                siteLocation: $2f32009932987788$require$constants.siteLocation.PAGE.LANDING
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8fd8dbed19be5bf4$exports, {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($2fb84f33f8bbcebd$exports, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($c47f6775379e994e$exports, {}),
                    props.i18n.language === "nld" && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $13f86dec8236346a$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($4b371f38060119be$exports, {})
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($d1dcc206415ef960$exports, {})
        ]
    });
}
$2f32009932987788$exports = $2f32009932987788$require$withTranslation("common")($2f32009932987788$var$LandingPage);


var $be6158963e52745f$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $b664f3b8c7958f69$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $c9Z8w = parcelRequire("c9Z8w");

var $b664f3b8c7958f69$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $b664f3b8c7958f69$var$AboutPageHero(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($81e115b62a8073a8$exports, {
        sizeClass: "is-small",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "columns level",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "column is-5 level-item",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("figure", {
                            className: "image is-4by3",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: "/svg/illustrations/about-page/about-page-office-move-spacer-by-cbre.svg",
                                alt: props.t("aboutPageHeroImgAlt")
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "column is-7",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "title has-text-primary is-financier-regular",
                        children: props.t("aboutPageHeroTitle")
                    })
                })
            ]
        })
    });
}
$b664f3b8c7958f69$var$AboutPageHero.propTypes = {
    t: $c9Z8w.func.isRequired
};
$b664f3b8c7958f69$exports = $b664f3b8c7958f69$require$withTranslation("aboutPage")($b664f3b8c7958f69$var$AboutPageHero);


var $693cc242b92293b3$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $aB89e = parcelRequire("aB89e");
var $693cc242b92293b3$require$constants = $aB89e.spacerFree;
var $3930bcf45abc5e7c$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $3930bcf45abc5e7c$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $3930bcf45abc5e7c$var$CallToActionBanner(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
            className: "section",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "columns level",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "column is-half level-item",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "flex flex-col has-text-centered",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "title is-2 level-item is-calibre",
                                    children: props.t("aboutPageContentEndSectionTitle")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($a30d198abc11571e$exports, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "column is-half level-item is-hidden-mobile",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("figure", {
                            className: "image",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: "/png/homepage-results-page-in-browser-spacer-by-cbre.png",
                                alt: props.t("aboutPageProgramPreviewImgAlt")
                            })
                        })
                    })
                ]
            })
        })
    });
}
$3930bcf45abc5e7c$var$CallToActionBanner.propTypes = {
    t: $c9Z8w.func.isRequired
};
$3930bcf45abc5e7c$exports = $3930bcf45abc5e7c$require$withTranslation("aboutPage")($3930bcf45abc5e7c$var$CallToActionBanner);


var $82152b43fbaba050$exports = {};
$82152b43fbaba050$exports = {
    getPageSections () {
        return [
            {
                title: "aboutPageContent1Title",
                text: "aboutPageContent1Text",
                image: "/svg/illustrations/about-page/about-page-people-talking-spacer-by-cbre.png",
                imageAlt: "aboutPageContent1ImgAlt"
            },
            {
                title: "aboutPageContent2Title",
                list: [
                    "aboutPageContent2List1",
                    "aboutPageContent2List2",
                    "aboutPageContent2List3",
                    "aboutPageContent2List4",
                    "aboutPageContent2List5"
                ],
                text: "aboutPageContent2Text",
                image: "/svg/illustrations/about-page/about-page-girl-working-spacer-by-cbre.png",
                imageAlt: "aboutPageContent2ImgAlt",
                addEmailLink: true
            }
        ];
    }
};



var $693cc242b92293b3$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $693cc242b92293b3$var$getTextSection(pageSection, t) {
    const titleText = t(pageSection.title);
    let listSection;
    let paragraphSection;
    if (pageSection.list) listSection = /*#__PURE__*/ (0, $ayMG0.jsx)("ol", {
        className: "has-margin-bottom-5",
        children: pageSection.list.map((listItem)=>/*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                className: "has-margin-bottom-7 has-margin-left-6 has-padding-left-7",
                children: t(listItem)
            }, listItem.substring(0, 25)))
    }, `${titleText}_list`);
    if (pageSection.text) {
        const paragraphs = pageSection.text.split("\n");
        const numParagraphs = paragraphs.length - 1;
        let paragraphText;
        paragraphSection = paragraphs.map((paragraph, i)=>(paragraphText = t(paragraph).split("\n"), /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "has-margin-bottom-7",
                children: [
                    paragraphText.map((val, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: val
                        }, index)),
                    pageSection.addEmailLink && i === numParagraphs && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: `mailto:${$693cc242b92293b3$require$constants.contact.SPACER_SUPPORT_EMAIL}`,
                                children: t("aboutPageSpacerSupportLink")
                            }),
                            "."
                        ]
                    })
                ]
            }, paragraph.substring(0, 25))));
    }
    return [
        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
            className: "subtitle has-margin-bottom-4",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                children: titleText
            })
        }, titleText.substring(0, 25)),
        listSection,
        paragraphSection
    ];
}
function $693cc242b92293b3$var$wrapGetPageSectionWithT(t) {
    return function getPageSection(pageSection, pageSectionIndex) {
        const isEven = pageSectionIndex % 2 === 0;
        const textColumn = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "column is-half level-item",
            children: $693cc242b92293b3$var$getTextSection(pageSection, t)
        }, `${pageSectionIndex}_${pageSection.title.substring(0, 10)}`);
        let imageClasses = "column is-half level-item";
        if (!isEven) imageClasses += " is-hidden-mobile";
        const imageColumn = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: imageClasses,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("figure", {
                className: "image",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: pageSection.image,
                    alt: pageSection.imageAlt,
                    className: "about-page-content-illustration"
                })
            })
        }, pageSection.imageAlt);
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: isEven ? "" : "is-white",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "container has-padding-left-1 has-padding-right-1 has-no-padding-mobile",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                    className: "section",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "columns level",
                        children: isEven ? [
                            textColumn,
                            imageColumn
                        ] : [
                            imageColumn,
                            textColumn
                        ]
                    })
                })
            })
        }, pageSectionIndex);
    };
}
function $693cc242b92293b3$var$AboutPageContent(props) {
    const pageSections = $82152b43fbaba050$exports.getPageSections();
    const getPageSectionWithT = $693cc242b92293b3$var$wrapGetPageSectionWithT(props.t);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "about-page",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "is-white",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "container has-padding-left-1 has-padding-right-1 has-no-padding-mobile",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("section", {
                        className: "section flex flex-justify-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "about-page-video",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "subtitle has-margin-bottom-4",
                                    children: props.t("aboutPageVideoTitle")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "iframe-container",
                                    lang: "en",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("iframe", {
                                        title: "Video: Determine the Right Amount of Space for Your Next Office With Spacer",
                                        src: "https://www.youtube.com/embed/UFEcTJr4QyA?modestbranding=1&rel=0&mute=1",
                                        // url params: modestbranding to take away youtube logos
                                        // rel to take away video recommendations at end of video
                                        // mute to default to a muted video
                                        width: "100%",
                                        height: "100%",
                                        allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                                        frameBorder: "0",
                                        allowFullScreen: true
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            pageSections.map(getPageSectionWithT),
            /*#__PURE__*/ (0, $ayMG0.jsx)($3930bcf45abc5e7c$exports, {})
        ]
    });
}
$693cc242b92293b3$var$AboutPageContent.propTypes = {
    t: $c9Z8w.func.isRequired
};
$693cc242b92293b3$exports = $693cc242b92293b3$require$withTranslation("aboutPage")($693cc242b92293b3$var$AboutPageContent);





var $aB89e = parcelRequire("aB89e");
var $be6158963e52745f$require$constants = $aB89e.spacerFree;
function $be6158963e52745f$var$AboutPage() {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9f69955d1adfb55f$exports, {
                siteLocation: $be6158963e52745f$require$constants.siteLocation.PAGE.ABOUT
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8fd8dbed19be5bf4$exports, {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($b664f3b8c7958f69$exports, {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($693cc242b92293b3$exports, {})
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($d1dcc206415ef960$exports, {})
        ]
    });
}
$be6158963e52745f$exports = $be6158963e52745f$var$AboutPage;


var $1c992f1332d56f69$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $f1q41 = parcelRequire("f1q41");

var $8g1PZ = parcelRequire("8g1PZ");

var $1c992f1332d56f69$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;




var $e35ef451741691fb$exports = {};
var $1b2c268833ed976a$exports = {};
$1b2c268833ed976a$exports = {
    SIZE_AND_FIT: "sizeAndFit",
    OFFICE_CULTURE: "officeCulture",
    SPACE_AND_DESIGN: "spaceAndDesign",
    WORKPLACE_TRENDS: "workplaceTrends"
};


$e35ef451741691fb$exports = [
    // articles for the blog
    {
        author: "Lauren Popish",
        date: "2019-06-21",
        tags: [
            $1b2c268833ed976a$exports.OFFICE_CULTURE
        ],
        image: "blog-2019-06-21.jpg",
        slug: "why-defining-your-perfect-office-matters",
        namespace: "blogArticle20190621"
    },
    {
        author: "Lauren Popish",
        date: "2019-06-25",
        tags: [],
        image: "blog-2019-06-25.jpg",
        slug: "how-does-spacer-work",
        namespace: "blogArticle20190625"
    },
    {
        author: "Lauren Popish",
        date: "2019-06-27",
        tags: [
            $1b2c268833ed976a$exports.SIZE_AND_FIT
        ],
        image: "blog-2019-06-27.jpg",
        slug: "difference-between-usable-rentable-square-feet",
        namespace: "blogArticle20190627"
    }
];




var $aB89e = parcelRequire("aB89e");
var $1c992f1332d56f69$require$constants = $aB89e.spacerFree;
var $8342358ddc90760a$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $lzNIT = parcelRequire("lzNIT");
var $8342358ddc90760a$require$Link = $lzNIT.Link;

var $8342358ddc90760a$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $8342358ddc90760a$var$BlogArticlePreview(props) {
    const { date: date, image: image, author: author, namespace: namespace, slug: slug } = props.article;
    // blogtodo: format date differently in different countries / prep for internationalization
    const dateString = new Date(date).toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric"
    });
    const articleHref = `/insights-spacer-by-cbre/${slug}`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($8342358ddc90760a$require$Link, {
        to: articleHref,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "blog-article-preview",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("figure", {
                    className: "image",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: `/jpg/blogArticles/${image}`,
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "has-padding-7",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "content is-small has-text-grey is-sans-medium",
                            children: `${dateString} by ${author}`
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                            className: "subtitle blog-link",
                            children: props.t(`${namespace}:title`)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "blog-article-preview-content",
                            children: props.t(`${namespace}:preview`)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "blog-link is-sans-medium",
                            href: articleHref,
                            children: "Continue Reading"
                        })
                    ]
                })
            ]
        })
    });
}
$8342358ddc90760a$var$BlogArticlePreview.propTypes = {
    t: $c9Z8w.func.isRequired,
    article: $c9Z8w.shape({
        date: $c9Z8w.string.isRequired,
        image: $c9Z8w.string.isRequired,
        author: $c9Z8w.string.isRequired,
        namespace: $c9Z8w.string.isRequired,
        slug: $c9Z8w.string.isRequired
    }).isRequired
};
$8342358ddc90760a$exports = $8342358ddc90760a$require$withTranslation("blogArticles")($8342358ddc90760a$var$BlogArticlePreview);


function $1c992f1332d56f69$var$BlogHome(props) {
    const [activeTag, setActiveTag] = $acw62.useState("");
    const tabs = [
        {
            value: "",
            text: props.t("blogTagAllArticles")
        },
        {
            value: $1b2c268833ed976a$exports.SIZE_AND_FIT,
            text: props.t("blogTagSizeAndFit")
        },
        {
            value: $1b2c268833ed976a$exports.OFFICE_CULTURE,
            text: props.t("blogTagOfficeCulture")
        }
    ];
    const filteredBlogPosts = $f1q41.filter($e35ef451741691fb$exports, (article)=>!activeTag || article.tags.indexOf(activeTag) > -1);
    const blogPostsSortedByDate = $f1q41.reverse($f1q41.sortBy(filteredBlogPosts, [
        "date"
    ])); // show latest dated posts first
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "blog-home",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9f69955d1adfb55f$exports, {
                siteLocation: $1c992f1332d56f69$require$constants.siteLocation.PAGE.BLOG_HOME
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8fd8dbed19be5bf4$exports, {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($81e115b62a8073a8$exports, {
                        hasPrimaryBackground: true,
                        classes: "blog-hero",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "has-text-centered",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                className: "title2",
                                children: props.t("blogHomeTitle")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "blog-tag-filter-background",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "blog-tag-filter",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    role: "radiogroup",
                                    className: "columns is-mobile is-variable is-0 is-multiline blog-tag-filter-options",
                                    "aria-label": "Filter Articles",
                                    children: tabs.map((tab, idx)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: $8g1PZ("column", {
                                                "is-one-third-mobile": idx !== tabs.length - 1
                                            }),
                                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        type: "radio",
                                                        name: "blog-tag-filter",
                                                        value: tab.value,
                                                        onChange: ()=>setActiveTag(tab.value),
                                                        checked: tab.value === activeTag
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                        className: $8g1PZ("blog-tag-filter-option is-sans-medium", {
                                                            "active-tag": tab.value === activeTag
                                                        }),
                                                        children: tab.text
                                                    })
                                                ]
                                            })
                                        }, tab.value))
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "container blog-article-container section",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "subtitle",
                                children: $f1q41.find(tabs, [
                                    "value",
                                    activeTag
                                ]).text
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "columns is-multiline",
                                children: blogPostsSortedByDate.map((article)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "column is-half",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($8342358ddc90760a$exports, {
                                            article: article
                                        })
                                    }, article.namespace))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($d1dcc206415ef960$exports, {})
        ]
    });
}
$1c992f1332d56f69$var$BlogHome.propTypes = {
    t: $c9Z8w.func.isRequired
};
$1c992f1332d56f69$exports = $1c992f1332d56f69$require$withTranslation("blogPages")($1c992f1332d56f69$var$BlogHome);


var $1ed9e1c56db6f4e4$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $lzNIT = parcelRequire("lzNIT");
var $1ed9e1c56db6f4e4$require$Link = $lzNIT.Link;

var $f1q41 = parcelRequire("f1q41");

var $c9Z8w = parcelRequire("c9Z8w");

var $1ed9e1c56db6f4e4$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;

var $3EC2Q = parcelRequire("3EC2Q");
var $21746c83337631d6$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $21746c83337631d6$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $21746c83337631d6$var$ErrorPage(props) {
    const ERROR_MESSAGES = {
        404: props.t("error404Text"),
        500: props.t("error500Text")
    };
    if (!ERROR_MESSAGES[props.errorCode]) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "is-flex is-fullheight is-grey-lighter has-padding-4-mobile",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "columns is-centered level",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "column is-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "subtitle has-text-grey-darker",
                            children: [
                                props.errorCode,
                                " ",
                                props.t("errorText")
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "title has-text-grey-darker",
                            children: [
                                props.t("errorOopsText"),
                                " ",
                                ERROR_MESSAGES[props.errorCode]
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            className: "button is-primary",
                            href: "/home-spacer-by-cbre",
                            children: props.t("errorReturnText")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "column is-5",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("figure", {
                        className: "image",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            className: "has-padding-top-1",
                            src: "/svg/illustrations/page-error-spilled-coffee-spacer.by-cbre.svg",
                            alt: props.t("errorAltText")
                        })
                    })
                })
            ]
        })
    });
}
$21746c83337631d6$var$ErrorPage.propTypes = {
    errorCode: $c9Z8w.number.isRequired,
    t: $c9Z8w.func.isRequired
};
$21746c83337631d6$exports = $21746c83337631d6$require$withTranslation("common")($21746c83337631d6$var$ErrorPage);









var $8NdSf = parcelRequire("8NdSf");
var $1ed9e1c56db6f4e4$require$withRouter = $8NdSf.withRouter;
function $1ed9e1c56db6f4e4$var$BlogArticle(props) {
    const blog = $f1q41.find($e35ef451741691fb$exports, [
        "slug",
        props.params.slug
    ]);
    if (!blog) return /*#__PURE__*/ (0, $ayMG0.jsx)($21746c83337631d6$exports, {
        errorCode: 404
    }); // go to error page if blog slug isn't valid
    const { date: date, image: image, author: author, namespace: namespace } = blog;
    // blogtodo: dry this with blogArticlePreview.jsx
    // blogtodo: format date differently in different countries / prep for internationalization
    const dateString = new Date(date).toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9f69955d1adfb55f$exports, {
                siteLocation: namespace
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8fd8dbed19be5bf4$exports, {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)($81e115b62a8073a8$exports, {
                        hasPrimaryBackground: true,
                        classes: "blog-hero blog-hero-small",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($1ed9e1c56db6f4e4$require$Link, {
                            to: "/insights-spacer-by-cbre",
                            className: "blog-home-link is-sans-medium has-margin-left-3",
                            children: props.t("blogHomeTitle")
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "blog-article",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "container blog-article-container section",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("figure", {
                                        className: "image",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: `/jpg/blogArticles/${image}`,
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "content is-small has-text-grey is-sans-medium is-inline-block",
                                        children: `${dateString} by ${author}`
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "blog-content",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                                                className: "title",
                                                children: props.t(`${namespace}:title`)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                dangerouslySetInnerHTML: {
                                                    __html: props.t(`${namespace}:content`)
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($3930bcf45abc5e7c$exports, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($d1dcc206415ef960$exports, {})
        ]
    });
}
$1ed9e1c56db6f4e4$var$BlogArticle.propTypes = {
    t: $c9Z8w.func.isRequired,
    match: $3EC2Q.routeMatchShape.isRequired
};
$1ed9e1c56db6f4e4$exports = $1ed9e1c56db6f4e4$require$withTranslation("blogPages")($1ed9e1c56db6f4e4$require$withRouter($1ed9e1c56db6f4e4$var$BlogArticle));


var $8d0110f273c17f86$exports = {};


var $jHTLJ = parcelRequire("jHTLJ");
var $8d0110f273c17f86$require$connect = $jHTLJ.connect;

var $eShmq = parcelRequire("eShmq");
var $8d0110f273c17f86$require$bindActionCreators = $eShmq.bindActionCreators;
var $377b7f31d6464090$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $377b7f31d6464090$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;

var $lzNIT = parcelRequire("lzNIT");
var $377b7f31d6464090$require$Link = $lzNIT.Link;

var $5fc9e9686b9624d5$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $5fc9e9686b9624d5$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $5fc9e9686b9624d5$var$ReferralLinkInformation(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                "aria-live": "polite",
                className: "title has-text-primary flex flex-justify-center",
                children: props.t("howReferralLinksWorkTitle")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                className: "flex flex-col referral-instructions-and-form",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                        children: [
                            props.t("referralLinkStep1"),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: props.t("referralLinkReq1")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                        children: props.t("referralLinkReq2")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        children: props.t("referralLinkStep2")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                className: "button is-primary-filled force-flex submitBtn",
                onClick: (e)=>{
                    e.preventDefault();
                    props.goToNextStep();
                },
                children: props.t("next")
            })
        ]
    });
}
$5fc9e9686b9624d5$var$ReferralLinkInformation.propTypes = {
    t: $c9Z8w.func.isRequired,
    goToNextStep: $c9Z8w.func.isRequired
};
$5fc9e9686b9624d5$exports = $5fc9e9686b9624d5$require$withTranslation("referrals")($5fc9e9686b9624d5$var$ReferralLinkInformation);


var $e1b0f58aae9a86a8$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $e1b0f58aae9a86a8$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
var $b8d5e5d00fd08f22$exports = {};

var $7PjUE = parcelRequire("7PjUE");
function $b8d5e5d00fd08f22$var$sendTestFitFormEmail(testFitFormData, onSuccess = ()=>{}, onFailure = ()=>{}) {
    return $7PjUE.jsonPostWithCredentials("/testFitForm", testFitFormData).then(()=>onSuccess()).catch((err)=>onFailure(err));
}
function $b8d5e5d00fd08f22$var$createSource(sourceData, onSuccess = ()=>{}, onFailure = ()=>{}) {
    return $7PjUE.jsonPostWithCredentials("/sources", sourceData).then(onSuccess).catch(onFailure);
}
function $b8d5e5d00fd08f22$var$getReferralLinkFromEmail(email, onSuccess = ()=>{}, onFailure = ()=>{}) {
    if (email) return $7PjUE.fetchWithCredentials(`/sources/email/${email}`).then(onSuccess).catch((err)=>onFailure(err));
    return null;
}
function $b8d5e5d00fd08f22$var$fetchSourceData(sourceId, onSuccess = ()=>{}, onFailure = ()=>{}) {
    return $7PjUE.fetchWithCredentials(`/sources/sourceId/${sourceId}`).then(onSuccess).catch(onFailure);
}
$b8d5e5d00fd08f22$exports = {
    sendTestFitFormEmail: $b8d5e5d00fd08f22$var$sendTestFitFormEmail,
    createSource: $b8d5e5d00fd08f22$var$createSource,
    getReferralLinkFromEmail: $b8d5e5d00fd08f22$var$getReferralLinkFromEmail,
    fetchSourceData: $b8d5e5d00fd08f22$var$fetchSourceData
};


var $e1b0f58aae9a86a8$require$getReferralLinkFromEmail = $b8d5e5d00fd08f22$exports.getReferralLinkFromEmail;
function $e1b0f58aae9a86a8$var$ReferralLinkSignUpForm(props) {
    const firstNameEmpty = props.firstName === "";
    const lastNameEmpty = props.lastName === "";
    const emailEmpty = props.email === "";
    const [dbError, setDbError] = $acw62.useState(false);
    const [takenLink, setTakenLink] = $acw62.useState("");
    const [triedSubmit, setTriedSubmit] = $acw62.useState(false);
    const [emailInvalid, setEmailInvalid] = $acw62.useState(!emailEmpty);
    const nameInputEl = $acw62.useRef(null);
    // manage focus - move it to first input when getting to this step
    $acw62.useEffect(()=>nameInputEl.current.focus(), []);
    function checkEmailTaken(userEmail) {
        $e1b0f58aae9a86a8$require$getReferralLinkFromEmail(userEmail, (referralLink)=>setTakenLink(referralLink), (err)=>{
            switch(err.message){
                case "We couldn't find a referral link associated with that email address.":
                    if (!firstNameEmpty && !lastNameEmpty && !emailEmpty && !emailInvalid) props.goToNextStep();
                    break;
                case "Not a cbre email":
                    setEmailInvalid(true);
                    break;
                default:
                    setDbError(true);
            }
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                "aria-live": "polite",
                className: "title has-text-primary flex flex-justify-center",
                children: props.t("enterYourInformation")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col referral-instructions-and-form user-inputs",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "form-title",
                        children: props.t("common:formLabel")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "columns is-mobile",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "column is-half is-half-mobile force-flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        className: "flex flex-col",
                                        children: [
                                            props.t("firstName"),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                ref: nameInputEl,
                                                type: "text",
                                                value: props.firstName,
                                                onChange: (evt)=>{
                                                    props.setFirstName(evt.target.value);
                                                    setDbError(false);
                                                },
                                                "aria-describedby": "firstName",
                                                "aria-invalid": firstNameEmpty && triedSubmit
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: `form-error-text ${!(firstNameEmpty && triedSubmit) ? "is-invisible" : ""}`,
                                        id: "firstName",
                                        children: props.t("emptyNameError")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "column is-half is-half-mobile force-flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        className: "flex flex-col",
                                        children: [
                                            props.t("lastName"),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                type: "text",
                                                value: props.lastName,
                                                onChange: (evt)=>{
                                                    props.setLastName(evt.target.value);
                                                    setDbError(false);
                                                },
                                                "aria-describedby": "lastName",
                                                "aria-invalid": lastNameEmpty && triedSubmit
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: `form-error-text ${!(lastNameEmpty && triedSubmit) ? "is-invisible" : ""}`,
                                        id: "lastName",
                                        children: props.t("emptyNameError")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                className: "flex flex-col",
                                children: [
                                    props.t("email"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                        type: "email",
                                        placeholder: props.t("emailExample"),
                                        value: props.email,
                                        onChange: (evt)=>{
                                            props.setEmail(evt.target.value);
                                            setEmailInvalid(false);
                                            setDbError(false);
                                        },
                                        "aria-describedby": "email",
                                        "aria-invalid": emailEmpty && triedSubmit || emailInvalid && triedSubmit || takenLink || dbError
                                    })
                                ]
                            }),
                            (emailEmpty && triedSubmit || emailInvalid && triedSubmit) && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "form-error-text",
                                id: "email",
                                children: props.t("emptyEmailError")
                            }),
                            takenLink && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "form-error-text",
                                id: "email",
                                children: props.t("emailTakenError", {
                                    takenLink: takenLink
                                })
                            }),
                            dbError && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "form-error-text",
                                id: "email",
                                children: props.t("somethingWrong")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                className: "button is-primary-filled force-flex submitBtn",
                onClick: (e)=>{
                    e.preventDefault();
                    setTriedSubmit(true);
                    checkEmailTaken(props.email);
                },
                children: props.t("next")
            })
        ]
    });
}
$e1b0f58aae9a86a8$var$ReferralLinkSignUpForm.propTypes = {
    t: $c9Z8w.func.isRequired,
    firstName: $c9Z8w.string,
    setFirstName: $c9Z8w.func.isRequired,
    lastName: $c9Z8w.string,
    setLastName: $c9Z8w.func.isRequired,
    email: $c9Z8w.string,
    setEmail: $c9Z8w.func.isRequired,
    goToNextStep: $c9Z8w.func.isRequired
};
$e1b0f58aae9a86a8$var$ReferralLinkSignUpForm.defaultProps = {
    firstName: "",
    lastName: "",
    email: ""
};
$e1b0f58aae9a86a8$exports = $e1b0f58aae9a86a8$require$withTranslation("referrals")($e1b0f58aae9a86a8$var$ReferralLinkSignUpForm);


var $aeb7c50ac7e49ef4$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $aeb7c50ac7e49ef4$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $aeb7c50ac7e49ef4$var$ReferralLinkConfirmInformation(props) {
    const editReferralButtonEl = $acw62.useRef(null);
    // manage focus - move it to first input when getting to this step
    $acw62.useEffect(()=>{
        editReferralButtonEl.current.focus();
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                "aria-live": "polite",
                className: "title has-text-primary flex flex-justify-center",
                children: props.t("confirmYourInformation")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col referral-instructions-and-form user-inputs",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "form-title",
                                children: props.t("common:formLabel")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                ref: editReferralButtonEl,
                                className: "edit-referral-info-button",
                                onClick: props.goToPreviousStep,
                                "aria-label": props.t("editReferralInfo")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "subtitle",
                        children: props.t("noLaterChanges")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "columns is-mobile",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "column is-half force-flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: props.t("firstName")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "bold-input",
                                        children: props.firstName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "column is-half force-flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: props.t("lastName")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "bold-input",
                                        children: props.lastName
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "flex flex-col",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                children: props.t("email")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "bold-input",
                                children: props.email
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                className: "button is-primary-filled force-flex submitBtn",
                onClick: (e)=>{
                    e.preventDefault();
                    props.createSource();
                },
                "aria-describedby": "serverError",
                children: props.t("next")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `form-error-text server-error ${!props.submitError ? "is-invisible" : ""}`,
                id: "serverError",
                children: props.t("somethingWrong")
            })
        ]
    });
}
$aeb7c50ac7e49ef4$var$ReferralLinkConfirmInformation.propTypes = {
    t: $c9Z8w.func.isRequired,
    firstName: $c9Z8w.string.isRequired,
    lastName: $c9Z8w.string.isRequired,
    email: $c9Z8w.string.isRequired,
    goToPreviousStep: $c9Z8w.func.isRequired,
    createSource: $c9Z8w.func.isRequired,
    submitError: $c9Z8w.bool.isRequired
};
$aeb7c50ac7e49ef4$exports = $aeb7c50ac7e49ef4$require$withTranslation("referrals")($aeb7c50ac7e49ef4$var$ReferralLinkConfirmInformation);


var $6f40e338b1d4485e$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $6f40e338b1d4485e$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
var $2700e91d4dee00eb$exports = {};




(function webpackUniversalModuleDefinition(root, factory) {
    $2700e91d4dee00eb$exports = factory((parcelRequire("5zOsi")), (parcelRequire("c9Z8w")), (parcelRequire("acw62")), (parcelRequire("1u0KT")));
})($2700e91d4dee00eb$exports, function(__WEBPACK_EXTERNAL_MODULE_clipboard__, __WEBPACK_EXTERNAL_MODULE_prop_types__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = "./index.js");
    /******/ }({
        /***/ "./index.js": /*!******************!*\
  !*** ./index.js ***!
  \******************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react-dom */ "react-dom");
            /* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! prop-types */ "prop-types");
            /* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
            function _typeof(obj) {
                if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                    return typeof obj;
                };
                else _typeof = function _typeof(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                return _typeof(obj);
            }
            function _objectSpread(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i] != null ? arguments[i] : {};
                    var ownKeys = Object.keys(source);
                    if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
                    }));
                    ownKeys.forEach(function(key) {
                        _defineProperty(target, key, source[key]);
                    });
                }
                return target;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _defineProperties(target, props) {
                for(var i = 0; i < props.length; i++){
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                return Constructor;
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) return call;
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _defineProperty(obj, key, value) {
                if (key in obj) Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: true,
                    configurable: true,
                    writable: true
                });
                else obj[key] = value;
                return obj;
            }
            var ClipboardButton = /*#__PURE__*/ function(_React$Component) {
                _inherits(ClipboardButton, _React$Component);
                function ClipboardButton() {
                    _classCallCheck(this, ClipboardButton);
                    return _possibleConstructorReturn(this, _getPrototypeOf(ClipboardButton).apply(this, arguments));
                }
                _createClass(ClipboardButton, [
                    {
                        key: "propsWith",
                        value: function propsWith(regexp) {
                            var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                            var object = {};
                            Object.keys(this.props).forEach(function(key) {
                                if (key.search(regexp) !== -1) {
                                    var objectKey = remove ? key.replace(regexp, "") : key;
                                    object[objectKey] = this.props[key];
                                }
                            }, this);
                            return object;
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function componentWillUnmount() {
                            this.clipboard && this.clipboard.destroy();
                        }
                    },
                    {
                        key: "componentDidMount",
                        value: function componentDidMount() {
                            // Support old API by trying to assign this.props.options first;
                            var options = this.props.options || this.propsWith(/^option-/, true);
                            var element = react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.findDOMNode(this.element);
                            if (!element) return;
                            var Clipboard = __webpack_require__(/*! clipboard */ "clipboard");
                            this.clipboard = new Clipboard(element, options);
                            var callbacks = this.propsWith(/^on/, true);
                            Object.keys(callbacks).forEach(function(callback) {
                                this.clipboard.on(callback.toLowerCase(), this.props["on" + callback]);
                            }, this);
                        }
                    },
                    {
                        key: "render",
                        value: function render() {
                            var _this = this;
                            var attributes = _objectSpread({
                                title: this.props.title || "",
                                type: this.getType(),
                                className: this.props.className || "",
                                style: this.props.style || {},
                                ref: function ref(element) {
                                    return _this.element = element;
                                },
                                onClick: this.props.onClick
                            }, this.propsWith(/^data-/), this.propsWith(/^button-/, true));
                            var Clipboard = __webpack_require__(/*! clipboard */ "clipboard");
                            if (!this.props.isVisibleWhenUnsupported && !Clipboard.isSupported()) return null;
                            return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(this.getComponent(), attributes, this.props.children);
                        }
                    },
                    {
                        key: "getType",
                        value: function getType() {
                            if (this.getComponent() === "button" || this.getComponent() === "input") return this.props.type || "button";
                            else return undefined;
                        }
                    },
                    {
                        key: "getComponent",
                        value: function getComponent() {
                            return this.props.component || "button";
                        }
                    }
                ]);
                return ClipboardButton;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
            _defineProperty(ClipboardButton, "propTypes", {
                options: function options(props, propName, componentName) {
                    var options = props[propName];
                    if (options && _typeof(options) !== "object" || Array.isArray(options)) return new Error("Invalid props '".concat(propName, "' supplied to '").concat(componentName, "'. ") + "'".concat(propName, "' is not an object."));
                    if (props["option-text"] !== undefined) {
                        var optionText = props["option-text"];
                        if (typeof optionText !== "function") return new Error("Invalid props 'option-text' supplied to '".concat(componentName, "'. ") + "'option-text' is not a function.");
                    }
                },
                title: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
                type: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
                className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
                style: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object,
                component: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.any,
                children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.any
            });
            _defineProperty(ClipboardButton, "defaultProps", {
                isVisibleWhenUnsupported: true,
                onClick: function onClick() {}
            });
            /* harmony default export */ __webpack_exports__["default"] = ClipboardButton;
        /***/ },
        /***/ "clipboard": /*!********************************************************************************************************!*\
  !*** external {"root":"ClipboardJS","amd":"clipboard","commonjs":"clipboard","commonjs2":"clipboard"} ***!
  \********************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_clipboard__;
        /***/ },
        /***/ "prop-types": /*!*********************************************************************************************************!*\
  !*** external {"root":"PropTypes","amd":"prop-types","commonjs":"prop-types","commonjs2":"prop-types"} ***!
  \*********************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_prop_types__;
        /***/ },
        /***/ "react": /*!**************************************************************************************!*\
  !*** external {"root":"React","amd":"react","commonjs":"react","commonjs2":"react"} ***!
  \**************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_react__;
        /***/ },
        /***/ "react-dom": /*!*****************************************************************************************************!*\
  !*** external {"root":"ReactDOM","amd":"react-dom","commonjs":"react-dom","commonjs2":"react-dom"} ***!
  \*****************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_react_dom__;
        /***/ }
    });
});


var $6f40e338b1d4485e$require$Clipboard = $2700e91d4dee00eb$exports.default;
function $6f40e338b1d4485e$var$GetReferralLink(props) {
    const [copied, setCopied] = $acw62.useState(false);
    const clipboardWrapperRef = $acw62.useRef(null);
    // manage focus - move to clipboard button on load
    $acw62.useEffect(()=>clipboardWrapperRef.current.getElementsByTagName("button")[0].focus(), []);
    const copiedLink = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex bold-input",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "copied-link-icon has-margin-right-8"
            }),
            props.t("copiedLink")
        ]
    });
    const clipboardText = copied ? copiedLink : props.t("copyLink");
    const title = props.getLinkFirstTime ? props.t("linkReady") : props.t("linkFound");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                "aria-live": "polite",
                className: "title has-text-primary flex flex-justify-center",
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: `flex flex-col referral-instructions-and-form get-referral-link ${props.getLinkFirstTime ? "" : "retrieve-link-form"}`,
                children: [
                    props.getLinkFirstTime && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "has-margin-bottom-3",
                        children: props.t("storeLinkInstructions")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "text",
                        readOnly: true,
                        value: props.link,
                        "aria-label": props.t("yourLink")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                "aria-live": "polite",
                ref: clipboardWrapperRef,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($6f40e338b1d4485e$require$Clipboard, {
                    className: "button is-primary-filled force-flex submitBtn clipboard-copy-btn",
                    "data-clipboard-text": props.link,
                    onClick: ()=>{
                        setCopied(true);
                        setTimeout(()=>{
                            setCopied(false);
                        }, 2000);
                    },
                    children: clipboardText
                })
            }),
            props.getLinkFirstTime && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "link-never-expires",
                children: props.t("linkNeverExpires")
            })
        ]
    });
}
$6f40e338b1d4485e$var$GetReferralLink.propTypes = {
    t: $c9Z8w.func.isRequired,
    link: $c9Z8w.string.isRequired,
    getLinkFirstTime: $c9Z8w.bool
};
$6f40e338b1d4485e$var$GetReferralLink.defaultProps = {
    getLinkFirstTime: false
};
$6f40e338b1d4485e$exports = $6f40e338b1d4485e$require$withTranslation("referrals")($6f40e338b1d4485e$var$GetReferralLink);



var $377b7f31d6464090$require$createSource = $b8d5e5d00fd08f22$exports.createSource;

var $aB89e = parcelRequire("aB89e");
var $377b7f31d6464090$require$constants = $aB89e.spacerFree;
var $26342a3847c760b7$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $26342a3847c760b7$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;



function $26342a3847c760b7$var$BrokerReferralWrapper(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "broker-referral-page",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9f69955d1adfb55f$exports, {
                siteLocation: props.siteLocationConstant
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($4e7513a104520779$exports, {
                navBarStartElements: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                        className: "referrals-navbar",
                        children: props.t("referrals")
                    }, "referral")
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
                children: props.children
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($d1dcc206415ef960$exports, {})
        ]
    });
}
$26342a3847c760b7$var$BrokerReferralWrapper.propTypes = {
    t: $c9Z8w.func.isRequired,
    siteLocationConstant: $c9Z8w.string.isRequired,
    children: $c9Z8w.node.isRequired
};
$26342a3847c760b7$exports = $26342a3847c760b7$require$withTranslation("common")($26342a3847c760b7$var$BrokerReferralWrapper);


const $377b7f31d6464090$var$STEPS = {
    REFERRAL_LINK_INFORMATION: 1,
    SIGN_UP_FORM: 2,
    CONFIRM_INFORMATION: 3,
    GET_REFERRAL_LINK: 4
};
function $377b7f31d6464090$var$BrokerReferralSignUpForm(props) {
    const [step, setStep] = $acw62.useState(1);
    const [firstName, setFirstName] = $acw62.useState("");
    const [lastName, setLastName] = $acw62.useState("");
    const [email, setEmail] = $acw62.useState("");
    const [link, setLink] = $acw62.useState("");
    const [submitError, setSubmitError] = $acw62.useState(false);
    function goToNextStep() {
        setStep(step + 1);
    }
    function goToPreviousStep() {
        setStep(step - 1);
    }
    function createSourceAndGetReferralLink() {
        $377b7f31d6464090$require$createSource({
            firstName: firstName,
            lastName: lastName,
            email: email
        }, (source)=>{
            setLink(source.referralLink);
            props.sendHeapEventWithoutProps("Create referral link");
            setSubmitError(false);
            goToNextStep();
        }, (err)=>{
            console.log("err:", err);
            setSubmitError(true);
        });
    }
    let currentFormView = null;
    switch(step){
        case $377b7f31d6464090$var$STEPS.REFERRAL_LINK_INFORMATION:
            currentFormView = /*#__PURE__*/ (0, $ayMG0.jsx)($5fc9e9686b9624d5$exports, {
                goToNextStep: goToNextStep
            });
            break;
        case $377b7f31d6464090$var$STEPS.SIGN_UP_FORM:
            currentFormView = /*#__PURE__*/ (0, $ayMG0.jsx)($e1b0f58aae9a86a8$exports, {
                firstName: firstName,
                setFirstName: setFirstName,
                lastName: lastName,
                setLastName: setLastName,
                email: email,
                setEmail: setEmail,
                goToNextStep: goToNextStep
            });
            break;
        case $377b7f31d6464090$var$STEPS.CONFIRM_INFORMATION:
            currentFormView = /*#__PURE__*/ (0, $ayMG0.jsx)($aeb7c50ac7e49ef4$exports, {
                firstName: firstName,
                lastName: lastName,
                email: email,
                goToPreviousStep: goToPreviousStep,
                createSource: createSourceAndGetReferralLink,
                submitError: submitError
            });
            break;
        case $377b7f31d6464090$var$STEPS.GET_REFERRAL_LINK:
            currentFormView = /*#__PURE__*/ (0, $ayMG0.jsx)($6f40e338b1d4485e$exports, {
                link: link,
                getLinkFirstTime: true
            });
            break;
        default:
            currentFormView = null;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($26342a3847c760b7$exports, {
        siteLocationConstant: $377b7f31d6464090$require$constants.siteLocation.PAGE.REFERRAL,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "referral-sign-up",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($81e115b62a8073a8$exports, {
                isLightColor: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex flex-justify-center",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "referral-link-box",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex flex-justify-between form-header",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "broker-form-progress",
                                        "aria-live": "polite",
                                        children: props.t("referralStep", {
                                            step: step
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($377b7f31d6464090$require$Link, {
                                        className: "link-in-referral-pages",
                                        to: "/referral/retrieve",
                                        children: props.t("forgotReferralLink")
                                    })
                                ]
                            }),
                            currentFormView
                        ]
                    })
                })
            })
        })
    });
}
$377b7f31d6464090$var$BrokerReferralSignUpForm.propTypes = {
    t: $c9Z8w.func.isRequired,
    sendHeapEventWithoutProps: $c9Z8w.func.isRequired
};
$377b7f31d6464090$exports = $377b7f31d6464090$require$withTranslation("referrals")($377b7f31d6464090$var$BrokerReferralSignUpForm);


// Map dispatch to props
function $8d0110f273c17f86$var$mapDispatchToProps(dispatch) {
    return {
        sendHeapEventWithoutProps: $8d0110f273c17f86$require$bindActionCreators((0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).sendHeapEventWithoutProps, dispatch)
    };
}
$8d0110f273c17f86$exports = $8d0110f273c17f86$require$connect(null, $8d0110f273c17f86$var$mapDispatchToProps)($377b7f31d6464090$exports);


var $f2c5509ab89aa1b3$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $8ffd662ad0e0f4a2$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8ffd662ad0e0f4a2$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;

var $lzNIT = parcelRequire("lzNIT");
var $8ffd662ad0e0f4a2$require$Link = $lzNIT.Link;

var $8ffd662ad0e0f4a2$require$getReferralLinkFromEmail = $b8d5e5d00fd08f22$exports.getReferralLinkFromEmail;
function $8ffd662ad0e0f4a2$var$RetrieveLinkForm(props) {
    const [emailNotAssociated, setEmailNotAssociated] = $acw62.useState(false);
    const [email, setEmail] = $acw62.useState("");
    const [triedSubmit, setTriedSubmit] = $acw62.useState(false);
    const [dbError, setDbError] = $acw62.useState(false);
    const emailInputEl = $acw62.useRef(null);
    // focus email input field on load of this form
    $acw62.useEffect(()=>emailInputEl.current.focus(), []);
    function emailEmptyOrInvalid() {
        return email === "" || email.substring(email.lastIndexOf("@") + 1, email.lastIndexOf(".")).toLowerCase() !== "cbre";
    }
    function getLinkFromEmail() {
        $8ffd662ad0e0f4a2$require$getReferralLinkFromEmail(email, (link)=>{
            setEmailNotAssociated(false);
            setDbError(false);
            props.setLink(link);
        }, (err)=>{
            if (err.message === "We couldn't find a referral link associated with that email address.") {
                if (!emailEmptyOrInvalid()) setEmailNotAssociated(true);
            } else setDbError(true);
        });
    }
    let error;
    if (emailNotAssociated) error = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "form-error-text",
        id: "email",
        children: [
            `${props.t("emailNotAssociated")}`,
            " ",
            /*#__PURE__*/ (0, $ayMG0.jsx)($8ffd662ad0e0f4a2$require$Link, {
                className: "link-in-referral-pages",
                to: "/referral",
                children: props.t("createLink")
            })
        ]
    });
    if (dbError) error = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "form-error-text",
        id: "email",
        children: `${props.t("somethingWrong")}`
    });
    if (emailEmptyOrInvalid() && triedSubmit) error = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "form-error-text",
        id: "email",
        children: `${props.t("emptyEmailError")}`
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                className: "title has-text-primary flex flex-justify-center",
                children: props.t("enterYourInformation")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex flex-col referral-instructions-and-form",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                        className: "flex flex-col",
                        children: [
                            props.t("email"),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                ref: emailInputEl,
                                type: "email",
                                placeholder: props.t("emailExample"),
                                value: email,
                                onChange: (evt)=>{
                                    setEmail(evt.target.value);
                                    setEmailNotAssociated(false);
                                    setDbError(false);
                                    setTriedSubmit(false);
                                },
                                "aria-describedby": "email",
                                "aria-invalid": emailNotAssociated || emailEmptyOrInvalid() && triedSubmit
                            })
                        ]
                    }),
                    error
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                className: "button is-primary-filled force-flex submitBtn",
                onClick: (e)=>{
                    e.preventDefault();
                    getLinkFromEmail();
                    setTriedSubmit(true);
                },
                children: props.t("next")
            })
        ]
    });
}
$8ffd662ad0e0f4a2$var$RetrieveLinkForm.propTypes = {
    t: $c9Z8w.func.isRequired,
    setLink: $c9Z8w.func.isRequired
};
$8ffd662ad0e0f4a2$exports = $8ffd662ad0e0f4a2$require$withTranslation("referrals")($8ffd662ad0e0f4a2$var$RetrieveLinkForm);




var $aB89e = parcelRequire("aB89e");
var $f2c5509ab89aa1b3$require$constants = $aB89e.spacerFree;

function $f2c5509ab89aa1b3$var$BrokerRetrievePage() {
    const [link, setLink] = $acw62.useState(false);
    let currentView;
    if (link) currentView = /*#__PURE__*/ (0, $ayMG0.jsx)($6f40e338b1d4485e$exports, {
        link: link
    });
    else currentView = /*#__PURE__*/ (0, $ayMG0.jsx)($8ffd662ad0e0f4a2$exports, {
        setLink: setLink
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($26342a3847c760b7$exports, {
        siteLocationConstant: $f2c5509ab89aa1b3$require$constants.siteLocation.PAGE.REFERRAL_RETRIEVE,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "referral-sign-up",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($81e115b62a8073a8$exports, {
                isLightColor: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "flex flex-justify-center",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "referral-link-box",
                        children: currentView
                    })
                })
            })
        })
    });
}
$f2c5509ab89aa1b3$exports = $f2c5509ab89aa1b3$var$BrokerRetrievePage;


var $7b6d62e85954a6f0$exports = {};


var $jHTLJ = parcelRequire("jHTLJ");
var $7b6d62e85954a6f0$require$connect = $jHTLJ.connect;

var $eShmq = parcelRequire("eShmq");
var $7b6d62e85954a6f0$require$bindActionCreators = $eShmq.bindActionCreators;


var $3d5a8542f4e060ff$exports = {};
const $3d5a8542f4e060ff$var$ADD_USER_DATA = "ADD_USER_DATA";
const $3d5a8542f4e060ff$var$ADD_USER_DATA_BULK = "ADD_USER_DATA_BULK";
const $3d5a8542f4e060ff$var$COMPLETE_TEST_FIT_FORM = "COMPLETE_TEST_FIT_FORM";
$3d5a8542f4e060ff$exports = {
    ADD_USER_DATA: // Action Types
    $3d5a8542f4e060ff$var$ADD_USER_DATA,
    ADD_USER_DATA_BULK: $3d5a8542f4e060ff$var$ADD_USER_DATA_BULK,
    COMPLETE_TEST_FIT_FORM: $3d5a8542f4e060ff$var$COMPLETE_TEST_FIT_FORM,
    // Action Creators
    addUserData (dataType, value, isUpdatingCurrentPersonalLocation) {
        return {
            type: $3d5a8542f4e060ff$var$ADD_USER_DATA,
            dataType: dataType,
            value: value,
            isUpdatingCurrentPersonalLocation: isUpdatingCurrentPersonalLocation
        };
    },
    addBulkUserData (dataTypeValueCollection) {
        return {
            type: $3d5a8542f4e060ff$var$ADD_USER_DATA_BULK,
            dataTypeValueCollection: dataTypeValueCollection
        };
    },
    completeTestFitForm () {
        return {
            type: $3d5a8542f4e060ff$var$COMPLETE_TEST_FIT_FORM
        };
    }
};


var $8b17002b4f01c9ac$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $aphAM = parcelRequire("aphAM");
var $8b17002b4f01c9ac$require$Navigate = $aphAM.Navigate;

var $f1q41 = parcelRequire("f1q41");

var $aB89e = parcelRequire("aB89e");
var $8b17002b4f01c9ac$require$constants = $aB89e.spacerFree;

var $8b17002b4f01c9ac$require$questionUnitUtil = $dc99b7806b365357$exports.questionUnit;
var $4121fd7cf83abe94$exports = {};
$4121fd7cf83abe94$exports = {
    backOrLandingPage () {
        // if a page is accessed through a link, document.referrer is the referring page
        // if a page is navigated to directly, document.referrer is an empty string
        if (document.referrer) window.history.back();
        else window.location = "/";
    }
};



var $ca43d93a51974d42$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $7235d1ba1fa916bf$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $fPryk = parcelRequire("fPryk");
var $7235d1ba1fa916bf$require$quizOrderInfo = $fPryk.quizOrderInfo;

var $56juP = parcelRequire("56juP");

var $7235d1ba1fa916bf$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $7235d1ba1fa916bf$var$QuizProgressLabel(props) {
    const progressPercentage = $7235d1ba1fa916bf$require$quizOrderInfo.quizProgressAtQuestion[props.questionIndex];
    let baseClasses = "title quiz-progress-label content is-small";
    const progressBarClasses = "progress is-white is-block has-margin-top-7";
    const progressBar = /*#__PURE__*/ (0, $ayMG0.jsx)("progress", {
        className: progressBarClasses,
        max: "100",
        value: progressPercentage,
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        "aria-valuenow": progressPercentage,
        children: progressPercentage
    });
    if ($56juP.isScreenMobileSize()) {
        baseClasses += " flex";
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: baseClasses,
            children: [
                progressBar,
                /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                    className: "percentage",
                    children: [
                        progressPercentage,
                        "%"
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: baseClasses,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                role: "heading",
                "aria-level": "1",
                children: `${progressPercentage}% ${props.t("progressLabelText")}`
            }),
            progressBar
        ]
    });
}
$7235d1ba1fa916bf$var$QuizProgressLabel.propTypes = {
    questionIndex: $c9Z8w.number.isRequired,
    t: $c9Z8w.func.isRequired
};
$7235d1ba1fa916bf$exports = $7235d1ba1fa916bf$require$withTranslation("quizPage")($7235d1ba1fa916bf$var$QuizProgressLabel);



var $70513402357a511f$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $f1q41 = parcelRequire("f1q41");

var $dbb59589576683a4$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $3EC2Q = parcelRequire("3EC2Q");


class $dbb59589576683a4$var$InactiveQuestion extends $acw62.Component {
    constructor(props){
        super(props);
        this.onClick = this.onClick.bind(this);
    }
    onClick() {
        this.props.onClick(this.props.questionUnit.id);
    }
    render() {
        return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
            onClick: this.onClick,
            className: "inactive-quiz-question-container",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($9dba7d2357a40545$exports, {
                questionUnit: this.props.questionUnit,
                questionAnswer: this.props.questionAnswer,
                isInactive: true
            })
        });
    }
}
$dbb59589576683a4$var$InactiveQuestion.propTypes = {
    questionUnit: $3e58c681e2cb99b8$exports.questionUnitShape.isRequired,
    questionAnswer: $3EC2Q.stringOrNumber.isRequired,
    onClick: $c9Z8w.func.isRequired
};
$dbb59589576683a4$exports = $dbb59589576683a4$var$InactiveQuestion;


function $70513402357a511f$var$QuestionGroup(props) {
    const questionComponents = [];
    const answeredQuestionIds = Object.keys(props.questionAnswers);
    props.questionUnits.forEach((questionUnit)=>{
        const questionAnswer = props.questionAnswers[questionUnit.id];
        let questionComponent;
        if (questionUnit.id === props.activeQuestionUnitId) questionComponent = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($9dba7d2357a40545$exports, {
                questionUnit: questionUnit,
                questionAnswer: questionAnswer,
                onAnswerChange: props.onAnswerChange,
                isSameOfficeAndPersonalLocation: props.isSameOfficeAndPersonalLocation,
                toggleSameOfficeAndPersonalLocation: props.toggleSameOfficeAndPersonalLocation
            })
        });
        else if (answeredQuestionIds.indexOf(questionUnit.id) > -1) questionComponent = /*#__PURE__*/ (0, $ayMG0.jsx)($dbb59589576683a4$exports, {
            questionUnit: questionUnit,
            questionAnswer: questionAnswer,
            onClick: props.onClickInactiveQuestion
        });
        if (questionComponent) questionComponents.push(/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: questionComponent
        }, `grouped-question-${questionUnit.id}`));
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "grouped-questions",
        children: questionComponents
    });
}
$70513402357a511f$var$QuestionGroup.propTypes = {
    questionUnits: $c9Z8w.arrayOf($3e58c681e2cb99b8$exports.questionUnitShape).isRequired,
    questionAnswers: $c9Z8w.objectOf($3e58c681e2cb99b8$exports.questionAnswerTypes).isRequired,
    onClickInactiveQuestion: $c9Z8w.func.isRequired,
    activeQuestionUnitId: $c9Z8w.string.isRequired,
    toggleSameOfficeAndPersonalLocation: $c9Z8w.func,
    isSameOfficeAndPersonalLocation: $c9Z8w.bool
};
$70513402357a511f$var$QuestionGroup.defaultProps = {
    toggleSameOfficeAndPersonalLocation: $f1q41.noop,
    isSameOfficeAndPersonalLocation: true
};
$70513402357a511f$exports = $70513402357a511f$var$QuestionGroup;


var $2891f0a9370b86e6$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $db0c0d417dc234d3$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $56juP = parcelRequire("56juP");

var $db0c0d417dc234d3$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $db0c0d417dc234d3$var$QuizNavigationButton(props) {
    let classes = "button is-sans-medium is-size-7 quiz-navigation-btn";
    classes += props.isBack ? " is-tertiary-outlined" : " is-tertiary-filled";
    if (props.hidden) classes += " is-hidden";
    if (props.isPulledLeft) classes += " is-pulled-left";
    let buttonText;
    if (props.isBack) buttonText = $56juP.isScreenMobileSize() ? props.t("quizNavBackButtonShortenedText") : props.t("quizNavBackButtonFullLengthText");
    else buttonText = $56juP.isScreenMobileSize() ? props.t("quizNavNextButtonShortenedText") : props.t("quizNavNextButtonFullLengthText");
    return /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
        className: classes,
        onClick: props.onClick,
        disabled: props.disabled,
        children: buttonText
    });
}
$db0c0d417dc234d3$var$QuizNavigationButton.propTypes = {
    onClick: $c9Z8w.func.isRequired,
    isBack: $c9Z8w.bool,
    hidden: $c9Z8w.bool,
    disabled: $c9Z8w.bool,
    isPulledLeft: $c9Z8w.bool,
    t: $c9Z8w.func.isRequired
};
$db0c0d417dc234d3$var$QuizNavigationButton.defaultProps = {
    isBack: false,
    hidden: false,
    disabled: false,
    isPulledLeft: false
};
$db0c0d417dc234d3$exports = $db0c0d417dc234d3$require$withTranslation("quizPage")($db0c0d417dc234d3$var$QuizNavigationButton);


function $2891f0a9370b86e6$var$QuizStickyFooter(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "navbar is-fixed-bottom is-green-forest-darker flex quiz-sticky-footer",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($db0c0d417dc234d3$exports, {
                isBack: true,
                onClick: props.previousQuestion,
                hidden: props.isFirstQuestion
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($db0c0d417dc234d3$exports, {
                onClick: props.nextQuestion,
                disabled: !props.isAnswerComplete,
                isPulledLeft: props.isFirstQuestion
            })
        ]
    });
}
$2891f0a9370b86e6$var$QuizStickyFooter.propTypes = {
    previousQuestion: $c9Z8w.func.isRequired,
    nextQuestion: $c9Z8w.func.isRequired,
    isFirstQuestion: $c9Z8w.bool.isRequired,
    isAnswerComplete: $c9Z8w.bool.isRequired
};
$2891f0a9370b86e6$exports = $2891f0a9370b86e6$var$QuizStickyFooter;




var $fPryk = parcelRequire("fPryk");
var $ca43d93a51974d42$require$quizOrderInfo = $fPryk.quizOrderInfo;


var $56juP = parcelRequire("56juP");
const $ca43d93a51974d42$var$quizOrder = $ca43d93a51974d42$require$quizOrderInfo.quizOrder;
const $ca43d93a51974d42$var$finalQuestionId = $ca43d93a51974d42$var$quizOrder[$ca43d93a51974d42$var$quizOrder.length - 1];
function $ca43d93a51974d42$var$getQuestionAnswerAndIsComplete(props) {
    const questionAnswer = props.getQuestionAnswer(props.questionIndex);
    const isAnswerComplete = $dc99b7806b365357$exports.questionUnit.isQuestionAnswerComplete(props.questionIndex, questionAnswer);
    return {
        questionAnswer: questionAnswer,
        isAnswerComplete: isAnswerComplete
    };
}
class $ca43d93a51974d42$var$QuestionSlide extends $acw62.Component {
    constructor(props){
        super(props);
        this.onClickInactiveQuestion = this.onClickInactiveQuestion.bind(this);
        this.previousQuestion = this.previousQuestion.bind(this);
        this.nextQuestion = this.nextQuestion.bind(this);
        this.nextOnEnter = this.nextOnEnter.bind(this);
        this.getQuestionComponent = this.getQuestionComponent.bind(this);
    }
    componentDidMount() {
        window.addEventListener("keydown", this.nextOnEnter);
    }
    componentWillUnmount() {
        window.removeEventListener("keydown", this.nextOnEnter);
    }
    onClickInactiveQuestion(questionId) {
        this.props.updateCurrentQuestion($ca43d93a51974d42$var$quizOrder.indexOf(questionId));
    }
    previousQuestion() {
        const previousQuestionId = $dc99b7806b365357$exports.questionUnit.getQuestionUnit(this.props.questionIndex - 1).id;
        let previousQuestionIndex;
        if (this.props.skippableQuestionIds.includes(previousQuestionId) && this.props.questionIndex >= 2) previousQuestionIndex = this.props.questionIndex - 2;
        else previousQuestionIndex = this.props.questionIndex - 1;
        this.props.updateCurrentQuestion(previousQuestionIndex);
    }
    nextOnEnter(evt) {
        if (evt.which === $c65935c63c29746a$exports.ENTER) {
            const { isAnswerComplete: isAnswerComplete } = $ca43d93a51974d42$var$getQuestionAnswerAndIsComplete(this.props);
            if (isAnswerComplete) this.nextQuestion();
        }
    }
    nextQuestion() {
        if ($dc99b7806b365357$exports.questionUnit.getQuestionUnit(this.props.questionIndex).id === $ca43d93a51974d42$var$finalQuestionId) this.props.afterFinalQuestionSlide();
        else {
            const nextQuestionId = $dc99b7806b365357$exports.questionUnit.getQuestionUnit(this.props.questionIndex + 1).id;
            let newQuestionIndex;
            if (this.props.skippableQuestionIds.includes(nextQuestionId)) newQuestionIndex = this.props.questionIndex + 2;
            else newQuestionIndex = this.props.questionIndex + 1;
            this.props.updateCurrentQuestion(newQuestionIndex);
        }
    }
    getQuestionComponent(questionAnswer, isAnswerComplete) {
        const activeQuestionUnit = $dc99b7806b365357$exports.questionUnit.getQuestionUnit(this.props.questionIndex);
        const shouldGroupQuestions = !$56juP.isScreenMobileSize() && !$56juP.isScreenTabletSize() && $dc99b7806b365357$exports.questionUnit.isGroupedQuestion(activeQuestionUnit);
        if (shouldGroupQuestions) {
            const groupedQuestionUnits = [];
            const groupedQuestionAnswers = {};
            let groupedQuestionUnit;
            let groupedQuestionAnswer;
            const groupedQuestions = $ca43d93a51974d42$require$quizOrderInfo.groupedQuestions;
            groupedQuestions.forEach((questionUnitId)=>{
                if (!(this.props.skippableQuestionIds.indexOf(questionUnitId) > -1)) {
                    groupedQuestionUnit = $dc99b7806b365357$exports.questionUnit.getQuestionUnit($ca43d93a51974d42$var$quizOrder.indexOf(questionUnitId));
                    groupedQuestionUnits.push(groupedQuestionUnit);
                    groupedQuestionAnswer = this.props.getQuestionAnswer($ca43d93a51974d42$var$quizOrder.indexOf(questionUnitId), true);
                    if (groupedQuestionAnswer) groupedQuestionAnswers[groupedQuestionUnit.id] = groupedQuestionAnswer;
                }
            });
            return /*#__PURE__*/ (0, $ayMG0.jsx)($70513402357a511f$exports, {
                questionUnits: groupedQuestionUnits,
                questionAnswers: groupedQuestionAnswers,
                activeQuestionUnitId: activeQuestionUnit.id,
                onAnswerChange: this.props.updateAnswer,
                onClickInactiveQuestion: this.onClickInactiveQuestion,
                isSameOfficeAndPersonalLocation: this.props.isSameOfficeAndPersonalLocation,
                toggleSameOfficeAndPersonalLocation: this.props.toggleSameOfficeAndPersonalLocation
            });
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)($9dba7d2357a40545$exports, {
            questionUnit: activeQuestionUnit,
            questionAnswer: questionAnswer,
            onAnswerChange: this.props.updateAnswer,
            showResponse: isAnswerComplete,
            isSameOfficeAndPersonalLocation: this.props.isSameOfficeAndPersonalLocation,
            toggleSameOfficeAndPersonalLocation: this.props.toggleSameOfficeAndPersonalLocation
        });
    }
    render() {
        const { questionAnswer: questionAnswer, isAnswerComplete: isAnswerComplete } = $ca43d93a51974d42$var$getQuestionAnswerAndIsComplete(this.props);
        const isFirstQuestion = this.props.questionIndex === 0;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "quiz-question-slide",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "quiz-question-and-progress-label",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($7235d1ba1fa916bf$exports, {
                                questionIndex: this.props.questionIndex
                            }),
                            this.getQuestionComponent(questionAnswer, isAnswerComplete)
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "quiz-navigation-btns-container",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($db0c0d417dc234d3$exports, {
                            isBack: true,
                            onClick: this.previousQuestion,
                            hidden: isFirstQuestion
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($db0c0d417dc234d3$exports, {
                            onClick: this.nextQuestion,
                            disabled: !isAnswerComplete,
                            isPulledLeft: isFirstQuestion
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($2891f0a9370b86e6$exports, {
                    previousQuestion: this.previousQuestion,
                    nextQuestion: this.nextQuestion,
                    isFirstQuestion: isFirstQuestion,
                    isAnswerComplete: isAnswerComplete
                })
            ]
        }, `question${this.props.questionIndex}`);
    }
}
$ca43d93a51974d42$var$QuestionSlide.propTypes = {
    questionIndex: $c9Z8w.number.isRequired,
    updateCurrentQuestion: $c9Z8w.func.isRequired,
    afterFinalQuestionSlide: $c9Z8w.func.isRequired,
    updateAnswer: $c9Z8w.func.isRequired,
    getQuestionAnswer: $c9Z8w.func.isRequired,
    isSameOfficeAndPersonalLocation: $c9Z8w.bool.isRequired,
    toggleSameOfficeAndPersonalLocation: $c9Z8w.func.isRequired,
    skippableQuestionIds: $c9Z8w.arrayOf($c9Z8w.string).isRequired
};
$ca43d93a51974d42$var$QuestionSlide.defaultProps = {
    skippableQuestionIds: []
};
$ca43d93a51974d42$exports = $ca43d93a51974d42$var$QuestionSlide;


var $e6577abf9f474ff5$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $e6577abf9f474ff5$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $e6577abf9f474ff5$var$QuizExitSlide(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "quiz-exit-slide",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "columns is-centered",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "column is-half",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("figure", {
                        className: "image is-4by3",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: "/svg/illustrations/quiz/quiz-two-people-high-five-spacer-by-cbre.svg",
                            alt: props.t("quizExitImgAlt")
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "loader light"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                className: "subtitle is-4 has-margin-bottom-3 has-margin-top-3 has-margin-bottom-3-mobile has-text-primary-invert has-text-centered",
                children: props.t("quizExitSubtitle")
            })
        ]
    });
}
$e6577abf9f474ff5$var$QuizExitSlide.propTypes = {
    t: $c9Z8w.func.isRequired
};
$e6577abf9f474ff5$exports = $e6577abf9f474ff5$require$withTranslation("quizPage")($e6577abf9f474ff5$var$QuizExitSlide);



var $56juP = parcelRequire("56juP");


var $8b17002b4f01c9ac$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;


var $3GYAO = parcelRequire("3GYAO");
const $8b17002b4f01c9ac$var$QUESTION_TYPE_TO_ANSWER_PROPS_MAP = {
    [$8b17002b4f01c9ac$require$constants.questionUnit.QUESTION_TYPE.PROFILE]: {
        executeAnswerFn: "answerProfileQuestion",
        answerObject: "userQuizAnswers",
        answerKeyProp: "id"
    },
    [$8b17002b4f01c9ac$require$constants.questionUnit.QUESTION_TYPE.USER_DATA]: {
        executeAnswerFn: "addUserData",
        answerObject: "userData",
        answerKeyProp: "userDataProperty"
    },
    [$8b17002b4f01c9ac$require$constants.questionUnit.QUESTION_TYPE.ASSUMPTION]: {
        executeAnswerFn: "addKeyAssumption",
        answerObject: "assumptions",
        answerKeyProp: "assumptionType"
    }
};
class $8b17002b4f01c9ac$var$Quiz extends $acw62.Component {
    constructor(props){
        super(props);
        const skippableQuestions = Object.keys(props.userQuizAnswers);
        skippableQuestions.push($8b17002b4f01c9ac$require$constants.quiz.currentLocationQuestionId);
        // skip the usersTypeQuestion if we came from a referral link (we'll auto populate it later)
        if (props.userData.sourceId) skippableQuestions.push($8b17002b4f01c9ac$require$constants.quiz.userTypeQuestionId);
        this.state = {
            questionIndex: 0,
            isSameOfficeAndPersonalLocation: true,
            skippableQuestionIds: skippableQuestions
        };
        this.endQuiz = this.endQuiz.bind(this);
        this.getExitOrQuestionSlide = this.getExitOrQuestionSlide.bind(this);
        this.updateAnswer = this.updateAnswer.bind(this);
        this.getQuestionAnswer = this.getQuestionAnswer.bind(this);
        this.updateCurrentQuestion = this.updateCurrentQuestion.bind(this);
        this.toggleSameOfficeAndPersonalLocation = this.toggleSameOfficeAndPersonalLocation.bind(this);
        this.addOrRemoveSkippableQuestion = this.addOrRemoveSkippableQuestion.bind(this);
    }
    getQuestionAnswer(questionIndex, excludeInitial) {
        const questionUnit = $8b17002b4f01c9ac$require$questionUnitUtil.getQuestionUnit(questionIndex);
        const answerProps = $8b17002b4f01c9ac$var$QUESTION_TYPE_TO_ANSWER_PROPS_MAP[questionUnit.type];
        const answerKey = questionUnit[answerProps.answerKeyProp];
        const questionAnswer = this.props[answerProps.answerObject][answerKey] || !excludeInitial && $8b17002b4f01c9ac$require$questionUnitUtil.getInitialAnswer(questionUnit);
        return questionAnswer;
    }
    updateCurrentQuestion(questionIndex) {
        this.setState({
            questionIndex: questionIndex
        });
        $56juP.scrollY(0);
    }
    updateAnswer(questionAnswer, passedQuestionIndex) {
        passedQuestionIndex = passedQuestionIndex || this.state.questionIndex;
        const questionUnit = $8b17002b4f01c9ac$require$questionUnitUtil.getQuestionUnit(passedQuestionIndex);
        const answerProps = $8b17002b4f01c9ac$var$QUESTION_TYPE_TO_ANSWER_PROPS_MAP[questionUnit.type];
        const answerKeyProp = questionUnit[answerProps.answerKeyProp];
        this.props[answerProps.executeAnswerFn](answerKeyProp, questionAnswer, this.state.isSameOfficeAndPersonalLocation);
    }
    endQuiz() {
        this.setState({
            showExitSlide: true
        });
        $56juP.scrollY(0);
        this.props.calculateProfileScores();
        this.props.setProfileAndCalculateProgram();
        $3GYAO.GAEvent($3a61343632c866bc$exports.categories.quiz, $3a61343632c866bc$exports.actions.finishQuiz, $3a61343632c866bc$exports.labels.finishQuiz);
        this.props.sendHeapEvent("Finish Quiz");
        setTimeout(()=>this.setState({
                redirectToResults: true
            }), 3000);
    }
    toggleSameOfficeAndPersonalLocation(isChecked) {
        this.setState({
            isSameOfficeAndPersonalLocation: !isChecked
        }, ()=>{
            // if (this.state.isSameOfficeAndPersonalLocation) {
            this.updateAnswer(this.props.userData.officeLocation, $8b17002b4f01c9ac$require$constants.quiz.currentLocationQuestionIndex);
        // } else {
        //   this.updateAnswer('', constants.quiz.currentLocationQuestionIndex);
        // }
        });
        this.addOrRemoveSkippableQuestion($8b17002b4f01c9ac$require$constants.quiz.currentLocationQuestionId, !isChecked);
    }
    addOrRemoveSkippableQuestion(questionId, addId) {
        const newSkippableQuestionIds = addId ? $f1q41.union(this.state.skippableQuestionIds, [
            questionId
        ]) : $f1q41.without(this.state.skippableQuestionIds, questionId); // remove questionId
        this.setState({
            skippableQuestionIds: newSkippableQuestionIds
        });
    }
    getExitOrQuestionSlide() {
        if (this.state.showExitSlide) return /*#__PURE__*/ (0, $ayMG0.jsx)($e6577abf9f474ff5$exports, {});
        return /*#__PURE__*/ (0, $ayMG0.jsx)($ca43d93a51974d42$exports, {
            questionIndex: this.state.questionIndex,
            updateCurrentQuestion: this.updateCurrentQuestion,
            afterFinalQuestionSlide: this.endQuiz,
            updateAnswer: this.updateAnswer,
            getQuestionAnswer: this.getQuestionAnswer,
            isSameOfficeAndPersonalLocation: this.state.isSameOfficeAndPersonalLocation,
            toggleSameOfficeAndPersonalLocation: this.toggleSameOfficeAndPersonalLocation,
            skippableQuestionIds: this.state.skippableQuestionIds
        });
    }
    render() {
        if (this.state.redirectToResults) return /*#__PURE__*/ (0, $ayMG0.jsx)($8b17002b4f01c9ac$require$Navigate, {
            to: "/program-your-results-spacer-by-cbre"
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "quiz is-fullheight",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($9f69955d1adfb55f$exports, {
                    siteLocation: $8b17002b4f01c9ac$require$constants.siteLocation.PAGE.QUIZ
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($4e7513a104520779$exports, {
                    isInQuiz: true,
                    isDark: true,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "navbar-item is-mobile",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            role: "link",
                            className: "delete is-large",
                            "aria-label": this.props.t("exitQuizButtonTitle"),
                            title: this.props.t("exitQuizButtonTitle"),
                            onClick: $4121fd7cf83abe94$exports.backOrLandingPage
                        })
                    }, "closeTag")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("main", {
                    className: "container",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "quiz-content columns is-centered has-emphasis-background",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "column align-center",
                            children: this.getExitOrQuestionSlide()
                        })
                    })
                })
            ]
        });
    }
}
$8b17002b4f01c9ac$var$Quiz.propTypes = {
    // previous answer props
    userQuizAnswers: $3e58c681e2cb99b8$exports.userQuizAnswersObject.isRequired,
    userData: $3e58c681e2cb99b8$exports.userDataForQuizShape.isRequired,
    assumptions: $3e58c681e2cb99b8$exports.assumptionsForQuizShape.isRequired,
    // answer question functions
    answerProfileQuestion: $c9Z8w.func.isRequired,
    addUserData: $c9Z8w.func.isRequired,
    addKeyAssumption: $c9Z8w.func.isRequired,
    // calculate results functions
    calculateProfileScores: $c9Z8w.func.isRequired,
    setProfileAndCalculateProgram: $c9Z8w.func.isRequired,
    sendHeapEvent: $c9Z8w.func.isRequired,
    t: $c9Z8w.func.isRequired
};
$8b17002b4f01c9ac$exports = $8b17002b4f01c9ac$require$withTranslation("quizPage")($8b17002b4f01c9ac$var$Quiz);


// Map state to props
function $7b6d62e85954a6f0$var$mapStateToProps(state) {
    return {
        // for determining previous answers
        userQuizAnswers: state.profileQuiz.userQuizAnswers,
        userData: state.userData,
        assumptions: state.spaceData.assumptions
    };
}
// Map dispatch to props
function $7b6d62e85954a6f0$var$mapDispatchToProps(dispatch) {
    return {
        // answer question functions
        answerProfileQuestion: $7b6d62e85954a6f0$require$bindActionCreators($91d5e1f7c4d12efe$exports.answerProfileQuestion, dispatch),
        addKeyAssumption: $7b6d62e85954a6f0$require$bindActionCreators($7f3ddf5ab2cb44f3$exports.addKeyAssumption, dispatch),
        addUserData: $7b6d62e85954a6f0$require$bindActionCreators($3d5a8542f4e060ff$exports.addUserData, dispatch),
        // calculate results functions
        calculateProfileScores: $7b6d62e85954a6f0$require$bindActionCreators($91d5e1f7c4d12efe$exports.calculateProfileScores, dispatch),
        setProfileAndCalculateProgram: $7b6d62e85954a6f0$require$bindActionCreators($7f3ddf5ab2cb44f3$exports.setProfileAndCalculateProgram, dispatch),
        sendHeapEvent: $7b6d62e85954a6f0$require$bindActionCreators((0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).sendHeapEvent, dispatch)
    };
}
$7b6d62e85954a6f0$exports = $7b6d62e85954a6f0$require$connect($7b6d62e85954a6f0$var$mapStateToProps, $7b6d62e85954a6f0$var$mapDispatchToProps)($8b17002b4f01c9ac$exports);


var $ca65c57dcef473df$exports = {};


var $jHTLJ = parcelRequire("jHTLJ");
var $ca65c57dcef473df$require$connect = $jHTLJ.connect;

var $eShmq = parcelRequire("eShmq");
var $ca65c57dcef473df$require$bindActionCreators = $eShmq.bindActionCreators;
var $ed457df1934acfb0$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $3EC2Q = parcelRequire("3EC2Q");

var $aphAM = parcelRequire("aphAM");
var $ed457df1934acfb0$require$Navigate = $aphAM.Navigate;


var $8HpaJ = parcelRequire("8HpaJ");
var $50748c6090d80f89$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $4c6935c3f206399d$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $4c6935c3f206399d$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
class $4c6935c3f206399d$var$FixedNavbar extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            isScrolled: false
        };
        this.updateScrollState = this.updateScrollState.bind(this);
    }
    componentDidMount() {
        window.addEventListener("scroll", this.updateScrollState);
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.state.isScrolled !== nextState.isScrolled || this.props.navItems !== nextProps.navItems;
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.updateScrollState);
    }
    updateScrollState() {
        this.setState({
            isScrolled: window.pageYOffset !== 0
        });
    }
    render() {
        let navbarClasses = "navbar is-fixed-top";
        if (this.state.isScrolled) navbarClasses += " has-shadow";
        return /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
            className: navbarClasses,
            ref: (navbar)=>{
                this.navbar = navbar;
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "navbar-brand",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            className: "navbar-item cbre-spacer-logo",
                            href: "/",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: "/svg/logos/spacer_logo.svg",
                                alt: "CBRE Spacer"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "navbar-menu",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "navbar-end",
                            children: this.props.navItems
                        })
                    })
                ]
            })
        });
    }
}
$4c6935c3f206399d$var$FixedNavbar.propTypes = {
    navItems: $c9Z8w.node,
    hasTransparentNavbarAtTop: $c9Z8w.bool,
    t: $c9Z8w.func.isRequired
};
$4c6935c3f206399d$var$FixedNavbar.defaultProps = {
    navItems: null,
    hasTransparentNavbarAtTop: false
};
$4c6935c3f206399d$exports = $4c6935c3f206399d$require$withTranslation("common")($4c6935c3f206399d$var$FixedNavbar);


var $41565916d367b110$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $41565916d367b110$require$Clipboard = $2700e91d4dee00eb$exports.default;

var $41565916d367b110$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $41565916d367b110$var$CopyToClipboardBox(props) {
    const [copied, setCopied] = $acw62.useState(false);
    let clipboardClasses = "copy-to-clipboard-box-clipboard";
    let clipboardText = props.t("clipboardBoxCopyText");
    if (copied) {
        clipboardClasses += " copied";
        clipboardText = props.t("clipboardBoxCopiedText");
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "copy-to-clipboard-box-background",
                role: "button",
                tabIndex: 0,
                onClick: props.closeCopyToClipboardBox
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "copy-to-clipboard-box",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                    className: "copy-to-clipboard-box-label",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "copy-to-clipboard-box-text",
                            title: props.clipboardBoxDescription,
                            children: props.clipboardBoxDescription
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            className: "copy-to-clipboard-box-input",
                            type: "text",
                            readOnly: true,
                            value: props.textToCopy
                        }),
                        copied && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "copy-to-clipboard-box-checkmark"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($41565916d367b110$require$Clipboard, {
                            className: clipboardClasses,
                            "data-clipboard-text": props.textToCopy,
                            onClick: ()=>{
                                setCopied(true);
                                setTimeout(()=>{
                                    setCopied(false);
                                }, 2000);
                            },
                            children: clipboardText
                        })
                    ]
                })
            })
        ]
    });
}
$41565916d367b110$var$CopyToClipboardBox.propTypes = {
    closeCopyToClipboardBox: $c9Z8w.func.isRequired,
    textToCopy: $c9Z8w.string.isRequired,
    clipboardBoxDescription: $c9Z8w.string.isRequired,
    t: $c9Z8w.func.isRequired
};
$41565916d367b110$exports = $41565916d367b110$require$withTranslation("resultsPage")($41565916d367b110$var$CopyToClipboardBox);



var $aB89e = parcelRequire("aB89e");
var $50748c6090d80f89$require$constants = $aB89e.spacerFree;
var $2ede5fa8fc52b625$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $2ede5fa8fc52b625$var$DownloadIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: 14,
        height: 17,
        fill: "currentColor",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M12.602 4.928L9.4 1.113a.324.324 0 0 0-.292-.11H2.272C1.57 1.003 1 1.573 1 2.275v12.453C1 15.43 1.57 16 2.272 16h9.167c.702 0 1.272-.57 1.272-1.272V5.193c0-.008.005-.015.005-.023a.314.314 0 0 0-.114-.242zM8.86 11.293l-1.648 1.81c-.003.002-.006.003-.008.006l-.018.017-.006.008c-.015.014-.035.019-.05.03l-.017.011c-.022.014-.04.031-.062.042l-.021.007c-.026.01-.053.012-.08.017-.027.005-.053.015-.08.015-.004 0-.008.003-.011.003-.004 0-.007-.002-.011-.003-.027 0-.053-.01-.08-.015-.027-.005-.054-.007-.08-.017l-.021-.007c-.024-.01-.043-.03-.065-.044a.166.166 0 0 0-.011-.008c-.017-.011-.038-.017-.053-.032l-.006-.007-.017-.017-.01-.007-1.648-1.81a.477.477 0 1 1 .706-.644l.818.899V6.66a.478.478 0 0 1 .955 0v4.885l.818-.897a.477.477 0 0 1 .674-.031c.196.177.21.48.032.675z"
        })
    });
$2ede5fa8fc52b625$exports = $2ede5fa8fc52b625$var$DownloadIcon;


var $339ca6a41f836346$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $339ca6a41f836346$var$SendIcon = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("svg", {
        width: 21,
        height: 15,
        fill: "currentColor",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
            d: "M20.746 6.996L11.372.122a.626.626 0 0 0-.995.504v3.77c-5.333.327-7.629 3.788-9.327 7.863-.23.55.374 1.08.888.783 2.528-1.446 4.549-2.417 8.439-2.417v3.75c0 .523.595.8.994.504l9.374-6.874a.626.626 0 0 0 0-1.009z"
        })
    });
$339ca6a41f836346$exports = $339ca6a41f836346$var$SendIcon;



var $50748c6090d80f89$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;


var $3GYAO = parcelRequire("3GYAO");

class $50748c6090d80f89$var$ResultsHeader extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            copyToClipboardBoxActive: false
        };
        this.closeCopyToClipboardBox = this.closeCopyToClipboardBox.bind(this);
    }
    closeCopyToClipboardBox() {
        this.setState({
            copyToClipboardBoxActive: false
        });
    }
    render() {
        const classesForItemWithIcon = "navbar-item no-outline has-margin-right-4";
        const exportPDFButton = /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
            className: classesForItemWithIcon,
            onClick: ()=>{
                window.print();
                $3GYAO.GAEvent($3a61343632c866bc$exports.categories.result, $3a61343632c866bc$exports.actions.exportPDFBtn, $3a61343632c866bc$exports.labels.exportPDFBtn);
            },
            children: [
                this.props.t("resultsHeaderExportPDFButtonText"),
                /*#__PURE__*/ (0, $ayMG0.jsx)($2ede5fa8fc52b625$exports, {})
            ]
        });
        const sendButtonProps = {
            text: this.props.t("resultsHeaderSendButtonText"),
            onClick: ()=>{
                this.setState((prevState)=>({
                        copyToClipboardBoxActive: !prevState.copyLinkBoxActive
                    }));
                $3GYAO.GAEvent($3a61343632c866bc$exports.categories.result, $3a61343632c866bc$exports.actions.sendResultBtn, $3a61343632c866bc$exports.labels.sendResultBtn);
            }
        };
        const sendButton = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "copy-to-clipboard-box-container",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: `${classesForItemWithIcon} send-results-button is-mobile`,
                        onClick: sendButtonProps.onClick,
                        children: [
                            sendButtonProps.text,
                            /*#__PURE__*/ (0, $ayMG0.jsx)($339ca6a41f836346$exports, {})
                        ]
                    }),
                    this.state.copyToClipboardBoxActive && /*#__PURE__*/ (0, $ayMG0.jsx)($41565916d367b110$exports, {
                        closeCopyToClipboardBox: this.closeCopyToClipboardBox,
                        textToCopy: window.location.href,
                        clipboardBoxDescription: this.props.t("resultsHeaderClipboardBoxDescription")
                    })
                ]
            })
        });
        const contactButton = /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
            className: "button is-primary-filled is-small find-space-button navbar-find-space-button has-margin-left-8",
            onClick: ()=>this.props.openModal($50748c6090d80f89$require$constants.modal.TYPES.FORM, {
                    formType: $50748c6090d80f89$require$constants.modal.FORM_TYPES.FIND_SPACE
                }),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: this.props.t("resultsHeaderContactButtonText")
            })
        });
        let navItems = null;
        if (this.props.programId !== "") navItems = /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: `language-dropdown-top-result ${classesForItemWithIcon}`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($65cd9dd502e03f27$exports, {})
                }),
                exportPDFButton,
                sendButton,
                contactButton
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)($4c6935c3f206399d$exports, {
            hasTransparentNavbarAtTop: true,
            navItems: navItems
        });
    }
}
$50748c6090d80f89$var$ResultsHeader.propTypes = {
    programId: $c9Z8w.string,
    openModal: $c9Z8w.func.isRequired,
    t: $c9Z8w.func.isRequired
};
$50748c6090d80f89$var$ResultsHeader.defaultProps = {
    programId: ""
};
$50748c6090d80f89$exports = $50748c6090d80f89$require$withTranslation("resultsPage")($50748c6090d80f89$var$ResultsHeader);



var $e964d86ceb037aa8$exports = {};

var $jHTLJ = parcelRequire("jHTLJ");
var $e964d86ceb037aa8$require$connect = $jHTLJ.connect;

var $eShmq = parcelRequire("eShmq");
var $e964d86ceb037aa8$require$bindActionCreators = $eShmq.bindActionCreators;
var $15a18ec2484069fc$exports = {};
const $15a18ec2484069fc$var$OPEN_MODAL = "OPEN_MODAL";
const $15a18ec2484069fc$var$CLOSE_MODAL = "CLOSE_MODAL";
$15a18ec2484069fc$exports = {
    OPEN_MODAL: // Action Types
    $15a18ec2484069fc$var$OPEN_MODAL,
    CLOSE_MODAL: $15a18ec2484069fc$var$CLOSE_MODAL,
    // Action Creators
    openModal (modalType, modalProps) {
        return {
            type: $15a18ec2484069fc$var$OPEN_MODAL,
            modalType: modalType,
            modalProps: modalProps
        };
    },
    closeModal () {
        return {
            type: $15a18ec2484069fc$var$CLOSE_MODAL
        };
    }
};



var $fPryk = parcelRequire("fPryk");
var $e964d86ceb037aa8$require$profileMap = $fPryk.profileMap;
var $fafc8e9a8354bea6$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $3d58e5ddff2e6c6a$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $3d58e5ddff2e6c6a$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $3d58e5ddff2e6c6a$var$ProfileHero(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($81e115b62a8073a8$exports, {
        addTopNavbarSpace: true,
        sizeClass: "is-small",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "columns is-gapless level profile-hero",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("h1", {
                    className: "column is-half level-item",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "subtitle is-half-spaced is-5 has-text-weight-medium profile-hero-subtitle is-calibre",
                            children: props.t("resultsProfileHeroAnnouncementTitle")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "title has-text-primary profile-hero-name",
                            children: props.profileName
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "column is-half is-hidden-print",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("figure", {
                        className: "image is-4by3",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: props.profileHeroImagePath,
                            alt: props.t("resultsProfileHeroImgAlt", {
                                profileName: props.profileName
                            })
                        })
                    })
                })
            ]
        })
    });
}
$3d58e5ddff2e6c6a$var$ProfileHero.propTypes = {
    profileName: $c9Z8w.string.isRequired,
    profileHeroImagePath: $c9Z8w.string.isRequired,
    t: $c9Z8w.func.isRequired
};
$3d58e5ddff2e6c6a$exports = $3d58e5ddff2e6c6a$require$withTranslation("resultsPage")($3d58e5ddff2e6c6a$var$ProfileHero);


var $73dd7f9ee93a0372$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $fPryk = parcelRequire("fPryk");
var $73dd7f9ee93a0372$require$profileTraitMap = $fPryk.profileTraitMap;

var $73dd7f9ee93a0372$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $73dd7f9ee93a0372$var$ProfileTrait(props) {
    const profileTrait = $73dd7f9ee93a0372$require$profileTraitMap.getProfileTraitById(props.traitId);
    const icon = props.isDark ? profileTrait.icon.light : profileTrait.icon.dark;
    const nameClasses = `title2 is-6 has-margin-bottom-7 ${props.isDark ? "" : "has-text-primary"}`;
    const descriptionClasses = `profile-trait-description ${props.isDark ? "" : "has-text-primary"}`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "profile-trait has-text-centered",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                src: icon,
                alt: profileTrait.name
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: nameClasses,
                children: props.t(profileTrait.name)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: descriptionClasses,
                children: props.t(profileTrait.description)
            })
        ]
    });
}
$73dd7f9ee93a0372$var$ProfileTrait.propTypes = {
    traitId: $c9Z8w.string.isRequired,
    isDark: $c9Z8w.bool,
    t: $c9Z8w.func.isRequired
};
$73dd7f9ee93a0372$var$ProfileTrait.defaultProps = {
    isDark: false
};
$73dd7f9ee93a0372$exports = $73dd7f9ee93a0372$require$withTranslation("resultsPage")($73dd7f9ee93a0372$var$ProfileTrait);


var $8dbf84adc5277014$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");
function $8dbf84adc5277014$var$ContentSection(props) {
    const classes = $8g1PZ("content-section section", {
        "is-hidden-mobile": props.hideOnMobile,
        "is-hidden-print": props.hideOnPrint,
        "email-wall-section": props.isEmailWallSection
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: classes,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "container",
            children: props.children
        })
    });
}
$8dbf84adc5277014$var$ContentSection.propTypes = {
    children: $c9Z8w.node.isRequired,
    hideOnMobile: $c9Z8w.bool,
    hideOnPrint: $c9Z8w.bool,
    isEmailWallSection: $c9Z8w.bool
};
$8dbf84adc5277014$var$ContentSection.defaultProps = {
    hideOnMobile: false,
    hideOnPrint: false,
    isEmailWallSection: false
};
$8dbf84adc5277014$exports = $8dbf84adc5277014$var$ContentSection;


var $8f998ca26a3057d1$exports = {};

var $jHTLJ = parcelRequire("jHTLJ");
var $8f998ca26a3057d1$require$connect = $jHTLJ.connect;

var $aB89e = parcelRequire("aB89e");
var $8f998ca26a3057d1$require$constants = $aB89e.spacerFree;
var $2a4962b1e81f9837$exports = {};

const $2a4962b1e81f9837$var$SPACE_UNIT_CATEGORY = (parcelRequire("aB89e")).shared.spaceUnit.CATEGORY;

var $85x8Z = parcelRequire("85x8Z");

// Module that will retrieve the desired (either current or original) data from parts of the program
const $2a4962b1e81f9837$var$categoryToAreaTotal = {
    [$2a4962b1e81f9837$var$SPACE_UNIT_CATEGORY.ME]: {
        custom: "totalCustomMeSF",
        original: "totalMeSF"
    },
    [$2a4962b1e81f9837$var$SPACE_UNIT_CATEGORY.WE]: {
        custom: "totalCustomWeSF",
        original: "totalWeSF"
    },
    [$2a4962b1e81f9837$var$SPACE_UNIT_CATEGORY.AMENITY]: {
        custom: "totalCustomAmenitySF",
        original: "totalAmenitySF"
    }
};
function $2a4962b1e81f9837$var$getDeltaHelper(customVal, originalVal) {
    const numericDelta = customVal - originalVal;
    if (!numericDelta) return null;
    const percentDelta = numericDelta / originalVal;
    const displayPercentDelta = $5f15cdd5de4823b1$exports.decimalToPercentage(percentDelta);
    return {
        numericDelta: numericDelta,
        percentDelta: percentDelta,
        displayPercentDelta: displayPercentDelta
    };
}
$2a4962b1e81f9837$exports = {
    // Current Value Getters
    getTotalSFForCategory (areaTotals, category) {
        return areaTotals[$2a4962b1e81f9837$var$categoryToAreaTotal[category].custom] || areaTotals[$2a4962b1e81f9837$var$categoryToAreaTotal[category].original];
    },
    getTotalSF (areaTotals) {
        return areaTotals.totalCustomSF || areaTotals.totalSF;
    },
    getNSF (programUnit) {
        return programUnit.customNSF || programUnit.nsf;
    },
    getQuantity (programUnit) {
        return programUnit.customQuantity || programUnit.quantity;
    },
    // Delta Getters
    // Delta in the format of:
    // {
    //   numericDelta: (number)
    //   displayPercentDelta: (string)
    // }
    //
    getNSFDelta (programUnit) {
        return $2a4962b1e81f9837$var$getDeltaHelper(programUnit.customNSF, programUnit.nsf);
    },
    getQuantityDelta (programUnit) {
        return $2a4962b1e81f9837$var$getDeltaHelper(programUnit.customQuantity, programUnit.quantity);
    },
    getTotalSFDelta (areaTotals) {
        return $2a4962b1e81f9837$var$getDeltaHelper(areaTotals.totalCustomSF, areaTotals.totalSF);
    },
    getTotalDeltaForCategoryAndContext (areaTotals, category, sfType, location, lossFactor) {
        const customTotal = areaTotals[$2a4962b1e81f9837$var$categoryToAreaTotal[category].custom];
        const originalTotal = areaTotals[$2a4962b1e81f9837$var$categoryToAreaTotal[category].original];
        const customTotalForContext = $85x8Z.getAreaForContext(customTotal, sfType, location, lossFactor);
        const originalTotalForContext = $85x8Z.getAreaForContext(originalTotal, sfType, location, lossFactor);
        return $2a4962b1e81f9837$var$getDeltaHelper(customTotalForContext, originalTotalForContext);
    }
};



var $85x8Z = parcelRequire("85x8Z");
var $4fc4a2a0b29668d5$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $460e9 = parcelRequire("460e9");

var $85x8Z = parcelRequire("85x8Z");

var $aB89e = parcelRequire("aB89e");
var $4fc4a2a0b29668d5$require$constants = $aB89e.spacerFree;
var $d550ce47c75bbc11$exports = {};

var $jHTLJ = parcelRequire("jHTLJ");
var $d550ce47c75bbc11$require$connect = $jHTLJ.connect;

var $eShmq = parcelRequire("eShmq");
var $d550ce47c75bbc11$require$bindActionCreators = $eShmq.bindActionCreators;

var $aB89e = parcelRequire("aB89e");
var $d550ce47c75bbc11$require$constants = $aB89e.shared;

var $6e7dbeaa5966242f$exports = {};
const $6e7dbeaa5966242f$var$DETECT_CHANGE_ON_RESULTS = "DETECT_CHANGE_ON_RESULTS";
const $6e7dbeaa5966242f$var$CHANGE_TO_RESULTS_SAVED = "CHANGE_TO_RESULTS_SAVED";
$6e7dbeaa5966242f$exports = {
    DETECT_CHANGE_ON_RESULTS: // Action types
    $6e7dbeaa5966242f$var$DETECT_CHANGE_ON_RESULTS,
    CHANGE_TO_RESULTS_SAVED: $6e7dbeaa5966242f$var$CHANGE_TO_RESULTS_SAVED,
    // Action creators
    detectChangeToSaveOnResults () {
        return {
            type: $6e7dbeaa5966242f$var$DETECT_CHANGE_ON_RESULTS
        };
    },
    changeToResultsSaved () {
        return {
            type: $6e7dbeaa5966242f$var$CHANGE_TO_RESULTS_SAVED
        };
    }
};


var $b02571d867baa0fc$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $8dfee474cfb1f477$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9sdkt = parcelRequire("9sdkt");
function $8dfee474cfb1f477$var$Tooltip(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9sdkt, {
        ...props,
        img: "/svg/icons/info-dark-grey-icon-spacer-by-cbre.svg"
    });
}
$8dfee474cfb1f477$exports = $8dfee474cfb1f477$var$Tooltip;


function $b02571d867baa0fc$var$RadioInput(props) {
    let isActive;
    const radioElements = props.options.map((option)=>{
        isActive = props.value === option.value;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "control radio-control",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                className: isActive ? "is-active" : "",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "radio",
                        name: props.name,
                        value: isActive ? "on" : "",
                        onClick: ()=>props.onChange(option.value)
                    }),
                    option.text,
                    option.tooltipText && /*#__PURE__*/ (0, $ayMG0.jsx)($8dfee474cfb1f477$exports, {
                        text: option.tooltipText
                    })
                ]
            })
        }, option.value);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "radio-control-container",
        children: radioElements
    });
}
$b02571d867baa0fc$var$RadioInput.propTypes = {
    name: $c9Z8w.string.isRequired,
    value: $c9Z8w.oneOfType([
        $c9Z8w.number,
        $c9Z8w.string
    ]).isRequired,
    onChange: $c9Z8w.func.isRequired,
    options: $c9Z8w.arrayOf($c9Z8w.shape({
        text: $c9Z8w.string.isRequired,
        value: $c9Z8w.oneOfType([
            $c9Z8w.number,
            $c9Z8w.string
        ]).isRequired
    })).isRequired
};
$b02571d867baa0fc$exports = $b02571d867baa0fc$var$RadioInput;



var $hjiT0 = parcelRequire("hjiT0");
// Map state to props
function $d550ce47c75bbc11$var$mapStateToProps(state, ownProps) {
    const optionsList = [
        {
            text: ownProps.t("measurementSystemSqFeetText"),
            value: $d550ce47c75bbc11$require$constants.calculator.MEASUREMENT_SYSTEM.IMPERIAL
        },
        {
            text: ownProps.t("measurementSystemSqMetersText"),
            value: $d550ce47c75bbc11$require$constants.calculator.MEASUREMENT_SYSTEM.METRIC
        }
    ];
    const { country: country } = $hjiT0.getCityStateCountry(state.userData.officeLocation);
    if ($hjiT0.isJapan(country)) optionsList.push({
        text: ownProps.t("measurementSystemTsuboText"),
        value: $d550ce47c75bbc11$require$constants.calculator.MEASUREMENT_SYSTEM.TSUBO
    });
    return {
        value: state.spaceData.measurementSystem,
        name: "measurementSystem",
        options: optionsList
    };
}
// Map dispatch to props
function $d550ce47c75bbc11$var$mapDispatchToProps(dispatch) {
    const updateMeasurementSystem = $d550ce47c75bbc11$require$bindActionCreators($7f3ddf5ab2cb44f3$exports.updateMeasurementSystem, dispatch);
    const detectChangeToSaveOnResults = $d550ce47c75bbc11$require$bindActionCreators($6e7dbeaa5966242f$exports.detectChangeToSaveOnResults, dispatch);
    return {
        onChange: (system)=>{
            updateMeasurementSystem(system);
            detectChangeToSaveOnResults();
        }
    };
}
$d550ce47c75bbc11$exports = $d550ce47c75bbc11$require$connect($d550ce47c75bbc11$var$mapStateToProps, $d550ce47c75bbc11$var$mapDispatchToProps)($b02571d867baa0fc$exports);


var $2ba9333cc46329cf$exports = {};

var $jHTLJ = parcelRequire("jHTLJ");
var $2ba9333cc46329cf$require$connect = $jHTLJ.connect;

var $eShmq = parcelRequire("eShmq");
var $2ba9333cc46329cf$require$bindActionCreators = $eShmq.bindActionCreators;

var $aB89e = parcelRequire("aB89e");
var $2ba9333cc46329cf$require$constants = $aB89e.spacerFree;

var $f1q41 = parcelRequire("f1q41");

var $460e9 = parcelRequire("460e9");



const $2ba9333cc46329cf$var$SF_TYPE = $2ba9333cc46329cf$require$constants.calculator.SF_TYPE;
// Map state to props
function $2ba9333cc46329cf$var$mapStateToProps(state, ownProps) {
    const unit = ownProps.t(`common:${$460e9.getTokenKeyForMeasurementSystem("feet", state.spaceData.measurementSystem)}`);
    const unitUppercase = $f1q41.capitalize(unit);
    const usableAreaTooltipText = ownProps.t("sfRadioInputUsableAreaTooltipText");
    const rentableAreaTooltipText = ownProps.t("sfRadioInputRentableAreaTooltipText", {
        unitUppercase: unitUppercase,
        unit: unit
    });
    return {
        value: state.spaceData.sfType,
        name: "sftype",
        options: [
            {
                value: $2ba9333cc46329cf$var$SF_TYPE.USF,
                text: ownProps.t("sfRadioInputUsableSquareText", {
                    unitUppercase: unitUppercase
                }),
                tooltipText: usableAreaTooltipText
            },
            {
                value: $2ba9333cc46329cf$var$SF_TYPE.RSF,
                text: ownProps.t("sfRadioInputRentableSquareText", {
                    unitUppercase: unitUppercase
                }),
                tooltipText: rentableAreaTooltipText
            }
        ]
    };
}
// Map dispatch to props
function $2ba9333cc46329cf$var$mapDispatchToProps(dispatch) {
    const updateSFType = $2ba9333cc46329cf$require$bindActionCreators($7f3ddf5ab2cb44f3$exports.updateSFType, dispatch);
    const detectChangeToSaveOnResults = $2ba9333cc46329cf$require$bindActionCreators($6e7dbeaa5966242f$exports.detectChangeToSaveOnResults, dispatch);
    return {
        onChange: (type)=>{
            updateSFType(type);
            detectChangeToSaveOnResults();
        }
    };
}
$2ba9333cc46329cf$exports = $2ba9333cc46329cf$require$connect($2ba9333cc46329cf$var$mapStateToProps, $2ba9333cc46329cf$var$mapDispatchToProps)($b02571d867baa0fc$exports);


var $56f4bfa5bb3ce489$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $56f4bfa5bb3ce489$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;

var $aB89e = parcelRequire("aB89e");
var $56f4bfa5bb3ce489$require$constants = $aB89e.spacerFree;
function $56f4bfa5bb3ce489$var$ProgramHeroForPrint(props) {
    const isNIA = props.sfType === $56f4bfa5bb3ce489$require$constants.calculator.SF_TYPE.NIA;
    const niaContent = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "column nsf",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "nsf-amount title is-4 has-text-primary is-sans-semibold",
                children: props.nsf
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "label is-sans-regular",
                children: props.t("printNIAText")
            })
        ]
    });
    const rsfUsfContent = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "columns",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "column usf",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "usf-amount title is-4 has-text-primary is-sans-semibold",
                        children: props.usf
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "label is-sans-regular",
                        children: props.t("printUSFText")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "column rsf",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "rsf-amount title is-4 has-text-primary is-sans-semibold",
                        children: props.rsf
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "label is-sans-regular",
                        children: props.t("printRSFText")
                    })
                ]
            })
        ]
    });
    const description = props.t("printDescText", {
        lossFactorPercentage: props.lossFactor,
        factorType: props.t(isNIA ? "printFitFactorText" : "printLossFactorText"),
        city: props.city
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "is-print-only program-hero-for-print section",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "columns",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "column is-3 loss-factor",
                        children: description
                    }),
                    isNIA ? niaContent : rsfUsfContent
                ]
            })
        })
    });
}
$56f4bfa5bb3ce489$var$ProgramHeroForPrint.propTypes = {
    lossFactor: $c9Z8w.number.isRequired,
    city: $c9Z8w.string.isRequired,
    usf: $c9Z8w.string.isRequired,
    rsf: $c9Z8w.string.isRequired,
    nsf: $c9Z8w.string.isRequired,
    sfType: $c9Z8w.number.isRequired,
    t: $c9Z8w.func.isRequired
};
$56f4bfa5bb3ce489$exports = $56f4bfa5bb3ce489$require$withTranslation("resultsPage")($56f4bfa5bb3ce489$var$ProgramHeroForPrint);




var $4fc4a2a0b29668d5$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;

var $ijNBi = parcelRequire("ijNBi");
var $4fc4a2a0b29668d5$require$dashOrValue = $ijNBi.dashOrValue;
const $4fc4a2a0b29668d5$var$SF_TYPE = $4fc4a2a0b29668d5$require$constants.calculator.SF_TYPE;
class $4fc4a2a0b29668d5$var$SpaceSummary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            showLossFactorHelper: false
        };
        this.toggleLossFactorHelper = this.toggleLossFactorHelper.bind(this);
    }
    toggleLossFactorHelper() {
        this.setState((prevState)=>({
                showLossFactorHelper: !prevState.showLossFactorHelper
            }));
    }
    render() {
        // Space Section Logic
        const selectedLanguage = this.props.i18n.language;
        const city = this.props.location.split(",")[0];
        const lossFactorInteger = Math.round(this.props.lossFactor * 100);
        const isRSF = this.props.sfType === $4fc4a2a0b29668d5$var$SF_TYPE.RSF;
        const isNIA = this.props.sfType === $4fc4a2a0b29668d5$var$SF_TYPE.NIA;
        const usf = $460e9.getNumberForMeasurementSystem(this.props.totalUSF, this.props.measurementSystem);
        const rsf = $460e9.getNumberForMeasurementSystem(this.props.totalRSF, this.props.measurementSystem, {
            precisionForFeet: -2
        });
        const rsfRange = $85x8Z.getRSFRange(this.props.totalRSF);
        if (selectedLanguage === "fr") rsfRange.min = this.props.totalRSF * 0.85;
        const rsfMin = $460e9.getNumberForMeasurementSystem(rsfRange.min, this.props.measurementSystem, {
            precisionForFeet: -2
        });
        const rsfMax = $460e9.getNumberForMeasurementSystem(rsfRange.max, this.props.measurementSystem, {
            precisionForFeet: -2
        });
        const rsfMinWithCommas = $5f15cdd5de4823b1$exports.numberWithLocaleFormat(rsfMin);
        const rsfMaxWithCommas = $5f15cdd5de4823b1$exports.numberWithLocaleFormat(rsfMax);
        let mainAreaCopy;
        const rsfOrRSM = this.props.t(`common:${$460e9.getTokenKeyForMeasurementSystem("RSF", this.props.measurementSystem)}`);
        const usfOrUSM = this.props.t(`common:${$460e9.getTokenKeyForMeasurementSystem("USF", this.props.measurementSystem)}`);
        const nia = this.props.t("common:NIA");
        const usfCopy = `${$4fc4a2a0b29668d5$require$dashOrValue(!usf, $5f15cdd5de4823b1$exports.numberWithLocaleFormat(usf))} ${usfOrUSM}`;
        const nsfCopy = `${$4fc4a2a0b29668d5$require$dashOrValue(!rsf, $5f15cdd5de4823b1$exports.numberWithLocaleFormat(rsf))} ${nia}`;
        const rsfMinCopy = `${$4fc4a2a0b29668d5$require$dashOrValue(!rsfMin, $5f15cdd5de4823b1$exports.numberWithLocaleFormat(rsfMin))} ${rsfOrRSM}`;
        const rsfMaxCopy = `${$4fc4a2a0b29668d5$require$dashOrValue(!rsfMax, $5f15cdd5de4823b1$exports.numberWithLocaleFormat(rsfMax))} ${rsfOrRSM}`;
        const rsfCopy = `${$4fc4a2a0b29668d5$require$dashOrValue(!rsf, $5f15cdd5de4823b1$exports.numberWithLocaleFormat(rsf))} ${rsfOrRSM}`;
        if (isRSF) mainAreaCopy = rsfCopy;
        else if (isNIA) mainAreaCopy = nsfCopy;
        else mainAreaCopy = usfCopy;
        const rsfBar = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "rsf-bar",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bar is-sans-regular has-text-primary",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "columns is-mobile",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "column is-one-quarter"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "bar-progress"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "min-max-labels flex flex-justify-between",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "min-rsf",
                                children: rsfMinCopy
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "max-rsf",
                                children: rsfMaxCopy
                            })
                        ]
                    })
                ]
            })
        });
        // Loss Factor Logic
        let lossFactorArrowClasses = "arrow-image";
        if (this.state.showLossFactorHelper) lossFactorArrowClasses += " is-up";
        const rsfLossFactorHelperText = this.props.t("spaceSummaryRSFLossFactorHelperText", {
            percentage: lossFactorInteger,
            place: city,
            min: rsfMinWithCommas,
            max: rsfMaxWithCommas,
            units: this.props.t(`common:${$460e9.getTokenKeyForMeasurementSystem("feet", this.props.measurementSystem)}`)
        });
        const niaLossFactorHelperText = this.props.t("spaceSummaryNIAFitFactorHelperText", {
            percentage: lossFactorInteger,
            place: city,
            amt: usf
        });
        const lossFactorHelper = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "loss-factor-helper-description is-sans-regular has-text-primary is-size-7",
            children: isNIA ? niaLossFactorHelperText : rsfLossFactorHelperText
        });
        const lossFactorSectionLabel = this.props.t("spaceSummaryLossFactorSectionLabel", {
            factor: isNIA ? this.props.t("spaceSummaryFitFactorText") : this.props.t("spaceSummaryLossFactorText")
        });
        const lossFactorSection = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "loss-factor-section",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "loss-factor-button flex no-outline",
                    onClick: this.toggleLossFactorHelper,
                    role: "button",
                    tabIndex: "0",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: lossFactorArrowClasses
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "loss-factor-text is-sans-regular has-text-primary",
                            children: lossFactorSectionLabel
                        })
                    ]
                }),
                this.state.showLossFactorHelper && lossFactorHelper
            ]
        });
        // Radio Inputs
        const sfRadioInput = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "radio-button-name is-sans-regular is-grey-dark has-padding-left-7",
                    children: this.props.t("spaceSummaryMeasurementTypeText")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($2ba9333cc46329cf$exports, {
                    t: this.props.t
                })
            ]
        });
        // Return
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($56f4bfa5bb3ce489$exports, {
                    lossFactor: lossFactorInteger,
                    city: city,
                    usf: usfCopy,
                    rsf: `${rsfMinCopy} - ${rsfMaxCopy}`,
                    nsf: nsfCopy,
                    sfType: this.props.sfType
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "space-summary",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "space-section has-padding-5",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "has-text-primary has-padding-bottom-6",
                                    children: this.props.t("spaceSummaryBarHeader")
                                }),
                                isRSF && rsfBar,
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "sf-label-container",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "title2 is-2 w-90",
                                            children: mainAreaCopy
                                        }),
                                        isNIA && /*#__PURE__*/ (0, $ayMG0.jsx)($8dfee474cfb1f477$exports, {
                                            text: this.props.t("spaceSummaryNIATooltipText")
                                        })
                                    ]
                                }),
                                !isNIA && sfRadioInput,
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "radio-button-name is-sans-regular is-grey-dark has-padding-left-7",
                                    children: this.props.t("spaceSummaryUnitTypeText")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($d550ce47c75bbc11$exports, {
                                    t: this.props.t
                                })
                            ]
                        }),
                        (isRSF || isNIA) && lossFactorSection
                    ]
                })
            ]
        });
    }
}
$4fc4a2a0b29668d5$var$SpaceSummary.propTypes = {
    location: $c9Z8w.string.isRequired,
    sfType: $c9Z8w.number.isRequired,
    lossFactor: $c9Z8w.number.isRequired,
    measurementSystem: $c9Z8w.string.isRequired,
    totalUSF: $c9Z8w.number.isRequired,
    totalRSF: $c9Z8w.number.isRequired,
    i18n: $c9Z8w.object.isRequired,
    t: $c9Z8w.func.isRequired
};
$4fc4a2a0b29668d5$exports = $4fc4a2a0b29668d5$require$withTranslation("resultsPage")($4fc4a2a0b29668d5$var$SpaceSummary);


// Map state to props
function $8f998ca26a3057d1$var$mapStateToProps(state) {
    const location = state.userData.officeLocation;
    const sfType = state.spaceData.sfType;
    const lossFactor = state.spaceData.lossFactor;
    const totalArea = $2a4962b1e81f9837$exports.getTotalSF(state.spaceData.program.areaTotals);
    return {
        location: location,
        sfType: sfType,
        lossFactor: lossFactor,
        measurementSystem: state.spaceData.measurementSystem,
        totalUSF: $85x8Z.getAreaForContext(totalArea, $8f998ca26a3057d1$require$constants.calculator.SF_TYPE.USF, location, lossFactor),
        totalRSF: $85x8Z.getAreaForContext(totalArea, $8f998ca26a3057d1$require$constants.calculator.SF_TYPE.RSF, location, lossFactor)
    };
}
$8f998ca26a3057d1$exports = $8f998ca26a3057d1$require$connect($8f998ca26a3057d1$var$mapStateToProps)($4fc4a2a0b29668d5$exports);




var $fafc8e9a8354bea6$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $fafc8e9a8354bea6$var$Profile(props) {
    const profileDescriptionParagraphs = props.description.split("\n");
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "results-profile",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($3d58e5ddff2e6c6a$exports, {
                profileName: props.displayName,
                profileHeroImagePath: props.profileHeroImagePath
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8dbf84adc5277014$exports, {
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "columns",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "space-summary-section column is-two-fifths-desktop is-half-tablet is-hidden-mobile",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($8f998ca26a3057d1$exports, {})
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "column is-three-fifths-desktop is-half-tablet profile-description-section",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "has-text-primary is-sans-semibold",
                                    children: props.t("resultsProfileSummaryTitle")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                profileDescriptionParagraphs.map((paragraph, i)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                children: [
                                                    paragraph,
                                                    i === profileDescriptionParagraphs.length - 1 && /*#__PURE__*/ (0, $ayMG0.jsx)($8dfee474cfb1f477$exports, {
                                                        position: "bottom",
                                                        text: props.t("resultsProfileTooltipText")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                                        ]
                                    }, paragraph.substring(0, 25))),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "columns is-mobile is-multiline has-padding-top-5 profile-traits-container",
                                    children: props.keyTraitIds.map((traitId)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "column is-half-mobile",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($73dd7f9ee93a0372$exports, {
                                                traitId: traitId,
                                                profileType: props.profileType
                                            })
                                        }, traitId))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mobile-space-summary-section column is-two-fifths is-hidden-desktop is-hidden-tablet has-padding-top-5-mobile",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($8f998ca26a3057d1$exports, {})
                        })
                    ]
                })
            })
        ]
    });
}
$fafc8e9a8354bea6$var$Profile.propTypes = {
    displayName: $c9Z8w.string.isRequired,
    description: $c9Z8w.string.isRequired,
    keyTraitIds: $c9Z8w.arrayOf($c9Z8w.string).isRequired,
    profileType: $c9Z8w.string.isRequired,
    profileHeroImagePath: $c9Z8w.string.isRequired,
    t: $c9Z8w.func.isRequired
};
$fafc8e9a8354bea6$exports = $fafc8e9a8354bea6$require$withTranslation("resultsPage")($fafc8e9a8354bea6$var$Profile);


// Map state to props
function $e964d86ceb037aa8$var$mapStateToProps(state, ownProps) {
    const profile = $e964d86ceb037aa8$require$profileMap[state.spaceData.profileId];
    const profileType = state.spaceData.profileType;
    return {
        displayName: ownProps.t(profile.displayNameToken),
        description: ownProps.t(profile.descriptionToken),
        keyTraitIds: profile.keyTraitIds,
        profileType: state.spaceData.profileType,
        profileHeroImagePath: profile.profileHeroImage
    };
}
// Map dispatch to props
function $e964d86ceb037aa8$var$mapDispatchToProps(dispatch) {
    return {
        openModal: $e964d86ceb037aa8$require$bindActionCreators($15a18ec2484069fc$exports.openModal, dispatch)
    };
}
$e964d86ceb037aa8$exports = $e964d86ceb037aa8$require$connect($e964d86ceb037aa8$var$mapStateToProps, $e964d86ceb037aa8$var$mapDispatchToProps)($fafc8e9a8354bea6$exports);


var $cdbd81a78e01d6bf$exports = {};


var $jHTLJ = parcelRequire("jHTLJ");
var $cdbd81a78e01d6bf$require$connect = $jHTLJ.connect;

var $eShmq = parcelRequire("eShmq");
var $cdbd81a78e01d6bf$require$bindActionCreators = $eShmq.bindActionCreators;
var $ec30531dc383a3d7$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $f1q41 = parcelRequire("f1q41");

var $ec30531dc383a3d7$require$constants = (parcelRequire("aB89e")).spacerFree;

const $ec30531dc383a3d7$var$SPACE_UNIT_CATEGORY = (parcelRequire("aB89e")).shared.spaceUnit.CATEGORY;

var $7e4764e91f130780$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $jHTLJ = parcelRequire("jHTLJ");
var $7e4764e91f130780$require$connect = $jHTLJ.connect;

var $c9Z8w = parcelRequire("c9Z8w");


var $85x8Z = parcelRequire("85x8Z");

const $7e4764e91f130780$var$SPACE_UNIT_CATEGORY = (parcelRequire("aB89e")).shared.spaceUnit.CATEGORY;

var $e431d00bfe1ed655$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $jxSY2 = parcelRequire("jxSY2");

var $56juP = parcelRequire("56juP");

var $e431d00bfe1ed655$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $e431d00bfe1ed655$var$BarChart(props) {
    function parsePercentage(percentage) {
        return parseInt(percentage.substring(0, percentage.length - 1), 10);
    }
    const isMobile = $56juP.isScreenMobileSize();
    const isEmpty = !parsePercentage(props.mePercentage) && !parsePercentage(props.wePercentage) && !parsePercentage(props.amenityPercentage);
    const classes = $8g1PZ("flex program-bar-chart office-breakdown-barchart", {
        "is-mobile-input-flex": isMobile,
        "is-hidden-mobile": !isMobile,
        "program-bar-chart-empty": isEmpty
    });
    if (isEmpty) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: classes,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "small-text",
            children: "Add a headcount to see a space breakdown."
        })
    });
    const barChartSegmentData = [
        {
            colorClass: "me",
            percentage: props.mePercentage,
            percentageSubtitle: props.t("barChartIndivSubtitle"),
            isMobileScreen: isMobile
        },
        {
            colorClass: "we",
            percentage: props.wePercentage,
            percentageSubtitle: props.t("barChartGroupSubtitle"),
            isMobileScreen: isMobile,
            isGroupSpace: true
        },
        {
            colorClass: "amenity",
            percentage: props.amenityPercentage,
            percentageSubtitle: props.t("barChartAmenitySubtitle"),
            isMobileScreen: isMobile
        }
    ];
    const barChartItems = barChartSegmentData.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)($jxSY2, {
            ...item
        }, item.percentageSubtitle));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: classes,
        children: barChartItems
    });
}
$e431d00bfe1ed655$var$BarChart.propTypes = {
    mePercentage: $c9Z8w.string.isRequired,
    wePercentage: $c9Z8w.string.isRequired,
    amenityPercentage: $c9Z8w.string.isRequired,
    t: $c9Z8w.func.isRequired
};
$e431d00bfe1ed655$exports = $e431d00bfe1ed655$require$withTranslation("resultsPage")($e431d00bfe1ed655$var$BarChart);


var $dc04eb8a541039e3$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

const $dc04eb8a541039e3$var$SPACE_UNIT_CATEGORY = (parcelRequire("aB89e")).shared.spaceUnit.CATEGORY;

var $dc04eb8a541039e3$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;

var $jxSY2 = parcelRequire("jxSY2");
function $dc04eb8a541039e3$var$TabbedProgramBarChart(props) {
    const onSelectSegment = function(spaceUnitCategory) {
        return ()=>props.updateActiveCategory(spaceUnitCategory);
    };
    const barChartSegmentData = [
        {
            colorClass: "me",
            spaceUnitCategory: $dc04eb8a541039e3$var$SPACE_UNIT_CATEGORY.ME,
            amount: props.meSF,
            percentage: props.mePercentage,
            percentageSubtitle: props.t("tabbedBarChartMeSubtitle")
        },
        {
            colorClass: "we",
            spaceUnitCategory: $dc04eb8a541039e3$var$SPACE_UNIT_CATEGORY.WE,
            amount: props.weSF,
            percentage: props.wePercentage,
            percentageSubtitle: props.t("tabbedBarChartGroupSubtitle"),
            isGroupSpace: true
        },
        {
            colorClass: "amenity",
            spaceUnitCategory: $dc04eb8a541039e3$var$SPACE_UNIT_CATEGORY.AMENITY,
            amount: props.amenitySF,
            percentage: props.amenityPercentage,
            percentageSubtitle: props.t("tabbedBarChartAmenitySubtitle")
        }
    ];
    const barChartItems = barChartSegmentData.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)($jxSY2, {
            isInactive: props.activeCategory !== item.spaceUnitCategory,
            onSelectSegment: onSelectSegment(item.spaceUnitCategory),
            leadWithPercentage: true,
            measurementSystem: props.measurementSystem,
            ...item
        }, item.percentageSubtitle));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "flex program-bar-chart has-padding-3 has-no-padding-mobile",
        children: barChartItems
    });
}
$dc04eb8a541039e3$var$TabbedProgramBarChart.propTypes = {
    meSF: $c9Z8w.number.isRequired,
    weSF: $c9Z8w.number.isRequired,
    amenitySF: $c9Z8w.number.isRequired,
    mePercentage: $c9Z8w.string.isRequired,
    wePercentage: $c9Z8w.string.isRequired,
    amenityPercentage: $c9Z8w.string.isRequired,
    activeCategory: $c9Z8w.string.isRequired,
    updateActiveCategory: $c9Z8w.func.isRequired,
    measurementSystem: $c9Z8w.string.isRequired,
    t: $c9Z8w.func.isRequired
};
$dc04eb8a541039e3$exports = $dc04eb8a541039e3$require$withTranslation("resultsPage")($dc04eb8a541039e3$var$TabbedProgramBarChart);


function $7e4764e91f130780$var$ProgramBarChart(props) {
    if (props.isTabbedBarChart) return /*#__PURE__*/ (0, $ayMG0.jsx)($dc04eb8a541039e3$exports, {
        ...props
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e431d00bfe1ed655$exports, {
        ...props
    });
}
// Map state to props
function $7e4764e91f130780$var$mapStateToProps(state) {
    const location = state.userData.officeLocation;
    const sfType = state.spaceData.sfType;
    const lossFactor = state.spaceData.lossFactor;
    const areaTotals = state.spaceData.program.areaTotals;
    const areaPercentage = state.spaceData.program.areaPercentage;
    const meSF = $85x8Z.getAreaForContext($2a4962b1e81f9837$exports.getTotalSFForCategory(areaTotals, $7e4764e91f130780$var$SPACE_UNIT_CATEGORY.ME), sfType, location, lossFactor);
    const weSF = $85x8Z.getAreaForContext($2a4962b1e81f9837$exports.getTotalSFForCategory(areaTotals, $7e4764e91f130780$var$SPACE_UNIT_CATEGORY.WE), sfType, location, lossFactor);
    const amenitySF = $85x8Z.getAreaForContext($2a4962b1e81f9837$exports.getTotalSFForCategory(areaTotals, $7e4764e91f130780$var$SPACE_UNIT_CATEGORY.AMENITY), sfType, location, lossFactor);
    const mePercentage = areaPercentage.me;
    const wePercentage = areaPercentage.we;
    const amenityPercentage = areaPercentage.amenity;
    return {
        meSF: meSF,
        weSF: weSF,
        amenitySF: amenitySF,
        mePercentage: mePercentage,
        wePercentage: wePercentage,
        amenityPercentage: amenityPercentage,
        measurementSystem: state.spaceData.measurementSystem
    };
}
$7e4764e91f130780$var$ProgramBarChart.propTypes = {
    isTabbedBarChart: $c9Z8w.bool
};
$7e4764e91f130780$var$ProgramBarChart.defaultProps = {
    isTabbedBarChart: false
};
$7e4764e91f130780$exports = $7e4764e91f130780$require$connect($7e4764e91f130780$var$mapStateToProps)($7e4764e91f130780$var$ProgramBarChart);


var $6b5edee5943f98ff$exports = {};

var $jHTLJ = parcelRequire("jHTLJ");
var $6b5edee5943f98ff$require$connect = $jHTLJ.connect;
var $6a040e1c9df0c798$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $c9Z8w = parcelRequire("c9Z8w");
var $6af3a386ee8ee259$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $f1q41 = parcelRequire("f1q41");
function $6af3a386ee8ee259$var$formatStatValue(stat) {
    if ($f1q41.endsWith(stat, "%")) {
        const newStat = stat.substring(0, stat.length - 1);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: newStat
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "title is-4 program-stat-value-percent",
                    children: "%"
                })
            ]
        });
    }
    return stat;
}
function $6af3a386ee8ee259$var$StatWithSubtitle(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "column",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "program-stat-content",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    className: "title is-6 program-stat-title has-margin-bottom-4 is-sans-semibold",
                    children: props.statTitle
                }),
                props.isRatio ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-row flex-justify-around",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "program-stat-content-column has-text-centered",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "title is-2 has-text-primary program-stat-value is-sans-semibold",
                                    children: $6af3a386ee8ee259$var$formatStatValue(props.stat[0])
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "subtitle ratio-width is-6 has-text-light is-sans-regular program-stat-subtitle",
                                    children: props.statSubtitle[0]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "title is-2 program-stat-value is-sans-semibold has-text-grey-light has-text-centered",
                            children: ":"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "program-stat-content-column program-stat-right-col has-text-centered",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "title is-2 has-text-primary program-stat-value is-sans-semibold ",
                                    children: $6af3a386ee8ee259$var$formatStatValue(props.stat[1])
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "subtitle is-6 has-text-light is-sans-regular program-stat-subtitle",
                                    children: props.statSubtitle[1]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "title is-2 has-text-primary program-stat-value is-sans-semibold has-text-centered",
                            children: props.stat
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "subtitle is-6 has-text-light is-sans-regular has-text-centered program-stat-subtitle",
                            children: props.statSubtitle
                        })
                    ]
                })
            ]
        })
    });
}
$6af3a386ee8ee259$var$StatWithSubtitle.propTypes = {
    statTitle: $c9Z8w.string.isRequired,
    stat: $c9Z8w.oneOfType([
        $c9Z8w.arrayOf($c9Z8w.string),
        $c9Z8w.string
    ]).isRequired,
    statSubtitle: $c9Z8w.oneOfType([
        $c9Z8w.arrayOf($c9Z8w.string),
        $c9Z8w.string
    ]).isRequired,
    isRatio: $c9Z8w.bool.isRequired
};
$6af3a386ee8ee259$var$StatWithSubtitle.defaultProps = {
    tooltipText: ""
};
$6af3a386ee8ee259$exports = $6af3a386ee8ee259$var$StatWithSubtitle;




var $460e9 = parcelRequire("460e9");

var $ijNBi = parcelRequire("ijNBi");
var $6a040e1c9df0c798$require$dashOrValue = $ijNBi.dashOrValue;

var $aB89e = parcelRequire("aB89e");
var $6a040e1c9df0c798$require$constants = $aB89e.spacerFree;

var $85x8Z = parcelRequire("85x8Z");

var $6a040e1c9df0c798$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
const $6a040e1c9df0c798$var$SF_TYPE = $6a040e1c9df0c798$require$constants.calculator.SF_TYPE;
const $6a040e1c9df0c798$var$SF_TYPE_ADJECTIVES = $6a040e1c9df0c798$require$constants.calculator.SF_TYPE_ADJECTIVES;
function $6a040e1c9df0c798$var$ProgramStats(props) {
    const [workstationPercentage, officePercentage] = $5f15cdd5de4823b1$exports.decimalTo100PercentageRatioArrayFormat(props.programStats.openPercentage);
    let collaborationRatioDecimal = $6a040e1c9df0c798$require$dashOrValue(!props.programStats.collabSeatRatio, $5f15cdd5de4823b1$exports.numberWithLocaleFormat(Math.round(props.programStats.collabSeatRatio * 100, 10) / 100));
    let seatsToPeopleRatioDecimal = $6a040e1c9df0c798$require$dashOrValue(!props.programStats.sharingRatio, $5f15cdd5de4823b1$exports.numberWithLocaleFormat(Math.round(props.programStats.sharingRatio * 100, 10) / 100));
    const unit = props.t(`common:${$460e9.getTokenKeyForMeasurementSystem("feet", props.measurementSystem)}`);
    const unitUppercase = $f1q41.capitalize(unit);
    // Cut leading 0
    // consulted with Lena, don't cut off leading 0 in German
    if (collaborationRatioDecimal.indexOf("0.") === 0) collaborationRatioDecimal = collaborationRatioDecimal.substr(1);
    if (seatsToPeopleRatioDecimal.indexOf("0.") === 0) seatsToPeopleRatioDecimal = seatsToPeopleRatioDecimal.substr(1);
    const usfPerSeat = props.programStats.usfPerSeat;
    const density = props.sfType === $6a040e1c9df0c798$var$SF_TYPE.USF || props.sfType === $6a040e1c9df0c798$var$SF_TYPE.NIA ? usfPerSeat : $85x8Z.getRSFForLocation(props.location, usfPerSeat, props.lossFactor);
    const densityForMeasurementSystem = $6a040e1c9df0c798$require$dashOrValue(!density || !$f1q41.isFinite(density), $5f15cdd5de4823b1$exports.numberWithLocaleFormat($460e9.getNumberForMeasurementSystem(density, props.measurementSystem)));
    let densitySubtitle;
    if ($460e9.isTsubo(props.measurementSystem)) densitySubtitle = props.t("programStatsDensitySubtitleTsubo");
    else densitySubtitle = props.t("programStatsDensitySubtitle", {
        adjective: props.t(`common:${$6a040e1c9df0c798$var$SF_TYPE_ADJECTIVES[props.sfType]}`),
        unitUppercase: unitUppercase
    });
    const statData = [
        {
            statTitle: props.t("programStatsIndivTitle"),
            stat: [
                workstationPercentage,
                officePercentage
            ],
            statSubtitle: [
                props.t("programStatsWorkstationsSubtitle"),
                props.t("programStatsOfficesSubtitle")
            ],
            isRatio: true
        },
        {
            statTitle: props.t("programStatsCollabTitle"),
            stat: [
                collaborationRatioDecimal,
                "1"
            ],
            statSubtitle: [
                props.t("programStatsEnclosedSubtitle"),
                props.t("programStatsIndivSeatSubtitle")
            ],
            isRatio: true
        },
        {
            statTitle: props.t("programStatsSeatsTitle"),
            stat: [
                seatsToPeopleRatioDecimal,
                "1"
            ],
            statSubtitle: [
                props.t("programStatsIndivSeatsSubtitle"),
                props.t("programStatsPersonSubtitle")
            ],
            isRatio: true
        },
        {
            statTitle: props.t("programStatsDensityTitle"),
            stat: densityForMeasurementSystem.toString(),
            statSubtitle: props.t("programStatsFullDensitySubtitle", {
                density: densitySubtitle
            }),
            isRatio: false
        }
    ];
    const statItems = statData.map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)($6af3a386ee8ee259$exports, {
            ...item
        }, item.statTitle));
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "columns program-stats",
        children: statItems
    });
}
$6a040e1c9df0c798$var$ProgramStats.propTypes = {
    programStats: $c9Z8w.shape({
        openPercentage: $c9Z8w.number,
        collabSeatRatio: $c9Z8w.number,
        sharingRatio: $c9Z8w.number,
        usfPerSeat: $c9Z8w.number
    }).isRequired,
    measurementSystem: $c9Z8w.string.isRequired,
    sfType: $c9Z8w.number.isRequired,
    location: $c9Z8w.string.isRequired,
    lossFactor: $c9Z8w.number.isRequired,
    t: $c9Z8w.func.isRequired
};
$6a040e1c9df0c798$exports = $6a040e1c9df0c798$require$withTranslation("resultsPage")($6a040e1c9df0c798$var$ProgramStats);


// Map state to props
function $6b5edee5943f98ff$var$mapStateToProps(state) {
    return {
        location: state.userData.officeLocation,
        sfType: state.spaceData.sfType,
        lossFactor: state.spaceData.lossFactor
    };
}
$6b5edee5943f98ff$exports = $6b5edee5943f98ff$require$connect($6b5edee5943f98ff$var$mapStateToProps, null)($6a040e1c9df0c798$exports);


var $a777271149d2323f$exports = {};

var $jHTLJ = parcelRequire("jHTLJ");
var $a777271149d2323f$require$connect = $jHTLJ.connect;

var $eShmq = parcelRequire("eShmq");
var $a777271149d2323f$require$bindActionCreators = $eShmq.bindActionCreators;

var $2e21ea82bc4b094d$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $aB89e = parcelRequire("aB89e");
var $2e21ea82bc4b094d$require$constants = $aB89e.spacerFree;

var $427fbdf9a564bd7f$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $3EC2Q = parcelRequire("3EC2Q");

var $aB89e = parcelRequire("aB89e");
var $427fbdf9a564bd7f$require$constants = $aB89e.spacerFree;


var $427fbdf9a564bd7f$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
const $427fbdf9a564bd7f$var$optionOrder = [
    $427fbdf9a564bd7f$require$constants.calculator.DENSITY_LEVEL.SAME,
    $427fbdf9a564bd7f$require$constants.calculator.DENSITY_LEVEL.LOW,
    $427fbdf9a564bd7f$require$constants.calculator.DENSITY_LEVEL.NOT_SURE
];
function $427fbdf9a564bd7f$var$CirculationDropdown(props) {
    const dropdownOptions = {
        [$427fbdf9a564bd7f$require$constants.calculator.DENSITY_LEVEL.SAME]: {
            text: props.t("preCovidText")
        },
        [$427fbdf9a564bd7f$require$constants.calculator.DENSITY_LEVEL.LOW]: {
            text: props.t("higherText")
        },
        [$427fbdf9a564bd7f$require$constants.calculator.DENSITY_LEVEL.NOT_SURE]: {
            text: props.t("notSureText")
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c0bae42d849a79e8$exports, {
        options: dropdownOptions,
        optionOrder: $427fbdf9a564bd7f$var$optionOrder,
        ...props
    });
}
$427fbdf9a564bd7f$var$CirculationDropdown.propTypes = {
    value: $3EC2Q.stringOrNumber.isRequired,
    onValueChange: $c9Z8w.func.isRequired,
    disabled: $c9Z8w.bool,
    isLarge: $c9Z8w.bool,
    t: $c9Z8w.func.isRequired
};
$427fbdf9a564bd7f$var$CirculationDropdown.defaultProps = {
    disabled: false,
    isLarge: false
};
$427fbdf9a564bd7f$exports = $427fbdf9a564bd7f$require$withTranslation("resultsPage")($427fbdf9a564bd7f$var$CirculationDropdown);





var $460e9 = parcelRequire("460e9");

var $ijNBi = parcelRequire("ijNBi");
var $2e21ea82bc4b094d$require$dashOrValue = $ijNBi.dashOrValue;


var $lzNIT = parcelRequire("lzNIT");
var $2e21ea82bc4b094d$require$ReactRouterLink = $lzNIT.Link;

var $fPryk = parcelRequire("fPryk");
var $2e21ea82bc4b094d$require$profileMap = $fPryk.profileMap;

var $2e21ea82bc4b094d$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
const $2e21ea82bc4b094d$var$SF_TYPE = $2e21ea82bc4b094d$require$constants.calculator.SF_TYPE;
class $2e21ea82bc4b094d$var$ProgramAssumptions extends $acw62.Component {
    constructor(props){
        super(props);
        this.updateKeyAssumptionState = this.updateKeyAssumptionState.bind(this);
        this.headcountInputOnValueChange = this.headcountInputOnValueChange.bind(this);
        this.collaborationDropdownOnValueChange = this.collaborationDropdownOnValueChange.bind(this);
        this.daysInOfficeDropdownOnValueChange = this.daysInOfficeDropdownOnValueChange.bind(this);
        this.circulationDropdownOnValueChange = this.circulationDropdownOnValueChange.bind(this);
    }
    updateKeyAssumptionState(assumptionType, value) {
        value = parseFloat(value);
        if (isNaN(value)) value = 0;
        this.props.updateKeyAssumption(assumptionType, value);
        this.props.detectChangeToSaveOnResults();
    }
    headcountInputOnValueChange(value) {
        this.updateKeyAssumptionState($2e21ea82bc4b094d$require$constants.questionUnit.ASSUMPTION_TYPE.HEADCOUNT, value);
    }
    collaborationDropdownOnValueChange(value) {
        this.updateKeyAssumptionState($2e21ea82bc4b094d$require$constants.questionUnit.ASSUMPTION_TYPE.COLLABORATION, value);
    }
    circulationDropdownOnValueChange(value) {
        this.updateKeyAssumptionState($2e21ea82bc4b094d$require$constants.questionUnit.ASSUMPTION_TYPE.DENSITY, value);
    }
    daysInOfficeDropdownOnValueChange(value) {
        this.updateKeyAssumptionState($2e21ea82bc4b094d$require$constants.questionUnit.ASSUMPTION_TYPE.DAYS_IN_OFFICE, value);
    }
    render() {
        const isNIA = this.props.sfType === $2e21ea82bc4b094d$var$SF_TYPE.NIA;
        let formattedTotalRSF = $460e9.getNumberForMeasurementSystem(this.props.totalRSF, this.props.measurementSystem);
        formattedTotalRSF = $2e21ea82bc4b094d$require$dashOrValue(!this.props.totalRSF, $5f15cdd5de4823b1$exports.numberWithLocaleFormat(formattedTotalRSF));
        let profileName = $2e21ea82bc4b094d$require$profileMap[this.props.currentProfileId].displayNameToken;
        const nameSplit = this.props.t(profileName).split(" ");
        profileName = nameSplit[1] ? nameSplit[1] : nameSplit[0]; // Removes the "the" in languages where that is a separate word vs a conjunction
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "assumptions-controls",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "columns assumptions-controls-container",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "column is-3-desktop is-full-tablet assumption-container recommended-office-size-section",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex flex-col flex-align-items-start has-margin-left-6 recommended-office-size-content",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "subtitle is-6 no-margin-bottom",
                                        children: this.props.t("programAssumptionsRecommendedOfficeSizeText")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "subtitle is-3",
                                        children: [
                                            formattedTotalRSF,
                                            " ",
                                            this.props.t(`common:${isNIA ? "NIA" : $460e9.getTokenKeyForMeasurementSystem("RSF", this.props.measurementSystem)}`)
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mobile-assumption-separator is-mobile-input"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "column assumption-container",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "assumption-separator has-margin-right-6 is-hidden-mobile"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "assumption-title is-hidden-mobile",
                                            children: this.props.t("programAssumptionsProfileText")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "profile-and-headcount-assumption-style is-hidden-mobile",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($2e21ea82bc4b094d$require$ReactRouterLink, {
                                                    to: {
                                                        pathname: "/profile-comparison-spacer-by-cbre",
                                                        programId: this.props.programId
                                                    },
                                                    className: "underline-input profile-type-name is-hidden-mobile",
                                                    children: profileName
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "underline-input profile-type-name is-mobile-input",
                                                    children: profileName
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "is-mobile-input flex flex-row mobile-assumption-container",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "assumption-title pull-start mobile-assumption-title",
                                            children: this.props.t("programAssumptionsProfileText")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mobile-assumption",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "underline-input profile-type-name is-mobile-input",
                                                children: profileName
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "columns assumptions-controls-container",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "column assumption-container",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "headcount-container",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "assumption-title is-hidden-mobile",
                                            children: this.props.t("programAssumptionsHeadcountText")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "profile-and-headcount-assumption-style is-hidden-mobile flex flex-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "headCount",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($6cbed09b54427939$exports, {
                                                        value: this.props.assumptions.headcount,
                                                        onValueChange: this.headcountInputOnValueChange,
                                                        hasXlargeArrows: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "assumption-title is-hidden-mobile headcount-following-text",
                                                    children: this.props.t("programAssumptionsHeadcountFollowingText")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "is-mobile-input flex flex-row mobile-assumption-container",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "assumption-title pull-start mobile-assumption-title",
                                            children: this.props.t("programAssumptionsHeadcountText")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mobile-assumption",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($6cbed09b54427939$exports, {
                                                value: this.props.assumptions.headcount,
                                                onValueChange: this.headcountInputOnValueChange,
                                                hasXlargeArrows: true
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mobile-assumption-separator is-mobile-input"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "column assumption-container",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "assumption-separator collaboration-assumption-separator has-margin-right-6 is-hidden-mobile"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "assumption-title is-hidden-mobile",
                                            children: this.props.t("programAssumptionsCollabText")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "collaboration-assumption-style is-hidden-mobile",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($498ea781240bc624$exports, {
                                                value: this.props.assumptions.collaboration,
                                                onValueChange: this.collaborationDropdownOnValueChange
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "is-mobile-input flex flex-row mobile-assumption-container",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "assumption-title pull-start mobile-assumption-title",
                                            children: this.props.t("programAssumptionsCollabText")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mobile-assumption",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($498ea781240bc624$exports, {
                                                value: this.props.assumptions.collaboration,
                                                onValueChange: this.collaborationDropdownOnValueChange
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mobile-assumption-separator is-mobile-input"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "column assumption-container",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "assumption-separator collaboration-assumption-separator has-margin-right-6 is-hidden-mobile"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "assumption-title is-hidden-mobile",
                                            children: this.props.t("programAssumptionsCirculationText")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "circulation-assumption-style is-hidden-mobile",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "circulation-dropdown",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "circulation-dropdown-input",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($427fbdf9a564bd7f$exports, {
                                                        value: this.props.assumptions.officeDensity,
                                                        onValueChange: this.circulationDropdownOnValueChange
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "is-mobile-input flex flex-row mobile-assumption-container",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "assumption-title pull-start mobile-assumption-title",
                                            children: this.props.t("programAssumptionsCirculationText")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mobile-assumption ",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($427fbdf9a564bd7f$exports, {
                                                value: this.props.assumptions.officeDensity,
                                                onValueChange: this.circulationDropdownOnValueChange
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mobile-assumption-separator is-mobile-input"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "column assumption-container",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "assumption-separator is-hidden-mobile days-per-week-assumption-separator"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "assumption-title is-hidden-mobile days-per-week-assumption-text",
                                            children: this.props.t("programAssumptionsAvgDaysText")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "days-in-office-assumption-style is-hidden-mobile flex flex-row",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($535eeb685e7404c1$exports, {
                                                    value: this.props.assumptions.daysPerWeekInOffice,
                                                    onValueChange: this.daysInOfficeDropdownOnValueChange
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "assumption-title is-hidden-mobile days-per-week-assumption-text per-week-text",
                                                    children: this.props.t("programAssumptionsAvgDaysFollowingText")
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "is-mobile-input flex flex-row mobile-assumption-container",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "assumption-title pull-start mobile-assumption-title",
                                            children: this.props.t("programAssumptionsAvgDaysPerWeekText")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "mobile-assumption",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)($535eeb685e7404c1$exports, {
                                                value: this.props.assumptions.daysPerWeekInOffice,
                                                onValueChange: this.daysInOfficeDropdownOnValueChange
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
$2e21ea82bc4b094d$var$ProgramAssumptions.propTypes = {
    assumptions: $3e58c681e2cb99b8$exports.assumptionsShape.isRequired,
    updateKeyAssumption: $c9Z8w.func.isRequired,
    measurementSystem: $c9Z8w.string.isRequired,
    totalRSF: $c9Z8w.number.isRequired,
    sfType: $c9Z8w.number.isRequired,
    profileType: $c9Z8w.string.isRequired,
    currentProfileId: $c9Z8w.string.isRequired,
    detectChangeToSaveOnResults: $c9Z8w.func.isRequired,
    programId: $c9Z8w.string.isRequired,
    t: $c9Z8w.func.isRequired
};
$2e21ea82bc4b094d$exports = $2e21ea82bc4b094d$require$withTranslation("resultsPage")($2e21ea82bc4b094d$var$ProgramAssumptions);




var $85x8Z = parcelRequire("85x8Z");

var $aB89e = parcelRequire("aB89e");
var $a777271149d2323f$require$constants = $aB89e.spacerFree;
// Map state to props
function $a777271149d2323f$var$mapStateToProps(state) {
    const totalArea = $2a4962b1e81f9837$exports.getTotalSF(state.spaceData.program.areaTotals);
    return {
        assumptions: state.spaceData.assumptions,
        measurementSystem: state.spaceData.measurementSystem,
        sfType: state.spaceData.sfType,
        totalRSF: $85x8Z.getAreaForContext(totalArea, $a777271149d2323f$require$constants.calculator.SF_TYPE.RSF, state.userData.officeLocation, state.spaceData.lossFactor),
        profileType: state.spaceData.profileType,
        currentProfileId: state.spaceData.profileId,
        programId: state.spaceData._id
    };
}
// Map dispatch to props
function $a777271149d2323f$var$mapDispatchToProps(dispatch) {
    return {
        updateKeyAssumption: $a777271149d2323f$require$bindActionCreators($7f3ddf5ab2cb44f3$exports.updateKeyAssumption, dispatch)
    };
}
$a777271149d2323f$exports = $a777271149d2323f$require$connect($a777271149d2323f$var$mapStateToProps, $a777271149d2323f$var$mapDispatchToProps)($2e21ea82bc4b094d$exports);


var $7e261e546ab7b524$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $7e261e546ab7b524$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $7e261e546ab7b524$var$TestFit(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "test-fit",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($81e115b62a8073a8$exports, {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "columns",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "column is-one-half",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "test-fit-info",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                    className: "title",
                                    children: props.t("testFitTitle")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "subtitle",
                                    children: props.t("testFitSubtitle")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "button cta-button is-primary-filled",
                                    onClick: props.openTestFitForm,
                                    children: props.t("requestTestFitButtonText")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "column",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: "/png/test-fit-example.png",
                            alt: "",
                            className: "test-fit-example-pair is-hidden-mobile"
                        })
                    })
                ]
            })
        })
    });
}
$7e261e546ab7b524$var$TestFit.propTypes = {
    openTestFitForm: $c9Z8w.func.isRequired,
    t: $c9Z8w.func.isRequired
};
$7e261e546ab7b524$exports = $7e261e546ab7b524$require$withTranslation("resultsPage")($7e261e546ab7b524$var$TestFit);


var $9b0229e22153adbc$exports = {};

var $jHTLJ = parcelRequire("jHTLJ");
var $9b0229e22153adbc$require$connect = $jHTLJ.connect;

var $eShmq = parcelRequire("eShmq");
var $9b0229e22153adbc$require$bindActionCreators = $eShmq.bindActionCreators;

var $6602635404395218$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $f1q41 = parcelRequire("f1q41");


var $6602635404395218$require$sendTestFitFormEmail = $b8d5e5d00fd08f22$exports.sendTestFitFormEmail;

var $6602635404395218$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $6602635404395218$var$TestFitForm(props) {
    // we have companyNameEmpty so that we don't show the empty company name error as soon as form opened
    const [companyName, setCompanyName] = $acw62.useState("");
    const [companyNameEmpty, setCompanyNameEmpty] = $acw62.useState(false);
    const [hasFloorPlate, setHasFloorPlate] = $acw62.useState(null);
    const [hasDrawingFile, setHasDrawingFile] = $acw62.useState(null);
    const [termsAndConditionsAgreed, setTermsAndConditionsAgreed] = $acw62.useState(false);
    const [emailSuccess, setEmailSuccess] = $acw62.useState(true);
    let secondRadioQuestionSpanText;
    if ($f1q41.isNull(hasDrawingFile)) secondRadioQuestionSpanText = null;
    else if (hasDrawingFile) secondRadioQuestionSpanText = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        id: "question2responseText",
        children: props.t("radioQ2yes")
    });
    else secondRadioQuestionSpanText = /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        id: "question2responseText",
        children: props.t("radioQ2no")
    });
    function submitTestFitForm(testFitFormData) {
        props.submitTestFitForm(testFitFormData);
        const testFitEmailObject = {
            company: testFitFormData.companyName,
            hasFloorPlate: testFitFormData.hasFloorPlate,
            hasDrawingFile: !!testFitFormData.hasDrawingFile,
            id: props.id
        };
        $6602635404395218$require$sendTestFitFormEmail(testFitEmailObject, ()=>{
            setEmailSuccess(true);
            props.completeTestFitForm();
        }, ()=>setEmailSuccess(false));
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "test-fit has-margin-top-3 has-margin-bottom-3",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($81e115b62a8073a8$exports, {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "columns",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "column is-4 is-offset-1",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "test-fit-info",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    className: "title",
                                    children: props.t("testFitFormTitle")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                    className: "subtitle",
                                    children: props.t("testFitFormSubtitle")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                    src: "/png/test-fit.png",
                                    alt: "",
                                    className: "is-hidden-mobile"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "column is-one-half flex",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("form", {
                                className: `flex flex-col ${props.completed && emailSuccess ? "flex-center-all completed-test-fit-form" : ""}`,
                                children: props.completed && emailSuccess ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "flex completed-test-fit-form-content",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: "/svg/icons/checkmark-white-icon-in-green-circle-large-spacer-by-cbre.svg",
                                            alt: ""
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: props.t("testFitFormCompleted")
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                            className: "form-title",
                                            children: props.t("common:formLabel")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                            type: "text",
                                            "aria-label": "Company name",
                                            placeholder: props.t("company"),
                                            value: companyName,
                                            onChange: (evt)=>{
                                                setCompanyNameEmpty(false);
                                                setCompanyName(evt.target.value);
                                            },
                                            "aria-describedby": "companyName"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: `form-error-text ${!companyNameEmpty ? "is-invisible" : ""}`,
                                            id: "companyName",
                                            children: props.t("emptyCompanyError")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "has-margin-bottom-8",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    id: "question1",
                                                    children: props.t("testFitFormQ1")
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    role: "radiogroup",
                                                    "aria-labelledby": "question1",
                                                    className: "flex test-fit-radio-pair",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    type: "radio",
                                                                    checked: !$f1q41.isNull(hasFloorPlate) && hasFloorPlate,
                                                                    onChange: ()=>setHasFloorPlate(true),
                                                                    "aria-describedby": "question1responseText",
                                                                    name: "question1"
                                                                }),
                                                                props.t("testFitFormYes")
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    type: "radio",
                                                                    checked: !$f1q41.isNull(hasFloorPlate) && !hasFloorPlate,
                                                                    onChange: ()=>{
                                                                        setHasFloorPlate(false);
                                                                        setHasDrawingFile(false);
                                                                    },
                                                                    "aria-describedby": "question1responseText",
                                                                    name: "question1"
                                                                }),
                                                                props.t("testFitFormNo")
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        hasFloorPlate === false && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            id: "question1responseText",
                                            children: props.t("testFitFormQ1No")
                                        }),
                                        hasFloorPlate && /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    id: "question2",
                                                    children: props.t("testFitFormQ2")
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    role: "radiogroup",
                                                    "aria-labelledby": "question2",
                                                    className: "flex test-fit-radio-pair",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    type: "radio",
                                                                    checked: !$f1q41.isNull(hasDrawingFile) && hasDrawingFile,
                                                                    onChange: ()=>setHasDrawingFile(true),
                                                                    "aria-describedby": "question2responseText",
                                                                    name: "question2"
                                                                }),
                                                                props.t("testFitFormYes")
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                                    type: "radio",
                                                                    checked: !$f1q41.isNull(hasDrawingFile) && !hasDrawingFile,
                                                                    onChange: ()=>setHasDrawingFile(false),
                                                                    "aria-describedby": "question2responseText",
                                                                    name: "question2"
                                                                }),
                                                                props.t("testFitFormNo")
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                secondRadioQuestionSpanText
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "test-fit-submit-section",
                                            children: [
                                                !$f1q41.isNull(hasFloorPlate) && /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                    className: `test-fit-terms-conditions checkbox in-results ${termsAndConditionsAgreed ? "is-active" : ""}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                            className: "visually-hidden",
                                                            type: "checkbox",
                                                            checked: termsAndConditionsAgreed,
                                                            onChange: ()=>setTermsAndConditionsAgreed((prevTermsAndConditionsAgreed)=>!prevTermsAndConditionsAgreed)
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            children: props.t("testFitTermsConditions")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                    className: "button cta-button is-primary-filled submit-test-fit-form-button",
                                                    onClick: (evt)=>{
                                                        evt.preventDefault();
                                                        if (companyName === "") setCompanyNameEmpty(true);
                                                        else submitTestFitForm({
                                                            companyName: companyName,
                                                            hasFloorPlate: hasFloorPlate,
                                                            hasDrawingFile: hasDrawingFile
                                                        });
                                                    },
                                                    disabled: !termsAndConditionsAgreed,
                                                    "aria-describedby": "backendError",
                                                    children: props.t("testFitSubmitButtonText")
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: `form-error-text email-success-error-text ${emailSuccess ? "is-invisible" : ""}`,
                                                    id: "backendError",
                                                    children: props.t("backendError")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            !props.completed && /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: props.closeTestFitForm,
                                className: "close-test-fit-form-button",
                                "aria-label": "Close test fit request form"
                            })
                        ]
                    })
                ]
            })
        })
    });
}
$6602635404395218$var$TestFitForm.propTypes = {
    submitTestFitForm: $c9Z8w.func.isRequired,
    completeTestFitForm: $c9Z8w.func.isRequired,
    closeTestFitForm: $c9Z8w.func.isRequired,
    completed: $c9Z8w.bool,
    id: $c9Z8w.string.isRequired,
    t: $c9Z8w.func.isRequired
};
$6602635404395218$var$TestFitForm.defaultProps = {
    completed: false
};
$6602635404395218$exports = $6602635404395218$require$withTranslation("resultsPage")($6602635404395218$var$TestFitForm);


// Map state to props
function $9b0229e22153adbc$var$mapStateToProps(state) {
    return {
        id: state.spaceData._id
    };
}
// Map dispatch to props
function $9b0229e22153adbc$var$mapDispatchToProps(dispatch) {
    return {
        // submitTestFitForm submits all the data from the form and updates the store with it, but doesn't flip the completedTestFit flag
        submitTestFitForm: $9b0229e22153adbc$require$bindActionCreators($3d5a8542f4e060ff$exports.addBulkUserData, dispatch),
        // completeTestFitForm flips the completedTestFit flag to true and does nothing else
        completeTestFitForm: $9b0229e22153adbc$require$bindActionCreators($3d5a8542f4e060ff$exports.completeTestFitForm, dispatch)
    };
}
$9b0229e22153adbc$exports = $9b0229e22153adbc$require$connect($9b0229e22153adbc$var$mapStateToProps, $9b0229e22153adbc$var$mapDispatchToProps)($6602635404395218$exports);


var $b2ecd9dbb8aa6b8f$exports = {};

var $jHTLJ = parcelRequire("jHTLJ");
var $b2ecd9dbb8aa6b8f$require$connect = $jHTLJ.connect;

var $eShmq = parcelRequire("eShmq");
var $b2ecd9dbb8aa6b8f$require$bindActionCreators = $eShmq.bindActionCreators;


var $85x8Z = parcelRequire("85x8Z");

var $214a43a38235fce6$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $f1q41 = parcelRequire("f1q41");

const $214a43a38235fce6$var$SPACE_UNIT_CATEGORY = (parcelRequire("aB89e")).shared.spaceUnit.CATEGORY;


var $3EC2Q = parcelRequire("3EC2Q");
var $e71593141e720fa2$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

const $e71593141e720fa2$var$SPACE_UNIT_CATEGORY = (parcelRequire("aB89e")).shared.spaceUnit.CATEGORY;

var $e71593141e720fa2$require$constants = (parcelRequire("aB89e")).spacerFree;


var $460e9 = parcelRequire("460e9");

var $ijNBi = parcelRequire("ijNBi");
var $e71593141e720fa2$require$dashOrValue = $ijNBi.dashOrValue;
var $852b85620e075dc9$exports = {};
$852b85620e075dc9$exports = {
    ME: "spaceCatMeDesc",
    WE: "spaceCatWeDesc",
    AMENITY: "spaceCatAmenityDesc"
};



var $e71593141e720fa2$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $e71593141e720fa2$var$SidebarInfo(props) {
    const sectionTitle = {
        [$e71593141e720fa2$var$SPACE_UNIT_CATEGORY.ME]: props.t("sidebarInfoMeTitle"),
        [$e71593141e720fa2$var$SPACE_UNIT_CATEGORY.WE]: props.t("sidebarInfoWeTitle"),
        [$e71593141e720fa2$var$SPACE_UNIT_CATEGORY.AMENITY]: props.t("sidebarInfoAmenityTitle")
    };
    const sidebarContent = {
        [$e71593141e720fa2$var$SPACE_UNIT_CATEGORY.ME]: props.t($852b85620e075dc9$exports.ME),
        [$e71593141e720fa2$var$SPACE_UNIT_CATEGORY.WE]: props.t($852b85620e075dc9$exports.WE),
        [$e71593141e720fa2$var$SPACE_UNIT_CATEGORY.AMENITY]: props.t($852b85620e075dc9$exports.AMENITY)
    };
    const sectionTitleClasses = `title is-4 is-sans-semibold is-half-spaced has-text-${props.spaceUnitCategory} has-margin-top-3 category-title-print`;
    const areaPercentage = props.areaPercentage[props.spaceUnitCategory];
    const categoryArea = $460e9.getNumberForMeasurementSystem(props.categoryAreaForContext, props.measurementSystem);
    const totalAreaForContext = $460e9.getNumberForMeasurementSystem(props.totalAreaForContext, props.measurementSystem);
    const categoryAreaWithCommas = $e71593141e720fa2$require$dashOrValue(!categoryArea, $5f15cdd5de4823b1$exports.numberWithLocaleFormat(categoryArea));
    const totalAreaForContextWithCommas = $e71593141e720fa2$require$dashOrValue(!totalAreaForContext, $5f15cdd5de4823b1$exports.numberWithLocaleFormat(totalAreaForContext));
    const unitCopyBasis = $e71593141e720fa2$require$constants.calculator.SF_TYPE_TEXT[props.sfType];
    const unitCopy = props.t(`common:${$460e9.getTokenKeyForMeasurementSystem(unitCopyBasis, props.measurementSystem)}`);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "space-category-description-container",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: sectionTitleClasses,
                children: [
                    sectionTitle[props.spaceUnitCategory],
                    " \u2014 ",
                    areaPercentage
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "subtitle is-6 is-sans-semibold",
                children: [
                    categoryAreaWithCommas,
                    " / ",
                    totalAreaForContextWithCommas,
                    " ",
                    unitCopy
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "sidebar-description",
                children: sidebarContent[props.spaceUnitCategory]
            })
        ]
    });
}
$e71593141e720fa2$var$SidebarInfo.propTypes = {
    categoryAreaForContext: $c9Z8w.number.isRequired,
    totalAreaForContext: $c9Z8w.number.isRequired,
    spaceUnitCategory: $c9Z8w.string.isRequired,
    measurementSystem: $c9Z8w.string.isRequired,
    sfType: $c9Z8w.number.isRequired,
    t: $c9Z8w.func.isRequired
};
$e71593141e720fa2$exports = $e71593141e720fa2$require$withTranslation("resultsPage")($e71593141e720fa2$var$SidebarInfo);


var $83196e03620132fb$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $83196e03620132fb$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
var $96708f5a2335291b$exports = {};

var $jHTLJ = parcelRequire("jHTLJ");
var $96708f5a2335291b$require$connect = $jHTLJ.connect;

var $eShmq = parcelRequire("eShmq");
var $96708f5a2335291b$require$bindActionCreators = $eShmq.bindActionCreators;

const $96708f5a2335291b$var$SPACE_UNIT_CATEGORY = (parcelRequire("aB89e")).shared.spaceUnit.CATEGORY;



var $fPryk = parcelRequire("fPryk");
var $96708f5a2335291b$require$spaceUnitMap = $fPryk.spaceUnitMap;

var $c9a28348e7fa4232$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $aB89e = parcelRequire("aB89e");
var $c9a28348e7fa4232$require$constants = $aB89e.spacerFree;



var $460e9 = parcelRequire("460e9");
var $4e8f5f084928c93c$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");



var $460e9 = parcelRequire("460e9");

var $ijNBi = parcelRequire("ijNBi");

var $4e8f5f084928c93c$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $4e8f5f084928c93c$var$DeltaLabel(props) {
    if (!props.delta) return null;
    const numericDelta = $460e9.getNumberForMeasurementSystem(props.delta.numericDelta, props.measurementSystem, {
        precisionForMeter: 1,
        precisionForTsubo: 1
    });
    if (!numericDelta) return null;
    const isPositive = props.delta.numericDelta > 0;
    const signSymbol = isPositive ? "+" : "";
    const numericDeltaWithComma = $ijNBi.dashOrValue(!numericDelta, $5f15cdd5de4823b1$exports.numberWithLocaleFormat(numericDelta));
    const measurementLabel = props.t($460e9.getTokenKeyForMeasurementSystem("sqft.", props.measurementSystem));
    let deltaDisplay = `${signSymbol}${numericDeltaWithComma} ${measurementLabel}`;
    if (props.showDeltaPercentage) deltaDisplay += ` (${signSymbol}${props.delta.displayPercentDelta})`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "program-delta-label subtitle is-6",
        children: deltaDisplay
    });
}
$4e8f5f084928c93c$var$DeltaLabel.propTypes = {
    delta: $3e58c681e2cb99b8$exports.deltaShape,
    showDeltaPercentage: $c9Z8w.bool,
    measurementSystem: $c9Z8w.string.isRequired,
    t: $c9Z8w.func.isRequired
};
$4e8f5f084928c93c$var$DeltaLabel.defaultProps = {
    delta: null,
    showDeltaPercentage: true
};
$4e8f5f084928c93c$exports = $4e8f5f084928c93c$require$withTranslation("common")($4e8f5f084928c93c$var$DeltaLabel);




var $1fc1961c97cea97b$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $460e9 = parcelRequire("460e9");




var $1fc1961c97cea97b$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $1fc1961c97cea97b$var$SpaceUnitRowMobile(props) {
    const totalArea = $460e9.getNumberForMeasurementSystem(props.totalArea, props.measurementSystem, {
        precisionForMeter: 1,
        precisionForTsubo: 1
    });
    const totalAreaWithCommas = $5f15cdd5de4823b1$exports.numberWithLocaleFormat(totalArea);
    const measurementLabel = props.t(`common:${$460e9.getTokenKeyForMeasurementSystem("USF", props.measurementSystem)}`);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "columns is-mobile is-multiline has-margin-0-auto space-category-breakdown-row has-padding-botton-5-mobile",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mobile-assumption-separator is-mobile-input has-margin-top-6"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "column is-4-mobile has-no-padding-bottom-mobile space-category-breakdown-row-name",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "name small-title",
                        children: props.name
                    }),
                    props.description && /*#__PURE__*/ (0, $ayMG0.jsx)($8dfee474cfb1f477$exports, {
                        text: props.description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "column is-1-mobile space-category-breakdown-input-container",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "has-padding-right-8 is-sans-regular small-title",
                        children: $460e9.getNumberForMeasurementSystem(props.area, props.measurementSystem, {
                            precisionForMeter: 1,
                            precisionForTsubo: 1
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "is-sans-regular small-title",
                        children: measurementLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "column custom-x-style has-text-light has-text-centered is-sans-regular small-title space-category-x has-no-padding-left-mobile has-no-padding-right-mobile",
                children: "x"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "column is-1-mobile space-category-breakdown-input-container",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "columns is-gapless space-category-units-container",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "column is-sans-regular small-title",
                            children: props.quantity
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "column space-category-unit has-padding-right-8 is-sans-regular small-title",
                            children: props.displayUnit
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `column is-1-mobile has-text-${props.spaceUnitCategory} has-text-centered space-category-quantity is-sans-regular small-title`,
                children: "="
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: `column is-sans-regular small-title has-no-padding-left-mobile has-no-padding-right-mobile has-text-${props.spaceUnitCategory}`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "grand-total",
                        children: [
                            totalAreaWithCommas,
                            " ",
                            measurementLabel
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($4e8f5f084928c93c$exports, {
                        showDeltaPercentage: props.showDeltaPercentage,
                        delta: props.delta,
                        measurementSystem: props.measurementSystem
                    })
                ]
            })
        ]
    });
}
$1fc1961c97cea97b$var$SpaceUnitRowMobile.propTypes = {
    description: $c9Z8w.string,
    name: $c9Z8w.oneOfType([
        $c9Z8w.string,
        $c9Z8w.node
    ]).isRequired,
    area: $c9Z8w.number.isRequired,
    measurementSystem: $c9Z8w.string.isRequired,
    quantity: $c9Z8w.number.isRequired,
    displayUnit: $c9Z8w.string.isRequired,
    totalArea: $c9Z8w.number.isRequired,
    showDeltaPercentage: $c9Z8w.bool,
    delta: $3e58c681e2cb99b8$exports.deltaShape,
    spaceUnitCategory: $c9Z8w.string,
    t: $c9Z8w.func.isRequired
};
$1fc1961c97cea97b$var$SpaceUnitRowMobile.defaultProps = {
    description: "",
    delta: null,
    showDeltaPercentage: true,
    spaceUnitCategory: ""
};
$1fc1961c97cea97b$exports = $1fc1961c97cea97b$require$withTranslation("resultsPage")($1fc1961c97cea97b$var$SpaceUnitRowMobile);



var $56juP = parcelRequire("56juP");

var $c9a28348e7fa4232$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
class $c9a28348e7fa4232$var$SpaceUnitRow extends $acw62.Component {
    constructor(props){
        super(props);
        this.confirmDeletion = this.confirmDeletion.bind(this);
        this.onAreaUpdate = this.onAreaUpdate.bind(this);
        this.onQuantityUpdate = this.onQuantityUpdate.bind(this);
    }
    onAreaUpdate(value) {
        const valueInSqFt = $460e9.getSqFeetForMeasurementSystem(value, this.props.measurementSystem);
        this.props.onAreaUpdate(this.props.spaceUnitId, valueInSqFt);
    }
    onQuantityUpdate(value) {
        this.props.onQuantityUpdate(this.props.spaceUnitId, value, this.props.officeLocation);
    }
    confirmDeletion() {
        if (!this.props.openModal) return this.props.deleteFunction(this.props.spaceUnitId);
        return this.props.openModal($c9a28348e7fa4232$require$constants.modal.TYPES.CONFIRMATION, {
            title: this.props.t("spaceUnitRowDeleteTitle"),
            text: this.props.t("spaceUnitRowDeleteText"),
            confirm: {
                text: this.props.t("spaceUnitRowConfirmDeleteText"),
                onClick: ()=>{
                    this.props.deleteFunction(this.props.spaceUnitId);
                    this.props.closeModal();
                }
            },
            cancel: {
                text: this.props.t("spaceUnitRowCancelDeleteText"),
                onClick: ()=>{
                    this.props.closeModal();
                }
            }
        });
    }
    render() {
        const areaNumberInput = /*#__PURE__*/ (0, $ayMG0.jsx)($90d7625f2e6d2261$exports, {
            min: 1,
            value: $460e9.getNumberForMeasurementSystem(this.props.area, this.props.measurementSystem, {
                precisionForMeter: 1,
                precisionForTsubo: 1
            }),
            onChange: this.onAreaUpdate,
            disabled: !this.props.areaIsEditable,
            hideNumberArrows: !this.props.areaIsEditable
        });
        const quantityNumberInput = /*#__PURE__*/ (0, $ayMG0.jsx)($90d7625f2e6d2261$exports, {
            min: 1,
            value: this.props.quantity,
            onChange: this.onQuantityUpdate,
            disabled: !this.props.quantityIsEditable,
            hideNumberArrows: !this.props.quantityIsEditable
        });
        const totalArea = $460e9.getNumberForMeasurementSystem(this.props.totalArea, this.props.measurementSystem, {
            precisionForMeter: 1,
            precisionForTsubo: 1
        });
        const totalAreaWithCommas = $5f15cdd5de4823b1$exports.numberWithLocaleFormat(totalArea);
        const measurementLabel = this.props.t(`common:${$460e9.getTokenKeyForMeasurementSystem("SF", this.props.measurementSystem)}`);
        let confirmButtonClasses = "add-icon is-selectable no-outline";
        if (!this.props.confirmFunction) confirmButtonClasses += " is-invisible";
        else if (!this.props.confirmIsActive) confirmButtonClasses += " is-inactive";
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: $56juP.isScreenMobileSize() ? /*#__PURE__*/ (0, $ayMG0.jsx)($1fc1961c97cea97b$exports, {
                description: this.props.description,
                name: this.props.name,
                area: this.props.area,
                measurementSystem: this.props.measurementSystem,
                quantity: this.props.quantity,
                displayUnit: this.props.displayUnit,
                totalArea: this.props.totalArea,
                showDeltaPercentage: this.props.showDeltaPercentage,
                delta: this.props.delta,
                spaceUnitCategory: this.props.spaceUnitCategory
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: this.props.isAmenityUnitAdder ? "amenity-unit-adder is-hidden-mobile" : "space-unit-row",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "columns is-mobile is-multiline has-margin-0-auto space-category-breakdown-row",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "column is-3-desktop is-3-tablet is-full-mobile has-no-padding-bottom-mobile space-category-breakdown-row-name",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "name",
                                        children: this.props.name
                                    }),
                                    this.props.description && /*#__PURE__*/ (0, $ayMG0.jsx)($8dfee474cfb1f477$exports, {
                                        text: this.props.description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "column is-2-desktop is-5-mobile space-category-breakdown-input-container",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "space-category-area",
                                        children: areaNumberInput
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "space-category-area-label",
                                        children: measurementLabel
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "column is-1-desktop is-2-mobile has-text-light has-text-centered",
                                children: "X"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "column is-2-desktop is-5-mobile space-category-breakdown-input-container",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "columns is-gapless space-category-units-container",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "column is-7 space-category-quantity",
                                            children: quantityNumberInput
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "column is-7 space-category-unit",
                                            children: this.props.displayUnit
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "column is-1-desktop is-3-mobile has-text-light has-text-centered",
                                children: "="
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "column is-2-desktop is-9-mobile",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "grand-total",
                                        children: [
                                            totalAreaWithCommas,
                                            " ",
                                            measurementLabel
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)($4e8f5f084928c93c$exports, {
                                        showDeltaPercentage: this.props.showDeltaPercentage,
                                        delta: this.props.delta,
                                        measurementSystem: this.props.measurementSystem
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "flex is-hidden-mobile",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div" // still include invisible ones for alignment
                                    , {
                                        role: "button",
                                        tabIndex: "0",
                                        className: confirmButtonClasses,
                                        onClick: this.props.confirmFunction
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        className: "delete-unit-row is-medium",
                                        "aria-label": `Delete ${this.props.name}`,
                                        onClick: this.confirmDeletion
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {})
                ]
            })
        });
    }
}
$c9a28348e7fa4232$var$SpaceUnitRow.propTypes = {
    spaceUnitId: $c9Z8w.string,
    name: $c9Z8w.oneOfType([
        $c9Z8w.string,
        $c9Z8w.node
    ]).isRequired,
    area: $c9Z8w.number.isRequired,
    quantity: $c9Z8w.number.isRequired,
    totalArea: $c9Z8w.number.isRequired,
    displayUnit: $c9Z8w.string.isRequired,
    description: $c9Z8w.string,
    isAmenityUnitAdder: $c9Z8w.bool,
    areaIsEditable: $c9Z8w.bool,
    quantityIsEditable: $c9Z8w.bool,
    onAreaUpdate: $c9Z8w.func.isRequired,
    onQuantityUpdate: $c9Z8w.func.isRequired,
    measurementSystem: $c9Z8w.string.isRequired,
    delta: $3e58c681e2cb99b8$exports.deltaShape,
    showDeltaPercentage: $c9Z8w.bool,
    confirmFunction: $c9Z8w.func,
    confirmIsActive: $c9Z8w.bool,
    deleteFunction: $c9Z8w.func,
    openModal: $c9Z8w.func,
    closeModal: $c9Z8w.func,
    spaceUnitCategory: $c9Z8w.string,
    t: $c9Z8w.func.isRequired
};
$c9a28348e7fa4232$var$SpaceUnitRow.defaultProps = {
    spaceUnitId: "",
    description: "",
    isAmenityUnitAdder: false,
    areaIsEditable: false,
    quantityIsEditable: false,
    showDeltaLabel: false,
    delta: null,
    showDeltaPercentage: true,
    confirmFunction: null,
    confirmIsActive: false,
    deleteFunction: null,
    openModal: null,
    closeModal: null,
    spaceUnitCategory: ""
};
$c9a28348e7fa4232$exports = $c9a28348e7fa4232$require$withTranslation("resultsPage")($c9a28348e7fa4232$var$SpaceUnitRow);


// Map state to props
function $96708f5a2335291b$var$mapStateToProps(state, ownProps) {
    const spaceUnit = $96708f5a2335291b$require$spaceUnitMap[ownProps.unit.spaceUnitId];
    const isAmenitySpace = spaceUnit.category === $96708f5a2335291b$var$SPACE_UNIT_CATEGORY.AMENITY;
    const area = isAmenitySpace ? $2a4962b1e81f9837$exports.getNSF(ownProps.unit) : spaceUnit.sf;
    const quantity = $2a4962b1e81f9837$exports.getQuantity(ownProps.unit);
    return {
        sfType: state.spaceData.sfType,
        measurementSystem: state.spaceData.measurementSystem,
        spaceUnitId: ownProps.unit.spaceUnitId,
        name: ownProps.t(spaceUnit.displayNameToken),
        area: area,
        quantity: quantity,
        totalArea: $2a4962b1e81f9837$exports.getNSF(ownProps.unit),
        // Pass the quantity as "count", and i18next can pluralize! See i18n.js for more explanation.
        displayUnit: ownProps.t(spaceUnit.displayUnit, {
            count: quantity
        }),
        description: ownProps.t(spaceUnit.descriptionToken),
        areaIsEditable: isAmenitySpace,
        quantityIsEditable: !isAmenitySpace,
        delta: $2a4962b1e81f9837$exports.getNSFDelta(ownProps.unit),
        officeLocation: state.userData.officeLocation
    };
}
// Map dispatch to props
function $96708f5a2335291b$var$mapDispatchToProps(dispatch) {
    return {
        onQuantityUpdate: $96708f5a2335291b$require$bindActionCreators($7f3ddf5ab2cb44f3$exports.updateSpaceUnitQuantity, dispatch),
        onAreaUpdate: $96708f5a2335291b$require$bindActionCreators($7f3ddf5ab2cb44f3$exports.updateSpaceUnitAmenitySF, dispatch),
        deleteFunction: $96708f5a2335291b$require$bindActionCreators($7f3ddf5ab2cb44f3$exports.deleteSpaceUnit, dispatch),
        openModal: $96708f5a2335291b$require$bindActionCreators($15a18ec2484069fc$exports.openModal, dispatch),
        closeModal: $96708f5a2335291b$require$bindActionCreators($15a18ec2484069fc$exports.closeModal, dispatch)
    };
}
$96708f5a2335291b$exports = $96708f5a2335291b$require$connect($96708f5a2335291b$var$mapStateToProps, $96708f5a2335291b$var$mapDispatchToProps)($c9a28348e7fa4232$exports);


var $080f7f40205dfe94$exports = {};

var $jHTLJ = parcelRequire("jHTLJ");
var $080f7f40205dfe94$require$connect = $jHTLJ.connect;

var $eShmq = parcelRequire("eShmq");
var $080f7f40205dfe94$require$bindActionCreators = $eShmq.bindActionCreators;

var $f1q41 = parcelRequire("f1q41");



var $fPryk = parcelRequire("fPryk");
var $080f7f40205dfe94$require$suggestedCustomAmenityUnitMap = $fPryk.suggestedCustomAmenityUnitMap;

const $080f7f40205dfe94$var$DEFAULT_CUSTOM_AMENITY_DISPLAY_UNIT = (parcelRequire("aB89e")).shared.spaceUnit.UNIT_LABEL.DEFAULT_CUSTOM_AMENITY_DISPLAY_UNIT;

// Map state to props
function $080f7f40205dfe94$var$mapStateToProps(state, ownProps) {
    const suggestedAmenity = $f1q41.find($080f7f40205dfe94$require$suggestedCustomAmenityUnitMap, [
        "dataKey",
        ownProps.unit.dataKey
    ]);
    const quantity = $2a4962b1e81f9837$exports.getQuantity(ownProps.unit);
    return {
        sfType: state.spaceData.sfType,
        measurementSystem: state.spaceData.measurementSystem,
        spaceUnitId: ownProps.unit.id,
        name: ownProps.unit.displayName,
        area: ownProps.unit.customSF,
        quantity: quantity,
        totalArea: $2a4962b1e81f9837$exports.getNSF(ownProps.unit),
        // Pass the quantity as "count", and i18next can pluralize! See i18n.js for more explanation.
        displayUnit: ownProps.t(suggestedAmenity && suggestedAmenity.displayUnit || $080f7f40205dfe94$var$DEFAULT_CUSTOM_AMENITY_DISPLAY_UNIT, {
            count: quantity
        }),
        areaIsEditable: true,
        quantityIsEditable: true,
        delta: $2a4962b1e81f9837$exports.getNSFDelta(ownProps.unit),
        showDeltaPercentage: false
    };
}
// Map dispatch to props
function $080f7f40205dfe94$var$mapDispatchToProps(dispatch) {
    return {
        onQuantityUpdate: $080f7f40205dfe94$require$bindActionCreators($7f3ddf5ab2cb44f3$exports.updateCustomAmenityQuantity, dispatch),
        onAreaUpdate: $080f7f40205dfe94$require$bindActionCreators($7f3ddf5ab2cb44f3$exports.updateCustomAmenitySF, dispatch),
        deleteFunction: $080f7f40205dfe94$require$bindActionCreators($7f3ddf5ab2cb44f3$exports.deleteSpaceUnit, dispatch)
    };
}
$080f7f40205dfe94$exports = $080f7f40205dfe94$require$connect($080f7f40205dfe94$var$mapStateToProps, $080f7f40205dfe94$var$mapDispatchToProps)($c9a28348e7fa4232$exports);


function $83196e03620132fb$var$SpaceUnits(props) {
    const unitRows = [];
    props.units.forEach((programUnit)=>{
        if (programUnit.isCustomAmenity) unitRows.push(/*#__PURE__*/ (0, $ayMG0.jsx)($080f7f40205dfe94$exports, {
            unit: programUnit,
            t: props.t
        }, programUnit.id));
        else if (programUnit.quantity > 0) unitRows.push(/*#__PURE__*/ (0, $ayMG0.jsx)($96708f5a2335291b$exports, {
            unit: programUnit,
            spaceUnitCategory: props.spaceUnitCategory,
            t: props.t
        }, programUnit.spaceUnitId));
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "is-sans-medium",
        children: unitRows
    });
}
$83196e03620132fb$var$SpaceUnits.propTypes = {
    units: $c9Z8w.arrayOf($c9Z8w.oneOfType([
        $3e58c681e2cb99b8$exports.spaceUnitShape,
        $3e58c681e2cb99b8$exports.customAmenityUnitShape
    ])).isRequired,
    spaceUnitCategory: $c9Z8w.string,
    t: $c9Z8w.func.isRequired
};
$83196e03620132fb$var$SpaceUnits.defaultProps = {
    spaceUnitCategory: ""
};
$83196e03620132fb$exports = $83196e03620132fb$require$withTranslation("resultsPage")($83196e03620132fb$var$SpaceUnits);


var $09d8e7421d6bd060$exports = {};

var $jHTLJ = parcelRequire("jHTLJ");
var $09d8e7421d6bd060$require$connect = $jHTLJ.connect;

var $eShmq = parcelRequire("eShmq");
var $09d8e7421d6bd060$require$bindActionCreators = $eShmq.bindActionCreators;


var $395b3865c2bacff2$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $f1q41 = parcelRequire("f1q41");

var $aB89e = parcelRequire("aB89e");
var $395b3865c2bacff2$require$constants = $aB89e.shared;

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $460e9 = parcelRequire("460e9");



var $fPryk = parcelRequire("fPryk");
var $395b3865c2bacff2$require$suggestedCustomAmenityUnitMap = $fPryk.suggestedCustomAmenityUnitMap;

var $395b3865c2bacff2$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
const $395b3865c2bacff2$var$DEFAULT_CUSTOM_AMENITY_DISPLAY_UNIT = $395b3865c2bacff2$require$constants.spaceUnit.UNIT_LABEL.DEFAULT_CUSTOM_AMENITY_DISPLAY_UNIT;
const $395b3865c2bacff2$var$INITIAL_AREA = 1;
class $395b3865c2bacff2$var$CustomAmenityAdder extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            currentlyAdding: false,
            displayName: "",
            dataKey: "",
            customSF: $460e9.getSqFeetForMeasurementSystem($395b3865c2bacff2$var$INITIAL_AREA, props.measurementSystem),
            customQuantity: 1,
            displayUnit: $395b3865c2bacff2$var$DEFAULT_CUSTOM_AMENITY_DISPLAY_UNIT
        };
        this.onNameUpdate = this.onNameUpdate.bind(this);
        this.onAreaUpdate = this.onAreaUpdate.bind(this);
        this.onQuantityUpdate = this.onQuantityUpdate.bind(this);
        this.toggleAmenityAdder = this.toggleAmenityAdder.bind(this);
        this.addCustomAmenity = this.addCustomAmenity.bind(this);
    }
    onNameUpdate(value) {
        const amenityUnit = $f1q41.find($395b3865c2bacff2$require$suggestedCustomAmenityUnitMap, (amenity)=>value === this.props.t(amenity.displayName));
        let programPart;
        if (amenityUnit) programPart = this.props.calculateCustomAmenityProgramPart(amenityUnit.dataKey);
        if (programPart) this.setState({
            dataKey: programPart.dataKey,
            displayName: value,
            customQuantity: programPart.customQuantity,
            customSF: programPart.customNSF,
            displayUnit: programPart.displayUnit
        });
        else this.setState({
            displayName: value,
            displayUnit: $395b3865c2bacff2$var$DEFAULT_CUSTOM_AMENITY_DISPLAY_UNIT
        });
    }
    // id not needed, it's just passed up from SpaceUnitRow
    onQuantityUpdate(id, value) {
        if (!value || value < 1) value = 1;
        this.setState({
            customQuantity: value
        });
    }
    onAreaUpdate(id, value) {
        if (!value || value < 1) value = 1;
        this.setState({
            customSF: value
        });
    }
    toggleAmenityAdder(isOpen) {
        this.setState({
            currentlyAdding: isOpen,
            // clear all preset values
            displayName: "",
            customSF: $460e9.getSqFeetForMeasurementSystem($395b3865c2bacff2$var$INITIAL_AREA, this.props.measurementSystem),
            customQuantity: 1,
            displayUnit: $395b3865c2bacff2$var$DEFAULT_CUSTOM_AMENITY_DISPLAY_UNIT
        });
    }
    // while the displayName can be edited, the amenity is not added to the program, adding it locks in the displayName
    addCustomAmenity() {
        if (this.state.displayName !== "") {
            this.props.addCustomAmenity(this.state.displayName, this.state.customQuantity, this.state.customSF, this.state.dataKey);
            this.toggleAmenityAdder(false);
        }
    }
    render() {
        // when not currently adding, show field to toggle visibility of adder row
        if (!this.state.currentlyAdding) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "amenity-unit-adder-opener has-margin-5 has-text-amenity is-hoverable is-sans-medium is-selectable is-hidden-mobile no-outline",
            role: "button",
            tabIndex: 0,
            onClick: ()=>this.toggleAmenityAdder(true),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "open-amenity-adder"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: this.props.t("customAmenityAddText")
                })
            ]
        });
        // list of names for suggested custom amenities
        const CUSTOM_AMENITY_LIST = $f1q41.map($395b3865c2bacff2$require$suggestedCustomAmenityUnitMap, (unit)=>this.props.t(unit.displayName));
        const nameField = /*#__PURE__*/ (0, $ayMG0.jsx)($a9ee39a026dc756f$exports, {
            allowValueNotInDropdown: true,
            dropdownOptions: CUSTOM_AMENITY_LIST,
            value: this.state.displayName,
            onValueChange: this.onNameUpdate,
            placeholder: this.props.t("customAmenityPlaceholder")
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)($c9a28348e7fa4232$exports, {
            isAmenityUnitAdder: true,
            name: nameField,
            area: this.state.customSF,
            quantity: this.state.customQuantity,
            totalArea: this.state.customSF * this.state.customQuantity,
            displayUnit: this.props.t(this.state.displayUnit, {
                count: this.state.customQuantity
            }),
            areaIsEditable: true,
            quantityIsEditable: true,
            onAreaUpdate: this.onAreaUpdate,
            onQuantityUpdate: this.onQuantityUpdate,
            sfType: this.props.sfType,
            measurementSystem: this.props.measurementSystem,
            confirmFunction: this.addCustomAmenity,
            confirmIsActive: this.state.displayName !== "",
            deleteFunction: ()=>this.toggleAmenityAdder(false)
        });
    }
}
$395b3865c2bacff2$var$CustomAmenityAdder.propTypes = {
    sfType: $c9Z8w.number.isRequired,
    measurementSystem: $c9Z8w.string.isRequired,
    addCustomAmenity: $c9Z8w.func.isRequired,
    calculateCustomAmenityProgramPart: $c9Z8w.func.isRequired,
    t: $c9Z8w.func.isRequired
};
$395b3865c2bacff2$exports = $395b3865c2bacff2$require$withTranslation("resultsPage")($395b3865c2bacff2$var$CustomAmenityAdder);


// Map state to props
function $09d8e7421d6bd060$var$mapStateToProps(state) {
    return {
        sfType: state.spaceData.sfType,
        measurementSystem: state.spaceData.measurementSystem,
        calculateCustomAmenityProgramPart: $dd1d3e43b4086c4d$exports.calculateCustomAmenityProgramPart
    };
}
// Map dispatch to props
function $09d8e7421d6bd060$var$mapDispatchToProps(dispatch) {
    return {
        addCustomAmenity: $09d8e7421d6bd060$require$bindActionCreators($7f3ddf5ab2cb44f3$exports.addCustomAmenity, dispatch)
    };
}
$09d8e7421d6bd060$exports = $09d8e7421d6bd060$require$connect($09d8e7421d6bd060$var$mapStateToProps, $09d8e7421d6bd060$var$mapDispatchToProps)($395b3865c2bacff2$exports);


var $77e576e30c1a674b$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $f1q41 = parcelRequire("f1q41");


var $aB89e = parcelRequire("aB89e");
var $77e576e30c1a674b$require$constants = $aB89e.spacerFree;


var $460e9 = parcelRequire("460e9");

var $ijNBi = parcelRequire("ijNBi");
var $77e576e30c1a674b$require$dashOrValue = $ijNBi.dashOrValue;


var $85x8Z = parcelRequire("85x8Z");



var $77e576e30c1a674b$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $77e576e30c1a674b$var$SpaceUnitTotals(props) {
    const circulationTotal = $460e9.getNumberForMeasurementSystem(props.circulationTotal, props.measurementSystem, {
        precisionForMeter: 1,
        precisionForTsubo: 1
    });
    const circulationTotalWithCommas = $77e576e30c1a674b$require$dashOrValue(!circulationTotal, $5f15cdd5de4823b1$exports.numberWithLocaleFormat(circulationTotal));
    const totalAreaForContext = $460e9.getNumberForMeasurementSystem(props.totalAreaForContext, props.measurementSystem, {
        precisionForMeter: 1,
        precisionForTsubo: 1
    });
    const totalAreaWithCommas = $77e576e30c1a674b$require$dashOrValue(!totalAreaForContext, $5f15cdd5de4823b1$exports.numberWithLocaleFormat(totalAreaForContext));
    const unit = props.t(`common:${$460e9.getTokenKeyForMeasurementSystem("feet", props.measurementSystem)}`);
    const unitCapitalized = $f1q41.capitalize(unit);
    const sfType = props.t(`common:${$460e9.getTokenKeyForMeasurementSystem("USF", props.measurementSystem)}`);
    const sfTypeAdj = props.sfType === $77e576e30c1a674b$require$constants.calculator.SF_TYPE.USF ? props.t("common:Usable") : props.t("common:Rentable");
    let totalTitleText;
    if (props.sfType === $77e576e30c1a674b$require$constants.calculator.SF_TYPE.NIA) totalTitleText = props.t("spaceUnitTotalsTitleNIA");
    else totalTitleText = props.t("spaceUnitTotalsTitle", {
        sfTypeAdj: sfTypeAdj,
        unitCapitalized: unitCapitalized
    });
    const unitCopyBasis = $77e576e30c1a674b$require$constants.calculator.SF_TYPE_TEXT[props.sfType];
    const measurementLabelForTotal = props.t(`common:${$460e9.getTokenKeyForMeasurementSystem(unitCopyBasis, props.measurementSystem)}`);
    const isNYC = $85x8Z.getRegion(props.location) === $77e576e30c1a674b$require$constants.calculator.RSF_REGIONS.NYC;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "columns is-mobile is-multiline has-margin-0-auto space-unit-breakdown-totals is-sans-medium",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "column is-3-desktop is-3-tablet is-half-mobile has-text-light space-category-breakdown-row-name",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "name",
                        children: props.t("spaceUnitTotalsCirculation")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($8dfee474cfb1f477$exports, {
                        text: props.t("spaceUnitTotalsCirculationTooltip", {
                            unitCapitalized: unitCapitalized
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "column is-3-desktop is-3-tablet is-offset-6-desktop is-half-mobile has-text-light total-metric-number",
                children: [
                    circulationTotalWithCommas,
                    " ",
                    sfType
                ]
            }),
            isNYC && /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "column is-3-desktop is-3-tablet is-half-mobile has-text-light space-category-breakdown-row-name",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "name",
                                children: props.t("spaceUnitTotalsREBNY")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($8dfee474cfb1f477$exports, {
                                text: props.t("spaceUnitTotalsREBNYTooltip", {
                                    sfType: sfType
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "column is-3-desktop is-3-tablet is-offset-6-desktop is-half-mobile has-text-light total-metric-number",
                        children: [
                            Math.round(($85x8Z.nycUSFFactor - 1) * 100),
                            "%"
                        ]
                    })
                ]
            }),
            props.sfType === $77e576e30c1a674b$require$constants.calculator.SF_TYPE.RSF && /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "column is-3-desktop is-3-tablet is-half-mobile has-text-light space-category-breakdown-row-name",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "name",
                                children: [
                                    isNYC && props.t("spaceUnitTotalsNYCText"),
                                    props.t("spaceUnitTotalsLossFactor")
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($8dfee474cfb1f477$exports, {
                                text: props.t("spaceUnitTotalsLossFactorTooltip", {
                                    unit: unit
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "column is-3-desktop is-3-tablet is-offset-6-desktop is-half-mobile has-text-light flex flex-row loss-factor-container total-metric-number",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($90d7625f2e6d2261$exports, {
                            min: 0,
                            max: $77e576e30c1a674b$require$constants.calculator.MAX_LOSS_FACTOR,
                            value: Math.round(props.lossFactor * 100),
                            onChange: (value)=>props.updateLossFactor(value / 100),
                            hasShortUnderline: true,
                            hasSpaceTypeColor: true,
                            isLossFactor: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "column is-9-desktop is-3-tablet is-half-mobile",
                children: totalTitleText
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "column is-3-desktop is-3-tablet is-half-mobile total-metric-number",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "grand-total",
                        children: [
                            totalAreaWithCommas,
                            " ",
                            measurementLabelForTotal
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($4e8f5f084928c93c$exports, {
                        delta: props.totalAreaDelta,
                        measurementSystem: props.measurementSystem
                    })
                ]
            })
        ]
    });
}
$77e576e30c1a674b$var$SpaceUnitTotals.propTypes = {
    totalAreaForContext: $c9Z8w.number.isRequired,
    totalAreaDelta: $3e58c681e2cb99b8$exports.deltaShape,
    circulationTotal: $c9Z8w.number.isRequired,
    location: $c9Z8w.string.isRequired,
    measurementSystem: $c9Z8w.string.isRequired,
    sfType: $c9Z8w.number.isRequired,
    lossFactor: $c9Z8w.number.isRequired,
    updateLossFactor: $c9Z8w.func.isRequired,
    t: $c9Z8w.func.isRequired
};
$77e576e30c1a674b$var$SpaceUnitTotals.defaultProps = {
    totalAreaDelta: null
};
$77e576e30c1a674b$exports = $77e576e30c1a674b$require$withTranslation("resultsPage")($77e576e30c1a674b$var$SpaceUnitTotals);



var $3c4b389dae14f430$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


const $3c4b389dae14f430$var$SPACE_UNIT_CATEGORY = (parcelRequire("aB89e")).shared.spaceUnit.CATEGORY;

var $3c4b389dae14f430$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
const $3c4b389dae14f430$var$optionOrder = [
    $3c4b389dae14f430$var$SPACE_UNIT_CATEGORY.ME,
    $3c4b389dae14f430$var$SPACE_UNIT_CATEGORY.WE,
    $3c4b389dae14f430$var$SPACE_UNIT_CATEGORY.AMENITY
];
function $3c4b389dae14f430$var$SpaceCategoryDropdown(props) {
    const dropdownOptions = {
        [$3c4b389dae14f430$var$SPACE_UNIT_CATEGORY.ME]: {
            text: props.t("spaceCatDropdownMeText")
        },
        [$3c4b389dae14f430$var$SPACE_UNIT_CATEGORY.WE]: {
            text: props.t("spaceCatDropdownWeText")
        },
        [$3c4b389dae14f430$var$SPACE_UNIT_CATEGORY.AMENITY]: {
            text: props.t("spaceCatDropdownAmenityText")
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c0bae42d849a79e8$exports, {
        options: dropdownOptions,
        optionOrder: $3c4b389dae14f430$var$optionOrder,
        ...props
    });
}
$3c4b389dae14f430$var$SpaceCategoryDropdown.propTypes = {
    value: $c9Z8w.string.isRequired,
    onValueChange: $c9Z8w.func.isRequired,
    t: $c9Z8w.func.isRequired
};
$3c4b389dae14f430$exports = $3c4b389dae14f430$require$withTranslation("resultsPage")($3c4b389dae14f430$var$SpaceCategoryDropdown);


var $33d334ec060caa37$exports = {};

var $jHTLJ = parcelRequire("jHTLJ");
var $33d334ec060caa37$require$connect = $jHTLJ.connect;

const $33d334ec060caa37$var$SPACE_UNIT_CATEGORY = (parcelRequire("aB89e")).shared.spaceUnit.CATEGORY;


var $85x8Z = parcelRequire("85x8Z");
var $035aa9054d4c9e60$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

const $035aa9054d4c9e60$var$SPACE_UNIT_CATEGORY = (parcelRequire("aB89e")).shared.spaceUnit.CATEGORY;
var $fdf7776428675e41$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $fdf7776428675e41$require$constants = (parcelRequire("aB89e")).spacerFree;

const $fdf7776428675e41$var$SPACE_UNIT_CATEGORY = (parcelRequire("aB89e")).shared.spaceUnit.CATEGORY;



var $460e9 = parcelRequire("460e9");

var $ijNBi = parcelRequire("ijNBi");
var $fdf7776428675e41$require$dashOrValue = $ijNBi.dashOrValue;


var $f1q41 = parcelRequire("f1q41");




var $fdf7776428675e41$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
class $fdf7776428675e41$var$SpaceCategoryBreakdownMobile extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            spaceCategorySectionOpen: false
        };
        this.toggleSpaceCategorySection = this.toggleSpaceCategorySection.bind(this);
    }
    toggleSpaceCategorySection() {
        this.setState((prevState)=>({
                spaceCategorySectionOpen: !prevState.spaceCategorySectionOpen
            }));
    }
    render() {
        const sectionTitle = {
            [$fdf7776428675e41$var$SPACE_UNIT_CATEGORY.ME]: this.props.t("spaceCatBreakdownMobileMeTitle"),
            [$fdf7776428675e41$var$SPACE_UNIT_CATEGORY.WE]: this.props.t("spaceCatBreakdownMobileWeTitle"),
            [$fdf7776428675e41$var$SPACE_UNIT_CATEGORY.AMENITY]: this.props.t("spaceCatBreakdownMobileAmenityTitle")
        };
        const sectionSubtitle = {
            [$fdf7776428675e41$var$SPACE_UNIT_CATEGORY.ME]: this.props.t("spaceCatBreakdownMobileMeSubtitle"),
            [$fdf7776428675e41$var$SPACE_UNIT_CATEGORY.WE]: this.props.t("spaceCatBreakdownMobileWeSubtitle"),
            [$fdf7776428675e41$var$SPACE_UNIT_CATEGORY.AMENITY]: this.props.t("spaceCatBreakdownMobileAmenitySubtitle")
        };
        const sectionContent = {
            [$fdf7776428675e41$var$SPACE_UNIT_CATEGORY.ME]: this.props.t($852b85620e075dc9$exports.ME),
            [$fdf7776428675e41$var$SPACE_UNIT_CATEGORY.WE]: this.props.t($852b85620e075dc9$exports.WE),
            [$fdf7776428675e41$var$SPACE_UNIT_CATEGORY.AMENITY]: this.props.t($852b85620e075dc9$exports.AMENITY)
        };
        const sectionTitleClasses = `is-sans-semibold is-half-spaced has-text-${this.props.spaceUnitCategory} has-padding-7-mobile has-no-padding-bottom-mobile`;
        const areaPercentage = $fdf7776428675e41$require$dashOrValue(!(this.props.categoryAreaForContext && this.props.totalAreaForContext), $5f15cdd5de4823b1$exports.decimalToPercentage(this.props.categoryAreaForContext / this.props.totalAreaForContext));
        const formattedCategoryArea = $fdf7776428675e41$require$dashOrValue(!this.props.categoryAreaForContext, $460e9.getNumberForMeasurementSystem(this.props.categoryAreaForContext, this.props.measurementSystem));
        const categoryNSF = $f1q41.reduce(this.props.programForCategory, (runningTotal, unit)=>runningTotal + $2a4962b1e81f9837$exports.getNSF(unit), 0);
        const circulationTotal = this.props.categoryArea - categoryNSF;
        const circulationTotalWithCommas = $fdf7776428675e41$require$dashOrValue(!circulationTotal, $5f15cdd5de4823b1$exports.numberWithLocaleFormat(circulationTotal));
        let totalTitleText;
        const unitCapitalized = $f1q41.capitalize(this.props.t(`common:${$460e9.getTokenKeyForMeasurementSystem("feet", this.props.measurementSystem)}`));
        if (this.props.sfType === $fdf7776428675e41$require$constants.calculator.SF_TYPE.NIA) totalTitleText = this.props.t("spaceCatBreakdownMobileNIATotalTitle");
        else totalTitleText = this.props.t("spaceCatBreakdownMobileTotalTitle", {
            sfType: this.props.sfType === $fdf7776428675e41$require$constants.calculator.SF_TYPE.USF ? this.props.t("common:Usable") : this.props.t("common:Rentable"),
            unitCapitalized: unitCapitalized
        });
        const categoryTotalAreaForContext = $460e9.getNumberForMeasurementSystem(this.props.categoryAreaForContext, this.props.measurementSystem, {
            precisionForMeter: 1,
            precisionForTsubo: 1
        });
        const totalAreaWithCommas = $fdf7776428675e41$require$dashOrValue(!categoryTotalAreaForContext, $5f15cdd5de4823b1$exports.numberWithLocaleFormat(categoryTotalAreaForContext));
        const unitCopyBasis = $fdf7776428675e41$require$constants.calculator.SF_TYPE_TEXT[this.props.sfType];
        const measurementLabelForTotal = this.props.t(`common:${$460e9.getTokenKeyForMeasurementSystem(unitCopyBasis, this.props.measurementSystem)}`);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "space-category-mobile-summary has-margin-top-6 is-hidden-print",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "flex flex-row",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pull-start",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: sectionTitleClasses,
                                    children: [
                                        areaPercentage,
                                        " ",
                                        sectionTitle[this.props.spaceUnitCategory]
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "is-sans-regular has-padding-7-mobile has-no-padding-top-mobile",
                                    children: [
                                        sectionSubtitle[this.props.spaceUnitCategory],
                                        " - ",
                                        $5f15cdd5de4823b1$exports.numberWithLocaleFormat(formattedCategoryArea),
                                        " ",
                                        this.props.t(`common:${$460e9.getTokenKeyForMeasurementSystem("sqft.", this.props.measurementSystem)}`)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                            className: `space-category-button space-category-button-${this.props.spaceUnitCategory}`,
                            onClick: this.toggleSpaceCategorySection
                        })
                    ]
                }),
                this.state.spaceCategorySectionOpen && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "is-sans-regular has-padding-7-mobile space-category-section-content",
                            children: sectionContent[this.props.spaceUnitCategory]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($83196e03620132fb$exports, {
                            units: this.props.programForCategory,
                            spaceUnitCategory: this.props.spaceUnitCategory
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "columns is-mobile is-multiline has-margin-0-auto space-category-breakdown-row",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "mobile-assumption-separator is-mobile-input has-margin-top-6"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "column is-8 has-no-padding-bottom space-category-breakdown-row-name",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "name small-title",
                                        children: this.props.t("spaceCatBreakdownMobileCirculationText")
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `column is-1 has-text-${this.props.spaceUnitCategory} has-text-centered space-category-quantity is-sans-regular small-title total-unit`,
                                    children: "="
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: `column is-sans-regular small-title has-no-padding-left has-no-padding-right has-text-${this.props.spaceUnitCategory}`,
                                    children: [
                                        circulationTotalWithCommas,
                                        " ",
                                        this.props.t(`common:${$460e9.getTokenKeyForMeasurementSystem("SF", this.props.measurementSystem)}`)
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "columns is-mobile is-multiline has-margin-0-auto space-category-breakdown-row",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "mobile-assumption-separator is-mobile-input has-margin-top-6"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "column is-8 has-no-padding-bottom space-category-breakdown-row-name",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "name small-title",
                                        children: totalTitleText
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `column is-1 has-text-${this.props.spaceUnitCategory} has-text-centered space-category-quantity is-sans-regular small-title total-unit`,
                                    children: "="
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: `is-sans-regular small-title has-no-padding-left has-no-padding-right has-text-${this.props.spaceUnitCategory}`,
                                            children: [
                                                totalAreaWithCommas,
                                                " ",
                                                measurementLabelForTotal
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($4e8f5f084928c93c$exports, {
                                            delta: this.props.totalAreaDelta,
                                            measurementSystem: this.props.measurementSystem
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "mobile-assumption-separator is-invisible is-mobile-input has-margin-top-6"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
}
$fdf7776428675e41$var$SpaceCategoryBreakdownMobile.propTypes = {
    spaceUnitCategory: $c9Z8w.string.isRequired,
    categoryArea: $c9Z8w.number.isRequired,
    categoryAreaForContext: $c9Z8w.number.isRequired,
    totalAreaForContext: $c9Z8w.number.isRequired,
    measurementSystem: $c9Z8w.string.isRequired,
    programForCategory: $c9Z8w.arrayOf($c9Z8w.object).isRequired,
    sfType: $c9Z8w.number.isRequired,
    totalAreaDelta: $3e58c681e2cb99b8$exports.deltaShape,
    t: $c9Z8w.func.isRequired
};
$fdf7776428675e41$var$SpaceCategoryBreakdownMobile.defaultProps = {
    totalAreaDelta: null
};
$fdf7776428675e41$exports = $fdf7776428675e41$require$withTranslation("resultsPage")($fdf7776428675e41$var$SpaceCategoryBreakdownMobile);




var $3EC2Q = parcelRequire("3EC2Q");
function $035aa9054d4c9e60$var$SpaceCategoryBreakdownMobileContainer(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($fdf7776428675e41$exports, {
                spaceUnitCategory: $035aa9054d4c9e60$var$SPACE_UNIT_CATEGORY.ME,
                categoryAreaForContext: props.meCategoryAreaForContext,
                measurementSystem: props.measurementSystem,
                programForCategory: props.meProgramForCategory,
                sfType: props.sfType,
                categoryArea: props.areaTotals.totalMeSF,
                totalAreaDelta: props.meCategoryAreaDelta,
                totalAreaForContext: props.totalAreaForContext
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($fdf7776428675e41$exports, {
                spaceUnitCategory: $035aa9054d4c9e60$var$SPACE_UNIT_CATEGORY.WE,
                categoryAreaForContext: props.weCategoryAreaForContext,
                measurementSystem: props.measurementSystem,
                programForCategory: props.weProgramForCategory,
                sfType: props.sfType,
                categoryArea: props.areaTotals.totalWeSF,
                totalAreaDelta: props.weCategoryAreaDelta,
                totalAreaForContext: props.totalAreaForContext
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($fdf7776428675e41$exports, {
                spaceUnitCategory: $035aa9054d4c9e60$var$SPACE_UNIT_CATEGORY.AMENITY,
                categoryAreaForContext: props.amenityCategoryAreaForContext,
                measurementSystem: props.measurementSystem,
                programForCategory: props.amenityProgramForCategory,
                sfType: props.sfType,
                categoryArea: props.areaTotals.totalAmenitySF,
                totalAreaDelta: props.amenityCategoryAreaDelta,
                totalAreaForContext: props.totalAreaForContext
            })
        ]
    });
}
$035aa9054d4c9e60$var$SpaceCategoryBreakdownMobileContainer.propTypes = {
    measurementSystem: $c9Z8w.string.isRequired,
    meCategoryAreaForContext: $c9Z8w.number.isRequired,
    weCategoryAreaForContext: $c9Z8w.number.isRequired,
    amenityCategoryAreaForContext: $c9Z8w.number.isRequired,
    meProgramForCategory: $c9Z8w.arrayOf($c9Z8w.object).isRequired,
    weProgramForCategory: $c9Z8w.arrayOf($c9Z8w.object).isRequired,
    amenityProgramForCategory: $c9Z8w.arrayOf($c9Z8w.object).isRequired,
    meCategoryAreaDelta: $3e58c681e2cb99b8$exports.deltaShape,
    weCategoryAreaDelta: $3e58c681e2cb99b8$exports.deltaShape,
    amenityCategoryAreaDelta: $3e58c681e2cb99b8$exports.deltaShape,
    sfType: $c9Z8w.number.isRequired,
    areaTotals: $3EC2Q.areaTotalsShape.isRequired,
    totalAreaForContext: $c9Z8w.number.isRequired
};
$035aa9054d4c9e60$var$SpaceCategoryBreakdownMobileContainer.defaultProps = {
    meCategoryAreaDelta: null,
    weCategoryAreaDelta: null,
    amenityCategoryAreaDelta: null
};
$035aa9054d4c9e60$exports = $035aa9054d4c9e60$var$SpaceCategoryBreakdownMobileContainer;



var $f1q41 = parcelRequire("f1q41");
function $33d334ec060caa37$var$mapStateToProps(state) {
    const location = state.userData.officeLocation;
    const sfType = state.spaceData.sfType;
    const lossFactor = state.spaceData.lossFactor;
    const areaTotals = state.spaceData.program.areaTotals;
    // ME
    const meCategoryArea = $2a4962b1e81f9837$exports.getTotalSFForCategory(areaTotals, $33d334ec060caa37$var$SPACE_UNIT_CATEGORY.ME);
    const meProgramForCategory = state.spaceData.program[$33d334ec060caa37$var$SPACE_UNIT_CATEGORY.ME];
    const meCategoryAreaDelta = $2a4962b1e81f9837$exports.getTotalDeltaForCategoryAndContext(areaTotals, $33d334ec060caa37$var$SPACE_UNIT_CATEGORY.ME, sfType, location, lossFactor);
    // WE
    const weCategoryArea = $2a4962b1e81f9837$exports.getTotalSFForCategory(areaTotals, $33d334ec060caa37$var$SPACE_UNIT_CATEGORY.WE);
    const weProgramForCategory = state.spaceData.program[$33d334ec060caa37$var$SPACE_UNIT_CATEGORY.WE];
    const weCategoryAreaDelta = $2a4962b1e81f9837$exports.getTotalDeltaForCategoryAndContext(areaTotals, $33d334ec060caa37$var$SPACE_UNIT_CATEGORY.WE, sfType, location, lossFactor);
    // AMENITY
    const amenityCategoryArea = $2a4962b1e81f9837$exports.getTotalSFForCategory(areaTotals, $33d334ec060caa37$var$SPACE_UNIT_CATEGORY.AMENITY);
    const amenityProgramForCategory = [
        ...state.spaceData.program[$33d334ec060caa37$var$SPACE_UNIT_CATEGORY.AMENITY],
        ...state.spaceData.program[$33d334ec060caa37$var$SPACE_UNIT_CATEGORY.SUPPORT],
        ...$f1q41.map(state.spaceData.program[$33d334ec060caa37$var$SPACE_UNIT_CATEGORY.CUSTOM_AMENITY], (amenity)=>{
            const amenityWithCustomFlag = $f1q41.cloneDeep(amenity);
            amenityWithCustomFlag.isCustomAmenity = true;
            return amenityWithCustomFlag;
        })
    ];
    const amenityCategoryAreaDelta = $2a4962b1e81f9837$exports.getTotalDeltaForCategoryAndContext(areaTotals, $33d334ec060caa37$var$SPACE_UNIT_CATEGORY.AMENITY, sfType, location, lossFactor);
    return {
        meProgramForCategory: meProgramForCategory,
        weProgramForCategory: weProgramForCategory,
        amenityProgramForCategory: amenityProgramForCategory,
        meCategoryAreaForContext: $85x8Z.getAreaForContext(meCategoryArea, sfType, location, lossFactor),
        weCategoryAreaForContext: $85x8Z.getAreaForContext(weCategoryArea, sfType, location, lossFactor),
        amenityCategoryAreaForContext: $85x8Z.getAreaForContext(amenityCategoryArea, sfType, location, lossFactor),
        meCategoryAreaDelta: meCategoryAreaDelta,
        weCategoryAreaDelta: weCategoryAreaDelta,
        amenityCategoryAreaDelta: amenityCategoryAreaDelta
    };
}
$33d334ec060caa37$exports = $33d334ec060caa37$require$connect($33d334ec060caa37$var$mapStateToProps)($035aa9054d4c9e60$exports);



var $56juP = parcelRequire("56juP");

var $214a43a38235fce6$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $214a43a38235fce6$var$SpaceCategoryBreakdown(props) {
    const categoryNSF = $f1q41.reduce(props.programForCategory, (runningTotal, unit)=>runningTotal + $2a4962b1e81f9837$exports.getNSF(unit), 0);
    const circulationTotal = props.categoryArea - categoryNSF;
    const containerClasses = `column is-full-desktop is-full-tablet space-unit-breakdown-container accent-text-${props.spaceUnitCategory}`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: $56juP.isScreenMobileSize() ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($33d334ec060caa37$exports, {
                totalAreaForContext: props.totalAreaForContext,
                measurementSystem: props.measurementSystem,
                totalAreaDelta: props.categoryAreaDelta,
                sfType: props.sfType,
                lossFactor: props.lossFactor,
                areaTotals: props.areaTotals,
                location: props.location,
                updateLossFactor: props.updateLossFactor
            })
        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "columns topDiv-column space-category-breakdown-container results-breakdown-padding",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "column is-full-desktop is-full-tablet space-category-sidebar-column",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "subtitle is-6 has-margin-bottom-7 is-hidden-print is-hidden-mobile space-category-dropdown-title",
                                    children: props.t("spaceCatBreakdownSubtitle")
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)($3c4b389dae14f430$exports, {
                                    value: props.spaceUnitCategory,
                                    onValueChange: props.updateCategory,
                                    isSpaceCategoryDropdown: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($e71593141e720fa2$exports, {
                            totalAreaForContext: props.totalAreaForContext,
                            sfType: props.sfType,
                            categoryAreaForContext: props.categoryAreaForContext,
                            spaceUnitCategory: props.spaceUnitCategory,
                            measurementSystem: props.measurementSystem,
                            areaPercentage: props.areaPercentage
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: containerClasses,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($83196e03620132fb$exports, {
                            units: props.programForCategory
                        }),
                        props.spaceUnitCategory === $214a43a38235fce6$var$SPACE_UNIT_CATEGORY.AMENITY && /*#__PURE__*/ (0, $ayMG0.jsx)($09d8e7421d6bd060$exports, {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($77e576e30c1a674b$exports, {
                            totalAreaForContext: props.categoryAreaForContext,
                            totalAreaDelta: props.categoryAreaDelta,
                            circulationTotal: circulationTotal,
                            measurementSystem: props.measurementSystem,
                            sfType: props.sfType,
                            lossFactor: props.lossFactor,
                            location: props.location,
                            updateLossFactor: props.updateLossFactor
                        })
                    ]
                })
            ]
        })
    });
}
$214a43a38235fce6$var$SpaceCategoryBreakdown.propTypes = {
    totalAreaForContext: $c9Z8w.number.isRequired,
    categoryAreaForContext: $c9Z8w.number.isRequired,
    categoryArea: $c9Z8w.number.isRequired,
    categoryAreaDelta: $3e58c681e2cb99b8$exports.deltaShape,
    spaceUnitCategory: $c9Z8w.string.isRequired,
    programForCategory: $c9Z8w.arrayOf($c9Z8w.object).isRequired,
    lossFactor: $c9Z8w.number.isRequired,
    areaTotals: $3EC2Q.areaTotalsShape.isRequired,
    measurementSystem: $c9Z8w.string.isRequired,
    sfType: $c9Z8w.number.isRequired,
    location: $c9Z8w.string.isRequired,
    updateCategory: $c9Z8w.func.isRequired,
    updateLossFactor: $c9Z8w.func.isRequired,
    t: $c9Z8w.func.isRequired
};
$214a43a38235fce6$var$SpaceCategoryBreakdown.defaultProps = {
    categoryAreaDelta: null
};
$214a43a38235fce6$exports = $214a43a38235fce6$require$withTranslation("resultsPage")($214a43a38235fce6$var$SpaceCategoryBreakdown);


// Map state to props
function $b2ecd9dbb8aa6b8f$var$mapStateToProps(state, ownProps) {
    const location = state.userData.officeLocation;
    const sfType = state.spaceData.sfType;
    const lossFactor = state.spaceData.lossFactor;
    const areaTotals = state.spaceData.program.areaTotals;
    const areaPercentage = state.spaceData.program.areaPercentage;
    const categoryArea = $2a4962b1e81f9837$exports.getTotalSFForCategory(areaTotals, ownProps.spaceUnitCategory);
    const categoryAreaDelta = $2a4962b1e81f9837$exports.getTotalDeltaForCategoryAndContext(areaTotals, ownProps.spaceUnitCategory, sfType, location, lossFactor);
    const totalArea = $2a4962b1e81f9837$exports.getTotalSF(areaTotals);
    const programForCategory = ownProps.programForCategory || state.spaceData.program[ownProps.spaceUnitCategory];
    return {
        areaPercentage: areaPercentage,
        location: location,
        sfType: sfType,
        lossFactor: lossFactor,
        areaTotals: areaTotals,
        categoryArea: categoryArea,
        categoryAreaDelta: categoryAreaDelta,
        programForCategory: programForCategory,
        measurementSystem: state.spaceData.measurementSystem,
        totalAreaForContext: $85x8Z.getAreaForContext(totalArea, sfType, location, lossFactor),
        categoryAreaForContext: $85x8Z.getAreaForContext(categoryArea, sfType, location, lossFactor)
    };
}
// Map dispatch to props
function $b2ecd9dbb8aa6b8f$var$mapDispatchToProps(dispatch) {
    return {
        updateLossFactor: $b2ecd9dbb8aa6b8f$require$bindActionCreators($7f3ddf5ab2cb44f3$exports.updateLossFactor, dispatch)
    };
}
$b2ecd9dbb8aa6b8f$exports = $b2ecd9dbb8aa6b8f$require$connect($b2ecd9dbb8aa6b8f$var$mapStateToProps, $b2ecd9dbb8aa6b8f$var$mapDispatchToProps)($214a43a38235fce6$exports);




var $8af964d59099bd8d$exports = {};

var $jHTLJ = parcelRequire("jHTLJ");
var $8af964d59099bd8d$require$connect = $jHTLJ.connect;
var $6223411174f60c00$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $460e9 = parcelRequire("460e9");

var $fPryk = parcelRequire("fPryk");
var $6223411174f60c00$require$EXAMPLE_PLAN_MAP = $fPryk.examplePlanMap;




var $aB89e = parcelRequire("aB89e");
var $6223411174f60c00$require$constants = $aB89e.spacerFree;

var $fPryk = parcelRequire("fPryk");
var $6223411174f60c00$require$profileMap = $fPryk.profileMap;

var $6223411174f60c00$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;


var $3GYAO = parcelRequire("3GYAO");

var $hjiT0 = parcelRequire("hjiT0");
function $6223411174f60c00$var$getLinkButtonToExamplePlan(href, t) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0d293be9728cb533$exports, {
        href: href,
        onClick: ()=>{
            $3GYAO.GAEvent($3a61343632c866bc$exports.categories.result, $3a61343632c866bc$exports.actions.examplePlansBtn, $3a61343632c866bc$exports.labels.examplePlansBtn);
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: "button is-primary-outlined is-small has-min-width-narrow example-plan-button heap-view-example-plan-button",
            children: t("examplePlanButtonText")
        })
    });
}
function $6223411174f60c00$var$getExampleRoute(profileId, size, isPartialFloor, measurementSystem, is2Dlink) {
    // if isPartialFloor is false, return for full floor
    const sizeString = `${isPartialFloor ? "partial" : "full"}_${size.toString()}`;
    let LinkType = is2Dlink ? "link2D" : "link3D";
    const fitId = $6223411174f60c00$require$EXAMPLE_PLAN_MAP[LinkType][profileId][sizeString];
    let url = `https://plans.cbre.com/examples#/testFits/${fitId}`;
    // Plans only has imperial and metric (no Tsubo)
    // default to metric URL for any non-imperial
    if (!$460e9.isImperial(measurementSystem)) url += "?units=metric";
    return url;
}
function $6223411174f60c00$var$getPreviewImageFileName(size, props) {
    const profileName = $6223411174f60c00$require$profileMap[props.profileId].displayNameToken;
    let fullPlanType;
    let partialPlanType;
    if (size === 5000) {
        fullPlanType = $6223411174f60c00$require$constants.profileInfo.FLOORPLAN_TYPE.FULL_5K;
        partialPlanType = $6223411174f60c00$require$constants.profileInfo.FLOORPLAN_TYPE.PARTIAL_5K;
    } else if (size === 10000) {
        fullPlanType = $6223411174f60c00$require$constants.profileInfo.FLOORPLAN_TYPE.FULL_10K;
        partialPlanType = $6223411174f60c00$require$constants.profileInfo.FLOORPLAN_TYPE.PARTIAL_10K;
    } else if (size === 15000) {
        fullPlanType = $6223411174f60c00$require$constants.profileInfo.FLOORPLAN_TYPE.FULL_15K;
        partialPlanType = $6223411174f60c00$require$constants.profileInfo.FLOORPLAN_TYPE.PARTIAL_15K;
    } else {
        fullPlanType = $6223411174f60c00$require$constants.profileInfo.FLOORPLAN_TYPE.FULL_20K;
        partialPlanType = $6223411174f60c00$require$constants.profileInfo.FLOORPLAN_TYPE.PARTIAL_20K;
    }
    const fullPlanUrl = $6223411174f60c00$require$profileMap[props.profileId].examplePreviewImageNames[fullPlanType];
    const partialPlanUrl = $6223411174f60c00$require$profileMap[props.profileId].examplePreviewImageNames[partialPlanType];
    return {
        fullPlanUrl: fullPlanUrl,
        partialPlanUrl: partialPlanUrl,
        profileName: profileName
    };
}
function $6223411174f60c00$var$ExamplePlans(props) {
    const is2Dlink = $hjiT0.is2DExampleLinkLocation(props.officeLocation);
    let examplePlanSize;
    if (props.totalRSF <= 7500) examplePlanSize = 5000;
    else if (props.totalRSF <= 12500) examplePlanSize = 10000;
    else if (props.totalRSF <= 17500) examplePlanSize = 15000;
    else examplePlanSize = 20000;
    const { fullPlanUrl: fullPlanUrl, partialPlanUrl: partialPlanUrl, profileName: profileName } = $6223411174f60c00$var$getPreviewImageFileName(examplePlanSize, props);
    const measurementLabel = props.t(`common:${$460e9.getTokenKeyForMeasurementSystem(props.sfType === $6223411174f60c00$require$constants.calculator.SF_TYPE.NIA ? "NIA" : "RSF", props.measurementSystem)}`);
    const size = $460e9.getNumberForMeasurementSystem(examplePlanSize, props.measurementSystem);
    const sizeWithCommas = $5f15cdd5de4823b1$exports.numberWithLocaleFormat(size);
    const fullLabel = `${sizeWithCommas} ${measurementLabel} ${props.t("examplePlanFullFloorText")}`;
    const partialLabel = `${sizeWithCommas} ${measurementLabel} ${props.t("examplePlanPartialFloorText")}`;
    const fullPlanLink = $6223411174f60c00$var$getExampleRoute(props.profileId, examplePlanSize, false, props.measurementSystem, is2Dlink);
    const partialPlanLink = $6223411174f60c00$var$getExampleRoute(props.profileId, examplePlanSize, true, props.measurementSystem, is2Dlink);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "columns example-plans-preview",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "column example-plan-column",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("figure", {
                        className: "image example-plan-image has-margin-0-auto",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: fullPlanUrl,
                            alt: props.t("examplePlanFullImgAlt", {
                                size: sizeWithCommas,
                                unit: $460e9.getTokenKeyForMeasurementSystem("foot", props.measurementSystem),
                                profileName: profileName
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "example-plan-label is-sans-semibold",
                        children: fullLabel
                    }),
                    $6223411174f60c00$var$getLinkButtonToExamplePlan(fullPlanLink, props.t)
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "column example-plan-column",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("figure", {
                        className: "image example-plan-image has-margin-0-auto",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: partialPlanUrl,
                            alt: props.t("examplePlanPartialImgAlt", {
                                size: sizeWithCommas,
                                unit: $460e9.getTokenKeyForMeasurementSystem("foot", props.measurementSystem),
                                profileName: profileName
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "example-plan-label is-sans-semibold",
                        children: partialLabel
                    }),
                    $6223411174f60c00$var$getLinkButtonToExamplePlan(partialPlanLink, props.t),
                    examplePlanSize === 20000 && /*#__PURE__*/ (0, $ayMG0.jsx)($8dfee474cfb1f477$exports, {
                        position: "bottom",
                        text: props.t("examplePlanTooltipText", {
                            size: sizeWithCommas,
                            unit: measurementLabel
                        })
                    })
                ]
            })
        ]
    });
}
$6223411174f60c00$var$ExamplePlans.propTypes = {
    sfType: $c9Z8w.number.isRequired,
    profileId: $c9Z8w.string.isRequired,
    measurementSystem: $c9Z8w.string.isRequired,
    profileType: $c9Z8w.string.isRequired,
    totalRSF: $c9Z8w.number.isRequired,
    t: $c9Z8w.func.isRequired
};
$6223411174f60c00$exports = $6223411174f60c00$require$withTranslation("resultsPage")($6223411174f60c00$var$ExamplePlans);




var $85x8Z = parcelRequire("85x8Z");

var $aB89e = parcelRequire("aB89e");
var $8af964d59099bd8d$require$constants = $aB89e.spacerFree;

// Map state to props
function $8af964d59099bd8d$var$mapStateToProps(state) {
    const calculatedProfileType = $e3ec1f29f8e2ec07$exports.calculateProfileType(state.userData.officeLocation, state.spaceData.assumptions.headcount, state.profileQuiz.userQuizAnswers);
    return {
        sfType: state.spaceData.sfType,
        profileId: state.spaceData.profileId,
        measurementSystem: state.spaceData.measurementSystem,
        profileType: calculatedProfileType,
        officeLocation: state.userData.officeLocation,
        totalRSF: $85x8Z.getAreaForContext($2a4962b1e81f9837$exports.getTotalSF(state.spaceData.program.areaTotals), $8af964d59099bd8d$require$constants.calculator.SF_TYPE.RSF, state.userData.officeLocation, state.spaceData.lossFactor)
    };
}
$8af964d59099bd8d$exports = $8af964d59099bd8d$require$connect($8af964d59099bd8d$var$mapStateToProps)($6223411174f60c00$exports);


var $d80d321807e00652$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

function $d80d321807e00652$var$HighlightedContentSection(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "light-gray-content-section",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($8dbf84adc5277014$exports, {
            children: props.children
        })
    });
}
$d80d321807e00652$var$HighlightedContentSection.propTypes = {
    children: $c9Z8w.node.isRequired
};
$d80d321807e00652$exports = $d80d321807e00652$var$HighlightedContentSection;


var $a9bccd3c65d72040$exports = {};


var $jHTLJ = parcelRequire("jHTLJ");
var $a9bccd3c65d72040$require$connect = $jHTLJ.connect;

var $hjiT0 = parcelRequire("hjiT0");
var $a7ed1d23eae0a668$exports = {};
$a7ed1d23eae0a668$exports = {
    isCBREEmployee (userRole) {
        // everything but 'cbreProfessional' is deprecated
        return userRole === "cbreProfessional" || userRole === "cbreWorkplace" || userRole === "cbreOther" || userRole === "cbreLeasingProfessional";
    },
    isCBREClient (userRole) {
        return userRole === "cbreClient";
    }
};




var $eShmq = parcelRequire("eShmq");
var $a9bccd3c65d72040$require$bindActionCreators = $eShmq.bindActionCreators;
var $f984a8727ab2c5b0$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $da568585ccda1a1d$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $da568585ccda1a1d$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;

var $da568585ccda1a1d$require$Trans = $e04d9533328ca578$export$8d6a9236f2e3f2ce;
function $da568585ccda1a1d$var$AcceptTermsText(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($da568585ccda1a1d$require$Trans, {
            i18nKey: "resultsPage:acceptTermsText",
            children: [
                "0",
                /*#__PURE__*/ (0, $ayMG0.jsx)($0d293be9728cb533$exports, {
                    href: "/terms-spacer-by-cbre",
                    children: "1"
                }),
                "2",
                /*#__PURE__*/ (0, $ayMG0.jsx)($0d293be9728cb533$exports, {
                    href: props.t("privacyPolicyLink"),
                    children: "3"
                }),
                "."
            ]
        })
    });
}
$da568585ccda1a1d$var$AcceptTermsText.propTypes = {
    t: $c9Z8w.func.isRequired
};
$da568585ccda1a1d$exports = $da568585ccda1a1d$require$withTranslation("resultsPage")($da568585ccda1a1d$var$AcceptTermsText);



var $f984a8727ab2c5b0$require$fetchSourceData = $b8d5e5d00fd08f22$exports.fetchSourceData;

var $f984a8727ab2c5b0$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;


var $3GYAO = parcelRequire("3GYAO");
class $f984a8727ab2c5b0$var$EmailWallSection extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            email: "",
            termsChecked: false,
            firstName: "",
            lastName: ""
        };
        if (this.props.isUserInEEA && !this.props.isCBREEmployee) this.state.contactOptIn = false;
        if (this.props.isUserInCalifornia && !this.props.isCBREEmployee) this.state.contactOptIn = true;
        if (!this.props.isCBREEmployee) this.state.cbreContact = this.props.cbreContact || "";
        this.onValueChange = this.onValueChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.firstNameRef = $acw62.createRef();
        this.lastNameRef = $acw62.createRef();
        this.emailRef = $acw62.createRef();
        this.cbreEmailRef = $acw62.createRef();
    }
    componentDidMount() {
        // if a sourceId was on the store, populate role: 'client' on the store, and broker email locally
        // (it's happening here instead of earlier in the quiz to not accidentally clear out the fetched
        // broker data when navigating in and out of the quiz)
        if (this.props.sourceId) {
            this.props.addBulkUserData({
                role: "cbreClient"
            }); // if there's a sourceId present, we know it's a client
            $f984a8727ab2c5b0$require$fetchSourceData(this.props.sourceId, (source)=>this.setState({
                    cbreContact: source.email
                }), ()=>this.setState({
                    troubleFetchingSource: true
                }));
        }
    }
    onValueChange(key, value) {
        this.setState({
            [key]: value
        });
        // Custom Form Input Validation
        const checkValidation = (ref, validationMessageToken)=>{
            if (ref === null) return;
            ref.setCustomValidity("");
            if (!ref.checkValidity()) ref.setCustomValidity(this.props.t(validationMessageToken));
        };
        checkValidation(this.firstNameRef.current, "emailWallFirstNameInvalid");
        checkValidation(this.lastNameRef.current, "emailWallLastNameInvalid");
        checkValidation(this.emailRef.current, "emailWallEmailInvalid");
        checkValidation(this.cbreEmailRef.current, "emailWallEmailInvalid");
    }
    onSubmit(evt) {
        evt.preventDefault();
        this.props.addBulkUserData({
            email: this.state.email,
            firstName: this.state.firstName,
            lastName: this.state.lastName
        });
        this.props.saveProgram(this.state);
        $3GYAO.GAEvent($3a61343632c866bc$exports.categories.result, $3a61343632c866bc$exports.actions.completeResultBtn, $3a61343632c866bc$exports.labels.completeResultBtn);
        if (this.props.sourceId && !this.state.troubleFetchingSource) this.props.sendHeapEventWithoutProps("View Results Page (Program Id Page) from Referral Link");
    }
    render() {
        const isEEANonEmployeeUser = this.props.isUserInEEA && !this.props.isCBREEmployee;
        const isCaliforniaNonEmployeeUser = this.props.isUserInCalifornia && !this.props.isCBREEmployee;
        return /*#__PURE__*/ (0, $ayMG0.jsx)($8dbf84adc5277014$exports, {
            hideOnPrint: true,
            isEmailWallSection: true,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "columns level",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                        onSubmit: this.onSubmit,
                        className: "column",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "email-wall-section-title",
                                children: this.props.t("emailWallTitle")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "email-wall-text email-wall-section-subtitle",
                                children: this.props.t("emailWallSubtitle")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "email-wall-container",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "email-wall-name-input-container",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                className: "email-wall-name",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "email-wall-text email-wall-label",
                                                        children: this.props.t("emailWallFirstNamePlaceholder")
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        required: true,
                                                        ref: this.firstNameRef,
                                                        className: "email-wall-text email-wall-section-input",
                                                        type: "text",
                                                        onChange: (evt)=>this.onValueChange("firstName", evt.target.value),
                                                        value: this.state.firstName
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                                className: "email-wall-name",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "email-wall-text email-wall-label",
                                                        children: this.props.t("emailWallLastNamePlaceholder")
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        required: true,
                                                        ref: this.lastNameRef,
                                                        className: "email-wall-text email-wall-section-input",
                                                        type: "text",
                                                        onChange: (evt)=>this.onValueChange("lastName", evt.target.value),
                                                        value: this.state.lastName
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "email-wall-text email-wall-label",
                                                children: this.props.t("emailWallEmailPlaceholder")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex flex-row",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        required: true,
                                                        ref: this.emailRef,
                                                        className: "email-wall-text email-wall-section-input",
                                                        type: "email",
                                                        onChange: (evt)=>this.onValueChange("email", evt.target.value),
                                                        value: this.state.email
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "email-wall-envelope-icon"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    this.props.isCBREClient && /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "email-wall-text email-wall-label",
                                                children: this.props.sourceId && !this.state.troubleFetchingSource ? this.props.t("emailWallLeasingProfessionalPlaceholder") : this.props.t("emailWallCBREEmailPlaceholder")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex flex-row",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                        ref: this.cbreEmailRef,
                                                        className: "email-wall-text email-wall-section-input",
                                                        type: "email",
                                                        onChange: (evt)=>this.onValueChange("cbreContact", evt.target.value),
                                                        value: this.state.cbreContact,
                                                        readOnly: this.props.sourceId && !this.state.troubleFetchingSource,
                                                        autoComplete: "nope"
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "email-wall-envelope-icon"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "email-wall-checkbox-container",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "acceptTermsCheckbox",
                                                className: "email-wall-checkbox",
                                                type: "checkbox",
                                                value: this.state.termsChecked,
                                                onClick: (evt)=>this.onValueChange("termsChecked", evt.target.checked)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                className: "email-wall-checkbox-label email-wall-text",
                                                htmlFor: "acceptTermsCheckbox",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)($da568585ccda1a1d$exports, {})
                                            })
                                        ]
                                    }),
                                    isEEANonEmployeeUser || isCaliforniaNonEmployeeUser ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "email-wall-checkbox-container",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                                                id: "allowContactCheckbox",
                                                className: "email-wall-checkbox",
                                                type: "checkbox",
                                                value: this.state.contactOptIn,
                                                checked: this.state.contactOptIn,
                                                onClick: (evt)=>this.onValueChange("contactOptIn", evt.target.checked)
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                                className: "email-wall-text email-wall-checkbox-label",
                                                htmlFor: "allowContactCheckbox",
                                                children: this.props.t("emailWallConnectMeText")
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "email-wall-text email-wall-contact-notice",
                                        children: this.props.t("emailWallContactNoticeText")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                        type: "submit",
                                        className: "button email-wall-submit-button",
                                        disabled: !(this.state.termsChecked && this.state.email),
                                        children: this.props.t("emailWallResultsButtonText")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "column is-hidden-mobile",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: "/png/results-page-email-wall-spacer-by-cbre.png",
                            alt: this.props.t("emailWallImgAltText")
                        })
                    })
                ]
            })
        });
    }
}
$f984a8727ab2c5b0$var$EmailWallSection.propTypes = {
    isUserInEEA: $c9Z8w.bool.isRequired,
    isUserInCalifornia: $c9Z8w.bool.isRequired,
    isCBREEmployee: $c9Z8w.bool.isRequired,
    isCBREClient: $c9Z8w.bool.isRequired,
    saveProgram: $c9Z8w.func.isRequired,
    cbreContact: $c9Z8w.string,
    sourceId: $c9Z8w.string,
    t: $c9Z8w.func.isRequired,
    addBulkUserData: $c9Z8w.func.isRequired,
    sendHeapEventWithoutProps: $c9Z8w.func.isRequired
};
$f984a8727ab2c5b0$var$EmailWallSection.defaultProps = {
    cbreContact: "",
    sourceId: null
};
$f984a8727ab2c5b0$exports = $f984a8727ab2c5b0$require$withTranslation("resultsPage")($f984a8727ab2c5b0$var$EmailWallSection);


// Map state to props
function $a9bccd3c65d72040$var$mapStateToProps(state) {
    const location = $hjiT0.getCityStateCountry(state.userData.currentPersonalLocation);
    return {
        isUserInEEA: $hjiT0.isEuropeanEconomicArea(location.country),
        isUserInCalifornia: $hjiT0.isCalifornia(location.state, location.country),
        isCBREEmployee: $a7ed1d23eae0a668$exports.isCBREEmployee(state.userData.role),
        isCBREClient: $a7ed1d23eae0a668$exports.isCBREClient(state.userData.role),
        cbreContact: state.userData.cbreContact,
        sourceId: state.userData.sourceId
    };
}
// Map dispatch to props
function $a9bccd3c65d72040$var$mapDispatchToProps(dispatch) {
    return {
        saveProgram: $a9bccd3c65d72040$require$bindActionCreators((0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).saveProgram, dispatch),
        addBulkUserData: $a9bccd3c65d72040$require$bindActionCreators($3d5a8542f4e060ff$exports.addBulkUserData, dispatch),
        sendHeapEventWithoutProps: $a9bccd3c65d72040$require$bindActionCreators((0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).sendHeapEventWithoutProps, dispatch)
    };
}
$a9bccd3c65d72040$exports = $a9bccd3c65d72040$require$connect($a9bccd3c65d72040$var$mapStateToProps, $a9bccd3c65d72040$var$mapDispatchToProps)($f984a8727ab2c5b0$exports);


var $f47fd9661f4a8b9a$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
function $f47fd9661f4a8b9a$var$SectionTitle(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "section-title-container",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                className: "title is-4 section-title has-margin-bottom-7 is-calibre",
                children: props.title
            }),
            props.subtitle && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "section-subtitle",
                children: props.subtitle
            })
        ]
    });
}
$f47fd9661f4a8b9a$var$SectionTitle.propTypes = {
    title: $c9Z8w.string.isRequired,
    subtitle: $c9Z8w.string
};
$f47fd9661f4a8b9a$var$SectionTitle.defaultProps = {
    subtitle: ""
};
$f47fd9661f4a8b9a$exports = $f47fd9661f4a8b9a$var$SectionTitle;


var $1ef8cf45334718b5$exports = {};

var $jHTLJ = parcelRequire("jHTLJ");
var $1ef8cf45334718b5$require$connect = $jHTLJ.connect;

var $eShmq = parcelRequire("eShmq");
var $1ef8cf45334718b5$require$bindActionCreators = $eShmq.bindActionCreators;

var $44cd3d7b7669eedf$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $aB89e = parcelRequire("aB89e");
var $44cd3d7b7669eedf$require$constants = $aB89e.spacerFree;

var $44cd3d7b7669eedf$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $44cd3d7b7669eedf$var$NextStepsSection(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "next-steps",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($81e115b62a8073a8$exports, {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "columns level",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "column is-3 is-offset-1 level-item is-hidden-mobile",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("figure", {
                            className: "image is-4by3",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: "/svg/illustrations/results-page-people-conversing-spacer-by-cbre.svg",
                                alt: props.t("nextStepsSectionImgAlt")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "column is-6 is-offset-1",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "subtitle is-6",
                                children: props.t("nextStepsSectionSubtitle")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "title is-3 next-steps-title is-calibre next-steps-size",
                                children: props.t("nextStepsSectionTitle")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "button is-primary-filled is-medium find-space-button next-steps-find-space-button",
                                onClick: ()=>props.openModal($44cd3d7b7669eedf$require$constants.modal.TYPES.FORM, {
                                        formType: $44cd3d7b7669eedf$require$constants.modal.FORM_TYPES.FIND_SPACE
                                    }),
                                children: props.t("nextStepsSectionButtonText")
                            })
                        ]
                    })
                ]
            })
        })
    });
}
$44cd3d7b7669eedf$var$NextStepsSection.propTypes = {
    openModal: $c9Z8w.func.isRequired,
    t: $c9Z8w.func.isRequired
};
$44cd3d7b7669eedf$exports = $44cd3d7b7669eedf$require$withTranslation("resultsPage")($44cd3d7b7669eedf$var$NextStepsSection);


// Map dispatch to props
function $1ef8cf45334718b5$var$mapDispatchToProps(dispatch) {
    return {
        openModal: $1ef8cf45334718b5$require$bindActionCreators($15a18ec2484069fc$exports.openModal, dispatch)
    };
}
$1ef8cf45334718b5$exports = $1ef8cf45334718b5$require$connect(null, $1ef8cf45334718b5$var$mapDispatchToProps)($44cd3d7b7669eedf$exports);



var $56juP = parcelRequire("56juP");

var $ec30531dc383a3d7$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;

var $ec30531dc383a3d7$require$Trans = $e04d9533328ca578$export$8d6a9236f2e3f2ce;
var $ebe62590acf7fd03$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
var $139439650754a6bb$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $139439650754a6bb$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;


var $3GYAO = parcelRequire("3GYAO");
function $139439650754a6bb$var$FlooredPlanReqButton(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
            style: {
                display: "table-cell"
            },
            href: "https://cbre.co/PlansRequest",
            target: "_blank",
            onClick: ()=>{
                $3GYAO.GAEvent($3a61343632c866bc$exports.categories.result, $3a61343632c866bc$exports.actions.requestPlanBtn, $3a61343632c866bc$exports.labels.requestPlanBtn);
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "button cta-button is-primary-filled has-min-width-narrow heap-size-my-office-button flooredPlanButton is-calibre",
                children: props.t("flooredPlanRequestLinkText")
            })
        })
    });
}
$139439650754a6bb$var$FlooredPlanReqButton.propTypes = {
    t: $c9Z8w.func.isRequired
};
$139439650754a6bb$exports = $139439650754a6bb$require$withTranslation("common")($139439650754a6bb$var$FlooredPlanReqButton);



var $ebe62590acf7fd03$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;

var $c9Z8w = parcelRequire("c9Z8w");
var $a04018e4cccb8ba6$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
function $a04018e4cccb8ba6$var$Video(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "Flooredvideo",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("video", {
            controls: true,
            poster: "/svg/Floored.svg",
            src: "/videos/FlooredPlanVideo.mp4",
            type: "video/mp4"
        })
    });
}
$a04018e4cccb8ba6$exports = $a04018e4cccb8ba6$var$Video;


function $ebe62590acf7fd03$var$FlooredPlanReqSection(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "flooredPlanrequestSection",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flooredPlan-heading",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: props.t("flooredTitle")
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "set-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($139439650754a6bb$exports, {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "columns",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "column floored",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "redefinedText",
                                        children: props.t("flooredSubTitle")
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "subtext",
                                        children: [
                                            " ",
                                            props.t("flooredSubText")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                        className: "paragraph",
                                        children: [
                                            props.t("flooredParagraphText1"),
                                            " ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            " ",
                                            props.t("flooredParagraphText2")
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "column floored",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("figure", {
                                    className: "image is-hidden-mobile flooredImage",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                        src: "/png/Floored_Plans_MacBook_2d-3d.png",
                                        alt: props.t("landingPageSecondaryHeroImgAlt")
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "line-seperator"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "sampleText",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: props.t("flooredVideoHeading")
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "set-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($a04018e4cccb8ba6$exports, {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "line-seperator"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flooredPlan-heading",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            children: props.t("flooredFreeText")
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "icons-floored",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "columns",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "column icon",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: "/svg/icons/blueprint.svg",
                                            alt: "",
                                            className: "floored-icon"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-1",
                                            children: props.t("flooredIconText1")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-2",
                                            children: props.t("flooredIconSubText1")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "column icon",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: "/svg/icons/adaptation.svg",
                                            alt: "",
                                            className: "floored-icon"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-1",
                                            children: props.t("flooredIconText2")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-2",
                                            children: props.t("flooredIconSubText2")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "column icon",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                            src: "/svg/icons/layers_icon.svg",
                                            alt: "",
                                            className: "floored-icon"
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-1",
                                            children: props.t("flooredIconText3")
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            className: "text-2",
                                            children: props.t("flooredIconSubText3")
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "set-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)($139439650754a6bb$exports, {})
                    })
                ]
            })
        })
    });
}
$ebe62590acf7fd03$var$FlooredPlanReqSection.propTypes = {
    t: $c9Z8w.func.isRequired
};
$ebe62590acf7fd03$exports = $ebe62590acf7fd03$require$withTranslation("resultsPage")($ebe62590acf7fd03$var$FlooredPlanReqSection);




var $3GYAO = parcelRequire("3GYAO");
const $ec30531dc383a3d7$var$TOO_MUCH_TINKERING_BOUNDARY = 0.2;
class $ec30531dc383a3d7$var$Program extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            activeCategory: $ec30531dc383a3d7$var$SPACE_UNIT_CATEGORY.AMENITY,
            isTinkerWarningVisible: false,
            haveClosedTinkerWarning: false,
            changesToResultsSaved: false,
            programSavedFromEmailWall: false,
            testFitFormClosed: !this.props.testFitFormCompleted
        };
        // Taking these bits of state off of React state because don't want to subscribe to the
        // React setState->render loop
        this.updateActiveCategory = this.updateActiveCategory.bind(this);
        this.closeTinkerWarning = this.closeTinkerWarning.bind(this);
        this.saveChangesOnSubmit = this.saveChangesOnSubmit.bind(this);
        this.revertChanges = this.revertChanges.bind(this);
        this.openTestFitForm = this.openTestFitForm.bind(this);
        this.closeTestFitForm = this.closeTestFitForm.bind(this);
    }
    // updating tinker warning
    componentDidUpdate(prevProps, prevState) {
        if (this.props.program.areaTotals !== prevProps.program.areaTotals || this.props.lossFactor !== prevProps.lossFactor) {
            this.props.detectChangeToSaveOnResults();
            this.props.onTinker();
        }
        const totalAreaDelta = $2a4962b1e81f9837$exports.getTotalSFDelta(this.props.program.areaTotals);
        const outsideTinkerBoundary = totalAreaDelta && (totalAreaDelta.percentDelta > $ec30531dc383a3d7$var$TOO_MUCH_TINKERING_BOUNDARY || totalAreaDelta.percentDelta < -$ec30531dc383a3d7$var$TOO_MUCH_TINKERING_BOUNDARY);
        // If we tinkered too far but haven't closed the warning, show the warning (prevents showing the warning every tinker after they close it)
        if (outsideTinkerBoundary && !prevState.haveClosedTinkerWarning) {
            if (!prevState.isTinkerWarningVisible) this.setState({
                isTinkerWarningVisible: true
            });
        } else if (!outsideTinkerBoundary) // Reset the closed flag so that if they go outside the bounds, close, go back in bounds, then back outside, we re-warn them
        {
            if (prevState.isTinkerWarningVisible || prevState.haveClosedTinkerWarning) this.setState({
                isTinkerWarningVisible: false,
                haveClosedTinkerWarning: false
            });
        }
        if (!this.props.showEmailWall && prevProps.showEmailWall) {
            this.setState({
                programSavedFromEmailWall: true
            });
            $56juP.scrollToWithNavbar(this.programElement);
        }
    }
    closeTinkerWarning() {
        this.setState({
            isTinkerWarningVisible: false,
            haveClosedTinkerWarning: true
        });
    }
    updateActiveCategory(activeCategory) {
        this.setState({
            activeCategory: activeCategory
        });
    }
    saveChangesOnSubmit() {
        this.props.updateProgram(this.props.programId);
        $3GYAO.GAEvent($3a61343632c866bc$exports.categories.result, $3a61343632c866bc$exports.actions.saveChangesBtn, $3a61343632c866bc$exports.labels.saveChangesBtn);
        this.setState({
            programSavedFromEmailWall: false,
            changesToResultsSaved: true
        });
        this.props.changeToResultsSaved();
        setTimeout(()=>{
            this.setState({
                changesToResultsSaved: false
            });
        }, 3000);
    }
    revertChanges() {
        this.props.fetchProgramIfNeeded(this.props.programId);
        $56juP.scrollToWithNavbar(this.programElement);
        this.props.changeToResultsSaved();
    }
    openTestFitForm() {
        this.setState({
            testFitFormClosed: false
        });
    }
    closeTestFitForm() {
        this.setState({
            testFitFormClosed: true
        });
    }
    render() {
        let visibleBreakDown;
        const meBreakdown = /*#__PURE__*/ (0, $ayMG0.jsx)($b2ecd9dbb8aa6b8f$exports, {
            spaceUnitCategory: $ec30531dc383a3d7$var$SPACE_UNIT_CATEGORY.ME,
            updateCategory: this.updateActiveCategory
        });
        const weBreakdown = /*#__PURE__*/ (0, $ayMG0.jsx)($b2ecd9dbb8aa6b8f$exports, {
            spaceUnitCategory: $ec30531dc383a3d7$var$SPACE_UNIT_CATEGORY.WE,
            updateCategory: this.updateActiveCategory
        });
        const amenityBreakdown = /*#__PURE__*/ (0, $ayMG0.jsx)($b2ecd9dbb8aa6b8f$exports, {
            spaceUnitCategory: $ec30531dc383a3d7$var$SPACE_UNIT_CATEGORY.AMENITY,
            updateCategory: this.updateActiveCategory,
            programForCategory: [
                ...this.props.program[$ec30531dc383a3d7$var$SPACE_UNIT_CATEGORY.AMENITY],
                ...this.props.program[$ec30531dc383a3d7$var$SPACE_UNIT_CATEGORY.SUPPORT],
                ...$f1q41.map(this.props.program[$ec30531dc383a3d7$var$SPACE_UNIT_CATEGORY.CUSTOM_AMENITY], (amenity)=>{
                    const amenityWithCustomFlag = $f1q41.cloneDeep(amenity);
                    amenityWithCustomFlag.isCustomAmenity = true;
                    amenityWithCustomFlag.displayName = this.props.t(amenityWithCustomFlag.displayName);
                    return amenityWithCustomFlag;
                }) // add custom amenity flag to all custom amenities
            ]
        });
        let featureBanner = null;
        if (window.SERVER_DATA.featureFlags.planIntegrationEnabled) featureBanner = this.state.testFitFormClosed ? /*#__PURE__*/ (0, $ayMG0.jsx)($7e261e546ab7b524$exports, {
            openTestFitForm: this.openTestFitForm
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)($9b0229e22153adbc$exports, {
            closeTestFitForm: this.closeTestFitForm,
            completed: this.props.testFitFormCompleted
        });
        else featureBanner = /*#__PURE__*/ (0, $ayMG0.jsxs)($8dbf84adc5277014$exports, {
            hideOnMobile: true,
            hideOnPrint: true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($f47fd9661f4a8b9a$exports, {
                    title: this.props.t("programExamplePlansTitle"),
                    subtitle: this.props.t("programExamplePlansSubtitle")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($8af964d59099bd8d$exports, {})
            ]
        });
        if (this.state.activeCategory === $ec30531dc383a3d7$var$SPACE_UNIT_CATEGORY.ME) visibleBreakDown = meBreakdown;
        else if (this.state.activeCategory === $ec30531dc383a3d7$var$SPACE_UNIT_CATEGORY.WE) visibleBreakDown = weBreakdown;
        else visibleBreakDown = amenityBreakdown;
        const email = this.props.t("common:spacerSupportEmail");
        const tooMuchTinkerWarning = this.state.isTinkerWarningVisible && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "notification is-danger program-tinker-warning",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "delete",
                    onClick: this.closeTinkerWarning
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)($ec30531dc383a3d7$require$Trans, {
                    i18nKey: "programTooMuchTinkerWarning",
                    email: email,
                    children: [
                        "0",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: "/quiz-spacer-by-cbre",
                            children: "1"
                        }),
                        "2",
                        /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                            href: `mailto:${$ec30531dc383a3d7$require$constants.contact.SPACER_SUPPORT_EMAIL}`,
                            children: {
                                email: email
                            }
                        }),
                        "."
                    ]
                })
            ]
        });
        let savedChangesClass = "";
        let saveButtonText = this.props.t("programSaveButtonText");
        if (this.state.changesToResultsSaved) {
            savedChangesClass = "has-checkmark-icon-before";
            saveButtonText = this.props.t("programSavedButtonText");
        }
        let workspaceClasses = " is-hidden-mobile";
        if ($56juP.isScreenMobileSize()) workspaceClasses = " is-mobile-input mobile-buttons";
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            ref: (node)=>{
                this.programElement = node;
            },
            children: this.props.showEmailWall ? /*#__PURE__*/ (0, $ayMG0.jsx)($a9bccd3c65d72040$exports, {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                children: [
                    this.state.programSavedFromEmailWall && /*#__PURE__*/ (0, $ayMG0.jsx)($8dbf84adc5277014$exports, {
                        hideOnPrint: true,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "program-save-confirmation-box",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "program-save-confirmation-box-text",
                                children: this.props.t("programSaveConfirmationBoxText")
                            })
                        })
                    }, "programBox"),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)($d80d321807e00652$exports, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)($f47fd9661f4a8b9a$exports, {
                                title: this.props.t("programMetricsTitle"),
                                subtitle: this.props.t("programMetricsSubtitle")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)($6b5edee5943f98ff$exports, {
                                programStats: this.props.program.finalStats,
                                measurementSystem: this.props.measurementSystem
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "is-print-only print-disclaimer",
                        children: this.props.t("programDisclaimer")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)($8dbf84adc5277014$exports, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "your-details",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)($f47fd9661f4a8b9a$exports, {
                                    title: this.props.t("programDetailsSectionTitle"),
                                    subtitle: this.props.t("programDetailsSectionSubtitle")
                                }),
                                tooMuchTinkerWarning,
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "your-details-border",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)($a777271149d2323f$exports, {
                                            detectChangeToSaveOnResults: this.props.detectChangeToSaveOnResults
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "your-details-workspace",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: `flex flex-row flex-justify-end ${workspaceClasses}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            className: "button cta-button is-primary-outlined has-min-width-narrow program-reset-button",
                                                            onClick: this.revertChanges,
                                                            disabled: !this.props.changesMadeToResultsDetails || this.props.isSubmittingForm,
                                                            children: this.props.t("programRevertButtonText")
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                                            className: `button cta-button is-primary-filled has-dark-success-color ${savedChangesClass} has-min-width-narrow save-changes-button`,
                                                            onClick: this.saveChangesOnSubmit,
                                                            disabled: !this.props.changesMadeToResultsDetails || this.props.incompleteAssumptions,
                                                            children: saveButtonText
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)($7e4764e91f130780$exports, {}),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    className: "visible-breakdown",
                                                    children: visibleBreakDown
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "is-print-only all-breakdowns-for-print is-hidden-mobile",
                                                    children: [
                                                        meBreakdown,
                                                        weBreakdown,
                                                        amenityBreakdown
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    featureBanner,
                    this.props.userData.role === "cbreProfessional" ? /*#__PURE__*/ (0, $ayMG0.jsx)($ebe62590acf7fd03$exports, {}) : null,
                    /*#__PURE__*/ (0, $ayMG0.jsx)($1ef8cf45334718b5$exports, {})
                ]
            })
        });
    }
}
$ec30531dc383a3d7$var$Program.propTypes = {
    userData: $3e58c681e2cb99b8$exports.userDataForQuizShape.isRequired,
    program: $3e58c681e2cb99b8$exports.programShape.isRequired,
    incompleteAssumptions: $c9Z8w.bool.isRequired,
    lossFactor: $c9Z8w.number.isRequired,
    measurementSystem: $c9Z8w.string.isRequired,
    showEmailWall: $c9Z8w.bool.isRequired,
    updateProgram: $c9Z8w.func.isRequired,
    programId: $c9Z8w.string.isRequired,
    onTinker: $c9Z8w.func.isRequired,
    detectChangeToSaveOnResults: $c9Z8w.func.isRequired,
    changeToResultsSaved: $c9Z8w.func.isRequired,
    changesMadeToResultsDetails: $c9Z8w.bool.isRequired,
    fetchProgramIfNeeded: $c9Z8w.func.isRequired,
    isSubmittingForm: $c9Z8w.bool.isRequired,
    testFitFormCompleted: $c9Z8w.bool,
    t: $c9Z8w.func.isRequired
};
$ec30531dc383a3d7$var$Program.defaultProps = {
    testFitFormCompleted: false
};
$ec30531dc383a3d7$exports = $ec30531dc383a3d7$require$withTranslation("resultsPage")($ec30531dc383a3d7$var$Program);



// Map state to props
function $cdbd81a78e01d6bf$var$mapStateToProps(state) {
    return {
        userData: state.userData,
        program: state.spaceData.program,
        // this is used to disable the save button when there's no headcount and all areas are NaN
        incompleteAssumptions: !state.spaceData.assumptions.headcount,
        measurementSystem: state.spaceData.measurementSystem,
        lossFactor: state.spaceData.lossFactor,
        changesMadeToResultsDetails: state.changeDetected.changesMadeToResultsDetails,
        wasProgramSaved: state.requests.wasProgramSaved,
        programId: state.spaceData._id,
        isSubmittingForm: state.requests.isSubmittingForm,
        testFitFormCompleted: state.userData.testFitFormCompleted
    };
}
function $cdbd81a78e01d6bf$var$mapDispatchToProps(dispatch) {
    return {
        updateProgram: $cdbd81a78e01d6bf$require$bindActionCreators((0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).updateProgram, dispatch),
        fetchProgramIfNeeded: $cdbd81a78e01d6bf$require$bindActionCreators((0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).fetchProgramIfNeeded, dispatch),
        onTinker: $cdbd81a78e01d6bf$require$bindActionCreators((0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).removeProgramSavedStatus, dispatch),
        detectChangeToSaveOnResults: $cdbd81a78e01d6bf$require$bindActionCreators($6e7dbeaa5966242f$exports.detectChangeToSaveOnResults, dispatch),
        changeToResultsSaved: $cdbd81a78e01d6bf$require$bindActionCreators($6e7dbeaa5966242f$exports.changeToResultsSaved, dispatch)
    };
}
$cdbd81a78e01d6bf$exports = $cdbd81a78e01d6bf$require$connect($cdbd81a78e01d6bf$var$mapStateToProps, $cdbd81a78e01d6bf$var$mapDispatchToProps)($ec30531dc383a3d7$exports);




var $aB89e = parcelRequire("aB89e");
var $ed457df1934acfb0$require$constants = $aB89e.spacerFree;

var $ed457df1934acfb0$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;

var $8NdSf = parcelRequire("8NdSf");
var $ed457df1934acfb0$require$withRouter = $8NdSf.withRouter;
class $ed457df1934acfb0$var$Results extends $acw62.Component {
    constructor(props){
        super(props);
        // If we have an id, we need to fetch the completed program from the server
        if (props.params.id) props.fetchProgramIfNeeded(props.params.id);
        this.onUnload = this.onUnload.bind(this);
    }
    UNSAFE_componentWillMount() {
        window.addEventListener("beforeunload", this.onUnload);
    }
    componentWillUnmount() {
        window.removeEventListener("beforeunload", this.onUnload);
        this.props.onPageUnload();
    }
    onUnload(event = {}) {
        const WARNING_MESSAGE = this.props.t("resultsWarningMessage");
        if (this.props.showWarningOnPageUnload) {
            event.returnValue = WARNING_MESSAGE;
            return WARNING_MESSAGE;
        }
        return undefined;
    }
    render() {
        if (this.props.fetchProgramErrorStatus) return /*#__PURE__*/ (0, $ayMG0.jsx)($21746c83337631d6$exports, {
            errorCode: this.props.fetchProgramErrorStatus
        });
        const shouldRedirect = this.props.isProgramEmpty && !this.props.params.id;
        const readyForRender = !this.props.params.id || this.props.params.id && !this.props.isFetchingProgram && !this.props.isProgramEmpty;
        if (shouldRedirect) return /*#__PURE__*/ (0, $ayMG0.jsx)($ed457df1934acfb0$require$Navigate, {
            to: "/"
        });
        if (!readyForRender) return /*#__PURE__*/ (0, $ayMG0.jsx)($8HpaJ, {});
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "results",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($9f69955d1adfb55f$exports, {
                    siteLocation: $ed457df1934acfb0$require$constants.siteLocation.PAGE.RESULTS
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($50748c6090d80f89$exports, {
                    programId: this.props.params.id,
                    openModal: this.props.openModal
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)($e964d86ceb037aa8$exports, {
                            t: this.props.t
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)($cdbd81a78e01d6bf$exports, {
                            showEmailWall: !this.props.params.id
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($d1dcc206415ef960$exports, {})
            ]
        });
    }
}
$ed457df1934acfb0$var$Results.propTypes = {
    isProgramEmpty: $c9Z8w.bool.isRequired,
    fetchProgramIfNeeded: $c9Z8w.func.isRequired,
    params: $3EC2Q.routeMatchShape.isRequired,
    isFetchingProgram: $c9Z8w.bool.isRequired,
    showWarningOnPageUnload: $c9Z8w.bool.isRequired,
    onPageUnload: $c9Z8w.func.isRequired,
    fetchProgramErrorStatus: $c9Z8w.number,
    openModal: $c9Z8w.func.isRequired,
    t: $c9Z8w.func.isRequired
};
$ed457df1934acfb0$var$Results.defaultProps = {
    fetchProgramErrorStatus: null
};
$ed457df1934acfb0$exports = $ed457df1934acfb0$require$withTranslation("resultsPage")($ed457df1934acfb0$require$withRouter($ed457df1934acfb0$var$Results));



var $f1q41 = parcelRequire("f1q41");

// Map state to props
function $ca65c57dcef473df$var$mapStateToProps(state) {
    const fetchProgramErrorStatus = state.requests.fetchProgramError && state.requests.fetchProgramError.statusCode;
    return {
        fetchProgramErrorStatus: fetchProgramErrorStatus,
        isProgramEmpty: $f1q41.isEmpty(state.spaceData.program),
        isFetchingProgram: state.requests.isFetchingProgram,
        showWarningOnPageUnload: !fetchProgramErrorStatus && state.changeDetected.changesMadeToResultsDetails
    };
}
// Map dispatch to props
function $ca65c57dcef473df$var$mapDispatchToProps(dispatch) {
    return {
        fetchProgramIfNeeded: $ca65c57dcef473df$require$bindActionCreators((0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).fetchProgramIfNeeded, dispatch),
        onPageUnload: $ca65c57dcef473df$require$bindActionCreators((0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).removeProgramSavedStatus, dispatch),
        openModal: $ca65c57dcef473df$require$bindActionCreators($15a18ec2484069fc$exports.openModal, dispatch)
    };
}
$ca65c57dcef473df$exports = $ca65c57dcef473df$require$connect($ca65c57dcef473df$var$mapStateToProps, $ca65c57dcef473df$var$mapDispatchToProps)($ed457df1934acfb0$exports);


var $28df4a49204f4f9e$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");




var $aB89e = parcelRequire("aB89e");
var $28df4a49204f4f9e$require$constants = $aB89e.spacerFree;

var $28df4a49204f4f9e$require$Trans = $e04d9533328ca578$export$8d6a9236f2e3f2ce;

var $28df4a49204f4f9e$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $28df4a49204f4f9e$var$TermsOfService(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($9f69955d1adfb55f$exports, {
                siteLocation: $28df4a49204f4f9e$require$constants.siteLocation.PAGE.TERMS
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($4e7513a104520779$exports, {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
                className: "has-navbar-fixed-top container terms-of-service",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        className: "title is-3 has-text-centered has-text-primary has-padding-top-4 is-sans-semibold",
                        children: props.t("TermsTitle")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: props.t("TermsIntroText")
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                        className: "main-list",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                children: [
                                    props.t("TermsLimitationsTitle"),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "a",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: props.t("TermsLimitationsA")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: props.t("TermsLimitationsB")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: props.t("TermsLimitationsC")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: props.t("TermsLimitationsD")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: props.t("TermsLimitationsE")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: props.t("TermsLimitationsF")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                children: [
                                    props.t("TermsOwnershipTitle"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        children: props.t("TermsOwnershipText")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                children: [
                                    props.t("TermsTerminationTitle"),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "a",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: props.t("TermsTerminationA")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: props.t("TermsTerminationB")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                children: [
                                    props.t("TermsDisclaimerTitle"),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "a",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: props.t("TermsDisclaimerA")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: props.t("TermsDisclaimerB")
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: props.t("TermsDisclaimerC")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                children: [
                                    props.t("TermsIndemnificationTitle"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        children: props.t("TermsIndemnificationText")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                children: [
                                    props.t("TermsGeneralTitle"),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("ol", {
                                        type: "a",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($28df4a49204f4f9e$require$Trans, {
                                                    i18nKey: "termsOfServicePage:TermsGeneralA",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("u", {
                                                            children: "0"
                                                        }),
                                                        "1"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($28df4a49204f4f9e$require$Trans, {
                                                    i18nKey: "termsOfServicePage:TermsGeneralB",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("u", {
                                                            children: "0"
                                                        }),
                                                        "1"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($28df4a49204f4f9e$require$Trans, {
                                                    i18nKey: "termsOfServicePage:TermsGeneralC",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("u", {
                                                            children: "0"
                                                        }),
                                                        "1"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($28df4a49204f4f9e$require$Trans, {
                                                    i18nKey: "termsOfServicePage:TermsGeneralD",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("u", {
                                                            children: "0"
                                                        }),
                                                        "1"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($28df4a49204f4f9e$require$Trans, {
                                                    i18nKey: "termsOfServicePage:TermsGeneralE",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("u", {
                                                            children: "0"
                                                        }),
                                                        "1"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($28df4a49204f4f9e$require$Trans, {
                                                    i18nKey: "termsOfServicePage:TermsGeneralF",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("u", {
                                                            children: "0"
                                                        }),
                                                        "1"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($28df4a49204f4f9e$require$Trans, {
                                                    i18nKey: "termsOfServicePage:TermsGeneralG",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("u", {
                                                            children: "0"
                                                        }),
                                                        "1"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($28df4a49204f4f9e$require$Trans, {
                                                    i18nKey: "termsOfServicePage:TermsGeneralH",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("u", {
                                                            children: "0"
                                                        }),
                                                        "1"
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($d1dcc206415ef960$exports, {})
        ]
    });
}
$28df4a49204f4f9e$var$TermsOfService.propTypes = {
    t: $c9Z8w.func.isRequired
};
$28df4a49204f4f9e$exports = $28df4a49204f4f9e$require$withTranslation("termsOfServicePage")($28df4a49204f4f9e$var$TermsOfService);



var $caab8d94beec0337$exports = {};


var $jHTLJ = parcelRequire("jHTLJ");
var $caab8d94beec0337$require$connect = $jHTLJ.connect;

var $eShmq = parcelRequire("eShmq");
var $caab8d94beec0337$require$bindActionCreators = $eShmq.bindActionCreators;


var $4f4a2df4af4d256c$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $aphAM = parcelRequire("aphAM");
var $4f4a2df4af4d256c$require$Navigate = $aphAM.Navigate;

var $aB89e = parcelRequire("aB89e");
var $4f4a2df4af4d256c$require$constants = $aB89e.spacerFree;

var $1db39420f38d6585$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $fPryk = parcelRequire("fPryk");
var $1db39420f38d6585$require$profileMap = $fPryk.profileMap;


var $1db39420f38d6585$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $1db39420f38d6585$var$ProfileComparisonColumn(props) {
    const profile = $1db39420f38d6585$require$profileMap[props.profileId];
    const profileType = props.profileType;
    const profileDescriptionFirstParagraph = props.t(profile.descriptionToken).split("\n")[0]; // only show first paragraph, user will see full description if they choose the profile
    let columnClasses = "profile-column no-outline";
    if (props.isSelected) columnClasses += " is-active";
    let buttonText = props.isSelected ? props.t("profileCompColumnSelectedText") : props.t("profileCompColumnSelectText");
    if (props.isRecommended) buttonText += props.t("profileCompColumnRecommendedText");
    const buttonClasses = `button no-focus-style has-margin-bottom-6 ${props.isSelected ? "is-tertiary-filled" : "is-tertiary-outlined has-tertiary-text is-filled-on-hover"}`;
    const profileName = props.t(profile.displayNameToken);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: columnClasses,
        role: "button",
        tabIndex: "0",
        onClick: props.onClick,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                className: buttonClasses,
                children: buttonText
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "profile-summary-and-traits",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "profile-summary",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                src: $1db39420f38d6585$require$profileMap[props.profileId].profileHeroImage,
                                alt: props.t("profileCompColumnImgAltText", {
                                    profileName: profileName
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "title is-5 has-padding-top-7 has-margin-bottom-7",
                                children: profileName
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "profile-description",
                                children: profileDescriptionFirstParagraph
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "profile-traits",
                        children: profile.keyTraitIds.map((traitId)=>/*#__PURE__*/ (0, $ayMG0.jsx)($73dd7f9ee93a0372$exports, {
                                traitId: traitId,
                                profileType: profileType,
                                isDark: true
                            }, traitId))
                    })
                ]
            })
        ]
    }, `profile-${props.profileId}`);
}
$1db39420f38d6585$var$ProfileComparisonColumn.propTypes = {
    profileType: $c9Z8w.string.isRequired,
    profileId: $c9Z8w.string.isRequired,
    isSelected: $c9Z8w.bool.isRequired,
    isRecommended: $c9Z8w.bool.isRequired,
    onClick: $c9Z8w.func.isRequired,
    t: $c9Z8w.func.isRequired
};
$1db39420f38d6585$exports = $1db39420f38d6585$require$withTranslation("resultsPage")($1db39420f38d6585$var$ProfileComparisonColumn);




var $4f4a2df4af4d256c$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;


var $8NdSf = parcelRequire("8NdSf");
var $4f4a2df4af4d256c$require$withRouter = $8NdSf.withRouter;
class $4f4a2df4af4d256c$var$ProfileComparison extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            selectedProfileId: props.currentProfileId
        };
        this.selectProfileAndReturnToResults = this.selectProfileAndReturnToResults.bind(this);
    }
    selectProfileAndReturnToResults() {
        if (this.state.selectedProfileId === this.props.currentProfileId) return this.props.history(-1);
        return this.props.openModal($4f4a2df4af4d256c$require$constants.modal.TYPES.CONFIRMATION, {
            title: this.props.t("profileCompModalTitle"),
            text: this.props.t("profileCompModalText"),
            confirm: {
                text: this.props.t("profileCompModalConfirmText"),
                onClick: ()=>{
                    this.props.setProfileAndCalculateProgram(this.state.selectedProfileId);
                    this.props.updateProgram(this.props.programId).then(()=>{
                        this.props.closeModal();
                        return this.props.history(`/program-your-results-spacer-by-cbre/${this.props.programId}`);
                    });
                }
            },
            cancel: {
                text: this.props.t("profileCompModalCancelText"),
                onClick: ()=>{
                    this.props.closeModal();
                    return this.props.history(-1);
                }
            }
        });
    }
    render() {
        if (!this.props.currentProfileId) return /*#__PURE__*/ (0, $ayMG0.jsx)($4f4a2df4af4d256c$require$Navigate, {
            push: true,
            to: "/"
        });
        // this.props.profileIds is in ranked order, swap the first and second ids
        // so the recommended profile gets displayed as the center column on the page
        const profileIds = [
            this.props.profileIds[1],
            this.props.profileIds[0],
            this.props.profileIds[2]
        ];
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "profile-comparison container has-navbar-fixed-top",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($9f69955d1adfb55f$exports, {
                    siteLocation: $4f4a2df4af4d256c$require$constants.siteLocation.PAGE.PROFILE_COMPARISON
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)($4c6935c3f206399d$exports, {
                    navItems: /*#__PURE__*/ (0, $ayMG0.jsxs)($acw62.Fragment, {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                tabIndex: "0",
                                role: "button",
                                className: "navbar-item no-outline",
                                onClick: ()=>{
                                    this.props.history(-1);
                                },
                                children: this.props.t("profileCompNavbarCancelButtonText")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "navbar-item",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                    className: "button is-primary",
                                    onClick: this.selectProfileAndReturnToResults,
                                    children: this.props.t("profileCompNavbarUseButtonText")
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("main", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            className: "title is-5 has-text-centered has-padding-top-4 has-padding-bottom-6",
                            children: this.props.t("profileCompCompareTitle")
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "columns",
                            children: profileIds.map((profileId)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "column",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)($1db39420f38d6585$exports, {
                                        profileType: this.props.profileType,
                                        profileId: profileId,
                                        isRecommended: profileId === this.props.profileIds[0],
                                        isSelected: profileId === this.state.selectedProfileId,
                                        onClick: ()=>this.setState({
                                                selectedProfileId: profileId
                                            })
                                    })
                                }, `profile-${profileId}`))
                        })
                    ]
                })
            ]
        });
    }
}
$4f4a2df4af4d256c$var$ProfileComparison.propTypes = {
    location: $c9Z8w.shape({
        programId: $c9Z8w.string.isRequired
    }).isRequired,
    programId: $c9Z8w.string,
    profileType: $c9Z8w.string.isRequired,
    currentProfileId: $c9Z8w.string.isRequired,
    profileIds: $c9Z8w.arrayOf($c9Z8w.string).isRequired,
    openModal: $c9Z8w.func.isRequired,
    closeModal: $c9Z8w.func.isRequired,
    setProfileAndCalculateProgram: $c9Z8w.func.isRequired,
    updateProgram: $c9Z8w.func.isRequired,
    t: $c9Z8w.func.isRequired
};
$4f4a2df4af4d256c$exports = $4f4a2df4af4d256c$require$withTranslation("resultsPage")($4f4a2df4af4d256c$require$withRouter($4f4a2df4af4d256c$var$ProfileComparison));


// Map state to props
function $caab8d94beec0337$var$mapStateToProps(state) {
    const profileScores = state.profileQuiz.profileScores;
    const sortedProfileIds = Object.keys(profileScores).sort((a, b)=>profileScores[b] - profileScores[a]);
    const programId = state.spaceData._id;
    return {
        profileType: state.spaceData.profileType,
        currentProfileId: state.spaceData.profileId,
        profileIds: sortedProfileIds.slice(0, 3),
        programId: programId
    };
}
// Map dispatch to props
function $caab8d94beec0337$var$mapDispatchToProps(dispatch) {
    return {
        openModal: $caab8d94beec0337$require$bindActionCreators($15a18ec2484069fc$exports.openModal, dispatch),
        closeModal: $caab8d94beec0337$require$bindActionCreators($15a18ec2484069fc$exports.closeModal, dispatch),
        setProfileAndCalculateProgram: $caab8d94beec0337$require$bindActionCreators($7f3ddf5ab2cb44f3$exports.setProfileAndCalculateProgram, dispatch),
        updateProgram: $caab8d94beec0337$require$bindActionCreators((0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).updateProgram, dispatch)
    };
}
$caab8d94beec0337$exports = $caab8d94beec0337$require$connect($caab8d94beec0337$var$mapStateToProps, $caab8d94beec0337$var$mapDispatchToProps)($4f4a2df4af4d256c$exports);


var $9309648189f0695f$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $aphAM = parcelRequire("aphAM");
var $9309648189f0695f$require$Route = $aphAM.Route;
var $9309648189f0695f$require$Navigate = $aphAM.Navigate;
function $9309648189f0695f$var$createRedirectComponent(path) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9309648189f0695f$require$Route, {
        path: path.from,
        element: /*#__PURE__*/ (0, $ayMG0.jsx)($9309648189f0695f$require$Navigate, {
            replace: true,
            to: path.to
        })
    }, path.to);
}
function $9309648189f0695f$var$createRedirectComponents(paths) {
    return paths.map($9309648189f0695f$var$createRedirectComponent);
}
$9309648189f0695f$exports = {
    createRedirectComponents: $9309648189f0695f$var$createRedirectComponents
};



var $fPryk = parcelRequire("fPryk");
var $0c5169fa3c108ac2$require$redirectPaths = $fPryk.redirectPaths;
const $0c5169fa3c108ac2$var$router = $0c5169fa3c108ac2$require$createBrowserRouter($0c5169fa3c108ac2$require$createRoutesFromElements(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
    children: [
        $9309648189f0695f$exports.createRedirectComponents($0c5169fa3c108ac2$require$redirectPaths.spacerFreeRedirectPaths),
        /*#__PURE__*/ (0, $ayMG0.jsx)($0c5169fa3c108ac2$require$Route, {
            exact: true,
            path: "/",
            element: /*#__PURE__*/ (0, $ayMG0.jsx)($2f32009932987788$exports, {})
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)($0c5169fa3c108ac2$require$Route, {
            exact: true,
            path: "/quiz-spacer-by-cbre",
            element: /*#__PURE__*/ (0, $ayMG0.jsx)($7b6d62e85954a6f0$exports, {})
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)($0c5169fa3c108ac2$require$Route, {
            exact: true,
            path: "/program-your-results-spacer-by-cbre",
            element: /*#__PURE__*/ (0, $ayMG0.jsx)($ca65c57dcef473df$exports, {})
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)($0c5169fa3c108ac2$require$Route, {
            exact: true,
            path: "/results/:id",
            element: /*#__PURE__*/ (0, $ayMG0.jsx)($ca65c57dcef473df$exports, {})
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)($0c5169fa3c108ac2$require$Route, {
            exact: true,
            path: "/program-your-results-spacer-by-cbre/:id",
            element: /*#__PURE__*/ (0, $ayMG0.jsx)($ca65c57dcef473df$exports, {})
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)($0c5169fa3c108ac2$require$Route, {
            exact: true,
            path: "/insights-spacer-by-cbre",
            element: /*#__PURE__*/ (0, $ayMG0.jsx)($1c992f1332d56f69$exports, {})
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)($0c5169fa3c108ac2$require$Route, {
            exact: true,
            path: "/insights-spacer-by-cbre/:slug",
            element: /*#__PURE__*/ (0, $ayMG0.jsx)($1ed9e1c56db6f4e4$exports, {})
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)($0c5169fa3c108ac2$require$Route, {
            exact: true,
            path: "/referral",
            element: /*#__PURE__*/ (0, $ayMG0.jsx)($8d0110f273c17f86$exports, {})
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)($0c5169fa3c108ac2$require$Route, {
            exact: true,
            path: "/referral/retrieve",
            element: /*#__PURE__*/ (0, $ayMG0.jsx)($f2c5509ab89aa1b3$exports, {})
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)($0c5169fa3c108ac2$require$Route, {
            exact: true,
            path: "/referral/:sourceId",
            element: /*#__PURE__*/ (0, $ayMG0.jsx)($2f32009932987788$exports, {})
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)($0c5169fa3c108ac2$require$Route, {
            exact: true,
            path: "/about-spacer-by-cbre",
            element: /*#__PURE__*/ (0, $ayMG0.jsx)($be6158963e52745f$exports, {})
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)($0c5169fa3c108ac2$require$Route, {
            exact: true,
            path: "/profile-comparison-spacer-by-cbre",
            element: /*#__PURE__*/ (0, $ayMG0.jsx)($caab8d94beec0337$exports, {})
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)($0c5169fa3c108ac2$require$Route, {
            exact: true,
            path: "/terms-spacer-by-cbre",
            element: /*#__PURE__*/ (0, $ayMG0.jsx)($28df4a49204f4f9e$exports, {})
        }),
        /*#__PURE__*/ (0, $ayMG0.jsx)($0c5169fa3c108ac2$require$Route, {
            render: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)($21746c83337631d6$exports, {
                    errorCode: 404
                })
        })
    ]
})));
$0c5169fa3c108ac2$exports = $0c5169fa3c108ac2$var$router;


// Action Types
const $a2062a5a6ecff0e2$var$REQUEST_PROGRAM = "REQUEST_PROGRAM";
const $a2062a5a6ecff0e2$var$RECEIVE_PROGRAM = "RECEIVE_PROGRAM";
const $a2062a5a6ecff0e2$var$REQUEST_PROGRAM_ERROR = "REQUEST_PROGRAM_ERROR";
const $a2062a5a6ecff0e2$var$SUBMIT_FORM = "SUBMIT_FORM";
const $a2062a5a6ecff0e2$var$SUBMIT_FORM_SUCCESS = "SUBMIT_FORM_SUCCESS";
const $a2062a5a6ecff0e2$var$SUBMIT_FORM_ERROR = "SUBMIT_FORM_ERROR";
const $a2062a5a6ecff0e2$var$RESET_SUBMIT_FORM_PROPERTIES = "RESET_SUBMIT_FORM_PROPERTIES";
const $a2062a5a6ecff0e2$var$REMOVE_PROGRAM_SAVED_STATUS = "REMOVE_PROGRAM_SAVED_STATUS";
const $a2062a5a6ecff0e2$var$SEND_HEAP_EVENT = "SEND_HEAP_EVENT";
const $a2062a5a6ecff0e2$var$SEND_HEAP_EVENT_WITHOUT_PROPS = "SEND_HEAP_EVENT_WITHOUT_PROPS";
const $a2062a5a6ecff0e2$var$CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
const $a2062a5a6ecff0e2$var$FORM_TO_URL_MAP = {
    SAVE: "/spacePrograms",
    CONTACT: "/contact"
};
// Private Action Helpers
function $a2062a5a6ecff0e2$var$requestProgram() {
    return {
        type: $a2062a5a6ecff0e2$var$REQUEST_PROGRAM
    };
}
function $a2062a5a6ecff0e2$var$receiveProgram(json) {
    return {
        type: $a2062a5a6ecff0e2$var$RECEIVE_PROGRAM,
        program: json
    };
}
function $a2062a5a6ecff0e2$var$requestProgramError(error) {
    return {
        type: $a2062a5a6ecff0e2$var$REQUEST_PROGRAM_ERROR,
        error: error
    };
}
function $a2062a5a6ecff0e2$var$fetchProgram(id) {
    return (dispatch)=>{
        dispatch($a2062a5a6ecff0e2$var$requestProgram());
        return fetch(`/spacePrograms/${id}`).then((response)=>$7PjUE.parseJSONResponse(response)).then((json)=>{
            const profileType = $e3ec1f29f8e2ec07$exports.calculateProfileType(json.userData.officeLocation, json.spaceData.assumptions.headcount, json.profileQuiz.userQuizAnswers);
            json.spaceData.profileType = profileType;
            json.spaceData._id = json._id;
            $dd1d3e43b4086c4d$exports.initSharedProgramCalculator(json.spaceData.program, json.spaceData.assumptions.headcount, json.userData.officeLocation, json.spaceData.assumptions.officeDensity);
            let areaTotals = json.spaceData.program.areaTotals;
            let obj = {
                meSF: areaTotals.totalCustomMeSF ? areaTotals.totalCustomMeSF : areaTotals.totalMeSF,
                weSF: areaTotals.totalCustomWeSF ? areaTotals.totalCustomWeSF : areaTotals.totalWeSF,
                amenitySF: areaTotals.totalCustomAmenitySF ? areaTotals.totalCustomAmenitySF : areaTotals.totalAmenitySF
            };
            json.spaceData.program.areaPercentage = $dd1d3e43b4086c4d$exports.roundPercentageTotals([
                obj.meSF,
                obj.weSF,
                obj.amenitySF
            ]);
            dispatch($a2062a5a6ecff0e2$var$receiveProgram(json));
        }, (error)=>dispatch($a2062a5a6ecff0e2$var$requestProgramError(error)));
    };
}
function $a2062a5a6ecff0e2$var$shouldFetchProgram(state) {
    return !state.requests.isFetchingProgram && ($f1q41.isEmpty(state.spaceData.program) || state.changeDetected.changesMadeToResultsDetails);
}
function $a2062a5a6ecff0e2$var$initiateSubmitForm() {
    return {
        type: $a2062a5a6ecff0e2$var$SUBMIT_FORM
    };
}
function $a2062a5a6ecff0e2$var$submitFormSuccess(isSaveForm) {
    return {
        type: $a2062a5a6ecff0e2$var$SUBMIT_FORM_SUCCESS,
        isSaveForm: isSaveForm
    };
}
function $a2062a5a6ecff0e2$var$submitFormError(error) {
    return {
        type: $a2062a5a6ecff0e2$var$SUBMIT_FORM_ERROR,
        error: error
    };
}
function $a2062a5a6ecff0e2$var$resetSubmitFormProperties() {
    return {
        type: $a2062a5a6ecff0e2$var$RESET_SUBMIT_FORM_PROPERTIES
    };
}
function $a2062a5a6ecff0e2$var$sendHeapEvent(eventName) {
    return {
        type: $a2062a5a6ecff0e2$var$SEND_HEAP_EVENT,
        eventName: eventName
    };
}
function $a2062a5a6ecff0e2$var$sendHeapEventWithoutProps(eventName) {
    return {
        type: $a2062a5a6ecff0e2$var$SEND_HEAP_EVENT_WITHOUT_PROPS,
        eventName: eventName
    };
}
function $a2062a5a6ecff0e2$var$changeSLanguage(val) {
    return {
        type: $a2062a5a6ecff0e2$var$CHANGE_LANGUAGE,
        value: val
    };
}
function $a2062a5a6ecff0e2$var$postRequestFromFormAndStore(url, userFormData, heapEventName) {
    return (dispatch, getState)=>{
        const state = getState();
        if (state.requests.isSubmittingForm) return Promise.resolve();
        dispatch($a2062a5a6ecff0e2$var$initiateSubmitForm());
        if (heapEventName) dispatch($a2062a5a6ecff0e2$var$sendHeapEvent(heapEventName));
        const dataToPost = $f1q41.cloneDeep({
            spaceData: state.spaceData,
            userData: state.userData,
            profileQuiz: state.profileQuiz
        });
        $f1q41.assign(dataToPost.userData, userFormData); // add user data that was input in the corresponding form (name, email, phone, etc.)
        return fetch(url, {
            method: "POST",
            body: JSON.stringify(dataToPost),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        }).then((response)=>$7PjUE.parseJSONResponse(response)).then((parsedJson)=>{
            const isSaveForm = url.match($a2062a5a6ecff0e2$var$FORM_TO_URL_MAP.SAVE) !== null;
            if (isSaveForm && parsedJson._id) {
                // if this was an initial save, not an update to an exisiting program, redirect
                if (url.indexOf(parsedJson._id) === -1) $0c5169fa3c108ac2$exports.navigate(`/program-your-results-spacer-by-cbre/${parsedJson._id}`);
                dispatch($7f3ddf5ab2cb44f3$exports.setProgramId(parsedJson._id));
            }
            dispatch($a2062a5a6ecff0e2$var$submitFormSuccess(isSaveForm));
            setTimeout(()=>{
                dispatch($a2062a5a6ecff0e2$var$resetSubmitFormProperties());
            }, 3000);
        }, (error)=>dispatch($a2062a5a6ecff0e2$var$submitFormError(error)));
    };
}
var $a2062a5a6ecff0e2$export$2e2bcd8739ae039 = {
    REQUEST_PROGRAM: // Action Types
    $a2062a5a6ecff0e2$var$REQUEST_PROGRAM,
    RECEIVE_PROGRAM: $a2062a5a6ecff0e2$var$RECEIVE_PROGRAM,
    REQUEST_PROGRAM_ERROR: $a2062a5a6ecff0e2$var$REQUEST_PROGRAM_ERROR,
    SUBMIT_FORM: $a2062a5a6ecff0e2$var$SUBMIT_FORM,
    SUBMIT_FORM_SUCCESS: $a2062a5a6ecff0e2$var$SUBMIT_FORM_SUCCESS,
    SUBMIT_FORM_ERROR: $a2062a5a6ecff0e2$var$SUBMIT_FORM_ERROR,
    RESET_SUBMIT_FORM_PROPERTIES: $a2062a5a6ecff0e2$var$RESET_SUBMIT_FORM_PROPERTIES,
    REMOVE_PROGRAM_SAVED_STATUS: $a2062a5a6ecff0e2$var$REMOVE_PROGRAM_SAVED_STATUS,
    SEND_HEAP_EVENT: $a2062a5a6ecff0e2$var$SEND_HEAP_EVENT,
    SEND_HEAP_EVENT_WITHOUT_PROPS: $a2062a5a6ecff0e2$var$SEND_HEAP_EVENT_WITHOUT_PROPS,
    CHANGE_LANGUAGE: $a2062a5a6ecff0e2$var$CHANGE_LANGUAGE,
    // Action Creators
    fetchProgramIfNeeded (id) {
        return (dispatch, getState)=>{
            if ($a2062a5a6ecff0e2$var$shouldFetchProgram(getState())) return dispatch($a2062a5a6ecff0e2$var$fetchProgram(id));
            return Promise.resolve();
        };
    },
    saveProgram (userFormData) {
        return $a2062a5a6ecff0e2$var$postRequestFromFormAndStore($a2062a5a6ecff0e2$var$FORM_TO_URL_MAP.SAVE, userFormData, "Save Program");
    },
    updateProgram (id) {
        const url = `${$a2062a5a6ecff0e2$var$FORM_TO_URL_MAP.SAVE}/${id}`;
        return $a2062a5a6ecff0e2$var$postRequestFromFormAndStore(url);
    },
    contactSupport (userFormData) {
        $3GYAO.GAEvent($3a61343632c866bc$exports.categories.result, $3a61343632c866bc$exports.actions.connectAdvisorFormSubmit, $3a61343632c866bc$exports.labels.connectAdvisorFormSubmit);
        return $a2062a5a6ecff0e2$var$postRequestFromFormAndStore($a2062a5a6ecff0e2$var$FORM_TO_URL_MAP.CONTACT, $f1q41.assign({
            programLink: window.location.href
        }, userFormData));
    },
    resetSubmitFormProperties: $a2062a5a6ecff0e2$var$resetSubmitFormProperties,
    removeProgramSavedStatus () {
        return {
            type: $a2062a5a6ecff0e2$var$REMOVE_PROGRAM_SAVED_STATUS
        };
    },
    sendHeapEvent: $a2062a5a6ecff0e2$var$sendHeapEvent,
    sendHeapEventWithoutProps: $a2062a5a6ecff0e2$var$sendHeapEventWithoutProps,
    changeSLanguage: $a2062a5a6ecff0e2$var$changeSLanguage
};



var $eShmq = parcelRequire("eShmq");
var $a5750ebba6802e03$require$combineReducers = $eShmq.combineReducers;
var $65b08a30dc81acba$exports = {};




var $f1q41 = parcelRequire("f1q41");
$65b08a30dc81acba$exports = function profileQuiz(state = {}, action) {
    let userQuizAnswers;
    switch(action.type){
        case $91d5e1f7c4d12efe$exports.ANSWER_PROFILE_QUESTION:
            userQuizAnswers = $f1q41.assign({}, state.userQuizAnswers, {
                [action.questionUnitId]: action.selectedOption
            });
            return $f1q41.assign({}, state, {
                userQuizAnswers: userQuizAnswers
            });
        case $91d5e1f7c4d12efe$exports.CALCULATE_PROFILE_SCORES:
            return $f1q41.assign({}, state, {
                profileScores: $e3ec1f29f8e2ec07$exports.calculateProfileScores(state.userQuizAnswers)
            });
        case (0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).RECEIVE_PROGRAM:
            return action.program.profileQuiz;
        default:
            return state;
    }
};


var $1796c0a763c37764$exports = {};




var $aB89e = parcelRequire("aB89e");
var $1796c0a763c37764$require$constants = $aB89e.spacerFree;

var $5sKyw = parcelRequire("5sKyw");
var $1796c0a763c37764$require$uuidv4 = $5sKyw.default;


var $85x8Z = parcelRequire("85x8Z");

var $hjiT0 = parcelRequire("hjiT0");

var $f1q41 = parcelRequire("f1q41");
$1796c0a763c37764$exports = function spaceData(state = {}, action) {
    let assumptions;
    let stateCopy;
    let customAmenity;
    switch(action.type){
        case $7f3ddf5ab2cb44f3$exports.ADD_KEY_ASSUMPTION:
            assumptions = $f1q41.assign({}, state.assumptions, {
                [action.assumptionType]: action.value
            });
            return $f1q41.assign({}, state, {
                assumptions: assumptions
            });
        case $3d5a8542f4e060ff$exports.ADD_USER_DATA:
            if (action.dataType === "officeLocation") return $f1q41.assign({}, state, {
                measurementSystem: $hjiT0.getMeasurementSystemForLocation(action.value),
                lossFactor: $85x8Z.getDefaultLossFactor(action.value),
                sfType: $hjiT0.getSFTypeForLocation(action.value)
            });
            return state;
        case $7f3ddf5ab2cb44f3$exports.UPDATE_MEASUREMENT_SYSTEM:
            return $f1q41.assign({}, state, {
                measurementSystem: action.measurementSystem
            });
        case $7f3ddf5ab2cb44f3$exports.UPDATE_SF_TYPE:
            return $f1q41.assign({}, state, {
                sfType: action.sfType
            });
        case $7f3ddf5ab2cb44f3$exports.UPDATE_LOSS_FACTOR:
            {
                let lossFactor = action.lossFactor;
                if (action.lossFactor > $1796c0a763c37764$require$constants.calculator.MAX_LOSS_FACTOR / 100) lossFactor = $1796c0a763c37764$require$constants.calculator.MAX_LOSS_FACTOR / 100;
                else if (!lossFactor || lossFactor < 0) lossFactor = 0;
                return $f1q41.assign({}, state, {
                    lossFactor: lossFactor
                });
            }
        case $7f3ddf5ab2cb44f3$exports.UPDATE_SPACE_UNIT_QUANTITY:
            stateCopy = $f1q41.cloneDeep(state);
            $dd1d3e43b4086c4d$exports.updateProgramForMeWeOrSupportCustomQuantity(stateCopy, action.spaceUnitId, action.value, action.officeLocation);
            return stateCopy;
        case $7f3ddf5ab2cb44f3$exports.UPDATE_SPACE_UNIT_AMENITY_SF:
            stateCopy = $f1q41.cloneDeep(state);
            $dd1d3e43b4086c4d$exports.updateProgramForAmenityCustomSF(stateCopy, action.spaceUnitId, action.value);
            return stateCopy;
        case $7f3ddf5ab2cb44f3$exports.ADD_CUSTOM_AMENITY:
            {
                stateCopy = $f1q41.cloneDeep(state);
                const id = `${action.displayName.toLowerCase()}_${$1796c0a763c37764$require$uuidv4()}`; // create random id for custom amenities
                // use 'customXXX' properties since all custom amentities are deltas off the normal program
                customAmenity = {
                    id: id,
                    dataKey: action.dataKey,
                    displayName: action.displayName,
                    usf: 0,
                    nsf: 0,
                    quantity: 0,
                    customUSF: 0,
                    customNSF: 0,
                    customSF: action.customSF,
                    customQuantity: action.customQuantity
                };
                $dd1d3e43b4086c4d$exports.addCustomAmenity(stateCopy, customAmenity);
                return stateCopy;
            }
        case $7f3ddf5ab2cb44f3$exports.UPDATE_CUSTOM_AMENITY_QUANTITY:
            stateCopy = $f1q41.cloneDeep(state);
            $dd1d3e43b4086c4d$exports.updateProgramForCustomAmenity(stateCopy, action.id, {
                customQuantity: action.quantity
            });
            return stateCopy;
        case $7f3ddf5ab2cb44f3$exports.UPDATE_CUSTOM_AMENITY_SF:
            stateCopy = $f1q41.cloneDeep(state);
            $dd1d3e43b4086c4d$exports.updateProgramForCustomAmenity(stateCopy, action.id, {
                customSF: action.customSF
            });
            return stateCopy;
        case $7f3ddf5ab2cb44f3$exports.DELETE_SPACE_UNIT:
            stateCopy = $f1q41.cloneDeep(state);
            $dd1d3e43b4086c4d$exports.removeProgramPart(stateCopy, action.id);
            return stateCopy;
        case (0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).RECEIVE_PROGRAM:
            return action.program.spaceData;
        case $7f3ddf5ab2cb44f3$exports.SET_PROGRAM_ID:
            return $f1q41.assign({}, state, {
                _id: action.id
            });
        default:
            return state;
    }
};


var $df91c04927a122df$exports = {};



var $f1q41 = parcelRequire("f1q41");
$df91c04927a122df$exports = function userData(state = {}, action) {
    switch(action.type){
        case $3d5a8542f4e060ff$exports.ADD_USER_DATA:
            if (action.dataType === "officeLocation" && action.isUpdatingCurrentPersonalLocation) return $f1q41.assign({}, state, {
                officeLocation: action.value,
                currentPersonalLocation: action.value
            });
            return $f1q41.assign({}, state, {
                [action.dataType]: action.value
            });
        case $3d5a8542f4e060ff$exports.ADD_USER_DATA_BULK:
            return $f1q41.assign({}, state, action.dataTypeValueCollection);
        case (0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).CHANGE_LANGUAGE:
            return $f1q41.assign({}, state, {
                language: action.value
            });
        case $3d5a8542f4e060ff$exports.COMPLETE_TEST_FIT_FORM:
            return $f1q41.assign({}, state, {
                testFitFormCompleted: true
            });
        case (0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).RECEIVE_PROGRAM:
            return action.program.userData;
        default:
            return state;
    }
};


var $40457d2e2142b51d$exports = {};
// const globalActions = require('../actions/global');


var $f1q41 = parcelRequire("f1q41");
$40457d2e2142b51d$exports = function requests(state = {}, action) {
    switch(action.type){
        case (0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).REQUEST_PROGRAM:
            return $f1q41.assign({}, state, {
                fetchProgramError: null,
                isFetchingProgram: true
            });
        case (0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).RECEIVE_PROGRAM:
            return $f1q41.assign({}, state, {
                fetchProgramError: null,
                isFetchingProgram: false
            });
        case (0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).REQUEST_PROGRAM_ERROR:
            console.log(action.error);
            return $f1q41.assign({}, state, {
                fetchProgramError: action.error,
                isFetchingProgram: false
            });
        case (0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).SUBMIT_FORM:
            return $f1q41.assign({}, state, {
                isSubmittingForm: true,
                submitFormSuccess: false,
                submitFormError: null
            });
        case (0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).SUBMIT_FORM_SUCCESS:
            return $f1q41.assign({}, state, {
                isSubmittingForm: false,
                submitFormSuccess: true,
                submitFormError: null,
                wasProgramSaved: action.isSaveForm || state.wasProgramSaved
            });
        case (0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).SUBMIT_FORM_ERROR:
            console.log(action.error);
            return $f1q41.assign({}, state, {
                isSubmittingForm: false,
                submitFormSuccess: false,
                submitFormError: action.error
            });
        case (0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).RESET_SUBMIT_FORM_PROPERTIES:
            return $f1q41.assign({}, state, {
                isSubmittingForm: false,
                submitFormSuccess: false,
                submitFormError: null
            });
        case (0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).REMOVE_PROGRAM_SAVED_STATUS:
            return $f1q41.assign({}, state, {
                wasProgramSaved: false
            });
        default:
            return state;
    }
};


var $8b51bff02f044485$exports = {};


var $aB89e = parcelRequire("aB89e");
var $8b51bff02f044485$require$constants = $aB89e.spacerFree;
$8b51bff02f044485$exports = function modals(state = {}, action) {
    switch(action.type){
        case $15a18ec2484069fc$exports.OPEN_MODAL:
            return {
                modalType: action.modalType,
                modalProps: action.modalProps
            };
        case $15a18ec2484069fc$exports.CLOSE_MODAL:
            return {
                modalType: $8b51bff02f044485$require$constants.modal.TYPES.NONE,
                modalProps: null
            };
        default:
            return state;
    }
};


var $ef68c3c40a6d65a2$exports = {};


var $f1q41 = parcelRequire("f1q41");
$ef68c3c40a6d65a2$exports = function changesMadeToResultsDetails(state = {}, action) {
    switch(action.type){
        case $6e7dbeaa5966242f$exports.DETECT_CHANGE_ON_RESULTS:
            return $f1q41.assign({}, state, {
                changesMadeToResultsDetails: true
            });
        case $6e7dbeaa5966242f$exports.CHANGE_TO_RESULTS_SAVED:
            return $f1q41.assign({}, state, {
                changesMadeToResultsDetails: false
            });
        default:
            return state;
    }
};


var $9e48680f5af0d7d5$exports = {};
/* global heap */ 
var $f1q41 = parcelRequire("f1q41");

var $9e48680f5af0d7d5$require$constants = (parcelRequire("aB89e")).spacerFree;

const $9e48680f5af0d7d5$var$SPACE_UNIT_CATEGORY = (parcelRequire("aB89e")).shared.spaceUnit.CATEGORY;

var $4ICSb = parcelRequire("4ICSb");

var $4Ds5C = parcelRequire("4Ds5C");
function $9e48680f5af0d7d5$var$getSpaceDataForAnalytics(spaceData) {
    const spaceDataForAnalytics = $f1q41.assign({}, spaceData.program.areaTotals, spaceData.assumptions, spaceData.program.metrics, spaceData.program.finalStats);
    spaceDataForAnalytics.collaboration = $f1q41.findKey($9e48680f5af0d7d5$require$constants.calculator.COLLABORATION_LEVEL, (level)=>level === spaceDataForAnalytics.collaboration); // translate to 'LOW', ...
    spaceDataForAnalytics.profileName = $4ICSb[spaceData.profileId].displayName;
    // flatten program
    $f1q41.values($9e48680f5af0d7d5$var$SPACE_UNIT_CATEGORY).forEach((category)=>{
        const section = spaceData.program[category]; // spacer free doesn't have sharedFocus sections in programs
        if (section) section.forEach((unit)=>{
            let unitName;
            if (category === $9e48680f5af0d7d5$var$SPACE_UNIT_CATEGORY.CUSTOM_AMENITY) unitName = unit.displayName;
            else unitName = $4Ds5C[unit.spaceUnitId].displayName;
            Object.keys(unit).forEach((property)=>{
                if (property !== "spaceUnitId" && property !== "id" && property !== "displayName") spaceDataForAnalytics[`program_${category}_${unitName}_${property}`] = unit[property];
            });
        });
    });
    return spaceDataForAnalytics;
}
// NOTE: we `could` send this not in number form, but in text form (instead of answer is '2', send 'Mostly from our office')
// that might be easier to read, but it might not be. Reconsider if John complains
function $9e48680f5af0d7d5$var$getProfileQuizForAnalytics(profileQuiz) {
    // flattening, but instead of just using 1, 2, 3 as keys, changing it to question_1 and so on instead
    const analyticsAnswers = {};
    Object.keys(profileQuiz.userQuizAnswers).forEach((questionId)=>{
        const answer = profileQuiz.userQuizAnswers[questionId];
        if ($f1q41.isArray(answer)) answer.forEach((ans, i)=>{
            analyticsAnswers[`question_${questionId}_${i}`] = ans;
        });
        else analyticsAnswers[`question_${questionId}`] = answer;
    });
    return analyticsAnswers;
}
// Heap doesn't accept nested properties, so flatten everything!
function $9e48680f5af0d7d5$var$formatHeapEventProps(state) {
    return $f1q41.assign({}, state.userData, $9e48680f5af0d7d5$var$getSpaceDataForAnalytics(state.spaceData), $9e48680f5af0d7d5$var$getProfileQuizForAnalytics(state.profileQuiz));
}
function $9e48680f5af0d7d5$var$sendHeapEvent(eventName, state) {
    if (window.SERVER_DATA.featureFlags.isHeapAnalyticsEnabled == "true") {
        const eventProps = $9e48680f5af0d7d5$var$formatHeapEventProps(state);
        return heap.track(eventName, eventProps);
    } else return null;
}
function $9e48680f5af0d7d5$var$sendHeapEventWithoutProps(eventName) {
    if (window.SERVER_DATA.featureFlags.isHeapAnalyticsEnabled == "true") return heap.track(eventName);
    else return null;
}
$9e48680f5af0d7d5$exports = {
    sendHeapEvent: $9e48680f5af0d7d5$var$sendHeapEvent,
    sendHeapEventWithoutProps: $9e48680f5af0d7d5$var$sendHeapEventWithoutProps
};


var $ef5cf714b4749bc3$exports = {};




const $ef5cf714b4749bc3$var$SPACE_UNIT_CATEGORY = (parcelRequire("aB89e")).shared.spaceUnit.CATEGORY;

var $f1q41 = parcelRequire("f1q41");
$ef5cf714b4749bc3$exports = function fullStateReducer(state = {}, action) {
    switch(action.type){
        case $7f3ddf5ab2cb44f3$exports.SET_PROFILE_AND_CALCULATE_PROGRAM:
            {
                const profileScores = state.profileQuiz.profileScores;
                const profileId = action.profileId || $f1q41.maxBy(Object.keys(profileScores), (profId)=>profileScores[profId]);
                const profileType = $e3ec1f29f8e2ec07$exports.calculateProfileType(state.userData.officeLocation, state.spaceData.assumptions.headcount, state.profileQuiz.userQuizAnswers);
                const program = $dd1d3e43b4086c4d$exports.calculateProgram(profileId, profileType, state.spaceData.assumptions, [], state.userData.officeLocation);
                const spaceData = $f1q41.assign({}, state.spaceData, {
                    profileId: profileId,
                    profileType: profileType,
                    program: program
                });
                return Object.assign({}, state, {
                    spaceData: spaceData
                });
            }
        case $7f3ddf5ab2cb44f3$exports.UPDATE_KEY_ASSUMPTION:
            {
                const assumptions = $f1q41.assign({}, state.spaceData.assumptions, {
                    [action.assumptionType]: action.value
                });
                const profileType = $e3ec1f29f8e2ec07$exports.calculateProfileType(state.userData.officeLocation, assumptions.headcount, state.profileQuiz.userQuizAnswers);
                // if there were custom Amenities, add those back in after
                const customAmenitiesAdded = $f1q41.cloneDeep(state.spaceData.program[$ef5cf714b4749bc3$var$SPACE_UNIT_CATEGORY.CUSTOM_AMENITY]);
                const program = $dd1d3e43b4086c4d$exports.calculateProgram(state.spaceData.profileId, profileType, assumptions, customAmenitiesAdded, state.userData.officeLocation);
                const spaceData = $f1q41.assign({}, state.spaceData, {
                    assumptions: assumptions,
                    profileType: profileType,
                    program: program
                });
                return Object.assign({}, state, {
                    spaceData: spaceData
                });
            }
        default:
            return state;
    }
};



const $a5750ebba6802e03$var$combinedReducers = $a5750ebba6802e03$require$combineReducers({
    profileQuiz: $65b08a30dc81acba$exports,
    spaceData: $1796c0a763c37764$exports,
    userData: $df91c04927a122df$exports,
    requests: $40457d2e2142b51d$exports,
    modal: $8b51bff02f044485$exports,
    changeDetected: $ef68c3c40a6d65a2$exports
});
// Here we define which actions need to utilize special case reducers for
// specific branches of the state tree
function $a5750ebba6802e03$var$crossSliceReducer(state, action) {
    switch(action.type){
        case $7f3ddf5ab2cb44f3$exports.SET_PROFILE_AND_CALCULATE_PROGRAM:
        case $7f3ddf5ab2cb44f3$exports.UPDATE_KEY_ASSUMPTION:
            return $ef5cf714b4749bc3$exports(state, action);
        case (0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).SEND_HEAP_EVENT:
            $9e48680f5af0d7d5$exports.sendHeapEvent(action.eventName, state);
            return state;
        case (0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).SEND_HEAP_EVENT_WITHOUT_PROPS:
            $9e48680f5af0d7d5$exports.sendHeapEventWithoutProps(action.eventName);
            return state;
        default:
            return state;
    }
}
$a5750ebba6802e03$exports = (state, action)=>{
    const intermediateState = $a5750ebba6802e03$var$combinedReducers(state, action);
    const finalState = $a5750ebba6802e03$var$crossSliceReducer(intermediateState, action);
    return finalState;
};



var $aB89e = parcelRequire("aB89e");
var $8924627178c725bd$require$constants = $aB89e.spacerFree;
var $09be42b69c5cf046$exports = {};
// Resource: https://egghead.io/lessons/javascript-redux-persisting-the-state-to-the-local-storage

var $f1q41 = parcelRequire("f1q41");
const $09be42b69c5cf046$var$DEFAULT_EXPIRATION = 86400000; // One day in milliseconds.
const $09be42b69c5cf046$var$SANITATION_KEYS = [
    "modal"
];
function $09be42b69c5cf046$var$load(key) {
    try {
        const serializedState = window.localStorage.getItem(key);
        if (serializedState === null) return undefined;
        const parsedState = JSON.parse(serializedState);
        // If our item met its expiration, remove from local storage,
        const now = new Date();
        if (parsedState.expiration && now - new Date(parsedState.timestamp) > parsedState.expiration) {
            window.localStorage.removeItem(key);
            return undefined;
        }
        return parsedState.value;
    } catch (err) {
        return undefined;
    }
}
// Shortcut for Redux State
function $09be42b69c5cf046$var$loadState() {
    return $09be42b69c5cf046$var$load("reduxState");
}
function $09be42b69c5cf046$var$save(key, value, expiration = $09be42b69c5cf046$var$DEFAULT_EXPIRATION) {
    const saveObject = {
        value: $f1q41.cloneDeep($f1q41.omit(value, $09be42b69c5cf046$var$SANITATION_KEYS)),
        timestamp: new Date(),
        expiration: expiration
    };
    try {
        const serializedState = JSON.stringify(saveObject);
        window.localStorage.setItem(key, serializedState);
    } catch (err) {
        console.log(err);
    }
}
// Shortcut for ReduxState
function $09be42b69c5cf046$var$saveState(state, expiration = $09be42b69c5cf046$var$DEFAULT_EXPIRATION) {
    $09be42b69c5cf046$var$save("reduxState", state, expiration);
}
function $09be42b69c5cf046$var$clear() {
    const didClearState = !!window.localStorage.length;
    window.localStorage.clear();
    return didClearState;
}
$09be42b69c5cf046$exports = {
    loadState: $09be42b69c5cf046$var$loadState,
    saveState: $09be42b69c5cf046$var$saveState,
    load: $09be42b69c5cf046$var$load,
    save: $09be42b69c5cf046$var$save,
    clear: $09be42b69c5cf046$var$clear
};


var $2ab8072069ea9a56$exports = {};
function $2ab8072069ea9a56$var$onQuizPage() {
    return window.location.pathname === "/quiz-spacer-by-cbre";
}
function $2ab8072069ea9a56$var$onHomePage() {
    return window.location.pathname === "/" || window.location.pathname.indexOf("/referral") > -1;
}
function $2ab8072069ea9a56$var$onResultsForIdPage() {
    const onOldResultsPageForIdRegex = /^\/results\/.+/;
    const onNewResultsPageForIdRegex = /^\/program-your-results-spacer-by-cbre\/.+/;
    return onOldResultsPageForIdRegex.test(window.location.pathname) || onNewResultsPageForIdRegex.test(window.location.pathname);
}
$2ab8072069ea9a56$exports = {
    onQuizPage: $2ab8072069ea9a56$var$onQuizPage,
    onHomePage: $2ab8072069ea9a56$var$onHomePage,
    onResultsForIdPage: $2ab8072069ea9a56$var$onResultsForIdPage
};



var $f1q41 = parcelRequire("f1q41");
var $4be8078b6f25ed06$exports = {};


var $jHTLJ = parcelRequire("jHTLJ");
var $4be8078b6f25ed06$require$connect = $jHTLJ.connect;

var $eShmq = parcelRequire("eShmq");
var $4be8078b6f25ed06$require$bindActionCreators = $eShmq.bindActionCreators;

var $aB89e = parcelRequire("aB89e");
var $4be8078b6f25ed06$require$constants = $aB89e.spacerFree;

var $3bcfe8c7d9c37ed1$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $aB89e = parcelRequire("aB89e");
var $3bcfe8c7d9c37ed1$require$constants = $aB89e.spacerFree;
var $3f2f42ab549e38f9$exports = {};

var $jHTLJ = parcelRequire("jHTLJ");
var $3f2f42ab549e38f9$require$connect = $jHTLJ.connect;

var $eShmq = parcelRequire("eShmq");
var $3f2f42ab549e38f9$require$bindActionCreators = $eShmq.bindActionCreators;

var $9472a461083b8656$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $aB89e = parcelRequire("aB89e");
var $9472a461083b8656$require$constants = $aB89e.spacerFree;
var $0ba6e20181a43213$exports = {};


var $jHTLJ = parcelRequire("jHTLJ");
var $0ba6e20181a43213$require$connect = $jHTLJ.connect;

var $eShmq = parcelRequire("eShmq");
var $0ba6e20181a43213$require$bindActionCreators = $eShmq.bindActionCreators;
var $7708a42db2f889d1$exports = {};

var $jHTLJ = parcelRequire("jHTLJ");
var $7708a42db2f889d1$require$connect = $jHTLJ.connect;

var $c0784c985b5dfa52$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $3EC2Q = parcelRequire("3EC2Q");
var $c65dfa4761b1f23d$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $3EC2Q = parcelRequire("3EC2Q");
var $3bded32c0b06b78b$exports = {};

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $3bded32c0b06b78b$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;

var $7YV43 = parcelRequire("7YV43");

const $3bded32c0b06b78b$var$inputTypesToValidate = [
    "email"
];
class $3bded32c0b06b78b$var$FormInput extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            isFocused: false
        };
        this.onChange = this.onChange.bind(this);
        this.inputRef = $acw62.createRef();
    }
    onChange(evt) {
        this.props.onChange(evt.target.value);
        if ($3bded32c0b06b78b$var$inputTypesToValidate.includes(this.props.type)) {
            this.inputRef.current.setCustomValidity("");
            if (!this.inputRef.current.checkValidity()) this.inputRef.current.setCustomValidity(this.props.t("formEmailInvalid"));
        }
    }
    render() {
        let containerClasses = "underline-input-with-label";
        if (this.props.autoComplete === "given-name") containerClasses += " first-name";
        else if (this.props.autoComplete === "family-name") containerClasses += " last-name";
        let labelClasses = "underline-input-label";
        // on IE, an input's placeholder gets hidden on focus, so we want to make sure the label is visible if the input has focus
        if (!this.props.value && !($7YV43.IS_IE && this.state.isFocused)) labelClasses += " is-invisible";
        let placeholder;
        if (this.props.placeholder) placeholder = this.props.placeholder;
        else {
            placeholder = this.props.label;
            placeholder += this.props.required ? " *" : this.props.t("formInputOptionalText");
        }
        let onKeyDown;
        if (this.props.multipleAllowed) onKeyDown = (evt)=>{
            // when entering multiple comma separated things, by default hitting space returns the cursor to the input's start
            if (evt.which === $c65935c63c29746a$exports.SPACE) evt.preventDefault();
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: containerClasses,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                    className: labelClasses,
                    children: this.props.label
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "underline-input",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: this.props.type,
                        ref: this.inputRef,
                        multiple: this.props.multipleAllowed,
                        className: "input",
                        required: this.props.required,
                        placeholder: placeholder,
                        autoComplete: this.props.autoComplete,
                        value: this.props.value,
                        onChange: this.onChange,
                        onKeyDown: onKeyDown,
                        onFocus: ()=>this.setState({
                                isFocused: true
                            }),
                        onBlur: ()=>this.setState({
                                isFocused: false
                            })
                    })
                })
            ]
        });
    }
}
$3bded32c0b06b78b$var$FormInput.propTypes = {
    value: $c9Z8w.string.isRequired,
    label: $c9Z8w.string.isRequired,
    type: $c9Z8w.string,
    multipleAllowed: $c9Z8w.bool,
    required: $c9Z8w.bool,
    placeholder: $c9Z8w.string,
    autoComplete: $c9Z8w.string,
    onChange: $c9Z8w.func.isRequired,
    t: $c9Z8w.func.isRequired
};
$3bded32c0b06b78b$var$FormInput.defaultProps = {
    type: "text",
    multipleAllowed: false,
    value: "",
    required: false,
    placeholder: "",
    autoComplete: "off"
};
$3bded32c0b06b78b$exports = $3bded32c0b06b78b$require$withTranslation("resultsPage")($3bded32c0b06b78b$var$FormInput);




var $c65dfa4761b1f23d$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
class $c65dfa4761b1f23d$var$Form extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {};
        props.fields.forEach((field)=>{
            this.state[field.name] = field.defaultValue;
        });
        this.onSubmit = this.onSubmit.bind(this);
    }
    onSubmit(evt) {
        evt.preventDefault();
        this.props.onSubmit(this.state);
    }
    render() {
        let disableSubmit = this.props.isSubmittingForm;
        for(let i = 0, len = this.props.fields.length; i < len; i += 1)if (this.props.fields[i].required && !this.state[this.props.fields[i].name]) {
            disableSubmit = true;
            break;
        }
        let FieldComponent;
        const fieldComponents = this.props.fields.map((field)=>{
            if (field.hidden) return null;
            FieldComponent = field.type === "checkbox" ? $cce78554523b012f$exports : $3bded32c0b06b78b$exports;
            return /*#__PURE__*/ (0, $ayMG0.jsx)(FieldComponent, {
                type: field.type,
                label: field.label,
                required: field.required,
                value: field.customValueFromState ? field.customValueFromState(this.state) : this.state[field.name],
                onChange: (val)=>this.setState({
                        [field.name]: val
                    }),
                // the following props aren't required on all field components, but including on all instead of some out of convenience
                checked: this.state[field.name],
                autoComplete: field.autoComplete,
                multipleAllowed: field.multipleAllowed
            }, field.name);
        });
        let errorTextClasses = "has-text-danger is-size-7 has-margin-top-6";
        if (!this.props.submitFormError) errorTextClasses += " is-invisible";
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
            className: "form",
            onSubmit: this.onSubmit,
            children: [
                fieldComponents,
                this.props.additionalInfoText && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "is-size-7 has-margin-top-6",
                    children: this.props.additionalInfoText
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: errorTextClasses,
                    children: this.props.t("formErrorText")
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "button is-primary-filled has-margin-top-6 submitBtn",
                    type: "submit",
                    disabled: disableSubmit,
                    children: this.props.submitText
                })
            ]
        });
    }
}
$c65dfa4761b1f23d$var$Form.propTypes = {
    fields: $3EC2Q.formFields.isRequired,
    onSubmit: $c9Z8w.func.isRequired,
    submitText: $c9Z8w.string.isRequired,
    additionalInfoText: $c9Z8w.string,
    isSubmittingForm: $c9Z8w.bool.isRequired,
    submitFormError: $c9Z8w.object,
    t: $c9Z8w.func.isRequired
};
$c65dfa4761b1f23d$var$Form.defaultProps = {
    additionalInfoText: "",
    submitFormError: null
};
$c65dfa4761b1f23d$exports = $c65dfa4761b1f23d$require$withTranslation("resultsPage")($c65dfa4761b1f23d$var$Form);




var $c0784c985b5dfa52$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $c0784c985b5dfa52$var$LegalForm(props) {
    const fields = props.fields.slice(); // don't mutate props
    fields.push({
        type: "checkbox",
        name: "termsOfService",
        required: true,
        label: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "form-checkbox is-small",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($da568585ccda1a1d$exports, {})
        }),
        defaultValue: false
    });
    let contactWarning;
    if (props.isLeadGenForm) {
        if (!props.isCBREEmployee) fields.push({
            name: "contactOptIn",
            type: "checkbox",
            label: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "form-checkbox is-small",
                children: this.props.t("legalFormCheckboxText")
            }),
            defaultValue: false
        });
        else contactWarning = this.props.t("legalFormContactWarningText");
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($c65dfa4761b1f23d$exports, {
        ...props,
        fields: fields,
        additionalInfoText: contactWarning
    });
}
$c0784c985b5dfa52$var$LegalForm.propTypes = {
    fields: $3EC2Q.formFields.isRequired,
    isLeadGenForm: $c9Z8w.bool,
    isCBREEmployee: $c9Z8w.bool.isRequired,
    t: $c9Z8w.func.isRequired
};
$c0784c985b5dfa52$var$LegalForm.defaultProps = {
    isLeadGenForm: false
};
$c0784c985b5dfa52$exports = $c0784c985b5dfa52$require$withTranslation("resultsPage")($c0784c985b5dfa52$var$LegalForm);


// Map state to props
function $7708a42db2f889d1$var$mapStateToProps(state) {
    return {
        isCBREEmployee: $a7ed1d23eae0a668$exports.isCBREEmployee(state.userData.role)
    };
}
$7708a42db2f889d1$exports = $7708a42db2f889d1$require$connect($7708a42db2f889d1$var$mapStateToProps)($c0784c985b5dfa52$exports);



var $0ba6e20181a43213$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
// Map dispatch to props
function $0ba6e20181a43213$var$mapDispatchToProps(dispatch, ownProps) {
    return {
        fields: [
            {
                name: "firstName",
                required: true,
                label: ownProps.t("contactFormFirstNameLabel"),
                autoComplete: "given-name",
                defaultValue: ""
            },
            {
                name: "lastName",
                required: true,
                label: ownProps.t("contactFormLastNameLabel"),
                autoComplete: "family-name",
                defaultValue: ""
            },
            {
                name: "email",
                type: "email",
                required: true,
                label: ownProps.t("contactFormEmailLabel"),
                autoComplete: "email",
                defaultValue: ""
            },
            {
                name: "phone",
                label: ownProps.t("contactFormPhoneLabel"),
                autoComplete: "tel",
                defaultValue: ""
            },
            {
                name: "message",
                label: ownProps.t("contactFormMessageLabel"),
                required: true,
                defaultValue: ""
            },
            {
                name: "contactType",
                defaultValue: ownProps.contactType,
                hidden: true
            }
        ],
        submitText: ownProps.t("contactFormSubmitText"),
        onSubmit: $0ba6e20181a43213$require$bindActionCreators((0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).contactSupport, dispatch)
    };
}
$0ba6e20181a43213$exports = $0ba6e20181a43213$require$withTranslation("resultsPage")($0ba6e20181a43213$require$connect(null, $0ba6e20181a43213$var$mapDispatchToProps)($7708a42db2f889d1$exports));


var $6f56e0ec666a7b3a$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $6f56e0ec666a7b3a$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
function $6f56e0ec666a7b3a$var$SuccessModal(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "success-modal",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "title is-4 has-text-primary",
                children: props.t("successModalTitle")
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "has-margin-top-4 has-margin-bottom-4",
                children: props.text
            })
        ]
    });
}
$6f56e0ec666a7b3a$var$SuccessModal.propTypes = {
    text: $c9Z8w.string.isRequired,
    t: $c9Z8w.func.isRequired
};
$6f56e0ec666a7b3a$exports = $6f56e0ec666a7b3a$require$withTranslation("resultsPage")($6f56e0ec666a7b3a$var$SuccessModal);



var $9472a461083b8656$require$withTranslation = $d9bd4545752f9667$export$2dcb0053efd21124;
// NOTE: this component was written to be flexible and work with multiple types of forms,
// however, all modal forms except FIND_SPACE have been deprecated, so it currently only hooks up to that one form
function $9472a461083b8656$var$getContentAndFormForType(type, isSubmittingForm, submitFormError, t) {
    let header;
    let body;
    let form;
    let successMessage;
    switch(type){
        case $9472a461083b8656$require$constants.modal.FORM_TYPES.FIND_SPACE:
            header = t("formModalFindSpaceHeader");
            body = t("formModalFindSpaceBody");
            form = /*#__PURE__*/ (0, $ayMG0.jsx)($0ba6e20181a43213$exports, {
                contactType: type,
                isSubmittingForm: isSubmittingForm,
                submitFormError: submitFormError
            });
            successMessage = t("formModalFindSpaceSuccessMessage");
            break;
        default:
            console.log("Invalid form type", type);
    }
    return {
        header: header,
        body: body,
        form: form,
        successMessage: successMessage
    };
}
class $9472a461083b8656$var$FormModal extends $acw62.Component {
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.submitFormSuccess && !nextProps.submitFormSuccess) this.props.closeModal();
    }
    render() {
        const { header: header, body: body, form: form, successMessage: successMessage } = $9472a461083b8656$var$getContentAndFormForType(this.props.formType, this.props.isSubmittingForm, this.props.submitFormError, this.props.t);
        if (this.props.submitFormSuccess) return /*#__PURE__*/ (0, $ayMG0.jsx)($6f56e0ec666a7b3a$exports, {
            text: successMessage
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "columns",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "column is-5",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "title is-4 has-text-primary has-margin-top-3 has-no-margin-top-mobile",
                            children: header
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: body
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "column is-7",
                    children: form
                })
            ]
        });
    }
}
$9472a461083b8656$var$FormModal.propTypes = {
    formType: $c9Z8w.string.isRequired,
    closeModal: $c9Z8w.func.isRequired,
    isSubmittingForm: $c9Z8w.bool.isRequired,
    submitFormSuccess: $c9Z8w.bool.isRequired,
    submitFormError: $c9Z8w.object,
    t: $c9Z8w.func.isRequired
};
$9472a461083b8656$var$FormModal.defaultProps = {
    submitFormError: null
};
$9472a461083b8656$exports = $9472a461083b8656$require$withTranslation("resultsPage")($9472a461083b8656$var$FormModal);


// Map state to props
function $3f2f42ab549e38f9$var$mapStateToProps(state) {
    return {
        isSubmittingForm: state.requests.isSubmittingForm,
        submitFormSuccess: state.requests.submitFormSuccess,
        submitFormError: state.requests.submitFormError
    };
}
// Map dispatch to props
function $3f2f42ab549e38f9$var$mapDispatchToProps(dispatch) {
    return {
        closeModal: $3f2f42ab549e38f9$require$bindActionCreators($15a18ec2484069fc$exports.closeModal, dispatch)
    };
}
$3f2f42ab549e38f9$exports = $3f2f42ab549e38f9$require$connect($3f2f42ab549e38f9$var$mapStateToProps, $3f2f42ab549e38f9$var$mapDispatchToProps)($9472a461083b8656$exports);


var $8d8d4063cf906610$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $c5c2c928a3c52acb$exports = {};

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");
function $c5c2c928a3c52acb$var$ButtonPair(props) {
    const leftButtonClasses = $8g1PZ("button no-focus-style is-tertiary-outlined-modal", {
        "has-tertiary-text": props.onLightBackground
    });
    const rightButtonClasses = "button no-focus-style is-tertiary-filled-modal";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "button-pair",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                className: leftButtonClasses,
                onClick: props.leftButton.onClick,
                children: props.leftButton.text
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                className: rightButtonClasses,
                onClick: props.rightButton.onClick,
                children: props.rightButton.text
            })
        ]
    });
}
const $c5c2c928a3c52acb$var$buttonProps = $c9Z8w.shape({
    text: $c9Z8w.string.isRequired,
    onClick: $c9Z8w.func.isRequired
});
$c5c2c928a3c52acb$var$ButtonPair.propTypes = {
    leftButton: $c5c2c928a3c52acb$var$buttonProps.isRequired,
    rightButton: $c5c2c928a3c52acb$var$buttonProps.isRequired,
    onLightBackground: $c9Z8w.bool
};
$c5c2c928a3c52acb$var$ButtonPair.defaultProps = {
    onLightBackground: false
};
$c5c2c928a3c52acb$exports = $c5c2c928a3c52acb$var$ButtonPair;


function $8d8d4063cf906610$var$ConfirmationModal(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "title2 is-4",
                children: props.title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "has-margin-top-4 has-margin-bottom-4",
                children: props.text
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($c5c2c928a3c52acb$exports, {
                onLightBackground: true,
                leftButton: {
                    text: props.cancel.text,
                    onClick: props.cancel.onClick
                },
                rightButton: {
                    text: props.confirm.text,
                    onClick: props.confirm.onClick
                }
            })
        ]
    });
}
$8d8d4063cf906610$var$ConfirmationModal.propTypes = {
    title: $c9Z8w.string.isRequired,
    text: $c9Z8w.string.isRequired,
    confirm: $c9Z8w.shape({
        text: $c9Z8w.string,
        onClick: $c9Z8w.func
    }).isRequired,
    cancel: $c9Z8w.shape({
        text: $c9Z8w.string,
        onClick: $c9Z8w.func
    }).isRequired
};
$8d8d4063cf906610$exports = $8d8d4063cf906610$var$ConfirmationModal;


const $3bcfe8c7d9c37ed1$var$MODAL_TYPE_TO_COMPONENT_MAP = {
    [$3bcfe8c7d9c37ed1$require$constants.modal.TYPES.FORM]: $3f2f42ab549e38f9$exports,
    [$3bcfe8c7d9c37ed1$require$constants.modal.TYPES.CONFIRMATION]: $8d8d4063cf906610$exports
};
function $3bcfe8c7d9c37ed1$var$closeModalForType(props) {
    props.closeModal();
    if (props.afterClose[props.modalType]) props.afterClose[props.modalType]();
}
function $3bcfe8c7d9c37ed1$var$Modal(props) {
    const closeModal = ()=>$3bcfe8c7d9c37ed1$var$closeModalForType(props);
    if (props.modalType === $3bcfe8c7d9c37ed1$require$constants.modal.TYPES.NONE) return null;
    const ComponentToRender = $3bcfe8c7d9c37ed1$var$MODAL_TYPE_TO_COMPONENT_MAP[props.modalType];
    let modalContentClasses = "modal-content";
    if (props.modalType === $3bcfe8c7d9c37ed1$require$constants.modal.TYPES.FORM) modalContentClasses += " is-wide";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "modal is-active",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "modal-background",
                role: "button",
                tabIndex: 0,
                onClick: closeModal
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: modalContentClasses,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "modal-close is-large",
                        onClick: closeModal
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)(ComponentToRender, {
                        ...props.modalProps,
                        closeModal: closeModal
                    })
                ]
            })
        ]
    });
}
$3bcfe8c7d9c37ed1$var$Modal.propTypes = {
    modalType: $c9Z8w.string.isRequired,
    modalProps: $c9Z8w.object,
    closeModal: $c9Z8w.func.isRequired,
    afterClose: $c9Z8w.objectOf($c9Z8w.func)
};
$3bcfe8c7d9c37ed1$var$Modal.defaultProps = {
    modalProps: null,
    afterClose: null
};
$3bcfe8c7d9c37ed1$exports = $3bcfe8c7d9c37ed1$var$Modal;


// Map state to props
function $4be8078b6f25ed06$var$mapStateToProps(state) {
    return {
        modalType: state.modal.modalType,
        modalProps: state.modal.modalProps
    };
}
// Map dispatch to props
function $4be8078b6f25ed06$var$mapDispatchToProps(dispatch) {
    return {
        closeModal: $4be8078b6f25ed06$require$bindActionCreators($15a18ec2484069fc$exports.closeModal, dispatch),
        afterClose: {
            [$4be8078b6f25ed06$require$constants.modal.TYPES.FORM]: $4be8078b6f25ed06$require$bindActionCreators((0, $a2062a5a6ecff0e2$export$2e2bcd8739ae039).resetSubmitFormProperties, dispatch)
        }
    };
}
$4be8078b6f25ed06$exports = $4be8078b6f25ed06$require$connect($4be8078b6f25ed06$var$mapStateToProps, $4be8078b6f25ed06$var$mapDispatchToProps)($3bcfe8c7d9c37ed1$exports);



var $7YV43 = parcelRequire("7YV43");


var $3GYAO = parcelRequire("3GYAO");

$5f15cdd5de4823b1$exports.updateCurrentLanguage($0ac28f67a425659a$exports.language);
function $8924627178c725bd$var$getSourceIdFromUrl() {
    const r = "referral/";
    const url = window.location.href;
    if (url.indexOf(r) > -1) {
        // knowing that a referral link looks e.g. like workplace.cbre.com/referral/helenforzano - grab all after the `referral/` bit
        const potentialSourceId = url.substring(url.indexOf(r) + r.length);
        if (potentialSourceId !== "retrieve") return potentialSourceId;
    }
    return null;
}
/*  Whenever we hit the home page, we want to make sure we clear local storage so we can restart the quiz.
 *  Similarly, if the quiz page is refreshed after question 1 has been answered we want to restart the quiz,
 *  since it has been started, but not when we first hit the quiz because we want the first question to persist.
*/ let $8924627178c725bd$var$persistedState = {};
const $8924627178c725bd$var$tentativeState = $09be42b69c5cf046$exports.loadState();
const $8924627178c725bd$var$startedQuiz = $8924627178c725bd$var$tentativeState && $8924627178c725bd$var$tentativeState.profileQuiz.userQuizAnswers["1"];
if ($2ab8072069ea9a56$exports.onHomePage() || $2ab8072069ea9a56$exports.onQuizPage() && $8924627178c725bd$var$startedQuiz) $09be42b69c5cf046$exports.clear();
else $8924627178c725bd$var$persistedState = $8924627178c725bd$var$tentativeState;
// Keep sourceId around even when we cleared all quiz answers. Just being agressive with keeping sourceId around.
$f1q41.set($8924627178c725bd$var$persistedState, "userData.sourceId", $8924627178c725bd$var$getSourceIdFromUrl() || $f1q41.get($8924627178c725bd$var$tentativeState, "userData.sourceId"));
const $8924627178c725bd$var$initialStateToBeOverriddenIfPersisted = {
    profileQuiz: {
        userQuizAnswers: {},
        profileScores: {}
    },
    spaceData: {
        profileId: "",
        assumptions: {},
        program: {},
        sfType: $8924627178c725bd$require$constants.calculator.SF_TYPE.RSF,
        _id: ""
    },
    userData: {
        role: "",
        industryCode: "",
        officeLocation: "",
        currentPersonalLocation: ""
    }
};
const $8924627178c725bd$var$initialStateDefaults = {
    requests: {
        isFetchingProgram: false,
        fetchProgramError: null,
        isSubmittingForm: false,
        submitFormSuccess: false,
        submitFormError: null,
        wasProgramSaved: false
    },
    modal: {
        modalType: $8924627178c725bd$require$constants.modal.TYPES.NONE,
        modalProps: null
    },
    changeDetected: {
        changesMadeToResultsDetails: false
    }
};
const $8924627178c725bd$var$initialState = $f1q41.merge({}, $8924627178c725bd$var$initialStateToBeOverriddenIfPersisted, $8924627178c725bd$var$persistedState, $8924627178c725bd$var$initialStateDefaults);
// put initial state on local storage (so sourceId is saved right away on the home page,
// instead of getting lost when navigating to e.g. About Page and back
$09be42b69c5cf046$exports.saveState($8924627178c725bd$var$initialState);
// This is a little hacky. Basically there's lots of conditions surrounding whether we should fetch
// a program on the results page, with one of them being that the space program is empty. if there is
// persisted state, then the space program isn't empty. This just force clears it if you hit the path
// with an id.
if ($2ab8072069ea9a56$exports.onResultsForIdPage()) $8924627178c725bd$var$initialState.spaceData.program = {};
const $8924627178c725bd$var$store = $8924627178c725bd$require$createStore($a5750ebba6802e03$exports, $8924627178c725bd$var$initialState, $8924627178c725bd$require$applyMiddleware($8924627178c725bd$require$thunk));
$8924627178c725bd$var$store.subscribe($f1q41.throttle(()=>{
    // Currently saving on local storage even when loaded from id, so we can go to square footage page and return from saved result.
    // TODO: we might want to rethink that in the future and not override local storage. Instead we could work with React Links.
    // if (pageManager.onResultsForIdPage()) return;
    $09be42b69c5cf046$exports.saveState($8924627178c725bd$var$store.getState());
}), 1000);
let $8924627178c725bd$var$browserClass = "";
if ($7YV43.IS_FIREFOX) $8924627178c725bd$var$browserClass = "is-firefox";
if ($7YV43.IS_IE) $8924627178c725bd$var$browserClass = "is-ie";
//Initialize Google Analytics 
$3GYAO.GAInitialize();
const $8924627178c725bd$var$container = document.getElementById("mainContent");
const $8924627178c725bd$var$root = $8924627178c725bd$require$createRoot($8924627178c725bd$var$container);
$0c5169fa3c108ac2$exports.subscribe(function(state, options) {
    const { historyAction: historyAction, location: location } = state;
    const { pathname: pathname } = location;
    if (historyAction === "PUSH") {
        window.scrollTo(0, 0);
        $3GYAO.GATrackRoute(pathname, pathname);
    }
});
$8924627178c725bd$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)($8924627178c725bd$require$Provider, {
    store: $8924627178c725bd$var$store,
    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: $8924627178c725bd$var$browserClass,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)($4be8078b6f25ed06$exports, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)($8924627178c725bd$require$RouterProvider, {
                router: $0c5169fa3c108ac2$exports
            })
        ]
    })
}));


//# sourceMappingURL=spacerFree.25c03e2b.js.map
